var ViewportMode;
(function (ViewportMode) {
    ViewportMode[ViewportMode["ONE"] = 0] = "ONE";
    ViewportMode[ViewportMode["TWO_HORIZON"] = 1] = "TWO_HORIZON";
    ViewportMode[ViewportMode["TWO_VERTICAL"] = 2] = "TWO_VERTICAL";
    ViewportMode[ViewportMode["FOUR"] = 3] = "FOUR";
})(ViewportMode || (ViewportMode = {}));/**
 * @license
 * Copyright 2010-2024 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
const REVISION$1 = '166';
const FrontSide$1 = 0;
const NormalBlending$1 = 1;
const AddEquation$1 = 100;
const SrcAlphaFactor$1 = 204;
const OneMinusSrcAlphaFactor$1 = 205;
const LessEqualDepth$1 = 3;

const UVMapping$1 = 300;
const RepeatWrapping$1 = 1000;
const ClampToEdgeWrapping$1 = 1001;
const MirroredRepeatWrapping$1 = 1002;
const LinearFilter$1 = 1006;
const LinearMipmapLinearFilter$1 = 1008;
const UnsignedByteType$1 = 1009;
const FloatType$1 = 1015;
const RGBAFormat$1 = 1023;

// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const NoColorSpace$1 = '';
const SRGBColorSpace$1 = 'srgb';
const LinearSRGBColorSpace$1 = 'srgb-linear';
const DisplayP3ColorSpace$1 = 'display-p3';
const LinearDisplayP3ColorSpace$1 = 'display-p3-linear';

const LinearTransfer$1 = 'linear';
const SRGBTransfer$1 = 'srgb';

const Rec709Primaries$1 = 'rec709';
const P3Primaries$1 = 'p3';
const KeepStencilOp$1 = 7680;
const AlwaysStencilFunc$1 = 519;

const StaticDrawUsage$1 = 35044;

const WebGLCoordinateSystem$1 = 2000;
const WebGPUCoordinateSystem$1 = 2001;

/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */

let EventDispatcher$3=class EventDispatcher {

	addEventListener( type, listener ) {

		if ( this._listeners === undefined ) this._listeners = {};

		const listeners = this._listeners;

		if ( listeners[ type ] === undefined ) {

			listeners[ type ] = [];

		}

		if ( listeners[ type ].indexOf( listener ) === - 1 ) {

			listeners[ type ].push( listener );

		}

	}

	hasEventListener( type, listener ) {

		if ( this._listeners === undefined ) return false;

		const listeners = this._listeners;

		return listeners[ type ] !== undefined && listeners[ type ].indexOf( listener ) !== - 1;

	}

	removeEventListener( type, listener ) {

		if ( this._listeners === undefined ) return;

		const listeners = this._listeners;
		const listenerArray = listeners[ type ];

		if ( listenerArray !== undefined ) {

			const index = listenerArray.indexOf( listener );

			if ( index !== - 1 ) {

				listenerArray.splice( index, 1 );

			}

		}

	}

	dispatchEvent( event ) {

		if ( this._listeners === undefined ) return;

		const listeners = this._listeners;
		const listenerArray = listeners[ event.type ];

		if ( listenerArray !== undefined ) {

			event.target = this;

			// Make a copy, in case listeners are removed while iterating.
			const array = listenerArray.slice( 0 );

			for ( let i = 0, l = array.length; i < l; i ++ ) {

				array[ i ].call( this, event );

			}

			event.target = null;

		}

	}

};

const _lut$1 = [ '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '0a', '0b', '0c', '0d', '0e', '0f', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '1a', '1b', '1c', '1d', '1e', '1f', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '2a', '2b', '2c', '2d', '2e', '2f', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '3a', '3b', '3c', '3d', '3e', '3f', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '4a', '4b', '4c', '4d', '4e', '4f', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '5a', '5b', '5c', '5d', '5e', '5f', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '6a', '6b', '6c', '6d', '6e', '6f', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '7a', '7b', '7c', '7d', '7e', '7f', '80', '81', '82', '83', '84', '85', '86', '87', '88', '89', '8a', '8b', '8c', '8d', '8e', '8f', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', '9a', '9b', '9c', '9d', '9e', '9f', 'a0', 'a1', 'a2', 'a3', 'a4', 'a5', 'a6', 'a7', 'a8', 'a9', 'aa', 'ab', 'ac', 'ad', 'ae', 'af', 'b0', 'b1', 'b2', 'b3', 'b4', 'b5', 'b6', 'b7', 'b8', 'b9', 'ba', 'bb', 'bc', 'bd', 'be', 'bf', 'c0', 'c1', 'c2', 'c3', 'c4', 'c5', 'c6', 'c7', 'c8', 'c9', 'ca', 'cb', 'cc', 'cd', 'ce', 'cf', 'd0', 'd1', 'd2', 'd3', 'd4', 'd5', 'd6', 'd7', 'd8', 'd9', 'da', 'db', 'dc', 'dd', 'de', 'df', 'e0', 'e1', 'e2', 'e3', 'e4', 'e5', 'e6', 'e7', 'e8', 'e9', 'ea', 'eb', 'ec', 'ed', 'ee', 'ef', 'f0', 'f1', 'f2', 'f3', 'f4', 'f5', 'f6', 'f7', 'f8', 'f9', 'fa', 'fb', 'fc', 'fd', 'fe', 'ff' ];

// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function generateUUID$1() {

	const d0 = Math.random() * 0xffffffff | 0;
	const d1 = Math.random() * 0xffffffff | 0;
	const d2 = Math.random() * 0xffffffff | 0;
	const d3 = Math.random() * 0xffffffff | 0;
	const uuid = _lut$1[ d0 & 0xff ] + _lut$1[ d0 >> 8 & 0xff ] + _lut$1[ d0 >> 16 & 0xff ] + _lut$1[ d0 >> 24 & 0xff ] + '-' +
			_lut$1[ d1 & 0xff ] + _lut$1[ d1 >> 8 & 0xff ] + '-' + _lut$1[ d1 >> 16 & 0x0f | 0x40 ] + _lut$1[ d1 >> 24 & 0xff ] + '-' +
			_lut$1[ d2 & 0x3f | 0x80 ] + _lut$1[ d2 >> 8 & 0xff ] + '-' + _lut$1[ d2 >> 16 & 0xff ] + _lut$1[ d2 >> 24 & 0xff ] +
			_lut$1[ d3 & 0xff ] + _lut$1[ d3 >> 8 & 0xff ] + _lut$1[ d3 >> 16 & 0xff ] + _lut$1[ d3 >> 24 & 0xff ];

	// .toLowerCase() here flattens concatenated strings to save heap memory space.
	return uuid.toLowerCase();

}

function clamp$1( value, min, max ) {

	return Math.max( min, Math.min( max, value ) );

}

// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function euclideanModulo$1( n, m ) {

	return ( ( n % m ) + m ) % m;

}

// https://en.wikipedia.org/wiki/Linear_interpolation
function lerp$1( x, y, t ) {

	return ( 1 - t ) * x + t * y;

}

function denormalize$1( value, array ) {

	switch ( array.constructor ) {

		case Float32Array:

			return value;

		case Uint32Array:

			return value / 4294967295.0;

		case Uint16Array:

			return value / 65535.0;

		case Uint8Array:

			return value / 255.0;

		case Int32Array:

			return Math.max( value / 2147483647.0, - 1.0 );

		case Int16Array:

			return Math.max( value / 32767.0, - 1.0 );

		case Int8Array:

			return Math.max( value / 127.0, - 1.0 );

		default:

			throw new Error( 'Invalid component type.' );

	}

}

function normalize$1( value, array ) {

	switch ( array.constructor ) {

		case Float32Array:

			return value;

		case Uint32Array:

			return Math.round( value * 4294967295.0 );

		case Uint16Array:

			return Math.round( value * 65535.0 );

		case Uint8Array:

			return Math.round( value * 255.0 );

		case Int32Array:

			return Math.round( value * 2147483647.0 );

		case Int16Array:

			return Math.round( value * 32767.0 );

		case Int8Array:

			return Math.round( value * 127.0 );

		default:

			throw new Error( 'Invalid component type.' );

	}

}

let Vector2$1=class Vector2 {

	constructor( x = 0, y = 0 ) {

		Vector2.prototype.isVector2 = true;

		this.x = x;
		this.y = y;

	}

	get width() {

		return this.x;

	}

	set width( value ) {

		this.x = value;

	}

	get height() {

		return this.y;

	}

	set height( value ) {

		this.y = value;

	}

	set( x, y ) {

		this.x = x;
		this.y = y;

		return this;

	}

	setScalar( scalar ) {

		this.x = scalar;
		this.y = scalar;

		return this;

	}

	setX( x ) {

		this.x = x;

		return this;

	}

	setY( y ) {

		this.y = y;

		return this;

	}

	setComponent( index, value ) {

		switch ( index ) {

			case 0: this.x = value; break;
			case 1: this.y = value; break;
			default: throw new Error( 'index is out of range: ' + index );

		}

		return this;

	}

	getComponent( index ) {

		switch ( index ) {

			case 0: return this.x;
			case 1: return this.y;
			default: throw new Error( 'index is out of range: ' + index );

		}

	}

	clone() {

		return new this.constructor( this.x, this.y );

	}

	copy( v ) {

		this.x = v.x;
		this.y = v.y;

		return this;

	}

	add( v ) {

		this.x += v.x;
		this.y += v.y;

		return this;

	}

	addScalar( s ) {

		this.x += s;
		this.y += s;

		return this;

	}

	addVectors( a, b ) {

		this.x = a.x + b.x;
		this.y = a.y + b.y;

		return this;

	}

	addScaledVector( v, s ) {

		this.x += v.x * s;
		this.y += v.y * s;

		return this;

	}

	sub( v ) {

		this.x -= v.x;
		this.y -= v.y;

		return this;

	}

	subScalar( s ) {

		this.x -= s;
		this.y -= s;

		return this;

	}

	subVectors( a, b ) {

		this.x = a.x - b.x;
		this.y = a.y - b.y;

		return this;

	}

	multiply( v ) {

		this.x *= v.x;
		this.y *= v.y;

		return this;

	}

	multiplyScalar( scalar ) {

		this.x *= scalar;
		this.y *= scalar;

		return this;

	}

	divide( v ) {

		this.x /= v.x;
		this.y /= v.y;

		return this;

	}

	divideScalar( scalar ) {

		return this.multiplyScalar( 1 / scalar );

	}

	applyMatrix3( m ) {

		const x = this.x, y = this.y;
		const e = m.elements;

		this.x = e[ 0 ] * x + e[ 3 ] * y + e[ 6 ];
		this.y = e[ 1 ] * x + e[ 4 ] * y + e[ 7 ];

		return this;

	}

	min( v ) {

		this.x = Math.min( this.x, v.x );
		this.y = Math.min( this.y, v.y );

		return this;

	}

	max( v ) {

		this.x = Math.max( this.x, v.x );
		this.y = Math.max( this.y, v.y );

		return this;

	}

	clamp( min, max ) {

		// assumes min < max, componentwise

		this.x = Math.max( min.x, Math.min( max.x, this.x ) );
		this.y = Math.max( min.y, Math.min( max.y, this.y ) );

		return this;

	}

	clampScalar( minVal, maxVal ) {

		this.x = Math.max( minVal, Math.min( maxVal, this.x ) );
		this.y = Math.max( minVal, Math.min( maxVal, this.y ) );

		return this;

	}

	clampLength( min, max ) {

		const length = this.length();

		return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );

	}

	floor() {

		this.x = Math.floor( this.x );
		this.y = Math.floor( this.y );

		return this;

	}

	ceil() {

		this.x = Math.ceil( this.x );
		this.y = Math.ceil( this.y );

		return this;

	}

	round() {

		this.x = Math.round( this.x );
		this.y = Math.round( this.y );

		return this;

	}

	roundToZero() {

		this.x = Math.trunc( this.x );
		this.y = Math.trunc( this.y );

		return this;

	}

	negate() {

		this.x = - this.x;
		this.y = - this.y;

		return this;

	}

	dot( v ) {

		return this.x * v.x + this.y * v.y;

	}

	cross( v ) {

		return this.x * v.y - this.y * v.x;

	}

	lengthSq() {

		return this.x * this.x + this.y * this.y;

	}

	length() {

		return Math.sqrt( this.x * this.x + this.y * this.y );

	}

	manhattanLength() {

		return Math.abs( this.x ) + Math.abs( this.y );

	}

	normalize() {

		return this.divideScalar( this.length() || 1 );

	}

	angle() {

		// computes the angle in radians with respect to the positive x-axis

		const angle = Math.atan2( - this.y, - this.x ) + Math.PI;

		return angle;

	}

	angleTo( v ) {

		const denominator = Math.sqrt( this.lengthSq() * v.lengthSq() );

		if ( denominator === 0 ) return Math.PI / 2;

		const theta = this.dot( v ) / denominator;

		// clamp, to handle numerical problems

		return Math.acos( clamp$1( theta, - 1, 1 ) );

	}

	distanceTo( v ) {

		return Math.sqrt( this.distanceToSquared( v ) );

	}

	distanceToSquared( v ) {

		const dx = this.x - v.x, dy = this.y - v.y;
		return dx * dx + dy * dy;

	}

	manhattanDistanceTo( v ) {

		return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y );

	}

	setLength( length ) {

		return this.normalize().multiplyScalar( length );

	}

	lerp( v, alpha ) {

		this.x += ( v.x - this.x ) * alpha;
		this.y += ( v.y - this.y ) * alpha;

		return this;

	}

	lerpVectors( v1, v2, alpha ) {

		this.x = v1.x + ( v2.x - v1.x ) * alpha;
		this.y = v1.y + ( v2.y - v1.y ) * alpha;

		return this;

	}

	equals( v ) {

		return ( ( v.x === this.x ) && ( v.y === this.y ) );

	}

	fromArray( array, offset = 0 ) {

		this.x = array[ offset ];
		this.y = array[ offset + 1 ];

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this.x;
		array[ offset + 1 ] = this.y;

		return array;

	}

	fromBufferAttribute( attribute, index ) {

		this.x = attribute.getX( index );
		this.y = attribute.getY( index );

		return this;

	}

	rotateAround( center, angle ) {

		const c = Math.cos( angle ), s = Math.sin( angle );

		const x = this.x - center.x;
		const y = this.y - center.y;

		this.x = x * c - y * s + center.x;
		this.y = x * s + y * c + center.y;

		return this;

	}

	random() {

		this.x = Math.random();
		this.y = Math.random();

		return this;

	}

	*[ Symbol.iterator ]() {

		yield this.x;
		yield this.y;

	}

};

let Matrix3$1=class Matrix3 {

	constructor( n11, n12, n13, n21, n22, n23, n31, n32, n33 ) {

		Matrix3.prototype.isMatrix3 = true;

		this.elements = [

			1, 0, 0,
			0, 1, 0,
			0, 0, 1

		];

		if ( n11 !== undefined ) {

			this.set( n11, n12, n13, n21, n22, n23, n31, n32, n33 );

		}

	}

	set( n11, n12, n13, n21, n22, n23, n31, n32, n33 ) {

		const te = this.elements;

		te[ 0 ] = n11; te[ 1 ] = n21; te[ 2 ] = n31;
		te[ 3 ] = n12; te[ 4 ] = n22; te[ 5 ] = n32;
		te[ 6 ] = n13; te[ 7 ] = n23; te[ 8 ] = n33;

		return this;

	}

	identity() {

		this.set(

			1, 0, 0,
			0, 1, 0,
			0, 0, 1

		);

		return this;

	}

	copy( m ) {

		const te = this.elements;
		const me = m.elements;

		te[ 0 ] = me[ 0 ]; te[ 1 ] = me[ 1 ]; te[ 2 ] = me[ 2 ];
		te[ 3 ] = me[ 3 ]; te[ 4 ] = me[ 4 ]; te[ 5 ] = me[ 5 ];
		te[ 6 ] = me[ 6 ]; te[ 7 ] = me[ 7 ]; te[ 8 ] = me[ 8 ];

		return this;

	}

	extractBasis( xAxis, yAxis, zAxis ) {

		xAxis.setFromMatrix3Column( this, 0 );
		yAxis.setFromMatrix3Column( this, 1 );
		zAxis.setFromMatrix3Column( this, 2 );

		return this;

	}

	setFromMatrix4( m ) {

		const me = m.elements;

		this.set(

			me[ 0 ], me[ 4 ], me[ 8 ],
			me[ 1 ], me[ 5 ], me[ 9 ],
			me[ 2 ], me[ 6 ], me[ 10 ]

		);

		return this;

	}

	multiply( m ) {

		return this.multiplyMatrices( this, m );

	}

	premultiply( m ) {

		return this.multiplyMatrices( m, this );

	}

	multiplyMatrices( a, b ) {

		const ae = a.elements;
		const be = b.elements;
		const te = this.elements;

		const a11 = ae[ 0 ], a12 = ae[ 3 ], a13 = ae[ 6 ];
		const a21 = ae[ 1 ], a22 = ae[ 4 ], a23 = ae[ 7 ];
		const a31 = ae[ 2 ], a32 = ae[ 5 ], a33 = ae[ 8 ];

		const b11 = be[ 0 ], b12 = be[ 3 ], b13 = be[ 6 ];
		const b21 = be[ 1 ], b22 = be[ 4 ], b23 = be[ 7 ];
		const b31 = be[ 2 ], b32 = be[ 5 ], b33 = be[ 8 ];

		te[ 0 ] = a11 * b11 + a12 * b21 + a13 * b31;
		te[ 3 ] = a11 * b12 + a12 * b22 + a13 * b32;
		te[ 6 ] = a11 * b13 + a12 * b23 + a13 * b33;

		te[ 1 ] = a21 * b11 + a22 * b21 + a23 * b31;
		te[ 4 ] = a21 * b12 + a22 * b22 + a23 * b32;
		te[ 7 ] = a21 * b13 + a22 * b23 + a23 * b33;

		te[ 2 ] = a31 * b11 + a32 * b21 + a33 * b31;
		te[ 5 ] = a31 * b12 + a32 * b22 + a33 * b32;
		te[ 8 ] = a31 * b13 + a32 * b23 + a33 * b33;

		return this;

	}

	multiplyScalar( s ) {

		const te = this.elements;

		te[ 0 ] *= s; te[ 3 ] *= s; te[ 6 ] *= s;
		te[ 1 ] *= s; te[ 4 ] *= s; te[ 7 ] *= s;
		te[ 2 ] *= s; te[ 5 ] *= s; te[ 8 ] *= s;

		return this;

	}

	determinant() {

		const te = this.elements;

		const a = te[ 0 ], b = te[ 1 ], c = te[ 2 ],
			d = te[ 3 ], e = te[ 4 ], f = te[ 5 ],
			g = te[ 6 ], h = te[ 7 ], i = te[ 8 ];

		return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;

	}

	invert() {

		const te = this.elements,

			n11 = te[ 0 ], n21 = te[ 1 ], n31 = te[ 2 ],
			n12 = te[ 3 ], n22 = te[ 4 ], n32 = te[ 5 ],
			n13 = te[ 6 ], n23 = te[ 7 ], n33 = te[ 8 ],

			t11 = n33 * n22 - n32 * n23,
			t12 = n32 * n13 - n33 * n12,
			t13 = n23 * n12 - n22 * n13,

			det = n11 * t11 + n21 * t12 + n31 * t13;

		if ( det === 0 ) return this.set( 0, 0, 0, 0, 0, 0, 0, 0, 0 );

		const detInv = 1 / det;

		te[ 0 ] = t11 * detInv;
		te[ 1 ] = ( n31 * n23 - n33 * n21 ) * detInv;
		te[ 2 ] = ( n32 * n21 - n31 * n22 ) * detInv;

		te[ 3 ] = t12 * detInv;
		te[ 4 ] = ( n33 * n11 - n31 * n13 ) * detInv;
		te[ 5 ] = ( n31 * n12 - n32 * n11 ) * detInv;

		te[ 6 ] = t13 * detInv;
		te[ 7 ] = ( n21 * n13 - n23 * n11 ) * detInv;
		te[ 8 ] = ( n22 * n11 - n21 * n12 ) * detInv;

		return this;

	}

	transpose() {

		let tmp;
		const m = this.elements;

		tmp = m[ 1 ]; m[ 1 ] = m[ 3 ]; m[ 3 ] = tmp;
		tmp = m[ 2 ]; m[ 2 ] = m[ 6 ]; m[ 6 ] = tmp;
		tmp = m[ 5 ]; m[ 5 ] = m[ 7 ]; m[ 7 ] = tmp;

		return this;

	}

	getNormalMatrix( matrix4 ) {

		return this.setFromMatrix4( matrix4 ).invert().transpose();

	}

	transposeIntoArray( r ) {

		const m = this.elements;

		r[ 0 ] = m[ 0 ];
		r[ 1 ] = m[ 3 ];
		r[ 2 ] = m[ 6 ];
		r[ 3 ] = m[ 1 ];
		r[ 4 ] = m[ 4 ];
		r[ 5 ] = m[ 7 ];
		r[ 6 ] = m[ 2 ];
		r[ 7 ] = m[ 5 ];
		r[ 8 ] = m[ 8 ];

		return this;

	}

	setUvTransform( tx, ty, sx, sy, rotation, cx, cy ) {

		const c = Math.cos( rotation );
		const s = Math.sin( rotation );

		this.set(
			sx * c, sx * s, - sx * ( c * cx + s * cy ) + cx + tx,
			- sy * s, sy * c, - sy * ( - s * cx + c * cy ) + cy + ty,
			0, 0, 1
		);

		return this;

	}

	//

	scale( sx, sy ) {

		this.premultiply( _m3$1.makeScale( sx, sy ) );

		return this;

	}

	rotate( theta ) {

		this.premultiply( _m3$1.makeRotation( - theta ) );

		return this;

	}

	translate( tx, ty ) {

		this.premultiply( _m3$1.makeTranslation( tx, ty ) );

		return this;

	}

	// for 2D Transforms

	makeTranslation( x, y ) {

		if ( x.isVector2 ) {

			this.set(

				1, 0, x.x,
				0, 1, x.y,
				0, 0, 1

			);

		} else {

			this.set(

				1, 0, x,
				0, 1, y,
				0, 0, 1

			);

		}

		return this;

	}

	makeRotation( theta ) {

		// counterclockwise

		const c = Math.cos( theta );
		const s = Math.sin( theta );

		this.set(

			c, - s, 0,
			s, c, 0,
			0, 0, 1

		);

		return this;

	}

	makeScale( x, y ) {

		this.set(

			x, 0, 0,
			0, y, 0,
			0, 0, 1

		);

		return this;

	}

	//

	equals( matrix ) {

		const te = this.elements;
		const me = matrix.elements;

		for ( let i = 0; i < 9; i ++ ) {

			if ( te[ i ] !== me[ i ] ) return false;

		}

		return true;

	}

	fromArray( array, offset = 0 ) {

		for ( let i = 0; i < 9; i ++ ) {

			this.elements[ i ] = array[ i + offset ];

		}

		return this;

	}

	toArray( array = [], offset = 0 ) {

		const te = this.elements;

		array[ offset ] = te[ 0 ];
		array[ offset + 1 ] = te[ 1 ];
		array[ offset + 2 ] = te[ 2 ];

		array[ offset + 3 ] = te[ 3 ];
		array[ offset + 4 ] = te[ 4 ];
		array[ offset + 5 ] = te[ 5 ];

		array[ offset + 6 ] = te[ 6 ];
		array[ offset + 7 ] = te[ 7 ];
		array[ offset + 8 ] = te[ 8 ];

		return array;

	}

	clone() {

		return new this.constructor().fromArray( this.elements );

	}

};

const _m3$1 = /*@__PURE__*/ new Matrix3$1();

function arrayNeedsUint32$1( array ) {

	// assumes larger values usually on last

	for ( let i = array.length - 1; i >= 0; -- i ) {

		if ( array[ i ] >= 65535 ) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565

	}

	return false;

}

function createElementNS$1( name ) {

	return document.createElementNS( 'http://www.w3.org/1999/xhtml', name );

}

const _cache$1 = {};

function warnOnce$1( message ) {

	if ( message in _cache$1 ) return;

	_cache$1[ message ] = true;

	console.warn( message );

}

/**
 * Matrices converting P3 <-> Rec. 709 primaries, without gamut mapping
 * or clipping. Based on W3C specifications for sRGB and Display P3,
 * and ICC specifications for the D50 connection space. Values in/out
 * are _linear_ sRGB and _linear_ Display P3.
 *
 * Note that both sRGB and Display P3 use the sRGB transfer functions.
 *
 * Reference:
 * - http://www.russellcottrell.com/photo/matrixCalculator.htm
 */

const LINEAR_SRGB_TO_LINEAR_DISPLAY_P3$1 = /*@__PURE__*/ new Matrix3$1().set(
	0.8224621, 0.177538, 0.0,
	0.0331941, 0.9668058, 0.0,
	0.0170827, 0.0723974, 0.9105199,
);

const LINEAR_DISPLAY_P3_TO_LINEAR_SRGB$1 = /*@__PURE__*/ new Matrix3$1().set(
	1.2249401, - 0.2249404, 0.0,
	- 0.0420569, 1.0420571, 0.0,
	- 0.0196376, - 0.0786361, 1.0982735
);

/**
 * Defines supported color spaces by transfer function and primaries,
 * and provides conversions to/from the Linear-sRGB reference space.
 */
const COLOR_SPACES$1 = {
	[ LinearSRGBColorSpace$1 ]: {
		transfer: LinearTransfer$1,
		primaries: Rec709Primaries$1,
		toReference: ( color ) => color,
		fromReference: ( color ) => color,
	},
	[ SRGBColorSpace$1 ]: {
		transfer: SRGBTransfer$1,
		primaries: Rec709Primaries$1,
		toReference: ( color ) => color.convertSRGBToLinear(),
		fromReference: ( color ) => color.convertLinearToSRGB(),
	},
	[ LinearDisplayP3ColorSpace$1 ]: {
		transfer: LinearTransfer$1,
		primaries: P3Primaries$1,
		toReference: ( color ) => color.applyMatrix3( LINEAR_DISPLAY_P3_TO_LINEAR_SRGB$1 ),
		fromReference: ( color ) => color.applyMatrix3( LINEAR_SRGB_TO_LINEAR_DISPLAY_P3$1 ),
	},
	[ DisplayP3ColorSpace$1 ]: {
		transfer: SRGBTransfer$1,
		primaries: P3Primaries$1,
		toReference: ( color ) => color.convertSRGBToLinear().applyMatrix3( LINEAR_DISPLAY_P3_TO_LINEAR_SRGB$1 ),
		fromReference: ( color ) => color.applyMatrix3( LINEAR_SRGB_TO_LINEAR_DISPLAY_P3$1 ).convertLinearToSRGB(),
	},
};

const SUPPORTED_WORKING_COLOR_SPACES$1 = new Set( [ LinearSRGBColorSpace$1, LinearDisplayP3ColorSpace$1 ] );

const ColorManagement$1 = {

	enabled: true,

	_workingColorSpace: LinearSRGBColorSpace$1,

	get workingColorSpace() {

		return this._workingColorSpace;

	},

	set workingColorSpace( colorSpace ) {

		if ( ! SUPPORTED_WORKING_COLOR_SPACES$1.has( colorSpace ) ) {

			throw new Error( `Unsupported working color space, "${ colorSpace }".` );

		}

		this._workingColorSpace = colorSpace;

	},

	convert: function ( color, sourceColorSpace, targetColorSpace ) {

		if ( this.enabled === false || sourceColorSpace === targetColorSpace || ! sourceColorSpace || ! targetColorSpace ) {

			return color;

		}

		const sourceToReference = COLOR_SPACES$1[ sourceColorSpace ].toReference;
		const targetFromReference = COLOR_SPACES$1[ targetColorSpace ].fromReference;

		return targetFromReference( sourceToReference( color ) );

	},

	fromWorkingColorSpace: function ( color, targetColorSpace ) {

		return this.convert( color, this._workingColorSpace, targetColorSpace );

	},

	toWorkingColorSpace: function ( color, sourceColorSpace ) {

		return this.convert( color, sourceColorSpace, this._workingColorSpace );

	},

	getPrimaries: function ( colorSpace ) {

		return COLOR_SPACES$1[ colorSpace ].primaries;

	},

	getTransfer: function ( colorSpace ) {

		if ( colorSpace === NoColorSpace$1 ) return LinearTransfer$1;

		return COLOR_SPACES$1[ colorSpace ].transfer;

	},

};


function SRGBToLinear$1( c ) {

	return ( c < 0.04045 ) ? c * 0.0773993808 : Math.pow( c * 0.9478672986 + 0.0521327014, 2.4 );

}

function LinearToSRGB$1( c ) {

	return ( c < 0.0031308 ) ? c * 12.92 : 1.055 * ( Math.pow( c, 0.41666 ) ) - 0.055;

}

let _canvas$1;

let ImageUtils$1=class ImageUtils {

	static getDataURL( image ) {

		if ( /^data:/i.test( image.src ) ) {

			return image.src;

		}

		if ( typeof HTMLCanvasElement === 'undefined' ) {

			return image.src;

		}

		let canvas;

		if ( image instanceof HTMLCanvasElement ) {

			canvas = image;

		} else {

			if ( _canvas$1 === undefined ) _canvas$1 = createElementNS$1( 'canvas' );

			_canvas$1.width = image.width;
			_canvas$1.height = image.height;

			const context = _canvas$1.getContext( '2d' );

			if ( image instanceof ImageData ) {

				context.putImageData( image, 0, 0 );

			} else {

				context.drawImage( image, 0, 0, image.width, image.height );

			}

			canvas = _canvas$1;

		}

		if ( canvas.width > 2048 || canvas.height > 2048 ) {

			console.warn( 'THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons', image );

			return canvas.toDataURL( 'image/jpeg', 0.6 );

		} else {

			return canvas.toDataURL( 'image/png' );

		}

	}

	static sRGBToLinear( image ) {

		if ( ( typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement ) ||
			( typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement ) ||
			( typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap ) ) {

			const canvas = createElementNS$1( 'canvas' );

			canvas.width = image.width;
			canvas.height = image.height;

			const context = canvas.getContext( '2d' );
			context.drawImage( image, 0, 0, image.width, image.height );

			const imageData = context.getImageData( 0, 0, image.width, image.height );
			const data = imageData.data;

			for ( let i = 0; i < data.length; i ++ ) {

				data[ i ] = SRGBToLinear$1( data[ i ] / 255 ) * 255;

			}

			context.putImageData( imageData, 0, 0 );

			return canvas;

		} else if ( image.data ) {

			const data = image.data.slice( 0 );

			for ( let i = 0; i < data.length; i ++ ) {

				if ( data instanceof Uint8Array || data instanceof Uint8ClampedArray ) {

					data[ i ] = Math.floor( SRGBToLinear$1( data[ i ] / 255 ) * 255 );

				} else {

					// assuming float

					data[ i ] = SRGBToLinear$1( data[ i ] );

				}

			}

			return {
				data: data,
				width: image.width,
				height: image.height
			};

		} else {

			console.warn( 'THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.' );
			return image;

		}

	}

};

let _sourceId$1 = 0;

let Source$1=class Source {

	constructor( data = null ) {

		this.isSource = true;

		Object.defineProperty( this, 'id', { value: _sourceId$1 ++ } );

		this.uuid = generateUUID$1();

		this.data = data;
		this.dataReady = true;

		this.version = 0;

	}

	set needsUpdate( value ) {

		if ( value === true ) this.version ++;

	}

	toJSON( meta ) {

		const isRootObject = ( meta === undefined || typeof meta === 'string' );

		if ( ! isRootObject && meta.images[ this.uuid ] !== undefined ) {

			return meta.images[ this.uuid ];

		}

		const output = {
			uuid: this.uuid,
			url: ''
		};

		const data = this.data;

		if ( data !== null ) {

			let url;

			if ( Array.isArray( data ) ) {

				// cube texture

				url = [];

				for ( let i = 0, l = data.length; i < l; i ++ ) {

					if ( data[ i ].isDataTexture ) {

						url.push( serializeImage$1( data[ i ].image ) );

					} else {

						url.push( serializeImage$1( data[ i ] ) );

					}

				}

			} else {

				// texture

				url = serializeImage$1( data );

			}

			output.url = url;

		}

		if ( ! isRootObject ) {

			meta.images[ this.uuid ] = output;

		}

		return output;

	}

};

function serializeImage$1( image ) {

	if ( ( typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement ) ||
		( typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement ) ||
		( typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap ) ) {

		// default images

		return ImageUtils$1.getDataURL( image );

	} else {

		if ( image.data ) {

			// images of DataTexture

			return {
				data: Array.from( image.data ),
				width: image.width,
				height: image.height,
				type: image.data.constructor.name
			};

		} else {

			console.warn( 'THREE.Texture: Unable to serialize Texture.' );
			return {};

		}

	}

}

let _textureId$1 = 0;

let Texture$1=class Texture extends EventDispatcher$3 {

	constructor( image = Texture.DEFAULT_IMAGE, mapping = Texture.DEFAULT_MAPPING, wrapS = ClampToEdgeWrapping$1, wrapT = ClampToEdgeWrapping$1, magFilter = LinearFilter$1, minFilter = LinearMipmapLinearFilter$1, format = RGBAFormat$1, type = UnsignedByteType$1, anisotropy = Texture.DEFAULT_ANISOTROPY, colorSpace = NoColorSpace$1 ) {

		super();

		this.isTexture = true;

		Object.defineProperty( this, 'id', { value: _textureId$1 ++ } );

		this.uuid = generateUUID$1();

		this.name = '';

		this.source = new Source$1( image );
		this.mipmaps = [];

		this.mapping = mapping;
		this.channel = 0;

		this.wrapS = wrapS;
		this.wrapT = wrapT;

		this.magFilter = magFilter;
		this.minFilter = minFilter;

		this.anisotropy = anisotropy;

		this.format = format;
		this.internalFormat = null;
		this.type = type;

		this.offset = new Vector2$1( 0, 0 );
		this.repeat = new Vector2$1( 1, 1 );
		this.center = new Vector2$1( 0, 0 );
		this.rotation = 0;

		this.matrixAutoUpdate = true;
		this.matrix = new Matrix3$1();

		this.generateMipmaps = true;
		this.premultiplyAlpha = false;
		this.flipY = true;
		this.unpackAlignment = 4;	// valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)

		this.colorSpace = colorSpace;

		this.userData = {};

		this.version = 0;
		this.onUpdate = null;

		this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
		this.pmremVersion = 0; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)

	}

	get image() {

		return this.source.data;

	}

	set image( value = null ) {

		this.source.data = value;

	}

	updateMatrix() {

		this.matrix.setUvTransform( this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y );

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( source ) {

		this.name = source.name;

		this.source = source.source;
		this.mipmaps = source.mipmaps.slice( 0 );

		this.mapping = source.mapping;
		this.channel = source.channel;

		this.wrapS = source.wrapS;
		this.wrapT = source.wrapT;

		this.magFilter = source.magFilter;
		this.minFilter = source.minFilter;

		this.anisotropy = source.anisotropy;

		this.format = source.format;
		this.internalFormat = source.internalFormat;
		this.type = source.type;

		this.offset.copy( source.offset );
		this.repeat.copy( source.repeat );
		this.center.copy( source.center );
		this.rotation = source.rotation;

		this.matrixAutoUpdate = source.matrixAutoUpdate;
		this.matrix.copy( source.matrix );

		this.generateMipmaps = source.generateMipmaps;
		this.premultiplyAlpha = source.premultiplyAlpha;
		this.flipY = source.flipY;
		this.unpackAlignment = source.unpackAlignment;
		this.colorSpace = source.colorSpace;

		this.userData = JSON.parse( JSON.stringify( source.userData ) );

		this.needsUpdate = true;

		return this;

	}

	toJSON( meta ) {

		const isRootObject = ( meta === undefined || typeof meta === 'string' );

		if ( ! isRootObject && meta.textures[ this.uuid ] !== undefined ) {

			return meta.textures[ this.uuid ];

		}

		const output = {

			metadata: {
				version: 4.6,
				type: 'Texture',
				generator: 'Texture.toJSON'
			},

			uuid: this.uuid,
			name: this.name,

			image: this.source.toJSON( meta ).uuid,

			mapping: this.mapping,
			channel: this.channel,

			repeat: [ this.repeat.x, this.repeat.y ],
			offset: [ this.offset.x, this.offset.y ],
			center: [ this.center.x, this.center.y ],
			rotation: this.rotation,

			wrap: [ this.wrapS, this.wrapT ],

			format: this.format,
			internalFormat: this.internalFormat,
			type: this.type,
			colorSpace: this.colorSpace,

			minFilter: this.minFilter,
			magFilter: this.magFilter,
			anisotropy: this.anisotropy,

			flipY: this.flipY,

			generateMipmaps: this.generateMipmaps,
			premultiplyAlpha: this.premultiplyAlpha,
			unpackAlignment: this.unpackAlignment

		};

		if ( Object.keys( this.userData ).length > 0 ) output.userData = this.userData;

		if ( ! isRootObject ) {

			meta.textures[ this.uuid ] = output;

		}

		return output;

	}

	dispose() {

		this.dispatchEvent( { type: 'dispose' } );

	}

	transformUv( uv ) {

		if ( this.mapping !== UVMapping$1 ) return uv;

		uv.applyMatrix3( this.matrix );

		if ( uv.x < 0 || uv.x > 1 ) {

			switch ( this.wrapS ) {

				case RepeatWrapping$1:

					uv.x = uv.x - Math.floor( uv.x );
					break;

				case ClampToEdgeWrapping$1:

					uv.x = uv.x < 0 ? 0 : 1;
					break;

				case MirroredRepeatWrapping$1:

					if ( Math.abs( Math.floor( uv.x ) % 2 ) === 1 ) {

						uv.x = Math.ceil( uv.x ) - uv.x;

					} else {

						uv.x = uv.x - Math.floor( uv.x );

					}

					break;

			}

		}

		if ( uv.y < 0 || uv.y > 1 ) {

			switch ( this.wrapT ) {

				case RepeatWrapping$1:

					uv.y = uv.y - Math.floor( uv.y );
					break;

				case ClampToEdgeWrapping$1:

					uv.y = uv.y < 0 ? 0 : 1;
					break;

				case MirroredRepeatWrapping$1:

					if ( Math.abs( Math.floor( uv.y ) % 2 ) === 1 ) {

						uv.y = Math.ceil( uv.y ) - uv.y;

					} else {

						uv.y = uv.y - Math.floor( uv.y );

					}

					break;

			}

		}

		if ( this.flipY ) {

			uv.y = 1 - uv.y;

		}

		return uv;

	}

	set needsUpdate( value ) {

		if ( value === true ) {

			this.version ++;
			this.source.needsUpdate = true;

		}

	}

	set needsPMREMUpdate( value ) {

		if ( value === true ) {

			this.pmremVersion ++;

		}

	}

};

Texture$1.DEFAULT_IMAGE = null;
Texture$1.DEFAULT_MAPPING = UVMapping$1;
Texture$1.DEFAULT_ANISOTROPY = 1;

let Quaternion$1=class Quaternion {

	constructor( x = 0, y = 0, z = 0, w = 1 ) {

		this.isQuaternion = true;

		this._x = x;
		this._y = y;
		this._z = z;
		this._w = w;

	}

	static slerpFlat( dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t ) {

		// fuzz-free, array-based Quaternion SLERP operation

		let x0 = src0[ srcOffset0 + 0 ],
			y0 = src0[ srcOffset0 + 1 ],
			z0 = src0[ srcOffset0 + 2 ],
			w0 = src0[ srcOffset0 + 3 ];

		const x1 = src1[ srcOffset1 + 0 ],
			y1 = src1[ srcOffset1 + 1 ],
			z1 = src1[ srcOffset1 + 2 ],
			w1 = src1[ srcOffset1 + 3 ];

		if ( t === 0 ) {

			dst[ dstOffset + 0 ] = x0;
			dst[ dstOffset + 1 ] = y0;
			dst[ dstOffset + 2 ] = z0;
			dst[ dstOffset + 3 ] = w0;
			return;

		}

		if ( t === 1 ) {

			dst[ dstOffset + 0 ] = x1;
			dst[ dstOffset + 1 ] = y1;
			dst[ dstOffset + 2 ] = z1;
			dst[ dstOffset + 3 ] = w1;
			return;

		}

		if ( w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1 ) {

			let s = 1 - t;
			const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1,
				dir = ( cos >= 0 ? 1 : - 1 ),
				sqrSin = 1 - cos * cos;

			// Skip the Slerp for tiny steps to avoid numeric problems:
			if ( sqrSin > Number.EPSILON ) {

				const sin = Math.sqrt( sqrSin ),
					len = Math.atan2( sin, cos * dir );

				s = Math.sin( s * len ) / sin;
				t = Math.sin( t * len ) / sin;

			}

			const tDir = t * dir;

			x0 = x0 * s + x1 * tDir;
			y0 = y0 * s + y1 * tDir;
			z0 = z0 * s + z1 * tDir;
			w0 = w0 * s + w1 * tDir;

			// Normalize in case we just did a lerp:
			if ( s === 1 - t ) {

				const f = 1 / Math.sqrt( x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0 );

				x0 *= f;
				y0 *= f;
				z0 *= f;
				w0 *= f;

			}

		}

		dst[ dstOffset ] = x0;
		dst[ dstOffset + 1 ] = y0;
		dst[ dstOffset + 2 ] = z0;
		dst[ dstOffset + 3 ] = w0;

	}

	static multiplyQuaternionsFlat( dst, dstOffset, src0, srcOffset0, src1, srcOffset1 ) {

		const x0 = src0[ srcOffset0 ];
		const y0 = src0[ srcOffset0 + 1 ];
		const z0 = src0[ srcOffset0 + 2 ];
		const w0 = src0[ srcOffset0 + 3 ];

		const x1 = src1[ srcOffset1 ];
		const y1 = src1[ srcOffset1 + 1 ];
		const z1 = src1[ srcOffset1 + 2 ];
		const w1 = src1[ srcOffset1 + 3 ];

		dst[ dstOffset ] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
		dst[ dstOffset + 1 ] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
		dst[ dstOffset + 2 ] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
		dst[ dstOffset + 3 ] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;

		return dst;

	}

	get x() {

		return this._x;

	}

	set x( value ) {

		this._x = value;
		this._onChangeCallback();

	}

	get y() {

		return this._y;

	}

	set y( value ) {

		this._y = value;
		this._onChangeCallback();

	}

	get z() {

		return this._z;

	}

	set z( value ) {

		this._z = value;
		this._onChangeCallback();

	}

	get w() {

		return this._w;

	}

	set w( value ) {

		this._w = value;
		this._onChangeCallback();

	}

	set( x, y, z, w ) {

		this._x = x;
		this._y = y;
		this._z = z;
		this._w = w;

		this._onChangeCallback();

		return this;

	}

	clone() {

		return new this.constructor( this._x, this._y, this._z, this._w );

	}

	copy( quaternion ) {

		this._x = quaternion.x;
		this._y = quaternion.y;
		this._z = quaternion.z;
		this._w = quaternion.w;

		this._onChangeCallback();

		return this;

	}

	setFromEuler( euler, update = true ) {

		const x = euler._x, y = euler._y, z = euler._z, order = euler._order;

		// http://www.mathworks.com/matlabcentral/fileexchange/
		// 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
		//	content/SpinCalc.m

		const cos = Math.cos;
		const sin = Math.sin;

		const c1 = cos( x / 2 );
		const c2 = cos( y / 2 );
		const c3 = cos( z / 2 );

		const s1 = sin( x / 2 );
		const s2 = sin( y / 2 );
		const s3 = sin( z / 2 );

		switch ( order ) {

			case 'XYZ':
				this._x = s1 * c2 * c3 + c1 * s2 * s3;
				this._y = c1 * s2 * c3 - s1 * c2 * s3;
				this._z = c1 * c2 * s3 + s1 * s2 * c3;
				this._w = c1 * c2 * c3 - s1 * s2 * s3;
				break;

			case 'YXZ':
				this._x = s1 * c2 * c3 + c1 * s2 * s3;
				this._y = c1 * s2 * c3 - s1 * c2 * s3;
				this._z = c1 * c2 * s3 - s1 * s2 * c3;
				this._w = c1 * c2 * c3 + s1 * s2 * s3;
				break;

			case 'ZXY':
				this._x = s1 * c2 * c3 - c1 * s2 * s3;
				this._y = c1 * s2 * c3 + s1 * c2 * s3;
				this._z = c1 * c2 * s3 + s1 * s2 * c3;
				this._w = c1 * c2 * c3 - s1 * s2 * s3;
				break;

			case 'ZYX':
				this._x = s1 * c2 * c3 - c1 * s2 * s3;
				this._y = c1 * s2 * c3 + s1 * c2 * s3;
				this._z = c1 * c2 * s3 - s1 * s2 * c3;
				this._w = c1 * c2 * c3 + s1 * s2 * s3;
				break;

			case 'YZX':
				this._x = s1 * c2 * c3 + c1 * s2 * s3;
				this._y = c1 * s2 * c3 + s1 * c2 * s3;
				this._z = c1 * c2 * s3 - s1 * s2 * c3;
				this._w = c1 * c2 * c3 - s1 * s2 * s3;
				break;

			case 'XZY':
				this._x = s1 * c2 * c3 - c1 * s2 * s3;
				this._y = c1 * s2 * c3 - s1 * c2 * s3;
				this._z = c1 * c2 * s3 + s1 * s2 * c3;
				this._w = c1 * c2 * c3 + s1 * s2 * s3;
				break;

			default:
				console.warn( 'THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order );

		}

		if ( update === true ) this._onChangeCallback();

		return this;

	}

	setFromAxisAngle( axis, angle ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm

		// assumes axis is normalized

		const halfAngle = angle / 2, s = Math.sin( halfAngle );

		this._x = axis.x * s;
		this._y = axis.y * s;
		this._z = axis.z * s;
		this._w = Math.cos( halfAngle );

		this._onChangeCallback();

		return this;

	}

	setFromRotationMatrix( m ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		const te = m.elements,

			m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ],
			m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ],
			m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ],

			trace = m11 + m22 + m33;

		if ( trace > 0 ) {

			const s = 0.5 / Math.sqrt( trace + 1.0 );

			this._w = 0.25 / s;
			this._x = ( m32 - m23 ) * s;
			this._y = ( m13 - m31 ) * s;
			this._z = ( m21 - m12 ) * s;

		} else if ( m11 > m22 && m11 > m33 ) {

			const s = 2.0 * Math.sqrt( 1.0 + m11 - m22 - m33 );

			this._w = ( m32 - m23 ) / s;
			this._x = 0.25 * s;
			this._y = ( m12 + m21 ) / s;
			this._z = ( m13 + m31 ) / s;

		} else if ( m22 > m33 ) {

			const s = 2.0 * Math.sqrt( 1.0 + m22 - m11 - m33 );

			this._w = ( m13 - m31 ) / s;
			this._x = ( m12 + m21 ) / s;
			this._y = 0.25 * s;
			this._z = ( m23 + m32 ) / s;

		} else {

			const s = 2.0 * Math.sqrt( 1.0 + m33 - m11 - m22 );

			this._w = ( m21 - m12 ) / s;
			this._x = ( m13 + m31 ) / s;
			this._y = ( m23 + m32 ) / s;
			this._z = 0.25 * s;

		}

		this._onChangeCallback();

		return this;

	}

	setFromUnitVectors( vFrom, vTo ) {

		// assumes direction vectors vFrom and vTo are normalized

		let r = vFrom.dot( vTo ) + 1;

		if ( r < Number.EPSILON ) {

			// vFrom and vTo point in opposite directions

			r = 0;

			if ( Math.abs( vFrom.x ) > Math.abs( vFrom.z ) ) {

				this._x = - vFrom.y;
				this._y = vFrom.x;
				this._z = 0;
				this._w = r;

			} else {

				this._x = 0;
				this._y = - vFrom.z;
				this._z = vFrom.y;
				this._w = r;

			}

		} else {

			// crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3

			this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
			this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
			this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
			this._w = r;

		}

		return this.normalize();

	}

	angleTo( q ) {

		return 2 * Math.acos( Math.abs( clamp$1( this.dot( q ), - 1, 1 ) ) );

	}

	rotateTowards( q, step ) {

		const angle = this.angleTo( q );

		if ( angle === 0 ) return this;

		const t = Math.min( 1, step / angle );

		this.slerp( q, t );

		return this;

	}

	identity() {

		return this.set( 0, 0, 0, 1 );

	}

	invert() {

		// quaternion is assumed to have unit length

		return this.conjugate();

	}

	conjugate() {

		this._x *= - 1;
		this._y *= - 1;
		this._z *= - 1;

		this._onChangeCallback();

		return this;

	}

	dot( v ) {

		return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;

	}

	lengthSq() {

		return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;

	}

	length() {

		return Math.sqrt( this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w );

	}

	normalize() {

		let l = this.length();

		if ( l === 0 ) {

			this._x = 0;
			this._y = 0;
			this._z = 0;
			this._w = 1;

		} else {

			l = 1 / l;

			this._x = this._x * l;
			this._y = this._y * l;
			this._z = this._z * l;
			this._w = this._w * l;

		}

		this._onChangeCallback();

		return this;

	}

	multiply( q ) {

		return this.multiplyQuaternions( this, q );

	}

	premultiply( q ) {

		return this.multiplyQuaternions( q, this );

	}

	multiplyQuaternions( a, b ) {

		// from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm

		const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
		const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;

		this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
		this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
		this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
		this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;

		this._onChangeCallback();

		return this;

	}

	slerp( qb, t ) {

		if ( t === 0 ) return this;
		if ( t === 1 ) return this.copy( qb );

		const x = this._x, y = this._y, z = this._z, w = this._w;

		// http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/

		let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;

		if ( cosHalfTheta < 0 ) {

			this._w = - qb._w;
			this._x = - qb._x;
			this._y = - qb._y;
			this._z = - qb._z;

			cosHalfTheta = - cosHalfTheta;

		} else {

			this.copy( qb );

		}

		if ( cosHalfTheta >= 1.0 ) {

			this._w = w;
			this._x = x;
			this._y = y;
			this._z = z;

			return this;

		}

		const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;

		if ( sqrSinHalfTheta <= Number.EPSILON ) {

			const s = 1 - t;
			this._w = s * w + t * this._w;
			this._x = s * x + t * this._x;
			this._y = s * y + t * this._y;
			this._z = s * z + t * this._z;

			this.normalize(); // normalize calls _onChangeCallback()

			return this;

		}

		const sinHalfTheta = Math.sqrt( sqrSinHalfTheta );
		const halfTheta = Math.atan2( sinHalfTheta, cosHalfTheta );
		const ratioA = Math.sin( ( 1 - t ) * halfTheta ) / sinHalfTheta,
			ratioB = Math.sin( t * halfTheta ) / sinHalfTheta;

		this._w = ( w * ratioA + this._w * ratioB );
		this._x = ( x * ratioA + this._x * ratioB );
		this._y = ( y * ratioA + this._y * ratioB );
		this._z = ( z * ratioA + this._z * ratioB );

		this._onChangeCallback();

		return this;

	}

	slerpQuaternions( qa, qb, t ) {

		return this.copy( qa ).slerp( qb, t );

	}

	random() {

		// sets this quaternion to a uniform random unit quaternnion

		// Ken Shoemake
		// Uniform random rotations
		// D. Kirk, editor, Graphics Gems III, pages 124-132. Academic Press, New York, 1992.

		const theta1 = 2 * Math.PI * Math.random();
		const theta2 = 2 * Math.PI * Math.random();

		const x0 = Math.random();
		const r1 = Math.sqrt( 1 - x0 );
		const r2 = Math.sqrt( x0 );

		return this.set(
			r1 * Math.sin( theta1 ),
			r1 * Math.cos( theta1 ),
			r2 * Math.sin( theta2 ),
			r2 * Math.cos( theta2 ),
		);

	}

	equals( quaternion ) {

		return ( quaternion._x === this._x ) && ( quaternion._y === this._y ) && ( quaternion._z === this._z ) && ( quaternion._w === this._w );

	}

	fromArray( array, offset = 0 ) {

		this._x = array[ offset ];
		this._y = array[ offset + 1 ];
		this._z = array[ offset + 2 ];
		this._w = array[ offset + 3 ];

		this._onChangeCallback();

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this._x;
		array[ offset + 1 ] = this._y;
		array[ offset + 2 ] = this._z;
		array[ offset + 3 ] = this._w;

		return array;

	}

	fromBufferAttribute( attribute, index ) {

		this._x = attribute.getX( index );
		this._y = attribute.getY( index );
		this._z = attribute.getZ( index );
		this._w = attribute.getW( index );

		this._onChangeCallback();

		return this;

	}

	toJSON() {

		return this.toArray();

	}

	_onChange( callback ) {

		this._onChangeCallback = callback;

		return this;

	}

	_onChangeCallback() {}

	*[ Symbol.iterator ]() {

		yield this._x;
		yield this._y;
		yield this._z;
		yield this._w;

	}

};

let Vector3$1=class Vector3 {

	constructor( x = 0, y = 0, z = 0 ) {

		Vector3.prototype.isVector3 = true;

		this.x = x;
		this.y = y;
		this.z = z;

	}

	set( x, y, z ) {

		if ( z === undefined ) z = this.z; // sprite.scale.set(x,y)

		this.x = x;
		this.y = y;
		this.z = z;

		return this;

	}

	setScalar( scalar ) {

		this.x = scalar;
		this.y = scalar;
		this.z = scalar;

		return this;

	}

	setX( x ) {

		this.x = x;

		return this;

	}

	setY( y ) {

		this.y = y;

		return this;

	}

	setZ( z ) {

		this.z = z;

		return this;

	}

	setComponent( index, value ) {

		switch ( index ) {

			case 0: this.x = value; break;
			case 1: this.y = value; break;
			case 2: this.z = value; break;
			default: throw new Error( 'index is out of range: ' + index );

		}

		return this;

	}

	getComponent( index ) {

		switch ( index ) {

			case 0: return this.x;
			case 1: return this.y;
			case 2: return this.z;
			default: throw new Error( 'index is out of range: ' + index );

		}

	}

	clone() {

		return new this.constructor( this.x, this.y, this.z );

	}

	copy( v ) {

		this.x = v.x;
		this.y = v.y;
		this.z = v.z;

		return this;

	}

	add( v ) {

		this.x += v.x;
		this.y += v.y;
		this.z += v.z;

		return this;

	}

	addScalar( s ) {

		this.x += s;
		this.y += s;
		this.z += s;

		return this;

	}

	addVectors( a, b ) {

		this.x = a.x + b.x;
		this.y = a.y + b.y;
		this.z = a.z + b.z;

		return this;

	}

	addScaledVector( v, s ) {

		this.x += v.x * s;
		this.y += v.y * s;
		this.z += v.z * s;

		return this;

	}

	sub( v ) {

		this.x -= v.x;
		this.y -= v.y;
		this.z -= v.z;

		return this;

	}

	subScalar( s ) {

		this.x -= s;
		this.y -= s;
		this.z -= s;

		return this;

	}

	subVectors( a, b ) {

		this.x = a.x - b.x;
		this.y = a.y - b.y;
		this.z = a.z - b.z;

		return this;

	}

	multiply( v ) {

		this.x *= v.x;
		this.y *= v.y;
		this.z *= v.z;

		return this;

	}

	multiplyScalar( scalar ) {

		this.x *= scalar;
		this.y *= scalar;
		this.z *= scalar;

		return this;

	}

	multiplyVectors( a, b ) {

		this.x = a.x * b.x;
		this.y = a.y * b.y;
		this.z = a.z * b.z;

		return this;

	}

	applyEuler( euler ) {

		return this.applyQuaternion( _quaternion$4$1.setFromEuler( euler ) );

	}

	applyAxisAngle( axis, angle ) {

		return this.applyQuaternion( _quaternion$4$1.setFromAxisAngle( axis, angle ) );

	}

	applyMatrix3( m ) {

		const x = this.x, y = this.y, z = this.z;
		const e = m.elements;

		this.x = e[ 0 ] * x + e[ 3 ] * y + e[ 6 ] * z;
		this.y = e[ 1 ] * x + e[ 4 ] * y + e[ 7 ] * z;
		this.z = e[ 2 ] * x + e[ 5 ] * y + e[ 8 ] * z;

		return this;

	}

	applyNormalMatrix( m ) {

		return this.applyMatrix3( m ).normalize();

	}

	applyMatrix4( m ) {

		const x = this.x, y = this.y, z = this.z;
		const e = m.elements;

		const w = 1 / ( e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ] );

		this.x = ( e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z + e[ 12 ] ) * w;
		this.y = ( e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z + e[ 13 ] ) * w;
		this.z = ( e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ] ) * w;

		return this;

	}

	applyQuaternion( q ) {

		// quaternion q is assumed to have unit length

		const vx = this.x, vy = this.y, vz = this.z;
		const qx = q.x, qy = q.y, qz = q.z, qw = q.w;

		// t = 2 * cross( q.xyz, v );
		const tx = 2 * ( qy * vz - qz * vy );
		const ty = 2 * ( qz * vx - qx * vz );
		const tz = 2 * ( qx * vy - qy * vx );

		// v + q.w * t + cross( q.xyz, t );
		this.x = vx + qw * tx + qy * tz - qz * ty;
		this.y = vy + qw * ty + qz * tx - qx * tz;
		this.z = vz + qw * tz + qx * ty - qy * tx;

		return this;

	}

	project( camera ) {

		return this.applyMatrix4( camera.matrixWorldInverse ).applyMatrix4( camera.projectionMatrix );

	}

	unproject( camera ) {

		return this.applyMatrix4( camera.projectionMatrixInverse ).applyMatrix4( camera.matrixWorld );

	}

	transformDirection( m ) {

		// input: THREE.Matrix4 affine matrix
		// vector interpreted as a direction

		const x = this.x, y = this.y, z = this.z;
		const e = m.elements;

		this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z;
		this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z;
		this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z;

		return this.normalize();

	}

	divide( v ) {

		this.x /= v.x;
		this.y /= v.y;
		this.z /= v.z;

		return this;

	}

	divideScalar( scalar ) {

		return this.multiplyScalar( 1 / scalar );

	}

	min( v ) {

		this.x = Math.min( this.x, v.x );
		this.y = Math.min( this.y, v.y );
		this.z = Math.min( this.z, v.z );

		return this;

	}

	max( v ) {

		this.x = Math.max( this.x, v.x );
		this.y = Math.max( this.y, v.y );
		this.z = Math.max( this.z, v.z );

		return this;

	}

	clamp( min, max ) {

		// assumes min < max, componentwise

		this.x = Math.max( min.x, Math.min( max.x, this.x ) );
		this.y = Math.max( min.y, Math.min( max.y, this.y ) );
		this.z = Math.max( min.z, Math.min( max.z, this.z ) );

		return this;

	}

	clampScalar( minVal, maxVal ) {

		this.x = Math.max( minVal, Math.min( maxVal, this.x ) );
		this.y = Math.max( minVal, Math.min( maxVal, this.y ) );
		this.z = Math.max( minVal, Math.min( maxVal, this.z ) );

		return this;

	}

	clampLength( min, max ) {

		const length = this.length();

		return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );

	}

	floor() {

		this.x = Math.floor( this.x );
		this.y = Math.floor( this.y );
		this.z = Math.floor( this.z );

		return this;

	}

	ceil() {

		this.x = Math.ceil( this.x );
		this.y = Math.ceil( this.y );
		this.z = Math.ceil( this.z );

		return this;

	}

	round() {

		this.x = Math.round( this.x );
		this.y = Math.round( this.y );
		this.z = Math.round( this.z );

		return this;

	}

	roundToZero() {

		this.x = Math.trunc( this.x );
		this.y = Math.trunc( this.y );
		this.z = Math.trunc( this.z );

		return this;

	}

	negate() {

		this.x = - this.x;
		this.y = - this.y;
		this.z = - this.z;

		return this;

	}

	dot( v ) {

		return this.x * v.x + this.y * v.y + this.z * v.z;

	}

	// TODO lengthSquared?

	lengthSq() {

		return this.x * this.x + this.y * this.y + this.z * this.z;

	}

	length() {

		return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z );

	}

	manhattanLength() {

		return Math.abs( this.x ) + Math.abs( this.y ) + Math.abs( this.z );

	}

	normalize() {

		return this.divideScalar( this.length() || 1 );

	}

	setLength( length ) {

		return this.normalize().multiplyScalar( length );

	}

	lerp( v, alpha ) {

		this.x += ( v.x - this.x ) * alpha;
		this.y += ( v.y - this.y ) * alpha;
		this.z += ( v.z - this.z ) * alpha;

		return this;

	}

	lerpVectors( v1, v2, alpha ) {

		this.x = v1.x + ( v2.x - v1.x ) * alpha;
		this.y = v1.y + ( v2.y - v1.y ) * alpha;
		this.z = v1.z + ( v2.z - v1.z ) * alpha;

		return this;

	}

	cross( v ) {

		return this.crossVectors( this, v );

	}

	crossVectors( a, b ) {

		const ax = a.x, ay = a.y, az = a.z;
		const bx = b.x, by = b.y, bz = b.z;

		this.x = ay * bz - az * by;
		this.y = az * bx - ax * bz;
		this.z = ax * by - ay * bx;

		return this;

	}

	projectOnVector( v ) {

		const denominator = v.lengthSq();

		if ( denominator === 0 ) return this.set( 0, 0, 0 );

		const scalar = v.dot( this ) / denominator;

		return this.copy( v ).multiplyScalar( scalar );

	}

	projectOnPlane( planeNormal ) {

		_vector$c$1.copy( this ).projectOnVector( planeNormal );

		return this.sub( _vector$c$1 );

	}

	reflect( normal ) {

		// reflect incident vector off plane orthogonal to normal
		// normal is assumed to have unit length

		return this.sub( _vector$c$1.copy( normal ).multiplyScalar( 2 * this.dot( normal ) ) );

	}

	angleTo( v ) {

		const denominator = Math.sqrt( this.lengthSq() * v.lengthSq() );

		if ( denominator === 0 ) return Math.PI / 2;

		const theta = this.dot( v ) / denominator;

		// clamp, to handle numerical problems

		return Math.acos( clamp$1( theta, - 1, 1 ) );

	}

	distanceTo( v ) {

		return Math.sqrt( this.distanceToSquared( v ) );

	}

	distanceToSquared( v ) {

		const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;

		return dx * dx + dy * dy + dz * dz;

	}

	manhattanDistanceTo( v ) {

		return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y ) + Math.abs( this.z - v.z );

	}

	setFromSpherical( s ) {

		return this.setFromSphericalCoords( s.radius, s.phi, s.theta );

	}

	setFromSphericalCoords( radius, phi, theta ) {

		const sinPhiRadius = Math.sin( phi ) * radius;

		this.x = sinPhiRadius * Math.sin( theta );
		this.y = Math.cos( phi ) * radius;
		this.z = sinPhiRadius * Math.cos( theta );

		return this;

	}

	setFromCylindrical( c ) {

		return this.setFromCylindricalCoords( c.radius, c.theta, c.y );

	}

	setFromCylindricalCoords( radius, theta, y ) {

		this.x = radius * Math.sin( theta );
		this.y = y;
		this.z = radius * Math.cos( theta );

		return this;

	}

	setFromMatrixPosition( m ) {

		const e = m.elements;

		this.x = e[ 12 ];
		this.y = e[ 13 ];
		this.z = e[ 14 ];

		return this;

	}

	setFromMatrixScale( m ) {

		const sx = this.setFromMatrixColumn( m, 0 ).length();
		const sy = this.setFromMatrixColumn( m, 1 ).length();
		const sz = this.setFromMatrixColumn( m, 2 ).length();

		this.x = sx;
		this.y = sy;
		this.z = sz;

		return this;

	}

	setFromMatrixColumn( m, index ) {

		return this.fromArray( m.elements, index * 4 );

	}

	setFromMatrix3Column( m, index ) {

		return this.fromArray( m.elements, index * 3 );

	}

	setFromEuler( e ) {

		this.x = e._x;
		this.y = e._y;
		this.z = e._z;

		return this;

	}

	setFromColor( c ) {

		this.x = c.r;
		this.y = c.g;
		this.z = c.b;

		return this;

	}

	equals( v ) {

		return ( ( v.x === this.x ) && ( v.y === this.y ) && ( v.z === this.z ) );

	}

	fromArray( array, offset = 0 ) {

		this.x = array[ offset ];
		this.y = array[ offset + 1 ];
		this.z = array[ offset + 2 ];

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this.x;
		array[ offset + 1 ] = this.y;
		array[ offset + 2 ] = this.z;

		return array;

	}

	fromBufferAttribute( attribute, index ) {

		this.x = attribute.getX( index );
		this.y = attribute.getY( index );
		this.z = attribute.getZ( index );

		return this;

	}

	random() {

		this.x = Math.random();
		this.y = Math.random();
		this.z = Math.random();

		return this;

	}

	randomDirection() {

		// https://mathworld.wolfram.com/SpherePointPicking.html

		const theta = Math.random() * Math.PI * 2;
		const u = Math.random() * 2 - 1;
		const c = Math.sqrt( 1 - u * u );

		this.x = c * Math.cos( theta );
		this.y = u;
		this.z = c * Math.sin( theta );

		return this;

	}

	*[ Symbol.iterator ]() {

		yield this.x;
		yield this.y;
		yield this.z;

	}

};

const _vector$c$1 = /*@__PURE__*/ new Vector3$1();
const _quaternion$4$1 = /*@__PURE__*/ new Quaternion$1();

let Box3$1=class Box3 {

	constructor( min = new Vector3$1( + Infinity, + Infinity, + Infinity ), max = new Vector3$1( - Infinity, - Infinity, - Infinity ) ) {

		this.isBox3 = true;

		this.min = min;
		this.max = max;

	}

	set( min, max ) {

		this.min.copy( min );
		this.max.copy( max );

		return this;

	}

	setFromArray( array ) {

		this.makeEmpty();

		for ( let i = 0, il = array.length; i < il; i += 3 ) {

			this.expandByPoint( _vector$b$1.fromArray( array, i ) );

		}

		return this;

	}

	setFromBufferAttribute( attribute ) {

		this.makeEmpty();

		for ( let i = 0, il = attribute.count; i < il; i ++ ) {

			this.expandByPoint( _vector$b$1.fromBufferAttribute( attribute, i ) );

		}

		return this;

	}

	setFromPoints( points ) {

		this.makeEmpty();

		for ( let i = 0, il = points.length; i < il; i ++ ) {

			this.expandByPoint( points[ i ] );

		}

		return this;

	}

	setFromCenterAndSize( center, size ) {

		const halfSize = _vector$b$1.copy( size ).multiplyScalar( 0.5 );

		this.min.copy( center ).sub( halfSize );
		this.max.copy( center ).add( halfSize );

		return this;

	}

	setFromObject( object, precise = false ) {

		this.makeEmpty();

		return this.expandByObject( object, precise );

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( box ) {

		this.min.copy( box.min );
		this.max.copy( box.max );

		return this;

	}

	makeEmpty() {

		this.min.x = this.min.y = this.min.z = + Infinity;
		this.max.x = this.max.y = this.max.z = - Infinity;

		return this;

	}

	isEmpty() {

		// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes

		return ( this.max.x < this.min.x ) || ( this.max.y < this.min.y ) || ( this.max.z < this.min.z );

	}

	getCenter( target ) {

		return this.isEmpty() ? target.set( 0, 0, 0 ) : target.addVectors( this.min, this.max ).multiplyScalar( 0.5 );

	}

	getSize( target ) {

		return this.isEmpty() ? target.set( 0, 0, 0 ) : target.subVectors( this.max, this.min );

	}

	expandByPoint( point ) {

		this.min.min( point );
		this.max.max( point );

		return this;

	}

	expandByVector( vector ) {

		this.min.sub( vector );
		this.max.add( vector );

		return this;

	}

	expandByScalar( scalar ) {

		this.min.addScalar( - scalar );
		this.max.addScalar( scalar );

		return this;

	}

	expandByObject( object, precise = false ) {

		// Computes the world-axis-aligned bounding box of an object (including its children),
		// accounting for both the object's, and children's, world transforms

		object.updateWorldMatrix( false, false );

		const geometry = object.geometry;

		if ( geometry !== undefined ) {

			const positionAttribute = geometry.getAttribute( 'position' );

			// precise AABB computation based on vertex data requires at least a position attribute.
			// instancing isn't supported so far and uses the normal (conservative) code path.

			if ( precise === true && positionAttribute !== undefined && object.isInstancedMesh !== true ) {

				for ( let i = 0, l = positionAttribute.count; i < l; i ++ ) {

					if ( object.isMesh === true ) {

						object.getVertexPosition( i, _vector$b$1 );

					} else {

						_vector$b$1.fromBufferAttribute( positionAttribute, i );

					}

					_vector$b$1.applyMatrix4( object.matrixWorld );
					this.expandByPoint( _vector$b$1 );

				}

			} else {

				if ( object.boundingBox !== undefined ) {

					// object-level bounding box

					if ( object.boundingBox === null ) {

						object.computeBoundingBox();

					}

					_box$4$1.copy( object.boundingBox );


				} else {

					// geometry-level bounding box

					if ( geometry.boundingBox === null ) {

						geometry.computeBoundingBox();

					}

					_box$4$1.copy( geometry.boundingBox );

				}

				_box$4$1.applyMatrix4( object.matrixWorld );

				this.union( _box$4$1 );

			}

		}

		const children = object.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			this.expandByObject( children[ i ], precise );

		}

		return this;

	}

	containsPoint( point ) {

		return point.x < this.min.x || point.x > this.max.x ||
			point.y < this.min.y || point.y > this.max.y ||
			point.z < this.min.z || point.z > this.max.z ? false : true;

	}

	containsBox( box ) {

		return this.min.x <= box.min.x && box.max.x <= this.max.x &&
			this.min.y <= box.min.y && box.max.y <= this.max.y &&
			this.min.z <= box.min.z && box.max.z <= this.max.z;

	}

	getParameter( point, target ) {

		// This can potentially have a divide by zero if the box
		// has a size dimension of 0.

		return target.set(
			( point.x - this.min.x ) / ( this.max.x - this.min.x ),
			( point.y - this.min.y ) / ( this.max.y - this.min.y ),
			( point.z - this.min.z ) / ( this.max.z - this.min.z )
		);

	}

	intersectsBox( box ) {

		// using 6 splitting planes to rule out intersections.
		return box.max.x < this.min.x || box.min.x > this.max.x ||
			box.max.y < this.min.y || box.min.y > this.max.y ||
			box.max.z < this.min.z || box.min.z > this.max.z ? false : true;

	}

	intersectsSphere( sphere ) {

		// Find the point on the AABB closest to the sphere center.
		this.clampPoint( sphere.center, _vector$b$1 );

		// If that point is inside the sphere, the AABB and sphere intersect.
		return _vector$b$1.distanceToSquared( sphere.center ) <= ( sphere.radius * sphere.radius );

	}

	intersectsPlane( plane ) {

		// We compute the minimum and maximum dot product values. If those values
		// are on the same side (back or front) of the plane, then there is no intersection.

		let min, max;

		if ( plane.normal.x > 0 ) {

			min = plane.normal.x * this.min.x;
			max = plane.normal.x * this.max.x;

		} else {

			min = plane.normal.x * this.max.x;
			max = plane.normal.x * this.min.x;

		}

		if ( plane.normal.y > 0 ) {

			min += plane.normal.y * this.min.y;
			max += plane.normal.y * this.max.y;

		} else {

			min += plane.normal.y * this.max.y;
			max += plane.normal.y * this.min.y;

		}

		if ( plane.normal.z > 0 ) {

			min += plane.normal.z * this.min.z;
			max += plane.normal.z * this.max.z;

		} else {

			min += plane.normal.z * this.max.z;
			max += plane.normal.z * this.min.z;

		}

		return ( min <= - plane.constant && max >= - plane.constant );

	}

	intersectsTriangle( triangle ) {

		if ( this.isEmpty() ) {

			return false;

		}

		// compute box center and extents
		this.getCenter( _center$2 );
		_extents$1.subVectors( this.max, _center$2 );

		// translate triangle to aabb origin
		_v0$2$1.subVectors( triangle.a, _center$2 );
		_v1$7$2.subVectors( triangle.b, _center$2 );
		_v2$4$2.subVectors( triangle.c, _center$2 );

		// compute edge vectors for triangle
		_f0$1.subVectors( _v1$7$2, _v0$2$1 );
		_f1$2.subVectors( _v2$4$2, _v1$7$2 );
		_f2$2.subVectors( _v0$2$1, _v2$4$2 );

		// test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
		// make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
		// axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
		let axes = [
			0, - _f0$1.z, _f0$1.y, 0, - _f1$2.z, _f1$2.y, 0, - _f2$2.z, _f2$2.y,
			_f0$1.z, 0, - _f0$1.x, _f1$2.z, 0, - _f1$2.x, _f2$2.z, 0, - _f2$2.x,
			- _f0$1.y, _f0$1.x, 0, - _f1$2.y, _f1$2.x, 0, - _f2$2.y, _f2$2.x, 0
		];
		if ( ! satForAxes$1( axes, _v0$2$1, _v1$7$2, _v2$4$2, _extents$1 ) ) {

			return false;

		}

		// test 3 face normals from the aabb
		axes = [ 1, 0, 0, 0, 1, 0, 0, 0, 1 ];
		if ( ! satForAxes$1( axes, _v0$2$1, _v1$7$2, _v2$4$2, _extents$1 ) ) {

			return false;

		}

		// finally testing the face normal of the triangle
		// use already existing triangle edge vectors here
		_triangleNormal$1.crossVectors( _f0$1, _f1$2 );
		axes = [ _triangleNormal$1.x, _triangleNormal$1.y, _triangleNormal$1.z ];

		return satForAxes$1( axes, _v0$2$1, _v1$7$2, _v2$4$2, _extents$1 );

	}

	clampPoint( point, target ) {

		return target.copy( point ).clamp( this.min, this.max );

	}

	distanceToPoint( point ) {

		return this.clampPoint( point, _vector$b$1 ).distanceTo( point );

	}

	getBoundingSphere( target ) {

		if ( this.isEmpty() ) {

			target.makeEmpty();

		} else {

			this.getCenter( target.center );

			target.radius = this.getSize( _vector$b$1 ).length() * 0.5;

		}

		return target;

	}

	intersect( box ) {

		this.min.max( box.min );
		this.max.min( box.max );

		// ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
		if ( this.isEmpty() ) this.makeEmpty();

		return this;

	}

	union( box ) {

		this.min.min( box.min );
		this.max.max( box.max );

		return this;

	}

	applyMatrix4( matrix ) {

		// transform of empty box is an empty box.
		if ( this.isEmpty() ) return this;

		// NOTE: I am using a binary pattern to specify all 2^3 combinations below
		_points$1[ 0 ].set( this.min.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 000
		_points$1[ 1 ].set( this.min.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 001
		_points$1[ 2 ].set( this.min.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 010
		_points$1[ 3 ].set( this.min.x, this.max.y, this.max.z ).applyMatrix4( matrix ); // 011
		_points$1[ 4 ].set( this.max.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 100
		_points$1[ 5 ].set( this.max.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 101
		_points$1[ 6 ].set( this.max.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 110
		_points$1[ 7 ].set( this.max.x, this.max.y, this.max.z ).applyMatrix4( matrix ); // 111

		this.setFromPoints( _points$1 );

		return this;

	}

	translate( offset ) {

		this.min.add( offset );
		this.max.add( offset );

		return this;

	}

	equals( box ) {

		return box.min.equals( this.min ) && box.max.equals( this.max );

	}

};

const _points$1 = [
	/*@__PURE__*/ new Vector3$1(),
	/*@__PURE__*/ new Vector3$1(),
	/*@__PURE__*/ new Vector3$1(),
	/*@__PURE__*/ new Vector3$1(),
	/*@__PURE__*/ new Vector3$1(),
	/*@__PURE__*/ new Vector3$1(),
	/*@__PURE__*/ new Vector3$1(),
	/*@__PURE__*/ new Vector3$1()
];

const _vector$b$1 = /*@__PURE__*/ new Vector3$1();

const _box$4$1 = /*@__PURE__*/ new Box3$1();

// triangle centered vertices

const _v0$2$1 = /*@__PURE__*/ new Vector3$1();
const _v1$7$2 = /*@__PURE__*/ new Vector3$1();
const _v2$4$2 = /*@__PURE__*/ new Vector3$1();

// triangle edge vectors

const _f0$1 = /*@__PURE__*/ new Vector3$1();
const _f1$2 = /*@__PURE__*/ new Vector3$1();
const _f2$2 = /*@__PURE__*/ new Vector3$1();

const _center$2 = /*@__PURE__*/ new Vector3$1();
const _extents$1 = /*@__PURE__*/ new Vector3$1();
const _triangleNormal$1 = /*@__PURE__*/ new Vector3$1();
const _testAxis$1 = /*@__PURE__*/ new Vector3$1();

function satForAxes$1( axes, v0, v1, v2, extents ) {

	for ( let i = 0, j = axes.length - 3; i <= j; i += 3 ) {

		_testAxis$1.fromArray( axes, i );
		// project the aabb onto the separating axis
		const r = extents.x * Math.abs( _testAxis$1.x ) + extents.y * Math.abs( _testAxis$1.y ) + extents.z * Math.abs( _testAxis$1.z );
		// project all 3 vertices of the triangle onto the separating axis
		const p0 = v0.dot( _testAxis$1 );
		const p1 = v1.dot( _testAxis$1 );
		const p2 = v2.dot( _testAxis$1 );
		// actual test, basically see if either of the most extreme of the triangle points intersects r
		if ( Math.max( - Math.max( p0, p1, p2 ), Math.min( p0, p1, p2 ) ) > r ) {

			// points of the projected triangle are outside the projected half-length of the aabb
			// the axis is separating and we can exit
			return false;

		}

	}

	return true;

}

const _box$3$1 = /*@__PURE__*/ new Box3$1();
const _v1$6$2 = /*@__PURE__*/ new Vector3$1();
const _v2$3$2 = /*@__PURE__*/ new Vector3$1();

let Sphere$1=class Sphere {

	constructor( center = new Vector3$1(), radius = - 1 ) {

		this.isSphere = true;

		this.center = center;
		this.radius = radius;

	}

	set( center, radius ) {

		this.center.copy( center );
		this.radius = radius;

		return this;

	}

	setFromPoints( points, optionalCenter ) {

		const center = this.center;

		if ( optionalCenter !== undefined ) {

			center.copy( optionalCenter );

		} else {

			_box$3$1.setFromPoints( points ).getCenter( center );

		}

		let maxRadiusSq = 0;

		for ( let i = 0, il = points.length; i < il; i ++ ) {

			maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( points[ i ] ) );

		}

		this.radius = Math.sqrt( maxRadiusSq );

		return this;

	}

	copy( sphere ) {

		this.center.copy( sphere.center );
		this.radius = sphere.radius;

		return this;

	}

	isEmpty() {

		return ( this.radius < 0 );

	}

	makeEmpty() {

		this.center.set( 0, 0, 0 );
		this.radius = - 1;

		return this;

	}

	containsPoint( point ) {

		return ( point.distanceToSquared( this.center ) <= ( this.radius * this.radius ) );

	}

	distanceToPoint( point ) {

		return ( point.distanceTo( this.center ) - this.radius );

	}

	intersectsSphere( sphere ) {

		const radiusSum = this.radius + sphere.radius;

		return sphere.center.distanceToSquared( this.center ) <= ( radiusSum * radiusSum );

	}

	intersectsBox( box ) {

		return box.intersectsSphere( this );

	}

	intersectsPlane( plane ) {

		return Math.abs( plane.distanceToPoint( this.center ) ) <= this.radius;

	}

	clampPoint( point, target ) {

		const deltaLengthSq = this.center.distanceToSquared( point );

		target.copy( point );

		if ( deltaLengthSq > ( this.radius * this.radius ) ) {

			target.sub( this.center ).normalize();
			target.multiplyScalar( this.radius ).add( this.center );

		}

		return target;

	}

	getBoundingBox( target ) {

		if ( this.isEmpty() ) {

			// Empty sphere produces empty bounding box
			target.makeEmpty();
			return target;

		}

		target.set( this.center, this.center );
		target.expandByScalar( this.radius );

		return target;

	}

	applyMatrix4( matrix ) {

		this.center.applyMatrix4( matrix );
		this.radius = this.radius * matrix.getMaxScaleOnAxis();

		return this;

	}

	translate( offset ) {

		this.center.add( offset );

		return this;

	}

	expandByPoint( point ) {

		if ( this.isEmpty() ) {

			this.center.copy( point );

			this.radius = 0;

			return this;

		}

		_v1$6$2.subVectors( point, this.center );

		const lengthSq = _v1$6$2.lengthSq();

		if ( lengthSq > ( this.radius * this.radius ) ) {

			// calculate the minimal sphere

			const length = Math.sqrt( lengthSq );

			const delta = ( length - this.radius ) * 0.5;

			this.center.addScaledVector( _v1$6$2, delta / length );

			this.radius += delta;

		}

		return this;

	}

	union( sphere ) {

		if ( sphere.isEmpty() ) {

			return this;

		}

		if ( this.isEmpty() ) {

			this.copy( sphere );

			return this;

		}

		if ( this.center.equals( sphere.center ) === true ) {

			 this.radius = Math.max( this.radius, sphere.radius );

		} else {

			_v2$3$2.subVectors( sphere.center, this.center ).setLength( sphere.radius );

			this.expandByPoint( _v1$6$2.copy( sphere.center ).add( _v2$3$2 ) );

			this.expandByPoint( _v1$6$2.copy( sphere.center ).sub( _v2$3$2 ) );

		}

		return this;

	}

	equals( sphere ) {

		return sphere.center.equals( this.center ) && ( sphere.radius === this.radius );

	}

	clone() {

		return new this.constructor().copy( this );

	}

};

const _vector$a$1 = /*@__PURE__*/ new Vector3$1();
const _segCenter$1 = /*@__PURE__*/ new Vector3$1();
const _segDir$1 = /*@__PURE__*/ new Vector3$1();
const _diff$1 = /*@__PURE__*/ new Vector3$1();

const _edge1$1 = /*@__PURE__*/ new Vector3$1();
const _edge2$1 = /*@__PURE__*/ new Vector3$1();
const _normal$1$1 = /*@__PURE__*/ new Vector3$1();

let Ray$1=class Ray {

	constructor( origin = new Vector3$1(), direction = new Vector3$1( 0, 0, - 1 ) ) {

		this.origin = origin;
		this.direction = direction;

	}

	set( origin, direction ) {

		this.origin.copy( origin );
		this.direction.copy( direction );

		return this;

	}

	copy( ray ) {

		this.origin.copy( ray.origin );
		this.direction.copy( ray.direction );

		return this;

	}

	at( t, target ) {

		return target.copy( this.origin ).addScaledVector( this.direction, t );

	}

	lookAt( v ) {

		this.direction.copy( v ).sub( this.origin ).normalize();

		return this;

	}

	recast( t ) {

		this.origin.copy( this.at( t, _vector$a$1 ) );

		return this;

	}

	closestPointToPoint( point, target ) {

		target.subVectors( point, this.origin );

		const directionDistance = target.dot( this.direction );

		if ( directionDistance < 0 ) {

			return target.copy( this.origin );

		}

		return target.copy( this.origin ).addScaledVector( this.direction, directionDistance );

	}

	distanceToPoint( point ) {

		return Math.sqrt( this.distanceSqToPoint( point ) );

	}

	distanceSqToPoint( point ) {

		const directionDistance = _vector$a$1.subVectors( point, this.origin ).dot( this.direction );

		// point behind the ray

		if ( directionDistance < 0 ) {

			return this.origin.distanceToSquared( point );

		}

		_vector$a$1.copy( this.origin ).addScaledVector( this.direction, directionDistance );

		return _vector$a$1.distanceToSquared( point );

	}

	distanceSqToSegment( v0, v1, optionalPointOnRay, optionalPointOnSegment ) {

		// from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
		// It returns the min distance between the ray and the segment
		// defined by v0 and v1
		// It can also set two optional targets :
		// - The closest point on the ray
		// - The closest point on the segment

		_segCenter$1.copy( v0 ).add( v1 ).multiplyScalar( 0.5 );
		_segDir$1.copy( v1 ).sub( v0 ).normalize();
		_diff$1.copy( this.origin ).sub( _segCenter$1 );

		const segExtent = v0.distanceTo( v1 ) * 0.5;
		const a01 = - this.direction.dot( _segDir$1 );
		const b0 = _diff$1.dot( this.direction );
		const b1 = - _diff$1.dot( _segDir$1 );
		const c = _diff$1.lengthSq();
		const det = Math.abs( 1 - a01 * a01 );
		let s0, s1, sqrDist, extDet;

		if ( det > 0 ) {

			// The ray and segment are not parallel.

			s0 = a01 * b1 - b0;
			s1 = a01 * b0 - b1;
			extDet = segExtent * det;

			if ( s0 >= 0 ) {

				if ( s1 >= - extDet ) {

					if ( s1 <= extDet ) {

						// region 0
						// Minimum at interior points of ray and segment.

						const invDet = 1 / det;
						s0 *= invDet;
						s1 *= invDet;
						sqrDist = s0 * ( s0 + a01 * s1 + 2 * b0 ) + s1 * ( a01 * s0 + s1 + 2 * b1 ) + c;

					} else {

						// region 1

						s1 = segExtent;
						s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
						sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

					}

				} else {

					// region 5

					s1 = - segExtent;
					s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
					sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

				}

			} else {

				if ( s1 <= - extDet ) {

					// region 4

					s0 = Math.max( 0, - ( - a01 * segExtent + b0 ) );
					s1 = ( s0 > 0 ) ? - segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
					sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

				} else if ( s1 <= extDet ) {

					// region 3

					s0 = 0;
					s1 = Math.min( Math.max( - segExtent, - b1 ), segExtent );
					sqrDist = s1 * ( s1 + 2 * b1 ) + c;

				} else {

					// region 2

					s0 = Math.max( 0, - ( a01 * segExtent + b0 ) );
					s1 = ( s0 > 0 ) ? segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
					sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

				}

			}

		} else {

			// Ray and segment are parallel.

			s1 = ( a01 > 0 ) ? - segExtent : segExtent;
			s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
			sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

		}

		if ( optionalPointOnRay ) {

			optionalPointOnRay.copy( this.origin ).addScaledVector( this.direction, s0 );

		}

		if ( optionalPointOnSegment ) {

			optionalPointOnSegment.copy( _segCenter$1 ).addScaledVector( _segDir$1, s1 );

		}

		return sqrDist;

	}

	intersectSphere( sphere, target ) {

		_vector$a$1.subVectors( sphere.center, this.origin );
		const tca = _vector$a$1.dot( this.direction );
		const d2 = _vector$a$1.dot( _vector$a$1 ) - tca * tca;
		const radius2 = sphere.radius * sphere.radius;

		if ( d2 > radius2 ) return null;

		const thc = Math.sqrt( radius2 - d2 );

		// t0 = first intersect point - entrance on front of sphere
		const t0 = tca - thc;

		// t1 = second intersect point - exit point on back of sphere
		const t1 = tca + thc;

		// test to see if t1 is behind the ray - if so, return null
		if ( t1 < 0 ) return null;

		// test to see if t0 is behind the ray:
		// if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
		// in order to always return an intersect point that is in front of the ray.
		if ( t0 < 0 ) return this.at( t1, target );

		// else t0 is in front of the ray, so return the first collision point scaled by t0
		return this.at( t0, target );

	}

	intersectsSphere( sphere ) {

		return this.distanceSqToPoint( sphere.center ) <= ( sphere.radius * sphere.radius );

	}

	distanceToPlane( plane ) {

		const denominator = plane.normal.dot( this.direction );

		if ( denominator === 0 ) {

			// line is coplanar, return origin
			if ( plane.distanceToPoint( this.origin ) === 0 ) {

				return 0;

			}

			// Null is preferable to undefined since undefined means.... it is undefined

			return null;

		}

		const t = - ( this.origin.dot( plane.normal ) + plane.constant ) / denominator;

		// Return if the ray never intersects the plane

		return t >= 0 ? t : null;

	}

	intersectPlane( plane, target ) {

		const t = this.distanceToPlane( plane );

		if ( t === null ) {

			return null;

		}

		return this.at( t, target );

	}

	intersectsPlane( plane ) {

		// check if the ray lies on the plane first

		const distToPoint = plane.distanceToPoint( this.origin );

		if ( distToPoint === 0 ) {

			return true;

		}

		const denominator = plane.normal.dot( this.direction );

		if ( denominator * distToPoint < 0 ) {

			return true;

		}

		// ray origin is behind the plane (and is pointing behind it)

		return false;

	}

	intersectBox( box, target ) {

		let tmin, tmax, tymin, tymax, tzmin, tzmax;

		const invdirx = 1 / this.direction.x,
			invdiry = 1 / this.direction.y,
			invdirz = 1 / this.direction.z;

		const origin = this.origin;

		if ( invdirx >= 0 ) {

			tmin = ( box.min.x - origin.x ) * invdirx;
			tmax = ( box.max.x - origin.x ) * invdirx;

		} else {

			tmin = ( box.max.x - origin.x ) * invdirx;
			tmax = ( box.min.x - origin.x ) * invdirx;

		}

		if ( invdiry >= 0 ) {

			tymin = ( box.min.y - origin.y ) * invdiry;
			tymax = ( box.max.y - origin.y ) * invdiry;

		} else {

			tymin = ( box.max.y - origin.y ) * invdiry;
			tymax = ( box.min.y - origin.y ) * invdiry;

		}

		if ( ( tmin > tymax ) || ( tymin > tmax ) ) return null;

		if ( tymin > tmin || isNaN( tmin ) ) tmin = tymin;

		if ( tymax < tmax || isNaN( tmax ) ) tmax = tymax;

		if ( invdirz >= 0 ) {

			tzmin = ( box.min.z - origin.z ) * invdirz;
			tzmax = ( box.max.z - origin.z ) * invdirz;

		} else {

			tzmin = ( box.max.z - origin.z ) * invdirz;
			tzmax = ( box.min.z - origin.z ) * invdirz;

		}

		if ( ( tmin > tzmax ) || ( tzmin > tmax ) ) return null;

		if ( tzmin > tmin || tmin !== tmin ) tmin = tzmin;

		if ( tzmax < tmax || tmax !== tmax ) tmax = tzmax;

		//return point closest to the ray (positive side)

		if ( tmax < 0 ) return null;

		return this.at( tmin >= 0 ? tmin : tmax, target );

	}

	intersectsBox( box ) {

		return this.intersectBox( box, _vector$a$1 ) !== null;

	}

	intersectTriangle( a, b, c, backfaceCulling, target ) {

		// Compute the offset origin, edges, and normal.

		// from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h

		_edge1$1.subVectors( b, a );
		_edge2$1.subVectors( c, a );
		_normal$1$1.crossVectors( _edge1$1, _edge2$1 );

		// Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
		// E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
		//   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
		//   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
		//   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
		let DdN = this.direction.dot( _normal$1$1 );
		let sign;

		if ( DdN > 0 ) {

			if ( backfaceCulling ) return null;
			sign = 1;

		} else if ( DdN < 0 ) {

			sign = - 1;
			DdN = - DdN;

		} else {

			return null;

		}

		_diff$1.subVectors( this.origin, a );
		const DdQxE2 = sign * this.direction.dot( _edge2$1.crossVectors( _diff$1, _edge2$1 ) );

		// b1 < 0, no intersection
		if ( DdQxE2 < 0 ) {

			return null;

		}

		const DdE1xQ = sign * this.direction.dot( _edge1$1.cross( _diff$1 ) );

		// b2 < 0, no intersection
		if ( DdE1xQ < 0 ) {

			return null;

		}

		// b1+b2 > 1, no intersection
		if ( DdQxE2 + DdE1xQ > DdN ) {

			return null;

		}

		// Line intersects triangle, check if ray does.
		const QdN = - sign * _diff$1.dot( _normal$1$1 );

		// t < 0, no intersection
		if ( QdN < 0 ) {

			return null;

		}

		// Ray intersects triangle.
		return this.at( QdN / DdN, target );

	}

	applyMatrix4( matrix4 ) {

		this.origin.applyMatrix4( matrix4 );
		this.direction.transformDirection( matrix4 );

		return this;

	}

	equals( ray ) {

		return ray.origin.equals( this.origin ) && ray.direction.equals( this.direction );

	}

	clone() {

		return new this.constructor().copy( this );

	}

};

let Matrix4$1=class Matrix4 {

	constructor( n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44 ) {

		Matrix4.prototype.isMatrix4 = true;

		this.elements = [

			1, 0, 0, 0,
			0, 1, 0, 0,
			0, 0, 1, 0,
			0, 0, 0, 1

		];

		if ( n11 !== undefined ) {

			this.set( n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44 );

		}

	}

	set( n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44 ) {

		const te = this.elements;

		te[ 0 ] = n11; te[ 4 ] = n12; te[ 8 ] = n13; te[ 12 ] = n14;
		te[ 1 ] = n21; te[ 5 ] = n22; te[ 9 ] = n23; te[ 13 ] = n24;
		te[ 2 ] = n31; te[ 6 ] = n32; te[ 10 ] = n33; te[ 14 ] = n34;
		te[ 3 ] = n41; te[ 7 ] = n42; te[ 11 ] = n43; te[ 15 ] = n44;

		return this;

	}

	identity() {

		this.set(

			1, 0, 0, 0,
			0, 1, 0, 0,
			0, 0, 1, 0,
			0, 0, 0, 1

		);

		return this;

	}

	clone() {

		return new Matrix4().fromArray( this.elements );

	}

	copy( m ) {

		const te = this.elements;
		const me = m.elements;

		te[ 0 ] = me[ 0 ]; te[ 1 ] = me[ 1 ]; te[ 2 ] = me[ 2 ]; te[ 3 ] = me[ 3 ];
		te[ 4 ] = me[ 4 ]; te[ 5 ] = me[ 5 ]; te[ 6 ] = me[ 6 ]; te[ 7 ] = me[ 7 ];
		te[ 8 ] = me[ 8 ]; te[ 9 ] = me[ 9 ]; te[ 10 ] = me[ 10 ]; te[ 11 ] = me[ 11 ];
		te[ 12 ] = me[ 12 ]; te[ 13 ] = me[ 13 ]; te[ 14 ] = me[ 14 ]; te[ 15 ] = me[ 15 ];

		return this;

	}

	copyPosition( m ) {

		const te = this.elements, me = m.elements;

		te[ 12 ] = me[ 12 ];
		te[ 13 ] = me[ 13 ];
		te[ 14 ] = me[ 14 ];

		return this;

	}

	setFromMatrix3( m ) {

		const me = m.elements;

		this.set(

			me[ 0 ], me[ 3 ], me[ 6 ], 0,
			me[ 1 ], me[ 4 ], me[ 7 ], 0,
			me[ 2 ], me[ 5 ], me[ 8 ], 0,
			0, 0, 0, 1

		);

		return this;

	}

	extractBasis( xAxis, yAxis, zAxis ) {

		xAxis.setFromMatrixColumn( this, 0 );
		yAxis.setFromMatrixColumn( this, 1 );
		zAxis.setFromMatrixColumn( this, 2 );

		return this;

	}

	makeBasis( xAxis, yAxis, zAxis ) {

		this.set(
			xAxis.x, yAxis.x, zAxis.x, 0,
			xAxis.y, yAxis.y, zAxis.y, 0,
			xAxis.z, yAxis.z, zAxis.z, 0,
			0, 0, 0, 1
		);

		return this;

	}

	extractRotation( m ) {

		// this method does not support reflection matrices

		const te = this.elements;
		const me = m.elements;

		const scaleX = 1 / _v1$5$2.setFromMatrixColumn( m, 0 ).length();
		const scaleY = 1 / _v1$5$2.setFromMatrixColumn( m, 1 ).length();
		const scaleZ = 1 / _v1$5$2.setFromMatrixColumn( m, 2 ).length();

		te[ 0 ] = me[ 0 ] * scaleX;
		te[ 1 ] = me[ 1 ] * scaleX;
		te[ 2 ] = me[ 2 ] * scaleX;
		te[ 3 ] = 0;

		te[ 4 ] = me[ 4 ] * scaleY;
		te[ 5 ] = me[ 5 ] * scaleY;
		te[ 6 ] = me[ 6 ] * scaleY;
		te[ 7 ] = 0;

		te[ 8 ] = me[ 8 ] * scaleZ;
		te[ 9 ] = me[ 9 ] * scaleZ;
		te[ 10 ] = me[ 10 ] * scaleZ;
		te[ 11 ] = 0;

		te[ 12 ] = 0;
		te[ 13 ] = 0;
		te[ 14 ] = 0;
		te[ 15 ] = 1;

		return this;

	}

	makeRotationFromEuler( euler ) {

		const te = this.elements;

		const x = euler.x, y = euler.y, z = euler.z;
		const a = Math.cos( x ), b = Math.sin( x );
		const c = Math.cos( y ), d = Math.sin( y );
		const e = Math.cos( z ), f = Math.sin( z );

		if ( euler.order === 'XYZ' ) {

			const ae = a * e, af = a * f, be = b * e, bf = b * f;

			te[ 0 ] = c * e;
			te[ 4 ] = - c * f;
			te[ 8 ] = d;

			te[ 1 ] = af + be * d;
			te[ 5 ] = ae - bf * d;
			te[ 9 ] = - b * c;

			te[ 2 ] = bf - ae * d;
			te[ 6 ] = be + af * d;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'YXZ' ) {

			const ce = c * e, cf = c * f, de = d * e, df = d * f;

			te[ 0 ] = ce + df * b;
			te[ 4 ] = de * b - cf;
			te[ 8 ] = a * d;

			te[ 1 ] = a * f;
			te[ 5 ] = a * e;
			te[ 9 ] = - b;

			te[ 2 ] = cf * b - de;
			te[ 6 ] = df + ce * b;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'ZXY' ) {

			const ce = c * e, cf = c * f, de = d * e, df = d * f;

			te[ 0 ] = ce - df * b;
			te[ 4 ] = - a * f;
			te[ 8 ] = de + cf * b;

			te[ 1 ] = cf + de * b;
			te[ 5 ] = a * e;
			te[ 9 ] = df - ce * b;

			te[ 2 ] = - a * d;
			te[ 6 ] = b;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'ZYX' ) {

			const ae = a * e, af = a * f, be = b * e, bf = b * f;

			te[ 0 ] = c * e;
			te[ 4 ] = be * d - af;
			te[ 8 ] = ae * d + bf;

			te[ 1 ] = c * f;
			te[ 5 ] = bf * d + ae;
			te[ 9 ] = af * d - be;

			te[ 2 ] = - d;
			te[ 6 ] = b * c;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'YZX' ) {

			const ac = a * c, ad = a * d, bc = b * c, bd = b * d;

			te[ 0 ] = c * e;
			te[ 4 ] = bd - ac * f;
			te[ 8 ] = bc * f + ad;

			te[ 1 ] = f;
			te[ 5 ] = a * e;
			te[ 9 ] = - b * e;

			te[ 2 ] = - d * e;
			te[ 6 ] = ad * f + bc;
			te[ 10 ] = ac - bd * f;

		} else if ( euler.order === 'XZY' ) {

			const ac = a * c, ad = a * d, bc = b * c, bd = b * d;

			te[ 0 ] = c * e;
			te[ 4 ] = - f;
			te[ 8 ] = d * e;

			te[ 1 ] = ac * f + bd;
			te[ 5 ] = a * e;
			te[ 9 ] = ad * f - bc;

			te[ 2 ] = bc * f - ad;
			te[ 6 ] = b * e;
			te[ 10 ] = bd * f + ac;

		}

		// bottom row
		te[ 3 ] = 0;
		te[ 7 ] = 0;
		te[ 11 ] = 0;

		// last column
		te[ 12 ] = 0;
		te[ 13 ] = 0;
		te[ 14 ] = 0;
		te[ 15 ] = 1;

		return this;

	}

	makeRotationFromQuaternion( q ) {

		return this.compose( _zero$1, q, _one$1 );

	}

	lookAt( eye, target, up ) {

		const te = this.elements;

		_z$5.subVectors( eye, target );

		if ( _z$5.lengthSq() === 0 ) {

			// eye and target are in the same position

			_z$5.z = 1;

		}

		_z$5.normalize();
		_x$3.crossVectors( up, _z$5 );

		if ( _x$3.lengthSq() === 0 ) {

			// up and z are parallel

			if ( Math.abs( up.z ) === 1 ) {

				_z$5.x += 0.0001;

			} else {

				_z$5.z += 0.0001;

			}

			_z$5.normalize();
			_x$3.crossVectors( up, _z$5 );

		}

		_x$3.normalize();
		_y$3.crossVectors( _z$5, _x$3 );

		te[ 0 ] = _x$3.x; te[ 4 ] = _y$3.x; te[ 8 ] = _z$5.x;
		te[ 1 ] = _x$3.y; te[ 5 ] = _y$3.y; te[ 9 ] = _z$5.y;
		te[ 2 ] = _x$3.z; te[ 6 ] = _y$3.z; te[ 10 ] = _z$5.z;

		return this;

	}

	multiply( m ) {

		return this.multiplyMatrices( this, m );

	}

	premultiply( m ) {

		return this.multiplyMatrices( m, this );

	}

	multiplyMatrices( a, b ) {

		const ae = a.elements;
		const be = b.elements;
		const te = this.elements;

		const a11 = ae[ 0 ], a12 = ae[ 4 ], a13 = ae[ 8 ], a14 = ae[ 12 ];
		const a21 = ae[ 1 ], a22 = ae[ 5 ], a23 = ae[ 9 ], a24 = ae[ 13 ];
		const a31 = ae[ 2 ], a32 = ae[ 6 ], a33 = ae[ 10 ], a34 = ae[ 14 ];
		const a41 = ae[ 3 ], a42 = ae[ 7 ], a43 = ae[ 11 ], a44 = ae[ 15 ];

		const b11 = be[ 0 ], b12 = be[ 4 ], b13 = be[ 8 ], b14 = be[ 12 ];
		const b21 = be[ 1 ], b22 = be[ 5 ], b23 = be[ 9 ], b24 = be[ 13 ];
		const b31 = be[ 2 ], b32 = be[ 6 ], b33 = be[ 10 ], b34 = be[ 14 ];
		const b41 = be[ 3 ], b42 = be[ 7 ], b43 = be[ 11 ], b44 = be[ 15 ];

		te[ 0 ] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
		te[ 4 ] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
		te[ 8 ] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
		te[ 12 ] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;

		te[ 1 ] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
		te[ 5 ] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
		te[ 9 ] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
		te[ 13 ] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;

		te[ 2 ] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
		te[ 6 ] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
		te[ 10 ] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
		te[ 14 ] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;

		te[ 3 ] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
		te[ 7 ] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
		te[ 11 ] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
		te[ 15 ] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;

		return this;

	}

	multiplyScalar( s ) {

		const te = this.elements;

		te[ 0 ] *= s; te[ 4 ] *= s; te[ 8 ] *= s; te[ 12 ] *= s;
		te[ 1 ] *= s; te[ 5 ] *= s; te[ 9 ] *= s; te[ 13 ] *= s;
		te[ 2 ] *= s; te[ 6 ] *= s; te[ 10 ] *= s; te[ 14 ] *= s;
		te[ 3 ] *= s; te[ 7 ] *= s; te[ 11 ] *= s; te[ 15 ] *= s;

		return this;

	}

	determinant() {

		const te = this.elements;

		const n11 = te[ 0 ], n12 = te[ 4 ], n13 = te[ 8 ], n14 = te[ 12 ];
		const n21 = te[ 1 ], n22 = te[ 5 ], n23 = te[ 9 ], n24 = te[ 13 ];
		const n31 = te[ 2 ], n32 = te[ 6 ], n33 = te[ 10 ], n34 = te[ 14 ];
		const n41 = te[ 3 ], n42 = te[ 7 ], n43 = te[ 11 ], n44 = te[ 15 ];

		//TODO: make this more efficient
		//( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )

		return (
			n41 * (
				+ n14 * n23 * n32
				 - n13 * n24 * n32
				 - n14 * n22 * n33
				 + n12 * n24 * n33
				 + n13 * n22 * n34
				 - n12 * n23 * n34
			) +
			n42 * (
				+ n11 * n23 * n34
				 - n11 * n24 * n33
				 + n14 * n21 * n33
				 - n13 * n21 * n34
				 + n13 * n24 * n31
				 - n14 * n23 * n31
			) +
			n43 * (
				+ n11 * n24 * n32
				 - n11 * n22 * n34
				 - n14 * n21 * n32
				 + n12 * n21 * n34
				 + n14 * n22 * n31
				 - n12 * n24 * n31
			) +
			n44 * (
				- n13 * n22 * n31
				 - n11 * n23 * n32
				 + n11 * n22 * n33
				 + n13 * n21 * n32
				 - n12 * n21 * n33
				 + n12 * n23 * n31
			)

		);

	}

	transpose() {

		const te = this.elements;
		let tmp;

		tmp = te[ 1 ]; te[ 1 ] = te[ 4 ]; te[ 4 ] = tmp;
		tmp = te[ 2 ]; te[ 2 ] = te[ 8 ]; te[ 8 ] = tmp;
		tmp = te[ 6 ]; te[ 6 ] = te[ 9 ]; te[ 9 ] = tmp;

		tmp = te[ 3 ]; te[ 3 ] = te[ 12 ]; te[ 12 ] = tmp;
		tmp = te[ 7 ]; te[ 7 ] = te[ 13 ]; te[ 13 ] = tmp;
		tmp = te[ 11 ]; te[ 11 ] = te[ 14 ]; te[ 14 ] = tmp;

		return this;

	}

	setPosition( x, y, z ) {

		const te = this.elements;

		if ( x.isVector3 ) {

			te[ 12 ] = x.x;
			te[ 13 ] = x.y;
			te[ 14 ] = x.z;

		} else {

			te[ 12 ] = x;
			te[ 13 ] = y;
			te[ 14 ] = z;

		}

		return this;

	}

	invert() {

		// based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
		const te = this.elements,

			n11 = te[ 0 ], n21 = te[ 1 ], n31 = te[ 2 ], n41 = te[ 3 ],
			n12 = te[ 4 ], n22 = te[ 5 ], n32 = te[ 6 ], n42 = te[ 7 ],
			n13 = te[ 8 ], n23 = te[ 9 ], n33 = te[ 10 ], n43 = te[ 11 ],
			n14 = te[ 12 ], n24 = te[ 13 ], n34 = te[ 14 ], n44 = te[ 15 ],

			t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44,
			t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44,
			t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44,
			t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;

		const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;

		if ( det === 0 ) return this.set( 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 );

		const detInv = 1 / det;

		te[ 0 ] = t11 * detInv;
		te[ 1 ] = ( n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44 ) * detInv;
		te[ 2 ] = ( n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44 ) * detInv;
		te[ 3 ] = ( n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43 ) * detInv;

		te[ 4 ] = t12 * detInv;
		te[ 5 ] = ( n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44 ) * detInv;
		te[ 6 ] = ( n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44 ) * detInv;
		te[ 7 ] = ( n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43 ) * detInv;

		te[ 8 ] = t13 * detInv;
		te[ 9 ] = ( n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44 ) * detInv;
		te[ 10 ] = ( n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44 ) * detInv;
		te[ 11 ] = ( n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43 ) * detInv;

		te[ 12 ] = t14 * detInv;
		te[ 13 ] = ( n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34 ) * detInv;
		te[ 14 ] = ( n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34 ) * detInv;
		te[ 15 ] = ( n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33 ) * detInv;

		return this;

	}

	scale( v ) {

		const te = this.elements;
		const x = v.x, y = v.y, z = v.z;

		te[ 0 ] *= x; te[ 4 ] *= y; te[ 8 ] *= z;
		te[ 1 ] *= x; te[ 5 ] *= y; te[ 9 ] *= z;
		te[ 2 ] *= x; te[ 6 ] *= y; te[ 10 ] *= z;
		te[ 3 ] *= x; te[ 7 ] *= y; te[ 11 ] *= z;

		return this;

	}

	getMaxScaleOnAxis() {

		const te = this.elements;

		const scaleXSq = te[ 0 ] * te[ 0 ] + te[ 1 ] * te[ 1 ] + te[ 2 ] * te[ 2 ];
		const scaleYSq = te[ 4 ] * te[ 4 ] + te[ 5 ] * te[ 5 ] + te[ 6 ] * te[ 6 ];
		const scaleZSq = te[ 8 ] * te[ 8 ] + te[ 9 ] * te[ 9 ] + te[ 10 ] * te[ 10 ];

		return Math.sqrt( Math.max( scaleXSq, scaleYSq, scaleZSq ) );

	}

	makeTranslation( x, y, z ) {

		if ( x.isVector3 ) {

			this.set(

				1, 0, 0, x.x,
				0, 1, 0, x.y,
				0, 0, 1, x.z,
				0, 0, 0, 1

			);

		} else {

			this.set(

				1, 0, 0, x,
				0, 1, 0, y,
				0, 0, 1, z,
				0, 0, 0, 1

			);

		}

		return this;

	}

	makeRotationX( theta ) {

		const c = Math.cos( theta ), s = Math.sin( theta );

		this.set(

			1, 0, 0, 0,
			0, c, - s, 0,
			0, s, c, 0,
			0, 0, 0, 1

		);

		return this;

	}

	makeRotationY( theta ) {

		const c = Math.cos( theta ), s = Math.sin( theta );

		this.set(

			 c, 0, s, 0,
			 0, 1, 0, 0,
			- s, 0, c, 0,
			 0, 0, 0, 1

		);

		return this;

	}

	makeRotationZ( theta ) {

		const c = Math.cos( theta ), s = Math.sin( theta );

		this.set(

			c, - s, 0, 0,
			s, c, 0, 0,
			0, 0, 1, 0,
			0, 0, 0, 1

		);

		return this;

	}

	makeRotationAxis( axis, angle ) {

		// Based on http://www.gamedev.net/reference/articles/article1199.asp

		const c = Math.cos( angle );
		const s = Math.sin( angle );
		const t = 1 - c;
		const x = axis.x, y = axis.y, z = axis.z;
		const tx = t * x, ty = t * y;

		this.set(

			tx * x + c, tx * y - s * z, tx * z + s * y, 0,
			tx * y + s * z, ty * y + c, ty * z - s * x, 0,
			tx * z - s * y, ty * z + s * x, t * z * z + c, 0,
			0, 0, 0, 1

		);

		return this;

	}

	makeScale( x, y, z ) {

		this.set(

			x, 0, 0, 0,
			0, y, 0, 0,
			0, 0, z, 0,
			0, 0, 0, 1

		);

		return this;

	}

	makeShear( xy, xz, yx, yz, zx, zy ) {

		this.set(

			1, yx, zx, 0,
			xy, 1, zy, 0,
			xz, yz, 1, 0,
			0, 0, 0, 1

		);

		return this;

	}

	compose( position, quaternion, scale ) {

		const te = this.elements;

		const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
		const x2 = x + x,	y2 = y + y, z2 = z + z;
		const xx = x * x2, xy = x * y2, xz = x * z2;
		const yy = y * y2, yz = y * z2, zz = z * z2;
		const wx = w * x2, wy = w * y2, wz = w * z2;

		const sx = scale.x, sy = scale.y, sz = scale.z;

		te[ 0 ] = ( 1 - ( yy + zz ) ) * sx;
		te[ 1 ] = ( xy + wz ) * sx;
		te[ 2 ] = ( xz - wy ) * sx;
		te[ 3 ] = 0;

		te[ 4 ] = ( xy - wz ) * sy;
		te[ 5 ] = ( 1 - ( xx + zz ) ) * sy;
		te[ 6 ] = ( yz + wx ) * sy;
		te[ 7 ] = 0;

		te[ 8 ] = ( xz + wy ) * sz;
		te[ 9 ] = ( yz - wx ) * sz;
		te[ 10 ] = ( 1 - ( xx + yy ) ) * sz;
		te[ 11 ] = 0;

		te[ 12 ] = position.x;
		te[ 13 ] = position.y;
		te[ 14 ] = position.z;
		te[ 15 ] = 1;

		return this;

	}

	decompose( position, quaternion, scale ) {

		const te = this.elements;

		let sx = _v1$5$2.set( te[ 0 ], te[ 1 ], te[ 2 ] ).length();
		const sy = _v1$5$2.set( te[ 4 ], te[ 5 ], te[ 6 ] ).length();
		const sz = _v1$5$2.set( te[ 8 ], te[ 9 ], te[ 10 ] ).length();

		// if determine is negative, we need to invert one scale
		const det = this.determinant();
		if ( det < 0 ) sx = - sx;

		position.x = te[ 12 ];
		position.y = te[ 13 ];
		position.z = te[ 14 ];

		// scale the rotation part
		_m1$4$1.copy( this );

		const invSX = 1 / sx;
		const invSY = 1 / sy;
		const invSZ = 1 / sz;

		_m1$4$1.elements[ 0 ] *= invSX;
		_m1$4$1.elements[ 1 ] *= invSX;
		_m1$4$1.elements[ 2 ] *= invSX;

		_m1$4$1.elements[ 4 ] *= invSY;
		_m1$4$1.elements[ 5 ] *= invSY;
		_m1$4$1.elements[ 6 ] *= invSY;

		_m1$4$1.elements[ 8 ] *= invSZ;
		_m1$4$1.elements[ 9 ] *= invSZ;
		_m1$4$1.elements[ 10 ] *= invSZ;

		quaternion.setFromRotationMatrix( _m1$4$1 );

		scale.x = sx;
		scale.y = sy;
		scale.z = sz;

		return this;

	}

	makePerspective( left, right, top, bottom, near, far, coordinateSystem = WebGLCoordinateSystem$1 ) {

		const te = this.elements;
		const x = 2 * near / ( right - left );
		const y = 2 * near / ( top - bottom );

		const a = ( right + left ) / ( right - left );
		const b = ( top + bottom ) / ( top - bottom );

		let c, d;

		if ( coordinateSystem === WebGLCoordinateSystem$1 ) {

			c = - ( far + near ) / ( far - near );
			d = ( - 2 * far * near ) / ( far - near );

		} else if ( coordinateSystem === WebGPUCoordinateSystem$1 ) {

			c = - far / ( far - near );
			d = ( - far * near ) / ( far - near );

		} else {

			throw new Error( 'THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + coordinateSystem );

		}

		te[ 0 ] = x;	te[ 4 ] = 0;	te[ 8 ] = a; 	te[ 12 ] = 0;
		te[ 1 ] = 0;	te[ 5 ] = y;	te[ 9 ] = b; 	te[ 13 ] = 0;
		te[ 2 ] = 0;	te[ 6 ] = 0;	te[ 10 ] = c; 	te[ 14 ] = d;
		te[ 3 ] = 0;	te[ 7 ] = 0;	te[ 11 ] = - 1;	te[ 15 ] = 0;

		return this;

	}

	makeOrthographic( left, right, top, bottom, near, far, coordinateSystem = WebGLCoordinateSystem$1 ) {

		const te = this.elements;
		const w = 1.0 / ( right - left );
		const h = 1.0 / ( top - bottom );
		const p = 1.0 / ( far - near );

		const x = ( right + left ) * w;
		const y = ( top + bottom ) * h;

		let z, zInv;

		if ( coordinateSystem === WebGLCoordinateSystem$1 ) {

			z = ( far + near ) * p;
			zInv = - 2 * p;

		} else if ( coordinateSystem === WebGPUCoordinateSystem$1 ) {

			z = near * p;
			zInv = - 1 * p;

		} else {

			throw new Error( 'THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + coordinateSystem );

		}

		te[ 0 ] = 2 * w;	te[ 4 ] = 0;		te[ 8 ] = 0; 		te[ 12 ] = - x;
		te[ 1 ] = 0; 		te[ 5 ] = 2 * h;	te[ 9 ] = 0; 		te[ 13 ] = - y;
		te[ 2 ] = 0; 		te[ 6 ] = 0;		te[ 10 ] = zInv;	te[ 14 ] = - z;
		te[ 3 ] = 0; 		te[ 7 ] = 0;		te[ 11 ] = 0;		te[ 15 ] = 1;

		return this;

	}

	equals( matrix ) {

		const te = this.elements;
		const me = matrix.elements;

		for ( let i = 0; i < 16; i ++ ) {

			if ( te[ i ] !== me[ i ] ) return false;

		}

		return true;

	}

	fromArray( array, offset = 0 ) {

		for ( let i = 0; i < 16; i ++ ) {

			this.elements[ i ] = array[ i + offset ];

		}

		return this;

	}

	toArray( array = [], offset = 0 ) {

		const te = this.elements;

		array[ offset ] = te[ 0 ];
		array[ offset + 1 ] = te[ 1 ];
		array[ offset + 2 ] = te[ 2 ];
		array[ offset + 3 ] = te[ 3 ];

		array[ offset + 4 ] = te[ 4 ];
		array[ offset + 5 ] = te[ 5 ];
		array[ offset + 6 ] = te[ 6 ];
		array[ offset + 7 ] = te[ 7 ];

		array[ offset + 8 ] = te[ 8 ];
		array[ offset + 9 ] = te[ 9 ];
		array[ offset + 10 ] = te[ 10 ];
		array[ offset + 11 ] = te[ 11 ];

		array[ offset + 12 ] = te[ 12 ];
		array[ offset + 13 ] = te[ 13 ];
		array[ offset + 14 ] = te[ 14 ];
		array[ offset + 15 ] = te[ 15 ];

		return array;

	}

};

const _v1$5$2 = /*@__PURE__*/ new Vector3$1();
const _m1$4$1 = /*@__PURE__*/ new Matrix4$1();
const _zero$1 = /*@__PURE__*/ new Vector3$1( 0, 0, 0 );
const _one$1 = /*@__PURE__*/ new Vector3$1( 1, 1, 1 );
const _x$3 = /*@__PURE__*/ new Vector3$1();
const _y$3 = /*@__PURE__*/ new Vector3$1();
const _z$5 = /*@__PURE__*/ new Vector3$1();

const _matrix$2$1 = /*@__PURE__*/ new Matrix4$1();
const _quaternion$3$1 = /*@__PURE__*/ new Quaternion$1();

let Euler$1=class Euler {

	constructor( x = 0, y = 0, z = 0, order = Euler.DEFAULT_ORDER ) {

		this.isEuler = true;

		this._x = x;
		this._y = y;
		this._z = z;
		this._order = order;

	}

	get x() {

		return this._x;

	}

	set x( value ) {

		this._x = value;
		this._onChangeCallback();

	}

	get y() {

		return this._y;

	}

	set y( value ) {

		this._y = value;
		this._onChangeCallback();

	}

	get z() {

		return this._z;

	}

	set z( value ) {

		this._z = value;
		this._onChangeCallback();

	}

	get order() {

		return this._order;

	}

	set order( value ) {

		this._order = value;
		this._onChangeCallback();

	}

	set( x, y, z, order = this._order ) {

		this._x = x;
		this._y = y;
		this._z = z;
		this._order = order;

		this._onChangeCallback();

		return this;

	}

	clone() {

		return new this.constructor( this._x, this._y, this._z, this._order );

	}

	copy( euler ) {

		this._x = euler._x;
		this._y = euler._y;
		this._z = euler._z;
		this._order = euler._order;

		this._onChangeCallback();

		return this;

	}

	setFromRotationMatrix( m, order = this._order, update = true ) {

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		const te = m.elements;
		const m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ];
		const m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ];
		const m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ];

		switch ( order ) {

			case 'XYZ':

				this._y = Math.asin( clamp$1( m13, - 1, 1 ) );

				if ( Math.abs( m13 ) < 0.9999999 ) {

					this._x = Math.atan2( - m23, m33 );
					this._z = Math.atan2( - m12, m11 );

				} else {

					this._x = Math.atan2( m32, m22 );
					this._z = 0;

				}

				break;

			case 'YXZ':

				this._x = Math.asin( - clamp$1( m23, - 1, 1 ) );

				if ( Math.abs( m23 ) < 0.9999999 ) {

					this._y = Math.atan2( m13, m33 );
					this._z = Math.atan2( m21, m22 );

				} else {

					this._y = Math.atan2( - m31, m11 );
					this._z = 0;

				}

				break;

			case 'ZXY':

				this._x = Math.asin( clamp$1( m32, - 1, 1 ) );

				if ( Math.abs( m32 ) < 0.9999999 ) {

					this._y = Math.atan2( - m31, m33 );
					this._z = Math.atan2( - m12, m22 );

				} else {

					this._y = 0;
					this._z = Math.atan2( m21, m11 );

				}

				break;

			case 'ZYX':

				this._y = Math.asin( - clamp$1( m31, - 1, 1 ) );

				if ( Math.abs( m31 ) < 0.9999999 ) {

					this._x = Math.atan2( m32, m33 );
					this._z = Math.atan2( m21, m11 );

				} else {

					this._x = 0;
					this._z = Math.atan2( - m12, m22 );

				}

				break;

			case 'YZX':

				this._z = Math.asin( clamp$1( m21, - 1, 1 ) );

				if ( Math.abs( m21 ) < 0.9999999 ) {

					this._x = Math.atan2( - m23, m22 );
					this._y = Math.atan2( - m31, m11 );

				} else {

					this._x = 0;
					this._y = Math.atan2( m13, m33 );

				}

				break;

			case 'XZY':

				this._z = Math.asin( - clamp$1( m12, - 1, 1 ) );

				if ( Math.abs( m12 ) < 0.9999999 ) {

					this._x = Math.atan2( m32, m22 );
					this._y = Math.atan2( m13, m11 );

				} else {

					this._x = Math.atan2( - m23, m33 );
					this._y = 0;

				}

				break;

			default:

				console.warn( 'THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order );

		}

		this._order = order;

		if ( update === true ) this._onChangeCallback();

		return this;

	}

	setFromQuaternion( q, order, update ) {

		_matrix$2$1.makeRotationFromQuaternion( q );

		return this.setFromRotationMatrix( _matrix$2$1, order, update );

	}

	setFromVector3( v, order = this._order ) {

		return this.set( v.x, v.y, v.z, order );

	}

	reorder( newOrder ) {

		// WARNING: this discards revolution information -bhouston

		_quaternion$3$1.setFromEuler( this );

		return this.setFromQuaternion( _quaternion$3$1, newOrder );

	}

	equals( euler ) {

		return ( euler._x === this._x ) && ( euler._y === this._y ) && ( euler._z === this._z ) && ( euler._order === this._order );

	}

	fromArray( array ) {

		this._x = array[ 0 ];
		this._y = array[ 1 ];
		this._z = array[ 2 ];
		if ( array[ 3 ] !== undefined ) this._order = array[ 3 ];

		this._onChangeCallback();

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this._x;
		array[ offset + 1 ] = this._y;
		array[ offset + 2 ] = this._z;
		array[ offset + 3 ] = this._order;

		return array;

	}

	_onChange( callback ) {

		this._onChangeCallback = callback;

		return this;

	}

	_onChangeCallback() {}

	*[ Symbol.iterator ]() {

		yield this._x;
		yield this._y;
		yield this._z;
		yield this._order;

	}

};

Euler$1.DEFAULT_ORDER = 'XYZ';

let Layers$1=class Layers {

	constructor() {

		this.mask = 1 | 0;

	}

	set( channel ) {

		this.mask = ( 1 << channel | 0 ) >>> 0;

	}

	enable( channel ) {

		this.mask |= 1 << channel | 0;

	}

	enableAll() {

		this.mask = 0xffffffff | 0;

	}

	toggle( channel ) {

		this.mask ^= 1 << channel | 0;

	}

	disable( channel ) {

		this.mask &= ~ ( 1 << channel | 0 );

	}

	disableAll() {

		this.mask = 0;

	}

	test( layers ) {

		return ( this.mask & layers.mask ) !== 0;

	}

	isEnabled( channel ) {

		return ( this.mask & ( 1 << channel | 0 ) ) !== 0;

	}

};

let _object3DId$1 = 0;

const _v1$4$2 = /*@__PURE__*/ new Vector3$1();
const _q1$1 = /*@__PURE__*/ new Quaternion$1();
const _m1$3$1 = /*@__PURE__*/ new Matrix4$1();
const _target$1 = /*@__PURE__*/ new Vector3$1();

const _position$3$1 = /*@__PURE__*/ new Vector3$1();
const _scale$2$1 = /*@__PURE__*/ new Vector3$1();
const _quaternion$2$1 = /*@__PURE__*/ new Quaternion$1();

const _xAxis$1 = /*@__PURE__*/ new Vector3$1( 1, 0, 0 );
const _yAxis$1 = /*@__PURE__*/ new Vector3$1( 0, 1, 0 );
const _zAxis$1 = /*@__PURE__*/ new Vector3$1( 0, 0, 1 );

const _addedEvent$1 = { type: 'added' };
const _removedEvent$1 = { type: 'removed' };

const _childaddedEvent$1 = { type: 'childadded', child: null };
const _childremovedEvent$1 = { type: 'childremoved', child: null };

let Object3D$1=class Object3D extends EventDispatcher$3 {

	constructor() {

		super();

		this.isObject3D = true;

		Object.defineProperty( this, 'id', { value: _object3DId$1 ++ } );

		this.uuid = generateUUID$1();

		this.name = '';
		this.type = 'Object3D';

		this.parent = null;
		this.children = [];

		this.up = Object3D.DEFAULT_UP.clone();

		const position = new Vector3$1();
		const rotation = new Euler$1();
		const quaternion = new Quaternion$1();
		const scale = new Vector3$1( 1, 1, 1 );

		function onRotationChange() {

			quaternion.setFromEuler( rotation, false );

		}

		function onQuaternionChange() {

			rotation.setFromQuaternion( quaternion, undefined, false );

		}

		rotation._onChange( onRotationChange );
		quaternion._onChange( onQuaternionChange );

		Object.defineProperties( this, {
			position: {
				configurable: true,
				enumerable: true,
				value: position
			},
			rotation: {
				configurable: true,
				enumerable: true,
				value: rotation
			},
			quaternion: {
				configurable: true,
				enumerable: true,
				value: quaternion
			},
			scale: {
				configurable: true,
				enumerable: true,
				value: scale
			},
			modelViewMatrix: {
				value: new Matrix4$1()
			},
			normalMatrix: {
				value: new Matrix3$1()
			}
		} );

		this.matrix = new Matrix4$1();
		this.matrixWorld = new Matrix4$1();

		this.matrixAutoUpdate = Object3D.DEFAULT_MATRIX_AUTO_UPDATE;

		this.matrixWorldAutoUpdate = Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
		this.matrixWorldNeedsUpdate = false;

		this.layers = new Layers$1();
		this.visible = true;

		this.castShadow = false;
		this.receiveShadow = false;

		this.frustumCulled = true;
		this.renderOrder = 0;

		this.animations = [];

		this.userData = {};

	}

	onBeforeShadow( /* renderer, object, camera, shadowCamera, geometry, depthMaterial, group */ ) {}

	onAfterShadow( /* renderer, object, camera, shadowCamera, geometry, depthMaterial, group */ ) {}

	onBeforeRender( /* renderer, scene, camera, geometry, material, group */ ) {}

	onAfterRender( /* renderer, scene, camera, geometry, material, group */ ) {}

	applyMatrix4( matrix ) {

		if ( this.matrixAutoUpdate ) this.updateMatrix();

		this.matrix.premultiply( matrix );

		this.matrix.decompose( this.position, this.quaternion, this.scale );

	}

	applyQuaternion( q ) {

		this.quaternion.premultiply( q );

		return this;

	}

	setRotationFromAxisAngle( axis, angle ) {

		// assumes axis is normalized

		this.quaternion.setFromAxisAngle( axis, angle );

	}

	setRotationFromEuler( euler ) {

		this.quaternion.setFromEuler( euler, true );

	}

	setRotationFromMatrix( m ) {

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		this.quaternion.setFromRotationMatrix( m );

	}

	setRotationFromQuaternion( q ) {

		// assumes q is normalized

		this.quaternion.copy( q );

	}

	rotateOnAxis( axis, angle ) {

		// rotate object on axis in object space
		// axis is assumed to be normalized

		_q1$1.setFromAxisAngle( axis, angle );

		this.quaternion.multiply( _q1$1 );

		return this;

	}

	rotateOnWorldAxis( axis, angle ) {

		// rotate object on axis in world space
		// axis is assumed to be normalized
		// method assumes no rotated parent

		_q1$1.setFromAxisAngle( axis, angle );

		this.quaternion.premultiply( _q1$1 );

		return this;

	}

	rotateX( angle ) {

		return this.rotateOnAxis( _xAxis$1, angle );

	}

	rotateY( angle ) {

		return this.rotateOnAxis( _yAxis$1, angle );

	}

	rotateZ( angle ) {

		return this.rotateOnAxis( _zAxis$1, angle );

	}

	translateOnAxis( axis, distance ) {

		// translate object by distance along axis in object space
		// axis is assumed to be normalized

		_v1$4$2.copy( axis ).applyQuaternion( this.quaternion );

		this.position.add( _v1$4$2.multiplyScalar( distance ) );

		return this;

	}

	translateX( distance ) {

		return this.translateOnAxis( _xAxis$1, distance );

	}

	translateY( distance ) {

		return this.translateOnAxis( _yAxis$1, distance );

	}

	translateZ( distance ) {

		return this.translateOnAxis( _zAxis$1, distance );

	}

	localToWorld( vector ) {

		this.updateWorldMatrix( true, false );

		return vector.applyMatrix4( this.matrixWorld );

	}

	worldToLocal( vector ) {

		this.updateWorldMatrix( true, false );

		return vector.applyMatrix4( _m1$3$1.copy( this.matrixWorld ).invert() );

	}

	lookAt( x, y, z ) {

		// This method does not support objects having non-uniformly-scaled parent(s)

		if ( x.isVector3 ) {

			_target$1.copy( x );

		} else {

			_target$1.set( x, y, z );

		}

		const parent = this.parent;

		this.updateWorldMatrix( true, false );

		_position$3$1.setFromMatrixPosition( this.matrixWorld );

		if ( this.isCamera || this.isLight ) {

			_m1$3$1.lookAt( _position$3$1, _target$1, this.up );

		} else {

			_m1$3$1.lookAt( _target$1, _position$3$1, this.up );

		}

		this.quaternion.setFromRotationMatrix( _m1$3$1 );

		if ( parent ) {

			_m1$3$1.extractRotation( parent.matrixWorld );
			_q1$1.setFromRotationMatrix( _m1$3$1 );
			this.quaternion.premultiply( _q1$1.invert() );

		}

	}

	add( object ) {

		if ( arguments.length > 1 ) {

			for ( let i = 0; i < arguments.length; i ++ ) {

				this.add( arguments[ i ] );

			}

			return this;

		}

		if ( object === this ) {

			console.error( 'THREE.Object3D.add: object can\'t be added as a child of itself.', object );
			return this;

		}

		if ( object && object.isObject3D ) {

			object.removeFromParent();
			object.parent = this;
			this.children.push( object );

			object.dispatchEvent( _addedEvent$1 );

			_childaddedEvent$1.child = object;
			this.dispatchEvent( _childaddedEvent$1 );
			_childaddedEvent$1.child = null;

		} else {

			console.error( 'THREE.Object3D.add: object not an instance of THREE.Object3D.', object );

		}

		return this;

	}

	remove( object ) {

		if ( arguments.length > 1 ) {

			for ( let i = 0; i < arguments.length; i ++ ) {

				this.remove( arguments[ i ] );

			}

			return this;

		}

		const index = this.children.indexOf( object );

		if ( index !== - 1 ) {

			object.parent = null;
			this.children.splice( index, 1 );

			object.dispatchEvent( _removedEvent$1 );

			_childremovedEvent$1.child = object;
			this.dispatchEvent( _childremovedEvent$1 );
			_childremovedEvent$1.child = null;

		}

		return this;

	}

	removeFromParent() {

		const parent = this.parent;

		if ( parent !== null ) {

			parent.remove( this );

		}

		return this;

	}

	clear() {

		return this.remove( ... this.children );

	}

	attach( object ) {

		// adds object as a child of this, while maintaining the object's world transform

		// Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)

		this.updateWorldMatrix( true, false );

		_m1$3$1.copy( this.matrixWorld ).invert();

		if ( object.parent !== null ) {

			object.parent.updateWorldMatrix( true, false );

			_m1$3$1.multiply( object.parent.matrixWorld );

		}

		object.applyMatrix4( _m1$3$1 );

		object.removeFromParent();
		object.parent = this;
		this.children.push( object );

		object.updateWorldMatrix( false, true );

		object.dispatchEvent( _addedEvent$1 );

		_childaddedEvent$1.child = object;
		this.dispatchEvent( _childaddedEvent$1 );
		_childaddedEvent$1.child = null;

		return this;

	}

	getObjectById( id ) {

		return this.getObjectByProperty( 'id', id );

	}

	getObjectByName( name ) {

		return this.getObjectByProperty( 'name', name );

	}

	getObjectByProperty( name, value ) {

		if ( this[ name ] === value ) return this;

		for ( let i = 0, l = this.children.length; i < l; i ++ ) {

			const child = this.children[ i ];
			const object = child.getObjectByProperty( name, value );

			if ( object !== undefined ) {

				return object;

			}

		}

		return undefined;

	}

	getObjectsByProperty( name, value, result = [] ) {

		if ( this[ name ] === value ) result.push( this );

		const children = this.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			children[ i ].getObjectsByProperty( name, value, result );

		}

		return result;

	}

	getWorldPosition( target ) {

		this.updateWorldMatrix( true, false );

		return target.setFromMatrixPosition( this.matrixWorld );

	}

	getWorldQuaternion( target ) {

		this.updateWorldMatrix( true, false );

		this.matrixWorld.decompose( _position$3$1, target, _scale$2$1 );

		return target;

	}

	getWorldScale( target ) {

		this.updateWorldMatrix( true, false );

		this.matrixWorld.decompose( _position$3$1, _quaternion$2$1, target );

		return target;

	}

	getWorldDirection( target ) {

		this.updateWorldMatrix( true, false );

		const e = this.matrixWorld.elements;

		return target.set( e[ 8 ], e[ 9 ], e[ 10 ] ).normalize();

	}

	raycast( /* raycaster, intersects */ ) {}

	traverse( callback ) {

		callback( this );

		const children = this.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			children[ i ].traverse( callback );

		}

	}

	traverseVisible( callback ) {

		if ( this.visible === false ) return;

		callback( this );

		const children = this.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			children[ i ].traverseVisible( callback );

		}

	}

	traverseAncestors( callback ) {

		const parent = this.parent;

		if ( parent !== null ) {

			callback( parent );

			parent.traverseAncestors( callback );

		}

	}

	updateMatrix() {

		this.matrix.compose( this.position, this.quaternion, this.scale );

		this.matrixWorldNeedsUpdate = true;

	}

	updateMatrixWorld( force ) {

		if ( this.matrixAutoUpdate ) this.updateMatrix();

		if ( this.matrixWorldNeedsUpdate || force ) {

			if ( this.matrixWorldAutoUpdate === true ) {

				if ( this.parent === null ) {

					this.matrixWorld.copy( this.matrix );

				} else {

					this.matrixWorld.multiplyMatrices( this.parent.matrixWorld, this.matrix );

				}

			}

			this.matrixWorldNeedsUpdate = false;

			force = true;

		}

		// make sure descendants are updated if required

		const children = this.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			const child = children[ i ];

			child.updateMatrixWorld( force );

		}

	}

	updateWorldMatrix( updateParents, updateChildren ) {

		const parent = this.parent;

		if ( updateParents === true && parent !== null ) {

			parent.updateWorldMatrix( true, false );

		}

		if ( this.matrixAutoUpdate ) this.updateMatrix();

		if ( this.matrixWorldAutoUpdate === true ) {

			if ( this.parent === null ) {

				this.matrixWorld.copy( this.matrix );

			} else {

				this.matrixWorld.multiplyMatrices( this.parent.matrixWorld, this.matrix );

			}

		}

		// make sure descendants are updated

		if ( updateChildren === true ) {

			const children = this.children;

			for ( let i = 0, l = children.length; i < l; i ++ ) {

				const child = children[ i ];

				child.updateWorldMatrix( false, true );

			}

		}

	}

	toJSON( meta ) {

		// meta is a string when called from JSON.stringify
		const isRootObject = ( meta === undefined || typeof meta === 'string' );

		const output = {};

		// meta is a hash used to collect geometries, materials.
		// not providing it implies that this is the root object
		// being serialized.
		if ( isRootObject ) {

			// initialize meta obj
			meta = {
				geometries: {},
				materials: {},
				textures: {},
				images: {},
				shapes: {},
				skeletons: {},
				animations: {},
				nodes: {}
			};

			output.metadata = {
				version: 4.6,
				type: 'Object',
				generator: 'Object3D.toJSON'
			};

		}

		// standard Object3D serialization

		const object = {};

		object.uuid = this.uuid;
		object.type = this.type;

		if ( this.name !== '' ) object.name = this.name;
		if ( this.castShadow === true ) object.castShadow = true;
		if ( this.receiveShadow === true ) object.receiveShadow = true;
		if ( this.visible === false ) object.visible = false;
		if ( this.frustumCulled === false ) object.frustumCulled = false;
		if ( this.renderOrder !== 0 ) object.renderOrder = this.renderOrder;
		if ( Object.keys( this.userData ).length > 0 ) object.userData = this.userData;

		object.layers = this.layers.mask;
		object.matrix = this.matrix.toArray();
		object.up = this.up.toArray();

		if ( this.matrixAutoUpdate === false ) object.matrixAutoUpdate = false;

		// object specific properties

		if ( this.isInstancedMesh ) {

			object.type = 'InstancedMesh';
			object.count = this.count;
			object.instanceMatrix = this.instanceMatrix.toJSON();
			if ( this.instanceColor !== null ) object.instanceColor = this.instanceColor.toJSON();

		}

		if ( this.isBatchedMesh ) {

			object.type = 'BatchedMesh';
			object.perObjectFrustumCulled = this.perObjectFrustumCulled;
			object.sortObjects = this.sortObjects;

			object.drawRanges = this._drawRanges;
			object.reservedRanges = this._reservedRanges;

			object.visibility = this._visibility;
			object.active = this._active;
			object.bounds = this._bounds.map( bound => ( {
				boxInitialized: bound.boxInitialized,
				boxMin: bound.box.min.toArray(),
				boxMax: bound.box.max.toArray(),

				sphereInitialized: bound.sphereInitialized,
				sphereRadius: bound.sphere.radius,
				sphereCenter: bound.sphere.center.toArray()
			} ) );

			object.maxInstanceCount = this._maxInstanceCount;
			object.maxVertexCount = this._maxVertexCount;
			object.maxIndexCount = this._maxIndexCount;

			object.geometryInitialized = this._geometryInitialized;
			object.geometryCount = this._geometryCount;

			object.matricesTexture = this._matricesTexture.toJSON( meta );

			if ( this._colorsTexture !== null ) object.colorsTexture = this._colorsTexture.toJSON( meta );

			if ( this.boundingSphere !== null ) {

				object.boundingSphere = {
					center: object.boundingSphere.center.toArray(),
					radius: object.boundingSphere.radius
				};

			}

			if ( this.boundingBox !== null ) {

				object.boundingBox = {
					min: object.boundingBox.min.toArray(),
					max: object.boundingBox.max.toArray()
				};

			}

		}

		//

		function serialize( library, element ) {

			if ( library[ element.uuid ] === undefined ) {

				library[ element.uuid ] = element.toJSON( meta );

			}

			return element.uuid;

		}

		if ( this.isScene ) {

			if ( this.background ) {

				if ( this.background.isColor ) {

					object.background = this.background.toJSON();

				} else if ( this.background.isTexture ) {

					object.background = this.background.toJSON( meta ).uuid;

				}

			}

			if ( this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true ) {

				object.environment = this.environment.toJSON( meta ).uuid;

			}

		} else if ( this.isMesh || this.isLine || this.isPoints ) {

			object.geometry = serialize( meta.geometries, this.geometry );

			const parameters = this.geometry.parameters;

			if ( parameters !== undefined && parameters.shapes !== undefined ) {

				const shapes = parameters.shapes;

				if ( Array.isArray( shapes ) ) {

					for ( let i = 0, l = shapes.length; i < l; i ++ ) {

						const shape = shapes[ i ];

						serialize( meta.shapes, shape );

					}

				} else {

					serialize( meta.shapes, shapes );

				}

			}

		}

		if ( this.isSkinnedMesh ) {

			object.bindMode = this.bindMode;
			object.bindMatrix = this.bindMatrix.toArray();

			if ( this.skeleton !== undefined ) {

				serialize( meta.skeletons, this.skeleton );

				object.skeleton = this.skeleton.uuid;

			}

		}

		if ( this.material !== undefined ) {

			if ( Array.isArray( this.material ) ) {

				const uuids = [];

				for ( let i = 0, l = this.material.length; i < l; i ++ ) {

					uuids.push( serialize( meta.materials, this.material[ i ] ) );

				}

				object.material = uuids;

			} else {

				object.material = serialize( meta.materials, this.material );

			}

		}

		//

		if ( this.children.length > 0 ) {

			object.children = [];

			for ( let i = 0; i < this.children.length; i ++ ) {

				object.children.push( this.children[ i ].toJSON( meta ).object );

			}

		}

		//

		if ( this.animations.length > 0 ) {

			object.animations = [];

			for ( let i = 0; i < this.animations.length; i ++ ) {

				const animation = this.animations[ i ];

				object.animations.push( serialize( meta.animations, animation ) );

			}

		}

		if ( isRootObject ) {

			const geometries = extractFromCache( meta.geometries );
			const materials = extractFromCache( meta.materials );
			const textures = extractFromCache( meta.textures );
			const images = extractFromCache( meta.images );
			const shapes = extractFromCache( meta.shapes );
			const skeletons = extractFromCache( meta.skeletons );
			const animations = extractFromCache( meta.animations );
			const nodes = extractFromCache( meta.nodes );

			if ( geometries.length > 0 ) output.geometries = geometries;
			if ( materials.length > 0 ) output.materials = materials;
			if ( textures.length > 0 ) output.textures = textures;
			if ( images.length > 0 ) output.images = images;
			if ( shapes.length > 0 ) output.shapes = shapes;
			if ( skeletons.length > 0 ) output.skeletons = skeletons;
			if ( animations.length > 0 ) output.animations = animations;
			if ( nodes.length > 0 ) output.nodes = nodes;

		}

		output.object = object;

		return output;

		// extract data from the cache hash
		// remove metadata on each item
		// and return as array
		function extractFromCache( cache ) {

			const values = [];
			for ( const key in cache ) {

				const data = cache[ key ];
				delete data.metadata;
				values.push( data );

			}

			return values;

		}

	}

	clone( recursive ) {

		return new this.constructor().copy( this, recursive );

	}

	copy( source, recursive = true ) {

		this.name = source.name;

		this.up.copy( source.up );

		this.position.copy( source.position );
		this.rotation.order = source.rotation.order;
		this.quaternion.copy( source.quaternion );
		this.scale.copy( source.scale );

		this.matrix.copy( source.matrix );
		this.matrixWorld.copy( source.matrixWorld );

		this.matrixAutoUpdate = source.matrixAutoUpdate;

		this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
		this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;

		this.layers.mask = source.layers.mask;
		this.visible = source.visible;

		this.castShadow = source.castShadow;
		this.receiveShadow = source.receiveShadow;

		this.frustumCulled = source.frustumCulled;
		this.renderOrder = source.renderOrder;

		this.animations = source.animations.slice();

		this.userData = JSON.parse( JSON.stringify( source.userData ) );

		if ( recursive === true ) {

			for ( let i = 0; i < source.children.length; i ++ ) {

				const child = source.children[ i ];
				this.add( child.clone() );

			}

		}

		return this;

	}

};

Object3D$1.DEFAULT_UP = /*@__PURE__*/ new Vector3$1( 0, 1, 0 );
Object3D$1.DEFAULT_MATRIX_AUTO_UPDATE = true;
Object3D$1.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;

const _colorKeywords$1 = { 'aliceblue': 0xF0F8FF, 'antiquewhite': 0xFAEBD7, 'aqua': 0x00FFFF, 'aquamarine': 0x7FFFD4, 'azure': 0xF0FFFF,
	'beige': 0xF5F5DC, 'bisque': 0xFFE4C4, 'black': 0x000000, 'blanchedalmond': 0xFFEBCD, 'blue': 0x0000FF, 'blueviolet': 0x8A2BE2,
	'brown': 0xA52A2A, 'burlywood': 0xDEB887, 'cadetblue': 0x5F9EA0, 'chartreuse': 0x7FFF00, 'chocolate': 0xD2691E, 'coral': 0xFF7F50,
	'cornflowerblue': 0x6495ED, 'cornsilk': 0xFFF8DC, 'crimson': 0xDC143C, 'cyan': 0x00FFFF, 'darkblue': 0x00008B, 'darkcyan': 0x008B8B,
	'darkgoldenrod': 0xB8860B, 'darkgray': 0xA9A9A9, 'darkgreen': 0x006400, 'darkgrey': 0xA9A9A9, 'darkkhaki': 0xBDB76B, 'darkmagenta': 0x8B008B,
	'darkolivegreen': 0x556B2F, 'darkorange': 0xFF8C00, 'darkorchid': 0x9932CC, 'darkred': 0x8B0000, 'darksalmon': 0xE9967A, 'darkseagreen': 0x8FBC8F,
	'darkslateblue': 0x483D8B, 'darkslategray': 0x2F4F4F, 'darkslategrey': 0x2F4F4F, 'darkturquoise': 0x00CED1, 'darkviolet': 0x9400D3,
	'deeppink': 0xFF1493, 'deepskyblue': 0x00BFFF, 'dimgray': 0x696969, 'dimgrey': 0x696969, 'dodgerblue': 0x1E90FF, 'firebrick': 0xB22222,
	'floralwhite': 0xFFFAF0, 'forestgreen': 0x228B22, 'fuchsia': 0xFF00FF, 'gainsboro': 0xDCDCDC, 'ghostwhite': 0xF8F8FF, 'gold': 0xFFD700,
	'goldenrod': 0xDAA520, 'gray': 0x808080, 'green': 0x008000, 'greenyellow': 0xADFF2F, 'grey': 0x808080, 'honeydew': 0xF0FFF0, 'hotpink': 0xFF69B4,
	'indianred': 0xCD5C5C, 'indigo': 0x4B0082, 'ivory': 0xFFFFF0, 'khaki': 0xF0E68C, 'lavender': 0xE6E6FA, 'lavenderblush': 0xFFF0F5, 'lawngreen': 0x7CFC00,
	'lemonchiffon': 0xFFFACD, 'lightblue': 0xADD8E6, 'lightcoral': 0xF08080, 'lightcyan': 0xE0FFFF, 'lightgoldenrodyellow': 0xFAFAD2, 'lightgray': 0xD3D3D3,
	'lightgreen': 0x90EE90, 'lightgrey': 0xD3D3D3, 'lightpink': 0xFFB6C1, 'lightsalmon': 0xFFA07A, 'lightseagreen': 0x20B2AA, 'lightskyblue': 0x87CEFA,
	'lightslategray': 0x778899, 'lightslategrey': 0x778899, 'lightsteelblue': 0xB0C4DE, 'lightyellow': 0xFFFFE0, 'lime': 0x00FF00, 'limegreen': 0x32CD32,
	'linen': 0xFAF0E6, 'magenta': 0xFF00FF, 'maroon': 0x800000, 'mediumaquamarine': 0x66CDAA, 'mediumblue': 0x0000CD, 'mediumorchid': 0xBA55D3,
	'mediumpurple': 0x9370DB, 'mediumseagreen': 0x3CB371, 'mediumslateblue': 0x7B68EE, 'mediumspringgreen': 0x00FA9A, 'mediumturquoise': 0x48D1CC,
	'mediumvioletred': 0xC71585, 'midnightblue': 0x191970, 'mintcream': 0xF5FFFA, 'mistyrose': 0xFFE4E1, 'moccasin': 0xFFE4B5, 'navajowhite': 0xFFDEAD,
	'navy': 0x000080, 'oldlace': 0xFDF5E6, 'olive': 0x808000, 'olivedrab': 0x6B8E23, 'orange': 0xFFA500, 'orangered': 0xFF4500, 'orchid': 0xDA70D6,
	'palegoldenrod': 0xEEE8AA, 'palegreen': 0x98FB98, 'paleturquoise': 0xAFEEEE, 'palevioletred': 0xDB7093, 'papayawhip': 0xFFEFD5, 'peachpuff': 0xFFDAB9,
	'peru': 0xCD853F, 'pink': 0xFFC0CB, 'plum': 0xDDA0DD, 'powderblue': 0xB0E0E6, 'purple': 0x800080, 'rebeccapurple': 0x663399, 'red': 0xFF0000, 'rosybrown': 0xBC8F8F,
	'royalblue': 0x4169E1, 'saddlebrown': 0x8B4513, 'salmon': 0xFA8072, 'sandybrown': 0xF4A460, 'seagreen': 0x2E8B57, 'seashell': 0xFFF5EE,
	'sienna': 0xA0522D, 'silver': 0xC0C0C0, 'skyblue': 0x87CEEB, 'slateblue': 0x6A5ACD, 'slategray': 0x708090, 'slategrey': 0x708090, 'snow': 0xFFFAFA,
	'springgreen': 0x00FF7F, 'steelblue': 0x4682B4, 'tan': 0xD2B48C, 'teal': 0x008080, 'thistle': 0xD8BFD8, 'tomato': 0xFF6347, 'turquoise': 0x40E0D0,
	'violet': 0xEE82EE, 'wheat': 0xF5DEB3, 'white': 0xFFFFFF, 'whitesmoke': 0xF5F5F5, 'yellow': 0xFFFF00, 'yellowgreen': 0x9ACD32 };

const _hslA$1 = { h: 0, s: 0, l: 0 };
const _hslB$1 = { h: 0, s: 0, l: 0 };

function hue2rgb$1( p, q, t ) {

	if ( t < 0 ) t += 1;
	if ( t > 1 ) t -= 1;
	if ( t < 1 / 6 ) return p + ( q - p ) * 6 * t;
	if ( t < 1 / 2 ) return q;
	if ( t < 2 / 3 ) return p + ( q - p ) * 6 * ( 2 / 3 - t );
	return p;

}

let Color$1=class Color {

	constructor( r, g, b ) {

		this.isColor = true;

		this.r = 1;
		this.g = 1;
		this.b = 1;

		return this.set( r, g, b );

	}

	set( r, g, b ) {

		if ( g === undefined && b === undefined ) {

			// r is THREE.Color, hex or string

			const value = r;

			if ( value && value.isColor ) {

				this.copy( value );

			} else if ( typeof value === 'number' ) {

				this.setHex( value );

			} else if ( typeof value === 'string' ) {

				this.setStyle( value );

			}

		} else {

			this.setRGB( r, g, b );

		}

		return this;

	}

	setScalar( scalar ) {

		this.r = scalar;
		this.g = scalar;
		this.b = scalar;

		return this;

	}

	setHex( hex, colorSpace = SRGBColorSpace$1 ) {

		hex = Math.floor( hex );

		this.r = ( hex >> 16 & 255 ) / 255;
		this.g = ( hex >> 8 & 255 ) / 255;
		this.b = ( hex & 255 ) / 255;

		ColorManagement$1.toWorkingColorSpace( this, colorSpace );

		return this;

	}

	setRGB( r, g, b, colorSpace = ColorManagement$1.workingColorSpace ) {

		this.r = r;
		this.g = g;
		this.b = b;

		ColorManagement$1.toWorkingColorSpace( this, colorSpace );

		return this;

	}

	setHSL( h, s, l, colorSpace = ColorManagement$1.workingColorSpace ) {

		// h,s,l ranges are in 0.0 - 1.0
		h = euclideanModulo$1( h, 1 );
		s = clamp$1( s, 0, 1 );
		l = clamp$1( l, 0, 1 );

		if ( s === 0 ) {

			this.r = this.g = this.b = l;

		} else {

			const p = l <= 0.5 ? l * ( 1 + s ) : l + s - ( l * s );
			const q = ( 2 * l ) - p;

			this.r = hue2rgb$1( q, p, h + 1 / 3 );
			this.g = hue2rgb$1( q, p, h );
			this.b = hue2rgb$1( q, p, h - 1 / 3 );

		}

		ColorManagement$1.toWorkingColorSpace( this, colorSpace );

		return this;

	}

	setStyle( style, colorSpace = SRGBColorSpace$1 ) {

		function handleAlpha( string ) {

			if ( string === undefined ) return;

			if ( parseFloat( string ) < 1 ) {

				console.warn( 'THREE.Color: Alpha component of ' + style + ' will be ignored.' );

			}

		}


		let m;

		if ( m = /^(\w+)\(([^\)]*)\)/.exec( style ) ) {

			// rgb / hsl

			let color;
			const name = m[ 1 ];
			const components = m[ 2 ];

			switch ( name ) {

				case 'rgb':
				case 'rgba':

					if ( color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec( components ) ) {

						// rgb(255,0,0) rgba(255,0,0,0.5)

						handleAlpha( color[ 4 ] );

						return this.setRGB(
							Math.min( 255, parseInt( color[ 1 ], 10 ) ) / 255,
							Math.min( 255, parseInt( color[ 2 ], 10 ) ) / 255,
							Math.min( 255, parseInt( color[ 3 ], 10 ) ) / 255,
							colorSpace
						);

					}

					if ( color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec( components ) ) {

						// rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)

						handleAlpha( color[ 4 ] );

						return this.setRGB(
							Math.min( 100, parseInt( color[ 1 ], 10 ) ) / 100,
							Math.min( 100, parseInt( color[ 2 ], 10 ) ) / 100,
							Math.min( 100, parseInt( color[ 3 ], 10 ) ) / 100,
							colorSpace
						);

					}

					break;

				case 'hsl':
				case 'hsla':

					if ( color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec( components ) ) {

						// hsl(120,50%,50%) hsla(120,50%,50%,0.5)

						handleAlpha( color[ 4 ] );

						return this.setHSL(
							parseFloat( color[ 1 ] ) / 360,
							parseFloat( color[ 2 ] ) / 100,
							parseFloat( color[ 3 ] ) / 100,
							colorSpace
						);

					}

					break;

				default:

					console.warn( 'THREE.Color: Unknown color model ' + style );

			}

		} else if ( m = /^\#([A-Fa-f\d]+)$/.exec( style ) ) {

			// hex color

			const hex = m[ 1 ];
			const size = hex.length;

			if ( size === 3 ) {

				// #ff0
				return this.setRGB(
					parseInt( hex.charAt( 0 ), 16 ) / 15,
					parseInt( hex.charAt( 1 ), 16 ) / 15,
					parseInt( hex.charAt( 2 ), 16 ) / 15,
					colorSpace
				);

			} else if ( size === 6 ) {

				// #ff0000
				return this.setHex( parseInt( hex, 16 ), colorSpace );

			} else {

				console.warn( 'THREE.Color: Invalid hex color ' + style );

			}

		} else if ( style && style.length > 0 ) {

			return this.setColorName( style, colorSpace );

		}

		return this;

	}

	setColorName( style, colorSpace = SRGBColorSpace$1 ) {

		// color keywords
		const hex = _colorKeywords$1[ style.toLowerCase() ];

		if ( hex !== undefined ) {

			// red
			this.setHex( hex, colorSpace );

		} else {

			// unknown color
			console.warn( 'THREE.Color: Unknown color ' + style );

		}

		return this;

	}

	clone() {

		return new this.constructor( this.r, this.g, this.b );

	}

	copy( color ) {

		this.r = color.r;
		this.g = color.g;
		this.b = color.b;

		return this;

	}

	copySRGBToLinear( color ) {

		this.r = SRGBToLinear$1( color.r );
		this.g = SRGBToLinear$1( color.g );
		this.b = SRGBToLinear$1( color.b );

		return this;

	}

	copyLinearToSRGB( color ) {

		this.r = LinearToSRGB$1( color.r );
		this.g = LinearToSRGB$1( color.g );
		this.b = LinearToSRGB$1( color.b );

		return this;

	}

	convertSRGBToLinear() {

		this.copySRGBToLinear( this );

		return this;

	}

	convertLinearToSRGB() {

		this.copyLinearToSRGB( this );

		return this;

	}

	getHex( colorSpace = SRGBColorSpace$1 ) {

		ColorManagement$1.fromWorkingColorSpace( _color$2.copy( this ), colorSpace );

		return Math.round( clamp$1( _color$2.r * 255, 0, 255 ) ) * 65536 + Math.round( clamp$1( _color$2.g * 255, 0, 255 ) ) * 256 + Math.round( clamp$1( _color$2.b * 255, 0, 255 ) );

	}

	getHexString( colorSpace = SRGBColorSpace$1 ) {

		return ( '000000' + this.getHex( colorSpace ).toString( 16 ) ).slice( - 6 );

	}

	getHSL( target, colorSpace = ColorManagement$1.workingColorSpace ) {

		// h,s,l ranges are in 0.0 - 1.0

		ColorManagement$1.fromWorkingColorSpace( _color$2.copy( this ), colorSpace );

		const r = _color$2.r, g = _color$2.g, b = _color$2.b;

		const max = Math.max( r, g, b );
		const min = Math.min( r, g, b );

		let hue, saturation;
		const lightness = ( min + max ) / 2.0;

		if ( min === max ) {

			hue = 0;
			saturation = 0;

		} else {

			const delta = max - min;

			saturation = lightness <= 0.5 ? delta / ( max + min ) : delta / ( 2 - max - min );

			switch ( max ) {

				case r: hue = ( g - b ) / delta + ( g < b ? 6 : 0 ); break;
				case g: hue = ( b - r ) / delta + 2; break;
				case b: hue = ( r - g ) / delta + 4; break;

			}

			hue /= 6;

		}

		target.h = hue;
		target.s = saturation;
		target.l = lightness;

		return target;

	}

	getRGB( target, colorSpace = ColorManagement$1.workingColorSpace ) {

		ColorManagement$1.fromWorkingColorSpace( _color$2.copy( this ), colorSpace );

		target.r = _color$2.r;
		target.g = _color$2.g;
		target.b = _color$2.b;

		return target;

	}

	getStyle( colorSpace = SRGBColorSpace$1 ) {

		ColorManagement$1.fromWorkingColorSpace( _color$2.copy( this ), colorSpace );

		const r = _color$2.r, g = _color$2.g, b = _color$2.b;

		if ( colorSpace !== SRGBColorSpace$1 ) {

			// Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
			return `color(${ colorSpace } ${ r.toFixed( 3 ) } ${ g.toFixed( 3 ) } ${ b.toFixed( 3 ) })`;

		}

		return `rgb(${ Math.round( r * 255 ) },${ Math.round( g * 255 ) },${ Math.round( b * 255 ) })`;

	}

	offsetHSL( h, s, l ) {

		this.getHSL( _hslA$1 );

		return this.setHSL( _hslA$1.h + h, _hslA$1.s + s, _hslA$1.l + l );

	}

	add( color ) {

		this.r += color.r;
		this.g += color.g;
		this.b += color.b;

		return this;

	}

	addColors( color1, color2 ) {

		this.r = color1.r + color2.r;
		this.g = color1.g + color2.g;
		this.b = color1.b + color2.b;

		return this;

	}

	addScalar( s ) {

		this.r += s;
		this.g += s;
		this.b += s;

		return this;

	}

	sub( color ) {

		this.r = Math.max( 0, this.r - color.r );
		this.g = Math.max( 0, this.g - color.g );
		this.b = Math.max( 0, this.b - color.b );

		return this;

	}

	multiply( color ) {

		this.r *= color.r;
		this.g *= color.g;
		this.b *= color.b;

		return this;

	}

	multiplyScalar( s ) {

		this.r *= s;
		this.g *= s;
		this.b *= s;

		return this;

	}

	lerp( color, alpha ) {

		this.r += ( color.r - this.r ) * alpha;
		this.g += ( color.g - this.g ) * alpha;
		this.b += ( color.b - this.b ) * alpha;

		return this;

	}

	lerpColors( color1, color2, alpha ) {

		this.r = color1.r + ( color2.r - color1.r ) * alpha;
		this.g = color1.g + ( color2.g - color1.g ) * alpha;
		this.b = color1.b + ( color2.b - color1.b ) * alpha;

		return this;

	}

	lerpHSL( color, alpha ) {

		this.getHSL( _hslA$1 );
		color.getHSL( _hslB$1 );

		const h = lerp$1( _hslA$1.h, _hslB$1.h, alpha );
		const s = lerp$1( _hslA$1.s, _hslB$1.s, alpha );
		const l = lerp$1( _hslA$1.l, _hslB$1.l, alpha );

		this.setHSL( h, s, l );

		return this;

	}

	setFromVector3( v ) {

		this.r = v.x;
		this.g = v.y;
		this.b = v.z;

		return this;

	}

	applyMatrix3( m ) {

		const r = this.r, g = this.g, b = this.b;
		const e = m.elements;

		this.r = e[ 0 ] * r + e[ 3 ] * g + e[ 6 ] * b;
		this.g = e[ 1 ] * r + e[ 4 ] * g + e[ 7 ] * b;
		this.b = e[ 2 ] * r + e[ 5 ] * g + e[ 8 ] * b;

		return this;

	}

	equals( c ) {

		return ( c.r === this.r ) && ( c.g === this.g ) && ( c.b === this.b );

	}

	fromArray( array, offset = 0 ) {

		this.r = array[ offset ];
		this.g = array[ offset + 1 ];
		this.b = array[ offset + 2 ];

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this.r;
		array[ offset + 1 ] = this.g;
		array[ offset + 2 ] = this.b;

		return array;

	}

	fromBufferAttribute( attribute, index ) {

		this.r = attribute.getX( index );
		this.g = attribute.getY( index );
		this.b = attribute.getZ( index );

		return this;

	}

	toJSON() {

		return this.getHex();

	}

	*[ Symbol.iterator ]() {

		yield this.r;
		yield this.g;
		yield this.b;

	}

};

const _color$2 = /*@__PURE__*/ new Color$1();

Color$1.NAMES = _colorKeywords$1;

let _materialId$1 = 0;

let Material$1=class Material extends EventDispatcher$3 {

	constructor() {

		super();

		this.isMaterial = true;

		Object.defineProperty( this, 'id', { value: _materialId$1 ++ } );

		this.uuid = generateUUID$1();

		this.name = '';
		this.type = 'Material';

		this.blending = NormalBlending$1;
		this.side = FrontSide$1;
		this.vertexColors = false;

		this.opacity = 1;
		this.transparent = false;
		this.alphaHash = false;

		this.blendSrc = SrcAlphaFactor$1;
		this.blendDst = OneMinusSrcAlphaFactor$1;
		this.blendEquation = AddEquation$1;
		this.blendSrcAlpha = null;
		this.blendDstAlpha = null;
		this.blendEquationAlpha = null;
		this.blendColor = new Color$1( 0, 0, 0 );
		this.blendAlpha = 0;

		this.depthFunc = LessEqualDepth$1;
		this.depthTest = true;
		this.depthWrite = true;

		this.stencilWriteMask = 0xff;
		this.stencilFunc = AlwaysStencilFunc$1;
		this.stencilRef = 0;
		this.stencilFuncMask = 0xff;
		this.stencilFail = KeepStencilOp$1;
		this.stencilZFail = KeepStencilOp$1;
		this.stencilZPass = KeepStencilOp$1;
		this.stencilWrite = false;

		this.clippingPlanes = null;
		this.clipIntersection = false;
		this.clipShadows = false;

		this.shadowSide = null;

		this.colorWrite = true;

		this.precision = null; // override the renderer's default precision for this material

		this.polygonOffset = false;
		this.polygonOffsetFactor = 0;
		this.polygonOffsetUnits = 0;

		this.dithering = false;

		this.alphaToCoverage = false;
		this.premultipliedAlpha = false;
		this.forceSinglePass = false;

		this.visible = true;

		this.toneMapped = true;

		this.userData = {};

		this.version = 0;

		this._alphaTest = 0;

	}

	get alphaTest() {

		return this._alphaTest;

	}

	set alphaTest( value ) {

		if ( this._alphaTest > 0 !== value > 0 ) {

			this.version ++;

		}

		this._alphaTest = value;

	}

	onBeforeCompile( /* shaderobject, renderer */ ) {}

	customProgramCacheKey() {

		return this.onBeforeCompile.toString();

	}

	setValues( values ) {

		if ( values === undefined ) return;

		for ( const key in values ) {

			const newValue = values[ key ];

			if ( newValue === undefined ) {

				console.warn( `THREE.Material: parameter '${ key }' has value of undefined.` );
				continue;

			}

			const currentValue = this[ key ];

			if ( currentValue === undefined ) {

				console.warn( `THREE.Material: '${ key }' is not a property of THREE.${ this.type }.` );
				continue;

			}

			if ( currentValue && currentValue.isColor ) {

				currentValue.set( newValue );

			} else if ( ( currentValue && currentValue.isVector3 ) && ( newValue && newValue.isVector3 ) ) {

				currentValue.copy( newValue );

			} else {

				this[ key ] = newValue;

			}

		}

	}

	toJSON( meta ) {

		const isRootObject = ( meta === undefined || typeof meta === 'string' );

		if ( isRootObject ) {

			meta = {
				textures: {},
				images: {}
			};

		}

		const data = {
			metadata: {
				version: 4.6,
				type: 'Material',
				generator: 'Material.toJSON'
			}
		};

		// standard Material serialization
		data.uuid = this.uuid;
		data.type = this.type;

		if ( this.name !== '' ) data.name = this.name;

		if ( this.color && this.color.isColor ) data.color = this.color.getHex();

		if ( this.roughness !== undefined ) data.roughness = this.roughness;
		if ( this.metalness !== undefined ) data.metalness = this.metalness;

		if ( this.sheen !== undefined ) data.sheen = this.sheen;
		if ( this.sheenColor && this.sheenColor.isColor ) data.sheenColor = this.sheenColor.getHex();
		if ( this.sheenRoughness !== undefined ) data.sheenRoughness = this.sheenRoughness;
		if ( this.emissive && this.emissive.isColor ) data.emissive = this.emissive.getHex();
		if ( this.emissiveIntensity !== undefined && this.emissiveIntensity !== 1 ) data.emissiveIntensity = this.emissiveIntensity;

		if ( this.specular && this.specular.isColor ) data.specular = this.specular.getHex();
		if ( this.specularIntensity !== undefined ) data.specularIntensity = this.specularIntensity;
		if ( this.specularColor && this.specularColor.isColor ) data.specularColor = this.specularColor.getHex();
		if ( this.shininess !== undefined ) data.shininess = this.shininess;
		if ( this.clearcoat !== undefined ) data.clearcoat = this.clearcoat;
		if ( this.clearcoatRoughness !== undefined ) data.clearcoatRoughness = this.clearcoatRoughness;

		if ( this.clearcoatMap && this.clearcoatMap.isTexture ) {

			data.clearcoatMap = this.clearcoatMap.toJSON( meta ).uuid;

		}

		if ( this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture ) {

			data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON( meta ).uuid;

		}

		if ( this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture ) {

			data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON( meta ).uuid;
			data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();

		}

		if ( this.dispersion !== undefined ) data.dispersion = this.dispersion;

		if ( this.iridescence !== undefined ) data.iridescence = this.iridescence;
		if ( this.iridescenceIOR !== undefined ) data.iridescenceIOR = this.iridescenceIOR;
		if ( this.iridescenceThicknessRange !== undefined ) data.iridescenceThicknessRange = this.iridescenceThicknessRange;

		if ( this.iridescenceMap && this.iridescenceMap.isTexture ) {

			data.iridescenceMap = this.iridescenceMap.toJSON( meta ).uuid;

		}

		if ( this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture ) {

			data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON( meta ).uuid;

		}

		if ( this.anisotropy !== undefined ) data.anisotropy = this.anisotropy;
		if ( this.anisotropyRotation !== undefined ) data.anisotropyRotation = this.anisotropyRotation;

		if ( this.anisotropyMap && this.anisotropyMap.isTexture ) {

			data.anisotropyMap = this.anisotropyMap.toJSON( meta ).uuid;

		}

		if ( this.map && this.map.isTexture ) data.map = this.map.toJSON( meta ).uuid;
		if ( this.matcap && this.matcap.isTexture ) data.matcap = this.matcap.toJSON( meta ).uuid;
		if ( this.alphaMap && this.alphaMap.isTexture ) data.alphaMap = this.alphaMap.toJSON( meta ).uuid;

		if ( this.lightMap && this.lightMap.isTexture ) {

			data.lightMap = this.lightMap.toJSON( meta ).uuid;
			data.lightMapIntensity = this.lightMapIntensity;

		}

		if ( this.aoMap && this.aoMap.isTexture ) {

			data.aoMap = this.aoMap.toJSON( meta ).uuid;
			data.aoMapIntensity = this.aoMapIntensity;

		}

		if ( this.bumpMap && this.bumpMap.isTexture ) {

			data.bumpMap = this.bumpMap.toJSON( meta ).uuid;
			data.bumpScale = this.bumpScale;

		}

		if ( this.normalMap && this.normalMap.isTexture ) {

			data.normalMap = this.normalMap.toJSON( meta ).uuid;
			data.normalMapType = this.normalMapType;
			data.normalScale = this.normalScale.toArray();

		}

		if ( this.displacementMap && this.displacementMap.isTexture ) {

			data.displacementMap = this.displacementMap.toJSON( meta ).uuid;
			data.displacementScale = this.displacementScale;
			data.displacementBias = this.displacementBias;

		}

		if ( this.roughnessMap && this.roughnessMap.isTexture ) data.roughnessMap = this.roughnessMap.toJSON( meta ).uuid;
		if ( this.metalnessMap && this.metalnessMap.isTexture ) data.metalnessMap = this.metalnessMap.toJSON( meta ).uuid;

		if ( this.emissiveMap && this.emissiveMap.isTexture ) data.emissiveMap = this.emissiveMap.toJSON( meta ).uuid;
		if ( this.specularMap && this.specularMap.isTexture ) data.specularMap = this.specularMap.toJSON( meta ).uuid;
		if ( this.specularIntensityMap && this.specularIntensityMap.isTexture ) data.specularIntensityMap = this.specularIntensityMap.toJSON( meta ).uuid;
		if ( this.specularColorMap && this.specularColorMap.isTexture ) data.specularColorMap = this.specularColorMap.toJSON( meta ).uuid;

		if ( this.envMap && this.envMap.isTexture ) {

			data.envMap = this.envMap.toJSON( meta ).uuid;

			if ( this.combine !== undefined ) data.combine = this.combine;

		}

		if ( this.envMapRotation !== undefined ) data.envMapRotation = this.envMapRotation.toArray();
		if ( this.envMapIntensity !== undefined ) data.envMapIntensity = this.envMapIntensity;
		if ( this.reflectivity !== undefined ) data.reflectivity = this.reflectivity;
		if ( this.refractionRatio !== undefined ) data.refractionRatio = this.refractionRatio;

		if ( this.gradientMap && this.gradientMap.isTexture ) {

			data.gradientMap = this.gradientMap.toJSON( meta ).uuid;

		}

		if ( this.transmission !== undefined ) data.transmission = this.transmission;
		if ( this.transmissionMap && this.transmissionMap.isTexture ) data.transmissionMap = this.transmissionMap.toJSON( meta ).uuid;
		if ( this.thickness !== undefined ) data.thickness = this.thickness;
		if ( this.thicknessMap && this.thicknessMap.isTexture ) data.thicknessMap = this.thicknessMap.toJSON( meta ).uuid;
		if ( this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity ) data.attenuationDistance = this.attenuationDistance;
		if ( this.attenuationColor !== undefined ) data.attenuationColor = this.attenuationColor.getHex();

		if ( this.size !== undefined ) data.size = this.size;
		if ( this.shadowSide !== null ) data.shadowSide = this.shadowSide;
		if ( this.sizeAttenuation !== undefined ) data.sizeAttenuation = this.sizeAttenuation;

		if ( this.blending !== NormalBlending$1 ) data.blending = this.blending;
		if ( this.side !== FrontSide$1 ) data.side = this.side;
		if ( this.vertexColors === true ) data.vertexColors = true;

		if ( this.opacity < 1 ) data.opacity = this.opacity;
		if ( this.transparent === true ) data.transparent = true;

		if ( this.blendSrc !== SrcAlphaFactor$1 ) data.blendSrc = this.blendSrc;
		if ( this.blendDst !== OneMinusSrcAlphaFactor$1 ) data.blendDst = this.blendDst;
		if ( this.blendEquation !== AddEquation$1 ) data.blendEquation = this.blendEquation;
		if ( this.blendSrcAlpha !== null ) data.blendSrcAlpha = this.blendSrcAlpha;
		if ( this.blendDstAlpha !== null ) data.blendDstAlpha = this.blendDstAlpha;
		if ( this.blendEquationAlpha !== null ) data.blendEquationAlpha = this.blendEquationAlpha;
		if ( this.blendColor && this.blendColor.isColor ) data.blendColor = this.blendColor.getHex();
		if ( this.blendAlpha !== 0 ) data.blendAlpha = this.blendAlpha;

		if ( this.depthFunc !== LessEqualDepth$1 ) data.depthFunc = this.depthFunc;
		if ( this.depthTest === false ) data.depthTest = this.depthTest;
		if ( this.depthWrite === false ) data.depthWrite = this.depthWrite;
		if ( this.colorWrite === false ) data.colorWrite = this.colorWrite;

		if ( this.stencilWriteMask !== 0xff ) data.stencilWriteMask = this.stencilWriteMask;
		if ( this.stencilFunc !== AlwaysStencilFunc$1 ) data.stencilFunc = this.stencilFunc;
		if ( this.stencilRef !== 0 ) data.stencilRef = this.stencilRef;
		if ( this.stencilFuncMask !== 0xff ) data.stencilFuncMask = this.stencilFuncMask;
		if ( this.stencilFail !== KeepStencilOp$1 ) data.stencilFail = this.stencilFail;
		if ( this.stencilZFail !== KeepStencilOp$1 ) data.stencilZFail = this.stencilZFail;
		if ( this.stencilZPass !== KeepStencilOp$1 ) data.stencilZPass = this.stencilZPass;
		if ( this.stencilWrite === true ) data.stencilWrite = this.stencilWrite;

		// rotation (SpriteMaterial)
		if ( this.rotation !== undefined && this.rotation !== 0 ) data.rotation = this.rotation;

		if ( this.polygonOffset === true ) data.polygonOffset = true;
		if ( this.polygonOffsetFactor !== 0 ) data.polygonOffsetFactor = this.polygonOffsetFactor;
		if ( this.polygonOffsetUnits !== 0 ) data.polygonOffsetUnits = this.polygonOffsetUnits;

		if ( this.linewidth !== undefined && this.linewidth !== 1 ) data.linewidth = this.linewidth;
		if ( this.dashSize !== undefined ) data.dashSize = this.dashSize;
		if ( this.gapSize !== undefined ) data.gapSize = this.gapSize;
		if ( this.scale !== undefined ) data.scale = this.scale;

		if ( this.dithering === true ) data.dithering = true;

		if ( this.alphaTest > 0 ) data.alphaTest = this.alphaTest;
		if ( this.alphaHash === true ) data.alphaHash = true;
		if ( this.alphaToCoverage === true ) data.alphaToCoverage = true;
		if ( this.premultipliedAlpha === true ) data.premultipliedAlpha = true;
		if ( this.forceSinglePass === true ) data.forceSinglePass = true;

		if ( this.wireframe === true ) data.wireframe = true;
		if ( this.wireframeLinewidth > 1 ) data.wireframeLinewidth = this.wireframeLinewidth;
		if ( this.wireframeLinecap !== 'round' ) data.wireframeLinecap = this.wireframeLinecap;
		if ( this.wireframeLinejoin !== 'round' ) data.wireframeLinejoin = this.wireframeLinejoin;

		if ( this.flatShading === true ) data.flatShading = true;

		if ( this.visible === false ) data.visible = false;

		if ( this.toneMapped === false ) data.toneMapped = false;

		if ( this.fog === false ) data.fog = false;

		if ( Object.keys( this.userData ).length > 0 ) data.userData = this.userData;

		// TODO: Copied from Object3D.toJSON

		function extractFromCache( cache ) {

			const values = [];

			for ( const key in cache ) {

				const data = cache[ key ];
				delete data.metadata;
				values.push( data );

			}

			return values;

		}

		if ( isRootObject ) {

			const textures = extractFromCache( meta.textures );
			const images = extractFromCache( meta.images );

			if ( textures.length > 0 ) data.textures = textures;
			if ( images.length > 0 ) data.images = images;

		}

		return data;

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( source ) {

		this.name = source.name;

		this.blending = source.blending;
		this.side = source.side;
		this.vertexColors = source.vertexColors;

		this.opacity = source.opacity;
		this.transparent = source.transparent;

		this.blendSrc = source.blendSrc;
		this.blendDst = source.blendDst;
		this.blendEquation = source.blendEquation;
		this.blendSrcAlpha = source.blendSrcAlpha;
		this.blendDstAlpha = source.blendDstAlpha;
		this.blendEquationAlpha = source.blendEquationAlpha;
		this.blendColor.copy( source.blendColor );
		this.blendAlpha = source.blendAlpha;

		this.depthFunc = source.depthFunc;
		this.depthTest = source.depthTest;
		this.depthWrite = source.depthWrite;

		this.stencilWriteMask = source.stencilWriteMask;
		this.stencilFunc = source.stencilFunc;
		this.stencilRef = source.stencilRef;
		this.stencilFuncMask = source.stencilFuncMask;
		this.stencilFail = source.stencilFail;
		this.stencilZFail = source.stencilZFail;
		this.stencilZPass = source.stencilZPass;
		this.stencilWrite = source.stencilWrite;

		const srcPlanes = source.clippingPlanes;
		let dstPlanes = null;

		if ( srcPlanes !== null ) {

			const n = srcPlanes.length;
			dstPlanes = new Array( n );

			for ( let i = 0; i !== n; ++ i ) {

				dstPlanes[ i ] = srcPlanes[ i ].clone();

			}

		}

		this.clippingPlanes = dstPlanes;
		this.clipIntersection = source.clipIntersection;
		this.clipShadows = source.clipShadows;

		this.shadowSide = source.shadowSide;

		this.colorWrite = source.colorWrite;

		this.precision = source.precision;

		this.polygonOffset = source.polygonOffset;
		this.polygonOffsetFactor = source.polygonOffsetFactor;
		this.polygonOffsetUnits = source.polygonOffsetUnits;

		this.dithering = source.dithering;

		this.alphaTest = source.alphaTest;
		this.alphaHash = source.alphaHash;
		this.alphaToCoverage = source.alphaToCoverage;
		this.premultipliedAlpha = source.premultipliedAlpha;
		this.forceSinglePass = source.forceSinglePass;

		this.visible = source.visible;

		this.toneMapped = source.toneMapped;

		this.userData = JSON.parse( JSON.stringify( source.userData ) );

		return this;

	}

	dispose() {

		this.dispatchEvent( { type: 'dispose' } );

	}

	set needsUpdate( value ) {

		if ( value === true ) this.version ++;

	}

	onBuild( /* shaderobject, renderer */ ) {

		console.warn( 'Material: onBuild() has been removed.' ); // @deprecated, r166

	}

	onBeforeRender( /* renderer, scene, camera, geometry, object, group */ ) {

		console.warn( 'Material: onBeforeRender() has been removed.' ); // @deprecated, r166

	}


};

const _vector$9$1 = /*@__PURE__*/ new Vector3$1();
const _vector2$1$1 = /*@__PURE__*/ new Vector2$1();

let BufferAttribute$1=class BufferAttribute {

	constructor( array, itemSize, normalized = false ) {

		if ( Array.isArray( array ) ) {

			throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );

		}

		this.isBufferAttribute = true;

		this.name = '';

		this.array = array;
		this.itemSize = itemSize;
		this.count = array !== undefined ? array.length / itemSize : 0;
		this.normalized = normalized;

		this.usage = StaticDrawUsage$1;
		this._updateRange = { offset: 0, count: - 1 };
		this.updateRanges = [];
		this.gpuType = FloatType$1;

		this.version = 0;

	}

	onUploadCallback() {}

	set needsUpdate( value ) {

		if ( value === true ) this.version ++;

	}

	get updateRange() {

		warnOnce$1( 'THREE.BufferAttribute: updateRange() is deprecated and will be removed in r169. Use addUpdateRange() instead.' ); // @deprecated, r159
		return this._updateRange;

	}

	setUsage( value ) {

		this.usage = value;

		return this;

	}

	addUpdateRange( start, count ) {

		this.updateRanges.push( { start, count } );

	}

	clearUpdateRanges() {

		this.updateRanges.length = 0;

	}

	copy( source ) {

		this.name = source.name;
		this.array = new source.array.constructor( source.array );
		this.itemSize = source.itemSize;
		this.count = source.count;
		this.normalized = source.normalized;

		this.usage = source.usage;
		this.gpuType = source.gpuType;

		return this;

	}

	copyAt( index1, attribute, index2 ) {

		index1 *= this.itemSize;
		index2 *= attribute.itemSize;

		for ( let i = 0, l = this.itemSize; i < l; i ++ ) {

			this.array[ index1 + i ] = attribute.array[ index2 + i ];

		}

		return this;

	}

	copyArray( array ) {

		this.array.set( array );

		return this;

	}

	applyMatrix3( m ) {

		if ( this.itemSize === 2 ) {

			for ( let i = 0, l = this.count; i < l; i ++ ) {

				_vector2$1$1.fromBufferAttribute( this, i );
				_vector2$1$1.applyMatrix3( m );

				this.setXY( i, _vector2$1$1.x, _vector2$1$1.y );

			}

		} else if ( this.itemSize === 3 ) {

			for ( let i = 0, l = this.count; i < l; i ++ ) {

				_vector$9$1.fromBufferAttribute( this, i );
				_vector$9$1.applyMatrix3( m );

				this.setXYZ( i, _vector$9$1.x, _vector$9$1.y, _vector$9$1.z );

			}

		}

		return this;

	}

	applyMatrix4( m ) {

		for ( let i = 0, l = this.count; i < l; i ++ ) {

			_vector$9$1.fromBufferAttribute( this, i );

			_vector$9$1.applyMatrix4( m );

			this.setXYZ( i, _vector$9$1.x, _vector$9$1.y, _vector$9$1.z );

		}

		return this;

	}

	applyNormalMatrix( m ) {

		for ( let i = 0, l = this.count; i < l; i ++ ) {

			_vector$9$1.fromBufferAttribute( this, i );

			_vector$9$1.applyNormalMatrix( m );

			this.setXYZ( i, _vector$9$1.x, _vector$9$1.y, _vector$9$1.z );

		}

		return this;

	}

	transformDirection( m ) {

		for ( let i = 0, l = this.count; i < l; i ++ ) {

			_vector$9$1.fromBufferAttribute( this, i );

			_vector$9$1.transformDirection( m );

			this.setXYZ( i, _vector$9$1.x, _vector$9$1.y, _vector$9$1.z );

		}

		return this;

	}

	set( value, offset = 0 ) {

		// Matching BufferAttribute constructor, do not normalize the array.
		this.array.set( value, offset );

		return this;

	}

	getComponent( index, component ) {

		let value = this.array[ index * this.itemSize + component ];

		if ( this.normalized ) value = denormalize$1( value, this.array );

		return value;

	}

	setComponent( index, component, value ) {

		if ( this.normalized ) value = normalize$1( value, this.array );

		this.array[ index * this.itemSize + component ] = value;

		return this;

	}

	getX( index ) {

		let x = this.array[ index * this.itemSize ];

		if ( this.normalized ) x = denormalize$1( x, this.array );

		return x;

	}

	setX( index, x ) {

		if ( this.normalized ) x = normalize$1( x, this.array );

		this.array[ index * this.itemSize ] = x;

		return this;

	}

	getY( index ) {

		let y = this.array[ index * this.itemSize + 1 ];

		if ( this.normalized ) y = denormalize$1( y, this.array );

		return y;

	}

	setY( index, y ) {

		if ( this.normalized ) y = normalize$1( y, this.array );

		this.array[ index * this.itemSize + 1 ] = y;

		return this;

	}

	getZ( index ) {

		let z = this.array[ index * this.itemSize + 2 ];

		if ( this.normalized ) z = denormalize$1( z, this.array );

		return z;

	}

	setZ( index, z ) {

		if ( this.normalized ) z = normalize$1( z, this.array );

		this.array[ index * this.itemSize + 2 ] = z;

		return this;

	}

	getW( index ) {

		let w = this.array[ index * this.itemSize + 3 ];

		if ( this.normalized ) w = denormalize$1( w, this.array );

		return w;

	}

	setW( index, w ) {

		if ( this.normalized ) w = normalize$1( w, this.array );

		this.array[ index * this.itemSize + 3 ] = w;

		return this;

	}

	setXY( index, x, y ) {

		index *= this.itemSize;

		if ( this.normalized ) {

			x = normalize$1( x, this.array );
			y = normalize$1( y, this.array );

		}

		this.array[ index + 0 ] = x;
		this.array[ index + 1 ] = y;

		return this;

	}

	setXYZ( index, x, y, z ) {

		index *= this.itemSize;

		if ( this.normalized ) {

			x = normalize$1( x, this.array );
			y = normalize$1( y, this.array );
			z = normalize$1( z, this.array );

		}

		this.array[ index + 0 ] = x;
		this.array[ index + 1 ] = y;
		this.array[ index + 2 ] = z;

		return this;

	}

	setXYZW( index, x, y, z, w ) {

		index *= this.itemSize;

		if ( this.normalized ) {

			x = normalize$1( x, this.array );
			y = normalize$1( y, this.array );
			z = normalize$1( z, this.array );
			w = normalize$1( w, this.array );

		}

		this.array[ index + 0 ] = x;
		this.array[ index + 1 ] = y;
		this.array[ index + 2 ] = z;
		this.array[ index + 3 ] = w;

		return this;

	}

	onUpload( callback ) {

		this.onUploadCallback = callback;

		return this;

	}

	clone() {

		return new this.constructor( this.array, this.itemSize ).copy( this );

	}

	toJSON() {

		const data = {
			itemSize: this.itemSize,
			type: this.array.constructor.name,
			array: Array.from( this.array ),
			normalized: this.normalized
		};

		if ( this.name !== '' ) data.name = this.name;
		if ( this.usage !== StaticDrawUsage$1 ) data.usage = this.usage;

		return data;

	}

};

let Uint16BufferAttribute$1=class Uint16BufferAttribute extends BufferAttribute$1 {

	constructor( array, itemSize, normalized ) {

		super( new Uint16Array( array ), itemSize, normalized );

	}

};

let Uint32BufferAttribute$1=class Uint32BufferAttribute extends BufferAttribute$1 {

	constructor( array, itemSize, normalized ) {

		super( new Uint32Array( array ), itemSize, normalized );

	}

};


let Float32BufferAttribute$1=class Float32BufferAttribute extends BufferAttribute$1 {

	constructor( array, itemSize, normalized ) {

		super( new Float32Array( array ), itemSize, normalized );

	}

};

let _id$2$1 = 0;

const _m1$2$1 = /*@__PURE__*/ new Matrix4$1();
const _obj$1 = /*@__PURE__*/ new Object3D$1();
const _offset$2 = /*@__PURE__*/ new Vector3$1();
const _box$2$1 = /*@__PURE__*/ new Box3$1();
const _boxMorphTargets$1 = /*@__PURE__*/ new Box3$1();
const _vector$8$1 = /*@__PURE__*/ new Vector3$1();

let BufferGeometry$1=class BufferGeometry extends EventDispatcher$3 {

	constructor() {

		super();

		this.isBufferGeometry = true;

		Object.defineProperty( this, 'id', { value: _id$2$1 ++ } );

		this.uuid = generateUUID$1();

		this.name = '';
		this.type = 'BufferGeometry';

		this.index = null;
		this.attributes = {};

		this.morphAttributes = {};
		this.morphTargetsRelative = false;

		this.groups = [];

		this.boundingBox = null;
		this.boundingSphere = null;

		this.drawRange = { start: 0, count: Infinity };

		this.userData = {};

	}

	getIndex() {

		return this.index;

	}

	setIndex( index ) {

		if ( Array.isArray( index ) ) {

			this.index = new ( arrayNeedsUint32$1( index ) ? Uint32BufferAttribute$1 : Uint16BufferAttribute$1 )( index, 1 );

		} else {

			this.index = index;

		}

		return this;

	}

	getAttribute( name ) {

		return this.attributes[ name ];

	}

	setAttribute( name, attribute ) {

		this.attributes[ name ] = attribute;

		return this;

	}

	deleteAttribute( name ) {

		delete this.attributes[ name ];

		return this;

	}

	hasAttribute( name ) {

		return this.attributes[ name ] !== undefined;

	}

	addGroup( start, count, materialIndex = 0 ) {

		this.groups.push( {

			start: start,
			count: count,
			materialIndex: materialIndex

		} );

	}

	clearGroups() {

		this.groups = [];

	}

	setDrawRange( start, count ) {

		this.drawRange.start = start;
		this.drawRange.count = count;

	}

	applyMatrix4( matrix ) {

		const position = this.attributes.position;

		if ( position !== undefined ) {

			position.applyMatrix4( matrix );

			position.needsUpdate = true;

		}

		const normal = this.attributes.normal;

		if ( normal !== undefined ) {

			const normalMatrix = new Matrix3$1().getNormalMatrix( matrix );

			normal.applyNormalMatrix( normalMatrix );

			normal.needsUpdate = true;

		}

		const tangent = this.attributes.tangent;

		if ( tangent !== undefined ) {

			tangent.transformDirection( matrix );

			tangent.needsUpdate = true;

		}

		if ( this.boundingBox !== null ) {

			this.computeBoundingBox();

		}

		if ( this.boundingSphere !== null ) {

			this.computeBoundingSphere();

		}

		return this;

	}

	applyQuaternion( q ) {

		_m1$2$1.makeRotationFromQuaternion( q );

		this.applyMatrix4( _m1$2$1 );

		return this;

	}

	rotateX( angle ) {

		// rotate geometry around world x-axis

		_m1$2$1.makeRotationX( angle );

		this.applyMatrix4( _m1$2$1 );

		return this;

	}

	rotateY( angle ) {

		// rotate geometry around world y-axis

		_m1$2$1.makeRotationY( angle );

		this.applyMatrix4( _m1$2$1 );

		return this;

	}

	rotateZ( angle ) {

		// rotate geometry around world z-axis

		_m1$2$1.makeRotationZ( angle );

		this.applyMatrix4( _m1$2$1 );

		return this;

	}

	translate( x, y, z ) {

		// translate geometry

		_m1$2$1.makeTranslation( x, y, z );

		this.applyMatrix4( _m1$2$1 );

		return this;

	}

	scale( x, y, z ) {

		// scale geometry

		_m1$2$1.makeScale( x, y, z );

		this.applyMatrix4( _m1$2$1 );

		return this;

	}

	lookAt( vector ) {

		_obj$1.lookAt( vector );

		_obj$1.updateMatrix();

		this.applyMatrix4( _obj$1.matrix );

		return this;

	}

	center() {

		this.computeBoundingBox();

		this.boundingBox.getCenter( _offset$2 ).negate();

		this.translate( _offset$2.x, _offset$2.y, _offset$2.z );

		return this;

	}

	setFromPoints( points ) {

		const position = [];

		for ( let i = 0, l = points.length; i < l; i ++ ) {

			const point = points[ i ];
			position.push( point.x, point.y, point.z || 0 );

		}

		this.setAttribute( 'position', new Float32BufferAttribute$1( position, 3 ) );

		return this;

	}

	computeBoundingBox() {

		if ( this.boundingBox === null ) {

			this.boundingBox = new Box3$1();

		}

		const position = this.attributes.position;
		const morphAttributesPosition = this.morphAttributes.position;

		if ( position && position.isGLBufferAttribute ) {

			console.error( 'THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.', this );

			this.boundingBox.set(
				new Vector3$1( - Infinity, - Infinity, - Infinity ),
				new Vector3$1( + Infinity, + Infinity, + Infinity )
			);

			return;

		}

		if ( position !== undefined ) {

			this.boundingBox.setFromBufferAttribute( position );

			// process morph attributes if present

			if ( morphAttributesPosition ) {

				for ( let i = 0, il = morphAttributesPosition.length; i < il; i ++ ) {

					const morphAttribute = morphAttributesPosition[ i ];
					_box$2$1.setFromBufferAttribute( morphAttribute );

					if ( this.morphTargetsRelative ) {

						_vector$8$1.addVectors( this.boundingBox.min, _box$2$1.min );
						this.boundingBox.expandByPoint( _vector$8$1 );

						_vector$8$1.addVectors( this.boundingBox.max, _box$2$1.max );
						this.boundingBox.expandByPoint( _vector$8$1 );

					} else {

						this.boundingBox.expandByPoint( _box$2$1.min );
						this.boundingBox.expandByPoint( _box$2$1.max );

					}

				}

			}

		} else {

			this.boundingBox.makeEmpty();

		}

		if ( isNaN( this.boundingBox.min.x ) || isNaN( this.boundingBox.min.y ) || isNaN( this.boundingBox.min.z ) ) {

			console.error( 'THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this );

		}

	}

	computeBoundingSphere() {

		if ( this.boundingSphere === null ) {

			this.boundingSphere = new Sphere$1();

		}

		const position = this.attributes.position;
		const morphAttributesPosition = this.morphAttributes.position;

		if ( position && position.isGLBufferAttribute ) {

			console.error( 'THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.', this );

			this.boundingSphere.set( new Vector3$1(), Infinity );

			return;

		}

		if ( position ) {

			// first, find the center of the bounding sphere

			const center = this.boundingSphere.center;

			_box$2$1.setFromBufferAttribute( position );

			// process morph attributes if present

			if ( morphAttributesPosition ) {

				for ( let i = 0, il = morphAttributesPosition.length; i < il; i ++ ) {

					const morphAttribute = morphAttributesPosition[ i ];
					_boxMorphTargets$1.setFromBufferAttribute( morphAttribute );

					if ( this.morphTargetsRelative ) {

						_vector$8$1.addVectors( _box$2$1.min, _boxMorphTargets$1.min );
						_box$2$1.expandByPoint( _vector$8$1 );

						_vector$8$1.addVectors( _box$2$1.max, _boxMorphTargets$1.max );
						_box$2$1.expandByPoint( _vector$8$1 );

					} else {

						_box$2$1.expandByPoint( _boxMorphTargets$1.min );
						_box$2$1.expandByPoint( _boxMorphTargets$1.max );

					}

				}

			}

			_box$2$1.getCenter( center );

			// second, try to find a boundingSphere with a radius smaller than the
			// boundingSphere of the boundingBox: sqrt(3) smaller in the best case

			let maxRadiusSq = 0;

			for ( let i = 0, il = position.count; i < il; i ++ ) {

				_vector$8$1.fromBufferAttribute( position, i );

				maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( _vector$8$1 ) );

			}

			// process morph attributes if present

			if ( morphAttributesPosition ) {

				for ( let i = 0, il = morphAttributesPosition.length; i < il; i ++ ) {

					const morphAttribute = morphAttributesPosition[ i ];
					const morphTargetsRelative = this.morphTargetsRelative;

					for ( let j = 0, jl = morphAttribute.count; j < jl; j ++ ) {

						_vector$8$1.fromBufferAttribute( morphAttribute, j );

						if ( morphTargetsRelative ) {

							_offset$2.fromBufferAttribute( position, j );
							_vector$8$1.add( _offset$2 );

						}

						maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( _vector$8$1 ) );

					}

				}

			}

			this.boundingSphere.radius = Math.sqrt( maxRadiusSq );

			if ( isNaN( this.boundingSphere.radius ) ) {

				console.error( 'THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this );

			}

		}

	}

	computeTangents() {

		const index = this.index;
		const attributes = this.attributes;

		// based on http://www.terathon.com/code/tangent.html
		// (per vertex tangents)

		if ( index === null ||
			 attributes.position === undefined ||
			 attributes.normal === undefined ||
			 attributes.uv === undefined ) {

			console.error( 'THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)' );
			return;

		}

		const positionAttribute = attributes.position;
		const normalAttribute = attributes.normal;
		const uvAttribute = attributes.uv;

		if ( this.hasAttribute( 'tangent' ) === false ) {

			this.setAttribute( 'tangent', new BufferAttribute$1( new Float32Array( 4 * positionAttribute.count ), 4 ) );

		}

		const tangentAttribute = this.getAttribute( 'tangent' );

		const tan1 = [], tan2 = [];

		for ( let i = 0; i < positionAttribute.count; i ++ ) {

			tan1[ i ] = new Vector3$1();
			tan2[ i ] = new Vector3$1();

		}

		const vA = new Vector3$1(),
			vB = new Vector3$1(),
			vC = new Vector3$1(),

			uvA = new Vector2$1(),
			uvB = new Vector2$1(),
			uvC = new Vector2$1(),

			sdir = new Vector3$1(),
			tdir = new Vector3$1();

		function handleTriangle( a, b, c ) {

			vA.fromBufferAttribute( positionAttribute, a );
			vB.fromBufferAttribute( positionAttribute, b );
			vC.fromBufferAttribute( positionAttribute, c );

			uvA.fromBufferAttribute( uvAttribute, a );
			uvB.fromBufferAttribute( uvAttribute, b );
			uvC.fromBufferAttribute( uvAttribute, c );

			vB.sub( vA );
			vC.sub( vA );

			uvB.sub( uvA );
			uvC.sub( uvA );

			const r = 1.0 / ( uvB.x * uvC.y - uvC.x * uvB.y );

			// silently ignore degenerate uv triangles having coincident or colinear vertices

			if ( ! isFinite( r ) ) return;

			sdir.copy( vB ).multiplyScalar( uvC.y ).addScaledVector( vC, - uvB.y ).multiplyScalar( r );
			tdir.copy( vC ).multiplyScalar( uvB.x ).addScaledVector( vB, - uvC.x ).multiplyScalar( r );

			tan1[ a ].add( sdir );
			tan1[ b ].add( sdir );
			tan1[ c ].add( sdir );

			tan2[ a ].add( tdir );
			tan2[ b ].add( tdir );
			tan2[ c ].add( tdir );

		}

		let groups = this.groups;

		if ( groups.length === 0 ) {

			groups = [ {
				start: 0,
				count: index.count
			} ];

		}

		for ( let i = 0, il = groups.length; i < il; ++ i ) {

			const group = groups[ i ];

			const start = group.start;
			const count = group.count;

			for ( let j = start, jl = start + count; j < jl; j += 3 ) {

				handleTriangle(
					index.getX( j + 0 ),
					index.getX( j + 1 ),
					index.getX( j + 2 )
				);

			}

		}

		const tmp = new Vector3$1(), tmp2 = new Vector3$1();
		const n = new Vector3$1(), n2 = new Vector3$1();

		function handleVertex( v ) {

			n.fromBufferAttribute( normalAttribute, v );
			n2.copy( n );

			const t = tan1[ v ];

			// Gram-Schmidt orthogonalize

			tmp.copy( t );
			tmp.sub( n.multiplyScalar( n.dot( t ) ) ).normalize();

			// Calculate handedness

			tmp2.crossVectors( n2, t );
			const test = tmp2.dot( tan2[ v ] );
			const w = ( test < 0.0 ) ? - 1.0 : 1.0;

			tangentAttribute.setXYZW( v, tmp.x, tmp.y, tmp.z, w );

		}

		for ( let i = 0, il = groups.length; i < il; ++ i ) {

			const group = groups[ i ];

			const start = group.start;
			const count = group.count;

			for ( let j = start, jl = start + count; j < jl; j += 3 ) {

				handleVertex( index.getX( j + 0 ) );
				handleVertex( index.getX( j + 1 ) );
				handleVertex( index.getX( j + 2 ) );

			}

		}

	}

	computeVertexNormals() {

		const index = this.index;
		const positionAttribute = this.getAttribute( 'position' );

		if ( positionAttribute !== undefined ) {

			let normalAttribute = this.getAttribute( 'normal' );

			if ( normalAttribute === undefined ) {

				normalAttribute = new BufferAttribute$1( new Float32Array( positionAttribute.count * 3 ), 3 );
				this.setAttribute( 'normal', normalAttribute );

			} else {

				// reset existing normals to zero

				for ( let i = 0, il = normalAttribute.count; i < il; i ++ ) {

					normalAttribute.setXYZ( i, 0, 0, 0 );

				}

			}

			const pA = new Vector3$1(), pB = new Vector3$1(), pC = new Vector3$1();
			const nA = new Vector3$1(), nB = new Vector3$1(), nC = new Vector3$1();
			const cb = new Vector3$1(), ab = new Vector3$1();

			// indexed elements

			if ( index ) {

				for ( let i = 0, il = index.count; i < il; i += 3 ) {

					const vA = index.getX( i + 0 );
					const vB = index.getX( i + 1 );
					const vC = index.getX( i + 2 );

					pA.fromBufferAttribute( positionAttribute, vA );
					pB.fromBufferAttribute( positionAttribute, vB );
					pC.fromBufferAttribute( positionAttribute, vC );

					cb.subVectors( pC, pB );
					ab.subVectors( pA, pB );
					cb.cross( ab );

					nA.fromBufferAttribute( normalAttribute, vA );
					nB.fromBufferAttribute( normalAttribute, vB );
					nC.fromBufferAttribute( normalAttribute, vC );

					nA.add( cb );
					nB.add( cb );
					nC.add( cb );

					normalAttribute.setXYZ( vA, nA.x, nA.y, nA.z );
					normalAttribute.setXYZ( vB, nB.x, nB.y, nB.z );
					normalAttribute.setXYZ( vC, nC.x, nC.y, nC.z );

				}

			} else {

				// non-indexed elements (unconnected triangle soup)

				for ( let i = 0, il = positionAttribute.count; i < il; i += 3 ) {

					pA.fromBufferAttribute( positionAttribute, i + 0 );
					pB.fromBufferAttribute( positionAttribute, i + 1 );
					pC.fromBufferAttribute( positionAttribute, i + 2 );

					cb.subVectors( pC, pB );
					ab.subVectors( pA, pB );
					cb.cross( ab );

					normalAttribute.setXYZ( i + 0, cb.x, cb.y, cb.z );
					normalAttribute.setXYZ( i + 1, cb.x, cb.y, cb.z );
					normalAttribute.setXYZ( i + 2, cb.x, cb.y, cb.z );

				}

			}

			this.normalizeNormals();

			normalAttribute.needsUpdate = true;

		}

	}

	normalizeNormals() {

		const normals = this.attributes.normal;

		for ( let i = 0, il = normals.count; i < il; i ++ ) {

			_vector$8$1.fromBufferAttribute( normals, i );

			_vector$8$1.normalize();

			normals.setXYZ( i, _vector$8$1.x, _vector$8$1.y, _vector$8$1.z );

		}

	}

	toNonIndexed() {

		function convertBufferAttribute( attribute, indices ) {

			const array = attribute.array;
			const itemSize = attribute.itemSize;
			const normalized = attribute.normalized;

			const array2 = new array.constructor( indices.length * itemSize );

			let index = 0, index2 = 0;

			for ( let i = 0, l = indices.length; i < l; i ++ ) {

				if ( attribute.isInterleavedBufferAttribute ) {

					index = indices[ i ] * attribute.data.stride + attribute.offset;

				} else {

					index = indices[ i ] * itemSize;

				}

				for ( let j = 0; j < itemSize; j ++ ) {

					array2[ index2 ++ ] = array[ index ++ ];

				}

			}

			return new BufferAttribute$1( array2, itemSize, normalized );

		}

		//

		if ( this.index === null ) {

			console.warn( 'THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.' );
			return this;

		}

		const geometry2 = new BufferGeometry();

		const indices = this.index.array;
		const attributes = this.attributes;

		// attributes

		for ( const name in attributes ) {

			const attribute = attributes[ name ];

			const newAttribute = convertBufferAttribute( attribute, indices );

			geometry2.setAttribute( name, newAttribute );

		}

		// morph attributes

		const morphAttributes = this.morphAttributes;

		for ( const name in morphAttributes ) {

			const morphArray = [];
			const morphAttribute = morphAttributes[ name ]; // morphAttribute: array of Float32BufferAttributes

			for ( let i = 0, il = morphAttribute.length; i < il; i ++ ) {

				const attribute = morphAttribute[ i ];

				const newAttribute = convertBufferAttribute( attribute, indices );

				morphArray.push( newAttribute );

			}

			geometry2.morphAttributes[ name ] = morphArray;

		}

		geometry2.morphTargetsRelative = this.morphTargetsRelative;

		// groups

		const groups = this.groups;

		for ( let i = 0, l = groups.length; i < l; i ++ ) {

			const group = groups[ i ];
			geometry2.addGroup( group.start, group.count, group.materialIndex );

		}

		return geometry2;

	}

	toJSON() {

		const data = {
			metadata: {
				version: 4.6,
				type: 'BufferGeometry',
				generator: 'BufferGeometry.toJSON'
			}
		};

		// standard BufferGeometry serialization

		data.uuid = this.uuid;
		data.type = this.type;
		if ( this.name !== '' ) data.name = this.name;
		if ( Object.keys( this.userData ).length > 0 ) data.userData = this.userData;

		if ( this.parameters !== undefined ) {

			const parameters = this.parameters;

			for ( const key in parameters ) {

				if ( parameters[ key ] !== undefined ) data[ key ] = parameters[ key ];

			}

			return data;

		}

		// for simplicity the code assumes attributes are not shared across geometries, see #15811

		data.data = { attributes: {} };

		const index = this.index;

		if ( index !== null ) {

			data.data.index = {
				type: index.array.constructor.name,
				array: Array.prototype.slice.call( index.array )
			};

		}

		const attributes = this.attributes;

		for ( const key in attributes ) {

			const attribute = attributes[ key ];

			data.data.attributes[ key ] = attribute.toJSON( data.data );

		}

		const morphAttributes = {};
		let hasMorphAttributes = false;

		for ( const key in this.morphAttributes ) {

			const attributeArray = this.morphAttributes[ key ];

			const array = [];

			for ( let i = 0, il = attributeArray.length; i < il; i ++ ) {

				const attribute = attributeArray[ i ];

				array.push( attribute.toJSON( data.data ) );

			}

			if ( array.length > 0 ) {

				morphAttributes[ key ] = array;

				hasMorphAttributes = true;

			}

		}

		if ( hasMorphAttributes ) {

			data.data.morphAttributes = morphAttributes;
			data.data.morphTargetsRelative = this.morphTargetsRelative;

		}

		const groups = this.groups;

		if ( groups.length > 0 ) {

			data.data.groups = JSON.parse( JSON.stringify( groups ) );

		}

		const boundingSphere = this.boundingSphere;

		if ( boundingSphere !== null ) {

			data.data.boundingSphere = {
				center: boundingSphere.center.toArray(),
				radius: boundingSphere.radius
			};

		}

		return data;

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( source ) {

		// reset

		this.index = null;
		this.attributes = {};
		this.morphAttributes = {};
		this.groups = [];
		this.boundingBox = null;
		this.boundingSphere = null;

		// used for storing cloned, shared data

		const data = {};

		// name

		this.name = source.name;

		// index

		const index = source.index;

		if ( index !== null ) {

			this.setIndex( index.clone( data ) );

		}

		// attributes

		const attributes = source.attributes;

		for ( const name in attributes ) {

			const attribute = attributes[ name ];
			this.setAttribute( name, attribute.clone( data ) );

		}

		// morph attributes

		const morphAttributes = source.morphAttributes;

		for ( const name in morphAttributes ) {

			const array = [];
			const morphAttribute = morphAttributes[ name ]; // morphAttribute: array of Float32BufferAttributes

			for ( let i = 0, l = morphAttribute.length; i < l; i ++ ) {

				array.push( morphAttribute[ i ].clone( data ) );

			}

			this.morphAttributes[ name ] = array;

		}

		this.morphTargetsRelative = source.morphTargetsRelative;

		// groups

		const groups = source.groups;

		for ( let i = 0, l = groups.length; i < l; i ++ ) {

			const group = groups[ i ];
			this.addGroup( group.start, group.count, group.materialIndex );

		}

		// bounding box

		const boundingBox = source.boundingBox;

		if ( boundingBox !== null ) {

			this.boundingBox = boundingBox.clone();

		}

		// bounding sphere

		const boundingSphere = source.boundingSphere;

		if ( boundingSphere !== null ) {

			this.boundingSphere = boundingSphere.clone();

		}

		// draw range

		this.drawRange.start = source.drawRange.start;
		this.drawRange.count = source.drawRange.count;

		// user data

		this.userData = source.userData;

		return this;

	}

	dispose() {

		this.dispatchEvent( { type: 'dispose' } );

	}

};

let LineBasicMaterial$1=class LineBasicMaterial extends Material$1 {

	constructor( parameters ) {

		super();

		this.isLineBasicMaterial = true;

		this.type = 'LineBasicMaterial';

		this.color = new Color$1( 0xffffff );

		this.map = null;

		this.linewidth = 1;
		this.linecap = 'round';
		this.linejoin = 'round';

		this.fog = true;

		this.setValues( parameters );

	}


	copy( source ) {

		super.copy( source );

		this.color.copy( source.color );

		this.map = source.map;

		this.linewidth = source.linewidth;
		this.linecap = source.linecap;
		this.linejoin = source.linejoin;

		this.fog = source.fog;

		return this;

	}

};

const _vStart$1 = /*@__PURE__*/ new Vector3$1();
const _vEnd$1 = /*@__PURE__*/ new Vector3$1();

const _inverseMatrix$1$1 = /*@__PURE__*/ new Matrix4$1();
const _ray$1$2 = /*@__PURE__*/ new Ray$1();
const _sphere$1$1 = /*@__PURE__*/ new Sphere$1();

const _intersectPointOnRay$1 = /*@__PURE__*/ new Vector3$1();
const _intersectPointOnSegment$1 = /*@__PURE__*/ new Vector3$1();

let Line$1=class Line extends Object3D$1 {

	constructor( geometry = new BufferGeometry$1(), material = new LineBasicMaterial$1() ) {

		super();

		this.isLine = true;

		this.type = 'Line';

		this.geometry = geometry;
		this.material = material;

		this.updateMorphTargets();

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.material = Array.isArray( source.material ) ? source.material.slice() : source.material;
		this.geometry = source.geometry;

		return this;

	}

	computeLineDistances() {

		const geometry = this.geometry;

		// we assume non-indexed geometry

		if ( geometry.index === null ) {

			const positionAttribute = geometry.attributes.position;
			const lineDistances = [ 0 ];

			for ( let i = 1, l = positionAttribute.count; i < l; i ++ ) {

				_vStart$1.fromBufferAttribute( positionAttribute, i - 1 );
				_vEnd$1.fromBufferAttribute( positionAttribute, i );

				lineDistances[ i ] = lineDistances[ i - 1 ];
				lineDistances[ i ] += _vStart$1.distanceTo( _vEnd$1 );

			}

			geometry.setAttribute( 'lineDistance', new Float32BufferAttribute$1( lineDistances, 1 ) );

		} else {

			console.warn( 'THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.' );

		}

		return this;

	}

	raycast( raycaster, intersects ) {

		const geometry = this.geometry;
		const matrixWorld = this.matrixWorld;
		const threshold = raycaster.params.Line.threshold;
		const drawRange = geometry.drawRange;

		// Checking boundingSphere distance to ray

		if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

		_sphere$1$1.copy( geometry.boundingSphere );
		_sphere$1$1.applyMatrix4( matrixWorld );
		_sphere$1$1.radius += threshold;

		if ( raycaster.ray.intersectsSphere( _sphere$1$1 ) === false ) return;

		//

		_inverseMatrix$1$1.copy( matrixWorld ).invert();
		_ray$1$2.copy( raycaster.ray ).applyMatrix4( _inverseMatrix$1$1 );

		const localThreshold = threshold / ( ( this.scale.x + this.scale.y + this.scale.z ) / 3 );
		const localThresholdSq = localThreshold * localThreshold;

		const step = this.isLineSegments ? 2 : 1;

		const index = geometry.index;
		const attributes = geometry.attributes;
		const positionAttribute = attributes.position;

		if ( index !== null ) {

			const start = Math.max( 0, drawRange.start );
			const end = Math.min( index.count, ( drawRange.start + drawRange.count ) );

			for ( let i = start, l = end - 1; i < l; i += step ) {

				const a = index.getX( i );
				const b = index.getX( i + 1 );

				const intersect = checkIntersection$2( this, raycaster, _ray$1$2, localThresholdSq, a, b );

				if ( intersect ) {

					intersects.push( intersect );

				}

			}

			if ( this.isLineLoop ) {

				const a = index.getX( end - 1 );
				const b = index.getX( start );

				const intersect = checkIntersection$2( this, raycaster, _ray$1$2, localThresholdSq, a, b );

				if ( intersect ) {

					intersects.push( intersect );

				}

			}

		} else {

			const start = Math.max( 0, drawRange.start );
			const end = Math.min( positionAttribute.count, ( drawRange.start + drawRange.count ) );

			for ( let i = start, l = end - 1; i < l; i += step ) {

				const intersect = checkIntersection$2( this, raycaster, _ray$1$2, localThresholdSq, i, i + 1 );

				if ( intersect ) {

					intersects.push( intersect );

				}

			}

			if ( this.isLineLoop ) {

				const intersect = checkIntersection$2( this, raycaster, _ray$1$2, localThresholdSq, end - 1, start );

				if ( intersect ) {

					intersects.push( intersect );

				}

			}

		}

	}

	updateMorphTargets() {

		const geometry = this.geometry;

		const morphAttributes = geometry.morphAttributes;
		const keys = Object.keys( morphAttributes );

		if ( keys.length > 0 ) {

			const morphAttribute = morphAttributes[ keys[ 0 ] ];

			if ( morphAttribute !== undefined ) {

				this.morphTargetInfluences = [];
				this.morphTargetDictionary = {};

				for ( let m = 0, ml = morphAttribute.length; m < ml; m ++ ) {

					const name = morphAttribute[ m ].name || String( m );

					this.morphTargetInfluences.push( 0 );
					this.morphTargetDictionary[ name ] = m;

				}

			}

		}

	}

};

function checkIntersection$2( object, raycaster, ray, thresholdSq, a, b ) {

	const positionAttribute = object.geometry.attributes.position;

	_vStart$1.fromBufferAttribute( positionAttribute, a );
	_vEnd$1.fromBufferAttribute( positionAttribute, b );

	const distSq = ray.distanceSqToSegment( _vStart$1, _vEnd$1, _intersectPointOnRay$1, _intersectPointOnSegment$1 );

	if ( distSq > thresholdSq ) return;

	_intersectPointOnRay$1.applyMatrix4( object.matrixWorld ); // Move back to world space for distance calculation

	const distance = raycaster.ray.origin.distanceTo( _intersectPointOnRay$1 );

	if ( distance < raycaster.near || distance > raycaster.far ) return;

	return {

		distance: distance,
		// What do we want? intersection point on the ray or on the segment??
		// point: raycaster.ray.at( distance ),
		point: _intersectPointOnSegment$1.clone().applyMatrix4( object.matrixWorld ),
		index: a,
		face: null,
		faceIndex: null,
		object: object

	};

}

if ( typeof __THREE_DEVTOOLS__ !== 'undefined' ) {

	__THREE_DEVTOOLS__.dispatchEvent( new CustomEvent( 'register', { detail: {
		revision: REVISION$1,
	} } ) );

}

if ( typeof window !== 'undefined' ) {

	if ( window.__THREE__ ) {

		console.warn( 'WARNING: Multiple instances of Three.js being imported.' );

	} else {

		window.__THREE__ = REVISION$1;

	}

}Vector3$1.prototype.equals = function (v) {
    return (Math.abs(this.x - v.x) < 1e-6 && Math.abs(this.y - v.y) < 1e-6 && Math.abs(this.z - v.z) < 1e-6);
};
/**
 * 空间几何点
 */
class Point extends Vector3$1 {
    equals(point, tolerance = 1e-6) {
        return (Math.abs(this.x - point.x) < tolerance && Math.abs(this.y - point.y) < tolerance && Math.abs(this.z - point.z) < tolerance);
    }
}/**
 * 声明几何特征点类型
 */
var FEATURE_POINT_TYPE;
(function (FEATURE_POINT_TYPE) {
    /**
     * 端点
     */
    FEATURE_POINT_TYPE[FEATURE_POINT_TYPE["END"] = 0] = "END";
    /**
     * 中点
     */
    FEATURE_POINT_TYPE[FEATURE_POINT_TYPE["MIDDLE"] = 1] = "MIDDLE";
    /**
     * 中心点
     */
    FEATURE_POINT_TYPE[FEATURE_POINT_TYPE["CENTER"] = 2] = "CENTER";
    /**
     * 面中心点
     */
    FEATURE_POINT_TYPE[FEATURE_POINT_TYPE["FACE_CENTER"] = 3] = "FACE_CENTER";
    /**
     * 象限点
     */
    FEATURE_POINT_TYPE[FEATURE_POINT_TYPE["QUADRANTAL"] = 4] = "QUADRANTAL";
    /**
     * 交点
     */
    FEATURE_POINT_TYPE[FEATURE_POINT_TYPE["INTERSECTION"] = 5] = "INTERSECTION";
})(FEATURE_POINT_TYPE || (FEATURE_POINT_TYPE = {}));/**
 * 几何基类
 */
class GeometryBase {
    /**
     * 获取X轴方向
     * @returns
     */
    getNormalizeX(target = null) {
        if (target == null)
            target = new Vector3$1();
        target.set(this.transformMatrix.elements[0], this.transformMatrix.elements[1], this.transformMatrix.elements[2]).normalize();
        // return new Vector3(this.transformMatrix.elements[0], this.transformMatrix.elements[1], this.transformMatrix.elements[2]).normalize();
        return target;
    }
    /**
     * 获取Y轴方向
     * @returns
     */
    getNormalizeY(target = null) {
        if (target == null)
            target = new Vector3$1();
        target.set(this.transformMatrix.elements[4], this.transformMatrix.elements[5], this.transformMatrix.elements[6]).normalize();
        return target;
        // return new Vector3(this.transformMatrix.elements[4], this.transformMatrix.elements[5], this.transformMatrix.elements[6]).normalize();
    }
    /**
     * 获取Z轴方向
     * @returns
     */
    getNormalizeZ(target = null) {
        if (target == null)
            target = new Vector3$1();
        target.set(this.transformMatrix.elements[8], this.transformMatrix.elements[9], this.transformMatrix.elements[10]).normalize();
        return target;
        // return new Vector3(this.transformMatrix.elements[8], this.transformMatrix.elements[9], this.transformMatrix.elements[10]).normalize();
    }
    /**
     * 获取X轴方向 带长度
     * @returns
     */
    getX(target = null) {
        if (target == null)
            target = new Vector3$1();
        target.set(this.transformMatrix.elements[0], this.transformMatrix.elements[1], this.transformMatrix.elements[2]);
        // return new Vector3(this.transformMatrix.elements[0], this.transformMatrix.elements[1], this.transformMatrix.elements[2]).normalize();
        return target;
    }
    /**
     * 获取Y轴方向 带长度
     * @returns
     */
    getY(target = null) {
        if (target == null)
            target = new Vector3$1();
        target.set(this.transformMatrix.elements[4], this.transformMatrix.elements[5], this.transformMatrix.elements[6]);
        return target;
        // return new Vector3(this.transformMatrix.elements[4], this.transformMatrix.elements[5], this.transformMatrix.elements[6]).normalize();
    }
    /**
     * 获取Z轴方向 带长度
     * @returns
     */
    getZ(target = null) {
        if (target == null)
            target = new Vector3$1();
        target.set(this.transformMatrix.elements[8], this.transformMatrix.elements[9], this.transformMatrix.elements[10]);
        return target;
        // return new Vector3(this.transformMatrix.elements[8], this.transformMatrix.elements[9], this.transformMatrix.elements[10]).normalize();
    }
    /**
     * 获取基点
     * @returns
     */
    getP(target = null) {
        if (target == null)
            target = new Point();
        target.set(this.transformMatrix.elements[12], this.transformMatrix.elements[13], this.transformMatrix.elements[14]);
        return target;
        // return new Point(this.transformMatrix.elements[12], this.transformMatrix.elements[13], this.transformMatrix.elements[14]);
    }
    /**
     * 设置基点
     * @param value
     */
    setP(value) {
        this.transformMatrix.elements[12] = value.x;
        this.transformMatrix.elements[13] = value.y;
        this.transformMatrix.elements[14] = value.z;
    }
    /**
     * 设置局部坐标系
     * @param x x轴方向
     * @param z z轴方向
     * @param [keepZ=true]
     */
    setXYZ(x, z, keepZ = true) {
        _vec1$1.copy(x).normalize();
        _vec3$1$1.copy(z).normalize();
        _vec2$1.copy(z).cross(_vec1$1).normalize();
        if (Math.abs(_vec1$1.dot(_vec3$1$1)) > 1e-6) {
            //x与z不垂直，需要根据keepZ的值设置x或者z
            if (keepZ) {
                _vec1$1.crossVectors(_vec2$1, _vec3$1$1);
            }
            else {
                _vec3$1$1.crossVectors(_vec1$1, _vec2$1);
            }
        }
        const scaleX = this.scaleX;
        const scaleY = this.scaleY;
        const scaleZ = this.scaleZ;
        this.transformMatrix.elements[0] = _vec1$1.x * scaleX;
        this.transformMatrix.elements[1] = _vec1$1.y * scaleX;
        this.transformMatrix.elements[2] = _vec1$1.z * scaleX;
        this.transformMatrix.elements[4] = _vec2$1.x * scaleY;
        this.transformMatrix.elements[5] = _vec2$1.y * scaleY;
        this.transformMatrix.elements[6] = _vec2$1.z * scaleY;
        this.transformMatrix.elements[8] = _vec3$1$1.x * scaleZ;
        this.transformMatrix.elements[9] = _vec3$1$1.y * scaleZ;
        this.transformMatrix.elements[10] = _vec3$1$1.z * scaleZ;
    }
    /**
     * x轴缩放因子
     */
    get scaleX() {
        return _vec$1$1.set(this.transformMatrix.elements[0], this.transformMatrix.elements[1], this.transformMatrix.elements[2]).length();
    }
    /**
     * y轴缩放因子
     */
    get scaleY() {
        return _vec$1$1.set(this.transformMatrix.elements[4], this.transformMatrix.elements[5], this.transformMatrix.elements[6]).length();
    }
    /**
     * z轴缩放因子
     */
    get scaleZ() {
        return _vec$1$1.set(this.transformMatrix.elements[8], this.transformMatrix.elements[9], this.transformMatrix.elements[10]).length();
    }
    /**
     * 构造函数
     */
    constructor() {
        /**
         * 几何类型
         */
        this.type = 'base';
        this.transformMatrix = new Matrix4$1();
        // this.setP(new Point(0, 0, 0));
        // this.setXYZ(new Vector3(1, 0, 0), new Vector3(0, 0, 1));
    }
    /**
     * 放大
     * @param point
     * @param factor
     */
    scale(point, factorX, factorY = null, factorZ = null) {
        if (factorY == null)
            factorY = factorX;
        if (factorZ == null)
            factorZ = factorX;
        _transformMatrix$1.set(factorX, 0, 0, point.x * (1 - factorX), 0, factorY, 0, point.y * (1 - factorY), 0, 0, factorZ, point.z * (1 - factorZ), 0, 0, 0, 1);
        this.transformMatrix.premultiply(_transformMatrix$1);
        return this;
        // _beforeMatrix.set(
        //     1, 0, 0, -point.x,
        //     0, 1, 0, -point.y,
        //     0, 0, 1, -point.z,
        //     0, 0, 0, 1
        // )
        // _afterMatrix.set(
        //     1, 0, 0, point.x,
        //     0, 1, 0, point.y,
        //     0, 0, 1, point.z,
        //     0, 0, 0, 1
        // )
        // _transformMatrix.set(
        //     factor, 0, 0, 0,
        //     0, factor, 0, 0,
        //     0, 0, factor, 0,
        //     0, 0, 0, 1
        // );
        // 第一个是错误写法，后面两种都行
        // this.transformMatrix = _beforeMatrix.multiply(_transformMatrix).multiply(_afterMatrix).multiply(this.transformMatrix);
        // this.transformMatrix = this.transformMatrix.multiply(_afterMatrix.multiply(_transformMatrix.multiply(_beforeMatrix)));
        // this.transformMatrix = _beforeMatrix.premultiply(_transformMatrix).premultiply(_afterMatrix).premultiply(this.transformMatrix);
    }
    /**
     * 移动图元
     * @param vec 位移向量,长度表示距离
     */
    move(vec) {
        _transformMatrix$1.set(1, 0, 0, vec.x, 0, 1, 0, vec.y, 0, 0, 1, vec.z, 0, 0, 0, 1);
        this.transformMatrix.premultiply(_transformMatrix$1);
        return this;
    }
    /**
     * 旋转图元
     * @param point 旋转中心
     * @param axis  旋转轴
     * @param angle 旋转角度
     */
    rotate(point, axis, angle) {
        _beforeMatrix$1.set(1, 0, 0, -point.x, 0, 1, 0, -point.y, 0, 0, 1, -point.z, 0, 0, 0, 1);
        _afterMatrix$1.set(1, 0, 0, point.x, 0, 1, 0, point.y, 0, 0, 1, point.z, 0, 0, 0, 1);
        _quaternion$1.setFromAxisAngle(axis, angle);
        _transformMatrix$1.makeRotationFromQuaternion(_quaternion$1);
        // this.transformMatrix = _beforeMatrix.premultiply(_transformMatrix).premultiply(_afterMatrix).premultiply(this.transformMatrix);
        this.transformMatrix.premultiply(_beforeMatrix$1).premultiply(_transformMatrix$1).premultiply(_afterMatrix$1);
        return this;
    }
    /**
     * 复制方法     need to override
     * @param geo
     * @returns
     */
    copy(geo) {
        this.transformMatrix.copy(geo.transformMatrix);
        return this;
    }
    /**
     * 克隆
     * @returns
     */
    clone() {
        return new GeometryBase().copy(this);
    }
    /**
     * 获取中心点
     * @param target 用以防止对象重复创建
     */
    getCenter(target) {
        if (target == null) {
            target = new Point();
        }
        this.getP(target);
        return target;
    }
    /**
     * 抽象成json数据格式
     * @returns
     */
    toJson() {
        return {
            transformMatrix: this.transformMatrix.elements,
        };
    }
    /**
     * 解析数据成对象
     */
    fromJson(json) {
        if (json.transformMatrix) {
            this.transformMatrix.fromArray(json.transformMatrix);
        }
        return this;
    }
    /**
     * 判断矩阵相等
     * @param another 另一个几何基类的矩阵
     * @param eplison 判断相等的精度
     * @returns
     */
    matrixEquals(another, eplison = 1e-6) {
        for (let i = 0; i < 16; i++) {
            if (Math.abs(this.transformMatrix.elements[i] - another.elements[i]) > eplison)
                return false;
        }
        return true;
    }
    /**
     * 判定相等
     * @param another
     * @returns
     */
    equals(another) {
        return false;
    }
    /**
     * X轴更新，同步更新剩下2个轴
     * @param vecX 新的X轴
     * @param withScale scale值是否覆盖
     */
    updateMatrixByX(vecX, withScale = true) {
        if (vecX == null)
            return this;
        _vec1$1.copy(vecX);
        let scaleX = _vec1$1.length();
        if (!withScale) {
            scaleX = this.scaleX;
        }
        _vec1$1.normalize();
        this.getNormalizeY(_vec2$1);
        const scaleY = this.scaleY;
        this.getNormalizeZ(_vec3$1$1);
        const scaleZ = this.scaleZ;
        // let copyN = _vec3.clone().normalize().sub(_vec1.normalize());
        let angle = Math.abs(_vec3$1$1.clone().angleTo(_vec1$1));
        if (Math.abs(Math.PI - angle) < 1 / 64 || angle < 1 / 64) {
            // 和新的x轴和原来的z轴靠很近，需要先计算新的z轴
            _vec3$1$1.crossVectors(_vec1$1, _vec2$1).normalize();
            _vec2$1.crossVectors(_vec3$1$1, _vec1$1).normalize();
        }
        else {
            // 否则，先计算新的y轴
            _vec2$1.crossVectors(_vec3$1$1, _vec1$1).normalize();
            _vec3$1$1.crossVectors(_vec1$1, _vec2$1).normalize();
        }
        this.transformMatrix.elements[0] = _vec1$1.x * scaleX;
        this.transformMatrix.elements[1] = _vec1$1.y * scaleX;
        this.transformMatrix.elements[2] = _vec1$1.z * scaleX;
        this.transformMatrix.elements[4] = _vec2$1.x * scaleY;
        this.transformMatrix.elements[5] = _vec2$1.y * scaleY;
        this.transformMatrix.elements[6] = _vec2$1.z * scaleY;
        this.transformMatrix.elements[8] = _vec3$1$1.x * scaleZ;
        this.transformMatrix.elements[9] = _vec3$1$1.y * scaleZ;
        this.transformMatrix.elements[10] = _vec3$1$1.z * scaleZ;
        return this;
    }
    /**
     * Y轴更新，同步更新剩下2个轴
     * @param vecY 新的Y轴，带ScaleY
     * @returns
     */
    updateMatrixByY(vecY, withScale = true) {
        if (vecY == null)
            return this;
        _vec2$1.copy(vecY);
        let scaleY = _vec2$1.length();
        if (!withScale) {
            scaleY = this.scaleY;
        }
        _vec2$1.normalize();
        this.getNormalizeX(_vec1$1);
        const scaleX = this.scaleX;
        this.getNormalizeZ(_vec3$1$1);
        const scaleZ = this.scaleZ;
        // let copyN = _vec3.clone().normalize().sub(_vec2.normalize());
        let angle = Math.abs(_vec3$1$1.clone().angleTo(_vec2$1));
        if (Math.abs(Math.PI - angle) < 1 / 64 || angle < 1 / 64) {
            // 新的y轴和原来的z轴靠很近，需要先计算新的z轴
            _vec3$1$1.crossVectors(_vec1$1, _vec2$1).normalize();
            _vec1$1.crossVectors(_vec2$1, _vec3$1$1).normalize();
        }
        else {
            // 否则，先计算新的x轴
            _vec1$1.crossVectors(_vec2$1, _vec3$1$1).normalize();
            _vec3$1$1.crossVectors(_vec1$1, _vec2$1).normalize();
        }
        this.transformMatrix.elements[0] = _vec1$1.x * scaleX;
        this.transformMatrix.elements[1] = _vec1$1.y * scaleX;
        this.transformMatrix.elements[2] = _vec1$1.z * scaleX;
        this.transformMatrix.elements[4] = _vec2$1.x * scaleY;
        this.transformMatrix.elements[5] = _vec2$1.y * scaleY;
        this.transformMatrix.elements[6] = _vec2$1.z * scaleY;
        this.transformMatrix.elements[8] = _vec3$1$1.x * scaleZ;
        this.transformMatrix.elements[9] = _vec3$1$1.y * scaleZ;
        this.transformMatrix.elements[10] = _vec3$1$1.z * scaleZ;
        return this;
    }
    /**
     * Z轴更新，同步更新剩下2个轴
     * @param vecZ 新的Z轴，带ScaleZ
     * @returns
     */
    updateMatrixByZ(vecZ, withScale = true) {
        if (vecZ == null)
            return this;
        _vec3$1$1.copy(vecZ);
        let scaleZ = _vec3$1$1.length();
        if (!withScale) {
            scaleZ = this.scaleZ;
        }
        _vec3$1$1.normalize();
        this.getNormalizeX(_vec1$1);
        const scaleX = this.scaleX;
        this.getNormalizeY(_vec2$1);
        const scaleY = this.scaleY;
        // let copyN = _vec1.clone().normalize().sub(_vec3.normalize());
        let angle = Math.abs(_vec1$1.clone().angleTo(_vec3$1$1));
        if (Math.abs(Math.PI - angle) < 1 / 64 || angle < 1 / 64) {
            // 新的z轴和原来的x轴靠很近，需要先计算新的x轴
            _vec1$1.crossVectors(_vec2$1, _vec3$1$1).normalize();
            _vec2$1.crossVectors(_vec3$1$1, _vec1$1).normalize();
        }
        else {
            // 否则，先计算新的y轴
            _vec2$1.crossVectors(_vec3$1$1, _vec1$1).normalize();
            _vec1$1.crossVectors(_vec2$1, _vec3$1$1).normalize();
        }
        this.transformMatrix.elements[0] = _vec1$1.x * scaleX;
        this.transformMatrix.elements[1] = _vec1$1.y * scaleX;
        this.transformMatrix.elements[2] = _vec1$1.z * scaleX;
        this.transformMatrix.elements[4] = _vec2$1.x * scaleY;
        this.transformMatrix.elements[5] = _vec2$1.y * scaleY;
        this.transformMatrix.elements[6] = _vec2$1.z * scaleY;
        this.transformMatrix.elements[8] = _vec3$1$1.x * scaleZ;
        this.transformMatrix.elements[9] = _vec3$1$1.y * scaleZ;
        this.transformMatrix.elements[10] = _vec3$1$1.z * scaleZ;
        return this;
    }
    /**
     * 获取基元列表
     * @returns
     */
    getGeoElements() {
        return [];
    }
    /**
     * 获取基元索引列表 用于绑定
     */
    getGeoElementsIdxList() {
        return [];
    }
    /**
     * 获取特征点列表
     * @returns
     */
    getFeaturePoints() {
        return [];
    }
    /**
     * 获取包围盒
     * @returns
     */
    getBoundingBox() {
        return {
            min: null,
            max: null,
        };
    }
    /**
     * 获取控制点 可用于stretch
     * @returns
     */
    getControlPoints() {
        return [];
    }
    /**
     * 通过控制点修改几何
     */
    setByControlPoint(controlPoints = [], vec) {
        let center = controlPoints.find(item => item.type === FEATURE_POINT_TYPE.CENTER);
        if (center != null) {
            this.move(vec);
            return true;
        }
        return false;
    }
}
//全局临时存储
const _beforeMatrix$1 = new Matrix4$1();
const _transformMatrix$1 = new Matrix4$1();
const _afterMatrix$1 = new Matrix4$1();
//临时四元数
const _quaternion$1 = new Quaternion$1();
const _vec1$1 = new Vector3$1();
const _vec2$1 = new Vector3$1();
const _vec3$1$1 = new Vector3$1();
const _vec$1$1 = new Vector3$1();/**
 * 空间曲线基类
 */
class Curve extends GeometryBase {
    constructor() {
        super(...arguments);
        this.type = 'Curve';
        /**
         * 为了解决instanceof在引用库时可能失败的问题，强制增加一条
         */
        this.isCurve = true;
    }
    /**
     * 获取插值点
     * @param t
     * @returns
     */
    getPointAt(t, target = null) {
        return null;
    }
    /**
     * 获取曲线长度
     * @returns
     */
    getPerimeter() {
        return 0;
    }
    /**
     * 获取曲线的插值点序列
     * @returns
     */
    getPoints(division) {
        return [];
    }
    /**
     * 获取起点和终点
     * @returns
     */
    getEndPoints() {
        let start = this.getPointAt(0);
        let end = this.getPointAt(1);
        return [start, end];
    }
    clone() {
        return new Curve().copy(this);
    }
    /**
     * 获取曲线上某点的切线方向
     * @param point
     * @returns
     */
    getCutLineDir(point, target) {
        if (target == null) {
            target = new Vector3$1();
        }
        return target;
    }
    /**
     * 获取基元列表
     * @returns
     */
    getGeoElements() {
        return [this];
    }
    /**
     * 获取基元索引列表 用于绑定
     */
    getGeoElementsIdxList() {
        return [0];
    }
    /**
     * 获取控制点 可用于stretch和夹点编辑
     * @returns
     */
    getControlPoints() {
        return [];
    }
    /**
     * 获取包围盒
     * @returns
     */
    getBoundingBox() {
        let min = new Point(0, 0, 0);
        let max = new Point(0, 0, 0);
        return {
            min: min,
            max: max,
        };
    }
    /**
     * 反向线的方向
     */
    reverse() {
        return this;
    }
    /**
    * 获取特征点列表
    * @returns
    */
    getFeaturePoints() {
        return [];
    }
}/**
 * 直线段
 * 其局部坐标系定义为起点为基点p，方向为局部x轴，长度为x轴向量长度
 */
let Line$2=class Line extends Curve {
    /**
     * 起点
     */
    get start() {
        return this.getP();
    }
    /**
     * 设置起点
     */
    set start(point) {
        this.set(point, this.end);
    }
    /**
     * 终点
     */
    get end() {
        this.getX(_vec$5);
        return this.start.clone().add(_vec$5);
    }
    /**
     * 设置终点
     */
    set end(point) {
        this.set(this.start, point);
    }
    /**
     * 构造函数
     * @param start
     * @param end
     */
    constructor(start = new Point(), end = new Point()) {
        super();
        /**
         * 类型
         */
        this.type = 'Line';
        this.set(start, end);
    }
    /**
     * 设置起点和终点
     * @param start
     * @param end
     * @returns
     */
    set(start, end) {
        this.setP(start);
        _vec$5.subVectors(end, start);
        let length = _vec$5.length();
        if (length < 1e-6) {
            _vec$5.set(1e-5, 0, 0);
        }
        this.updateMatrixByX(_vec$5, true);
        return this;
    }
    /**
     * 获取切线方向
     * @param point
     */
    getCutLineDir(point, target) {
        if (target == null) {
            target = new Vector3$1();
        }
        this.getNormalizeX(target);
        return target;
    }
    /**
     * 获取端点
     * @returns
     */
    getEndPoints() {
        return [this.start, this.end];
    }
    /**
     * 获取插值点
     * @param t 0-1
     * @returns
     */
    getPointAt(t, target = null) {
        if (target == null) {
            target = new Point();
        }
        this.getX(target).multiplyScalar(t).add(this.start);
        return target;
    }
    /**
     * 获取中心点
     * @param target
     */
    getCenter(target) {
        if (target == null) {
            target = new Point();
        }
        target.set(0.5, 0, 0).applyMatrix4(this.transformMatrix);
        return target;
    }
    /**
     * 克隆一个新的线对象
     * @returns
     */
    clone() {
        return new Line().copy(this);
    }
    /**
     * 转成json格式数据
     * @returns
     */
    toJson() {
        let data = Object.assign({ type: this.type }, super.toJson());
        return data;
    }
    /**
     * 判定相等
     * @param another
     * @returns
     */
    equals(another) {
        return this.start.equals(another.start) && this.end.equals(another.end);
    }
    /**
     * 获取特征点列表
     * @returns
     */
    getFeaturePoints() {
        return [
            { type: FEATURE_POINT_TYPE.END, point: this.getPointAt(0), geoType: this.type, uvtPosition: 0 },
            { type: FEATURE_POINT_TYPE.END, point: this.getPointAt(1), geoType: this.type, uvtPosition: 1 },
            { type: FEATURE_POINT_TYPE.MIDDLE, point: this.getPointAt(0.5), geoType: this.type },
        ];
    }
    /**
     * 获取控制点 可用于stretch和夹点编辑
     * @returns
     */
    getControlPoints() {
        return [
            { type: FEATURE_POINT_TYPE.END, point: this.getPointAt(0), geoType: this.type, uvtPosition: 0 },
            { type: FEATURE_POINT_TYPE.END, point: this.getPointAt(1), geoType: this.type, uvtPosition: 1 },
            { type: FEATURE_POINT_TYPE.CENTER, point: this.getPointAt(0.5), geoType: this.type },
        ];
    }
    /**
     * 获取包围盒
     * @returns
     */
    getBoundingBox() {
        let min = new Point();
        let max = new Point(1, 0, 0);
        min.applyMatrix4(this.transformMatrix);
        max.applyMatrix4(this.transformMatrix);
        return {
            min: min,
            max: max,
        };
    }
    /**
     * 线翻转
     */
    negate() {
        let start = this.getP();
        let end = this.getPointAt(1);
        this.set(end, start);
    }
    reverse() {
        let start = this.getP();
        let end = this.getPointAt(1);
        this.set(end, start);
        return this;
    }
    /**
     * 获取曲线的插值点序列
     * @returns
     */
    getPoints(division) {
        return [
            this.start,
            this.end,
        ];
    }
};
const _vec$5 = new Vector3$1();class Surface extends GeometryBase {
    constructor() {
        super(...arguments);
        /**
         * 为了解决instanceof在引用库时可能失败的问题，强制增加一条
         */
        this.isSurface = true;
    }
    /**
     * 获得曲面的插值点列表
     * @param div_t
     * @param div_u
     * @returns
     */
    getPoints(div_t = 20, div_u = 8) {
        const points = [];
        for (let u = 0; u <= div_u; u++) {
            for (let t = 0; t <= div_t; t++) {
                let point = this.getPointAt(t / div_t, u / div_u);
                if (!point)
                    continue;
                points.push(point);
            }
        }
        return points;
    }
    /**
     * 获得指定位置比例的曲面插值点， t u 0...1 override
     * @param t
     * @param u
     * @param target
     * @returns
     */
    getPointAt(t, u, target = null) {
        return target;
    }
    getGeoElements() {
        return [this];
    }
    /**
     * 获取基元索引列表 用于绑定
     */
    getGeoElementsIdxList() {
        return [0];
    }
    /**
     * 克隆
     * @returns
     */
    clone() {
        return new Surface().copy(this);
    }
    /**
     * 获取面的边线
     * @returns
     */
    getSideEdges() {
        // throw new Error("Method 'getSideEdges' must be implemented in Surface!")
        return [];
    }
}var GeoMeasurement;
(function (GeoMeasurement) {
    /**
    * 求点到平面的距离
    * @param point 三维点
    * @param plane 平面
    * @returns
    */
    function PointDistanceToPlane(point, plane) {
        return plane.normal.dot(point) + plane.constant;
    }
    GeoMeasurement.PointDistanceToPlane = PointDistanceToPlane;
    /**
     * 获取点在平面上的投影点
     * @param point
     * @param plane
     */
    function getPointProjectToPlane(point, plane, target = null) {
        if (target == null) {
            target = new Point();
        }
        target.copy(point);
        _matrixInverse.copy(plane.transformMatrix).invert();
        target.applyMatrix4(_matrixInverse);
        target.z = 0;
        target.applyMatrix4(plane.transformMatrix);
        return target;
    }
    GeoMeasurement.getPointProjectToPlane = getPointProjectToPlane;
    const _matrixInverse = new Matrix4$1();
    // /**
    //  * 求成环的edges的面积
    //  * @param curves 
    //  * @returns 
    //  */
    // static GetAreaByEdges(curves: Curve[]) {
    //     const _prevVector: Vector3 = new Vector3();
    //     const _nextVector: Vector3 = new Vector3();
    //     // 由有序的边得到的顶点
    //     let points: Point[] = [];
    //     let noRepeatPoints: Point[] = [];
    //     curves.forEach(edge => {
    //         points.push(...edge.getPoints());
    //     })
    //     // 对顶点去重
    //     points.forEach(point => {
    //         if (!noRepeatPoints.some(item => item.equals(point))) {
    //             noRepeatPoints.push(point);
    //         }
    //     })
    //     /**         
    //      * 计算多边形面积，参考文献：[1]韦品瑚,晓伟.三维空间多边形的面积计算[J].数学通报,1984(02):18-21. 引理2
    //      * 空间多边形A1A2...An的面积S=1/2 * |A1A2 * A1A3 + A1A3 * A1A4 + ... + A1An-1 * A1An|
    //      */
    //     if (noRepeatPoints.length < 3) return 0;
    //     // 第一个点
    //     let firstPoint = noRepeatPoints[0];
    //     // 矢量积
    //     let vectorProduct = new Vector3();
    //     for (let i = 2; i <= noRepeatPoints.length - 1; i++) {
    //         // A1Ai-1
    //         _prevVector.subVectors(noRepeatPoints[i - 1], firstPoint);
    //         // A1Ai
    //         _nextVector.subVectors(noRepeatPoints[i], firstPoint);
    //         // A1Ai-1 * A1Ai
    //         vectorProduct.add(_prevVector.cross(_nextVector));
    //     }
    //     return vectorProduct.length() / 2
    // }
    /**
     * 射线起点沿射线方向与平面的距离
     * @param ray
     * @param plane
     * @returns
     */
    function RayOriginDistanceToPlane(ray, plane) {
        const denominator = plane.normal.dot(ray.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (PointDistanceToPlane(ray.origin, plane) === 0) {
                return 0;
            }
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(ray.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 1e-6 ? t : null;
    }
    GeoMeasurement.RayOriginDistanceToPlane = RayOriginDistanceToPlane;
    //求v1到v2的旋转角，两个向量都是单位向量
    function getRotateAngle(v1, v2) {
        let npi = Math.PI;
        let dot = v1.clone().dot(v2);
        let angle = 0;
        if (Math.abs(dot - 1.0) <= 1e-6) {
            angle = 0.0;
        }
        else if (Math.abs(dot + 1.0) <= 1e-6) {
            angle = npi;
        }
        else {
            angle = Math.acos(dot);
            let crossX = v1.y * v2.z - v1.z * v2.y;
            let crossY = v1.z * v2.x - v1.x * v2.z;
            let crossZ = v1.x * v2.y - v1.y * v2.x;
            // 向量 p2 是相对于向量 p1 的顺时针方向（根据右手定则）
            if (crossX < 0 || crossY < 0 || crossZ < 0) {
                angle = 2 * npi - angle;
            }
        }
        return angle;
    }
    GeoMeasurement.getRotateAngle = getRotateAngle;
})(GeoMeasurement || (GeoMeasurement = {}));/**
 * 几何平面
 */
let Plane$1=class Plane extends Surface {
    constructor(normal = new Vector3$1(0, 0, 1), constant = 0) {
        super();
        /**
         * 为了解决instanceof在引用库时可能失败的问题，强制增加一条
         */
        this.isPlane = true;
        if (this.transformMatrix == null) {
            this.transformMatrix = new Matrix4$1();
        }
        this.set(normal, constant);
    }
    /**
     * 按平面方程定义构造平面
     * @param normal
     * @param constant
     */
    set(normal = new Vector3$1(0, 0, 1), constant = 0) {
        normal.normalize();
        this.normal = normal;
        this.constant = constant;
    }
    /**
     * 平面法向量
     */
    set normal(value) {
        this.setXYZ(this.getNormalizeX(), value);
    }
    /**
     * 平面法向量
     */
    get normal() {
        return this.getNormalizeZ();
    }
    /**
     * 平面常数
     */
    set constant(value) {
        _point$2$1.copy(this.normal).multiplyScalar(-value);
        this.setP(_point$2$1);
    }
    /**
     * 平面常数
     */
    get constant() {
        let value = -this.getP().dot(this.normal);
        return value;
    }
    /**
     * 获取平面上一点
     * @param target 若target不为空，则原位设置返回
     * @returns
     */
    coplanarPoint(target = null) {
        if (target == null) {
            target = new Point();
        }
        target.set(this.getP().x, this.getP().y, this.getP().z);
        return target;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && (plane.constant === this.constant);
    }
    /**
     * 克隆
     * @returns
     */
    clone() {
        return new Plane().copy(this);
    }
    /**
     * 根据平面上三个点构造平面
     * @param a
     * @param b
     * @param c
     * @returns
     */
    setFromCoplanarPoints(a, b, c) {
        const normal = _vector1$1.subVectors(c, b).cross(_vector2$1$2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    /**
     * 根据平面法向量和平面上一点构造平面
     * @param normal
     * @param point
     * @returns
     */
    setFromNormalAndCoplanarPoint(normal, point) {
        _vector1$1.copy(normal);
        if (_vector1$1.length() < 1e-6) {
            _vector1$1.set(0, 0, 1);
        }
        else {
            _vector1$1.normalize();
        }
        this.setXYZ(this.getNormalizeX(), _vector1$1, true);
        this.setP(point);
        return this;
    }
    /**
     * 计算点在平面的投影点
     * @param normal
     * @param point
     * @returns
     */
    projectPoint(point, target = null) {
        if (target == null) {
            target = new Point();
        }
        return target.copy(this.normal).multiplyScalar(-GeoMeasurement.PointDistanceToPlane(point, this)).add(point);
    }
    getSideEdges() {
        return [];
    }
    /**
     * 转化为一般面域
     * @returns
     */
    toGeneralRegion() {
        return null;
    }
};
const _point$2$1 = new Point();
const _vector1$1 = new Vector3$1();
const _vector2$1$2 = new Vector3$1();Vector2$1.prototype.equals = function (v) {
    return Math.abs(this.x - v.x) < 1e-6 && Math.abs(this.y - v.y) < 1e-6;
};
/**
 * 平面几何点
 */
class Point2 extends Vector2$1 {
    equals(point, tolerance = 1e-6) {
        return (Math.abs(this.x - point.x) < tolerance && Math.abs(this.y - point.y) < tolerance);
    }
}/**
 * 直线
 */
class StraightLine extends Curve {
    /**
     * 经过点
     */
    get origin() {
        return this.getP();
    }
    /**
     * 设置经过点
     */
    set origin(value) {
        this.setP(value);
    }
    /**
     * 方向
     */
    get direction() {
        return this.getNormalizeX();
    }
    /**
     * 设置方向
     */
    set direction(value) {
        if (value.length() < 1e-6) {
            return;
        }
        this.updateMatrixByX(value, false);
    }
    /**
     * 返回直线上某点切线
     * @param point
     */
    getCutLineDir(point, target) {
        if (target == null) {
            target = new Vector3$1();
        }
        this.getNormalizeX(target);
        return target;
    }
    /**
     * 构造函数
     * @param origin
     * @param direction
     */
    constructor(origin = new Point(0, 0, 0), direction = new Vector3$1(1, 0, 0)) {
        super();
        /**
         * 类型
         */
        this.type = 'StraightLine';
        this.origin = origin;
        this.direction = direction.clone().normalize();
    }
    /**
     * 利用经过点和方向构造直线
     * @param origin
     * @param direction
     */
    setFromDirection(origin, direction) {
        this.origin = origin;
        if (direction.length() < 1e-6) {
            return;
        }
        this.direction = direction.clone().normalize();
    }
    /**
     * 利用两点构造直线
     * @param start
     * @param end
     * @returns
     */
    setFromPoints(start, end) {
        let dir = end.clone().sub(start);
        if (dir.length() <= 1e-6)
            return;
        this.origin = start;
        this.direction = dir.normalize();
    }
    /**
     * 直线的中心，由于没有现实意义的中心，等效成获取origin
     * @param target
     * @returns
     */
    getCenter(target = null) {
        if (target == null) {
            target = new Point();
        }
        target.copy(this.origin);
        return target;
    }
    /**
     * 直线没有端点
     * @returns
     */
    getEndPoints() {
        return [];
    }
    /**
     * 获取直线上与经过点距离为t的点
     * @param t 距离
     * @param target
     * @returns
     */
    getPointAt(t, target = null) {
        if (target == null) {
            target = new Point();
        }
        target.copy(this.origin).add(this.direction.clone().multiplyScalar(t));
        return target;
    }
    /**
     * 克隆
     * @returns
     */
    clone() {
        return new StraightLine().copy(this);
    }
    /**
     * 复制
     * @param source
     * @returns
     */
    copy(source) {
        this.origin = source.origin;
        this.direction = source.direction;
        return this;
    }
    /**
     * 判断相等
     * @param curve
     * @returns
     */
    equals(curve) {
        if (!this.direction.equals(curve.direction) || !this.direction.equals(curve.direction.multiplyScalar(-1)))
            return false;
        let dir = this.origin.sub(curve.origin).normalize();
        if ((1 - Math.abs(dir.dot(this.direction))) > 1e-6)
            return false;
        return true;
    }
}/**
 * 一般多边形
 */
class GeneralRegion extends Plane$1 {
    /**
     * @param rings 三维点构成的二维数组，表示多边形的环（环的方向需延法向量逆时针）
     * @param normal 法向量
     */
    constructor(rings = [], normal = new Vector3$1(0, 0, 1)) {
        super(normal);
        /**
         * 一般多边形
         */
        this.type = 'GeneralRegion';
        this.rings = [];
        this.setByRingsAndNormal(rings, normal);
    }
    /**
     * 通过空间三维点与法向量设置一般多边形
     * @param rings
     * @param normal
     * @param useNormal 是否使用传入的normal
     */
    setByRingsAndNormal(rings = [], normal = new Vector3$1(0, 0, 1), useNormal = true) {
        let regionNormal;
        if (useNormal) {
            regionNormal = normal;
        }
        else {
            let points = [];
            for (let ringIndex = 0; ringIndex < rings.length; ringIndex++) {
                let ring = rings[ringIndex];
                for (let pointIndex = 0; pointIndex < ring.length; pointIndex++) {
                    points.push(ring[pointIndex]);
                    if (points.length >= 3) {
                        break;
                    }
                }
                if (points.length >= 3) {
                    break;
                }
            }
            if (points.length < 3) {
                regionNormal = new Vector3$1(0, 0, 1);
            }
            regionNormal = new Plane$1().setFromCoplanarPoints(points[0], points[1], points[2]).getNormalizeZ();
        }
        if (!GeneralRegion.isEmptyRing(rings)) { //如果不是空环，根据环中的点设置多边形
            this.setFromNormalAndCoplanarPoint(regionNormal, rings[0][0]);
            const matrixInverse = new Matrix4$1().copy(this.transformMatrix).invert();
            for (let ringIndex = 0; ringIndex < rings.length; ringIndex++) {
                let ring = rings[ringIndex];
                this.rings.push([]);
                for (let pointIndex = 0; pointIndex < ring.length; pointIndex++) {
                    _point$1$1.copy(ring[pointIndex]).applyMatrix4(matrixInverse);
                    this.rings[ringIndex].push(new Point2(_point$1$1.x, _point$1$1.y)); //直接舍弃掉z轴，默认将所有点拍平到一个平面上
                }
            }
        }
    }
    /**
     * 判断是否为空环
     * @param rings
     * @returns
     */
    static isEmptyRing(rings) {
        if (rings && rings.length > 0 && rings[0].length > 0) {
            return false;
        }
        return true;
    }
    /**
     * 多边形反向，所有线的方向与法向量方向均反
     */
    negate() {
        this.scale(this.getP(), -1, -1, -1);
        let newRings = [];
        for (let i = 0; i < this.rings.length; i++) {
            let newRing = [];
            for (let j = this.rings[i].length - 1; j >= 0; j--) {
                newRing.push(newRing[j]);
            }
            newRings.push(newRing);
        }
        this.rings = newRings;
    }
    /**
     * 判断是否为一个有效多边形
     * @returns
     */
    isVaild() {
        return this.transformMatrix && this.rings && this.rings.length > 0 && this.rings[0].length > 2;
    }
    /**
     * 获取反向的面
     * @returns
     */
    getNegate() {
        let res = this.clone();
        res.negate();
        return res;
    }
    getCenter(target) {
        if (target == null) {
            target = new Point();
        }
        target.set(0, 0, 0);
        let count = 0;
        if (this.rings) {
            this.rings.forEach(ring => {
                ring.forEach(point2 => {
                    target.set(point2.x + target.x, point2.y + target.y, 0);
                    count += 1;
                });
            });
        }
        if (count === 0)
            return target;
        target.multiplyScalar(count);
        target.applyMatrix4(this.transformMatrix);
        return target;
    }
    /**
     * 获得指定位置比例的曲面插值点， t u 0...1 override
     * @param t
     * @param u
     * @param target
     * @returns
     */
    getPointAt(t, u, target = null) {
        if (target == null) {
            target = new Point();
        }
        target.set(t, u, 0).applyMatrix4(this.transformMatrix);
        return target;
    }
    copy(geo) {
        super.copy(geo);
        if (geo instanceof GeneralRegion) {
            this.rings = [];
            geo.rings.forEach(ring => {
                let newRing = [];
                ring.forEach(point2 => {
                    newRing.push(point2.clone());
                });
                this.rings.push(newRing);
            });
        }
        return this;
    }
    clone() {
        return new GeneralRegion().copy(this);
    }
    getSideEdges() {
        let res = [];
        if (GeneralRegion.isEmptyRing(this.rings)) {
            return res;
        }
        this.rings.forEach(ring => {
            if (ring.length <= 1)
                return;
            for (let pointIndex = 0; pointIndex < ring.length; pointIndex++) {
                if (pointIndex != ring.length - 1) {
                    res.push(new Line$2(this.getPointAt(ring[pointIndex].x, ring[pointIndex].y), this.getPointAt(ring[pointIndex + 1].x, ring[pointIndex + 1].y)));
                }
                else {
                    res.push(new Line$2(this.getPointAt(ring[pointIndex].x, ring[pointIndex].y), this.getPointAt(ring[0].x, ring[0].y)));
                }
            }
        });
        return res;
    }
    getBoundingBox() {
        let min = new Vector3$1(Number.MAX_VALUE, Number.MAX_VALUE, 0);
        let max = new Vector3$1(Number.MIN_VALUE, Number.MIN_VALUE, 0);
        this.rings.forEach(ring => {
            ring.forEach(point2 => {
                min.x = Math.min(min.x, point2.x);
                min.y = Math.min(min.y, point2.y);
                max.x = Math.max(max.x, point2.x);
                max.y = Math.max(max.y, point2.y);
            });
        });
        let box = new Box3$1(min, max);
        box.applyMatrix4(this.transformMatrix);
        return box;
    }
    toJson() {
        let data = Object.assign(Object.assign({}, super.toJson()), { type: this.type });
        let rings = this.rings.map(ring => {
            return ring.map(point2 => {
                return { x: point2.x, y: point2.y };
            });
        });
        data['rings'] = rings;
        return data;
    }
    fromJson(json) {
        super.fromJson(json);
        if (json.rings) {
            let newRings = [];
            json.rings.forEach(ring => {
                let newRing = [];
                ring.forEach(point2 => {
                    newRing.push(new Point2(point2.x, point2.y));
                });
                newRings.push(newRing);
            });
            this.rings = newRings;
        }
        return this;
    }
}
const _point$1$1 = new Point();const EPSILON = 1e-6;var GeoRelation;
(function (GeoRelation) {
    /**
    * 求直线上距离空间中任意一点最近的点
    * @param straightLine
    * @param point
    * @param target
    * @returns
    */
    function StraightLineClosestPointToPoint(straightLine, point, target = null) {
        if (target == null) {
            target = new Point();
        }
        target.subVectors(point, straightLine.origin);
        const directionDistance = target.dot(straightLine.direction);
        return target.copy(straightLine.direction).multiplyScalar(directionDistance).add(straightLine.origin);
    }
    GeoRelation.StraightLineClosestPointToPoint = StraightLineClosestPointToPoint;
    /**
     * 线上距离一点最近的点
     * @param line
     * @param point
     * @param clampToLine
     * @param target
     * @returns
     */
    function LineClosestPointToPoint(line, point, clampToLine, target) {
        const t = GeoRelation.LineClosestPointToPointParameter(line, point, clampToLine);
        if (target === undefined) {
            target = new Point();
        }
        return line.getPointAt(t, target);
    }
    GeoRelation.LineClosestPointToPoint = LineClosestPointToPoint;
    /**
     * 线上距离一点最近的点的参数
     * @param line
     * @param point
     * @param clampToLine
     * @returns
     */
    function LineClosestPointToPointParameter(line, point, clampToLine = false) {
        if (point == null)
            return null;
        const _startP = new Vector3$1();
        const _startEnd = new Vector3$1();
        _startP.subVectors(point, line.start);
        _startEnd.subVectors(line.end, line.start);
        const startEnd2 = _startEnd.dot(_startEnd);
        const startEnd_startP = _startEnd.dot(_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) {
            t = Math.max(0, Math.min(1, t));
        }
        return t;
    }
    GeoRelation.LineClosestPointToPointParameter = LineClosestPointToPointParameter;
    /**
     * 射线上距离一点最近的点
     * @param ray
     * @param point
     * @param target
     * @returns
     */
    function RayClosestPointToPoint(ray, point, target = null) {
        if (target == null) {
            target = new Point();
        }
        target.subVectors(point, ray.origin);
        const directionDistance = target.dot(ray.direction);
        if (directionDistance < 0) {
            return target.copy(ray.origin);
        }
        return target.copy(ray.direction).multiplyScalar(directionDistance).add(ray.origin);
    }
    GeoRelation.RayClosestPointToPoint = RayClosestPointToPoint;
    /**
     * 圆弧上距离一点最近的点
     * @param arc
     * @param point
     * @param clampToArc 所求点是否限制在圆弧上
     * @param target
     * @returns
     */
    function ArcClosestPointToPoint(arc, point, clampToArc = false, target = null) {
        if (target == null) {
            target = new Point();
        }
        let plane = new Plane$1();
        plane.setFromNormalAndCoplanarPoint(arc.normal, arc.center);
        let distToPlane = GeoMeasurement.PointDistanceToPlane(point, plane);
        if (Math.abs(distToPlane) > 1e-6) {
            // point不在圆弧所在平面
            plane.projectPoint(point.clone(), point);
        }
        let pDir = point.clone().sub(arc.center).normalize();
        let foot = new Point();
        foot.copy(pDir.clone().multiplyScalar(arc.radius).add(arc.center));
        let t = arc.getPointParameter(foot);
        if ((t >= -1e-6 && t <= 1 + 1e-6) || !clampToArc) {
            return target.copy(foot);
        }
        // 判断point距离起点还是端点更近
        let endPoints = arc.getEndPoints();
        let startPoint = endPoints[0];
        let endPoint = endPoints[1];
        let dirStart = startPoint.clone().sub(arc.center);
        let dirEnd = endPoint.clone().sub(arc.center);
        let angleToStart = pDir.angleTo(dirStart);
        let angleToEnd = pDir.angleTo(dirEnd);
        if (angleToStart <= angleToEnd) {
            return target.copy(startPoint);
        }
        return target.copy(endPoint);
    }
    GeoRelation.ArcClosestPointToPoint = ArcClosestPointToPoint;
    /**
     * 圆弧上距离射线最近的点
     * @param ray
     * @param arc
     * @param target
     * @returns
     */
    function RayClosestPointInArc(ray, arc, target = null) {
        if (target == null) {
            target = new Point();
        }
        let arcPlane = new Plane$1();
        arcPlane.setFromNormalAndCoplanarPoint(arc.normal, arc.center);
        if (Math.abs(ray.direction.dot(arc.normal)) < 1e-6) {
            // 射线平行于圆弧面 
            return null;
        }
        // 不共面
        let point = GeoIntersection.RayIntersectPlane(ray, arcPlane);
        if (!point) {
            // 射线与圆弧面无交点
            point = ray.origin;
            // return null;
        }
        GeoRelation.ArcClosestPointToPoint(arc, point, true, target);
        return target;
    }
    GeoRelation.RayClosestPointInArc = RayClosestPointInArc;
    /**
     * 逆时针计算角度
     * @param start
     * @param end
     * @param normal
     * @returns
     */
    function Vector3AngleTo(start, end, normal) {
        let theta = Math.acos(start.dot(end) / start.length() / end.length());
        let mark = start.clone().cross(end).dot(normal);
        if (mark < 0) {
            return 2 * Math.PI - theta;
        }
        return theta;
    }
    GeoRelation.Vector3AngleTo = Vector3AngleTo;
    /**
     * 判断两个是否接近
     * @param v1
     * @param v2
     * @returns
     */
    function Vector3IsClose(v1, v2) {
        if (v1.distanceTo(v2) < 1e-2) {
            return true;
        }
        return false;
    }
    GeoRelation.Vector3IsClose = Vector3IsClose;
    /**
     * 计算点到平面的距离
     * @param plane
     * @param point
     * @returns
     */
    function DistanceToPoint(plane, point) {
        return plane.normal.dot(point) + plane.constant;
    }
    GeoRelation.DistanceToPoint = DistanceToPoint;
    /**
     * 枚举类型，用于判定点与多边形的关系
     */
    let PointInRegion;
    (function (PointInRegion) {
        PointInRegion[PointInRegion["in"] = 1] = "in";
        PointInRegion[PointInRegion["on"] = 2] = "on";
        PointInRegion[PointInRegion["out"] = 3] = "out";
    })(PointInRegion = GeoRelation.PointInRegion || (GeoRelation.PointInRegion = {}));
    /**
     * 判断二维空间中的点c是否在a与b连成的线段之间（包括点a与点b）
     * @param a
     * @param b
     * @param c
     * @returns
     */
    function pointBetweenTwoPoints2D(a, b, c) {
        if (Math.abs(a[0] * b[1] + b[0] * c[1] + c[0] * a[1] - a[0] * c[1] - b[0] * a[1] - c[0] * b[1]) < EPSILON) {
            // 判断平行
            const x1 = [a[0] - c[0], a[1] - c[1]];
            const x2 = [b[0] - c[0], b[1] - c[1]];
            if (x1[0] * x2[0] + x1[1] * x2[1] <= 0) {
                // 判断是否在中间
                return true;
            }
        }
        return false;
    }
    /**
     * 获取下一点的索引，如果current是最后一个节点，则返回第一个点
     * @param current 当前索引
     * @param length 数组长度
     * @returns
     */
    function getNextIndex(current, length) {
        return current === length - 1 ? 0 : current + 1;
    }
    /**
     * 获取上一点的索引，如果current是第一个节点，则返回最后一点
     * @param current 当前索引
     * @param length 数组长度
     * @returns
     */
    function getLastIndex(current, length) {
        return current === 0 ? length - 1 : current - 1;
    }
    /**
     * 获取一个点在一条二维直线段上的定比分点的数值， 参考：https://zhuanlan.zhihu.com/p/422377860， 图片：点到直线定比分点.png
     * @param point
     * @param segment
     */
    function ratioToLine2(point, start, end) {
        _delta.subVectors(end, start);
        return (_delta.x * (point.x - start.x) + _delta.y * (point.y - start.y)) / (_delta.lengthSq());
    }
    GeoRelation.ratioToLine2 = ratioToLine2;
    const _delta = new Point2();
    /**
     * 判断二维点是否在多边形内部，注意此处的点和多边形在同一个坐标系下
     * 如果不能保证，请使用Point3InGeneralRegion进行转化
     * 采用射线法进行计算，默认发射一条从点point开始，延x轴正方向的射线。
     * 射线与图元交点为奇数，则在多边形内，否则在多边形外。
     * @param region
     * @param point
     * @returns
     */
    function Point2InGeneralRegion(region, point) {
        //1.如果是空环，直接认为不属于
        if (GeneralRegion.isEmptyRing(region.rings)) {
            return PointInRegion.out;
        }
        //2.定义交点个数
        let count = 0;
        //3.遍历所有环
        for (let ringIndex = 0; ringIndex < region.rings.length; ringIndex++) {
            let ring = region.rings[ringIndex];
            //4.如果环的长度小于等于2，直接舍弃
            if (ring.length <= 2) {
                continue;
            }
            //5.遍历一个环中的所有点
            let haveDone = new Array(ring.length).fill(false); //标记某条边被处理过
            for (let pointIndex = 0; pointIndex < ring.length; pointIndex++) {
                if (haveDone[pointIndex]) { //如果被处理过，则直接跳过
                    continue;
                }
                //5.1获取环中当前点point1与下一点point2与上一点point0
                let point1 = ring[pointIndex];
                let lastPointIndex = getLastIndex(pointIndex, ring.length);
                let nextPointIndex = getNextIndex(pointIndex, ring.length);
                let point2 = ring[nextPointIndex];
                let point0 = ring[lastPointIndex];
                //5.1判断point1和point2是否重合，如果重合直接不考虑这条线
                if (point1.equals(point2)) {
                    haveDone[pointIndex] = true;
                    continue;
                }
                //5.3判断传入的点是否位于多边形的某一条边，如果是，直接得出点在多边形上
                if (pointBetweenTwoPoints2D([point1.x, point1.y], [point2.x, point2.y], [point.x, point.y])) {
                    return PointInRegion.on;
                }
                //判断point1与point2这条线是否与射线y=point.y(x>=point.x)平行
                if (Math.abs(point1.y - point2.y) < EPSILON) {
                    if (Math.abs(point.y - point2.y) < EPSILON) { //重合
                        let maxX = Math.max(point1.x, point2.x);
                        if (point.x > maxX + EPSILON) ;
                        else {
                            //TODO，可能有很多条线平行的病态情况
                            //如果平行直线段两端反向，算一个交点
                            let point3 = ring[getNextIndex(nextPointIndex, ring.length)];
                            if ((point3.y - point2.y) * (point0.y - point1.y) < 0) {
                                count += 1;
                            }
                        }
                        haveDone[lastPointIndex] = true;
                        haveDone[pointIndex] = true;
                        haveDone[nextPointIndex] = true;
                        continue;
                    }
                    else { //平行不重合，直接返回
                        haveDone[pointIndex] = true;
                        continue;
                    }
                }
                //判断是否与起点重合
                if (point1.equals(point)) {
                    //每条线段只考虑起点，不考虑终点，以防重复计算
                    if ((point2.y - point1.y) * (point0.y - point1.y) < 0) {
                        count += 1;
                    }
                    haveDone[lastPointIndex] = true;
                    haveDone[pointIndex] = true;
                    continue;
                }
                //既不平行，也不重合，只用计算是否有交点即可
                //(已知(x1, y1), (x2, y2)后，直线方程为(y2-y1)*x+(x1-x2)*y+(x2*y1-x1*y2)=0)
                let intersectionX = ((point1.x * point2.y - point2.x * point1.y) + point.y * (point2.x - point1.x)) / (point2.y - point1.y);
                let maxX = Math.max(point1.x, point2.x);
                let minX = Math.min(point1.x, point2.x);
                let maxY = Math.max(point1.y, point2.y);
                let minY = Math.min(point1.y, point2.y);
                // console.log("intersectionX", intersectionX, "point1.x", point1.x, "point1.y", point1.y, "point2.x", point2.x, "point2.y", point2.y)
                if (point.x > intersectionX + EPSILON || intersectionX < minX - EPSILON || intersectionX > maxX + EPSILON || point.y < minY - EPSILON || point.y > maxY + EPSILON) ;
                else {
                    _point2Intersection.set(intersectionX, point.y); //设置交点
                    if (_point2Intersection.equals(point1)) {
                        //交点等于起点
                        if ((point2.y - point1.y) * (point0.y - point1.y) < 0) {
                            count += 1;
                            // console.log("pointIndex", pointIndex, "交点等于起点");
                            haveDone[pointIndex] = true;
                            haveDone[lastPointIndex] = true;
                        }
                        continue;
                    }
                    if (_point2Intersection.equals(point2)) {
                        //交点等于终点
                        let point3 = ring[getNextIndex(nextPointIndex, ring.length)];
                        if ((point3.y - point2.y) * (point1.y - point2.y) < 0) {
                            count += 1;
                            // console.log("pointIndex", pointIndex, "交点等于终点");
                            haveDone[pointIndex] = true;
                            haveDone[nextPointIndex] = true;
                        }
                        continue;
                    }
                    // console.log("pointIndex", pointIndex, "正常相交", intersectionX, "_point2Intersection", _point2Intersection.x, _point2Intersection.y); 
                    count += 1;
                }
                haveDone[pointIndex] = true;
                continue;
            }
        }
        // console.log("count", count)
        if (count % 2 == 0) {
            return PointInRegion.out;
        }
        return PointInRegion.in;
    }
    GeoRelation.Point2InGeneralRegion = Point2InGeneralRegion;
    /**
     * 判断三维点是否在多边形内部
     * @param region
     * @param point
     * @returns
     */
    function Point3InGeneralRegion(region, point) {
        if (GeoRelation.DistanceToPoint(region, point) > 1e-6) { //如果不共面，直接认为不属于
            return GeoRelation.PointInRegion.out;
        }
        _matrix$4.copy(region.transformMatrix).invert();
        _point3$1$1.copy(point).applyMatrix4(_matrix$4);
        _point2$1$1.set(_point3$1$1.x, _point3$1$1.y);
        return GeoRelation.Point2InGeneralRegion(region, _point2$1$1);
    }
    GeoRelation.Point3InGeneralRegion = Point3InGeneralRegion;
    /**
     * 从平面上的二维点中，提取所有环
     * @param lines 线段集合
     * @param precision 判断相等的小数位数精度
     * @returns 环的集合，每个环是一个 Point2 的数组
     */
    function extractAllLoops(lines, precision = 6) {
        console.log("lines", lines.map(loop => loop.map(p => `(${p.x}, ${p.y})`)));
        // 构建邻接表
        const adjMap = new Map();
        const pointKey = (p) => `${p.x.toFixed(precision)},${p.y.toFixed(precision)}`;
        for (const [p1, p2] of lines) {
            const key1 = pointKey(p1);
            const key2 = pointKey(p2);
            if (!adjMap.has(key1))
                adjMap.set(key1, []);
            if (!adjMap.has(key2))
                adjMap.set(key2, []);
            adjMap.get(key1).push(p2);
            adjMap.get(key2).push(p1);
        }
        // 存储环的集合
        const loops = [];
        const visitedEdges = new Set(); // 已访问的边避免重复计算
        // 深度优先搜索
        const dfs = (current, start, path, visitedNodes) => {
            const key = pointKey(current);
            visitedNodes.add(key);
            path.push(current);
            for (const neighbor of adjMap.get(key) || []) {
                const edgeKey = [pointKey(current), pointKey(neighbor)].sort().join("-");
                if (path.length > 2 && neighbor.equals(start)) {
                    // 找到一个环
                    loops.push([...path]);
                    continue;
                }
                if (!visitedEdges.has(edgeKey)) {
                    visitedEdges.add(edgeKey);
                    if (!visitedNodes.has(pointKey(neighbor))) {
                        dfs(neighbor, start, path, visitedNodes);
                    }
                    visitedEdges.delete(edgeKey);
                }
            }
            // 回溯
            path.pop();
            visitedNodes.delete(key);
        };
        // 遍历所有顶点并启动 DFS
        for (const [p1] of lines) {
            const visitedNodes = new Set();
            dfs(p1, p1, [], visitedNodes);
        }
        // 去重环
        const uniqueLoops = new Set();
        const result = [];
        for (const loop of loops) {
            const sortedLoop = loop
                .slice()
                .sort((a, b) => (a.x === b.x ? a.y - b.y : a.x - b.x))
                .map(pointKey)
                .join("-");
            if (!uniqueLoops.has(sortedLoop)) {
                uniqueLoops.add(sortedLoop);
                result.push(loop);
            }
        }
        return result;
    }
    GeoRelation.extractAllLoops = extractAllLoops;
    /**
     * 从空间中的三维点中，提取所有环
     * @param lines 线段集合
     * @param precision 判断相等的小数位数精度
     * @returns 环的集合，每个环是一个 Point2 的数组
     */
    function extractAllLoops3D(lines, precision = 6) {
        // 构建邻接表
        const adjMap = new Map();
        const pointKey = (p) => `${p.x.toFixed(precision)},${p.y.toFixed(precision)},${p.z.toFixed(precision)}`;
        for (const [p1, p2] of lines) {
            const key1 = pointKey(p1);
            const key2 = pointKey(p2);
            if (!adjMap.has(key1))
                adjMap.set(key1, []);
            if (!adjMap.has(key2))
                adjMap.set(key2, []);
            adjMap.get(key1).push(p2);
            adjMap.get(key2).push(p1);
        }
        // 存储环的集合
        const loops = [];
        const visitedEdges = new Set(); // 已访问的边避免重复计算
        // 深度优先搜索
        const dfs = (current, start, path, visitedNodes) => {
            const key = pointKey(current);
            visitedNodes.add(key);
            path.push(current);
            for (const neighbor of adjMap.get(key) || []) {
                const edgeKey = [pointKey(current), pointKey(neighbor)].sort().join("-");
                if (path.length > 2 && neighbor.equals(start)) {
                    // 找到一个环
                    loops.push([...path]);
                    continue;
                }
                if (!visitedEdges.has(edgeKey)) {
                    visitedEdges.add(edgeKey);
                    if (!visitedNodes.has(pointKey(neighbor))) {
                        dfs(neighbor, start, path, visitedNodes);
                    }
                    visitedEdges.delete(edgeKey);
                }
            }
            // 回溯
            path.pop();
            visitedNodes.delete(key);
        };
        // 遍历所有顶点并启动 DFS
        for (const [p1] of lines) {
            const visitedNodes = new Set();
            dfs(p1, p1, [], visitedNodes);
        }
        // 去重环
        const uniqueLoops = new Set();
        const result = [];
        for (const loop of loops) {
            const sortedLoop = loop
                .slice()
                .sort((a, b) => {
                if (a.x === b.x && a.y === b.y) {
                    return a.z - b.z;
                }
                else if (a.x === b.x) {
                    return a.y - b.y;
                }
                return a.x - b.x;
            })
                .map(pointKey)
                .join("-");
            if (!uniqueLoops.has(sortedLoop)) {
                uniqueLoops.add(sortedLoop);
                result.push(loop);
            }
        }
        return result;
    }
    GeoRelation.extractAllLoops3D = extractAllLoops3D;
    /**
     * 判断点是否在线上
     * @param line
     * @param point
     * @returns
     */
    function getT(line, point) {
        const lineLength = line.start.distanceTo(line.end);
        const startToPoint = line.start.distanceTo(point);
        const endToPoint = line.end.distanceTo(point);
        // 判断点是否在线段上：如果点到起点和终点的距离之和等于线段的总长度，说明点在该线段上
        if (Math.abs((startToPoint + endToPoint) - lineLength) > 1e-6) {
            return null;
        }
        // 计算 t 值
        return startToPoint / lineLength; // 返回 t 值，范围 [0, 1]
    }
    GeoRelation.getT = getT;
})(GeoRelation || (GeoRelation = {}));
const _point3$1$1 = new Point();
const _point2$1$1 = new Point2();
const _point2Intersection = new Point2();
const _matrix$4 = new Matrix4$1();/**
 * 布尔操作枚举
 */
var BoolOpeType;
(function (BoolOpeType) {
    /**
     * 布尔-交
     */
    BoolOpeType[BoolOpeType["INTERSECT"] = 1] = "INTERSECT";
    /**
     * 布尔-并
     */
    BoolOpeType[BoolOpeType["UNION"] = 2] = "UNION";
    /**
     * 布尔-差
     */
    BoolOpeType[BoolOpeType["SUBSTRACT"] = 3] = "SUBSTRACT";
})(BoolOpeType || (BoolOpeType = {}));/**
 * 几何体基类
 */
class Solid extends GeometryBase {
    constructor() {
        super(...arguments);
        /**
         * 几何类熊
         */
        this.type = 'Solid';
        /**
         * 为了解决instanceof在引用库时可能失败的问题，强制增加一条
         */
        this.isSolid = true;
        /**
         * 面索引
         */
        this.surfaceIndex = [];
    }
    clone() {
        return new Solid().copy(this);
    }
    equals(solid) {
        return false;
    }
    getCenter(target = null) {
        return target;
    }
    /**
     * 获取基元索引列表 用于绑定
     */
    getGeoElementsIdxList() {
        return this.surfaceIndex;
    }
}/**
 * 索引面，用以减少存储空间
 */
class PolygonIndex {
    constructor(rings = [], normal = new Vector3$1(0, 0, 1)) {
        this.rings = rings;
        this.normal = normal.clone();
        this.normal.normalize();
    }
    copy(polygonIndex) {
        this.normal = polygonIndex.normal.clone();
        this.rings = [];
        for (let i = 0; i < polygonIndex.rings.length; i++) {
            let tmpRing = [];
            for (let j = 0; j < polygonIndex.rings[i].length; j++) {
                tmpRing.push(polygonIndex.rings[i][j]);
            }
            this.rings.push(tmpRing);
        }
        return this;
    }
    getCenter(points, target = null) {
        let len = 0;
        if (target == null) {
            target = new Point();
        }
        this.rings.forEach(ring => {
            ring.forEach(line => {
                target.add(points[line]);
                len += 1;
            });
        });
        if (len > 0) {
            target.multiplyScalar(1 / len);
        }
        return target;
    }
    negate() {
        this.normal.negate();
        this.negateRings();
    }
    negateRings() {
        let newRings = [];
        this.rings.forEach(ring => {
            let newRing = [];
            for (let i = ring.length - 1; i >= 0; i--) {
                newRing.push(ring[i]);
            }
            newRings.push(newRing);
        });
        this.rings = newRings;
    }
    clone() {
        let res = new PolygonIndex();
        res.copy(this);
        return res;
    }
    fromJson(json) {
        this.normal.set(json.normal.x, json.normal.y, json.normal.z);
        this.rings = json.rings;
    }
    toJson() {
        let data = {
            version: "1.0",
            normal: {
                x: this.normal.x,
                y: this.normal.y,
                z: this.normal.z
            },
            rings: this.rings
        };
        return data;
    }
}
/**
 * 一般几何体
 */
class GeneralSolid extends Solid {
    constructor(points = [], faces = [], transformMatrix = new Matrix4$1()) {
        super();
        /**
         * 一般多边形
         */
        this.type = 'GeneralSolid';
        this.points = [];
        this.faces = [];
        this.points = [...points];
        this.faces = [...faces];
        this.transformMatrix.copy(transformMatrix);
    }
    copy(geo) {
        super.copy(geo);
        if (geo instanceof GeneralSolid) {
            this.points = [];
            geo.points.forEach(point => {
                this.points.push(point.clone());
            });
            this.faces = [];
            geo.faces.forEach(face => {
                this.faces.push(face.clone());
            });
        }
        return this;
    }
    clone() {
        return new GeneralSolid().copy(this);
    }
    equals(geo) {
        return false;
    }
    /**
     * 每个面生成实际多边形
     * @returns
     */
    getAllPolygons() {
        let res = [];
        for (let i = 0; i < this.faces.length; i++) {
            let polygon = this.getSurface(i);
            res.push(polygon);
        }
        return res;
    }
    /**
     * 获取基元索引列表 用于绑定
     */
    getGeoElementsIdxList() {
        return this.surfaceIndex;
    }
    /**
     * 获取包围盒
     * @returns
     */
    getBoundingBox() {
        let min = new Vector3$1(Number.MAX_VALUE, Number.MAX_VALUE, 0);
        let max = new Vector3$1(Number.MIN_VALUE, Number.MIN_VALUE, 0);
        this.points.forEach(point => {
            min.x = Math.min(min.x, point.x);
            min.y = Math.min(min.y, point.y);
            max.x = Math.max(max.x, point.x);
            max.y = Math.max(max.y, point.y);
        });
        let box = new Box3$1(min, max);
        box.applyMatrix4(this.transformMatrix);
        return box;
    }
    /**
     * 获取基元数组
     * @returns
     */
    getGeoElements() {
        return this.getAllPolygons();
    }
    /**
     * 根据索引值获取表面
     * @param index
     * @returns
     */
    getSurface(index) {
        if (index >= this.faces.length)
            return null;
        let polygon = new GeneralRegion([], this.faces[index].normal.clone());
        let rings = [];
        this.faces[index].rings.forEach(ring => {
            let realRing = [];
            ring.forEach(pointIndex => {
                realRing.push(new Point().copy(this.points[pointIndex]).applyMatrix4(this.transformMatrix));
            });
            rings.push(realRing);
        });
        _matrix3.setFromMatrix4(this.transformMatrix);
        const normal = this.faces[index].normal.clone().applyMatrix3(_matrix3);
        polygon.setByRingsAndNormal(rings, normal);
        return polygon;
    }
    fromJson(json) {
        super.fromJson(json);
        this.points = [];
        this.faces = [];
        json.points.forEach(point => {
            let newPoint = new Point(point.x, point.y, point.z);
            this.points.push(newPoint);
        });
        json.faces.forEach(face => {
            let newFace = new PolygonIndex();
            newFace.normal.set(face.normal.x, face.normal.y, face.normal.z);
            newFace.rings = face.rings;
            this.faces.push(newFace);
        });
        return this;
    }
    toJson() {
        let data = Object.assign(Object.assign({}, super.toJson()), { version: "1.0", type: 'GeneralSolid', points: this.points.map(point => { return { x: point.x, y: point.y, z: point.z }; }), faces: this.faces.map(face => { return face.toJson(); }) });
        return data;
    }
}
const _matrix3 = new Matrix3$1();/**
 * 计算机编程的通用基础库
 */
var BaseUtils;
(function (BaseUtils) {
    /**
     * 保留小数点后n位
     * @param value
     * @param n
     * @returns
     */
    BaseUtils.NumFixed = (value, n) => {
        return Math.round(value * Math.pow(10, n)) / Math.pow(10, n);
    };
    const _lut = [];
    /**
     * 随机生成全局唯一uuid
     * @returns
     */
    function genUUID() {
        if (_lut.length == 0) {
            for (let i = 0; i < 256; i++) {
                _lut[i] = (i < 16 ? '0' : '') + (i).toString(16);
            }
        }
        const d0 = Math.random() * 0xffffffff | 0;
        const d1 = Math.random() * 0xffffffff | 0;
        const d2 = Math.random() * 0xffffffff | 0;
        const d3 = Math.random() * 0xffffffff | 0;
        const uuid = _lut[d0 & 0xff] + _lut[(d0 >> 8) & 0xff] + _lut[(d0 >> 16) & 0xff] + _lut[(d0 >> 24) & 0xff] + '-' +
            _lut[d1 & 0xff] + _lut[(d1 >> 8) & 0xff] + '-' + _lut[((d1 >> 16) & 0x0f) | 0x40] + _lut[(d1 >> 24) & 0xff] + '-' +
            _lut[(d2 & 0x3f) | 0x80] + _lut[(d2 >> 8) & 0xff] + '-' + _lut[(d2 >> 16) & 0xff] + _lut[(d2 >> 24) & 0xff] +
            _lut[d3 & 0xff] + _lut[(d3 >> 8) & 0xff] + _lut[(d3 >> 16) & 0xff] + _lut[(d3 >> 24) & 0xff];
        // .toUpperCase() here flattens concatenated strings to save heap memory space.
        // return uuid.toUpperCase().replace(/-/g, '');
        return uuid;
    }
    BaseUtils.genUUID = genUUID;
    /**
     * 随机生成全局唯一uuid，不带短横线
     * @returns
     */
    function genUUIDNoLine() {
        return genUUID().toLowerCase().replace(/-/g, "");
    }
    BaseUtils.genUUIDNoLine = genUUIDNoLine;
    /**
     * 用以验证antd输入的字符一定是浮点数字符
     * 输入输出示例
     * 1.041  => 1.041
     * -1.30 => -1.30
     * ---2.41 => -2.41
     * ANF-3 => 3
     * ANF-3.4GF5 => 3.45
     * AIEGHQING => 空字符串
     */
    function FloatVerification(value) {
        if (!value)
            return '';
        //按照.对字符串进行分割
        const tempArr = value.split('.');
        let minus = "";
        //如果不是空字符串，且第一位为“-”，说明输入的浮点数为负数，在之后的结果中加
        if ((value === null || value === void 0 ? void 0 : value.length) > 0 && value[0] == "-")
            minus = "-";
        if (tempArr.length >= 2) {
            //则将除了[0-9]和.号的其他字符全部替换为空字符
            return minus + `${tempArr[0]}.${tempArr[1]}`.replace(/([^\d{1,}\.\d{1,}|\d{1,}])|,+/g, '');
        }
        else {
            return minus + value.replace(/([^\d{1,}\.\d{1,}|\d{1,}])|,+/g, '');
        }
    }
    BaseUtils.FloatVerification = FloatVerification;
    /**
     * 用以验证antd输入的字符一定是非负整数字符
     * 输入输出示例
     * 1.041  => 1041
     * -1.30 => 130
     * ---2.41 => 2.41
     * ANF-3 => 3
     * ANF-3.4GF5 => 3.45
     * AIEGHQING => 空字符串
     */
    function NonNegativeIntegerVerification(value) {
        if (!value)
            return '';
        // 将除了 [0-9] 的其他字符全部替换为空字符
        return value.replace(/[^\d]/g, '');
    }
    BaseUtils.NonNegativeIntegerVerification = NonNegativeIntegerVerification;
    /**
     * 将值设置在min和max之间
     * @param value
     * @param min
     * @param max
     * @returns
     */
    function clamp(value, min, max) {
        return Math.max(min, Math.min(max, value));
    }
    BaseUtils.clamp = clamp;
    // compute euclidian modulo of m % n
    // https://en.wikipedia.org/wiki/Modulo_operation
    function euclideanModulo(n, m) {
        return ((n % m) + m) % m;
    }
    BaseUtils.euclideanModulo = euclideanModulo;
    /**
     * 获取下一点的索引，如果current是最后一个节点，则返回第一个点
     * @param current 当前索引
     * @param length 数组长度
     * @returns
     */
    function getNextIndex(current, length) {
        return current === length - 1 ? 0 : current + 1;
    }
    BaseUtils.getNextIndex = getNextIndex;
    /**
     * 获取上一点的索引，如果current是第一个节点，则返回最后一点
     * @param current 当前索引
     * @param length 数组长度
     * @returns
     */
    function getLastIndex(current, length) {
        return current === 0 ? length - 1 : current - 1;
    }
    BaseUtils.getLastIndex = getLastIndex;
})(BaseUtils || (BaseUtils = {}));/**
 * 闭区间
 */
class ClosedInterval {
    constructor(datas = [], needMerge = false) {
        this.datas = [];
        this.datas = datas;
        this.sort();
        if (needMerge) {
            this.merge();
        }
        this.needMerge = needMerge;
    }
    /**
     *
     * @param data 向闭区间中添加区间
     */
    add(data) {
        this.datas.push(data);
        this.sort();
    }
    /**
     * 闭区间排序
     */
    sort() {
        this.datas.sort((a, b) => a[0] - b[0]);
    }
    /**
     * 获取闭区间数据
     * @returns
     */
    getData() {
        return this.datas;
    }
    /**
     * 设置数据
     * @param datas
     */
    setData(datas) {
        this.datas = datas;
    }
    /**
     *  区间类合并函数,可将排好序的区间进行合并区间
     *  eg [[-3, 7], [1, 9], [11, 13]] =>  [[-3, 9], [11, 13]]
     */
    merge() {
        const newDatas = [];
        for (const data of this.datas) {
            if (!newDatas.length || newDatas[newDatas.length - 1][1] < data[0]) {
                // c 大
                newDatas.push(data);
            }
            else {
                // b 大
                // 将 b 和 d 中大的作为后一个元素
                newDatas[newDatas.length - 1][1] = Math.max(newDatas[newDatas.length - 1][1], data[1]);
            }
        }
        this.datas = newDatas;
    }
    /**
     * 求a的补集
     * @param a
     */
    getComplement() {
        const newDatas = [];
        if (this.datas.length === 0) {
            return new ClosedInterval([[-Infinity, Infinity]]);
        }
        newDatas.push([-Infinity, this.datas[0][0]]);
        let i = 0;
        while (i < this.datas.length - 1) {
            newDatas.push([this.datas[i][1], this.datas[i + 1][0]]);
            i += 1;
        }
        newDatas.push([this.datas[i][1], Infinity]);
        return new ClosedInterval(newDatas, this.needMerge);
    }
}
/**
 * 布尔操作算法类
 */
var BoolOperation;
(function (BoolOperation) {
    /**
     * 一维闭区间的布尔操作算法
     * @param a
     * @param b
     * @param ope
     * @returns
     */
    function boolOperation1D(a, b, ope = BoolOpeType.INTERSECT) {
        if (ope === BoolOpeType.UNION) {
            const newDatas = [...a.getData(), ...b.getData()];
            return new ClosedInterval(newDatas, a.needMerge);
        }
        else if (ope === BoolOpeType.SUBSTRACT) {
            return boolOperation1D(a, b.getComplement(), BoolOpeType.INTERSECT);
        }
        else if (ope === BoolOpeType.INTERSECT) {
            const A = a.getData();
            const B = b.getData();
            let i = 0;
            let j = 0;
            let result = [];
            while (i < A.length && j < B.length) {
                const [a1, a2] = A[i];
                const [b1, b2] = B[j];
                // 计算有交集的情况
                const tmpMin = Math.max(a1, b1);
                const tmpMax = Math.min(a2, b2);
                if (b2 >= a1 && a2 >= b1 && tmpMin < tmpMax) {
                    // 计算出交集
                    result.push([tmpMin, tmpMax]);
                }
                // 指针前进
                if (b2 < a2) {
                    j += 1;
                }
                if (b2 >= a2) {
                    i += 1;
                }
            }
            return new ClosedInterval(result, a.needMerge);
        }
        else {
            return new ClosedInterval();
        }
    }
    BoolOperation.boolOperation1D = boolOperation1D;
    /**
     * 二维布尔操作，操作后的图元默认采用left的局部坐标系
     * @param left 操作左侧多边形
     * @param right 操作右侧多边形
     * @param ope 操作类型
     * @returns
     */
    function boolOperation2D(left, right, ope = BoolOpeType.INTERSECT) {
        if (!left && !right)
            return new GeneralRegion(); //left和right都为空，直接返回空
        if (!left)
            return right.clone(); //left为空，返回right
        if (!right)
            return left.clone(); //right为空，返回left
        if (left.normal.cross(right.normal).length() > 1e-6 || GeoRelation.DistanceToPoint(left, right.getP()) > 1e-6) { //如果不共面，直接返回左
            return left.clone();
        }
        let leftResult = _generateInOnOutForPolygon(left, right, true);
        // console.log("=====================================================================================")
        let rightResult = _generateInOnOutForPolygon(right, left);
        // console.log("leftResult", leftResult)
        // console.log("rightResult", rightResult)
        let left_in_right = leftResult.in;
        let left_on_right = leftResult.on;
        let left_out_right = leftResult.out;
        let right_in_left = rightResult.in;
        // let right_on_left = rightResult.on;
        let right_out_left = rightResult.out;
        let res = new GeneralRegion();
        res.transformMatrix.copy(left.transformMatrix);
        if (ope === BoolOpeType.INTERSECT) {
            res.rings = GeoRelation.extractAllLoops([...left_in_right, ...right_in_left, ...left_on_right]);
        }
        else if (ope === BoolOpeType.UNION) {
            res.rings = GeoRelation.extractAllLoops([...left_out_right, ...right_out_left, ...left_on_right]);
        }
        else { //默认作差
            res.rings = GeoRelation.extractAllLoops([...left_out_right, ...right_in_left, ...left_on_right]);
        }
        return res;
    }
    BoolOperation.boolOperation2D = boolOperation2D;
    function boolOperation3D(left, right, ope = BoolOpeType.INTERSECT) {
        let res = new GeneralSolid();
        // console.log("a ---> b ++++");
        let resA = _generateInOnOutForSolid(left, right);
        // console.log("b ---> a ++++");
        let resB = _generateInOnOutForSolid(right, left);
        let a_in_b = resA.in;
        let a_on_b = resA.on;
        let a_out_b = resA.out;
        let b_in_a = resB.in;
        // let b_on_a = resB.on;
        let b_out_a = resB.out;
        let points = [];
        let faces = [];
        if (ope === BoolOpeType.INTERSECT) {
            removeDuplicatePoint(a_in_b, points, faces);
            removeDuplicatePoint(b_in_a, points, faces);
            removeDuplicatePoint(a_on_b, points, faces);
        }
        else if (ope === BoolOpeType.SUBSTRACT) {
            removeDuplicatePoint(a_out_b, points, faces);
            removeDuplicatePoint(a_on_b, points, faces);
            let b_in_a_inverse = [];
            b_in_a.forEach(item => {
                b_in_a_inverse.push(item.getNegate());
            });
            removeDuplicatePoint(b_in_a_inverse, points, faces);
        }
        else if (ope === BoolOpeType.UNION) {
            removeDuplicatePoint(a_out_b, points, faces);
            removeDuplicatePoint(b_out_a, points, faces);
            removeDuplicatePoint(a_on_b, points, faces);
        }
        res.faces = faces;
        res.points = points;
        return res;
    }
    BoolOperation.boolOperation3D = boolOperation3D;
    /**
     * GeneralSolid顶点去重
     * @param polygonItem
     * @param points
     * @param faces
     */
    function removeDuplicatePoint(polygonItem, points, faces) {
        polygonItem.forEach(item => {
            // console.log("item in removeDuplicatePoint", item.virtual, item.polygon);
            let pIndex = new PolygonIndex([], item.normal.clone());
            item.rings.forEach(ring => {
                let ringIndex = [];
                ring.forEach(point2 => {
                    let alreadyInPoints = false;
                    let start = 0;
                    _point3$4.set(point2.x, point2.y, 0).applyMatrix4(item.transformMatrix);
                    for (let i = 0; i < points.length; i++) {
                        if (_point3$4.equals(points[i])) {
                            alreadyInPoints = true;
                            start = i;
                            break;
                        }
                    }
                    if (!alreadyInPoints) {
                        start = points.length;
                        points.push(_point3$4.clone());
                    }
                    ringIndex.push(start);
                });
                pIndex.rings.push(ringIndex);
            });
            faces.push(pIndex);
        });
    }
    BoolOperation.removeDuplicatePoint = removeDuplicatePoint;
    /**
     * 三维布尔操作核心逻辑
     * @param a 一般体a
     * @param b 一般体b
     * @returns 返回一般体a在一般体b的内部、面上、外部的PolygonItem集合
     */
    function _generateInOnOutForSolid(a, b) {
        let res = { out: [], in: [], on: [] };
        let polygonItemOfA = a.getAllPolygons();
        let polygonItemOfB = b.getAllPolygons();
        for (let i = 0; i < polygonItemOfA.length; i++) {
            let itemA = polygonItemOfA[i];
            let shouldBeOut = true;
            let polygonOnPlaneA = [];
            let intersectLines = [];
            let shouldBeIn = false;
            // console.log("==============================================================================================");
            polygonItemOfB.forEach(itemB => {
                let inResultPlaneAAndPolygonB = GeoIntersection.polygonIntersectPlane(itemB, itemA, null, true); //B上多边形与A上多边形所在平面的交线集合
                if (inResultPlaneAAndPolygonB.status === 2) {
                    //重合
                    if (itemA.normal.dot(itemB.normal) < 0) {
                        //如果法向量反向，将polygon_b反转
                        polygonOnPlaneA.push(itemB.getNegate());
                    }
                    else {
                        polygonOnPlaneA.push(itemB);
                    }
                    // console.log("---------------polygonOnPlaneA-----------------", polygonOnPlaneA);
                    shouldBeOut = false;
                }
                else if (inResultPlaneAAndPolygonB.status === 1) {
                    //相交
                    if (inResultPlaneAAndPolygonB.lines.length > 0) {
                        shouldBeOut = false;
                        if (!inResultPlaneAAndPolygonB.onlyOn) {
                            shouldBeIn = true;
                        }
                        // console.log("多边形", itemB.polygon, "与平面", planeA, "相交结果:", inResultPlaneAAndPolygonB.lines)
                        intersectLines = [...intersectLines, ...inResultPlaneAAndPolygonB.lines];
                        // intersectLines.forEach(line => {
                        //     console.log("当前交线集合：：", 'start: ', line.start.x.toFixed(4), line.start.y.toFixed(4), line.start.z.toFixed(4), 'end: ',  line.end.x.toFixed(4), line.end.y.toFixed(4), line.end.z.toFixed(4))
                        // });
                        // console.log('\n');
                    }
                }
                //平行不考虑
            });
            if (shouldBeOut && itemA.isVaild()) {
                res.out.push(itemA);
                continue;
            }
            polygonOnPlaneA.forEach(polygon => {
                let tmpPolygon = boolOperation2D(itemA.clone(), polygon.clone(), BoolOpeType.INTERSECT);
                if (tmpPolygon.isVaild()) {
                    res.on.push(tmpPolygon);
                }
            });
            let allPolygons = [...polygonOnPlaneA];
            if (intersectLines.length > 0 && shouldBeIn) {
                // console.log("bool 3d拼交面")
                // console.log("交线长度大于0了，接下来准备拼交面了!!!");
                // intersectLines.forEach(line => {
                //     console.log("start:", line.start.x.toFixed(6), line.start.y.toFixed(6), line.start.z.toFixed(6), "end:", line.end.x.toFixed(6), line.end.y.toFixed(6), line.end.z.toFixed(6))
                // })
                let intersectLinesPolygon = GeoRelation.extractAllLoops3D(intersectLines);
                if (!!intersectLinesPolygon && !GeneralRegion.isEmptyRing(intersectLinesPolygon)) {
                    let tmpGeneralRegion = new GeneralRegion();
                    tmpGeneralRegion.setByRingsAndNormal(intersectLinesPolygon, null, false);
                    if (tmpGeneralRegion.normal.dot(itemA.normal) < 0) {
                        tmpGeneralRegion.negate();
                    }
                    let tmpPolygon = boolOperation2D(tmpGeneralRegion, itemA, BoolOpeType.INTERSECT);
                    if (tmpPolygon.isVaild()) {
                        res.in.push(tmpPolygon);
                    }
                    allPolygons.push(tmpGeneralRegion);
                }
            }
            let outPolygons = [itemA.clone()]; // 初始化一个包含初始多边形的数组
            allPolygons.forEach(item => {
                // 用全体部分减去在多边形内部的部分，得到更新后的多边形数组
                let updatedPolygons = [];
                outPolygons.forEach(outPolygon => {
                    updatedPolygons = updatedPolygons.concat(boolOperation2D(outPolygon, item, BoolOpeType.SUBSTRACT)); // 将每个 outPolygon 与当前 item 进行布尔运算，得到更新后的多边形数组
                });
                outPolygons = updatedPolygons; // 更新 outPolygons 为更新后的多边形数组
            });
            // 将结果添加到 res.out 数组中
            outPolygons.forEach(outPolygon => {
                if (outPolygon.isVaild()) {
                    res.out.push(outPolygon);
                }
            });
        }
        return res;
    }
    BoolOperation._generateInOnOutForSolid = _generateInOnOutForSolid;
    /**
     * 二维布尔操作核心逻辑
     * @param left 多边形left
     * @param right 多边形right
     * @param needChangeToLeft 将所求得的点转化到left的局部坐标空间中
     * @returns 返回多边形left在多边形right的内部、边上、外部的线段集合
     */
    function _generateInOnOutForPolygon(left, right, needChangeToLeft = false) {
        let res = { out: [], in: [], on: [] }; //返回结果
        //获取左图元所有边（平铺开）
        let allLinesOfLeft = [];
        let ringsOfLeftInRightUcs = []; //left图元的环在right的世界坐标系下的位置
        _matrix1.copy(right.transformMatrix).invert(); //right图元的逆矩阵
        left.rings.forEach(ring => {
            let newRing = [];
            ring.forEach(point2InLeftUcs => {
                // console.log("left point", point2InLeftUcs.x, point2InLeftUcs.y)
                _point3$4.set(point2InLeftUcs.x, point2InLeftUcs.y, 0).applyMatrix4(left.transformMatrix); //left转世界
                _point3$4.applyMatrix4(_matrix1); //世界转right
                let point2InRightUcs = new Point2(_point3$4.x, _point3$4.y);
                // console.log("right point", _point3.x, _point3.y, "\n")
                newRing.push(point2InRightUcs);
            });
            ringsOfLeftInRightUcs.push(newRing);
        });
        ringsOfLeftInRightUcs.forEach(ring => {
            for (let pointIndex = 0; pointIndex < ring.length; pointIndex++) {
                allLinesOfLeft.push([ring[pointIndex], ring[BaseUtils.getNextIndex(pointIndex, ring.length)]]);
            }
        });
        // console.log("matrix_left", left.transformMatrix.elements);
        // console.log("matrix_right", right.transformMatrix.elements);
        // console.log("matrix_right_inserve", _matrix1.elements);
        // console.log("ringsOfLeftInRightUcs", ringsOfLeftInRightUcs.map(loop => loop.map(p => `(${p.x}, ${p.y})`)));
        // console.log("right.rings", right.rings.map(loop => loop.map(p => `(${p.x}, ${p.y})`)))
        //遍历left中所有铺开的线段
        allLinesOfLeft.forEach(line2 => {
            // console.log("line2 start", line2[0].x, line2[0].y, "line2 end", line2[1].x, line2[1].y)
            if (line2[0].equals(line2[1])) { //两点重合，直接舍弃
                return;
            }
            let tmpRes = _generateInOnOutForLine(line2, right);
            res.out = [...res.out, ...tmpRes.out];
            res.in = [...res.in, ...tmpRes.in];
            res.on = [...res.on, ...tmpRes.on];
        });
        if (needChangeToLeft) {
            _matrix2.copy(left.transformMatrix).invert();
            res.out.forEach(line2 => {
                _point3$4.set(line2[0].x, line2[0].y, 0);
                _point3$4.applyMatrix4(right.transformMatrix).applyMatrix4(_matrix2);
                line2[0].set(_point3$4.x, _point3$4.y);
                _point3$4.set(line2[1].x, line2[1].y, 0);
                _point3$4.applyMatrix4(right.transformMatrix).applyMatrix4(_matrix2);
                line2[1].set(_point3$4.x, _point3$4.y);
            });
            res.in.forEach(line2 => {
                _point3$4.set(line2[0].x, line2[0].y, 0);
                _point3$4.applyMatrix4(right.transformMatrix).applyMatrix4(_matrix2);
                line2[0].set(_point3$4.x, _point3$4.y);
                _point3$4.set(line2[1].x, line2[1].y, 0);
                _point3$4.applyMatrix4(right.transformMatrix).applyMatrix4(_matrix2);
                line2[1].set(_point3$4.x, _point3$4.y);
            });
            res.on.forEach(line2 => {
                _point3$4.set(line2[0].x, line2[0].y, 0);
                _point3$4.applyMatrix4(right.transformMatrix).applyMatrix4(_matrix2);
                line2[0].set(_point3$4.x, _point3$4.y);
                _point3$4.set(line2[1].x, line2[1].y, 0);
                _point3$4.applyMatrix4(right.transformMatrix).applyMatrix4(_matrix2);
                line2[1].set(_point3$4.x, _point3$4.y);
            });
        }
        return res;
    }
    BoolOperation._generateInOnOutForPolygon = _generateInOnOutForPolygon;
    /**
     * 求得一条二维线段在另一个多边形内部、边界与外部的部分
     * @param line2
     * @param region
     * @returns
     */
    function _generateInOnOutForLine(line2, region) {
        let res = { out: [], in: [], on: [] };
        //1.先求region在直线line2上的部分
        let onInterval = new ClosedInterval([]); //a_on_b的所有部分在a上的定比分点值所组成的区间
        region.rings.forEach(ring => {
            for (let pointIndex = 0; pointIndex < ring.length; pointIndex++) {
                //******算法起始：判断两直线是否共线******
                let start = ring[pointIndex];
                let end = ring[BaseUtils.getNextIndex(pointIndex, ring.length)];
                if (start.equals(end)) {
                    continue;
                }
                // console.log("line2 start", line2[0].x, line2[0].y, "line2 end", line2[1].x, line2[1].y, "segment start", start.x, start.y, "segment end", end.x, end.y)
                let A = line2[0].y - line2[1].y;
                let B = line2[1].x - line2[0].x;
                let C = line2[0].x * line2[1].y - line2[1].x * line2[0].y;
                let length = Math.sqrt(A * A + B * B);
                // console.log("A", A, "B", B, "C", C, "length", length, "eee", A * start.x + B * start.y + C, A * end.x + B * end.y + C);
                if (Math.abs(A * start.x + B * start.y + C) / length < EPSILON && Math.abs(A * end.x + B * end.y + C) / length < EPSILON) {
                    //共线
                    let startRatio = GeoRelation.ratioToLine2(start, line2[0], line2[1]);
                    let endRatio = GeoRelation.ratioToLine2(end, line2[0], line2[1]);
                    let tmpClosedInterval = boolOperation1D(new ClosedInterval([[startRatio, endRatio]]), new ClosedInterval([[0, 1]]), BoolOpeType.INTERSECT);
                    onInterval = boolOperation1D(onInterval, tmpClosedInterval, BoolOpeType.UNION);
                }
                //******算法结束：判断两直线是否共线******
            }
        });
        let line2Dir = { x: line2[1].x - line2[0].x, y: line2[1].y - line2[0].y };
        // console.log("onIntervalonIntervalonInterval", onInterval.getData())
        onInterval.getData().forEach(data => {
            res.on.push([
                new Point2(line2[0].x + data[0] * line2Dir.x, line2[0].y + data[0] * line2Dir.y),
                new Point2(line2[0].x + data[1] * line2Dir.x, line2[0].y + data[1] * line2Dir.y)
            ]);
        });
        let intersectionPointsWithLine = _straightLineIntersectPolygon2d(line2, region);
        // console.log("intersectionPointsWithLine", intersectionPointsWithLine.map(item => `p(${item.point.x},${item.point.y})`))
        if (intersectionPointsWithLine.length === 0) {
            //如果没有交点，那么整条a都是位于多边形b的外侧的
            res.out.push([line2[0].clone(), line2[1].clone()]);
            return res;
        }
        let intersectionPointInfos = [];
        intersectionPointsWithLine.forEach(item => {
            intersectionPointInfos.push({
                line: item.line,
                point: item.point,
                t: GeoRelation.ratioToLine2(item.point, line2[0], line2[1])
            });
        });
        intersectionPointInfos.sort((a, b) => a.t - b.t);
        // console.log("intersectionPointInfos", intersectionPointInfos.map(item => `p(${item.point.x},${item.point.y}), t(${item.t}), l(${item.line[0].x},${item.line[0].y}  ,${item.line[1].x},${item.line[1].y})`))
        let totalInterval = new ClosedInterval([[-Infinity, intersectionPointInfos[0].t]]);
        // console.log("totalInterval", totalInterval.getData());
        for (let i = 0; i < intersectionPointInfos.length; i++) {
            if (i < intersectionPointInfos.length - 1) {
                totalInterval = boolOperation1D(totalInterval, new ClosedInterval([[intersectionPointInfos[i].t, intersectionPointInfos[i + 1].t]]), BoolOpeType.UNION);
                // console.log("totalInterval", totalInterval.getData());
            }
            else {
                //最后一个
                totalInterval = boolOperation1D(totalInterval, new ClosedInterval([[intersectionPointInfos[i].t, Infinity]]), BoolOpeType.UNION);
                // console.log("totalInterval", totalInterval.getData());
            }
        }
        totalInterval = boolOperation1D(totalInterval, new ClosedInterval([[0, 1]]), BoolOpeType.INTERSECT);
        // console.log("totalInterval", totalInterval.getData());
        let otherInterval = boolOperation1D(totalInterval, onInterval, BoolOpeType.SUBSTRACT);
        // console.log("otherInterval", otherInterval.getData());
        otherInterval.getData().forEach(data => {
            let t = (data[0] + data[1]) / 2;
            let startpoint = new Point2(line2[0].x + data[0] * line2Dir.x, line2[0].y + data[0] * line2Dir.y);
            let endpoint = new Point2(line2[0].x + data[1] * line2Dir.x, line2[0].y + data[1] * line2Dir.y);
            let midpoint = new Point2(line2[0].x + t * line2Dir.x, line2[0].y + t * line2Dir.y);
            // console.log("midpoint", midpoint.x, midpoint.y, "status", GeoRelation.Point2InGeneralRegion(region, midpoint))
            if (GeoRelation.Point2InGeneralRegion(region, midpoint) === GeoRelation.PointInRegion.out) {
                res.out.push([startpoint, endpoint]);
            }
            else {
                res.in.push([startpoint, endpoint]);
            }
        });
        return res;
    }
    BoolOperation._generateInOnOutForLine = _generateInOnOutForLine;
    // /**
    //  * 根据t获取二维直线段上的点
    //  * @param start 
    //  * @param end 
    //  * @param t 
    //  * @param target 
    //  * @returns 
    //  */
    // function getPointAtByLine2(start: Point2, end: Point2, t: number, target: Point2 = null) {
    //     if (target == null) {
    //         target = new Point2();
    //     }
    //     target.copy(end).multiplyScalar(t).add(start);
    //     return target;
    // }
    /**
     * 在同一平面上的直线与多边形求交，返回直线与多边形交点与交点所在线段。
     * @param a
     * @param b
     * @returns
     */
    function _straightLineIntersectPolygon2d(line2, b) {
        let res = [];
        b.rings.forEach(ring => {
            for (let pointIndex = 0; pointIndex < ring.length; pointIndex++) {
                let start = ring[pointIndex];
                let end = ring[BaseUtils.getNextIndex(pointIndex, ring.length)];
                // console.log("line2 start", line2[0].x, line2[0].y, "line2 end", line2[1].x, line2[1].y);
                // console.log("segment start", start.x, start.y, "segment end", end.x, end.y);
                let intersectPointInfo = GeoIntersection.straightLine2IntersectLine2(line2, [start, end]);
                // console.log("intersectPointInfo", intersectPointInfo.status, intersectPointInfo.t);
                if (intersectPointInfo.status === 1) {
                    res.push({ line: [start, end], point: intersectPointInfo.point });
                }
            }
        });
        return res;
    }
    BoolOperation._straightLineIntersectPolygon2d = _straightLineIntersectPolygon2d;
})(BoolOperation || (BoolOperation = {}));
const _point3$4 = new Point();
const _matrix1 = new Matrix4$1();
const _matrix2 = new Matrix4$1();var GeoIntersection;
(function (GeoIntersection) {
    /**
    * 求直线段和平面的交点
    * @param line
    * @param plane
    * @param target 返回值
    * @returns
    */
    function LineIntersectPlane(line, plane, target = null) {
        if (target == null) {
            target = new Point();
        }
        const start = line.start;
        const end = line.end;
        const normal = plane.normal;
        const constant = plane.constant;
        const direction = end.clone().sub(start);
        // const direction = end.clone().sub(start).normalize();
        const denominator = normal.dot(direction); //TODO 可以考虑做成基本函数，判断共线和垂直
        if (Math.abs(denominator) < 1e-6) {
            // line is coplanar, return origin
            if (Math.abs(GeoMeasurement.PointDistanceToPlane(start, plane)) < 1e-6) {
                return target.copy(start);
            }
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(start.dot(normal) + constant) / denominator;
        if (t < -1e-6 || t > 1 + 1e-6) {
            return null;
        }
        return target.copy(direction).multiplyScalar(t).add(start);
    }
    GeoIntersection.LineIntersectPlane = LineIntersectPlane;
    /**
     * 两直线求交
     * @param aline
     * @param sline
     * @param target
     * @returns
     */
    function StraightLineIntersectStraightLine(aline, sline, target = null) {
        let t = LineIntersectLineParameter(aline.origin, aline.direction, sline.origin, sline.direction);
        if (t === null) {
            target = null;
            return null;
        }
        if (target == null) {
            target = new Point();
        }
        target.copy(aline.origin).add(aline.direction.clone().multiplyScalar(t));
        return target;
    }
    GeoIntersection.StraightLineIntersectStraightLine = StraightLineIntersectStraightLine;
    /**
     * 求b线与a线的交点在a线上的参数t
     * @param originP a线起点
     * @param pDir a线方向
     * @param originQ b线起点
     * @param qDir b线方向
     * @returns
     */
    function LineIntersectLineParameter(originP, pDir, originQ, qDir) {
        // https://www.cnblogs.com/xiangtingshen/p/12329951.html
        if (pDir.clone().cross(qDir).length() < 1e-6) {
            // 平行
            return null;
        }
        let AC = originQ.clone().sub(originP);
        if (!(Math.abs(qDir.clone().cross(pDir).normalize().dot(AC)) < 1e-6)) {
            // 不共面
            return null;
        }
        let sACD = AC.clone().cross(qDir); // AC X CD / 2 = sACD
        let sCED = pDir.clone().cross(qDir); // AB X CD / 2 = sCED
        let sign = Math.sign(sACD.dot(sCED));
        let t = sign * sACD.length() / sCED.length(); // t 为AO/AB
        return t;
    }
    GeoIntersection.LineIntersectLineParameter = LineIntersectLineParameter;
    /**
     * 两线交点
     * @param A
     * @param B
     * @param C
     * @param D
     * @returns
     */
    function LineSegmentIntersection(A, B, C, D) {
        // 计算方向向量
        const AB = B.clone().sub(A);
        const CD = D.clone().sub(C);
        const AC = C.clone().sub(A);
        const AD = D.clone().sub(A);
        // 判断是否平行
        const crossABCD = AB.clone().cross(CD);
        if (crossABCD.length() < 1e-6) {
            return null; // 平行
        }
        _ab.copy(AB).normalize();
        _ac.copy(AC).normalize();
        _ad.copy(AD).normalize();
        /**
         * 构造一个 3x3 矩阵并计算行列式，判断是否共面
         */
        const matrix = new Matrix3$1().set(_ab.x, _ac.x, _ad.x, _ab.y, _ac.y, _ad.y, _ab.z, _ac.z, _ad.z);
        /**
         * 若是线性相关，则共面，继续进行交点判断
         */
        if (Math.abs(matrix.determinant()) > 1e-3) {
            return null;
        }
        // 计算 t 和 s
        const crossACCD = AC.clone().cross(CD);
        const t = crossACCD.dot(crossABCD) / crossABCD.lengthSq();
        const crossACAB = AC.clone().cross(AB);
        const s = crossACAB.dot(crossABCD) / crossABCD.lengthSq();
        // 检查 t 和 s 是否在 [0, 1] 范围内
        if (t < -1e-6 || t > 1 + 1e-6 || s < -1e-6 || s > 1 + 1e-6) {
            return null; // 线段不相交
        }
        // 计算交点
        const intersection = A.clone().add(AB.multiplyScalar(t));
        return intersection;
    }
    GeoIntersection.LineSegmentIntersection = LineSegmentIntersection;
    /**
     * 求圆弧与线的交点
     * @param arc 圆弧
     * @param line 线段
     * @param clampToArc 交点是否限制在圆弧上
     * @param clampToLine 交点是否限制在线段上
     * @returns
     */
    function ArcIntersectLine(arc, line, clampToArc = false, clampToLine = true) {
        let pDir = line.getX();
        if (pDir.length() < 1e-6)
            return [];
        if (Math.abs(arc.radius) < 1e-6)
            return [];
        let denominator = arc.normal.dot(pDir.normalize());
        let plane = new Plane$1();
        plane.setFromNormalAndCoplanarPoint(arc.normal, arc.center);
        if (Math.abs(denominator) > 1e-3) {
            // 不共面
            let pointInPlane = PlaneIntersectLine(plane, line);
            // 线段与圆弧所在平面不相交
            if (pointInPlane == null)
                return [];
            let dist = pointInPlane.distanceTo(arc.center);
            // 线段的交点至圆弧圆心的距离不等于半径
            if (Math.abs(dist - arc.radius) > 1e-3)
                return [];
            if (clampToArc) {
                // 需要判断在圆弧上
                let s = arc.getPointParameter(pointInPlane);
                if (s < 0 || s > 1)
                    return [];
            }
            return [pointInPlane];
        }
        // 共面或者平行
        let lineDisCheck = GeoMeasurement.PointDistanceToPlane(line.getP(), plane);
        if (Math.abs(lineDisCheck) > 1e-2) {
            // 平行不共面
            return [];
        }
        // 共面
        let foot = GeoRelation.LineClosestPointToPoint(line, arc.center, false);
        let dist = foot.distanceTo(arc.center);
        if (dist > arc.radius) {
            // 无交点
            return [];
        }
        if (Math.abs(dist - arc.radius) < 1e-6) {
            // 相切
            let t = GeoRelation.LineClosestPointToPointParameter(line, foot, false);
            if (clampToLine) {
                //需要判断在线上
                if (t > 1 || t < 0)
                    return [];
            }
            if (clampToArc) {
                // 需要判断在圆弧上
                let s = arc.getPointParameter(foot);
                if (s < 0 || s > 1)
                    return [];
            }
            return [foot];
        }
        // 相交 两个交点
        let len = Math.sqrt(arc.radius ** 2 - dist ** 2);
        let res = [];
        let point1 = foot.clone().sub(pDir.clone().multiplyScalar(len));
        let t1 = GeoRelation.LineClosestPointToPointParameter(line, point1, false);
        if ((t1 >= -1e-6 && t1 <= 1 + 1e-6) || !clampToLine) {
            let s = arc.getPointParameter(point1);
            if ((s >= -1e-6 && s <= 1 + 1e-6) || !clampToArc) {
                res.push(point1);
            }
        }
        let point2 = foot.clone().add(pDir.clone().multiplyScalar(len));
        let t2 = GeoRelation.LineClosestPointToPointParameter(line, point2, false);
        if ((t2 >= -1e-6 && t2 <= 1 + 1e-6) || !clampToLine) {
            let s = arc.getPointParameter(point2);
            if ((s >= -1e-6 && s <= 1 + 1e-6) || !clampToArc) {
                res.push(point2);
            }
        }
        return res;
    }
    GeoIntersection.ArcIntersectLine = ArcIntersectLine;
    /**
     * 平面与线段的交点
     * @param plane 平面
     * @param line 线段
     * @param target
     */
    function PlaneIntersectLine(plane, line, target = null) {
        if (target == null) {
            target = new Point();
        }
        let start = line.start;
        let end = line.end;
        const direction = end.clone().sub(start);
        const denominator = plane.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (GeoMeasurement.PointDistanceToPlane(start, plane) === 0) {
                return target.copy(start);
            }
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(start.dot(plane.normal) + plane.constant) / denominator;
        if (t < -1e-6 || t > 1 + 1e-6) {
            return null;
        }
        return target.copy(direction).multiplyScalar(t).add(start);
    }
    GeoIntersection.PlaneIntersectLine = PlaneIntersectLine;
    /**
     * 求两圆弧的交点
     * @param arcA
     * @param arcB
     * @param clampToA 交点是否限制在圆弧A上
     * @param clampToB 交点是否限制在圆弧B上
     * @returns
     */
    function ArcIntersectArc(arcA, arcB, clampToA = false, clampToB = false) {
        if (arcA.radius === 0 || arcB.radius === 0)
            return [];
        let checkDis = arcA.normal.cross(arcB.normal).length();
        if (checkDis < 1e-3) {
            // 圆弧面平行
            let centerDir = arcB.center.clone().sub(arcA.center).normalize();
            let checkDot = centerDir.dot(arcA.normal);
            if (Math.abs(checkDot) > 1e-3) {
                // 平行不共面
                return [];
            }
            // 平行共面
            let centerDist = arcB.center.distanceTo(arcA.center);
            if (centerDist < 1e-6) {
                // 两个圆弧的圆心重合
                return [];
            }
            if (centerDist > arcB.radius + arcA.radius) {
                // 相离
                return [];
            }
            if (centerDist === arcB.radius + arcA.radius || Math.abs(arcA.radius - arcB.radius) === centerDist) {
                // 外切或内切
                if (arcB.radius - arcA.radius === centerDist) {
                    // this内切于arc
                    centerDir.multiplyScalar(-1);
                }
                let target = centerDir.clone().multiplyScalar(arcA.radius).add(arcA.center);
                let s = arcB.getPointParameter(target);
                if (clampToB && (s < 0 || s > 1))
                    return []; // 不在arc圆弧上
                let t = arcA.getPointParameter(target);
                if (clampToA && (t < -1e-6 || t > 1 + 1e-6)) {
                    // 不在this圆弧上
                    return [];
                }
                return [target];
            }
            if (Math.abs(arcA.radius - arcB.radius) > centerDist) {
                // 内相离
                return [];
            }
            // 相交
            // 利用相交圆弧的勾股定理求出圆心连线和相交割线的交点
            let t = (arcA.radius * arcA.radius + centerDist * centerDist - arcB.radius * arcB.radius) / (2 * centerDist);
            let tPoint = centerDir.clone().multiplyScalar(t).add(arcA.center);
            let l_dir = arcA.normal.clone().cross(centerDir).normalize();
            let v_dist = Math.sqrt(arcA.radius * arcA.radius - t * t);
            let target1 = tPoint.clone().add(l_dir.clone().multiplyScalar(v_dist));
            let target2 = tPoint.clone().add(l_dir.clone().multiplyScalar(-v_dist));
            let res = [];
            let s1 = arcB.getPointParameter(target1);
            if ((s1 >= 0 && s1 <= 1) || !clampToB) {
                let t1 = arcA.getPointParameter(target1);
                if ((t1 >= 0 && t1 <= 1) || !clampToA) {
                    res.push(target1);
                }
            }
            let s2 = arcB.getPointParameter(target2);
            if ((s2 >= 0 && s2 <= 1) || !clampToB) {
                let t2 = arcA.getPointParameter(target2);
                if ((t2 >= 0 && t2 <= 1) || !clampToA) {
                    res.push(target2);
                }
            }
            return res;
        }
        // 不共面
        // 两个圆面交线的方向向量
        let dir = arcA.normal.clone().cross(arcB.normal).normalize();
        let arcPlane = new Plane$1();
        arcPlane.setFromNormalAndCoplanarPoint(arcB.normal, arcB.center);
        const centerDistToArcPlane = GeoMeasurement.PointDistanceToPlane(arcA.center, arcPlane);
        // this中一点到该交线作垂线，垂线的方向向量 乘dist为了保证方向朝着交线
        const l_dir1 = arcA.normal.clone().cross(dir).multiplyScalar(centerDistToArcPlane).normalize();
        const denominator1 = arcB.normal.dot(l_dir1);
        // this圆心到交线的最短距离
        const v_dist1 = Math.abs(centerDistToArcPlane / denominator1);
        let thisPlane = new Plane$1();
        thisPlane.setFromNormalAndCoplanarPoint(arcA.normal, arcA.center);
        const centerDistToThisPlane = GeoMeasurement.PointDistanceToPlane(arcB.center, thisPlane);
        // circle中一点到该交线作垂线，垂线的方向向量
        const l_dir2 = arcB.normal.clone().cross(dir).multiplyScalar(centerDistToThisPlane).normalize();
        const denominator2 = arcA.normal.dot(l_dir2);
        // circle圆心到交线的最短距离
        const v_dist2 = Math.abs(centerDistToThisPlane / denominator2);
        if (v_dist1 > arcA.radius || v_dist2 > arcB.radius) {
            // 相离
            return [];
        }
        // 交线上离this圆心最近的点
        const target = arcA.center.clone().add(l_dir1.multiplyScalar(v_dist1));
        if (Math.abs(v_dist1 - arcA.radius) < 1e-6) {
            // 相切
            // 切点不在arc圆弧上，不相交
            if (Math.abs(target.distanceTo(arcB.center) - arcB.radius) > 1e-6)
                return [];
            let s = arcB.getPointParameter(target);
            // 切点在arc圆周上，不在arc圆弧上，不相交
            if (clampToB) {
                if (s < 0 || s > 1)
                    return [];
            }
            if (clampToA) {
                let t = arcA.getPointParameter(target);
                // 切点在this的延长线上
                if (t < -1e-6 || t > 1 + 1e-6)
                    return [];
            }
            return [target];
        }
        // 该点target到圆弧与交线的交点之间的距离
        const i_dist = Math.sqrt(arcA.radius * arcA.radius - v_dist1 * v_dist1);
        let res = [];
        // 在交线上的圆弧上的两点
        const target1 = target.clone().add(dir.clone().multiplyScalar(i_dist));
        // 交点在另一个弧的半径上
        if (Math.abs(target1.distanceTo(arcB.center)) < 1e-6) {
            let s = arcB.getPointParameter(target1);
            if ((s >= 0 && s <= 1) || !clampToB) {
                let t = arcA.getPointParameter(target1);
                if ((t >= 0 && t <= 1) || !clampToA) {
                    res.push(target1);
                }
            }
        }
        const target2 = target.clone().add(dir.clone().multiplyScalar(-i_dist));
        if (Math.abs(target2.distanceTo(arcB.center)) < 1e-6) {
            let s = arcB.getPointParameter(target2);
            if ((s >= 0 && s <= 1) || !clampToB) {
                let t = arcA.getPointParameter(target2);
                if ((t >= 0 && t <= 1) || !clampToA) {
                    res.push(target2);
                }
            }
        }
        return res;
    }
    GeoIntersection.ArcIntersectArc = ArcIntersectArc;
    /**
     * 求圆弧与平面的交点
     * @param arc
     * @param plane
     * @param clampToArc 交点是否限制在圆弧上
     * @returns
     */
    function ArcIntersectPlane(arc, plane, clampToArc = false) {
        return GeoIntersection.PlaneIntersectArc(plane, arc, clampToArc);
    }
    GeoIntersection.ArcIntersectPlane = ArcIntersectPlane;
    /**
     * 求平面与圆弧交点
     * @param plane
     * @param arc
     * @param clampToArc 交点是否限制在圆弧上
     * @returns
     */
    function PlaneIntersectArc(plane, arc, clampToArc = false) {
        if (arc.radius === 0)
            return [];
        if (plane.normal.equals(arc.normal) || plane.normal.equals(arc.normal.clone().multiplyScalar(-1))) {
            // 圆弧与面平行
            return [];
        }
        // 不共面
        // 两个面交线的方向向量
        let dir = plane.normal.clone().cross(arc.normal).normalize();
        const centerDistToThisPlane = GeoMeasurement.PointDistanceToPlane(arc.center, plane);
        // arc圆心到该交线作垂线，垂线的方向向量，指向交线
        const l_dir2 = dir.clone().cross(arc.normal).multiplyScalar(centerDistToThisPlane).normalize();
        // arc圆心到交线的最短距离,利用距离沿平面法向投影等于圆心到平面距离
        const v_dist2 = Math.abs(centerDistToThisPlane / plane.normal.dot(l_dir2));
        if (v_dist2 > arc.radius) {
            // 相离
            return [];
        }
        // 交线上离this圆心最近的点
        const target = arc.center.clone().add(l_dir2.multiplyScalar(v_dist2));
        if (Math.abs(v_dist2 - arc.radius) < 1e-6) {
            // 相切
            // 切点不在arc圆弧上，不相交
            let s = arc.getPointParameter(target);
            if (s < 0 || s > 1 && clampToArc)
                return [];
            return [target];
        }
        // 该点target到圆弧与交线的交点之间的距离
        const i_dist = Math.sqrt(arc.radius * arc.radius - v_dist2 * v_dist2);
        let res = [];
        // 在交线上的圆弧上的两点
        const target1 = target.clone().add(dir.clone().multiplyScalar(i_dist));
        let s1 = arc.getPointParameter(target1);
        if ((s1 >= 0 && s1 <= 1) || !clampToArc)
            res.push(target1);
        const target2 = target.clone().add(dir.clone().multiplyScalar(-i_dist));
        let s2 = arc.getPointParameter(target2);
        if ((s2 >= 0 && s2 <= 1) || !clampToArc)
            res.push(target2);
        return res;
    }
    GeoIntersection.PlaneIntersectArc = PlaneIntersectArc;
    /**
     * 求圆弧与射线的交点
     * @param arc
     * @param ray
     * @param clampToArc
     * @returns
     */
    function ArcIntersectRay(arc, ray, clampToArc = false) {
        let arcPlane = new Plane$1();
        arcPlane.setFromNormalAndCoplanarPoint(arc.normal, arc.center);
        if (Math.abs(ray.direction.dot(arc.normal)) < 1e-6) {
            // 射线平行于圆弧面
            if (Math.abs(GeoMeasurement.PointDistanceToPlane(ray.origin, arcPlane)) > 1e-6) {
                // 平行不共面
                return [];
            }
            // 共面
            let closestPoint = GeoRelation.RayClosestPointToPoint(ray, arc.center);
            let dist = closestPoint.distanceTo(arc.center);
            if (dist > arc.radius) {
                // 无交点
                return [];
            }
            if (Math.abs(dist - arc.radius) < 1e-6) {
                // 相切
                let t = arc.getPointParameter(closestPoint);
                if (clampToArc && (t < -1e-6 || t > 1 + 1e-6)) {
                    // 不在this圆弧上
                    return [];
                }
                return [closestPoint];
            }
            // 相交 两个交点
            let len = Math.sqrt(arc.radius ** 2 - dist ** 2);
            let res = [];
            let point1 = closestPoint.clone().sub(ray.direction.clone().multiplyScalar(len));
            let dir1 = point1.clone().sub(ray.origin);
            let directionDistance1 = dir1.dot(ray.direction);
            if (directionDistance1 > 0) {
                // 需要判断点在圆弧上
                let t = arc.getPointParameter(point1);
                if ((t >= 0 && t <= 1) || !clampToArc) {
                    res.push(point1);
                }
            }
            let point2 = closestPoint.clone().add(ray.direction.clone().multiplyScalar(len));
            let dir2 = point2.clone().sub(ray.origin);
            let directionDistance2 = dir2.dot(ray.direction);
            if (directionDistance2 > 0) {
                // 需要判断点在圆弧上
                let t = arc.getPointParameter(point2);
                if ((t >= 0 && t <= 1) || !clampToArc) {
                    res.push(point2);
                }
            }
            return res;
        }
        // 不共面
        let target = GeoIntersection.RayIntersectPlane(ray, arcPlane);
        if (!target) {
            return [];
        }
        if (Math.abs(target.distanceTo(arc.center) - arc.radius) > 1e-6) {
            // 无命中
            return [];
        }
        let t = arc.getPointParameter(target);
        if (t < -1e-6 || t > 1 + 1e-6)
            return [];
        return [target];
    }
    GeoIntersection.ArcIntersectRay = ArcIntersectRay;
    /**
     * 求射线与平面的交点
     * @param ray
     * @param plane
     * @param target
     * @returns
     */
    function RayIntersectPlane(ray, plane, target = null) {
        const t = GeoMeasurement.RayOriginDistanceToPlane(ray, plane);
        if (t === null) {
            return null;
        }
        return ray.getPointAt(t, target);
    }
    GeoIntersection.RayIntersectPlane = RayIntersectPlane;
    /**
     * 求圆弧与线的延长线上的交点（不在线上）
     * @param arc
     * @param line
     * @returns
     */
    function ArcIntersectExtendLine(arc, line) {
        let intersectPoints = [];
        let points = GeoIntersection.ArcIntersectLine(arc, line);
        points.forEach((point) => {
            let t = arc.getPointParameter(point);
            if (t < -1e-6 || t > 1 + 1e-6) {
                intersectPoints.push(point);
            }
        });
        return intersectPoints;
    }
    GeoIntersection.ArcIntersectExtendLine = ArcIntersectExtendLine;
    /**
     * 求圆弧A与圆弧B的延长线上的交点（不在A,B上）
     * @param arcA
     * @param arcB
     * @returns
     */
    function ArcIntersectExtendArc(arcA, arcB) {
        let intersectPoints = [];
        let points = GeoIntersection.ArcIntersectArc(arcA, arcB);
        points.forEach((point) => {
            let t = arcA.getPointParameter(point);
            if (t < -1e-6 || t > 1 + 1e-6) {
                intersectPoints.push(point);
            }
        });
        return intersectPoints;
    }
    GeoIntersection.ArcIntersectExtendArc = ArcIntersectExtendArc;
    /**
     * 线段P和Q的交点，若clampToLine = false且共面，可返回P的延长线和Q的交点
     * @param q1
     * @param q2
     * @param clampToLine
     * @param clampToLineQ
     * @returns
     */
    function LineIntersectSegment(line, q1, q2, clampToLine = false, clampToLineQ = true) {
        let t = GeoIntersection.LineIntersectSegmentParameter(line, q1, q2, clampToLine);
        let p1 = line.start; // A
        let p2 = line.end;
        let pDir = p2.clone().sub(p1); // B
        let target = p1.clone().add(pDir.multiplyScalar(t));
        let targetInQ = Math.abs((target.distanceTo(q1) + target.distanceTo(q2) - q2.distanceTo(q1))) < 1e-6;
        if (!targetInQ && clampToLineQ)
            return null;
        return target;
    }
    GeoIntersection.LineIntersectSegment = LineIntersectSegment;
    /**
     * 求一条线段l的与一条由q1与q2组成的线段的交点参数 t
     * @param line 线段l
     * @param q1 第二条线段的端点
     * @param q2 第二条线段的端点
     * @param clampToLine1 交点是否限制在line上
     * @param clampToLine2 交点是否限制在由q1与q2组成的线段上
     * @returns
     */
    function LineIntersectSegmentParameter(line, q1, q2, clampToLine1 = false, clampToLine2 = true) {
        // https://www.cnblogs.com/xiangtingshen/p/12329951.html
        let p1 = line.start; // A
        let p2 = line.end; // B
        let pDir = p2.clone().sub(p1); //AB
        let qDir = q2.clone().sub(q1); //CD
        let pqCross = pDir.clone().cross(qDir);
        if (Math.abs(pqCross.lengthSq()) < 1e-6) {
            // 平行
            return null;
        }
        let AC = q1.clone().sub(p1);
        if (!(Math.abs(pqCross.clone().normalize().dot(AC.clone().normalize())) < 1e-6)) {
            // 不共面,如果共面，ABCD的法向量方向相同，AB和CD叉积与
            return null;
        }
        let sACD = AC.clone().cross(qDir); // AC X CD / 2 = sACD // AB X CD / 2 = sCED
        let sign = Math.sign(sACD.dot(pqCross));
        let t = sign * sACD.length() / pqCross.length(); // t 为AO/AB
        if ((t < -1e-6 || t > 1 + 1e-6) && clampToLine1) {
            // 交点不在线段内
            return null;
        }
        if (clampToLine2) {
            // 计算交点 P
            const intersection = p1.clone().add(pDir.multiplyScalar(t));
            // 检查交点是否在线段 CD 上
            const cdLength = q2.clone().sub(q1).length(); // CD 的长度
            const d1 = intersection.clone().sub(q1).length(); // P 到 C 的距离
            const d2 = intersection.clone().sub(q2).length(); // P 到 D 的距离
            if (Math.abs(d1 + d2 - cdLength) > 1e-6) {
                return null; // 交点不在线段 CD 上
            }
        }
        return t;
    }
    GeoIntersection.LineIntersectSegmentParameter = LineIntersectSegmentParameter;
    const _startP = /*@__PURE__*/ new Vector3$1();
    const _startEnd = /*@__PURE__*/ new Vector3$1();
    /**
     * 求直线上距离点最近的点 在直线上的t值
     * @param line
     * @param point
     * @param clampToLine
     * @returns
     */
    function closestPointToLineParameter(line, point, clampToLine = false) {
        if (point == null)
            return null;
        _startP.subVectors(point, line.start);
        _startEnd.subVectors(line.end, line.start);
        const startEnd2 = _startEnd.dot(_startEnd);
        const startEnd_startP = _startEnd.dot(_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) {
            t = BaseUtils.clamp(t, 0, 1);
        }
        return t;
    }
    GeoIntersection.closestPointToLineParameter = closestPointToLineParameter;
    const _plane = new Plane$1();
    const _pDir = new Vector3$1();
    /**
     * 已知圆弧上一点坐标，求其相对起点的比例t值
     * @param arc
     * @param point
     * @param clamp
     * @returns
     */
    function PointToArcParameter(arc, point, clamp = false) {
        if (point == null)
            return null;
        if (Math.abs(arc.angle) < 1e-5)
            return 0;
        const center = arc.center;
        const normal = arc.normal;
        let distToCenter = point.distanceTo(center);
        if (Math.abs(distToCenter - arc.radius) > 1e-5) {
            return null;
        }
        _plane.setFromNormalAndCoplanarPoint(normal, center);
        let distToPlane = GeoMeasurement.PointDistanceToPlane(point, _plane);
        if (Math.abs(distToPlane) > 1e-5) {
            return null;
        }
        _pDir.subVectors(point, center);
        let axisX = arc.getNormalizeX();
        let angle = _pDir.angleTo(axisX);
        let value = axisX.cross(_pDir).angleTo(normal);
        if (value > Math.PI / 2) {
            angle = Math.PI * 2 - angle;
        }
        let t = angle / arc.angle;
        if (clamp) {
            t = BaseUtils.clamp(t, 0, 1);
        }
        return t;
    }
    GeoIntersection.PointToArcParameter = PointToArcParameter;
    /**
     * 求直线与线段的交点
     * @param sline
     * @param line
     * @param target
     * @returns
     */
    function StraightLineIntersectLine(sline, line, target = null) {
        if (target == null) {
            target = new Point();
        }
        let t = GeoIntersection.StraightLineIntersectLineParameter(sline, line.start, line.getX());
        target.copy(sline.origin).add(sline.direction.clone().multiplyScalar(t));
        let q1 = line.start;
        let q2 = line.end;
        let targetInQ = Math.abs((target.distanceTo(q1) + target.distanceTo(q2) - q2.distanceTo(q1))) < 1e-6;
        if (!targetInQ)
            return null;
        return target;
    }
    GeoIntersection.StraightLineIntersectLine = StraightLineIntersectLine;
    /**
     * 求线与直线的交点
     * @param line
     * @param sline
     * @param target
     * @returns
     */
    function LineIntersectStraightLine(line, sline, target = null) {
        if (target == null) {
            target = new Point();
        }
        return GeoIntersection.StraightLineIntersectLine(sline, line, target);
    }
    GeoIntersection.LineIntersectStraightLine = LineIntersectStraightLine;
    /**
     * 求直线与线段的交点在直线上的参数t
     * @param sline
     * @param originQ
     * @param qDir
     * @returns
     */
    function StraightLineIntersectLineParameter(sline, originQ, qDir) {
        // https://www.cnblogs.com/xiangtingshen/p/12329951.html
        let originP = sline.origin; // A
        let pDir = sline.direction; //AB
        if (pDir.clone().cross(qDir).length() < 1e-6) {
            // 平行
            return null;
        }
        let AC = originQ.clone().sub(originP);
        if (!(Math.abs(qDir.clone().cross(pDir).normalize().dot(AC)) < 1e-6)) {
            // 不共面
            return null;
        }
        let sACD = AC.clone().cross(qDir); // AC X CD / 2 = sACD
        let sCED = pDir.clone().cross(qDir); // AB X CD / 2 = sCED
        let sign = Math.sign(sACD.dot(sCED));
        let t = sign * sACD.length() / sCED.length(); // t 为AO/AB
        return t;
    }
    GeoIntersection.StraightLineIntersectLineParameter = StraightLineIntersectLineParameter;
    /**
     * 平面与直线求交
     * @param plane
     * @param origin
     * @param direction
     * @param target
     * @returns
     */
    function PlaneIntersectStraightLine(plane, origin, direction, target = null) {
        if (target === undefined) {
            target = new Point();
        }
        const denominator = plane.normal.dot(direction);
        if (Math.abs(denominator) < 1e-6) {
            // line is coplanar, return origin
            if (GeoMeasurement.PointDistanceToPlane(origin, plane) === 0) {
                return target.copy(origin);
            }
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(origin.dot(plane.normal) + plane.constant) / denominator;
        return target.copy(direction).multiplyScalar(t).add(origin);
    }
    GeoIntersection.PlaneIntersectStraightLine = PlaneIntersectStraightLine;
    /**
     *  求直线与线段的交点。返回值status变量含义：
     *  0：平行，无交点；
     *  1：有交点；
     *  2：有交点，但不在线段内部；
     *  3：segment长度为0，认为没有交点
     *  4：线段与直线重合，这种情况也认为没有交点。
     *  返回值t为交点在线段segment上的定比分点值
     * @param line 直线
     * @param segment 线段
     */
    function straightLine2IntersectLine2(line, segment) {
        if (segment[0].equals(segment[1])) {
            return { status: 3, point: null, t: null };
        }
        // 计算直线方向向量
        _dirLine.subVectors(line[1], line[0]);
        _dirSegment.subVectors(segment[1], segment[0]);
        // 计算行列式 (cross product)
        const determinant = _dirLine.x * _dirSegment.y - _dirLine.y * _dirSegment.x;
        if (Math.abs(determinant) < EPSILON) { //平行或重合
            // 检查是否重合
            _toSegmentStart.subVectors(segment[0], line[0]);
            const crossProduct = _toSegmentStart.x * _dirLine.y - _toSegmentStart.y * _dirLine.x;
            if (Math.abs(crossProduct) < Number.EPSILON) { //重合
                return { status: 4, point: null, t: null };
            }
            return { status: 0, point: null, t: null };
        }
        _toSegmentStart.subVectors(segment[0], line[0]);
        const t1 = (_toSegmentStart.x * _dirSegment.y - _toSegmentStart.y * _dirSegment.x) / determinant;
        const t2 = (_toSegmentStart.x * _dirLine.y - _toSegmentStart.y * _dirLine.x) / determinant;
        // 交点的坐标
        const intersection = new Point2(line[0].x + t1 * _dirLine.x, line[0].y + t1 * _dirLine.y);
        // 判断交点是否在线段内部
        if (t2 >= 0 && t2 <= 1) {
            return { status: 1, point: intersection, t: t2 }; // 有交点且在线段内部
        }
        return { status: 2, point: intersection, t: t2 }; // 有交点但不在线段内部
    }
    GeoIntersection.straightLine2IntersectLine2 = straightLine2IntersectLine2;
    /**
     * 算法4-54PolygonAnyIntersectPlane
     * 返回值第二个数表示状态。
     * 0多边形所在平面与平面平行
     * 1多边形所在平面与平面正常相交
     * 2多边形所在平面与平面重合
     */
    function polygonIntersectPlane(polygon, plane, intersectLine = null, needOn = false) {
        let intersectLineInfo = planeIntersectPlane(polygon, plane);
        if (intersectLineInfo.status === 0 || intersectLineInfo.status === 2) {
            return { status: intersectLineInfo.status, lines: [], onlyOn: false };
        }
        else {
            if (!!intersectLine) {
                intersectLine.copy(intersectLineInfo.line);
            }
            _matrix.copy(polygon.transformMatrix).invert();
            intersectLineInfo.line.getP(_point1);
            intersectLineInfo.line.getX(_point2).add(_point1);
            _point1.applyMatrix4(_matrix);
            _point2.applyMatrix4(_matrix);
            // console.log("_point1", _point1.x, _point1.y);
            // console.log("_point2", _point2.x, _point2.y)
            let resForStraightLineInOnPol = generateInOnForStraightLine([new Point2(_point1.x, _point1.y), new Point2(_point2.x, _point2.y)], polygon.clone());
            if (needOn) {
                return { status: intersectLineInfo.status, lines: [...resForStraightLineInOnPol.in, ...resForStraightLineInOnPol.on], onlyOn: resForStraightLineInOnPol.in.length === 0 };
            }
            else {
                return { status: intersectLineInfo.status, lines: [...resForStraightLineInOnPol.in], onlyOn: resForStraightLineInOnPol.in.length === 0 };
            }
        }
    }
    GeoIntersection.polygonIntersectPlane = polygonIntersectPlane;
    const _point1 = new Point();
    const _point2 = new Point();
    const _matrix = new Matrix4$1();
    /**
     * 算法4-11平面求交线
     * 返回值第二个数表示状态。
     * 0平面平行
     * 1平面正常相交
     * 2平面重合
     */
    function planeIntersectPlane(p1, p2) {
        const normal1 = p1.normal;
        const a1 = normal1.x;
        const b1 = normal1.y;
        const c1 = normal1.z;
        const d1 = p1.constant;
        const normal2 = p2.normal;
        const a2 = normal2.x;
        const b2 = normal2.y;
        const c2 = normal2.z;
        const d2 = p2.constant;
        const n = p1.normal.clone().cross(p2.normal);
        const nLength = n.lengthSq();
        if (nLength < EPSILON) {
            // 平行或重合
            let point = p2.getP();
            if (Math.abs(a1 * point.x + b1 * point.y + c1 * point.z + d1) < EPSILON) {
                // 如果平面2上的点在平面1上，则重合
                return { line: null, status: 2 };
            }
            return { line: null, status: 0 };
        }
        const delta1 = a1 * b2 - a2 * b1;
        if (Math.abs(delta1) > EPSILON) {
            const x = (-d1 * b2 + d2 * b1) / delta1;
            const y = (-a1 * d2 + a2 * d1) / delta1;
            const z = 0;
            return { line: new StraightLine(new Point(x, y, z), n), status: 1 };
        }
        const delta2 = b1 * c2 - b2 * c1;
        if (Math.abs(delta2) > EPSILON) {
            const x = 0;
            const y = (-d1 * c2 + d2 * c1) / delta2;
            const z = (-b1 * d2 + b2 * d1) / delta2;
            return { line: new StraightLine(new Point(x, y, z), n), status: 1 };
        }
        const delta3 = a1 * c2 - a2 * c1;
        const x = (-d1 * c2 + d2 * c1) / delta3;
        const y = 0;
        const z = (-a1 * d2 + a2 * d1) / delta3;
        return { line: new StraightLine(new Point(x, y, z), n), status: 1 };
    }
    GeoIntersection.planeIntersectPlane = planeIntersectPlane;
    /**
     * 获取下一点的索引，如果current是最后一个节点，则返回第一个点
     * @param current 当前索引
     * @param length 数组长度
     * @returns
     */
    function getNextIndex(current, length) {
        return current === length - 1 ? 0 : current + 1;
    }
    /**
     * 求得一条直线在另一个多边形内部与边界部分，默认共面
     * @param a
     * @param b
     * @returns
     */
    function generateInOnForStraightLine(line2, b) {
        let res = { in: [], on: [] };
        let onInterval = new ClosedInterval([]); //a_on_b的所有部分在a上的定比分点值所组成的区间
        b.rings.forEach(ring => {
            for (let pointIndex = 0; pointIndex < ring.length; pointIndex++) {
                //******算法起始：判断两直线是否共线******
                let start = ring[pointIndex];
                let end = ring[getNextIndex(pointIndex, ring.length)];
                if (start.equals(end)) {
                    continue;
                }
                let A = line2[0].y - line2[1].y;
                let B = line2[1].x - line2[0].x;
                let C = line2[0].x * line2[1].y - line2[1].x * line2[0].y;
                let length = Math.sqrt(A * A + B * B);
                // console.log("A", A, "B", B, "C", C, "length", length, "eee", A * start.x + B * start.y + C, A * end.x + B * end.y + C);
                if (Math.abs(A * start.x + B * start.y + C) / length < EPSILON && Math.abs(A * end.x + B * end.y + C) / length < EPSILON) {
                    //共线
                    let startRatio = GeoRelation.ratioToLine2(start, line2[0], line2[1]);
                    let endRatio = GeoRelation.ratioToLine2(end, line2[0], line2[1]);
                    let tmpClosedInterval = BoolOperation.boolOperation1D(new ClosedInterval([[startRatio, endRatio]]), new ClosedInterval([[0, 1]]), BoolOpeType.INTERSECT);
                    onInterval = BoolOperation.boolOperation1D(onInterval, tmpClosedInterval, BoolOpeType.UNION);
                }
                //******算法结束：判断两直线是否共线******
            }
        });
        let line2Dir = { x: line2[1].x - line2[0].x, y: line2[1].y - line2[0].y };
        onInterval.getData().forEach(data => {
            res.on.push([
                new Point(line2[0].x + data[0] * line2Dir.x, line2[0].y + data[0] * line2Dir.y, 0).applyMatrix4(b.transformMatrix),
                new Point(line2[0].x + data[1] * line2Dir.x, line2[0].y + data[1] * line2Dir.y, 0).applyMatrix4(b.transformMatrix)
            ]);
        });
        let intersectionPointsWithLine = BoolOperation._straightLineIntersectPolygon2d(line2, b);
        if (intersectionPointsWithLine.length <= 1) {
            //如果没有交点，那么整条a都是位于多边形b的外侧的，如果只有一个交点也是（但实际中，这种情况不可能存在）
            return res;
        }
        let intersectionPointInfos = [];
        intersectionPointsWithLine.forEach(item => {
            intersectionPointInfos.push({
                line: item.line,
                point: item.point,
                t: GeoRelation.ratioToLine2(item.point, line2[0], line2[1])
            });
        });
        intersectionPointInfos.sort((c, d) => c.t - d.t);
        let totalInterval = new ClosedInterval([[intersectionPointInfos[0].t, intersectionPointInfos[1].t]]);
        for (let i = 1; i < intersectionPointInfos.length - 1; i++) {
            totalInterval = BoolOperation.boolOperation1D(totalInterval, new ClosedInterval([[intersectionPointInfos[i].t, intersectionPointInfos[i + 1].t]]), BoolOpeType.UNION);
        }
        let otherInterval = BoolOperation.boolOperation1D(totalInterval, onInterval, BoolOpeType.SUBSTRACT);
        otherInterval.getData().forEach(data => {
            let t = (data[0] + data[1]) / 2;
            let midpoint = new Point2(line2[0].x + t * line2Dir.x, line2[0].y + t * line2Dir.y);
            if (GeoRelation.Point2InGeneralRegion(b, midpoint) === GeoRelation.PointInRegion.out) {
                let startpoint = new Point(line2[0].x + data[0] * line2Dir.x, line2[0].y + data[0] * line2Dir.y).applyMatrix4(b.transformMatrix);
                let endpoint = new Point(line2[0].x + data[1] * line2Dir.x, line2[0].y + data[1] * line2Dir.y).applyMatrix4(b.transformMatrix);
                res.in.push([startpoint, endpoint]);
            }
        });
        return res;
    }
    GeoIntersection.generateInOnForStraightLine = generateInOnForStraightLine;
})(GeoIntersection || (GeoIntersection = {}));
// 计算直线方向向量
const _dirLine = new Point2();
const _dirSegment = new Point2();
const _toSegmentStart = new Point2();
const _ab = new Vector3$1();
const _ac = new Vector3$1();
const _ad = new Vector3$1();/**
 * 圆弧
 * 其局部坐标系定义为半径为1，起点在x轴的逆时针的标准圆弧
 */
class Arc extends Curve {
    /**
     * 圆心
     */
    get center() {
        return this.getP();
    }
    /**
     * 设置圆心
     */
    set center(value) {
        this.setP(value);
    }
    /**
     * 法向量
     */
    get normal() {
        return this.getNormalizeZ();
    }
    /**
     * 半径
     */
    get radius() {
        return this.scaleX;
    }
    /**
     * 设置半径
     */
    set radius(value) {
        let scale = value / this.scaleX;
        if (scale == 0)
            scale = 1;
        this.scale(this.getP(), scale);
    }
    /**
     * 构造函数
     * @param center 圆心
     * @param radius 半径
     * @param endAngle 终止角度
     * @param normal 法向量
     * @param axisX 局部坐标系x轴
     */
    constructor(center = new Point(), radius = 1, angle = Math.PI, normal = new Vector3$1(0, 0, 1), axisX = new Vector3$1(1, 0, 0)) {
        super();
        /**
         * 类型
         */
        this.type = 'Arc';
        this.transformMatrix.elements[8] = normal.x;
        this.transformMatrix.elements[9] = normal.y;
        this.transformMatrix.elements[10] = normal.z;
        axisX.normalize();
        this.updateMatrixByX(axisX, false);
        if (radius <= 0)
            radius = 1;
        this.radius = radius;
        this.center = center;
        while (angle > 2 * Math.PI || angle < 0) {
            if (angle > 2 * Math.PI)
                angle -= 2 * Math.PI;
            if (angle < 0)
                angle += 2 * Math.PI;
        }
        this.angle = angle;
    }
    /**
     * 设置属性
     * @param key
     * @param value
     * @returns
     */
    set(key, value) {
        if (key == "center") {
            if (!(value instanceof Point))
                return;
            this.center = value;
        }
        else if (key == "radius") {
            if (typeof value !== 'number')
                return;
            this.radius = value;
        }
        else if (key == "angle") {
            if (typeof value !== 'number')
                return;
            let angle = value;
            while (angle > 2 * Math.PI || angle < 0) {
                if (angle > 2 * Math.PI)
                    angle -= 2 * Math.PI;
                if (angle < 0)
                    angle += 2 * Math.PI;
            }
            this.angle = angle;
        }
    }
    /**
     * 两点和圆心确定圆弧，点都是在同一平面下，适用于圆弧已经定好后更改起点终点和圆心
     * @param start
     * @param end
     * @param center
     * @param normal 参考法向量，用于判断圆弧的方向
     */
    setFromTwoPointAndCenter(start, end, center, normal) {
        const radius = center.distanceTo(start);
        if (radius <= 1e-6)
            return false;
        this.center = center; // 设置圆心
        if (_vec2$2.copy(end).sub(center).length() < 1e-6) {
            // 终点和圆心重合
            end = start.clone();
        }
        if (start.distanceTo(end) < 1e-6) {
            // 起点等于终点，约定角度为2Pi
            this.angle = 0;
            _vec1.copy(start).sub(center).normalize();
            this.setXYZ(_vec1, normal);
            this.radius = radius;
            return true;
        }
        _vec1.copy(start).sub(center).normalize(); // center到start连线的方向向量
        _vec2$2.copy(end).sub(center).normalize(); // center到end连线的方向向量
        this.angle = _vec2$2.angleTo(_vec1);
        let _normal = _vec1.clone().cross(_vec2$2).normalize(); // 计算法向量
        if (_normal.dot(normal) < 0) {
            // 方向不一致，圆心角大于180° 需要倒转法向量
            _normal.multiplyScalar(-1);
            this.angle = Math.PI * 2 - this.angle;
        }
        this.setXYZ(_vec1, _normal); // 设置局部坐标系
        this.radius = radius;
        return true;
    }
    /**
     * 三点确定圆弧
     * @param start
     * @param mid
     * @param end
     */
    setByThreePoint(start, mid, end) {
        // start到mid连线的方向向量
        _startToMid.copy(mid).sub(start).normalize();
        if (_startToMid.length() < 1e-6)
            return;
        // mid到end连线的方向向量
        _midToEnd.copy(end).sub(mid).normalize();
        if (_midToEnd.length() < 1e-6)
            return;
        // 法向量
        _normal$2.copy(_startToMid).cross(_midToEnd).normalize();
        // start和mid连线的中点
        _point1$5.copy(start).add(mid).multiplyScalar(0.5);
        // mid和end连线的中点
        _point2$6.copy(end).add(mid).multiplyScalar(0.5);
        // start和mid连线的中垂线
        _plumbLine1.setFromDirection(_point1$5, _normal$2.clone().cross(_startToMid));
        // mid和end连线的中垂线
        _plumbLine2.setFromDirection(_point2$6, _normal$2.clone().cross(_midToEnd));
        // 中垂线交点为圆心
        let center = GeoIntersection.StraightLineIntersectStraightLine(_plumbLine1, _plumbLine2);
        if (center == null)
            return;
        let radius = center.distanceTo(start);
        if (radius < 1e-6)
            radius = 1e-5;
        _vec1.copy(start).sub(center).normalize(); // center到start连线的方向向量 x轴
        _vec2$2.copy(end).sub(center).normalize(); // center到end连线的方向向量
        _vec3$2.copy(mid).sub(center).normalize(); // center到mid连线的方向向量
        // 计算圆心角
        let angle = _vec2$2.angleTo(_vec1);
        let tmpAngle = _startToMid.angleTo(_midToEnd); // 计算这个夹角，防止cross平行判断
        if (tmpAngle > Math.PI / 2) {
            // 如果夹角大于90度 说明是大角圆弧
            angle = Math.PI * 2 - angle;
        }
        // _vec4.crossVectors(_vec1, _vec3); // 起点到中点
        // _vec5.crossVectors(_vec2, _vec3); // 端点到中点
        // if (_vec4.dot(_vec5) < 0) {
        //     angle = Math.PI * 2 - angle;
        // }
        // 设置圆弧
        this.setXYZ(_vec1, _normal$2);
        this.center = center;
        this.radius = radius;
        this.angle = angle;
    }
    /**
     * 两点加半径设置圆弧
     * @param start 起点
     * @param end 端点
     * @param radius 半径
     * @param normal
     * @returns true表示可以构成圆弧、false表示无法构成
     */
    setByTwoPointAndRadius(start, end, radius, normal) {
        let dist = start.distanceTo(end);
        if (dist > 2 * radius) {
            return false;
        }
        // 起点到端点
        _vec1.subVectors(end, start).normalize();
        // 起点到端点连线中点
        _vec2$2.addVectors(start, end).multiplyScalar(0.5);
        // 圆心到连线中点的垂直距离
        let halfChordDist = dist / 2;
        let h = Math.sqrt(radius ** 2 - halfChordDist ** 2);
        // 起点到端点连线的中垂线方向向量
        let plumbLineDir = normal.clone().cross(_vec1).normalize();
        // 判断顺时针或逆时针
        let towardCenter = plumbLineDir.clone();
        // 圆心的位置
        let center = towardCenter.multiplyScalar(h).add(_vec2$2);
        this.setFromTwoPointAndCenter(start, end, center, normal);
        return true;
    }
    /**
     * 两点和矢高定义圆弧
     * @param startPoint
     * @param endPoint
     * @param h
     */
    setByEndPointChordHeight(startPoint, endPoint, h, normal) {
        // 起点到端点的距离
        let dist = startPoint.distanceTo(endPoint);
        if (dist < 1e-6)
            return;
        // 圆弧半径
        let radius = ((dist * 0.5) ** 2 + h ** 2) / (2 * h);
        if (radius < 1e-6)
            return;
        // 起点到端点连线的单位向量
        let dir = _vec1.copy(endPoint).sub(startPoint).normalize();
        // 起点到端点连线的中点
        let pHalf = _point$b.copy(startPoint).add(endPoint).multiplyScalar(0.5);
        // 起点到端点连线的中垂线的方向向量（指向圆心）
        let towardCenter = _vec2$2.copy(normal).cross(dir).normalize();
        if (h > radius) {
            towardCenter.negate();
        }
        // 圆弧圆心
        let center = towardCenter.multiplyScalar(Math.abs(radius - h)).add(pHalf);
        // 圆心角
        let angle = _point1$5.copy(startPoint).sub(center).angleTo(_point2$6.copy(endPoint).sub(center));
        if (_point1$5.cross(_point2$6).dot(normal) < 0) {
            angle = Math.PI * 2 - angle;
        }
        _point1$5.copy(startPoint).sub(center);
        this.setXYZ(_point1$5, normal);
        this.center = center;
        this.radius = radius;
        this.angle = angle;
    }
    /**
     * 获得弧线上某一点切线的方向向量
     * @param point
     * @returns
     */
    getCutLineDir(point, target) {
        if (target == null) {
            target = new Vector3$1();
        }
        this.getNormalizeZ(target);
        _p$1$1.subVectors(point, this.center);
        return target.cross(_p$1$1).normalize();
    }
    /**
     * 计算象限点
     * @returns
     */
    getQuadrantPoints() {
        let quadrantPoints = [];
        let x_dir = this.getX();
        let y_dir = this.getY();
        let point1 = this.center.add(x_dir);
        let point2 = this.center.add(y_dir);
        let point3 = this.center.sub(x_dir);
        let point4 = this.center.sub(y_dir);
        let t1 = this.getPointParameter(point1);
        let t2 = this.getPointParameter(point2);
        let t3 = this.getPointParameter(point3);
        let t4 = this.getPointParameter(point4);
        if (t1 >= 0 && t1 <= 1) {
            quadrantPoints.push(point1);
        }
        if (t2 >= 0 && t2 <= 1) {
            quadrantPoints.push(point2);
        }
        if (t3 >= 0 && t3 <= 1) {
            quadrantPoints.push(point3);
        }
        if (t4 >= 0 && t4 <= 1) {
            quadrantPoints.push(point4);
        }
        return quadrantPoints;
    }
    /**
     * 计算插值点
     * @param t 0-1
     * @param target
     * @returns
     */
    getPointAt(t, target = null) {
        if (target == null) {
            target = new Point();
        }
        // let deltaAngle = this.getDeltaAngle(this.endAngle);
        const angle = t * this.angle;
        let x = Math.cos(angle);
        let y = Math.sin(angle);
        target.set(x, y, 0).applyMatrix4(this.transformMatrix);
        return target;
    }
    /**
     * 获取圆弧上的点
     * @param division
     * @returns
     */
    getPoints(division) {
        let points = [];
        for (let d = 0; d <= division; d++) {
            points.push(this.getPointAt(d / division));
        }
        return points;
    }
    /**
     * 计算一个点在圆弧（圆周）上到起点的角度占总角度的比例
     * @param point
     * @returns t 0-1
     */
    getPointParameter(point) {
        // 将点变换到局部坐标系下
        let p = point.clone().applyMatrix4(this.transformMatrix.clone().invert());
        // 判断点是否在圆周上
        if (Math.abs(p.z) > 1e-6)
            return null;
        if (Math.abs(p.length() - 1) > 1e-6)
            return null;
        // 计算比例
        let theta = Math.acos(p.x);
        if (p.y < 0)
            theta = Math.PI * 2 - theta;
        let t = theta / this.angle;
        return t;
    }
    /**
     * 获取中心点
     * @param target 用以防止对象重复创建
     */
    getCenter(target) {
        if (target == null) {
            target = new Point();
        }
        this.getPointAt(0.5, target); //弧中点
        return target;
    }
    /**
     * 计算圆弧的凸度
     * @returns
     */
    getBulge() {
        return Math.tan(this.angle / 4);
    }
    /**
     * 获取曲线长度
     * @returns
     */
    getPerimeter() {
        return this.radius * Math.abs(this.angle);
    }
    /**
     * 克隆
     * @returns
     */
    clone() {
        return new Arc().copy(this);
    }
    /**
     * 复制
     * @param arc
     * @returns
     */
    copy(arc) {
        super.copy(arc);
        this.angle = arc.angle;
        return this;
    }
    /**
     * 抽象成json数据格式
     * @returns
     */
    toJson() {
        let data = Object.assign({ type: this.type, angle: this.angle }, super.toJson());
        return data;
    }
    /**
     * 解析json数据成圆弧对象
     * @param json
     * @returns
     */
    fromJson(json) {
        super.fromJson(json);
        this.angle = json.angle;
        return this;
    }
    /**
     * 判断相等
     * @param arc
     * @returns
     */
    equals(arc) {
        if (!this.center.equals(arc.center))
            return false;
        if (!this.normal.equals(arc.normal))
            return false;
        if (!this.getX().equals(arc.getX()))
            return false;
        if (this.angle != arc.angle)
            return false;
        return true;
    }
    /**
     * 获取特征点列表
     * @returns
     */
    getFeaturePoints() {
        return [
            { type: FEATURE_POINT_TYPE.END, point: this.getPointAt(0), geoType: this.type, uvtPosition: 0 },
            { type: FEATURE_POINT_TYPE.END, point: this.getPointAt(1), geoType: this.type, uvtPosition: 1 },
            { type: FEATURE_POINT_TYPE.MIDDLE, point: this.getPointAt(0.5), geoType: this.type, uvtPosition: 0.5 },
            { type: FEATURE_POINT_TYPE.CENTER, point: this.center, geoType: this.type },
        ];
    }
    /**
     * 获取包围盒
     * @returns
     */
    getBoundingBox() {
        let min_x = 0;
        let min_y = 0;
        let max_x = 0;
        let max_y = 0;
        // let min = new Point(0, 0, 0);
        // let max = new Point(0, 0, 0);
        if (this.angle < Math.PI / 2) {
            min_x = Math.cos(this.angle);
            min_y = 0;
            max_x = 1;
            max_y = Math.sin(this.angle);
        }
        else if (this.angle >= Math.PI / 2 && this.angle < Math.PI) {
            min_x = Math.cos(this.angle);
            min_y = 0;
            max_x = 1;
            max_y = 1;
        }
        else if (this.angle >= Math.PI && this.angle < Math.PI * 3 / 2) {
            min_x = -1;
            min_y = Math.sin(this.angle);
            max_x = 1;
            max_y = 1;
        }
        else {
            min_x = -1;
            min_y = -1;
            max_x = 1;
            max_y = 1;
        }
        let box = new Box3$1().setFromPoints([new Vector3$1(min_x, min_y, 0), new Vector3$1(max_x, max_y, 0)]);
        box.applyMatrix4(this.transformMatrix);
        return {
            min: box.min,
            max: box.max,
        };
    }
    /**
     * 获取控制点 可用于stretch
     * @returns
     */
    getControlPoints() {
        return [
            { type: FEATURE_POINT_TYPE.CENTER, point: this.center, geoType: this.type },
            { type: FEATURE_POINT_TYPE.END, point: this.getPointAt(0), geoType: this.type, uvtPosition: 0 },
            { type: FEATURE_POINT_TYPE.END, point: this.getPointAt(1), geoType: this.type, uvtPosition: 1 },
        ];
    }
    /**
     * 通过控制点修改几何
     */
    setByControlPoint(controlPoints = [], vec) {
        let res = super.setByControlPoint(controlPoints, vec); // 如果有center，直接move，不执行下面的
        if (res)
            return true;
        let height = this.getChordHeight();
        let normal = this.normal;
        for (let cp of controlPoints) {
            // 没有center的情况
            if (cp.uvtPosition == null || cp.point == null)
                continue;
            _p$1$1.copy(cp.point).add(vec);
            if (cp.uvtPosition == 0) {
                // 改起点
                this.setByEndPointChordHeight(_p$1$1, this.getPointAt(1), height, normal);
            }
            else if (cp.uvtPosition == 1) {
                // 改终点
                this.setByEndPointChordHeight(this.getPointAt(0), _p$1$1, height, normal);
            }
        }
        return true;
    }
    /**
     * 计算圆弧矢高
     */
    getChordHeight() {
        return this.radius * (1 - Math.cos(this.angle / 2));
    }
    /**
     * 反向
     */
    reverse() {
        const endDir = this.getPointAt(1).sub(this.center);
        this.setXYZ(endDir.normalize(), this.getNormalizeZ().multiplyScalar(-1));
        return this;
    }
}
const _vec1 = new Vector3$1();
const _vec2$2 = new Vector3$1();
const _vec3$2 = new Vector3$1();
const _normal$2 = new Vector3$1();
const _point$b = new Point();
const _point1$5 = new Point();
const _point2$6 = new Point();
const _p$1$1 = new Point();
const _startToMid = new Vector3$1();
const _midToEnd = new Vector3$1();
const _plumbLine1 = new StraightLine();
const _plumbLine2 = new StraightLine();/**
 * 圆
 */
class Circle extends Arc {
    constructor(center = new Point(), radius = 1, normal = new Vector3$1(0, 0, 1), axisX = new Vector3$1(1, 0, 0)) {
        super(center, radius, 2 * Math.PI, normal, axisX);
        this.type = 'Circle';
    }
    /**
     * 抽象成json数据
     * @returns
     */
    toJson() {
        let data = super.toJson();
        data = Object.assign(Object.assign({}, data), { type: this.type });
        return data;
    }
    /**
     * 克隆
     * @returns
     */
    clone() {
        return new Circle().copy(this);
    }
    /**
     * 获取圆上的点
     * @param division
     * @returns
     */
    getPoints(division) {
        let points = [];
        for (let d = 0; d <= division; d++) {
            points.push(this.getPointAt(d / division));
        }
        return points;
    }
    /**
     * 获取特征点列表
     * @returns
     */
    getFeaturePoints() {
        return [
            { type: FEATURE_POINT_TYPE.CENTER, point: this.center, geoType: this.type },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: this.getPointAt(0), geoType: this.type, uvtPosition: 0 },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: this.getPointAt(0.25), geoType: this.type, uvtPosition: 0.25 },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: this.getPointAt(0.5), geoType: this.type, uvtPosition: 0.5 },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: this.getPointAt(0.75), geoType: this.type, uvtPosition: 0.75 },
        ];
    }
    /**
     * 获取包围盒
     * @returns
     */
    getBoundingBox() {
        let min = new Point(-1, -1, 0);
        let max = new Point(1, 1, 0);
        min.applyMatrix4(this.transformMatrix);
        max.applyMatrix4(this.transformMatrix);
        return {
            min: min,
            max: max,
        };
    }
    /**
     * 获取中心点
     * @param target 用以防止对象重复创建
     */
    getCenter(target) {
        if (target == null) {
            target = new Point();
        }
        this.getP(target);
        return target;
    }
    /**
     * 获取控制点 可用于stretch
     * @returns
     */
    getControlPoints() {
        return [
            { type: FEATURE_POINT_TYPE.CENTER, point: this.center, geoType: this.type },
        ];
    }
    /**
     * 通过控制点修改几何
     */
    setByControlPoint(controlPoints = [], vec) {
        return super.setByControlPoint(controlPoints, vec);
    }
}/**
 * 椭圆弧
 * 局部坐标系下为起始角度为0，终止角度为angle，a轴长度等于b轴长度等于1的圆弧
 * 局部坐标系x轴等于椭圆弧的a轴方向与a轴长度
 * 局部坐标系y轴等于椭圆弧的b轴方向与b轴长度
 */
class EllipseArc extends Curve {
    get center() {
        return new Point().copy(this.getP());
    }
    set center(value) {
        this.setP(value);
    }
    get normal() {
        return this.getNormalizeZ();
    }
    get axisX() {
        return this.getNormalizeX();
    }
    set axisA(a) {
        if (a.length() < 1e-5) {
            a = this.getNormalizeX().multiplyScalar(1e-5);
        }
        this.transformMatrix.elements[0] = a.x;
        this.transformMatrix.elements[1] = a.y;
        this.transformMatrix.elements[2] = a.z;
        this.setXYZ(this.getX(), this.getNormalizeZ());
    }
    set axisB(b) {
        if (b.length() < 1e-5) {
            b = this.getNormalizeY().multiplyScalar(1e-5);
        }
        this.transformMatrix.elements[4] = b.x;
        this.transformMatrix.elements[5] = b.y;
        this.transformMatrix.elements[6] = b.z;
    }
    /**
     * 获取椭圆弧上一点切线方向
     * @param point
     */
    getCutLineDir(point, target) {
        if (target == null) {
            target = new Vector3$1();
        }
        const xAxis = this.getX().normalize();
        const yAxis = this.getY().normalize();
        const localOffset = new Vector3$1(point.x - this.center.x, point.y - this.center.y, point.z - this.center.z);
        const a = this.getX().length();
        const b = this.getY().length();
        const xOffset = localOffset.dot(xAxis) / a;
        const yOffset = localOffset.dot(yAxis) / b;
        const t = Math.atan2(yOffset, xOffset);
        const dx = -a * Math.sin(t);
        const dy = b * Math.cos(t);
        target
            .addScaledVector(xAxis, dx)
            .addScaledVector(yAxis, dy)
            .normalize();
        return target;
    }
    /**
     * 椭圆弧
     * 局部坐标系下为起始角度为0，终止角度为angle，a轴长度等于b轴长度等于1的圆弧
     * 局部坐标系x轴等于椭圆弧的a轴方向与a轴长度
     * 局部坐标系y轴等于椭圆弧的b轴方向与b轴长度
     */
    constructor(center = new Point(0, 0, 0), axisX = new Vector3$1(1, 0, 0), axisY = new Vector3$1(0, 1, 0), angle = 0) {
        super();
        this.type = 'EllipseArc';
        let normal = (axisX.clone().cross(axisY)).normalize();
        this.transformMatrix.set(axisX.x, axisY.x, normal.x, center.x, axisX.y, axisY.y, normal.y, center.y, axisX.z, axisY.z, normal.z, center.z, 0, 0, 0, 1);
        this.angle = angle;
    }
    set(center = new Point(0, 0, 0), axisX = new Vector3$1(1, 0, 0), axisY = new Vector3$1(0, 1, 0), angle = 0) {
        let normal = (axisX.clone().cross(axisY)).normalize();
        this.transformMatrix.set(axisX.x, axisY.x, normal.x, center.x, axisX.y, axisY.y, normal.y, center.y, axisX.z, axisY.z, normal.z, center.z, 0, 0, 0, 1);
        this.angle = angle;
        return this;
    }
    // overwrite
    // t: 沿曲线的比例
    getPointAt(t, target = null) {
        if (target === null) {
            target = new Point();
        }
        const angle = t * this.angle;
        let x = Math.cos(angle);
        let y = Math.sin(angle);
        target.set(x, y, 0).applyMatrix4(this.transformMatrix);
        return target;
    }
    getCenter(target) {
        if (target == null) {
            target = new Point();
        }
        target.copy(this.center);
        return target;
    }
    clone() {
        return new EllipseArc().copy(this);
    }
    copy(arc) {
        this.transformMatrix.copy(arc.transformMatrix);
        this.angle = arc.angle;
        return this;
    }
    // overwrite
    toJson() {
        let data = Object.assign({ version: "1.0", angle: this.angle, type: this.type }, super.toJson());
        return data;
    }
    /**
     * 获取控制点 可用于stretch
     * @returns
     */
    getControlPoints() {
        let res = [];
        res.push({ type: FEATURE_POINT_TYPE.END, point: this.getPointAt(0), geoType: this.type, uvtPosition: 0 });
        res.push({ type: FEATURE_POINT_TYPE.END, point: this.getPointAt(1), geoType: this.type, uvtPosition: 1 });
        // 构造椭圆
        let ellipse = new Ellipse(this.getP(), this.getX(), this.getY());
        res.push(...ellipse.getControlPoints());
        return res;
    }
    /**
     * 获取包围盒
     * @returns
     */
    getBoundingBox() {
        let min = new Point();
        let max = new Point();
        if (this.angle < Math.PI / 2) {
            min.x = Math.cos(this.angle);
            min.y = 0;
            max.x = 1;
            max.y = Math.sin(this.angle);
        }
        else if (this.angle >= Math.PI / 2 && this.angle < Math.PI) {
            min.x = Math.cos(this.angle);
            min.y = 0;
            max.x = 1;
            max.y = 1;
        }
        else if (this.angle >= Math.PI && this.angle < Math.PI * 3 / 2) {
            min.x = -1;
            min.y = Math.sin(this.angle);
            max.x = 1;
            max.y = 1;
        }
        else {
            min.x = -1;
            min.y = -1;
            max.x = 1;
            max.y = 1;
        }
        min.applyMatrix4(this.transformMatrix);
        max.applyMatrix4(this.transformMatrix);
        return {
            min: min,
            max: max,
        };
    }
    /**
    * 获取特征点列表
    * @returns
    */
    getFeaturePoints() {
        let res = [];
        res.push({ type: FEATURE_POINT_TYPE.QUADRANTAL, point: this.getPointAt(0), geoType: this.type, uvtPosition: 0 });
        res.push({ type: FEATURE_POINT_TYPE.END, point: this.getPointAt(0), geoType: this.type, uvtPosition: 0 });
        res.push({ type: FEATURE_POINT_TYPE.END, point: this.getPointAt(1), geoType: this.type, uvtPosition: 1 });
        res.push({ type: FEATURE_POINT_TYPE.MIDDLE, point: this.getPointAt(0.5), geoType: this.type, uvtPosition: 0.5 });
        if (this.angle > Math.PI / 2) {
            let ratio = Math.PI / 2 / this.angle;
            let point = this.getPointAt(ratio);
            res.push({ type: FEATURE_POINT_TYPE.QUADRANTAL, point: point, geoType: this.type, uvtPosition: ratio });
        }
        if (this.angle > Math.PI) {
            let ratio = Math.PI / this.angle;
            let point = this.getPointAt(ratio);
            res.push({ type: FEATURE_POINT_TYPE.QUADRANTAL, point: point, geoType: this.type, uvtPosition: ratio });
        }
        if (this.angle > Math.PI * 3 / 2) {
            let ratio = Math.PI * 3 / 2 / this.angle;
            let point = this.getPointAt(ratio);
            res.push({ type: FEATURE_POINT_TYPE.QUADRANTAL, point: point, geoType: this.type, uvtPosition: ratio });
        }
        return res;
    }
    // overwrite
    fromJson(json) {
        super.fromJson(json);
        this.angle = json.angle;
        return this;
    }
    reverse() {
        // TODO 椭圆弧反向
        return this;
    }
    // overwrite
    equals(arc) {
        const eplison = 1e-6;
        for (let i = 0; i < 16; i++) {
            if (Math.abs(this.transformMatrix.elements[i] - arc.transformMatrix.elements[i]) > eplison)
                return false;
        }
        if (Math.abs(this.angle - arc.angle) > eplison)
            return false;
        return true;
    }
}/**
 * 椭圆
 * 局部坐标系定义同EllipseArc
 */
class Ellipse extends EllipseArc {
    constructor(center = new Point(0, 0, 0), axisX = new Vector3$1(1, 0, 0), axisY = new Vector3$1(0, 1, 0)) {
        super(center, axisX, axisY, Math.PI * 2);
        this.type = "Ellipse";
    }
    getValue(key) {
        if (key === 'center') {
            return this.center;
        }
        else {
            return this.center;
        }
    }
    // 圆心
    getCenter(target = null) {
        if (target == null) {
            target = new Point();
        }
        target.copy(this.center);
        return target;
    }
    /**
     * 获取控制点 可用于stretch
     * @returns
     */
    getControlPoints() {
        let point1 = this.getPointAt(0);
        let point2 = this.getPointAt(0.25);
        let point3 = this.getPointAt(0.5);
        let point4 = this.getPointAt(0.75);
        return [
            // 控制点
            { type: FEATURE_POINT_TYPE.CENTER, point: this.getP(), geoType: this.type }, // 夹点
            // 夹点
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: point1, geoType: this.type, uvtPosition: 0 },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: point2, geoType: this.type, uvtPosition: 0.25 },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: point3, geoType: this.type, uvtPosition: 0.5 },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: point4, geoType: this.type, uvtPosition: 0.75 },
        ];
    }
    /**
     * 获取包围盒
     * @returns
     */
    getBoundingBox() {
        // let aLength = this.getX().length()
        // let bLength = this.getY().length()
        let min = new Point(1, 1, 0).applyMatrix4(this.transformMatrix);
        let max = new Point(-1, -1, 0).applyMatrix4(this.transformMatrix);
        return {
            min: min,
            max: max,
        };
    }
    /**
    * 获取特征点列表
    * @returns
    */
    getFeaturePoints() {
        let point1 = this.getPointAt(0);
        let point2 = this.getPointAt(0.25);
        let point3 = this.getPointAt(0.5);
        let point4 = this.getPointAt(0.75);
        return [
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: point1, geoType: this.type, uvtPosition: 0 },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: point2, geoType: this.type, uvtPosition: 0.25 },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: point3, geoType: this.type, uvtPosition: 0.5 },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: point4, geoType: this.type, uvtPosition: 0.75 },
            { type: FEATURE_POINT_TYPE.CENTER, point: this.getP(), geoType: this.type },
        ];
    }
}/**
 * 用于根据基线的string字段，生成基线类的文件
 */var BaseCurveTrans=/*#__PURE__*/Object.freeze({__proto__:null,Arc:Arc,Circle:Circle,Ellipse:Ellipse,EllipseArc:EllipseArc,Line:Line$2});/**
 *
 */
class RevolveSurface extends Surface {
    constructor(baseCurve, axis = new StraightLine(), angle = 2 * Math.PI, axisX = new Vector3$1(1, 0, 0)) {
        super();
        this.type = 'RevolveSurface';
        // 设置旋转轴方向
        const zAxis = axis.direction.clone().normalize();
        // 旋转轴起点
        const origin = axis.origin.clone();
        // 设置x向量xAxis
        const anyAxis = axisX.clone();
        // 如果方向接近平行，选择另一个方向
        if (Math.abs(zAxis.dot(anyAxis)) > 0.999) {
            anyAxis.set(0, 1, 0);
        }
        if (Math.abs(zAxis.dot(anyAxis)) > 0.999) {
            anyAxis.set(1, 0, 0);
        }
        const yAxis = zAxis.clone().cross(anyAxis).normalize();
        // 生成yAxis
        const xAxis = yAxis.clone().cross(zAxis).normalize();
        // 构造旋转体的变换矩阵
        this.transformMatrix.set(xAxis.x, yAxis.x, zAxis.x, origin.x, xAxis.y, yAxis.y, zAxis.y, origin.y, xAxis.z, yAxis.z, zAxis.z, origin.z, 0, 0, 0, 1);
        this.angle = angle;
        // 将curve的局部坐标系转换到旋转体的局部坐标系下
        if (baseCurve) {
            this.baseCurve = baseCurve.clone();
            this.baseCurve.transformMatrix.premultiply(this.transformMatrix.clone().invert());
        }
    }
    /**
     * 返回特征点
     * @returns
     */
    getFeaturePoints() {
        const points = this.baseCurve.getFeaturePoints();
        const revolvePoints = [];
        const origin = this.getP();
        const direction = this.getZ().normalize();
        points.forEach(point => {
            point.point.applyMatrix4(this.transformMatrix);
            revolvePoints.push({
                type: point.type, point: point.point.clone().sub(origin).applyAxisAngle(direction, this.angle * 1).add(origin), geoType: point.geoType
            });
        });
        return [
            ...points,
            ...revolvePoints
        ];
    }
    /**
     * 获取控制点
     * @returns
     */
    getControlPoints() {
        const points = this.baseCurve.getControlPoints();
        points.forEach(point => {
            point.point.applyMatrix4(this.transformMatrix);
        });
        return [
            ...points
        ];
    }
    copy(surface) {
        super.copy(surface);
        this.baseCurve = surface.baseCurve.clone();
        this.angle = surface.angle;
        return this;
    }
    clone() {
        return new RevolveSurface().copy(this);
    }
    equals(surface) {
        return this.baseCurve.equals(surface.baseCurve) && this.transformMatrix.equals(surface.transformMatrix) && this.angle === surface.angle;
    }
    getCenter(target) {
        if (target == null) {
            target = new Point();
        }
        this.getP(target);
        return target;
    }
    getBoundingBox() {
        // 初始化最小值和最大值为无穷
        const min = new Point(Infinity, Infinity, Infinity);
        const max = new Point(-Infinity, -Infinity, -Infinity);
        const numSamples = 15; // 采样点数
        // 获取基准曲线上的点
        const basePoints = this.baseCurve.getPoints(numSamples);
        // 遍历旋转角度，生成旋转后的点
        for (let i = 0; i <= numSamples; i++) {
            const theta = (i / numSamples) * this.angle;
            const rotationMatrix = new Matrix4$1().makeRotationAxis(this.getZ().normalize(), // 旋转轴方向
            theta);
            // 遍历基准曲线上的点并计算旋转后的点
            for (const point of basePoints) {
                const rotatedPoint = point.clone().applyMatrix4(rotationMatrix);
                rotatedPoint.applyMatrix4(this.transformMatrix); // 转换到世界坐标系
                // 更新最小值和最大值
                min.x = Math.min(min.x, rotatedPoint.x);
                min.y = Math.min(min.y, rotatedPoint.y);
                min.z = Math.min(min.z, rotatedPoint.z);
                max.x = Math.max(max.x, rotatedPoint.x);
                max.y = Math.max(max.y, rotatedPoint.y);
                max.z = Math.max(max.z, rotatedPoint.z);
            }
        }
        return {
            min: min,
            max: max
        };
    }
    /**
     * 获取曲面插值点
     * @param t 底线上的比例
     * @param u 占旋转角度的比例
     * @param target
     * @returns
     */
    getPointAt(t, u, target = null) {
        if (target == null) {
            target = new Point();
        }
        const origin = this.getP();
        const direction = this.getZ().normalize();
        this.baseCurve.getPointAt(t, target);
        target.applyMatrix4(this.transformMatrix); //需要乘以旋转面的局部坐标
        return target.sub(origin).applyAxisAngle(direction, this.angle * u).add(origin);
        // return target.applyAxisAngle(direction, this.angle * u);
    }
    // overwrite
    toJson() {
        return Object.assign({ version: "1.0", baseCurve: this.baseCurve.toJson(), angle: this.angle, type: this.type }, super.toJson());
    }
    // overwrite
    fromJson(json) {
        super.fromJson(json);
        this.baseCurve = new BaseCurveTrans[json.baseCurve.type]().fromJson(json.baseCurve);
        this.angle = json.angle;
        return this;
    }
    getSideEdges() {
        let res = [];
        // 底线
        let baseC = this.baseCurve.clone();
        baseC.transformMatrix.premultiply(this.transformMatrix);
        res.push(baseC);
        // 旋转后的底线
        let baseRC = this.baseCurve.clone();
        baseRC.transformMatrix.premultiply(this.transformMatrix);
        baseRC.rotate(this.getP(), this.getNormalizeZ(), this.angle);
        res.push(baseRC);
        // 旋转的弧线
        let arc1 = new Arc();
        let arc2 = new Arc();
        let downPoint1 = this.getPointAt(0, 0);
        let downPoint2 = this.getPointAt(0, 1);
        let upPoint1 = this.getPointAt(1, 0);
        let upPoint2 = this.getPointAt(1, 1);
        let center1 = new Point();
        let center2 = new Point();
        let sLine = new StraightLine(this.getP(), this.getNormalizeZ());
        GeoRelation.StraightLineClosestPointToPoint(sLine, downPoint1, center1);
        GeoRelation.StraightLineClosestPointToPoint(sLine, upPoint1, center2);
        if (arc1.setFromTwoPointAndCenter(downPoint1, downPoint2, center1, this.getNormalizeZ())) {
            res.push(arc1);
        }
        if (arc2.setFromTwoPointAndCenter(upPoint1, upPoint2, center2, this.getNormalizeZ())) {
            res.push(arc2);
        }
        return res;
    }
}/**
 * 圆锥侧面
 * 局部坐标系原点为圆的圆心
 * 局部坐标系x轴方向与长度表示圆的x方向与半径长度
 * 用局部坐标系的z轴表示旋转轴
 */
class ConeSideSurface extends RevolveSurface {
    /**
     * @param baseCenter 底面圆心
     * @param vecX 含半径长度的x方向
     * @param vecZ 含高度的z方向
     */
    constructor(baseCenter = new Point(), vecX = new Vector3$1(1, 0, 0), vecZ = new Vector3$1(0, 0, 1)) {
        let radius = vecX.length(); //底面圆半径
        let circle = new Circle(baseCenter, radius, vecZ, vecX.normalize());
        const point1 = baseCenter.clone().add(vecZ.clone()); //圆锥顶点
        const point2 = circle.getPointAt(0.5); //底面圆上一点
        const baseCurve = new Line$2(point1, point2); //旋转基线
        const axis = new StraightLine(baseCenter, vecZ); //旋转轴
        super(baseCurve, axis, 2 * Math.PI);
        this.type = 'ConeSideSurface';
    }
    /**
     * 获取控制点 可用于stretch
     * @returns
     */
    getControlPoints() {
        // 获取顶点
        let topPoint = this.baseCurve.getPointAt(0);
        // 获取底面上一点
        let bottomPoint = this.baseCurve.getPointAt(1);
        // 获取旋转轴
        let axis = new StraightLine(this.getP(), this.getNormalizeZ());
        // 获取旋转轴距离底面点最近的点
        let crossPoint = GeoRelation.StraightLineClosestPointToPoint(axis, bottomPoint);
        // 获取半径
        let raidus = crossPoint.distanceTo(bottomPoint);
        // 获取象限点
        let sidePoint1 = bottomPoint.clone().add(this.getNormalizeX().multiplyScalar(raidus));
        let sidePoint2 = bottomPoint.clone().add(this.getNormalizeY().multiplyScalar(raidus));
        let sidePoint3 = bottomPoint.clone().add(this.getNormalizeX().multiplyScalar(-raidus));
        let sidePoint4 = bottomPoint.clone().add(this.getNormalizeY().multiplyScalar(-raidus));
        return [
            // 控制点
            // 夹点
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint1, geoType: this.type, uvtPosition: new Point(1, 0, 0) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint2, geoType: this.type, uvtPosition: new Point(0, 1, 0) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint3, geoType: this.type, uvtPosition: new Point(-1, 0, 0) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint4, geoType: this.type, uvtPosition: new Point(0, -1, 0) },
            { type: FEATURE_POINT_TYPE.END, point: topPoint, geoType: this.type, uvtPosition: new Point(0, 0, 1) },
        ];
    }
    /**
     * 获取包围盒
     * @returns
     */
    getBoundingBox() {
        let min = new Point(0, 0, 0);
        let max = new Point(0, 0, 0);
        return {
            min: min,
            max: max,
        };
    }
    /**
    * 获取特征点列表
    * @returns
    */
    getFeaturePoints() {
        // 获取顶点
        let topPoint = this.baseCurve.getPointAt(0);
        // 获取底面上一点
        let bottomPoint = this.baseCurve.getPointAt(1);
        // 获取旋转轴
        let axis = new StraightLine(this.getP(), this.getNormalizeZ());
        // 获取旋转轴距离底面点最近的点
        let crossPoint = GeoRelation.StraightLineClosestPointToPoint(axis, bottomPoint);
        // 获取半径
        let raidus = crossPoint.distanceTo(bottomPoint);
        // 获取象限点
        let sidePoint1 = bottomPoint.clone().add(this.getNormalizeX().multiplyScalar(raidus));
        let sidePoint2 = bottomPoint.clone().add(this.getNormalizeY().multiplyScalar(raidus));
        let sidePoint3 = bottomPoint.clone().add(this.getNormalizeX().multiplyScalar(-raidus));
        let sidePoint4 = bottomPoint.clone().add(this.getNormalizeY().multiplyScalar(-raidus));
        return [
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint1, geoType: this.type, uvtPosition: new Point(1, 0, 0) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint2, geoType: this.type, uvtPosition: new Point(0, 1, 0) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint3, geoType: this.type, uvtPosition: new Point(-1, 0, 0) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint4, geoType: this.type, uvtPosition: new Point(0, -1, 0) },
            { type: FEATURE_POINT_TYPE.END, point: topPoint, geoType: this.type, uvtPosition: new Point(0, 0, 1) },
        ];
    }
}/**
 * 椭圆基面
 * 局部坐标系下椭圆为长轴为1，短轴也为1的椭圆
 * 局部坐标系原点为椭圆的圆心
 * 局部坐标系x轴方向与长度表示椭圆的x方向与a轴长度
 * 局部坐标系y轴方向与长度表示椭圆的y方向与b轴长度
 * 用局部坐标系的z轴表示矩形所在平面的法向量
 */
class EllipseSurface extends Surface {
    /**
     * 椭圆基面
     * 局部坐标系下椭圆为长轴为1，短轴也为1的椭圆
     * 局部坐标系原点为椭圆的圆心
     * 局部坐标系x轴方向与长度表示椭圆的x方向与a轴长度
     * 局部坐标系y轴方向与长度表示椭圆的y方向与b轴长度
     * 用局部坐标系的z轴表示矩形所在平面的法向量
     * @param basePoint 基点位置
     * @param vecX 含a轴长度的x方向
     * @param vecY 含b轴长度的y方向
     */
    constructor(basePoint = new Point(), vecX = new Vector3$1(1, 0, 0), vecY = new Vector3$1(0, 1, 0)) {
        super();
        this.type = 'EllipseSurface';
        let normal = (vecX.clone().cross(vecY.clone())).normalize();
        this.transformMatrix.set(vecX.x, vecY.x, normal.x, basePoint.x, vecX.y, vecY.y, normal.y, basePoint.y, vecX.z, vecY.z, normal.z, basePoint.z, 0, 0, 0, 1);
    }
    /**
     * 获取圆面上的插值点
     * @param t 角度（x轴）方向插值比例
     * @param u 半径（y轴）方向插值比例
     * @param target 插值点引用对象
     * @returns
     */
    getPointAt(t, u, target) {
        if (target == null) {
            target = new Point();
        }
        let angle = t * Math.PI * 2;
        // 统一化，使用局部坐标点加上变换矩阵的方法
        target.set(Math.cos(angle), Math.sin(angle), 0).multiplyScalar(u).applyMatrix4(this.transformMatrix);
        return target;
    }
    /**
     * 复制
     * @param ellipse
     * @returns
     */
    copy(ellipse) {
        this.transformMatrix.copy(ellipse.transformMatrix);
        return this;
    }
    /**
     * 克隆
     * @returns
     */
    clone() {
        return new EllipseSurface().copy(this);
    }
    /**
     * 获取控制点 可用于stretch
     * @returns
     */
    getControlPoints() {
        let point1 = this.getPointAt(0, 1);
        let point2 = this.getPointAt(0.25, 1);
        let point3 = this.getPointAt(0.5, 1);
        let point4 = this.getPointAt(0.75, 1);
        return [
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: point1, geoType: this.type, uvtPosition: new Point2(0, 1) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: point2, geoType: this.type, uvtPosition: new Point2(0.25, 1) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: point3, geoType: this.type, uvtPosition: new Point2(0.5, 1) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: point4, geoType: this.type, uvtPosition: new Point2(0.75, 1) },
            { type: FEATURE_POINT_TYPE.CENTER, point: this.getP(), geoType: this.type },
        ];
    }
    /**
     * 获取包围盒
     * @returns
     */
    getBoundingBox() {
        // let aLength = this.getX().length()
        // let bLength = this.getY().length()
        let min = new Point(1, 1, 0).applyMatrix4(this.transformMatrix);
        let max = new Point(-1, -1, 0).applyMatrix4(this.transformMatrix);
        return {
            min: min,
            max: max,
        };
    }
    /**
    * 获取特征点列表
    * @returns
    */
    getFeaturePoints() {
        let point1 = this.getPointAt(0, 1);
        let point2 = this.getPointAt(0.25, 1);
        let point3 = this.getPointAt(0.5, 1);
        let point4 = this.getPointAt(0.75, 1);
        return [
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: point1, geoType: this.type, uvtPosition: new Point2(0, 1) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: point2, geoType: this.type, uvtPosition: new Point2(0.25, 1) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: point3, geoType: this.type, uvtPosition: new Point2(0.5, 1) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: point4, geoType: this.type, uvtPosition: new Point2(0.75, 1) },
            { type: FEATURE_POINT_TYPE.CENTER, point: this.getP(), geoType: this.type },
        ];
    }
    toJson() {
        let data = Object.assign({ version: "1.1", type: this.type }, super.toJson());
        return data;
    }
    getSideEdges() {
        let res = [new Ellipse(this.getP(), this.getX(), this.getY())];
        return res;
    }
}const ConeSurfaceType = {
    Bottom: 0,
    Side: 1
};
/**
 * 圆锥
 */
class Cone extends Solid {
    /**
     * 底面圆心
     */
    get center() {
        return new Point().copy(this.getP());
    }
    /**
     * 设置底面圆心
     */
    set center(value) {
        this.setP(value);
    }
    /**
     * 法向量
     */
    get normal() {
        return this.getNormalizeZ();
    }
    /**
     * 需要保证z与x轴方向不同，所以建议以后设置normal时都调用这个方法
     * @param nx
     * @param ny
     * @param nz
     */
    setNormal(nx, ny, nz) {
        this.setXYZ(this.axisX, new Vector3$1(nx, ny, nz));
    }
    /**
     * x轴方向(带长度)
     */
    get axisX() {
        return new Vector3$1().copy(this.getX());
    }
    /**
     * 底面半径
     */
    get radius() {
        return this.scaleX;
    }
    /**
     * 设置底面半径
     */
    set radius(value) {
        let scale = value / this.scaleX;
        if (scale == 0)
            scale = 1;
        this.scale(this.getP(), scale, scale, 1);
    }
    /**
     * 高
     */
    get height() {
        return this.scaleZ;
    }
    /**
     * 设置高
     */
    set height(value) {
        let scale = value / this.scaleZ;
        if (scale == 0)
            scale = 1;
        this.scale(this.getP(), 1, 1, scale);
    }
    // /**
    //  * 局部坐标系x轴
    //  */
    // get axisX() {
    //     return this.getX();
    // }
    /**
     * 构造函数
     * @param center 圆心
     * @param radius 半径
     * @param height 高
     * @param normal 法向量
     * @param axisX 局部坐标系x轴
     */
    constructor(center = new Point(), radius = 1, height = 0, normal = new Vector3$1(0, 0, 1), axisX = new Vector3$1(1, 0, 0)) {
        super();
        /**
         * 类型
         */
        this.type = 'Cone';
        /**
         * 圆锥表面索引，以局部坐标系尺度来看，0代表底面，1代表侧面
         */
        this.surfaceIndex = [ConeSurfaceType.Bottom, ConeSurfaceType.Side];
        this.transformMatrix.elements[8] = normal.x;
        this.transformMatrix.elements[9] = normal.y;
        this.transformMatrix.elements[10] = normal.z;
        axisX.normalize();
        this.updateMatrixByX(axisX, false);
        if (radius <= 0)
            radius = 1;
        this.radius = radius;
        this.center = center;
        this.height = height;
        //this.setXYZ(this.getX(), normal);
    }
    /**
     * 设置属性
     * @param  center
     * @param  radius
     * @param  height
     * @param  normal
     * @returns
     */
    set(center, radius, height, normal) {
        this.center = center;
        this.radius = radius;
        this.height = height;
        this.setXYZ(this.getX(), normal);
        return this;
    }
    /**
     * 复制
     * @param cone
     * @returns
     */
    copy(cone) {
        super.copy(cone);
        return this;
    }
    /**
     * 克隆
     * @returns
     */
    clone() {
        return new Cone().copy(this);
    }
    /**
     * 判断相等
     * @param cone
     * @returns
     */
    equals(cone) {
        // if (!this.center.equals(cone.center)) return false;
        // if (Math.abs(this.radius - cone.radius) > 1e-6) return false;
        // if (Math.abs(this.height - cone.height) > 1e-6) return false;
        // if (!this.normal.equals(cone.normal)) return false;
        for (let i = 0; i < 16; i++) {
            if (Math.abs(this.transformMatrix.elements[i] - cone.transformMatrix.elements[i]) > 1e-6)
                return false;
        }
        return true;
    }
    /**
     * 获取中心点
     * @param target
     * @returns
     */
    getCenter(target) {
        if (target == null) {
            target = new Point();
        }
        target.copy(this.center);
        target.add(this.normal.clone().multiplyScalar(this.height / 2));
        return target;
    }
    /**
     * 获取基元数组
     * @returns
     */
    getGeoElements() {
        let res = []; //返回的数组
        this.surfaceIndex.forEach(index => {
            let surface = this.getSurface(index);
            if (surface) {
                res.push(surface);
            }
        });
        return res;
    }
    /**
     * 根据索引值获取表面
     * @param index
     * @returns
     */
    getSurface(index) {
        switch (index) {
            case ConeSurfaceType.Bottom:
                return new EllipseSurface(this.getP(), this.getX(), this.getY());
            case ConeSurfaceType.Side:
                return new ConeSideSurface(this.center, this.getX(), this.getZ());
            default:
                return null;
        }
    }
    /**
     * 获取控制点 可用于stretch
     * @returns
     */
    getControlPoints() {
        let raidus = this.getX().length();
        let sidePoint1 = this.getP().add(this.getNormalizeX().multiplyScalar(raidus));
        let sidePoint2 = this.getP().add(this.getNormalizeY().multiplyScalar(raidus));
        let sidePoint3 = this.getP().add(this.getNormalizeX().multiplyScalar(-raidus));
        let sidePoint4 = this.getP().add(this.getNormalizeY().multiplyScalar(-raidus));
        let topPoint = this.getP().add(this.getZ());
        return [
            // 控制点
            // 夹点
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint1, geoType: this.type, uvtPosition: new Point(1, 0, 0) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint2, geoType: this.type, uvtPosition: new Point(0, 1, 0) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint3, geoType: this.type, uvtPosition: new Point(-1, 0, 0) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint4, geoType: this.type, uvtPosition: new Point(0, -1, 0) },
            { type: FEATURE_POINT_TYPE.FACE_CENTER, point: this.getP(), geoType: this.type, uvtPosition: new Point(0, 0, 0) },
            { type: FEATURE_POINT_TYPE.END, point: topPoint, geoType: this.type, uvtPosition: new Point(0, 0, 1) },
        ];
    }
    /**
     * 获取包围盒
     * @returns
     */
    getBoundingBox() {
        let raidus = this.getX().length();
        let sidePoint1 = this.getP().add(this.getNormalizeX().multiplyScalar(raidus));
        let sidePoint2 = this.getP().add(this.getNormalizeY().multiplyScalar(raidus));
        let sidePoint3 = this.getP().add(this.getNormalizeX().multiplyScalar(-raidus));
        let sidePoint4 = this.getP().add(this.getNormalizeY().multiplyScalar(-raidus));
        let topPoint1 = sidePoint1.clone().add(this.getZ());
        let topPoint2 = sidePoint2.clone().add(this.getZ());
        let topPoint3 = sidePoint3.clone().add(this.getZ());
        let topPoint4 = sidePoint4.clone().add(this.getZ());
        let box = new Box3$1();
        box.setFromPoints([sidePoint1, sidePoint2, sidePoint3, sidePoint4, topPoint1, topPoint2, topPoint3, topPoint4]);
        return {
            min: box.min,
            max: box.max,
        };
    }
    /**
    * 获取特征点列表
    * @returns
    */
    getFeaturePoints() {
        let raidus = this.getX().length();
        let sidePoint1 = this.getP().add(this.getNormalizeX().multiplyScalar(raidus));
        let sidePoint2 = this.getP().add(this.getNormalizeY().multiplyScalar(raidus));
        let sidePoint3 = this.getP().add(this.getNormalizeX().multiplyScalar(-raidus));
        let sidePoint4 = this.getP().add(this.getNormalizeY().multiplyScalar(-raidus));
        let topPoint = this.getP().add(this.getZ());
        return [
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint1, geoType: this.type, uvtPosition: new Point(1, 0, 0) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint2, geoType: this.type, uvtPosition: new Point(0, 1, 0) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint3, geoType: this.type, uvtPosition: new Point(-1, 0, 0) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint4, geoType: this.type, uvtPosition: new Point(0, -1, 0) },
            { type: FEATURE_POINT_TYPE.CENTER, point: this.getP(), geoType: this.type, uvtPosition: new Point(0, 0, 0) },
            { type: FEATURE_POINT_TYPE.END, point: topPoint, geoType: this.type, uvtPosition: new Point(0, 0, 1) },
        ];
    }
    /**
     * 抽象成json数据格式
     * @returns
     */
    toJson() {
        return Object.assign({ type: this.type }, super.toJson());
    }
    /**
     * 解析json数据成圆弧对象
     * @param json
     * @returns
     */
    fromJson(json) {
        super.fromJson(json);
        return this;
    }
}const _dirDelta = new Vector3$1();
/**
 * 拉伸面
 * 高度并入z轴缩放
 * 拉伸面的底面的局部坐标系三个轴的方向必须为
 * (1, 0, 0)
 * (0, 1, 0)
 * (0, 0, 1)
 */
class ExtrudeSurface extends Surface {
    set offsetDirection(v) {
        if (v != null) {
            this._offsetDirection.copy(v);
            this._offsetDirection.applyMatrix4(this.transformMatrix.clone().invert());
            this._offsetDirection.normalize();
        }
    }
    get offsetDirection() {
        return this._offsetDirection;
    }
    /**
     * 拉伸方向
     */
    get direction() {
        return new Vector3$1().copy(this.getZ());
    }
    /**
     * 设置拉伸高度
     */
    set height(value) {
        let scale = value / this.scaleZ;
        if (scale == 0)
            scale = 1;
        this.scale(this.getP(), 1, 1, scale);
    }
    /**
     * 拉伸高度
     */
    get height() {
        return this.scaleZ;
    }
    /**
     * 构造函数
     * @param baseCurve 基准线
     * @param direction 拉伸向量含高度
     */
    constructor(baseCurve, direction = new Vector3$1(0, 0, 1)) {
        super();
        /**
         * 类型
         */
        this.type = 'ExtrudeSurface';
        /**
         * 相对于底面的水平方向偏移向量(单位向量)
         */
        this._offsetDirection = new Vector3$1(0, 0, 0);
        /**
         * 偏移比例， 偏移方向与高度的比值
         */
        this.offsetRatio = 0;
        /**
         * 判断偏移方向的正反
         */
        this.initBiggerThanZero = true;
        if (baseCurve) {
            this.baseCurve = baseCurve.clone();
            if (this.baseCurve.type == "Line") {
                let tmpLine = new Line$2();
                tmpLine.copy(baseCurve);
                tmpLine.setXYZ(this.baseCurve.getNormalizeX(), direction.clone().normalize(), false);
                this.baseCurve.transformMatrix.set(tmpLine.scaleX, 0, 0, 0, 0, tmpLine.scaleY, 0, 0, 0, 0, tmpLine.scaleZ, 0, 0, 0, 0, 1);
                this.transformMatrix.set(1 / tmpLine.scaleX, 0, 0, 0, 0, 1 / tmpLine.scaleY, 0, 0, 0, 0, 1 / tmpLine.scaleZ, 0, 0, 0, 0, 1).premultiply(tmpLine.transformMatrix);
            }
            else {
                this.baseCurve.transformMatrix.set(baseCurve.scaleX, 0, 0, 0, 0, baseCurve.scaleY, 0, 0, 0, 0, baseCurve.scaleZ, 0, 0, 0, 0, 1);
                this.transformMatrix.set(1 / baseCurve.scaleX, 0, 0, 0, 0, 1 / baseCurve.scaleY, 0, 0, 0, 0, 1 / baseCurve.scaleZ, 0, 0, 0, 0, 1).premultiply(baseCurve.transformMatrix);
            }
            const length = direction.length();
            const lengthZ = this.scaleZ;
            this.transformMatrix.elements[8] = this.transformMatrix.elements[8] * length / lengthZ;
            this.transformMatrix.elements[9] = this.transformMatrix.elements[9] * length / lengthZ;
            this.transformMatrix.elements[10] = this.transformMatrix.elements[10] * length / lengthZ;
            let bottomNormal = baseCurve.getNormalizeZ();
            let directionNormal = direction.clone().normalize();
            let t = bottomNormal.dot(directionNormal);
            if (Math.abs(t - 1) > 1e-6) {
                // 底面法向量与拉伸方向不一致,设置偏移变量
                if (Math.abs(t) < 1e-6) { //垂直情况，不做处理
                    return;
                }
                let origin = this.getP(); // 拉伸面局部坐标系原点的世界坐标
                let pointInDirectionNormal = origin.clone().add(directionNormal);
                let pointInBottomNormal = bottomNormal.clone().multiplyScalar(t).add(origin);
                let offset = new Vector3$1().subVectors(pointInDirectionNormal, pointInBottomNormal);
                this.offsetDirection = offset;
                this.offsetRatio = offset.length() / Math.abs(t);
                this.initBiggerThanZero = (this.transformMatrix.elements[8] + this.transformMatrix.elements[9] + this.transformMatrix.elements[10]) >= 0;
            }
        }
    }
    /**
     * 复制
     * @param surface
     * @returns
     */
    copy(surface) {
        this.baseCurve = surface.baseCurve.clone();
        this.transformMatrix.copy(surface.transformMatrix);
        this.height = surface.height;
        this.offsetDirection = surface.offsetDirection;
        this.offsetRatio = surface.offsetRatio;
        this.initBiggerThanZero = surface.initBiggerThanZero;
        return this;
    }
    setHeight(height, normal) {
        if (this.getNormalizeX().dot(normal) < 0) {
            height *= -1;
        }
        this.height = height;
    }
    /**
     * 克隆
     * @returns
     */
    clone() {
        return new ExtrudeSurface().copy(this);
    }
    /**
     * 判断相等
     */
    equals(Surface) {
        let isEquals = this.baseCurve.equals(Surface.baseCurve);
        if (!isEquals)
            return false;
        for (let i = 0; i < this.transformMatrix.elements.length; i++) {
            if (this.transformMatrix.elements[i] !== Surface.transformMatrix.elements[i]) {
                isEquals = false;
                break;
            }
        }
        return isEquals;
    }
    /**
     * 计算插值点
     * @param t 底线的比例
     * @param u 沿着拉伸方向的比例
     * @param target
     * @returns
     */
    getPointAt(t, u, target = null) {
        if (target == null) {
            target = new Point();
        }
        this.baseCurve.getPointAt(t, target);
        target.applyMatrix4(this.transformMatrix);
        this.getZ(_dirDelta);
        _dirDelta.multiplyScalar(u);
        target.add(_dirDelta);
        // 乘以横向偏移
        const sum = this.transformMatrix.elements[8] + this.transformMatrix.elements[9] + this.transformMatrix.elements[10];
        const sign = ((this.initBiggerThanZero && sum >= 0) || (!this.initBiggerThanZero && sum < 0)) ? 1 : -1;
        _dirDelta.copy(this._offsetDirection).multiplyScalar(this.offsetRatio * this.scaleZ * u * sign);
        target.add(_dirDelta);
        return target;
    }
    /**
     * 获取包围盒
     * @returns
     */
    getBoundingBox() {
        const data = this.baseCurve.getBoundingBox();
        let baseMin = data.min.applyMatrix4(this.transformMatrix);
        let baseMax = data.max.applyMatrix4(this.transformMatrix);
        let dirMin = baseMin.clone().add(this.getZ());
        let dirMax = baseMax.clone().add(this.getZ());
        let min = new Vector3$1(Math.min(dirMin.x, baseMin.x), Math.min(dirMin.y, baseMin.y), Math.min(dirMin.z, baseMin.z));
        let max = new Vector3$1(Math.max(dirMax.x, baseMax.x), Math.max(dirMax.y, baseMax.y), Math.max(dirMax.z, baseMax.z));
        return {
            min: min,
            max: max,
        };
    }
    /**
     * 抽象成json数据格式
     * @returns
     */
    toJson() {
        return Object.assign(Object.assign({}, super.toJson()), { version: "1.1", baseCurve: this.baseCurve.toJson(), offsetDirection: {
                x: this.offsetDirection.x,
                y: this.offsetDirection.y,
                z: this.offsetDirection.z
            }, offsetRatio: this.offsetRatio, type: this.type, initBiggerThanZero: this.initBiggerThanZero });
    }
    /**
     * 解析json数据
     * @param json
     * @returns
     */
    fromJson(json) {
        super.fromJson(json);
        this.baseCurve = new BaseCurveTrans[json.baseCurve.type]().fromJson(json.baseCurve);
        if (json.offsetDirection) {
            this._offsetDirection.set(json.offsetDirection.x, json.offsetDirection.y, json.offsetDirection.z);
        }
        this.offsetRatio = json.offsetRatio || 0;
        this.initBiggerThanZero = json.initBiggerThanZero;
        return this;
    }
    getSideEdges() {
        let res = [];
        res.push(this.baseCurve.clone());
        res.push(this.baseCurve.clone().move(this.direction));
        res.push(new Line$2(this.getPointAt(0, 0), this.getPointAt(0, 1)));
        res.push(new Line$2(this.getPointAt(1, 0), this.getPointAt(1, 1)));
        return res;
    }
    /**
     * 获取控制点 可用于stretch
     * @returns
     */
    getControlPoints() {
        let bottomPointList = this.baseCurve.getControlPoints();
        bottomPointList.forEach(item => {
            item.point.applyMatrix4(this.transformMatrix);
            let uv = item.uvtPosition;
            let newUv = new Point2(uv, 0);
            item.uvtPosition = newUv;
        });
        let topCenter = this.baseCurve.getP().applyMatrix4(this.transformMatrix).add(this.getZ());
        return [
            // 
            // 顶部拉伸夹点
            { type: FEATURE_POINT_TYPE.MIDDLE, point: topCenter, geoType: this.type, uvtPosition: new Point(0.5, 0.5, 1) },
            // 底面夹点
            ...bottomPointList,
        ];
    }
    /**
    * 获取特征点列表
    * @returns
    */
    getFeaturePoints() {
        let bottomPointList = this.baseCurve.getFeaturePoints();
        bottomPointList.forEach(item => {
            item.point.applyMatrix4(this.transformMatrix);
            let uv = item.uvtPosition;
            let newUv = new Point2(uv, 0);
            item.uvtPosition = newUv;
        });
        let topPointList = this.baseCurve.getFeaturePoints();
        topPointList.forEach(item => {
            item.point.applyMatrix4(this.transformMatrix);
            item.point.add(this.getZ());
            let uv = item.uvtPosition;
            let newUv = new Point2(uv, 1);
            item.uvtPosition = newUv;
        });
        return [
            ...bottomPointList,
            ...topPointList
        ];
    }
}
new Matrix4$1();const CylinderSurfaceType = {
    Top: 0,
    Bottom: 1,
    Side: 2
};
/**
 * 圆柱
 * 局部坐标系下定义为底面半径为1，高度为1的圆柱
 * 其高度等于z的长度，底面的半径等于x轴的长度
 */
class Cylinder extends Solid {
    get center() {
        return new Point().copy(this.getP());
    }
    set center(value) {
        this.setP(value);
    }
    get normal() {
        return new Vector3$1().copy(this.getZ());
    }
    get axisX() {
        return new Vector3$1().copy(this.getX());
    }
    get height() {
        return this.getZ().length();
    }
    set height(h) {
        let normal = this.getNormalizeZ();
        if (Math.abs(h) < 1e-5) {
            h = 1e-5;
        }
        this.transformMatrix.elements[8] = normal.x * h;
        this.transformMatrix.elements[9] = normal.y * h;
        this.transformMatrix.elements[10] = normal.z * h;
    }
    get radius() {
        return this.getX().length();
    }
    set radius(r) {
        if (Math.abs(r) < 1e-5) {
            r = 1e-5;
        }
        let midX = this.getNormalizeX();
        this.transformMatrix.elements[0] = midX.x * r;
        this.transformMatrix.elements[1] = midX.y * r;
        this.transformMatrix.elements[2] = midX.z * r;
    }
    constructor(center = new Point(), radius = 0, height = 1, normal = new Vector3$1(0, 0, 1), axisX = new Vector3$1(1, 0, 0)) {
        super();
        /*1.初始定义与构造*/
        this.type = 'Cylinder';
        this.surfaceIndex = [CylinderSurfaceType.Top, CylinderSurfaceType.Bottom, CylinderSurfaceType.Side];
        let vecY = normal.clone().normalize().cross(axisX.normalize());
        this.transformMatrix.set(axisX.x * radius, vecY.x, normal.x * height, center.x, axisX.y * radius, vecY.y, normal.y * height, center.y, axisX.z * radius, vecY.z, normal.z * height, center.z, 0, 0, 0, 1);
    }
    /**
     * 需要保证z与x轴方向不同，所以建议以后设置normal时都调用这个方法
     * @param nx
     * @param ny
     * @param nz
     */
    setNormal(nx, ny, nz) {
        this.setXYZ(this.axisX, new Vector3$1(nx, ny, nz));
    }
    /**
     * 需要保证z与x轴方向不同，所以建议以后设置normal时都调用这个方法
     * @param nx
     * @param ny
     * @param nz
     */
    setNormalFromVec(v) {
        this.setXYZ(this.axisX, v);
    }
    /*2.复制、克隆与判断相等*/
    copy(cylinder) {
        this.transformMatrix.copy(cylinder.transformMatrix);
        return this;
    }
    clone() {
        return new Cylinder().copy(this);
    }
    equals(cylinder) {
        const eplison = 1e-6;
        // 相等方法
        for (let i = 0; i < 16; i++) {
            if (Math.abs(this.transformMatrix.elements[i] - cylinder.transformMatrix.elements[i]) > eplison)
                return false;
        }
        return true;
    }
    /**
     * 获取圆柱中心
     * @param target
     * @returns
     */
    getCenter(target) {
        if (target == null) {
            target = new Point();
        }
        this.getP(target);
        let normal = this.getZ();
        target.add(normal.multiplyScalar(0.5));
        return target;
    }
    /**
     * 获取基元数组
     * @returns
     */
    getGeoElements() {
        let res = []; //返回的数组
        this.surfaceIndex.forEach(index => {
            let surface = this.getSurface(index);
            if (surface) {
                res.push(surface);
            }
        });
        return res;
    }
    /**
     * 根据索引值获取表面
     * @param index
     * @returns
     */
    getSurface(index) {
        let radius = this.getX().length();
        if (index == CylinderSurfaceType.Top) {
            return new EllipseSurface(this.getP().add(this.getZ()), this.getX(), this.getNormalizeY().multiplyScalar(radius));
        }
        else if (index == CylinderSurfaceType.Bottom) {
            return new EllipseSurface(this.getP(), this.getX(), this.getNormalizeY().multiplyScalar(radius).negate());
        }
        else if (index == CylinderSurfaceType.Side) {
            return new ExtrudeSurface(new Circle(this.center, this.getX().length(), this.getNormalizeZ(), this.getNormalizeX()), this.getZ());
        }
        return null;
    }
    /**
     * 获取控制点 可用于stretch
     * @returns
     */
    getControlPoints() {
        let raidus = this.getX().length();
        let sidePoint1 = this.getP().add(this.getNormalizeX().multiplyScalar(raidus));
        let sidePoint2 = this.getP().add(this.getNormalizeY().multiplyScalar(raidus));
        let sidePoint3 = this.getP().add(this.getNormalizeX().multiplyScalar(-raidus));
        let sidePoint4 = this.getP().add(this.getNormalizeY().multiplyScalar(-raidus));
        return [
            // 控制点
            // 夹点
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint1, geoType: this.type, uvtPosition: new Point(1, 0, 0) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint2, geoType: this.type, uvtPosition: new Point(0, 1, 0) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint3, geoType: this.type, uvtPosition: new Point(-1, 0, 0) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint4, geoType: this.type, uvtPosition: new Point(0, -1, 0) },
            { type: FEATURE_POINT_TYPE.FACE_CENTER, point: this.getP(), geoType: this.type, uvtPosition: new Point(0, 0, 0) },
            { type: FEATURE_POINT_TYPE.FACE_CENTER, point: this.getP().add(this.getZ()), geoType: this.type, uvtPosition: new Point(0, 0, 1) },
            { type: FEATURE_POINT_TYPE.CENTER, point: this.getP().add(this.getZ().multiplyScalar(0.5)), geoType: this.type }
        ];
    }
    /**
     * 获取包围盒
     * @returns
     */
    getBoundingBox() {
        let raidus = this.getX().length();
        let xDir = this.getX();
        let yDir = this.getNormalizeY().multiplyScalar(raidus);
        let bottomPoint1 = this.getP().add(xDir).add(yDir);
        let bottomPoint2 = this.getP().add(xDir.clone().negate()).add(yDir);
        let bottomPoint3 = this.getP().add(xDir.clone().negate()).add(yDir.clone().negate());
        let bottomPoint4 = this.getP().add(xDir).add(yDir.clone().negate());
        let topPoint1 = bottomPoint1.clone().add(this.getZ());
        let topPoint2 = bottomPoint2.clone().add(this.getZ());
        let topPoint3 = bottomPoint3.clone().add(this.getZ());
        let topPoint4 = bottomPoint4.clone().add(this.getZ());
        let box = new Box3$1();
        box.setFromPoints([bottomPoint1, bottomPoint2, bottomPoint3, bottomPoint4, topPoint1, topPoint2, topPoint3, topPoint4]);
        return {
            min: box.min,
            max: box.max,
        };
    }
    /**
    * 获取特征点列表
    * @returns
    */
    getFeaturePoints() {
        let raidus = this.getX().length();
        let sidePoint1 = this.getP().add(this.getNormalizeX().multiplyScalar(raidus));
        let sidePoint2 = this.getP().add(this.getNormalizeY().multiplyScalar(raidus));
        let sidePoint3 = this.getP().add(this.getNormalizeX().multiplyScalar(-raidus));
        let sidePoint4 = this.getP().add(this.getNormalizeY().multiplyScalar(-raidus));
        return [
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint1, geoType: this.type, uvtPosition: new Point(1, 0, 0) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint2, geoType: this.type, uvtPosition: new Point(0, 1, 0) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint3, geoType: this.type, uvtPosition: new Point(-1, 0, 0) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint4, geoType: this.type, uvtPosition: new Point(0, -1, 0) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint1.clone().add(this.getZ()), geoType: this.type, uvtPosition: new Point(1, 0, 1) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint2.clone().add(this.getZ()), geoType: this.type, uvtPosition: new Point(0, 1, 1) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint3.clone().add(this.getZ()), geoType: this.type, uvtPosition: new Point(-1, 0, 1) },
            { type: FEATURE_POINT_TYPE.QUADRANTAL, point: sidePoint4.clone().add(this.getZ()), geoType: this.type, uvtPosition: new Point(0, -1, 1) },
            { type: FEATURE_POINT_TYPE.FACE_CENTER, point: this.getP(), geoType: this.type, uvtPosition: new Point(0, 0, 0) },
            { type: FEATURE_POINT_TYPE.FACE_CENTER, point: this.getP().add(this.getZ()), geoType: this.type, uvtPosition: new Point(0, 0, 1) },
        ];
    }
    toJson() {
        return Object.assign({ type: this.type }, super.toJson());
    }
}/**
 * 矩形基面
 * 用局部坐标系基点表示矩形左下角，
 * 用局部坐标系的x轴表示矩形的长边的方向与长度
 * 用局部坐标系的y轴表示矩形的宽边的方向与长度
 * 用局部坐标系的z轴表示矩形所在平面的法向量
 */
class RectFace extends Plane$1 {
    /**
     * 矩形基面
     * 用局部坐标系基点表示矩形左下角，
     * 用局部坐标系的x轴表示矩形的长边的方向与长度
     * 用局部坐标系的y轴表示矩形的宽边的方向与长度
     * 用局部坐标系的z轴表示矩形所在平面的法向量
     * @param basePoint 基点
     * @param vecX x轴，含方向与长度信息
     * @param vecY y轴，含方向与长度信息
     */
    constructor(basePoint = new Point(), vecX = new Vector3$1(1, 0, 0), vecY = new Vector3$1(0, 1, 0)) {
        super();
        this.type = 'RectFace';
        let dirZ = vecX.clone().cross(vecY).normalize();
        this.transformMatrix.set(vecX.x, vecY.x, dirZ.x, basePoint.x, vecX.y, vecY.y, dirZ.y, basePoint.y, vecX.z, vecY.z, dirZ.z, basePoint.z, 0, 0, 0, 1);
    }
    clone() {
        return new RectFace().copy(this);
    }
    getCenter(target) {
        if (target == null) {
            target = new Point();
        }
        this.getPointAt(0.5, 0.5, target);
        return target;
    }
    /**
     * 获取矩形面上的插值点
     * @param t 长度（x轴）方向插值比例
     * @param u 宽度（y轴）方向插值比例
     * @param target 插值点引用对象
     * @returns
     */
    getPointAt(t, u, target) {
        if (target == null) {
            target = new Point();
        }
        // const matArr = this.transformMatrix.elements;
        // target.set(
        //     matArr[12] + t * matArr[0] + u * matArr[4], 
        //     matArr[13] + t * matArr[1] + u * matArr[5], 
        //     matArr[14] + t * matArr[2] + u * matArr[6]
        // );
        // return target;
        // 统一化，使用局部坐标点加上变换矩阵的方法
        target.set(t, u, 0).applyMatrix4(this.transformMatrix);
        return target;
    }
    toJson() {
        let data = Object.assign({ version: "1.1", type: this.type }, super.toJson());
        return data;
    }
    getSideEdges() {
        let res = [];
        let point1 = this.getPointAt(0, 0);
        let point2 = this.getPointAt(1, 0);
        let point3 = this.getPointAt(1, 1);
        let point4 = this.getPointAt(0, 1);
        res.push(new Line$2(point1, point2));
        res.push(new Line$2(point2, point3));
        res.push(new Line$2(point3, point4));
        res.push(new Line$2(point4, point1));
        return res;
    }
    /**
     * 获取包围盒
     * @returns
     */
    getBoundingBox() {
        let point1 = this.getPointAt(0, 0);
        let point2 = this.getPointAt(1, 0);
        let point3 = this.getPointAt(1, 1);
        let point4 = this.getPointAt(0, 1);
        let minX = Math.min(point1.x, point2.x, point3.x, point4.x);
        let minY = Math.min(point1.y, point2.y, point3.y, point4.y);
        let minZ = Math.min(point1.z, point2.z, point3.z, point4.z);
        let maxX = Math.max(point1.x, point2.x, point3.x, point4.x);
        let maxY = Math.max(point1.y, point2.y, point3.y, point4.y);
        let maxZ = Math.max(point1.z, point2.z, point3.z, point4.z);
        return {
            min: new Vector3$1(minX, minY, minZ),
            max: new Vector3$1(maxX, maxY, maxZ),
        };
    }
    /**
     * 获取特征点
     * @returns
     */
    getFeaturePoints() {
        return [
            { type: FEATURE_POINT_TYPE.END, point: this.getPointAt(0, 0), geoType: this.type },
            { type: FEATURE_POINT_TYPE.END, point: this.getPointAt(1, 0), geoType: this.type },
            { type: FEATURE_POINT_TYPE.END, point: this.getPointAt(1, 1), geoType: this.type },
            { type: FEATURE_POINT_TYPE.END, point: this.getPointAt(0, 1), geoType: this.type },
            { type: FEATURE_POINT_TYPE.MIDDLE, point: this.getPointAt(0.5, 0), geoType: this.type },
            { type: FEATURE_POINT_TYPE.MIDDLE, point: this.getPointAt(1, 0.5), geoType: this.type },
            { type: FEATURE_POINT_TYPE.MIDDLE, point: this.getPointAt(0.5, 1), geoType: this.type },
            { type: FEATURE_POINT_TYPE.MIDDLE, point: this.getPointAt(0, 0.5), geoType: this.type },
        ];
    }
    /**
     * 获取控制点
     * @returns
     */
    getControlPoints() {
        return [
            { type: FEATURE_POINT_TYPE.END, point: this.getPointAt(0, 0), geoType: this.type },
            { type: FEATURE_POINT_TYPE.END, point: this.getPointAt(1, 0), geoType: this.type },
            { type: FEATURE_POINT_TYPE.END, point: this.getPointAt(1, 1), geoType: this.type },
            { type: FEATURE_POINT_TYPE.END, point: this.getPointAt(0, 1), geoType: this.type },
        ];
    }
}/**
 * 平面任意面域
 */
class RegionFace extends Plane$1 {
    /**
     * x轴设置方法
     */
    set axisX(value) {
        this.setXYZ(value, this.normal);
    }
    /**
     * x轴获取方法
     */
    get axisX() {
        return this.getX();
    }
    /**
     * 构造方法
     * @param edges 边数组
     * @param axisX x轴
     * @param basePoint 基点
     */
    constructor(edges = [], axisX = new Vector3$1(1, 0, 0), basePoint = null) {
        super();
        /**
         * 类型
         */
        this.type = 'RegionFace';
        /**
         * 边点列表
         */
        this.vertexList = [];
        /**
         * 边数组
         */
        this.edges = [];
        /**
         * 洞数组
         */
        this.holes = [];
        //初始化边
        this.edges = edges.map(edge => edge.clone());
        //初始化x轴向量
        if (axisX)
            this.axisX = axisX.normalize();
        //初始化normal与洞数据结构
        this.generate();
        //指定基点，如果没有基点，则将所有顶点的平均值作为基点
        if (basePoint) {
            this.setP(basePoint);
        }
        else {
            const P = new Point();
            this.vertexList.forEach(point => {
                P.add(point);
            });
            if (this.vertexList.length > 0) {
                P.multiplyScalar(1 / this.vertexList.length);
            }
            this.setP(P);
        }
        let inverseMatrix = this.transformMatrix.clone().invert();
        this.edges.forEach(edge => {
            edge.transformMatrix.premultiply(inverseMatrix);
        });
        this.holes.forEach(hole => {
            hole.transformMatrix.premultiply(inverseMatrix);
        });
    }
    /**
     * 设置底面
     * @param edges
     * @param axisX
     */
    setRegionFace(edges = [], holes = [], axisX) {
        if (edges.length > 0) {
            this.edges = edges.map(edge => edge.clone());
        }
        if (holes.length > 0) {
            this.holes = holes.map(hole => hole.clone());
        }
        if (axisX)
            this.axisX = axisX.normalize();
        this.generate();
        let inverseMatrix = this.transformMatrix.clone().invert();
        this.edges.forEach(edge => {
            edge.transformMatrix.premultiply(inverseMatrix);
        });
        this.holes.forEach(hole => {
            hole.transformMatrix.premultiply(inverseMatrix);
        });
    }
    /**
     * 复制
     * @param regionFace
     * @returns
     */
    copy(regionFace) {
        super.copy(regionFace);
        if (this.edges.length === regionFace.edges.length) {
            this.edges.forEach((edge, idx) => {
                if (edge.type === regionFace.edges[idx].type) {
                    edge.copy(regionFace.edges[idx]);
                }
                else {
                    this.edges[idx] = regionFace.edges[idx].clone();
                }
            });
        }
        else {
            let edges = regionFace.edges.map(item => item.clone());
            this.edges = [...edges];
        }
        if (this.holes.length === regionFace.holes.length) {
            this.holes.forEach((hole, idx) => {
                hole.copy(regionFace.holes[idx]);
            });
        }
        else {
            this.holes = regionFace.holes.map(item => item.clone());
        }
        if (this.vertexList.length === regionFace.vertexList.length) {
            this.vertexList.forEach((vertex, idx) => {
                vertex.copy(regionFace.vertexList[idx]);
            });
        }
        else {
            this.vertexList = regionFace.vertexList.map(vertex => vertex.clone());
        }
        this.generate(false);
        return this;
    }
    clone() {
        return new RegionFace().copy(this);
    }
    /**
     * 生成面域，顶点、包围盒与
     */
    generate(init = true) {
        if (this.vertexList.length === 0) {
            for (let i = 0; i < this.edges.length; i++) {
                let edge = this.edges[i];
                let endPoints = edge.getEndPoints();
                if (endPoints.length > 0) {
                    this.vertexList.push(endPoints[0]);
                }
            }
            this.holes.forEach(hole => {
                hole.edges.forEach(edge => {
                    let endPoints = edge.getEndPoints();
                    if (endPoints.length > 0) {
                        this.vertexList.push(endPoints[0]);
                    }
                });
            });
        }
        if (init) {
            if (this.edges.length === 1) {
                if (this.edges[0] instanceof Circle) {
                    let circle = this.edges[0];
                    this.setFromNormalAndCoplanarPoint(circle.normal, circle.center);
                }
                else if (this.edges[0] instanceof Ellipse) {
                    let ell = this.edges[0];
                    this.setFromNormalAndCoplanarPoint(ell.normal, ell.getCenter());
                }
            }
            else if (this.vertexList.length === 2) {
                if (this.edges[0] instanceof Arc) {
                    let arc = this.edges[0];
                    this.setFromNormalAndCoplanarPoint(arc.normal, arc.center);
                }
                else if (this.edges[1] instanceof Arc) {
                    let arc = this.edges[1];
                    this.setFromNormalAndCoplanarPoint(arc.normal, arc.center);
                }
            }
            else if (this.vertexList.length > 2) {
                this.setFromCoplanarPoints(this.vertexList[0], this.vertexList[1], this.vertexList[2]);
            }
            for (let i = 0; i < this.edges.length; i++) {
                const l = this.edges[i];
                if (l.type === "Line") {
                    l.setXYZ(l.getNormalizeX(), this.getNormalizeZ());
                }
            }
        }
    }
    /**
     * 获取特征点
     * @returns
     */
    getFeaturePoints() {
        const res = [];
        if (this.edges.length === 1) {
            res.push(...this.edges[0].getFeaturePoints());
            // if (this.edges[0] instanceof Circle || this.edges[0].type === 'Circle') {
            //     let circle = this.edges[0] as Circle;
            //     return [
            //         { type: FEATURE_POINT_TYPE.CENTER, point: circle.center.applyMatrix4(this.transformMatrix), geoType: this.type },
            //     ]
            // }
        }
        else {
            this.edges.forEach(edge => {
                res.push({ type: FEATURE_POINT_TYPE.END, point: edge.getPointAt(0).applyMatrix4(this.transformMatrix), geoType: this.type });
                res.push({ type: FEATURE_POINT_TYPE.MIDDLE, point: edge.getPointAt(0.5).applyMatrix4(this.transformMatrix), geoType: this.type });
            });
        }
        // hole
        return [...res];
    }
    /**
     * 获取包围盒
     * @returns
     */
    getBoundingBox() {
        // if (this.edges.length === 1) {
        //     if (this.edges[0] instanceof Circle) {
        //         let circle = this.edges[0];
        //         return circle.getBoundingBox();
        //     }
        // }
        let min = new Vector3$1(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        let max = new Vector3$1(Number.MIN_VALUE, Number.MIN_VALUE, Number.MIN_VALUE);
        for (const edge of this.edges) {
            const box = edge.getBoundingBox();
            min.x = Math.min(min.x, box.min.x);
            min.y = Math.min(min.y, box.min.y);
            min.z = Math.min(min.z, box.min.z);
            max.x = Math.max(max.x, box.max.x);
            max.y = Math.max(max.y, box.max.y);
            max.z = Math.max(max.z, box.max.z);
        }
        min.applyMatrix4(this.transformMatrix);
        max.applyMatrix4(this.transformMatrix);
        return { min, max };
    }
    /**
     * 获取控制点
     * @returns
     */
    getControlPoints() {
        if (this.edges.length === 1) {
            if (this.edges[0] instanceof Circle) {
                let circle = this.edges[0];
                return [
                    { type: FEATURE_POINT_TYPE.CENTER, point: circle.center, geoType: this.type },
                ];
            }
        }
        this.edges.map(edge => {
            return [
                { type: FEATURE_POINT_TYPE.END, point: edge.getPointAt(0), geoType: this.type }
            ];
        });
        return [];
    }
    getCenter(target) {
        if (target == null) {
            target = new Point();
        }
        if (this.edges.length === 1 && (this.edges[0].type === 'Circle' || this.edges[0].type === 'Ellipse')) {
            target.copy(this.edges[0].getCenter());
            target.applyMatrix4(this.transformMatrix);
            return target;
        }
        let count = 0;
        let sum = new Point();
        this.vertexList.forEach(item => {
            sum.add(item);
            count++;
        });
        if (count === 0)
            return target;
        target.copy(sum).divideScalar(count);
        target.applyMatrix4(this.transformMatrix);
        return target;
    }
    /**
     * 获取多边形基点
     * @param target 传入点（可避免重复创建对象）
     * @returns
     */
    getBasePoint(target) {
        if (target == null) {
            target = new Point();
        }
        this.getP(target);
        return target;
    }
    //todo
    isPointInRegionFace(point) {
        // 假设curve已经成环且排好序了
        return false;
    }
    // 面积
    getArea() {
        // 边界围成的面积
        let edgeArea = this.getAreaByEdges(this.edges);
        // 洞的面积
        let holeArea = 0;
        this.holes.forEach(hole => {
            holeArea += this.getAreaByEdges(hole.edges);
        });
        return edgeArea - holeArea;
    }
    //TODO 如何从外部传入分割值
    // _prevVector: Vector3 = new Vector3();
    // _nextVector: Vector3 = new Vector3();
    getAreaByEdges(curves) {
        // const _prevVector: Vector3 = new Vector3();
        // const _nextVector: Vector3 = new Vector3();
        // // 由有序的边得到的顶点
        // let points: Point[] = [];
        // let noRepeatPoints: Point[] = [];
        // curves.forEach(edge => {
        //     points.push(...edge.getPoints());
        // })
        // // 对顶点去重
        // points.forEach(point => {
        //     if (!noRepeatPoints.some(item => item.equals(point))) {
        //         noRepeatPoints.push(point);
        //     }
        // })
        // /**         
        //  * 计算多边形面积，参考文献：[1]韦品瑚,晓伟.三维空间多边形的面积计算[J].数学通报,1984(02):18-21. 引理2
        //  * 空间多边形A1A2...An的面积S=1/2 * |A1A2 * A1A3 + A1A3 * A1A4 + ... + A1An-1 * A1An|
        //  */
        // if (noRepeatPoints.length < 3) return 0;
        // // 第一个点
        // let firstPoint = noRepeatPoints[0];
        // // 矢量积
        // let vectorProduct = new Vector3();
        // for (let i = 2; i <= noRepeatPoints.length - 1; i++) {
        //     // A1Ai-1
        //     _prevVector.subVectors(noRepeatPoints[i - 1], firstPoint);
        //     // A1Ai
        //     _nextVector.subVectors(noRepeatPoints[i], firstPoint);
        //     // A1Ai-1 * A1Ai
        //     vectorProduct.add(_prevVector.cross(_nextVector));
        // }
        // return vectorProduct.length() / 2
        return 0;
    }
    //TODO 重写获取点的方法
    getPoints() {
        let points = [];
        // for (let i = 0; i < this.edges.length; i++) {
        //     let midList = [...this.edges[i].getPoints()]
        //     points.push(...midList)
        // }
        // for (let i = 0; i < this.holes.length; i++) {
        //     points.push(...this.holes[i].getPoints())
        // }
        return points;
    }
    //TODO 重写获取点的方法
    getPointsNoLoop() {
        let points = [];
        // for (let i = 0; i < this.edges.length; i++) {
        //     let midList = [...this.edges[i].getPoints()]
        //     // if (this.edges[i].type == 'Circle') {
        //     midList.pop()
        //     // }
        //     points.push(...midList)
        // }
        // for (let i = 0; i < this.holes.length; i++) {
        //     points.push(...this.holes[i].getPointsNoLoop())
        // }
        return points;
    }
    // generateRings(rings: Ring[], polygon: RegionFace) {
    //     let ring: Ring = [];
    //     polygon.edges.forEach(edge => {
    //         //TODO 需要移动至外部
    //         let points: Point[] = [];
    //         for (let d = 0; d <= division; d++) {
    //             points.push(this.getPointAt(d / division));
    //         }
    //         let points = edge.getPoints();
    //         for (let i = 0; i < points.length - 1; i++) {
    //             ring.push(new Line(points[i].clone(), points[i + 1].clone()));
    //         }
    //     });
    //     rings.push(ring);
    //     polygon.holes.forEach(polygon => {
    //         this.generateRings(rings, polygon);
    //     })
    // }
    // /**
    //  * 转化为一般面域
    //  * @returns 
    //  */
    // toGeneralRegion(): GeneralRegion {
    //     let res = new GeneralRegion();
    //     res.normal = this.normal;
    //     let rings: Ring[] = [];
    //     return this;
    // }
    // overwrite
    toJson() {
        let data = Object.assign(Object.assign({}, super.toJson()), { version: "1.0", type: this.type, edges: this.edges.map(edge => edge.toJson()), holes: this.holes.map(hole => hole.toJson()) });
        return data;
    }
    fromJson(json) {
        super.fromJson(json);
        //生成边
        this.edges = json.edges.map(item => {
            let edge = new BaseCurveTrans[item.type]().fromJson(item);
            return edge;
        });
        //没有洞的情况，直接生成
        if (json.holes == null || json.holes.length === 0) {
            this.holes = [];
            this.generate(false);
            return this;
        }
        //生成洞
        this.holes = json.holes.map(jsonhole => {
            let hole = new RegionFace().fromJson(jsonhole);
            return hole;
        });
        this.generate(false);
        return this;
    }
    getSideEdges() {
        let res = [];
        let regionNormal = this.getNormalizeZ();
        for (let i = 0; i < this.edges.length; i++) {
            let edge = this.edges[i].clone();
            // 将线的法向量设置为面域的法向量
            if (edge.getNormalizeZ().dot(regionNormal) < -1e-6) {
                edge.reverse();
            }
            edge.transformMatrix.premultiply(this.transformMatrix);
            res.push(edge);
        }
        for (let i = 0; i < this.holes.length; i++) {
            res.push(...this.holes[i].getSideEdges());
        }
        return res;
    }
}/**
 * 球面
 * 其局部坐标系定义为半径为1，基点为(0,0,0)的面
 */
let Spherical$1=class Spherical extends Surface {
    // radius: number;
    // center: Point;
    get center() {
        return new Point().copy(this.getP());
    }
    set center(value) {
        this.setP(value);
    }
    /**
     * 半径
     */
    get radius() {
        return this.scaleX;
    }
    /**
     * 设置半径
     */
    set radius(value) {
        let scale = value / this.scaleX;
        if (scale == 0)
            scale = 1;
        this.scale(this.getP(), scale);
    }
    constructor(center = new Point(), radius = 0) {
        super();
        /*1.初始定义与构造*/
        this.type = 'Spherical';
        this.center = center;
        this.radius = radius;
        this.transformMatrix.set(radius, 0, 0, center.x, 0, radius, 0, center.y, 0, 0, radius, center.z, 0, 0, 0, 1);
    }
    getCenter(target) {
        if (target == null) {
            target = new Point();
        }
        target.copy(this.center);
        return target;
    }
    /**
     * 获取包围盒
     * @returns
     */
    getBoundingBox() {
        const min = new Point(-1, -1, -1);
        const max = new Point(1, 1, 1);
        min.applyMatrix4(this.transformMatrix);
        max.applyMatrix4(this.transformMatrix);
        return {
            min: min,
            max: max,
        };
    }
    /**
     * 获取特征点
     * @returns
     */
    getFeaturePoints() {
        return [];
    }
    /**
     * 获取控制点
     * @returns
     */
    getControlPoints() {
        return [];
    }
    getPointAt(t, u, target) {
        if (target == null) {
            target = new Point();
        }
        // 将 t 和 u 转换为经纬度角度
        const theta = t * Math.PI * 2; // θ：绕 Z 轴的角度 (0 ~ 2π)
        const phi = u * Math.PI; // φ：从北极到南极的角度 (0 ~ π)
        // 球面参数化公式计算局部坐标系点
        const x = Math.sin(phi) * Math.cos(theta);
        const y = Math.sin(phi) * Math.sin(theta);
        const z = Math.cos(phi);
        // 统一化，使用局部坐标点加上变换矩阵的方法
        target.set(x, y, z).applyMatrix4(this.transformMatrix);
        return target;
    }
    clone() {
        return new Spherical().copy(this);
    }
    equals(spherical) {
        if (!this.center.equals(spherical.center))
            return false;
        if (Math.abs(this.radius - spherical.radius) > 1e-6)
            return false;
        return true;
    }
    toJson() {
        return Object.assign({ version: "1.0", type: this.type }, super.toJson());
    }
};class SweeperSurface extends Surface {
    /**
     * 构造函数
     * @param baseCurve 扫掠基线(二维曲线)
     * @param sweepPath 扫掠路径(只实现二维曲线)
     * @param basePoint 扫掠基线基点
     * @param angle 沿轴修正角度
     */
    constructor(baseCurve, sweepPath, basePoint, angle = 0) {
        super();
        /**
         * 几何类型
         */
        this.type = 'SweeperSurface';
        if (baseCurve) {
            this.baseCurve = baseCurve.clone();
        }
        if (sweepPath) {
            this.sweepPath = sweepPath.clone();
        }
        if (basePoint == null) {
            // 未指定扫掠基点，进行默认处理
            this.basePoint = SweeperSurface.getCurveCenterPoint(baseCurve);
        }
        else {
            this.basePoint = basePoint.clone();
        }
        // 对基线进行平移变换，将基线变换到原点位置
        const transM = new Matrix4$1(1, 0, 0, -this.basePoint.x, 0, 1, 0, -this.basePoint.y, 0, 0, 1, -this.basePoint.z, 0, 0, 0, 1);
        if (this.baseCurve) {
            this.baseCurve.transformMatrix.premultiply(transM);
        }
        this.angle = angle;
    }
    /**
     * 获取曲线的默认基点
     * @param curve 曲线
     * @param type 曲线类型
     * @returns 返回曲线基点
     */
    static getCurveCenterPoint(curve) {
        if (curve == null) {
            return new Point(0, 0, 0);
        }
        // 只对几种特殊曲线做处理
        if (curve instanceof Line$1) { // 对直线做特殊处理
            const pointStart = curve.getEndPoints()[0];
            const pointEnd = curve.getEndPoints()[1];
            return new Point((pointStart.x + pointEnd.x) / 2, (pointStart.y + pointEnd.y) / 2, (pointStart.z + pointEnd.z) / 2);
        }
        if (curve instanceof Circle) { // 对圆做特殊处理
            return curve.center;
        }
        if (curve instanceof Ellipse) { // 对椭圆做特殊处理
            return curve.center;
        }
        // 其他默认返回起始点
        return curve.getEndPoints()[0];
    }
    /**
     * 获取当前点
     * @param t 扫掠路径插值位置
     * @param u 扫掠基线插值位置
     * @param target 获取点
     * @returns
     */
    getPointAt(t, u, target) {
        if (target == null) {
            target = new Point();
        }
        // 获取路径上的点
        this.sweepPath.getPointAt(t, targetPath);
        // 获取路径上点的切向量
        this.sweepPath.getCutLineDir(targetPath, direct);
        // 构造方位变换矩阵 
        // 扫掠方向向量
        this.baseCurve.getNormalizeZ(normal);
        // 计算法向量和切向量之间的变换矩阵
        direct.normalize();
        normal.normalize();
        const rotationMatrix = this.getRotationMatrix(normal, direct);
        // 构造平移变换矩阵2
        const transM = new Matrix4$1(1, 0, 0, targetPath.x, 0, 1, 0, targetPath.y, 0, 0, 1, targetPath.z, 0, 0, 0, 1);
        const baseCurveClone = this.baseCurve.clone();
        baseCurveClone.transformMatrix.premultiply(rotationMatrix);
        // 沿扫掠方向向量旋转修正y轴，将y轴和扫掠路径z轴对齐
        const rotaMY = this.getRotationMatrix(baseCurveClone.getNormalizeY(), this.sweepPath.getNormalizeZ(), direct);
        baseCurveClone.transformMatrix.premultiply(rotaMY);
        // 根据偏移量修正y轴
        baseCurveClone.rotate(new Point(0, 0, 0), baseCurveClone.getNormalizeZ(), this.angle);
        baseCurveClone.transformMatrix.premultiply(transM);
        baseCurveClone.getPointAt(u, target);
        return target;
    }
    /**
     * 构造旋转矩阵
     * @param vecOrigin 物体原先方向
     * @param vecTarget 旋转后物体方向
     * @param axis 用户指定旋转轴(当物体旋转角度为PI的时候才有效果)
     * @returns
     */
    getRotationMatrix(vecOrigin, vecTarget, axis) {
        vecOrigin.normalize();
        vecTarget.normalize();
        // 计算旋转轴
        const myAxis = new Vector3$1().crossVectors(vecOrigin, vecTarget);
        // 计算旋转角度
        const angle = Math.acos(vecOrigin.dot(vecTarget));
        // 构造旋转矩阵
        if (Math.abs(angle - Math.PI) < Number.EPSILON && axis != null) {
            // 判断旋转角度是否为pi，在旋转角度为pi时用户可以自定义旋转轴
            return new Matrix4$1().makeRotationAxis(axis.normalize(), angle);
        }
        return new Matrix4$1().makeRotationAxis(myAxis.normalize(), angle);
    }
    copy(geo) {
        super.copy(geo);
        this.baseCurve = geo.baseCurve.clone();
        this.sweepPath = geo.sweepPath.clone();
        this.basePoint = geo.basePoint.clone();
        this.angle = geo.angle;
        return this;
    }
    clone() {
        return new SweeperSurface().copy(this);
    }
    getBoundingBox() {
        // 初始化最小值和最大值为无穷
        const min = new Point(Infinity, Infinity, Infinity);
        const max = new Point(-Infinity, -Infinity, -Infinity);
        const numSamples = 15; // 采样点数
        for (let i = 0; i < numSamples; i++) {
            for (let j = 0; j < numSamples; j++) {
                this.getPointAt(i / numSamples, j / numSamples, point);
                // 更新最小值和最大值
                min.x = Math.min(min.x, point.x);
                min.y = Math.min(min.y, point.y);
                min.z = Math.min(min.z, point.z);
                max.x = Math.max(max.x, point.x);
                max.y = Math.max(max.y, point.y);
                max.z = Math.max(max.z, point.z);
            }
        }
        return {
            min: min,
            max: max
        };
    }
    /**
     * 抽象成json数据格式
     * @returns
     */
    toJson() {
        return Object.assign(Object.assign({}, super.toJson()), { version: "1.1", type: this.type, baseCurve: this.baseCurve.toJson(), sweepPath: this.sweepPath.toJson(), basePoint: {
                x: this.basePoint.x,
                y: this.basePoint.y,
                z: this.basePoint.z,
            }, angle: this.angle });
    }
    /**
     * 解析json数据
     * @param json
     * @returns
     */
    fromJson(json) {
        super.fromJson(json);
        this.baseCurve = new BaseCurveTrans[json.baseCurve.type]().fromJson(json.baseCurve);
        this.sweepPath = new BaseCurveTrans[json.sweepPath.type]().fromJson(json.sweepPath);
        this.basePoint = new Point(json.basePoint.x, json.basePoint.y, json.basePoint.z);
        this.angle = json.angle;
        return this;
    }
}
const normal = new Vector3$1();
const direct = new Vector3$1();
const targetPath = new Point();
const point = new Point();/**
 * 梯形
 * 其局部坐标系定义为底边长度为1，高度为1梯形,x轴为底边方向,y轴为底边高度方向,z轴为法向量方向,原点为底边一端点  todo修改顶边定义
 */
class Trapezoid extends Surface {
    /**
     * 端点
     */
    get center() {
        return this.getP();
    }
    /**
     * 设置端点
     */
    set center(value) {
        this.setP(value);
    }
    /**
     * 法向量
     */
    get normal() {
        return this.getNormalizeZ();
    }
    /**
     * 底边长度
     */
    get length() {
        return this.scaleX;
    }
    /**
     * 设置底边长度,同时因为顶边长度储存格式为底边的比例，所以也需要更新Z轴缩放比例
     */
    set length(value) {
        let scale = value / this.scaleX;
        if (scale == 0)
            scale = 1;
        this.scale(this.getP(), scale, 1, 1 / scale);
    }
    /**
     * 高度
     */
    get height() {
        return this.scaleY;
    }
    /**
     * 设置底边上的高度
     */
    set height(value) {
        let scale = value / this.scaleY;
        if (scale == 0)
            scale = 1;
        this.scale(this.getP(), 1, scale, 1);
    }
    /**
    * 顶边长度，以底边长度为基准计算比例存入在Z轴上，以避免后续对矩阵的修改导致顶边长度的变化
    */
    get length2() {
        return this.scaleZ * this.length_2;
    }
    /**
     * 设置顶边上的高度
     */
    set length2(value) {
        let scale = value / this.scaleX;
        if (scale == 0)
            scale = 1;
        this.length_2 = scale;
    }
    /**
     * 构造函数
        * @param center 底边端点
        * @param length 底边长度
        * @param height 高度
        * @param length2 顶边长度
        * @param normal 法向量
        * @param axisX x轴方向
        * @param angle 端点所在角的角度
     */
    constructor(center = new Point(), length = 1, height = 1, length2 = 1, normal = new Vector3$1(0, 0, 1), axisX = new Vector3$1(1, 0, 0), angle = Math.PI / 2) {
        super();
        /**
         * 类型
         */
        this.type = 'Trapezoid';
        this.transformMatrix.elements[8] = normal.x;
        this.transformMatrix.elements[9] = normal.y;
        this.transformMatrix.elements[10] = normal.z;
        axisX.normalize();
        this.updateMatrixByX(axisX, false);
        if (length <= 0)
            length = 1;
        this.length = length;
        if (height <= 0)
            height = 1;
        this.height = height;
        if (length2 <= 0)
            length2 = 1;
        this.length2 = length2;
        this.center = center;
        while (angle > 2 * Math.PI || angle < 0) {
            if (angle > 2 * Math.PI)
                angle -= 2 * Math.PI;
            if (angle < 0)
                angle += 2 * Math.PI;
        }
        this.angle = angle;
    }
    /**
     * 设置属性
     * @param key
     * @param value
     * @returns
     */
    set(key, value) {
        if (key == "center") {
            if (!(value instanceof Point))
                return;
            this.center = value;
        }
        else if (key == "length") {
            if (typeof value !== 'number')
                return;
            this.length = value;
        }
        else if (key == "height") {
            if (typeof value !== 'number')
                return;
            this.height = value;
        }
        else if (key == "length2") {
            if (typeof value !== 'number')
                return;
            this.length2 = value;
        }
        else if (key == "angle") {
            if (typeof value !== 'number')
                return;
            let angle = value;
            while (angle > 2 * Math.PI || angle < 0) {
                if (angle > 2 * Math.PI)
                    angle -= 2 * Math.PI;
                if (angle < 0)
                    angle += 2 * Math.PI;
            }
            this.angle = angle;
        }
    }
    /**
     * 克隆
     * @returns
     */
    clone() {
        return new Trapezoid().copy(this);
    }
    /**
     * 复制
     * @param trapezoid
     * @returns
     */
    copy(trapezoid) {
        super.copy(trapezoid);
        this.angle = trapezoid.angle;
        return this;
    }
    /**
     * 获取梯形上的插值点（只能获得端点）
     * @param u u=0时为左边端点，u=1时为右边端点
     * @param v v=0时为底边端点，v=1时为顶边端点
     * 其余情况均返回原点
     * @param target 插值点引用对象
     * @returns
     */
    getPointAt(u, v, target) {
        if (target == null) {
            target = new Point().copy(this.getP());
        }
        if (u == 0 && v == 0) {
            target.copy(this.getP());
        }
        else if (u == 1 && v == 0) {
            target.set(1, 0, 0).applyMatrix4(this.transformMatrix);
        }
        else if (u == 0 && v == 1) {
            {
                let dx = 1 / Math.tan(this.angle);
                target.set(dx, 1, 0).applyMatrix4(this.transformMatrix);
            }
        }
        else if (u == 1 && v == 1) {
            let dx = 1 / Math.tan(this.angle);
            target.set(this.length2 + dx, 1, 0).applyMatrix4(this.transformMatrix);
        }
        return target;
    }
    /**
     * 抽象成json数据格式
     * @returns
     */
    toJson() {
        let data = Object.assign({ type: this.type, angle: this.angle }, super.toJson());
        return data;
    }
    /**
     * 解析json数据成三角形对象
     * @param json
     * @returns
     */
    fromJson(json) {
        super.fromJson(json);
        this.angle = json.angle;
        return this;
    }
    /**
     * 判断相等
     * @param Trapezoid
     * @returns
     */
    equals(trapezoid) {
        if (!this.matrixEquals(trapezoid.transformMatrix))
            return false;
        if (this.angle != trapezoid.angle)
            return false;
        return true;
    }
    getSideEdges() {
        let res = [];
        let point1 = this.getPointAt(0, 0);
        let point2 = this.getPointAt(1, 0);
        let point3 = this.getPointAt(1, 1);
        let point4 = this.getPointAt(0, 1);
        res.push(new Line$2(point1, point2));
        res.push(new Line$2(point2, point3));
        res.push(new Line$2(point3, point4));
        res.push(new Line$2(point4, point1));
        return res;
    }
}/**
 * 三角形
 * 其局部坐标系定义为底边长度为1，高度为1三角形,x轴为底边方向,y轴为高度方向,z轴为法向量方向,原点为底边一端点
 */
let Triangle$1=class Triangle extends Surface {
    /**
     * 端点
     */
    get center() {
        return this.getP();
    }
    /**
     * 设置端点
     */
    set center(value) {
        this.setP(value);
    }
    /**
     * 法向量
     */
    get normal() {
        return this.getNormalizeZ();
    }
    /**
     * 底边长度
     */
    get length() {
        return this.scaleX;
    }
    /**
     * 设置底边长度
     */
    set length(value) {
        let scale = value / this.scaleX;
        if (scale == 0)
            scale = 1;
        this.scale(this.getP(), scale, 1, 1);
    }
    /**
     * 高度
     */
    get height() {
        return this.scaleY;
    }
    /**
     * 设置底边上的高度
     */
    set height(value) {
        let scale = value / this.scaleY;
        if (scale == 0)
            scale = 1;
        this.scale(this.getP(), 1, scale, 1);
    }
    /**
     * 构造函数
        * @param first 第一点 A
        * @param second 第二点 B
        * @param third 第三点 C
        * 第一点A为原点，第二点B减去第一点作为A BA x轴， BA叉乘CA作为Z轴
     */
    constructor(first = new Point(), second = new Point(), third = new Point()) {
        super();
        /**
         * 类型
         */
        this.type = 'Triangle';
        this.setByThreePoints(first, second, third);
    }
    /**
     * 设置属性
     * @param key
     * @param value
     * @returns
     */
    set(key, value) {
        if (key == "center") {
            if (!(value instanceof Point))
                return;
            this.center = value;
        }
        else if (key == "length") {
            if (typeof value !== 'number')
                return;
            this.length = value;
        }
        else if (key == "height") {
            if (typeof value !== 'number')
                return;
            this.height = value;
        }
        else if (key == "angle") {
            if (typeof value !== 'number')
                return;
            let angle = value;
            while (angle > 2 * Math.PI || angle < 0) {
                if (angle > 2 * Math.PI)
                    angle -= 2 * Math.PI;
                if (angle < 0)
                    angle += 2 * Math.PI;
            }
            this.angle = angle;
        }
    }
    /**
     * 根据三点生成三角形
     * @param p1 原点
     * @param p2 底边端点
     * @param p3 顶点
     * @returns
     */
    setByThreePoints(p1, p2, p3) {
        //根据三点计算三角形信息
        _v1$1$1.subVectors(p2, p1);
        let s1 = _v1$1$1.length();
        if (s1 < 1e-6) {
            _v1$1$1.set(1, 0, 0);
            s1 = 1e-5;
        }
        _v1$1$1.normalize();
        _v2Old.subVectors(p3, p1);
        let s2 = _v2Old.length();
        if (s2 < 1e-6) {
            if (Math.abs(_v1$1$1.dot(_v3$5.set(0, 1, 0))) > 1 - 1 / 64) {
                _v2$7.set(0, 0, 1);
            }
            else {
                _v2$7.set(0, 1, 0);
            }
        }
        else {
            _v2$7.copy(_v2Old);
        }
        //v3
        _v3$5.crossVectors(_v1$1$1, _v2$7).normalize();
        //v2
        _v2$7.crossVectors(_v3$5, _v1$1$1).normalize();
        //s2
        if (s2 < 1e-6) {
            s2 = 1e-5;
        }
        else {
            s2 = _v2$7.dot(_v2Old);
        }
        this.transformMatrix.set(_v1$1$1.x * s1, _v2$7.x * s2, _v3$5.x, p1.x, _v1$1$1.y * s1, _v2$7.y * s2, _v3$5.y, p1.y, _v1$1$1.z * s1, _v2$7.z * s2, _v3$5.z, p1.z, 0, 0, 0, 1);
        let theta = Math.acos(_v1$1$1.dot(_v2Old) / _v1$1$1.length() / _v2Old.length());
        let mark = _v1$1$1.clone().cross(_v2Old).dot(_v3$5);
        if (mark < 0) {
            this.angle = 2 * Math.PI - theta;
        }
        this.angle = theta;
    }
    /**
     * 克隆
     * @returns
     */
    clone() {
        return new Triangle().copy(this);
    }
    /**
     * 复制
     * @param triangle
     * @returns
     */
    copy(triangle) {
        super.copy(triangle);
        this.angle = triangle.angle;
        return this;
    }
    /**
     * 获取三角形上的插值点（只能获得端点）
     * @param u u=0时为左边端点，u=1时为右边端点
     * @param v v=0时为底边端点，v=1时为顶边端点
     * 其余情况均返回原点
     * @param target 插值点引用对象
     * @returns
     */
    //todo 有问题·，因为xy坐标轴缩放不一样
    getPointAt(u, v, target) {
        if (target == null) {
            target = new Point().copy(this.getP());
        }
        if (u == 0 && v == 0) {
            target.copy(this.getP());
        }
        else if (u == 1 && v == 0) {
            target.set(1, 0, 0).applyMatrix4(this.transformMatrix);
        }
        else if (u == 0 && v == 1 || u == 1 && v == 1) {
            let dx = 1 / Math.tan(this.angle);
            target.set(dx, 1, 0).applyMatrix4(this.transformMatrix);
        }
        return target;
    }
    /**
     * 抽象成json数据格式
     * @returns
     */
    toJson() {
        let data = Object.assign({ type: this.type, angle: this.angle }, super.toJson());
        return data;
    }
    /**
     * 解析json数据成三角形对象
     * @param json
     * @returns
     */
    fromJson(json) {
        super.fromJson(json);
        this.angle = json.angle;
        return this;
    }
    /**
     * 判断相等
     * @param triangle
     * @returns
     */
    equals(triangle) {
        if (!this.matrixEquals(triangle.transformMatrix))
            return false;
        if (this.angle != triangle.angle)
            return false;
        return true;
    }
    getSideEdges() {
        let res = [];
        let point1 = this.getPointAt(0, 0);
        let point2 = this.getPointAt(1, 0);
        let point3 = this.getPointAt(0, 1);
        res.push(new Line$2(point1, point2));
        res.push(new Line$2(point2, point3));
        res.push(new Line$2(point3, point1));
        return res;
    }
};
const _v1$1$1 = new Vector3$1();
const _v2$7 = new Vector3$1();
const _v2Old = new Vector3$1();
const _v3$5 = new Vector3$1();var BaseFaceTrans=/*#__PURE__*/Object.freeze({__proto__:null,ConeSideSurface:ConeSideSurface,EllipseSurface:EllipseSurface,ExtrudeSurface:ExtrudeSurface,GeneralRegion:GeneralRegion,RectFace:RectFace,RegionFace:RegionFace,RevolveSurface:RevolveSurface,Spherical:Spherical$1,SweeperSurface:SweeperSurface,Trapezoid:Trapezoid,Triangle:Triangle$1});const ExtrudeSolidType = {
    Top: 0,
    Bottom: 1
};
/**
 * 拉伸体
 * 默认往z轴方向拉伸，
 * 拉伸体的底面的局部坐标系三个轴的方向必须为
 * (1, 0, 0)
 * (0, 1, 0)
 * (0, 0, 1)
 */
class ExtrudeSolid extends Solid {
    set offsetDirection(v) {
        if (v != null) {
            this._offsetDirection.copy(v);
            this._offsetDirection.applyMatrix4(this.transformMatrix.clone().invert());
            this._offsetDirection.normalize();
        }
    }
    get offsetDirection() {
        return this._offsetDirection;
    }
    /**
     * 获取基元数组
     * @returns
     */
    getGeoElements() {
        this.surfaceIndex = [ExtrudeSolidType.Top, ExtrudeSolidType.Bottom];
        let sideCurves = this.bottomFace.getSideEdges();
        for (let i = 0; i < sideCurves.length; i++) {
            this.surfaceIndex.push(i + 2);
        }
        let res = []; // 返回的数组
        this.surfaceIndex.forEach(index => {
            let surface = this.getSurface(index, sideCurves);
            if (surface) {
                res.push(surface);
            }
        });
        return res;
    }
    setHeight(height, normal) {
        if (this.getNormalizeX().dot(normal) < 0) {
            height *= -1;
        }
        this.height = height;
    }
    /**
     * 获取控制点 可用于stretch
     * @returns
     */
    getControlPoints() {
        let bottomRes = this.bottomFace.getControlPoints();
        return [
            ...bottomRes,
            { type: FEATURE_POINT_TYPE.CENTER, point: this.getP().add(this.getZ()), geoType: this.type, uvtPosition: new Point(0, 0, 1) }
        ];
    }
    /**
    * 获取特征点列表
    * @returns
    */
    getFeaturePoints() {
        let bottomRes = this.bottomFace.getFeaturePoints();
        bottomRes.forEach(item => {
            item.point.applyMatrix4(this.transformMatrix);
            let uv = item.uvtPosition;
            if (!uv) {
                uv = new Point2(0, 0);
            }
            let newUv = new Point(uv.x, uv.y, 0);
            item.uvtPosition = newUv;
        });
        let topBottomRes = this.bottomFace.getFeaturePoints();
        topBottomRes.forEach(item => {
            item.point.applyMatrix4(this.transformMatrix);
            item.point.add(this.getZ());
            let uv = item.uvtPosition;
            if (!uv) {
                uv = new Point2(0, 0);
            }
            let newUv = new Point(uv.x, uv.y, 1);
            item.uvtPosition = newUv;
        });
        return [
            ...bottomRes,
            ...topBottomRes
        ];
    }
    /**
     * 根据索引值获取表面
     * @param index
     * @returns
     */
    getSurface(index, sideCurves = []) {
        if (index == ExtrudeSolidType.Top) {
            const sum = this.transformMatrix.elements[8] + this.transformMatrix.elements[9] + this.transformMatrix.elements[10];
            const sign = ((this.initBiggerThanZero && sum >= 0) || (!this.initBiggerThanZero && sum < 0)) ? 1 : -1;
            const top = this.bottomFace.clone();
            top.move(new Vector3$1(0, 0, 1));
            if (this._offsetDirection != null) {
                _v1$8.copy(this._offsetDirection).multiplyScalar(this.offsetRatio * this.scaleZ * sign);
                top.move(_v1$8);
            }
            top.scale(top.getP(), this.scaleFactor);
            top.transformMatrix.premultiply(this.transformMatrix);
            return top;
        }
        else if (index == ExtrudeSolidType.Bottom) {
            const bottom = this.bottomFace.clone();
            bottom.transformMatrix.premultiply(this.transformMatrix);
            return bottom;
        }
        else {
            let actualIndex = index - 2;
            // 边线数组
            if (sideCurves.length === 0) {
                sideCurves = this.bottomFace.getSideEdges();
            }
            let extrudeSurface = new ExtrudeSurface(sideCurves[actualIndex], new Vector3$1(0, 0, 1));
            extrudeSurface.transformMatrix.premultiply(this.transformMatrix);
            return extrudeSurface;
        }
    }
    /**
     * 拉伸方向
     */
    get direction() {
        return new Vector3$1().copy(this.getZ());
    }
    /**
     * 设置高度
     */
    set height(value) {
        if (Math.abs(value) < 1e-6) {
            const sign = Math.sign(value);
            if (sign === 0) {
                value = 1e-4;
            }
            else {
                value = Math.sign(value) * 1e-4;
            }
        }
        const z = this.getNormalizeZ();
        z.multiplyScalar(value);
        this.transformMatrix.elements[8] = z.x;
        this.transformMatrix.elements[9] = z.y;
        this.transformMatrix.elements[10] = z.z;
        // let scale = value / this.height;
        // if (scale < 1e-4) {
        //     scale = 1;
        // }
        // const p = this.getP();
        // _transformMatrix.set(
        //     1, 0, 0, 0,
        //     0, 1, 0, 0,
        //     0, 0, scale, p.z * (1 - scale),
        //     0, 0, 0, 1
        // )
        // this.transformMatrix.multiply(_transformMatrix);
    }
    /**
     * 高度
     */
    get height() {
        return this.getZ().length();
    }
    /**
     * 构造函数
     * @param bottomFace 底面
     * @param offsetDirection 含距离
     */
    constructor(bottomFace = new Surface(), height = 1, offsetDirection = new Vector3$1()) {
        super();
        /**
         * 类型
         */
        this.type = 'ExtrudeSolid';
        /**
         * 顶面相对于底面的缩放系数
         */
        this.scaleFactor = 1;
        /**
         * 圆弧中间的竖线
         */
        this.bottomMiddlePoints = [];
        /**
         * 是否需要侧面中线
         */
        this._hasMiddleCurve = true;
        /**
         * 面类型数组
         */
        this.surfaceIndex = [ExtrudeSolidType.Top, ExtrudeSolidType.Bottom];
        /**
         * 相对于底面的水平方向偏移向量(单位向量)
         */
        this._offsetDirection = new Vector3$1(0, 0, 1);
        /**
         * 偏移比例， 偏移方向与高度的比值
         */
        this.offsetRatio = 1;
        /**
         * 判断偏移方向的正反
         */
        this.initBiggerThanZero = true;
        if (bottomFace) {
            this.bottomFace = bottomFace.clone();
            this.bottomFace.transformMatrix.set(bottomFace.scaleX, 0, 0, 0, 0, bottomFace.scaleY, 0, 0, 0, 0, bottomFace.scaleZ, 0, 0, 0, 0, 1);
            this.transformMatrix.set(1 / bottomFace.scaleX, 0, 0, 0, 0, 1 / bottomFace.scaleY, 0, 0, 0, 0, 1 / bottomFace.scaleZ, 0, 0, 0, 0, 1).premultiply(bottomFace.transformMatrix);
            const lengthZ = this.scaleZ;
            this.transformMatrix.elements[8] = this.transformMatrix.elements[8] * height / lengthZ;
            this.transformMatrix.elements[9] = this.transformMatrix.elements[9] * height / lengthZ;
            this.transformMatrix.elements[10] = this.transformMatrix.elements[10] * height / lengthZ;
            this.offsetDirection = offsetDirection.clone().normalize();
            this.offsetRatio = offsetDirection.length() / height;
            this.initBiggerThanZero = (this.transformMatrix.elements[8] + this.transformMatrix.elements[9] + this.transformMatrix.elements[10]) >= 0;
            let curves = bottomFace.getSideEdges();
            for (let i = 0; i < curves.length; i++) {
                this.surfaceIndex.push(i + 2);
            }
        }
    }
    /**
     * 复制
     * @param solid
     * @returns
     */
    copy(solid) {
        this.bottomFace = solid.bottomFace.clone();
        this.transformMatrix.copy(solid.transformMatrix);
        this.scaleFactor = solid.scaleFactor;
        this.offsetDirection = solid.offsetDirection;
        this.offsetRatio = solid.offsetRatio;
        this.initBiggerThanZero = solid.initBiggerThanZero;
        return this;
    }
    /**
     * 克隆
     * @returns
     */
    clone() {
        return new ExtrudeSolid(this.bottomFace.clone(), this.height).copy(this);
    }
    /**
     * 判断是否相等
     * @param solid
     * @returns
     */
    equals(solid) {
        let isEquals = solid.bottomFace.equals(this.bottomFace);
        if (!isEquals)
            return false;
        isEquals = true;
        for (let i = 0; i < this.transformMatrix.elements.length; i++) {
            if (this.transformMatrix.elements[i] !== solid.transformMatrix.elements[i]) {
                isEquals = false;
                break;
            }
        }
        return isEquals;
    }
    /**
     * 抽象成json数据格式
     * @returns
     */
    toJson() {
        let res = Object.assign(Object.assign({}, super.toJson()), { version: "1.0", 
            // baseCurves: this.baseCurves.map(item => item.toJson()),
            bottomFace: this.bottomFace.toJson(), scaleFactor: this.scaleFactor, initBiggerThanZero: this.initBiggerThanZero, type: this.type });
        if (this._offsetDirection != null) {
            res = Object.assign(Object.assign({}, res), { _offsetDirection: {
                    x: this._offsetDirection.x,
                    y: this._offsetDirection.y,
                    z: this._offsetDirection.z
                } });
        }
        return res;
    }
    /**
     * 解析json数据
     * @param json
     * @returns
     */
    fromJson(json) {
        super.fromJson(json);
        this.bottomFace = new BaseFaceTrans[json.bottomFace.type]().fromJson(json.bottomFace);
        this.scaleFactor = (json === null || json === void 0 ? void 0 : json.scaleFactor) || 1;
        if (json.offsetDirection) {
            this.offsetDirection.set(json.offsetDirection.x, json.offsetDirection.y, json.offsetDirection.z);
        }
        this.offsetRatio = json.offsetRatio || 1;
        this.initBiggerThanZero = json.initBiggerThanZero;
        return this;
    }
    getCenter(target) {
        if (target == null) {
            target = new Point();
        }
        this.bottomFace.getCenter(target);
        target.add(this.direction.normalize().clone().multiplyScalar(this.height / 2));
        return target;
    }
    /**
     * 获取包围盒
     * @returns
     */
    getBoundingBox() {
        let top = this.getSurface(ExtrudeSolidType.Top);
        let bottom = this.getSurface(ExtrudeSolidType.Bottom);
        let topData = top.getBoundingBox();
        let bottomData = bottom.getBoundingBox();
        let min = new Vector3$1(Math.min(topData.min.x, bottomData.min.x), Math.min(topData.min.y, bottomData.min.y), Math.min(topData.min.z, bottomData.min.z));
        let max = new Vector3$1(Math.max(topData.max.x, bottomData.max.x), Math.max(topData.max.y, bottomData.max.y), Math.max(topData.max.z, bottomData.max.z));
        return {
            min: min,
            max: max
        };
    }
}
const _v1$8 = new Vector3$1();
// const _transformMatrix = new Matrix4();
/**
 * 多边形
 */
class Polygon extends Curve {
    /**
     * 基点
     */
    get basePoint() {
        return this.getP();
    }
    /**
     * 获取基元列表
     * @returns
     */
    getGeoElements() {
        const res = [...this.edges];
        this.holes.forEach(hole => res.push(...hole.getGeoElements()));
        return [...res];
    }
    /**
     * 设置基点
     */
    set basePoint(value) {
        this.setP(value);
    }
    /**
     * 设置平面法向量
     */
    set normal(value) {
        this.setXYZ(this.getNormalizeX(), value);
    }
    /**
     * 平面法向量
     */
    get normal() {
        return this.getNormalizeZ();
    }
    /**
     * 获取基元索引列表 用于绑定
     */
    getGeoElementsIdxList() {
        const arr = [];
        for (let i = 0; i < this.edges.length; i++) {
            arr.push(i);
        }
        let start = (arr[arr.length - 1] + 1) || 0;
        for (let i = 0; i < this.holes.length; i++) {
            this.holes[i].getGeoElementsIdxList().forEach(idx => {
                arr.push(start + idx);
                start++;
            });
        }
        return arr;
    }
    // /**
    //  * 获取多边形上的点
    //  * @param t 
    //  * @param target 
    //  */
    // getPointAt(t, target = null) {
    //     if (target == null) {
    //         target = new Point();
    //     }
    //     if (this.edges.length == 1) {
    //         return this.edges[0].getPointAt(t, target);
    //     } else {
    //         // 向下取整
    //         const index = Math.floor(t * this.edges.length);
    //         const edgeIdx = index % this.edges.length;
    //         const delta = 1 / this.edges.length;
    //         const startT = edgeIdx * delta;
    //         let endT;
    //         if (edgeIdx === this.edges.length - 1) {
    //             endT = 1;
    //         } else {
    //             endT = (edgeIdx + 1) * delta;
    //         }
    //         // 把t映射到当前边上
    //         const tOnEdge = (t - startT) / (endT - startT);
    //         return this.edges[edgeIdx].getPointAt(tOnEdge, target);
    //     }
    // }
    /**
     * 构造函数
     * @param edges 边列表
     * @param axisX X轴方向
     * @param basePoint 基点
     */
    constructor(edges = [], axisX = new Vector3$1(1, 0, 0), basePoint = null) {
        super();
        this.type = 'Polygon';
        /**
         * 点列表
         */
        this.vertexList = [];
        /**
         * 边列表
         */
        this.edges = [];
        /**
         * 洞列表
         */
        this.holes = [];
        this.edges = [...edges];
        if (axisX)
            this.axisX = axisX.normalize();
        this.generate();
        if (basePoint) {
            this.basePoint = basePoint;
        }
        else {
            this.basePoint = new Point();
            this.vertexList.forEach(point => {
                this.basePoint.add(point);
            });
            if (this.vertexList.length > 0) {
                this.basePoint.multiplyScalar(1 / this.vertexList.length);
            }
        }
    }
    /**
     * 设置多边形
     * @param edges
     * @param axisX
     */
    setPolygon(edges = [], axisX) {
        this.edges = [...edges];
        if (axisX)
            this.axisX = axisX.normalize();
        this.generate();
    }
    /**
     * 设置X轴方向
     */
    set axisX(value) {
        this.setXYZ(value, this.normal);
    }
    /**
     * 获取X轴方向
     */
    get axisX() {
        return this.getX();
    }
    copy(polygon) {
        if (this.edges.length === polygon.edges.length) {
            this.edges.forEach((edge, idx) => {
                if (edge.type === polygon.edges[idx].type) {
                    edge.copy(polygon.edges[idx]);
                }
                else {
                    this.edges[idx] = polygon.edges[idx].clone();
                }
            });
        }
        else {
            let edges = polygon.edges.map(item => item.clone());
            this.edges = [...edges];
        }
        if (this.holes.length === polygon.holes.length) {
            this.holes.forEach((hole, idx) => {
                hole.copy(polygon.holes[idx]);
            });
        }
        else {
            this.holes = polygon.holes.map(item => item.clone());
        }
        if (this.vertexList.length === polygon.vertexList.length) {
            this.vertexList.forEach((vertex, idx) => {
                vertex.copy(polygon.vertexList[idx]);
            });
        }
        else {
            this.vertexList = polygon.vertexList.map(vertex => vertex.clone());
        }
        //TODO,等插值点移过来再处理
        // if (this._polygonPoints.length === polygon._polygonPoints.length) {
        //     this._polygonPoints.forEach((vertex, idx) => {
        //         vertex.copy(polygon._polygonPoints[idx]);
        //     })
        // } else {
        //     this._polygonPoints = polygon._polygonPoints.map(vertex => vertex.clone());
        // }
        this.axisX = polygon.axisX;
        this.generate();
        this.basePoint.copy(polygon.basePoint);
        return this;
    }
    /**
     * 克隆
     * @returns
     */
    clone() {
        return new Polygon().copy(this);
    }
    /**
     * 生成多边形
     */
    generate() {
        if (this.vertexList.length === 0) {
            for (let i = 0; i < this.edges.length; i++) {
                let edge = this.edges[i];
                let endPoints = edge.getEndPoints();
                if (endPoints.length > 0) {
                    this.vertexList.push(endPoints[0]);
                }
            }
            this.holes.forEach(hole => {
                hole.edges.forEach(edge => {
                    let endPoints = edge.getEndPoints();
                    if (endPoints.length > 0) {
                        this.vertexList.push(endPoints[0]);
                    }
                });
            });
        }
        if (this.edges.length === 1) {
            if (this.edges[0] instanceof Circle) {
                let circle = this.edges[0];
                this.setFromNormalAndCoplanarPoint(circle.normal, circle.center);
            }
            else if (this.edges[0] instanceof Ellipse) {
                let ell = this.edges[0];
                this.setFromNormalAndCoplanarPoint(ell.normal, ell.getCenter());
            }
        }
        else if (this.vertexList.length === 2) {
            if (this.edges[0] instanceof Arc) {
                let arc = this.edges[0];
                this.setFromNormalAndCoplanarPoint(arc.normal, arc.center);
            }
            else if (this.edges[1] instanceof Arc) {
                let arc = this.edges[1];
                this.setFromNormalAndCoplanarPoint(arc.normal, arc.center);
            }
        }
        else if (this.vertexList.length > 2) {
            this.setFromCoplanarPoints(this.vertexList[0], this.vertexList[1], this.vertexList[2]);
        }
    }
    /**
     * 根据平面法向量和平面上一点构造平面
     * @param normal
     * @param point
     * @returns
     */
    setFromNormalAndCoplanarPoint(normal, point) {
        if (normal.length() < 1e-6) {
            normal.set(0, 0, 1);
        }
        else {
            normal.normalize();
        }
        this.normal = normal;
        this.setP(point);
        return this;
    }
    /**
 * 根据平面上三个点构造平面
 * @param a
 * @param b
 * @param c
 * @returns
 */
    setFromCoplanarPoints(a, b, c) {
        const normal = _vector1$2.subVectors(c, b).cross(_vector2$3.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    //TODO 暂时不需要该方法
    // getCenter(target?: Point) {
    //     if (target == null) {
    //         target = new Point();
    //     }
    //     if (this.edges.length === 1 && (this.edges[0].type === 'Circle' || this.edges[0].type === 'Ellipse')) {
    //         target.copy(this.edges[0].getCenter());
    //         return target;
    //     }
    //     let count = 0;
    //     let sum = new Point();
    //     this.vertexList.forEach(item => {
    //         sum.add(item);
    //         count++;
    //     })
    //     if (count === 0) return target;
    //     target.copy(sum).divideScalar(count);
    //     return target;
    // }
    /**
     * 获取基点
     * @param target
     * @returns
     */
    getBasePoint(target) {
        if (target == null) {
            target = new Point();
        }
        target.copy(this.basePoint);
        return target;
    }
    //todo
    isPointInPolygon(point) {
        // 假设curve已经成环且排好序了
        return false;
    }
    /**
     * 获取面积
     * @returns
     */
    getArea() {
        // 边界围成的面积
        let edgeArea = this.getAreaByEdges(this.edges);
        // 洞的面积
        let holeArea = 0;
        this.holes.forEach(hole => {
            holeArea += this.getAreaByEdges(hole.edges);
        });
        return edgeArea - holeArea;
    }
    //TODO 如何从外部传入分割值
    // _prevVector: Vector3 = new Vector3();
    // _nextVector: Vector3 = new Vector3();
    getAreaByEdges(curves) {
        // const _prevVector: Vector3 = new Vector3();
        // const _nextVector: Vector3 = new Vector3();
        // // 由有序的边得到的顶点
        // let points: Point[] = [];
        // let noRepeatPoints: Point[] = [];
        // curves.forEach(edge => {
        //     points.push(...edge.getPoints());
        // })
        // // 对顶点去重
        // points.forEach(point => {
        //     if (!noRepeatPoints.some(item => item.equals(point))) {
        //         noRepeatPoints.push(point);
        //     }
        // })
        // /**         
        //  * 计算多边形面积，参考文献：[1]韦品瑚,晓伟.三维空间多边形的面积计算[J].数学通报,1984(02):18-21. 引理2
        //  * 空间多边形A1A2...An的面积S=1/2 * |A1A2 * A1A3 + A1A3 * A1A4 + ... + A1An-1 * A1An|
        //  */
        // if (noRepeatPoints.length < 3) return 0;
        // // 第一个点
        // let firstPoint = noRepeatPoints[0];
        // // 矢量积
        // let vectorProduct = new Vector3();
        // for (let i = 2; i <= noRepeatPoints.length - 1; i++) {
        //     // A1Ai-1
        //     _prevVector.subVectors(noRepeatPoints[i - 1], firstPoint);
        //     // A1Ai
        //     _nextVector.subVectors(noRepeatPoints[i], firstPoint);
        //     // A1Ai-1 * A1Ai
        //     vectorProduct.add(_prevVector.cross(_nextVector));
        // }
        // return vectorProduct.length() / 2
        return 0;
    }
    //TODO 重写获取点的方法
    getPoints() {
        let points = [];
        // for (let i = 0; i < this.edges.length; i++) {
        //     let midList = [...this.edges[i].getPoints()]
        //     points.push(...midList)
        // }
        // for (let i = 0; i < this.holes.length; i++) {
        //     points.push(...this.holes[i].getPoints())
        // }
        return points;
    }
    //TODO 重写获取点的方法
    getPointsNoLoop() {
        let points = [];
        // for (let i = 0; i < this.edges.length; i++) {
        //     let midList = [...this.edges[i].getPoints()]
        //     // if (this.edges[i].type == 'Circle') {
        //     midList.pop()
        //     // }
        //     points.push(...midList)
        // }
        // for (let i = 0; i < this.holes.length; i++) {
        //     points.push(...this.holes[i].getPointsNoLoop())
        // }
        return points;
    }
    /**
     * 抽象成json
     * @returns
     */
    toJson() {
        let data = {
            version: "1.0",
            edges: this.edges.map(edge => edge.toJson()),
            holes: this.holes.map(hole => hole.toJson()),
            axisX: {
                x: this.axisX.x,
                y: this.axisX.y,
                z: this.axisX.z,
            },
            basePoint: {
                x: this.basePoint.x,
                y: this.basePoint.y,
                z: this.basePoint.z,
            }
        };
        return data;
    }
    /**
     * 从json中解析
     * @param json
     * @returns
     */
    fromJson(json) {
        //TODO
        return this;
    }
}
const _vector1$2 = new Vector3$1();
const _vector2$3 = new Vector3$1();const BoxSurfaceType = {
    Top: 0,
    Bottom: 1,
    Left: 2,
    Right: 3,
    Front: 4,
    Back: 5
};
/**
 * 长方体。默认局部坐标系下的立方体只是一个原点为（0， 0， 0）， 三条边方向分别为xyz轴，长度均为1的坐标轴
 * 定义方式：将长方体的长宽高分别存入，局部坐标系的xyz轴中，长方体的基点存入局部坐标系的基点
 */
class Box extends Solid {
    /**
     *
     * @param basePoint 立方体基点（左下角）
     * @param vecX 立方体x轴，含长度与x轴方向
     * @param vecY 立方体y轴，含宽度与y轴方向
     * @param vecZ 立方体z轴，含高度与z轴方向
     */
    constructor(basePoint = new Point(), vecX = new Vector3$1(1, 0, 0), vecZ = new Vector3$1(0, 1, 0), vecY = null) {
        super();
        /**
         * 几何类型
         */
        this.type = 'Box';
        /**
         * 长方体表面索引，以局部坐标系尺度来看，0~5分别对应上下左右前后
         */
        this.surfaceIndex = [BoxSurfaceType.Top, BoxSurfaceType.Bottom, BoxSurfaceType.Left, BoxSurfaceType.Right, BoxSurfaceType.Front, BoxSurfaceType.Back];
        let vecTmpY = vecY; // 立方体y轴，如果有传入设置为传入的值，否则设置为z叉乘x
        if (vecY == null) {
            vecTmpY = vecZ.clone().cross(vecX).normalize();
        }
        this.transformMatrix.set(vecX.x, vecTmpY.x, vecZ.x, basePoint.x, vecX.y, vecTmpY.y, vecZ.y, basePoint.y, vecX.z, vecTmpY.z, vecZ.z, basePoint.z, 0, 0, 0, 1);
    }
    clone() {
        return new Box().copy(this);
    }
    /**
     * 获取基元数组
     * @returns
     */
    getGeoElements() {
        let res = []; //返回的数组
        this.surfaceIndex.forEach(index => {
            let surface = this.getSurface(index);
            if (surface) {
                res.push(surface);
            }
        });
        return res;
    }
    /**
     * 根据索引值获取表面
     * @param index
     * @returns
     */
    getSurface(index) {
        switch (index) {
            case BoxSurfaceType.Top:
                return new RectFace(new Point(1, 1, 1).applyMatrix4(this.transformMatrix), this.getX().multiplyScalar(-1), this.getY().multiplyScalar(-1));
            case BoxSurfaceType.Bottom:
                return new RectFace(this.getP(), this.getX(), this.getY());
            case BoxSurfaceType.Left:
                return new RectFace(this.getP(), this.getZ(), this.getY());
            case BoxSurfaceType.Right:
                return new RectFace(new Point(1, 1, 1).applyMatrix4(this.transformMatrix), this.getY().multiplyScalar(-1), this.getZ().multiplyScalar(-1));
            case BoxSurfaceType.Front:
                return new RectFace(this.getP(), this.getX(), this.getZ());
            case BoxSurfaceType.Back:
                return new RectFace(new Point(1, 1, 1).applyMatrix4(this.transformMatrix), this.getX().multiplyScalar(-1), this.getZ().multiplyScalar(-1));
            default:
                return null;
        }
    }
    /**
     * 获取中心点
     * @param target
     */
    getCenter(target) {
        if (target == null) {
            target = new Point();
        }
        target.set(0.5, 0.5, 0.5).applyMatrix4(this.transformMatrix);
        return target;
    }
    /**
     * 判断两个立方体是否相等，本质上是判断两个立方体的矩阵是否相等
     * @param box
     * @returns
     */
    equals(box) {
        const eplison = 1e-6;
        // TODO 矩阵相等方法，后续需要提取出去
        for (let i = 0; i < 16; i++) {
            if (Math.abs(this.transformMatrix.elements[i] - box.transformMatrix.elements[i]) > eplison)
                return false;
        }
        return true;
    }
    /**
     * 获取控制点 可用于stretch
     * @returns
     */
    getControlPoints() {
        let bottomPoint1 = this.getP();
        let bottomPoint2 = this.getP().add(this.getX());
        let bottomPoint3 = this.getP().add(this.getX()).add(this.getY());
        let bottomPoint4 = this.getP().add(this.getY());
        let bottomCenter = this.getP().add(this.getX().multiplyScalar(0.5)).add(this.getY().multiplyScalar(0.5));
        let topCenter = bottomCenter.clone().add(this.getZ());
        return [
            // stretch点
            // 夹点
            { type: FEATURE_POINT_TYPE.END, point: bottomPoint1, geoType: this.type, uvtPosition: new Point(0, 0, 0) },
            { type: FEATURE_POINT_TYPE.END, point: bottomPoint2, geoType: this.type, uvtPosition: new Point(1, 0, 0) },
            { type: FEATURE_POINT_TYPE.END, point: bottomPoint3, geoType: this.type, uvtPosition: new Point(1, 1, 0) },
            { type: FEATURE_POINT_TYPE.END, point: bottomPoint4, geoType: this.type, uvtPosition: new Point(0, 1, 0) },
            { type: FEATURE_POINT_TYPE.FACE_CENTER, point: bottomCenter, geoType: this.type, uvtPosition: new Point(0.5, 0.5, 0) },
            { type: FEATURE_POINT_TYPE.FACE_CENTER, point: topCenter, geoType: this.type, uvtPosition: new Point(0.5, 0.5, 1) },
            { type: FEATURE_POINT_TYPE.CENTER, point: new Point().addVectors(bottomCenter, topCenter).multiplyScalar(0.5), geoType: this.type }
        ];
    }
    /**
     * 获取包围盒
     * @returns
     */
    getBoundingBox() {
        let bottomPoint1 = this.getP();
        let bottomPoint2 = this.getP().add(this.getX());
        let bottomPoint3 = this.getP().add(this.getX()).add(this.getY());
        let bottomPoint4 = this.getP().add(this.getY());
        let topPoint1 = bottomPoint1.clone().add(this.getZ());
        let topPoint2 = bottomPoint2.clone().add(this.getZ());
        let topPoint3 = bottomPoint3.clone().add(this.getZ());
        let topPoint4 = bottomPoint4.clone().add(this.getZ());
        let box = new Box3$1();
        box.setFromPoints([bottomPoint1, bottomPoint2, bottomPoint3, bottomPoint4, topPoint1, topPoint2, topPoint3, topPoint4]);
        return {
            min: box.min,
            max: box.max,
        };
    }
    /**
    * 获取特征点列表
    * @returns
    */
    getFeaturePoints() {
        let bottomPoint1 = this.getP();
        let bottomPoint2 = this.getP().add(this.getX());
        let bottomPoint3 = this.getP().add(this.getX()).add(this.getY());
        let bottomPoint4 = this.getP().add(this.getY());
        let topPoint1 = bottomPoint1.clone().add(this.getZ());
        let topPoint2 = bottomPoint2.clone().add(this.getZ());
        let topPoint3 = bottomPoint3.clone().add(this.getZ());
        let topPoint4 = bottomPoint4.clone().add(this.getZ());
        let res = [
            { type: FEATURE_POINT_TYPE.END, point: bottomPoint1, geoType: this.type, uvtPosition: new Point(0, 0, 0) },
            { type: FEATURE_POINT_TYPE.END, point: bottomPoint2, geoType: this.type, uvtPosition: new Point(1, 0, 0) },
            { type: FEATURE_POINT_TYPE.END, point: bottomPoint3, geoType: this.type, uvtPosition: new Point(1, 1, 0) },
            { type: FEATURE_POINT_TYPE.END, point: bottomPoint4, geoType: this.type, uvtPosition: new Point(0, 1, 0) },
            { type: FEATURE_POINT_TYPE.END, point: topPoint1, geoType: this.type, uvtPosition: new Point(0, 0, 1) },
            { type: FEATURE_POINT_TYPE.END, point: topPoint2, geoType: this.type, uvtPosition: new Point(1, 0, 1) },
            { type: FEATURE_POINT_TYPE.END, point: topPoint3, geoType: this.type, uvtPosition: new Point(1, 1, 1) },
            { type: FEATURE_POINT_TYPE.END, point: topPoint4, geoType: this.type, uvtPosition: new Point(0, 1, 1) },
            { type: FEATURE_POINT_TYPE.MIDDLE, point: new Vector3$1().addVectors(bottomPoint1, bottomPoint2).multiplyScalar(0.5), geoType: this.type, uvtPosition: new Point(0.5, 0, 0) },
            { type: FEATURE_POINT_TYPE.MIDDLE, point: new Vector3$1().addVectors(bottomPoint2, bottomPoint3).multiplyScalar(0.5), geoType: this.type, uvtPosition: new Point(1, 0.5, 0) },
            { type: FEATURE_POINT_TYPE.MIDDLE, point: new Vector3$1().addVectors(bottomPoint3, bottomPoint4).multiplyScalar(0.5), geoType: this.type, uvtPosition: new Point(0.5, 1, 0) },
            { type: FEATURE_POINT_TYPE.MIDDLE, point: new Vector3$1().addVectors(bottomPoint4, bottomPoint1).multiplyScalar(0.5), geoType: this.type, uvtPosition: new Point(0, 0.5, 0) },
            { type: FEATURE_POINT_TYPE.MIDDLE, point: new Vector3$1().addVectors(topPoint1, topPoint2).multiplyScalar(0.5), geoType: this.type, uvtPosition: new Point(0.5, 0, 1) },
            { type: FEATURE_POINT_TYPE.MIDDLE, point: new Vector3$1().addVectors(topPoint2, topPoint3).multiplyScalar(0.5), geoType: this.type, uvtPosition: new Point(1, 0.5, 1) },
            { type: FEATURE_POINT_TYPE.MIDDLE, point: new Vector3$1().addVectors(topPoint3, topPoint4).multiplyScalar(0.5), geoType: this.type, uvtPosition: new Point(0.5, 1, 1) },
            { type: FEATURE_POINT_TYPE.MIDDLE, point: new Vector3$1().addVectors(topPoint4, topPoint1).multiplyScalar(0.5), geoType: this.type, uvtPosition: new Point(0, 0.5, 1) },
        ];
        return res;
    }
    toJson() {
        let data = Object.assign({ version: "1.1", type: this.type }, super.toJson());
        return data;
    }
}const PyramidSurfaceType = {
    Bottom: 0
};
/**
 * 棱锥
 *
 */
class Pyramid extends Solid {
    /**
     * 底面中心
     */
    get center() {
        return new Point().copy(this.getP());
    }
    /**
     * 设置底面中心
     */
    set center(value) {
        this.setP(value);
    }
    /**
     * 底面指向顶部的方向单位向量
     */
    get normal() {
        return new Vector3$1().copy(this.getZ().normalize());
    }
    /**
     * 需要保证z与x轴方向不同，所以建议以后设置normal时都调用这个方法
     * @param nx
     * @param ny
     * @param nz
     */
    setNormal(nx, ny, nz) {
        this.setXYZ(this.getX(), new Vector3$1(nx, ny, nz));
    }
    /**
     * 底面中心指向第一个顶点的方向单位向量
     */
    get firstDir() {
        return new Vector3$1().copy(this.getX().normalize());
    }
    /**
     * 棱锥高
     */
    get height() {
        return this.scaleZ;
    }
    /**
     * 设置棱锥高
     */
    set height(value) {
        let scale = value / this.scaleZ;
        if (scale == 0)
            scale = 1;
        this.scale(this.getP(), 1, 1, scale);
    }
    /**
     * 底面外接圆半径
     */
    get radius() {
        return this.scaleX;
    }
    /**
     * 设置底面外接圆半径
     */
    set radius(value) {
        let scale = value / this.scaleX;
        if (scale == 0)
            scale = 1;
        this.ratio = this.ratio / scale;
        this.scale(this.getP(), scale, scale, 1);
    }
    /**
     * 顶面外接圆半径
     */
    get topRadius() {
        return this.radius * this.ratio;
    }
    /**
     * 设置顶面外接圆半径
     */
    set topRadius(value) {
        let scale = value / this.radius;
        this.ratio = scale;
    }
    /**
     * 构造函数
     * @param center 底面中心
     * @param radius 底面外接圆半径
     * @param height 棱锥高度
     * @param edge 棱锥侧面数量
     * @param topRadius 棱台顶面外接圆半径
     * @param normal 法向量
     * @param firstDir
     */
    constructor(center = new Point(), radius = 0, height = 0, edge = 4, topRadius = 0, normal = new Vector3$1(0, 0, 1), firstDir = new Vector3$1(1, 0, 0)) {
        super();
        /**
         * 类型
         */
        this.type = 'Pyramid';
        /**
         * 棱锥表面索引
         */
        this.surfaceIndex = [PyramidSurfaceType.Bottom];
        this.transformMatrix.elements[8] = normal.x;
        this.transformMatrix.elements[9] = normal.y;
        this.transformMatrix.elements[10] = normal.z;
        firstDir.normalize();
        this.updateMatrixByX(firstDir, false);
        if (radius <= 0)
            radius = 1;
        this.center = center;
        this.radius = radius;
        this.height = height;
        this.edge = edge;
        this.topRadius = topRadius;
        for (let i = 0; i < this.edge; i++) {
            this.surfaceIndex.push(i + 1);
        }
        if (this.topRadius > 1e-6)
            this.surfaceIndex.push(this.edge + 1);
    }
    /**
     * 设置属性
     * @param center 底面中心
     * @param radius 底面外接圆半径
     * @param height 棱锥高度
     * @param edge 棱锥侧面数量
     * @param topRadius 棱台顶面外接圆半径
     * @param normal 法向量
     * @returns
     */
    set(center, radius, height, edge, normal) {
        this.center = center;
        this.radius = radius;
        this.topRadius = this.topRadius;
        this.height = height;
        this.edge = edge;
        this.setXYZ(this.getX(), normal);
        return this;
    }
    /**
     * 复制
     * @param pyramid
     * @returns
     */
    copy(pyramid) {
        super.copy(pyramid);
        this.edge = pyramid.edge;
        this.ratio = pyramid.ratio;
        return this;
    }
    /**
     * 克隆
     * @param
     * @returns
     */
    clone() {
        return new Pyramid().copy(this);
    }
    equals(pyramid) {
        for (let i = 0; i < 16; i++) {
            if (Math.abs(this.transformMatrix.elements[i] - pyramid.transformMatrix.elements[i]) > 1e-6)
                return false;
        }
        if (this.edge != pyramid.edge)
            return false;
        if (Math.abs(this.topRadius - pyramid.topRadius) > 1e-6)
            return false;
        return false;
    }
    /**
     * 获取中心点
     * @param target
     * @returns
     */
    getCenter(target) {
        if (target == null) {
            target = new Point();
        }
        target.copy(this.center);
        target.add(this.normal.clone().multiplyScalar(this.height / 2));
        return target;
    }
    /**
     * 抽象成json数据格式
     * @returns
     */
    toJson() {
        return Object.assign(Object.assign({ version: "1.0", type: this.type }, super.toJson()), { edge: this.edge, ratio: this.ratio });
    }
    /**
     * 解析json数据成圆弧对象
     * @param json
     * @returns
     */
    fromJson(json) {
        super.fromJson(json);
        this.edge = json.edge;
        this.ratio = json.ratio;
        return this;
    }
    /**
     * 获取基元数组
     * @returns
     */
    getGeoElements() {
        let res = []; //返回的数组
        this.surfaceIndex.forEach(index => {
            let surface = this.getSurface(index);
            if (surface) {
                res.push(surface);
            }
        });
        return res;
    }
    /**
     * 根据索引值获取表面
     * @param index
     * @returns
     */
    getSurface(index) {
        let points = this.getBottomPoints();
        let topPoints = this.getTopPoints();
        //底面
        if (index == PyramidSurfaceType.Bottom) {
            let edges = [];
            for (let i = 1; i <= this.edge; i++) {
                const edge = new Line$2(points[i - 1], points[i % this.edge]);
                edges.push(edge);
            }
            return new RegionFace(edges, this.firstDir, this.center);
        }
        else if (index == this.edge + 1) { //顶面
            if (this.topRadius < 1e-6)
                return null;
            let edges = [];
            for (let i = 1; i <= this.edge; i++) {
                const edge = new Line$2(topPoints[i - 1], topPoints[i % this.edge]);
                edges.push(edge);
            }
            return new RegionFace(edges, this.firstDir, topPoints[0]);
        }
        else { //侧面
            let bottomPoint1 = points[index - 1];
            let bottomPoint2 = points[index % this.edge];
            let tempEdges = [];
            if (this.topRadius < 1e-6) { //三角形
                tempEdges.push(new Line$2(bottomPoint1, bottomPoint2));
                tempEdges.push(new Line$2(bottomPoint2, topPoints[0]));
                tempEdges.push(new Line$2(topPoints[0], bottomPoint1));
                return new RegionFace(tempEdges, this.firstDir);
                //return new Triangle(topPoints[0], bottomPoint1, bottomPoint2);
            }
            else { // 返回梯形
                let topPoint1 = topPoints[index - 1];
                let topPoint2 = topPoints[index % this.edge];
                tempEdges.push(new Line$2(bottomPoint1, bottomPoint2));
                tempEdges.push(new Line$2(bottomPoint2, topPoint2));
                tempEdges.push(new Line$2(topPoint2, topPoint1));
                tempEdges.push(new Line$2(topPoint1, bottomPoint1));
                return new RegionFace(tempEdges, this.firstDir);
            }
        }
    }
    rotate_point(origin, point, rotateAxis, angle) {
        origin.sub(point).applyAxisAngle(rotateAxis, angle).add(point);
        return origin.clone();
    }
    /**
     * 获取底面端点
     * @param
     * @returns
     */
    getBottomPoints() {
        let points = [];
        let firstPoint = this.center.clone().add(this.firstDir.clone().multiplyScalar(this.radius));
        let angleSegment = Math.PI * 2 / this.edge;
        points.push(firstPoint);
        for (let i = 1; i < this.edge; i++) {
            let tmpPoint = this.rotate_point(firstPoint.clone(), this.center, this.normal, angleSegment * i);
            points.push(tmpPoint);
        }
        return points;
    }
    /**
     * 获取顶面端点
     * @param
     * @returns
     */
    getTopPoints() {
        if (this.topRadius < 1e-6) {
            return [this.center.clone().add(this.normal.clone().multiplyScalar(this.height))];
        }
        else {
            let points = [];
            let angleSegment = Math.PI * 2 / this.edge;
            let firstTopPoint = this.center.clone().add(this.firstDir.clone().multiplyScalar(this.topRadius))
                .add(this.normal.clone().multiplyScalar(this.height));
            points.push(firstTopPoint);
            for (let i = 1; i < this.edge; i++) {
                let tmpPoint = this.rotate_point(firstTopPoint.clone(), this.center, this.normal, angleSegment * i);
                points.push(tmpPoint);
            }
            return points;
        }
    }
}const _normalMatrix$1 = new Matrix3$1();
/**
 * 射线
 * 其局部坐标系定义为起点为基点p，方向为局部x轴
 */
let Ray$2=class Ray extends Curve {
    /**
     * 端点
     */
    get origin() {
        return new Point().copy(this.getP());
    }
    /**
     * 设置端点
     */
    set origin(value) {
        this.setP(value);
    }
    /**
     * 方向
     */
    get direction() {
        return this.getZ();
    }
    /**
     * 获取切线方向
     * @param point
     */
    getCutLineDir(point, target) {
        if (target == null) {
            target = new Vector3$1();
        }
        this.getNormalizeX(target);
        return target;
    }
    /**
     * 构造函数
     * @param origin
     * @param direction
     */
    constructor(origin = new Point(), direction = new Vector3$1(0, 0, -1)) {
        super();
        /**
         * 类型
         */
        this.type = 'Ray';
        this.origin = origin;
        this.setXYZ(this.getX(), direction);
    }
    /**
     * 设置端点和方向
     * @param origin
     * @param direction
     * @returns
     */
    set(origin, direction) {
        this.origin = origin;
        this.setXYZ(this.getX(), direction);
        return this;
    }
    /**
     * 应用矩阵
     * @param matrix4
     * @returns
     */
    applyMatrix4(matrix4) {
        const normalMatrix = _normalMatrix$1.getNormalMatrix(matrix4);
        this.origin.applyMatrix4(matrix4);
        this.direction.applyMatrix3(normalMatrix).normalize();
        return this;
    }
    /**
     * 判定相等
     * @param ray
     * @returns
     */
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    /**
     * 克隆一个新的射线对象
     * @returns
     */
    clone() {
        return new Ray().copy(this);
    }
    /**
     * 获取插值点
     * @param t 0-1
     * @returns
     */
    getPointAt(t, target = null) {
        if (target == null) {
            target = new Point();
        }
        return target.copy(this.direction).multiplyScalar(t).add(this.origin);
    }
    /**
     * 改变观察方向
     * @param v
     * @returns
     */
    lookAt(v) {
        let dir = this.direction.copy(v).sub(this.origin).normalize();
        this.setXYZ(this.getX(), dir);
        return this;
    }
    /**
     * 转成json格式数据
     * @returns
     */
    toJson() {
        return Object.assign({ version: "1.1", type: this.type }, super.toJson());
    }
};// const _rotateDivition: number = 16;
// const _tmpArc: Arc = new Arc()
// const  _tmpPoint = new Point();
//todo较多内容待实现
const RevolveSolidType = {
    Top: 0,
    Bottom: 1,
};
/**
 * 旋转体
 * 局部坐标系为：基点为(0,0,0), 起点在x轴
 */
class RevolveSolid extends Solid {
    get center() {
        return new Point().copy(this.getP());
    }
    set center(value) {
        this.setP(value);
    }
    get axis() {
        //axis是旋转轴z轴
        return this.getZ();
    }
    constructor(bottomFace, axis = new StraightLine(), angle = 2 * Math.PI) {
        super();
        this.type = 'RevolveSolid';
        // // 拉伸面的基准线
        // baseCurves: Curve[] = [];
        /**
         * 面类型数组
         */
        this.surfaceIndex = [RevolveSolidType.Top, RevolveSolidType.Bottom];
        // 设置旋转轴方向
        const zAxis = axis.direction.clone().normalize();
        // 旋转轴起点
        const origin = axis.origin.clone();
        // 设置x向量xAxis
        const anyAxis = new Vector3$1(1, 0, 0);
        // 如果方向接近平行，选择另一个方向
        if (Math.abs(zAxis.dot(anyAxis)) > 0.999) {
            anyAxis.set(0, 1, 0);
        }
        const xAxis = anyAxis.cross(zAxis).normalize();
        // 生成yAxis
        const yAxis = zAxis.clone().cross(xAxis).normalize();
        // 构造旋转体的变换矩阵
        this.transformMatrix.set(xAxis.x, yAxis.x, zAxis.x, origin.x, xAxis.y, yAxis.y, zAxis.y, origin.y, xAxis.z, yAxis.z, zAxis.z, origin.z, 0, 0, 0, 1);
        this.angle = angle;
        // 将bottomFace的局部坐标系转换到旋转体的局部坐标系下
        if (bottomFace) {
            this.bottomFace = bottomFace;
            // bottomFace.transformMatrix.premultiply(this.transformMatrix.clone().invert());
            let curves = bottomFace.getSideEdges();
            for (let i = 0; i < curves.length; i++) {
                this.surfaceIndex.push(i + 2);
            }
        }
    }
    getGeoElements() {
        this.surfaceIndex = [RevolveSolidType.Top, RevolveSolidType.Bottom];
        let sideCurves = this.bottomFace.getSideEdges();
        for (let i = 0; i < sideCurves.length; i++) {
            this.surfaceIndex.push(i + 2);
        }
        let res = []; // 返回的数组
        this.surfaceIndex.forEach(index => {
            let surface = this.getSurface(index, sideCurves);
            if (surface) {
                res.push(surface);
            }
        });
        return res;
    }
    copy(solid) {
        super.copy(solid);
        this.bottomFace = solid.bottomFace;
        this.angle = solid.angle;
        return this;
    }
    clone() {
        return new RevolveSolid().copy(this);
    }
    equals(solid) {
        return this.bottomFace.equals(solid.bottomFace) && this.axis.equals(solid.axis) && this.angle === solid.angle;
    }
    getCenter(target) {
        if (target == null) {
            target = new Point();
        }
        target.copy(this.center);
        return target;
    }
    /**
     * 根据索引值获取表面
     * @param index
     * @returns
     */
    getSurface(index, sideCurves = []) {
        if (index === RevolveSolidType.Bottom) {
            const bottom = this.bottomFace.clone();
            // bottom.transformMatrix.premultiply(this.transformMatrix);
            return bottom;
        }
        else if (index === RevolveSolidType.Top) {
            const top = this.bottomFace.clone();
            // top.transformMatrix.premultiply(this.transformMatrix);
            top.rotate(this.getP(), this.getNormalizeZ(), this.angle);
            return top;
        }
        else {
            // 侧面的旋转面
            let actualIndex = index - 2;
            // 边线数组
            if (sideCurves.length === 0) {
                sideCurves = this.bottomFace.getSideEdges();
            }
            // 获取旋转轴
            this.getNormalizeZ(_direction);
            this.getP(_origin);
            _axis.setFromDirection(_origin, _direction);
            const side = sideCurves[actualIndex].clone();
            // side.transformMatrix.premultiply(this.transformMatrix);
            let surface = new RevolveSurface(side, _axis, this.angle);
            // surface.transformMatrix.premultiply(this.transformMatrix);
            return surface;
        }
    }
    /**
     * 返回特征点
     * @returns
     */
    getFeaturePoints() {
        const featurePoints = [];
        const bottomPoints = this.bottomFace.getFeaturePoints();
        bottomPoints.forEach(p => {
            p.point.applyMatrix4(this.transformMatrix);
        });
        featurePoints.push(...bottomPoints);
        // const els = this.getGeoElements();
        // const featurePoints = [];
        // els.forEach(el => {
        //     const points = el.getFeaturePoints()
        //     if (points) {
        //         featurePoints.push(...points);
        //     }
        // })
        return featurePoints;
    }
    /**
     * 获取控制点
     * @returns
     */
    getControlPoints() {
        let points = [];
        points.push(...this.bottomFace.getControlPoints());
        return points;
    }
    getBoundingBox() {
        // 初始化最小值和最大值为无穷
        const min = new Point(Infinity, Infinity, Infinity);
        const max = new Point(-Infinity, -Infinity, -Infinity);
        const edgeSample = 4; // 边线采样点数
        const numSamples = 15; // 旋转面采样点数
        // 获取底面上的所有顶点
        const edges = this.bottomFace.edges;
        const basePoints = [];
        for (let i = 0; i < edges.length; i++) {
            const edge = edges[i];
            const points = edge.getPoints(edgeSample);
            basePoints.push(...points);
        }
        // 遍历旋转角度，生成旋转后的点
        for (let i = 0; i <= numSamples; i++) {
            const theta = (i / numSamples) * this.angle;
            // 构造旋转矩阵
            const rotationMatrix = new Matrix4$1().makeRotationAxis(this.axis.clone().normalize(), // 旋转轴方向
            theta);
            // 遍历底面上的点，计算旋转后的点
            for (const point of basePoints) {
                // 点先应用旋转变换
                const rotatedPoint = point.clone().applyMatrix4(rotationMatrix);
                // 转换到世界坐标系
                // rotatedPoint.applyMatrix4(this.transformMatrix);
                // 更新最小值和最大值
                min.x = Math.min(min.x, rotatedPoint.x);
                min.y = Math.min(min.y, rotatedPoint.y);
                min.z = Math.min(min.z, rotatedPoint.z);
                max.x = Math.max(max.x, rotatedPoint.x);
                max.y = Math.max(max.y, rotatedPoint.y);
                max.z = Math.max(max.z, rotatedPoint.z);
            }
        }
        return { min, max };
    }
    // overwrite
    toJson() {
        return Object.assign({ version: "1.0", bottomFace: this.bottomFace.toJson(), angle: this.angle, type: this.type }, super.toJson());
    }
    // overwrite
    fromJson(json) {
        super.fromJson(json);
        this.bottomFace = new RegionFace().fromJson(json.bottomFace);
        this.angle = json.angle;
        return this;
    }
}
const _direction = new Vector3$1();
const _origin = new Vector3$1();
const _axis = new StraightLine();/**
 * 球体
 * 其局部坐标系定义为半径为1，起点为(0,0,0)的标准球体
 */
let Sphere$2=class Sphere extends Solid {
    get center() {
        return new Point().copy(this.getP());
    }
    set center(value) {
        this.setP(value);
    }
    /**
     * 半径
     */
    get radius() {
        return this.scaleX;
    }
    /**
     * 设置半径
     */
    set radius(value) {
        let scale = value / this.scaleX;
        if (scale == 0)
            scale = 1;
        this.scale(this.getP(), scale);
    }
    constructor(center = new Point(), radius = 0) {
        super();
        /*1.初始定义与构造*/
        this.type = 'Sphere';
        // radius: number;
        // center: Point;
        //线框模型三个大圆的normal，为固定的
        this.xDir = new Vector3$1(1, 0, 0);
        this.yDir = new Vector3$1(0, 1, 0);
        this.zDir = new Vector3$1(0, 0, 1);
        /**
         * 球体表面索引，只有一个球面
         */
        this.surfaceIndex = [0];
        this.center = center;
        this.radius = radius;
        this.transformMatrix.set(radius, 0, 0, center.x, 0, radius, 0, center.y, 0, 0, radius, center.z, 0, 0, 0, 1);
    }
    /**
     * 获取包围盒
     * @returns
     */
    getBoundingBox() {
        const min = new Point(-1, -1, -1);
        const max = new Point(1, 1, 1);
        min.applyMatrix4(this.transformMatrix);
        max.applyMatrix4(this.transformMatrix);
        return {
            min: min,
            max: max,
        };
    }
    /**
     * 获取特征点
     * @returns
     */
    getFeaturePoints() {
        const featurePoints = [];
        featurePoints.push({ type: FEATURE_POINT_TYPE.CENTER, point: this.center, geoType: this.type });
        return featurePoints;
    }
    /**
     * 返回控制点
     * @returns
     */
    getControlPoints() {
        const featurePoints = [];
        const spherical = this.getGeoElements()[0];
        featurePoints.push(...[
            { type: FEATURE_POINT_TYPE.END, point: spherical.getPointAt(0, 0.5), geoType: this.type, uvtPosition: new Point(1, 0, 0) },
            { type: FEATURE_POINT_TYPE.END, point: spherical.getPointAt(0.25, 0.5), geoType: this.type, uvtPosition: new Point(0, 1, 0) },
            { type: FEATURE_POINT_TYPE.END, point: spherical.getPointAt(0.5, 0.5), geoType: this.type, uvtPosition: new Point(-1, 0, 0) },
            { type: FEATURE_POINT_TYPE.END, point: spherical.getPointAt(0.75, 0.5), geoType: this.type, uvtPosition: new Point(0, -1, 0) },
        ]);
        featurePoints.push({ type: FEATURE_POINT_TYPE.CENTER, point: this.center, geoType: this.type, uvtPosition: new Point(0, 0, 0) });
        return featurePoints;
    }
    /*2.复制、克隆与判断相等*/
    copy(sphere) {
        this.center = sphere.center;
        this.radius = sphere.radius;
        this.transformMatrix = sphere.transformMatrix;
        return this;
    }
    clone() {
        return new Sphere().copy(this);
    }
    equals(sphere) {
        if (!this.center.equals(sphere.center))
            return false;
        if (Math.abs(this.radius - sphere.radius) > 1e-6)
            return false;
        return true;
    }
    /*4.获取图元上的各种信息*/
    //线框模型的五个圆的几何信息
    // private _xCircle: Circle = new Circle();
    // private _yCircle: Circle = new Circle();
    // private _zCircle: Circle = new Circle();
    // private _topCircle: Circle = new Circle();
    // private _bottomCircle: Circle = new Circle();
    //重新设置线框模型的几何信息   TODO
    // resetHelpCircle() {
    //     this._xCircle.center = this.center;
    //     this._xCircle.radius = this.radius;
    //     this._xCircle.setXYZ(this.yDir, this.xDir);
    //     this._yCircle.center = this.center;
    //     this._yCircle.radius = this.radius;
    //     this._yCircle.setXYZ(this._yCircle.axisX, this.xDir);
    //     this._zCircle.center = this.center;
    //     this._zCircle.radius = this.radius;
    //     this._zCircle.setXYZ(this._zCircle.axisX, this.zDir);
    //     this._topCircle.radius = this.radius / Math.sqrt(2);
    //     this._topCircle.center = this.center.clone().add(this.zDir.clone().multiplyScalar(this._topCircle.radius));
    //     this._topCircle.setXYZ(this._topCircle.axisX, this.zDir);
    //     this._bottomCircle.radius = this.radius / Math.sqrt(2);
    //     this._bottomCircle.center = this.center.clone().add(this.zDir.clone().multiplyScalar(-this._bottomCircle.radius));
    //     this._bottomCircle.setXYZ(this._bottomCircle.axisX, this.zDir);
    // }
    getCenter(target) {
        if (target == null) {
            target = new Point();
        }
        target.copy(this.center);
        return target;
    }
    /**
     * 获取基元数组
     * @returns
     */
    getGeoElements() {
        let res = []; //返回的数组
        this.surfaceIndex.forEach(_ => {
            let surface = new Spherical$1(this.center, this.radius);
            res.push(surface);
        });
        return res;
    }
    toJson() {
        return Object.assign({ version: "1.0", type: this.type }, super.toJson());
    }
    fromJson(json) {
        super.fromJson(json);
        return this;
    }
};const WedgeSurfaceType = {
    Bottom: 0,
    Left: 1,
    Right: 2,
    Front: 3,
    Back: 4
};
/**
 * 楔形
 * 其局部坐标系定义为底边长度为1，宽度为1，高度为1楔形,
 * x轴为底边方向
 * y轴为宽度方向
 * z轴为法向量方向
 * 原点为底面矩阵左下角
 */
class Wedge extends Solid {
    get dirX() {
        return new Vector3$1().copy(this.getX());
    }
    get dirY() {
        return new Vector3$1().copy(this.getY());
    }
    get normal() {
        return new Vector3$1().copy(this.getZ());
    }
    get basePoint() {
        return new Point().copy(this.getP());
    }
    set basePoint(value) {
        this.setP(value);
    }
    get length() {
        return this.scaleX;
    }
    set length(value) {
        let scale = value / this.scaleX;
        if (scale == 0)
            scale = 1;
        this.scale(this.getP(), scale, 1, 1);
    }
    get width() {
        return this.scaleY;
    }
    set width(value) {
        let scale = value / this.scaleY;
        if (scale == 0)
            scale = 1;
        this.scale(this.getP(), 1, scale, 1);
    }
    get height() {
        return this.scaleZ;
    }
    set height(value) {
        let scale = value / this.scaleZ;
        if (scale == 0)
            scale = 1;
        this.scale(this.getP(), 1, 1, scale);
    }
    constructor(basePoint = new Point(), length = 0, width = 0, heigth = 0, dirX = new Vector3$1(1, 0, 0), normal = new Vector3$1(0, 0, 1)) {
        super();
        this.type = 'Wedge';
        this.surfaceIndex = [WedgeSurfaceType.Bottom, WedgeSurfaceType.Left, WedgeSurfaceType.Right, WedgeSurfaceType.Front, WedgeSurfaceType.Back];
        this.basePoint = basePoint;
        this.length = length;
        this.width = width;
        this.height = heigth;
        this.setXYZ(dirX, normal);
    }
    set(basePoint, length, width, heigth, dirX, normal) {
        this.basePoint = basePoint;
        this.length = length;
        this.width = width;
        this.height = heigth;
        this.setXYZ(dirX, normal);
        return this;
    }
    copy(box) {
        this.basePoint = box.basePoint;
        this.length = box.length;
        this.width = box.width;
        this.height = box.height;
        this.setXYZ(box.dirX, box.normal);
        return this;
    }
    clone() {
        return new Wedge().copy(this);
    }
    equals(wedge) {
        if (!this.matrixEquals(wedge.transformMatrix))
            return false;
        return true;
    }
    getCenter(target) {
        if (target == null) {
            target = new Point();
        }
        target.copy(this.dirX.clone().multiplyScalar(this.length).add(this.dirY.clone().multiplyScalar(this.width)).multiplyScalar(0.5)).add(this.basePoint);
        return target;
    }
    /**
     * 获取特征点
     * @returns
     */
    getFeaturePoints() {
        return [];
    }
    /**
     * 获取控制点
     * @returns
     */
    getControlPoints() {
        return [
            { type: FEATURE_POINT_TYPE.CENTER, point: this.getSurface(WedgeSurfaceType.Bottom).getPointAt(0.5, 0.5), geoType: this.type }
        ];
    }
    /**
     * 获取包围盒
     * @returns
     */
    getBoundingBox() {
        const bottom = this.getSurface(WedgeSurfaceType.Bottom);
        const left = this.getSurface(WedgeSurfaceType.Left);
        const bottomData = bottom.getBoundingBox();
        const leftData = left.getBoundingBox();
        let min = new Vector3$1(Math.min(leftData.min.x, bottomData.min.x), Math.min(leftData.min.y, bottomData.min.y), Math.min(leftData.min.z, bottomData.min.z));
        let max = new Vector3$1(Math.max(leftData.max.x, bottomData.max.x), Math.max(leftData.max.y, bottomData.max.y), Math.max(leftData.max.z, bottomData.max.z));
        return {
            min: min,
            max: max
        };
    }
    /**
     * 获取基元数组
     * @returns
     */
    getGeoElements() {
        let res = []; //返回的数组
        this.surfaceIndex.forEach(index => {
            let surface = this.getSurface(index);
            if (surface) {
                res.push(surface);
            }
        });
        return res;
    }
    /**
     * 根据索引值获取表面
     * @param index
     * @returns
     */
    getSurface(index) {
        switch (index) {
            case WedgeSurfaceType.Bottom:
                return new RectFace(this.getP(), this.getX(), this.getY());
            case WedgeSurfaceType.Left:
                return new RectFace(this.getP(), this.getZ(), this.getY());
            case WedgeSurfaceType.Right:
                let vecX = new Vector3$1(1, 0, -1).applyMatrix4(this.transformMatrix).sub(this.getP());
                return new RectFace(new Point(0, 0, 1).applyMatrix4(this.transformMatrix), vecX, this.getY());
            case WedgeSurfaceType.Front:
                return new Triangle$1(this.getP(), new Point(1, 0, 0).applyMatrix4(this.transformMatrix), new Point(0, 0, 1).applyMatrix4(this.transformMatrix));
            case WedgeSurfaceType.Back:
                return new Triangle$1(new Point(0, 1, 0).applyMatrix4(this.transformMatrix), new Point(0, 1, 1).applyMatrix4(this.transformMatrix), new Point(1, 1, 0).applyMatrix4(this.transformMatrix));
            default:
                return null;
        }
    }
    toJson() {
        let data = Object.assign({ version: "1.0", basePoint: {
                x: this.basePoint.x,
                y: this.basePoint.y,
                z: this.basePoint.z,
            }, length: this.length, width: this.width, height: this.height, dirX: {
                x: this.dirX.x,
                y: this.dirX.y,
                z: this.dirX.z,
            }, dirY: {
                x: this.dirY.x,
                y: this.dirY.y,
                z: this.dirY.z,
            }, normal: {
                x: this.normal.x,
                y: this.normal.y,
                z: this.normal.z,
            } }, super.toJson());
        return data;
    }
    fromJson(json) {
        this.basePoint = new Point(json.basePoint.x, json.basePoint.y, json.basePoint.z);
        this.length = json.length;
        this.width = json.width;
        this.height = json.height;
        this.setXYZ(new Vector3$1(json.dirX.x, json.dirX.y, json.dirX.z), new Vector3$1(json.normal.x, json.normal.y, json.normal.z));
        return this;
    }
}/**
 * 圆环体
 */
class Torus extends Solid {
    /**
     * 平面法向量
     */
    get normal() {
        return this.getNormalizeZ();
    }
    /**
     * 圆环半径
     */
    get radius() {
        return this.scaleX;
    }
    getGeoElements() {
        let res = []; //返回的数组
        const line = new StraightLine(this.center, this.normal);
        this.getP(_p$6).add(this.getX());
        const rev = new RevolveSurface(new Circle(_p$6, this.segmentRadius, this.getNormalizeY(), this.getNormalizeX()), line);
        res.push(rev);
        return res;
    }
    /**
     * 设置圆环半径
     */
    set radius(value) {
        let scale = value / this.scaleX;
        if (scale == 0)
            scale = 1;
        this.scale(this.getP(), scale);
    }
    /**
     * 设置圆环截面半径，重新计算旋转体的底面
     * @param value
     */
    setSegmentRadius(value) {
        this.segmentRadius = value;
    }
    /**
     * 圆心
     */
    get center() {
        return this.getP();
    }
    /**
     * 设置圆心
     */
    set center(value) {
        this.setP(value);
    }
    /**
     * 构造方法
     * @param center 圆环圆心
     * @param radius 圆环半径
     * @param normal 法向量
     * @param axisX x轴
     * @param segmentRadius 截面半径
     */
    constructor(center = new Point(), radius = 1, normal = new Vector3$1(0, 0, 1), axisX = new Vector3$1(1, 0, 0), segmentRadius = 0) {
        super();
        /**
         * 类型
         */
        this.type = "Torus";
        /**
         * 面索引
         */
        this.surfaceIndex = [0];
        this.transformMatrix.elements[8] = normal.x;
        this.transformMatrix.elements[9] = normal.y;
        this.transformMatrix.elements[10] = normal.z;
        axisX = axisX.normalize();
        this.updateMatrixByX(axisX, false);
        if (radius <= 0)
            radius = 1;
        this.radius = radius;
        this.center = center;
        this.segmentRadius = segmentRadius;
    }
    /**
     * 复制
     * @param torus
     * @returns
     */
    copy(torus) {
        this.transformMatrix.copy(torus.transformMatrix);
        this.segmentRadius = torus.segmentRadius;
        return this;
    }
    scale(point, factorX, factorY, factorZ) {
        super.scale(point, factorX, factorY, factorZ);
        this.setSegmentRadius(this.segmentRadius * factorX);
        return this;
    }
    /**
     * 获取特征点
     * @returns
     */
    getFeaturePoints() {
        const featurePoints = [];
        return featurePoints;
    }
    /**
     * 获取控制点
     * @returns
     */
    getControlPoints() {
        const featurePoints = [];
        const revolve = this.getGeoElements()[0];
        const origin = this.getP();
        const direction = this.getZ().normalize();
        const baseCenter = revolve.baseCurve.center;
        baseCenter.applyMatrix4(revolve.transformMatrix); //需要乘以旋转面的局部坐标
        featurePoints.push(...[
            { type: FEATURE_POINT_TYPE.END, point: baseCenter.clone().sub(origin).applyAxisAngle(direction, 0).add(origin), geoType: this.type, uvtPosition: new Point(1, 0, 0) },
            { type: FEATURE_POINT_TYPE.END, point: baseCenter.clone().sub(origin).applyAxisAngle(direction, revolve.angle * 0.25).add(origin), geoType: this.type, uvtPosition: new Point(0, 1, 0) },
            { type: FEATURE_POINT_TYPE.END, point: baseCenter.clone().sub(origin).applyAxisAngle(direction, revolve.angle * 0.5).add(origin), geoType: this.type, uvtPosition: new Point(-1, 0, 0) },
            { type: FEATURE_POINT_TYPE.END, point: baseCenter.clone().sub(origin).applyAxisAngle(direction, revolve.angle * 0.75).add(origin), geoType: this.type, uvtPosition: new Point(0, -1, 0) },
        ]);
        featurePoints.push({ type: FEATURE_POINT_TYPE.CENTER, point: this.center, geoType: this.type, uvtPosition: new Point(0, 0, 0) });
        return featurePoints;
    }
    /**
     * 获取包围盒
     * @returns
     */
    getBoundingBox() {
        return this.getGeoElements()[0].getBoundingBox();
    }
    /**
     * 克隆
     * @returns
     */
    clone() {
        return new Torus().copy(this);
    }
    /**
     * 判断是否相等
     * @param box
     * @returns
     */
    equals(torus) {
        if (torus.segmentRadius !== this.segmentRadius)
            return false;
        return this.matrixEquals(torus.transformMatrix);
    }
    /**
     * 抽象成json
     * @returns
     */
    toJson() {
        let data = Object.assign({ version: "1.0", type: this.type, segmentRadius: this.segmentRadius }, super.toJson());
        return data;
    }
    fromJson(json) {
        super.fromJson(json);
        this.segmentRadius = json.segmentRadius;
        return this;
    }
}
const _p$6 = new Point();const SweeperSolidType = {
    Top: 0,
    Bottom: 1,
};
class SweeperSolid extends Solid {
    /**
     * 构造函数
     * @param baseSurface 扫掠基面
     * @param sweepPath 扫掠路径
     */
    constructor(baseSurface, sweepPath, basePoint) {
        super();
        /**
         * 几何类型
         */
        this.type = 'SweeperSolid';
        /**
         * 顶面相对于底面的缩放系数
         */
        this.scaleFactor = 1;
        /**
         * 面类型数组
         */
        this.surfaceIndex = [SweeperSolidType.Top, SweeperSolidType.Bottom];
        if (baseSurface) {
            this.baseSurface = baseSurface.clone();
        }
        if (sweepPath) {
            this.sweepPath = sweepPath.clone(); // 将曲线设置为多段的曲线
        }
        //未指定基点，对基点进行默认选择操作
        if (basePoint == null) {
            this.basePoint = baseSurface ? baseSurface.getCenter() : new Point();
        }
        else {
            this.basePoint = basePoint.clone();
        }
        this.surfaceIndex = [SweeperSolidType.Top, SweeperSolidType.Bottom];
        if (baseSurface) {
            let curves = baseSurface.getSideEdges();
            for (let i = 0; i < curves.length; i++) {
                this.surfaceIndex.push(i + 2);
            }
        }
    }
    /**
     * 获取基元数组
     * @returns
     */
    getGeoElements() {
        this.surfaceIndex = [SweeperSolidType.Top, SweeperSolidType.Bottom];
        let sideCurves = this.baseSurface.getSideEdges();
        for (let i = 0; i < sideCurves.length; i++) {
            this.surfaceIndex.push(i + 2);
        }
        let res = []; // 返回的数组
        this.surfaceIndex.map(index => {
            const surface = this.getSurface(index);
            if (surface) {
                res.push(surface);
            }
        });
        return res;
    }
    /**
     * 根据索引值获得表面
     * @param index
     */
    getSurface(index) {
        if (index === SweeperSolidType.Top) { // 当获取的表面是顶面时，对顶面进行旋转并将顶面平移到扫掠路径对应的终点
            // 获取扫掠基面
            let top = this.baseSurface.clone();
            // 获取扫掠路径终点的位置
            const endPoint = this.sweepPath.getEndPoints()[0];
            // 获取路径终点处切向量
            const endTangent = this.sweepPath.getCutLineDir(endPoint);
            top = this.getEndSurface(top, endPoint, endTangent);
            return top;
        }
        else if (index === SweeperSolidType.Bottom) { // 当获取的表面是底面
            // 对底面进行旋转并将顶面平移到扫掠路径对应的起点
            // 获取扫掠基面
            let top = this.baseSurface.clone();
            // 获取扫掠路径起点的位置
            const startPoint = this.sweepPath.getEndPoints()[1];
            // 获取路径起点处切向量
            const startTangent = this.sweepPath.getCutLineDir(startPoint);
            top = this.getEndSurface(top, startPoint, startTangent);
            return top;
        }
        else { // 当获取的表面是扫掠侧面
            // 通过底面边和扫掠路径创建扫掠面
            const top = this.baseSurface.clone();
            const edges = top.getSideEdges();
            // 创建扫掠面
            const edge = edges[index - 2];
            let angle;
            if (top.getNormalizeX().cross(edge.getNormalizeX()).z > 0) {
                angle = Math.acos(top.getNormalizeX().dot(edge.getNormalizeX()));
            }
            else {
                angle = -Math.acos(top.getNormalizeX().dot(edge.getNormalizeX()));
            }
            const sweeperSurface = new SweeperSurface(edge, this.sweepPath, this.basePoint, angle);
            return sweeperSurface;
        }
    }
    /**
     * 构造旋转矩阵
     * @param vecOrigin 物体原先方向
     * @param vecTarget 旋转后物体方向
     * @param axis 用户指定旋转轴(当物体旋转角度为PI的时候才有效果)
     * @returns
     */
    getRotationMatrix(vecOrigin, vecTarget, axis) {
        vecOrigin.normalize();
        vecTarget.normalize();
        // 计算旋转轴
        const myAxis = new Vector3$1().crossVectors(vecOrigin, vecTarget);
        // 计算旋转角度
        const angle = Math.acos(vecOrigin.dot(vecTarget));
        // 构造旋转矩阵
        if (Math.abs(angle - Math.PI) < Number.EPSILON && axis != null) {
            // 判断旋转角度是否为pi，在旋转角度为pi时用户可以自定义旋转轴
            return new Matrix4$1().makeRotationAxis(axis.normalize(), angle);
        }
        return new Matrix4$1().makeRotationAxis(myAxis.normalize(), angle);
    }
    /**
     * 获取扫掠体两端的面
     * @param bottom 基面
     * @param point 端点坐标
     * @param tangent 端点处切向量
     * @returns
     */
    getEndSurface(bottom, point, tangent) {
        // 获取扫掠基面对应的坐标点
        const basePoint = this.basePoint.clone();
        // 获取基面法向量
        const baseNormal = bottom.getNormalizeZ();
        /**
         * 获取到顶面需要进行三步变换:
         * 1. 将原有底面平移到原点处
         * 2. 对底面进行旋转，将底面法向量旋转到扫掠路径终点切向量的方向
         * 3. 将底面平移到扫掠路径终点处
         * 由上面三步可知，需要构造三个变换矩阵
         */
        // 构造平移变换矩阵1，将底面平移到原点
        const transM1 = new Matrix4$1(1, 0, 0, -basePoint.x, 0, 1, 0, -basePoint.y, 0, 0, 1, -basePoint.z, 0, 0, 0, 1);
        // 构造旋转变换矩阵
        const rotationMatrix = this.getRotationMatrix(baseNormal, tangent);
        // 构造平移变换矩阵2，将底面平移到扫掠路径位置
        const transM2 = new Matrix4$1(1, 0, 0, point.x, 0, 1, 0, point.y, 0, 0, 1, point.z, 0, 0, 0, 1);
        // 对原始矩阵进行变换
        bottom.transformMatrix.premultiply(transM1);
        bottom.transformMatrix.premultiply(rotationMatrix);
        //旋转后平面的y轴需要和曲线的z轴对齐
        const bottomY = bottom.getNormalizeY();
        const sweepZ = this.sweepPath.getNormalizeZ();
        const rotaMY = this.getRotationMatrix(bottomY, sweepZ, tangent);
        bottom.transformMatrix.premultiply(rotaMY);
        bottom.transformMatrix.premultiply(transM2);
        return bottom;
    }
    copy(geo) {
        super.copy(geo);
        this.baseSurface = geo.baseSurface.clone();
        this.sweepPath = geo.sweepPath.clone();
        this.basePoint = geo.basePoint.clone();
        this.scaleFactor = geo.scaleFactor;
        this.surfaceIndex = [...geo.surfaceIndex];
        return this;
    }
    clone() {
        return new SweeperSolid().copy(this);
    }
    getBoundingBox() {
        const min = new Point(Infinity, Infinity, Infinity);
        const max = new Point(-Infinity, -Infinity, -Infinity);
        let boxs = [0, 1].map(index => {
            return this.getSurface(index).getBoundingBox();
        });
        boxs.forEach(box => {
            min.x = Math.min(min.x, box.min.x);
            min.y = Math.min(min.y, box.min.y);
            min.z = Math.min(min.z, box.min.z);
            max.x = Math.max(max.x, box.max.x);
            max.y = Math.max(max.y, box.max.y);
            max.z = Math.max(max.z, box.max.z);
        });
        return { min, max };
    }
    /**
    * 获取特征点列表
    * @returns
    */
    getFeaturePoints() {
        let bottomRes = this.getSurface(0).getFeaturePoints();
        let topBottomRes = this.getSurface(1).getFeaturePoints();
        bottomRes.forEach(item => {
            item.point.applyMatrix4(this.transformMatrix);
            let uv = item.uvtPosition;
            if (!uv) {
                uv = new Point2(0, 0);
            }
            let newUv = new Point(uv.x, uv.y, 0);
            item.uvtPosition = newUv;
        });
        topBottomRes.forEach(item => {
            item.point.applyMatrix4(this.transformMatrix);
            item.point.add(this.getZ());
            let uv = item.uvtPosition;
            if (!uv) {
                uv = new Point2(0, 0);
            }
            let newUv = new Point(uv.x, uv.y, 1);
            item.uvtPosition = newUv;
        });
        return [
            ...bottomRes,
            ...topBottomRes
        ];
    }
    toJson() {
        return Object.assign(Object.assign({}, super.toJson()), { version: "1.1", type: this.type, baseSurface: this.baseSurface.toJson(), sweepPath: this.sweepPath.toJson(), basePoint: {
                x: this.basePoint.x,
                y: this.basePoint.y,
                z: this.basePoint.z,
            }, scaleFactor: this.scaleFactor });
    }
    fromJson(json) {
        super.fromJson(json);
        this.baseSurface = new BaseFaceTrans[json.baseSurface.type]().fromJson(json.baseSurface);
        this.sweepPath = new BaseCurveTrans[json.sweepPath.type]().fromJson(json.sweepPath);
        this.basePoint = new Point(json.basePoint.x, json.basePoint.y, json.basePoint.z);
        this.scaleFactor = json.scaleFactor;
        return this;
    }
}function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}var EarClip = {exports: {}};EarClip.exports = earcut;
EarClip.exports.default = earcut;

function earcut(data, holeIndices, dim) {

    dim = dim || 2;

    var hasHoles = holeIndices && holeIndices.length,
        outerLen = hasHoles ? holeIndices[0] * dim : data.length,
        outerNode = linkedList(data, 0, outerLen, dim, true),
        triangles = [];

    if (!outerNode || outerNode.next === outerNode.prev) return triangles;

    var minX, minY, maxX, maxY, x, y, invSize;

    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);

    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = maxX = data[0];
        minY = maxY = data[1];

        for (var i = dim; i < outerLen; i += dim) {
            x = data[i];
            y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }

        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 1 / invSize : 0;
    }

    earcutLinked(outerNode, triangles, dim, minX, minY, invSize);

    return triangles;
}

// create a circular doubly linked list from polygon points in the specified winding order
function linkedList(data, start, end, dim, clockwise) {
    var i, last;

    if (clockwise === (signedArea(data, start, end, dim) > 0)) {
        for (i = start; i < end; i += dim) last = insertNode(i, data[i], data[i + 1], last);
    } else {
        for (i = end - dim; i >= start; i -= dim) last = insertNode(i, data[i], data[i + 1], last);
    }

    if (last && equals(last, last.next)) {
        removeNode(last);
        last = last.next;
    }

    return last;
}

// eliminate colinear or duplicate points
function filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;

    var p = start,
        again;
    do {
        again = false;

        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
            removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;

        } else {
            p = p.next;
        }
    } while (again || p !== end);

    return end;
}

// main ear slicing loop which triangulates a polygon (given as a linked list)
function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;

    // interlink polygon nodes in z-order
    if (!pass && invSize) indexCurve(ear, minX, minY, invSize);

    var stop = ear,
        prev, next;

    // iterate through ears, slicing them one by one
    while (ear.prev !== ear.next) {
        prev = ear.prev;
        next = ear.next;

        if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim);
            triangles.push(ear.i / dim);
            triangles.push(next.i / dim);

            removeNode(ear);

            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;

            continue;
        }

        ear = next;

        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) {
                earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);

            // if this didn't work, try curing all small self-intersections locally
            } else if (pass === 1) {
                ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
                earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);

            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) {
                splitEarcut(ear, triangles, dim, minX, minY, invSize);
            }

            break;
        }
    }
}

// check whether a polygon node forms a valid ear with adjacent nodes
function isEar(ear) {
    var a = ear.prev,
        b = ear,
        c = ear.next;

    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear

    // now make sure we don't have other points inside the potential ear
    var p = ear.next.next;

    while (p !== ear.prev) {
        if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
            area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }

    return true;
}

function isEarHashed(ear, minX, minY, invSize) {
    var a = ear.prev,
        b = ear,
        c = ear.next;

    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear

    // triangle bbox; min & max are calculated like this for speed
    var minTX = a.x < b.x ? (a.x < c.x ? a.x : c.x) : (b.x < c.x ? b.x : c.x),
        minTY = a.y < b.y ? (a.y < c.y ? a.y : c.y) : (b.y < c.y ? b.y : c.y),
        maxTX = a.x > b.x ? (a.x > c.x ? a.x : c.x) : (b.x > c.x ? b.x : c.x),
        maxTY = a.y > b.y ? (a.y > c.y ? a.y : c.y) : (b.y > c.y ? b.y : c.y);

    // z-order range for the current triangle bbox;
    var minZ = zOrder(minTX, minTY, minX, minY, invSize),
        maxZ = zOrder(maxTX, maxTY, minX, minY, invSize);

    var p = ear.prevZ,
        n = ear.nextZ;

    // look for points inside the triangle in both directions
    while (p && p.z >= minZ && n && n.z <= maxZ) {
        if (p !== ear.prev && p !== ear.next &&
            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
            area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;

        if (n !== ear.prev && n !== ear.next &&
            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) &&
            area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }

    // look for remaining points in decreasing z-order
    while (p && p.z >= minZ) {
        if (p !== ear.prev && p !== ear.next &&
            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
            area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }

    // look for remaining points in increasing z-order
    while (n && n.z <= maxZ) {
        if (n !== ear.prev && n !== ear.next &&
            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) &&
            area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }

    return true;
}

// go through all polygon nodes and cure small local self-intersections
function cureLocalIntersections(start, triangles, dim) {
    var p = start;
    do {
        var a = p.prev,
            b = p.next.next;

        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {

            triangles.push(a.i / dim);
            triangles.push(p.i / dim);
            triangles.push(b.i / dim);

            // remove two nodes involved
            removeNode(p);
            removeNode(p.next);

            p = start = b;
        }
        p = p.next;
    } while (p !== start);

    return filterPoints(p);
}

// try splitting polygon into two and triangulate them independently
function splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    var a = start;
    do {
        var b = a.next.next;
        while (b !== a.prev) {
            if (a.i !== b.i && isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                var c = splitPolygon(a, b);

                // filter colinear points around the cuts
                a = filterPoints(a, a.next);
                c = filterPoints(c, c.next);

                // run earcut on each half
                earcutLinked(a, triangles, dim, minX, minY, invSize);
                earcutLinked(c, triangles, dim, minX, minY, invSize);
                return;
            }
            b = b.next;
        }
        a = a.next;
    } while (a !== start);
}

// link every hole into the outer loop, producing a single-ring polygon without holes
function eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [],
        i, len, start, end, list;

    for (i = 0, len = holeIndices.length; i < len; i++) {
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push(getLeftmost(list));
    }

    queue.sort(compareX);

    // process holes from left to right
    for (i = 0; i < queue.length; i++) {
        outerNode = eliminateHole(queue[i], outerNode);
        outerNode = filterPoints(outerNode, outerNode.next);
    }

    return outerNode;
}

function compareX(a, b) {
    return a.x - b.x;
}

// find a bridge between vertices that connects hole with an outer ring and and link it
function eliminateHole(hole, outerNode) {
    var bridge = findHoleBridge(hole, outerNode);
    if (!bridge) {
        return outerNode;
    }

    var bridgeReverse = splitPolygon(bridge, hole);

    // filter collinear points around the cuts
    var filteredBridge = filterPoints(bridge, bridge.next);
    filterPoints(bridgeReverse, bridgeReverse.next);

    // Check if input node was removed by the filtering
    return outerNode === bridge ? filteredBridge : outerNode;
}

// David Eberly's algorithm for finding a bridge between hole and outer polygon
function findHoleBridge(hole, outerNode) {
    var p = outerNode,
        hx = hole.x,
        hy = hole.y,
        qx = -Infinity,
        m;

    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                if (x === hx) {
                    if (hy === p.y) return p;
                    if (hy === p.next.y) return p.next;
                }
                m = p.x < p.next.x ? p : p.next;
            }
        }
        p = p.next;
    } while (p !== outerNode);

    if (!m) return null;

    if (hx === qx) return m; // hole touches outer segment; pick leftmost endpoint

    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point

    var stop = m,
        mx = m.x,
        my = m.y,
        tanMin = Infinity,
        tan;

    p = m;

    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x &&
                pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {

            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential

            if (locallyInside(p, hole) &&
                (tan < tanMin || (tan === tanMin && (p.x > m.x || (p.x === m.x && sectorContainsSector(m, p)))))) {
                m = p;
                tanMin = tan;
            }
        }

        p = p.next;
    } while (p !== stop);

    return m;
}

// whether sector in vertex m contains sector in vertex p in the same coordinates
function sectorContainsSector(m, p) {
    return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
}

// interlink polygon nodes in z-order
function indexCurve(start, minX, minY, invSize) {
    var p = start;
    do {
        if (p.z === null) p.z = zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    } while (p !== start);

    p.prevZ.nextZ = null;
    p.prevZ = null;

    sortLinked(p);
}

// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function sortLinked(list) {
    var i, p, q, e, tail, numMerges, pSize, qSize,
        inSize = 1;

    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;

        while (p) {
            numMerges++;
            q = p;
            pSize = 0;
            for (i = 0; i < inSize; i++) {
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;

            while (pSize > 0 || (qSize > 0 && q)) {

                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }

                if (tail) tail.nextZ = e;
                else list = e;

                e.prevZ = tail;
                tail = e;
            }

            p = q;
        }

        tail.nextZ = null;
        inSize *= 2;

    } while (numMerges > 1);

    return list;
}

// z-order of a point given coords and inverse of the longer side of data bbox
function zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = 32767 * (x - minX) * invSize;
    y = 32767 * (y - minY) * invSize;

    x = (x | (x << 8)) & 0x00FF00FF;
    x = (x | (x << 4)) & 0x0F0F0F0F;
    x = (x | (x << 2)) & 0x33333333;
    x = (x | (x << 1)) & 0x55555555;

    y = (y | (y << 8)) & 0x00FF00FF;
    y = (y | (y << 4)) & 0x0F0F0F0F;
    y = (y | (y << 2)) & 0x33333333;
    y = (y | (y << 1)) & 0x55555555;

    return x | (y << 1);
}

// find the leftmost node of a polygon ring
function getLeftmost(start) {
    var p = start,
        leftmost = start;
    do {
        if (p.x < leftmost.x || (p.x === leftmost.x && p.y < leftmost.y)) leftmost = p;
        p = p.next;
    } while (p !== start);

    return leftmost;
}

// check if a point lies within a convex triangle
function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 &&
           (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 &&
           (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
}

// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && // dones't intersect other edges
           (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && // locally visible
            (area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
            equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
}

// signed area of a triangle
function area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}

// check if two points are equal
function equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}

// check if two segments intersect
function intersects(p1, q1, p2, q2) {
    var o1 = sign(area(p1, q1, p2));
    var o2 = sign(area(p1, q1, q2));
    var o3 = sign(area(p2, q2, p1));
    var o4 = sign(area(p2, q2, q1));

    if (o1 !== o2 && o3 !== o4) return true; // general case

    if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2

    return false;
}

// for collinear points p, q, r, check if point q lies on segment pr
function onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}

function sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}

// check if a polygon diagonal intersects any polygon segments
function intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
                intersects(p, p.next, a, b)) return true;
        p = p.next;
    } while (p !== a);

    return false;
}

// check if a polygon diagonal is locally inside the polygon
function locallyInside(a, b) {
    return area(a.prev, a, a.next) < 0 ?
        area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 :
        area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
}

// check if the middle point of a polygon diagonal is inside the polygon
function middleInside(a, b) {
    var p = a,
        inside = false,
        px = (a.x + b.x) / 2,
        py = (a.y + b.y) / 2;
    do {
        if (((p.y > py) !== (p.next.y > py)) && p.next.y !== p.y &&
                (px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x))
            inside = !inside;
        p = p.next;
    } while (p !== a);

    return inside;
}

// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function splitPolygon(a, b) {
    var a2 = new Node(a.i, a.x, a.y),
        b2 = new Node(b.i, b.x, b.y),
        an = a.next,
        bp = b.prev;

    a.next = b;
    b.prev = a;

    a2.next = an;
    an.prev = a2;

    b2.next = a2;
    a2.prev = b2;

    bp.next = b2;
    b2.prev = bp;

    return b2;
}

// create a node and optionally link it with previous one (in a circular doubly linked list)
function insertNode(i, x, y, last) {
    var p = new Node(i, x, y);

    if (!last) {
        p.prev = p;
        p.next = p;

    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}

function removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;

    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}

function Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;

    // vertex coordinates
    this.x = x;
    this.y = y;

    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;

    // z-order curve value
    this.z = null;

    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;

    // indicates whether this is a steiner point
    this.steiner = false;
}

// return a percentage difference between the polygon area and its triangulation area;
// used to verify correctness of triangulation
earcut.deviation = function (data, holeIndices, dim, triangles) {
    var hasHoles = holeIndices && holeIndices.length;
    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;

    var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
    if (hasHoles) {
        for (var i = 0, len = holeIndices.length; i < len; i++) {
            var start = holeIndices[i] * dim;
            var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
            polygonArea -= Math.abs(signedArea(data, start, end, dim));
        }
    }

    var trianglesArea = 0;
    for (i = 0; i < triangles.length; i += 3) {
        var a = triangles[i] * dim;
        var b = triangles[i + 1] * dim;
        var c = triangles[i + 2] * dim;
        trianglesArea += Math.abs(
            (data[a] - data[c]) * (data[b + 1] - data[a + 1]) -
            (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }

    return polygonArea === 0 && trianglesArea === 0 ? 0 :
        Math.abs((trianglesArea - polygonArea) / polygonArea);
};

function signedArea(data, start, end, dim) {
    var sum = 0;
    for (var i = start, j = end - dim; i < end; i += dim) {
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}

// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
earcut.flatten = function (data) {
    var dim = data[0][0].length,
        result = {vertices: [], holes: [], dimensions: dim},
        holeIndex = 0;

    for (var i = 0; i < data.length; i++) {
        for (var j = 0; j < data[i].length; j++) {
            for (var d = 0; d < dim; d++) result.vertices.push(data[i][j][d]);
        }
        if (i > 0) {
            holeIndex += data[i - 1].length;
            result.holes.push(holeIndex);
        }
    }
    return result;
};

var EarClipExports = EarClip.exports;
var earcut$1 = /*@__PURE__*/getDefaultExportFromCjs(EarClipExports);/**
 * 通过耳切法返回三角剖分数组
 * @param coords 耳切法顶点坐标（二维坐标，铺开，比如有点A(xa, ya), B(xb, yb), C(xc, yc)可以写成[xa, ya, xb, yb, xc, yc]）
 * @param holesIndics 耳切法所需洞的开始索引，比如第一个洞的顶点从数组data的索引20开始，第二个洞的顶点从数组data1索引34开始，则写成[20, 34]
 */
function triangulationByEarcut(coords, holesIndics) {
    return earcut$1(coords, holesIndics, 2);
}/**
 * 捕捉信息存储器
 */
class CaptureStore {
    constructor() {
        /**
         * 开启捕捉
         */
        this.enabled = true;
        /**
         * 激活捕捉 初始化捕捉节点那里激活
         */
        this.captureActived = false;
        /**
         * 可被捕捉到的点
         */
        this.capturePointsPool = [];
        /**
         * 捕捉像素精度
         */
        this.captureThreshold = 15;
        /**
         * 捕捉类别列表
         */
        this.captureTypeList = [FEATURE_POINT_TYPE.END, FEATURE_POINT_TYPE.MIDDLE];
    }
    /**
     * 销毁
     */
    dispose() {
        this.capturePointsPool = [];
        this.capturePoint = null;
    }
}/**
 * @license
 * Copyright 2010-2024 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
const REVISION = '166';
const CullFaceNone = 0;
const CullFaceBack = 1;
const CullFaceFront = 2;
const PCFShadowMap = 1;
const PCFSoftShadowMap = 2;
const VSMShadowMap = 3;
const FrontSide = 0;
const BackSide = 1;
const DoubleSide = 2;
const NoBlending = 0;
const NormalBlending = 1;
const AdditiveBlending = 2;
const SubtractiveBlending = 3;
const MultiplyBlending = 4;
const CustomBlending = 5;
const AddEquation = 100;
const SubtractEquation = 101;
const ReverseSubtractEquation = 102;
const MinEquation = 103;
const MaxEquation = 104;
const ZeroFactor = 200;
const OneFactor = 201;
const SrcColorFactor = 202;
const OneMinusSrcColorFactor = 203;
const SrcAlphaFactor = 204;
const OneMinusSrcAlphaFactor = 205;
const DstAlphaFactor = 206;
const OneMinusDstAlphaFactor = 207;
const DstColorFactor = 208;
const OneMinusDstColorFactor = 209;
const SrcAlphaSaturateFactor = 210;
const ConstantColorFactor = 211;
const OneMinusConstantColorFactor = 212;
const ConstantAlphaFactor = 213;
const OneMinusConstantAlphaFactor = 214;
const NeverDepth = 0;
const AlwaysDepth = 1;
const LessDepth = 2;
const LessEqualDepth = 3;
const EqualDepth = 4;
const GreaterEqualDepth = 5;
const GreaterDepth = 6;
const NotEqualDepth = 7;
const MultiplyOperation = 0;
const MixOperation = 1;
const AddOperation = 2;
const NoToneMapping = 0;
const LinearToneMapping = 1;
const ReinhardToneMapping = 2;
const CineonToneMapping = 3;
const ACESFilmicToneMapping = 4;
const CustomToneMapping = 5;
const AgXToneMapping = 6;
const NeutralToneMapping = 7;

const UVMapping = 300;
const CubeReflectionMapping = 301;
const CubeRefractionMapping = 302;
const EquirectangularReflectionMapping = 303;
const EquirectangularRefractionMapping = 304;
const CubeUVReflectionMapping = 306;
const RepeatWrapping = 1000;
const ClampToEdgeWrapping = 1001;
const MirroredRepeatWrapping = 1002;
const NearestFilter = 1003;
const NearestMipmapNearestFilter = 1004;
const NearestMipmapLinearFilter = 1005;
const LinearFilter = 1006;
const LinearMipmapNearestFilter = 1007;
const LinearMipmapLinearFilter = 1008;
const UnsignedByteType = 1009;
const ByteType = 1010;
const ShortType = 1011;
const UnsignedShortType = 1012;
const IntType = 1013;
const UnsignedIntType = 1014;
const FloatType = 1015;
const HalfFloatType = 1016;
const UnsignedShort4444Type = 1017;
const UnsignedShort5551Type = 1018;
const UnsignedInt248Type = 1020;
const UnsignedInt5999Type = 35902;
const AlphaFormat = 1021;
const RGBFormat = 1022;
const RGBAFormat = 1023;
const LuminanceFormat = 1024;
const LuminanceAlphaFormat = 1025;
const DepthFormat = 1026;
const DepthStencilFormat = 1027;
const RedFormat = 1028;
const RedIntegerFormat = 1029;
const RGFormat = 1030;
const RGIntegerFormat = 1031;
const RGBAIntegerFormat = 1033;

const RGB_S3TC_DXT1_Format = 33776;
const RGBA_S3TC_DXT1_Format = 33777;
const RGBA_S3TC_DXT3_Format = 33778;
const RGBA_S3TC_DXT5_Format = 33779;
const RGB_PVRTC_4BPPV1_Format = 35840;
const RGB_PVRTC_2BPPV1_Format = 35841;
const RGBA_PVRTC_4BPPV1_Format = 35842;
const RGBA_PVRTC_2BPPV1_Format = 35843;
const RGB_ETC1_Format = 36196;
const RGB_ETC2_Format = 37492;
const RGBA_ETC2_EAC_Format = 37496;
const RGBA_ASTC_4x4_Format = 37808;
const RGBA_ASTC_5x4_Format = 37809;
const RGBA_ASTC_5x5_Format = 37810;
const RGBA_ASTC_6x5_Format = 37811;
const RGBA_ASTC_6x6_Format = 37812;
const RGBA_ASTC_8x5_Format = 37813;
const RGBA_ASTC_8x6_Format = 37814;
const RGBA_ASTC_8x8_Format = 37815;
const RGBA_ASTC_10x5_Format = 37816;
const RGBA_ASTC_10x6_Format = 37817;
const RGBA_ASTC_10x8_Format = 37818;
const RGBA_ASTC_10x10_Format = 37819;
const RGBA_ASTC_12x10_Format = 37820;
const RGBA_ASTC_12x12_Format = 37821;
const RGBA_BPTC_Format = 36492;
const RGB_BPTC_SIGNED_Format = 36494;
const RGB_BPTC_UNSIGNED_Format = 36495;
const RED_RGTC1_Format = 36283;
const SIGNED_RED_RGTC1_Format = 36284;
const RED_GREEN_RGTC2_Format = 36285;
const SIGNED_RED_GREEN_RGTC2_Format = 36286;
const BasicDepthPacking = 3200;
const RGBADepthPacking = 3201;
const TangentSpaceNormalMap = 0;
const ObjectSpaceNormalMap = 1;

// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const NoColorSpace = '';
const SRGBColorSpace = 'srgb';
const LinearSRGBColorSpace = 'srgb-linear';
const DisplayP3ColorSpace = 'display-p3';
const LinearDisplayP3ColorSpace = 'display-p3-linear';

const LinearTransfer = 'linear';
const SRGBTransfer = 'srgb';

const Rec709Primaries = 'rec709';
const P3Primaries = 'p3';
const KeepStencilOp = 7680;
const AlwaysStencilFunc = 519;

const NeverCompare = 512;
const LessCompare = 513;
const EqualCompare = 514;
const LessEqualCompare = 515;
const GreaterCompare = 516;
const NotEqualCompare = 517;
const GreaterEqualCompare = 518;
const AlwaysCompare = 519;

const StaticDrawUsage = 35044;
const GLSL3 = '300 es';

const WebGLCoordinateSystem = 2000;
const WebGPUCoordinateSystem = 2001;

/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */

let EventDispatcher$2=class EventDispatcher {

	addEventListener( type, listener ) {

		if ( this._listeners === undefined ) this._listeners = {};

		const listeners = this._listeners;

		if ( listeners[ type ] === undefined ) {

			listeners[ type ] = [];

		}

		if ( listeners[ type ].indexOf( listener ) === - 1 ) {

			listeners[ type ].push( listener );

		}

	}

	hasEventListener( type, listener ) {

		if ( this._listeners === undefined ) return false;

		const listeners = this._listeners;

		return listeners[ type ] !== undefined && listeners[ type ].indexOf( listener ) !== - 1;

	}

	removeEventListener( type, listener ) {

		if ( this._listeners === undefined ) return;

		const listeners = this._listeners;
		const listenerArray = listeners[ type ];

		if ( listenerArray !== undefined ) {

			const index = listenerArray.indexOf( listener );

			if ( index !== - 1 ) {

				listenerArray.splice( index, 1 );

			}

		}

	}

	dispatchEvent( event ) {

		if ( this._listeners === undefined ) return;

		const listeners = this._listeners;
		const listenerArray = listeners[ event.type ];

		if ( listenerArray !== undefined ) {

			event.target = this;

			// Make a copy, in case listeners are removed while iterating.
			const array = listenerArray.slice( 0 );

			for ( let i = 0, l = array.length; i < l; i ++ ) {

				array[ i ].call( this, event );

			}

			event.target = null;

		}

	}

};

const _lut = [ '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '0a', '0b', '0c', '0d', '0e', '0f', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '1a', '1b', '1c', '1d', '1e', '1f', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '2a', '2b', '2c', '2d', '2e', '2f', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '3a', '3b', '3c', '3d', '3e', '3f', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '4a', '4b', '4c', '4d', '4e', '4f', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '5a', '5b', '5c', '5d', '5e', '5f', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '6a', '6b', '6c', '6d', '6e', '6f', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '7a', '7b', '7c', '7d', '7e', '7f', '80', '81', '82', '83', '84', '85', '86', '87', '88', '89', '8a', '8b', '8c', '8d', '8e', '8f', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', '9a', '9b', '9c', '9d', '9e', '9f', 'a0', 'a1', 'a2', 'a3', 'a4', 'a5', 'a6', 'a7', 'a8', 'a9', 'aa', 'ab', 'ac', 'ad', 'ae', 'af', 'b0', 'b1', 'b2', 'b3', 'b4', 'b5', 'b6', 'b7', 'b8', 'b9', 'ba', 'bb', 'bc', 'bd', 'be', 'bf', 'c0', 'c1', 'c2', 'c3', 'c4', 'c5', 'c6', 'c7', 'c8', 'c9', 'ca', 'cb', 'cc', 'cd', 'ce', 'cf', 'd0', 'd1', 'd2', 'd3', 'd4', 'd5', 'd6', 'd7', 'd8', 'd9', 'da', 'db', 'dc', 'dd', 'de', 'df', 'e0', 'e1', 'e2', 'e3', 'e4', 'e5', 'e6', 'e7', 'e8', 'e9', 'ea', 'eb', 'ec', 'ed', 'ee', 'ef', 'f0', 'f1', 'f2', 'f3', 'f4', 'f5', 'f6', 'f7', 'f8', 'f9', 'fa', 'fb', 'fc', 'fd', 'fe', 'ff' ];


const DEG2RAD = Math.PI / 180;
const RAD2DEG = 180 / Math.PI;

// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function generateUUID() {

	const d0 = Math.random() * 0xffffffff | 0;
	const d1 = Math.random() * 0xffffffff | 0;
	const d2 = Math.random() * 0xffffffff | 0;
	const d3 = Math.random() * 0xffffffff | 0;
	const uuid = _lut[ d0 & 0xff ] + _lut[ d0 >> 8 & 0xff ] + _lut[ d0 >> 16 & 0xff ] + _lut[ d0 >> 24 & 0xff ] + '-' +
			_lut[ d1 & 0xff ] + _lut[ d1 >> 8 & 0xff ] + '-' + _lut[ d1 >> 16 & 0x0f | 0x40 ] + _lut[ d1 >> 24 & 0xff ] + '-' +
			_lut[ d2 & 0x3f | 0x80 ] + _lut[ d2 >> 8 & 0xff ] + '-' + _lut[ d2 >> 16 & 0xff ] + _lut[ d2 >> 24 & 0xff ] +
			_lut[ d3 & 0xff ] + _lut[ d3 >> 8 & 0xff ] + _lut[ d3 >> 16 & 0xff ] + _lut[ d3 >> 24 & 0xff ];

	// .toLowerCase() here flattens concatenated strings to save heap memory space.
	return uuid.toLowerCase();

}

function clamp( value, min, max ) {

	return Math.max( min, Math.min( max, value ) );

}

// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function euclideanModulo( n, m ) {

	return ( ( n % m ) + m ) % m;

}

// https://en.wikipedia.org/wiki/Linear_interpolation
function lerp( x, y, t ) {

	return ( 1 - t ) * x + t * y;

}

function denormalize( value, array ) {

	switch ( array.constructor ) {

		case Float32Array:

			return value;

		case Uint32Array:

			return value / 4294967295.0;

		case Uint16Array:

			return value / 65535.0;

		case Uint8Array:

			return value / 255.0;

		case Int32Array:

			return Math.max( value / 2147483647.0, - 1.0 );

		case Int16Array:

			return Math.max( value / 32767.0, - 1.0 );

		case Int8Array:

			return Math.max( value / 127.0, - 1.0 );

		default:

			throw new Error( 'Invalid component type.' );

	}

}

function normalize( value, array ) {

	switch ( array.constructor ) {

		case Float32Array:

			return value;

		case Uint32Array:

			return Math.round( value * 4294967295.0 );

		case Uint16Array:

			return Math.round( value * 65535.0 );

		case Uint8Array:

			return Math.round( value * 255.0 );

		case Int32Array:

			return Math.round( value * 2147483647.0 );

		case Int16Array:

			return Math.round( value * 32767.0 );

		case Int8Array:

			return Math.round( value * 127.0 );

		default:

			throw new Error( 'Invalid component type.' );

	}

}

class Vector2 {

	constructor( x = 0, y = 0 ) {

		Vector2.prototype.isVector2 = true;

		this.x = x;
		this.y = y;

	}

	get width() {

		return this.x;

	}

	set width( value ) {

		this.x = value;

	}

	get height() {

		return this.y;

	}

	set height( value ) {

		this.y = value;

	}

	set( x, y ) {

		this.x = x;
		this.y = y;

		return this;

	}

	setScalar( scalar ) {

		this.x = scalar;
		this.y = scalar;

		return this;

	}

	setX( x ) {

		this.x = x;

		return this;

	}

	setY( y ) {

		this.y = y;

		return this;

	}

	setComponent( index, value ) {

		switch ( index ) {

			case 0: this.x = value; break;
			case 1: this.y = value; break;
			default: throw new Error( 'index is out of range: ' + index );

		}

		return this;

	}

	getComponent( index ) {

		switch ( index ) {

			case 0: return this.x;
			case 1: return this.y;
			default: throw new Error( 'index is out of range: ' + index );

		}

	}

	clone() {

		return new this.constructor( this.x, this.y );

	}

	copy( v ) {

		this.x = v.x;
		this.y = v.y;

		return this;

	}

	add( v ) {

		this.x += v.x;
		this.y += v.y;

		return this;

	}

	addScalar( s ) {

		this.x += s;
		this.y += s;

		return this;

	}

	addVectors( a, b ) {

		this.x = a.x + b.x;
		this.y = a.y + b.y;

		return this;

	}

	addScaledVector( v, s ) {

		this.x += v.x * s;
		this.y += v.y * s;

		return this;

	}

	sub( v ) {

		this.x -= v.x;
		this.y -= v.y;

		return this;

	}

	subScalar( s ) {

		this.x -= s;
		this.y -= s;

		return this;

	}

	subVectors( a, b ) {

		this.x = a.x - b.x;
		this.y = a.y - b.y;

		return this;

	}

	multiply( v ) {

		this.x *= v.x;
		this.y *= v.y;

		return this;

	}

	multiplyScalar( scalar ) {

		this.x *= scalar;
		this.y *= scalar;

		return this;

	}

	divide( v ) {

		this.x /= v.x;
		this.y /= v.y;

		return this;

	}

	divideScalar( scalar ) {

		return this.multiplyScalar( 1 / scalar );

	}

	applyMatrix3( m ) {

		const x = this.x, y = this.y;
		const e = m.elements;

		this.x = e[ 0 ] * x + e[ 3 ] * y + e[ 6 ];
		this.y = e[ 1 ] * x + e[ 4 ] * y + e[ 7 ];

		return this;

	}

	min( v ) {

		this.x = Math.min( this.x, v.x );
		this.y = Math.min( this.y, v.y );

		return this;

	}

	max( v ) {

		this.x = Math.max( this.x, v.x );
		this.y = Math.max( this.y, v.y );

		return this;

	}

	clamp( min, max ) {

		// assumes min < max, componentwise

		this.x = Math.max( min.x, Math.min( max.x, this.x ) );
		this.y = Math.max( min.y, Math.min( max.y, this.y ) );

		return this;

	}

	clampScalar( minVal, maxVal ) {

		this.x = Math.max( minVal, Math.min( maxVal, this.x ) );
		this.y = Math.max( minVal, Math.min( maxVal, this.y ) );

		return this;

	}

	clampLength( min, max ) {

		const length = this.length();

		return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );

	}

	floor() {

		this.x = Math.floor( this.x );
		this.y = Math.floor( this.y );

		return this;

	}

	ceil() {

		this.x = Math.ceil( this.x );
		this.y = Math.ceil( this.y );

		return this;

	}

	round() {

		this.x = Math.round( this.x );
		this.y = Math.round( this.y );

		return this;

	}

	roundToZero() {

		this.x = Math.trunc( this.x );
		this.y = Math.trunc( this.y );

		return this;

	}

	negate() {

		this.x = - this.x;
		this.y = - this.y;

		return this;

	}

	dot( v ) {

		return this.x * v.x + this.y * v.y;

	}

	cross( v ) {

		return this.x * v.y - this.y * v.x;

	}

	lengthSq() {

		return this.x * this.x + this.y * this.y;

	}

	length() {

		return Math.sqrt( this.x * this.x + this.y * this.y );

	}

	manhattanLength() {

		return Math.abs( this.x ) + Math.abs( this.y );

	}

	normalize() {

		return this.divideScalar( this.length() || 1 );

	}

	angle() {

		// computes the angle in radians with respect to the positive x-axis

		const angle = Math.atan2( - this.y, - this.x ) + Math.PI;

		return angle;

	}

	angleTo( v ) {

		const denominator = Math.sqrt( this.lengthSq() * v.lengthSq() );

		if ( denominator === 0 ) return Math.PI / 2;

		const theta = this.dot( v ) / denominator;

		// clamp, to handle numerical problems

		return Math.acos( clamp( theta, - 1, 1 ) );

	}

	distanceTo( v ) {

		return Math.sqrt( this.distanceToSquared( v ) );

	}

	distanceToSquared( v ) {

		const dx = this.x - v.x, dy = this.y - v.y;
		return dx * dx + dy * dy;

	}

	manhattanDistanceTo( v ) {

		return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y );

	}

	setLength( length ) {

		return this.normalize().multiplyScalar( length );

	}

	lerp( v, alpha ) {

		this.x += ( v.x - this.x ) * alpha;
		this.y += ( v.y - this.y ) * alpha;

		return this;

	}

	lerpVectors( v1, v2, alpha ) {

		this.x = v1.x + ( v2.x - v1.x ) * alpha;
		this.y = v1.y + ( v2.y - v1.y ) * alpha;

		return this;

	}

	equals( v ) {

		return ( ( v.x === this.x ) && ( v.y === this.y ) );

	}

	fromArray( array, offset = 0 ) {

		this.x = array[ offset ];
		this.y = array[ offset + 1 ];

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this.x;
		array[ offset + 1 ] = this.y;

		return array;

	}

	fromBufferAttribute( attribute, index ) {

		this.x = attribute.getX( index );
		this.y = attribute.getY( index );

		return this;

	}

	rotateAround( center, angle ) {

		const c = Math.cos( angle ), s = Math.sin( angle );

		const x = this.x - center.x;
		const y = this.y - center.y;

		this.x = x * c - y * s + center.x;
		this.y = x * s + y * c + center.y;

		return this;

	}

	random() {

		this.x = Math.random();
		this.y = Math.random();

		return this;

	}

	*[ Symbol.iterator ]() {

		yield this.x;
		yield this.y;

	}

}

class Matrix3 {

	constructor( n11, n12, n13, n21, n22, n23, n31, n32, n33 ) {

		Matrix3.prototype.isMatrix3 = true;

		this.elements = [

			1, 0, 0,
			0, 1, 0,
			0, 0, 1

		];

		if ( n11 !== undefined ) {

			this.set( n11, n12, n13, n21, n22, n23, n31, n32, n33 );

		}

	}

	set( n11, n12, n13, n21, n22, n23, n31, n32, n33 ) {

		const te = this.elements;

		te[ 0 ] = n11; te[ 1 ] = n21; te[ 2 ] = n31;
		te[ 3 ] = n12; te[ 4 ] = n22; te[ 5 ] = n32;
		te[ 6 ] = n13; te[ 7 ] = n23; te[ 8 ] = n33;

		return this;

	}

	identity() {

		this.set(

			1, 0, 0,
			0, 1, 0,
			0, 0, 1

		);

		return this;

	}

	copy( m ) {

		const te = this.elements;
		const me = m.elements;

		te[ 0 ] = me[ 0 ]; te[ 1 ] = me[ 1 ]; te[ 2 ] = me[ 2 ];
		te[ 3 ] = me[ 3 ]; te[ 4 ] = me[ 4 ]; te[ 5 ] = me[ 5 ];
		te[ 6 ] = me[ 6 ]; te[ 7 ] = me[ 7 ]; te[ 8 ] = me[ 8 ];

		return this;

	}

	extractBasis( xAxis, yAxis, zAxis ) {

		xAxis.setFromMatrix3Column( this, 0 );
		yAxis.setFromMatrix3Column( this, 1 );
		zAxis.setFromMatrix3Column( this, 2 );

		return this;

	}

	setFromMatrix4( m ) {

		const me = m.elements;

		this.set(

			me[ 0 ], me[ 4 ], me[ 8 ],
			me[ 1 ], me[ 5 ], me[ 9 ],
			me[ 2 ], me[ 6 ], me[ 10 ]

		);

		return this;

	}

	multiply( m ) {

		return this.multiplyMatrices( this, m );

	}

	premultiply( m ) {

		return this.multiplyMatrices( m, this );

	}

	multiplyMatrices( a, b ) {

		const ae = a.elements;
		const be = b.elements;
		const te = this.elements;

		const a11 = ae[ 0 ], a12 = ae[ 3 ], a13 = ae[ 6 ];
		const a21 = ae[ 1 ], a22 = ae[ 4 ], a23 = ae[ 7 ];
		const a31 = ae[ 2 ], a32 = ae[ 5 ], a33 = ae[ 8 ];

		const b11 = be[ 0 ], b12 = be[ 3 ], b13 = be[ 6 ];
		const b21 = be[ 1 ], b22 = be[ 4 ], b23 = be[ 7 ];
		const b31 = be[ 2 ], b32 = be[ 5 ], b33 = be[ 8 ];

		te[ 0 ] = a11 * b11 + a12 * b21 + a13 * b31;
		te[ 3 ] = a11 * b12 + a12 * b22 + a13 * b32;
		te[ 6 ] = a11 * b13 + a12 * b23 + a13 * b33;

		te[ 1 ] = a21 * b11 + a22 * b21 + a23 * b31;
		te[ 4 ] = a21 * b12 + a22 * b22 + a23 * b32;
		te[ 7 ] = a21 * b13 + a22 * b23 + a23 * b33;

		te[ 2 ] = a31 * b11 + a32 * b21 + a33 * b31;
		te[ 5 ] = a31 * b12 + a32 * b22 + a33 * b32;
		te[ 8 ] = a31 * b13 + a32 * b23 + a33 * b33;

		return this;

	}

	multiplyScalar( s ) {

		const te = this.elements;

		te[ 0 ] *= s; te[ 3 ] *= s; te[ 6 ] *= s;
		te[ 1 ] *= s; te[ 4 ] *= s; te[ 7 ] *= s;
		te[ 2 ] *= s; te[ 5 ] *= s; te[ 8 ] *= s;

		return this;

	}

	determinant() {

		const te = this.elements;

		const a = te[ 0 ], b = te[ 1 ], c = te[ 2 ],
			d = te[ 3 ], e = te[ 4 ], f = te[ 5 ],
			g = te[ 6 ], h = te[ 7 ], i = te[ 8 ];

		return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;

	}

	invert() {

		const te = this.elements,

			n11 = te[ 0 ], n21 = te[ 1 ], n31 = te[ 2 ],
			n12 = te[ 3 ], n22 = te[ 4 ], n32 = te[ 5 ],
			n13 = te[ 6 ], n23 = te[ 7 ], n33 = te[ 8 ],

			t11 = n33 * n22 - n32 * n23,
			t12 = n32 * n13 - n33 * n12,
			t13 = n23 * n12 - n22 * n13,

			det = n11 * t11 + n21 * t12 + n31 * t13;

		if ( det === 0 ) return this.set( 0, 0, 0, 0, 0, 0, 0, 0, 0 );

		const detInv = 1 / det;

		te[ 0 ] = t11 * detInv;
		te[ 1 ] = ( n31 * n23 - n33 * n21 ) * detInv;
		te[ 2 ] = ( n32 * n21 - n31 * n22 ) * detInv;

		te[ 3 ] = t12 * detInv;
		te[ 4 ] = ( n33 * n11 - n31 * n13 ) * detInv;
		te[ 5 ] = ( n31 * n12 - n32 * n11 ) * detInv;

		te[ 6 ] = t13 * detInv;
		te[ 7 ] = ( n21 * n13 - n23 * n11 ) * detInv;
		te[ 8 ] = ( n22 * n11 - n21 * n12 ) * detInv;

		return this;

	}

	transpose() {

		let tmp;
		const m = this.elements;

		tmp = m[ 1 ]; m[ 1 ] = m[ 3 ]; m[ 3 ] = tmp;
		tmp = m[ 2 ]; m[ 2 ] = m[ 6 ]; m[ 6 ] = tmp;
		tmp = m[ 5 ]; m[ 5 ] = m[ 7 ]; m[ 7 ] = tmp;

		return this;

	}

	getNormalMatrix( matrix4 ) {

		return this.setFromMatrix4( matrix4 ).invert().transpose();

	}

	transposeIntoArray( r ) {

		const m = this.elements;

		r[ 0 ] = m[ 0 ];
		r[ 1 ] = m[ 3 ];
		r[ 2 ] = m[ 6 ];
		r[ 3 ] = m[ 1 ];
		r[ 4 ] = m[ 4 ];
		r[ 5 ] = m[ 7 ];
		r[ 6 ] = m[ 2 ];
		r[ 7 ] = m[ 5 ];
		r[ 8 ] = m[ 8 ];

		return this;

	}

	setUvTransform( tx, ty, sx, sy, rotation, cx, cy ) {

		const c = Math.cos( rotation );
		const s = Math.sin( rotation );

		this.set(
			sx * c, sx * s, - sx * ( c * cx + s * cy ) + cx + tx,
			- sy * s, sy * c, - sy * ( - s * cx + c * cy ) + cy + ty,
			0, 0, 1
		);

		return this;

	}

	//

	scale( sx, sy ) {

		this.premultiply( _m3.makeScale( sx, sy ) );

		return this;

	}

	rotate( theta ) {

		this.premultiply( _m3.makeRotation( - theta ) );

		return this;

	}

	translate( tx, ty ) {

		this.premultiply( _m3.makeTranslation( tx, ty ) );

		return this;

	}

	// for 2D Transforms

	makeTranslation( x, y ) {

		if ( x.isVector2 ) {

			this.set(

				1, 0, x.x,
				0, 1, x.y,
				0, 0, 1

			);

		} else {

			this.set(

				1, 0, x,
				0, 1, y,
				0, 0, 1

			);

		}

		return this;

	}

	makeRotation( theta ) {

		// counterclockwise

		const c = Math.cos( theta );
		const s = Math.sin( theta );

		this.set(

			c, - s, 0,
			s, c, 0,
			0, 0, 1

		);

		return this;

	}

	makeScale( x, y ) {

		this.set(

			x, 0, 0,
			0, y, 0,
			0, 0, 1

		);

		return this;

	}

	//

	equals( matrix ) {

		const te = this.elements;
		const me = matrix.elements;

		for ( let i = 0; i < 9; i ++ ) {

			if ( te[ i ] !== me[ i ] ) return false;

		}

		return true;

	}

	fromArray( array, offset = 0 ) {

		for ( let i = 0; i < 9; i ++ ) {

			this.elements[ i ] = array[ i + offset ];

		}

		return this;

	}

	toArray( array = [], offset = 0 ) {

		const te = this.elements;

		array[ offset ] = te[ 0 ];
		array[ offset + 1 ] = te[ 1 ];
		array[ offset + 2 ] = te[ 2 ];

		array[ offset + 3 ] = te[ 3 ];
		array[ offset + 4 ] = te[ 4 ];
		array[ offset + 5 ] = te[ 5 ];

		array[ offset + 6 ] = te[ 6 ];
		array[ offset + 7 ] = te[ 7 ];
		array[ offset + 8 ] = te[ 8 ];

		return array;

	}

	clone() {

		return new this.constructor().fromArray( this.elements );

	}

}

const _m3 = /*@__PURE__*/ new Matrix3();

function arrayNeedsUint32( array ) {

	// assumes larger values usually on last

	for ( let i = array.length - 1; i >= 0; -- i ) {

		if ( array[ i ] >= 65535 ) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565

	}

	return false;

}

function createElementNS( name ) {

	return document.createElementNS( 'http://www.w3.org/1999/xhtml', name );

}

function createCanvasElement() {

	const canvas = createElementNS( 'canvas' );
	canvas.style.display = 'block';
	return canvas;

}

const _cache = {};

function warnOnce( message ) {

	if ( message in _cache ) return;

	_cache[ message ] = true;

	console.warn( message );

}

function probeAsync( gl, sync, interval ) {

	return new Promise( function ( resolve, reject ) {

		function probe() {

			switch ( gl.clientWaitSync( sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0 ) ) {

				case gl.WAIT_FAILED:
					reject();
					break;

				case gl.TIMEOUT_EXPIRED:
					setTimeout( probe, interval );
					break;

				default:
					resolve();

			}

		}

		setTimeout( probe, interval );

	} );

}

/**
 * Matrices converting P3 <-> Rec. 709 primaries, without gamut mapping
 * or clipping. Based on W3C specifications for sRGB and Display P3,
 * and ICC specifications for the D50 connection space. Values in/out
 * are _linear_ sRGB and _linear_ Display P3.
 *
 * Note that both sRGB and Display P3 use the sRGB transfer functions.
 *
 * Reference:
 * - http://www.russellcottrell.com/photo/matrixCalculator.htm
 */

const LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = /*@__PURE__*/ new Matrix3().set(
	0.8224621, 0.177538, 0.0,
	0.0331941, 0.9668058, 0.0,
	0.0170827, 0.0723974, 0.9105199,
);

const LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = /*@__PURE__*/ new Matrix3().set(
	1.2249401, - 0.2249404, 0.0,
	- 0.0420569, 1.0420571, 0.0,
	- 0.0196376, - 0.0786361, 1.0982735
);

/**
 * Defines supported color spaces by transfer function and primaries,
 * and provides conversions to/from the Linear-sRGB reference space.
 */
const COLOR_SPACES = {
	[ LinearSRGBColorSpace ]: {
		transfer: LinearTransfer,
		primaries: Rec709Primaries,
		toReference: ( color ) => color,
		fromReference: ( color ) => color,
	},
	[ SRGBColorSpace ]: {
		transfer: SRGBTransfer,
		primaries: Rec709Primaries,
		toReference: ( color ) => color.convertSRGBToLinear(),
		fromReference: ( color ) => color.convertLinearToSRGB(),
	},
	[ LinearDisplayP3ColorSpace ]: {
		transfer: LinearTransfer,
		primaries: P3Primaries,
		toReference: ( color ) => color.applyMatrix3( LINEAR_DISPLAY_P3_TO_LINEAR_SRGB ),
		fromReference: ( color ) => color.applyMatrix3( LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 ),
	},
	[ DisplayP3ColorSpace ]: {
		transfer: SRGBTransfer,
		primaries: P3Primaries,
		toReference: ( color ) => color.convertSRGBToLinear().applyMatrix3( LINEAR_DISPLAY_P3_TO_LINEAR_SRGB ),
		fromReference: ( color ) => color.applyMatrix3( LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 ).convertLinearToSRGB(),
	},
};

const SUPPORTED_WORKING_COLOR_SPACES = new Set( [ LinearSRGBColorSpace, LinearDisplayP3ColorSpace ] );

const ColorManagement = {

	enabled: true,

	_workingColorSpace: LinearSRGBColorSpace,

	get workingColorSpace() {

		return this._workingColorSpace;

	},

	set workingColorSpace( colorSpace ) {

		if ( ! SUPPORTED_WORKING_COLOR_SPACES.has( colorSpace ) ) {

			throw new Error( `Unsupported working color space, "${ colorSpace }".` );

		}

		this._workingColorSpace = colorSpace;

	},

	convert: function ( color, sourceColorSpace, targetColorSpace ) {

		if ( this.enabled === false || sourceColorSpace === targetColorSpace || ! sourceColorSpace || ! targetColorSpace ) {

			return color;

		}

		const sourceToReference = COLOR_SPACES[ sourceColorSpace ].toReference;
		const targetFromReference = COLOR_SPACES[ targetColorSpace ].fromReference;

		return targetFromReference( sourceToReference( color ) );

	},

	fromWorkingColorSpace: function ( color, targetColorSpace ) {

		return this.convert( color, this._workingColorSpace, targetColorSpace );

	},

	toWorkingColorSpace: function ( color, sourceColorSpace ) {

		return this.convert( color, sourceColorSpace, this._workingColorSpace );

	},

	getPrimaries: function ( colorSpace ) {

		return COLOR_SPACES[ colorSpace ].primaries;

	},

	getTransfer: function ( colorSpace ) {

		if ( colorSpace === NoColorSpace ) return LinearTransfer;

		return COLOR_SPACES[ colorSpace ].transfer;

	},

};


function SRGBToLinear( c ) {

	return ( c < 0.04045 ) ? c * 0.0773993808 : Math.pow( c * 0.9478672986 + 0.0521327014, 2.4 );

}

function LinearToSRGB( c ) {

	return ( c < 0.0031308 ) ? c * 12.92 : 1.055 * ( Math.pow( c, 0.41666 ) ) - 0.055;

}

let _canvas;

class ImageUtils {

	static getDataURL( image ) {

		if ( /^data:/i.test( image.src ) ) {

			return image.src;

		}

		if ( typeof HTMLCanvasElement === 'undefined' ) {

			return image.src;

		}

		let canvas;

		if ( image instanceof HTMLCanvasElement ) {

			canvas = image;

		} else {

			if ( _canvas === undefined ) _canvas = createElementNS( 'canvas' );

			_canvas.width = image.width;
			_canvas.height = image.height;

			const context = _canvas.getContext( '2d' );

			if ( image instanceof ImageData ) {

				context.putImageData( image, 0, 0 );

			} else {

				context.drawImage( image, 0, 0, image.width, image.height );

			}

			canvas = _canvas;

		}

		if ( canvas.width > 2048 || canvas.height > 2048 ) {

			console.warn( 'THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons', image );

			return canvas.toDataURL( 'image/jpeg', 0.6 );

		} else {

			return canvas.toDataURL( 'image/png' );

		}

	}

	static sRGBToLinear( image ) {

		if ( ( typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement ) ||
			( typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement ) ||
			( typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap ) ) {

			const canvas = createElementNS( 'canvas' );

			canvas.width = image.width;
			canvas.height = image.height;

			const context = canvas.getContext( '2d' );
			context.drawImage( image, 0, 0, image.width, image.height );

			const imageData = context.getImageData( 0, 0, image.width, image.height );
			const data = imageData.data;

			for ( let i = 0; i < data.length; i ++ ) {

				data[ i ] = SRGBToLinear( data[ i ] / 255 ) * 255;

			}

			context.putImageData( imageData, 0, 0 );

			return canvas;

		} else if ( image.data ) {

			const data = image.data.slice( 0 );

			for ( let i = 0; i < data.length; i ++ ) {

				if ( data instanceof Uint8Array || data instanceof Uint8ClampedArray ) {

					data[ i ] = Math.floor( SRGBToLinear( data[ i ] / 255 ) * 255 );

				} else {

					// assuming float

					data[ i ] = SRGBToLinear( data[ i ] );

				}

			}

			return {
				data: data,
				width: image.width,
				height: image.height
			};

		} else {

			console.warn( 'THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.' );
			return image;

		}

	}

}

let _sourceId = 0;

class Source {

	constructor( data = null ) {

		this.isSource = true;

		Object.defineProperty( this, 'id', { value: _sourceId ++ } );

		this.uuid = generateUUID();

		this.data = data;
		this.dataReady = true;

		this.version = 0;

	}

	set needsUpdate( value ) {

		if ( value === true ) this.version ++;

	}

	toJSON( meta ) {

		const isRootObject = ( meta === undefined || typeof meta === 'string' );

		if ( ! isRootObject && meta.images[ this.uuid ] !== undefined ) {

			return meta.images[ this.uuid ];

		}

		const output = {
			uuid: this.uuid,
			url: ''
		};

		const data = this.data;

		if ( data !== null ) {

			let url;

			if ( Array.isArray( data ) ) {

				// cube texture

				url = [];

				for ( let i = 0, l = data.length; i < l; i ++ ) {

					if ( data[ i ].isDataTexture ) {

						url.push( serializeImage( data[ i ].image ) );

					} else {

						url.push( serializeImage( data[ i ] ) );

					}

				}

			} else {

				// texture

				url = serializeImage( data );

			}

			output.url = url;

		}

		if ( ! isRootObject ) {

			meta.images[ this.uuid ] = output;

		}

		return output;

	}

}

function serializeImage( image ) {

	if ( ( typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement ) ||
		( typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement ) ||
		( typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap ) ) {

		// default images

		return ImageUtils.getDataURL( image );

	} else {

		if ( image.data ) {

			// images of DataTexture

			return {
				data: Array.from( image.data ),
				width: image.width,
				height: image.height,
				type: image.data.constructor.name
			};

		} else {

			console.warn( 'THREE.Texture: Unable to serialize Texture.' );
			return {};

		}

	}

}

let _textureId = 0;

class Texture extends EventDispatcher$2 {

	constructor( image = Texture.DEFAULT_IMAGE, mapping = Texture.DEFAULT_MAPPING, wrapS = ClampToEdgeWrapping, wrapT = ClampToEdgeWrapping, magFilter = LinearFilter, minFilter = LinearMipmapLinearFilter, format = RGBAFormat, type = UnsignedByteType, anisotropy = Texture.DEFAULT_ANISOTROPY, colorSpace = NoColorSpace ) {

		super();

		this.isTexture = true;

		Object.defineProperty( this, 'id', { value: _textureId ++ } );

		this.uuid = generateUUID();

		this.name = '';

		this.source = new Source( image );
		this.mipmaps = [];

		this.mapping = mapping;
		this.channel = 0;

		this.wrapS = wrapS;
		this.wrapT = wrapT;

		this.magFilter = magFilter;
		this.minFilter = minFilter;

		this.anisotropy = anisotropy;

		this.format = format;
		this.internalFormat = null;
		this.type = type;

		this.offset = new Vector2( 0, 0 );
		this.repeat = new Vector2( 1, 1 );
		this.center = new Vector2( 0, 0 );
		this.rotation = 0;

		this.matrixAutoUpdate = true;
		this.matrix = new Matrix3();

		this.generateMipmaps = true;
		this.premultiplyAlpha = false;
		this.flipY = true;
		this.unpackAlignment = 4;	// valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)

		this.colorSpace = colorSpace;

		this.userData = {};

		this.version = 0;
		this.onUpdate = null;

		this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
		this.pmremVersion = 0; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)

	}

	get image() {

		return this.source.data;

	}

	set image( value = null ) {

		this.source.data = value;

	}

	updateMatrix() {

		this.matrix.setUvTransform( this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y );

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( source ) {

		this.name = source.name;

		this.source = source.source;
		this.mipmaps = source.mipmaps.slice( 0 );

		this.mapping = source.mapping;
		this.channel = source.channel;

		this.wrapS = source.wrapS;
		this.wrapT = source.wrapT;

		this.magFilter = source.magFilter;
		this.minFilter = source.minFilter;

		this.anisotropy = source.anisotropy;

		this.format = source.format;
		this.internalFormat = source.internalFormat;
		this.type = source.type;

		this.offset.copy( source.offset );
		this.repeat.copy( source.repeat );
		this.center.copy( source.center );
		this.rotation = source.rotation;

		this.matrixAutoUpdate = source.matrixAutoUpdate;
		this.matrix.copy( source.matrix );

		this.generateMipmaps = source.generateMipmaps;
		this.premultiplyAlpha = source.premultiplyAlpha;
		this.flipY = source.flipY;
		this.unpackAlignment = source.unpackAlignment;
		this.colorSpace = source.colorSpace;

		this.userData = JSON.parse( JSON.stringify( source.userData ) );

		this.needsUpdate = true;

		return this;

	}

	toJSON( meta ) {

		const isRootObject = ( meta === undefined || typeof meta === 'string' );

		if ( ! isRootObject && meta.textures[ this.uuid ] !== undefined ) {

			return meta.textures[ this.uuid ];

		}

		const output = {

			metadata: {
				version: 4.6,
				type: 'Texture',
				generator: 'Texture.toJSON'
			},

			uuid: this.uuid,
			name: this.name,

			image: this.source.toJSON( meta ).uuid,

			mapping: this.mapping,
			channel: this.channel,

			repeat: [ this.repeat.x, this.repeat.y ],
			offset: [ this.offset.x, this.offset.y ],
			center: [ this.center.x, this.center.y ],
			rotation: this.rotation,

			wrap: [ this.wrapS, this.wrapT ],

			format: this.format,
			internalFormat: this.internalFormat,
			type: this.type,
			colorSpace: this.colorSpace,

			minFilter: this.minFilter,
			magFilter: this.magFilter,
			anisotropy: this.anisotropy,

			flipY: this.flipY,

			generateMipmaps: this.generateMipmaps,
			premultiplyAlpha: this.premultiplyAlpha,
			unpackAlignment: this.unpackAlignment

		};

		if ( Object.keys( this.userData ).length > 0 ) output.userData = this.userData;

		if ( ! isRootObject ) {

			meta.textures[ this.uuid ] = output;

		}

		return output;

	}

	dispose() {

		this.dispatchEvent( { type: 'dispose' } );

	}

	transformUv( uv ) {

		if ( this.mapping !== UVMapping ) return uv;

		uv.applyMatrix3( this.matrix );

		if ( uv.x < 0 || uv.x > 1 ) {

			switch ( this.wrapS ) {

				case RepeatWrapping:

					uv.x = uv.x - Math.floor( uv.x );
					break;

				case ClampToEdgeWrapping:

					uv.x = uv.x < 0 ? 0 : 1;
					break;

				case MirroredRepeatWrapping:

					if ( Math.abs( Math.floor( uv.x ) % 2 ) === 1 ) {

						uv.x = Math.ceil( uv.x ) - uv.x;

					} else {

						uv.x = uv.x - Math.floor( uv.x );

					}

					break;

			}

		}

		if ( uv.y < 0 || uv.y > 1 ) {

			switch ( this.wrapT ) {

				case RepeatWrapping:

					uv.y = uv.y - Math.floor( uv.y );
					break;

				case ClampToEdgeWrapping:

					uv.y = uv.y < 0 ? 0 : 1;
					break;

				case MirroredRepeatWrapping:

					if ( Math.abs( Math.floor( uv.y ) % 2 ) === 1 ) {

						uv.y = Math.ceil( uv.y ) - uv.y;

					} else {

						uv.y = uv.y - Math.floor( uv.y );

					}

					break;

			}

		}

		if ( this.flipY ) {

			uv.y = 1 - uv.y;

		}

		return uv;

	}

	set needsUpdate( value ) {

		if ( value === true ) {

			this.version ++;
			this.source.needsUpdate = true;

		}

	}

	set needsPMREMUpdate( value ) {

		if ( value === true ) {

			this.pmremVersion ++;

		}

	}

}

Texture.DEFAULT_IMAGE = null;
Texture.DEFAULT_MAPPING = UVMapping;
Texture.DEFAULT_ANISOTROPY = 1;

class Vector4 {

	constructor( x = 0, y = 0, z = 0, w = 1 ) {

		Vector4.prototype.isVector4 = true;

		this.x = x;
		this.y = y;
		this.z = z;
		this.w = w;

	}

	get width() {

		return this.z;

	}

	set width( value ) {

		this.z = value;

	}

	get height() {

		return this.w;

	}

	set height( value ) {

		this.w = value;

	}

	set( x, y, z, w ) {

		this.x = x;
		this.y = y;
		this.z = z;
		this.w = w;

		return this;

	}

	setScalar( scalar ) {

		this.x = scalar;
		this.y = scalar;
		this.z = scalar;
		this.w = scalar;

		return this;

	}

	setX( x ) {

		this.x = x;

		return this;

	}

	setY( y ) {

		this.y = y;

		return this;

	}

	setZ( z ) {

		this.z = z;

		return this;

	}

	setW( w ) {

		this.w = w;

		return this;

	}

	setComponent( index, value ) {

		switch ( index ) {

			case 0: this.x = value; break;
			case 1: this.y = value; break;
			case 2: this.z = value; break;
			case 3: this.w = value; break;
			default: throw new Error( 'index is out of range: ' + index );

		}

		return this;

	}

	getComponent( index ) {

		switch ( index ) {

			case 0: return this.x;
			case 1: return this.y;
			case 2: return this.z;
			case 3: return this.w;
			default: throw new Error( 'index is out of range: ' + index );

		}

	}

	clone() {

		return new this.constructor( this.x, this.y, this.z, this.w );

	}

	copy( v ) {

		this.x = v.x;
		this.y = v.y;
		this.z = v.z;
		this.w = ( v.w !== undefined ) ? v.w : 1;

		return this;

	}

	add( v ) {

		this.x += v.x;
		this.y += v.y;
		this.z += v.z;
		this.w += v.w;

		return this;

	}

	addScalar( s ) {

		this.x += s;
		this.y += s;
		this.z += s;
		this.w += s;

		return this;

	}

	addVectors( a, b ) {

		this.x = a.x + b.x;
		this.y = a.y + b.y;
		this.z = a.z + b.z;
		this.w = a.w + b.w;

		return this;

	}

	addScaledVector( v, s ) {

		this.x += v.x * s;
		this.y += v.y * s;
		this.z += v.z * s;
		this.w += v.w * s;

		return this;

	}

	sub( v ) {

		this.x -= v.x;
		this.y -= v.y;
		this.z -= v.z;
		this.w -= v.w;

		return this;

	}

	subScalar( s ) {

		this.x -= s;
		this.y -= s;
		this.z -= s;
		this.w -= s;

		return this;

	}

	subVectors( a, b ) {

		this.x = a.x - b.x;
		this.y = a.y - b.y;
		this.z = a.z - b.z;
		this.w = a.w - b.w;

		return this;

	}

	multiply( v ) {

		this.x *= v.x;
		this.y *= v.y;
		this.z *= v.z;
		this.w *= v.w;

		return this;

	}

	multiplyScalar( scalar ) {

		this.x *= scalar;
		this.y *= scalar;
		this.z *= scalar;
		this.w *= scalar;

		return this;

	}

	applyMatrix4( m ) {

		const x = this.x, y = this.y, z = this.z, w = this.w;
		const e = m.elements;

		this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z + e[ 12 ] * w;
		this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z + e[ 13 ] * w;
		this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ] * w;
		this.w = e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ] * w;

		return this;

	}

	divideScalar( scalar ) {

		return this.multiplyScalar( 1 / scalar );

	}

	setAxisAngleFromQuaternion( q ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm

		// q is assumed to be normalized

		this.w = 2 * Math.acos( q.w );

		const s = Math.sqrt( 1 - q.w * q.w );

		if ( s < 0.0001 ) {

			this.x = 1;
			this.y = 0;
			this.z = 0;

		} else {

			this.x = q.x / s;
			this.y = q.y / s;
			this.z = q.z / s;

		}

		return this;

	}

	setAxisAngleFromRotationMatrix( m ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		let angle, x, y, z; // variables for result
		const epsilon = 0.01,		// margin to allow for rounding errors
			epsilon2 = 0.1,		// margin to distinguish between 0 and 180 degrees

			te = m.elements,

			m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ],
			m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ],
			m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ];

		if ( ( Math.abs( m12 - m21 ) < epsilon ) &&
		     ( Math.abs( m13 - m31 ) < epsilon ) &&
		     ( Math.abs( m23 - m32 ) < epsilon ) ) {

			// singularity found
			// first check for identity matrix which must have +1 for all terms
			// in leading diagonal and zero in other terms

			if ( ( Math.abs( m12 + m21 ) < epsilon2 ) &&
			     ( Math.abs( m13 + m31 ) < epsilon2 ) &&
			     ( Math.abs( m23 + m32 ) < epsilon2 ) &&
			     ( Math.abs( m11 + m22 + m33 - 3 ) < epsilon2 ) ) {

				// this singularity is identity matrix so angle = 0

				this.set( 1, 0, 0, 0 );

				return this; // zero angle, arbitrary axis

			}

			// otherwise this singularity is angle = 180

			angle = Math.PI;

			const xx = ( m11 + 1 ) / 2;
			const yy = ( m22 + 1 ) / 2;
			const zz = ( m33 + 1 ) / 2;
			const xy = ( m12 + m21 ) / 4;
			const xz = ( m13 + m31 ) / 4;
			const yz = ( m23 + m32 ) / 4;

			if ( ( xx > yy ) && ( xx > zz ) ) {

				// m11 is the largest diagonal term

				if ( xx < epsilon ) {

					x = 0;
					y = 0.707106781;
					z = 0.707106781;

				} else {

					x = Math.sqrt( xx );
					y = xy / x;
					z = xz / x;

				}

			} else if ( yy > zz ) {

				// m22 is the largest diagonal term

				if ( yy < epsilon ) {

					x = 0.707106781;
					y = 0;
					z = 0.707106781;

				} else {

					y = Math.sqrt( yy );
					x = xy / y;
					z = yz / y;

				}

			} else {

				// m33 is the largest diagonal term so base result on this

				if ( zz < epsilon ) {

					x = 0.707106781;
					y = 0.707106781;
					z = 0;

				} else {

					z = Math.sqrt( zz );
					x = xz / z;
					y = yz / z;

				}

			}

			this.set( x, y, z, angle );

			return this; // return 180 deg rotation

		}

		// as we have reached here there are no singularities so we can handle normally

		let s = Math.sqrt( ( m32 - m23 ) * ( m32 - m23 ) +
			( m13 - m31 ) * ( m13 - m31 ) +
			( m21 - m12 ) * ( m21 - m12 ) ); // used to normalize

		if ( Math.abs( s ) < 0.001 ) s = 1;

		// prevent divide by zero, should not happen if matrix is orthogonal and should be
		// caught by singularity test above, but I've left it in just in case

		this.x = ( m32 - m23 ) / s;
		this.y = ( m13 - m31 ) / s;
		this.z = ( m21 - m12 ) / s;
		this.w = Math.acos( ( m11 + m22 + m33 - 1 ) / 2 );

		return this;

	}

	setFromMatrixPosition( m ) {

		const e = m.elements;

		this.x = e[ 12 ];
		this.y = e[ 13 ];
		this.z = e[ 14 ];
		this.w = e[ 15 ];

		return this;

	}

	min( v ) {

		this.x = Math.min( this.x, v.x );
		this.y = Math.min( this.y, v.y );
		this.z = Math.min( this.z, v.z );
		this.w = Math.min( this.w, v.w );

		return this;

	}

	max( v ) {

		this.x = Math.max( this.x, v.x );
		this.y = Math.max( this.y, v.y );
		this.z = Math.max( this.z, v.z );
		this.w = Math.max( this.w, v.w );

		return this;

	}

	clamp( min, max ) {

		// assumes min < max, componentwise

		this.x = Math.max( min.x, Math.min( max.x, this.x ) );
		this.y = Math.max( min.y, Math.min( max.y, this.y ) );
		this.z = Math.max( min.z, Math.min( max.z, this.z ) );
		this.w = Math.max( min.w, Math.min( max.w, this.w ) );

		return this;

	}

	clampScalar( minVal, maxVal ) {

		this.x = Math.max( minVal, Math.min( maxVal, this.x ) );
		this.y = Math.max( minVal, Math.min( maxVal, this.y ) );
		this.z = Math.max( minVal, Math.min( maxVal, this.z ) );
		this.w = Math.max( minVal, Math.min( maxVal, this.w ) );

		return this;

	}

	clampLength( min, max ) {

		const length = this.length();

		return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );

	}

	floor() {

		this.x = Math.floor( this.x );
		this.y = Math.floor( this.y );
		this.z = Math.floor( this.z );
		this.w = Math.floor( this.w );

		return this;

	}

	ceil() {

		this.x = Math.ceil( this.x );
		this.y = Math.ceil( this.y );
		this.z = Math.ceil( this.z );
		this.w = Math.ceil( this.w );

		return this;

	}

	round() {

		this.x = Math.round( this.x );
		this.y = Math.round( this.y );
		this.z = Math.round( this.z );
		this.w = Math.round( this.w );

		return this;

	}

	roundToZero() {

		this.x = Math.trunc( this.x );
		this.y = Math.trunc( this.y );
		this.z = Math.trunc( this.z );
		this.w = Math.trunc( this.w );

		return this;

	}

	negate() {

		this.x = - this.x;
		this.y = - this.y;
		this.z = - this.z;
		this.w = - this.w;

		return this;

	}

	dot( v ) {

		return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;

	}

	lengthSq() {

		return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;

	}

	length() {

		return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w );

	}

	manhattanLength() {

		return Math.abs( this.x ) + Math.abs( this.y ) + Math.abs( this.z ) + Math.abs( this.w );

	}

	normalize() {

		return this.divideScalar( this.length() || 1 );

	}

	setLength( length ) {

		return this.normalize().multiplyScalar( length );

	}

	lerp( v, alpha ) {

		this.x += ( v.x - this.x ) * alpha;
		this.y += ( v.y - this.y ) * alpha;
		this.z += ( v.z - this.z ) * alpha;
		this.w += ( v.w - this.w ) * alpha;

		return this;

	}

	lerpVectors( v1, v2, alpha ) {

		this.x = v1.x + ( v2.x - v1.x ) * alpha;
		this.y = v1.y + ( v2.y - v1.y ) * alpha;
		this.z = v1.z + ( v2.z - v1.z ) * alpha;
		this.w = v1.w + ( v2.w - v1.w ) * alpha;

		return this;

	}

	equals( v ) {

		return ( ( v.x === this.x ) && ( v.y === this.y ) && ( v.z === this.z ) && ( v.w === this.w ) );

	}

	fromArray( array, offset = 0 ) {

		this.x = array[ offset ];
		this.y = array[ offset + 1 ];
		this.z = array[ offset + 2 ];
		this.w = array[ offset + 3 ];

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this.x;
		array[ offset + 1 ] = this.y;
		array[ offset + 2 ] = this.z;
		array[ offset + 3 ] = this.w;

		return array;

	}

	fromBufferAttribute( attribute, index ) {

		this.x = attribute.getX( index );
		this.y = attribute.getY( index );
		this.z = attribute.getZ( index );
		this.w = attribute.getW( index );

		return this;

	}

	random() {

		this.x = Math.random();
		this.y = Math.random();
		this.z = Math.random();
		this.w = Math.random();

		return this;

	}

	*[ Symbol.iterator ]() {

		yield this.x;
		yield this.y;
		yield this.z;
		yield this.w;

	}

}

/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/
class RenderTarget extends EventDispatcher$2 {

	constructor( width = 1, height = 1, options = {} ) {

		super();

		this.isRenderTarget = true;

		this.width = width;
		this.height = height;
		this.depth = 1;

		this.scissor = new Vector4( 0, 0, width, height );
		this.scissorTest = false;

		this.viewport = new Vector4( 0, 0, width, height );

		const image = { width: width, height: height, depth: 1 };

		options = Object.assign( {
			generateMipmaps: false,
			internalFormat: null,
			minFilter: LinearFilter,
			depthBuffer: true,
			stencilBuffer: false,
			resolveDepthBuffer: true,
			resolveStencilBuffer: true,
			depthTexture: null,
			samples: 0,
			count: 1
		}, options );

		const texture = new Texture( image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace );

		texture.flipY = false;
		texture.generateMipmaps = options.generateMipmaps;
		texture.internalFormat = options.internalFormat;

		this.textures = [];

		const count = options.count;
		for ( let i = 0; i < count; i ++ ) {

			this.textures[ i ] = texture.clone();
			this.textures[ i ].isRenderTargetTexture = true;

		}

		this.depthBuffer = options.depthBuffer;
		this.stencilBuffer = options.stencilBuffer;

		this.resolveDepthBuffer = options.resolveDepthBuffer;
		this.resolveStencilBuffer = options.resolveStencilBuffer;

		this.depthTexture = options.depthTexture;

		this.samples = options.samples;

	}

	get texture() {

		return this.textures[ 0 ];

	}

	set texture( value ) {

		this.textures[ 0 ] = value;

	}

	setSize( width, height, depth = 1 ) {

		if ( this.width !== width || this.height !== height || this.depth !== depth ) {

			this.width = width;
			this.height = height;
			this.depth = depth;

			for ( let i = 0, il = this.textures.length; i < il; i ++ ) {

				this.textures[ i ].image.width = width;
				this.textures[ i ].image.height = height;
				this.textures[ i ].image.depth = depth;

			}

			this.dispose();

		}

		this.viewport.set( 0, 0, width, height );
		this.scissor.set( 0, 0, width, height );

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( source ) {

		this.width = source.width;
		this.height = source.height;
		this.depth = source.depth;

		this.scissor.copy( source.scissor );
		this.scissorTest = source.scissorTest;

		this.viewport.copy( source.viewport );

		this.textures.length = 0;

		for ( let i = 0, il = source.textures.length; i < il; i ++ ) {

			this.textures[ i ] = source.textures[ i ].clone();
			this.textures[ i ].isRenderTargetTexture = true;

		}

		// ensure image object is not shared, see #20328

		const image = Object.assign( {}, source.texture.image );
		this.texture.source = new Source( image );

		this.depthBuffer = source.depthBuffer;
		this.stencilBuffer = source.stencilBuffer;

		this.resolveDepthBuffer = source.resolveDepthBuffer;
		this.resolveStencilBuffer = source.resolveStencilBuffer;

		if ( source.depthTexture !== null ) this.depthTexture = source.depthTexture.clone();

		this.samples = source.samples;

		return this;

	}

	dispose() {

		this.dispatchEvent( { type: 'dispose' } );

	}

}

class WebGLRenderTarget extends RenderTarget {

	constructor( width = 1, height = 1, options = {} ) {

		super( width, height, options );

		this.isWebGLRenderTarget = true;

	}

}

class DataArrayTexture extends Texture {

	constructor( data = null, width = 1, height = 1, depth = 1 ) {

		super( null );

		this.isDataArrayTexture = true;

		this.image = { data, width, height, depth };

		this.magFilter = NearestFilter;
		this.minFilter = NearestFilter;

		this.wrapR = ClampToEdgeWrapping;

		this.generateMipmaps = false;
		this.flipY = false;
		this.unpackAlignment = 1;

		this.layerUpdates = new Set();

	}

	addLayerUpdate( layerIndex ) {

		this.layerUpdates.add( layerIndex );

	}

	clearLayerUpdates() {

		this.layerUpdates.clear();

	}

}

class Data3DTexture extends Texture {

	constructor( data = null, width = 1, height = 1, depth = 1 ) {

		// We're going to add .setXXX() methods for setting properties later.
		// Users can still set in DataTexture3D directly.
		//
		//	const texture = new THREE.DataTexture3D( data, width, height, depth );
		// 	texture.anisotropy = 16;
		//
		// See #14839

		super( null );

		this.isData3DTexture = true;

		this.image = { data, width, height, depth };

		this.magFilter = NearestFilter;
		this.minFilter = NearestFilter;

		this.wrapR = ClampToEdgeWrapping;

		this.generateMipmaps = false;
		this.flipY = false;
		this.unpackAlignment = 1;

	}

}

class Quaternion {

	constructor( x = 0, y = 0, z = 0, w = 1 ) {

		this.isQuaternion = true;

		this._x = x;
		this._y = y;
		this._z = z;
		this._w = w;

	}

	static slerpFlat( dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t ) {

		// fuzz-free, array-based Quaternion SLERP operation

		let x0 = src0[ srcOffset0 + 0 ],
			y0 = src0[ srcOffset0 + 1 ],
			z0 = src0[ srcOffset0 + 2 ],
			w0 = src0[ srcOffset0 + 3 ];

		const x1 = src1[ srcOffset1 + 0 ],
			y1 = src1[ srcOffset1 + 1 ],
			z1 = src1[ srcOffset1 + 2 ],
			w1 = src1[ srcOffset1 + 3 ];

		if ( t === 0 ) {

			dst[ dstOffset + 0 ] = x0;
			dst[ dstOffset + 1 ] = y0;
			dst[ dstOffset + 2 ] = z0;
			dst[ dstOffset + 3 ] = w0;
			return;

		}

		if ( t === 1 ) {

			dst[ dstOffset + 0 ] = x1;
			dst[ dstOffset + 1 ] = y1;
			dst[ dstOffset + 2 ] = z1;
			dst[ dstOffset + 3 ] = w1;
			return;

		}

		if ( w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1 ) {

			let s = 1 - t;
			const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1,
				dir = ( cos >= 0 ? 1 : - 1 ),
				sqrSin = 1 - cos * cos;

			// Skip the Slerp for tiny steps to avoid numeric problems:
			if ( sqrSin > Number.EPSILON ) {

				const sin = Math.sqrt( sqrSin ),
					len = Math.atan2( sin, cos * dir );

				s = Math.sin( s * len ) / sin;
				t = Math.sin( t * len ) / sin;

			}

			const tDir = t * dir;

			x0 = x0 * s + x1 * tDir;
			y0 = y0 * s + y1 * tDir;
			z0 = z0 * s + z1 * tDir;
			w0 = w0 * s + w1 * tDir;

			// Normalize in case we just did a lerp:
			if ( s === 1 - t ) {

				const f = 1 / Math.sqrt( x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0 );

				x0 *= f;
				y0 *= f;
				z0 *= f;
				w0 *= f;

			}

		}

		dst[ dstOffset ] = x0;
		dst[ dstOffset + 1 ] = y0;
		dst[ dstOffset + 2 ] = z0;
		dst[ dstOffset + 3 ] = w0;

	}

	static multiplyQuaternionsFlat( dst, dstOffset, src0, srcOffset0, src1, srcOffset1 ) {

		const x0 = src0[ srcOffset0 ];
		const y0 = src0[ srcOffset0 + 1 ];
		const z0 = src0[ srcOffset0 + 2 ];
		const w0 = src0[ srcOffset0 + 3 ];

		const x1 = src1[ srcOffset1 ];
		const y1 = src1[ srcOffset1 + 1 ];
		const z1 = src1[ srcOffset1 + 2 ];
		const w1 = src1[ srcOffset1 + 3 ];

		dst[ dstOffset ] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
		dst[ dstOffset + 1 ] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
		dst[ dstOffset + 2 ] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
		dst[ dstOffset + 3 ] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;

		return dst;

	}

	get x() {

		return this._x;

	}

	set x( value ) {

		this._x = value;
		this._onChangeCallback();

	}

	get y() {

		return this._y;

	}

	set y( value ) {

		this._y = value;
		this._onChangeCallback();

	}

	get z() {

		return this._z;

	}

	set z( value ) {

		this._z = value;
		this._onChangeCallback();

	}

	get w() {

		return this._w;

	}

	set w( value ) {

		this._w = value;
		this._onChangeCallback();

	}

	set( x, y, z, w ) {

		this._x = x;
		this._y = y;
		this._z = z;
		this._w = w;

		this._onChangeCallback();

		return this;

	}

	clone() {

		return new this.constructor( this._x, this._y, this._z, this._w );

	}

	copy( quaternion ) {

		this._x = quaternion.x;
		this._y = quaternion.y;
		this._z = quaternion.z;
		this._w = quaternion.w;

		this._onChangeCallback();

		return this;

	}

	setFromEuler( euler, update = true ) {

		const x = euler._x, y = euler._y, z = euler._z, order = euler._order;

		// http://www.mathworks.com/matlabcentral/fileexchange/
		// 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
		//	content/SpinCalc.m

		const cos = Math.cos;
		const sin = Math.sin;

		const c1 = cos( x / 2 );
		const c2 = cos( y / 2 );
		const c3 = cos( z / 2 );

		const s1 = sin( x / 2 );
		const s2 = sin( y / 2 );
		const s3 = sin( z / 2 );

		switch ( order ) {

			case 'XYZ':
				this._x = s1 * c2 * c3 + c1 * s2 * s3;
				this._y = c1 * s2 * c3 - s1 * c2 * s3;
				this._z = c1 * c2 * s3 + s1 * s2 * c3;
				this._w = c1 * c2 * c3 - s1 * s2 * s3;
				break;

			case 'YXZ':
				this._x = s1 * c2 * c3 + c1 * s2 * s3;
				this._y = c1 * s2 * c3 - s1 * c2 * s3;
				this._z = c1 * c2 * s3 - s1 * s2 * c3;
				this._w = c1 * c2 * c3 + s1 * s2 * s3;
				break;

			case 'ZXY':
				this._x = s1 * c2 * c3 - c1 * s2 * s3;
				this._y = c1 * s2 * c3 + s1 * c2 * s3;
				this._z = c1 * c2 * s3 + s1 * s2 * c3;
				this._w = c1 * c2 * c3 - s1 * s2 * s3;
				break;

			case 'ZYX':
				this._x = s1 * c2 * c3 - c1 * s2 * s3;
				this._y = c1 * s2 * c3 + s1 * c2 * s3;
				this._z = c1 * c2 * s3 - s1 * s2 * c3;
				this._w = c1 * c2 * c3 + s1 * s2 * s3;
				break;

			case 'YZX':
				this._x = s1 * c2 * c3 + c1 * s2 * s3;
				this._y = c1 * s2 * c3 + s1 * c2 * s3;
				this._z = c1 * c2 * s3 - s1 * s2 * c3;
				this._w = c1 * c2 * c3 - s1 * s2 * s3;
				break;

			case 'XZY':
				this._x = s1 * c2 * c3 - c1 * s2 * s3;
				this._y = c1 * s2 * c3 - s1 * c2 * s3;
				this._z = c1 * c2 * s3 + s1 * s2 * c3;
				this._w = c1 * c2 * c3 + s1 * s2 * s3;
				break;

			default:
				console.warn( 'THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order );

		}

		if ( update === true ) this._onChangeCallback();

		return this;

	}

	setFromAxisAngle( axis, angle ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm

		// assumes axis is normalized

		const halfAngle = angle / 2, s = Math.sin( halfAngle );

		this._x = axis.x * s;
		this._y = axis.y * s;
		this._z = axis.z * s;
		this._w = Math.cos( halfAngle );

		this._onChangeCallback();

		return this;

	}

	setFromRotationMatrix( m ) {

		// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		const te = m.elements,

			m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ],
			m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ],
			m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ],

			trace = m11 + m22 + m33;

		if ( trace > 0 ) {

			const s = 0.5 / Math.sqrt( trace + 1.0 );

			this._w = 0.25 / s;
			this._x = ( m32 - m23 ) * s;
			this._y = ( m13 - m31 ) * s;
			this._z = ( m21 - m12 ) * s;

		} else if ( m11 > m22 && m11 > m33 ) {

			const s = 2.0 * Math.sqrt( 1.0 + m11 - m22 - m33 );

			this._w = ( m32 - m23 ) / s;
			this._x = 0.25 * s;
			this._y = ( m12 + m21 ) / s;
			this._z = ( m13 + m31 ) / s;

		} else if ( m22 > m33 ) {

			const s = 2.0 * Math.sqrt( 1.0 + m22 - m11 - m33 );

			this._w = ( m13 - m31 ) / s;
			this._x = ( m12 + m21 ) / s;
			this._y = 0.25 * s;
			this._z = ( m23 + m32 ) / s;

		} else {

			const s = 2.0 * Math.sqrt( 1.0 + m33 - m11 - m22 );

			this._w = ( m21 - m12 ) / s;
			this._x = ( m13 + m31 ) / s;
			this._y = ( m23 + m32 ) / s;
			this._z = 0.25 * s;

		}

		this._onChangeCallback();

		return this;

	}

	setFromUnitVectors( vFrom, vTo ) {

		// assumes direction vectors vFrom and vTo are normalized

		let r = vFrom.dot( vTo ) + 1;

		if ( r < Number.EPSILON ) {

			// vFrom and vTo point in opposite directions

			r = 0;

			if ( Math.abs( vFrom.x ) > Math.abs( vFrom.z ) ) {

				this._x = - vFrom.y;
				this._y = vFrom.x;
				this._z = 0;
				this._w = r;

			} else {

				this._x = 0;
				this._y = - vFrom.z;
				this._z = vFrom.y;
				this._w = r;

			}

		} else {

			// crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3

			this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
			this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
			this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
			this._w = r;

		}

		return this.normalize();

	}

	angleTo( q ) {

		return 2 * Math.acos( Math.abs( clamp( this.dot( q ), - 1, 1 ) ) );

	}

	rotateTowards( q, step ) {

		const angle = this.angleTo( q );

		if ( angle === 0 ) return this;

		const t = Math.min( 1, step / angle );

		this.slerp( q, t );

		return this;

	}

	identity() {

		return this.set( 0, 0, 0, 1 );

	}

	invert() {

		// quaternion is assumed to have unit length

		return this.conjugate();

	}

	conjugate() {

		this._x *= - 1;
		this._y *= - 1;
		this._z *= - 1;

		this._onChangeCallback();

		return this;

	}

	dot( v ) {

		return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;

	}

	lengthSq() {

		return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;

	}

	length() {

		return Math.sqrt( this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w );

	}

	normalize() {

		let l = this.length();

		if ( l === 0 ) {

			this._x = 0;
			this._y = 0;
			this._z = 0;
			this._w = 1;

		} else {

			l = 1 / l;

			this._x = this._x * l;
			this._y = this._y * l;
			this._z = this._z * l;
			this._w = this._w * l;

		}

		this._onChangeCallback();

		return this;

	}

	multiply( q ) {

		return this.multiplyQuaternions( this, q );

	}

	premultiply( q ) {

		return this.multiplyQuaternions( q, this );

	}

	multiplyQuaternions( a, b ) {

		// from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm

		const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
		const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;

		this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
		this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
		this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
		this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;

		this._onChangeCallback();

		return this;

	}

	slerp( qb, t ) {

		if ( t === 0 ) return this;
		if ( t === 1 ) return this.copy( qb );

		const x = this._x, y = this._y, z = this._z, w = this._w;

		// http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/

		let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;

		if ( cosHalfTheta < 0 ) {

			this._w = - qb._w;
			this._x = - qb._x;
			this._y = - qb._y;
			this._z = - qb._z;

			cosHalfTheta = - cosHalfTheta;

		} else {

			this.copy( qb );

		}

		if ( cosHalfTheta >= 1.0 ) {

			this._w = w;
			this._x = x;
			this._y = y;
			this._z = z;

			return this;

		}

		const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;

		if ( sqrSinHalfTheta <= Number.EPSILON ) {

			const s = 1 - t;
			this._w = s * w + t * this._w;
			this._x = s * x + t * this._x;
			this._y = s * y + t * this._y;
			this._z = s * z + t * this._z;

			this.normalize(); // normalize calls _onChangeCallback()

			return this;

		}

		const sinHalfTheta = Math.sqrt( sqrSinHalfTheta );
		const halfTheta = Math.atan2( sinHalfTheta, cosHalfTheta );
		const ratioA = Math.sin( ( 1 - t ) * halfTheta ) / sinHalfTheta,
			ratioB = Math.sin( t * halfTheta ) / sinHalfTheta;

		this._w = ( w * ratioA + this._w * ratioB );
		this._x = ( x * ratioA + this._x * ratioB );
		this._y = ( y * ratioA + this._y * ratioB );
		this._z = ( z * ratioA + this._z * ratioB );

		this._onChangeCallback();

		return this;

	}

	slerpQuaternions( qa, qb, t ) {

		return this.copy( qa ).slerp( qb, t );

	}

	random() {

		// sets this quaternion to a uniform random unit quaternnion

		// Ken Shoemake
		// Uniform random rotations
		// D. Kirk, editor, Graphics Gems III, pages 124-132. Academic Press, New York, 1992.

		const theta1 = 2 * Math.PI * Math.random();
		const theta2 = 2 * Math.PI * Math.random();

		const x0 = Math.random();
		const r1 = Math.sqrt( 1 - x0 );
		const r2 = Math.sqrt( x0 );

		return this.set(
			r1 * Math.sin( theta1 ),
			r1 * Math.cos( theta1 ),
			r2 * Math.sin( theta2 ),
			r2 * Math.cos( theta2 ),
		);

	}

	equals( quaternion ) {

		return ( quaternion._x === this._x ) && ( quaternion._y === this._y ) && ( quaternion._z === this._z ) && ( quaternion._w === this._w );

	}

	fromArray( array, offset = 0 ) {

		this._x = array[ offset ];
		this._y = array[ offset + 1 ];
		this._z = array[ offset + 2 ];
		this._w = array[ offset + 3 ];

		this._onChangeCallback();

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this._x;
		array[ offset + 1 ] = this._y;
		array[ offset + 2 ] = this._z;
		array[ offset + 3 ] = this._w;

		return array;

	}

	fromBufferAttribute( attribute, index ) {

		this._x = attribute.getX( index );
		this._y = attribute.getY( index );
		this._z = attribute.getZ( index );
		this._w = attribute.getW( index );

		this._onChangeCallback();

		return this;

	}

	toJSON() {

		return this.toArray();

	}

	_onChange( callback ) {

		this._onChangeCallback = callback;

		return this;

	}

	_onChangeCallback() {}

	*[ Symbol.iterator ]() {

		yield this._x;
		yield this._y;
		yield this._z;
		yield this._w;

	}

}

class Vector3 {

	constructor( x = 0, y = 0, z = 0 ) {

		Vector3.prototype.isVector3 = true;

		this.x = x;
		this.y = y;
		this.z = z;

	}

	set( x, y, z ) {

		if ( z === undefined ) z = this.z; // sprite.scale.set(x,y)

		this.x = x;
		this.y = y;
		this.z = z;

		return this;

	}

	setScalar( scalar ) {

		this.x = scalar;
		this.y = scalar;
		this.z = scalar;

		return this;

	}

	setX( x ) {

		this.x = x;

		return this;

	}

	setY( y ) {

		this.y = y;

		return this;

	}

	setZ( z ) {

		this.z = z;

		return this;

	}

	setComponent( index, value ) {

		switch ( index ) {

			case 0: this.x = value; break;
			case 1: this.y = value; break;
			case 2: this.z = value; break;
			default: throw new Error( 'index is out of range: ' + index );

		}

		return this;

	}

	getComponent( index ) {

		switch ( index ) {

			case 0: return this.x;
			case 1: return this.y;
			case 2: return this.z;
			default: throw new Error( 'index is out of range: ' + index );

		}

	}

	clone() {

		return new this.constructor( this.x, this.y, this.z );

	}

	copy( v ) {

		this.x = v.x;
		this.y = v.y;
		this.z = v.z;

		return this;

	}

	add( v ) {

		this.x += v.x;
		this.y += v.y;
		this.z += v.z;

		return this;

	}

	addScalar( s ) {

		this.x += s;
		this.y += s;
		this.z += s;

		return this;

	}

	addVectors( a, b ) {

		this.x = a.x + b.x;
		this.y = a.y + b.y;
		this.z = a.z + b.z;

		return this;

	}

	addScaledVector( v, s ) {

		this.x += v.x * s;
		this.y += v.y * s;
		this.z += v.z * s;

		return this;

	}

	sub( v ) {

		this.x -= v.x;
		this.y -= v.y;
		this.z -= v.z;

		return this;

	}

	subScalar( s ) {

		this.x -= s;
		this.y -= s;
		this.z -= s;

		return this;

	}

	subVectors( a, b ) {

		this.x = a.x - b.x;
		this.y = a.y - b.y;
		this.z = a.z - b.z;

		return this;

	}

	multiply( v ) {

		this.x *= v.x;
		this.y *= v.y;
		this.z *= v.z;

		return this;

	}

	multiplyScalar( scalar ) {

		this.x *= scalar;
		this.y *= scalar;
		this.z *= scalar;

		return this;

	}

	multiplyVectors( a, b ) {

		this.x = a.x * b.x;
		this.y = a.y * b.y;
		this.z = a.z * b.z;

		return this;

	}

	applyEuler( euler ) {

		return this.applyQuaternion( _quaternion$4.setFromEuler( euler ) );

	}

	applyAxisAngle( axis, angle ) {

		return this.applyQuaternion( _quaternion$4.setFromAxisAngle( axis, angle ) );

	}

	applyMatrix3( m ) {

		const x = this.x, y = this.y, z = this.z;
		const e = m.elements;

		this.x = e[ 0 ] * x + e[ 3 ] * y + e[ 6 ] * z;
		this.y = e[ 1 ] * x + e[ 4 ] * y + e[ 7 ] * z;
		this.z = e[ 2 ] * x + e[ 5 ] * y + e[ 8 ] * z;

		return this;

	}

	applyNormalMatrix( m ) {

		return this.applyMatrix3( m ).normalize();

	}

	applyMatrix4( m ) {

		const x = this.x, y = this.y, z = this.z;
		const e = m.elements;

		const w = 1 / ( e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ] );

		this.x = ( e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z + e[ 12 ] ) * w;
		this.y = ( e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z + e[ 13 ] ) * w;
		this.z = ( e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ] ) * w;

		return this;

	}

	applyQuaternion( q ) {

		// quaternion q is assumed to have unit length

		const vx = this.x, vy = this.y, vz = this.z;
		const qx = q.x, qy = q.y, qz = q.z, qw = q.w;

		// t = 2 * cross( q.xyz, v );
		const tx = 2 * ( qy * vz - qz * vy );
		const ty = 2 * ( qz * vx - qx * vz );
		const tz = 2 * ( qx * vy - qy * vx );

		// v + q.w * t + cross( q.xyz, t );
		this.x = vx + qw * tx + qy * tz - qz * ty;
		this.y = vy + qw * ty + qz * tx - qx * tz;
		this.z = vz + qw * tz + qx * ty - qy * tx;

		return this;

	}

	project( camera ) {

		return this.applyMatrix4( camera.matrixWorldInverse ).applyMatrix4( camera.projectionMatrix );

	}

	unproject( camera ) {

		return this.applyMatrix4( camera.projectionMatrixInverse ).applyMatrix4( camera.matrixWorld );

	}

	transformDirection( m ) {

		// input: THREE.Matrix4 affine matrix
		// vector interpreted as a direction

		const x = this.x, y = this.y, z = this.z;
		const e = m.elements;

		this.x = e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z;
		this.y = e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z;
		this.z = e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z;

		return this.normalize();

	}

	divide( v ) {

		this.x /= v.x;
		this.y /= v.y;
		this.z /= v.z;

		return this;

	}

	divideScalar( scalar ) {

		return this.multiplyScalar( 1 / scalar );

	}

	min( v ) {

		this.x = Math.min( this.x, v.x );
		this.y = Math.min( this.y, v.y );
		this.z = Math.min( this.z, v.z );

		return this;

	}

	max( v ) {

		this.x = Math.max( this.x, v.x );
		this.y = Math.max( this.y, v.y );
		this.z = Math.max( this.z, v.z );

		return this;

	}

	clamp( min, max ) {

		// assumes min < max, componentwise

		this.x = Math.max( min.x, Math.min( max.x, this.x ) );
		this.y = Math.max( min.y, Math.min( max.y, this.y ) );
		this.z = Math.max( min.z, Math.min( max.z, this.z ) );

		return this;

	}

	clampScalar( minVal, maxVal ) {

		this.x = Math.max( minVal, Math.min( maxVal, this.x ) );
		this.y = Math.max( minVal, Math.min( maxVal, this.y ) );
		this.z = Math.max( minVal, Math.min( maxVal, this.z ) );

		return this;

	}

	clampLength( min, max ) {

		const length = this.length();

		return this.divideScalar( length || 1 ).multiplyScalar( Math.max( min, Math.min( max, length ) ) );

	}

	floor() {

		this.x = Math.floor( this.x );
		this.y = Math.floor( this.y );
		this.z = Math.floor( this.z );

		return this;

	}

	ceil() {

		this.x = Math.ceil( this.x );
		this.y = Math.ceil( this.y );
		this.z = Math.ceil( this.z );

		return this;

	}

	round() {

		this.x = Math.round( this.x );
		this.y = Math.round( this.y );
		this.z = Math.round( this.z );

		return this;

	}

	roundToZero() {

		this.x = Math.trunc( this.x );
		this.y = Math.trunc( this.y );
		this.z = Math.trunc( this.z );

		return this;

	}

	negate() {

		this.x = - this.x;
		this.y = - this.y;
		this.z = - this.z;

		return this;

	}

	dot( v ) {

		return this.x * v.x + this.y * v.y + this.z * v.z;

	}

	// TODO lengthSquared?

	lengthSq() {

		return this.x * this.x + this.y * this.y + this.z * this.z;

	}

	length() {

		return Math.sqrt( this.x * this.x + this.y * this.y + this.z * this.z );

	}

	manhattanLength() {

		return Math.abs( this.x ) + Math.abs( this.y ) + Math.abs( this.z );

	}

	normalize() {

		return this.divideScalar( this.length() || 1 );

	}

	setLength( length ) {

		return this.normalize().multiplyScalar( length );

	}

	lerp( v, alpha ) {

		this.x += ( v.x - this.x ) * alpha;
		this.y += ( v.y - this.y ) * alpha;
		this.z += ( v.z - this.z ) * alpha;

		return this;

	}

	lerpVectors( v1, v2, alpha ) {

		this.x = v1.x + ( v2.x - v1.x ) * alpha;
		this.y = v1.y + ( v2.y - v1.y ) * alpha;
		this.z = v1.z + ( v2.z - v1.z ) * alpha;

		return this;

	}

	cross( v ) {

		return this.crossVectors( this, v );

	}

	crossVectors( a, b ) {

		const ax = a.x, ay = a.y, az = a.z;
		const bx = b.x, by = b.y, bz = b.z;

		this.x = ay * bz - az * by;
		this.y = az * bx - ax * bz;
		this.z = ax * by - ay * bx;

		return this;

	}

	projectOnVector( v ) {

		const denominator = v.lengthSq();

		if ( denominator === 0 ) return this.set( 0, 0, 0 );

		const scalar = v.dot( this ) / denominator;

		return this.copy( v ).multiplyScalar( scalar );

	}

	projectOnPlane( planeNormal ) {

		_vector$c.copy( this ).projectOnVector( planeNormal );

		return this.sub( _vector$c );

	}

	reflect( normal ) {

		// reflect incident vector off plane orthogonal to normal
		// normal is assumed to have unit length

		return this.sub( _vector$c.copy( normal ).multiplyScalar( 2 * this.dot( normal ) ) );

	}

	angleTo( v ) {

		const denominator = Math.sqrt( this.lengthSq() * v.lengthSq() );

		if ( denominator === 0 ) return Math.PI / 2;

		const theta = this.dot( v ) / denominator;

		// clamp, to handle numerical problems

		return Math.acos( clamp( theta, - 1, 1 ) );

	}

	distanceTo( v ) {

		return Math.sqrt( this.distanceToSquared( v ) );

	}

	distanceToSquared( v ) {

		const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;

		return dx * dx + dy * dy + dz * dz;

	}

	manhattanDistanceTo( v ) {

		return Math.abs( this.x - v.x ) + Math.abs( this.y - v.y ) + Math.abs( this.z - v.z );

	}

	setFromSpherical( s ) {

		return this.setFromSphericalCoords( s.radius, s.phi, s.theta );

	}

	setFromSphericalCoords( radius, phi, theta ) {

		const sinPhiRadius = Math.sin( phi ) * radius;

		this.x = sinPhiRadius * Math.sin( theta );
		this.y = Math.cos( phi ) * radius;
		this.z = sinPhiRadius * Math.cos( theta );

		return this;

	}

	setFromCylindrical( c ) {

		return this.setFromCylindricalCoords( c.radius, c.theta, c.y );

	}

	setFromCylindricalCoords( radius, theta, y ) {

		this.x = radius * Math.sin( theta );
		this.y = y;
		this.z = radius * Math.cos( theta );

		return this;

	}

	setFromMatrixPosition( m ) {

		const e = m.elements;

		this.x = e[ 12 ];
		this.y = e[ 13 ];
		this.z = e[ 14 ];

		return this;

	}

	setFromMatrixScale( m ) {

		const sx = this.setFromMatrixColumn( m, 0 ).length();
		const sy = this.setFromMatrixColumn( m, 1 ).length();
		const sz = this.setFromMatrixColumn( m, 2 ).length();

		this.x = sx;
		this.y = sy;
		this.z = sz;

		return this;

	}

	setFromMatrixColumn( m, index ) {

		return this.fromArray( m.elements, index * 4 );

	}

	setFromMatrix3Column( m, index ) {

		return this.fromArray( m.elements, index * 3 );

	}

	setFromEuler( e ) {

		this.x = e._x;
		this.y = e._y;
		this.z = e._z;

		return this;

	}

	setFromColor( c ) {

		this.x = c.r;
		this.y = c.g;
		this.z = c.b;

		return this;

	}

	equals( v ) {

		return ( ( v.x === this.x ) && ( v.y === this.y ) && ( v.z === this.z ) );

	}

	fromArray( array, offset = 0 ) {

		this.x = array[ offset ];
		this.y = array[ offset + 1 ];
		this.z = array[ offset + 2 ];

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this.x;
		array[ offset + 1 ] = this.y;
		array[ offset + 2 ] = this.z;

		return array;

	}

	fromBufferAttribute( attribute, index ) {

		this.x = attribute.getX( index );
		this.y = attribute.getY( index );
		this.z = attribute.getZ( index );

		return this;

	}

	random() {

		this.x = Math.random();
		this.y = Math.random();
		this.z = Math.random();

		return this;

	}

	randomDirection() {

		// https://mathworld.wolfram.com/SpherePointPicking.html

		const theta = Math.random() * Math.PI * 2;
		const u = Math.random() * 2 - 1;
		const c = Math.sqrt( 1 - u * u );

		this.x = c * Math.cos( theta );
		this.y = u;
		this.z = c * Math.sin( theta );

		return this;

	}

	*[ Symbol.iterator ]() {

		yield this.x;
		yield this.y;
		yield this.z;

	}

}

const _vector$c = /*@__PURE__*/ new Vector3();
const _quaternion$4 = /*@__PURE__*/ new Quaternion();

class Box3 {

	constructor( min = new Vector3( + Infinity, + Infinity, + Infinity ), max = new Vector3( - Infinity, - Infinity, - Infinity ) ) {

		this.isBox3 = true;

		this.min = min;
		this.max = max;

	}

	set( min, max ) {

		this.min.copy( min );
		this.max.copy( max );

		return this;

	}

	setFromArray( array ) {

		this.makeEmpty();

		for ( let i = 0, il = array.length; i < il; i += 3 ) {

			this.expandByPoint( _vector$b.fromArray( array, i ) );

		}

		return this;

	}

	setFromBufferAttribute( attribute ) {

		this.makeEmpty();

		for ( let i = 0, il = attribute.count; i < il; i ++ ) {

			this.expandByPoint( _vector$b.fromBufferAttribute( attribute, i ) );

		}

		return this;

	}

	setFromPoints( points ) {

		this.makeEmpty();

		for ( let i = 0, il = points.length; i < il; i ++ ) {

			this.expandByPoint( points[ i ] );

		}

		return this;

	}

	setFromCenterAndSize( center, size ) {

		const halfSize = _vector$b.copy( size ).multiplyScalar( 0.5 );

		this.min.copy( center ).sub( halfSize );
		this.max.copy( center ).add( halfSize );

		return this;

	}

	setFromObject( object, precise = false ) {

		this.makeEmpty();

		return this.expandByObject( object, precise );

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( box ) {

		this.min.copy( box.min );
		this.max.copy( box.max );

		return this;

	}

	makeEmpty() {

		this.min.x = this.min.y = this.min.z = + Infinity;
		this.max.x = this.max.y = this.max.z = - Infinity;

		return this;

	}

	isEmpty() {

		// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes

		return ( this.max.x < this.min.x ) || ( this.max.y < this.min.y ) || ( this.max.z < this.min.z );

	}

	getCenter( target ) {

		return this.isEmpty() ? target.set( 0, 0, 0 ) : target.addVectors( this.min, this.max ).multiplyScalar( 0.5 );

	}

	getSize( target ) {

		return this.isEmpty() ? target.set( 0, 0, 0 ) : target.subVectors( this.max, this.min );

	}

	expandByPoint( point ) {

		this.min.min( point );
		this.max.max( point );

		return this;

	}

	expandByVector( vector ) {

		this.min.sub( vector );
		this.max.add( vector );

		return this;

	}

	expandByScalar( scalar ) {

		this.min.addScalar( - scalar );
		this.max.addScalar( scalar );

		return this;

	}

	expandByObject( object, precise = false ) {

		// Computes the world-axis-aligned bounding box of an object (including its children),
		// accounting for both the object's, and children's, world transforms

		object.updateWorldMatrix( false, false );

		const geometry = object.geometry;

		if ( geometry !== undefined ) {

			const positionAttribute = geometry.getAttribute( 'position' );

			// precise AABB computation based on vertex data requires at least a position attribute.
			// instancing isn't supported so far and uses the normal (conservative) code path.

			if ( precise === true && positionAttribute !== undefined && object.isInstancedMesh !== true ) {

				for ( let i = 0, l = positionAttribute.count; i < l; i ++ ) {

					if ( object.isMesh === true ) {

						object.getVertexPosition( i, _vector$b );

					} else {

						_vector$b.fromBufferAttribute( positionAttribute, i );

					}

					_vector$b.applyMatrix4( object.matrixWorld );
					this.expandByPoint( _vector$b );

				}

			} else {

				if ( object.boundingBox !== undefined ) {

					// object-level bounding box

					if ( object.boundingBox === null ) {

						object.computeBoundingBox();

					}

					_box$4.copy( object.boundingBox );


				} else {

					// geometry-level bounding box

					if ( geometry.boundingBox === null ) {

						geometry.computeBoundingBox();

					}

					_box$4.copy( geometry.boundingBox );

				}

				_box$4.applyMatrix4( object.matrixWorld );

				this.union( _box$4 );

			}

		}

		const children = object.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			this.expandByObject( children[ i ], precise );

		}

		return this;

	}

	containsPoint( point ) {

		return point.x < this.min.x || point.x > this.max.x ||
			point.y < this.min.y || point.y > this.max.y ||
			point.z < this.min.z || point.z > this.max.z ? false : true;

	}

	containsBox( box ) {

		return this.min.x <= box.min.x && box.max.x <= this.max.x &&
			this.min.y <= box.min.y && box.max.y <= this.max.y &&
			this.min.z <= box.min.z && box.max.z <= this.max.z;

	}

	getParameter( point, target ) {

		// This can potentially have a divide by zero if the box
		// has a size dimension of 0.

		return target.set(
			( point.x - this.min.x ) / ( this.max.x - this.min.x ),
			( point.y - this.min.y ) / ( this.max.y - this.min.y ),
			( point.z - this.min.z ) / ( this.max.z - this.min.z )
		);

	}

	intersectsBox( box ) {

		// using 6 splitting planes to rule out intersections.
		return box.max.x < this.min.x || box.min.x > this.max.x ||
			box.max.y < this.min.y || box.min.y > this.max.y ||
			box.max.z < this.min.z || box.min.z > this.max.z ? false : true;

	}

	intersectsSphere( sphere ) {

		// Find the point on the AABB closest to the sphere center.
		this.clampPoint( sphere.center, _vector$b );

		// If that point is inside the sphere, the AABB and sphere intersect.
		return _vector$b.distanceToSquared( sphere.center ) <= ( sphere.radius * sphere.radius );

	}

	intersectsPlane( plane ) {

		// We compute the minimum and maximum dot product values. If those values
		// are on the same side (back or front) of the plane, then there is no intersection.

		let min, max;

		if ( plane.normal.x > 0 ) {

			min = plane.normal.x * this.min.x;
			max = plane.normal.x * this.max.x;

		} else {

			min = plane.normal.x * this.max.x;
			max = plane.normal.x * this.min.x;

		}

		if ( plane.normal.y > 0 ) {

			min += plane.normal.y * this.min.y;
			max += plane.normal.y * this.max.y;

		} else {

			min += plane.normal.y * this.max.y;
			max += plane.normal.y * this.min.y;

		}

		if ( plane.normal.z > 0 ) {

			min += plane.normal.z * this.min.z;
			max += plane.normal.z * this.max.z;

		} else {

			min += plane.normal.z * this.max.z;
			max += plane.normal.z * this.min.z;

		}

		return ( min <= - plane.constant && max >= - plane.constant );

	}

	intersectsTriangle( triangle ) {

		if ( this.isEmpty() ) {

			return false;

		}

		// compute box center and extents
		this.getCenter( _center$1 );
		_extents.subVectors( this.max, _center$1 );

		// translate triangle to aabb origin
		_v0$2.subVectors( triangle.a, _center$1 );
		_v1$7$1.subVectors( triangle.b, _center$1 );
		_v2$4$1.subVectors( triangle.c, _center$1 );

		// compute edge vectors for triangle
		_f0.subVectors( _v1$7$1, _v0$2 );
		_f1$1.subVectors( _v2$4$1, _v1$7$1 );
		_f2$1.subVectors( _v0$2, _v2$4$1 );

		// test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
		// make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
		// axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
		let axes = [
			0, - _f0.z, _f0.y, 0, - _f1$1.z, _f1$1.y, 0, - _f2$1.z, _f2$1.y,
			_f0.z, 0, - _f0.x, _f1$1.z, 0, - _f1$1.x, _f2$1.z, 0, - _f2$1.x,
			- _f0.y, _f0.x, 0, - _f1$1.y, _f1$1.x, 0, - _f2$1.y, _f2$1.x, 0
		];
		if ( ! satForAxes( axes, _v0$2, _v1$7$1, _v2$4$1, _extents ) ) {

			return false;

		}

		// test 3 face normals from the aabb
		axes = [ 1, 0, 0, 0, 1, 0, 0, 0, 1 ];
		if ( ! satForAxes( axes, _v0$2, _v1$7$1, _v2$4$1, _extents ) ) {

			return false;

		}

		// finally testing the face normal of the triangle
		// use already existing triangle edge vectors here
		_triangleNormal.crossVectors( _f0, _f1$1 );
		axes = [ _triangleNormal.x, _triangleNormal.y, _triangleNormal.z ];

		return satForAxes( axes, _v0$2, _v1$7$1, _v2$4$1, _extents );

	}

	clampPoint( point, target ) {

		return target.copy( point ).clamp( this.min, this.max );

	}

	distanceToPoint( point ) {

		return this.clampPoint( point, _vector$b ).distanceTo( point );

	}

	getBoundingSphere( target ) {

		if ( this.isEmpty() ) {

			target.makeEmpty();

		} else {

			this.getCenter( target.center );

			target.radius = this.getSize( _vector$b ).length() * 0.5;

		}

		return target;

	}

	intersect( box ) {

		this.min.max( box.min );
		this.max.min( box.max );

		// ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
		if ( this.isEmpty() ) this.makeEmpty();

		return this;

	}

	union( box ) {

		this.min.min( box.min );
		this.max.max( box.max );

		return this;

	}

	applyMatrix4( matrix ) {

		// transform of empty box is an empty box.
		if ( this.isEmpty() ) return this;

		// NOTE: I am using a binary pattern to specify all 2^3 combinations below
		_points[ 0 ].set( this.min.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 000
		_points[ 1 ].set( this.min.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 001
		_points[ 2 ].set( this.min.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 010
		_points[ 3 ].set( this.min.x, this.max.y, this.max.z ).applyMatrix4( matrix ); // 011
		_points[ 4 ].set( this.max.x, this.min.y, this.min.z ).applyMatrix4( matrix ); // 100
		_points[ 5 ].set( this.max.x, this.min.y, this.max.z ).applyMatrix4( matrix ); // 101
		_points[ 6 ].set( this.max.x, this.max.y, this.min.z ).applyMatrix4( matrix ); // 110
		_points[ 7 ].set( this.max.x, this.max.y, this.max.z ).applyMatrix4( matrix ); // 111

		this.setFromPoints( _points );

		return this;

	}

	translate( offset ) {

		this.min.add( offset );
		this.max.add( offset );

		return this;

	}

	equals( box ) {

		return box.min.equals( this.min ) && box.max.equals( this.max );

	}

}

const _points = [
	/*@__PURE__*/ new Vector3(),
	/*@__PURE__*/ new Vector3(),
	/*@__PURE__*/ new Vector3(),
	/*@__PURE__*/ new Vector3(),
	/*@__PURE__*/ new Vector3(),
	/*@__PURE__*/ new Vector3(),
	/*@__PURE__*/ new Vector3(),
	/*@__PURE__*/ new Vector3()
];

const _vector$b = /*@__PURE__*/ new Vector3();

const _box$4 = /*@__PURE__*/ new Box3();

// triangle centered vertices

const _v0$2 = /*@__PURE__*/ new Vector3();
const _v1$7$1 = /*@__PURE__*/ new Vector3();
const _v2$4$1 = /*@__PURE__*/ new Vector3();

// triangle edge vectors

const _f0 = /*@__PURE__*/ new Vector3();
const _f1$1 = /*@__PURE__*/ new Vector3();
const _f2$1 = /*@__PURE__*/ new Vector3();

const _center$1 = /*@__PURE__*/ new Vector3();
const _extents = /*@__PURE__*/ new Vector3();
const _triangleNormal = /*@__PURE__*/ new Vector3();
const _testAxis = /*@__PURE__*/ new Vector3();

function satForAxes( axes, v0, v1, v2, extents ) {

	for ( let i = 0, j = axes.length - 3; i <= j; i += 3 ) {

		_testAxis.fromArray( axes, i );
		// project the aabb onto the separating axis
		const r = extents.x * Math.abs( _testAxis.x ) + extents.y * Math.abs( _testAxis.y ) + extents.z * Math.abs( _testAxis.z );
		// project all 3 vertices of the triangle onto the separating axis
		const p0 = v0.dot( _testAxis );
		const p1 = v1.dot( _testAxis );
		const p2 = v2.dot( _testAxis );
		// actual test, basically see if either of the most extreme of the triangle points intersects r
		if ( Math.max( - Math.max( p0, p1, p2 ), Math.min( p0, p1, p2 ) ) > r ) {

			// points of the projected triangle are outside the projected half-length of the aabb
			// the axis is separating and we can exit
			return false;

		}

	}

	return true;

}

const _box$3 = /*@__PURE__*/ new Box3();
const _v1$6$1 = /*@__PURE__*/ new Vector3();
const _v2$3$1 = /*@__PURE__*/ new Vector3();

class Sphere {

	constructor( center = new Vector3(), radius = - 1 ) {

		this.isSphere = true;

		this.center = center;
		this.radius = radius;

	}

	set( center, radius ) {

		this.center.copy( center );
		this.radius = radius;

		return this;

	}

	setFromPoints( points, optionalCenter ) {

		const center = this.center;

		if ( optionalCenter !== undefined ) {

			center.copy( optionalCenter );

		} else {

			_box$3.setFromPoints( points ).getCenter( center );

		}

		let maxRadiusSq = 0;

		for ( let i = 0, il = points.length; i < il; i ++ ) {

			maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( points[ i ] ) );

		}

		this.radius = Math.sqrt( maxRadiusSq );

		return this;

	}

	copy( sphere ) {

		this.center.copy( sphere.center );
		this.radius = sphere.radius;

		return this;

	}

	isEmpty() {

		return ( this.radius < 0 );

	}

	makeEmpty() {

		this.center.set( 0, 0, 0 );
		this.radius = - 1;

		return this;

	}

	containsPoint( point ) {

		return ( point.distanceToSquared( this.center ) <= ( this.radius * this.radius ) );

	}

	distanceToPoint( point ) {

		return ( point.distanceTo( this.center ) - this.radius );

	}

	intersectsSphere( sphere ) {

		const radiusSum = this.radius + sphere.radius;

		return sphere.center.distanceToSquared( this.center ) <= ( radiusSum * radiusSum );

	}

	intersectsBox( box ) {

		return box.intersectsSphere( this );

	}

	intersectsPlane( plane ) {

		return Math.abs( plane.distanceToPoint( this.center ) ) <= this.radius;

	}

	clampPoint( point, target ) {

		const deltaLengthSq = this.center.distanceToSquared( point );

		target.copy( point );

		if ( deltaLengthSq > ( this.radius * this.radius ) ) {

			target.sub( this.center ).normalize();
			target.multiplyScalar( this.radius ).add( this.center );

		}

		return target;

	}

	getBoundingBox( target ) {

		if ( this.isEmpty() ) {

			// Empty sphere produces empty bounding box
			target.makeEmpty();
			return target;

		}

		target.set( this.center, this.center );
		target.expandByScalar( this.radius );

		return target;

	}

	applyMatrix4( matrix ) {

		this.center.applyMatrix4( matrix );
		this.radius = this.radius * matrix.getMaxScaleOnAxis();

		return this;

	}

	translate( offset ) {

		this.center.add( offset );

		return this;

	}

	expandByPoint( point ) {

		if ( this.isEmpty() ) {

			this.center.copy( point );

			this.radius = 0;

			return this;

		}

		_v1$6$1.subVectors( point, this.center );

		const lengthSq = _v1$6$1.lengthSq();

		if ( lengthSq > ( this.radius * this.radius ) ) {

			// calculate the minimal sphere

			const length = Math.sqrt( lengthSq );

			const delta = ( length - this.radius ) * 0.5;

			this.center.addScaledVector( _v1$6$1, delta / length );

			this.radius += delta;

		}

		return this;

	}

	union( sphere ) {

		if ( sphere.isEmpty() ) {

			return this;

		}

		if ( this.isEmpty() ) {

			this.copy( sphere );

			return this;

		}

		if ( this.center.equals( sphere.center ) === true ) {

			 this.radius = Math.max( this.radius, sphere.radius );

		} else {

			_v2$3$1.subVectors( sphere.center, this.center ).setLength( sphere.radius );

			this.expandByPoint( _v1$6$1.copy( sphere.center ).add( _v2$3$1 ) );

			this.expandByPoint( _v1$6$1.copy( sphere.center ).sub( _v2$3$1 ) );

		}

		return this;

	}

	equals( sphere ) {

		return sphere.center.equals( this.center ) && ( sphere.radius === this.radius );

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

const _vector$a = /*@__PURE__*/ new Vector3();
const _segCenter = /*@__PURE__*/ new Vector3();
const _segDir = /*@__PURE__*/ new Vector3();
const _diff = /*@__PURE__*/ new Vector3();

const _edge1 = /*@__PURE__*/ new Vector3();
const _edge2 = /*@__PURE__*/ new Vector3();
const _normal$1 = /*@__PURE__*/ new Vector3();

class Ray {

	constructor( origin = new Vector3(), direction = new Vector3( 0, 0, - 1 ) ) {

		this.origin = origin;
		this.direction = direction;

	}

	set( origin, direction ) {

		this.origin.copy( origin );
		this.direction.copy( direction );

		return this;

	}

	copy( ray ) {

		this.origin.copy( ray.origin );
		this.direction.copy( ray.direction );

		return this;

	}

	at( t, target ) {

		return target.copy( this.origin ).addScaledVector( this.direction, t );

	}

	lookAt( v ) {

		this.direction.copy( v ).sub( this.origin ).normalize();

		return this;

	}

	recast( t ) {

		this.origin.copy( this.at( t, _vector$a ) );

		return this;

	}

	closestPointToPoint( point, target ) {

		target.subVectors( point, this.origin );

		const directionDistance = target.dot( this.direction );

		if ( directionDistance < 0 ) {

			return target.copy( this.origin );

		}

		return target.copy( this.origin ).addScaledVector( this.direction, directionDistance );

	}

	distanceToPoint( point ) {

		return Math.sqrt( this.distanceSqToPoint( point ) );

	}

	distanceSqToPoint( point ) {

		const directionDistance = _vector$a.subVectors( point, this.origin ).dot( this.direction );

		// point behind the ray

		if ( directionDistance < 0 ) {

			return this.origin.distanceToSquared( point );

		}

		_vector$a.copy( this.origin ).addScaledVector( this.direction, directionDistance );

		return _vector$a.distanceToSquared( point );

	}

	distanceSqToSegment( v0, v1, optionalPointOnRay, optionalPointOnSegment ) {

		// from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
		// It returns the min distance between the ray and the segment
		// defined by v0 and v1
		// It can also set two optional targets :
		// - The closest point on the ray
		// - The closest point on the segment

		_segCenter.copy( v0 ).add( v1 ).multiplyScalar( 0.5 );
		_segDir.copy( v1 ).sub( v0 ).normalize();
		_diff.copy( this.origin ).sub( _segCenter );

		const segExtent = v0.distanceTo( v1 ) * 0.5;
		const a01 = - this.direction.dot( _segDir );
		const b0 = _diff.dot( this.direction );
		const b1 = - _diff.dot( _segDir );
		const c = _diff.lengthSq();
		const det = Math.abs( 1 - a01 * a01 );
		let s0, s1, sqrDist, extDet;

		if ( det > 0 ) {

			// The ray and segment are not parallel.

			s0 = a01 * b1 - b0;
			s1 = a01 * b0 - b1;
			extDet = segExtent * det;

			if ( s0 >= 0 ) {

				if ( s1 >= - extDet ) {

					if ( s1 <= extDet ) {

						// region 0
						// Minimum at interior points of ray and segment.

						const invDet = 1 / det;
						s0 *= invDet;
						s1 *= invDet;
						sqrDist = s0 * ( s0 + a01 * s1 + 2 * b0 ) + s1 * ( a01 * s0 + s1 + 2 * b1 ) + c;

					} else {

						// region 1

						s1 = segExtent;
						s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
						sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

					}

				} else {

					// region 5

					s1 = - segExtent;
					s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
					sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

				}

			} else {

				if ( s1 <= - extDet ) {

					// region 4

					s0 = Math.max( 0, - ( - a01 * segExtent + b0 ) );
					s1 = ( s0 > 0 ) ? - segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
					sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

				} else if ( s1 <= extDet ) {

					// region 3

					s0 = 0;
					s1 = Math.min( Math.max( - segExtent, - b1 ), segExtent );
					sqrDist = s1 * ( s1 + 2 * b1 ) + c;

				} else {

					// region 2

					s0 = Math.max( 0, - ( a01 * segExtent + b0 ) );
					s1 = ( s0 > 0 ) ? segExtent : Math.min( Math.max( - segExtent, - b1 ), segExtent );
					sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

				}

			}

		} else {

			// Ray and segment are parallel.

			s1 = ( a01 > 0 ) ? - segExtent : segExtent;
			s0 = Math.max( 0, - ( a01 * s1 + b0 ) );
			sqrDist = - s0 * s0 + s1 * ( s1 + 2 * b1 ) + c;

		}

		if ( optionalPointOnRay ) {

			optionalPointOnRay.copy( this.origin ).addScaledVector( this.direction, s0 );

		}

		if ( optionalPointOnSegment ) {

			optionalPointOnSegment.copy( _segCenter ).addScaledVector( _segDir, s1 );

		}

		return sqrDist;

	}

	intersectSphere( sphere, target ) {

		_vector$a.subVectors( sphere.center, this.origin );
		const tca = _vector$a.dot( this.direction );
		const d2 = _vector$a.dot( _vector$a ) - tca * tca;
		const radius2 = sphere.radius * sphere.radius;

		if ( d2 > radius2 ) return null;

		const thc = Math.sqrt( radius2 - d2 );

		// t0 = first intersect point - entrance on front of sphere
		const t0 = tca - thc;

		// t1 = second intersect point - exit point on back of sphere
		const t1 = tca + thc;

		// test to see if t1 is behind the ray - if so, return null
		if ( t1 < 0 ) return null;

		// test to see if t0 is behind the ray:
		// if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
		// in order to always return an intersect point that is in front of the ray.
		if ( t0 < 0 ) return this.at( t1, target );

		// else t0 is in front of the ray, so return the first collision point scaled by t0
		return this.at( t0, target );

	}

	intersectsSphere( sphere ) {

		return this.distanceSqToPoint( sphere.center ) <= ( sphere.radius * sphere.radius );

	}

	distanceToPlane( plane ) {

		const denominator = plane.normal.dot( this.direction );

		if ( denominator === 0 ) {

			// line is coplanar, return origin
			if ( plane.distanceToPoint( this.origin ) === 0 ) {

				return 0;

			}

			// Null is preferable to undefined since undefined means.... it is undefined

			return null;

		}

		const t = - ( this.origin.dot( plane.normal ) + plane.constant ) / denominator;

		// Return if the ray never intersects the plane

		return t >= 0 ? t : null;

	}

	intersectPlane( plane, target ) {

		const t = this.distanceToPlane( plane );

		if ( t === null ) {

			return null;

		}

		return this.at( t, target );

	}

	intersectsPlane( plane ) {

		// check if the ray lies on the plane first

		const distToPoint = plane.distanceToPoint( this.origin );

		if ( distToPoint === 0 ) {

			return true;

		}

		const denominator = plane.normal.dot( this.direction );

		if ( denominator * distToPoint < 0 ) {

			return true;

		}

		// ray origin is behind the plane (and is pointing behind it)

		return false;

	}

	intersectBox( box, target ) {

		let tmin, tmax, tymin, tymax, tzmin, tzmax;

		const invdirx = 1 / this.direction.x,
			invdiry = 1 / this.direction.y,
			invdirz = 1 / this.direction.z;

		const origin = this.origin;

		if ( invdirx >= 0 ) {

			tmin = ( box.min.x - origin.x ) * invdirx;
			tmax = ( box.max.x - origin.x ) * invdirx;

		} else {

			tmin = ( box.max.x - origin.x ) * invdirx;
			tmax = ( box.min.x - origin.x ) * invdirx;

		}

		if ( invdiry >= 0 ) {

			tymin = ( box.min.y - origin.y ) * invdiry;
			tymax = ( box.max.y - origin.y ) * invdiry;

		} else {

			tymin = ( box.max.y - origin.y ) * invdiry;
			tymax = ( box.min.y - origin.y ) * invdiry;

		}

		if ( ( tmin > tymax ) || ( tymin > tmax ) ) return null;

		if ( tymin > tmin || isNaN( tmin ) ) tmin = tymin;

		if ( tymax < tmax || isNaN( tmax ) ) tmax = tymax;

		if ( invdirz >= 0 ) {

			tzmin = ( box.min.z - origin.z ) * invdirz;
			tzmax = ( box.max.z - origin.z ) * invdirz;

		} else {

			tzmin = ( box.max.z - origin.z ) * invdirz;
			tzmax = ( box.min.z - origin.z ) * invdirz;

		}

		if ( ( tmin > tzmax ) || ( tzmin > tmax ) ) return null;

		if ( tzmin > tmin || tmin !== tmin ) tmin = tzmin;

		if ( tzmax < tmax || tmax !== tmax ) tmax = tzmax;

		//return point closest to the ray (positive side)

		if ( tmax < 0 ) return null;

		return this.at( tmin >= 0 ? tmin : tmax, target );

	}

	intersectsBox( box ) {

		return this.intersectBox( box, _vector$a ) !== null;

	}

	intersectTriangle( a, b, c, backfaceCulling, target ) {

		// Compute the offset origin, edges, and normal.

		// from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h

		_edge1.subVectors( b, a );
		_edge2.subVectors( c, a );
		_normal$1.crossVectors( _edge1, _edge2 );

		// Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
		// E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
		//   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
		//   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
		//   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
		let DdN = this.direction.dot( _normal$1 );
		let sign;

		if ( DdN > 0 ) {

			if ( backfaceCulling ) return null;
			sign = 1;

		} else if ( DdN < 0 ) {

			sign = - 1;
			DdN = - DdN;

		} else {

			return null;

		}

		_diff.subVectors( this.origin, a );
		const DdQxE2 = sign * this.direction.dot( _edge2.crossVectors( _diff, _edge2 ) );

		// b1 < 0, no intersection
		if ( DdQxE2 < 0 ) {

			return null;

		}

		const DdE1xQ = sign * this.direction.dot( _edge1.cross( _diff ) );

		// b2 < 0, no intersection
		if ( DdE1xQ < 0 ) {

			return null;

		}

		// b1+b2 > 1, no intersection
		if ( DdQxE2 + DdE1xQ > DdN ) {

			return null;

		}

		// Line intersects triangle, check if ray does.
		const QdN = - sign * _diff.dot( _normal$1 );

		// t < 0, no intersection
		if ( QdN < 0 ) {

			return null;

		}

		// Ray intersects triangle.
		return this.at( QdN / DdN, target );

	}

	applyMatrix4( matrix4 ) {

		this.origin.applyMatrix4( matrix4 );
		this.direction.transformDirection( matrix4 );

		return this;

	}

	equals( ray ) {

		return ray.origin.equals( this.origin ) && ray.direction.equals( this.direction );

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

class Matrix4 {

	constructor( n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44 ) {

		Matrix4.prototype.isMatrix4 = true;

		this.elements = [

			1, 0, 0, 0,
			0, 1, 0, 0,
			0, 0, 1, 0,
			0, 0, 0, 1

		];

		if ( n11 !== undefined ) {

			this.set( n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44 );

		}

	}

	set( n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44 ) {

		const te = this.elements;

		te[ 0 ] = n11; te[ 4 ] = n12; te[ 8 ] = n13; te[ 12 ] = n14;
		te[ 1 ] = n21; te[ 5 ] = n22; te[ 9 ] = n23; te[ 13 ] = n24;
		te[ 2 ] = n31; te[ 6 ] = n32; te[ 10 ] = n33; te[ 14 ] = n34;
		te[ 3 ] = n41; te[ 7 ] = n42; te[ 11 ] = n43; te[ 15 ] = n44;

		return this;

	}

	identity() {

		this.set(

			1, 0, 0, 0,
			0, 1, 0, 0,
			0, 0, 1, 0,
			0, 0, 0, 1

		);

		return this;

	}

	clone() {

		return new Matrix4().fromArray( this.elements );

	}

	copy( m ) {

		const te = this.elements;
		const me = m.elements;

		te[ 0 ] = me[ 0 ]; te[ 1 ] = me[ 1 ]; te[ 2 ] = me[ 2 ]; te[ 3 ] = me[ 3 ];
		te[ 4 ] = me[ 4 ]; te[ 5 ] = me[ 5 ]; te[ 6 ] = me[ 6 ]; te[ 7 ] = me[ 7 ];
		te[ 8 ] = me[ 8 ]; te[ 9 ] = me[ 9 ]; te[ 10 ] = me[ 10 ]; te[ 11 ] = me[ 11 ];
		te[ 12 ] = me[ 12 ]; te[ 13 ] = me[ 13 ]; te[ 14 ] = me[ 14 ]; te[ 15 ] = me[ 15 ];

		return this;

	}

	copyPosition( m ) {

		const te = this.elements, me = m.elements;

		te[ 12 ] = me[ 12 ];
		te[ 13 ] = me[ 13 ];
		te[ 14 ] = me[ 14 ];

		return this;

	}

	setFromMatrix3( m ) {

		const me = m.elements;

		this.set(

			me[ 0 ], me[ 3 ], me[ 6 ], 0,
			me[ 1 ], me[ 4 ], me[ 7 ], 0,
			me[ 2 ], me[ 5 ], me[ 8 ], 0,
			0, 0, 0, 1

		);

		return this;

	}

	extractBasis( xAxis, yAxis, zAxis ) {

		xAxis.setFromMatrixColumn( this, 0 );
		yAxis.setFromMatrixColumn( this, 1 );
		zAxis.setFromMatrixColumn( this, 2 );

		return this;

	}

	makeBasis( xAxis, yAxis, zAxis ) {

		this.set(
			xAxis.x, yAxis.x, zAxis.x, 0,
			xAxis.y, yAxis.y, zAxis.y, 0,
			xAxis.z, yAxis.z, zAxis.z, 0,
			0, 0, 0, 1
		);

		return this;

	}

	extractRotation( m ) {

		// this method does not support reflection matrices

		const te = this.elements;
		const me = m.elements;

		const scaleX = 1 / _v1$5$1.setFromMatrixColumn( m, 0 ).length();
		const scaleY = 1 / _v1$5$1.setFromMatrixColumn( m, 1 ).length();
		const scaleZ = 1 / _v1$5$1.setFromMatrixColumn( m, 2 ).length();

		te[ 0 ] = me[ 0 ] * scaleX;
		te[ 1 ] = me[ 1 ] * scaleX;
		te[ 2 ] = me[ 2 ] * scaleX;
		te[ 3 ] = 0;

		te[ 4 ] = me[ 4 ] * scaleY;
		te[ 5 ] = me[ 5 ] * scaleY;
		te[ 6 ] = me[ 6 ] * scaleY;
		te[ 7 ] = 0;

		te[ 8 ] = me[ 8 ] * scaleZ;
		te[ 9 ] = me[ 9 ] * scaleZ;
		te[ 10 ] = me[ 10 ] * scaleZ;
		te[ 11 ] = 0;

		te[ 12 ] = 0;
		te[ 13 ] = 0;
		te[ 14 ] = 0;
		te[ 15 ] = 1;

		return this;

	}

	makeRotationFromEuler( euler ) {

		const te = this.elements;

		const x = euler.x, y = euler.y, z = euler.z;
		const a = Math.cos( x ), b = Math.sin( x );
		const c = Math.cos( y ), d = Math.sin( y );
		const e = Math.cos( z ), f = Math.sin( z );

		if ( euler.order === 'XYZ' ) {

			const ae = a * e, af = a * f, be = b * e, bf = b * f;

			te[ 0 ] = c * e;
			te[ 4 ] = - c * f;
			te[ 8 ] = d;

			te[ 1 ] = af + be * d;
			te[ 5 ] = ae - bf * d;
			te[ 9 ] = - b * c;

			te[ 2 ] = bf - ae * d;
			te[ 6 ] = be + af * d;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'YXZ' ) {

			const ce = c * e, cf = c * f, de = d * e, df = d * f;

			te[ 0 ] = ce + df * b;
			te[ 4 ] = de * b - cf;
			te[ 8 ] = a * d;

			te[ 1 ] = a * f;
			te[ 5 ] = a * e;
			te[ 9 ] = - b;

			te[ 2 ] = cf * b - de;
			te[ 6 ] = df + ce * b;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'ZXY' ) {

			const ce = c * e, cf = c * f, de = d * e, df = d * f;

			te[ 0 ] = ce - df * b;
			te[ 4 ] = - a * f;
			te[ 8 ] = de + cf * b;

			te[ 1 ] = cf + de * b;
			te[ 5 ] = a * e;
			te[ 9 ] = df - ce * b;

			te[ 2 ] = - a * d;
			te[ 6 ] = b;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'ZYX' ) {

			const ae = a * e, af = a * f, be = b * e, bf = b * f;

			te[ 0 ] = c * e;
			te[ 4 ] = be * d - af;
			te[ 8 ] = ae * d + bf;

			te[ 1 ] = c * f;
			te[ 5 ] = bf * d + ae;
			te[ 9 ] = af * d - be;

			te[ 2 ] = - d;
			te[ 6 ] = b * c;
			te[ 10 ] = a * c;

		} else if ( euler.order === 'YZX' ) {

			const ac = a * c, ad = a * d, bc = b * c, bd = b * d;

			te[ 0 ] = c * e;
			te[ 4 ] = bd - ac * f;
			te[ 8 ] = bc * f + ad;

			te[ 1 ] = f;
			te[ 5 ] = a * e;
			te[ 9 ] = - b * e;

			te[ 2 ] = - d * e;
			te[ 6 ] = ad * f + bc;
			te[ 10 ] = ac - bd * f;

		} else if ( euler.order === 'XZY' ) {

			const ac = a * c, ad = a * d, bc = b * c, bd = b * d;

			te[ 0 ] = c * e;
			te[ 4 ] = - f;
			te[ 8 ] = d * e;

			te[ 1 ] = ac * f + bd;
			te[ 5 ] = a * e;
			te[ 9 ] = ad * f - bc;

			te[ 2 ] = bc * f - ad;
			te[ 6 ] = b * e;
			te[ 10 ] = bd * f + ac;

		}

		// bottom row
		te[ 3 ] = 0;
		te[ 7 ] = 0;
		te[ 11 ] = 0;

		// last column
		te[ 12 ] = 0;
		te[ 13 ] = 0;
		te[ 14 ] = 0;
		te[ 15 ] = 1;

		return this;

	}

	makeRotationFromQuaternion( q ) {

		return this.compose( _zero, q, _one );

	}

	lookAt( eye, target, up ) {

		const te = this.elements;

		_z$4.subVectors( eye, target );

		if ( _z$4.lengthSq() === 0 ) {

			// eye and target are in the same position

			_z$4.z = 1;

		}

		_z$4.normalize();
		_x$2.crossVectors( up, _z$4 );

		if ( _x$2.lengthSq() === 0 ) {

			// up and z are parallel

			if ( Math.abs( up.z ) === 1 ) {

				_z$4.x += 0.0001;

			} else {

				_z$4.z += 0.0001;

			}

			_z$4.normalize();
			_x$2.crossVectors( up, _z$4 );

		}

		_x$2.normalize();
		_y$2.crossVectors( _z$4, _x$2 );

		te[ 0 ] = _x$2.x; te[ 4 ] = _y$2.x; te[ 8 ] = _z$4.x;
		te[ 1 ] = _x$2.y; te[ 5 ] = _y$2.y; te[ 9 ] = _z$4.y;
		te[ 2 ] = _x$2.z; te[ 6 ] = _y$2.z; te[ 10 ] = _z$4.z;

		return this;

	}

	multiply( m ) {

		return this.multiplyMatrices( this, m );

	}

	premultiply( m ) {

		return this.multiplyMatrices( m, this );

	}

	multiplyMatrices( a, b ) {

		const ae = a.elements;
		const be = b.elements;
		const te = this.elements;

		const a11 = ae[ 0 ], a12 = ae[ 4 ], a13 = ae[ 8 ], a14 = ae[ 12 ];
		const a21 = ae[ 1 ], a22 = ae[ 5 ], a23 = ae[ 9 ], a24 = ae[ 13 ];
		const a31 = ae[ 2 ], a32 = ae[ 6 ], a33 = ae[ 10 ], a34 = ae[ 14 ];
		const a41 = ae[ 3 ], a42 = ae[ 7 ], a43 = ae[ 11 ], a44 = ae[ 15 ];

		const b11 = be[ 0 ], b12 = be[ 4 ], b13 = be[ 8 ], b14 = be[ 12 ];
		const b21 = be[ 1 ], b22 = be[ 5 ], b23 = be[ 9 ], b24 = be[ 13 ];
		const b31 = be[ 2 ], b32 = be[ 6 ], b33 = be[ 10 ], b34 = be[ 14 ];
		const b41 = be[ 3 ], b42 = be[ 7 ], b43 = be[ 11 ], b44 = be[ 15 ];

		te[ 0 ] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
		te[ 4 ] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
		te[ 8 ] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
		te[ 12 ] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;

		te[ 1 ] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
		te[ 5 ] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
		te[ 9 ] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
		te[ 13 ] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;

		te[ 2 ] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
		te[ 6 ] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
		te[ 10 ] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
		te[ 14 ] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;

		te[ 3 ] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
		te[ 7 ] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
		te[ 11 ] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
		te[ 15 ] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;

		return this;

	}

	multiplyScalar( s ) {

		const te = this.elements;

		te[ 0 ] *= s; te[ 4 ] *= s; te[ 8 ] *= s; te[ 12 ] *= s;
		te[ 1 ] *= s; te[ 5 ] *= s; te[ 9 ] *= s; te[ 13 ] *= s;
		te[ 2 ] *= s; te[ 6 ] *= s; te[ 10 ] *= s; te[ 14 ] *= s;
		te[ 3 ] *= s; te[ 7 ] *= s; te[ 11 ] *= s; te[ 15 ] *= s;

		return this;

	}

	determinant() {

		const te = this.elements;

		const n11 = te[ 0 ], n12 = te[ 4 ], n13 = te[ 8 ], n14 = te[ 12 ];
		const n21 = te[ 1 ], n22 = te[ 5 ], n23 = te[ 9 ], n24 = te[ 13 ];
		const n31 = te[ 2 ], n32 = te[ 6 ], n33 = te[ 10 ], n34 = te[ 14 ];
		const n41 = te[ 3 ], n42 = te[ 7 ], n43 = te[ 11 ], n44 = te[ 15 ];

		//TODO: make this more efficient
		//( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )

		return (
			n41 * (
				+ n14 * n23 * n32
				 - n13 * n24 * n32
				 - n14 * n22 * n33
				 + n12 * n24 * n33
				 + n13 * n22 * n34
				 - n12 * n23 * n34
			) +
			n42 * (
				+ n11 * n23 * n34
				 - n11 * n24 * n33
				 + n14 * n21 * n33
				 - n13 * n21 * n34
				 + n13 * n24 * n31
				 - n14 * n23 * n31
			) +
			n43 * (
				+ n11 * n24 * n32
				 - n11 * n22 * n34
				 - n14 * n21 * n32
				 + n12 * n21 * n34
				 + n14 * n22 * n31
				 - n12 * n24 * n31
			) +
			n44 * (
				- n13 * n22 * n31
				 - n11 * n23 * n32
				 + n11 * n22 * n33
				 + n13 * n21 * n32
				 - n12 * n21 * n33
				 + n12 * n23 * n31
			)

		);

	}

	transpose() {

		const te = this.elements;
		let tmp;

		tmp = te[ 1 ]; te[ 1 ] = te[ 4 ]; te[ 4 ] = tmp;
		tmp = te[ 2 ]; te[ 2 ] = te[ 8 ]; te[ 8 ] = tmp;
		tmp = te[ 6 ]; te[ 6 ] = te[ 9 ]; te[ 9 ] = tmp;

		tmp = te[ 3 ]; te[ 3 ] = te[ 12 ]; te[ 12 ] = tmp;
		tmp = te[ 7 ]; te[ 7 ] = te[ 13 ]; te[ 13 ] = tmp;
		tmp = te[ 11 ]; te[ 11 ] = te[ 14 ]; te[ 14 ] = tmp;

		return this;

	}

	setPosition( x, y, z ) {

		const te = this.elements;

		if ( x.isVector3 ) {

			te[ 12 ] = x.x;
			te[ 13 ] = x.y;
			te[ 14 ] = x.z;

		} else {

			te[ 12 ] = x;
			te[ 13 ] = y;
			te[ 14 ] = z;

		}

		return this;

	}

	invert() {

		// based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
		const te = this.elements,

			n11 = te[ 0 ], n21 = te[ 1 ], n31 = te[ 2 ], n41 = te[ 3 ],
			n12 = te[ 4 ], n22 = te[ 5 ], n32 = te[ 6 ], n42 = te[ 7 ],
			n13 = te[ 8 ], n23 = te[ 9 ], n33 = te[ 10 ], n43 = te[ 11 ],
			n14 = te[ 12 ], n24 = te[ 13 ], n34 = te[ 14 ], n44 = te[ 15 ],

			t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44,
			t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44,
			t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44,
			t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;

		const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;

		if ( det === 0 ) return this.set( 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 );

		const detInv = 1 / det;

		te[ 0 ] = t11 * detInv;
		te[ 1 ] = ( n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44 ) * detInv;
		te[ 2 ] = ( n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44 ) * detInv;
		te[ 3 ] = ( n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43 ) * detInv;

		te[ 4 ] = t12 * detInv;
		te[ 5 ] = ( n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44 ) * detInv;
		te[ 6 ] = ( n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44 ) * detInv;
		te[ 7 ] = ( n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43 ) * detInv;

		te[ 8 ] = t13 * detInv;
		te[ 9 ] = ( n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44 ) * detInv;
		te[ 10 ] = ( n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44 ) * detInv;
		te[ 11 ] = ( n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43 ) * detInv;

		te[ 12 ] = t14 * detInv;
		te[ 13 ] = ( n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34 ) * detInv;
		te[ 14 ] = ( n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34 ) * detInv;
		te[ 15 ] = ( n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33 ) * detInv;

		return this;

	}

	scale( v ) {

		const te = this.elements;
		const x = v.x, y = v.y, z = v.z;

		te[ 0 ] *= x; te[ 4 ] *= y; te[ 8 ] *= z;
		te[ 1 ] *= x; te[ 5 ] *= y; te[ 9 ] *= z;
		te[ 2 ] *= x; te[ 6 ] *= y; te[ 10 ] *= z;
		te[ 3 ] *= x; te[ 7 ] *= y; te[ 11 ] *= z;

		return this;

	}

	getMaxScaleOnAxis() {

		const te = this.elements;

		const scaleXSq = te[ 0 ] * te[ 0 ] + te[ 1 ] * te[ 1 ] + te[ 2 ] * te[ 2 ];
		const scaleYSq = te[ 4 ] * te[ 4 ] + te[ 5 ] * te[ 5 ] + te[ 6 ] * te[ 6 ];
		const scaleZSq = te[ 8 ] * te[ 8 ] + te[ 9 ] * te[ 9 ] + te[ 10 ] * te[ 10 ];

		return Math.sqrt( Math.max( scaleXSq, scaleYSq, scaleZSq ) );

	}

	makeTranslation( x, y, z ) {

		if ( x.isVector3 ) {

			this.set(

				1, 0, 0, x.x,
				0, 1, 0, x.y,
				0, 0, 1, x.z,
				0, 0, 0, 1

			);

		} else {

			this.set(

				1, 0, 0, x,
				0, 1, 0, y,
				0, 0, 1, z,
				0, 0, 0, 1

			);

		}

		return this;

	}

	makeRotationX( theta ) {

		const c = Math.cos( theta ), s = Math.sin( theta );

		this.set(

			1, 0, 0, 0,
			0, c, - s, 0,
			0, s, c, 0,
			0, 0, 0, 1

		);

		return this;

	}

	makeRotationY( theta ) {

		const c = Math.cos( theta ), s = Math.sin( theta );

		this.set(

			 c, 0, s, 0,
			 0, 1, 0, 0,
			- s, 0, c, 0,
			 0, 0, 0, 1

		);

		return this;

	}

	makeRotationZ( theta ) {

		const c = Math.cos( theta ), s = Math.sin( theta );

		this.set(

			c, - s, 0, 0,
			s, c, 0, 0,
			0, 0, 1, 0,
			0, 0, 0, 1

		);

		return this;

	}

	makeRotationAxis( axis, angle ) {

		// Based on http://www.gamedev.net/reference/articles/article1199.asp

		const c = Math.cos( angle );
		const s = Math.sin( angle );
		const t = 1 - c;
		const x = axis.x, y = axis.y, z = axis.z;
		const tx = t * x, ty = t * y;

		this.set(

			tx * x + c, tx * y - s * z, tx * z + s * y, 0,
			tx * y + s * z, ty * y + c, ty * z - s * x, 0,
			tx * z - s * y, ty * z + s * x, t * z * z + c, 0,
			0, 0, 0, 1

		);

		return this;

	}

	makeScale( x, y, z ) {

		this.set(

			x, 0, 0, 0,
			0, y, 0, 0,
			0, 0, z, 0,
			0, 0, 0, 1

		);

		return this;

	}

	makeShear( xy, xz, yx, yz, zx, zy ) {

		this.set(

			1, yx, zx, 0,
			xy, 1, zy, 0,
			xz, yz, 1, 0,
			0, 0, 0, 1

		);

		return this;

	}

	compose( position, quaternion, scale ) {

		const te = this.elements;

		const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
		const x2 = x + x,	y2 = y + y, z2 = z + z;
		const xx = x * x2, xy = x * y2, xz = x * z2;
		const yy = y * y2, yz = y * z2, zz = z * z2;
		const wx = w * x2, wy = w * y2, wz = w * z2;

		const sx = scale.x, sy = scale.y, sz = scale.z;

		te[ 0 ] = ( 1 - ( yy + zz ) ) * sx;
		te[ 1 ] = ( xy + wz ) * sx;
		te[ 2 ] = ( xz - wy ) * sx;
		te[ 3 ] = 0;

		te[ 4 ] = ( xy - wz ) * sy;
		te[ 5 ] = ( 1 - ( xx + zz ) ) * sy;
		te[ 6 ] = ( yz + wx ) * sy;
		te[ 7 ] = 0;

		te[ 8 ] = ( xz + wy ) * sz;
		te[ 9 ] = ( yz - wx ) * sz;
		te[ 10 ] = ( 1 - ( xx + yy ) ) * sz;
		te[ 11 ] = 0;

		te[ 12 ] = position.x;
		te[ 13 ] = position.y;
		te[ 14 ] = position.z;
		te[ 15 ] = 1;

		return this;

	}

	decompose( position, quaternion, scale ) {

		const te = this.elements;

		let sx = _v1$5$1.set( te[ 0 ], te[ 1 ], te[ 2 ] ).length();
		const sy = _v1$5$1.set( te[ 4 ], te[ 5 ], te[ 6 ] ).length();
		const sz = _v1$5$1.set( te[ 8 ], te[ 9 ], te[ 10 ] ).length();

		// if determine is negative, we need to invert one scale
		const det = this.determinant();
		if ( det < 0 ) sx = - sx;

		position.x = te[ 12 ];
		position.y = te[ 13 ];
		position.z = te[ 14 ];

		// scale the rotation part
		_m1$4.copy( this );

		const invSX = 1 / sx;
		const invSY = 1 / sy;
		const invSZ = 1 / sz;

		_m1$4.elements[ 0 ] *= invSX;
		_m1$4.elements[ 1 ] *= invSX;
		_m1$4.elements[ 2 ] *= invSX;

		_m1$4.elements[ 4 ] *= invSY;
		_m1$4.elements[ 5 ] *= invSY;
		_m1$4.elements[ 6 ] *= invSY;

		_m1$4.elements[ 8 ] *= invSZ;
		_m1$4.elements[ 9 ] *= invSZ;
		_m1$4.elements[ 10 ] *= invSZ;

		quaternion.setFromRotationMatrix( _m1$4 );

		scale.x = sx;
		scale.y = sy;
		scale.z = sz;

		return this;

	}

	makePerspective( left, right, top, bottom, near, far, coordinateSystem = WebGLCoordinateSystem ) {

		const te = this.elements;
		const x = 2 * near / ( right - left );
		const y = 2 * near / ( top - bottom );

		const a = ( right + left ) / ( right - left );
		const b = ( top + bottom ) / ( top - bottom );

		let c, d;

		if ( coordinateSystem === WebGLCoordinateSystem ) {

			c = - ( far + near ) / ( far - near );
			d = ( - 2 * far * near ) / ( far - near );

		} else if ( coordinateSystem === WebGPUCoordinateSystem ) {

			c = - far / ( far - near );
			d = ( - far * near ) / ( far - near );

		} else {

			throw new Error( 'THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + coordinateSystem );

		}

		te[ 0 ] = x;	te[ 4 ] = 0;	te[ 8 ] = a; 	te[ 12 ] = 0;
		te[ 1 ] = 0;	te[ 5 ] = y;	te[ 9 ] = b; 	te[ 13 ] = 0;
		te[ 2 ] = 0;	te[ 6 ] = 0;	te[ 10 ] = c; 	te[ 14 ] = d;
		te[ 3 ] = 0;	te[ 7 ] = 0;	te[ 11 ] = - 1;	te[ 15 ] = 0;

		return this;

	}

	makeOrthographic( left, right, top, bottom, near, far, coordinateSystem = WebGLCoordinateSystem ) {

		const te = this.elements;
		const w = 1.0 / ( right - left );
		const h = 1.0 / ( top - bottom );
		const p = 1.0 / ( far - near );

		const x = ( right + left ) * w;
		const y = ( top + bottom ) * h;

		let z, zInv;

		if ( coordinateSystem === WebGLCoordinateSystem ) {

			z = ( far + near ) * p;
			zInv = - 2 * p;

		} else if ( coordinateSystem === WebGPUCoordinateSystem ) {

			z = near * p;
			zInv = - 1 * p;

		} else {

			throw new Error( 'THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + coordinateSystem );

		}

		te[ 0 ] = 2 * w;	te[ 4 ] = 0;		te[ 8 ] = 0; 		te[ 12 ] = - x;
		te[ 1 ] = 0; 		te[ 5 ] = 2 * h;	te[ 9 ] = 0; 		te[ 13 ] = - y;
		te[ 2 ] = 0; 		te[ 6 ] = 0;		te[ 10 ] = zInv;	te[ 14 ] = - z;
		te[ 3 ] = 0; 		te[ 7 ] = 0;		te[ 11 ] = 0;		te[ 15 ] = 1;

		return this;

	}

	equals( matrix ) {

		const te = this.elements;
		const me = matrix.elements;

		for ( let i = 0; i < 16; i ++ ) {

			if ( te[ i ] !== me[ i ] ) return false;

		}

		return true;

	}

	fromArray( array, offset = 0 ) {

		for ( let i = 0; i < 16; i ++ ) {

			this.elements[ i ] = array[ i + offset ];

		}

		return this;

	}

	toArray( array = [], offset = 0 ) {

		const te = this.elements;

		array[ offset ] = te[ 0 ];
		array[ offset + 1 ] = te[ 1 ];
		array[ offset + 2 ] = te[ 2 ];
		array[ offset + 3 ] = te[ 3 ];

		array[ offset + 4 ] = te[ 4 ];
		array[ offset + 5 ] = te[ 5 ];
		array[ offset + 6 ] = te[ 6 ];
		array[ offset + 7 ] = te[ 7 ];

		array[ offset + 8 ] = te[ 8 ];
		array[ offset + 9 ] = te[ 9 ];
		array[ offset + 10 ] = te[ 10 ];
		array[ offset + 11 ] = te[ 11 ];

		array[ offset + 12 ] = te[ 12 ];
		array[ offset + 13 ] = te[ 13 ];
		array[ offset + 14 ] = te[ 14 ];
		array[ offset + 15 ] = te[ 15 ];

		return array;

	}

}

const _v1$5$1 = /*@__PURE__*/ new Vector3();
const _m1$4 = /*@__PURE__*/ new Matrix4();
const _zero = /*@__PURE__*/ new Vector3( 0, 0, 0 );
const _one = /*@__PURE__*/ new Vector3( 1, 1, 1 );
const _x$2 = /*@__PURE__*/ new Vector3();
const _y$2 = /*@__PURE__*/ new Vector3();
const _z$4 = /*@__PURE__*/ new Vector3();

const _matrix$2 = /*@__PURE__*/ new Matrix4();
const _quaternion$3 = /*@__PURE__*/ new Quaternion();

class Euler {

	constructor( x = 0, y = 0, z = 0, order = Euler.DEFAULT_ORDER ) {

		this.isEuler = true;

		this._x = x;
		this._y = y;
		this._z = z;
		this._order = order;

	}

	get x() {

		return this._x;

	}

	set x( value ) {

		this._x = value;
		this._onChangeCallback();

	}

	get y() {

		return this._y;

	}

	set y( value ) {

		this._y = value;
		this._onChangeCallback();

	}

	get z() {

		return this._z;

	}

	set z( value ) {

		this._z = value;
		this._onChangeCallback();

	}

	get order() {

		return this._order;

	}

	set order( value ) {

		this._order = value;
		this._onChangeCallback();

	}

	set( x, y, z, order = this._order ) {

		this._x = x;
		this._y = y;
		this._z = z;
		this._order = order;

		this._onChangeCallback();

		return this;

	}

	clone() {

		return new this.constructor( this._x, this._y, this._z, this._order );

	}

	copy( euler ) {

		this._x = euler._x;
		this._y = euler._y;
		this._z = euler._z;
		this._order = euler._order;

		this._onChangeCallback();

		return this;

	}

	setFromRotationMatrix( m, order = this._order, update = true ) {

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		const te = m.elements;
		const m11 = te[ 0 ], m12 = te[ 4 ], m13 = te[ 8 ];
		const m21 = te[ 1 ], m22 = te[ 5 ], m23 = te[ 9 ];
		const m31 = te[ 2 ], m32 = te[ 6 ], m33 = te[ 10 ];

		switch ( order ) {

			case 'XYZ':

				this._y = Math.asin( clamp( m13, - 1, 1 ) );

				if ( Math.abs( m13 ) < 0.9999999 ) {

					this._x = Math.atan2( - m23, m33 );
					this._z = Math.atan2( - m12, m11 );

				} else {

					this._x = Math.atan2( m32, m22 );
					this._z = 0;

				}

				break;

			case 'YXZ':

				this._x = Math.asin( - clamp( m23, - 1, 1 ) );

				if ( Math.abs( m23 ) < 0.9999999 ) {

					this._y = Math.atan2( m13, m33 );
					this._z = Math.atan2( m21, m22 );

				} else {

					this._y = Math.atan2( - m31, m11 );
					this._z = 0;

				}

				break;

			case 'ZXY':

				this._x = Math.asin( clamp( m32, - 1, 1 ) );

				if ( Math.abs( m32 ) < 0.9999999 ) {

					this._y = Math.atan2( - m31, m33 );
					this._z = Math.atan2( - m12, m22 );

				} else {

					this._y = 0;
					this._z = Math.atan2( m21, m11 );

				}

				break;

			case 'ZYX':

				this._y = Math.asin( - clamp( m31, - 1, 1 ) );

				if ( Math.abs( m31 ) < 0.9999999 ) {

					this._x = Math.atan2( m32, m33 );
					this._z = Math.atan2( m21, m11 );

				} else {

					this._x = 0;
					this._z = Math.atan2( - m12, m22 );

				}

				break;

			case 'YZX':

				this._z = Math.asin( clamp( m21, - 1, 1 ) );

				if ( Math.abs( m21 ) < 0.9999999 ) {

					this._x = Math.atan2( - m23, m22 );
					this._y = Math.atan2( - m31, m11 );

				} else {

					this._x = 0;
					this._y = Math.atan2( m13, m33 );

				}

				break;

			case 'XZY':

				this._z = Math.asin( - clamp( m12, - 1, 1 ) );

				if ( Math.abs( m12 ) < 0.9999999 ) {

					this._x = Math.atan2( m32, m22 );
					this._y = Math.atan2( m13, m11 );

				} else {

					this._x = Math.atan2( - m23, m33 );
					this._y = 0;

				}

				break;

			default:

				console.warn( 'THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order );

		}

		this._order = order;

		if ( update === true ) this._onChangeCallback();

		return this;

	}

	setFromQuaternion( q, order, update ) {

		_matrix$2.makeRotationFromQuaternion( q );

		return this.setFromRotationMatrix( _matrix$2, order, update );

	}

	setFromVector3( v, order = this._order ) {

		return this.set( v.x, v.y, v.z, order );

	}

	reorder( newOrder ) {

		// WARNING: this discards revolution information -bhouston

		_quaternion$3.setFromEuler( this );

		return this.setFromQuaternion( _quaternion$3, newOrder );

	}

	equals( euler ) {

		return ( euler._x === this._x ) && ( euler._y === this._y ) && ( euler._z === this._z ) && ( euler._order === this._order );

	}

	fromArray( array ) {

		this._x = array[ 0 ];
		this._y = array[ 1 ];
		this._z = array[ 2 ];
		if ( array[ 3 ] !== undefined ) this._order = array[ 3 ];

		this._onChangeCallback();

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this._x;
		array[ offset + 1 ] = this._y;
		array[ offset + 2 ] = this._z;
		array[ offset + 3 ] = this._order;

		return array;

	}

	_onChange( callback ) {

		this._onChangeCallback = callback;

		return this;

	}

	_onChangeCallback() {}

	*[ Symbol.iterator ]() {

		yield this._x;
		yield this._y;
		yield this._z;
		yield this._order;

	}

}

Euler.DEFAULT_ORDER = 'XYZ';

class Layers {

	constructor() {

		this.mask = 1 | 0;

	}

	set( channel ) {

		this.mask = ( 1 << channel | 0 ) >>> 0;

	}

	enable( channel ) {

		this.mask |= 1 << channel | 0;

	}

	enableAll() {

		this.mask = 0xffffffff | 0;

	}

	toggle( channel ) {

		this.mask ^= 1 << channel | 0;

	}

	disable( channel ) {

		this.mask &= ~ ( 1 << channel | 0 );

	}

	disableAll() {

		this.mask = 0;

	}

	test( layers ) {

		return ( this.mask & layers.mask ) !== 0;

	}

	isEnabled( channel ) {

		return ( this.mask & ( 1 << channel | 0 ) ) !== 0;

	}

}

let _object3DId = 0;

const _v1$4$1 = /*@__PURE__*/ new Vector3();
const _q1 = /*@__PURE__*/ new Quaternion();
const _m1$3 = /*@__PURE__*/ new Matrix4();
const _target = /*@__PURE__*/ new Vector3();

const _position$3 = /*@__PURE__*/ new Vector3();
const _scale$2 = /*@__PURE__*/ new Vector3();
const _quaternion$2 = /*@__PURE__*/ new Quaternion();

const _xAxis = /*@__PURE__*/ new Vector3( 1, 0, 0 );
const _yAxis = /*@__PURE__*/ new Vector3( 0, 1, 0 );
const _zAxis = /*@__PURE__*/ new Vector3( 0, 0, 1 );

const _addedEvent = { type: 'added' };
const _removedEvent = { type: 'removed' };

const _childaddedEvent = { type: 'childadded', child: null };
const _childremovedEvent = { type: 'childremoved', child: null };

class Object3D extends EventDispatcher$2 {

	constructor() {

		super();

		this.isObject3D = true;

		Object.defineProperty( this, 'id', { value: _object3DId ++ } );

		this.uuid = generateUUID();

		this.name = '';
		this.type = 'Object3D';

		this.parent = null;
		this.children = [];

		this.up = Object3D.DEFAULT_UP.clone();

		const position = new Vector3();
		const rotation = new Euler();
		const quaternion = new Quaternion();
		const scale = new Vector3( 1, 1, 1 );

		function onRotationChange() {

			quaternion.setFromEuler( rotation, false );

		}

		function onQuaternionChange() {

			rotation.setFromQuaternion( quaternion, undefined, false );

		}

		rotation._onChange( onRotationChange );
		quaternion._onChange( onQuaternionChange );

		Object.defineProperties( this, {
			position: {
				configurable: true,
				enumerable: true,
				value: position
			},
			rotation: {
				configurable: true,
				enumerable: true,
				value: rotation
			},
			quaternion: {
				configurable: true,
				enumerable: true,
				value: quaternion
			},
			scale: {
				configurable: true,
				enumerable: true,
				value: scale
			},
			modelViewMatrix: {
				value: new Matrix4()
			},
			normalMatrix: {
				value: new Matrix3()
			}
		} );

		this.matrix = new Matrix4();
		this.matrixWorld = new Matrix4();

		this.matrixAutoUpdate = Object3D.DEFAULT_MATRIX_AUTO_UPDATE;

		this.matrixWorldAutoUpdate = Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
		this.matrixWorldNeedsUpdate = false;

		this.layers = new Layers();
		this.visible = true;

		this.castShadow = false;
		this.receiveShadow = false;

		this.frustumCulled = true;
		this.renderOrder = 0;

		this.animations = [];

		this.userData = {};

	}

	onBeforeShadow( /* renderer, object, camera, shadowCamera, geometry, depthMaterial, group */ ) {}

	onAfterShadow( /* renderer, object, camera, shadowCamera, geometry, depthMaterial, group */ ) {}

	onBeforeRender( /* renderer, scene, camera, geometry, material, group */ ) {}

	onAfterRender( /* renderer, scene, camera, geometry, material, group */ ) {}

	applyMatrix4( matrix ) {

		if ( this.matrixAutoUpdate ) this.updateMatrix();

		this.matrix.premultiply( matrix );

		this.matrix.decompose( this.position, this.quaternion, this.scale );

	}

	applyQuaternion( q ) {

		this.quaternion.premultiply( q );

		return this;

	}

	setRotationFromAxisAngle( axis, angle ) {

		// assumes axis is normalized

		this.quaternion.setFromAxisAngle( axis, angle );

	}

	setRotationFromEuler( euler ) {

		this.quaternion.setFromEuler( euler, true );

	}

	setRotationFromMatrix( m ) {

		// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

		this.quaternion.setFromRotationMatrix( m );

	}

	setRotationFromQuaternion( q ) {

		// assumes q is normalized

		this.quaternion.copy( q );

	}

	rotateOnAxis( axis, angle ) {

		// rotate object on axis in object space
		// axis is assumed to be normalized

		_q1.setFromAxisAngle( axis, angle );

		this.quaternion.multiply( _q1 );

		return this;

	}

	rotateOnWorldAxis( axis, angle ) {

		// rotate object on axis in world space
		// axis is assumed to be normalized
		// method assumes no rotated parent

		_q1.setFromAxisAngle( axis, angle );

		this.quaternion.premultiply( _q1 );

		return this;

	}

	rotateX( angle ) {

		return this.rotateOnAxis( _xAxis, angle );

	}

	rotateY( angle ) {

		return this.rotateOnAxis( _yAxis, angle );

	}

	rotateZ( angle ) {

		return this.rotateOnAxis( _zAxis, angle );

	}

	translateOnAxis( axis, distance ) {

		// translate object by distance along axis in object space
		// axis is assumed to be normalized

		_v1$4$1.copy( axis ).applyQuaternion( this.quaternion );

		this.position.add( _v1$4$1.multiplyScalar( distance ) );

		return this;

	}

	translateX( distance ) {

		return this.translateOnAxis( _xAxis, distance );

	}

	translateY( distance ) {

		return this.translateOnAxis( _yAxis, distance );

	}

	translateZ( distance ) {

		return this.translateOnAxis( _zAxis, distance );

	}

	localToWorld( vector ) {

		this.updateWorldMatrix( true, false );

		return vector.applyMatrix4( this.matrixWorld );

	}

	worldToLocal( vector ) {

		this.updateWorldMatrix( true, false );

		return vector.applyMatrix4( _m1$3.copy( this.matrixWorld ).invert() );

	}

	lookAt( x, y, z ) {

		// This method does not support objects having non-uniformly-scaled parent(s)

		if ( x.isVector3 ) {

			_target.copy( x );

		} else {

			_target.set( x, y, z );

		}

		const parent = this.parent;

		this.updateWorldMatrix( true, false );

		_position$3.setFromMatrixPosition( this.matrixWorld );

		if ( this.isCamera || this.isLight ) {

			_m1$3.lookAt( _position$3, _target, this.up );

		} else {

			_m1$3.lookAt( _target, _position$3, this.up );

		}

		this.quaternion.setFromRotationMatrix( _m1$3 );

		if ( parent ) {

			_m1$3.extractRotation( parent.matrixWorld );
			_q1.setFromRotationMatrix( _m1$3 );
			this.quaternion.premultiply( _q1.invert() );

		}

	}

	add( object ) {

		if ( arguments.length > 1 ) {

			for ( let i = 0; i < arguments.length; i ++ ) {

				this.add( arguments[ i ] );

			}

			return this;

		}

		if ( object === this ) {

			console.error( 'THREE.Object3D.add: object can\'t be added as a child of itself.', object );
			return this;

		}

		if ( object && object.isObject3D ) {

			object.removeFromParent();
			object.parent = this;
			this.children.push( object );

			object.dispatchEvent( _addedEvent );

			_childaddedEvent.child = object;
			this.dispatchEvent( _childaddedEvent );
			_childaddedEvent.child = null;

		} else {

			console.error( 'THREE.Object3D.add: object not an instance of THREE.Object3D.', object );

		}

		return this;

	}

	remove( object ) {

		if ( arguments.length > 1 ) {

			for ( let i = 0; i < arguments.length; i ++ ) {

				this.remove( arguments[ i ] );

			}

			return this;

		}

		const index = this.children.indexOf( object );

		if ( index !== - 1 ) {

			object.parent = null;
			this.children.splice( index, 1 );

			object.dispatchEvent( _removedEvent );

			_childremovedEvent.child = object;
			this.dispatchEvent( _childremovedEvent );
			_childremovedEvent.child = null;

		}

		return this;

	}

	removeFromParent() {

		const parent = this.parent;

		if ( parent !== null ) {

			parent.remove( this );

		}

		return this;

	}

	clear() {

		return this.remove( ... this.children );

	}

	attach( object ) {

		// adds object as a child of this, while maintaining the object's world transform

		// Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)

		this.updateWorldMatrix( true, false );

		_m1$3.copy( this.matrixWorld ).invert();

		if ( object.parent !== null ) {

			object.parent.updateWorldMatrix( true, false );

			_m1$3.multiply( object.parent.matrixWorld );

		}

		object.applyMatrix4( _m1$3 );

		object.removeFromParent();
		object.parent = this;
		this.children.push( object );

		object.updateWorldMatrix( false, true );

		object.dispatchEvent( _addedEvent );

		_childaddedEvent.child = object;
		this.dispatchEvent( _childaddedEvent );
		_childaddedEvent.child = null;

		return this;

	}

	getObjectById( id ) {

		return this.getObjectByProperty( 'id', id );

	}

	getObjectByName( name ) {

		return this.getObjectByProperty( 'name', name );

	}

	getObjectByProperty( name, value ) {

		if ( this[ name ] === value ) return this;

		for ( let i = 0, l = this.children.length; i < l; i ++ ) {

			const child = this.children[ i ];
			const object = child.getObjectByProperty( name, value );

			if ( object !== undefined ) {

				return object;

			}

		}

		return undefined;

	}

	getObjectsByProperty( name, value, result = [] ) {

		if ( this[ name ] === value ) result.push( this );

		const children = this.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			children[ i ].getObjectsByProperty( name, value, result );

		}

		return result;

	}

	getWorldPosition( target ) {

		this.updateWorldMatrix( true, false );

		return target.setFromMatrixPosition( this.matrixWorld );

	}

	getWorldQuaternion( target ) {

		this.updateWorldMatrix( true, false );

		this.matrixWorld.decompose( _position$3, target, _scale$2 );

		return target;

	}

	getWorldScale( target ) {

		this.updateWorldMatrix( true, false );

		this.matrixWorld.decompose( _position$3, _quaternion$2, target );

		return target;

	}

	getWorldDirection( target ) {

		this.updateWorldMatrix( true, false );

		const e = this.matrixWorld.elements;

		return target.set( e[ 8 ], e[ 9 ], e[ 10 ] ).normalize();

	}

	raycast( /* raycaster, intersects */ ) {}

	traverse( callback ) {

		callback( this );

		const children = this.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			children[ i ].traverse( callback );

		}

	}

	traverseVisible( callback ) {

		if ( this.visible === false ) return;

		callback( this );

		const children = this.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			children[ i ].traverseVisible( callback );

		}

	}

	traverseAncestors( callback ) {

		const parent = this.parent;

		if ( parent !== null ) {

			callback( parent );

			parent.traverseAncestors( callback );

		}

	}

	updateMatrix() {

		this.matrix.compose( this.position, this.quaternion, this.scale );

		this.matrixWorldNeedsUpdate = true;

	}

	updateMatrixWorld( force ) {

		if ( this.matrixAutoUpdate ) this.updateMatrix();

		if ( this.matrixWorldNeedsUpdate || force ) {

			if ( this.matrixWorldAutoUpdate === true ) {

				if ( this.parent === null ) {

					this.matrixWorld.copy( this.matrix );

				} else {

					this.matrixWorld.multiplyMatrices( this.parent.matrixWorld, this.matrix );

				}

			}

			this.matrixWorldNeedsUpdate = false;

			force = true;

		}

		// make sure descendants are updated if required

		const children = this.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			const child = children[ i ];

			child.updateMatrixWorld( force );

		}

	}

	updateWorldMatrix( updateParents, updateChildren ) {

		const parent = this.parent;

		if ( updateParents === true && parent !== null ) {

			parent.updateWorldMatrix( true, false );

		}

		if ( this.matrixAutoUpdate ) this.updateMatrix();

		if ( this.matrixWorldAutoUpdate === true ) {

			if ( this.parent === null ) {

				this.matrixWorld.copy( this.matrix );

			} else {

				this.matrixWorld.multiplyMatrices( this.parent.matrixWorld, this.matrix );

			}

		}

		// make sure descendants are updated

		if ( updateChildren === true ) {

			const children = this.children;

			for ( let i = 0, l = children.length; i < l; i ++ ) {

				const child = children[ i ];

				child.updateWorldMatrix( false, true );

			}

		}

	}

	toJSON( meta ) {

		// meta is a string when called from JSON.stringify
		const isRootObject = ( meta === undefined || typeof meta === 'string' );

		const output = {};

		// meta is a hash used to collect geometries, materials.
		// not providing it implies that this is the root object
		// being serialized.
		if ( isRootObject ) {

			// initialize meta obj
			meta = {
				geometries: {},
				materials: {},
				textures: {},
				images: {},
				shapes: {},
				skeletons: {},
				animations: {},
				nodes: {}
			};

			output.metadata = {
				version: 4.6,
				type: 'Object',
				generator: 'Object3D.toJSON'
			};

		}

		// standard Object3D serialization

		const object = {};

		object.uuid = this.uuid;
		object.type = this.type;

		if ( this.name !== '' ) object.name = this.name;
		if ( this.castShadow === true ) object.castShadow = true;
		if ( this.receiveShadow === true ) object.receiveShadow = true;
		if ( this.visible === false ) object.visible = false;
		if ( this.frustumCulled === false ) object.frustumCulled = false;
		if ( this.renderOrder !== 0 ) object.renderOrder = this.renderOrder;
		if ( Object.keys( this.userData ).length > 0 ) object.userData = this.userData;

		object.layers = this.layers.mask;
		object.matrix = this.matrix.toArray();
		object.up = this.up.toArray();

		if ( this.matrixAutoUpdate === false ) object.matrixAutoUpdate = false;

		// object specific properties

		if ( this.isInstancedMesh ) {

			object.type = 'InstancedMesh';
			object.count = this.count;
			object.instanceMatrix = this.instanceMatrix.toJSON();
			if ( this.instanceColor !== null ) object.instanceColor = this.instanceColor.toJSON();

		}

		if ( this.isBatchedMesh ) {

			object.type = 'BatchedMesh';
			object.perObjectFrustumCulled = this.perObjectFrustumCulled;
			object.sortObjects = this.sortObjects;

			object.drawRanges = this._drawRanges;
			object.reservedRanges = this._reservedRanges;

			object.visibility = this._visibility;
			object.active = this._active;
			object.bounds = this._bounds.map( bound => ( {
				boxInitialized: bound.boxInitialized,
				boxMin: bound.box.min.toArray(),
				boxMax: bound.box.max.toArray(),

				sphereInitialized: bound.sphereInitialized,
				sphereRadius: bound.sphere.radius,
				sphereCenter: bound.sphere.center.toArray()
			} ) );

			object.maxInstanceCount = this._maxInstanceCount;
			object.maxVertexCount = this._maxVertexCount;
			object.maxIndexCount = this._maxIndexCount;

			object.geometryInitialized = this._geometryInitialized;
			object.geometryCount = this._geometryCount;

			object.matricesTexture = this._matricesTexture.toJSON( meta );

			if ( this._colorsTexture !== null ) object.colorsTexture = this._colorsTexture.toJSON( meta );

			if ( this.boundingSphere !== null ) {

				object.boundingSphere = {
					center: object.boundingSphere.center.toArray(),
					radius: object.boundingSphere.radius
				};

			}

			if ( this.boundingBox !== null ) {

				object.boundingBox = {
					min: object.boundingBox.min.toArray(),
					max: object.boundingBox.max.toArray()
				};

			}

		}

		//

		function serialize( library, element ) {

			if ( library[ element.uuid ] === undefined ) {

				library[ element.uuid ] = element.toJSON( meta );

			}

			return element.uuid;

		}

		if ( this.isScene ) {

			if ( this.background ) {

				if ( this.background.isColor ) {

					object.background = this.background.toJSON();

				} else if ( this.background.isTexture ) {

					object.background = this.background.toJSON( meta ).uuid;

				}

			}

			if ( this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true ) {

				object.environment = this.environment.toJSON( meta ).uuid;

			}

		} else if ( this.isMesh || this.isLine || this.isPoints ) {

			object.geometry = serialize( meta.geometries, this.geometry );

			const parameters = this.geometry.parameters;

			if ( parameters !== undefined && parameters.shapes !== undefined ) {

				const shapes = parameters.shapes;

				if ( Array.isArray( shapes ) ) {

					for ( let i = 0, l = shapes.length; i < l; i ++ ) {

						const shape = shapes[ i ];

						serialize( meta.shapes, shape );

					}

				} else {

					serialize( meta.shapes, shapes );

				}

			}

		}

		if ( this.isSkinnedMesh ) {

			object.bindMode = this.bindMode;
			object.bindMatrix = this.bindMatrix.toArray();

			if ( this.skeleton !== undefined ) {

				serialize( meta.skeletons, this.skeleton );

				object.skeleton = this.skeleton.uuid;

			}

		}

		if ( this.material !== undefined ) {

			if ( Array.isArray( this.material ) ) {

				const uuids = [];

				for ( let i = 0, l = this.material.length; i < l; i ++ ) {

					uuids.push( serialize( meta.materials, this.material[ i ] ) );

				}

				object.material = uuids;

			} else {

				object.material = serialize( meta.materials, this.material );

			}

		}

		//

		if ( this.children.length > 0 ) {

			object.children = [];

			for ( let i = 0; i < this.children.length; i ++ ) {

				object.children.push( this.children[ i ].toJSON( meta ).object );

			}

		}

		//

		if ( this.animations.length > 0 ) {

			object.animations = [];

			for ( let i = 0; i < this.animations.length; i ++ ) {

				const animation = this.animations[ i ];

				object.animations.push( serialize( meta.animations, animation ) );

			}

		}

		if ( isRootObject ) {

			const geometries = extractFromCache( meta.geometries );
			const materials = extractFromCache( meta.materials );
			const textures = extractFromCache( meta.textures );
			const images = extractFromCache( meta.images );
			const shapes = extractFromCache( meta.shapes );
			const skeletons = extractFromCache( meta.skeletons );
			const animations = extractFromCache( meta.animations );
			const nodes = extractFromCache( meta.nodes );

			if ( geometries.length > 0 ) output.geometries = geometries;
			if ( materials.length > 0 ) output.materials = materials;
			if ( textures.length > 0 ) output.textures = textures;
			if ( images.length > 0 ) output.images = images;
			if ( shapes.length > 0 ) output.shapes = shapes;
			if ( skeletons.length > 0 ) output.skeletons = skeletons;
			if ( animations.length > 0 ) output.animations = animations;
			if ( nodes.length > 0 ) output.nodes = nodes;

		}

		output.object = object;

		return output;

		// extract data from the cache hash
		// remove metadata on each item
		// and return as array
		function extractFromCache( cache ) {

			const values = [];
			for ( const key in cache ) {

				const data = cache[ key ];
				delete data.metadata;
				values.push( data );

			}

			return values;

		}

	}

	clone( recursive ) {

		return new this.constructor().copy( this, recursive );

	}

	copy( source, recursive = true ) {

		this.name = source.name;

		this.up.copy( source.up );

		this.position.copy( source.position );
		this.rotation.order = source.rotation.order;
		this.quaternion.copy( source.quaternion );
		this.scale.copy( source.scale );

		this.matrix.copy( source.matrix );
		this.matrixWorld.copy( source.matrixWorld );

		this.matrixAutoUpdate = source.matrixAutoUpdate;

		this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
		this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;

		this.layers.mask = source.layers.mask;
		this.visible = source.visible;

		this.castShadow = source.castShadow;
		this.receiveShadow = source.receiveShadow;

		this.frustumCulled = source.frustumCulled;
		this.renderOrder = source.renderOrder;

		this.animations = source.animations.slice();

		this.userData = JSON.parse( JSON.stringify( source.userData ) );

		if ( recursive === true ) {

			for ( let i = 0; i < source.children.length; i ++ ) {

				const child = source.children[ i ];
				this.add( child.clone() );

			}

		}

		return this;

	}

}

Object3D.DEFAULT_UP = /*@__PURE__*/ new Vector3( 0, 1, 0 );
Object3D.DEFAULT_MATRIX_AUTO_UPDATE = true;
Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;

const _v0$1 = /*@__PURE__*/ new Vector3();
const _v1$3$1 = /*@__PURE__*/ new Vector3();
const _v2$2$1 = /*@__PURE__*/ new Vector3();
const _v3$2$1 = /*@__PURE__*/ new Vector3();

const _vab = /*@__PURE__*/ new Vector3();
const _vac = /*@__PURE__*/ new Vector3();
const _vbc = /*@__PURE__*/ new Vector3();
const _vap = /*@__PURE__*/ new Vector3();
const _vbp = /*@__PURE__*/ new Vector3();
const _vcp = /*@__PURE__*/ new Vector3();

class Triangle {

	constructor( a = new Vector3(), b = new Vector3(), c = new Vector3() ) {

		this.a = a;
		this.b = b;
		this.c = c;

	}

	static getNormal( a, b, c, target ) {

		target.subVectors( c, b );
		_v0$1.subVectors( a, b );
		target.cross( _v0$1 );

		const targetLengthSq = target.lengthSq();
		if ( targetLengthSq > 0 ) {

			return target.multiplyScalar( 1 / Math.sqrt( targetLengthSq ) );

		}

		return target.set( 0, 0, 0 );

	}

	// static/instance method to calculate barycentric coordinates
	// based on: http://www.blackpawn.com/texts/pointinpoly/default.html
	static getBarycoord( point, a, b, c, target ) {

		_v0$1.subVectors( c, a );
		_v1$3$1.subVectors( b, a );
		_v2$2$1.subVectors( point, a );

		const dot00 = _v0$1.dot( _v0$1 );
		const dot01 = _v0$1.dot( _v1$3$1 );
		const dot02 = _v0$1.dot( _v2$2$1 );
		const dot11 = _v1$3$1.dot( _v1$3$1 );
		const dot12 = _v1$3$1.dot( _v2$2$1 );

		const denom = ( dot00 * dot11 - dot01 * dot01 );

		// collinear or singular triangle
		if ( denom === 0 ) {

			target.set( 0, 0, 0 );
			return null;

		}

		const invDenom = 1 / denom;
		const u = ( dot11 * dot02 - dot01 * dot12 ) * invDenom;
		const v = ( dot00 * dot12 - dot01 * dot02 ) * invDenom;

		// barycentric coordinates must always sum to 1
		return target.set( 1 - u - v, v, u );

	}

	static containsPoint( point, a, b, c ) {

		// if the triangle is degenerate then we can't contain a point
		if ( this.getBarycoord( point, a, b, c, _v3$2$1 ) === null ) {

			return false;

		}

		return ( _v3$2$1.x >= 0 ) && ( _v3$2$1.y >= 0 ) && ( ( _v3$2$1.x + _v3$2$1.y ) <= 1 );

	}

	static getInterpolation( point, p1, p2, p3, v1, v2, v3, target ) {

		if ( this.getBarycoord( point, p1, p2, p3, _v3$2$1 ) === null ) {

			target.x = 0;
			target.y = 0;
			if ( 'z' in target ) target.z = 0;
			if ( 'w' in target ) target.w = 0;
			return null;

		}

		target.setScalar( 0 );
		target.addScaledVector( v1, _v3$2$1.x );
		target.addScaledVector( v2, _v3$2$1.y );
		target.addScaledVector( v3, _v3$2$1.z );

		return target;

	}

	static isFrontFacing( a, b, c, direction ) {

		_v0$1.subVectors( c, b );
		_v1$3$1.subVectors( a, b );

		// strictly front facing
		return ( _v0$1.cross( _v1$3$1 ).dot( direction ) < 0 ) ? true : false;

	}

	set( a, b, c ) {

		this.a.copy( a );
		this.b.copy( b );
		this.c.copy( c );

		return this;

	}

	setFromPointsAndIndices( points, i0, i1, i2 ) {

		this.a.copy( points[ i0 ] );
		this.b.copy( points[ i1 ] );
		this.c.copy( points[ i2 ] );

		return this;

	}

	setFromAttributeAndIndices( attribute, i0, i1, i2 ) {

		this.a.fromBufferAttribute( attribute, i0 );
		this.b.fromBufferAttribute( attribute, i1 );
		this.c.fromBufferAttribute( attribute, i2 );

		return this;

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( triangle ) {

		this.a.copy( triangle.a );
		this.b.copy( triangle.b );
		this.c.copy( triangle.c );

		return this;

	}

	getArea() {

		_v0$1.subVectors( this.c, this.b );
		_v1$3$1.subVectors( this.a, this.b );

		return _v0$1.cross( _v1$3$1 ).length() * 0.5;

	}

	getMidpoint( target ) {

		return target.addVectors( this.a, this.b ).add( this.c ).multiplyScalar( 1 / 3 );

	}

	getNormal( target ) {

		return Triangle.getNormal( this.a, this.b, this.c, target );

	}

	getPlane( target ) {

		return target.setFromCoplanarPoints( this.a, this.b, this.c );

	}

	getBarycoord( point, target ) {

		return Triangle.getBarycoord( point, this.a, this.b, this.c, target );

	}

	getInterpolation( point, v1, v2, v3, target ) {

		return Triangle.getInterpolation( point, this.a, this.b, this.c, v1, v2, v3, target );

	}

	containsPoint( point ) {

		return Triangle.containsPoint( point, this.a, this.b, this.c );

	}

	isFrontFacing( direction ) {

		return Triangle.isFrontFacing( this.a, this.b, this.c, direction );

	}

	intersectsBox( box ) {

		return box.intersectsTriangle( this );

	}

	closestPointToPoint( p, target ) {

		const a = this.a, b = this.b, c = this.c;
		let v, w;

		// algorithm thanks to Real-Time Collision Detection by Christer Ericson,
		// published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
		// under the accompanying license; see chapter 5.1.5 for detailed explanation.
		// basically, we're distinguishing which of the voronoi regions of the triangle
		// the point lies in with the minimum amount of redundant computation.

		_vab.subVectors( b, a );
		_vac.subVectors( c, a );
		_vap.subVectors( p, a );
		const d1 = _vab.dot( _vap );
		const d2 = _vac.dot( _vap );
		if ( d1 <= 0 && d2 <= 0 ) {

			// vertex region of A; barycentric coords (1, 0, 0)
			return target.copy( a );

		}

		_vbp.subVectors( p, b );
		const d3 = _vab.dot( _vbp );
		const d4 = _vac.dot( _vbp );
		if ( d3 >= 0 && d4 <= d3 ) {

			// vertex region of B; barycentric coords (0, 1, 0)
			return target.copy( b );

		}

		const vc = d1 * d4 - d3 * d2;
		if ( vc <= 0 && d1 >= 0 && d3 <= 0 ) {

			v = d1 / ( d1 - d3 );
			// edge region of AB; barycentric coords (1-v, v, 0)
			return target.copy( a ).addScaledVector( _vab, v );

		}

		_vcp.subVectors( p, c );
		const d5 = _vab.dot( _vcp );
		const d6 = _vac.dot( _vcp );
		if ( d6 >= 0 && d5 <= d6 ) {

			// vertex region of C; barycentric coords (0, 0, 1)
			return target.copy( c );

		}

		const vb = d5 * d2 - d1 * d6;
		if ( vb <= 0 && d2 >= 0 && d6 <= 0 ) {

			w = d2 / ( d2 - d6 );
			// edge region of AC; barycentric coords (1-w, 0, w)
			return target.copy( a ).addScaledVector( _vac, w );

		}

		const va = d3 * d6 - d5 * d4;
		if ( va <= 0 && ( d4 - d3 ) >= 0 && ( d5 - d6 ) >= 0 ) {

			_vbc.subVectors( c, b );
			w = ( d4 - d3 ) / ( ( d4 - d3 ) + ( d5 - d6 ) );
			// edge region of BC; barycentric coords (0, 1-w, w)
			return target.copy( b ).addScaledVector( _vbc, w ); // edge region of BC

		}

		// face region
		const denom = 1 / ( va + vb + vc );
		// u = va * denom
		v = vb * denom;
		w = vc * denom;

		return target.copy( a ).addScaledVector( _vab, v ).addScaledVector( _vac, w );

	}

	equals( triangle ) {

		return triangle.a.equals( this.a ) && triangle.b.equals( this.b ) && triangle.c.equals( this.c );

	}

}

const _colorKeywords = { 'aliceblue': 0xF0F8FF, 'antiquewhite': 0xFAEBD7, 'aqua': 0x00FFFF, 'aquamarine': 0x7FFFD4, 'azure': 0xF0FFFF,
	'beige': 0xF5F5DC, 'bisque': 0xFFE4C4, 'black': 0x000000, 'blanchedalmond': 0xFFEBCD, 'blue': 0x0000FF, 'blueviolet': 0x8A2BE2,
	'brown': 0xA52A2A, 'burlywood': 0xDEB887, 'cadetblue': 0x5F9EA0, 'chartreuse': 0x7FFF00, 'chocolate': 0xD2691E, 'coral': 0xFF7F50,
	'cornflowerblue': 0x6495ED, 'cornsilk': 0xFFF8DC, 'crimson': 0xDC143C, 'cyan': 0x00FFFF, 'darkblue': 0x00008B, 'darkcyan': 0x008B8B,
	'darkgoldenrod': 0xB8860B, 'darkgray': 0xA9A9A9, 'darkgreen': 0x006400, 'darkgrey': 0xA9A9A9, 'darkkhaki': 0xBDB76B, 'darkmagenta': 0x8B008B,
	'darkolivegreen': 0x556B2F, 'darkorange': 0xFF8C00, 'darkorchid': 0x9932CC, 'darkred': 0x8B0000, 'darksalmon': 0xE9967A, 'darkseagreen': 0x8FBC8F,
	'darkslateblue': 0x483D8B, 'darkslategray': 0x2F4F4F, 'darkslategrey': 0x2F4F4F, 'darkturquoise': 0x00CED1, 'darkviolet': 0x9400D3,
	'deeppink': 0xFF1493, 'deepskyblue': 0x00BFFF, 'dimgray': 0x696969, 'dimgrey': 0x696969, 'dodgerblue': 0x1E90FF, 'firebrick': 0xB22222,
	'floralwhite': 0xFFFAF0, 'forestgreen': 0x228B22, 'fuchsia': 0xFF00FF, 'gainsboro': 0xDCDCDC, 'ghostwhite': 0xF8F8FF, 'gold': 0xFFD700,
	'goldenrod': 0xDAA520, 'gray': 0x808080, 'green': 0x008000, 'greenyellow': 0xADFF2F, 'grey': 0x808080, 'honeydew': 0xF0FFF0, 'hotpink': 0xFF69B4,
	'indianred': 0xCD5C5C, 'indigo': 0x4B0082, 'ivory': 0xFFFFF0, 'khaki': 0xF0E68C, 'lavender': 0xE6E6FA, 'lavenderblush': 0xFFF0F5, 'lawngreen': 0x7CFC00,
	'lemonchiffon': 0xFFFACD, 'lightblue': 0xADD8E6, 'lightcoral': 0xF08080, 'lightcyan': 0xE0FFFF, 'lightgoldenrodyellow': 0xFAFAD2, 'lightgray': 0xD3D3D3,
	'lightgreen': 0x90EE90, 'lightgrey': 0xD3D3D3, 'lightpink': 0xFFB6C1, 'lightsalmon': 0xFFA07A, 'lightseagreen': 0x20B2AA, 'lightskyblue': 0x87CEFA,
	'lightslategray': 0x778899, 'lightslategrey': 0x778899, 'lightsteelblue': 0xB0C4DE, 'lightyellow': 0xFFFFE0, 'lime': 0x00FF00, 'limegreen': 0x32CD32,
	'linen': 0xFAF0E6, 'magenta': 0xFF00FF, 'maroon': 0x800000, 'mediumaquamarine': 0x66CDAA, 'mediumblue': 0x0000CD, 'mediumorchid': 0xBA55D3,
	'mediumpurple': 0x9370DB, 'mediumseagreen': 0x3CB371, 'mediumslateblue': 0x7B68EE, 'mediumspringgreen': 0x00FA9A, 'mediumturquoise': 0x48D1CC,
	'mediumvioletred': 0xC71585, 'midnightblue': 0x191970, 'mintcream': 0xF5FFFA, 'mistyrose': 0xFFE4E1, 'moccasin': 0xFFE4B5, 'navajowhite': 0xFFDEAD,
	'navy': 0x000080, 'oldlace': 0xFDF5E6, 'olive': 0x808000, 'olivedrab': 0x6B8E23, 'orange': 0xFFA500, 'orangered': 0xFF4500, 'orchid': 0xDA70D6,
	'palegoldenrod': 0xEEE8AA, 'palegreen': 0x98FB98, 'paleturquoise': 0xAFEEEE, 'palevioletred': 0xDB7093, 'papayawhip': 0xFFEFD5, 'peachpuff': 0xFFDAB9,
	'peru': 0xCD853F, 'pink': 0xFFC0CB, 'plum': 0xDDA0DD, 'powderblue': 0xB0E0E6, 'purple': 0x800080, 'rebeccapurple': 0x663399, 'red': 0xFF0000, 'rosybrown': 0xBC8F8F,
	'royalblue': 0x4169E1, 'saddlebrown': 0x8B4513, 'salmon': 0xFA8072, 'sandybrown': 0xF4A460, 'seagreen': 0x2E8B57, 'seashell': 0xFFF5EE,
	'sienna': 0xA0522D, 'silver': 0xC0C0C0, 'skyblue': 0x87CEEB, 'slateblue': 0x6A5ACD, 'slategray': 0x708090, 'slategrey': 0x708090, 'snow': 0xFFFAFA,
	'springgreen': 0x00FF7F, 'steelblue': 0x4682B4, 'tan': 0xD2B48C, 'teal': 0x008080, 'thistle': 0xD8BFD8, 'tomato': 0xFF6347, 'turquoise': 0x40E0D0,
	'violet': 0xEE82EE, 'wheat': 0xF5DEB3, 'white': 0xFFFFFF, 'whitesmoke': 0xF5F5F5, 'yellow': 0xFFFF00, 'yellowgreen': 0x9ACD32 };

const _hslA = { h: 0, s: 0, l: 0 };
const _hslB = { h: 0, s: 0, l: 0 };

function hue2rgb( p, q, t ) {

	if ( t < 0 ) t += 1;
	if ( t > 1 ) t -= 1;
	if ( t < 1 / 6 ) return p + ( q - p ) * 6 * t;
	if ( t < 1 / 2 ) return q;
	if ( t < 2 / 3 ) return p + ( q - p ) * 6 * ( 2 / 3 - t );
	return p;

}

class Color {

	constructor( r, g, b ) {

		this.isColor = true;

		this.r = 1;
		this.g = 1;
		this.b = 1;

		return this.set( r, g, b );

	}

	set( r, g, b ) {

		if ( g === undefined && b === undefined ) {

			// r is THREE.Color, hex or string

			const value = r;

			if ( value && value.isColor ) {

				this.copy( value );

			} else if ( typeof value === 'number' ) {

				this.setHex( value );

			} else if ( typeof value === 'string' ) {

				this.setStyle( value );

			}

		} else {

			this.setRGB( r, g, b );

		}

		return this;

	}

	setScalar( scalar ) {

		this.r = scalar;
		this.g = scalar;
		this.b = scalar;

		return this;

	}

	setHex( hex, colorSpace = SRGBColorSpace ) {

		hex = Math.floor( hex );

		this.r = ( hex >> 16 & 255 ) / 255;
		this.g = ( hex >> 8 & 255 ) / 255;
		this.b = ( hex & 255 ) / 255;

		ColorManagement.toWorkingColorSpace( this, colorSpace );

		return this;

	}

	setRGB( r, g, b, colorSpace = ColorManagement.workingColorSpace ) {

		this.r = r;
		this.g = g;
		this.b = b;

		ColorManagement.toWorkingColorSpace( this, colorSpace );

		return this;

	}

	setHSL( h, s, l, colorSpace = ColorManagement.workingColorSpace ) {

		// h,s,l ranges are in 0.0 - 1.0
		h = euclideanModulo( h, 1 );
		s = clamp( s, 0, 1 );
		l = clamp( l, 0, 1 );

		if ( s === 0 ) {

			this.r = this.g = this.b = l;

		} else {

			const p = l <= 0.5 ? l * ( 1 + s ) : l + s - ( l * s );
			const q = ( 2 * l ) - p;

			this.r = hue2rgb( q, p, h + 1 / 3 );
			this.g = hue2rgb( q, p, h );
			this.b = hue2rgb( q, p, h - 1 / 3 );

		}

		ColorManagement.toWorkingColorSpace( this, colorSpace );

		return this;

	}

	setStyle( style, colorSpace = SRGBColorSpace ) {

		function handleAlpha( string ) {

			if ( string === undefined ) return;

			if ( parseFloat( string ) < 1 ) {

				console.warn( 'THREE.Color: Alpha component of ' + style + ' will be ignored.' );

			}

		}


		let m;

		if ( m = /^(\w+)\(([^\)]*)\)/.exec( style ) ) {

			// rgb / hsl

			let color;
			const name = m[ 1 ];
			const components = m[ 2 ];

			switch ( name ) {

				case 'rgb':
				case 'rgba':

					if ( color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec( components ) ) {

						// rgb(255,0,0) rgba(255,0,0,0.5)

						handleAlpha( color[ 4 ] );

						return this.setRGB(
							Math.min( 255, parseInt( color[ 1 ], 10 ) ) / 255,
							Math.min( 255, parseInt( color[ 2 ], 10 ) ) / 255,
							Math.min( 255, parseInt( color[ 3 ], 10 ) ) / 255,
							colorSpace
						);

					}

					if ( color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec( components ) ) {

						// rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)

						handleAlpha( color[ 4 ] );

						return this.setRGB(
							Math.min( 100, parseInt( color[ 1 ], 10 ) ) / 100,
							Math.min( 100, parseInt( color[ 2 ], 10 ) ) / 100,
							Math.min( 100, parseInt( color[ 3 ], 10 ) ) / 100,
							colorSpace
						);

					}

					break;

				case 'hsl':
				case 'hsla':

					if ( color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec( components ) ) {

						// hsl(120,50%,50%) hsla(120,50%,50%,0.5)

						handleAlpha( color[ 4 ] );

						return this.setHSL(
							parseFloat( color[ 1 ] ) / 360,
							parseFloat( color[ 2 ] ) / 100,
							parseFloat( color[ 3 ] ) / 100,
							colorSpace
						);

					}

					break;

				default:

					console.warn( 'THREE.Color: Unknown color model ' + style );

			}

		} else if ( m = /^\#([A-Fa-f\d]+)$/.exec( style ) ) {

			// hex color

			const hex = m[ 1 ];
			const size = hex.length;

			if ( size === 3 ) {

				// #ff0
				return this.setRGB(
					parseInt( hex.charAt( 0 ), 16 ) / 15,
					parseInt( hex.charAt( 1 ), 16 ) / 15,
					parseInt( hex.charAt( 2 ), 16 ) / 15,
					colorSpace
				);

			} else if ( size === 6 ) {

				// #ff0000
				return this.setHex( parseInt( hex, 16 ), colorSpace );

			} else {

				console.warn( 'THREE.Color: Invalid hex color ' + style );

			}

		} else if ( style && style.length > 0 ) {

			return this.setColorName( style, colorSpace );

		}

		return this;

	}

	setColorName( style, colorSpace = SRGBColorSpace ) {

		// color keywords
		const hex = _colorKeywords[ style.toLowerCase() ];

		if ( hex !== undefined ) {

			// red
			this.setHex( hex, colorSpace );

		} else {

			// unknown color
			console.warn( 'THREE.Color: Unknown color ' + style );

		}

		return this;

	}

	clone() {

		return new this.constructor( this.r, this.g, this.b );

	}

	copy( color ) {

		this.r = color.r;
		this.g = color.g;
		this.b = color.b;

		return this;

	}

	copySRGBToLinear( color ) {

		this.r = SRGBToLinear( color.r );
		this.g = SRGBToLinear( color.g );
		this.b = SRGBToLinear( color.b );

		return this;

	}

	copyLinearToSRGB( color ) {

		this.r = LinearToSRGB( color.r );
		this.g = LinearToSRGB( color.g );
		this.b = LinearToSRGB( color.b );

		return this;

	}

	convertSRGBToLinear() {

		this.copySRGBToLinear( this );

		return this;

	}

	convertLinearToSRGB() {

		this.copyLinearToSRGB( this );

		return this;

	}

	getHex( colorSpace = SRGBColorSpace ) {

		ColorManagement.fromWorkingColorSpace( _color$1.copy( this ), colorSpace );

		return Math.round( clamp( _color$1.r * 255, 0, 255 ) ) * 65536 + Math.round( clamp( _color$1.g * 255, 0, 255 ) ) * 256 + Math.round( clamp( _color$1.b * 255, 0, 255 ) );

	}

	getHexString( colorSpace = SRGBColorSpace ) {

		return ( '000000' + this.getHex( colorSpace ).toString( 16 ) ).slice( - 6 );

	}

	getHSL( target, colorSpace = ColorManagement.workingColorSpace ) {

		// h,s,l ranges are in 0.0 - 1.0

		ColorManagement.fromWorkingColorSpace( _color$1.copy( this ), colorSpace );

		const r = _color$1.r, g = _color$1.g, b = _color$1.b;

		const max = Math.max( r, g, b );
		const min = Math.min( r, g, b );

		let hue, saturation;
		const lightness = ( min + max ) / 2.0;

		if ( min === max ) {

			hue = 0;
			saturation = 0;

		} else {

			const delta = max - min;

			saturation = lightness <= 0.5 ? delta / ( max + min ) : delta / ( 2 - max - min );

			switch ( max ) {

				case r: hue = ( g - b ) / delta + ( g < b ? 6 : 0 ); break;
				case g: hue = ( b - r ) / delta + 2; break;
				case b: hue = ( r - g ) / delta + 4; break;

			}

			hue /= 6;

		}

		target.h = hue;
		target.s = saturation;
		target.l = lightness;

		return target;

	}

	getRGB( target, colorSpace = ColorManagement.workingColorSpace ) {

		ColorManagement.fromWorkingColorSpace( _color$1.copy( this ), colorSpace );

		target.r = _color$1.r;
		target.g = _color$1.g;
		target.b = _color$1.b;

		return target;

	}

	getStyle( colorSpace = SRGBColorSpace ) {

		ColorManagement.fromWorkingColorSpace( _color$1.copy( this ), colorSpace );

		const r = _color$1.r, g = _color$1.g, b = _color$1.b;

		if ( colorSpace !== SRGBColorSpace ) {

			// Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
			return `color(${ colorSpace } ${ r.toFixed( 3 ) } ${ g.toFixed( 3 ) } ${ b.toFixed( 3 ) })`;

		}

		return `rgb(${ Math.round( r * 255 ) },${ Math.round( g * 255 ) },${ Math.round( b * 255 ) })`;

	}

	offsetHSL( h, s, l ) {

		this.getHSL( _hslA );

		return this.setHSL( _hslA.h + h, _hslA.s + s, _hslA.l + l );

	}

	add( color ) {

		this.r += color.r;
		this.g += color.g;
		this.b += color.b;

		return this;

	}

	addColors( color1, color2 ) {

		this.r = color1.r + color2.r;
		this.g = color1.g + color2.g;
		this.b = color1.b + color2.b;

		return this;

	}

	addScalar( s ) {

		this.r += s;
		this.g += s;
		this.b += s;

		return this;

	}

	sub( color ) {

		this.r = Math.max( 0, this.r - color.r );
		this.g = Math.max( 0, this.g - color.g );
		this.b = Math.max( 0, this.b - color.b );

		return this;

	}

	multiply( color ) {

		this.r *= color.r;
		this.g *= color.g;
		this.b *= color.b;

		return this;

	}

	multiplyScalar( s ) {

		this.r *= s;
		this.g *= s;
		this.b *= s;

		return this;

	}

	lerp( color, alpha ) {

		this.r += ( color.r - this.r ) * alpha;
		this.g += ( color.g - this.g ) * alpha;
		this.b += ( color.b - this.b ) * alpha;

		return this;

	}

	lerpColors( color1, color2, alpha ) {

		this.r = color1.r + ( color2.r - color1.r ) * alpha;
		this.g = color1.g + ( color2.g - color1.g ) * alpha;
		this.b = color1.b + ( color2.b - color1.b ) * alpha;

		return this;

	}

	lerpHSL( color, alpha ) {

		this.getHSL( _hslA );
		color.getHSL( _hslB );

		const h = lerp( _hslA.h, _hslB.h, alpha );
		const s = lerp( _hslA.s, _hslB.s, alpha );
		const l = lerp( _hslA.l, _hslB.l, alpha );

		this.setHSL( h, s, l );

		return this;

	}

	setFromVector3( v ) {

		this.r = v.x;
		this.g = v.y;
		this.b = v.z;

		return this;

	}

	applyMatrix3( m ) {

		const r = this.r, g = this.g, b = this.b;
		const e = m.elements;

		this.r = e[ 0 ] * r + e[ 3 ] * g + e[ 6 ] * b;
		this.g = e[ 1 ] * r + e[ 4 ] * g + e[ 7 ] * b;
		this.b = e[ 2 ] * r + e[ 5 ] * g + e[ 8 ] * b;

		return this;

	}

	equals( c ) {

		return ( c.r === this.r ) && ( c.g === this.g ) && ( c.b === this.b );

	}

	fromArray( array, offset = 0 ) {

		this.r = array[ offset ];
		this.g = array[ offset + 1 ];
		this.b = array[ offset + 2 ];

		return this;

	}

	toArray( array = [], offset = 0 ) {

		array[ offset ] = this.r;
		array[ offset + 1 ] = this.g;
		array[ offset + 2 ] = this.b;

		return array;

	}

	fromBufferAttribute( attribute, index ) {

		this.r = attribute.getX( index );
		this.g = attribute.getY( index );
		this.b = attribute.getZ( index );

		return this;

	}

	toJSON() {

		return this.getHex();

	}

	*[ Symbol.iterator ]() {

		yield this.r;
		yield this.g;
		yield this.b;

	}

}

const _color$1 = /*@__PURE__*/ new Color();

Color.NAMES = _colorKeywords;

let _materialId = 0;

class Material extends EventDispatcher$2 {

	constructor() {

		super();

		this.isMaterial = true;

		Object.defineProperty( this, 'id', { value: _materialId ++ } );

		this.uuid = generateUUID();

		this.name = '';
		this.type = 'Material';

		this.blending = NormalBlending;
		this.side = FrontSide;
		this.vertexColors = false;

		this.opacity = 1;
		this.transparent = false;
		this.alphaHash = false;

		this.blendSrc = SrcAlphaFactor;
		this.blendDst = OneMinusSrcAlphaFactor;
		this.blendEquation = AddEquation;
		this.blendSrcAlpha = null;
		this.blendDstAlpha = null;
		this.blendEquationAlpha = null;
		this.blendColor = new Color( 0, 0, 0 );
		this.blendAlpha = 0;

		this.depthFunc = LessEqualDepth;
		this.depthTest = true;
		this.depthWrite = true;

		this.stencilWriteMask = 0xff;
		this.stencilFunc = AlwaysStencilFunc;
		this.stencilRef = 0;
		this.stencilFuncMask = 0xff;
		this.stencilFail = KeepStencilOp;
		this.stencilZFail = KeepStencilOp;
		this.stencilZPass = KeepStencilOp;
		this.stencilWrite = false;

		this.clippingPlanes = null;
		this.clipIntersection = false;
		this.clipShadows = false;

		this.shadowSide = null;

		this.colorWrite = true;

		this.precision = null; // override the renderer's default precision for this material

		this.polygonOffset = false;
		this.polygonOffsetFactor = 0;
		this.polygonOffsetUnits = 0;

		this.dithering = false;

		this.alphaToCoverage = false;
		this.premultipliedAlpha = false;
		this.forceSinglePass = false;

		this.visible = true;

		this.toneMapped = true;

		this.userData = {};

		this.version = 0;

		this._alphaTest = 0;

	}

	get alphaTest() {

		return this._alphaTest;

	}

	set alphaTest( value ) {

		if ( this._alphaTest > 0 !== value > 0 ) {

			this.version ++;

		}

		this._alphaTest = value;

	}

	onBeforeCompile( /* shaderobject, renderer */ ) {}

	customProgramCacheKey() {

		return this.onBeforeCompile.toString();

	}

	setValues( values ) {

		if ( values === undefined ) return;

		for ( const key in values ) {

			const newValue = values[ key ];

			if ( newValue === undefined ) {

				console.warn( `THREE.Material: parameter '${ key }' has value of undefined.` );
				continue;

			}

			const currentValue = this[ key ];

			if ( currentValue === undefined ) {

				console.warn( `THREE.Material: '${ key }' is not a property of THREE.${ this.type }.` );
				continue;

			}

			if ( currentValue && currentValue.isColor ) {

				currentValue.set( newValue );

			} else if ( ( currentValue && currentValue.isVector3 ) && ( newValue && newValue.isVector3 ) ) {

				currentValue.copy( newValue );

			} else {

				this[ key ] = newValue;

			}

		}

	}

	toJSON( meta ) {

		const isRootObject = ( meta === undefined || typeof meta === 'string' );

		if ( isRootObject ) {

			meta = {
				textures: {},
				images: {}
			};

		}

		const data = {
			metadata: {
				version: 4.6,
				type: 'Material',
				generator: 'Material.toJSON'
			}
		};

		// standard Material serialization
		data.uuid = this.uuid;
		data.type = this.type;

		if ( this.name !== '' ) data.name = this.name;

		if ( this.color && this.color.isColor ) data.color = this.color.getHex();

		if ( this.roughness !== undefined ) data.roughness = this.roughness;
		if ( this.metalness !== undefined ) data.metalness = this.metalness;

		if ( this.sheen !== undefined ) data.sheen = this.sheen;
		if ( this.sheenColor && this.sheenColor.isColor ) data.sheenColor = this.sheenColor.getHex();
		if ( this.sheenRoughness !== undefined ) data.sheenRoughness = this.sheenRoughness;
		if ( this.emissive && this.emissive.isColor ) data.emissive = this.emissive.getHex();
		if ( this.emissiveIntensity !== undefined && this.emissiveIntensity !== 1 ) data.emissiveIntensity = this.emissiveIntensity;

		if ( this.specular && this.specular.isColor ) data.specular = this.specular.getHex();
		if ( this.specularIntensity !== undefined ) data.specularIntensity = this.specularIntensity;
		if ( this.specularColor && this.specularColor.isColor ) data.specularColor = this.specularColor.getHex();
		if ( this.shininess !== undefined ) data.shininess = this.shininess;
		if ( this.clearcoat !== undefined ) data.clearcoat = this.clearcoat;
		if ( this.clearcoatRoughness !== undefined ) data.clearcoatRoughness = this.clearcoatRoughness;

		if ( this.clearcoatMap && this.clearcoatMap.isTexture ) {

			data.clearcoatMap = this.clearcoatMap.toJSON( meta ).uuid;

		}

		if ( this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture ) {

			data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON( meta ).uuid;

		}

		if ( this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture ) {

			data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON( meta ).uuid;
			data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();

		}

		if ( this.dispersion !== undefined ) data.dispersion = this.dispersion;

		if ( this.iridescence !== undefined ) data.iridescence = this.iridescence;
		if ( this.iridescenceIOR !== undefined ) data.iridescenceIOR = this.iridescenceIOR;
		if ( this.iridescenceThicknessRange !== undefined ) data.iridescenceThicknessRange = this.iridescenceThicknessRange;

		if ( this.iridescenceMap && this.iridescenceMap.isTexture ) {

			data.iridescenceMap = this.iridescenceMap.toJSON( meta ).uuid;

		}

		if ( this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture ) {

			data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON( meta ).uuid;

		}

		if ( this.anisotropy !== undefined ) data.anisotropy = this.anisotropy;
		if ( this.anisotropyRotation !== undefined ) data.anisotropyRotation = this.anisotropyRotation;

		if ( this.anisotropyMap && this.anisotropyMap.isTexture ) {

			data.anisotropyMap = this.anisotropyMap.toJSON( meta ).uuid;

		}

		if ( this.map && this.map.isTexture ) data.map = this.map.toJSON( meta ).uuid;
		if ( this.matcap && this.matcap.isTexture ) data.matcap = this.matcap.toJSON( meta ).uuid;
		if ( this.alphaMap && this.alphaMap.isTexture ) data.alphaMap = this.alphaMap.toJSON( meta ).uuid;

		if ( this.lightMap && this.lightMap.isTexture ) {

			data.lightMap = this.lightMap.toJSON( meta ).uuid;
			data.lightMapIntensity = this.lightMapIntensity;

		}

		if ( this.aoMap && this.aoMap.isTexture ) {

			data.aoMap = this.aoMap.toJSON( meta ).uuid;
			data.aoMapIntensity = this.aoMapIntensity;

		}

		if ( this.bumpMap && this.bumpMap.isTexture ) {

			data.bumpMap = this.bumpMap.toJSON( meta ).uuid;
			data.bumpScale = this.bumpScale;

		}

		if ( this.normalMap && this.normalMap.isTexture ) {

			data.normalMap = this.normalMap.toJSON( meta ).uuid;
			data.normalMapType = this.normalMapType;
			data.normalScale = this.normalScale.toArray();

		}

		if ( this.displacementMap && this.displacementMap.isTexture ) {

			data.displacementMap = this.displacementMap.toJSON( meta ).uuid;
			data.displacementScale = this.displacementScale;
			data.displacementBias = this.displacementBias;

		}

		if ( this.roughnessMap && this.roughnessMap.isTexture ) data.roughnessMap = this.roughnessMap.toJSON( meta ).uuid;
		if ( this.metalnessMap && this.metalnessMap.isTexture ) data.metalnessMap = this.metalnessMap.toJSON( meta ).uuid;

		if ( this.emissiveMap && this.emissiveMap.isTexture ) data.emissiveMap = this.emissiveMap.toJSON( meta ).uuid;
		if ( this.specularMap && this.specularMap.isTexture ) data.specularMap = this.specularMap.toJSON( meta ).uuid;
		if ( this.specularIntensityMap && this.specularIntensityMap.isTexture ) data.specularIntensityMap = this.specularIntensityMap.toJSON( meta ).uuid;
		if ( this.specularColorMap && this.specularColorMap.isTexture ) data.specularColorMap = this.specularColorMap.toJSON( meta ).uuid;

		if ( this.envMap && this.envMap.isTexture ) {

			data.envMap = this.envMap.toJSON( meta ).uuid;

			if ( this.combine !== undefined ) data.combine = this.combine;

		}

		if ( this.envMapRotation !== undefined ) data.envMapRotation = this.envMapRotation.toArray();
		if ( this.envMapIntensity !== undefined ) data.envMapIntensity = this.envMapIntensity;
		if ( this.reflectivity !== undefined ) data.reflectivity = this.reflectivity;
		if ( this.refractionRatio !== undefined ) data.refractionRatio = this.refractionRatio;

		if ( this.gradientMap && this.gradientMap.isTexture ) {

			data.gradientMap = this.gradientMap.toJSON( meta ).uuid;

		}

		if ( this.transmission !== undefined ) data.transmission = this.transmission;
		if ( this.transmissionMap && this.transmissionMap.isTexture ) data.transmissionMap = this.transmissionMap.toJSON( meta ).uuid;
		if ( this.thickness !== undefined ) data.thickness = this.thickness;
		if ( this.thicknessMap && this.thicknessMap.isTexture ) data.thicknessMap = this.thicknessMap.toJSON( meta ).uuid;
		if ( this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity ) data.attenuationDistance = this.attenuationDistance;
		if ( this.attenuationColor !== undefined ) data.attenuationColor = this.attenuationColor.getHex();

		if ( this.size !== undefined ) data.size = this.size;
		if ( this.shadowSide !== null ) data.shadowSide = this.shadowSide;
		if ( this.sizeAttenuation !== undefined ) data.sizeAttenuation = this.sizeAttenuation;

		if ( this.blending !== NormalBlending ) data.blending = this.blending;
		if ( this.side !== FrontSide ) data.side = this.side;
		if ( this.vertexColors === true ) data.vertexColors = true;

		if ( this.opacity < 1 ) data.opacity = this.opacity;
		if ( this.transparent === true ) data.transparent = true;

		if ( this.blendSrc !== SrcAlphaFactor ) data.blendSrc = this.blendSrc;
		if ( this.blendDst !== OneMinusSrcAlphaFactor ) data.blendDst = this.blendDst;
		if ( this.blendEquation !== AddEquation ) data.blendEquation = this.blendEquation;
		if ( this.blendSrcAlpha !== null ) data.blendSrcAlpha = this.blendSrcAlpha;
		if ( this.blendDstAlpha !== null ) data.blendDstAlpha = this.blendDstAlpha;
		if ( this.blendEquationAlpha !== null ) data.blendEquationAlpha = this.blendEquationAlpha;
		if ( this.blendColor && this.blendColor.isColor ) data.blendColor = this.blendColor.getHex();
		if ( this.blendAlpha !== 0 ) data.blendAlpha = this.blendAlpha;

		if ( this.depthFunc !== LessEqualDepth ) data.depthFunc = this.depthFunc;
		if ( this.depthTest === false ) data.depthTest = this.depthTest;
		if ( this.depthWrite === false ) data.depthWrite = this.depthWrite;
		if ( this.colorWrite === false ) data.colorWrite = this.colorWrite;

		if ( this.stencilWriteMask !== 0xff ) data.stencilWriteMask = this.stencilWriteMask;
		if ( this.stencilFunc !== AlwaysStencilFunc ) data.stencilFunc = this.stencilFunc;
		if ( this.stencilRef !== 0 ) data.stencilRef = this.stencilRef;
		if ( this.stencilFuncMask !== 0xff ) data.stencilFuncMask = this.stencilFuncMask;
		if ( this.stencilFail !== KeepStencilOp ) data.stencilFail = this.stencilFail;
		if ( this.stencilZFail !== KeepStencilOp ) data.stencilZFail = this.stencilZFail;
		if ( this.stencilZPass !== KeepStencilOp ) data.stencilZPass = this.stencilZPass;
		if ( this.stencilWrite === true ) data.stencilWrite = this.stencilWrite;

		// rotation (SpriteMaterial)
		if ( this.rotation !== undefined && this.rotation !== 0 ) data.rotation = this.rotation;

		if ( this.polygonOffset === true ) data.polygonOffset = true;
		if ( this.polygonOffsetFactor !== 0 ) data.polygonOffsetFactor = this.polygonOffsetFactor;
		if ( this.polygonOffsetUnits !== 0 ) data.polygonOffsetUnits = this.polygonOffsetUnits;

		if ( this.linewidth !== undefined && this.linewidth !== 1 ) data.linewidth = this.linewidth;
		if ( this.dashSize !== undefined ) data.dashSize = this.dashSize;
		if ( this.gapSize !== undefined ) data.gapSize = this.gapSize;
		if ( this.scale !== undefined ) data.scale = this.scale;

		if ( this.dithering === true ) data.dithering = true;

		if ( this.alphaTest > 0 ) data.alphaTest = this.alphaTest;
		if ( this.alphaHash === true ) data.alphaHash = true;
		if ( this.alphaToCoverage === true ) data.alphaToCoverage = true;
		if ( this.premultipliedAlpha === true ) data.premultipliedAlpha = true;
		if ( this.forceSinglePass === true ) data.forceSinglePass = true;

		if ( this.wireframe === true ) data.wireframe = true;
		if ( this.wireframeLinewidth > 1 ) data.wireframeLinewidth = this.wireframeLinewidth;
		if ( this.wireframeLinecap !== 'round' ) data.wireframeLinecap = this.wireframeLinecap;
		if ( this.wireframeLinejoin !== 'round' ) data.wireframeLinejoin = this.wireframeLinejoin;

		if ( this.flatShading === true ) data.flatShading = true;

		if ( this.visible === false ) data.visible = false;

		if ( this.toneMapped === false ) data.toneMapped = false;

		if ( this.fog === false ) data.fog = false;

		if ( Object.keys( this.userData ).length > 0 ) data.userData = this.userData;

		// TODO: Copied from Object3D.toJSON

		function extractFromCache( cache ) {

			const values = [];

			for ( const key in cache ) {

				const data = cache[ key ];
				delete data.metadata;
				values.push( data );

			}

			return values;

		}

		if ( isRootObject ) {

			const textures = extractFromCache( meta.textures );
			const images = extractFromCache( meta.images );

			if ( textures.length > 0 ) data.textures = textures;
			if ( images.length > 0 ) data.images = images;

		}

		return data;

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( source ) {

		this.name = source.name;

		this.blending = source.blending;
		this.side = source.side;
		this.vertexColors = source.vertexColors;

		this.opacity = source.opacity;
		this.transparent = source.transparent;

		this.blendSrc = source.blendSrc;
		this.blendDst = source.blendDst;
		this.blendEquation = source.blendEquation;
		this.blendSrcAlpha = source.blendSrcAlpha;
		this.blendDstAlpha = source.blendDstAlpha;
		this.blendEquationAlpha = source.blendEquationAlpha;
		this.blendColor.copy( source.blendColor );
		this.blendAlpha = source.blendAlpha;

		this.depthFunc = source.depthFunc;
		this.depthTest = source.depthTest;
		this.depthWrite = source.depthWrite;

		this.stencilWriteMask = source.stencilWriteMask;
		this.stencilFunc = source.stencilFunc;
		this.stencilRef = source.stencilRef;
		this.stencilFuncMask = source.stencilFuncMask;
		this.stencilFail = source.stencilFail;
		this.stencilZFail = source.stencilZFail;
		this.stencilZPass = source.stencilZPass;
		this.stencilWrite = source.stencilWrite;

		const srcPlanes = source.clippingPlanes;
		let dstPlanes = null;

		if ( srcPlanes !== null ) {

			const n = srcPlanes.length;
			dstPlanes = new Array( n );

			for ( let i = 0; i !== n; ++ i ) {

				dstPlanes[ i ] = srcPlanes[ i ].clone();

			}

		}

		this.clippingPlanes = dstPlanes;
		this.clipIntersection = source.clipIntersection;
		this.clipShadows = source.clipShadows;

		this.shadowSide = source.shadowSide;

		this.colorWrite = source.colorWrite;

		this.precision = source.precision;

		this.polygonOffset = source.polygonOffset;
		this.polygonOffsetFactor = source.polygonOffsetFactor;
		this.polygonOffsetUnits = source.polygonOffsetUnits;

		this.dithering = source.dithering;

		this.alphaTest = source.alphaTest;
		this.alphaHash = source.alphaHash;
		this.alphaToCoverage = source.alphaToCoverage;
		this.premultipliedAlpha = source.premultipliedAlpha;
		this.forceSinglePass = source.forceSinglePass;

		this.visible = source.visible;

		this.toneMapped = source.toneMapped;

		this.userData = JSON.parse( JSON.stringify( source.userData ) );

		return this;

	}

	dispose() {

		this.dispatchEvent( { type: 'dispose' } );

	}

	set needsUpdate( value ) {

		if ( value === true ) this.version ++;

	}

	onBuild( /* shaderobject, renderer */ ) {

		console.warn( 'Material: onBuild() has been removed.' ); // @deprecated, r166

	}

	onBeforeRender( /* renderer, scene, camera, geometry, object, group */ ) {

		console.warn( 'Material: onBeforeRender() has been removed.' ); // @deprecated, r166

	}


}

class MeshBasicMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isMeshBasicMaterial = true;

		this.type = 'MeshBasicMaterial';

		this.color = new Color( 0xffffff ); // emissive

		this.map = null;

		this.lightMap = null;
		this.lightMapIntensity = 1.0;

		this.aoMap = null;
		this.aoMapIntensity = 1.0;

		this.specularMap = null;

		this.alphaMap = null;

		this.envMap = null;
		this.envMapRotation = new Euler();
		this.combine = MultiplyOperation;
		this.reflectivity = 1;
		this.refractionRatio = 0.98;

		this.wireframe = false;
		this.wireframeLinewidth = 1;
		this.wireframeLinecap = 'round';
		this.wireframeLinejoin = 'round';

		this.fog = true;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.color.copy( source.color );

		this.map = source.map;

		this.lightMap = source.lightMap;
		this.lightMapIntensity = source.lightMapIntensity;

		this.aoMap = source.aoMap;
		this.aoMapIntensity = source.aoMapIntensity;

		this.specularMap = source.specularMap;

		this.alphaMap = source.alphaMap;

		this.envMap = source.envMap;
		this.envMapRotation.copy( source.envMapRotation );
		this.combine = source.combine;
		this.reflectivity = source.reflectivity;
		this.refractionRatio = source.refractionRatio;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;
		this.wireframeLinecap = source.wireframeLinecap;
		this.wireframeLinejoin = source.wireframeLinejoin;

		this.fog = source.fog;

		return this;

	}

}

const _vector$9 = /*@__PURE__*/ new Vector3();
const _vector2$1 = /*@__PURE__*/ new Vector2();

class BufferAttribute {

	constructor( array, itemSize, normalized = false ) {

		if ( Array.isArray( array ) ) {

			throw new TypeError( 'THREE.BufferAttribute: array should be a Typed Array.' );

		}

		this.isBufferAttribute = true;

		this.name = '';

		this.array = array;
		this.itemSize = itemSize;
		this.count = array !== undefined ? array.length / itemSize : 0;
		this.normalized = normalized;

		this.usage = StaticDrawUsage;
		this._updateRange = { offset: 0, count: - 1 };
		this.updateRanges = [];
		this.gpuType = FloatType;

		this.version = 0;

	}

	onUploadCallback() {}

	set needsUpdate( value ) {

		if ( value === true ) this.version ++;

	}

	get updateRange() {

		warnOnce( 'THREE.BufferAttribute: updateRange() is deprecated and will be removed in r169. Use addUpdateRange() instead.' ); // @deprecated, r159
		return this._updateRange;

	}

	setUsage( value ) {

		this.usage = value;

		return this;

	}

	addUpdateRange( start, count ) {

		this.updateRanges.push( { start, count } );

	}

	clearUpdateRanges() {

		this.updateRanges.length = 0;

	}

	copy( source ) {

		this.name = source.name;
		this.array = new source.array.constructor( source.array );
		this.itemSize = source.itemSize;
		this.count = source.count;
		this.normalized = source.normalized;

		this.usage = source.usage;
		this.gpuType = source.gpuType;

		return this;

	}

	copyAt( index1, attribute, index2 ) {

		index1 *= this.itemSize;
		index2 *= attribute.itemSize;

		for ( let i = 0, l = this.itemSize; i < l; i ++ ) {

			this.array[ index1 + i ] = attribute.array[ index2 + i ];

		}

		return this;

	}

	copyArray( array ) {

		this.array.set( array );

		return this;

	}

	applyMatrix3( m ) {

		if ( this.itemSize === 2 ) {

			for ( let i = 0, l = this.count; i < l; i ++ ) {

				_vector2$1.fromBufferAttribute( this, i );
				_vector2$1.applyMatrix3( m );

				this.setXY( i, _vector2$1.x, _vector2$1.y );

			}

		} else if ( this.itemSize === 3 ) {

			for ( let i = 0, l = this.count; i < l; i ++ ) {

				_vector$9.fromBufferAttribute( this, i );
				_vector$9.applyMatrix3( m );

				this.setXYZ( i, _vector$9.x, _vector$9.y, _vector$9.z );

			}

		}

		return this;

	}

	applyMatrix4( m ) {

		for ( let i = 0, l = this.count; i < l; i ++ ) {

			_vector$9.fromBufferAttribute( this, i );

			_vector$9.applyMatrix4( m );

			this.setXYZ( i, _vector$9.x, _vector$9.y, _vector$9.z );

		}

		return this;

	}

	applyNormalMatrix( m ) {

		for ( let i = 0, l = this.count; i < l; i ++ ) {

			_vector$9.fromBufferAttribute( this, i );

			_vector$9.applyNormalMatrix( m );

			this.setXYZ( i, _vector$9.x, _vector$9.y, _vector$9.z );

		}

		return this;

	}

	transformDirection( m ) {

		for ( let i = 0, l = this.count; i < l; i ++ ) {

			_vector$9.fromBufferAttribute( this, i );

			_vector$9.transformDirection( m );

			this.setXYZ( i, _vector$9.x, _vector$9.y, _vector$9.z );

		}

		return this;

	}

	set( value, offset = 0 ) {

		// Matching BufferAttribute constructor, do not normalize the array.
		this.array.set( value, offset );

		return this;

	}

	getComponent( index, component ) {

		let value = this.array[ index * this.itemSize + component ];

		if ( this.normalized ) value = denormalize( value, this.array );

		return value;

	}

	setComponent( index, component, value ) {

		if ( this.normalized ) value = normalize( value, this.array );

		this.array[ index * this.itemSize + component ] = value;

		return this;

	}

	getX( index ) {

		let x = this.array[ index * this.itemSize ];

		if ( this.normalized ) x = denormalize( x, this.array );

		return x;

	}

	setX( index, x ) {

		if ( this.normalized ) x = normalize( x, this.array );

		this.array[ index * this.itemSize ] = x;

		return this;

	}

	getY( index ) {

		let y = this.array[ index * this.itemSize + 1 ];

		if ( this.normalized ) y = denormalize( y, this.array );

		return y;

	}

	setY( index, y ) {

		if ( this.normalized ) y = normalize( y, this.array );

		this.array[ index * this.itemSize + 1 ] = y;

		return this;

	}

	getZ( index ) {

		let z = this.array[ index * this.itemSize + 2 ];

		if ( this.normalized ) z = denormalize( z, this.array );

		return z;

	}

	setZ( index, z ) {

		if ( this.normalized ) z = normalize( z, this.array );

		this.array[ index * this.itemSize + 2 ] = z;

		return this;

	}

	getW( index ) {

		let w = this.array[ index * this.itemSize + 3 ];

		if ( this.normalized ) w = denormalize( w, this.array );

		return w;

	}

	setW( index, w ) {

		if ( this.normalized ) w = normalize( w, this.array );

		this.array[ index * this.itemSize + 3 ] = w;

		return this;

	}

	setXY( index, x, y ) {

		index *= this.itemSize;

		if ( this.normalized ) {

			x = normalize( x, this.array );
			y = normalize( y, this.array );

		}

		this.array[ index + 0 ] = x;
		this.array[ index + 1 ] = y;

		return this;

	}

	setXYZ( index, x, y, z ) {

		index *= this.itemSize;

		if ( this.normalized ) {

			x = normalize( x, this.array );
			y = normalize( y, this.array );
			z = normalize( z, this.array );

		}

		this.array[ index + 0 ] = x;
		this.array[ index + 1 ] = y;
		this.array[ index + 2 ] = z;

		return this;

	}

	setXYZW( index, x, y, z, w ) {

		index *= this.itemSize;

		if ( this.normalized ) {

			x = normalize( x, this.array );
			y = normalize( y, this.array );
			z = normalize( z, this.array );
			w = normalize( w, this.array );

		}

		this.array[ index + 0 ] = x;
		this.array[ index + 1 ] = y;
		this.array[ index + 2 ] = z;
		this.array[ index + 3 ] = w;

		return this;

	}

	onUpload( callback ) {

		this.onUploadCallback = callback;

		return this;

	}

	clone() {

		return new this.constructor( this.array, this.itemSize ).copy( this );

	}

	toJSON() {

		const data = {
			itemSize: this.itemSize,
			type: this.array.constructor.name,
			array: Array.from( this.array ),
			normalized: this.normalized
		};

		if ( this.name !== '' ) data.name = this.name;
		if ( this.usage !== StaticDrawUsage ) data.usage = this.usage;

		return data;

	}

}

class Uint16BufferAttribute extends BufferAttribute {

	constructor( array, itemSize, normalized ) {

		super( new Uint16Array( array ), itemSize, normalized );

	}

}

class Uint32BufferAttribute extends BufferAttribute {

	constructor( array, itemSize, normalized ) {

		super( new Uint32Array( array ), itemSize, normalized );

	}

}


class Float32BufferAttribute extends BufferAttribute {

	constructor( array, itemSize, normalized ) {

		super( new Float32Array( array ), itemSize, normalized );

	}

}

let _id$2 = 0;

const _m1$2 = /*@__PURE__*/ new Matrix4();
const _obj = /*@__PURE__*/ new Object3D();
const _offset$1 = /*@__PURE__*/ new Vector3();
const _box$2 = /*@__PURE__*/ new Box3();
const _boxMorphTargets = /*@__PURE__*/ new Box3();
const _vector$8 = /*@__PURE__*/ new Vector3();

class BufferGeometry extends EventDispatcher$2 {

	constructor() {

		super();

		this.isBufferGeometry = true;

		Object.defineProperty( this, 'id', { value: _id$2 ++ } );

		this.uuid = generateUUID();

		this.name = '';
		this.type = 'BufferGeometry';

		this.index = null;
		this.attributes = {};

		this.morphAttributes = {};
		this.morphTargetsRelative = false;

		this.groups = [];

		this.boundingBox = null;
		this.boundingSphere = null;

		this.drawRange = { start: 0, count: Infinity };

		this.userData = {};

	}

	getIndex() {

		return this.index;

	}

	setIndex( index ) {

		if ( Array.isArray( index ) ) {

			this.index = new ( arrayNeedsUint32( index ) ? Uint32BufferAttribute : Uint16BufferAttribute )( index, 1 );

		} else {

			this.index = index;

		}

		return this;

	}

	getAttribute( name ) {

		return this.attributes[ name ];

	}

	setAttribute( name, attribute ) {

		this.attributes[ name ] = attribute;

		return this;

	}

	deleteAttribute( name ) {

		delete this.attributes[ name ];

		return this;

	}

	hasAttribute( name ) {

		return this.attributes[ name ] !== undefined;

	}

	addGroup( start, count, materialIndex = 0 ) {

		this.groups.push( {

			start: start,
			count: count,
			materialIndex: materialIndex

		} );

	}

	clearGroups() {

		this.groups = [];

	}

	setDrawRange( start, count ) {

		this.drawRange.start = start;
		this.drawRange.count = count;

	}

	applyMatrix4( matrix ) {

		const position = this.attributes.position;

		if ( position !== undefined ) {

			position.applyMatrix4( matrix );

			position.needsUpdate = true;

		}

		const normal = this.attributes.normal;

		if ( normal !== undefined ) {

			const normalMatrix = new Matrix3().getNormalMatrix( matrix );

			normal.applyNormalMatrix( normalMatrix );

			normal.needsUpdate = true;

		}

		const tangent = this.attributes.tangent;

		if ( tangent !== undefined ) {

			tangent.transformDirection( matrix );

			tangent.needsUpdate = true;

		}

		if ( this.boundingBox !== null ) {

			this.computeBoundingBox();

		}

		if ( this.boundingSphere !== null ) {

			this.computeBoundingSphere();

		}

		return this;

	}

	applyQuaternion( q ) {

		_m1$2.makeRotationFromQuaternion( q );

		this.applyMatrix4( _m1$2 );

		return this;

	}

	rotateX( angle ) {

		// rotate geometry around world x-axis

		_m1$2.makeRotationX( angle );

		this.applyMatrix4( _m1$2 );

		return this;

	}

	rotateY( angle ) {

		// rotate geometry around world y-axis

		_m1$2.makeRotationY( angle );

		this.applyMatrix4( _m1$2 );

		return this;

	}

	rotateZ( angle ) {

		// rotate geometry around world z-axis

		_m1$2.makeRotationZ( angle );

		this.applyMatrix4( _m1$2 );

		return this;

	}

	translate( x, y, z ) {

		// translate geometry

		_m1$2.makeTranslation( x, y, z );

		this.applyMatrix4( _m1$2 );

		return this;

	}

	scale( x, y, z ) {

		// scale geometry

		_m1$2.makeScale( x, y, z );

		this.applyMatrix4( _m1$2 );

		return this;

	}

	lookAt( vector ) {

		_obj.lookAt( vector );

		_obj.updateMatrix();

		this.applyMatrix4( _obj.matrix );

		return this;

	}

	center() {

		this.computeBoundingBox();

		this.boundingBox.getCenter( _offset$1 ).negate();

		this.translate( _offset$1.x, _offset$1.y, _offset$1.z );

		return this;

	}

	setFromPoints( points ) {

		const position = [];

		for ( let i = 0, l = points.length; i < l; i ++ ) {

			const point = points[ i ];
			position.push( point.x, point.y, point.z || 0 );

		}

		this.setAttribute( 'position', new Float32BufferAttribute( position, 3 ) );

		return this;

	}

	computeBoundingBox() {

		if ( this.boundingBox === null ) {

			this.boundingBox = new Box3();

		}

		const position = this.attributes.position;
		const morphAttributesPosition = this.morphAttributes.position;

		if ( position && position.isGLBufferAttribute ) {

			console.error( 'THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.', this );

			this.boundingBox.set(
				new Vector3( - Infinity, - Infinity, - Infinity ),
				new Vector3( + Infinity, + Infinity, + Infinity )
			);

			return;

		}

		if ( position !== undefined ) {

			this.boundingBox.setFromBufferAttribute( position );

			// process morph attributes if present

			if ( morphAttributesPosition ) {

				for ( let i = 0, il = morphAttributesPosition.length; i < il; i ++ ) {

					const morphAttribute = morphAttributesPosition[ i ];
					_box$2.setFromBufferAttribute( morphAttribute );

					if ( this.morphTargetsRelative ) {

						_vector$8.addVectors( this.boundingBox.min, _box$2.min );
						this.boundingBox.expandByPoint( _vector$8 );

						_vector$8.addVectors( this.boundingBox.max, _box$2.max );
						this.boundingBox.expandByPoint( _vector$8 );

					} else {

						this.boundingBox.expandByPoint( _box$2.min );
						this.boundingBox.expandByPoint( _box$2.max );

					}

				}

			}

		} else {

			this.boundingBox.makeEmpty();

		}

		if ( isNaN( this.boundingBox.min.x ) || isNaN( this.boundingBox.min.y ) || isNaN( this.boundingBox.min.z ) ) {

			console.error( 'THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this );

		}

	}

	computeBoundingSphere() {

		if ( this.boundingSphere === null ) {

			this.boundingSphere = new Sphere();

		}

		const position = this.attributes.position;
		const morphAttributesPosition = this.morphAttributes.position;

		if ( position && position.isGLBufferAttribute ) {

			console.error( 'THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.', this );

			this.boundingSphere.set( new Vector3(), Infinity );

			return;

		}

		if ( position ) {

			// first, find the center of the bounding sphere

			const center = this.boundingSphere.center;

			_box$2.setFromBufferAttribute( position );

			// process morph attributes if present

			if ( morphAttributesPosition ) {

				for ( let i = 0, il = morphAttributesPosition.length; i < il; i ++ ) {

					const morphAttribute = morphAttributesPosition[ i ];
					_boxMorphTargets.setFromBufferAttribute( morphAttribute );

					if ( this.morphTargetsRelative ) {

						_vector$8.addVectors( _box$2.min, _boxMorphTargets.min );
						_box$2.expandByPoint( _vector$8 );

						_vector$8.addVectors( _box$2.max, _boxMorphTargets.max );
						_box$2.expandByPoint( _vector$8 );

					} else {

						_box$2.expandByPoint( _boxMorphTargets.min );
						_box$2.expandByPoint( _boxMorphTargets.max );

					}

				}

			}

			_box$2.getCenter( center );

			// second, try to find a boundingSphere with a radius smaller than the
			// boundingSphere of the boundingBox: sqrt(3) smaller in the best case

			let maxRadiusSq = 0;

			for ( let i = 0, il = position.count; i < il; i ++ ) {

				_vector$8.fromBufferAttribute( position, i );

				maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( _vector$8 ) );

			}

			// process morph attributes if present

			if ( morphAttributesPosition ) {

				for ( let i = 0, il = morphAttributesPosition.length; i < il; i ++ ) {

					const morphAttribute = morphAttributesPosition[ i ];
					const morphTargetsRelative = this.morphTargetsRelative;

					for ( let j = 0, jl = morphAttribute.count; j < jl; j ++ ) {

						_vector$8.fromBufferAttribute( morphAttribute, j );

						if ( morphTargetsRelative ) {

							_offset$1.fromBufferAttribute( position, j );
							_vector$8.add( _offset$1 );

						}

						maxRadiusSq = Math.max( maxRadiusSq, center.distanceToSquared( _vector$8 ) );

					}

				}

			}

			this.boundingSphere.radius = Math.sqrt( maxRadiusSq );

			if ( isNaN( this.boundingSphere.radius ) ) {

				console.error( 'THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this );

			}

		}

	}

	computeTangents() {

		const index = this.index;
		const attributes = this.attributes;

		// based on http://www.terathon.com/code/tangent.html
		// (per vertex tangents)

		if ( index === null ||
			 attributes.position === undefined ||
			 attributes.normal === undefined ||
			 attributes.uv === undefined ) {

			console.error( 'THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)' );
			return;

		}

		const positionAttribute = attributes.position;
		const normalAttribute = attributes.normal;
		const uvAttribute = attributes.uv;

		if ( this.hasAttribute( 'tangent' ) === false ) {

			this.setAttribute( 'tangent', new BufferAttribute( new Float32Array( 4 * positionAttribute.count ), 4 ) );

		}

		const tangentAttribute = this.getAttribute( 'tangent' );

		const tan1 = [], tan2 = [];

		for ( let i = 0; i < positionAttribute.count; i ++ ) {

			tan1[ i ] = new Vector3();
			tan2[ i ] = new Vector3();

		}

		const vA = new Vector3(),
			vB = new Vector3(),
			vC = new Vector3(),

			uvA = new Vector2(),
			uvB = new Vector2(),
			uvC = new Vector2(),

			sdir = new Vector3(),
			tdir = new Vector3();

		function handleTriangle( a, b, c ) {

			vA.fromBufferAttribute( positionAttribute, a );
			vB.fromBufferAttribute( positionAttribute, b );
			vC.fromBufferAttribute( positionAttribute, c );

			uvA.fromBufferAttribute( uvAttribute, a );
			uvB.fromBufferAttribute( uvAttribute, b );
			uvC.fromBufferAttribute( uvAttribute, c );

			vB.sub( vA );
			vC.sub( vA );

			uvB.sub( uvA );
			uvC.sub( uvA );

			const r = 1.0 / ( uvB.x * uvC.y - uvC.x * uvB.y );

			// silently ignore degenerate uv triangles having coincident or colinear vertices

			if ( ! isFinite( r ) ) return;

			sdir.copy( vB ).multiplyScalar( uvC.y ).addScaledVector( vC, - uvB.y ).multiplyScalar( r );
			tdir.copy( vC ).multiplyScalar( uvB.x ).addScaledVector( vB, - uvC.x ).multiplyScalar( r );

			tan1[ a ].add( sdir );
			tan1[ b ].add( sdir );
			tan1[ c ].add( sdir );

			tan2[ a ].add( tdir );
			tan2[ b ].add( tdir );
			tan2[ c ].add( tdir );

		}

		let groups = this.groups;

		if ( groups.length === 0 ) {

			groups = [ {
				start: 0,
				count: index.count
			} ];

		}

		for ( let i = 0, il = groups.length; i < il; ++ i ) {

			const group = groups[ i ];

			const start = group.start;
			const count = group.count;

			for ( let j = start, jl = start + count; j < jl; j += 3 ) {

				handleTriangle(
					index.getX( j + 0 ),
					index.getX( j + 1 ),
					index.getX( j + 2 )
				);

			}

		}

		const tmp = new Vector3(), tmp2 = new Vector3();
		const n = new Vector3(), n2 = new Vector3();

		function handleVertex( v ) {

			n.fromBufferAttribute( normalAttribute, v );
			n2.copy( n );

			const t = tan1[ v ];

			// Gram-Schmidt orthogonalize

			tmp.copy( t );
			tmp.sub( n.multiplyScalar( n.dot( t ) ) ).normalize();

			// Calculate handedness

			tmp2.crossVectors( n2, t );
			const test = tmp2.dot( tan2[ v ] );
			const w = ( test < 0.0 ) ? - 1.0 : 1.0;

			tangentAttribute.setXYZW( v, tmp.x, tmp.y, tmp.z, w );

		}

		for ( let i = 0, il = groups.length; i < il; ++ i ) {

			const group = groups[ i ];

			const start = group.start;
			const count = group.count;

			for ( let j = start, jl = start + count; j < jl; j += 3 ) {

				handleVertex( index.getX( j + 0 ) );
				handleVertex( index.getX( j + 1 ) );
				handleVertex( index.getX( j + 2 ) );

			}

		}

	}

	computeVertexNormals() {

		const index = this.index;
		const positionAttribute = this.getAttribute( 'position' );

		if ( positionAttribute !== undefined ) {

			let normalAttribute = this.getAttribute( 'normal' );

			if ( normalAttribute === undefined ) {

				normalAttribute = new BufferAttribute( new Float32Array( positionAttribute.count * 3 ), 3 );
				this.setAttribute( 'normal', normalAttribute );

			} else {

				// reset existing normals to zero

				for ( let i = 0, il = normalAttribute.count; i < il; i ++ ) {

					normalAttribute.setXYZ( i, 0, 0, 0 );

				}

			}

			const pA = new Vector3(), pB = new Vector3(), pC = new Vector3();
			const nA = new Vector3(), nB = new Vector3(), nC = new Vector3();
			const cb = new Vector3(), ab = new Vector3();

			// indexed elements

			if ( index ) {

				for ( let i = 0, il = index.count; i < il; i += 3 ) {

					const vA = index.getX( i + 0 );
					const vB = index.getX( i + 1 );
					const vC = index.getX( i + 2 );

					pA.fromBufferAttribute( positionAttribute, vA );
					pB.fromBufferAttribute( positionAttribute, vB );
					pC.fromBufferAttribute( positionAttribute, vC );

					cb.subVectors( pC, pB );
					ab.subVectors( pA, pB );
					cb.cross( ab );

					nA.fromBufferAttribute( normalAttribute, vA );
					nB.fromBufferAttribute( normalAttribute, vB );
					nC.fromBufferAttribute( normalAttribute, vC );

					nA.add( cb );
					nB.add( cb );
					nC.add( cb );

					normalAttribute.setXYZ( vA, nA.x, nA.y, nA.z );
					normalAttribute.setXYZ( vB, nB.x, nB.y, nB.z );
					normalAttribute.setXYZ( vC, nC.x, nC.y, nC.z );

				}

			} else {

				// non-indexed elements (unconnected triangle soup)

				for ( let i = 0, il = positionAttribute.count; i < il; i += 3 ) {

					pA.fromBufferAttribute( positionAttribute, i + 0 );
					pB.fromBufferAttribute( positionAttribute, i + 1 );
					pC.fromBufferAttribute( positionAttribute, i + 2 );

					cb.subVectors( pC, pB );
					ab.subVectors( pA, pB );
					cb.cross( ab );

					normalAttribute.setXYZ( i + 0, cb.x, cb.y, cb.z );
					normalAttribute.setXYZ( i + 1, cb.x, cb.y, cb.z );
					normalAttribute.setXYZ( i + 2, cb.x, cb.y, cb.z );

				}

			}

			this.normalizeNormals();

			normalAttribute.needsUpdate = true;

		}

	}

	normalizeNormals() {

		const normals = this.attributes.normal;

		for ( let i = 0, il = normals.count; i < il; i ++ ) {

			_vector$8.fromBufferAttribute( normals, i );

			_vector$8.normalize();

			normals.setXYZ( i, _vector$8.x, _vector$8.y, _vector$8.z );

		}

	}

	toNonIndexed() {

		function convertBufferAttribute( attribute, indices ) {

			const array = attribute.array;
			const itemSize = attribute.itemSize;
			const normalized = attribute.normalized;

			const array2 = new array.constructor( indices.length * itemSize );

			let index = 0, index2 = 0;

			for ( let i = 0, l = indices.length; i < l; i ++ ) {

				if ( attribute.isInterleavedBufferAttribute ) {

					index = indices[ i ] * attribute.data.stride + attribute.offset;

				} else {

					index = indices[ i ] * itemSize;

				}

				for ( let j = 0; j < itemSize; j ++ ) {

					array2[ index2 ++ ] = array[ index ++ ];

				}

			}

			return new BufferAttribute( array2, itemSize, normalized );

		}

		//

		if ( this.index === null ) {

			console.warn( 'THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.' );
			return this;

		}

		const geometry2 = new BufferGeometry();

		const indices = this.index.array;
		const attributes = this.attributes;

		// attributes

		for ( const name in attributes ) {

			const attribute = attributes[ name ];

			const newAttribute = convertBufferAttribute( attribute, indices );

			geometry2.setAttribute( name, newAttribute );

		}

		// morph attributes

		const morphAttributes = this.morphAttributes;

		for ( const name in morphAttributes ) {

			const morphArray = [];
			const morphAttribute = morphAttributes[ name ]; // morphAttribute: array of Float32BufferAttributes

			for ( let i = 0, il = morphAttribute.length; i < il; i ++ ) {

				const attribute = morphAttribute[ i ];

				const newAttribute = convertBufferAttribute( attribute, indices );

				morphArray.push( newAttribute );

			}

			geometry2.morphAttributes[ name ] = morphArray;

		}

		geometry2.morphTargetsRelative = this.morphTargetsRelative;

		// groups

		const groups = this.groups;

		for ( let i = 0, l = groups.length; i < l; i ++ ) {

			const group = groups[ i ];
			geometry2.addGroup( group.start, group.count, group.materialIndex );

		}

		return geometry2;

	}

	toJSON() {

		const data = {
			metadata: {
				version: 4.6,
				type: 'BufferGeometry',
				generator: 'BufferGeometry.toJSON'
			}
		};

		// standard BufferGeometry serialization

		data.uuid = this.uuid;
		data.type = this.type;
		if ( this.name !== '' ) data.name = this.name;
		if ( Object.keys( this.userData ).length > 0 ) data.userData = this.userData;

		if ( this.parameters !== undefined ) {

			const parameters = this.parameters;

			for ( const key in parameters ) {

				if ( parameters[ key ] !== undefined ) data[ key ] = parameters[ key ];

			}

			return data;

		}

		// for simplicity the code assumes attributes are not shared across geometries, see #15811

		data.data = { attributes: {} };

		const index = this.index;

		if ( index !== null ) {

			data.data.index = {
				type: index.array.constructor.name,
				array: Array.prototype.slice.call( index.array )
			};

		}

		const attributes = this.attributes;

		for ( const key in attributes ) {

			const attribute = attributes[ key ];

			data.data.attributes[ key ] = attribute.toJSON( data.data );

		}

		const morphAttributes = {};
		let hasMorphAttributes = false;

		for ( const key in this.morphAttributes ) {

			const attributeArray = this.morphAttributes[ key ];

			const array = [];

			for ( let i = 0, il = attributeArray.length; i < il; i ++ ) {

				const attribute = attributeArray[ i ];

				array.push( attribute.toJSON( data.data ) );

			}

			if ( array.length > 0 ) {

				morphAttributes[ key ] = array;

				hasMorphAttributes = true;

			}

		}

		if ( hasMorphAttributes ) {

			data.data.morphAttributes = morphAttributes;
			data.data.morphTargetsRelative = this.morphTargetsRelative;

		}

		const groups = this.groups;

		if ( groups.length > 0 ) {

			data.data.groups = JSON.parse( JSON.stringify( groups ) );

		}

		const boundingSphere = this.boundingSphere;

		if ( boundingSphere !== null ) {

			data.data.boundingSphere = {
				center: boundingSphere.center.toArray(),
				radius: boundingSphere.radius
			};

		}

		return data;

	}

	clone() {

		return new this.constructor().copy( this );

	}

	copy( source ) {

		// reset

		this.index = null;
		this.attributes = {};
		this.morphAttributes = {};
		this.groups = [];
		this.boundingBox = null;
		this.boundingSphere = null;

		// used for storing cloned, shared data

		const data = {};

		// name

		this.name = source.name;

		// index

		const index = source.index;

		if ( index !== null ) {

			this.setIndex( index.clone( data ) );

		}

		// attributes

		const attributes = source.attributes;

		for ( const name in attributes ) {

			const attribute = attributes[ name ];
			this.setAttribute( name, attribute.clone( data ) );

		}

		// morph attributes

		const morphAttributes = source.morphAttributes;

		for ( const name in morphAttributes ) {

			const array = [];
			const morphAttribute = morphAttributes[ name ]; // morphAttribute: array of Float32BufferAttributes

			for ( let i = 0, l = morphAttribute.length; i < l; i ++ ) {

				array.push( morphAttribute[ i ].clone( data ) );

			}

			this.morphAttributes[ name ] = array;

		}

		this.morphTargetsRelative = source.morphTargetsRelative;

		// groups

		const groups = source.groups;

		for ( let i = 0, l = groups.length; i < l; i ++ ) {

			const group = groups[ i ];
			this.addGroup( group.start, group.count, group.materialIndex );

		}

		// bounding box

		const boundingBox = source.boundingBox;

		if ( boundingBox !== null ) {

			this.boundingBox = boundingBox.clone();

		}

		// bounding sphere

		const boundingSphere = source.boundingSphere;

		if ( boundingSphere !== null ) {

			this.boundingSphere = boundingSphere.clone();

		}

		// draw range

		this.drawRange.start = source.drawRange.start;
		this.drawRange.count = source.drawRange.count;

		// user data

		this.userData = source.userData;

		return this;

	}

	dispose() {

		this.dispatchEvent( { type: 'dispose' } );

	}

}

const _inverseMatrix$3 = /*@__PURE__*/ new Matrix4();
const _ray$3$1 = /*@__PURE__*/ new Ray();
const _sphere$6 = /*@__PURE__*/ new Sphere();
const _sphereHitAt = /*@__PURE__*/ new Vector3();

const _vA$1 = /*@__PURE__*/ new Vector3();
const _vB$1 = /*@__PURE__*/ new Vector3();
const _vC$1 = /*@__PURE__*/ new Vector3();

const _tempA = /*@__PURE__*/ new Vector3();
const _morphA = /*@__PURE__*/ new Vector3();

const _uvA$1 = /*@__PURE__*/ new Vector2();
const _uvB$1 = /*@__PURE__*/ new Vector2();
const _uvC$1 = /*@__PURE__*/ new Vector2();

const _normalA = /*@__PURE__*/ new Vector3();
const _normalB = /*@__PURE__*/ new Vector3();
const _normalC = /*@__PURE__*/ new Vector3();

const _intersectionPoint = /*@__PURE__*/ new Vector3();
const _intersectionPointWorld = /*@__PURE__*/ new Vector3();

class Mesh extends Object3D {

	constructor( geometry = new BufferGeometry(), material = new MeshBasicMaterial() ) {

		super();

		this.isMesh = true;

		this.type = 'Mesh';

		this.geometry = geometry;
		this.material = material;

		this.updateMorphTargets();

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		if ( source.morphTargetInfluences !== undefined ) {

			this.morphTargetInfluences = source.morphTargetInfluences.slice();

		}

		if ( source.morphTargetDictionary !== undefined ) {

			this.morphTargetDictionary = Object.assign( {}, source.morphTargetDictionary );

		}

		this.material = Array.isArray( source.material ) ? source.material.slice() : source.material;
		this.geometry = source.geometry;

		return this;

	}

	updateMorphTargets() {

		const geometry = this.geometry;

		const morphAttributes = geometry.morphAttributes;
		const keys = Object.keys( morphAttributes );

		if ( keys.length > 0 ) {

			const morphAttribute = morphAttributes[ keys[ 0 ] ];

			if ( morphAttribute !== undefined ) {

				this.morphTargetInfluences = [];
				this.morphTargetDictionary = {};

				for ( let m = 0, ml = morphAttribute.length; m < ml; m ++ ) {

					const name = morphAttribute[ m ].name || String( m );

					this.morphTargetInfluences.push( 0 );
					this.morphTargetDictionary[ name ] = m;

				}

			}

		}

	}

	getVertexPosition( index, target ) {

		const geometry = this.geometry;
		const position = geometry.attributes.position;
		const morphPosition = geometry.morphAttributes.position;
		const morphTargetsRelative = geometry.morphTargetsRelative;

		target.fromBufferAttribute( position, index );

		const morphInfluences = this.morphTargetInfluences;

		if ( morphPosition && morphInfluences ) {

			_morphA.set( 0, 0, 0 );

			for ( let i = 0, il = morphPosition.length; i < il; i ++ ) {

				const influence = morphInfluences[ i ];
				const morphAttribute = morphPosition[ i ];

				if ( influence === 0 ) continue;

				_tempA.fromBufferAttribute( morphAttribute, index );

				if ( morphTargetsRelative ) {

					_morphA.addScaledVector( _tempA, influence );

				} else {

					_morphA.addScaledVector( _tempA.sub( target ), influence );

				}

			}

			target.add( _morphA );

		}

		return target;

	}

	raycast( raycaster, intersects ) {

		const geometry = this.geometry;
		const material = this.material;
		const matrixWorld = this.matrixWorld;

		if ( material === undefined ) return;

		// test with bounding sphere in world space

		if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

		_sphere$6.copy( geometry.boundingSphere );
		_sphere$6.applyMatrix4( matrixWorld );

		// check distance from ray origin to bounding sphere

		_ray$3$1.copy( raycaster.ray ).recast( raycaster.near );

		if ( _sphere$6.containsPoint( _ray$3$1.origin ) === false ) {

			if ( _ray$3$1.intersectSphere( _sphere$6, _sphereHitAt ) === null ) return;

			if ( _ray$3$1.origin.distanceToSquared( _sphereHitAt ) > ( raycaster.far - raycaster.near ) ** 2 ) return;

		}

		// convert ray to local space of mesh

		_inverseMatrix$3.copy( matrixWorld ).invert();
		_ray$3$1.copy( raycaster.ray ).applyMatrix4( _inverseMatrix$3 );

		// test with bounding box in local space

		if ( geometry.boundingBox !== null ) {

			if ( _ray$3$1.intersectsBox( geometry.boundingBox ) === false ) return;

		}

		// test for intersections with geometry

		this._computeIntersections( raycaster, intersects, _ray$3$1 );

	}

	_computeIntersections( raycaster, intersects, rayLocalSpace ) {

		let intersection;

		const geometry = this.geometry;
		const material = this.material;

		const index = geometry.index;
		const position = geometry.attributes.position;
		const uv = geometry.attributes.uv;
		const uv1 = geometry.attributes.uv1;
		const normal = geometry.attributes.normal;
		const groups = geometry.groups;
		const drawRange = geometry.drawRange;

		if ( index !== null ) {

			// indexed buffer geometry

			if ( Array.isArray( material ) ) {

				for ( let i = 0, il = groups.length; i < il; i ++ ) {

					const group = groups[ i ];
					const groupMaterial = material[ group.materialIndex ];

					const start = Math.max( group.start, drawRange.start );
					const end = Math.min( index.count, Math.min( ( group.start + group.count ), ( drawRange.start + drawRange.count ) ) );

					for ( let j = start, jl = end; j < jl; j += 3 ) {

						const a = index.getX( j );
						const b = index.getX( j + 1 );
						const c = index.getX( j + 2 );

						intersection = checkGeometryIntersection( this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c );

						if ( intersection ) {

							intersection.faceIndex = Math.floor( j / 3 ); // triangle number in indexed buffer semantics
							intersection.face.materialIndex = group.materialIndex;
							intersects.push( intersection );

						}

					}

				}

			} else {

				const start = Math.max( 0, drawRange.start );
				const end = Math.min( index.count, ( drawRange.start + drawRange.count ) );

				for ( let i = start, il = end; i < il; i += 3 ) {

					const a = index.getX( i );
					const b = index.getX( i + 1 );
					const c = index.getX( i + 2 );

					intersection = checkGeometryIntersection( this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c );

					if ( intersection ) {

						intersection.faceIndex = Math.floor( i / 3 ); // triangle number in indexed buffer semantics
						intersects.push( intersection );

					}

				}

			}

		} else if ( position !== undefined ) {

			// non-indexed buffer geometry

			if ( Array.isArray( material ) ) {

				for ( let i = 0, il = groups.length; i < il; i ++ ) {

					const group = groups[ i ];
					const groupMaterial = material[ group.materialIndex ];

					const start = Math.max( group.start, drawRange.start );
					const end = Math.min( position.count, Math.min( ( group.start + group.count ), ( drawRange.start + drawRange.count ) ) );

					for ( let j = start, jl = end; j < jl; j += 3 ) {

						const a = j;
						const b = j + 1;
						const c = j + 2;

						intersection = checkGeometryIntersection( this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c );

						if ( intersection ) {

							intersection.faceIndex = Math.floor( j / 3 ); // triangle number in non-indexed buffer semantics
							intersection.face.materialIndex = group.materialIndex;
							intersects.push( intersection );

						}

					}

				}

			} else {

				const start = Math.max( 0, drawRange.start );
				const end = Math.min( position.count, ( drawRange.start + drawRange.count ) );

				for ( let i = start, il = end; i < il; i += 3 ) {

					const a = i;
					const b = i + 1;
					const c = i + 2;

					intersection = checkGeometryIntersection( this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c );

					if ( intersection ) {

						intersection.faceIndex = Math.floor( i / 3 ); // triangle number in non-indexed buffer semantics
						intersects.push( intersection );

					}

				}

			}

		}

	}

}

function checkIntersection$1( object, material, raycaster, ray, pA, pB, pC, point ) {

	let intersect;

	if ( material.side === BackSide ) {

		intersect = ray.intersectTriangle( pC, pB, pA, true, point );

	} else {

		intersect = ray.intersectTriangle( pA, pB, pC, ( material.side === FrontSide ), point );

	}

	if ( intersect === null ) return null;

	_intersectionPointWorld.copy( point );
	_intersectionPointWorld.applyMatrix4( object.matrixWorld );

	const distance = raycaster.ray.origin.distanceTo( _intersectionPointWorld );

	if ( distance < raycaster.near || distance > raycaster.far ) return null;

	return {
		distance: distance,
		point: _intersectionPointWorld.clone(),
		object: object
	};

}

function checkGeometryIntersection( object, material, raycaster, ray, uv, uv1, normal, a, b, c ) {

	object.getVertexPosition( a, _vA$1 );
	object.getVertexPosition( b, _vB$1 );
	object.getVertexPosition( c, _vC$1 );

	const intersection = checkIntersection$1( object, material, raycaster, ray, _vA$1, _vB$1, _vC$1, _intersectionPoint );

	if ( intersection ) {

		if ( uv ) {

			_uvA$1.fromBufferAttribute( uv, a );
			_uvB$1.fromBufferAttribute( uv, b );
			_uvC$1.fromBufferAttribute( uv, c );

			intersection.uv = Triangle.getInterpolation( _intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new Vector2() );

		}

		if ( uv1 ) {

			_uvA$1.fromBufferAttribute( uv1, a );
			_uvB$1.fromBufferAttribute( uv1, b );
			_uvC$1.fromBufferAttribute( uv1, c );

			intersection.uv1 = Triangle.getInterpolation( _intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new Vector2() );

		}

		if ( normal ) {

			_normalA.fromBufferAttribute( normal, a );
			_normalB.fromBufferAttribute( normal, b );
			_normalC.fromBufferAttribute( normal, c );

			intersection.normal = Triangle.getInterpolation( _intersectionPoint, _vA$1, _vB$1, _vC$1, _normalA, _normalB, _normalC, new Vector3() );

			if ( intersection.normal.dot( ray.direction ) > 0 ) {

				intersection.normal.multiplyScalar( - 1 );

			}

		}

		const face = {
			a: a,
			b: b,
			c: c,
			normal: new Vector3(),
			materialIndex: 0
		};

		Triangle.getNormal( _vA$1, _vB$1, _vC$1, face.normal );

		intersection.face = face;

	}

	return intersection;

}

class BoxGeometry extends BufferGeometry {

	constructor( width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1 ) {

		super();

		this.type = 'BoxGeometry';

		this.parameters = {
			width: width,
			height: height,
			depth: depth,
			widthSegments: widthSegments,
			heightSegments: heightSegments,
			depthSegments: depthSegments
		};

		const scope = this;

		// segments

		widthSegments = Math.floor( widthSegments );
		heightSegments = Math.floor( heightSegments );
		depthSegments = Math.floor( depthSegments );

		// buffers

		const indices = [];
		const vertices = [];
		const normals = [];
		const uvs = [];

		// helper variables

		let numberOfVertices = 0;
		let groupStart = 0;

		// build each side of the box geometry

		buildPlane( 'z', 'y', 'x', - 1, - 1, depth, height, width, depthSegments, heightSegments, 0 ); // px
		buildPlane( 'z', 'y', 'x', 1, - 1, depth, height, - width, depthSegments, heightSegments, 1 ); // nx
		buildPlane( 'x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2 ); // py
		buildPlane( 'x', 'z', 'y', 1, - 1, width, depth, - height, widthSegments, depthSegments, 3 ); // ny
		buildPlane( 'x', 'y', 'z', 1, - 1, width, height, depth, widthSegments, heightSegments, 4 ); // pz
		buildPlane( 'x', 'y', 'z', - 1, - 1, width, height, - depth, widthSegments, heightSegments, 5 ); // nz

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

		function buildPlane( u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex ) {

			const segmentWidth = width / gridX;
			const segmentHeight = height / gridY;

			const widthHalf = width / 2;
			const heightHalf = height / 2;
			const depthHalf = depth / 2;

			const gridX1 = gridX + 1;
			const gridY1 = gridY + 1;

			let vertexCounter = 0;
			let groupCount = 0;

			const vector = new Vector3();

			// generate vertices, normals and uvs

			for ( let iy = 0; iy < gridY1; iy ++ ) {

				const y = iy * segmentHeight - heightHalf;

				for ( let ix = 0; ix < gridX1; ix ++ ) {

					const x = ix * segmentWidth - widthHalf;

					// set values to correct vector component

					vector[ u ] = x * udir;
					vector[ v ] = y * vdir;
					vector[ w ] = depthHalf;

					// now apply vector to vertex buffer

					vertices.push( vector.x, vector.y, vector.z );

					// set values to correct vector component

					vector[ u ] = 0;
					vector[ v ] = 0;
					vector[ w ] = depth > 0 ? 1 : - 1;

					// now apply vector to normal buffer

					normals.push( vector.x, vector.y, vector.z );

					// uvs

					uvs.push( ix / gridX );
					uvs.push( 1 - ( iy / gridY ) );

					// counters

					vertexCounter += 1;

				}

			}

			// indices

			// 1. you need three indices to draw a single face
			// 2. a single segment consists of two faces
			// 3. so we need to generate six (2*3) indices per segment

			for ( let iy = 0; iy < gridY; iy ++ ) {

				for ( let ix = 0; ix < gridX; ix ++ ) {

					const a = numberOfVertices + ix + gridX1 * iy;
					const b = numberOfVertices + ix + gridX1 * ( iy + 1 );
					const c = numberOfVertices + ( ix + 1 ) + gridX1 * ( iy + 1 );
					const d = numberOfVertices + ( ix + 1 ) + gridX1 * iy;

					// faces

					indices.push( a, b, d );
					indices.push( b, c, d );

					// increase counter

					groupCount += 6;

				}

			}

			// add a group to the geometry. this will ensure multi material support

			scope.addGroup( groupStart, groupCount, materialIndex );

			// calculate new start value for groups

			groupStart += groupCount;

			// update total number of vertices

			numberOfVertices += vertexCounter;

		}

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new BoxGeometry( data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments );

	}

}

/**
 * Uniform Utilities
 */

function cloneUniforms( src ) {

	const dst = {};

	for ( const u in src ) {

		dst[ u ] = {};

		for ( const p in src[ u ] ) {

			const property = src[ u ][ p ];

			if ( property && ( property.isColor ||
				property.isMatrix3 || property.isMatrix4 ||
				property.isVector2 || property.isVector3 || property.isVector4 ||
				property.isTexture || property.isQuaternion ) ) {

				if ( property.isRenderTargetTexture ) {

					console.warn( 'UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().' );
					dst[ u ][ p ] = null;

				} else {

					dst[ u ][ p ] = property.clone();

				}

			} else if ( Array.isArray( property ) ) {

				dst[ u ][ p ] = property.slice();

			} else {

				dst[ u ][ p ] = property;

			}

		}

	}

	return dst;

}

function mergeUniforms( uniforms ) {

	const merged = {};

	for ( let u = 0; u < uniforms.length; u ++ ) {

		const tmp = cloneUniforms( uniforms[ u ] );

		for ( const p in tmp ) {

			merged[ p ] = tmp[ p ];

		}

	}

	return merged;

}

function cloneUniformsGroups( src ) {

	const dst = [];

	for ( let u = 0; u < src.length; u ++ ) {

		dst.push( src[ u ].clone() );

	}

	return dst;

}

function getUnlitUniformColorSpace( renderer ) {

	const currentRenderTarget = renderer.getRenderTarget();

	if ( currentRenderTarget === null ) {

		// https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
		return renderer.outputColorSpace;

	}

	// https://github.com/mrdoob/three.js/issues/27868
	if ( currentRenderTarget.isXRRenderTarget === true ) {

		return currentRenderTarget.texture.colorSpace;

	}

	return ColorManagement.workingColorSpace;

}

// Legacy

const UniformsUtils = { clone: cloneUniforms, merge: mergeUniforms };

var default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";

var default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";

class ShaderMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isShaderMaterial = true;

		this.type = 'ShaderMaterial';

		this.defines = {};
		this.uniforms = {};
		this.uniformsGroups = [];

		this.vertexShader = default_vertex;
		this.fragmentShader = default_fragment;

		this.linewidth = 1;

		this.wireframe = false;
		this.wireframeLinewidth = 1;

		this.fog = false; // set to use scene fog
		this.lights = false; // set to use scene lights
		this.clipping = false; // set to use user-defined clipping planes

		this.forceSinglePass = true;

		this.extensions = {
			clipCullDistance: false, // set to use vertex shader clipping
			multiDraw: false // set to use vertex shader multi_draw / enable gl_DrawID
		};

		// When rendered geometry doesn't include these attributes but the material does,
		// use these default values in WebGL. This avoids errors when buffer data is missing.
		this.defaultAttributeValues = {
			'color': [ 1, 1, 1 ],
			'uv': [ 0, 0 ],
			'uv1': [ 0, 0 ]
		};

		this.index0AttributeName = undefined;
		this.uniformsNeedUpdate = false;

		this.glslVersion = null;

		if ( parameters !== undefined ) {

			this.setValues( parameters );

		}

	}

	copy( source ) {

		super.copy( source );

		this.fragmentShader = source.fragmentShader;
		this.vertexShader = source.vertexShader;

		this.uniforms = cloneUniforms( source.uniforms );
		this.uniformsGroups = cloneUniformsGroups( source.uniformsGroups );

		this.defines = Object.assign( {}, source.defines );

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;

		this.fog = source.fog;
		this.lights = source.lights;
		this.clipping = source.clipping;

		this.extensions = Object.assign( {}, source.extensions );

		this.glslVersion = source.glslVersion;

		return this;

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		data.glslVersion = this.glslVersion;
		data.uniforms = {};

		for ( const name in this.uniforms ) {

			const uniform = this.uniforms[ name ];
			const value = uniform.value;

			if ( value && value.isTexture ) {

				data.uniforms[ name ] = {
					type: 't',
					value: value.toJSON( meta ).uuid
				};

			} else if ( value && value.isColor ) {

				data.uniforms[ name ] = {
					type: 'c',
					value: value.getHex()
				};

			} else if ( value && value.isVector2 ) {

				data.uniforms[ name ] = {
					type: 'v2',
					value: value.toArray()
				};

			} else if ( value && value.isVector3 ) {

				data.uniforms[ name ] = {
					type: 'v3',
					value: value.toArray()
				};

			} else if ( value && value.isVector4 ) {

				data.uniforms[ name ] = {
					type: 'v4',
					value: value.toArray()
				};

			} else if ( value && value.isMatrix3 ) {

				data.uniforms[ name ] = {
					type: 'm3',
					value: value.toArray()
				};

			} else if ( value && value.isMatrix4 ) {

				data.uniforms[ name ] = {
					type: 'm4',
					value: value.toArray()
				};

			} else {

				data.uniforms[ name ] = {
					value: value
				};

				// note: the array variants v2v, v3v, v4v, m4v and tv are not supported so far

			}

		}

		if ( Object.keys( this.defines ).length > 0 ) data.defines = this.defines;

		data.vertexShader = this.vertexShader;
		data.fragmentShader = this.fragmentShader;

		data.lights = this.lights;
		data.clipping = this.clipping;

		const extensions = {};

		for ( const key in this.extensions ) {

			if ( this.extensions[ key ] === true ) extensions[ key ] = true;

		}

		if ( Object.keys( extensions ).length > 0 ) data.extensions = extensions;

		return data;

	}

}

class Camera extends Object3D {

	constructor() {

		super();

		this.isCamera = true;

		this.type = 'Camera';

		this.matrixWorldInverse = new Matrix4();

		this.projectionMatrix = new Matrix4();
		this.projectionMatrixInverse = new Matrix4();

		this.coordinateSystem = WebGLCoordinateSystem;

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.matrixWorldInverse.copy( source.matrixWorldInverse );

		this.projectionMatrix.copy( source.projectionMatrix );
		this.projectionMatrixInverse.copy( source.projectionMatrixInverse );

		this.coordinateSystem = source.coordinateSystem;

		return this;

	}

	getWorldDirection( target ) {

		return super.getWorldDirection( target ).negate();

	}

	updateMatrixWorld( force ) {

		super.updateMatrixWorld( force );

		this.matrixWorldInverse.copy( this.matrixWorld ).invert();

	}

	updateWorldMatrix( updateParents, updateChildren ) {

		super.updateWorldMatrix( updateParents, updateChildren );

		this.matrixWorldInverse.copy( this.matrixWorld ).invert();

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

const _v3$1$1 = /*@__PURE__*/ new Vector3();
const _minTarget = /*@__PURE__*/ new Vector2();
const _maxTarget = /*@__PURE__*/ new Vector2();


class PerspectiveCamera extends Camera {

	constructor( fov = 50, aspect = 1, near = 0.1, far = 2000 ) {

		super();

		this.isPerspectiveCamera = true;

		this.type = 'PerspectiveCamera';

		this.fov = fov;
		this.zoom = 1;

		this.near = near;
		this.far = far;
		this.focus = 10;

		this.aspect = aspect;
		this.view = null;

		this.filmGauge = 35;	// width of the film (default in millimeters)
		this.filmOffset = 0;	// horizontal film offset (same unit as gauge)

		this.updateProjectionMatrix();

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.fov = source.fov;
		this.zoom = source.zoom;

		this.near = source.near;
		this.far = source.far;
		this.focus = source.focus;

		this.aspect = source.aspect;
		this.view = source.view === null ? null : Object.assign( {}, source.view );

		this.filmGauge = source.filmGauge;
		this.filmOffset = source.filmOffset;

		return this;

	}

	/**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */
	setFocalLength( focalLength ) {

		/** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */
		const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;

		this.fov = RAD2DEG * 2 * Math.atan( vExtentSlope );
		this.updateProjectionMatrix();

	}

	/**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */
	getFocalLength() {

		const vExtentSlope = Math.tan( DEG2RAD * 0.5 * this.fov );

		return 0.5 * this.getFilmHeight() / vExtentSlope;

	}

	getEffectiveFOV() {

		return RAD2DEG * 2 * Math.atan(
			Math.tan( DEG2RAD * 0.5 * this.fov ) / this.zoom );

	}

	getFilmWidth() {

		// film not completely covered in portrait format (aspect < 1)
		return this.filmGauge * Math.min( this.aspect, 1 );

	}

	getFilmHeight() {

		// film not completely covered in landscape format (aspect > 1)
		return this.filmGauge / Math.max( this.aspect, 1 );

	}

	/**
	 * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Sets minTarget and maxTarget to the coordinates of the lower-left and upper-right corners of the view rectangle.
	 */
	getViewBounds( distance, minTarget, maxTarget ) {

		_v3$1$1.set( - 1, - 1, 0.5 ).applyMatrix4( this.projectionMatrixInverse );

		minTarget.set( _v3$1$1.x, _v3$1$1.y ).multiplyScalar( - distance / _v3$1$1.z );

		_v3$1$1.set( 1, 1, 0.5 ).applyMatrix4( this.projectionMatrixInverse );

		maxTarget.set( _v3$1$1.x, _v3$1$1.y ).multiplyScalar( - distance / _v3$1$1.z );

	}

	/**
	 * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Copies the result into the target Vector2, where x is width and y is height.
	 */
	getViewSize( distance, target ) {

		this.getViewBounds( distance, _minTarget, _maxTarget );

		return target.subVectors( _maxTarget, _minTarget );

	}

	/**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */
	setViewOffset( fullWidth, fullHeight, x, y, width, height ) {

		this.aspect = fullWidth / fullHeight;

		if ( this.view === null ) {

			this.view = {
				enabled: true,
				fullWidth: 1,
				fullHeight: 1,
				offsetX: 0,
				offsetY: 0,
				width: 1,
				height: 1
			};

		}

		this.view.enabled = true;
		this.view.fullWidth = fullWidth;
		this.view.fullHeight = fullHeight;
		this.view.offsetX = x;
		this.view.offsetY = y;
		this.view.width = width;
		this.view.height = height;

		this.updateProjectionMatrix();

	}

	clearViewOffset() {

		if ( this.view !== null ) {

			this.view.enabled = false;

		}

		this.updateProjectionMatrix();

	}

	updateProjectionMatrix() {

		const near = this.near;
		let top = near * Math.tan( DEG2RAD * 0.5 * this.fov ) / this.zoom;
		let height = 2 * top;
		let width = this.aspect * height;
		let left = - 0.5 * width;
		const view = this.view;

		if ( this.view !== null && this.view.enabled ) {

			const fullWidth = view.fullWidth,
				fullHeight = view.fullHeight;

			left += view.offsetX * width / fullWidth;
			top -= view.offsetY * height / fullHeight;
			width *= view.width / fullWidth;
			height *= view.height / fullHeight;

		}

		const skew = this.filmOffset;
		if ( skew !== 0 ) left += near * skew / this.getFilmWidth();

		this.projectionMatrix.makePerspective( left, left + width, top, top - height, near, this.far, this.coordinateSystem );

		this.projectionMatrixInverse.copy( this.projectionMatrix ).invert();

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		data.object.fov = this.fov;
		data.object.zoom = this.zoom;

		data.object.near = this.near;
		data.object.far = this.far;
		data.object.focus = this.focus;

		data.object.aspect = this.aspect;

		if ( this.view !== null ) data.object.view = Object.assign( {}, this.view );

		data.object.filmGauge = this.filmGauge;
		data.object.filmOffset = this.filmOffset;

		return data;

	}

}

const fov = - 90; // negative fov is not an error
const aspect = 1;

class CubeCamera extends Object3D {

	constructor( near, far, renderTarget ) {

		super();

		this.type = 'CubeCamera';

		this.renderTarget = renderTarget;
		this.coordinateSystem = null;
		this.activeMipmapLevel = 0;

		const cameraPX = new PerspectiveCamera( fov, aspect, near, far );
		cameraPX.layers = this.layers;
		this.add( cameraPX );

		const cameraNX = new PerspectiveCamera( fov, aspect, near, far );
		cameraNX.layers = this.layers;
		this.add( cameraNX );

		const cameraPY = new PerspectiveCamera( fov, aspect, near, far );
		cameraPY.layers = this.layers;
		this.add( cameraPY );

		const cameraNY = new PerspectiveCamera( fov, aspect, near, far );
		cameraNY.layers = this.layers;
		this.add( cameraNY );

		const cameraPZ = new PerspectiveCamera( fov, aspect, near, far );
		cameraPZ.layers = this.layers;
		this.add( cameraPZ );

		const cameraNZ = new PerspectiveCamera( fov, aspect, near, far );
		cameraNZ.layers = this.layers;
		this.add( cameraNZ );

	}

	updateCoordinateSystem() {

		const coordinateSystem = this.coordinateSystem;

		const cameras = this.children.concat();

		const [ cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ ] = cameras;

		for ( const camera of cameras ) this.remove( camera );

		if ( coordinateSystem === WebGLCoordinateSystem ) {

			cameraPX.up.set( 0, 1, 0 );
			cameraPX.lookAt( 1, 0, 0 );

			cameraNX.up.set( 0, 1, 0 );
			cameraNX.lookAt( - 1, 0, 0 );

			cameraPY.up.set( 0, 0, - 1 );
			cameraPY.lookAt( 0, 1, 0 );

			cameraNY.up.set( 0, 0, 1 );
			cameraNY.lookAt( 0, - 1, 0 );

			cameraPZ.up.set( 0, 1, 0 );
			cameraPZ.lookAt( 0, 0, 1 );

			cameraNZ.up.set( 0, 1, 0 );
			cameraNZ.lookAt( 0, 0, - 1 );

		} else if ( coordinateSystem === WebGPUCoordinateSystem ) {

			cameraPX.up.set( 0, - 1, 0 );
			cameraPX.lookAt( - 1, 0, 0 );

			cameraNX.up.set( 0, - 1, 0 );
			cameraNX.lookAt( 1, 0, 0 );

			cameraPY.up.set( 0, 0, 1 );
			cameraPY.lookAt( 0, 1, 0 );

			cameraNY.up.set( 0, 0, - 1 );
			cameraNY.lookAt( 0, - 1, 0 );

			cameraPZ.up.set( 0, - 1, 0 );
			cameraPZ.lookAt( 0, 0, 1 );

			cameraNZ.up.set( 0, - 1, 0 );
			cameraNZ.lookAt( 0, 0, - 1 );

		} else {

			throw new Error( 'THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ' + coordinateSystem );

		}

		for ( const camera of cameras ) {

			this.add( camera );

			camera.updateMatrixWorld();

		}

	}

	update( renderer, scene ) {

		if ( this.parent === null ) this.updateMatrixWorld();

		const { renderTarget, activeMipmapLevel } = this;

		if ( this.coordinateSystem !== renderer.coordinateSystem ) {

			this.coordinateSystem = renderer.coordinateSystem;

			this.updateCoordinateSystem();

		}

		const [ cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ ] = this.children;

		const currentRenderTarget = renderer.getRenderTarget();
		const currentActiveCubeFace = renderer.getActiveCubeFace();
		const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();

		const currentXrEnabled = renderer.xr.enabled;

		renderer.xr.enabled = false;

		const generateMipmaps = renderTarget.texture.generateMipmaps;

		renderTarget.texture.generateMipmaps = false;

		renderer.setRenderTarget( renderTarget, 0, activeMipmapLevel );
		renderer.render( scene, cameraPX );

		renderer.setRenderTarget( renderTarget, 1, activeMipmapLevel );
		renderer.render( scene, cameraNX );

		renderer.setRenderTarget( renderTarget, 2, activeMipmapLevel );
		renderer.render( scene, cameraPY );

		renderer.setRenderTarget( renderTarget, 3, activeMipmapLevel );
		renderer.render( scene, cameraNY );

		renderer.setRenderTarget( renderTarget, 4, activeMipmapLevel );
		renderer.render( scene, cameraPZ );

		// mipmaps are generated during the last call of render()
		// at this point, all sides of the cube render target are defined

		renderTarget.texture.generateMipmaps = generateMipmaps;

		renderer.setRenderTarget( renderTarget, 5, activeMipmapLevel );
		renderer.render( scene, cameraNZ );

		renderer.setRenderTarget( currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel );

		renderer.xr.enabled = currentXrEnabled;

		renderTarget.texture.needsPMREMUpdate = true;

	}

}

class CubeTexture extends Texture {

	constructor( images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace ) {

		images = images !== undefined ? images : [];
		mapping = mapping !== undefined ? mapping : CubeReflectionMapping;

		super( images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace );

		this.isCubeTexture = true;

		this.flipY = false;

	}

	get images() {

		return this.image;

	}

	set images( value ) {

		this.image = value;

	}

}

class WebGLCubeRenderTarget extends WebGLRenderTarget {

	constructor( size = 1, options = {} ) {

		super( size, size, options );

		this.isWebGLCubeRenderTarget = true;

		const image = { width: size, height: size, depth: 1 };
		const images = [ image, image, image, image, image, image ];

		this.texture = new CubeTexture( images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace );

		// By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
		// in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
		// in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.

		// three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
		// and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
		// as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).

		this.texture.isRenderTargetTexture = true;

		this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
		this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : LinearFilter;

	}

	fromEquirectangularTexture( renderer, texture ) {

		this.texture.type = texture.type;
		this.texture.colorSpace = texture.colorSpace;

		this.texture.generateMipmaps = texture.generateMipmaps;
		this.texture.minFilter = texture.minFilter;
		this.texture.magFilter = texture.magFilter;

		const shader = {

			uniforms: {
				tEquirect: { value: null },
			},

			vertexShader: /* glsl */`

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,

			fragmentShader: /* glsl */`

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
		};

		const geometry = new BoxGeometry( 5, 5, 5 );

		const material = new ShaderMaterial( {

			name: 'CubemapFromEquirect',

			uniforms: cloneUniforms( shader.uniforms ),
			vertexShader: shader.vertexShader,
			fragmentShader: shader.fragmentShader,
			side: BackSide,
			blending: NoBlending

		} );

		material.uniforms.tEquirect.value = texture;

		const mesh = new Mesh( geometry, material );

		const currentMinFilter = texture.minFilter;

		// Avoid blurred poles
		if ( texture.minFilter === LinearMipmapLinearFilter ) texture.minFilter = LinearFilter;

		const camera = new CubeCamera( 1, 10, this );
		camera.update( renderer, mesh );

		texture.minFilter = currentMinFilter;

		mesh.geometry.dispose();
		mesh.material.dispose();

		return this;

	}

	clear( renderer, color, depth, stencil ) {

		const currentRenderTarget = renderer.getRenderTarget();

		for ( let i = 0; i < 6; i ++ ) {

			renderer.setRenderTarget( this, i );

			renderer.clear( color, depth, stencil );

		}

		renderer.setRenderTarget( currentRenderTarget );

	}

}

const _vector1 = /*@__PURE__*/ new Vector3();
const _vector2$2 = /*@__PURE__*/ new Vector3();
const _normalMatrix = /*@__PURE__*/ new Matrix3();

class Plane {

	constructor( normal = new Vector3( 1, 0, 0 ), constant = 0 ) {

		this.isPlane = true;

		// normal is assumed to be normalized

		this.normal = normal;
		this.constant = constant;

	}

	set( normal, constant ) {

		this.normal.copy( normal );
		this.constant = constant;

		return this;

	}

	setComponents( x, y, z, w ) {

		this.normal.set( x, y, z );
		this.constant = w;

		return this;

	}

	setFromNormalAndCoplanarPoint( normal, point ) {

		this.normal.copy( normal );
		this.constant = - point.dot( this.normal );

		return this;

	}

	setFromCoplanarPoints( a, b, c ) {

		const normal = _vector1.subVectors( c, b ).cross( _vector2$2.subVectors( a, b ) ).normalize();

		// Q: should an error be thrown if normal is zero (e.g. degenerate plane)?

		this.setFromNormalAndCoplanarPoint( normal, a );

		return this;

	}

	copy( plane ) {

		this.normal.copy( plane.normal );
		this.constant = plane.constant;

		return this;

	}

	normalize() {

		// Note: will lead to a divide by zero if the plane is invalid.

		const inverseNormalLength = 1.0 / this.normal.length();
		this.normal.multiplyScalar( inverseNormalLength );
		this.constant *= inverseNormalLength;

		return this;

	}

	negate() {

		this.constant *= - 1;
		this.normal.negate();

		return this;

	}

	distanceToPoint( point ) {

		return this.normal.dot( point ) + this.constant;

	}

	distanceToSphere( sphere ) {

		return this.distanceToPoint( sphere.center ) - sphere.radius;

	}

	projectPoint( point, target ) {

		return target.copy( point ).addScaledVector( this.normal, - this.distanceToPoint( point ) );

	}

	intersectLine( line, target ) {

		const direction = line.delta( _vector1 );

		const denominator = this.normal.dot( direction );

		if ( denominator === 0 ) {

			// line is coplanar, return origin
			if ( this.distanceToPoint( line.start ) === 0 ) {

				return target.copy( line.start );

			}

			// Unsure if this is the correct method to handle this case.
			return null;

		}

		const t = - ( line.start.dot( this.normal ) + this.constant ) / denominator;

		if ( t < 0 || t > 1 ) {

			return null;

		}

		return target.copy( line.start ).addScaledVector( direction, t );

	}

	intersectsLine( line ) {

		// Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.

		const startSign = this.distanceToPoint( line.start );
		const endSign = this.distanceToPoint( line.end );

		return ( startSign < 0 && endSign > 0 ) || ( endSign < 0 && startSign > 0 );

	}

	intersectsBox( box ) {

		return box.intersectsPlane( this );

	}

	intersectsSphere( sphere ) {

		return sphere.intersectsPlane( this );

	}

	coplanarPoint( target ) {

		return target.copy( this.normal ).multiplyScalar( - this.constant );

	}

	applyMatrix4( matrix, optionalNormalMatrix ) {

		const normalMatrix = optionalNormalMatrix || _normalMatrix.getNormalMatrix( matrix );

		const referencePoint = this.coplanarPoint( _vector1 ).applyMatrix4( matrix );

		const normal = this.normal.applyMatrix3( normalMatrix ).normalize();

		this.constant = - referencePoint.dot( normal );

		return this;

	}

	translate( offset ) {

		this.constant -= offset.dot( this.normal );

		return this;

	}

	equals( plane ) {

		return plane.normal.equals( this.normal ) && ( plane.constant === this.constant );

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

const _sphere$5 = /*@__PURE__*/ new Sphere();
const _vector$7 = /*@__PURE__*/ new Vector3();

class Frustum {

	constructor( p0 = new Plane(), p1 = new Plane(), p2 = new Plane(), p3 = new Plane(), p4 = new Plane(), p5 = new Plane() ) {

		this.planes = [ p0, p1, p2, p3, p4, p5 ];

	}

	set( p0, p1, p2, p3, p4, p5 ) {

		const planes = this.planes;

		planes[ 0 ].copy( p0 );
		planes[ 1 ].copy( p1 );
		planes[ 2 ].copy( p2 );
		planes[ 3 ].copy( p3 );
		planes[ 4 ].copy( p4 );
		planes[ 5 ].copy( p5 );

		return this;

	}

	copy( frustum ) {

		const planes = this.planes;

		for ( let i = 0; i < 6; i ++ ) {

			planes[ i ].copy( frustum.planes[ i ] );

		}

		return this;

	}

	setFromProjectionMatrix( m, coordinateSystem = WebGLCoordinateSystem ) {

		const planes = this.planes;
		const me = m.elements;
		const me0 = me[ 0 ], me1 = me[ 1 ], me2 = me[ 2 ], me3 = me[ 3 ];
		const me4 = me[ 4 ], me5 = me[ 5 ], me6 = me[ 6 ], me7 = me[ 7 ];
		const me8 = me[ 8 ], me9 = me[ 9 ], me10 = me[ 10 ], me11 = me[ 11 ];
		const me12 = me[ 12 ], me13 = me[ 13 ], me14 = me[ 14 ], me15 = me[ 15 ];

		planes[ 0 ].setComponents( me3 - me0, me7 - me4, me11 - me8, me15 - me12 ).normalize();
		planes[ 1 ].setComponents( me3 + me0, me7 + me4, me11 + me8, me15 + me12 ).normalize();
		planes[ 2 ].setComponents( me3 + me1, me7 + me5, me11 + me9, me15 + me13 ).normalize();
		planes[ 3 ].setComponents( me3 - me1, me7 - me5, me11 - me9, me15 - me13 ).normalize();
		planes[ 4 ].setComponents( me3 - me2, me7 - me6, me11 - me10, me15 - me14 ).normalize();

		if ( coordinateSystem === WebGLCoordinateSystem ) {

			planes[ 5 ].setComponents( me3 + me2, me7 + me6, me11 + me10, me15 + me14 ).normalize();

		} else if ( coordinateSystem === WebGPUCoordinateSystem ) {

			planes[ 5 ].setComponents( me2, me6, me10, me14 ).normalize();

		} else {

			throw new Error( 'THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' + coordinateSystem );

		}

		return this;

	}

	intersectsObject( object ) {

		if ( object.boundingSphere !== undefined ) {

			if ( object.boundingSphere === null ) object.computeBoundingSphere();

			_sphere$5.copy( object.boundingSphere ).applyMatrix4( object.matrixWorld );

		} else {

			const geometry = object.geometry;

			if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

			_sphere$5.copy( geometry.boundingSphere ).applyMatrix4( object.matrixWorld );

		}

		return this.intersectsSphere( _sphere$5 );

	}

	intersectsSprite( sprite ) {

		_sphere$5.center.set( 0, 0, 0 );
		_sphere$5.radius = 0.7071067811865476;
		_sphere$5.applyMatrix4( sprite.matrixWorld );

		return this.intersectsSphere( _sphere$5 );

	}

	intersectsSphere( sphere ) {

		const planes = this.planes;
		const center = sphere.center;
		const negRadius = - sphere.radius;

		for ( let i = 0; i < 6; i ++ ) {

			const distance = planes[ i ].distanceToPoint( center );

			if ( distance < negRadius ) {

				return false;

			}

		}

		return true;

	}

	intersectsBox( box ) {

		const planes = this.planes;

		for ( let i = 0; i < 6; i ++ ) {

			const plane = planes[ i ];

			// corner at max distance

			_vector$7.x = plane.normal.x > 0 ? box.max.x : box.min.x;
			_vector$7.y = plane.normal.y > 0 ? box.max.y : box.min.y;
			_vector$7.z = plane.normal.z > 0 ? box.max.z : box.min.z;

			if ( plane.distanceToPoint( _vector$7 ) < 0 ) {

				return false;

			}

		}

		return true;

	}

	containsPoint( point ) {

		const planes = this.planes;

		for ( let i = 0; i < 6; i ++ ) {

			if ( planes[ i ].distanceToPoint( point ) < 0 ) {

				return false;

			}

		}

		return true;

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

function WebGLAnimation() {

	let context = null;
	let isAnimating = false;
	let animationLoop = null;
	let requestId = null;

	function onAnimationFrame( time, frame ) {

		animationLoop( time, frame );

		requestId = context.requestAnimationFrame( onAnimationFrame );

	}

	return {

		start: function () {

			if ( isAnimating === true ) return;
			if ( animationLoop === null ) return;

			requestId = context.requestAnimationFrame( onAnimationFrame );

			isAnimating = true;

		},

		stop: function () {

			context.cancelAnimationFrame( requestId );

			isAnimating = false;

		},

		setAnimationLoop: function ( callback ) {

			animationLoop = callback;

		},

		setContext: function ( value ) {

			context = value;

		}

	};

}

function WebGLAttributes( gl ) {

	const buffers = new WeakMap();

	function createBuffer( attribute, bufferType ) {

		const array = attribute.array;
		const usage = attribute.usage;
		const size = array.byteLength;

		const buffer = gl.createBuffer();

		gl.bindBuffer( bufferType, buffer );
		gl.bufferData( bufferType, array, usage );

		attribute.onUploadCallback();

		let type;

		if ( array instanceof Float32Array ) {

			type = gl.FLOAT;

		} else if ( array instanceof Uint16Array ) {

			if ( attribute.isFloat16BufferAttribute ) {

				type = gl.HALF_FLOAT;

			} else {

				type = gl.UNSIGNED_SHORT;

			}

		} else if ( array instanceof Int16Array ) {

			type = gl.SHORT;

		} else if ( array instanceof Uint32Array ) {

			type = gl.UNSIGNED_INT;

		} else if ( array instanceof Int32Array ) {

			type = gl.INT;

		} else if ( array instanceof Int8Array ) {

			type = gl.BYTE;

		} else if ( array instanceof Uint8Array ) {

			type = gl.UNSIGNED_BYTE;

		} else if ( array instanceof Uint8ClampedArray ) {

			type = gl.UNSIGNED_BYTE;

		} else {

			throw new Error( 'THREE.WebGLAttributes: Unsupported buffer data format: ' + array );

		}

		return {
			buffer: buffer,
			type: type,
			bytesPerElement: array.BYTES_PER_ELEMENT,
			version: attribute.version,
			size: size
		};

	}

	function updateBuffer( buffer, attribute, bufferType ) {

		const array = attribute.array;
		const updateRange = attribute._updateRange; // @deprecated, r159
		const updateRanges = attribute.updateRanges;

		gl.bindBuffer( bufferType, buffer );

		if ( updateRange.count === - 1 && updateRanges.length === 0 ) {

			// Not using update ranges
			gl.bufferSubData( bufferType, 0, array );

		}

		if ( updateRanges.length !== 0 ) {

			for ( let i = 0, l = updateRanges.length; i < l; i ++ ) {

				const range = updateRanges[ i ];

				gl.bufferSubData( bufferType, range.start * array.BYTES_PER_ELEMENT,
					array, range.start, range.count );

			}

			attribute.clearUpdateRanges();

		}

		// @deprecated, r159
		if ( updateRange.count !== - 1 ) {

			gl.bufferSubData( bufferType, updateRange.offset * array.BYTES_PER_ELEMENT,
				array, updateRange.offset, updateRange.count );

			updateRange.count = - 1; // reset range

		}

		attribute.onUploadCallback();

	}

	//

	function get( attribute ) {

		if ( attribute.isInterleavedBufferAttribute ) attribute = attribute.data;

		return buffers.get( attribute );

	}

	function remove( attribute ) {

		if ( attribute.isInterleavedBufferAttribute ) attribute = attribute.data;

		const data = buffers.get( attribute );

		if ( data ) {

			gl.deleteBuffer( data.buffer );

			buffers.delete( attribute );

		}

	}

	function update( attribute, bufferType ) {

		if ( attribute.isGLBufferAttribute ) {

			const cached = buffers.get( attribute );

			if ( ! cached || cached.version < attribute.version ) {

				buffers.set( attribute, {
					buffer: attribute.buffer,
					type: attribute.type,
					bytesPerElement: attribute.elementSize,
					version: attribute.version
				} );

			}

			return;

		}

		if ( attribute.isInterleavedBufferAttribute ) attribute = attribute.data;

		const data = buffers.get( attribute );

		if ( data === undefined ) {

			buffers.set( attribute, createBuffer( attribute, bufferType ) );

		} else if ( data.version < attribute.version ) {

			if ( data.size !== attribute.array.byteLength ) {

				throw new Error( 'THREE.WebGLAttributes: The size of the buffer attribute\'s array buffer does not match the original size. Resizing buffer attributes is not supported.' );

			}

			updateBuffer( data.buffer, attribute, bufferType );

			data.version = attribute.version;

		}

	}

	return {

		get: get,
		remove: remove,
		update: update

	};

}

class PlaneGeometry extends BufferGeometry {

	constructor( width = 1, height = 1, widthSegments = 1, heightSegments = 1 ) {

		super();

		this.type = 'PlaneGeometry';

		this.parameters = {
			width: width,
			height: height,
			widthSegments: widthSegments,
			heightSegments: heightSegments
		};

		const width_half = width / 2;
		const height_half = height / 2;

		const gridX = Math.floor( widthSegments );
		const gridY = Math.floor( heightSegments );

		const gridX1 = gridX + 1;
		const gridY1 = gridY + 1;

		const segment_width = width / gridX;
		const segment_height = height / gridY;

		//

		const indices = [];
		const vertices = [];
		const normals = [];
		const uvs = [];

		for ( let iy = 0; iy < gridY1; iy ++ ) {

			const y = iy * segment_height - height_half;

			for ( let ix = 0; ix < gridX1; ix ++ ) {

				const x = ix * segment_width - width_half;

				vertices.push( x, - y, 0 );

				normals.push( 0, 0, 1 );

				uvs.push( ix / gridX );
				uvs.push( 1 - ( iy / gridY ) );

			}

		}

		for ( let iy = 0; iy < gridY; iy ++ ) {

			for ( let ix = 0; ix < gridX; ix ++ ) {

				const a = ix + gridX1 * iy;
				const b = ix + gridX1 * ( iy + 1 );
				const c = ( ix + 1 ) + gridX1 * ( iy + 1 );
				const d = ( ix + 1 ) + gridX1 * iy;

				indices.push( a, b, d );
				indices.push( b, c, d );

			}

		}

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new PlaneGeometry( data.width, data.height, data.widthSegments, data.heightSegments );

	}

}

var alphahash_fragment = "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";

var alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif";

var alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";

var alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";

var alphatest_fragment = "#ifdef USE_ALPHATEST\n\t#ifdef ALPHA_TO_COVERAGE\n\tdiffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\tif ( diffuseColor.a < alphaTest ) discard;\n\t#endif\n#endif";

var alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";

var aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";

var aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";

var batching_pars_vertex = "#ifdef USE_BATCHING\n\t#if ! defined( GL_ANGLE_multi_draw )\n\t#define gl_DrawID _gl_DrawID\n\tuniform int _gl_DrawID;\n\t#endif\n\tuniform highp sampler2D batchingTexture;\n\tuniform highp usampler2D batchingIdTexture;\n\tmat4 getBatchingMatrix( const in float i ) {\n\t\tint size = textureSize( batchingTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n\tfloat getIndirectIndex( const in int i ) {\n\t\tint size = textureSize( batchingIdTexture, 0 ).x;\n\t\tint x = i % size;\n\t\tint y = i / size;\n\t\treturn float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n\t}\n#endif\n#ifdef USE_BATCHING_COLOR\n\tuniform sampler2D batchingColorTexture;\n\tvec3 getBatchingColor( const in float i ) {\n\t\tint size = textureSize( batchingColorTexture, 0 ).x;\n\t\tint j = int( i );\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\treturn texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;\n\t}\n#endif";

var batching_vertex = "#ifdef USE_BATCHING\n\tmat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif";

var begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif";

var beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";

var bsdfs = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated";

var iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";

var bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";

var clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#ifdef ALPHA_TO_COVERAGE\n\t\tfloat distanceToPlane, distanceGradient;\n\t\tfloat clipOpacity = 1.0;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\tclipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\tif ( clipOpacity == 0.0 ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tfloat unionClipOpacity = 1.0;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\t\tunionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tclipOpacity *= 1.0 - unionClipOpacity;\n\t\t#endif\n\t\tdiffuseColor.a *= clipOpacity;\n\t\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tbool clipped = true;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tif ( clipped ) discard;\n\t\t#endif\n\t#endif\n#endif";

var clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";

var clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";

var clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";

var color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";

var color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";

var color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvarying vec3 vColor;\n#endif";

var color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif\n#ifdef USE_BATCHING_COLOR\n\tvec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );\n\tvColor.xyz *= batchingColor.xyz;\n#endif";

var common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n\tconst vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n\treturn dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";

var cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";

var defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n\tmat3 bm = mat3( batchingMatrix );\n\ttransformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n\ttransformedNormal = bm * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = bm * transformedTangent;\n\t#endif\n#endif\n#ifdef USE_INSTANCING\n\tmat3 im = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n\ttransformedNormal = im * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = im * transformedTangent;\n\t#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\ttransformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";

var displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";

var displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";

var emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";

var emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";

var colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";

var colorspace_pars_fragment = "\nconst mat3 LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = mat3(\n\tvec3( 0.8224621, 0.177538, 0.0 ),\n\tvec3( 0.0331941, 0.9668058, 0.0 ),\n\tvec3( 0.0170827, 0.0723974, 0.9105199 )\n);\nconst mat3 LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.2249401, - 0.2249404, 0.0 ),\n\tvec3( - 0.0420569, 1.0420571, 0.0 ),\n\tvec3( - 0.0196376, - 0.0786361, 1.0982735 )\n);\nvec4 LinearSRGBToLinearDisplayP3( in vec4 value ) {\n\treturn vec4( value.rgb * LINEAR_SRGB_TO_LINEAR_DISPLAY_P3, value.a );\n}\nvec4 LinearDisplayP3ToLinearSRGB( in vec4 value ) {\n\treturn vec4( value.rgb * LINEAR_DISPLAY_P3_TO_LINEAR_SRGB, value.a );\n}\nvec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn sRGBTransferOETF( value );\n}";

var envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";

var envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform mat3 envMapRotation;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";

var envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";

var envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";

var envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";

var fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";

var fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";

var fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";

var fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";

var gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";

var lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";

var lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";

var lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";

var lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif ( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";

var envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif";

var lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";

var lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";

var lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";

var lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";

var lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n\tmaterial.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tif( material.anisotropy == 0.0 ) {\n\t\tanisotropyV = vec2( 1.0, 0.0 );\n\t} else {\n\t\tanisotropyV /= material.anisotropy;\n\t\tmaterial.anisotropy = saturate( material.anisotropy );\n\t}\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";

var lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\tfloat dispersion;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn saturate(v);\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColor;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";

var lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";

var lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";

var lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";

var logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tgl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";

var logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";

var logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";

var logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvFragDepth = 1.0 + gl_Position.w;\n\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";

var map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n\t\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";

var map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";

var map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";

var map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";

var metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";

var metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";

var morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n\tfloat morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\tfloat morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tmorphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n\t}\n#endif";

var morphcolor_vertex = "#if defined( USE_MORPHCOLORS )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";

var morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";

var morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_INSTANCING_MORPH\n\t\tuniform float morphTargetBaseInfluence;\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t#endif\n\tuniform sampler2DArray morphTargetsTexture;\n\tuniform ivec2 morphTargetsTextureSize;\n\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t}\n#endif";

var morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";

var normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;";

var normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";

var normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";

var normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";

var normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";

var normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif";

var clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif";

var clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";

var clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif";

var iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";

var opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";

var packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec2 packDepthToRG( in highp float v ) {\n\treturn packDepthToRGBA( v ).yx;\n}\nfloat unpackRGToDepth( const in highp vec2 v ) {\n\treturn unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}";

var premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";

var project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n\tmvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";

var dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";

var dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";

var roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";

var roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";

var shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\t\n\t\tfloat lightToPositionLength = length( lightToPosition );\n\t\tif ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\t\tdp += shadowBias;\n\t\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\t\tshadow = (\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t\t) * ( 1.0 / 9.0 );\n\t\t\t#else\n\t\t\t\tshadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n#endif";

var shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";

var shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif";

var shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";

var skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";

var skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tint size = textureSize( boneTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif";

var skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";

var skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";

var specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";

var specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";

var tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";

var tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.6605, - 0.1246, - 0.0182 ),\n\tvec3( - 0.5876, 1.1329, - 0.1006 ),\n\tvec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n\tvec3( 0.6274, 0.0691, 0.0164 ),\n\tvec3( 0.3293, 0.9195, 0.0880 ),\n\tvec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n\tvec3 x2 = x * x;\n\tvec3 x4 = x2 * x2;\n\treturn + 15.5 * x4 * x2\n\t\t- 40.14 * x4 * x\n\t\t+ 31.96 * x4\n\t\t- 6.868 * x2 * x\n\t\t+ 0.4298 * x2\n\t\t+ 0.1191 * x\n\t\t- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n\tconst mat3 AgXInsetMatrix = mat3(\n\t\tvec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n\t\tvec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n\t\tvec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n\t);\n\tconst mat3 AgXOutsetMatrix = mat3(\n\t\tvec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n\t\tvec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n\t\tvec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n\t);\n\tconst float AgxMinEv = - 12.47393;\tconst float AgxMaxEv = 4.026069;\n\tcolor *= toneMappingExposure;\n\tcolor = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n\tcolor = AgXInsetMatrix * color;\n\tcolor = max( color, 1e-10 );\tcolor = log2( color );\n\tcolor = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n\tcolor = clamp( color, 0.0, 1.0 );\n\tcolor = agxDefaultContrastApprox( color );\n\tcolor = AgXOutsetMatrix * color;\n\tcolor = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n\tcolor = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n\tcolor = clamp( color, 0.0, 1.0 );\n\treturn color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n\tconst float StartCompression = 0.8 - 0.04;\n\tconst float Desaturation = 0.15;\n\tcolor *= toneMappingExposure;\n\tfloat x = min( color.r, min( color.g, color.b ) );\n\tfloat offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n\tcolor -= offset;\n\tfloat peak = max( color.r, max( color.g, color.b ) );\n\tif ( peak < StartCompression ) return color;\n\tfloat d = 1. - StartCompression;\n\tfloat newPeak = 1. - d * d / ( peak + d - StartCompression );\n\tcolor *= newPeak / peak;\n\tfloat g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n\treturn mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";

var transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";

var transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec4 transmittedLight;\n\t\tvec3 transmittance;\n\t\t#ifdef USE_DISPERSION\n\t\t\tfloat halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n\t\t\tvec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n\t\t\tfor ( int i = 0; i < 3; i ++ ) {\n\t\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n\t\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\n\t\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\t\trefractionCoords += 1.0;\n\t\t\t\trefractionCoords /= 2.0;\n\t\t\n\t\t\t\tvec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n\t\t\t\ttransmittedLight[ i ] = transmissionSample[ i ];\n\t\t\t\ttransmittedLight.a += transmissionSample.a;\n\t\t\t\ttransmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n\t\t\t}\n\t\t\ttransmittedLight.a /= 3.0;\n\t\t\n\t\t#else\n\t\t\n\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\trefractionCoords += 1.0;\n\t\t\trefractionCoords /= 2.0;\n\t\t\ttransmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\t\ttransmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\t\n\t\t#endif\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif";

var uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";

var uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";

var uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";

var worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_BATCHING\n\t\tworldPosition = batchingMatrix * worldPosition;\n\t#endif\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";

const vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";

const fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";

const vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";

const fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";

const vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";

const fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";

const vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";

const fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}";

const vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";

const fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";

const vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";

const fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";

const vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";

const fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";

const vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";

const fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

const vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";

const fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

const vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";

const fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

const vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";

const fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";

const vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";

const fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

const vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";

const fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n\tuniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

const vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";

const fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

const vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";

const fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";

const vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";

const fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";

const vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";

const fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";

const ShaderChunk = {
	alphahash_fragment: alphahash_fragment,
	alphahash_pars_fragment: alphahash_pars_fragment,
	alphamap_fragment: alphamap_fragment,
	alphamap_pars_fragment: alphamap_pars_fragment,
	alphatest_fragment: alphatest_fragment,
	alphatest_pars_fragment: alphatest_pars_fragment,
	aomap_fragment: aomap_fragment,
	aomap_pars_fragment: aomap_pars_fragment,
	batching_pars_vertex: batching_pars_vertex,
	batching_vertex: batching_vertex,
	begin_vertex: begin_vertex,
	beginnormal_vertex: beginnormal_vertex,
	bsdfs: bsdfs,
	iridescence_fragment: iridescence_fragment,
	bumpmap_pars_fragment: bumpmap_pars_fragment,
	clipping_planes_fragment: clipping_planes_fragment,
	clipping_planes_pars_fragment: clipping_planes_pars_fragment,
	clipping_planes_pars_vertex: clipping_planes_pars_vertex,
	clipping_planes_vertex: clipping_planes_vertex,
	color_fragment: color_fragment,
	color_pars_fragment: color_pars_fragment,
	color_pars_vertex: color_pars_vertex,
	color_vertex: color_vertex,
	common: common,
	cube_uv_reflection_fragment: cube_uv_reflection_fragment,
	defaultnormal_vertex: defaultnormal_vertex,
	displacementmap_pars_vertex: displacementmap_pars_vertex,
	displacementmap_vertex: displacementmap_vertex,
	emissivemap_fragment: emissivemap_fragment,
	emissivemap_pars_fragment: emissivemap_pars_fragment,
	colorspace_fragment: colorspace_fragment,
	colorspace_pars_fragment: colorspace_pars_fragment,
	envmap_fragment: envmap_fragment,
	envmap_common_pars_fragment: envmap_common_pars_fragment,
	envmap_pars_fragment: envmap_pars_fragment,
	envmap_pars_vertex: envmap_pars_vertex,
	envmap_physical_pars_fragment: envmap_physical_pars_fragment,
	envmap_vertex: envmap_vertex,
	fog_vertex: fog_vertex,
	fog_pars_vertex: fog_pars_vertex,
	fog_fragment: fog_fragment,
	fog_pars_fragment: fog_pars_fragment,
	gradientmap_pars_fragment: gradientmap_pars_fragment,
	lightmap_pars_fragment: lightmap_pars_fragment,
	lights_lambert_fragment: lights_lambert_fragment,
	lights_lambert_pars_fragment: lights_lambert_pars_fragment,
	lights_pars_begin: lights_pars_begin,
	lights_toon_fragment: lights_toon_fragment,
	lights_toon_pars_fragment: lights_toon_pars_fragment,
	lights_phong_fragment: lights_phong_fragment,
	lights_phong_pars_fragment: lights_phong_pars_fragment,
	lights_physical_fragment: lights_physical_fragment,
	lights_physical_pars_fragment: lights_physical_pars_fragment,
	lights_fragment_begin: lights_fragment_begin,
	lights_fragment_maps: lights_fragment_maps,
	lights_fragment_end: lights_fragment_end,
	logdepthbuf_fragment: logdepthbuf_fragment,
	logdepthbuf_pars_fragment: logdepthbuf_pars_fragment,
	logdepthbuf_pars_vertex: logdepthbuf_pars_vertex,
	logdepthbuf_vertex: logdepthbuf_vertex,
	map_fragment: map_fragment,
	map_pars_fragment: map_pars_fragment,
	map_particle_fragment: map_particle_fragment,
	map_particle_pars_fragment: map_particle_pars_fragment,
	metalnessmap_fragment: metalnessmap_fragment,
	metalnessmap_pars_fragment: metalnessmap_pars_fragment,
	morphinstance_vertex: morphinstance_vertex,
	morphcolor_vertex: morphcolor_vertex,
	morphnormal_vertex: morphnormal_vertex,
	morphtarget_pars_vertex: morphtarget_pars_vertex,
	morphtarget_vertex: morphtarget_vertex,
	normal_fragment_begin: normal_fragment_begin,
	normal_fragment_maps: normal_fragment_maps,
	normal_pars_fragment: normal_pars_fragment,
	normal_pars_vertex: normal_pars_vertex,
	normal_vertex: normal_vertex,
	normalmap_pars_fragment: normalmap_pars_fragment,
	clearcoat_normal_fragment_begin: clearcoat_normal_fragment_begin,
	clearcoat_normal_fragment_maps: clearcoat_normal_fragment_maps,
	clearcoat_pars_fragment: clearcoat_pars_fragment,
	iridescence_pars_fragment: iridescence_pars_fragment,
	opaque_fragment: opaque_fragment,
	packing: packing,
	premultiplied_alpha_fragment: premultiplied_alpha_fragment,
	project_vertex: project_vertex,
	dithering_fragment: dithering_fragment,
	dithering_pars_fragment: dithering_pars_fragment,
	roughnessmap_fragment: roughnessmap_fragment,
	roughnessmap_pars_fragment: roughnessmap_pars_fragment,
	shadowmap_pars_fragment: shadowmap_pars_fragment,
	shadowmap_pars_vertex: shadowmap_pars_vertex,
	shadowmap_vertex: shadowmap_vertex,
	shadowmask_pars_fragment: shadowmask_pars_fragment,
	skinbase_vertex: skinbase_vertex,
	skinning_pars_vertex: skinning_pars_vertex,
	skinning_vertex: skinning_vertex,
	skinnormal_vertex: skinnormal_vertex,
	specularmap_fragment: specularmap_fragment,
	specularmap_pars_fragment: specularmap_pars_fragment,
	tonemapping_fragment: tonemapping_fragment,
	tonemapping_pars_fragment: tonemapping_pars_fragment,
	transmission_fragment: transmission_fragment,
	transmission_pars_fragment: transmission_pars_fragment,
	uv_pars_fragment: uv_pars_fragment,
	uv_pars_vertex: uv_pars_vertex,
	uv_vertex: uv_vertex,
	worldpos_vertex: worldpos_vertex,

	background_vert: vertex$h,
	background_frag: fragment$h,
	backgroundCube_vert: vertex$g,
	backgroundCube_frag: fragment$g,
	cube_vert: vertex$f,
	cube_frag: fragment$f,
	depth_vert: vertex$e,
	depth_frag: fragment$e,
	distanceRGBA_vert: vertex$d,
	distanceRGBA_frag: fragment$d,
	equirect_vert: vertex$c,
	equirect_frag: fragment$c,
	linedashed_vert: vertex$b,
	linedashed_frag: fragment$b,
	meshbasic_vert: vertex$a,
	meshbasic_frag: fragment$a,
	meshlambert_vert: vertex$9,
	meshlambert_frag: fragment$9,
	meshmatcap_vert: vertex$8,
	meshmatcap_frag: fragment$8,
	meshnormal_vert: vertex$7,
	meshnormal_frag: fragment$7,
	meshphong_vert: vertex$6,
	meshphong_frag: fragment$6,
	meshphysical_vert: vertex$5,
	meshphysical_frag: fragment$5,
	meshtoon_vert: vertex$4,
	meshtoon_frag: fragment$4,
	points_vert: vertex$3,
	points_frag: fragment$3,
	shadow_vert: vertex$2,
	shadow_frag: fragment$2,
	sprite_vert: vertex$1,
	sprite_frag: fragment$1
};

/**
 * Uniforms library for shared webgl shaders
 */

const UniformsLib = {

	common: {

		diffuse: { value: /*@__PURE__*/ new Color( 0xffffff ) },
		opacity: { value: 1.0 },

		map: { value: null },
		mapTransform: { value: /*@__PURE__*/ new Matrix3() },

		alphaMap: { value: null },
		alphaMapTransform: { value: /*@__PURE__*/ new Matrix3() },

		alphaTest: { value: 0 }

	},

	specularmap: {

		specularMap: { value: null },
		specularMapTransform: { value: /*@__PURE__*/ new Matrix3() }

	},

	envmap: {

		envMap: { value: null },
		envMapRotation: { value: /*@__PURE__*/ new Matrix3() },
		flipEnvMap: { value: - 1 },
		reflectivity: { value: 1.0 }, // basic, lambert, phong
		ior: { value: 1.5 }, // physical
		refractionRatio: { value: 0.98 }, // basic, lambert, phong

	},

	aomap: {

		aoMap: { value: null },
		aoMapIntensity: { value: 1 },
		aoMapTransform: { value: /*@__PURE__*/ new Matrix3() }

	},

	lightmap: {

		lightMap: { value: null },
		lightMapIntensity: { value: 1 },
		lightMapTransform: { value: /*@__PURE__*/ new Matrix3() }

	},

	bumpmap: {

		bumpMap: { value: null },
		bumpMapTransform: { value: /*@__PURE__*/ new Matrix3() },
		bumpScale: { value: 1 }

	},

	normalmap: {

		normalMap: { value: null },
		normalMapTransform: { value: /*@__PURE__*/ new Matrix3() },
		normalScale: { value: /*@__PURE__*/ new Vector2( 1, 1 ) }

	},

	displacementmap: {

		displacementMap: { value: null },
		displacementMapTransform: { value: /*@__PURE__*/ new Matrix3() },
		displacementScale: { value: 1 },
		displacementBias: { value: 0 }

	},

	emissivemap: {

		emissiveMap: { value: null },
		emissiveMapTransform: { value: /*@__PURE__*/ new Matrix3() }

	},

	metalnessmap: {

		metalnessMap: { value: null },
		metalnessMapTransform: { value: /*@__PURE__*/ new Matrix3() }

	},

	roughnessmap: {

		roughnessMap: { value: null },
		roughnessMapTransform: { value: /*@__PURE__*/ new Matrix3() }

	},

	gradientmap: {

		gradientMap: { value: null }

	},

	fog: {

		fogDensity: { value: 0.00025 },
		fogNear: { value: 1 },
		fogFar: { value: 2000 },
		fogColor: { value: /*@__PURE__*/ new Color( 0xffffff ) }

	},

	lights: {

		ambientLightColor: { value: [] },

		lightProbe: { value: [] },

		directionalLights: { value: [], properties: {
			direction: {},
			color: {}
		} },

		directionalLightShadows: { value: [], properties: {
			shadowIntensity: 1,
			shadowBias: {},
			shadowNormalBias: {},
			shadowRadius: {},
			shadowMapSize: {}
		} },

		directionalShadowMap: { value: [] },
		directionalShadowMatrix: { value: [] },

		spotLights: { value: [], properties: {
			color: {},
			position: {},
			direction: {},
			distance: {},
			coneCos: {},
			penumbraCos: {},
			decay: {}
		} },

		spotLightShadows: { value: [], properties: {
			shadowIntensity: 1,
			shadowBias: {},
			shadowNormalBias: {},
			shadowRadius: {},
			shadowMapSize: {}
		} },

		spotLightMap: { value: [] },
		spotShadowMap: { value: [] },
		spotLightMatrix: { value: [] },

		pointLights: { value: [], properties: {
			color: {},
			position: {},
			decay: {},
			distance: {}
		} },

		pointLightShadows: { value: [], properties: {
			shadowIntensity: 1,
			shadowBias: {},
			shadowNormalBias: {},
			shadowRadius: {},
			shadowMapSize: {},
			shadowCameraNear: {},
			shadowCameraFar: {}
		} },

		pointShadowMap: { value: [] },
		pointShadowMatrix: { value: [] },

		hemisphereLights: { value: [], properties: {
			direction: {},
			skyColor: {},
			groundColor: {}
		} },

		// TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
		rectAreaLights: { value: [], properties: {
			color: {},
			position: {},
			width: {},
			height: {}
		} },

		ltc_1: { value: null },
		ltc_2: { value: null }

	},

	points: {

		diffuse: { value: /*@__PURE__*/ new Color( 0xffffff ) },
		opacity: { value: 1.0 },
		size: { value: 1.0 },
		scale: { value: 1.0 },
		map: { value: null },
		alphaMap: { value: null },
		alphaMapTransform: { value: /*@__PURE__*/ new Matrix3() },
		alphaTest: { value: 0 },
		uvTransform: { value: /*@__PURE__*/ new Matrix3() }

	},

	sprite: {

		diffuse: { value: /*@__PURE__*/ new Color( 0xffffff ) },
		opacity: { value: 1.0 },
		center: { value: /*@__PURE__*/ new Vector2( 0.5, 0.5 ) },
		rotation: { value: 0.0 },
		map: { value: null },
		mapTransform: { value: /*@__PURE__*/ new Matrix3() },
		alphaMap: { value: null },
		alphaMapTransform: { value: /*@__PURE__*/ new Matrix3() },
		alphaTest: { value: 0 }

	}

};

const ShaderLib = {

	basic: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.specularmap,
			UniformsLib.envmap,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.fog
		] ),

		vertexShader: ShaderChunk.meshbasic_vert,
		fragmentShader: ShaderChunk.meshbasic_frag

	},

	lambert: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.specularmap,
			UniformsLib.envmap,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.emissivemap,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			UniformsLib.fog,
			UniformsLib.lights,
			{
				emissive: { value: /*@__PURE__*/ new Color( 0x000000 ) }
			}
		] ),

		vertexShader: ShaderChunk.meshlambert_vert,
		fragmentShader: ShaderChunk.meshlambert_frag

	},

	phong: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.specularmap,
			UniformsLib.envmap,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.emissivemap,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			UniformsLib.fog,
			UniformsLib.lights,
			{
				emissive: { value: /*@__PURE__*/ new Color( 0x000000 ) },
				specular: { value: /*@__PURE__*/ new Color( 0x111111 ) },
				shininess: { value: 30 }
			}
		] ),

		vertexShader: ShaderChunk.meshphong_vert,
		fragmentShader: ShaderChunk.meshphong_frag

	},

	standard: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.envmap,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.emissivemap,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			UniformsLib.roughnessmap,
			UniformsLib.metalnessmap,
			UniformsLib.fog,
			UniformsLib.lights,
			{
				emissive: { value: /*@__PURE__*/ new Color( 0x000000 ) },
				roughness: { value: 1.0 },
				metalness: { value: 0.0 },
				envMapIntensity: { value: 1 }
			}
		] ),

		vertexShader: ShaderChunk.meshphysical_vert,
		fragmentShader: ShaderChunk.meshphysical_frag

	},

	toon: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.aomap,
			UniformsLib.lightmap,
			UniformsLib.emissivemap,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			UniformsLib.gradientmap,
			UniformsLib.fog,
			UniformsLib.lights,
			{
				emissive: { value: /*@__PURE__*/ new Color( 0x000000 ) }
			}
		] ),

		vertexShader: ShaderChunk.meshtoon_vert,
		fragmentShader: ShaderChunk.meshtoon_frag

	},

	matcap: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			UniformsLib.fog,
			{
				matcap: { value: null }
			}
		] ),

		vertexShader: ShaderChunk.meshmatcap_vert,
		fragmentShader: ShaderChunk.meshmatcap_frag

	},

	points: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.points,
			UniformsLib.fog
		] ),

		vertexShader: ShaderChunk.points_vert,
		fragmentShader: ShaderChunk.points_frag

	},

	dashed: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.fog,
			{
				scale: { value: 1 },
				dashSize: { value: 1 },
				totalSize: { value: 2 }
			}
		] ),

		vertexShader: ShaderChunk.linedashed_vert,
		fragmentShader: ShaderChunk.linedashed_frag

	},

	depth: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.displacementmap
		] ),

		vertexShader: ShaderChunk.depth_vert,
		fragmentShader: ShaderChunk.depth_frag

	},

	normal: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.bumpmap,
			UniformsLib.normalmap,
			UniformsLib.displacementmap,
			{
				opacity: { value: 1.0 }
			}
		] ),

		vertexShader: ShaderChunk.meshnormal_vert,
		fragmentShader: ShaderChunk.meshnormal_frag

	},

	sprite: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.sprite,
			UniformsLib.fog
		] ),

		vertexShader: ShaderChunk.sprite_vert,
		fragmentShader: ShaderChunk.sprite_frag

	},

	background: {

		uniforms: {
			uvTransform: { value: /*@__PURE__*/ new Matrix3() },
			t2D: { value: null },
			backgroundIntensity: { value: 1 }
		},

		vertexShader: ShaderChunk.background_vert,
		fragmentShader: ShaderChunk.background_frag

	},

	backgroundCube: {

		uniforms: {
			envMap: { value: null },
			flipEnvMap: { value: - 1 },
			backgroundBlurriness: { value: 0 },
			backgroundIntensity: { value: 1 },
			backgroundRotation: { value: /*@__PURE__*/ new Matrix3() }
		},

		vertexShader: ShaderChunk.backgroundCube_vert,
		fragmentShader: ShaderChunk.backgroundCube_frag

	},

	cube: {

		uniforms: {
			tCube: { value: null },
			tFlip: { value: - 1 },
			opacity: { value: 1.0 }
		},

		vertexShader: ShaderChunk.cube_vert,
		fragmentShader: ShaderChunk.cube_frag

	},

	equirect: {

		uniforms: {
			tEquirect: { value: null },
		},

		vertexShader: ShaderChunk.equirect_vert,
		fragmentShader: ShaderChunk.equirect_frag

	},

	distanceRGBA: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.common,
			UniformsLib.displacementmap,
			{
				referencePosition: { value: /*@__PURE__*/ new Vector3() },
				nearDistance: { value: 1 },
				farDistance: { value: 1000 }
			}
		] ),

		vertexShader: ShaderChunk.distanceRGBA_vert,
		fragmentShader: ShaderChunk.distanceRGBA_frag

	},

	shadow: {

		uniforms: /*@__PURE__*/ mergeUniforms( [
			UniformsLib.lights,
			UniformsLib.fog,
			{
				color: { value: /*@__PURE__*/ new Color( 0x00000 ) },
				opacity: { value: 1.0 }
			},
		] ),

		vertexShader: ShaderChunk.shadow_vert,
		fragmentShader: ShaderChunk.shadow_frag

	}

};

ShaderLib.physical = {

	uniforms: /*@__PURE__*/ mergeUniforms( [
		ShaderLib.standard.uniforms,
		{
			clearcoat: { value: 0 },
			clearcoatMap: { value: null },
			clearcoatMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			clearcoatNormalMap: { value: null },
			clearcoatNormalMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			clearcoatNormalScale: { value: /*@__PURE__*/ new Vector2( 1, 1 ) },
			clearcoatRoughness: { value: 0 },
			clearcoatRoughnessMap: { value: null },
			clearcoatRoughnessMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			dispersion: { value: 0 },
			iridescence: { value: 0 },
			iridescenceMap: { value: null },
			iridescenceMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			iridescenceIOR: { value: 1.3 },
			iridescenceThicknessMinimum: { value: 100 },
			iridescenceThicknessMaximum: { value: 400 },
			iridescenceThicknessMap: { value: null },
			iridescenceThicknessMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			sheen: { value: 0 },
			sheenColor: { value: /*@__PURE__*/ new Color( 0x000000 ) },
			sheenColorMap: { value: null },
			sheenColorMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			sheenRoughness: { value: 1 },
			sheenRoughnessMap: { value: null },
			sheenRoughnessMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			transmission: { value: 0 },
			transmissionMap: { value: null },
			transmissionMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			transmissionSamplerSize: { value: /*@__PURE__*/ new Vector2() },
			transmissionSamplerMap: { value: null },
			thickness: { value: 0 },
			thicknessMap: { value: null },
			thicknessMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			attenuationDistance: { value: 0 },
			attenuationColor: { value: /*@__PURE__*/ new Color( 0x000000 ) },
			specularColor: { value: /*@__PURE__*/ new Color( 1, 1, 1 ) },
			specularColorMap: { value: null },
			specularColorMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			specularIntensity: { value: 1 },
			specularIntensityMap: { value: null },
			specularIntensityMapTransform: { value: /*@__PURE__*/ new Matrix3() },
			anisotropyVector: { value: /*@__PURE__*/ new Vector2() },
			anisotropyMap: { value: null },
			anisotropyMapTransform: { value: /*@__PURE__*/ new Matrix3() },
		}
	] ),

	vertexShader: ShaderChunk.meshphysical_vert,
	fragmentShader: ShaderChunk.meshphysical_frag

};

const _rgb = { r: 0, b: 0, g: 0 };
const _e1$1 = /*@__PURE__*/ new Euler();
const _m1$1 = /*@__PURE__*/ new Matrix4();

function WebGLBackground( renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha ) {

	const clearColor = new Color( 0x000000 );
	let clearAlpha = alpha === true ? 0 : 1;

	let planeMesh;
	let boxMesh;

	let currentBackground = null;
	let currentBackgroundVersion = 0;
	let currentTonemapping = null;

	function getBackground( scene ) {

		let background = scene.isScene === true ? scene.background : null;

		if ( background && background.isTexture ) {

			const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
			background = ( usePMREM ? cubeuvmaps : cubemaps ).get( background );

		}

		return background;

	}

	function render( scene ) {

		let forceClear = false;
		const background = getBackground( scene );

		if ( background === null ) {

			setClear( clearColor, clearAlpha );

		} else if ( background && background.isColor ) {

			setClear( background, 1 );
			forceClear = true;

		}

		const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();

		if ( environmentBlendMode === 'additive' ) {

			state.buffers.color.setClear( 0, 0, 0, 1, premultipliedAlpha );

		} else if ( environmentBlendMode === 'alpha-blend' ) {

			state.buffers.color.setClear( 0, 0, 0, 0, premultipliedAlpha );

		}

		if ( renderer.autoClear || forceClear ) {

			// buffers might not be writable which is required to ensure a correct clear

			state.buffers.depth.setTest( true );
			state.buffers.depth.setMask( true );
			state.buffers.color.setMask( true );

			renderer.clear( renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil );

		}

	}

	function addToRenderList( renderList, scene ) {

		const background = getBackground( scene );

		if ( background && ( background.isCubeTexture || background.mapping === CubeUVReflectionMapping ) ) {

			if ( boxMesh === undefined ) {

				boxMesh = new Mesh(
					new BoxGeometry( 1, 1, 1 ),
					new ShaderMaterial( {
						name: 'BackgroundCubeMaterial',
						uniforms: cloneUniforms( ShaderLib.backgroundCube.uniforms ),
						vertexShader: ShaderLib.backgroundCube.vertexShader,
						fragmentShader: ShaderLib.backgroundCube.fragmentShader,
						side: BackSide,
						depthTest: false,
						depthWrite: false,
						fog: false
					} )
				);

				boxMesh.geometry.deleteAttribute( 'normal' );
				boxMesh.geometry.deleteAttribute( 'uv' );

				boxMesh.onBeforeRender = function ( renderer, scene, camera ) {

					this.matrixWorld.copyPosition( camera.matrixWorld );

				};

				// add "envMap" material property so the renderer can evaluate it like for built-in materials
				Object.defineProperty( boxMesh.material, 'envMap', {

					get: function () {

						return this.uniforms.envMap.value;

					}

				} );

				objects.update( boxMesh );

			}

			_e1$1.copy( scene.backgroundRotation );

			// accommodate left-handed frame
			_e1$1.x *= - 1; _e1$1.y *= - 1; _e1$1.z *= - 1;

			if ( background.isCubeTexture && background.isRenderTargetTexture === false ) {

				// environment maps which are not cube render targets or PMREMs follow a different convention
				_e1$1.y *= - 1;
				_e1$1.z *= - 1;

			}

			boxMesh.material.uniforms.envMap.value = background;
			boxMesh.material.uniforms.flipEnvMap.value = ( background.isCubeTexture && background.isRenderTargetTexture === false ) ? - 1 : 1;
			boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
			boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
			boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4( _m1$1.makeRotationFromEuler( _e1$1 ) );
			boxMesh.material.toneMapped = ColorManagement.getTransfer( background.colorSpace ) !== SRGBTransfer;

			if ( currentBackground !== background ||
				currentBackgroundVersion !== background.version ||
				currentTonemapping !== renderer.toneMapping ) {

				boxMesh.material.needsUpdate = true;

				currentBackground = background;
				currentBackgroundVersion = background.version;
				currentTonemapping = renderer.toneMapping;

			}

			boxMesh.layers.enableAll();

			// push to the pre-sorted opaque render list
			renderList.unshift( boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null );

		} else if ( background && background.isTexture ) {

			if ( planeMesh === undefined ) {

				planeMesh = new Mesh(
					new PlaneGeometry( 2, 2 ),
					new ShaderMaterial( {
						name: 'BackgroundMaterial',
						uniforms: cloneUniforms( ShaderLib.background.uniforms ),
						vertexShader: ShaderLib.background.vertexShader,
						fragmentShader: ShaderLib.background.fragmentShader,
						side: FrontSide,
						depthTest: false,
						depthWrite: false,
						fog: false
					} )
				);

				planeMesh.geometry.deleteAttribute( 'normal' );

				// add "map" material property so the renderer can evaluate it like for built-in materials
				Object.defineProperty( planeMesh.material, 'map', {

					get: function () {

						return this.uniforms.t2D.value;

					}

				} );

				objects.update( planeMesh );

			}

			planeMesh.material.uniforms.t2D.value = background;
			planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
			planeMesh.material.toneMapped = ColorManagement.getTransfer( background.colorSpace ) !== SRGBTransfer;

			if ( background.matrixAutoUpdate === true ) {

				background.updateMatrix();

			}

			planeMesh.material.uniforms.uvTransform.value.copy( background.matrix );

			if ( currentBackground !== background ||
				currentBackgroundVersion !== background.version ||
				currentTonemapping !== renderer.toneMapping ) {

				planeMesh.material.needsUpdate = true;

				currentBackground = background;
				currentBackgroundVersion = background.version;
				currentTonemapping = renderer.toneMapping;

			}

			planeMesh.layers.enableAll();

			// push to the pre-sorted opaque render list
			renderList.unshift( planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null );

		}

	}

	function setClear( color, alpha ) {

		color.getRGB( _rgb, getUnlitUniformColorSpace( renderer ) );

		state.buffers.color.setClear( _rgb.r, _rgb.g, _rgb.b, alpha, premultipliedAlpha );

	}

	return {

		getClearColor: function () {

			return clearColor;

		},
		setClearColor: function ( color, alpha = 1 ) {

			clearColor.set( color );
			clearAlpha = alpha;
			setClear( clearColor, clearAlpha );

		},
		getClearAlpha: function () {

			return clearAlpha;

		},
		setClearAlpha: function ( alpha ) {

			clearAlpha = alpha;
			setClear( clearColor, clearAlpha );

		},
		render: render,
		addToRenderList: addToRenderList

	};

}

function WebGLBindingStates( gl, attributes ) {

	const maxVertexAttributes = gl.getParameter( gl.MAX_VERTEX_ATTRIBS );

	const bindingStates = {};

	const defaultState = createBindingState( null );
	let currentState = defaultState;
	let forceUpdate = false;

	function setup( object, material, program, geometry, index ) {

		let updateBuffers = false;

		const state = getBindingState( geometry, program, material );

		if ( currentState !== state ) {

			currentState = state;
			bindVertexArrayObject( currentState.object );

		}

		updateBuffers = needsUpdate( object, geometry, program, index );

		if ( updateBuffers ) saveCache( object, geometry, program, index );

		if ( index !== null ) {

			attributes.update( index, gl.ELEMENT_ARRAY_BUFFER );

		}

		if ( updateBuffers || forceUpdate ) {

			forceUpdate = false;

			setupVertexAttributes( object, material, program, geometry );

			if ( index !== null ) {

				gl.bindBuffer( gl.ELEMENT_ARRAY_BUFFER, attributes.get( index ).buffer );

			}

		}

	}

	function createVertexArrayObject() {

		return gl.createVertexArray();

	}

	function bindVertexArrayObject( vao ) {

		return gl.bindVertexArray( vao );

	}

	function deleteVertexArrayObject( vao ) {

		return gl.deleteVertexArray( vao );

	}

	function getBindingState( geometry, program, material ) {

		const wireframe = ( material.wireframe === true );

		let programMap = bindingStates[ geometry.id ];

		if ( programMap === undefined ) {

			programMap = {};
			bindingStates[ geometry.id ] = programMap;

		}

		let stateMap = programMap[ program.id ];

		if ( stateMap === undefined ) {

			stateMap = {};
			programMap[ program.id ] = stateMap;

		}

		let state = stateMap[ wireframe ];

		if ( state === undefined ) {

			state = createBindingState( createVertexArrayObject() );
			stateMap[ wireframe ] = state;

		}

		return state;

	}

	function createBindingState( vao ) {

		const newAttributes = [];
		const enabledAttributes = [];
		const attributeDivisors = [];

		for ( let i = 0; i < maxVertexAttributes; i ++ ) {

			newAttributes[ i ] = 0;
			enabledAttributes[ i ] = 0;
			attributeDivisors[ i ] = 0;

		}

		return {

			// for backward compatibility on non-VAO support browser
			geometry: null,
			program: null,
			wireframe: false,

			newAttributes: newAttributes,
			enabledAttributes: enabledAttributes,
			attributeDivisors: attributeDivisors,
			object: vao,
			attributes: {},
			index: null

		};

	}

	function needsUpdate( object, geometry, program, index ) {

		const cachedAttributes = currentState.attributes;
		const geometryAttributes = geometry.attributes;

		let attributesNum = 0;

		const programAttributes = program.getAttributes();

		for ( const name in programAttributes ) {

			const programAttribute = programAttributes[ name ];

			if ( programAttribute.location >= 0 ) {

				const cachedAttribute = cachedAttributes[ name ];
				let geometryAttribute = geometryAttributes[ name ];

				if ( geometryAttribute === undefined ) {

					if ( name === 'instanceMatrix' && object.instanceMatrix ) geometryAttribute = object.instanceMatrix;
					if ( name === 'instanceColor' && object.instanceColor ) geometryAttribute = object.instanceColor;

				}

				if ( cachedAttribute === undefined ) return true;

				if ( cachedAttribute.attribute !== geometryAttribute ) return true;

				if ( geometryAttribute && cachedAttribute.data !== geometryAttribute.data ) return true;

				attributesNum ++;

			}

		}

		if ( currentState.attributesNum !== attributesNum ) return true;

		if ( currentState.index !== index ) return true;

		return false;

	}

	function saveCache( object, geometry, program, index ) {

		const cache = {};
		const attributes = geometry.attributes;
		let attributesNum = 0;

		const programAttributes = program.getAttributes();

		for ( const name in programAttributes ) {

			const programAttribute = programAttributes[ name ];

			if ( programAttribute.location >= 0 ) {

				let attribute = attributes[ name ];

				if ( attribute === undefined ) {

					if ( name === 'instanceMatrix' && object.instanceMatrix ) attribute = object.instanceMatrix;
					if ( name === 'instanceColor' && object.instanceColor ) attribute = object.instanceColor;

				}

				const data = {};
				data.attribute = attribute;

				if ( attribute && attribute.data ) {

					data.data = attribute.data;

				}

				cache[ name ] = data;

				attributesNum ++;

			}

		}

		currentState.attributes = cache;
		currentState.attributesNum = attributesNum;

		currentState.index = index;

	}

	function initAttributes() {

		const newAttributes = currentState.newAttributes;

		for ( let i = 0, il = newAttributes.length; i < il; i ++ ) {

			newAttributes[ i ] = 0;

		}

	}

	function enableAttribute( attribute ) {

		enableAttributeAndDivisor( attribute, 0 );

	}

	function enableAttributeAndDivisor( attribute, meshPerAttribute ) {

		const newAttributes = currentState.newAttributes;
		const enabledAttributes = currentState.enabledAttributes;
		const attributeDivisors = currentState.attributeDivisors;

		newAttributes[ attribute ] = 1;

		if ( enabledAttributes[ attribute ] === 0 ) {

			gl.enableVertexAttribArray( attribute );
			enabledAttributes[ attribute ] = 1;

		}

		if ( attributeDivisors[ attribute ] !== meshPerAttribute ) {

			gl.vertexAttribDivisor( attribute, meshPerAttribute );
			attributeDivisors[ attribute ] = meshPerAttribute;

		}

	}

	function disableUnusedAttributes() {

		const newAttributes = currentState.newAttributes;
		const enabledAttributes = currentState.enabledAttributes;

		for ( let i = 0, il = enabledAttributes.length; i < il; i ++ ) {

			if ( enabledAttributes[ i ] !== newAttributes[ i ] ) {

				gl.disableVertexAttribArray( i );
				enabledAttributes[ i ] = 0;

			}

		}

	}

	function vertexAttribPointer( index, size, type, normalized, stride, offset, integer ) {

		if ( integer === true ) {

			gl.vertexAttribIPointer( index, size, type, stride, offset );

		} else {

			gl.vertexAttribPointer( index, size, type, normalized, stride, offset );

		}

	}

	function setupVertexAttributes( object, material, program, geometry ) {

		initAttributes();

		const geometryAttributes = geometry.attributes;

		const programAttributes = program.getAttributes();

		const materialDefaultAttributeValues = material.defaultAttributeValues;

		for ( const name in programAttributes ) {

			const programAttribute = programAttributes[ name ];

			if ( programAttribute.location >= 0 ) {

				let geometryAttribute = geometryAttributes[ name ];

				if ( geometryAttribute === undefined ) {

					if ( name === 'instanceMatrix' && object.instanceMatrix ) geometryAttribute = object.instanceMatrix;
					if ( name === 'instanceColor' && object.instanceColor ) geometryAttribute = object.instanceColor;

				}

				if ( geometryAttribute !== undefined ) {

					const normalized = geometryAttribute.normalized;
					const size = geometryAttribute.itemSize;

					const attribute = attributes.get( geometryAttribute );

					// TODO Attribute may not be available on context restore

					if ( attribute === undefined ) continue;

					const buffer = attribute.buffer;
					const type = attribute.type;
					const bytesPerElement = attribute.bytesPerElement;

					// check for integer attributes

					const integer = ( type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === IntType );

					if ( geometryAttribute.isInterleavedBufferAttribute ) {

						const data = geometryAttribute.data;
						const stride = data.stride;
						const offset = geometryAttribute.offset;

						if ( data.isInstancedInterleavedBuffer ) {

							for ( let i = 0; i < programAttribute.locationSize; i ++ ) {

								enableAttributeAndDivisor( programAttribute.location + i, data.meshPerAttribute );

							}

							if ( object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined ) {

								geometry._maxInstanceCount = data.meshPerAttribute * data.count;

							}

						} else {

							for ( let i = 0; i < programAttribute.locationSize; i ++ ) {

								enableAttribute( programAttribute.location + i );

							}

						}

						gl.bindBuffer( gl.ARRAY_BUFFER, buffer );

						for ( let i = 0; i < programAttribute.locationSize; i ++ ) {

							vertexAttribPointer(
								programAttribute.location + i,
								size / programAttribute.locationSize,
								type,
								normalized,
								stride * bytesPerElement,
								( offset + ( size / programAttribute.locationSize ) * i ) * bytesPerElement,
								integer
							);

						}

					} else {

						if ( geometryAttribute.isInstancedBufferAttribute ) {

							for ( let i = 0; i < programAttribute.locationSize; i ++ ) {

								enableAttributeAndDivisor( programAttribute.location + i, geometryAttribute.meshPerAttribute );

							}

							if ( object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined ) {

								geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;

							}

						} else {

							for ( let i = 0; i < programAttribute.locationSize; i ++ ) {

								enableAttribute( programAttribute.location + i );

							}

						}

						gl.bindBuffer( gl.ARRAY_BUFFER, buffer );

						for ( let i = 0; i < programAttribute.locationSize; i ++ ) {

							vertexAttribPointer(
								programAttribute.location + i,
								size / programAttribute.locationSize,
								type,
								normalized,
								size * bytesPerElement,
								( size / programAttribute.locationSize ) * i * bytesPerElement,
								integer
							);

						}

					}

				} else if ( materialDefaultAttributeValues !== undefined ) {

					const value = materialDefaultAttributeValues[ name ];

					if ( value !== undefined ) {

						switch ( value.length ) {

							case 2:
								gl.vertexAttrib2fv( programAttribute.location, value );
								break;

							case 3:
								gl.vertexAttrib3fv( programAttribute.location, value );
								break;

							case 4:
								gl.vertexAttrib4fv( programAttribute.location, value );
								break;

							default:
								gl.vertexAttrib1fv( programAttribute.location, value );

						}

					}

				}

			}

		}

		disableUnusedAttributes();

	}

	function dispose() {

		reset();

		for ( const geometryId in bindingStates ) {

			const programMap = bindingStates[ geometryId ];

			for ( const programId in programMap ) {

				const stateMap = programMap[ programId ];

				for ( const wireframe in stateMap ) {

					deleteVertexArrayObject( stateMap[ wireframe ].object );

					delete stateMap[ wireframe ];

				}

				delete programMap[ programId ];

			}

			delete bindingStates[ geometryId ];

		}

	}

	function releaseStatesOfGeometry( geometry ) {

		if ( bindingStates[ geometry.id ] === undefined ) return;

		const programMap = bindingStates[ geometry.id ];

		for ( const programId in programMap ) {

			const stateMap = programMap[ programId ];

			for ( const wireframe in stateMap ) {

				deleteVertexArrayObject( stateMap[ wireframe ].object );

				delete stateMap[ wireframe ];

			}

			delete programMap[ programId ];

		}

		delete bindingStates[ geometry.id ];

	}

	function releaseStatesOfProgram( program ) {

		for ( const geometryId in bindingStates ) {

			const programMap = bindingStates[ geometryId ];

			if ( programMap[ program.id ] === undefined ) continue;

			const stateMap = programMap[ program.id ];

			for ( const wireframe in stateMap ) {

				deleteVertexArrayObject( stateMap[ wireframe ].object );

				delete stateMap[ wireframe ];

			}

			delete programMap[ program.id ];

		}

	}

	function reset() {

		resetDefaultState();
		forceUpdate = true;

		if ( currentState === defaultState ) return;

		currentState = defaultState;
		bindVertexArrayObject( currentState.object );

	}

	// for backward-compatibility

	function resetDefaultState() {

		defaultState.geometry = null;
		defaultState.program = null;
		defaultState.wireframe = false;

	}

	return {

		setup: setup,
		reset: reset,
		resetDefaultState: resetDefaultState,
		dispose: dispose,
		releaseStatesOfGeometry: releaseStatesOfGeometry,
		releaseStatesOfProgram: releaseStatesOfProgram,

		initAttributes: initAttributes,
		enableAttribute: enableAttribute,
		disableUnusedAttributes: disableUnusedAttributes

	};

}

function WebGLBufferRenderer( gl, extensions, info ) {

	let mode;

	function setMode( value ) {

		mode = value;

	}

	function render( start, count ) {

		gl.drawArrays( mode, start, count );

		info.update( count, mode, 1 );

	}

	function renderInstances( start, count, primcount ) {

		if ( primcount === 0 ) return;

		gl.drawArraysInstanced( mode, start, count, primcount );

		info.update( count, mode, primcount );

	}

	function renderMultiDraw( starts, counts, drawCount ) {

		if ( drawCount === 0 ) return;

		const extension = extensions.get( 'WEBGL_multi_draw' );
		extension.multiDrawArraysWEBGL( mode, starts, 0, counts, 0, drawCount );

		let elementCount = 0;
		for ( let i = 0; i < drawCount; i ++ ) {

			elementCount += counts[ i ];

		}

		info.update( elementCount, mode, 1 );

	}

	function renderMultiDrawInstances( starts, counts, drawCount, primcount ) {

		if ( drawCount === 0 ) return;

		const extension = extensions.get( 'WEBGL_multi_draw' );

		if ( extension === null ) {

			for ( let i = 0; i < starts.length; i ++ ) {

				renderInstances( starts[ i ], counts[ i ], primcount[ i ] );

			}

		} else {

			extension.multiDrawArraysInstancedWEBGL( mode, starts, 0, counts, 0, primcount, 0, drawCount );

			let elementCount = 0;
			for ( let i = 0; i < drawCount; i ++ ) {

				elementCount += counts[ i ];

			}

			for ( let i = 0; i < primcount.length; i ++ ) {

				info.update( elementCount, mode, primcount[ i ] );

			}

		}

	}

	//

	this.setMode = setMode;
	this.render = render;
	this.renderInstances = renderInstances;
	this.renderMultiDraw = renderMultiDraw;
	this.renderMultiDrawInstances = renderMultiDrawInstances;

}

function WebGLCapabilities( gl, extensions, parameters, utils ) {

	let maxAnisotropy;

	function getMaxAnisotropy() {

		if ( maxAnisotropy !== undefined ) return maxAnisotropy;

		if ( extensions.has( 'EXT_texture_filter_anisotropic' ) === true ) {

			const extension = extensions.get( 'EXT_texture_filter_anisotropic' );

			maxAnisotropy = gl.getParameter( extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT );

		} else {

			maxAnisotropy = 0;

		}

		return maxAnisotropy;

	}

	function textureFormatReadable( textureFormat ) {

		if ( textureFormat !== RGBAFormat && utils.convert( textureFormat ) !== gl.getParameter( gl.IMPLEMENTATION_COLOR_READ_FORMAT ) ) {

			return false;

		}

		return true;

	}

	function textureTypeReadable( textureType ) {

		const halfFloatSupportedByExt = ( textureType === HalfFloatType ) && ( extensions.has( 'EXT_color_buffer_half_float' ) || extensions.has( 'EXT_color_buffer_float' ) );

		if ( textureType !== UnsignedByteType && utils.convert( textureType ) !== gl.getParameter( gl.IMPLEMENTATION_COLOR_READ_TYPE ) && // Edge and Chrome Mac < 52 (#9513)
			textureType !== FloatType && ! halfFloatSupportedByExt ) {

			return false;

		}

		return true;

	}

	function getMaxPrecision( precision ) {

		if ( precision === 'highp' ) {

			if ( gl.getShaderPrecisionFormat( gl.VERTEX_SHADER, gl.HIGH_FLOAT ).precision > 0 &&
				gl.getShaderPrecisionFormat( gl.FRAGMENT_SHADER, gl.HIGH_FLOAT ).precision > 0 ) {

				return 'highp';

			}

			precision = 'mediump';

		}

		if ( precision === 'mediump' ) {

			if ( gl.getShaderPrecisionFormat( gl.VERTEX_SHADER, gl.MEDIUM_FLOAT ).precision > 0 &&
				gl.getShaderPrecisionFormat( gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT ).precision > 0 ) {

				return 'mediump';

			}

		}

		return 'lowp';

	}

	let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
	const maxPrecision = getMaxPrecision( precision );

	if ( maxPrecision !== precision ) {

		console.warn( 'THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.' );
		precision = maxPrecision;

	}

	const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;

	const maxTextures = gl.getParameter( gl.MAX_TEXTURE_IMAGE_UNITS );
	const maxVertexTextures = gl.getParameter( gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS );
	const maxTextureSize = gl.getParameter( gl.MAX_TEXTURE_SIZE );
	const maxCubemapSize = gl.getParameter( gl.MAX_CUBE_MAP_TEXTURE_SIZE );

	const maxAttributes = gl.getParameter( gl.MAX_VERTEX_ATTRIBS );
	const maxVertexUniforms = gl.getParameter( gl.MAX_VERTEX_UNIFORM_VECTORS );
	const maxVaryings = gl.getParameter( gl.MAX_VARYING_VECTORS );
	const maxFragmentUniforms = gl.getParameter( gl.MAX_FRAGMENT_UNIFORM_VECTORS );

	const vertexTextures = maxVertexTextures > 0;

	const maxSamples = gl.getParameter( gl.MAX_SAMPLES );

	return {

		isWebGL2: true, // keeping this for backwards compatibility

		getMaxAnisotropy: getMaxAnisotropy,
		getMaxPrecision: getMaxPrecision,

		textureFormatReadable: textureFormatReadable,
		textureTypeReadable: textureTypeReadable,

		precision: precision,
		logarithmicDepthBuffer: logarithmicDepthBuffer,

		maxTextures: maxTextures,
		maxVertexTextures: maxVertexTextures,
		maxTextureSize: maxTextureSize,
		maxCubemapSize: maxCubemapSize,

		maxAttributes: maxAttributes,
		maxVertexUniforms: maxVertexUniforms,
		maxVaryings: maxVaryings,
		maxFragmentUniforms: maxFragmentUniforms,

		vertexTextures: vertexTextures,

		maxSamples: maxSamples

	};

}

function WebGLClipping( properties ) {

	const scope = this;

	let globalState = null,
		numGlobalPlanes = 0,
		localClippingEnabled = false,
		renderingShadows = false;

	const plane = new Plane(),
		viewNormalMatrix = new Matrix3(),

		uniform = { value: null, needsUpdate: false };

	this.uniform = uniform;
	this.numPlanes = 0;
	this.numIntersection = 0;

	this.init = function ( planes, enableLocalClipping ) {

		const enabled =
			planes.length !== 0 ||
			enableLocalClipping ||
			// enable state of previous frame - the clipping code has to
			// run another frame in order to reset the state:
			numGlobalPlanes !== 0 ||
			localClippingEnabled;

		localClippingEnabled = enableLocalClipping;

		numGlobalPlanes = planes.length;

		return enabled;

	};

	this.beginShadows = function () {

		renderingShadows = true;
		projectPlanes( null );

	};

	this.endShadows = function () {

		renderingShadows = false;

	};

	this.setGlobalState = function ( planes, camera ) {

		globalState = projectPlanes( planes, camera, 0 );

	};

	this.setState = function ( material, camera, useCache ) {

		const planes = material.clippingPlanes,
			clipIntersection = material.clipIntersection,
			clipShadows = material.clipShadows;

		const materialProperties = properties.get( material );

		if ( ! localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && ! clipShadows ) {

			// there's no local clipping

			if ( renderingShadows ) {

				// there's no global clipping

				projectPlanes( null );

			} else {

				resetGlobalState();

			}

		} else {

			const nGlobal = renderingShadows ? 0 : numGlobalPlanes,
				lGlobal = nGlobal * 4;

			let dstArray = materialProperties.clippingState || null;

			uniform.value = dstArray; // ensure unique state

			dstArray = projectPlanes( planes, camera, lGlobal, useCache );

			for ( let i = 0; i !== lGlobal; ++ i ) {

				dstArray[ i ] = globalState[ i ];

			}

			materialProperties.clippingState = dstArray;
			this.numIntersection = clipIntersection ? this.numPlanes : 0;
			this.numPlanes += nGlobal;

		}


	};

	function resetGlobalState() {

		if ( uniform.value !== globalState ) {

			uniform.value = globalState;
			uniform.needsUpdate = numGlobalPlanes > 0;

		}

		scope.numPlanes = numGlobalPlanes;
		scope.numIntersection = 0;

	}

	function projectPlanes( planes, camera, dstOffset, skipTransform ) {

		const nPlanes = planes !== null ? planes.length : 0;
		let dstArray = null;

		if ( nPlanes !== 0 ) {

			dstArray = uniform.value;

			if ( skipTransform !== true || dstArray === null ) {

				const flatSize = dstOffset + nPlanes * 4,
					viewMatrix = camera.matrixWorldInverse;

				viewNormalMatrix.getNormalMatrix( viewMatrix );

				if ( dstArray === null || dstArray.length < flatSize ) {

					dstArray = new Float32Array( flatSize );

				}

				for ( let i = 0, i4 = dstOffset; i !== nPlanes; ++ i, i4 += 4 ) {

					plane.copy( planes[ i ] ).applyMatrix4( viewMatrix, viewNormalMatrix );

					plane.normal.toArray( dstArray, i4 );
					dstArray[ i4 + 3 ] = plane.constant;

				}

			}

			uniform.value = dstArray;
			uniform.needsUpdate = true;

		}

		scope.numPlanes = nPlanes;
		scope.numIntersection = 0;

		return dstArray;

	}

}

function WebGLCubeMaps( renderer ) {

	let cubemaps = new WeakMap();

	function mapTextureMapping( texture, mapping ) {

		if ( mapping === EquirectangularReflectionMapping ) {

			texture.mapping = CubeReflectionMapping;

		} else if ( mapping === EquirectangularRefractionMapping ) {

			texture.mapping = CubeRefractionMapping;

		}

		return texture;

	}

	function get( texture ) {

		if ( texture && texture.isTexture ) {

			const mapping = texture.mapping;

			if ( mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping ) {

				if ( cubemaps.has( texture ) ) {

					const cubemap = cubemaps.get( texture ).texture;
					return mapTextureMapping( cubemap, texture.mapping );

				} else {

					const image = texture.image;

					if ( image && image.height > 0 ) {

						const renderTarget = new WebGLCubeRenderTarget( image.height );
						renderTarget.fromEquirectangularTexture( renderer, texture );
						cubemaps.set( texture, renderTarget );

						texture.addEventListener( 'dispose', onTextureDispose );

						return mapTextureMapping( renderTarget.texture, texture.mapping );

					} else {

						// image not yet ready. try the conversion next frame

						return null;

					}

				}

			}

		}

		return texture;

	}

	function onTextureDispose( event ) {

		const texture = event.target;

		texture.removeEventListener( 'dispose', onTextureDispose );

		const cubemap = cubemaps.get( texture );

		if ( cubemap !== undefined ) {

			cubemaps.delete( texture );
			cubemap.dispose();

		}

	}

	function dispose() {

		cubemaps = new WeakMap();

	}

	return {
		get: get,
		dispose: dispose
	};

}

class OrthographicCamera extends Camera {

	constructor( left = - 1, right = 1, top = 1, bottom = - 1, near = 0.1, far = 2000 ) {

		super();

		this.isOrthographicCamera = true;

		this.type = 'OrthographicCamera';

		this.zoom = 1;
		this.view = null;

		this.left = left;
		this.right = right;
		this.top = top;
		this.bottom = bottom;

		this.near = near;
		this.far = far;

		this.updateProjectionMatrix();

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.left = source.left;
		this.right = source.right;
		this.top = source.top;
		this.bottom = source.bottom;
		this.near = source.near;
		this.far = source.far;

		this.zoom = source.zoom;
		this.view = source.view === null ? null : Object.assign( {}, source.view );

		return this;

	}

	setViewOffset( fullWidth, fullHeight, x, y, width, height ) {

		if ( this.view === null ) {

			this.view = {
				enabled: true,
				fullWidth: 1,
				fullHeight: 1,
				offsetX: 0,
				offsetY: 0,
				width: 1,
				height: 1
			};

		}

		this.view.enabled = true;
		this.view.fullWidth = fullWidth;
		this.view.fullHeight = fullHeight;
		this.view.offsetX = x;
		this.view.offsetY = y;
		this.view.width = width;
		this.view.height = height;

		this.updateProjectionMatrix();

	}

	clearViewOffset() {

		if ( this.view !== null ) {

			this.view.enabled = false;

		}

		this.updateProjectionMatrix();

	}

	updateProjectionMatrix() {

		const dx = ( this.right - this.left ) / ( 2 * this.zoom );
		const dy = ( this.top - this.bottom ) / ( 2 * this.zoom );
		const cx = ( this.right + this.left ) / 2;
		const cy = ( this.top + this.bottom ) / 2;

		let left = cx - dx;
		let right = cx + dx;
		let top = cy + dy;
		let bottom = cy - dy;

		if ( this.view !== null && this.view.enabled ) {

			const scaleW = ( this.right - this.left ) / this.view.fullWidth / this.zoom;
			const scaleH = ( this.top - this.bottom ) / this.view.fullHeight / this.zoom;

			left += scaleW * this.view.offsetX;
			right = left + scaleW * this.view.width;
			top -= scaleH * this.view.offsetY;
			bottom = top - scaleH * this.view.height;

		}

		this.projectionMatrix.makeOrthographic( left, right, top, bottom, this.near, this.far, this.coordinateSystem );

		this.projectionMatrixInverse.copy( this.projectionMatrix ).invert();

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		data.object.zoom = this.zoom;
		data.object.left = this.left;
		data.object.right = this.right;
		data.object.top = this.top;
		data.object.bottom = this.bottom;
		data.object.near = this.near;
		data.object.far = this.far;

		if ( this.view !== null ) data.object.view = Object.assign( {}, this.view );

		return data;

	}

}

const LOD_MIN = 4;

// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const EXTRA_LOD_SIGMA = [ 0.125, 0.215, 0.35, 0.446, 0.526, 0.582 ];

// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const MAX_SAMPLES = 20;

const _flatCamera = /*@__PURE__*/ new OrthographicCamera();
const _clearColor = /*@__PURE__*/ new Color();
let _oldTarget = null;
let _oldActiveCubeFace = 0;
let _oldActiveMipmapLevel = 0;
let _oldXrEnabled = false;

// Golden Ratio
const PHI = ( 1 + Math.sqrt( 5 ) ) / 2;
const INV_PHI = 1 / PHI;

// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const _axisDirections = [
	/*@__PURE__*/ new Vector3( - PHI, INV_PHI, 0 ),
	/*@__PURE__*/ new Vector3( PHI, INV_PHI, 0 ),
	/*@__PURE__*/ new Vector3( - INV_PHI, 0, PHI ),
	/*@__PURE__*/ new Vector3( INV_PHI, 0, PHI ),
	/*@__PURE__*/ new Vector3( 0, PHI, - INV_PHI ),
	/*@__PURE__*/ new Vector3( 0, PHI, INV_PHI ),
	/*@__PURE__*/ new Vector3( - 1, 1, - 1 ),
	/*@__PURE__*/ new Vector3( 1, 1, - 1 ),
	/*@__PURE__*/ new Vector3( - 1, 1, 1 ),
	/*@__PURE__*/ new Vector3( 1, 1, 1 ) ];

/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/

class PMREMGenerator {

	constructor( renderer ) {

		this._renderer = renderer;
		this._pingPongRenderTarget = null;

		this._lodMax = 0;
		this._cubeSize = 0;
		this._lodPlanes = [];
		this._sizeLods = [];
		this._sigmas = [];

		this._blurMaterial = null;
		this._cubemapMaterial = null;
		this._equirectMaterial = null;

		this._compileMaterial( this._blurMaterial );

	}

	/**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */
	fromScene( scene, sigma = 0, near = 0.1, far = 100 ) {

		_oldTarget = this._renderer.getRenderTarget();
		_oldActiveCubeFace = this._renderer.getActiveCubeFace();
		_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
		_oldXrEnabled = this._renderer.xr.enabled;

		this._renderer.xr.enabled = false;

		this._setSize( 256 );

		const cubeUVRenderTarget = this._allocateTargets();
		cubeUVRenderTarget.depthBuffer = true;

		this._sceneToCubeUV( scene, near, far, cubeUVRenderTarget );

		if ( sigma > 0 ) {

			this._blur( cubeUVRenderTarget, 0, 0, sigma );

		}

		this._applyPMREM( cubeUVRenderTarget );
		this._cleanup( cubeUVRenderTarget );

		return cubeUVRenderTarget;

	}

	/**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 * The smallest supported equirectangular image size is 64 x 32.
	 */
	fromEquirectangular( equirectangular, renderTarget = null ) {

		return this._fromTexture( equirectangular, renderTarget );

	}

	/**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 * The smallest supported cube size is 16 x 16.
	 */
	fromCubemap( cubemap, renderTarget = null ) {

		return this._fromTexture( cubemap, renderTarget );

	}

	/**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */
	compileCubemapShader() {

		if ( this._cubemapMaterial === null ) {

			this._cubemapMaterial = _getCubemapMaterial();
			this._compileMaterial( this._cubemapMaterial );

		}

	}

	/**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */
	compileEquirectangularShader() {

		if ( this._equirectMaterial === null ) {

			this._equirectMaterial = _getEquirectMaterial();
			this._compileMaterial( this._equirectMaterial );

		}

	}

	/**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */
	dispose() {

		this._dispose();

		if ( this._cubemapMaterial !== null ) this._cubemapMaterial.dispose();
		if ( this._equirectMaterial !== null ) this._equirectMaterial.dispose();

	}

	// private interface

	_setSize( cubeSize ) {

		this._lodMax = Math.floor( Math.log2( cubeSize ) );
		this._cubeSize = Math.pow( 2, this._lodMax );

	}

	_dispose() {

		if ( this._blurMaterial !== null ) this._blurMaterial.dispose();

		if ( this._pingPongRenderTarget !== null ) this._pingPongRenderTarget.dispose();

		for ( let i = 0; i < this._lodPlanes.length; i ++ ) {

			this._lodPlanes[ i ].dispose();

		}

	}

	_cleanup( outputTarget ) {

		this._renderer.setRenderTarget( _oldTarget, _oldActiveCubeFace, _oldActiveMipmapLevel );
		this._renderer.xr.enabled = _oldXrEnabled;

		outputTarget.scissorTest = false;
		_setViewport( outputTarget, 0, 0, outputTarget.width, outputTarget.height );

	}

	_fromTexture( texture, renderTarget ) {

		if ( texture.mapping === CubeReflectionMapping || texture.mapping === CubeRefractionMapping ) {

			this._setSize( texture.image.length === 0 ? 16 : ( texture.image[ 0 ].width || texture.image[ 0 ].image.width ) );

		} else { // Equirectangular

			this._setSize( texture.image.width / 4 );

		}

		_oldTarget = this._renderer.getRenderTarget();
		_oldActiveCubeFace = this._renderer.getActiveCubeFace();
		_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
		_oldXrEnabled = this._renderer.xr.enabled;

		this._renderer.xr.enabled = false;

		const cubeUVRenderTarget = renderTarget || this._allocateTargets();
		this._textureToCubeUV( texture, cubeUVRenderTarget );
		this._applyPMREM( cubeUVRenderTarget );
		this._cleanup( cubeUVRenderTarget );

		return cubeUVRenderTarget;

	}

	_allocateTargets() {

		const width = 3 * Math.max( this._cubeSize, 16 * 7 );
		const height = 4 * this._cubeSize;

		const params = {
			magFilter: LinearFilter,
			minFilter: LinearFilter,
			generateMipmaps: false,
			type: HalfFloatType,
			format: RGBAFormat,
			colorSpace: LinearSRGBColorSpace,
			depthBuffer: false
		};

		const cubeUVRenderTarget = _createRenderTarget( width, height, params );

		if ( this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height ) {

			if ( this._pingPongRenderTarget !== null ) {

				this._dispose();

			}

			this._pingPongRenderTarget = _createRenderTarget( width, height, params );

			const { _lodMax } = this;
			( { sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = _createPlanes( _lodMax ) );

			this._blurMaterial = _getBlurShader( _lodMax, width, height );

		}

		return cubeUVRenderTarget;

	}

	_compileMaterial( material ) {

		const tmpMesh = new Mesh( this._lodPlanes[ 0 ], material );
		this._renderer.compile( tmpMesh, _flatCamera );

	}

	_sceneToCubeUV( scene, near, far, cubeUVRenderTarget ) {

		const fov = 90;
		const aspect = 1;
		const cubeCamera = new PerspectiveCamera( fov, aspect, near, far );
		const upSign = [ 1, - 1, 1, 1, 1, 1 ];
		const forwardSign = [ 1, 1, 1, - 1, - 1, - 1 ];
		const renderer = this._renderer;

		const originalAutoClear = renderer.autoClear;
		const toneMapping = renderer.toneMapping;
		renderer.getClearColor( _clearColor );

		renderer.toneMapping = NoToneMapping;
		renderer.autoClear = false;

		const backgroundMaterial = new MeshBasicMaterial( {
			name: 'PMREM.Background',
			side: BackSide,
			depthWrite: false,
			depthTest: false,
		} );

		const backgroundBox = new Mesh( new BoxGeometry(), backgroundMaterial );

		let useSolidColor = false;
		const background = scene.background;

		if ( background ) {

			if ( background.isColor ) {

				backgroundMaterial.color.copy( background );
				scene.background = null;
				useSolidColor = true;

			}

		} else {

			backgroundMaterial.color.copy( _clearColor );
			useSolidColor = true;

		}

		for ( let i = 0; i < 6; i ++ ) {

			const col = i % 3;

			if ( col === 0 ) {

				cubeCamera.up.set( 0, upSign[ i ], 0 );
				cubeCamera.lookAt( forwardSign[ i ], 0, 0 );

			} else if ( col === 1 ) {

				cubeCamera.up.set( 0, 0, upSign[ i ] );
				cubeCamera.lookAt( 0, forwardSign[ i ], 0 );

			} else {

				cubeCamera.up.set( 0, upSign[ i ], 0 );
				cubeCamera.lookAt( 0, 0, forwardSign[ i ] );

			}

			const size = this._cubeSize;

			_setViewport( cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size );

			renderer.setRenderTarget( cubeUVRenderTarget );

			if ( useSolidColor ) {

				renderer.render( backgroundBox, cubeCamera );

			}

			renderer.render( scene, cubeCamera );

		}

		backgroundBox.geometry.dispose();
		backgroundBox.material.dispose();

		renderer.toneMapping = toneMapping;
		renderer.autoClear = originalAutoClear;
		scene.background = background;

	}

	_textureToCubeUV( texture, cubeUVRenderTarget ) {

		const renderer = this._renderer;

		const isCubeTexture = ( texture.mapping === CubeReflectionMapping || texture.mapping === CubeRefractionMapping );

		if ( isCubeTexture ) {

			if ( this._cubemapMaterial === null ) {

				this._cubemapMaterial = _getCubemapMaterial();

			}

			this._cubemapMaterial.uniforms.flipEnvMap.value = ( texture.isRenderTargetTexture === false ) ? - 1 : 1;

		} else {

			if ( this._equirectMaterial === null ) {

				this._equirectMaterial = _getEquirectMaterial();

			}

		}

		const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
		const mesh = new Mesh( this._lodPlanes[ 0 ], material );

		const uniforms = material.uniforms;

		uniforms[ 'envMap' ].value = texture;

		const size = this._cubeSize;

		_setViewport( cubeUVRenderTarget, 0, 0, 3 * size, 2 * size );

		renderer.setRenderTarget( cubeUVRenderTarget );
		renderer.render( mesh, _flatCamera );

	}

	_applyPMREM( cubeUVRenderTarget ) {

		const renderer = this._renderer;
		const autoClear = renderer.autoClear;
		renderer.autoClear = false;
		const n = this._lodPlanes.length;

		for ( let i = 1; i < n; i ++ ) {

			const sigma = Math.sqrt( this._sigmas[ i ] * this._sigmas[ i ] - this._sigmas[ i - 1 ] * this._sigmas[ i - 1 ] );

			const poleAxis = _axisDirections[ ( n - i - 1 ) % _axisDirections.length ];

			this._blur( cubeUVRenderTarget, i - 1, i, sigma, poleAxis );

		}

		renderer.autoClear = autoClear;

	}

	/**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */
	_blur( cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis ) {

		const pingPongRenderTarget = this._pingPongRenderTarget;

		this._halfBlur(
			cubeUVRenderTarget,
			pingPongRenderTarget,
			lodIn,
			lodOut,
			sigma,
			'latitudinal',
			poleAxis );

		this._halfBlur(
			pingPongRenderTarget,
			cubeUVRenderTarget,
			lodOut,
			lodOut,
			sigma,
			'longitudinal',
			poleAxis );

	}

	_halfBlur( targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis ) {

		const renderer = this._renderer;
		const blurMaterial = this._blurMaterial;

		if ( direction !== 'latitudinal' && direction !== 'longitudinal' ) {

			console.error(
				'blur direction must be either latitudinal or longitudinal!' );

		}

		// Number of standard deviations at which to cut off the discrete approximation.
		const STANDARD_DEVIATIONS = 3;

		const blurMesh = new Mesh( this._lodPlanes[ lodOut ], blurMaterial );
		const blurUniforms = blurMaterial.uniforms;

		const pixels = this._sizeLods[ lodIn ] - 1;
		const radiansPerPixel = isFinite( sigmaRadians ) ? Math.PI / ( 2 * pixels ) : 2 * Math.PI / ( 2 * MAX_SAMPLES - 1 );
		const sigmaPixels = sigmaRadians / radiansPerPixel;
		const samples = isFinite( sigmaRadians ) ? 1 + Math.floor( STANDARD_DEVIATIONS * sigmaPixels ) : MAX_SAMPLES;

		if ( samples > MAX_SAMPLES ) {

			console.warn( `sigmaRadians, ${
				sigmaRadians}, is too large and will clip, as it requested ${
				samples} samples when the maximum is set to ${MAX_SAMPLES}` );

		}

		const weights = [];
		let sum = 0;

		for ( let i = 0; i < MAX_SAMPLES; ++ i ) {

			const x = i / sigmaPixels;
			const weight = Math.exp( - x * x / 2 );
			weights.push( weight );

			if ( i === 0 ) {

				sum += weight;

			} else if ( i < samples ) {

				sum += 2 * weight;

			}

		}

		for ( let i = 0; i < weights.length; i ++ ) {

			weights[ i ] = weights[ i ] / sum;

		}

		blurUniforms[ 'envMap' ].value = targetIn.texture;
		blurUniforms[ 'samples' ].value = samples;
		blurUniforms[ 'weights' ].value = weights;
		blurUniforms[ 'latitudinal' ].value = direction === 'latitudinal';

		if ( poleAxis ) {

			blurUniforms[ 'poleAxis' ].value = poleAxis;

		}

		const { _lodMax } = this;
		blurUniforms[ 'dTheta' ].value = radiansPerPixel;
		blurUniforms[ 'mipInt' ].value = _lodMax - lodIn;

		const outputSize = this._sizeLods[ lodOut ];
		const x = 3 * outputSize * ( lodOut > _lodMax - LOD_MIN ? lodOut - _lodMax + LOD_MIN : 0 );
		const y = 4 * ( this._cubeSize - outputSize );

		_setViewport( targetOut, x, y, 3 * outputSize, 2 * outputSize );
		renderer.setRenderTarget( targetOut );
		renderer.render( blurMesh, _flatCamera );

	}

}



function _createPlanes( lodMax ) {

	const lodPlanes = [];
	const sizeLods = [];
	const sigmas = [];

	let lod = lodMax;

	const totalLods = lodMax - LOD_MIN + 1 + EXTRA_LOD_SIGMA.length;

	for ( let i = 0; i < totalLods; i ++ ) {

		const sizeLod = Math.pow( 2, lod );
		sizeLods.push( sizeLod );
		let sigma = 1.0 / sizeLod;

		if ( i > lodMax - LOD_MIN ) {

			sigma = EXTRA_LOD_SIGMA[ i - lodMax + LOD_MIN - 1 ];

		} else if ( i === 0 ) {

			sigma = 0;

		}

		sigmas.push( sigma );

		const texelSize = 1.0 / ( sizeLod - 2 );
		const min = - texelSize;
		const max = 1 + texelSize;
		const uv1 = [ min, min, max, min, max, max, min, min, max, max, min, max ];

		const cubeFaces = 6;
		const vertices = 6;
		const positionSize = 3;
		const uvSize = 2;
		const faceIndexSize = 1;

		const position = new Float32Array( positionSize * vertices * cubeFaces );
		const uv = new Float32Array( uvSize * vertices * cubeFaces );
		const faceIndex = new Float32Array( faceIndexSize * vertices * cubeFaces );

		for ( let face = 0; face < cubeFaces; face ++ ) {

			const x = ( face % 3 ) * 2 / 3 - 1;
			const y = face > 2 ? 0 : - 1;
			const coordinates = [
				x, y, 0,
				x + 2 / 3, y, 0,
				x + 2 / 3, y + 1, 0,
				x, y, 0,
				x + 2 / 3, y + 1, 0,
				x, y + 1, 0
			];
			position.set( coordinates, positionSize * vertices * face );
			uv.set( uv1, uvSize * vertices * face );
			const fill = [ face, face, face, face, face, face ];
			faceIndex.set( fill, faceIndexSize * vertices * face );

		}

		const planes = new BufferGeometry();
		planes.setAttribute( 'position', new BufferAttribute( position, positionSize ) );
		planes.setAttribute( 'uv', new BufferAttribute( uv, uvSize ) );
		planes.setAttribute( 'faceIndex', new BufferAttribute( faceIndex, faceIndexSize ) );
		lodPlanes.push( planes );

		if ( lod > LOD_MIN ) {

			lod --;

		}

	}

	return { lodPlanes, sizeLods, sigmas };

}

function _createRenderTarget( width, height, params ) {

	const cubeUVRenderTarget = new WebGLRenderTarget( width, height, params );
	cubeUVRenderTarget.texture.mapping = CubeUVReflectionMapping;
	cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
	cubeUVRenderTarget.scissorTest = true;
	return cubeUVRenderTarget;

}

function _setViewport( target, x, y, width, height ) {

	target.viewport.set( x, y, width, height );
	target.scissor.set( x, y, width, height );

}

function _getBlurShader( lodMax, width, height ) {

	const weights = new Float32Array( MAX_SAMPLES );
	const poleAxis = new Vector3( 0, 1, 0 );
	const shaderMaterial = new ShaderMaterial( {

		name: 'SphericalGaussianBlur',

		defines: {
			'n': MAX_SAMPLES,
			'CUBEUV_TEXEL_WIDTH': 1.0 / width,
			'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
			'CUBEUV_MAX_MIP': `${lodMax}.0`,
		},

		uniforms: {
			'envMap': { value: null },
			'samples': { value: 1 },
			'weights': { value: weights },
			'latitudinal': { value: false },
			'dTheta': { value: 0 },
			'mipInt': { value: 0 },
			'poleAxis': { value: poleAxis }
		},

		vertexShader: _getCommonVertexShader(),

		fragmentShader: /* glsl */`

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,

		blending: NoBlending,
		depthTest: false,
		depthWrite: false

	} );

	return shaderMaterial;

}

function _getEquirectMaterial() {

	return new ShaderMaterial( {

		name: 'EquirectangularToCubeUV',

		uniforms: {
			'envMap': { value: null }
		},

		vertexShader: _getCommonVertexShader(),

		fragmentShader: /* glsl */`

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,

		blending: NoBlending,
		depthTest: false,
		depthWrite: false

	} );

}

function _getCubemapMaterial() {

	return new ShaderMaterial( {

		name: 'CubemapToCubeUV',

		uniforms: {
			'envMap': { value: null },
			'flipEnvMap': { value: - 1 }
		},

		vertexShader: _getCommonVertexShader(),

		fragmentShader: /* glsl */`

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,

		blending: NoBlending,
		depthTest: false,
		depthWrite: false

	} );

}

function _getCommonVertexShader() {

	return /* glsl */`

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;

}

function WebGLCubeUVMaps( renderer ) {

	let cubeUVmaps = new WeakMap();

	let pmremGenerator = null;

	function get( texture ) {

		if ( texture && texture.isTexture ) {

			const mapping = texture.mapping;

			const isEquirectMap = ( mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping );
			const isCubeMap = ( mapping === CubeReflectionMapping || mapping === CubeRefractionMapping );

			// equirect/cube map to cubeUV conversion

			if ( isEquirectMap || isCubeMap ) {

				let renderTarget = cubeUVmaps.get( texture );

				const currentPMREMVersion = renderTarget !== undefined ? renderTarget.texture.pmremVersion : 0;

				if ( texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion ) {

					if ( pmremGenerator === null ) pmremGenerator = new PMREMGenerator( renderer );

					renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular( texture, renderTarget ) : pmremGenerator.fromCubemap( texture, renderTarget );
					renderTarget.texture.pmremVersion = texture.pmremVersion;

					cubeUVmaps.set( texture, renderTarget );

					return renderTarget.texture;

				} else {

					if ( renderTarget !== undefined ) {

						return renderTarget.texture;

					} else {

						const image = texture.image;

						if ( ( isEquirectMap && image && image.height > 0 ) || ( isCubeMap && image && isCubeTextureComplete( image ) ) ) {

							if ( pmremGenerator === null ) pmremGenerator = new PMREMGenerator( renderer );

							renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular( texture ) : pmremGenerator.fromCubemap( texture );
							renderTarget.texture.pmremVersion = texture.pmremVersion;

							cubeUVmaps.set( texture, renderTarget );

							texture.addEventListener( 'dispose', onTextureDispose );

							return renderTarget.texture;

						} else {

							// image not yet ready. try the conversion next frame

							return null;

						}

					}

				}

			}

		}

		return texture;

	}

	function isCubeTextureComplete( image ) {

		let count = 0;
		const length = 6;

		for ( let i = 0; i < length; i ++ ) {

			if ( image[ i ] !== undefined ) count ++;

		}

		return count === length;


	}

	function onTextureDispose( event ) {

		const texture = event.target;

		texture.removeEventListener( 'dispose', onTextureDispose );

		const cubemapUV = cubeUVmaps.get( texture );

		if ( cubemapUV !== undefined ) {

			cubeUVmaps.delete( texture );
			cubemapUV.dispose();

		}

	}

	function dispose() {

		cubeUVmaps = new WeakMap();

		if ( pmremGenerator !== null ) {

			pmremGenerator.dispose();
			pmremGenerator = null;

		}

	}

	return {
		get: get,
		dispose: dispose
	};

}

function WebGLExtensions( gl ) {

	const extensions = {};

	function getExtension( name ) {

		if ( extensions[ name ] !== undefined ) {

			return extensions[ name ];

		}

		let extension;

		switch ( name ) {

			case 'WEBGL_depth_texture':
				extension = gl.getExtension( 'WEBGL_depth_texture' ) || gl.getExtension( 'MOZ_WEBGL_depth_texture' ) || gl.getExtension( 'WEBKIT_WEBGL_depth_texture' );
				break;

			case 'EXT_texture_filter_anisotropic':
				extension = gl.getExtension( 'EXT_texture_filter_anisotropic' ) || gl.getExtension( 'MOZ_EXT_texture_filter_anisotropic' ) || gl.getExtension( 'WEBKIT_EXT_texture_filter_anisotropic' );
				break;

			case 'WEBGL_compressed_texture_s3tc':
				extension = gl.getExtension( 'WEBGL_compressed_texture_s3tc' ) || gl.getExtension( 'MOZ_WEBGL_compressed_texture_s3tc' ) || gl.getExtension( 'WEBKIT_WEBGL_compressed_texture_s3tc' );
				break;

			case 'WEBGL_compressed_texture_pvrtc':
				extension = gl.getExtension( 'WEBGL_compressed_texture_pvrtc' ) || gl.getExtension( 'WEBKIT_WEBGL_compressed_texture_pvrtc' );
				break;

			default:
				extension = gl.getExtension( name );

		}

		extensions[ name ] = extension;

		return extension;

	}

	return {

		has: function ( name ) {

			return getExtension( name ) !== null;

		},

		init: function () {

			getExtension( 'EXT_color_buffer_float' );
			getExtension( 'WEBGL_clip_cull_distance' );
			getExtension( 'OES_texture_float_linear' );
			getExtension( 'EXT_color_buffer_half_float' );
			getExtension( 'WEBGL_multisampled_render_to_texture' );
			getExtension( 'WEBGL_render_shared_exponent' );

		},

		get: function ( name ) {

			const extension = getExtension( name );

			if ( extension === null ) {

				warnOnce( 'THREE.WebGLRenderer: ' + name + ' extension not supported.' );

			}

			return extension;

		}

	};

}

function WebGLGeometries( gl, attributes, info, bindingStates ) {

	const geometries = {};
	const wireframeAttributes = new WeakMap();

	function onGeometryDispose( event ) {

		const geometry = event.target;

		if ( geometry.index !== null ) {

			attributes.remove( geometry.index );

		}

		for ( const name in geometry.attributes ) {

			attributes.remove( geometry.attributes[ name ] );

		}

		for ( const name in geometry.morphAttributes ) {

			const array = geometry.morphAttributes[ name ];

			for ( let i = 0, l = array.length; i < l; i ++ ) {

				attributes.remove( array[ i ] );

			}

		}

		geometry.removeEventListener( 'dispose', onGeometryDispose );

		delete geometries[ geometry.id ];

		const attribute = wireframeAttributes.get( geometry );

		if ( attribute ) {

			attributes.remove( attribute );
			wireframeAttributes.delete( geometry );

		}

		bindingStates.releaseStatesOfGeometry( geometry );

		if ( geometry.isInstancedBufferGeometry === true ) {

			delete geometry._maxInstanceCount;

		}

		//

		info.memory.geometries --;

	}

	function get( object, geometry ) {

		if ( geometries[ geometry.id ] === true ) return geometry;

		geometry.addEventListener( 'dispose', onGeometryDispose );

		geometries[ geometry.id ] = true;

		info.memory.geometries ++;

		return geometry;

	}

	function update( geometry ) {

		const geometryAttributes = geometry.attributes;

		// Updating index buffer in VAO now. See WebGLBindingStates.

		for ( const name in geometryAttributes ) {

			attributes.update( geometryAttributes[ name ], gl.ARRAY_BUFFER );

		}

		// morph targets

		const morphAttributes = geometry.morphAttributes;

		for ( const name in morphAttributes ) {

			const array = morphAttributes[ name ];

			for ( let i = 0, l = array.length; i < l; i ++ ) {

				attributes.update( array[ i ], gl.ARRAY_BUFFER );

			}

		}

	}

	function updateWireframeAttribute( geometry ) {

		const indices = [];

		const geometryIndex = geometry.index;
		const geometryPosition = geometry.attributes.position;
		let version = 0;

		if ( geometryIndex !== null ) {

			const array = geometryIndex.array;
			version = geometryIndex.version;

			for ( let i = 0, l = array.length; i < l; i += 3 ) {

				const a = array[ i + 0 ];
				const b = array[ i + 1 ];
				const c = array[ i + 2 ];

				indices.push( a, b, b, c, c, a );

			}

		} else if ( geometryPosition !== undefined ) {

			const array = geometryPosition.array;
			version = geometryPosition.version;

			for ( let i = 0, l = ( array.length / 3 ) - 1; i < l; i += 3 ) {

				const a = i + 0;
				const b = i + 1;
				const c = i + 2;

				indices.push( a, b, b, c, c, a );

			}

		} else {

			return;

		}

		const attribute = new ( arrayNeedsUint32( indices ) ? Uint32BufferAttribute : Uint16BufferAttribute )( indices, 1 );
		attribute.version = version;

		// Updating index buffer in VAO now. See WebGLBindingStates

		//

		const previousAttribute = wireframeAttributes.get( geometry );

		if ( previousAttribute ) attributes.remove( previousAttribute );

		//

		wireframeAttributes.set( geometry, attribute );

	}

	function getWireframeAttribute( geometry ) {

		const currentAttribute = wireframeAttributes.get( geometry );

		if ( currentAttribute ) {

			const geometryIndex = geometry.index;

			if ( geometryIndex !== null ) {

				// if the attribute is obsolete, create a new one

				if ( currentAttribute.version < geometryIndex.version ) {

					updateWireframeAttribute( geometry );

				}

			}

		} else {

			updateWireframeAttribute( geometry );

		}

		return wireframeAttributes.get( geometry );

	}

	return {

		get: get,
		update: update,

		getWireframeAttribute: getWireframeAttribute

	};

}

function WebGLIndexedBufferRenderer( gl, extensions, info ) {

	let mode;

	function setMode( value ) {

		mode = value;

	}

	let type, bytesPerElement;

	function setIndex( value ) {

		type = value.type;
		bytesPerElement = value.bytesPerElement;

	}

	function render( start, count ) {

		gl.drawElements( mode, count, type, start * bytesPerElement );

		info.update( count, mode, 1 );

	}

	function renderInstances( start, count, primcount ) {

		if ( primcount === 0 ) return;

		gl.drawElementsInstanced( mode, count, type, start * bytesPerElement, primcount );

		info.update( count, mode, primcount );

	}

	function renderMultiDraw( starts, counts, drawCount ) {

		if ( drawCount === 0 ) return;

		const extension = extensions.get( 'WEBGL_multi_draw' );
		extension.multiDrawElementsWEBGL( mode, counts, 0, type, starts, 0, drawCount );

		let elementCount = 0;
		for ( let i = 0; i < drawCount; i ++ ) {

			elementCount += counts[ i ];

		}

		info.update( elementCount, mode, 1 );


	}

	function renderMultiDrawInstances( starts, counts, drawCount, primcount ) {

		if ( drawCount === 0 ) return;

		const extension = extensions.get( 'WEBGL_multi_draw' );

		if ( extension === null ) {

			for ( let i = 0; i < starts.length; i ++ ) {

				renderInstances( starts[ i ] / bytesPerElement, counts[ i ], primcount[ i ] );

			}

		} else {

			extension.multiDrawElementsInstancedWEBGL( mode, counts, 0, type, starts, 0, primcount, 0, drawCount );

			let elementCount = 0;
			for ( let i = 0; i < drawCount; i ++ ) {

				elementCount += counts[ i ];

			}

			for ( let i = 0; i < primcount.length; i ++ ) {

				info.update( elementCount, mode, primcount[ i ] );

			}

		}

	}

	//

	this.setMode = setMode;
	this.setIndex = setIndex;
	this.render = render;
	this.renderInstances = renderInstances;
	this.renderMultiDraw = renderMultiDraw;
	this.renderMultiDrawInstances = renderMultiDrawInstances;

}

function WebGLInfo( gl ) {

	const memory = {
		geometries: 0,
		textures: 0
	};

	const render = {
		frame: 0,
		calls: 0,
		triangles: 0,
		points: 0,
		lines: 0
	};

	function update( count, mode, instanceCount ) {

		render.calls ++;

		switch ( mode ) {

			case gl.TRIANGLES:
				render.triangles += instanceCount * ( count / 3 );
				break;

			case gl.LINES:
				render.lines += instanceCount * ( count / 2 );
				break;

			case gl.LINE_STRIP:
				render.lines += instanceCount * ( count - 1 );
				break;

			case gl.LINE_LOOP:
				render.lines += instanceCount * count;
				break;

			case gl.POINTS:
				render.points += instanceCount * count;
				break;

			default:
				console.error( 'THREE.WebGLInfo: Unknown draw mode:', mode );
				break;

		}

	}

	function reset() {

		render.calls = 0;
		render.triangles = 0;
		render.points = 0;
		render.lines = 0;

	}

	return {
		memory: memory,
		render: render,
		programs: null,
		autoReset: true,
		reset: reset,
		update: update
	};

}

function WebGLMorphtargets( gl, capabilities, textures ) {

	const morphTextures = new WeakMap();
	const morph = new Vector4();

	function update( object, geometry, program ) {

		const objectInfluences = object.morphTargetInfluences;

		// the following encodes morph targets into an array of data textures. Each layer represents a single morph target.

		const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
		const morphTargetsCount = ( morphAttribute !== undefined ) ? morphAttribute.length : 0;

		let entry = morphTextures.get( geometry );

		if ( entry === undefined || entry.count !== morphTargetsCount ) {

			if ( entry !== undefined ) entry.texture.dispose();

			const hasMorphPosition = geometry.morphAttributes.position !== undefined;
			const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
			const hasMorphColors = geometry.morphAttributes.color !== undefined;

			const morphTargets = geometry.morphAttributes.position || [];
			const morphNormals = geometry.morphAttributes.normal || [];
			const morphColors = geometry.morphAttributes.color || [];

			let vertexDataCount = 0;

			if ( hasMorphPosition === true ) vertexDataCount = 1;
			if ( hasMorphNormals === true ) vertexDataCount = 2;
			if ( hasMorphColors === true ) vertexDataCount = 3;

			let width = geometry.attributes.position.count * vertexDataCount;
			let height = 1;

			if ( width > capabilities.maxTextureSize ) {

				height = Math.ceil( width / capabilities.maxTextureSize );
				width = capabilities.maxTextureSize;

			}

			const buffer = new Float32Array( width * height * 4 * morphTargetsCount );

			const texture = new DataArrayTexture( buffer, width, height, morphTargetsCount );
			texture.type = FloatType;
			texture.needsUpdate = true;

			// fill buffer

			const vertexDataStride = vertexDataCount * 4;

			for ( let i = 0; i < morphTargetsCount; i ++ ) {

				const morphTarget = morphTargets[ i ];
				const morphNormal = morphNormals[ i ];
				const morphColor = morphColors[ i ];

				const offset = width * height * 4 * i;

				for ( let j = 0; j < morphTarget.count; j ++ ) {

					const stride = j * vertexDataStride;

					if ( hasMorphPosition === true ) {

						morph.fromBufferAttribute( morphTarget, j );

						buffer[ offset + stride + 0 ] = morph.x;
						buffer[ offset + stride + 1 ] = morph.y;
						buffer[ offset + stride + 2 ] = morph.z;
						buffer[ offset + stride + 3 ] = 0;

					}

					if ( hasMorphNormals === true ) {

						morph.fromBufferAttribute( morphNormal, j );

						buffer[ offset + stride + 4 ] = morph.x;
						buffer[ offset + stride + 5 ] = morph.y;
						buffer[ offset + stride + 6 ] = morph.z;
						buffer[ offset + stride + 7 ] = 0;

					}

					if ( hasMorphColors === true ) {

						morph.fromBufferAttribute( morphColor, j );

						buffer[ offset + stride + 8 ] = morph.x;
						buffer[ offset + stride + 9 ] = morph.y;
						buffer[ offset + stride + 10 ] = morph.z;
						buffer[ offset + stride + 11 ] = ( morphColor.itemSize === 4 ) ? morph.w : 1;

					}

				}

			}

			entry = {
				count: morphTargetsCount,
				texture: texture,
				size: new Vector2( width, height )
			};

			morphTextures.set( geometry, entry );

			function disposeTexture() {

				texture.dispose();

				morphTextures.delete( geometry );

				geometry.removeEventListener( 'dispose', disposeTexture );

			}

			geometry.addEventListener( 'dispose', disposeTexture );

		}

		//
		if ( object.isInstancedMesh === true && object.morphTexture !== null ) {

			program.getUniforms().setValue( gl, 'morphTexture', object.morphTexture, textures );

		} else {

			let morphInfluencesSum = 0;

			for ( let i = 0; i < objectInfluences.length; i ++ ) {

				morphInfluencesSum += objectInfluences[ i ];

			}

			const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;


			program.getUniforms().setValue( gl, 'morphTargetBaseInfluence', morphBaseInfluence );
			program.getUniforms().setValue( gl, 'morphTargetInfluences', objectInfluences );

		}

		program.getUniforms().setValue( gl, 'morphTargetsTexture', entry.texture, textures );
		program.getUniforms().setValue( gl, 'morphTargetsTextureSize', entry.size );

	}

	return {

		update: update

	};

}

function WebGLObjects( gl, geometries, attributes, info ) {

	let updateMap = new WeakMap();

	function update( object ) {

		const frame = info.render.frame;

		const geometry = object.geometry;
		const buffergeometry = geometries.get( object, geometry );

		// Update once per frame

		if ( updateMap.get( buffergeometry ) !== frame ) {

			geometries.update( buffergeometry );

			updateMap.set( buffergeometry, frame );

		}

		if ( object.isInstancedMesh ) {

			if ( object.hasEventListener( 'dispose', onInstancedMeshDispose ) === false ) {

				object.addEventListener( 'dispose', onInstancedMeshDispose );

			}

			if ( updateMap.get( object ) !== frame ) {

				attributes.update( object.instanceMatrix, gl.ARRAY_BUFFER );

				if ( object.instanceColor !== null ) {

					attributes.update( object.instanceColor, gl.ARRAY_BUFFER );

				}

				updateMap.set( object, frame );

			}

		}

		if ( object.isSkinnedMesh ) {

			const skeleton = object.skeleton;

			if ( updateMap.get( skeleton ) !== frame ) {

				skeleton.update();

				updateMap.set( skeleton, frame );

			}

		}

		return buffergeometry;

	}

	function dispose() {

		updateMap = new WeakMap();

	}

	function onInstancedMeshDispose( event ) {

		const instancedMesh = event.target;

		instancedMesh.removeEventListener( 'dispose', onInstancedMeshDispose );

		attributes.remove( instancedMesh.instanceMatrix );

		if ( instancedMesh.instanceColor !== null ) attributes.remove( instancedMesh.instanceColor );

	}

	return {

		update: update,
		dispose: dispose

	};

}

class DepthTexture extends Texture {

	constructor( width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format = DepthFormat ) {

		if ( format !== DepthFormat && format !== DepthStencilFormat ) {

			throw new Error( 'DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat' );

		}

		if ( type === undefined && format === DepthFormat ) type = UnsignedIntType;
		if ( type === undefined && format === DepthStencilFormat ) type = UnsignedInt248Type;

		super( null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy );

		this.isDepthTexture = true;

		this.image = { width: width, height: height };

		this.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
		this.minFilter = minFilter !== undefined ? minFilter : NearestFilter;

		this.flipY = false;
		this.generateMipmaps = false;

		this.compareFunction = null;

	}


	copy( source ) {

		super.copy( source );

		this.compareFunction = source.compareFunction;

		return this;

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		if ( this.compareFunction !== null ) data.compareFunction = this.compareFunction;

		return data;

	}

}

/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */


const emptyTexture = /*@__PURE__*/ new Texture();

const emptyShadowTexture = /*@__PURE__*/ new DepthTexture( 1, 1 );

const emptyArrayTexture = /*@__PURE__*/ new DataArrayTexture();
const empty3dTexture = /*@__PURE__*/ new Data3DTexture();
const emptyCubeTexture = /*@__PURE__*/ new CubeTexture();

// --- Utilities ---

// Array Caches (provide typed arrays for temporary by size)

const arrayCacheF32 = [];
const arrayCacheI32 = [];

// Float32Array caches used for uploading Matrix uniforms

const mat4array = new Float32Array( 16 );
const mat3array = new Float32Array( 9 );
const mat2array = new Float32Array( 4 );

// Flattening for arrays of vectors and matrices

function flatten( array, nBlocks, blockSize ) {

	const firstElem = array[ 0 ];

	if ( firstElem <= 0 || firstElem > 0 ) return array;
	// unoptimized: ! isNaN( firstElem )
	// see http://jacksondunstan.com/articles/983

	const n = nBlocks * blockSize;
	let r = arrayCacheF32[ n ];

	if ( r === undefined ) {

		r = new Float32Array( n );
		arrayCacheF32[ n ] = r;

	}

	if ( nBlocks !== 0 ) {

		firstElem.toArray( r, 0 );

		for ( let i = 1, offset = 0; i !== nBlocks; ++ i ) {

			offset += blockSize;
			array[ i ].toArray( r, offset );

		}

	}

	return r;

}

function arraysEqual( a, b ) {

	if ( a.length !== b.length ) return false;

	for ( let i = 0, l = a.length; i < l; i ++ ) {

		if ( a[ i ] !== b[ i ] ) return false;

	}

	return true;

}

function copyArray( a, b ) {

	for ( let i = 0, l = b.length; i < l; i ++ ) {

		a[ i ] = b[ i ];

	}

}

// Texture unit allocation

function allocTexUnits( textures, n ) {

	let r = arrayCacheI32[ n ];

	if ( r === undefined ) {

		r = new Int32Array( n );
		arrayCacheI32[ n ] = r;

	}

	for ( let i = 0; i !== n; ++ i ) {

		r[ i ] = textures.allocateTextureUnit();

	}

	return r;

}

// --- Setters ---

// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.

// Single scalar

function setValueV1f( gl, v ) {

	const cache = this.cache;

	if ( cache[ 0 ] === v ) return;

	gl.uniform1f( this.addr, v );

	cache[ 0 ] = v;

}

// Single float vector (from flat array or THREE.VectorN)

function setValueV2f( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y ) {

			gl.uniform2f( this.addr, v.x, v.y );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform2fv( this.addr, v );

		copyArray( cache, v );

	}

}

function setValueV3f( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y || cache[ 2 ] !== v.z ) {

			gl.uniform3f( this.addr, v.x, v.y, v.z );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;
			cache[ 2 ] = v.z;

		}

	} else if ( v.r !== undefined ) {

		if ( cache[ 0 ] !== v.r || cache[ 1 ] !== v.g || cache[ 2 ] !== v.b ) {

			gl.uniform3f( this.addr, v.r, v.g, v.b );

			cache[ 0 ] = v.r;
			cache[ 1 ] = v.g;
			cache[ 2 ] = v.b;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform3fv( this.addr, v );

		copyArray( cache, v );

	}

}

function setValueV4f( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y || cache[ 2 ] !== v.z || cache[ 3 ] !== v.w ) {

			gl.uniform4f( this.addr, v.x, v.y, v.z, v.w );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;
			cache[ 2 ] = v.z;
			cache[ 3 ] = v.w;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform4fv( this.addr, v );

		copyArray( cache, v );

	}

}

// Single matrix (from flat array or THREE.MatrixN)

function setValueM2( gl, v ) {

	const cache = this.cache;
	const elements = v.elements;

	if ( elements === undefined ) {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniformMatrix2fv( this.addr, false, v );

		copyArray( cache, v );

	} else {

		if ( arraysEqual( cache, elements ) ) return;

		mat2array.set( elements );

		gl.uniformMatrix2fv( this.addr, false, mat2array );

		copyArray( cache, elements );

	}

}

function setValueM3( gl, v ) {

	const cache = this.cache;
	const elements = v.elements;

	if ( elements === undefined ) {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniformMatrix3fv( this.addr, false, v );

		copyArray( cache, v );

	} else {

		if ( arraysEqual( cache, elements ) ) return;

		mat3array.set( elements );

		gl.uniformMatrix3fv( this.addr, false, mat3array );

		copyArray( cache, elements );

	}

}

function setValueM4( gl, v ) {

	const cache = this.cache;
	const elements = v.elements;

	if ( elements === undefined ) {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniformMatrix4fv( this.addr, false, v );

		copyArray( cache, v );

	} else {

		if ( arraysEqual( cache, elements ) ) return;

		mat4array.set( elements );

		gl.uniformMatrix4fv( this.addr, false, mat4array );

		copyArray( cache, elements );

	}

}

// Single integer / boolean

function setValueV1i( gl, v ) {

	const cache = this.cache;

	if ( cache[ 0 ] === v ) return;

	gl.uniform1i( this.addr, v );

	cache[ 0 ] = v;

}

// Single integer / boolean vector (from flat array or THREE.VectorN)

function setValueV2i( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y ) {

			gl.uniform2i( this.addr, v.x, v.y );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform2iv( this.addr, v );

		copyArray( cache, v );

	}

}

function setValueV3i( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y || cache[ 2 ] !== v.z ) {

			gl.uniform3i( this.addr, v.x, v.y, v.z );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;
			cache[ 2 ] = v.z;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform3iv( this.addr, v );

		copyArray( cache, v );

	}

}

function setValueV4i( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y || cache[ 2 ] !== v.z || cache[ 3 ] !== v.w ) {

			gl.uniform4i( this.addr, v.x, v.y, v.z, v.w );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;
			cache[ 2 ] = v.z;
			cache[ 3 ] = v.w;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform4iv( this.addr, v );

		copyArray( cache, v );

	}

}

// Single unsigned integer

function setValueV1ui( gl, v ) {

	const cache = this.cache;

	if ( cache[ 0 ] === v ) return;

	gl.uniform1ui( this.addr, v );

	cache[ 0 ] = v;

}

// Single unsigned integer vector (from flat array or THREE.VectorN)

function setValueV2ui( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y ) {

			gl.uniform2ui( this.addr, v.x, v.y );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform2uiv( this.addr, v );

		copyArray( cache, v );

	}

}

function setValueV3ui( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y || cache[ 2 ] !== v.z ) {

			gl.uniform3ui( this.addr, v.x, v.y, v.z );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;
			cache[ 2 ] = v.z;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform3uiv( this.addr, v );

		copyArray( cache, v );

	}

}

function setValueV4ui( gl, v ) {

	const cache = this.cache;

	if ( v.x !== undefined ) {

		if ( cache[ 0 ] !== v.x || cache[ 1 ] !== v.y || cache[ 2 ] !== v.z || cache[ 3 ] !== v.w ) {

			gl.uniform4ui( this.addr, v.x, v.y, v.z, v.w );

			cache[ 0 ] = v.x;
			cache[ 1 ] = v.y;
			cache[ 2 ] = v.z;
			cache[ 3 ] = v.w;

		}

	} else {

		if ( arraysEqual( cache, v ) ) return;

		gl.uniform4uiv( this.addr, v );

		copyArray( cache, v );

	}

}


// Single texture (2D / Cube)

function setValueT1( gl, v, textures ) {

	const cache = this.cache;
	const unit = textures.allocateTextureUnit();

	if ( cache[ 0 ] !== unit ) {

		gl.uniform1i( this.addr, unit );
		cache[ 0 ] = unit;

	}

	let emptyTexture2D;

	if ( this.type === gl.SAMPLER_2D_SHADOW ) {

		emptyShadowTexture.compareFunction = LessEqualCompare; // #28670
		emptyTexture2D = emptyShadowTexture;

	} else {

		emptyTexture2D = emptyTexture;

	}

	textures.setTexture2D( v || emptyTexture2D, unit );

}

function setValueT3D1( gl, v, textures ) {

	const cache = this.cache;
	const unit = textures.allocateTextureUnit();

	if ( cache[ 0 ] !== unit ) {

		gl.uniform1i( this.addr, unit );
		cache[ 0 ] = unit;

	}

	textures.setTexture3D( v || empty3dTexture, unit );

}

function setValueT6( gl, v, textures ) {

	const cache = this.cache;
	const unit = textures.allocateTextureUnit();

	if ( cache[ 0 ] !== unit ) {

		gl.uniform1i( this.addr, unit );
		cache[ 0 ] = unit;

	}

	textures.setTextureCube( v || emptyCubeTexture, unit );

}

function setValueT2DArray1( gl, v, textures ) {

	const cache = this.cache;
	const unit = textures.allocateTextureUnit();

	if ( cache[ 0 ] !== unit ) {

		gl.uniform1i( this.addr, unit );
		cache[ 0 ] = unit;

	}

	textures.setTexture2DArray( v || emptyArrayTexture, unit );

}

// Helper to pick the right setter for the singular case

function getSingularSetter( type ) {

	switch ( type ) {

		case 0x1406: return setValueV1f; // FLOAT
		case 0x8b50: return setValueV2f; // _VEC2
		case 0x8b51: return setValueV3f; // _VEC3
		case 0x8b52: return setValueV4f; // _VEC4

		case 0x8b5a: return setValueM2; // _MAT2
		case 0x8b5b: return setValueM3; // _MAT3
		case 0x8b5c: return setValueM4; // _MAT4

		case 0x1404: case 0x8b56: return setValueV1i; // INT, BOOL
		case 0x8b53: case 0x8b57: return setValueV2i; // _VEC2
		case 0x8b54: case 0x8b58: return setValueV3i; // _VEC3
		case 0x8b55: case 0x8b59: return setValueV4i; // _VEC4

		case 0x1405: return setValueV1ui; // UINT
		case 0x8dc6: return setValueV2ui; // _VEC2
		case 0x8dc7: return setValueV3ui; // _VEC3
		case 0x8dc8: return setValueV4ui; // _VEC4

		case 0x8b5e: // SAMPLER_2D
		case 0x8d66: // SAMPLER_EXTERNAL_OES
		case 0x8dca: // INT_SAMPLER_2D
		case 0x8dd2: // UNSIGNED_INT_SAMPLER_2D
		case 0x8b62: // SAMPLER_2D_SHADOW
			return setValueT1;

		case 0x8b5f: // SAMPLER_3D
		case 0x8dcb: // INT_SAMPLER_3D
		case 0x8dd3: // UNSIGNED_INT_SAMPLER_3D
			return setValueT3D1;

		case 0x8b60: // SAMPLER_CUBE
		case 0x8dcc: // INT_SAMPLER_CUBE
		case 0x8dd4: // UNSIGNED_INT_SAMPLER_CUBE
		case 0x8dc5: // SAMPLER_CUBE_SHADOW
			return setValueT6;

		case 0x8dc1: // SAMPLER_2D_ARRAY
		case 0x8dcf: // INT_SAMPLER_2D_ARRAY
		case 0x8dd7: // UNSIGNED_INT_SAMPLER_2D_ARRAY
		case 0x8dc4: // SAMPLER_2D_ARRAY_SHADOW
			return setValueT2DArray1;

	}

}


// Array of scalars

function setValueV1fArray( gl, v ) {

	gl.uniform1fv( this.addr, v );

}

// Array of vectors (from flat array or array of THREE.VectorN)

function setValueV2fArray( gl, v ) {

	const data = flatten( v, this.size, 2 );

	gl.uniform2fv( this.addr, data );

}

function setValueV3fArray( gl, v ) {

	const data = flatten( v, this.size, 3 );

	gl.uniform3fv( this.addr, data );

}

function setValueV4fArray( gl, v ) {

	const data = flatten( v, this.size, 4 );

	gl.uniform4fv( this.addr, data );

}

// Array of matrices (from flat array or array of THREE.MatrixN)

function setValueM2Array( gl, v ) {

	const data = flatten( v, this.size, 4 );

	gl.uniformMatrix2fv( this.addr, false, data );

}

function setValueM3Array( gl, v ) {

	const data = flatten( v, this.size, 9 );

	gl.uniformMatrix3fv( this.addr, false, data );

}

function setValueM4Array( gl, v ) {

	const data = flatten( v, this.size, 16 );

	gl.uniformMatrix4fv( this.addr, false, data );

}

// Array of integer / boolean

function setValueV1iArray( gl, v ) {

	gl.uniform1iv( this.addr, v );

}

// Array of integer / boolean vectors (from flat array)

function setValueV2iArray( gl, v ) {

	gl.uniform2iv( this.addr, v );

}

function setValueV3iArray( gl, v ) {

	gl.uniform3iv( this.addr, v );

}

function setValueV4iArray( gl, v ) {

	gl.uniform4iv( this.addr, v );

}

// Array of unsigned integer

function setValueV1uiArray( gl, v ) {

	gl.uniform1uiv( this.addr, v );

}

// Array of unsigned integer vectors (from flat array)

function setValueV2uiArray( gl, v ) {

	gl.uniform2uiv( this.addr, v );

}

function setValueV3uiArray( gl, v ) {

	gl.uniform3uiv( this.addr, v );

}

function setValueV4uiArray( gl, v ) {

	gl.uniform4uiv( this.addr, v );

}


// Array of textures (2D / 3D / Cube / 2DArray)

function setValueT1Array( gl, v, textures ) {

	const cache = this.cache;

	const n = v.length;

	const units = allocTexUnits( textures, n );

	if ( ! arraysEqual( cache, units ) ) {

		gl.uniform1iv( this.addr, units );

		copyArray( cache, units );

	}

	for ( let i = 0; i !== n; ++ i ) {

		textures.setTexture2D( v[ i ] || emptyTexture, units[ i ] );

	}

}

function setValueT3DArray( gl, v, textures ) {

	const cache = this.cache;

	const n = v.length;

	const units = allocTexUnits( textures, n );

	if ( ! arraysEqual( cache, units ) ) {

		gl.uniform1iv( this.addr, units );

		copyArray( cache, units );

	}

	for ( let i = 0; i !== n; ++ i ) {

		textures.setTexture3D( v[ i ] || empty3dTexture, units[ i ] );

	}

}

function setValueT6Array( gl, v, textures ) {

	const cache = this.cache;

	const n = v.length;

	const units = allocTexUnits( textures, n );

	if ( ! arraysEqual( cache, units ) ) {

		gl.uniform1iv( this.addr, units );

		copyArray( cache, units );

	}

	for ( let i = 0; i !== n; ++ i ) {

		textures.setTextureCube( v[ i ] || emptyCubeTexture, units[ i ] );

	}

}

function setValueT2DArrayArray( gl, v, textures ) {

	const cache = this.cache;

	const n = v.length;

	const units = allocTexUnits( textures, n );

	if ( ! arraysEqual( cache, units ) ) {

		gl.uniform1iv( this.addr, units );

		copyArray( cache, units );

	}

	for ( let i = 0; i !== n; ++ i ) {

		textures.setTexture2DArray( v[ i ] || emptyArrayTexture, units[ i ] );

	}

}


// Helper to pick the right setter for a pure (bottom-level) array

function getPureArraySetter( type ) {

	switch ( type ) {

		case 0x1406: return setValueV1fArray; // FLOAT
		case 0x8b50: return setValueV2fArray; // _VEC2
		case 0x8b51: return setValueV3fArray; // _VEC3
		case 0x8b52: return setValueV4fArray; // _VEC4

		case 0x8b5a: return setValueM2Array; // _MAT2
		case 0x8b5b: return setValueM3Array; // _MAT3
		case 0x8b5c: return setValueM4Array; // _MAT4

		case 0x1404: case 0x8b56: return setValueV1iArray; // INT, BOOL
		case 0x8b53: case 0x8b57: return setValueV2iArray; // _VEC2
		case 0x8b54: case 0x8b58: return setValueV3iArray; // _VEC3
		case 0x8b55: case 0x8b59: return setValueV4iArray; // _VEC4

		case 0x1405: return setValueV1uiArray; // UINT
		case 0x8dc6: return setValueV2uiArray; // _VEC2
		case 0x8dc7: return setValueV3uiArray; // _VEC3
		case 0x8dc8: return setValueV4uiArray; // _VEC4

		case 0x8b5e: // SAMPLER_2D
		case 0x8d66: // SAMPLER_EXTERNAL_OES
		case 0x8dca: // INT_SAMPLER_2D
		case 0x8dd2: // UNSIGNED_INT_SAMPLER_2D
		case 0x8b62: // SAMPLER_2D_SHADOW
			return setValueT1Array;

		case 0x8b5f: // SAMPLER_3D
		case 0x8dcb: // INT_SAMPLER_3D
		case 0x8dd3: // UNSIGNED_INT_SAMPLER_3D
			return setValueT3DArray;

		case 0x8b60: // SAMPLER_CUBE
		case 0x8dcc: // INT_SAMPLER_CUBE
		case 0x8dd4: // UNSIGNED_INT_SAMPLER_CUBE
		case 0x8dc5: // SAMPLER_CUBE_SHADOW
			return setValueT6Array;

		case 0x8dc1: // SAMPLER_2D_ARRAY
		case 0x8dcf: // INT_SAMPLER_2D_ARRAY
		case 0x8dd7: // UNSIGNED_INT_SAMPLER_2D_ARRAY
		case 0x8dc4: // SAMPLER_2D_ARRAY_SHADOW
			return setValueT2DArrayArray;

	}

}

// --- Uniform Classes ---

class SingleUniform {

	constructor( id, activeInfo, addr ) {

		this.id = id;
		this.addr = addr;
		this.cache = [];
		this.type = activeInfo.type;
		this.setValue = getSingularSetter( activeInfo.type );

		// this.path = activeInfo.name; // DEBUG

	}

}

class PureArrayUniform {

	constructor( id, activeInfo, addr ) {

		this.id = id;
		this.addr = addr;
		this.cache = [];
		this.type = activeInfo.type;
		this.size = activeInfo.size;
		this.setValue = getPureArraySetter( activeInfo.type );

		// this.path = activeInfo.name; // DEBUG

	}

}

class StructuredUniform {

	constructor( id ) {

		this.id = id;

		this.seq = [];
		this.map = {};

	}

	setValue( gl, value, textures ) {

		const seq = this.seq;

		for ( let i = 0, n = seq.length; i !== n; ++ i ) {

			const u = seq[ i ];
			u.setValue( gl, value[ u.id ], textures );

		}

	}

}

// --- Top-level ---

// Parser - builds up the property tree from the path strings

const RePathPart = /(\w+)(\])?(\[|\.)?/g;

// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.

function addUniform( container, uniformObject ) {

	container.seq.push( uniformObject );
	container.map[ uniformObject.id ] = uniformObject;

}

function parseUniform( activeInfo, addr, container ) {

	const path = activeInfo.name,
		pathLength = path.length;

	// reset RegExp object, because of the early exit of a previous run
	RePathPart.lastIndex = 0;

	while ( true ) {

		const match = RePathPart.exec( path ),
			matchEnd = RePathPart.lastIndex;

		let id = match[ 1 ];
		const idIsIndex = match[ 2 ] === ']',
			subscript = match[ 3 ];

		if ( idIsIndex ) id = id | 0; // convert to integer

		if ( subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength ) {

			// bare name or "pure" bottom-level array "[0]" suffix

			addUniform( container, subscript === undefined ?
				new SingleUniform( id, activeInfo, addr ) :
				new PureArrayUniform( id, activeInfo, addr ) );

			break;

		} else {

			// step into inner node / create it in case it doesn't exist

			const map = container.map;
			let next = map[ id ];

			if ( next === undefined ) {

				next = new StructuredUniform( id );
				addUniform( container, next );

			}

			container = next;

		}

	}

}

// Root Container

class WebGLUniforms {

	constructor( gl, program ) {

		this.seq = [];
		this.map = {};

		const n = gl.getProgramParameter( program, gl.ACTIVE_UNIFORMS );

		for ( let i = 0; i < n; ++ i ) {

			const info = gl.getActiveUniform( program, i ),
				addr = gl.getUniformLocation( program, info.name );

			parseUniform( info, addr, this );

		}

	}

	setValue( gl, name, value, textures ) {

		const u = this.map[ name ];

		if ( u !== undefined ) u.setValue( gl, value, textures );

	}

	setOptional( gl, object, name ) {

		const v = object[ name ];

		if ( v !== undefined ) this.setValue( gl, name, v );

	}

	static upload( gl, seq, values, textures ) {

		for ( let i = 0, n = seq.length; i !== n; ++ i ) {

			const u = seq[ i ],
				v = values[ u.id ];

			if ( v.needsUpdate !== false ) {

				// note: always updating when .needsUpdate is undefined
				u.setValue( gl, v.value, textures );

			}

		}

	}

	static seqWithValue( seq, values ) {

		const r = [];

		for ( let i = 0, n = seq.length; i !== n; ++ i ) {

			const u = seq[ i ];
			if ( u.id in values ) r.push( u );

		}

		return r;

	}

}

function WebGLShader( gl, type, string ) {

	const shader = gl.createShader( type );

	gl.shaderSource( shader, string );
	gl.compileShader( shader );

	return shader;

}

// From https://www.khronos.org/registry/webgl/extensions/KHR_parallel_shader_compile/
const COMPLETION_STATUS_KHR = 0x91B1;

let programIdCount = 0;

function handleSource( string, errorLine ) {

	const lines = string.split( '\n' );
	const lines2 = [];

	const from = Math.max( errorLine - 6, 0 );
	const to = Math.min( errorLine + 6, lines.length );

	for ( let i = from; i < to; i ++ ) {

		const line = i + 1;
		lines2.push( `${line === errorLine ? '>' : ' '} ${line}: ${lines[ i ]}` );

	}

	return lines2.join( '\n' );

}

function getEncodingComponents( colorSpace ) {

	const workingPrimaries = ColorManagement.getPrimaries( ColorManagement.workingColorSpace );
	const encodingPrimaries = ColorManagement.getPrimaries( colorSpace );

	let gamutMapping;

	if ( workingPrimaries === encodingPrimaries ) {

		gamutMapping = '';

	} else if ( workingPrimaries === P3Primaries && encodingPrimaries === Rec709Primaries ) {

		gamutMapping = 'LinearDisplayP3ToLinearSRGB';

	} else if ( workingPrimaries === Rec709Primaries && encodingPrimaries === P3Primaries ) {

		gamutMapping = 'LinearSRGBToLinearDisplayP3';

	}

	switch ( colorSpace ) {

		case LinearSRGBColorSpace:
		case LinearDisplayP3ColorSpace:
			return [ gamutMapping, 'LinearTransferOETF' ];

		case SRGBColorSpace:
		case DisplayP3ColorSpace:
			return [ gamutMapping, 'sRGBTransferOETF' ];

		default:
			console.warn( 'THREE.WebGLProgram: Unsupported color space:', colorSpace );
			return [ gamutMapping, 'LinearTransferOETF' ];

	}

}

function getShaderErrors( gl, shader, type ) {

	const status = gl.getShaderParameter( shader, gl.COMPILE_STATUS );
	const errors = gl.getShaderInfoLog( shader ).trim();

	if ( status && errors === '' ) return '';

	const errorMatches = /ERROR: 0:(\d+)/.exec( errors );
	if ( errorMatches ) {

		// --enable-privileged-webgl-extension
		// console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );

		const errorLine = parseInt( errorMatches[ 1 ] );
		return type.toUpperCase() + '\n\n' + errors + '\n\n' + handleSource( gl.getShaderSource( shader ), errorLine );

	} else {

		return errors;

	}

}

function getTexelEncodingFunction( functionName, colorSpace ) {

	const components = getEncodingComponents( colorSpace );
	return `vec4 ${functionName}( vec4 value ) { return ${components[ 0 ]}( ${components[ 1 ]}( value ) ); }`;

}

function getToneMappingFunction( functionName, toneMapping ) {

	let toneMappingName;

	switch ( toneMapping ) {

		case LinearToneMapping:
			toneMappingName = 'Linear';
			break;

		case ReinhardToneMapping:
			toneMappingName = 'Reinhard';
			break;

		case CineonToneMapping:
			toneMappingName = 'OptimizedCineon';
			break;

		case ACESFilmicToneMapping:
			toneMappingName = 'ACESFilmic';
			break;

		case AgXToneMapping:
			toneMappingName = 'AgX';
			break;

		case NeutralToneMapping:
			toneMappingName = 'Neutral';
			break;

		case CustomToneMapping:
			toneMappingName = 'Custom';
			break;

		default:
			console.warn( 'THREE.WebGLProgram: Unsupported toneMapping:', toneMapping );
			toneMappingName = 'Linear';

	}

	return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';

}

function generateVertexExtensions( parameters ) {

	const chunks = [
		parameters.extensionClipCullDistance ? '#extension GL_ANGLE_clip_cull_distance : require' : '',
		parameters.extensionMultiDraw ? '#extension GL_ANGLE_multi_draw : require' : '',
	];

	return chunks.filter( filterEmptyLine ).join( '\n' );

}

function generateDefines( defines ) {

	const chunks = [];

	for ( const name in defines ) {

		const value = defines[ name ];

		if ( value === false ) continue;

		chunks.push( '#define ' + name + ' ' + value );

	}

	return chunks.join( '\n' );

}

function fetchAttributeLocations( gl, program ) {

	const attributes = {};

	const n = gl.getProgramParameter( program, gl.ACTIVE_ATTRIBUTES );

	for ( let i = 0; i < n; i ++ ) {

		const info = gl.getActiveAttrib( program, i );
		const name = info.name;

		let locationSize = 1;
		if ( info.type === gl.FLOAT_MAT2 ) locationSize = 2;
		if ( info.type === gl.FLOAT_MAT3 ) locationSize = 3;
		if ( info.type === gl.FLOAT_MAT4 ) locationSize = 4;

		// console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );

		attributes[ name ] = {
			type: info.type,
			location: gl.getAttribLocation( program, name ),
			locationSize: locationSize
		};

	}

	return attributes;

}

function filterEmptyLine( string ) {

	return string !== '';

}

function replaceLightNums( string, parameters ) {

	const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;

	return string
		.replace( /NUM_DIR_LIGHTS/g, parameters.numDirLights )
		.replace( /NUM_SPOT_LIGHTS/g, parameters.numSpotLights )
		.replace( /NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps )
		.replace( /NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords )
		.replace( /NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights )
		.replace( /NUM_POINT_LIGHTS/g, parameters.numPointLights )
		.replace( /NUM_HEMI_LIGHTS/g, parameters.numHemiLights )
		.replace( /NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows )
		.replace( /NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps )
		.replace( /NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows )
		.replace( /NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows );

}

function replaceClippingPlaneNums( string, parameters ) {

	return string
		.replace( /NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes )
		.replace( /UNION_CLIPPING_PLANES/g, ( parameters.numClippingPlanes - parameters.numClipIntersection ) );

}

// Resolve Includes

const includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;

function resolveIncludes( string ) {

	return string.replace( includePattern, includeReplacer );

}

const shaderChunkMap = new Map();

function includeReplacer( match, include ) {

	let string = ShaderChunk[ include ];

	if ( string === undefined ) {

		const newInclude = shaderChunkMap.get( include );

		if ( newInclude !== undefined ) {

			string = ShaderChunk[ newInclude ];
			console.warn( 'THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude );

		} else {

			throw new Error( 'Can not resolve #include <' + include + '>' );

		}

	}

	return resolveIncludes( string );

}

// Unroll Loops

const unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;

function unrollLoops( string ) {

	return string.replace( unrollLoopPattern, loopReplacer );

}

function loopReplacer( match, start, end, snippet ) {

	let string = '';

	for ( let i = parseInt( start ); i < parseInt( end ); i ++ ) {

		string += snippet
			.replace( /\[\s*i\s*\]/g, '[ ' + i + ' ]' )
			.replace( /UNROLLED_LOOP_INDEX/g, i );

	}

	return string;

}

//

function generatePrecision( parameters ) {

	let precisionstring = `precision ${parameters.precision} float;
	precision ${parameters.precision} int;
	precision ${parameters.precision} sampler2D;
	precision ${parameters.precision} samplerCube;
	precision ${parameters.precision} sampler3D;
	precision ${parameters.precision} sampler2DArray;
	precision ${parameters.precision} sampler2DShadow;
	precision ${parameters.precision} samplerCubeShadow;
	precision ${parameters.precision} sampler2DArrayShadow;
	precision ${parameters.precision} isampler2D;
	precision ${parameters.precision} isampler3D;
	precision ${parameters.precision} isamplerCube;
	precision ${parameters.precision} isampler2DArray;
	precision ${parameters.precision} usampler2D;
	precision ${parameters.precision} usampler3D;
	precision ${parameters.precision} usamplerCube;
	precision ${parameters.precision} usampler2DArray;
	`;

	if ( parameters.precision === 'highp' ) {

		precisionstring += '\n#define HIGH_PRECISION';

	} else if ( parameters.precision === 'mediump' ) {

		precisionstring += '\n#define MEDIUM_PRECISION';

	} else if ( parameters.precision === 'lowp' ) {

		precisionstring += '\n#define LOW_PRECISION';

	}

	return precisionstring;

}

function generateShadowMapTypeDefine( parameters ) {

	let shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';

	if ( parameters.shadowMapType === PCFShadowMap ) {

		shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';

	} else if ( parameters.shadowMapType === PCFSoftShadowMap ) {

		shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';

	} else if ( parameters.shadowMapType === VSMShadowMap ) {

		shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';

	}

	return shadowMapTypeDefine;

}

function generateEnvMapTypeDefine( parameters ) {

	let envMapTypeDefine = 'ENVMAP_TYPE_CUBE';

	if ( parameters.envMap ) {

		switch ( parameters.envMapMode ) {

			case CubeReflectionMapping:
			case CubeRefractionMapping:
				envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
				break;

			case CubeUVReflectionMapping:
				envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
				break;

		}

	}

	return envMapTypeDefine;

}

function generateEnvMapModeDefine( parameters ) {

	let envMapModeDefine = 'ENVMAP_MODE_REFLECTION';

	if ( parameters.envMap ) {

		switch ( parameters.envMapMode ) {

			case CubeRefractionMapping:

				envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
				break;

		}

	}

	return envMapModeDefine;

}

function generateEnvMapBlendingDefine( parameters ) {

	let envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';

	if ( parameters.envMap ) {

		switch ( parameters.combine ) {

			case MultiplyOperation:
				envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
				break;

			case MixOperation:
				envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
				break;

			case AddOperation:
				envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
				break;

		}

	}

	return envMapBlendingDefine;

}

function generateCubeUVSize( parameters ) {

	const imageHeight = parameters.envMapCubeUVHeight;

	if ( imageHeight === null ) return null;

	const maxMip = Math.log2( imageHeight ) - 2;

	const texelHeight = 1.0 / imageHeight;

	const texelWidth = 1.0 / ( 3 * Math.max( Math.pow( 2, maxMip ), 7 * 16 ) );

	return { texelWidth, texelHeight, maxMip };

}

function WebGLProgram( renderer, cacheKey, parameters, bindingStates ) {

	// TODO Send this event to Three.js DevTools
	// console.log( 'WebGLProgram', cacheKey );

	const gl = renderer.getContext();

	const defines = parameters.defines;

	let vertexShader = parameters.vertexShader;
	let fragmentShader = parameters.fragmentShader;

	const shadowMapTypeDefine = generateShadowMapTypeDefine( parameters );
	const envMapTypeDefine = generateEnvMapTypeDefine( parameters );
	const envMapModeDefine = generateEnvMapModeDefine( parameters );
	const envMapBlendingDefine = generateEnvMapBlendingDefine( parameters );
	const envMapCubeUVSize = generateCubeUVSize( parameters );

	const customVertexExtensions = generateVertexExtensions( parameters );

	const customDefines = generateDefines( defines );

	const program = gl.createProgram();

	let prefixVertex, prefixFragment;
	let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';

	if ( parameters.isRawShaderMaterial ) {

		prefixVertex = [

			'#define SHADER_TYPE ' + parameters.shaderType,
			'#define SHADER_NAME ' + parameters.shaderName,

			customDefines

		].filter( filterEmptyLine ).join( '\n' );

		if ( prefixVertex.length > 0 ) {

			prefixVertex += '\n';

		}

		prefixFragment = [

			'#define SHADER_TYPE ' + parameters.shaderType,
			'#define SHADER_NAME ' + parameters.shaderName,

			customDefines

		].filter( filterEmptyLine ).join( '\n' );

		if ( prefixFragment.length > 0 ) {

			prefixFragment += '\n';

		}

	} else {

		prefixVertex = [

			generatePrecision( parameters ),

			'#define SHADER_TYPE ' + parameters.shaderType,
			'#define SHADER_NAME ' + parameters.shaderName,

			customDefines,

			parameters.extensionClipCullDistance ? '#define USE_CLIP_DISTANCE' : '',
			parameters.batching ? '#define USE_BATCHING' : '',
			parameters.batchingColor ? '#define USE_BATCHING_COLOR' : '',
			parameters.instancing ? '#define USE_INSTANCING' : '',
			parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
			parameters.instancingMorph ? '#define USE_INSTANCING_MORPH' : '',

			parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
			parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',

			parameters.map ? '#define USE_MAP' : '',
			parameters.envMap ? '#define USE_ENVMAP' : '',
			parameters.envMap ? '#define ' + envMapModeDefine : '',
			parameters.lightMap ? '#define USE_LIGHTMAP' : '',
			parameters.aoMap ? '#define USE_AOMAP' : '',
			parameters.bumpMap ? '#define USE_BUMPMAP' : '',
			parameters.normalMap ? '#define USE_NORMALMAP' : '',
			parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
			parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
			parameters.displacementMap ? '#define USE_DISPLACEMENTMAP' : '',
			parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',

			parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
			parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',

			parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
			parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
			parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',

			parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
			parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',

			parameters.specularMap ? '#define USE_SPECULARMAP' : '',
			parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
			parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',

			parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
			parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
			parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
			parameters.alphaHash ? '#define USE_ALPHAHASH' : '',

			parameters.transmission ? '#define USE_TRANSMISSION' : '',
			parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
			parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',

			parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
			parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',

			//

			parameters.mapUv ? '#define MAP_UV ' + parameters.mapUv : '',
			parameters.alphaMapUv ? '#define ALPHAMAP_UV ' + parameters.alphaMapUv : '',
			parameters.lightMapUv ? '#define LIGHTMAP_UV ' + parameters.lightMapUv : '',
			parameters.aoMapUv ? '#define AOMAP_UV ' + parameters.aoMapUv : '',
			parameters.emissiveMapUv ? '#define EMISSIVEMAP_UV ' + parameters.emissiveMapUv : '',
			parameters.bumpMapUv ? '#define BUMPMAP_UV ' + parameters.bumpMapUv : '',
			parameters.normalMapUv ? '#define NORMALMAP_UV ' + parameters.normalMapUv : '',
			parameters.displacementMapUv ? '#define DISPLACEMENTMAP_UV ' + parameters.displacementMapUv : '',

			parameters.metalnessMapUv ? '#define METALNESSMAP_UV ' + parameters.metalnessMapUv : '',
			parameters.roughnessMapUv ? '#define ROUGHNESSMAP_UV ' + parameters.roughnessMapUv : '',

			parameters.anisotropyMapUv ? '#define ANISOTROPYMAP_UV ' + parameters.anisotropyMapUv : '',

			parameters.clearcoatMapUv ? '#define CLEARCOATMAP_UV ' + parameters.clearcoatMapUv : '',
			parameters.clearcoatNormalMapUv ? '#define CLEARCOAT_NORMALMAP_UV ' + parameters.clearcoatNormalMapUv : '',
			parameters.clearcoatRoughnessMapUv ? '#define CLEARCOAT_ROUGHNESSMAP_UV ' + parameters.clearcoatRoughnessMapUv : '',

			parameters.iridescenceMapUv ? '#define IRIDESCENCEMAP_UV ' + parameters.iridescenceMapUv : '',
			parameters.iridescenceThicknessMapUv ? '#define IRIDESCENCE_THICKNESSMAP_UV ' + parameters.iridescenceThicknessMapUv : '',

			parameters.sheenColorMapUv ? '#define SHEEN_COLORMAP_UV ' + parameters.sheenColorMapUv : '',
			parameters.sheenRoughnessMapUv ? '#define SHEEN_ROUGHNESSMAP_UV ' + parameters.sheenRoughnessMapUv : '',

			parameters.specularMapUv ? '#define SPECULARMAP_UV ' + parameters.specularMapUv : '',
			parameters.specularColorMapUv ? '#define SPECULAR_COLORMAP_UV ' + parameters.specularColorMapUv : '',
			parameters.specularIntensityMapUv ? '#define SPECULAR_INTENSITYMAP_UV ' + parameters.specularIntensityMapUv : '',

			parameters.transmissionMapUv ? '#define TRANSMISSIONMAP_UV ' + parameters.transmissionMapUv : '',
			parameters.thicknessMapUv ? '#define THICKNESSMAP_UV ' + parameters.thicknessMapUv : '',

			//

			parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
			parameters.vertexColors ? '#define USE_COLOR' : '',
			parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
			parameters.vertexUv1s ? '#define USE_UV1' : '',
			parameters.vertexUv2s ? '#define USE_UV2' : '',
			parameters.vertexUv3s ? '#define USE_UV3' : '',

			parameters.pointsUvs ? '#define USE_POINTS_UV' : '',

			parameters.flatShading ? '#define FLAT_SHADED' : '',

			parameters.skinning ? '#define USE_SKINNING' : '',

			parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
			parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
			( parameters.morphColors ) ? '#define USE_MORPHCOLORS' : '',
			( parameters.morphTargetsCount > 0 ) ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '',
			( parameters.morphTargetsCount > 0 ) ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '',
			parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
			parameters.flipSided ? '#define FLIP_SIDED' : '',

			parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
			parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',

			parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',

			parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',

			parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',

			'uniform mat4 modelMatrix;',
			'uniform mat4 modelViewMatrix;',
			'uniform mat4 projectionMatrix;',
			'uniform mat4 viewMatrix;',
			'uniform mat3 normalMatrix;',
			'uniform vec3 cameraPosition;',
			'uniform bool isOrthographic;',

			'#ifdef USE_INSTANCING',

			'	attribute mat4 instanceMatrix;',

			'#endif',

			'#ifdef USE_INSTANCING_COLOR',

			'	attribute vec3 instanceColor;',

			'#endif',

			'#ifdef USE_INSTANCING_MORPH',

			'	uniform sampler2D morphTexture;',

			'#endif',

			'attribute vec3 position;',
			'attribute vec3 normal;',
			'attribute vec2 uv;',

			'#ifdef USE_UV1',

			'	attribute vec2 uv1;',

			'#endif',

			'#ifdef USE_UV2',

			'	attribute vec2 uv2;',

			'#endif',

			'#ifdef USE_UV3',

			'	attribute vec2 uv3;',

			'#endif',

			'#ifdef USE_TANGENT',

			'	attribute vec4 tangent;',

			'#endif',

			'#if defined( USE_COLOR_ALPHA )',

			'	attribute vec4 color;',

			'#elif defined( USE_COLOR )',

			'	attribute vec3 color;',

			'#endif',

			'#ifdef USE_SKINNING',

			'	attribute vec4 skinIndex;',
			'	attribute vec4 skinWeight;',

			'#endif',

			'\n'

		].filter( filterEmptyLine ).join( '\n' );

		prefixFragment = [

			generatePrecision( parameters ),

			'#define SHADER_TYPE ' + parameters.shaderType,
			'#define SHADER_NAME ' + parameters.shaderName,

			customDefines,

			parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
			parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',

			parameters.alphaToCoverage ? '#define ALPHA_TO_COVERAGE' : '',
			parameters.map ? '#define USE_MAP' : '',
			parameters.matcap ? '#define USE_MATCAP' : '',
			parameters.envMap ? '#define USE_ENVMAP' : '',
			parameters.envMap ? '#define ' + envMapTypeDefine : '',
			parameters.envMap ? '#define ' + envMapModeDefine : '',
			parameters.envMap ? '#define ' + envMapBlendingDefine : '',
			envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '',
			envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '',
			envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '',
			parameters.lightMap ? '#define USE_LIGHTMAP' : '',
			parameters.aoMap ? '#define USE_AOMAP' : '',
			parameters.bumpMap ? '#define USE_BUMPMAP' : '',
			parameters.normalMap ? '#define USE_NORMALMAP' : '',
			parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
			parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
			parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',

			parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
			parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',

			parameters.clearcoat ? '#define USE_CLEARCOAT' : '',
			parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
			parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
			parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',

			parameters.dispersion ? '#define USE_DISPERSION' : '',

			parameters.iridescence ? '#define USE_IRIDESCENCE' : '',
			parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
			parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',

			parameters.specularMap ? '#define USE_SPECULARMAP' : '',
			parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
			parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',

			parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
			parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',

			parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
			parameters.alphaTest ? '#define USE_ALPHATEST' : '',
			parameters.alphaHash ? '#define USE_ALPHAHASH' : '',

			parameters.sheen ? '#define USE_SHEEN' : '',
			parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
			parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',

			parameters.transmission ? '#define USE_TRANSMISSION' : '',
			parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
			parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',

			parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
			parameters.vertexColors || parameters.instancingColor || parameters.batchingColor ? '#define USE_COLOR' : '',
			parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
			parameters.vertexUv1s ? '#define USE_UV1' : '',
			parameters.vertexUv2s ? '#define USE_UV2' : '',
			parameters.vertexUv3s ? '#define USE_UV3' : '',

			parameters.pointsUvs ? '#define USE_POINTS_UV' : '',

			parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',

			parameters.flatShading ? '#define FLAT_SHADED' : '',

			parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
			parameters.flipSided ? '#define FLIP_SIDED' : '',

			parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
			parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',

			parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',

			parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',

			parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',

			parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',

			'uniform mat4 viewMatrix;',
			'uniform vec3 cameraPosition;',
			'uniform bool isOrthographic;',

			( parameters.toneMapping !== NoToneMapping ) ? '#define TONE_MAPPING' : '',
			( parameters.toneMapping !== NoToneMapping ) ? ShaderChunk[ 'tonemapping_pars_fragment' ] : '', // this code is required here because it is used by the toneMapping() function defined below
			( parameters.toneMapping !== NoToneMapping ) ? getToneMappingFunction( 'toneMapping', parameters.toneMapping ) : '',

			parameters.dithering ? '#define DITHERING' : '',
			parameters.opaque ? '#define OPAQUE' : '',

			ShaderChunk[ 'colorspace_pars_fragment' ], // this code is required here because it is used by the various encoding/decoding function defined below
			getTexelEncodingFunction( 'linearToOutputTexel', parameters.outputColorSpace ),

			parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',

			'\n'

		].filter( filterEmptyLine ).join( '\n' );

	}

	vertexShader = resolveIncludes( vertexShader );
	vertexShader = replaceLightNums( vertexShader, parameters );
	vertexShader = replaceClippingPlaneNums( vertexShader, parameters );

	fragmentShader = resolveIncludes( fragmentShader );
	fragmentShader = replaceLightNums( fragmentShader, parameters );
	fragmentShader = replaceClippingPlaneNums( fragmentShader, parameters );

	vertexShader = unrollLoops( vertexShader );
	fragmentShader = unrollLoops( fragmentShader );

	if ( parameters.isRawShaderMaterial !== true ) {

		// GLSL 3.0 conversion for built-in materials and ShaderMaterial

		versionString = '#version 300 es\n';

		prefixVertex = [
			customVertexExtensions,
			'#define attribute in',
			'#define varying out',
			'#define texture2D texture'
		].join( '\n' ) + '\n' + prefixVertex;

		prefixFragment = [
			'#define varying in',
			( parameters.glslVersion === GLSL3 ) ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;',
			( parameters.glslVersion === GLSL3 ) ? '' : '#define gl_FragColor pc_fragColor',
			'#define gl_FragDepthEXT gl_FragDepth',
			'#define texture2D texture',
			'#define textureCube texture',
			'#define texture2DProj textureProj',
			'#define texture2DLodEXT textureLod',
			'#define texture2DProjLodEXT textureProjLod',
			'#define textureCubeLodEXT textureLod',
			'#define texture2DGradEXT textureGrad',
			'#define texture2DProjGradEXT textureProjGrad',
			'#define textureCubeGradEXT textureGrad'
		].join( '\n' ) + '\n' + prefixFragment;

	}

	const vertexGlsl = versionString + prefixVertex + vertexShader;
	const fragmentGlsl = versionString + prefixFragment + fragmentShader;

	// console.log( '*VERTEX*', vertexGlsl );
	// console.log( '*FRAGMENT*', fragmentGlsl );

	const glVertexShader = WebGLShader( gl, gl.VERTEX_SHADER, vertexGlsl );
	const glFragmentShader = WebGLShader( gl, gl.FRAGMENT_SHADER, fragmentGlsl );

	gl.attachShader( program, glVertexShader );
	gl.attachShader( program, glFragmentShader );

	// Force a particular attribute to index 0.

	if ( parameters.index0AttributeName !== undefined ) {

		gl.bindAttribLocation( program, 0, parameters.index0AttributeName );

	} else if ( parameters.morphTargets === true ) {

		// programs with morphTargets displace position out of attribute 0
		gl.bindAttribLocation( program, 0, 'position' );

	}

	gl.linkProgram( program );

	function onFirstUse( self ) {

		// check for link errors
		if ( renderer.debug.checkShaderErrors ) {

			const programLog = gl.getProgramInfoLog( program ).trim();
			const vertexLog = gl.getShaderInfoLog( glVertexShader ).trim();
			const fragmentLog = gl.getShaderInfoLog( glFragmentShader ).trim();

			let runnable = true;
			let haveDiagnostics = true;

			if ( gl.getProgramParameter( program, gl.LINK_STATUS ) === false ) {

				runnable = false;

				if ( typeof renderer.debug.onShaderError === 'function' ) {

					renderer.debug.onShaderError( gl, program, glVertexShader, glFragmentShader );

				} else {

					// default error reporting

					const vertexErrors = getShaderErrors( gl, glVertexShader, 'vertex' );
					const fragmentErrors = getShaderErrors( gl, glFragmentShader, 'fragment' );

					console.error(
						'THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' +
						'VALIDATE_STATUS ' + gl.getProgramParameter( program, gl.VALIDATE_STATUS ) + '\n\n' +
						'Material Name: ' + self.name + '\n' +
						'Material Type: ' + self.type + '\n\n' +
						'Program Info Log: ' + programLog + '\n' +
						vertexErrors + '\n' +
						fragmentErrors
					);

				}

			} else if ( programLog !== '' ) {

				console.warn( 'THREE.WebGLProgram: Program Info Log:', programLog );

			} else if ( vertexLog === '' || fragmentLog === '' ) {

				haveDiagnostics = false;

			}

			if ( haveDiagnostics ) {

				self.diagnostics = {

					runnable: runnable,

					programLog: programLog,

					vertexShader: {

						log: vertexLog,
						prefix: prefixVertex

					},

					fragmentShader: {

						log: fragmentLog,
						prefix: prefixFragment

					}

				};

			}

		}

		// Clean up

		// Crashes in iOS9 and iOS10. #18402
		// gl.detachShader( program, glVertexShader );
		// gl.detachShader( program, glFragmentShader );

		gl.deleteShader( glVertexShader );
		gl.deleteShader( glFragmentShader );

		cachedUniforms = new WebGLUniforms( gl, program );
		cachedAttributes = fetchAttributeLocations( gl, program );

	}

	// set up caching for uniform locations

	let cachedUniforms;

	this.getUniforms = function () {

		if ( cachedUniforms === undefined ) {

			// Populates cachedUniforms and cachedAttributes
			onFirstUse( this );

		}

		return cachedUniforms;

	};

	// set up caching for attribute locations

	let cachedAttributes;

	this.getAttributes = function () {

		if ( cachedAttributes === undefined ) {

			// Populates cachedAttributes and cachedUniforms
			onFirstUse( this );

		}

		return cachedAttributes;

	};

	// indicate when the program is ready to be used. if the KHR_parallel_shader_compile extension isn't supported,
	// flag the program as ready immediately. It may cause a stall when it's first used.

	let programReady = ( parameters.rendererExtensionParallelShaderCompile === false );

	this.isReady = function () {

		if ( programReady === false ) {

			programReady = gl.getProgramParameter( program, COMPLETION_STATUS_KHR );

		}

		return programReady;

	};

	// free resource

	this.destroy = function () {

		bindingStates.releaseStatesOfProgram( this );

		gl.deleteProgram( program );
		this.program = undefined;

	};

	//

	this.type = parameters.shaderType;
	this.name = parameters.shaderName;
	this.id = programIdCount ++;
	this.cacheKey = cacheKey;
	this.usedTimes = 1;
	this.program = program;
	this.vertexShader = glVertexShader;
	this.fragmentShader = glFragmentShader;

	return this;

}

let _id$1 = 0;

class WebGLShaderCache {

	constructor() {

		this.shaderCache = new Map();
		this.materialCache = new Map();

	}

	update( material ) {

		const vertexShader = material.vertexShader;
		const fragmentShader = material.fragmentShader;

		const vertexShaderStage = this._getShaderStage( vertexShader );
		const fragmentShaderStage = this._getShaderStage( fragmentShader );

		const materialShaders = this._getShaderCacheForMaterial( material );

		if ( materialShaders.has( vertexShaderStage ) === false ) {

			materialShaders.add( vertexShaderStage );
			vertexShaderStage.usedTimes ++;

		}

		if ( materialShaders.has( fragmentShaderStage ) === false ) {

			materialShaders.add( fragmentShaderStage );
			fragmentShaderStage.usedTimes ++;

		}

		return this;

	}

	remove( material ) {

		const materialShaders = this.materialCache.get( material );

		for ( const shaderStage of materialShaders ) {

			shaderStage.usedTimes --;

			if ( shaderStage.usedTimes === 0 ) this.shaderCache.delete( shaderStage.code );

		}

		this.materialCache.delete( material );

		return this;

	}

	getVertexShaderID( material ) {

		return this._getShaderStage( material.vertexShader ).id;

	}

	getFragmentShaderID( material ) {

		return this._getShaderStage( material.fragmentShader ).id;

	}

	dispose() {

		this.shaderCache.clear();
		this.materialCache.clear();

	}

	_getShaderCacheForMaterial( material ) {

		const cache = this.materialCache;
		let set = cache.get( material );

		if ( set === undefined ) {

			set = new Set();
			cache.set( material, set );

		}

		return set;

	}

	_getShaderStage( code ) {

		const cache = this.shaderCache;
		let stage = cache.get( code );

		if ( stage === undefined ) {

			stage = new WebGLShaderStage( code );
			cache.set( code, stage );

		}

		return stage;

	}

}

class WebGLShaderStage {

	constructor( code ) {

		this.id = _id$1 ++;

		this.code = code;
		this.usedTimes = 0;

	}

}

function WebGLPrograms( renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping ) {

	const _programLayers = new Layers();
	const _customShaders = new WebGLShaderCache();
	const _activeChannels = new Set();
	const programs = [];

	const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
	const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;

	let precision = capabilities.precision;

	const shaderIDs = {
		MeshDepthMaterial: 'depth',
		MeshDistanceMaterial: 'distanceRGBA',
		MeshNormalMaterial: 'normal',
		MeshBasicMaterial: 'basic',
		MeshLambertMaterial: 'lambert',
		MeshPhongMaterial: 'phong',
		MeshToonMaterial: 'toon',
		MeshStandardMaterial: 'physical',
		MeshPhysicalMaterial: 'physical',
		MeshMatcapMaterial: 'matcap',
		LineBasicMaterial: 'basic',
		LineDashedMaterial: 'dashed',
		PointsMaterial: 'points',
		ShadowMaterial: 'shadow',
		SpriteMaterial: 'sprite'
	};

	function getChannel( value ) {

		_activeChannels.add( value );

		if ( value === 0 ) return 'uv';

		return `uv${ value }`;

	}

	function getParameters( material, lights, shadows, scene, object ) {

		const fog = scene.fog;
		const geometry = object.geometry;
		const environment = material.isMeshStandardMaterial ? scene.environment : null;

		const envMap = ( material.isMeshStandardMaterial ? cubeuvmaps : cubemaps ).get( material.envMap || environment );
		const envMapCubeUVHeight = ( !! envMap ) && ( envMap.mapping === CubeUVReflectionMapping ) ? envMap.image.height : null;

		const shaderID = shaderIDs[ material.type ];

		// heuristics to create shader parameters according to lights in the scene
		// (not to blow over maxLights budget)

		if ( material.precision !== null ) {

			precision = capabilities.getMaxPrecision( material.precision );

			if ( precision !== material.precision ) {

				console.warn( 'THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.' );

			}

		}

		//

		const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
		const morphTargetsCount = ( morphAttribute !== undefined ) ? morphAttribute.length : 0;

		let morphTextureStride = 0;

		if ( geometry.morphAttributes.position !== undefined ) morphTextureStride = 1;
		if ( geometry.morphAttributes.normal !== undefined ) morphTextureStride = 2;
		if ( geometry.morphAttributes.color !== undefined ) morphTextureStride = 3;

		//

		let vertexShader, fragmentShader;
		let customVertexShaderID, customFragmentShaderID;

		if ( shaderID ) {

			const shader = ShaderLib[ shaderID ];

			vertexShader = shader.vertexShader;
			fragmentShader = shader.fragmentShader;

		} else {

			vertexShader = material.vertexShader;
			fragmentShader = material.fragmentShader;

			_customShaders.update( material );

			customVertexShaderID = _customShaders.getVertexShaderID( material );
			customFragmentShaderID = _customShaders.getFragmentShaderID( material );

		}

		const currentRenderTarget = renderer.getRenderTarget();

		const IS_INSTANCEDMESH = object.isInstancedMesh === true;
		const IS_BATCHEDMESH = object.isBatchedMesh === true;

		const HAS_MAP = !! material.map;
		const HAS_MATCAP = !! material.matcap;
		const HAS_ENVMAP = !! envMap;
		const HAS_AOMAP = !! material.aoMap;
		const HAS_LIGHTMAP = !! material.lightMap;
		const HAS_BUMPMAP = !! material.bumpMap;
		const HAS_NORMALMAP = !! material.normalMap;
		const HAS_DISPLACEMENTMAP = !! material.displacementMap;
		const HAS_EMISSIVEMAP = !! material.emissiveMap;

		const HAS_METALNESSMAP = !! material.metalnessMap;
		const HAS_ROUGHNESSMAP = !! material.roughnessMap;

		const HAS_ANISOTROPY = material.anisotropy > 0;
		const HAS_CLEARCOAT = material.clearcoat > 0;
		const HAS_DISPERSION = material.dispersion > 0;
		const HAS_IRIDESCENCE = material.iridescence > 0;
		const HAS_SHEEN = material.sheen > 0;
		const HAS_TRANSMISSION = material.transmission > 0;

		const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !! material.anisotropyMap;

		const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !! material.clearcoatMap;
		const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !! material.clearcoatNormalMap;
		const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !! material.clearcoatRoughnessMap;

		const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !! material.iridescenceMap;
		const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !! material.iridescenceThicknessMap;

		const HAS_SHEEN_COLORMAP = HAS_SHEEN && !! material.sheenColorMap;
		const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !! material.sheenRoughnessMap;

		const HAS_SPECULARMAP = !! material.specularMap;
		const HAS_SPECULAR_COLORMAP = !! material.specularColorMap;
		const HAS_SPECULAR_INTENSITYMAP = !! material.specularIntensityMap;

		const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !! material.transmissionMap;
		const HAS_THICKNESSMAP = HAS_TRANSMISSION && !! material.thicknessMap;

		const HAS_GRADIENTMAP = !! material.gradientMap;

		const HAS_ALPHAMAP = !! material.alphaMap;

		const HAS_ALPHATEST = material.alphaTest > 0;

		const HAS_ALPHAHASH = !! material.alphaHash;

		const HAS_EXTENSIONS = !! material.extensions;

		let toneMapping = NoToneMapping;

		if ( material.toneMapped ) {

			if ( currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true ) {

				toneMapping = renderer.toneMapping;

			}

		}

		const parameters = {

			shaderID: shaderID,
			shaderType: material.type,
			shaderName: material.name,

			vertexShader: vertexShader,
			fragmentShader: fragmentShader,
			defines: material.defines,

			customVertexShaderID: customVertexShaderID,
			customFragmentShaderID: customFragmentShaderID,

			isRawShaderMaterial: material.isRawShaderMaterial === true,
			glslVersion: material.glslVersion,

			precision: precision,

			batching: IS_BATCHEDMESH,
			batchingColor: IS_BATCHEDMESH && object._colorsTexture !== null,
			instancing: IS_INSTANCEDMESH,
			instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
			instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,

			supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
			outputColorSpace: ( currentRenderTarget === null ) ? renderer.outputColorSpace : ( currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : LinearSRGBColorSpace ),
			alphaToCoverage: !! material.alphaToCoverage,

			map: HAS_MAP,
			matcap: HAS_MATCAP,
			envMap: HAS_ENVMAP,
			envMapMode: HAS_ENVMAP && envMap.mapping,
			envMapCubeUVHeight: envMapCubeUVHeight,
			aoMap: HAS_AOMAP,
			lightMap: HAS_LIGHTMAP,
			bumpMap: HAS_BUMPMAP,
			normalMap: HAS_NORMALMAP,
			displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
			emissiveMap: HAS_EMISSIVEMAP,

			normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === ObjectSpaceNormalMap,
			normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === TangentSpaceNormalMap,

			metalnessMap: HAS_METALNESSMAP,
			roughnessMap: HAS_ROUGHNESSMAP,

			anisotropy: HAS_ANISOTROPY,
			anisotropyMap: HAS_ANISOTROPYMAP,

			clearcoat: HAS_CLEARCOAT,
			clearcoatMap: HAS_CLEARCOATMAP,
			clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
			clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,

			dispersion: HAS_DISPERSION,

			iridescence: HAS_IRIDESCENCE,
			iridescenceMap: HAS_IRIDESCENCEMAP,
			iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,

			sheen: HAS_SHEEN,
			sheenColorMap: HAS_SHEEN_COLORMAP,
			sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,

			specularMap: HAS_SPECULARMAP,
			specularColorMap: HAS_SPECULAR_COLORMAP,
			specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,

			transmission: HAS_TRANSMISSION,
			transmissionMap: HAS_TRANSMISSIONMAP,
			thicknessMap: HAS_THICKNESSMAP,

			gradientMap: HAS_GRADIENTMAP,

			opaque: material.transparent === false && material.blending === NormalBlending && material.alphaToCoverage === false,

			alphaMap: HAS_ALPHAMAP,
			alphaTest: HAS_ALPHATEST,
			alphaHash: HAS_ALPHAHASH,

			combine: material.combine,

			//

			mapUv: HAS_MAP && getChannel( material.map.channel ),
			aoMapUv: HAS_AOMAP && getChannel( material.aoMap.channel ),
			lightMapUv: HAS_LIGHTMAP && getChannel( material.lightMap.channel ),
			bumpMapUv: HAS_BUMPMAP && getChannel( material.bumpMap.channel ),
			normalMapUv: HAS_NORMALMAP && getChannel( material.normalMap.channel ),
			displacementMapUv: HAS_DISPLACEMENTMAP && getChannel( material.displacementMap.channel ),
			emissiveMapUv: HAS_EMISSIVEMAP && getChannel( material.emissiveMap.channel ),

			metalnessMapUv: HAS_METALNESSMAP && getChannel( material.metalnessMap.channel ),
			roughnessMapUv: HAS_ROUGHNESSMAP && getChannel( material.roughnessMap.channel ),

			anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel( material.anisotropyMap.channel ),

			clearcoatMapUv: HAS_CLEARCOATMAP && getChannel( material.clearcoatMap.channel ),
			clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel( material.clearcoatNormalMap.channel ),
			clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel( material.clearcoatRoughnessMap.channel ),

			iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel( material.iridescenceMap.channel ),
			iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel( material.iridescenceThicknessMap.channel ),

			sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel( material.sheenColorMap.channel ),
			sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel( material.sheenRoughnessMap.channel ),

			specularMapUv: HAS_SPECULARMAP && getChannel( material.specularMap.channel ),
			specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel( material.specularColorMap.channel ),
			specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel( material.specularIntensityMap.channel ),

			transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel( material.transmissionMap.channel ),
			thicknessMapUv: HAS_THICKNESSMAP && getChannel( material.thicknessMap.channel ),

			alphaMapUv: HAS_ALPHAMAP && getChannel( material.alphaMap.channel ),

			//

			vertexTangents: !! geometry.attributes.tangent && ( HAS_NORMALMAP || HAS_ANISOTROPY ),
			vertexColors: material.vertexColors,
			vertexAlphas: material.vertexColors === true && !! geometry.attributes.color && geometry.attributes.color.itemSize === 4,

			pointsUvs: object.isPoints === true && !! geometry.attributes.uv && ( HAS_MAP || HAS_ALPHAMAP ),

			fog: !! fog,
			useFog: material.fog === true,
			fogExp2: ( !! fog && fog.isFogExp2 ),

			flatShading: material.flatShading === true,

			sizeAttenuation: material.sizeAttenuation === true,
			logarithmicDepthBuffer: logarithmicDepthBuffer,

			skinning: object.isSkinnedMesh === true,

			morphTargets: geometry.morphAttributes.position !== undefined,
			morphNormals: geometry.morphAttributes.normal !== undefined,
			morphColors: geometry.morphAttributes.color !== undefined,
			morphTargetsCount: morphTargetsCount,
			morphTextureStride: morphTextureStride,

			numDirLights: lights.directional.length,
			numPointLights: lights.point.length,
			numSpotLights: lights.spot.length,
			numSpotLightMaps: lights.spotLightMap.length,
			numRectAreaLights: lights.rectArea.length,
			numHemiLights: lights.hemi.length,

			numDirLightShadows: lights.directionalShadowMap.length,
			numPointLightShadows: lights.pointShadowMap.length,
			numSpotLightShadows: lights.spotShadowMap.length,
			numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,

			numLightProbes: lights.numLightProbes,

			numClippingPlanes: clipping.numPlanes,
			numClipIntersection: clipping.numIntersection,

			dithering: material.dithering,

			shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
			shadowMapType: renderer.shadowMap.type,

			toneMapping: toneMapping,

			decodeVideoTexture: HAS_MAP && ( material.map.isVideoTexture === true ) && ( ColorManagement.getTransfer( material.map.colorSpace ) === SRGBTransfer ),

			premultipliedAlpha: material.premultipliedAlpha,

			doubleSided: material.side === DoubleSide,
			flipSided: material.side === BackSide,

			useDepthPacking: material.depthPacking >= 0,
			depthPacking: material.depthPacking || 0,

			index0AttributeName: material.index0AttributeName,

			extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions.has( 'WEBGL_clip_cull_distance' ),
			extensionMultiDraw: ( HAS_EXTENSIONS && material.extensions.multiDraw === true || IS_BATCHEDMESH ) && extensions.has( 'WEBGL_multi_draw' ),

			rendererExtensionParallelShaderCompile: extensions.has( 'KHR_parallel_shader_compile' ),

			customProgramCacheKey: material.customProgramCacheKey()

		};

		// the usage of getChannel() determines the active texture channels for this shader

		parameters.vertexUv1s = _activeChannels.has( 1 );
		parameters.vertexUv2s = _activeChannels.has( 2 );
		parameters.vertexUv3s = _activeChannels.has( 3 );

		_activeChannels.clear();

		return parameters;

	}

	function getProgramCacheKey( parameters ) {

		const array = [];

		if ( parameters.shaderID ) {

			array.push( parameters.shaderID );

		} else {

			array.push( parameters.customVertexShaderID );
			array.push( parameters.customFragmentShaderID );

		}

		if ( parameters.defines !== undefined ) {

			for ( const name in parameters.defines ) {

				array.push( name );
				array.push( parameters.defines[ name ] );

			}

		}

		if ( parameters.isRawShaderMaterial === false ) {

			getProgramCacheKeyParameters( array, parameters );
			getProgramCacheKeyBooleans( array, parameters );
			array.push( renderer.outputColorSpace );

		}

		array.push( parameters.customProgramCacheKey );

		return array.join();

	}

	function getProgramCacheKeyParameters( array, parameters ) {

		array.push( parameters.precision );
		array.push( parameters.outputColorSpace );
		array.push( parameters.envMapMode );
		array.push( parameters.envMapCubeUVHeight );
		array.push( parameters.mapUv );
		array.push( parameters.alphaMapUv );
		array.push( parameters.lightMapUv );
		array.push( parameters.aoMapUv );
		array.push( parameters.bumpMapUv );
		array.push( parameters.normalMapUv );
		array.push( parameters.displacementMapUv );
		array.push( parameters.emissiveMapUv );
		array.push( parameters.metalnessMapUv );
		array.push( parameters.roughnessMapUv );
		array.push( parameters.anisotropyMapUv );
		array.push( parameters.clearcoatMapUv );
		array.push( parameters.clearcoatNormalMapUv );
		array.push( parameters.clearcoatRoughnessMapUv );
		array.push( parameters.iridescenceMapUv );
		array.push( parameters.iridescenceThicknessMapUv );
		array.push( parameters.sheenColorMapUv );
		array.push( parameters.sheenRoughnessMapUv );
		array.push( parameters.specularMapUv );
		array.push( parameters.specularColorMapUv );
		array.push( parameters.specularIntensityMapUv );
		array.push( parameters.transmissionMapUv );
		array.push( parameters.thicknessMapUv );
		array.push( parameters.combine );
		array.push( parameters.fogExp2 );
		array.push( parameters.sizeAttenuation );
		array.push( parameters.morphTargetsCount );
		array.push( parameters.morphAttributeCount );
		array.push( parameters.numDirLights );
		array.push( parameters.numPointLights );
		array.push( parameters.numSpotLights );
		array.push( parameters.numSpotLightMaps );
		array.push( parameters.numHemiLights );
		array.push( parameters.numRectAreaLights );
		array.push( parameters.numDirLightShadows );
		array.push( parameters.numPointLightShadows );
		array.push( parameters.numSpotLightShadows );
		array.push( parameters.numSpotLightShadowsWithMaps );
		array.push( parameters.numLightProbes );
		array.push( parameters.shadowMapType );
		array.push( parameters.toneMapping );
		array.push( parameters.numClippingPlanes );
		array.push( parameters.numClipIntersection );
		array.push( parameters.depthPacking );

	}

	function getProgramCacheKeyBooleans( array, parameters ) {

		_programLayers.disableAll();

		if ( parameters.supportsVertexTextures )
			_programLayers.enable( 0 );
		if ( parameters.instancing )
			_programLayers.enable( 1 );
		if ( parameters.instancingColor )
			_programLayers.enable( 2 );
		if ( parameters.instancingMorph )
			_programLayers.enable( 3 );
		if ( parameters.matcap )
			_programLayers.enable( 4 );
		if ( parameters.envMap )
			_programLayers.enable( 5 );
		if ( parameters.normalMapObjectSpace )
			_programLayers.enable( 6 );
		if ( parameters.normalMapTangentSpace )
			_programLayers.enable( 7 );
		if ( parameters.clearcoat )
			_programLayers.enable( 8 );
		if ( parameters.iridescence )
			_programLayers.enable( 9 );
		if ( parameters.alphaTest )
			_programLayers.enable( 10 );
		if ( parameters.vertexColors )
			_programLayers.enable( 11 );
		if ( parameters.vertexAlphas )
			_programLayers.enable( 12 );
		if ( parameters.vertexUv1s )
			_programLayers.enable( 13 );
		if ( parameters.vertexUv2s )
			_programLayers.enable( 14 );
		if ( parameters.vertexUv3s )
			_programLayers.enable( 15 );
		if ( parameters.vertexTangents )
			_programLayers.enable( 16 );
		if ( parameters.anisotropy )
			_programLayers.enable( 17 );
		if ( parameters.alphaHash )
			_programLayers.enable( 18 );
		if ( parameters.batching )
			_programLayers.enable( 19 );
		if ( parameters.dispersion )
			_programLayers.enable( 20 );
		if ( parameters.batchingColor )
			_programLayers.enable( 21 );

		array.push( _programLayers.mask );
		_programLayers.disableAll();

		if ( parameters.fog )
			_programLayers.enable( 0 );
		if ( parameters.useFog )
			_programLayers.enable( 1 );
		if ( parameters.flatShading )
			_programLayers.enable( 2 );
		if ( parameters.logarithmicDepthBuffer )
			_programLayers.enable( 3 );
		if ( parameters.skinning )
			_programLayers.enable( 4 );
		if ( parameters.morphTargets )
			_programLayers.enable( 5 );
		if ( parameters.morphNormals )
			_programLayers.enable( 6 );
		if ( parameters.morphColors )
			_programLayers.enable( 7 );
		if ( parameters.premultipliedAlpha )
			_programLayers.enable( 8 );
		if ( parameters.shadowMapEnabled )
			_programLayers.enable( 9 );
		if ( parameters.doubleSided )
			_programLayers.enable( 10 );
		if ( parameters.flipSided )
			_programLayers.enable( 11 );
		if ( parameters.useDepthPacking )
			_programLayers.enable( 12 );
		if ( parameters.dithering )
			_programLayers.enable( 13 );
		if ( parameters.transmission )
			_programLayers.enable( 14 );
		if ( parameters.sheen )
			_programLayers.enable( 15 );
		if ( parameters.opaque )
			_programLayers.enable( 16 );
		if ( parameters.pointsUvs )
			_programLayers.enable( 17 );
		if ( parameters.decodeVideoTexture )
			_programLayers.enable( 18 );
		if ( parameters.alphaToCoverage )
			_programLayers.enable( 19 );

		array.push( _programLayers.mask );

	}

	function getUniforms( material ) {

		const shaderID = shaderIDs[ material.type ];
		let uniforms;

		if ( shaderID ) {

			const shader = ShaderLib[ shaderID ];
			uniforms = UniformsUtils.clone( shader.uniforms );

		} else {

			uniforms = material.uniforms;

		}

		return uniforms;

	}

	function acquireProgram( parameters, cacheKey ) {

		let program;

		// Check if code has been already compiled
		for ( let p = 0, pl = programs.length; p < pl; p ++ ) {

			const preexistingProgram = programs[ p ];

			if ( preexistingProgram.cacheKey === cacheKey ) {

				program = preexistingProgram;
				++ program.usedTimes;

				break;

			}

		}

		if ( program === undefined ) {

			program = new WebGLProgram( renderer, cacheKey, parameters, bindingStates );
			programs.push( program );

		}

		return program;

	}

	function releaseProgram( program ) {

		if ( -- program.usedTimes === 0 ) {

			// Remove from unordered set
			const i = programs.indexOf( program );
			programs[ i ] = programs[ programs.length - 1 ];
			programs.pop();

			// Free WebGL resources
			program.destroy();

		}

	}

	function releaseShaderCache( material ) {

		_customShaders.remove( material );

	}

	function dispose() {

		_customShaders.dispose();

	}

	return {
		getParameters: getParameters,
		getProgramCacheKey: getProgramCacheKey,
		getUniforms: getUniforms,
		acquireProgram: acquireProgram,
		releaseProgram: releaseProgram,
		releaseShaderCache: releaseShaderCache,
		// Exposed for resource monitoring & error feedback via renderer.info:
		programs: programs,
		dispose: dispose
	};

}

function WebGLProperties() {

	let properties = new WeakMap();

	function get( object ) {

		let map = properties.get( object );

		if ( map === undefined ) {

			map = {};
			properties.set( object, map );

		}

		return map;

	}

	function remove( object ) {

		properties.delete( object );

	}

	function update( object, key, value ) {

		properties.get( object )[ key ] = value;

	}

	function dispose() {

		properties = new WeakMap();

	}

	return {
		get: get,
		remove: remove,
		update: update,
		dispose: dispose
	};

}

function painterSortStable( a, b ) {

	if ( a.groupOrder !== b.groupOrder ) {

		return a.groupOrder - b.groupOrder;

	} else if ( a.renderOrder !== b.renderOrder ) {

		return a.renderOrder - b.renderOrder;

	} else if ( a.material.id !== b.material.id ) {

		return a.material.id - b.material.id;

	} else if ( a.z !== b.z ) {

		return a.z - b.z;

	} else {

		return a.id - b.id;

	}

}

function reversePainterSortStable( a, b ) {

	if ( a.groupOrder !== b.groupOrder ) {

		return a.groupOrder - b.groupOrder;

	} else if ( a.renderOrder !== b.renderOrder ) {

		return a.renderOrder - b.renderOrder;

	} else if ( a.z !== b.z ) {

		return b.z - a.z;

	} else {

		return a.id - b.id;

	}

}


function WebGLRenderList() {

	const renderItems = [];
	let renderItemsIndex = 0;

	const opaque = [];
	const transmissive = [];
	const transparent = [];

	function init() {

		renderItemsIndex = 0;

		opaque.length = 0;
		transmissive.length = 0;
		transparent.length = 0;

	}

	function getNextRenderItem( object, geometry, material, groupOrder, z, group ) {

		let renderItem = renderItems[ renderItemsIndex ];

		if ( renderItem === undefined ) {

			renderItem = {
				id: object.id,
				object: object,
				geometry: geometry,
				material: material,
				groupOrder: groupOrder,
				renderOrder: object.renderOrder,
				z: z,
				group: group
			};

			renderItems[ renderItemsIndex ] = renderItem;

		} else {

			renderItem.id = object.id;
			renderItem.object = object;
			renderItem.geometry = geometry;
			renderItem.material = material;
			renderItem.groupOrder = groupOrder;
			renderItem.renderOrder = object.renderOrder;
			renderItem.z = z;
			renderItem.group = group;

		}

		renderItemsIndex ++;

		return renderItem;

	}

	function push( object, geometry, material, groupOrder, z, group ) {

		const renderItem = getNextRenderItem( object, geometry, material, groupOrder, z, group );

		if ( material.transmission > 0.0 ) {

			transmissive.push( renderItem );

		} else if ( material.transparent === true ) {

			transparent.push( renderItem );

		} else {

			opaque.push( renderItem );

		}

	}

	function unshift( object, geometry, material, groupOrder, z, group ) {

		const renderItem = getNextRenderItem( object, geometry, material, groupOrder, z, group );

		if ( material.transmission > 0.0 ) {

			transmissive.unshift( renderItem );

		} else if ( material.transparent === true ) {

			transparent.unshift( renderItem );

		} else {

			opaque.unshift( renderItem );

		}

	}

	function sort( customOpaqueSort, customTransparentSort ) {

		if ( opaque.length > 1 ) opaque.sort( customOpaqueSort || painterSortStable );
		if ( transmissive.length > 1 ) transmissive.sort( customTransparentSort || reversePainterSortStable );
		if ( transparent.length > 1 ) transparent.sort( customTransparentSort || reversePainterSortStable );

	}

	function finish() {

		// Clear references from inactive renderItems in the list

		for ( let i = renderItemsIndex, il = renderItems.length; i < il; i ++ ) {

			const renderItem = renderItems[ i ];

			if ( renderItem.id === null ) break;

			renderItem.id = null;
			renderItem.object = null;
			renderItem.geometry = null;
			renderItem.material = null;
			renderItem.group = null;

		}

	}

	return {

		opaque: opaque,
		transmissive: transmissive,
		transparent: transparent,

		init: init,
		push: push,
		unshift: unshift,
		finish: finish,

		sort: sort
	};

}

function WebGLRenderLists() {

	let lists = new WeakMap();

	function get( scene, renderCallDepth ) {

		const listArray = lists.get( scene );
		let list;

		if ( listArray === undefined ) {

			list = new WebGLRenderList();
			lists.set( scene, [ list ] );

		} else {

			if ( renderCallDepth >= listArray.length ) {

				list = new WebGLRenderList();
				listArray.push( list );

			} else {

				list = listArray[ renderCallDepth ];

			}

		}

		return list;

	}

	function dispose() {

		lists = new WeakMap();

	}

	return {
		get: get,
		dispose: dispose
	};

}

function UniformsCache() {

	const lights = {};

	return {

		get: function ( light ) {

			if ( lights[ light.id ] !== undefined ) {

				return lights[ light.id ];

			}

			let uniforms;

			switch ( light.type ) {

				case 'DirectionalLight':
					uniforms = {
						direction: new Vector3(),
						color: new Color()
					};
					break;

				case 'SpotLight':
					uniforms = {
						position: new Vector3(),
						direction: new Vector3(),
						color: new Color(),
						distance: 0,
						coneCos: 0,
						penumbraCos: 0,
						decay: 0
					};
					break;

				case 'PointLight':
					uniforms = {
						position: new Vector3(),
						color: new Color(),
						distance: 0,
						decay: 0
					};
					break;

				case 'HemisphereLight':
					uniforms = {
						direction: new Vector3(),
						skyColor: new Color(),
						groundColor: new Color()
					};
					break;

				case 'RectAreaLight':
					uniforms = {
						color: new Color(),
						position: new Vector3(),
						halfWidth: new Vector3(),
						halfHeight: new Vector3()
					};
					break;

			}

			lights[ light.id ] = uniforms;

			return uniforms;

		}

	};

}

function ShadowUniformsCache() {

	const lights = {};

	return {

		get: function ( light ) {

			if ( lights[ light.id ] !== undefined ) {

				return lights[ light.id ];

			}

			let uniforms;

			switch ( light.type ) {

				case 'DirectionalLight':
					uniforms = {
						shadowIntensity: 1,
						shadowBias: 0,
						shadowNormalBias: 0,
						shadowRadius: 1,
						shadowMapSize: new Vector2()
					};
					break;

				case 'SpotLight':
					uniforms = {
						shadowIntensity: 1,
						shadowBias: 0,
						shadowNormalBias: 0,
						shadowRadius: 1,
						shadowMapSize: new Vector2()
					};
					break;

				case 'PointLight':
					uniforms = {
						shadowIntensity: 1,
						shadowBias: 0,
						shadowNormalBias: 0,
						shadowRadius: 1,
						shadowMapSize: new Vector2(),
						shadowCameraNear: 1,
						shadowCameraFar: 1000
					};
					break;

				// TODO (abelnation): set RectAreaLight shadow uniforms

			}

			lights[ light.id ] = uniforms;

			return uniforms;

		}

	};

}



let nextVersion = 0;

function shadowCastingAndTexturingLightsFirst( lightA, lightB ) {

	return ( lightB.castShadow ? 2 : 0 ) - ( lightA.castShadow ? 2 : 0 ) + ( lightB.map ? 1 : 0 ) - ( lightA.map ? 1 : 0 );

}

function WebGLLights( extensions ) {

	const cache = new UniformsCache();

	const shadowCache = ShadowUniformsCache();

	const state = {

		version: 0,

		hash: {
			directionalLength: - 1,
			pointLength: - 1,
			spotLength: - 1,
			rectAreaLength: - 1,
			hemiLength: - 1,

			numDirectionalShadows: - 1,
			numPointShadows: - 1,
			numSpotShadows: - 1,
			numSpotMaps: - 1,

			numLightProbes: - 1
		},

		ambient: [ 0, 0, 0 ],
		probe: [],
		directional: [],
		directionalShadow: [],
		directionalShadowMap: [],
		directionalShadowMatrix: [],
		spot: [],
		spotLightMap: [],
		spotShadow: [],
		spotShadowMap: [],
		spotLightMatrix: [],
		rectArea: [],
		rectAreaLTC1: null,
		rectAreaLTC2: null,
		point: [],
		pointShadow: [],
		pointShadowMap: [],
		pointShadowMatrix: [],
		hemi: [],
		numSpotLightShadowsWithMaps: 0,
		numLightProbes: 0

	};

	for ( let i = 0; i < 9; i ++ ) state.probe.push( new Vector3() );

	const vector3 = new Vector3();
	const matrix4 = new Matrix4();
	const matrix42 = new Matrix4();

	function setup( lights ) {

		let r = 0, g = 0, b = 0;

		for ( let i = 0; i < 9; i ++ ) state.probe[ i ].set( 0, 0, 0 );

		let directionalLength = 0;
		let pointLength = 0;
		let spotLength = 0;
		let rectAreaLength = 0;
		let hemiLength = 0;

		let numDirectionalShadows = 0;
		let numPointShadows = 0;
		let numSpotShadows = 0;
		let numSpotMaps = 0;
		let numSpotShadowsWithMaps = 0;

		let numLightProbes = 0;

		// ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
		lights.sort( shadowCastingAndTexturingLightsFirst );

		for ( let i = 0, l = lights.length; i < l; i ++ ) {

			const light = lights[ i ];

			const color = light.color;
			const intensity = light.intensity;
			const distance = light.distance;

			const shadowMap = ( light.shadow && light.shadow.map ) ? light.shadow.map.texture : null;

			if ( light.isAmbientLight ) {

				r += color.r * intensity;
				g += color.g * intensity;
				b += color.b * intensity;

			} else if ( light.isLightProbe ) {

				for ( let j = 0; j < 9; j ++ ) {

					state.probe[ j ].addScaledVector( light.sh.coefficients[ j ], intensity );

				}

				numLightProbes ++;

			} else if ( light.isDirectionalLight ) {

				const uniforms = cache.get( light );

				uniforms.color.copy( light.color ).multiplyScalar( light.intensity );

				if ( light.castShadow ) {

					const shadow = light.shadow;

					const shadowUniforms = shadowCache.get( light );

					shadowUniforms.shadowIntensity = shadow.intensity;
					shadowUniforms.shadowBias = shadow.bias;
					shadowUniforms.shadowNormalBias = shadow.normalBias;
					shadowUniforms.shadowRadius = shadow.radius;
					shadowUniforms.shadowMapSize = shadow.mapSize;

					state.directionalShadow[ directionalLength ] = shadowUniforms;
					state.directionalShadowMap[ directionalLength ] = shadowMap;
					state.directionalShadowMatrix[ directionalLength ] = light.shadow.matrix;

					numDirectionalShadows ++;

				}

				state.directional[ directionalLength ] = uniforms;

				directionalLength ++;

			} else if ( light.isSpotLight ) {

				const uniforms = cache.get( light );

				uniforms.position.setFromMatrixPosition( light.matrixWorld );

				uniforms.color.copy( color ).multiplyScalar( intensity );
				uniforms.distance = distance;

				uniforms.coneCos = Math.cos( light.angle );
				uniforms.penumbraCos = Math.cos( light.angle * ( 1 - light.penumbra ) );
				uniforms.decay = light.decay;

				state.spot[ spotLength ] = uniforms;

				const shadow = light.shadow;

				if ( light.map ) {

					state.spotLightMap[ numSpotMaps ] = light.map;
					numSpotMaps ++;

					// make sure the lightMatrix is up to date
					// TODO : do it if required only
					shadow.updateMatrices( light );

					if ( light.castShadow ) numSpotShadowsWithMaps ++;

				}

				state.spotLightMatrix[ spotLength ] = shadow.matrix;

				if ( light.castShadow ) {

					const shadowUniforms = shadowCache.get( light );

					shadowUniforms.shadowIntensity = shadow.intensity;
					shadowUniforms.shadowBias = shadow.bias;
					shadowUniforms.shadowNormalBias = shadow.normalBias;
					shadowUniforms.shadowRadius = shadow.radius;
					shadowUniforms.shadowMapSize = shadow.mapSize;

					state.spotShadow[ spotLength ] = shadowUniforms;
					state.spotShadowMap[ spotLength ] = shadowMap;

					numSpotShadows ++;

				}

				spotLength ++;

			} else if ( light.isRectAreaLight ) {

				const uniforms = cache.get( light );

				uniforms.color.copy( color ).multiplyScalar( intensity );

				uniforms.halfWidth.set( light.width * 0.5, 0.0, 0.0 );
				uniforms.halfHeight.set( 0.0, light.height * 0.5, 0.0 );

				state.rectArea[ rectAreaLength ] = uniforms;

				rectAreaLength ++;

			} else if ( light.isPointLight ) {

				const uniforms = cache.get( light );

				uniforms.color.copy( light.color ).multiplyScalar( light.intensity );
				uniforms.distance = light.distance;
				uniforms.decay = light.decay;

				if ( light.castShadow ) {

					const shadow = light.shadow;

					const shadowUniforms = shadowCache.get( light );

					shadowUniforms.shadowIntensity = shadow.intensity;
					shadowUniforms.shadowBias = shadow.bias;
					shadowUniforms.shadowNormalBias = shadow.normalBias;
					shadowUniforms.shadowRadius = shadow.radius;
					shadowUniforms.shadowMapSize = shadow.mapSize;
					shadowUniforms.shadowCameraNear = shadow.camera.near;
					shadowUniforms.shadowCameraFar = shadow.camera.far;

					state.pointShadow[ pointLength ] = shadowUniforms;
					state.pointShadowMap[ pointLength ] = shadowMap;
					state.pointShadowMatrix[ pointLength ] = light.shadow.matrix;

					numPointShadows ++;

				}

				state.point[ pointLength ] = uniforms;

				pointLength ++;

			} else if ( light.isHemisphereLight ) {

				const uniforms = cache.get( light );

				uniforms.skyColor.copy( light.color ).multiplyScalar( intensity );
				uniforms.groundColor.copy( light.groundColor ).multiplyScalar( intensity );

				state.hemi[ hemiLength ] = uniforms;

				hemiLength ++;

			}

		}

		if ( rectAreaLength > 0 ) {

			if ( extensions.has( 'OES_texture_float_linear' ) === true ) {

				state.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1;
				state.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2;

			} else {

				state.rectAreaLTC1 = UniformsLib.LTC_HALF_1;
				state.rectAreaLTC2 = UniformsLib.LTC_HALF_2;

			}

		}

		state.ambient[ 0 ] = r;
		state.ambient[ 1 ] = g;
		state.ambient[ 2 ] = b;

		const hash = state.hash;

		if ( hash.directionalLength !== directionalLength ||
			hash.pointLength !== pointLength ||
			hash.spotLength !== spotLength ||
			hash.rectAreaLength !== rectAreaLength ||
			hash.hemiLength !== hemiLength ||
			hash.numDirectionalShadows !== numDirectionalShadows ||
			hash.numPointShadows !== numPointShadows ||
			hash.numSpotShadows !== numSpotShadows ||
			hash.numSpotMaps !== numSpotMaps ||
			hash.numLightProbes !== numLightProbes ) {

			state.directional.length = directionalLength;
			state.spot.length = spotLength;
			state.rectArea.length = rectAreaLength;
			state.point.length = pointLength;
			state.hemi.length = hemiLength;

			state.directionalShadow.length = numDirectionalShadows;
			state.directionalShadowMap.length = numDirectionalShadows;
			state.pointShadow.length = numPointShadows;
			state.pointShadowMap.length = numPointShadows;
			state.spotShadow.length = numSpotShadows;
			state.spotShadowMap.length = numSpotShadows;
			state.directionalShadowMatrix.length = numDirectionalShadows;
			state.pointShadowMatrix.length = numPointShadows;
			state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
			state.spotLightMap.length = numSpotMaps;
			state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
			state.numLightProbes = numLightProbes;

			hash.directionalLength = directionalLength;
			hash.pointLength = pointLength;
			hash.spotLength = spotLength;
			hash.rectAreaLength = rectAreaLength;
			hash.hemiLength = hemiLength;

			hash.numDirectionalShadows = numDirectionalShadows;
			hash.numPointShadows = numPointShadows;
			hash.numSpotShadows = numSpotShadows;
			hash.numSpotMaps = numSpotMaps;

			hash.numLightProbes = numLightProbes;

			state.version = nextVersion ++;

		}

	}

	function setupView( lights, camera ) {

		let directionalLength = 0;
		let pointLength = 0;
		let spotLength = 0;
		let rectAreaLength = 0;
		let hemiLength = 0;

		const viewMatrix = camera.matrixWorldInverse;

		for ( let i = 0, l = lights.length; i < l; i ++ ) {

			const light = lights[ i ];

			if ( light.isDirectionalLight ) {

				const uniforms = state.directional[ directionalLength ];

				uniforms.direction.setFromMatrixPosition( light.matrixWorld );
				vector3.setFromMatrixPosition( light.target.matrixWorld );
				uniforms.direction.sub( vector3 );
				uniforms.direction.transformDirection( viewMatrix );

				directionalLength ++;

			} else if ( light.isSpotLight ) {

				const uniforms = state.spot[ spotLength ];

				uniforms.position.setFromMatrixPosition( light.matrixWorld );
				uniforms.position.applyMatrix4( viewMatrix );

				uniforms.direction.setFromMatrixPosition( light.matrixWorld );
				vector3.setFromMatrixPosition( light.target.matrixWorld );
				uniforms.direction.sub( vector3 );
				uniforms.direction.transformDirection( viewMatrix );

				spotLength ++;

			} else if ( light.isRectAreaLight ) {

				const uniforms = state.rectArea[ rectAreaLength ];

				uniforms.position.setFromMatrixPosition( light.matrixWorld );
				uniforms.position.applyMatrix4( viewMatrix );

				// extract local rotation of light to derive width/height half vectors
				matrix42.identity();
				matrix4.copy( light.matrixWorld );
				matrix4.premultiply( viewMatrix );
				matrix42.extractRotation( matrix4 );

				uniforms.halfWidth.set( light.width * 0.5, 0.0, 0.0 );
				uniforms.halfHeight.set( 0.0, light.height * 0.5, 0.0 );

				uniforms.halfWidth.applyMatrix4( matrix42 );
				uniforms.halfHeight.applyMatrix4( matrix42 );

				rectAreaLength ++;

			} else if ( light.isPointLight ) {

				const uniforms = state.point[ pointLength ];

				uniforms.position.setFromMatrixPosition( light.matrixWorld );
				uniforms.position.applyMatrix4( viewMatrix );

				pointLength ++;

			} else if ( light.isHemisphereLight ) {

				const uniforms = state.hemi[ hemiLength ];

				uniforms.direction.setFromMatrixPosition( light.matrixWorld );
				uniforms.direction.transformDirection( viewMatrix );

				hemiLength ++;

			}

		}

	}

	return {
		setup: setup,
		setupView: setupView,
		state: state
	};

}

function WebGLRenderState( extensions ) {

	const lights = new WebGLLights( extensions );

	const lightsArray = [];
	const shadowsArray = [];

	function init( camera ) {

		state.camera = camera;

		lightsArray.length = 0;
		shadowsArray.length = 0;

	}

	function pushLight( light ) {

		lightsArray.push( light );

	}

	function pushShadow( shadowLight ) {

		shadowsArray.push( shadowLight );

	}

	function setupLights() {

		lights.setup( lightsArray );

	}

	function setupLightsView( camera ) {

		lights.setupView( lightsArray, camera );

	}

	const state = {
		lightsArray: lightsArray,
		shadowsArray: shadowsArray,

		camera: null,

		lights: lights,

		transmissionRenderTarget: {}
	};

	return {
		init: init,
		state: state,
		setupLights: setupLights,
		setupLightsView: setupLightsView,

		pushLight: pushLight,
		pushShadow: pushShadow
	};

}

function WebGLRenderStates( extensions ) {

	let renderStates = new WeakMap();

	function get( scene, renderCallDepth = 0 ) {

		const renderStateArray = renderStates.get( scene );
		let renderState;

		if ( renderStateArray === undefined ) {

			renderState = new WebGLRenderState( extensions );
			renderStates.set( scene, [ renderState ] );

		} else {

			if ( renderCallDepth >= renderStateArray.length ) {

				renderState = new WebGLRenderState( extensions );
				renderStateArray.push( renderState );

			} else {

				renderState = renderStateArray[ renderCallDepth ];

			}

		}

		return renderState;

	}

	function dispose() {

		renderStates = new WeakMap();

	}

	return {
		get: get,
		dispose: dispose
	};

}

class MeshDepthMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isMeshDepthMaterial = true;

		this.type = 'MeshDepthMaterial';

		this.depthPacking = BasicDepthPacking;

		this.map = null;

		this.alphaMap = null;

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.wireframe = false;
		this.wireframeLinewidth = 1;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.depthPacking = source.depthPacking;

		this.map = source.map;

		this.alphaMap = source.alphaMap;

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;

		return this;

	}

}

class MeshDistanceMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isMeshDistanceMaterial = true;

		this.type = 'MeshDistanceMaterial';

		this.map = null;

		this.alphaMap = null;

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.map = source.map;

		this.alphaMap = source.alphaMap;

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		return this;

	}

}

const vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";

const fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";

function WebGLShadowMap( renderer, objects, capabilities ) {

	let _frustum = new Frustum();

	const _shadowMapSize = new Vector2(),
		_viewportSize = new Vector2(),

		_viewport = new Vector4(),

		_depthMaterial = new MeshDepthMaterial( { depthPacking: RGBADepthPacking } ),
		_distanceMaterial = new MeshDistanceMaterial(),

		_materialCache = {},

		_maxTextureSize = capabilities.maxTextureSize;

	const shadowSide = { [ FrontSide ]: BackSide, [ BackSide ]: FrontSide, [ DoubleSide ]: DoubleSide };

	const shadowMaterialVertical = new ShaderMaterial( {
		defines: {
			VSM_SAMPLES: 8
		},
		uniforms: {
			shadow_pass: { value: null },
			resolution: { value: new Vector2() },
			radius: { value: 4.0 }
		},

		vertexShader: vertex,
		fragmentShader: fragment

	} );

	const shadowMaterialHorizontal = shadowMaterialVertical.clone();
	shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;

	const fullScreenTri = new BufferGeometry();
	fullScreenTri.setAttribute(
		'position',
		new BufferAttribute(
			new Float32Array( [ - 1, - 1, 0.5, 3, - 1, 0.5, - 1, 3, 0.5 ] ),
			3
		)
	);

	const fullScreenMesh = new Mesh( fullScreenTri, shadowMaterialVertical );

	const scope = this;

	this.enabled = false;

	this.autoUpdate = true;
	this.needsUpdate = false;

	this.type = PCFShadowMap;
	let _previousType = this.type;

	this.render = function ( lights, scene, camera ) {

		if ( scope.enabled === false ) return;
		if ( scope.autoUpdate === false && scope.needsUpdate === false ) return;

		if ( lights.length === 0 ) return;

		const currentRenderTarget = renderer.getRenderTarget();
		const activeCubeFace = renderer.getActiveCubeFace();
		const activeMipmapLevel = renderer.getActiveMipmapLevel();

		const _state = renderer.state;

		// Set GL state for depth map.
		_state.setBlending( NoBlending );
		_state.buffers.color.setClear( 1, 1, 1, 1 );
		_state.buffers.depth.setTest( true );
		_state.setScissorTest( false );

		// check for shadow map type changes

		const toVSM = ( _previousType !== VSMShadowMap && this.type === VSMShadowMap );
		const fromVSM = ( _previousType === VSMShadowMap && this.type !== VSMShadowMap );

		// render depth map

		for ( let i = 0, il = lights.length; i < il; i ++ ) {

			const light = lights[ i ];
			const shadow = light.shadow;

			if ( shadow === undefined ) {

				console.warn( 'THREE.WebGLShadowMap:', light, 'has no shadow.' );
				continue;

			}

			if ( shadow.autoUpdate === false && shadow.needsUpdate === false ) continue;

			_shadowMapSize.copy( shadow.mapSize );

			const shadowFrameExtents = shadow.getFrameExtents();

			_shadowMapSize.multiply( shadowFrameExtents );

			_viewportSize.copy( shadow.mapSize );

			if ( _shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize ) {

				if ( _shadowMapSize.x > _maxTextureSize ) {

					_viewportSize.x = Math.floor( _maxTextureSize / shadowFrameExtents.x );
					_shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
					shadow.mapSize.x = _viewportSize.x;

				}

				if ( _shadowMapSize.y > _maxTextureSize ) {

					_viewportSize.y = Math.floor( _maxTextureSize / shadowFrameExtents.y );
					_shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
					shadow.mapSize.y = _viewportSize.y;

				}

			}

			if ( shadow.map === null || toVSM === true || fromVSM === true ) {

				const pars = ( this.type !== VSMShadowMap ) ? { minFilter: NearestFilter, magFilter: NearestFilter } : {};

				if ( shadow.map !== null ) {

					shadow.map.dispose();

				}

				shadow.map = new WebGLRenderTarget( _shadowMapSize.x, _shadowMapSize.y, pars );
				shadow.map.texture.name = light.name + '.shadowMap';

				shadow.camera.updateProjectionMatrix();

			}

			renderer.setRenderTarget( shadow.map );
			renderer.clear();

			const viewportCount = shadow.getViewportCount();

			for ( let vp = 0; vp < viewportCount; vp ++ ) {

				const viewport = shadow.getViewport( vp );

				_viewport.set(
					_viewportSize.x * viewport.x,
					_viewportSize.y * viewport.y,
					_viewportSize.x * viewport.z,
					_viewportSize.y * viewport.w
				);

				_state.viewport( _viewport );

				shadow.updateMatrices( light, vp );

				_frustum = shadow.getFrustum();

				renderObject( scene, camera, shadow.camera, light, this.type );

			}

			// do blur pass for VSM

			if ( shadow.isPointLightShadow !== true && this.type === VSMShadowMap ) {

				VSMPass( shadow, camera );

			}

			shadow.needsUpdate = false;

		}

		_previousType = this.type;

		scope.needsUpdate = false;

		renderer.setRenderTarget( currentRenderTarget, activeCubeFace, activeMipmapLevel );

	};

	function VSMPass( shadow, camera ) {

		const geometry = objects.update( fullScreenMesh );

		if ( shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples ) {

			shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
			shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;

			shadowMaterialVertical.needsUpdate = true;
			shadowMaterialHorizontal.needsUpdate = true;

		}

		if ( shadow.mapPass === null ) {

			shadow.mapPass = new WebGLRenderTarget( _shadowMapSize.x, _shadowMapSize.y );

		}

		// vertical pass

		shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
		shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
		shadowMaterialVertical.uniforms.radius.value = shadow.radius;
		renderer.setRenderTarget( shadow.mapPass );
		renderer.clear();
		renderer.renderBufferDirect( camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null );

		// horizontal pass

		shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
		shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
		shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
		renderer.setRenderTarget( shadow.map );
		renderer.clear();
		renderer.renderBufferDirect( camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null );

	}

	function getDepthMaterial( object, material, light, type ) {

		let result = null;

		const customMaterial = ( light.isPointLight === true ) ? object.customDistanceMaterial : object.customDepthMaterial;

		if ( customMaterial !== undefined ) {

			result = customMaterial;

		} else {

			result = ( light.isPointLight === true ) ? _distanceMaterial : _depthMaterial;

			if ( ( renderer.localClippingEnabled && material.clipShadows === true && Array.isArray( material.clippingPlanes ) && material.clippingPlanes.length !== 0 ) ||
				( material.displacementMap && material.displacementScale !== 0 ) ||
				( material.alphaMap && material.alphaTest > 0 ) ||
				( material.map && material.alphaTest > 0 ) ) {

				// in this case we need a unique material instance reflecting the
				// appropriate state

				const keyA = result.uuid, keyB = material.uuid;

				let materialsForVariant = _materialCache[ keyA ];

				if ( materialsForVariant === undefined ) {

					materialsForVariant = {};
					_materialCache[ keyA ] = materialsForVariant;

				}

				let cachedMaterial = materialsForVariant[ keyB ];

				if ( cachedMaterial === undefined ) {

					cachedMaterial = result.clone();
					materialsForVariant[ keyB ] = cachedMaterial;
					material.addEventListener( 'dispose', onMaterialDispose );

				}

				result = cachedMaterial;

			}

		}

		result.visible = material.visible;
		result.wireframe = material.wireframe;

		if ( type === VSMShadowMap ) {

			result.side = ( material.shadowSide !== null ) ? material.shadowSide : material.side;

		} else {

			result.side = ( material.shadowSide !== null ) ? material.shadowSide : shadowSide[ material.side ];

		}

		result.alphaMap = material.alphaMap;
		result.alphaTest = material.alphaTest;
		result.map = material.map;

		result.clipShadows = material.clipShadows;
		result.clippingPlanes = material.clippingPlanes;
		result.clipIntersection = material.clipIntersection;

		result.displacementMap = material.displacementMap;
		result.displacementScale = material.displacementScale;
		result.displacementBias = material.displacementBias;

		result.wireframeLinewidth = material.wireframeLinewidth;
		result.linewidth = material.linewidth;

		if ( light.isPointLight === true && result.isMeshDistanceMaterial === true ) {

			const materialProperties = renderer.properties.get( result );
			materialProperties.light = light;

		}

		return result;

	}

	function renderObject( object, camera, shadowCamera, light, type ) {

		if ( object.visible === false ) return;

		const visible = object.layers.test( camera.layers );

		if ( visible && ( object.isMesh || object.isLine || object.isPoints ) ) {

			if ( ( object.castShadow || ( object.receiveShadow && type === VSMShadowMap ) ) && ( ! object.frustumCulled || _frustum.intersectsObject( object ) ) ) {

				object.modelViewMatrix.multiplyMatrices( shadowCamera.matrixWorldInverse, object.matrixWorld );

				const geometry = objects.update( object );
				const material = object.material;

				if ( Array.isArray( material ) ) {

					const groups = geometry.groups;

					for ( let k = 0, kl = groups.length; k < kl; k ++ ) {

						const group = groups[ k ];
						const groupMaterial = material[ group.materialIndex ];

						if ( groupMaterial && groupMaterial.visible ) {

							const depthMaterial = getDepthMaterial( object, groupMaterial, light, type );

							object.onBeforeShadow( renderer, object, camera, shadowCamera, geometry, depthMaterial, group );

							renderer.renderBufferDirect( shadowCamera, null, geometry, depthMaterial, object, group );

							object.onAfterShadow( renderer, object, camera, shadowCamera, geometry, depthMaterial, group );

						}

					}

				} else if ( material.visible ) {

					const depthMaterial = getDepthMaterial( object, material, light, type );

					object.onBeforeShadow( renderer, object, camera, shadowCamera, geometry, depthMaterial, null );

					renderer.renderBufferDirect( shadowCamera, null, geometry, depthMaterial, object, null );

					object.onAfterShadow( renderer, object, camera, shadowCamera, geometry, depthMaterial, null );

				}

			}

		}

		const children = object.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			renderObject( children[ i ], camera, shadowCamera, light, type );

		}

	}

	function onMaterialDispose( event ) {

		const material = event.target;

		material.removeEventListener( 'dispose', onMaterialDispose );

		// make sure to remove the unique distance/depth materials used for shadow map rendering

		for ( const id in _materialCache ) {

			const cache = _materialCache[ id ];

			const uuid = event.target.uuid;

			if ( uuid in cache ) {

				const shadowMaterial = cache[ uuid ];
				shadowMaterial.dispose();
				delete cache[ uuid ];

			}

		}

	}

}

function WebGLState( gl ) {

	function ColorBuffer() {

		let locked = false;

		const color = new Vector4();
		let currentColorMask = null;
		const currentColorClear = new Vector4( 0, 0, 0, 0 );

		return {

			setMask: function ( colorMask ) {

				if ( currentColorMask !== colorMask && ! locked ) {

					gl.colorMask( colorMask, colorMask, colorMask, colorMask );
					currentColorMask = colorMask;

				}

			},

			setLocked: function ( lock ) {

				locked = lock;

			},

			setClear: function ( r, g, b, a, premultipliedAlpha ) {

				if ( premultipliedAlpha === true ) {

					r *= a; g *= a; b *= a;

				}

				color.set( r, g, b, a );

				if ( currentColorClear.equals( color ) === false ) {

					gl.clearColor( r, g, b, a );
					currentColorClear.copy( color );

				}

			},

			reset: function () {

				locked = false;

				currentColorMask = null;
				currentColorClear.set( - 1, 0, 0, 0 ); // set to invalid state

			}

		};

	}

	function DepthBuffer() {

		let locked = false;

		let currentDepthMask = null;
		let currentDepthFunc = null;
		let currentDepthClear = null;

		return {

			setTest: function ( depthTest ) {

				if ( depthTest ) {

					enable( gl.DEPTH_TEST );

				} else {

					disable( gl.DEPTH_TEST );

				}

			},

			setMask: function ( depthMask ) {

				if ( currentDepthMask !== depthMask && ! locked ) {

					gl.depthMask( depthMask );
					currentDepthMask = depthMask;

				}

			},

			setFunc: function ( depthFunc ) {

				if ( currentDepthFunc !== depthFunc ) {

					switch ( depthFunc ) {

						case NeverDepth:

							gl.depthFunc( gl.NEVER );
							break;

						case AlwaysDepth:

							gl.depthFunc( gl.ALWAYS );
							break;

						case LessDepth:

							gl.depthFunc( gl.LESS );
							break;

						case LessEqualDepth:

							gl.depthFunc( gl.LEQUAL );
							break;

						case EqualDepth:

							gl.depthFunc( gl.EQUAL );
							break;

						case GreaterEqualDepth:

							gl.depthFunc( gl.GEQUAL );
							break;

						case GreaterDepth:

							gl.depthFunc( gl.GREATER );
							break;

						case NotEqualDepth:

							gl.depthFunc( gl.NOTEQUAL );
							break;

						default:

							gl.depthFunc( gl.LEQUAL );

					}

					currentDepthFunc = depthFunc;

				}

			},

			setLocked: function ( lock ) {

				locked = lock;

			},

			setClear: function ( depth ) {

				if ( currentDepthClear !== depth ) {

					gl.clearDepth( depth );
					currentDepthClear = depth;

				}

			},

			reset: function () {

				locked = false;

				currentDepthMask = null;
				currentDepthFunc = null;
				currentDepthClear = null;

			}

		};

	}

	function StencilBuffer() {

		let locked = false;

		let currentStencilMask = null;
		let currentStencilFunc = null;
		let currentStencilRef = null;
		let currentStencilFuncMask = null;
		let currentStencilFail = null;
		let currentStencilZFail = null;
		let currentStencilZPass = null;
		let currentStencilClear = null;

		return {

			setTest: function ( stencilTest ) {

				if ( ! locked ) {

					if ( stencilTest ) {

						enable( gl.STENCIL_TEST );

					} else {

						disable( gl.STENCIL_TEST );

					}

				}

			},

			setMask: function ( stencilMask ) {

				if ( currentStencilMask !== stencilMask && ! locked ) {

					gl.stencilMask( stencilMask );
					currentStencilMask = stencilMask;

				}

			},

			setFunc: function ( stencilFunc, stencilRef, stencilMask ) {

				if ( currentStencilFunc !== stencilFunc ||
				     currentStencilRef !== stencilRef ||
				     currentStencilFuncMask !== stencilMask ) {

					gl.stencilFunc( stencilFunc, stencilRef, stencilMask );

					currentStencilFunc = stencilFunc;
					currentStencilRef = stencilRef;
					currentStencilFuncMask = stencilMask;

				}

			},

			setOp: function ( stencilFail, stencilZFail, stencilZPass ) {

				if ( currentStencilFail !== stencilFail ||
				     currentStencilZFail !== stencilZFail ||
				     currentStencilZPass !== stencilZPass ) {

					gl.stencilOp( stencilFail, stencilZFail, stencilZPass );

					currentStencilFail = stencilFail;
					currentStencilZFail = stencilZFail;
					currentStencilZPass = stencilZPass;

				}

			},

			setLocked: function ( lock ) {

				locked = lock;

			},

			setClear: function ( stencil ) {

				if ( currentStencilClear !== stencil ) {

					gl.clearStencil( stencil );
					currentStencilClear = stencil;

				}

			},

			reset: function () {

				locked = false;

				currentStencilMask = null;
				currentStencilFunc = null;
				currentStencilRef = null;
				currentStencilFuncMask = null;
				currentStencilFail = null;
				currentStencilZFail = null;
				currentStencilZPass = null;
				currentStencilClear = null;

			}

		};

	}

	//

	const colorBuffer = new ColorBuffer();
	const depthBuffer = new DepthBuffer();
	const stencilBuffer = new StencilBuffer();

	const uboBindings = new WeakMap();
	const uboProgramMap = new WeakMap();

	let enabledCapabilities = {};

	let currentBoundFramebuffers = {};
	let currentDrawbuffers = new WeakMap();
	let defaultDrawbuffers = [];

	let currentProgram = null;

	let currentBlendingEnabled = false;
	let currentBlending = null;
	let currentBlendEquation = null;
	let currentBlendSrc = null;
	let currentBlendDst = null;
	let currentBlendEquationAlpha = null;
	let currentBlendSrcAlpha = null;
	let currentBlendDstAlpha = null;
	let currentBlendColor = new Color( 0, 0, 0 );
	let currentBlendAlpha = 0;
	let currentPremultipledAlpha = false;

	let currentFlipSided = null;
	let currentCullFace = null;

	let currentLineWidth = null;

	let currentPolygonOffsetFactor = null;
	let currentPolygonOffsetUnits = null;

	const maxTextures = gl.getParameter( gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS );

	let lineWidthAvailable = false;
	let version = 0;
	const glVersion = gl.getParameter( gl.VERSION );

	if ( glVersion.indexOf( 'WebGL' ) !== - 1 ) {

		version = parseFloat( /^WebGL (\d)/.exec( glVersion )[ 1 ] );
		lineWidthAvailable = ( version >= 1.0 );

	} else if ( glVersion.indexOf( 'OpenGL ES' ) !== - 1 ) {

		version = parseFloat( /^OpenGL ES (\d)/.exec( glVersion )[ 1 ] );
		lineWidthAvailable = ( version >= 2.0 );

	}

	let currentTextureSlot = null;
	let currentBoundTextures = {};

	const scissorParam = gl.getParameter( gl.SCISSOR_BOX );
	const viewportParam = gl.getParameter( gl.VIEWPORT );

	const currentScissor = new Vector4().fromArray( scissorParam );
	const currentViewport = new Vector4().fromArray( viewportParam );

	function createTexture( type, target, count, dimensions ) {

		const data = new Uint8Array( 4 ); // 4 is required to match default unpack alignment of 4.
		const texture = gl.createTexture();

		gl.bindTexture( type, texture );
		gl.texParameteri( type, gl.TEXTURE_MIN_FILTER, gl.NEAREST );
		gl.texParameteri( type, gl.TEXTURE_MAG_FILTER, gl.NEAREST );

		for ( let i = 0; i < count; i ++ ) {

			if ( type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY ) {

				gl.texImage3D( target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data );

			} else {

				gl.texImage2D( target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data );

			}

		}

		return texture;

	}

	const emptyTextures = {};
	emptyTextures[ gl.TEXTURE_2D ] = createTexture( gl.TEXTURE_2D, gl.TEXTURE_2D, 1 );
	emptyTextures[ gl.TEXTURE_CUBE_MAP ] = createTexture( gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6 );
	emptyTextures[ gl.TEXTURE_2D_ARRAY ] = createTexture( gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1 );
	emptyTextures[ gl.TEXTURE_3D ] = createTexture( gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1 );

	// init

	colorBuffer.setClear( 0, 0, 0, 1 );
	depthBuffer.setClear( 1 );
	stencilBuffer.setClear( 0 );

	enable( gl.DEPTH_TEST );
	depthBuffer.setFunc( LessEqualDepth );

	setFlipSided( false );
	setCullFace( CullFaceBack );
	enable( gl.CULL_FACE );

	setBlending( NoBlending );

	//

	function enable( id ) {

		if ( enabledCapabilities[ id ] !== true ) {

			gl.enable( id );
			enabledCapabilities[ id ] = true;

		}

	}

	function disable( id ) {

		if ( enabledCapabilities[ id ] !== false ) {

			gl.disable( id );
			enabledCapabilities[ id ] = false;

		}

	}

	function bindFramebuffer( target, framebuffer ) {

		if ( currentBoundFramebuffers[ target ] !== framebuffer ) {

			gl.bindFramebuffer( target, framebuffer );

			currentBoundFramebuffers[ target ] = framebuffer;

			// gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER

			if ( target === gl.DRAW_FRAMEBUFFER ) {

				currentBoundFramebuffers[ gl.FRAMEBUFFER ] = framebuffer;

			}

			if ( target === gl.FRAMEBUFFER ) {

				currentBoundFramebuffers[ gl.DRAW_FRAMEBUFFER ] = framebuffer;

			}

			return true;

		}

		return false;

	}

	function drawBuffers( renderTarget, framebuffer ) {

		let drawBuffers = defaultDrawbuffers;

		let needsUpdate = false;

		if ( renderTarget ) {

			drawBuffers = currentDrawbuffers.get( framebuffer );

			if ( drawBuffers === undefined ) {

				drawBuffers = [];
				currentDrawbuffers.set( framebuffer, drawBuffers );

			}

			const textures = renderTarget.textures;

			if ( drawBuffers.length !== textures.length || drawBuffers[ 0 ] !== gl.COLOR_ATTACHMENT0 ) {

				for ( let i = 0, il = textures.length; i < il; i ++ ) {

					drawBuffers[ i ] = gl.COLOR_ATTACHMENT0 + i;

				}

				drawBuffers.length = textures.length;

				needsUpdate = true;

			}

		} else {

			if ( drawBuffers[ 0 ] !== gl.BACK ) {

				drawBuffers[ 0 ] = gl.BACK;

				needsUpdate = true;

			}

		}

		if ( needsUpdate ) {

			gl.drawBuffers( drawBuffers );

		}

	}

	function useProgram( program ) {

		if ( currentProgram !== program ) {

			gl.useProgram( program );

			currentProgram = program;

			return true;

		}

		return false;

	}

	const equationToGL = {
		[ AddEquation ]: gl.FUNC_ADD,
		[ SubtractEquation ]: gl.FUNC_SUBTRACT,
		[ ReverseSubtractEquation ]: gl.FUNC_REVERSE_SUBTRACT
	};

	equationToGL[ MinEquation ] = gl.MIN;
	equationToGL[ MaxEquation ] = gl.MAX;

	const factorToGL = {
		[ ZeroFactor ]: gl.ZERO,
		[ OneFactor ]: gl.ONE,
		[ SrcColorFactor ]: gl.SRC_COLOR,
		[ SrcAlphaFactor ]: gl.SRC_ALPHA,
		[ SrcAlphaSaturateFactor ]: gl.SRC_ALPHA_SATURATE,
		[ DstColorFactor ]: gl.DST_COLOR,
		[ DstAlphaFactor ]: gl.DST_ALPHA,
		[ OneMinusSrcColorFactor ]: gl.ONE_MINUS_SRC_COLOR,
		[ OneMinusSrcAlphaFactor ]: gl.ONE_MINUS_SRC_ALPHA,
		[ OneMinusDstColorFactor ]: gl.ONE_MINUS_DST_COLOR,
		[ OneMinusDstAlphaFactor ]: gl.ONE_MINUS_DST_ALPHA,
		[ ConstantColorFactor ]: gl.CONSTANT_COLOR,
		[ OneMinusConstantColorFactor ]: gl.ONE_MINUS_CONSTANT_COLOR,
		[ ConstantAlphaFactor ]: gl.CONSTANT_ALPHA,
		[ OneMinusConstantAlphaFactor ]: gl.ONE_MINUS_CONSTANT_ALPHA
	};

	function setBlending( blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha ) {

		if ( blending === NoBlending ) {

			if ( currentBlendingEnabled === true ) {

				disable( gl.BLEND );
				currentBlendingEnabled = false;

			}

			return;

		}

		if ( currentBlendingEnabled === false ) {

			enable( gl.BLEND );
			currentBlendingEnabled = true;

		}

		if ( blending !== CustomBlending ) {

			if ( blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha ) {

				if ( currentBlendEquation !== AddEquation || currentBlendEquationAlpha !== AddEquation ) {

					gl.blendEquation( gl.FUNC_ADD );

					currentBlendEquation = AddEquation;
					currentBlendEquationAlpha = AddEquation;

				}

				if ( premultipliedAlpha ) {

					switch ( blending ) {

						case NormalBlending:
							gl.blendFuncSeparate( gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA );
							break;

						case AdditiveBlending:
							gl.blendFunc( gl.ONE, gl.ONE );
							break;

						case SubtractiveBlending:
							gl.blendFuncSeparate( gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE );
							break;

						case MultiplyBlending:
							gl.blendFuncSeparate( gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA );
							break;

						default:
							console.error( 'THREE.WebGLState: Invalid blending: ', blending );
							break;

					}

				} else {

					switch ( blending ) {

						case NormalBlending:
							gl.blendFuncSeparate( gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA );
							break;

						case AdditiveBlending:
							gl.blendFunc( gl.SRC_ALPHA, gl.ONE );
							break;

						case SubtractiveBlending:
							gl.blendFuncSeparate( gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE );
							break;

						case MultiplyBlending:
							gl.blendFunc( gl.ZERO, gl.SRC_COLOR );
							break;

						default:
							console.error( 'THREE.WebGLState: Invalid blending: ', blending );
							break;

					}

				}

				currentBlendSrc = null;
				currentBlendDst = null;
				currentBlendSrcAlpha = null;
				currentBlendDstAlpha = null;
				currentBlendColor.set( 0, 0, 0 );
				currentBlendAlpha = 0;

				currentBlending = blending;
				currentPremultipledAlpha = premultipliedAlpha;

			}

			return;

		}

		// custom blending

		blendEquationAlpha = blendEquationAlpha || blendEquation;
		blendSrcAlpha = blendSrcAlpha || blendSrc;
		blendDstAlpha = blendDstAlpha || blendDst;

		if ( blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha ) {

			gl.blendEquationSeparate( equationToGL[ blendEquation ], equationToGL[ blendEquationAlpha ] );

			currentBlendEquation = blendEquation;
			currentBlendEquationAlpha = blendEquationAlpha;

		}

		if ( blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha ) {

			gl.blendFuncSeparate( factorToGL[ blendSrc ], factorToGL[ blendDst ], factorToGL[ blendSrcAlpha ], factorToGL[ blendDstAlpha ] );

			currentBlendSrc = blendSrc;
			currentBlendDst = blendDst;
			currentBlendSrcAlpha = blendSrcAlpha;
			currentBlendDstAlpha = blendDstAlpha;

		}

		if ( blendColor.equals( currentBlendColor ) === false || blendAlpha !== currentBlendAlpha ) {

			gl.blendColor( blendColor.r, blendColor.g, blendColor.b, blendAlpha );

			currentBlendColor.copy( blendColor );
			currentBlendAlpha = blendAlpha;

		}

		currentBlending = blending;
		currentPremultipledAlpha = false;

	}

	function setMaterial( material, frontFaceCW ) {

		material.side === DoubleSide
			? disable( gl.CULL_FACE )
			: enable( gl.CULL_FACE );

		let flipSided = ( material.side === BackSide );
		if ( frontFaceCW ) flipSided = ! flipSided;

		setFlipSided( flipSided );

		( material.blending === NormalBlending && material.transparent === false )
			? setBlending( NoBlending )
			: setBlending( material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha );

		depthBuffer.setFunc( material.depthFunc );
		depthBuffer.setTest( material.depthTest );
		depthBuffer.setMask( material.depthWrite );
		colorBuffer.setMask( material.colorWrite );

		const stencilWrite = material.stencilWrite;
		stencilBuffer.setTest( stencilWrite );
		if ( stencilWrite ) {

			stencilBuffer.setMask( material.stencilWriteMask );
			stencilBuffer.setFunc( material.stencilFunc, material.stencilRef, material.stencilFuncMask );
			stencilBuffer.setOp( material.stencilFail, material.stencilZFail, material.stencilZPass );

		}

		setPolygonOffset( material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits );

		material.alphaToCoverage === true
			? enable( gl.SAMPLE_ALPHA_TO_COVERAGE )
			: disable( gl.SAMPLE_ALPHA_TO_COVERAGE );

	}

	//

	function setFlipSided( flipSided ) {

		if ( currentFlipSided !== flipSided ) {

			if ( flipSided ) {

				gl.frontFace( gl.CW );

			} else {

				gl.frontFace( gl.CCW );

			}

			currentFlipSided = flipSided;

		}

	}

	function setCullFace( cullFace ) {

		if ( cullFace !== CullFaceNone ) {

			enable( gl.CULL_FACE );

			if ( cullFace !== currentCullFace ) {

				if ( cullFace === CullFaceBack ) {

					gl.cullFace( gl.BACK );

				} else if ( cullFace === CullFaceFront ) {

					gl.cullFace( gl.FRONT );

				} else {

					gl.cullFace( gl.FRONT_AND_BACK );

				}

			}

		} else {

			disable( gl.CULL_FACE );

		}

		currentCullFace = cullFace;

	}

	function setLineWidth( width ) {

		if ( width !== currentLineWidth ) {

			if ( lineWidthAvailable ) gl.lineWidth( width );

			currentLineWidth = width;

		}

	}

	function setPolygonOffset( polygonOffset, factor, units ) {

		if ( polygonOffset ) {

			enable( gl.POLYGON_OFFSET_FILL );

			if ( currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units ) {

				gl.polygonOffset( factor, units );

				currentPolygonOffsetFactor = factor;
				currentPolygonOffsetUnits = units;

			}

		} else {

			disable( gl.POLYGON_OFFSET_FILL );

		}

	}

	function setScissorTest( scissorTest ) {

		if ( scissorTest ) {

			enable( gl.SCISSOR_TEST );

		} else {

			disable( gl.SCISSOR_TEST );

		}

	}

	// texture

	function activeTexture( webglSlot ) {

		if ( webglSlot === undefined ) webglSlot = gl.TEXTURE0 + maxTextures - 1;

		if ( currentTextureSlot !== webglSlot ) {

			gl.activeTexture( webglSlot );
			currentTextureSlot = webglSlot;

		}

	}

	function bindTexture( webglType, webglTexture, webglSlot ) {

		if ( webglSlot === undefined ) {

			if ( currentTextureSlot === null ) {

				webglSlot = gl.TEXTURE0 + maxTextures - 1;

			} else {

				webglSlot = currentTextureSlot;

			}

		}

		let boundTexture = currentBoundTextures[ webglSlot ];

		if ( boundTexture === undefined ) {

			boundTexture = { type: undefined, texture: undefined };
			currentBoundTextures[ webglSlot ] = boundTexture;

		}

		if ( boundTexture.type !== webglType || boundTexture.texture !== webglTexture ) {

			if ( currentTextureSlot !== webglSlot ) {

				gl.activeTexture( webglSlot );
				currentTextureSlot = webglSlot;

			}

			gl.bindTexture( webglType, webglTexture || emptyTextures[ webglType ] );

			boundTexture.type = webglType;
			boundTexture.texture = webglTexture;

		}

	}

	function unbindTexture() {

		const boundTexture = currentBoundTextures[ currentTextureSlot ];

		if ( boundTexture !== undefined && boundTexture.type !== undefined ) {

			gl.bindTexture( boundTexture.type, null );

			boundTexture.type = undefined;
			boundTexture.texture = undefined;

		}

	}

	function compressedTexImage2D() {

		try {

			gl.compressedTexImage2D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function compressedTexImage3D() {

		try {

			gl.compressedTexImage3D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function texSubImage2D() {

		try {

			gl.texSubImage2D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function texSubImage3D() {

		try {

			gl.texSubImage3D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function compressedTexSubImage2D() {

		try {

			gl.compressedTexSubImage2D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function compressedTexSubImage3D() {

		try {

			gl.compressedTexSubImage3D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function texStorage2D() {

		try {

			gl.texStorage2D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function texStorage3D() {

		try {

			gl.texStorage3D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function texImage2D() {

		try {

			gl.texImage2D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	function texImage3D() {

		try {

			gl.texImage3D.apply( gl, arguments );

		} catch ( error ) {

			console.error( 'THREE.WebGLState:', error );

		}

	}

	//

	function scissor( scissor ) {

		if ( currentScissor.equals( scissor ) === false ) {

			gl.scissor( scissor.x, scissor.y, scissor.z, scissor.w );
			currentScissor.copy( scissor );

		}

	}

	function viewport( viewport ) {

		if ( currentViewport.equals( viewport ) === false ) {

			gl.viewport( viewport.x, viewport.y, viewport.z, viewport.w );
			currentViewport.copy( viewport );

		}

	}

	function updateUBOMapping( uniformsGroup, program ) {

		let mapping = uboProgramMap.get( program );

		if ( mapping === undefined ) {

			mapping = new WeakMap();

			uboProgramMap.set( program, mapping );

		}

		let blockIndex = mapping.get( uniformsGroup );

		if ( blockIndex === undefined ) {

			blockIndex = gl.getUniformBlockIndex( program, uniformsGroup.name );

			mapping.set( uniformsGroup, blockIndex );

		}

	}

	function uniformBlockBinding( uniformsGroup, program ) {

		const mapping = uboProgramMap.get( program );
		const blockIndex = mapping.get( uniformsGroup );

		if ( uboBindings.get( program ) !== blockIndex ) {

			// bind shader specific block index to global block point
			gl.uniformBlockBinding( program, blockIndex, uniformsGroup.__bindingPointIndex );

			uboBindings.set( program, blockIndex );

		}

	}

	//

	function reset() {

		// reset state

		gl.disable( gl.BLEND );
		gl.disable( gl.CULL_FACE );
		gl.disable( gl.DEPTH_TEST );
		gl.disable( gl.POLYGON_OFFSET_FILL );
		gl.disable( gl.SCISSOR_TEST );
		gl.disable( gl.STENCIL_TEST );
		gl.disable( gl.SAMPLE_ALPHA_TO_COVERAGE );

		gl.blendEquation( gl.FUNC_ADD );
		gl.blendFunc( gl.ONE, gl.ZERO );
		gl.blendFuncSeparate( gl.ONE, gl.ZERO, gl.ONE, gl.ZERO );
		gl.blendColor( 0, 0, 0, 0 );

		gl.colorMask( true, true, true, true );
		gl.clearColor( 0, 0, 0, 0 );

		gl.depthMask( true );
		gl.depthFunc( gl.LESS );
		gl.clearDepth( 1 );

		gl.stencilMask( 0xffffffff );
		gl.stencilFunc( gl.ALWAYS, 0, 0xffffffff );
		gl.stencilOp( gl.KEEP, gl.KEEP, gl.KEEP );
		gl.clearStencil( 0 );

		gl.cullFace( gl.BACK );
		gl.frontFace( gl.CCW );

		gl.polygonOffset( 0, 0 );

		gl.activeTexture( gl.TEXTURE0 );

		gl.bindFramebuffer( gl.FRAMEBUFFER, null );
		gl.bindFramebuffer( gl.DRAW_FRAMEBUFFER, null );
		gl.bindFramebuffer( gl.READ_FRAMEBUFFER, null );

		gl.useProgram( null );

		gl.lineWidth( 1 );

		gl.scissor( 0, 0, gl.canvas.width, gl.canvas.height );
		gl.viewport( 0, 0, gl.canvas.width, gl.canvas.height );

		// reset internals

		enabledCapabilities = {};

		currentTextureSlot = null;
		currentBoundTextures = {};

		currentBoundFramebuffers = {};
		currentDrawbuffers = new WeakMap();
		defaultDrawbuffers = [];

		currentProgram = null;

		currentBlendingEnabled = false;
		currentBlending = null;
		currentBlendEquation = null;
		currentBlendSrc = null;
		currentBlendDst = null;
		currentBlendEquationAlpha = null;
		currentBlendSrcAlpha = null;
		currentBlendDstAlpha = null;
		currentBlendColor = new Color( 0, 0, 0 );
		currentBlendAlpha = 0;
		currentPremultipledAlpha = false;

		currentFlipSided = null;
		currentCullFace = null;

		currentLineWidth = null;

		currentPolygonOffsetFactor = null;
		currentPolygonOffsetUnits = null;

		currentScissor.set( 0, 0, gl.canvas.width, gl.canvas.height );
		currentViewport.set( 0, 0, gl.canvas.width, gl.canvas.height );

		colorBuffer.reset();
		depthBuffer.reset();
		stencilBuffer.reset();

	}

	return {

		buffers: {
			color: colorBuffer,
			depth: depthBuffer,
			stencil: stencilBuffer
		},

		enable: enable,
		disable: disable,

		bindFramebuffer: bindFramebuffer,
		drawBuffers: drawBuffers,

		useProgram: useProgram,

		setBlending: setBlending,
		setMaterial: setMaterial,

		setFlipSided: setFlipSided,
		setCullFace: setCullFace,

		setLineWidth: setLineWidth,
		setPolygonOffset: setPolygonOffset,

		setScissorTest: setScissorTest,

		activeTexture: activeTexture,
		bindTexture: bindTexture,
		unbindTexture: unbindTexture,
		compressedTexImage2D: compressedTexImage2D,
		compressedTexImage3D: compressedTexImage3D,
		texImage2D: texImage2D,
		texImage3D: texImage3D,

		updateUBOMapping: updateUBOMapping,
		uniformBlockBinding: uniformBlockBinding,

		texStorage2D: texStorage2D,
		texStorage3D: texStorage3D,
		texSubImage2D: texSubImage2D,
		texSubImage3D: texSubImage3D,
		compressedTexSubImage2D: compressedTexSubImage2D,
		compressedTexSubImage3D: compressedTexSubImage3D,

		scissor: scissor,
		viewport: viewport,

		reset: reset

	};

}



/**
 * Given the width, height, format, and type of a texture. Determines how many
 * bytes must be used to represent the texture.
 */
function getByteLength( width, height, format, type ) {

	const typeByteLength = getTextureTypeByteLength( type );

	switch ( format ) {

		// https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
		case AlphaFormat:
			return width * height;
		case LuminanceFormat:
			return width * height;
		case LuminanceAlphaFormat:
			return width * height * 2;
		case RedFormat:
			return ( ( width * height ) / typeByteLength.components ) * typeByteLength.byteLength;
		case RedIntegerFormat:
			return ( ( width * height ) / typeByteLength.components ) * typeByteLength.byteLength;
		case RGFormat:
			return ( ( width * height * 2 ) / typeByteLength.components ) * typeByteLength.byteLength;
		case RGIntegerFormat:
			return ( ( width * height * 2 ) / typeByteLength.components ) * typeByteLength.byteLength;
		case RGBFormat:
			return ( ( width * height * 3 ) / typeByteLength.components ) * typeByteLength.byteLength;
		case RGBAFormat:
			return ( ( width * height * 4 ) / typeByteLength.components ) * typeByteLength.byteLength;
		case RGBAIntegerFormat:
			return ( ( width * height * 4 ) / typeByteLength.components ) * typeByteLength.byteLength;

		// https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
		case RGB_S3TC_DXT1_Format:
		case RGBA_S3TC_DXT1_Format:
			return Math.floor( ( width + 3 ) / 4 ) * Math.floor( ( height + 3 ) / 4 ) * 8;
		case RGBA_S3TC_DXT3_Format:
		case RGBA_S3TC_DXT5_Format:
			return Math.floor( ( width + 3 ) / 4 ) * Math.floor( ( height + 3 ) / 4 ) * 16;

		// https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
		case RGB_PVRTC_2BPPV1_Format:
		case RGBA_PVRTC_2BPPV1_Format:
			return ( Math.max( width, 16 ) * Math.max( height, 8 ) ) / 4;
		case RGB_PVRTC_4BPPV1_Format:
		case RGBA_PVRTC_4BPPV1_Format:
			return ( Math.max( width, 8 ) * Math.max( height, 8 ) ) / 2;

		// https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
		case RGB_ETC1_Format:
		case RGB_ETC2_Format:
			return Math.floor( ( width + 3 ) / 4 ) * Math.floor( ( height + 3 ) / 4 ) * 8;
		case RGBA_ETC2_EAC_Format:
			return Math.floor( ( width + 3 ) / 4 ) * Math.floor( ( height + 3 ) / 4 ) * 16;

		// https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
		case RGBA_ASTC_4x4_Format:
			return Math.floor( ( width + 3 ) / 4 ) * Math.floor( ( height + 3 ) / 4 ) * 16;
		case RGBA_ASTC_5x4_Format:
			return Math.floor( ( width + 4 ) / 5 ) * Math.floor( ( height + 3 ) / 4 ) * 16;
		case RGBA_ASTC_5x5_Format:
			return Math.floor( ( width + 4 ) / 5 ) * Math.floor( ( height + 4 ) / 5 ) * 16;
		case RGBA_ASTC_6x5_Format:
			return Math.floor( ( width + 5 ) / 6 ) * Math.floor( ( height + 4 ) / 5 ) * 16;
		case RGBA_ASTC_6x6_Format:
			return Math.floor( ( width + 5 ) / 6 ) * Math.floor( ( height + 5 ) / 6 ) * 16;
		case RGBA_ASTC_8x5_Format:
			return Math.floor( ( width + 7 ) / 8 ) * Math.floor( ( height + 4 ) / 5 ) * 16;
		case RGBA_ASTC_8x6_Format:
			return Math.floor( ( width + 7 ) / 8 ) * Math.floor( ( height + 5 ) / 6 ) * 16;
		case RGBA_ASTC_8x8_Format:
			return Math.floor( ( width + 7 ) / 8 ) * Math.floor( ( height + 7 ) / 8 ) * 16;
		case RGBA_ASTC_10x5_Format:
			return Math.floor( ( width + 9 ) / 10 ) * Math.floor( ( height + 4 ) / 5 ) * 16;
		case RGBA_ASTC_10x6_Format:
			return Math.floor( ( width + 9 ) / 10 ) * Math.floor( ( height + 5 ) / 6 ) * 16;
		case RGBA_ASTC_10x8_Format:
			return Math.floor( ( width + 9 ) / 10 ) * Math.floor( ( height + 7 ) / 8 ) * 16;
		case RGBA_ASTC_10x10_Format:
			return Math.floor( ( width + 9 ) / 10 ) * Math.floor( ( height + 9 ) / 10 ) * 16;
		case RGBA_ASTC_12x10_Format:
			return Math.floor( ( width + 11 ) / 12 ) * Math.floor( ( height + 9 ) / 10 ) * 16;
		case RGBA_ASTC_12x12_Format:
			return Math.floor( ( width + 11 ) / 12 ) * Math.floor( ( height + 11 ) / 12 ) * 16;

		// https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
		case RGBA_BPTC_Format:
		case RGB_BPTC_SIGNED_Format:
		case RGB_BPTC_UNSIGNED_Format:
			return Math.ceil( width / 4 ) * Math.ceil( height / 4 ) * 16;

		// https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
		case RED_RGTC1_Format:
		case SIGNED_RED_RGTC1_Format:
			return Math.ceil( width / 4 ) * Math.ceil( height / 4 ) * 8;
		case RED_GREEN_RGTC2_Format:
		case SIGNED_RED_GREEN_RGTC2_Format:
			return Math.ceil( width / 4 ) * Math.ceil( height / 4 ) * 16;

	}

	throw new Error(
		`Unable to determine texture byte length for ${format} format.`,
	);

}

function getTextureTypeByteLength( type ) {

	switch ( type ) {

		case UnsignedByteType:
		case ByteType:
			return { byteLength: 1, components: 1 };
		case UnsignedShortType:
		case ShortType:
		case HalfFloatType:
			return { byteLength: 2, components: 1 };
		case UnsignedShort4444Type:
		case UnsignedShort5551Type:
			return { byteLength: 2, components: 4 };
		case UnsignedIntType:
		case IntType:
		case FloatType:
			return { byteLength: 4, components: 1 };
		case UnsignedInt5999Type:
			return { byteLength: 4, components: 3 };

	}

	throw new Error( `Unknown texture type ${type}.` );

}

function WebGLTextures( _gl, extensions, state, properties, capabilities, utils, info ) {

	const multisampledRTTExt = extensions.has( 'WEBGL_multisampled_render_to_texture' ) ? extensions.get( 'WEBGL_multisampled_render_to_texture' ) : null;
	const supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test( navigator.userAgent );

	const _imageDimensions = new Vector2();
	const _videoTextures = new WeakMap();
	let _canvas;

	const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source

	// cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
	// also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
	// Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).

	let useOffscreenCanvas = false;

	try {

		useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined'
			// eslint-disable-next-line compat/compat
			&& ( new OffscreenCanvas( 1, 1 ).getContext( '2d' ) ) !== null;

	} catch ( err ) {

		// Ignore any errors

	}

	function createCanvas( width, height ) {

		// Use OffscreenCanvas when available. Specially needed in web workers

		return useOffscreenCanvas ?
			// eslint-disable-next-line compat/compat
			new OffscreenCanvas( width, height ) : createElementNS( 'canvas' );

	}

	function resizeImage( image, needsNewCanvas, maxSize ) {

		let scale = 1;

		const dimensions = getDimensions( image );

		// handle case if texture exceeds max size

		if ( dimensions.width > maxSize || dimensions.height > maxSize ) {

			scale = maxSize / Math.max( dimensions.width, dimensions.height );

		}

		// only perform resize if necessary

		if ( scale < 1 ) {

			// only perform resize for certain image types

			if ( ( typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement ) ||
				( typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement ) ||
				( typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap ) ||
				( typeof VideoFrame !== 'undefined' && image instanceof VideoFrame ) ) {

				const width = Math.floor( scale * dimensions.width );
				const height = Math.floor( scale * dimensions.height );

				if ( _canvas === undefined ) _canvas = createCanvas( width, height );

				// cube textures can't reuse the same canvas

				const canvas = needsNewCanvas ? createCanvas( width, height ) : _canvas;

				canvas.width = width;
				canvas.height = height;

				const context = canvas.getContext( '2d' );
				context.drawImage( image, 0, 0, width, height );

				console.warn( 'THREE.WebGLRenderer: Texture has been resized from (' + dimensions.width + 'x' + dimensions.height + ') to (' + width + 'x' + height + ').' );

				return canvas;

			} else {

				if ( 'data' in image ) {

					console.warn( 'THREE.WebGLRenderer: Image in DataTexture is too big (' + dimensions.width + 'x' + dimensions.height + ').' );

				}

				return image;

			}

		}

		return image;

	}

	function textureNeedsGenerateMipmaps( texture ) {

		return texture.generateMipmaps && texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter;

	}

	function generateMipmap( target ) {

		_gl.generateMipmap( target );

	}

	function getInternalFormat( internalFormatName, glFormat, glType, colorSpace, forceLinearTransfer = false ) {

		if ( internalFormatName !== null ) {

			if ( _gl[ internalFormatName ] !== undefined ) return _gl[ internalFormatName ];

			console.warn( 'THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'' );

		}

		let internalFormat = glFormat;

		if ( glFormat === _gl.RED ) {

			if ( glType === _gl.FLOAT ) internalFormat = _gl.R32F;
			if ( glType === _gl.HALF_FLOAT ) internalFormat = _gl.R16F;
			if ( glType === _gl.UNSIGNED_BYTE ) internalFormat = _gl.R8;

		}

		if ( glFormat === _gl.RED_INTEGER ) {

			if ( glType === _gl.UNSIGNED_BYTE ) internalFormat = _gl.R8UI;
			if ( glType === _gl.UNSIGNED_SHORT ) internalFormat = _gl.R16UI;
			if ( glType === _gl.UNSIGNED_INT ) internalFormat = _gl.R32UI;
			if ( glType === _gl.BYTE ) internalFormat = _gl.R8I;
			if ( glType === _gl.SHORT ) internalFormat = _gl.R16I;
			if ( glType === _gl.INT ) internalFormat = _gl.R32I;

		}

		if ( glFormat === _gl.RG ) {

			if ( glType === _gl.FLOAT ) internalFormat = _gl.RG32F;
			if ( glType === _gl.HALF_FLOAT ) internalFormat = _gl.RG16F;
			if ( glType === _gl.UNSIGNED_BYTE ) internalFormat = _gl.RG8;

		}

		if ( glFormat === _gl.RG_INTEGER ) {

			if ( glType === _gl.UNSIGNED_BYTE ) internalFormat = _gl.RG8UI;
			if ( glType === _gl.UNSIGNED_SHORT ) internalFormat = _gl.RG16UI;
			if ( glType === _gl.UNSIGNED_INT ) internalFormat = _gl.RG32UI;
			if ( glType === _gl.BYTE ) internalFormat = _gl.RG8I;
			if ( glType === _gl.SHORT ) internalFormat = _gl.RG16I;
			if ( glType === _gl.INT ) internalFormat = _gl.RG32I;

		}

		if ( glFormat === _gl.RGB ) {

			if ( glType === _gl.UNSIGNED_INT_5_9_9_9_REV ) internalFormat = _gl.RGB9_E5;

		}

		if ( glFormat === _gl.RGBA ) {

			const transfer = forceLinearTransfer ? LinearTransfer : ColorManagement.getTransfer( colorSpace );

			if ( glType === _gl.FLOAT ) internalFormat = _gl.RGBA32F;
			if ( glType === _gl.HALF_FLOAT ) internalFormat = _gl.RGBA16F;
			if ( glType === _gl.UNSIGNED_BYTE ) internalFormat = ( transfer === SRGBTransfer ) ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
			if ( glType === _gl.UNSIGNED_SHORT_4_4_4_4 ) internalFormat = _gl.RGBA4;
			if ( glType === _gl.UNSIGNED_SHORT_5_5_5_1 ) internalFormat = _gl.RGB5_A1;

		}

		if ( internalFormat === _gl.R16F || internalFormat === _gl.R32F ||
			internalFormat === _gl.RG16F || internalFormat === _gl.RG32F ||
			internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F ) {

			extensions.get( 'EXT_color_buffer_float' );

		}

		return internalFormat;

	}

	function getInternalDepthFormat( useStencil, depthType ) {

		let glInternalFormat;
		if ( useStencil ) {

			if ( depthType === null || depthType === UnsignedIntType || depthType === UnsignedInt248Type ) {

				glInternalFormat = _gl.DEPTH24_STENCIL8;

			} else if ( depthType === FloatType ) {

				glInternalFormat = _gl.DEPTH32F_STENCIL8;

			} else if ( depthType === UnsignedShortType ) {

				glInternalFormat = _gl.DEPTH24_STENCIL8;
				console.warn( 'DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.' );

			}

		} else {

			if ( depthType === null || depthType === UnsignedIntType || depthType === UnsignedInt248Type ) {

				glInternalFormat = _gl.DEPTH_COMPONENT24;

			} else if ( depthType === FloatType ) {

				glInternalFormat = _gl.DEPTH_COMPONENT32F;

			} else if ( depthType === UnsignedShortType ) {

				glInternalFormat = _gl.DEPTH_COMPONENT16;

			}

		}

		return glInternalFormat;

	}

	function getMipLevels( texture, image ) {

		if ( textureNeedsGenerateMipmaps( texture ) === true || ( texture.isFramebufferTexture && texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter ) ) {

			return Math.log2( Math.max( image.width, image.height ) ) + 1;

		} else if ( texture.mipmaps !== undefined && texture.mipmaps.length > 0 ) {

			// user-defined mipmaps

			return texture.mipmaps.length;

		} else if ( texture.isCompressedTexture && Array.isArray( texture.image ) ) {

			return image.mipmaps.length;

		} else {

			// texture without mipmaps (only base level)

			return 1;

		}

	}

	//

	function onTextureDispose( event ) {

		const texture = event.target;

		texture.removeEventListener( 'dispose', onTextureDispose );

		deallocateTexture( texture );

		if ( texture.isVideoTexture ) {

			_videoTextures.delete( texture );

		}

	}

	function onRenderTargetDispose( event ) {

		const renderTarget = event.target;

		renderTarget.removeEventListener( 'dispose', onRenderTargetDispose );

		deallocateRenderTarget( renderTarget );

	}

	//

	function deallocateTexture( texture ) {

		const textureProperties = properties.get( texture );

		if ( textureProperties.__webglInit === undefined ) return;

		// check if it's necessary to remove the WebGLTexture object

		const source = texture.source;
		const webglTextures = _sources.get( source );

		if ( webglTextures ) {

			const webglTexture = webglTextures[ textureProperties.__cacheKey ];
			webglTexture.usedTimes --;

			// the WebGLTexture object is not used anymore, remove it

			if ( webglTexture.usedTimes === 0 ) {

				deleteTexture( texture );

			}

			// remove the weak map entry if no WebGLTexture uses the source anymore

			if ( Object.keys( webglTextures ).length === 0 ) {

				_sources.delete( source );

			}

		}

		properties.remove( texture );

	}

	function deleteTexture( texture ) {

		const textureProperties = properties.get( texture );
		_gl.deleteTexture( textureProperties.__webglTexture );

		const source = texture.source;
		const webglTextures = _sources.get( source );
		delete webglTextures[ textureProperties.__cacheKey ];

		info.memory.textures --;

	}

	function deallocateRenderTarget( renderTarget ) {

		const renderTargetProperties = properties.get( renderTarget );

		if ( renderTarget.depthTexture ) {

			renderTarget.depthTexture.dispose();

		}

		if ( renderTarget.isWebGLCubeRenderTarget ) {

			for ( let i = 0; i < 6; i ++ ) {

				if ( Array.isArray( renderTargetProperties.__webglFramebuffer[ i ] ) ) {

					for ( let level = 0; level < renderTargetProperties.__webglFramebuffer[ i ].length; level ++ ) _gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer[ i ][ level ] );

				} else {

					_gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer[ i ] );

				}

				if ( renderTargetProperties.__webglDepthbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthbuffer[ i ] );

			}

		} else {

			if ( Array.isArray( renderTargetProperties.__webglFramebuffer ) ) {

				for ( let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level ++ ) _gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer[ level ] );

			} else {

				_gl.deleteFramebuffer( renderTargetProperties.__webglFramebuffer );

			}

			if ( renderTargetProperties.__webglDepthbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthbuffer );
			if ( renderTargetProperties.__webglMultisampledFramebuffer ) _gl.deleteFramebuffer( renderTargetProperties.__webglMultisampledFramebuffer );

			if ( renderTargetProperties.__webglColorRenderbuffer ) {

				for ( let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i ++ ) {

					if ( renderTargetProperties.__webglColorRenderbuffer[ i ] ) _gl.deleteRenderbuffer( renderTargetProperties.__webglColorRenderbuffer[ i ] );

				}

			}

			if ( renderTargetProperties.__webglDepthRenderbuffer ) _gl.deleteRenderbuffer( renderTargetProperties.__webglDepthRenderbuffer );

		}

		const textures = renderTarget.textures;

		for ( let i = 0, il = textures.length; i < il; i ++ ) {

			const attachmentProperties = properties.get( textures[ i ] );

			if ( attachmentProperties.__webglTexture ) {

				_gl.deleteTexture( attachmentProperties.__webglTexture );

				info.memory.textures --;

			}

			properties.remove( textures[ i ] );

		}

		properties.remove( renderTarget );

	}

	//

	let textureUnits = 0;

	function resetTextureUnits() {

		textureUnits = 0;

	}

	function allocateTextureUnit() {

		const textureUnit = textureUnits;

		if ( textureUnit >= capabilities.maxTextures ) {

			console.warn( 'THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures );

		}

		textureUnits += 1;

		return textureUnit;

	}

	function getTextureCacheKey( texture ) {

		const array = [];

		array.push( texture.wrapS );
		array.push( texture.wrapT );
		array.push( texture.wrapR || 0 );
		array.push( texture.magFilter );
		array.push( texture.minFilter );
		array.push( texture.anisotropy );
		array.push( texture.internalFormat );
		array.push( texture.format );
		array.push( texture.type );
		array.push( texture.generateMipmaps );
		array.push( texture.premultiplyAlpha );
		array.push( texture.flipY );
		array.push( texture.unpackAlignment );
		array.push( texture.colorSpace );

		return array.join();

	}

	//

	function setTexture2D( texture, slot ) {

		const textureProperties = properties.get( texture );

		if ( texture.isVideoTexture ) updateVideoTexture( texture );

		if ( texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version ) {

			const image = texture.image;

			if ( image === null ) {

				console.warn( 'THREE.WebGLRenderer: Texture marked for update but no image data found.' );

			} else if ( image.complete === false ) {

				console.warn( 'THREE.WebGLRenderer: Texture marked for update but image is incomplete' );

			} else {

				uploadTexture( textureProperties, texture, slot );
				return;

			}

		}

		state.bindTexture( _gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot );

	}

	function setTexture2DArray( texture, slot ) {

		const textureProperties = properties.get( texture );

		if ( texture.version > 0 && textureProperties.__version !== texture.version ) {

			uploadTexture( textureProperties, texture, slot );
			return;

		}

		state.bindTexture( _gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot );

	}

	function setTexture3D( texture, slot ) {

		const textureProperties = properties.get( texture );

		if ( texture.version > 0 && textureProperties.__version !== texture.version ) {

			uploadTexture( textureProperties, texture, slot );
			return;

		}

		state.bindTexture( _gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot );

	}

	function setTextureCube( texture, slot ) {

		const textureProperties = properties.get( texture );

		if ( texture.version > 0 && textureProperties.__version !== texture.version ) {

			uploadCubeTexture( textureProperties, texture, slot );
			return;

		}

		state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot );

	}

	const wrappingToGL = {
		[ RepeatWrapping ]: _gl.REPEAT,
		[ ClampToEdgeWrapping ]: _gl.CLAMP_TO_EDGE,
		[ MirroredRepeatWrapping ]: _gl.MIRRORED_REPEAT
	};

	const filterToGL = {
		[ NearestFilter ]: _gl.NEAREST,
		[ NearestMipmapNearestFilter ]: _gl.NEAREST_MIPMAP_NEAREST,
		[ NearestMipmapLinearFilter ]: _gl.NEAREST_MIPMAP_LINEAR,

		[ LinearFilter ]: _gl.LINEAR,
		[ LinearMipmapNearestFilter ]: _gl.LINEAR_MIPMAP_NEAREST,
		[ LinearMipmapLinearFilter ]: _gl.LINEAR_MIPMAP_LINEAR
	};

	const compareToGL = {
		[ NeverCompare ]: _gl.NEVER,
		[ AlwaysCompare ]: _gl.ALWAYS,
		[ LessCompare ]: _gl.LESS,
		[ LessEqualCompare ]: _gl.LEQUAL,
		[ EqualCompare ]: _gl.EQUAL,
		[ GreaterEqualCompare ]: _gl.GEQUAL,
		[ GreaterCompare ]: _gl.GREATER,
		[ NotEqualCompare ]: _gl.NOTEQUAL
	};

	function setTextureParameters( textureType, texture ) {

		if ( texture.type === FloatType && extensions.has( 'OES_texture_float_linear' ) === false &&
			( texture.magFilter === LinearFilter || texture.magFilter === LinearMipmapNearestFilter || texture.magFilter === NearestMipmapLinearFilter || texture.magFilter === LinearMipmapLinearFilter ||
			texture.minFilter === LinearFilter || texture.minFilter === LinearMipmapNearestFilter || texture.minFilter === NearestMipmapLinearFilter || texture.minFilter === LinearMipmapLinearFilter ) ) {

			console.warn( 'THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.' );

		}

		_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[ texture.wrapS ] );
		_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[ texture.wrapT ] );

		if ( textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY ) {

			_gl.texParameteri( textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[ texture.wrapR ] );

		}

		_gl.texParameteri( textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[ texture.magFilter ] );
		_gl.texParameteri( textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[ texture.minFilter ] );

		if ( texture.compareFunction ) {

			_gl.texParameteri( textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE );
			_gl.texParameteri( textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[ texture.compareFunction ] );

		}

		if ( extensions.has( 'EXT_texture_filter_anisotropic' ) === true ) {

			if ( texture.magFilter === NearestFilter ) return;
			if ( texture.minFilter !== NearestMipmapLinearFilter && texture.minFilter !== LinearMipmapLinearFilter ) return;
			if ( texture.type === FloatType && extensions.has( 'OES_texture_float_linear' ) === false ) return; // verify extension

			if ( texture.anisotropy > 1 || properties.get( texture ).__currentAnisotropy ) {

				const extension = extensions.get( 'EXT_texture_filter_anisotropic' );
				_gl.texParameterf( textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min( texture.anisotropy, capabilities.getMaxAnisotropy() ) );
				properties.get( texture ).__currentAnisotropy = texture.anisotropy;

			}

		}

	}

	function initTexture( textureProperties, texture ) {

		let forceUpload = false;

		if ( textureProperties.__webglInit === undefined ) {

			textureProperties.__webglInit = true;

			texture.addEventListener( 'dispose', onTextureDispose );

		}

		// create Source <-> WebGLTextures mapping if necessary

		const source = texture.source;
		let webglTextures = _sources.get( source );

		if ( webglTextures === undefined ) {

			webglTextures = {};
			_sources.set( source, webglTextures );

		}

		// check if there is already a WebGLTexture object for the given texture parameters

		const textureCacheKey = getTextureCacheKey( texture );

		if ( textureCacheKey !== textureProperties.__cacheKey ) {

			// if not, create a new instance of WebGLTexture

			if ( webglTextures[ textureCacheKey ] === undefined ) {

				// create new entry

				webglTextures[ textureCacheKey ] = {
					texture: _gl.createTexture(),
					usedTimes: 0
				};

				info.memory.textures ++;

				// when a new instance of WebGLTexture was created, a texture upload is required
				// even if the image contents are identical

				forceUpload = true;

			}

			webglTextures[ textureCacheKey ].usedTimes ++;

			// every time the texture cache key changes, it's necessary to check if an instance of
			// WebGLTexture can be deleted in order to avoid a memory leak.

			const webglTexture = webglTextures[ textureProperties.__cacheKey ];

			if ( webglTexture !== undefined ) {

				webglTextures[ textureProperties.__cacheKey ].usedTimes --;

				if ( webglTexture.usedTimes === 0 ) {

					deleteTexture( texture );

				}

			}

			// store references to cache key and WebGLTexture object

			textureProperties.__cacheKey = textureCacheKey;
			textureProperties.__webglTexture = webglTextures[ textureCacheKey ].texture;

		}

		return forceUpload;

	}

	function uploadTexture( textureProperties, texture, slot ) {

		let textureType = _gl.TEXTURE_2D;

		if ( texture.isDataArrayTexture || texture.isCompressedArrayTexture ) textureType = _gl.TEXTURE_2D_ARRAY;
		if ( texture.isData3DTexture ) textureType = _gl.TEXTURE_3D;

		const forceUpload = initTexture( textureProperties, texture );
		const source = texture.source;

		state.bindTexture( textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot );

		const sourceProperties = properties.get( source );

		if ( source.version !== sourceProperties.__version || forceUpload === true ) {

			state.activeTexture( _gl.TEXTURE0 + slot );

			const workingPrimaries = ColorManagement.getPrimaries( ColorManagement.workingColorSpace );
			const texturePrimaries = texture.colorSpace === NoColorSpace ? null : ColorManagement.getPrimaries( texture.colorSpace );
			const unpackConversion = texture.colorSpace === NoColorSpace || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;

			_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, texture.flipY );
			_gl.pixelStorei( _gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha );
			_gl.pixelStorei( _gl.UNPACK_ALIGNMENT, texture.unpackAlignment );
			_gl.pixelStorei( _gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion );

			let image = resizeImage( texture.image, false, capabilities.maxTextureSize );
			image = verifyColorSpace( texture, image );

			const glFormat = utils.convert( texture.format, texture.colorSpace );

			const glType = utils.convert( texture.type );
			let glInternalFormat = getInternalFormat( texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture );

			setTextureParameters( textureType, texture );

			let mipmap;
			const mipmaps = texture.mipmaps;

			const useTexStorage = ( texture.isVideoTexture !== true );
			const allocateMemory = ( sourceProperties.__version === undefined ) || ( forceUpload === true );
			const dataReady = source.dataReady;
			const levels = getMipLevels( texture, image );

			if ( texture.isDepthTexture ) {

				glInternalFormat = getInternalDepthFormat( texture.format === DepthStencilFormat, texture.type );

				//

				if ( allocateMemory ) {

					if ( useTexStorage ) {

						state.texStorage2D( _gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height );

					} else {

						state.texImage2D( _gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null );

					}

				}

			} else if ( texture.isDataTexture ) {

				// use manually created mipmaps if available
				// if there are no manual mipmaps
				// set 0 level mipmap and then use GL to generate other mipmap levels

				if ( mipmaps.length > 0 ) {

					if ( useTexStorage && allocateMemory ) {

						state.texStorage2D( _gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[ 0 ].width, mipmaps[ 0 ].height );

					}

					for ( let i = 0, il = mipmaps.length; i < il; i ++ ) {

						mipmap = mipmaps[ i ];

						if ( useTexStorage ) {

							if ( dataReady ) {

								state.texSubImage2D( _gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data );

							}

						} else {

							state.texImage2D( _gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );

						}

					}

					texture.generateMipmaps = false;

				} else {

					if ( useTexStorage ) {

						if ( allocateMemory ) {

							state.texStorage2D( _gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height );

						}

						if ( dataReady ) {

							state.texSubImage2D( _gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data );

						}

					} else {

						state.texImage2D( _gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data );

					}

				}

			} else if ( texture.isCompressedTexture ) {

				if ( texture.isCompressedArrayTexture ) {

					if ( useTexStorage && allocateMemory ) {

						state.texStorage3D( _gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[ 0 ].width, mipmaps[ 0 ].height, image.depth );

					}

					for ( let i = 0, il = mipmaps.length; i < il; i ++ ) {

						mipmap = mipmaps[ i ];

						if ( texture.format !== RGBAFormat ) {

							if ( glFormat !== null ) {

								if ( useTexStorage ) {

									if ( dataReady ) {

										if ( texture.layerUpdates.size > 0 ) {

											const layerByteLength = getByteLength( mipmap.width, mipmap.height, texture.format, texture.type );

											for ( const layerIndex of texture.layerUpdates ) {

												const layerData = mipmap.data.subarray(
													layerIndex * layerByteLength / mipmap.data.BYTES_PER_ELEMENT,
													( layerIndex + 1 ) * layerByteLength / mipmap.data.BYTES_PER_ELEMENT
												);
												state.compressedTexSubImage3D( _gl.TEXTURE_2D_ARRAY, i, 0, 0, layerIndex, mipmap.width, mipmap.height, 1, glFormat, layerData, 0, 0 );

											}

											texture.clearLayerUpdates();

										} else {

											state.compressedTexSubImage3D( _gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data, 0, 0 );

										}

									}

								} else {

									state.compressedTexImage3D( _gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0 );

								}

							} else {

								console.warn( 'THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()' );

							}

						} else {

							if ( useTexStorage ) {

								if ( dataReady ) {

									state.texSubImage3D( _gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data );

								}

							} else {

								state.texImage3D( _gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data );

							}

						}

					}

				} else {

					if ( useTexStorage && allocateMemory ) {

						state.texStorage2D( _gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[ 0 ].width, mipmaps[ 0 ].height );

					}

					for ( let i = 0, il = mipmaps.length; i < il; i ++ ) {

						mipmap = mipmaps[ i ];

						if ( texture.format !== RGBAFormat ) {

							if ( glFormat !== null ) {

								if ( useTexStorage ) {

									if ( dataReady ) {

										state.compressedTexSubImage2D( _gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data );

									}

								} else {

									state.compressedTexImage2D( _gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data );

								}

							} else {

								console.warn( 'THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()' );

							}

						} else {

							if ( useTexStorage ) {

								if ( dataReady ) {

									state.texSubImage2D( _gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data );

								}

							} else {

								state.texImage2D( _gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );

							}

						}

					}

				}

			} else if ( texture.isDataArrayTexture ) {

				if ( useTexStorage ) {

					if ( allocateMemory ) {

						state.texStorage3D( _gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth );

					}

					if ( dataReady ) {

						if ( texture.layerUpdates.size > 0 ) {

							const layerByteLength = getByteLength( image.width, image.height, texture.format, texture.type );

							for ( const layerIndex of texture.layerUpdates ) {

								const layerData = image.data.subarray(
									layerIndex * layerByteLength / image.data.BYTES_PER_ELEMENT,
									( layerIndex + 1 ) * layerByteLength / image.data.BYTES_PER_ELEMENT
								);
								state.texSubImage3D( _gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex, image.width, image.height, 1, glFormat, glType, layerData );

							}

							texture.clearLayerUpdates();

						} else {

							state.texSubImage3D( _gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data );

						}

					}

				} else {

					state.texImage3D( _gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data );

				}

			} else if ( texture.isData3DTexture ) {

				if ( useTexStorage ) {

					if ( allocateMemory ) {

						state.texStorage3D( _gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth );

					}

					if ( dataReady ) {

						state.texSubImage3D( _gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data );

					}

				} else {

					state.texImage3D( _gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data );

				}

			} else if ( texture.isFramebufferTexture ) {

				if ( allocateMemory ) {

					if ( useTexStorage ) {

						state.texStorage2D( _gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height );

					} else {

						let width = image.width, height = image.height;

						for ( let i = 0; i < levels; i ++ ) {

							state.texImage2D( _gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null );

							width >>= 1;
							height >>= 1;

						}

					}

				}

			} else {

				// regular Texture (image, video, canvas)

				// use manually created mipmaps if available
				// if there are no manual mipmaps
				// set 0 level mipmap and then use GL to generate other mipmap levels

				if ( mipmaps.length > 0 ) {

					if ( useTexStorage && allocateMemory ) {

						const dimensions = getDimensions( mipmaps[ 0 ] );

						state.texStorage2D( _gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height );

					}

					for ( let i = 0, il = mipmaps.length; i < il; i ++ ) {

						mipmap = mipmaps[ i ];

						if ( useTexStorage ) {

							if ( dataReady ) {

								state.texSubImage2D( _gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap );

							}

						} else {

							state.texImage2D( _gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap );

						}

					}

					texture.generateMipmaps = false;

				} else {

					if ( useTexStorage ) {

						if ( allocateMemory ) {

							const dimensions = getDimensions( image );

							state.texStorage2D( _gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height );

						}

						if ( dataReady ) {

							state.texSubImage2D( _gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image );

						}

					} else {

						state.texImage2D( _gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image );

					}

				}

			}

			if ( textureNeedsGenerateMipmaps( texture ) ) {

				generateMipmap( textureType );

			}

			sourceProperties.__version = source.version;

			if ( texture.onUpdate ) texture.onUpdate( texture );

		}

		textureProperties.__version = texture.version;

	}

	function uploadCubeTexture( textureProperties, texture, slot ) {

		if ( texture.image.length !== 6 ) return;

		const forceUpload = initTexture( textureProperties, texture );
		const source = texture.source;

		state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot );

		const sourceProperties = properties.get( source );

		if ( source.version !== sourceProperties.__version || forceUpload === true ) {

			state.activeTexture( _gl.TEXTURE0 + slot );

			const workingPrimaries = ColorManagement.getPrimaries( ColorManagement.workingColorSpace );
			const texturePrimaries = texture.colorSpace === NoColorSpace ? null : ColorManagement.getPrimaries( texture.colorSpace );
			const unpackConversion = texture.colorSpace === NoColorSpace || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;

			_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, texture.flipY );
			_gl.pixelStorei( _gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha );
			_gl.pixelStorei( _gl.UNPACK_ALIGNMENT, texture.unpackAlignment );
			_gl.pixelStorei( _gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion );

			const isCompressed = ( texture.isCompressedTexture || texture.image[ 0 ].isCompressedTexture );
			const isDataTexture = ( texture.image[ 0 ] && texture.image[ 0 ].isDataTexture );

			const cubeImage = [];

			for ( let i = 0; i < 6; i ++ ) {

				if ( ! isCompressed && ! isDataTexture ) {

					cubeImage[ i ] = resizeImage( texture.image[ i ], true, capabilities.maxCubemapSize );

				} else {

					cubeImage[ i ] = isDataTexture ? texture.image[ i ].image : texture.image[ i ];

				}

				cubeImage[ i ] = verifyColorSpace( texture, cubeImage[ i ] );

			}

			const image = cubeImage[ 0 ],
				glFormat = utils.convert( texture.format, texture.colorSpace ),
				glType = utils.convert( texture.type ),
				glInternalFormat = getInternalFormat( texture.internalFormat, glFormat, glType, texture.colorSpace );

			const useTexStorage = ( texture.isVideoTexture !== true );
			const allocateMemory = ( sourceProperties.__version === undefined ) || ( forceUpload === true );
			const dataReady = source.dataReady;
			let levels = getMipLevels( texture, image );

			setTextureParameters( _gl.TEXTURE_CUBE_MAP, texture );

			let mipmaps;

			if ( isCompressed ) {

				if ( useTexStorage && allocateMemory ) {

					state.texStorage2D( _gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height );

				}

				for ( let i = 0; i < 6; i ++ ) {

					mipmaps = cubeImage[ i ].mipmaps;

					for ( let j = 0; j < mipmaps.length; j ++ ) {

						const mipmap = mipmaps[ j ];

						if ( texture.format !== RGBAFormat ) {

							if ( glFormat !== null ) {

								if ( useTexStorage ) {

									if ( dataReady ) {

										state.compressedTexSubImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data );

									}

								} else {

									state.compressedTexImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data );

								}

							} else {

								console.warn( 'THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()' );

							}

						} else {

							if ( useTexStorage ) {

								if ( dataReady ) {

									state.texSubImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data );

								}

							} else {

								state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data );

							}

						}

					}

				}

			} else {

				mipmaps = texture.mipmaps;

				if ( useTexStorage && allocateMemory ) {

					// TODO: Uniformly handle mipmap definitions
					// Normal textures and compressed cube textures define base level + mips with their mipmap array
					// Uncompressed cube textures use their mipmap array only for mips (no base level)

					if ( mipmaps.length > 0 ) levels ++;

					const dimensions = getDimensions( cubeImage[ 0 ] );

					state.texStorage2D( _gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height );

				}

				for ( let i = 0; i < 6; i ++ ) {

					if ( isDataTexture ) {

						if ( useTexStorage ) {

							if ( dataReady ) {

								state.texSubImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[ i ].width, cubeImage[ i ].height, glFormat, glType, cubeImage[ i ].data );

							}

						} else {

							state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[ i ].width, cubeImage[ i ].height, 0, glFormat, glType, cubeImage[ i ].data );

						}

						for ( let j = 0; j < mipmaps.length; j ++ ) {

							const mipmap = mipmaps[ j ];
							const mipmapImage = mipmap.image[ i ].image;

							if ( useTexStorage ) {

								if ( dataReady ) {

									state.texSubImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data );

								}

							} else {

								state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data );

							}

						}

					} else {

						if ( useTexStorage ) {

							if ( dataReady ) {

								state.texSubImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[ i ] );

							}

						} else {

							state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[ i ] );

						}

						for ( let j = 0; j < mipmaps.length; j ++ ) {

							const mipmap = mipmaps[ j ];

							if ( useTexStorage ) {

								if ( dataReady ) {

									state.texSubImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[ i ] );

								}

							} else {

								state.texImage2D( _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[ i ] );

							}

						}

					}

				}

			}

			if ( textureNeedsGenerateMipmaps( texture ) ) {

				// We assume images for cube map have the same size.
				generateMipmap( _gl.TEXTURE_CUBE_MAP );

			}

			sourceProperties.__version = source.version;

			if ( texture.onUpdate ) texture.onUpdate( texture );

		}

		textureProperties.__version = texture.version;

	}

	// Render targets

	// Setup storage for target texture and bind it to correct framebuffer
	function setupFrameBufferTexture( framebuffer, renderTarget, texture, attachment, textureTarget, level ) {

		const glFormat = utils.convert( texture.format, texture.colorSpace );
		const glType = utils.convert( texture.type );
		const glInternalFormat = getInternalFormat( texture.internalFormat, glFormat, glType, texture.colorSpace );
		const renderTargetProperties = properties.get( renderTarget );

		if ( ! renderTargetProperties.__hasExternalTextures ) {

			const width = Math.max( 1, renderTarget.width >> level );
			const height = Math.max( 1, renderTarget.height >> level );

			if ( textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY ) {

				state.texImage3D( textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null );

			} else {

				state.texImage2D( textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null );

			}

		}

		state.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

		if ( useMultisampledRTT( renderTarget ) ) {

			multisampledRTTExt.framebufferTexture2DMultisampleEXT( _gl.FRAMEBUFFER, attachment, textureTarget, properties.get( texture ).__webglTexture, 0, getRenderTargetSamples( renderTarget ) );

		} else if ( textureTarget === _gl.TEXTURE_2D || ( textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z ) ) { // see #24753

			_gl.framebufferTexture2D( _gl.FRAMEBUFFER, attachment, textureTarget, properties.get( texture ).__webglTexture, level );

		}

		state.bindFramebuffer( _gl.FRAMEBUFFER, null );

	}

	// Setup storage for internal depth/stencil buffers and bind to correct framebuffer
	function setupRenderBufferStorage( renderbuffer, renderTarget, isMultisample ) {

		_gl.bindRenderbuffer( _gl.RENDERBUFFER, renderbuffer );

		if ( renderTarget.depthBuffer ) {

			// retrieve the depth attachment types
			const depthTexture = renderTarget.depthTexture;
			const depthType = depthTexture && depthTexture.isDepthTexture ? depthTexture.type : null;
			const glInternalFormat = getInternalDepthFormat( renderTarget.stencilBuffer, depthType );
			const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;

			// set up the attachment
			const samples = getRenderTargetSamples( renderTarget );
			const isUseMultisampledRTT = useMultisampledRTT( renderTarget );
			if ( isUseMultisampledRTT ) {

				multisampledRTTExt.renderbufferStorageMultisampleEXT( _gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height );

			} else if ( isMultisample ) {

				_gl.renderbufferStorageMultisample( _gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height );

			} else {

				_gl.renderbufferStorage( _gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height );

			}

			_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer );

		} else {

			const textures = renderTarget.textures;

			for ( let i = 0; i < textures.length; i ++ ) {

				const texture = textures[ i ];

				const glFormat = utils.convert( texture.format, texture.colorSpace );
				const glType = utils.convert( texture.type );
				const glInternalFormat = getInternalFormat( texture.internalFormat, glFormat, glType, texture.colorSpace );
				const samples = getRenderTargetSamples( renderTarget );

				if ( isMultisample && useMultisampledRTT( renderTarget ) === false ) {

					_gl.renderbufferStorageMultisample( _gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height );

				} else if ( useMultisampledRTT( renderTarget ) ) {

					multisampledRTTExt.renderbufferStorageMultisampleEXT( _gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height );

				} else {

					_gl.renderbufferStorage( _gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height );

				}

			}

		}

		_gl.bindRenderbuffer( _gl.RENDERBUFFER, null );

	}

	// Setup resources for a Depth Texture for a FBO (needs an extension)
	function setupDepthTexture( framebuffer, renderTarget ) {

		const isCube = ( renderTarget && renderTarget.isWebGLCubeRenderTarget );
		if ( isCube ) throw new Error( 'Depth Texture with cube render targets is not supported' );

		state.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

		if ( ! ( renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture ) ) {

			throw new Error( 'renderTarget.depthTexture must be an instance of THREE.DepthTexture' );

		}

		// upload an empty depth texture with framebuffer size
		if ( ! properties.get( renderTarget.depthTexture ).__webglTexture ||
				renderTarget.depthTexture.image.width !== renderTarget.width ||
				renderTarget.depthTexture.image.height !== renderTarget.height ) {

			renderTarget.depthTexture.image.width = renderTarget.width;
			renderTarget.depthTexture.image.height = renderTarget.height;
			renderTarget.depthTexture.needsUpdate = true;

		}

		setTexture2D( renderTarget.depthTexture, 0 );

		const webglDepthTexture = properties.get( renderTarget.depthTexture ).__webglTexture;
		const samples = getRenderTargetSamples( renderTarget );

		if ( renderTarget.depthTexture.format === DepthFormat ) {

			if ( useMultisampledRTT( renderTarget ) ) {

				multisampledRTTExt.framebufferTexture2DMultisampleEXT( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples );

			} else {

				_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0 );

			}

		} else if ( renderTarget.depthTexture.format === DepthStencilFormat ) {

			if ( useMultisampledRTT( renderTarget ) ) {

				multisampledRTTExt.framebufferTexture2DMultisampleEXT( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples );

			} else {

				_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0 );

			}

		} else {

			throw new Error( 'Unknown depthTexture format' );

		}

	}

	// Setup GL resources for a non-texture depth buffer
	function setupDepthRenderbuffer( renderTarget ) {

		const renderTargetProperties = properties.get( renderTarget );
		const isCube = ( renderTarget.isWebGLCubeRenderTarget === true );

		if ( renderTarget.depthTexture && ! renderTargetProperties.__autoAllocateDepthBuffer ) {

			if ( isCube ) throw new Error( 'target.depthTexture not supported in Cube render targets' );

			setupDepthTexture( renderTargetProperties.__webglFramebuffer, renderTarget );

		} else {

			if ( isCube ) {

				renderTargetProperties.__webglDepthbuffer = [];

				for ( let i = 0; i < 6; i ++ ) {

					state.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[ i ] );
					renderTargetProperties.__webglDepthbuffer[ i ] = _gl.createRenderbuffer();
					setupRenderBufferStorage( renderTargetProperties.__webglDepthbuffer[ i ], renderTarget, false );

				}

			} else {

				state.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer );
				renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
				setupRenderBufferStorage( renderTargetProperties.__webglDepthbuffer, renderTarget, false );

			}

		}

		state.bindFramebuffer( _gl.FRAMEBUFFER, null );

	}

	// rebind framebuffer with external textures
	function rebindTextures( renderTarget, colorTexture, depthTexture ) {

		const renderTargetProperties = properties.get( renderTarget );

		if ( colorTexture !== undefined ) {

			setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0 );

		}

		if ( depthTexture !== undefined ) {

			setupDepthRenderbuffer( renderTarget );

		}

	}

	// Set up GL resources for the render target
	function setupRenderTarget( renderTarget ) {

		const texture = renderTarget.texture;

		const renderTargetProperties = properties.get( renderTarget );
		const textureProperties = properties.get( texture );

		renderTarget.addEventListener( 'dispose', onRenderTargetDispose );

		const textures = renderTarget.textures;

		const isCube = ( renderTarget.isWebGLCubeRenderTarget === true );
		const isMultipleRenderTargets = ( textures.length > 1 );

		if ( ! isMultipleRenderTargets ) {

			if ( textureProperties.__webglTexture === undefined ) {

				textureProperties.__webglTexture = _gl.createTexture();

			}

			textureProperties.__version = texture.version;
			info.memory.textures ++;

		}

		// Setup framebuffer

		if ( isCube ) {

			renderTargetProperties.__webglFramebuffer = [];

			for ( let i = 0; i < 6; i ++ ) {

				if ( texture.mipmaps && texture.mipmaps.length > 0 ) {

					renderTargetProperties.__webglFramebuffer[ i ] = [];

					for ( let level = 0; level < texture.mipmaps.length; level ++ ) {

						renderTargetProperties.__webglFramebuffer[ i ][ level ] = _gl.createFramebuffer();

					}

				} else {

					renderTargetProperties.__webglFramebuffer[ i ] = _gl.createFramebuffer();

				}

			}

		} else {

			if ( texture.mipmaps && texture.mipmaps.length > 0 ) {

				renderTargetProperties.__webglFramebuffer = [];

				for ( let level = 0; level < texture.mipmaps.length; level ++ ) {

					renderTargetProperties.__webglFramebuffer[ level ] = _gl.createFramebuffer();

				}

			} else {

				renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();

			}

			if ( isMultipleRenderTargets ) {

				for ( let i = 0, il = textures.length; i < il; i ++ ) {

					const attachmentProperties = properties.get( textures[ i ] );

					if ( attachmentProperties.__webglTexture === undefined ) {

						attachmentProperties.__webglTexture = _gl.createTexture();

						info.memory.textures ++;

					}

				}

			}

			if ( ( renderTarget.samples > 0 ) && useMultisampledRTT( renderTarget ) === false ) {

				renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
				renderTargetProperties.__webglColorRenderbuffer = [];

				state.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer );

				for ( let i = 0; i < textures.length; i ++ ) {

					const texture = textures[ i ];
					renderTargetProperties.__webglColorRenderbuffer[ i ] = _gl.createRenderbuffer();

					_gl.bindRenderbuffer( _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[ i ] );

					const glFormat = utils.convert( texture.format, texture.colorSpace );
					const glType = utils.convert( texture.type );
					const glInternalFormat = getInternalFormat( texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true );
					const samples = getRenderTargetSamples( renderTarget );
					_gl.renderbufferStorageMultisample( _gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height );

					_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[ i ] );

				}

				_gl.bindRenderbuffer( _gl.RENDERBUFFER, null );

				if ( renderTarget.depthBuffer ) {

					renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
					setupRenderBufferStorage( renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true );

				}

				state.bindFramebuffer( _gl.FRAMEBUFFER, null );

			}

		}

		// Setup color buffer

		if ( isCube ) {

			state.bindTexture( _gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture );
			setTextureParameters( _gl.TEXTURE_CUBE_MAP, texture );

			for ( let i = 0; i < 6; i ++ ) {

				if ( texture.mipmaps && texture.mipmaps.length > 0 ) {

					for ( let level = 0; level < texture.mipmaps.length; level ++ ) {

						setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer[ i ][ level ], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level );

					}

				} else {

					setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer[ i ], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0 );

				}

			}

			if ( textureNeedsGenerateMipmaps( texture ) ) {

				generateMipmap( _gl.TEXTURE_CUBE_MAP );

			}

			state.unbindTexture();

		} else if ( isMultipleRenderTargets ) {

			for ( let i = 0, il = textures.length; i < il; i ++ ) {

				const attachment = textures[ i ];
				const attachmentProperties = properties.get( attachment );

				state.bindTexture( _gl.TEXTURE_2D, attachmentProperties.__webglTexture );
				setTextureParameters( _gl.TEXTURE_2D, attachment );
				setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, 0 );

				if ( textureNeedsGenerateMipmaps( attachment ) ) {

					generateMipmap( _gl.TEXTURE_2D );

				}

			}

			state.unbindTexture();

		} else {

			let glTextureType = _gl.TEXTURE_2D;

			if ( renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget ) {

				glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;

			}

			state.bindTexture( glTextureType, textureProperties.__webglTexture );
			setTextureParameters( glTextureType, texture );

			if ( texture.mipmaps && texture.mipmaps.length > 0 ) {

				for ( let level = 0; level < texture.mipmaps.length; level ++ ) {

					setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer[ level ], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level );

				}

			} else {

				setupFrameBufferTexture( renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0 );

			}

			if ( textureNeedsGenerateMipmaps( texture ) ) {

				generateMipmap( glTextureType );

			}

			state.unbindTexture();

		}

		// Setup depth and stencil buffers

		if ( renderTarget.depthBuffer ) {

			setupDepthRenderbuffer( renderTarget );

		}

	}

	function updateRenderTargetMipmap( renderTarget ) {

		const textures = renderTarget.textures;

		for ( let i = 0, il = textures.length; i < il; i ++ ) {

			const texture = textures[ i ];

			if ( textureNeedsGenerateMipmaps( texture ) ) {

				const target = renderTarget.isWebGLCubeRenderTarget ? _gl.TEXTURE_CUBE_MAP : _gl.TEXTURE_2D;
				const webglTexture = properties.get( texture ).__webglTexture;

				state.bindTexture( target, webglTexture );
				generateMipmap( target );
				state.unbindTexture();

			}

		}

	}

	const invalidationArrayRead = [];
	const invalidationArrayDraw = [];

	function updateMultisampleRenderTarget( renderTarget ) {

		if ( renderTarget.samples > 0 ) {

			if ( useMultisampledRTT( renderTarget ) === false ) {

				const textures = renderTarget.textures;
				const width = renderTarget.width;
				const height = renderTarget.height;
				let mask = _gl.COLOR_BUFFER_BIT;
				const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
				const renderTargetProperties = properties.get( renderTarget );
				const isMultipleRenderTargets = ( textures.length > 1 );

				// If MRT we need to remove FBO attachments
				if ( isMultipleRenderTargets ) {

					for ( let i = 0; i < textures.length; i ++ ) {

						state.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer );
						_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null );

						state.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer );
						_gl.framebufferTexture2D( _gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0 );

					}

				}

				state.bindFramebuffer( _gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer );
				state.bindFramebuffer( _gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer );

				for ( let i = 0; i < textures.length; i ++ ) {

					if ( renderTarget.resolveDepthBuffer ) {

						if ( renderTarget.depthBuffer ) mask |= _gl.DEPTH_BUFFER_BIT;

						// resolving stencil is slow with a D3D backend. disable it for all transmission render targets (see #27799)

						if ( renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer ) mask |= _gl.STENCIL_BUFFER_BIT;

					}

					if ( isMultipleRenderTargets ) {

						_gl.framebufferRenderbuffer( _gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[ i ] );

						const webglTexture = properties.get( textures[ i ] ).__webglTexture;
						_gl.framebufferTexture2D( _gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0 );

					}

					_gl.blitFramebuffer( 0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST );

					if ( supportsInvalidateFramebuffer === true ) {

						invalidationArrayRead.length = 0;
						invalidationArrayDraw.length = 0;

						invalidationArrayRead.push( _gl.COLOR_ATTACHMENT0 + i );

						if ( renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false ) {

							invalidationArrayRead.push( depthStyle );
							invalidationArrayDraw.push( depthStyle );

							_gl.invalidateFramebuffer( _gl.DRAW_FRAMEBUFFER, invalidationArrayDraw );

						}

						_gl.invalidateFramebuffer( _gl.READ_FRAMEBUFFER, invalidationArrayRead );

					}

				}

				state.bindFramebuffer( _gl.READ_FRAMEBUFFER, null );
				state.bindFramebuffer( _gl.DRAW_FRAMEBUFFER, null );

				// If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
				if ( isMultipleRenderTargets ) {

					for ( let i = 0; i < textures.length; i ++ ) {

						state.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer );
						_gl.framebufferRenderbuffer( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[ i ] );

						const webglTexture = properties.get( textures[ i ] ).__webglTexture;

						state.bindFramebuffer( _gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer );
						_gl.framebufferTexture2D( _gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0 );

					}

				}

				state.bindFramebuffer( _gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer );

			} else {

				if ( renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false && supportsInvalidateFramebuffer ) {

					const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;

					_gl.invalidateFramebuffer( _gl.DRAW_FRAMEBUFFER, [ depthStyle ] );

				}

			}

		}

	}

	function getRenderTargetSamples( renderTarget ) {

		return Math.min( capabilities.maxSamples, renderTarget.samples );

	}

	function useMultisampledRTT( renderTarget ) {

		const renderTargetProperties = properties.get( renderTarget );

		return renderTarget.samples > 0 && extensions.has( 'WEBGL_multisampled_render_to_texture' ) === true && renderTargetProperties.__useRenderToTexture !== false;

	}

	function updateVideoTexture( texture ) {

		const frame = info.render.frame;

		// Check the last frame we updated the VideoTexture

		if ( _videoTextures.get( texture ) !== frame ) {

			_videoTextures.set( texture, frame );
			texture.update();

		}

	}

	function verifyColorSpace( texture, image ) {

		const colorSpace = texture.colorSpace;
		const format = texture.format;
		const type = texture.type;

		if ( texture.isCompressedTexture === true || texture.isVideoTexture === true ) return image;

		if ( colorSpace !== LinearSRGBColorSpace && colorSpace !== NoColorSpace ) {

			// sRGB

			if ( ColorManagement.getTransfer( colorSpace ) === SRGBTransfer ) {

				// in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format

				if ( format !== RGBAFormat || type !== UnsignedByteType ) {

					console.warn( 'THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.' );

				}

			} else {

				console.error( 'THREE.WebGLTextures: Unsupported texture color space:', colorSpace );

			}

		}

		return image;

	}

	function getDimensions( image ) {

		if ( typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement ) {

			// if intrinsic data are not available, fallback to width/height

			_imageDimensions.width = image.naturalWidth || image.width;
			_imageDimensions.height = image.naturalHeight || image.height;

		} else if ( typeof VideoFrame !== 'undefined' && image instanceof VideoFrame ) {

			_imageDimensions.width = image.displayWidth;
			_imageDimensions.height = image.displayHeight;

		} else {

			_imageDimensions.width = image.width;
			_imageDimensions.height = image.height;

		}

		return _imageDimensions;

	}

	//

	this.allocateTextureUnit = allocateTextureUnit;
	this.resetTextureUnits = resetTextureUnits;

	this.setTexture2D = setTexture2D;
	this.setTexture2DArray = setTexture2DArray;
	this.setTexture3D = setTexture3D;
	this.setTextureCube = setTextureCube;
	this.rebindTextures = rebindTextures;
	this.setupRenderTarget = setupRenderTarget;
	this.updateRenderTargetMipmap = updateRenderTargetMipmap;
	this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
	this.setupDepthRenderbuffer = setupDepthRenderbuffer;
	this.setupFrameBufferTexture = setupFrameBufferTexture;
	this.useMultisampledRTT = useMultisampledRTT;

}

function WebGLUtils( gl, extensions ) {

	function convert( p, colorSpace = NoColorSpace ) {

		let extension;

		const transfer = ColorManagement.getTransfer( colorSpace );

		if ( p === UnsignedByteType ) return gl.UNSIGNED_BYTE;
		if ( p === UnsignedShort4444Type ) return gl.UNSIGNED_SHORT_4_4_4_4;
		if ( p === UnsignedShort5551Type ) return gl.UNSIGNED_SHORT_5_5_5_1;
		if ( p === UnsignedInt5999Type ) return gl.UNSIGNED_INT_5_9_9_9_REV;

		if ( p === ByteType ) return gl.BYTE;
		if ( p === ShortType ) return gl.SHORT;
		if ( p === UnsignedShortType ) return gl.UNSIGNED_SHORT;
		if ( p === IntType ) return gl.INT;
		if ( p === UnsignedIntType ) return gl.UNSIGNED_INT;
		if ( p === FloatType ) return gl.FLOAT;
		if ( p === HalfFloatType ) return gl.HALF_FLOAT;

		if ( p === AlphaFormat ) return gl.ALPHA;
		if ( p === RGBFormat ) return gl.RGB;
		if ( p === RGBAFormat ) return gl.RGBA;
		if ( p === LuminanceFormat ) return gl.LUMINANCE;
		if ( p === LuminanceAlphaFormat ) return gl.LUMINANCE_ALPHA;
		if ( p === DepthFormat ) return gl.DEPTH_COMPONENT;
		if ( p === DepthStencilFormat ) return gl.DEPTH_STENCIL;

		// WebGL2 formats.

		if ( p === RedFormat ) return gl.RED;
		if ( p === RedIntegerFormat ) return gl.RED_INTEGER;
		if ( p === RGFormat ) return gl.RG;
		if ( p === RGIntegerFormat ) return gl.RG_INTEGER;
		if ( p === RGBAIntegerFormat ) return gl.RGBA_INTEGER;

		// S3TC

		if ( p === RGB_S3TC_DXT1_Format || p === RGBA_S3TC_DXT1_Format || p === RGBA_S3TC_DXT3_Format || p === RGBA_S3TC_DXT5_Format ) {

			if ( transfer === SRGBTransfer ) {

				extension = extensions.get( 'WEBGL_compressed_texture_s3tc_srgb' );

				if ( extension !== null ) {

					if ( p === RGB_S3TC_DXT1_Format ) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
					if ( p === RGBA_S3TC_DXT1_Format ) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
					if ( p === RGBA_S3TC_DXT3_Format ) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
					if ( p === RGBA_S3TC_DXT5_Format ) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;

				} else {

					return null;

				}

			} else {

				extension = extensions.get( 'WEBGL_compressed_texture_s3tc' );

				if ( extension !== null ) {

					if ( p === RGB_S3TC_DXT1_Format ) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
					if ( p === RGBA_S3TC_DXT1_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
					if ( p === RGBA_S3TC_DXT3_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
					if ( p === RGBA_S3TC_DXT5_Format ) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;

				} else {

					return null;

				}

			}

		}

		// PVRTC

		if ( p === RGB_PVRTC_4BPPV1_Format || p === RGB_PVRTC_2BPPV1_Format || p === RGBA_PVRTC_4BPPV1_Format || p === RGBA_PVRTC_2BPPV1_Format ) {

			extension = extensions.get( 'WEBGL_compressed_texture_pvrtc' );

			if ( extension !== null ) {

				if ( p === RGB_PVRTC_4BPPV1_Format ) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
				if ( p === RGB_PVRTC_2BPPV1_Format ) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
				if ( p === RGBA_PVRTC_4BPPV1_Format ) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
				if ( p === RGBA_PVRTC_2BPPV1_Format ) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;

			} else {

				return null;

			}

		}

		// ETC

		if ( p === RGB_ETC1_Format || p === RGB_ETC2_Format || p === RGBA_ETC2_EAC_Format ) {

			extension = extensions.get( 'WEBGL_compressed_texture_etc' );

			if ( extension !== null ) {

				if ( p === RGB_ETC1_Format || p === RGB_ETC2_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
				if ( p === RGBA_ETC2_EAC_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;

			} else {

				return null;

			}

		}

		// ASTC

		if ( p === RGBA_ASTC_4x4_Format || p === RGBA_ASTC_5x4_Format || p === RGBA_ASTC_5x5_Format ||
			p === RGBA_ASTC_6x5_Format || p === RGBA_ASTC_6x6_Format || p === RGBA_ASTC_8x5_Format ||
			p === RGBA_ASTC_8x6_Format || p === RGBA_ASTC_8x8_Format || p === RGBA_ASTC_10x5_Format ||
			p === RGBA_ASTC_10x6_Format || p === RGBA_ASTC_10x8_Format || p === RGBA_ASTC_10x10_Format ||
			p === RGBA_ASTC_12x10_Format || p === RGBA_ASTC_12x12_Format ) {

			extension = extensions.get( 'WEBGL_compressed_texture_astc' );

			if ( extension !== null ) {

				if ( p === RGBA_ASTC_4x4_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
				if ( p === RGBA_ASTC_5x4_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
				if ( p === RGBA_ASTC_5x5_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
				if ( p === RGBA_ASTC_6x5_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
				if ( p === RGBA_ASTC_6x6_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
				if ( p === RGBA_ASTC_8x5_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
				if ( p === RGBA_ASTC_8x6_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
				if ( p === RGBA_ASTC_8x8_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
				if ( p === RGBA_ASTC_10x5_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
				if ( p === RGBA_ASTC_10x6_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
				if ( p === RGBA_ASTC_10x8_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
				if ( p === RGBA_ASTC_10x10_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
				if ( p === RGBA_ASTC_12x10_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
				if ( p === RGBA_ASTC_12x12_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;

			} else {

				return null;

			}

		}

		// BPTC

		if ( p === RGBA_BPTC_Format || p === RGB_BPTC_SIGNED_Format || p === RGB_BPTC_UNSIGNED_Format ) {

			extension = extensions.get( 'EXT_texture_compression_bptc' );

			if ( extension !== null ) {

				if ( p === RGBA_BPTC_Format ) return ( transfer === SRGBTransfer ) ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
				if ( p === RGB_BPTC_SIGNED_Format ) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
				if ( p === RGB_BPTC_UNSIGNED_Format ) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;

			} else {

				return null;

			}

		}

		// RGTC

		if ( p === RED_RGTC1_Format || p === SIGNED_RED_RGTC1_Format || p === RED_GREEN_RGTC2_Format || p === SIGNED_RED_GREEN_RGTC2_Format ) {

			extension = extensions.get( 'EXT_texture_compression_rgtc' );

			if ( extension !== null ) {

				if ( p === RGBA_BPTC_Format ) return extension.COMPRESSED_RED_RGTC1_EXT;
				if ( p === SIGNED_RED_RGTC1_Format ) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
				if ( p === RED_GREEN_RGTC2_Format ) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
				if ( p === SIGNED_RED_GREEN_RGTC2_Format ) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;

			} else {

				return null;

			}

		}

		//

		if ( p === UnsignedInt248Type ) return gl.UNSIGNED_INT_24_8;

		// if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)

		return ( gl[ p ] !== undefined ) ? gl[ p ] : null;

	}

	return { convert: convert };

}

class ArrayCamera extends PerspectiveCamera {

	constructor( array = [] ) {

		super();

		this.isArrayCamera = true;

		this.cameras = array;

	}

}

class Group extends Object3D {

	constructor() {

		super();

		this.isGroup = true;

		this.type = 'Group';

	}

}

const _moveEvent = { type: 'move' };

class WebXRController {

	constructor() {

		this._targetRay = null;
		this._grip = null;
		this._hand = null;

	}

	getHandSpace() {

		if ( this._hand === null ) {

			this._hand = new Group();
			this._hand.matrixAutoUpdate = false;
			this._hand.visible = false;

			this._hand.joints = {};
			this._hand.inputState = { pinching: false };

		}

		return this._hand;

	}

	getTargetRaySpace() {

		if ( this._targetRay === null ) {

			this._targetRay = new Group();
			this._targetRay.matrixAutoUpdate = false;
			this._targetRay.visible = false;
			this._targetRay.hasLinearVelocity = false;
			this._targetRay.linearVelocity = new Vector3();
			this._targetRay.hasAngularVelocity = false;
			this._targetRay.angularVelocity = new Vector3();

		}

		return this._targetRay;

	}

	getGripSpace() {

		if ( this._grip === null ) {

			this._grip = new Group();
			this._grip.matrixAutoUpdate = false;
			this._grip.visible = false;
			this._grip.hasLinearVelocity = false;
			this._grip.linearVelocity = new Vector3();
			this._grip.hasAngularVelocity = false;
			this._grip.angularVelocity = new Vector3();

		}

		return this._grip;

	}

	dispatchEvent( event ) {

		if ( this._targetRay !== null ) {

			this._targetRay.dispatchEvent( event );

		}

		if ( this._grip !== null ) {

			this._grip.dispatchEvent( event );

		}

		if ( this._hand !== null ) {

			this._hand.dispatchEvent( event );

		}

		return this;

	}

	connect( inputSource ) {

		if ( inputSource && inputSource.hand ) {

			const hand = this._hand;

			if ( hand ) {

				for ( const inputjoint of inputSource.hand.values() ) {

					// Initialize hand with joints when connected
					this._getHandJoint( hand, inputjoint );

				}

			}

		}

		this.dispatchEvent( { type: 'connected', data: inputSource } );

		return this;

	}

	disconnect( inputSource ) {

		this.dispatchEvent( { type: 'disconnected', data: inputSource } );

		if ( this._targetRay !== null ) {

			this._targetRay.visible = false;

		}

		if ( this._grip !== null ) {

			this._grip.visible = false;

		}

		if ( this._hand !== null ) {

			this._hand.visible = false;

		}

		return this;

	}

	update( inputSource, frame, referenceSpace ) {

		let inputPose = null;
		let gripPose = null;
		let handPose = null;

		const targetRay = this._targetRay;
		const grip = this._grip;
		const hand = this._hand;

		if ( inputSource && frame.session.visibilityState !== 'visible-blurred' ) {

			if ( hand && inputSource.hand ) {

				handPose = true;

				for ( const inputjoint of inputSource.hand.values() ) {

					// Update the joints groups with the XRJoint poses
					const jointPose = frame.getJointPose( inputjoint, referenceSpace );

					// The transform of this joint will be updated with the joint pose on each frame
					const joint = this._getHandJoint( hand, inputjoint );

					if ( jointPose !== null ) {

						joint.matrix.fromArray( jointPose.transform.matrix );
						joint.matrix.decompose( joint.position, joint.rotation, joint.scale );
						joint.matrixWorldNeedsUpdate = true;
						joint.jointRadius = jointPose.radius;

					}

					joint.visible = jointPose !== null;

				}

				// Custom events

				// Check pinchz
				const indexTip = hand.joints[ 'index-finger-tip' ];
				const thumbTip = hand.joints[ 'thumb-tip' ];
				const distance = indexTip.position.distanceTo( thumbTip.position );

				const distanceToPinch = 0.02;
				const threshold = 0.005;

				if ( hand.inputState.pinching && distance > distanceToPinch + threshold ) {

					hand.inputState.pinching = false;
					this.dispatchEvent( {
						type: 'pinchend',
						handedness: inputSource.handedness,
						target: this
					} );

				} else if ( ! hand.inputState.pinching && distance <= distanceToPinch - threshold ) {

					hand.inputState.pinching = true;
					this.dispatchEvent( {
						type: 'pinchstart',
						handedness: inputSource.handedness,
						target: this
					} );

				}

			} else {

				if ( grip !== null && inputSource.gripSpace ) {

					gripPose = frame.getPose( inputSource.gripSpace, referenceSpace );

					if ( gripPose !== null ) {

						grip.matrix.fromArray( gripPose.transform.matrix );
						grip.matrix.decompose( grip.position, grip.rotation, grip.scale );
						grip.matrixWorldNeedsUpdate = true;

						if ( gripPose.linearVelocity ) {

							grip.hasLinearVelocity = true;
							grip.linearVelocity.copy( gripPose.linearVelocity );

						} else {

							grip.hasLinearVelocity = false;

						}

						if ( gripPose.angularVelocity ) {

							grip.hasAngularVelocity = true;
							grip.angularVelocity.copy( gripPose.angularVelocity );

						} else {

							grip.hasAngularVelocity = false;

						}

					}

				}

			}

			if ( targetRay !== null ) {

				inputPose = frame.getPose( inputSource.targetRaySpace, referenceSpace );

				// Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
				if ( inputPose === null && gripPose !== null ) {

					inputPose = gripPose;

				}

				if ( inputPose !== null ) {

					targetRay.matrix.fromArray( inputPose.transform.matrix );
					targetRay.matrix.decompose( targetRay.position, targetRay.rotation, targetRay.scale );
					targetRay.matrixWorldNeedsUpdate = true;

					if ( inputPose.linearVelocity ) {

						targetRay.hasLinearVelocity = true;
						targetRay.linearVelocity.copy( inputPose.linearVelocity );

					} else {

						targetRay.hasLinearVelocity = false;

					}

					if ( inputPose.angularVelocity ) {

						targetRay.hasAngularVelocity = true;
						targetRay.angularVelocity.copy( inputPose.angularVelocity );

					} else {

						targetRay.hasAngularVelocity = false;

					}

					this.dispatchEvent( _moveEvent );

				}

			}


		}

		if ( targetRay !== null ) {

			targetRay.visible = ( inputPose !== null );

		}

		if ( grip !== null ) {

			grip.visible = ( gripPose !== null );

		}

		if ( hand !== null ) {

			hand.visible = ( handPose !== null );

		}

		return this;

	}

	// private method

	_getHandJoint( hand, inputjoint ) {

		if ( hand.joints[ inputjoint.jointName ] === undefined ) {

			const joint = new Group();
			joint.matrixAutoUpdate = false;
			joint.visible = false;
			hand.joints[ inputjoint.jointName ] = joint;

			hand.add( joint );

		}

		return hand.joints[ inputjoint.jointName ];

	}

}

const _occlusion_vertex = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`;

const _occlusion_fragment = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;

class WebXRDepthSensing {

	constructor() {

		this.texture = null;
		this.mesh = null;

		this.depthNear = 0;
		this.depthFar = 0;

	}

	init( renderer, depthData, renderState ) {

		if ( this.texture === null ) {

			const texture = new Texture();

			const texProps = renderer.properties.get( texture );
			texProps.__webglTexture = depthData.texture;

			if ( ( depthData.depthNear != renderState.depthNear ) || ( depthData.depthFar != renderState.depthFar ) ) {

				this.depthNear = depthData.depthNear;
				this.depthFar = depthData.depthFar;

			}

			this.texture = texture;

		}

	}

	getMesh( cameraXR ) {

		if ( this.texture !== null ) {

			if ( this.mesh === null ) {

				const viewport = cameraXR.cameras[ 0 ].viewport;
				const material = new ShaderMaterial( {
					vertexShader: _occlusion_vertex,
					fragmentShader: _occlusion_fragment,
					uniforms: {
						depthColor: { value: this.texture },
						depthWidth: { value: viewport.z },
						depthHeight: { value: viewport.w }
					}
				} );

				this.mesh = new Mesh( new PlaneGeometry( 20, 20 ), material );

			}

		}

		return this.mesh;

	}

	reset() {

		this.texture = null;
		this.mesh = null;

	}

	getDepthTexture() {

		return this.texture;

	}

}

class WebXRManager extends EventDispatcher$2 {

	constructor( renderer, gl ) {

		super();

		const scope = this;

		let session = null;

		let framebufferScaleFactor = 1.0;

		let referenceSpace = null;
		let referenceSpaceType = 'local-floor';
		// Set default foveation to maximum.
		let foveation = 1.0;
		let customReferenceSpace = null;

		let pose = null;
		let glBinding = null;
		let glProjLayer = null;
		let glBaseLayer = null;
		let xrFrame = null;

		const depthSensing = new WebXRDepthSensing();
		const attributes = gl.getContextAttributes();

		let initialRenderTarget = null;
		let newRenderTarget = null;

		const controllers = [];
		const controllerInputSources = [];

		const currentSize = new Vector2();
		let currentPixelRatio = null;

		//

		const cameraL = new PerspectiveCamera();
		cameraL.layers.enable( 1 );
		cameraL.viewport = new Vector4();

		const cameraR = new PerspectiveCamera();
		cameraR.layers.enable( 2 );
		cameraR.viewport = new Vector4();

		const cameras = [ cameraL, cameraR ];

		const cameraXR = new ArrayCamera();
		cameraXR.layers.enable( 1 );
		cameraXR.layers.enable( 2 );

		let _currentDepthNear = null;
		let _currentDepthFar = null;

		//

		this.cameraAutoUpdate = true;
		this.enabled = false;

		this.isPresenting = false;

		this.getController = function ( index ) {

			let controller = controllers[ index ];

			if ( controller === undefined ) {

				controller = new WebXRController();
				controllers[ index ] = controller;

			}

			return controller.getTargetRaySpace();

		};

		this.getControllerGrip = function ( index ) {

			let controller = controllers[ index ];

			if ( controller === undefined ) {

				controller = new WebXRController();
				controllers[ index ] = controller;

			}

			return controller.getGripSpace();

		};

		this.getHand = function ( index ) {

			let controller = controllers[ index ];

			if ( controller === undefined ) {

				controller = new WebXRController();
				controllers[ index ] = controller;

			}

			return controller.getHandSpace();

		};

		//

		function onSessionEvent( event ) {

			const controllerIndex = controllerInputSources.indexOf( event.inputSource );

			if ( controllerIndex === - 1 ) {

				return;

			}

			const controller = controllers[ controllerIndex ];

			if ( controller !== undefined ) {

				controller.update( event.inputSource, event.frame, customReferenceSpace || referenceSpace );
				controller.dispatchEvent( { type: event.type, data: event.inputSource } );

			}

		}

		function onSessionEnd() {

			session.removeEventListener( 'select', onSessionEvent );
			session.removeEventListener( 'selectstart', onSessionEvent );
			session.removeEventListener( 'selectend', onSessionEvent );
			session.removeEventListener( 'squeeze', onSessionEvent );
			session.removeEventListener( 'squeezestart', onSessionEvent );
			session.removeEventListener( 'squeezeend', onSessionEvent );
			session.removeEventListener( 'end', onSessionEnd );
			session.removeEventListener( 'inputsourceschange', onInputSourcesChange );

			for ( let i = 0; i < controllers.length; i ++ ) {

				const inputSource = controllerInputSources[ i ];

				if ( inputSource === null ) continue;

				controllerInputSources[ i ] = null;

				controllers[ i ].disconnect( inputSource );

			}

			_currentDepthNear = null;
			_currentDepthFar = null;

			depthSensing.reset();

			// restore framebuffer/rendering state

			renderer.setRenderTarget( initialRenderTarget );

			glBaseLayer = null;
			glProjLayer = null;
			glBinding = null;
			session = null;
			newRenderTarget = null;

			//

			animation.stop();

			scope.isPresenting = false;

			renderer.setPixelRatio( currentPixelRatio );
			renderer.setSize( currentSize.width, currentSize.height, false );

			scope.dispatchEvent( { type: 'sessionend' } );

		}

		this.setFramebufferScaleFactor = function ( value ) {

			framebufferScaleFactor = value;

			if ( scope.isPresenting === true ) {

				console.warn( 'THREE.WebXRManager: Cannot change framebuffer scale while presenting.' );

			}

		};

		this.setReferenceSpaceType = function ( value ) {

			referenceSpaceType = value;

			if ( scope.isPresenting === true ) {

				console.warn( 'THREE.WebXRManager: Cannot change reference space type while presenting.' );

			}

		};

		this.getReferenceSpace = function () {

			return customReferenceSpace || referenceSpace;

		};

		this.setReferenceSpace = function ( space ) {

			customReferenceSpace = space;

		};

		this.getBaseLayer = function () {

			return glProjLayer !== null ? glProjLayer : glBaseLayer;

		};

		this.getBinding = function () {

			return glBinding;

		};

		this.getFrame = function () {

			return xrFrame;

		};

		this.getSession = function () {

			return session;

		};

		this.setSession = async function ( value ) {

			session = value;

			if ( session !== null ) {

				initialRenderTarget = renderer.getRenderTarget();

				session.addEventListener( 'select', onSessionEvent );
				session.addEventListener( 'selectstart', onSessionEvent );
				session.addEventListener( 'selectend', onSessionEvent );
				session.addEventListener( 'squeeze', onSessionEvent );
				session.addEventListener( 'squeezestart', onSessionEvent );
				session.addEventListener( 'squeezeend', onSessionEvent );
				session.addEventListener( 'end', onSessionEnd );
				session.addEventListener( 'inputsourceschange', onInputSourcesChange );

				if ( attributes.xrCompatible !== true ) {

					await gl.makeXRCompatible();

				}

				currentPixelRatio = renderer.getPixelRatio();
				renderer.getSize( currentSize );

				if ( session.renderState.layers === undefined ) {

					const layerInit = {
						antialias: attributes.antialias,
						alpha: true,
						depth: attributes.depth,
						stencil: attributes.stencil,
						framebufferScaleFactor: framebufferScaleFactor
					};

					glBaseLayer = new XRWebGLLayer( session, gl, layerInit );

					session.updateRenderState( { baseLayer: glBaseLayer } );

					renderer.setPixelRatio( 1 );
					renderer.setSize( glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false );

					newRenderTarget = new WebGLRenderTarget(
						glBaseLayer.framebufferWidth,
						glBaseLayer.framebufferHeight,
						{
							format: RGBAFormat,
							type: UnsignedByteType,
							colorSpace: renderer.outputColorSpace,
							stencilBuffer: attributes.stencil
						}
					);

				} else {

					let depthFormat = null;
					let depthType = null;
					let glDepthFormat = null;

					if ( attributes.depth ) {

						glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
						depthFormat = attributes.stencil ? DepthStencilFormat : DepthFormat;
						depthType = attributes.stencil ? UnsignedInt248Type : UnsignedIntType;

					}

					const projectionlayerInit = {
						colorFormat: gl.RGBA8,
						depthFormat: glDepthFormat,
						scaleFactor: framebufferScaleFactor
					};

					glBinding = new XRWebGLBinding( session, gl );

					glProjLayer = glBinding.createProjectionLayer( projectionlayerInit );

					session.updateRenderState( { layers: [ glProjLayer ] } );

					renderer.setPixelRatio( 1 );
					renderer.setSize( glProjLayer.textureWidth, glProjLayer.textureHeight, false );

					newRenderTarget = new WebGLRenderTarget(
						glProjLayer.textureWidth,
						glProjLayer.textureHeight,
						{
							format: RGBAFormat,
							type: UnsignedByteType,
							depthTexture: new DepthTexture( glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat ),
							stencilBuffer: attributes.stencil,
							colorSpace: renderer.outputColorSpace,
							samples: attributes.antialias ? 4 : 0,
							resolveDepthBuffer: ( glProjLayer.ignoreDepthValues === false )
						} );

				}

				newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278

				this.setFoveation( foveation );

				customReferenceSpace = null;
				referenceSpace = await session.requestReferenceSpace( referenceSpaceType );

				animation.setContext( session );
				animation.start();

				scope.isPresenting = true;

				scope.dispatchEvent( { type: 'sessionstart' } );

			}

		};

		this.getEnvironmentBlendMode = function () {

			if ( session !== null ) {

				return session.environmentBlendMode;

			}

		};

		this.getDepthTexture = function () {

			return depthSensing.getDepthTexture();

		};

		function onInputSourcesChange( event ) {

			// Notify disconnected

			for ( let i = 0; i < event.removed.length; i ++ ) {

				const inputSource = event.removed[ i ];
				const index = controllerInputSources.indexOf( inputSource );

				if ( index >= 0 ) {

					controllerInputSources[ index ] = null;
					controllers[ index ].disconnect( inputSource );

				}

			}

			// Notify connected

			for ( let i = 0; i < event.added.length; i ++ ) {

				const inputSource = event.added[ i ];

				let controllerIndex = controllerInputSources.indexOf( inputSource );

				if ( controllerIndex === - 1 ) {

					// Assign input source a controller that currently has no input source

					for ( let i = 0; i < controllers.length; i ++ ) {

						if ( i >= controllerInputSources.length ) {

							controllerInputSources.push( inputSource );
							controllerIndex = i;
							break;

						} else if ( controllerInputSources[ i ] === null ) {

							controllerInputSources[ i ] = inputSource;
							controllerIndex = i;
							break;

						}

					}

					// If all controllers do currently receive input we ignore new ones

					if ( controllerIndex === - 1 ) break;

				}

				const controller = controllers[ controllerIndex ];

				if ( controller ) {

					controller.connect( inputSource );

				}

			}

		}

		//

		const cameraLPos = new Vector3();
		const cameraRPos = new Vector3();

		/**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */
		function setProjectionFromUnion( camera, cameraL, cameraR ) {

			cameraLPos.setFromMatrixPosition( cameraL.matrixWorld );
			cameraRPos.setFromMatrixPosition( cameraR.matrixWorld );

			const ipd = cameraLPos.distanceTo( cameraRPos );

			const projL = cameraL.projectionMatrix.elements;
			const projR = cameraR.projectionMatrix.elements;

			// VR systems will have identical far and near planes, and
			// most likely identical top and bottom frustum extents.
			// Use the left camera for these values.
			const near = projL[ 14 ] / ( projL[ 10 ] - 1 );
			const far = projL[ 14 ] / ( projL[ 10 ] + 1 );
			const topFov = ( projL[ 9 ] + 1 ) / projL[ 5 ];
			const bottomFov = ( projL[ 9 ] - 1 ) / projL[ 5 ];

			const leftFov = ( projL[ 8 ] - 1 ) / projL[ 0 ];
			const rightFov = ( projR[ 8 ] + 1 ) / projR[ 0 ];
			const left = near * leftFov;
			const right = near * rightFov;

			// Calculate the new camera's position offset from the
			// left camera. xOffset should be roughly half `ipd`.
			const zOffset = ipd / ( - leftFov + rightFov );
			const xOffset = zOffset * - leftFov;

			// TODO: Better way to apply this offset?
			cameraL.matrixWorld.decompose( camera.position, camera.quaternion, camera.scale );
			camera.translateX( xOffset );
			camera.translateZ( zOffset );
			camera.matrixWorld.compose( camera.position, camera.quaternion, camera.scale );
			camera.matrixWorldInverse.copy( camera.matrixWorld ).invert();

			// Find the union of the frustum values of the cameras and scale
			// the values so that the near plane's position does not change in world space,
			// although must now be relative to the new union camera.
			const near2 = near + zOffset;
			const far2 = far + zOffset;
			const left2 = left - xOffset;
			const right2 = right + ( ipd - xOffset );
			const top2 = topFov * far / far2 * near2;
			const bottom2 = bottomFov * far / far2 * near2;

			camera.projectionMatrix.makePerspective( left2, right2, top2, bottom2, near2, far2 );
			camera.projectionMatrixInverse.copy( camera.projectionMatrix ).invert();

		}

		function updateCamera( camera, parent ) {

			if ( parent === null ) {

				camera.matrixWorld.copy( camera.matrix );

			} else {

				camera.matrixWorld.multiplyMatrices( parent.matrixWorld, camera.matrix );

			}

			camera.matrixWorldInverse.copy( camera.matrixWorld ).invert();

		}

		this.updateCamera = function ( camera ) {

			if ( session === null ) return;

			if ( depthSensing.texture !== null ) {

				camera.near = depthSensing.depthNear;
				camera.far = depthSensing.depthFar;

			}

			cameraXR.near = cameraR.near = cameraL.near = camera.near;
			cameraXR.far = cameraR.far = cameraL.far = camera.far;

			if ( _currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far ) {

				// Note that the new renderState won't apply until the next frame. See #18320

				session.updateRenderState( {
					depthNear: cameraXR.near,
					depthFar: cameraXR.far
				} );

				_currentDepthNear = cameraXR.near;
				_currentDepthFar = cameraXR.far;

				cameraL.near = _currentDepthNear;
				cameraL.far = _currentDepthFar;
				cameraR.near = _currentDepthNear;
				cameraR.far = _currentDepthFar;

				cameraL.updateProjectionMatrix();
				cameraR.updateProjectionMatrix();
				camera.updateProjectionMatrix();

			}

			const parent = camera.parent;
			const cameras = cameraXR.cameras;

			updateCamera( cameraXR, parent );

			for ( let i = 0; i < cameras.length; i ++ ) {

				updateCamera( cameras[ i ], parent );

			}

			// update projection matrix for proper view frustum culling

			if ( cameras.length === 2 ) {

				setProjectionFromUnion( cameraXR, cameraL, cameraR );

			} else {

				// assume single camera setup (AR)

				cameraXR.projectionMatrix.copy( cameraL.projectionMatrix );

			}

			// update user camera and its children

			updateUserCamera( camera, cameraXR, parent );

		};

		function updateUserCamera( camera, cameraXR, parent ) {

			if ( parent === null ) {

				camera.matrix.copy( cameraXR.matrixWorld );

			} else {

				camera.matrix.copy( parent.matrixWorld );
				camera.matrix.invert();
				camera.matrix.multiply( cameraXR.matrixWorld );

			}

			camera.matrix.decompose( camera.position, camera.quaternion, camera.scale );
			camera.updateMatrixWorld( true );

			camera.projectionMatrix.copy( cameraXR.projectionMatrix );
			camera.projectionMatrixInverse.copy( cameraXR.projectionMatrixInverse );

			if ( camera.isPerspectiveCamera ) {

				camera.fov = RAD2DEG * 2 * Math.atan( 1 / camera.projectionMatrix.elements[ 5 ] );
				camera.zoom = 1;

			}

		}

		this.getCamera = function () {

			return cameraXR;

		};

		this.getFoveation = function () {

			if ( glProjLayer === null && glBaseLayer === null ) {

				return undefined;

			}

			return foveation;

		};

		this.setFoveation = function ( value ) {

			// 0 = no foveation = full resolution
			// 1 = maximum foveation = the edges render at lower resolution

			foveation = value;

			if ( glProjLayer !== null ) {

				glProjLayer.fixedFoveation = value;

			}

			if ( glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined ) {

				glBaseLayer.fixedFoveation = value;

			}

		};

		this.hasDepthSensing = function () {

			return depthSensing.texture !== null;

		};

		this.getDepthSensingMesh = function () {

			return depthSensing.getMesh( cameraXR );

		};

		// Animation Loop

		let onAnimationFrameCallback = null;

		function onAnimationFrame( time, frame ) {

			pose = frame.getViewerPose( customReferenceSpace || referenceSpace );
			xrFrame = frame;

			if ( pose !== null ) {

				const views = pose.views;

				if ( glBaseLayer !== null ) {

					renderer.setRenderTargetFramebuffer( newRenderTarget, glBaseLayer.framebuffer );
					renderer.setRenderTarget( newRenderTarget );

				}

				let cameraXRNeedsUpdate = false;

				// check if it's necessary to rebuild cameraXR's camera list

				if ( views.length !== cameraXR.cameras.length ) {

					cameraXR.cameras.length = 0;
					cameraXRNeedsUpdate = true;

				}

				for ( let i = 0; i < views.length; i ++ ) {

					const view = views[ i ];

					let viewport = null;

					if ( glBaseLayer !== null ) {

						viewport = glBaseLayer.getViewport( view );

					} else {

						const glSubImage = glBinding.getViewSubImage( glProjLayer, view );
						viewport = glSubImage.viewport;

						// For side-by-side projection, we only produce a single texture for both eyes.
						if ( i === 0 ) {

							renderer.setRenderTargetTextures(
								newRenderTarget,
								glSubImage.colorTexture,
								glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture );

							renderer.setRenderTarget( newRenderTarget );

						}

					}

					let camera = cameras[ i ];

					if ( camera === undefined ) {

						camera = new PerspectiveCamera();
						camera.layers.enable( i );
						camera.viewport = new Vector4();
						cameras[ i ] = camera;

					}

					camera.matrix.fromArray( view.transform.matrix );
					camera.matrix.decompose( camera.position, camera.quaternion, camera.scale );
					camera.projectionMatrix.fromArray( view.projectionMatrix );
					camera.projectionMatrixInverse.copy( camera.projectionMatrix ).invert();
					camera.viewport.set( viewport.x, viewport.y, viewport.width, viewport.height );

					if ( i === 0 ) {

						cameraXR.matrix.copy( camera.matrix );
						cameraXR.matrix.decompose( cameraXR.position, cameraXR.quaternion, cameraXR.scale );

					}

					if ( cameraXRNeedsUpdate === true ) {

						cameraXR.cameras.push( camera );

					}

				}

				//

				const enabledFeatures = session.enabledFeatures;

				if ( enabledFeatures && enabledFeatures.includes( 'depth-sensing' ) ) {

					const depthData = glBinding.getDepthInformation( views[ 0 ] );

					if ( depthData && depthData.isValid && depthData.texture ) {

						depthSensing.init( renderer, depthData, session.renderState );

					}

				}

			}

			//

			for ( let i = 0; i < controllers.length; i ++ ) {

				const inputSource = controllerInputSources[ i ];
				const controller = controllers[ i ];

				if ( inputSource !== null && controller !== undefined ) {

					controller.update( inputSource, frame, customReferenceSpace || referenceSpace );

				}

			}

			if ( onAnimationFrameCallback ) onAnimationFrameCallback( time, frame );

			if ( frame.detectedPlanes ) {

				scope.dispatchEvent( { type: 'planesdetected', data: frame } );

			}

			xrFrame = null;

		}

		const animation = new WebGLAnimation();

		animation.setAnimationLoop( onAnimationFrame );

		this.setAnimationLoop = function ( callback ) {

			onAnimationFrameCallback = callback;

		};

		this.dispose = function () {};

	}

}

const _e1 = /*@__PURE__*/ new Euler();
const _m1 = /*@__PURE__*/ new Matrix4();

function WebGLMaterials( renderer, properties ) {

	function refreshTransformUniform( map, uniform ) {

		if ( map.matrixAutoUpdate === true ) {

			map.updateMatrix();

		}

		uniform.value.copy( map.matrix );

	}

	function refreshFogUniforms( uniforms, fog ) {

		fog.color.getRGB( uniforms.fogColor.value, getUnlitUniformColorSpace( renderer ) );

		if ( fog.isFog ) {

			uniforms.fogNear.value = fog.near;
			uniforms.fogFar.value = fog.far;

		} else if ( fog.isFogExp2 ) {

			uniforms.fogDensity.value = fog.density;

		}

	}

	function refreshMaterialUniforms( uniforms, material, pixelRatio, height, transmissionRenderTarget ) {

		if ( material.isMeshBasicMaterial ) {

			refreshUniformsCommon( uniforms, material );

		} else if ( material.isMeshLambertMaterial ) {

			refreshUniformsCommon( uniforms, material );

		} else if ( material.isMeshToonMaterial ) {

			refreshUniformsCommon( uniforms, material );
			refreshUniformsToon( uniforms, material );

		} else if ( material.isMeshPhongMaterial ) {

			refreshUniformsCommon( uniforms, material );
			refreshUniformsPhong( uniforms, material );

		} else if ( material.isMeshStandardMaterial ) {

			refreshUniformsCommon( uniforms, material );
			refreshUniformsStandard( uniforms, material );

			if ( material.isMeshPhysicalMaterial ) {

				refreshUniformsPhysical( uniforms, material, transmissionRenderTarget );

			}

		} else if ( material.isMeshMatcapMaterial ) {

			refreshUniformsCommon( uniforms, material );
			refreshUniformsMatcap( uniforms, material );

		} else if ( material.isMeshDepthMaterial ) {

			refreshUniformsCommon( uniforms, material );

		} else if ( material.isMeshDistanceMaterial ) {

			refreshUniformsCommon( uniforms, material );
			refreshUniformsDistance( uniforms, material );

		} else if ( material.isMeshNormalMaterial ) {

			refreshUniformsCommon( uniforms, material );

		} else if ( material.isLineBasicMaterial ) {

			refreshUniformsLine( uniforms, material );

			if ( material.isLineDashedMaterial ) {

				refreshUniformsDash( uniforms, material );

			}

		} else if ( material.isPointsMaterial ) {

			refreshUniformsPoints( uniforms, material, pixelRatio, height );

		} else if ( material.isSpriteMaterial ) {

			refreshUniformsSprites( uniforms, material );

		} else if ( material.isShadowMaterial ) {

			uniforms.color.value.copy( material.color );
			uniforms.opacity.value = material.opacity;

		} else if ( material.isShaderMaterial ) {

			material.uniformsNeedUpdate = false; // #15581

		}

	}

	function refreshUniformsCommon( uniforms, material ) {

		uniforms.opacity.value = material.opacity;

		if ( material.color ) {

			uniforms.diffuse.value.copy( material.color );

		}

		if ( material.emissive ) {

			uniforms.emissive.value.copy( material.emissive ).multiplyScalar( material.emissiveIntensity );

		}

		if ( material.map ) {

			uniforms.map.value = material.map;

			refreshTransformUniform( material.map, uniforms.mapTransform );

		}

		if ( material.alphaMap ) {

			uniforms.alphaMap.value = material.alphaMap;

			refreshTransformUniform( material.alphaMap, uniforms.alphaMapTransform );

		}

		if ( material.bumpMap ) {

			uniforms.bumpMap.value = material.bumpMap;

			refreshTransformUniform( material.bumpMap, uniforms.bumpMapTransform );

			uniforms.bumpScale.value = material.bumpScale;

			if ( material.side === BackSide ) {

				uniforms.bumpScale.value *= - 1;

			}

		}

		if ( material.normalMap ) {

			uniforms.normalMap.value = material.normalMap;

			refreshTransformUniform( material.normalMap, uniforms.normalMapTransform );

			uniforms.normalScale.value.copy( material.normalScale );

			if ( material.side === BackSide ) {

				uniforms.normalScale.value.negate();

			}

		}

		if ( material.displacementMap ) {

			uniforms.displacementMap.value = material.displacementMap;

			refreshTransformUniform( material.displacementMap, uniforms.displacementMapTransform );

			uniforms.displacementScale.value = material.displacementScale;
			uniforms.displacementBias.value = material.displacementBias;

		}

		if ( material.emissiveMap ) {

			uniforms.emissiveMap.value = material.emissiveMap;

			refreshTransformUniform( material.emissiveMap, uniforms.emissiveMapTransform );

		}

		if ( material.specularMap ) {

			uniforms.specularMap.value = material.specularMap;

			refreshTransformUniform( material.specularMap, uniforms.specularMapTransform );

		}

		if ( material.alphaTest > 0 ) {

			uniforms.alphaTest.value = material.alphaTest;

		}

		const materialProperties = properties.get( material );

		const envMap = materialProperties.envMap;
		const envMapRotation = materialProperties.envMapRotation;

		if ( envMap ) {

			uniforms.envMap.value = envMap;

			_e1.copy( envMapRotation );

			// accommodate left-handed frame
			_e1.x *= - 1; _e1.y *= - 1; _e1.z *= - 1;

			if ( envMap.isCubeTexture && envMap.isRenderTargetTexture === false ) {

				// environment maps which are not cube render targets or PMREMs follow a different convention
				_e1.y *= - 1;
				_e1.z *= - 1;

			}

			uniforms.envMapRotation.value.setFromMatrix4( _m1.makeRotationFromEuler( _e1 ) );

			uniforms.flipEnvMap.value = ( envMap.isCubeTexture && envMap.isRenderTargetTexture === false ) ? - 1 : 1;

			uniforms.reflectivity.value = material.reflectivity;
			uniforms.ior.value = material.ior;
			uniforms.refractionRatio.value = material.refractionRatio;

		}

		if ( material.lightMap ) {

			uniforms.lightMap.value = material.lightMap;
			uniforms.lightMapIntensity.value = material.lightMapIntensity;

			refreshTransformUniform( material.lightMap, uniforms.lightMapTransform );

		}

		if ( material.aoMap ) {

			uniforms.aoMap.value = material.aoMap;
			uniforms.aoMapIntensity.value = material.aoMapIntensity;

			refreshTransformUniform( material.aoMap, uniforms.aoMapTransform );

		}

	}

	function refreshUniformsLine( uniforms, material ) {

		uniforms.diffuse.value.copy( material.color );
		uniforms.opacity.value = material.opacity;

		if ( material.map ) {

			uniforms.map.value = material.map;

			refreshTransformUniform( material.map, uniforms.mapTransform );

		}

	}

	function refreshUniformsDash( uniforms, material ) {

		uniforms.dashSize.value = material.dashSize;
		uniforms.totalSize.value = material.dashSize + material.gapSize;
		uniforms.scale.value = material.scale;

	}

	function refreshUniformsPoints( uniforms, material, pixelRatio, height ) {

		uniforms.diffuse.value.copy( material.color );
		uniforms.opacity.value = material.opacity;
		uniforms.size.value = material.size * pixelRatio;
		uniforms.scale.value = height * 0.5;

		if ( material.map ) {

			uniforms.map.value = material.map;

			refreshTransformUniform( material.map, uniforms.uvTransform );

		}

		if ( material.alphaMap ) {

			uniforms.alphaMap.value = material.alphaMap;

			refreshTransformUniform( material.alphaMap, uniforms.alphaMapTransform );

		}

		if ( material.alphaTest > 0 ) {

			uniforms.alphaTest.value = material.alphaTest;

		}

	}

	function refreshUniformsSprites( uniforms, material ) {

		uniforms.diffuse.value.copy( material.color );
		uniforms.opacity.value = material.opacity;
		uniforms.rotation.value = material.rotation;

		if ( material.map ) {

			uniforms.map.value = material.map;

			refreshTransformUniform( material.map, uniforms.mapTransform );

		}

		if ( material.alphaMap ) {

			uniforms.alphaMap.value = material.alphaMap;

			refreshTransformUniform( material.alphaMap, uniforms.alphaMapTransform );

		}

		if ( material.alphaTest > 0 ) {

			uniforms.alphaTest.value = material.alphaTest;

		}

	}

	function refreshUniformsPhong( uniforms, material ) {

		uniforms.specular.value.copy( material.specular );
		uniforms.shininess.value = Math.max( material.shininess, 1e-4 ); // to prevent pow( 0.0, 0.0 )

	}

	function refreshUniformsToon( uniforms, material ) {

		if ( material.gradientMap ) {

			uniforms.gradientMap.value = material.gradientMap;

		}

	}

	function refreshUniformsStandard( uniforms, material ) {

		uniforms.metalness.value = material.metalness;

		if ( material.metalnessMap ) {

			uniforms.metalnessMap.value = material.metalnessMap;

			refreshTransformUniform( material.metalnessMap, uniforms.metalnessMapTransform );

		}

		uniforms.roughness.value = material.roughness;

		if ( material.roughnessMap ) {

			uniforms.roughnessMap.value = material.roughnessMap;

			refreshTransformUniform( material.roughnessMap, uniforms.roughnessMapTransform );

		}

		if ( material.envMap ) {

			//uniforms.envMap.value = material.envMap; // part of uniforms common

			uniforms.envMapIntensity.value = material.envMapIntensity;

		}

	}

	function refreshUniformsPhysical( uniforms, material, transmissionRenderTarget ) {

		uniforms.ior.value = material.ior; // also part of uniforms common

		if ( material.sheen > 0 ) {

			uniforms.sheenColor.value.copy( material.sheenColor ).multiplyScalar( material.sheen );

			uniforms.sheenRoughness.value = material.sheenRoughness;

			if ( material.sheenColorMap ) {

				uniforms.sheenColorMap.value = material.sheenColorMap;

				refreshTransformUniform( material.sheenColorMap, uniforms.sheenColorMapTransform );

			}

			if ( material.sheenRoughnessMap ) {

				uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;

				refreshTransformUniform( material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform );

			}

		}

		if ( material.clearcoat > 0 ) {

			uniforms.clearcoat.value = material.clearcoat;
			uniforms.clearcoatRoughness.value = material.clearcoatRoughness;

			if ( material.clearcoatMap ) {

				uniforms.clearcoatMap.value = material.clearcoatMap;

				refreshTransformUniform( material.clearcoatMap, uniforms.clearcoatMapTransform );

			}

			if ( material.clearcoatRoughnessMap ) {

				uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;

				refreshTransformUniform( material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform );

			}

			if ( material.clearcoatNormalMap ) {

				uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;

				refreshTransformUniform( material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform );

				uniforms.clearcoatNormalScale.value.copy( material.clearcoatNormalScale );

				if ( material.side === BackSide ) {

					uniforms.clearcoatNormalScale.value.negate();

				}

			}

		}

		if ( material.dispersion > 0 ) {

			uniforms.dispersion.value = material.dispersion;

		}

		if ( material.iridescence > 0 ) {

			uniforms.iridescence.value = material.iridescence;
			uniforms.iridescenceIOR.value = material.iridescenceIOR;
			uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[ 0 ];
			uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[ 1 ];

			if ( material.iridescenceMap ) {

				uniforms.iridescenceMap.value = material.iridescenceMap;

				refreshTransformUniform( material.iridescenceMap, uniforms.iridescenceMapTransform );

			}

			if ( material.iridescenceThicknessMap ) {

				uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;

				refreshTransformUniform( material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform );

			}

		}

		if ( material.transmission > 0 ) {

			uniforms.transmission.value = material.transmission;
			uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
			uniforms.transmissionSamplerSize.value.set( transmissionRenderTarget.width, transmissionRenderTarget.height );

			if ( material.transmissionMap ) {

				uniforms.transmissionMap.value = material.transmissionMap;

				refreshTransformUniform( material.transmissionMap, uniforms.transmissionMapTransform );

			}

			uniforms.thickness.value = material.thickness;

			if ( material.thicknessMap ) {

				uniforms.thicknessMap.value = material.thicknessMap;

				refreshTransformUniform( material.thicknessMap, uniforms.thicknessMapTransform );

			}

			uniforms.attenuationDistance.value = material.attenuationDistance;
			uniforms.attenuationColor.value.copy( material.attenuationColor );

		}

		if ( material.anisotropy > 0 ) {

			uniforms.anisotropyVector.value.set( material.anisotropy * Math.cos( material.anisotropyRotation ), material.anisotropy * Math.sin( material.anisotropyRotation ) );

			if ( material.anisotropyMap ) {

				uniforms.anisotropyMap.value = material.anisotropyMap;

				refreshTransformUniform( material.anisotropyMap, uniforms.anisotropyMapTransform );

			}

		}

		uniforms.specularIntensity.value = material.specularIntensity;
		uniforms.specularColor.value.copy( material.specularColor );

		if ( material.specularColorMap ) {

			uniforms.specularColorMap.value = material.specularColorMap;

			refreshTransformUniform( material.specularColorMap, uniforms.specularColorMapTransform );

		}

		if ( material.specularIntensityMap ) {

			uniforms.specularIntensityMap.value = material.specularIntensityMap;

			refreshTransformUniform( material.specularIntensityMap, uniforms.specularIntensityMapTransform );

		}

	}

	function refreshUniformsMatcap( uniforms, material ) {

		if ( material.matcap ) {

			uniforms.matcap.value = material.matcap;

		}

	}

	function refreshUniformsDistance( uniforms, material ) {

		const light = properties.get( material ).light;

		uniforms.referencePosition.value.setFromMatrixPosition( light.matrixWorld );
		uniforms.nearDistance.value = light.shadow.camera.near;
		uniforms.farDistance.value = light.shadow.camera.far;

	}

	return {
		refreshFogUniforms: refreshFogUniforms,
		refreshMaterialUniforms: refreshMaterialUniforms
	};

}

function WebGLUniformsGroups( gl, info, capabilities, state ) {

	let buffers = {};
	let updateList = {};
	let allocatedBindingPoints = [];

	const maxBindingPoints = gl.getParameter( gl.MAX_UNIFORM_BUFFER_BINDINGS ); // binding points are global whereas block indices are per shader program

	function bind( uniformsGroup, program ) {

		const webglProgram = program.program;
		state.uniformBlockBinding( uniformsGroup, webglProgram );

	}

	function update( uniformsGroup, program ) {

		let buffer = buffers[ uniformsGroup.id ];

		if ( buffer === undefined ) {

			prepareUniformsGroup( uniformsGroup );

			buffer = createBuffer( uniformsGroup );
			buffers[ uniformsGroup.id ] = buffer;

			uniformsGroup.addEventListener( 'dispose', onUniformsGroupsDispose );

		}

		// ensure to update the binding points/block indices mapping for this program

		const webglProgram = program.program;
		state.updateUBOMapping( uniformsGroup, webglProgram );

		// update UBO once per frame

		const frame = info.render.frame;

		if ( updateList[ uniformsGroup.id ] !== frame ) {

			updateBufferData( uniformsGroup );

			updateList[ uniformsGroup.id ] = frame;

		}

	}

	function createBuffer( uniformsGroup ) {

		// the setup of an UBO is independent of a particular shader program but global

		const bindingPointIndex = allocateBindingPointIndex();
		uniformsGroup.__bindingPointIndex = bindingPointIndex;

		const buffer = gl.createBuffer();
		const size = uniformsGroup.__size;
		const usage = uniformsGroup.usage;

		gl.bindBuffer( gl.UNIFORM_BUFFER, buffer );
		gl.bufferData( gl.UNIFORM_BUFFER, size, usage );
		gl.bindBuffer( gl.UNIFORM_BUFFER, null );
		gl.bindBufferBase( gl.UNIFORM_BUFFER, bindingPointIndex, buffer );

		return buffer;

	}

	function allocateBindingPointIndex() {

		for ( let i = 0; i < maxBindingPoints; i ++ ) {

			if ( allocatedBindingPoints.indexOf( i ) === - 1 ) {

				allocatedBindingPoints.push( i );
				return i;

			}

		}

		console.error( 'THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.' );

		return 0;

	}

	function updateBufferData( uniformsGroup ) {

		const buffer = buffers[ uniformsGroup.id ];
		const uniforms = uniformsGroup.uniforms;
		const cache = uniformsGroup.__cache;

		gl.bindBuffer( gl.UNIFORM_BUFFER, buffer );

		for ( let i = 0, il = uniforms.length; i < il; i ++ ) {

			const uniformArray = Array.isArray( uniforms[ i ] ) ? uniforms[ i ] : [ uniforms[ i ] ];

			for ( let j = 0, jl = uniformArray.length; j < jl; j ++ ) {

				const uniform = uniformArray[ j ];

				if ( hasUniformChanged( uniform, i, j, cache ) === true ) {

					const offset = uniform.__offset;

					const values = Array.isArray( uniform.value ) ? uniform.value : [ uniform.value ];

					let arrayOffset = 0;

					for ( let k = 0; k < values.length; k ++ ) {

						const value = values[ k ];

						const info = getUniformSize( value );

						// TODO add integer and struct support
						if ( typeof value === 'number' || typeof value === 'boolean' ) {

							uniform.__data[ 0 ] = value;
							gl.bufferSubData( gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data );

						} else if ( value.isMatrix3 ) {

							// manually converting 3x3 to 3x4

							uniform.__data[ 0 ] = value.elements[ 0 ];
							uniform.__data[ 1 ] = value.elements[ 1 ];
							uniform.__data[ 2 ] = value.elements[ 2 ];
							uniform.__data[ 3 ] = 0;
							uniform.__data[ 4 ] = value.elements[ 3 ];
							uniform.__data[ 5 ] = value.elements[ 4 ];
							uniform.__data[ 6 ] = value.elements[ 5 ];
							uniform.__data[ 7 ] = 0;
							uniform.__data[ 8 ] = value.elements[ 6 ];
							uniform.__data[ 9 ] = value.elements[ 7 ];
							uniform.__data[ 10 ] = value.elements[ 8 ];
							uniform.__data[ 11 ] = 0;

						} else {

							value.toArray( uniform.__data, arrayOffset );

							arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;

						}

					}

					gl.bufferSubData( gl.UNIFORM_BUFFER, offset, uniform.__data );

				}

			}

		}

		gl.bindBuffer( gl.UNIFORM_BUFFER, null );

	}

	function hasUniformChanged( uniform, index, indexArray, cache ) {

		const value = uniform.value;
		const indexString = index + '_' + indexArray;

		if ( cache[ indexString ] === undefined ) {

			// cache entry does not exist so far

			if ( typeof value === 'number' || typeof value === 'boolean' ) {

				cache[ indexString ] = value;

			} else {

				cache[ indexString ] = value.clone();

			}

			return true;

		} else {

			const cachedObject = cache[ indexString ];

			// compare current value with cached entry

			if ( typeof value === 'number' || typeof value === 'boolean' ) {

				if ( cachedObject !== value ) {

					cache[ indexString ] = value;
					return true;

				}

			} else {

				if ( cachedObject.equals( value ) === false ) {

					cachedObject.copy( value );
					return true;

				}

			}

		}

		return false;

	}

	function prepareUniformsGroup( uniformsGroup ) {

		// determine total buffer size according to the STD140 layout
		// Hint: STD140 is the only supported layout in WebGL 2

		const uniforms = uniformsGroup.uniforms;

		let offset = 0; // global buffer offset in bytes
		const chunkSize = 16; // size of a chunk in bytes

		for ( let i = 0, l = uniforms.length; i < l; i ++ ) {

			const uniformArray = Array.isArray( uniforms[ i ] ) ? uniforms[ i ] : [ uniforms[ i ] ];

			for ( let j = 0, jl = uniformArray.length; j < jl; j ++ ) {

				const uniform = uniformArray[ j ];

				const values = Array.isArray( uniform.value ) ? uniform.value : [ uniform.value ];

				for ( let k = 0, kl = values.length; k < kl; k ++ ) {

					const value = values[ k ];

					const info = getUniformSize( value );

					// Calculate the chunk offset
					const chunkOffsetUniform = offset % chunkSize;

					// Check for chunk overflow
					if ( chunkOffsetUniform !== 0 && ( chunkSize - chunkOffsetUniform ) < info.boundary ) {

						// Add padding and adjust offset
						offset += ( chunkSize - chunkOffsetUniform );

					}

					// the following two properties will be used for partial buffer updates

					uniform.__data = new Float32Array( info.storage / Float32Array.BYTES_PER_ELEMENT );
					uniform.__offset = offset;


					// Update the global offset
					offset += info.storage;


				}

			}

		}

		// ensure correct final padding

		const chunkOffset = offset % chunkSize;

		if ( chunkOffset > 0 ) offset += ( chunkSize - chunkOffset );

		//

		uniformsGroup.__size = offset;
		uniformsGroup.__cache = {};

		return this;

	}

	function getUniformSize( value ) {

		const info = {
			boundary: 0, // bytes
			storage: 0 // bytes
		};

		// determine sizes according to STD140

		if ( typeof value === 'number' || typeof value === 'boolean' ) {

			// float/int/bool

			info.boundary = 4;
			info.storage = 4;

		} else if ( value.isVector2 ) {

			// vec2

			info.boundary = 8;
			info.storage = 8;

		} else if ( value.isVector3 || value.isColor ) {

			// vec3

			info.boundary = 16;
			info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes

		} else if ( value.isVector4 ) {

			// vec4

			info.boundary = 16;
			info.storage = 16;

		} else if ( value.isMatrix3 ) {

			// mat3 (in STD140 a 3x3 matrix is represented as 3x4)

			info.boundary = 48;
			info.storage = 48;

		} else if ( value.isMatrix4 ) {

			// mat4

			info.boundary = 64;
			info.storage = 64;

		} else if ( value.isTexture ) {

			console.warn( 'THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.' );

		} else {

			console.warn( 'THREE.WebGLRenderer: Unsupported uniform value type.', value );

		}

		return info;

	}

	function onUniformsGroupsDispose( event ) {

		const uniformsGroup = event.target;

		uniformsGroup.removeEventListener( 'dispose', onUniformsGroupsDispose );

		const index = allocatedBindingPoints.indexOf( uniformsGroup.__bindingPointIndex );
		allocatedBindingPoints.splice( index, 1 );

		gl.deleteBuffer( buffers[ uniformsGroup.id ] );

		delete buffers[ uniformsGroup.id ];
		delete updateList[ uniformsGroup.id ];

	}

	function dispose() {

		for ( const id in buffers ) {

			gl.deleteBuffer( buffers[ id ] );

		}

		allocatedBindingPoints = [];
		buffers = {};
		updateList = {};

	}

	return {

		bind: bind,
		update: update,

		dispose: dispose

	};

}

class WebGLRenderer {

	constructor( parameters = {} ) {

		const {
			canvas = createCanvasElement(),
			context = null,
			depth = true,
			stencil = false,
			alpha = false,
			antialias = false,
			premultipliedAlpha = true,
			preserveDrawingBuffer = false,
			powerPreference = 'default',
			failIfMajorPerformanceCaveat = false,
		} = parameters;

		this.isWebGLRenderer = true;

		let _alpha;

		if ( context !== null ) {

			if ( typeof WebGLRenderingContext !== 'undefined' && context instanceof WebGLRenderingContext ) {

				throw new Error( 'THREE.WebGLRenderer: WebGL 1 is not supported since r163.' );

			}

			_alpha = context.getContextAttributes().alpha;

		} else {

			_alpha = alpha;

		}

		const uintClearColor = new Uint32Array( 4 );
		const intClearColor = new Int32Array( 4 );

		let currentRenderList = null;
		let currentRenderState = null;

		// render() can be called from within a callback triggered by another render.
		// We track this so that the nested render call gets its list and state isolated from the parent render call.

		const renderListStack = [];
		const renderStateStack = [];

		// public properties

		this.domElement = canvas;

		// Debug configuration container
		this.debug = {

			/**
			 * Enables error checking and reporting when shader programs are being compiled
			 * @type {boolean}
			 */
			checkShaderErrors: true,
			/**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */
			onShaderError: null
		};

		// clearing

		this.autoClear = true;
		this.autoClearColor = true;
		this.autoClearDepth = true;
		this.autoClearStencil = true;

		// scene graph

		this.sortObjects = true;

		// user-defined clipping

		this.clippingPlanes = [];
		this.localClippingEnabled = false;

		// physically based shading

		this._outputColorSpace = SRGBColorSpace;

		// tone mapping

		this.toneMapping = NoToneMapping;
		this.toneMappingExposure = 1.0;

		// internal properties

		const _this = this;

		let _isContextLost = false;

		// internal state cache

		let _currentActiveCubeFace = 0;
		let _currentActiveMipmapLevel = 0;
		let _currentRenderTarget = null;
		let _currentMaterialId = - 1;

		let _currentCamera = null;

		const _currentViewport = new Vector4();
		const _currentScissor = new Vector4();
		let _currentScissorTest = null;

		const _currentClearColor = new Color( 0x000000 );
		let _currentClearAlpha = 0;

		//

		let _width = canvas.width;
		let _height = canvas.height;

		let _pixelRatio = 1;
		let _opaqueSort = null;
		let _transparentSort = null;

		const _viewport = new Vector4( 0, 0, _width, _height );
		const _scissor = new Vector4( 0, 0, _width, _height );
		let _scissorTest = false;

		// frustum

		const _frustum = new Frustum();

		// clipping

		let _clippingEnabled = false;
		let _localClippingEnabled = false;

		// camera matrices cache

		const _projScreenMatrix = new Matrix4();

		const _vector3 = new Vector3();

		const _vector4 = new Vector4();

		const _emptyScene = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: true };

		let _renderBackground = false;

		function getTargetPixelRatio() {

			return _currentRenderTarget === null ? _pixelRatio : 1;

		}

		// initialize

		let _gl = context;

		function getContext( contextName, contextAttributes ) {

			return canvas.getContext( contextName, contextAttributes );

		}

		try {

			const contextAttributes = {
				alpha: true,
				depth,
				stencil,
				antialias,
				premultipliedAlpha,
				preserveDrawingBuffer,
				powerPreference,
				failIfMajorPerformanceCaveat,
			};

			// OffscreenCanvas does not have setAttribute, see #22811
			if ( 'setAttribute' in canvas ) canvas.setAttribute( 'data-engine', `three.js r${REVISION}` );

			// event listeners must be registered before WebGL context is created, see #12753
			canvas.addEventListener( 'webglcontextlost', onContextLost, false );
			canvas.addEventListener( 'webglcontextrestored', onContextRestore, false );
			canvas.addEventListener( 'webglcontextcreationerror', onContextCreationError, false );

			if ( _gl === null ) {

				const contextName = 'webgl2';

				_gl = getContext( contextName, contextAttributes );

				if ( _gl === null ) {

					if ( getContext( contextName ) ) {

						throw new Error( 'Error creating WebGL context with your selected attributes.' );

					} else {

						throw new Error( 'Error creating WebGL context.' );

					}

				}

			}

		} catch ( error ) {

			console.error( 'THREE.WebGLRenderer: ' + error.message );
			throw error;

		}

		let extensions, capabilities, state, info;
		let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
		let programCache, materials, renderLists, renderStates, clipping, shadowMap;

		let background, morphtargets, bufferRenderer, indexedBufferRenderer;

		let utils, bindingStates, uniformsGroups;

		function initGLContext() {

			extensions = new WebGLExtensions( _gl );
			extensions.init();

			utils = new WebGLUtils( _gl, extensions );

			capabilities = new WebGLCapabilities( _gl, extensions, parameters, utils );

			state = new WebGLState( _gl );

			info = new WebGLInfo( _gl );
			properties = new WebGLProperties();
			textures = new WebGLTextures( _gl, extensions, state, properties, capabilities, utils, info );
			cubemaps = new WebGLCubeMaps( _this );
			cubeuvmaps = new WebGLCubeUVMaps( _this );
			attributes = new WebGLAttributes( _gl );
			bindingStates = new WebGLBindingStates( _gl, attributes );
			geometries = new WebGLGeometries( _gl, attributes, info, bindingStates );
			objects = new WebGLObjects( _gl, geometries, attributes, info );
			morphtargets = new WebGLMorphtargets( _gl, capabilities, textures );
			clipping = new WebGLClipping( properties );
			programCache = new WebGLPrograms( _this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping );
			materials = new WebGLMaterials( _this, properties );
			renderLists = new WebGLRenderLists();
			renderStates = new WebGLRenderStates( extensions );
			background = new WebGLBackground( _this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha );
			shadowMap = new WebGLShadowMap( _this, objects, capabilities );
			uniformsGroups = new WebGLUniformsGroups( _gl, info, capabilities, state );

			bufferRenderer = new WebGLBufferRenderer( _gl, extensions, info );
			indexedBufferRenderer = new WebGLIndexedBufferRenderer( _gl, extensions, info );

			info.programs = programCache.programs;

			_this.capabilities = capabilities;
			_this.extensions = extensions;
			_this.properties = properties;
			_this.renderLists = renderLists;
			_this.shadowMap = shadowMap;
			_this.state = state;
			_this.info = info;

		}

		initGLContext();

		// xr

		const xr = new WebXRManager( _this, _gl );

		this.xr = xr;

		// API

		this.getContext = function () {

			return _gl;

		};

		this.getContextAttributes = function () {

			return _gl.getContextAttributes();

		};

		this.forceContextLoss = function () {

			const extension = extensions.get( 'WEBGL_lose_context' );
			if ( extension ) extension.loseContext();

		};

		this.forceContextRestore = function () {

			const extension = extensions.get( 'WEBGL_lose_context' );
			if ( extension ) extension.restoreContext();

		};

		this.getPixelRatio = function () {

			return _pixelRatio;

		};

		this.setPixelRatio = function ( value ) {

			if ( value === undefined ) return;

			_pixelRatio = value;

			this.setSize( _width, _height, false );

		};

		this.getSize = function ( target ) {

			return target.set( _width, _height );

		};

		this.setSize = function ( width, height, updateStyle = true ) {

			if ( xr.isPresenting ) {

				console.warn( 'THREE.WebGLRenderer: Can\'t change size while VR device is presenting.' );
				return;

			}

			_width = width;
			_height = height;

			canvas.width = Math.floor( width * _pixelRatio );
			canvas.height = Math.floor( height * _pixelRatio );

			if ( updateStyle === true ) {

				canvas.style.width = width + 'px';
				canvas.style.height = height + 'px';

			}

			this.setViewport( 0, 0, width, height );

		};

		this.getDrawingBufferSize = function ( target ) {

			return target.set( _width * _pixelRatio, _height * _pixelRatio ).floor();

		};

		this.setDrawingBufferSize = function ( width, height, pixelRatio ) {

			_width = width;
			_height = height;

			_pixelRatio = pixelRatio;

			canvas.width = Math.floor( width * pixelRatio );
			canvas.height = Math.floor( height * pixelRatio );

			this.setViewport( 0, 0, width, height );

		};

		this.getCurrentViewport = function ( target ) {

			return target.copy( _currentViewport );

		};

		this.getViewport = function ( target ) {

			return target.copy( _viewport );

		};

		this.setViewport = function ( x, y, width, height ) {

			if ( x.isVector4 ) {

				_viewport.set( x.x, x.y, x.z, x.w );

			} else {

				_viewport.set( x, y, width, height );

			}

			state.viewport( _currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio ).round() );

		};

		this.getScissor = function ( target ) {

			return target.copy( _scissor );

		};

		this.setScissor = function ( x, y, width, height ) {

			if ( x.isVector4 ) {

				_scissor.set( x.x, x.y, x.z, x.w );

			} else {

				_scissor.set( x, y, width, height );

			}

			state.scissor( _currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio ).round() );

		};

		this.getScissorTest = function () {

			return _scissorTest;

		};

		this.setScissorTest = function ( boolean ) {

			state.setScissorTest( _scissorTest = boolean );

		};

		this.setOpaqueSort = function ( method ) {

			_opaqueSort = method;

		};

		this.setTransparentSort = function ( method ) {

			_transparentSort = method;

		};

		// Clearing

		this.getClearColor = function ( target ) {

			return target.copy( background.getClearColor() );

		};

		this.setClearColor = function () {

			background.setClearColor.apply( background, arguments );

		};

		this.getClearAlpha = function () {

			return background.getClearAlpha();

		};

		this.setClearAlpha = function () {

			background.setClearAlpha.apply( background, arguments );

		};

		this.clear = function ( color = true, depth = true, stencil = true ) {

			let bits = 0;

			if ( color ) {

				// check if we're trying to clear an integer target
				let isIntegerFormat = false;
				if ( _currentRenderTarget !== null ) {

					const targetFormat = _currentRenderTarget.texture.format;
					isIntegerFormat = targetFormat === RGBAIntegerFormat ||
						targetFormat === RGIntegerFormat ||
						targetFormat === RedIntegerFormat;

				}

				// use the appropriate clear functions to clear the target if it's a signed
				// or unsigned integer target
				if ( isIntegerFormat ) {

					const targetType = _currentRenderTarget.texture.type;
					const isUnsignedType = targetType === UnsignedByteType ||
						targetType === UnsignedIntType ||
						targetType === UnsignedShortType ||
						targetType === UnsignedInt248Type ||
						targetType === UnsignedShort4444Type ||
						targetType === UnsignedShort5551Type;

					const clearColor = background.getClearColor();
					const a = background.getClearAlpha();
					const r = clearColor.r;
					const g = clearColor.g;
					const b = clearColor.b;

					if ( isUnsignedType ) {

						uintClearColor[ 0 ] = r;
						uintClearColor[ 1 ] = g;
						uintClearColor[ 2 ] = b;
						uintClearColor[ 3 ] = a;
						_gl.clearBufferuiv( _gl.COLOR, 0, uintClearColor );

					} else {

						intClearColor[ 0 ] = r;
						intClearColor[ 1 ] = g;
						intClearColor[ 2 ] = b;
						intClearColor[ 3 ] = a;
						_gl.clearBufferiv( _gl.COLOR, 0, intClearColor );

					}

				} else {

					bits |= _gl.COLOR_BUFFER_BIT;

				}

			}

			if ( depth ) bits |= _gl.DEPTH_BUFFER_BIT;
			if ( stencil ) {

				bits |= _gl.STENCIL_BUFFER_BIT;
				this.state.buffers.stencil.setMask( 0xffffffff );

			}

			_gl.clear( bits );

		};

		this.clearColor = function () {

			this.clear( true, false, false );

		};

		this.clearDepth = function () {

			this.clear( false, true, false );

		};

		this.clearStencil = function () {

			this.clear( false, false, true );

		};

		//

		this.dispose = function () {

			canvas.removeEventListener( 'webglcontextlost', onContextLost, false );
			canvas.removeEventListener( 'webglcontextrestored', onContextRestore, false );
			canvas.removeEventListener( 'webglcontextcreationerror', onContextCreationError, false );

			renderLists.dispose();
			renderStates.dispose();
			properties.dispose();
			cubemaps.dispose();
			cubeuvmaps.dispose();
			objects.dispose();
			bindingStates.dispose();
			uniformsGroups.dispose();
			programCache.dispose();

			xr.dispose();

			xr.removeEventListener( 'sessionstart', onXRSessionStart );
			xr.removeEventListener( 'sessionend', onXRSessionEnd );

			animation.stop();

		};

		// Events

		function onContextLost( event ) {

			event.preventDefault();

			console.log( 'THREE.WebGLRenderer: Context Lost.' );

			_isContextLost = true;

		}

		function onContextRestore( /* event */ ) {

			console.log( 'THREE.WebGLRenderer: Context Restored.' );

			_isContextLost = false;

			const infoAutoReset = info.autoReset;
			const shadowMapEnabled = shadowMap.enabled;
			const shadowMapAutoUpdate = shadowMap.autoUpdate;
			const shadowMapNeedsUpdate = shadowMap.needsUpdate;
			const shadowMapType = shadowMap.type;

			initGLContext();

			info.autoReset = infoAutoReset;
			shadowMap.enabled = shadowMapEnabled;
			shadowMap.autoUpdate = shadowMapAutoUpdate;
			shadowMap.needsUpdate = shadowMapNeedsUpdate;
			shadowMap.type = shadowMapType;

		}

		function onContextCreationError( event ) {

			console.error( 'THREE.WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage );

		}

		function onMaterialDispose( event ) {

			const material = event.target;

			material.removeEventListener( 'dispose', onMaterialDispose );

			deallocateMaterial( material );

		}

		// Buffer deallocation

		function deallocateMaterial( material ) {

			releaseMaterialProgramReferences( material );

			properties.remove( material );

		}


		function releaseMaterialProgramReferences( material ) {

			const programs = properties.get( material ).programs;

			if ( programs !== undefined ) {

				programs.forEach( function ( program ) {

					programCache.releaseProgram( program );

				} );

				if ( material.isShaderMaterial ) {

					programCache.releaseShaderCache( material );

				}

			}

		}

		// Buffer rendering

		this.renderBufferDirect = function ( camera, scene, geometry, material, object, group ) {

			if ( scene === null ) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)

			const frontFaceCW = ( object.isMesh && object.matrixWorld.determinant() < 0 );

			const program = setProgram( camera, scene, geometry, material, object );

			state.setMaterial( material, frontFaceCW );

			//

			let index = geometry.index;
			let rangeFactor = 1;

			if ( material.wireframe === true ) {

				index = geometries.getWireframeAttribute( geometry );

				if ( index === undefined ) return;

				rangeFactor = 2;

			}

			//

			const drawRange = geometry.drawRange;
			const position = geometry.attributes.position;

			let drawStart = drawRange.start * rangeFactor;
			let drawEnd = ( drawRange.start + drawRange.count ) * rangeFactor;

			if ( group !== null ) {

				drawStart = Math.max( drawStart, group.start * rangeFactor );
				drawEnd = Math.min( drawEnd, ( group.start + group.count ) * rangeFactor );

			}

			if ( index !== null ) {

				drawStart = Math.max( drawStart, 0 );
				drawEnd = Math.min( drawEnd, index.count );

			} else if ( position !== undefined && position !== null ) {

				drawStart = Math.max( drawStart, 0 );
				drawEnd = Math.min( drawEnd, position.count );

			}

			const drawCount = drawEnd - drawStart;

			if ( drawCount < 0 || drawCount === Infinity ) return;

			//

			bindingStates.setup( object, material, program, geometry, index );

			let attribute;
			let renderer = bufferRenderer;

			if ( index !== null ) {

				attribute = attributes.get( index );

				renderer = indexedBufferRenderer;
				renderer.setIndex( attribute );

			}

			//

			if ( object.isMesh ) {

				if ( material.wireframe === true ) {

					state.setLineWidth( material.wireframeLinewidth * getTargetPixelRatio() );
					renderer.setMode( _gl.LINES );

				} else {

					renderer.setMode( _gl.TRIANGLES );

				}

			} else if ( object.isLine ) {

				let lineWidth = material.linewidth;

				if ( lineWidth === undefined ) lineWidth = 1; // Not using Line*Material

				state.setLineWidth( lineWidth * getTargetPixelRatio() );

				if ( object.isLineSegments ) {

					renderer.setMode( _gl.LINES );

				} else if ( object.isLineLoop ) {

					renderer.setMode( _gl.LINE_LOOP );

				} else {

					renderer.setMode( _gl.LINE_STRIP );

				}

			} else if ( object.isPoints ) {

				renderer.setMode( _gl.POINTS );

			} else if ( object.isSprite ) {

				renderer.setMode( _gl.TRIANGLES );

			}

			if ( object.isBatchedMesh ) {

				if ( object._multiDrawInstances !== null ) {

					renderer.renderMultiDrawInstances( object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount, object._multiDrawInstances );

				} else {

					if ( ! extensions.get( 'WEBGL_multi_draw' ) ) {

						const starts = object._multiDrawStarts;
						const counts = object._multiDrawCounts;
						const drawCount = object._multiDrawCount;
						const bytesPerElement = index ? attributes.get( index ).bytesPerElement : 1;
						const uniforms = properties.get( material ).currentProgram.getUniforms();
						for ( let i = 0; i < drawCount; i ++ ) {

							uniforms.setValue( _gl, '_gl_DrawID', i );
							renderer.render( starts[ i ] / bytesPerElement, counts[ i ] );

						}

					} else {

						renderer.renderMultiDraw( object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount );

					}

				}

			} else if ( object.isInstancedMesh ) {

				renderer.renderInstances( drawStart, drawCount, object.count );

			} else if ( geometry.isInstancedBufferGeometry ) {

				const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
				const instanceCount = Math.min( geometry.instanceCount, maxInstanceCount );

				renderer.renderInstances( drawStart, drawCount, instanceCount );

			} else {

				renderer.render( drawStart, drawCount );

			}

		};

		// Compile

		function prepareMaterial( material, scene, object ) {

			if ( material.transparent === true && material.side === DoubleSide && material.forceSinglePass === false ) {

				material.side = BackSide;
				material.needsUpdate = true;
				getProgram( material, scene, object );

				material.side = FrontSide;
				material.needsUpdate = true;
				getProgram( material, scene, object );

				material.side = DoubleSide;

			} else {

				getProgram( material, scene, object );

			}

		}

		this.compile = function ( scene, camera, targetScene = null ) {

			if ( targetScene === null ) targetScene = scene;

			currentRenderState = renderStates.get( targetScene );
			currentRenderState.init( camera );

			renderStateStack.push( currentRenderState );

			// gather lights from both the target scene and the new object that will be added to the scene.

			targetScene.traverseVisible( function ( object ) {

				if ( object.isLight && object.layers.test( camera.layers ) ) {

					currentRenderState.pushLight( object );

					if ( object.castShadow ) {

						currentRenderState.pushShadow( object );

					}

				}

			} );

			if ( scene !== targetScene ) {

				scene.traverseVisible( function ( object ) {

					if ( object.isLight && object.layers.test( camera.layers ) ) {

						currentRenderState.pushLight( object );

						if ( object.castShadow ) {

							currentRenderState.pushShadow( object );

						}

					}

				} );

			}

			currentRenderState.setupLights();

			// Only initialize materials in the new scene, not the targetScene.

			const materials = new Set();

			scene.traverse( function ( object ) {

				const material = object.material;

				if ( material ) {

					if ( Array.isArray( material ) ) {

						for ( let i = 0; i < material.length; i ++ ) {

							const material2 = material[ i ];

							prepareMaterial( material2, targetScene, object );
							materials.add( material2 );

						}

					} else {

						prepareMaterial( material, targetScene, object );
						materials.add( material );

					}

				}

			} );

			renderStateStack.pop();
			currentRenderState = null;

			return materials;

		};

		// compileAsync

		this.compileAsync = function ( scene, camera, targetScene = null ) {

			const materials = this.compile( scene, camera, targetScene );

			// Wait for all the materials in the new object to indicate that they're
			// ready to be used before resolving the promise.

			return new Promise( ( resolve ) => {

				function checkMaterialsReady() {

					materials.forEach( function ( material ) {

						const materialProperties = properties.get( material );
						const program = materialProperties.currentProgram;

						if ( program.isReady() ) {

							// remove any programs that report they're ready to use from the list
							materials.delete( material );

						}

					} );

					// once the list of compiling materials is empty, call the callback

					if ( materials.size === 0 ) {

						resolve( scene );
						return;

					}

					// if some materials are still not ready, wait a bit and check again

					setTimeout( checkMaterialsReady, 10 );

				}

				if ( extensions.get( 'KHR_parallel_shader_compile' ) !== null ) {

					// If we can check the compilation status of the materials without
					// blocking then do so right away.

					checkMaterialsReady();

				} else {

					// Otherwise start by waiting a bit to give the materials we just
					// initialized a chance to finish.

					setTimeout( checkMaterialsReady, 10 );

				}

			} );

		};

		// Animation Loop

		let onAnimationFrameCallback = null;

		function onAnimationFrame( time ) {

			if ( onAnimationFrameCallback ) onAnimationFrameCallback( time );

		}

		function onXRSessionStart() {

			animation.stop();

		}

		function onXRSessionEnd() {

			animation.start();

		}

		const animation = new WebGLAnimation();
		animation.setAnimationLoop( onAnimationFrame );

		if ( typeof self !== 'undefined' ) animation.setContext( self );

		this.setAnimationLoop = function ( callback ) {

			onAnimationFrameCallback = callback;
			xr.setAnimationLoop( callback );

			( callback === null ) ? animation.stop() : animation.start();

		};

		xr.addEventListener( 'sessionstart', onXRSessionStart );
		xr.addEventListener( 'sessionend', onXRSessionEnd );

		// Rendering

		this.render = function ( scene, camera ) {

			if ( camera !== undefined && camera.isCamera !== true ) {

				console.error( 'THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.' );
				return;

			}

			if ( _isContextLost === true ) return;

			// update scene graph

			if ( scene.matrixWorldAutoUpdate === true ) scene.updateMatrixWorld();

			// update camera matrices and frustum

			if ( camera.parent === null && camera.matrixWorldAutoUpdate === true ) camera.updateMatrixWorld();

			if ( xr.enabled === true && xr.isPresenting === true ) {

				if ( xr.cameraAutoUpdate === true ) xr.updateCamera( camera );

				camera = xr.getCamera(); // use XR camera for rendering

			}

			//
			if ( scene.isScene === true ) scene.onBeforeRender( _this, scene, camera, _currentRenderTarget );

			currentRenderState = renderStates.get( scene, renderStateStack.length );
			currentRenderState.init( camera );

			renderStateStack.push( currentRenderState );

			_projScreenMatrix.multiplyMatrices( camera.projectionMatrix, camera.matrixWorldInverse );
			_frustum.setFromProjectionMatrix( _projScreenMatrix );

			_localClippingEnabled = this.localClippingEnabled;
			_clippingEnabled = clipping.init( this.clippingPlanes, _localClippingEnabled );

			currentRenderList = renderLists.get( scene, renderListStack.length );
			currentRenderList.init();

			renderListStack.push( currentRenderList );

			if ( xr.enabled === true && xr.isPresenting === true ) {

				const depthSensingMesh = _this.xr.getDepthSensingMesh();

				if ( depthSensingMesh !== null ) {

					projectObject( depthSensingMesh, camera, - Infinity, _this.sortObjects );

				}

			}

			projectObject( scene, camera, 0, _this.sortObjects );

			currentRenderList.finish();

			if ( _this.sortObjects === true ) {

				currentRenderList.sort( _opaqueSort, _transparentSort );

			}

			_renderBackground = xr.enabled === false || xr.isPresenting === false || xr.hasDepthSensing() === false;
			if ( _renderBackground ) {

				background.addToRenderList( currentRenderList, scene );

			}

			//

			this.info.render.frame ++;

			if ( _clippingEnabled === true ) clipping.beginShadows();

			const shadowsArray = currentRenderState.state.shadowsArray;

			shadowMap.render( shadowsArray, scene, camera );

			if ( _clippingEnabled === true ) clipping.endShadows();

			//

			if ( this.info.autoReset === true ) this.info.reset();

			// render scene

			const opaqueObjects = currentRenderList.opaque;
			const transmissiveObjects = currentRenderList.transmissive;

			currentRenderState.setupLights();

			if ( camera.isArrayCamera ) {

				const cameras = camera.cameras;

				if ( transmissiveObjects.length > 0 ) {

					for ( let i = 0, l = cameras.length; i < l; i ++ ) {

						const camera2 = cameras[ i ];

						renderTransmissionPass( opaqueObjects, transmissiveObjects, scene, camera2 );

					}

				}

				if ( _renderBackground ) background.render( scene );

				for ( let i = 0, l = cameras.length; i < l; i ++ ) {

					const camera2 = cameras[ i ];

					renderScene( currentRenderList, scene, camera2, camera2.viewport );

				}

			} else {

				if ( transmissiveObjects.length > 0 ) renderTransmissionPass( opaqueObjects, transmissiveObjects, scene, camera );

				if ( _renderBackground ) background.render( scene );

				renderScene( currentRenderList, scene, camera );

			}

			//

			if ( _currentRenderTarget !== null ) {

				// resolve multisample renderbuffers to a single-sample texture if necessary

				textures.updateMultisampleRenderTarget( _currentRenderTarget );

				// Generate mipmap if we're using any kind of mipmap filtering

				textures.updateRenderTargetMipmap( _currentRenderTarget );

			}

			//

			if ( scene.isScene === true ) scene.onAfterRender( _this, scene, camera );

			// _gl.finish();

			bindingStates.resetDefaultState();
			_currentMaterialId = - 1;
			_currentCamera = null;

			renderStateStack.pop();

			if ( renderStateStack.length > 0 ) {

				currentRenderState = renderStateStack[ renderStateStack.length - 1 ];

				if ( _clippingEnabled === true ) clipping.setGlobalState( _this.clippingPlanes, currentRenderState.state.camera );

			} else {

				currentRenderState = null;

			}

			renderListStack.pop();

			if ( renderListStack.length > 0 ) {

				currentRenderList = renderListStack[ renderListStack.length - 1 ];

			} else {

				currentRenderList = null;

			}

		};

		function projectObject( object, camera, groupOrder, sortObjects ) {

			if ( object.visible === false ) return;

			const visible = object.layers.test( camera.layers );

			if ( visible ) {

				if ( object.isGroup ) {

					groupOrder = object.renderOrder;

				} else if ( object.isLOD ) {

					if ( object.autoUpdate === true ) object.update( camera );

				} else if ( object.isLight ) {

					currentRenderState.pushLight( object );

					if ( object.castShadow ) {

						currentRenderState.pushShadow( object );

					}

				} else if ( object.isSprite ) {

					if ( ! object.frustumCulled || _frustum.intersectsSprite( object ) ) {

						if ( sortObjects ) {

							_vector4.setFromMatrixPosition( object.matrixWorld )
								.applyMatrix4( _projScreenMatrix );

						}

						const geometry = objects.update( object );
						const material = object.material;

						if ( material.visible ) {

							currentRenderList.push( object, geometry, material, groupOrder, _vector4.z, null );

						}

					}

				} else if ( object.isMesh || object.isLine || object.isPoints ) {

					if ( ! object.frustumCulled || _frustum.intersectsObject( object ) ) {

						const geometry = objects.update( object );
						const material = object.material;

						if ( sortObjects ) {

							if ( object.boundingSphere !== undefined ) {

								if ( object.boundingSphere === null ) object.computeBoundingSphere();
								_vector4.copy( object.boundingSphere.center );

							} else {

								if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();
								_vector4.copy( geometry.boundingSphere.center );

							}

							_vector4
								.applyMatrix4( object.matrixWorld )
								.applyMatrix4( _projScreenMatrix );

						}

						if ( Array.isArray( material ) ) {

							const groups = geometry.groups;

							for ( let i = 0, l = groups.length; i < l; i ++ ) {

								const group = groups[ i ];
								const groupMaterial = material[ group.materialIndex ];

								if ( groupMaterial && groupMaterial.visible ) {

									currentRenderList.push( object, geometry, groupMaterial, groupOrder, _vector4.z, group );

								}

							}

						} else if ( material.visible ) {

							currentRenderList.push( object, geometry, material, groupOrder, _vector4.z, null );

						}

					}

				}

			}

			const children = object.children;

			for ( let i = 0, l = children.length; i < l; i ++ ) {

				projectObject( children[ i ], camera, groupOrder, sortObjects );

			}

		}

		function renderScene( currentRenderList, scene, camera, viewport ) {

			const opaqueObjects = currentRenderList.opaque;
			const transmissiveObjects = currentRenderList.transmissive;
			const transparentObjects = currentRenderList.transparent;

			currentRenderState.setupLightsView( camera );

			if ( _clippingEnabled === true ) clipping.setGlobalState( _this.clippingPlanes, camera );

			if ( viewport ) state.viewport( _currentViewport.copy( viewport ) );

			if ( opaqueObjects.length > 0 ) renderObjects( opaqueObjects, scene, camera );
			if ( transmissiveObjects.length > 0 ) renderObjects( transmissiveObjects, scene, camera );
			if ( transparentObjects.length > 0 ) renderObjects( transparentObjects, scene, camera );

			// Ensure depth buffer writing is enabled so it can be cleared on next render

			state.buffers.depth.setTest( true );
			state.buffers.depth.setMask( true );
			state.buffers.color.setMask( true );

			state.setPolygonOffset( false );

		}

		function renderTransmissionPass( opaqueObjects, transmissiveObjects, scene, camera ) {

			const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;

			if ( overrideMaterial !== null ) {

				return;

			}

			if ( currentRenderState.state.transmissionRenderTarget[ camera.id ] === undefined ) {

				currentRenderState.state.transmissionRenderTarget[ camera.id ] = new WebGLRenderTarget( 1, 1, {
					generateMipmaps: true,
					type: ( extensions.has( 'EXT_color_buffer_half_float' ) || extensions.has( 'EXT_color_buffer_float' ) ) ? HalfFloatType : UnsignedByteType,
					minFilter: LinearMipmapLinearFilter,
					samples: 4,
					stencilBuffer: stencil,
					resolveDepthBuffer: false,
					resolveStencilBuffer: false,
					colorSpace: ColorManagement.workingColorSpace,
				} );

				// debug

				/*
				const geometry = new PlaneGeometry();
				const material = new MeshBasicMaterial( { map: _transmissionRenderTarget.texture } );

				const mesh = new Mesh( geometry, material );
				scene.add( mesh );
				*/

			}

			const transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget[ camera.id ];

			const activeViewport = camera.viewport || _currentViewport;
			transmissionRenderTarget.setSize( activeViewport.z, activeViewport.w );

			//

			const currentRenderTarget = _this.getRenderTarget();
			_this.setRenderTarget( transmissionRenderTarget );

			_this.getClearColor( _currentClearColor );
			_currentClearAlpha = _this.getClearAlpha();
			if ( _currentClearAlpha < 1 ) _this.setClearColor( 0xffffff, 0.5 );

			if ( _renderBackground ) {

				background.render( scene );

			} else {

				_this.clear();

			}

			// Turn off the features which can affect the frag color for opaque objects pass.
			// Otherwise they are applied twice in opaque objects pass and transmission objects pass.
			const currentToneMapping = _this.toneMapping;
			_this.toneMapping = NoToneMapping;

			// Remove viewport from camera to avoid nested render calls resetting viewport to it (e.g Reflector).
			// Transmission render pass requires viewport to match the transmissionRenderTarget.
			const currentCameraViewport = camera.viewport;
			if ( camera.viewport !== undefined ) camera.viewport = undefined;

			currentRenderState.setupLightsView( camera );

			if ( _clippingEnabled === true ) clipping.setGlobalState( _this.clippingPlanes, camera );

			renderObjects( opaqueObjects, scene, camera );

			textures.updateMultisampleRenderTarget( transmissionRenderTarget );
			textures.updateRenderTargetMipmap( transmissionRenderTarget );

			if ( extensions.has( 'WEBGL_multisampled_render_to_texture' ) === false ) { // see #28131

				let renderTargetNeedsUpdate = false;

				for ( let i = 0, l = transmissiveObjects.length; i < l; i ++ ) {

					const renderItem = transmissiveObjects[ i ];

					const object = renderItem.object;
					const geometry = renderItem.geometry;
					const material = renderItem.material;
					const group = renderItem.group;

					if ( material.side === DoubleSide && object.layers.test( camera.layers ) ) {

						const currentSide = material.side;

						material.side = BackSide;
						material.needsUpdate = true;

						renderObject( object, scene, camera, geometry, material, group );

						material.side = currentSide;
						material.needsUpdate = true;

						renderTargetNeedsUpdate = true;

					}

				}

				if ( renderTargetNeedsUpdate === true ) {

					textures.updateMultisampleRenderTarget( transmissionRenderTarget );
					textures.updateRenderTargetMipmap( transmissionRenderTarget );

				}

			}

			_this.setRenderTarget( currentRenderTarget );

			_this.setClearColor( _currentClearColor, _currentClearAlpha );

			if ( currentCameraViewport !== undefined ) camera.viewport = currentCameraViewport;

			_this.toneMapping = currentToneMapping;

		}

		function renderObjects( renderList, scene, camera ) {

			const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;

			for ( let i = 0, l = renderList.length; i < l; i ++ ) {

				const renderItem = renderList[ i ];

				const object = renderItem.object;
				const geometry = renderItem.geometry;
				const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
				const group = renderItem.group;

				if ( object.layers.test( camera.layers ) ) {

					renderObject( object, scene, camera, geometry, material, group );

				}

			}

		}

		function renderObject( object, scene, camera, geometry, material, group ) {

			object.onBeforeRender( _this, scene, camera, geometry, material, group );

			object.modelViewMatrix.multiplyMatrices( camera.matrixWorldInverse, object.matrixWorld );
			object.normalMatrix.getNormalMatrix( object.modelViewMatrix );

			if ( material.transparent === true && material.side === DoubleSide && material.forceSinglePass === false ) {

				material.side = BackSide;
				material.needsUpdate = true;
				_this.renderBufferDirect( camera, scene, geometry, material, object, group );

				material.side = FrontSide;
				material.needsUpdate = true;
				_this.renderBufferDirect( camera, scene, geometry, material, object, group );

				material.side = DoubleSide;

			} else {

				_this.renderBufferDirect( camera, scene, geometry, material, object, group );

			}

			object.onAfterRender( _this, scene, camera, geometry, material, group );

		}

		function getProgram( material, scene, object ) {

			if ( scene.isScene !== true ) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...

			const materialProperties = properties.get( material );

			const lights = currentRenderState.state.lights;
			const shadowsArray = currentRenderState.state.shadowsArray;

			const lightsStateVersion = lights.state.version;

			const parameters = programCache.getParameters( material, lights.state, shadowsArray, scene, object );
			const programCacheKey = programCache.getProgramCacheKey( parameters );

			let programs = materialProperties.programs;

			// always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change

			materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
			materialProperties.fog = scene.fog;
			materialProperties.envMap = ( material.isMeshStandardMaterial ? cubeuvmaps : cubemaps ).get( material.envMap || materialProperties.environment );
			materialProperties.envMapRotation = ( materialProperties.environment !== null && material.envMap === null ) ? scene.environmentRotation : material.envMapRotation;

			if ( programs === undefined ) {

				// new material

				material.addEventListener( 'dispose', onMaterialDispose );

				programs = new Map();
				materialProperties.programs = programs;

			}

			let program = programs.get( programCacheKey );

			if ( program !== undefined ) {

				// early out if program and light state is identical

				if ( materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion ) {

					updateCommonMaterialProperties( material, parameters );

					return program;

				}

			} else {

				parameters.uniforms = programCache.getUniforms( material );

				material.onBeforeCompile( parameters, _this );

				program = programCache.acquireProgram( parameters, programCacheKey );
				programs.set( programCacheKey, program );

				materialProperties.uniforms = parameters.uniforms;

			}

			const uniforms = materialProperties.uniforms;

			if ( ( ! material.isShaderMaterial && ! material.isRawShaderMaterial ) || material.clipping === true ) {

				uniforms.clippingPlanes = clipping.uniform;

			}

			updateCommonMaterialProperties( material, parameters );

			// store the light setup it was created for

			materialProperties.needsLights = materialNeedsLights( material );
			materialProperties.lightsStateVersion = lightsStateVersion;

			if ( materialProperties.needsLights ) {

				// wire up the material to this renderer's lighting state

				uniforms.ambientLightColor.value = lights.state.ambient;
				uniforms.lightProbe.value = lights.state.probe;
				uniforms.directionalLights.value = lights.state.directional;
				uniforms.directionalLightShadows.value = lights.state.directionalShadow;
				uniforms.spotLights.value = lights.state.spot;
				uniforms.spotLightShadows.value = lights.state.spotShadow;
				uniforms.rectAreaLights.value = lights.state.rectArea;
				uniforms.ltc_1.value = lights.state.rectAreaLTC1;
				uniforms.ltc_2.value = lights.state.rectAreaLTC2;
				uniforms.pointLights.value = lights.state.point;
				uniforms.pointLightShadows.value = lights.state.pointShadow;
				uniforms.hemisphereLights.value = lights.state.hemi;

				uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
				uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
				uniforms.spotShadowMap.value = lights.state.spotShadowMap;
				uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
				uniforms.spotLightMap.value = lights.state.spotLightMap;
				uniforms.pointShadowMap.value = lights.state.pointShadowMap;
				uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
				// TODO (abelnation): add area lights shadow info to uniforms

			}

			materialProperties.currentProgram = program;
			materialProperties.uniformsList = null;

			return program;

		}

		function getUniformList( materialProperties ) {

			if ( materialProperties.uniformsList === null ) {

				const progUniforms = materialProperties.currentProgram.getUniforms();
				materialProperties.uniformsList = WebGLUniforms.seqWithValue( progUniforms.seq, materialProperties.uniforms );

			}

			return materialProperties.uniformsList;

		}

		function updateCommonMaterialProperties( material, parameters ) {

			const materialProperties = properties.get( material );

			materialProperties.outputColorSpace = parameters.outputColorSpace;
			materialProperties.batching = parameters.batching;
			materialProperties.batchingColor = parameters.batchingColor;
			materialProperties.instancing = parameters.instancing;
			materialProperties.instancingColor = parameters.instancingColor;
			materialProperties.instancingMorph = parameters.instancingMorph;
			materialProperties.skinning = parameters.skinning;
			materialProperties.morphTargets = parameters.morphTargets;
			materialProperties.morphNormals = parameters.morphNormals;
			materialProperties.morphColors = parameters.morphColors;
			materialProperties.morphTargetsCount = parameters.morphTargetsCount;
			materialProperties.numClippingPlanes = parameters.numClippingPlanes;
			materialProperties.numIntersection = parameters.numClipIntersection;
			materialProperties.vertexAlphas = parameters.vertexAlphas;
			materialProperties.vertexTangents = parameters.vertexTangents;
			materialProperties.toneMapping = parameters.toneMapping;

		}

		function setProgram( camera, scene, geometry, material, object ) {

			if ( scene.isScene !== true ) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...

			textures.resetTextureUnits();

			const fog = scene.fog;
			const environment = material.isMeshStandardMaterial ? scene.environment : null;
			const colorSpace = ( _currentRenderTarget === null ) ? _this.outputColorSpace : ( _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : LinearSRGBColorSpace );
			const envMap = ( material.isMeshStandardMaterial ? cubeuvmaps : cubemaps ).get( material.envMap || environment );
			const vertexAlphas = material.vertexColors === true && !! geometry.attributes.color && geometry.attributes.color.itemSize === 4;
			const vertexTangents = !! geometry.attributes.tangent && ( !! material.normalMap || material.anisotropy > 0 );
			const morphTargets = !! geometry.morphAttributes.position;
			const morphNormals = !! geometry.morphAttributes.normal;
			const morphColors = !! geometry.morphAttributes.color;

			let toneMapping = NoToneMapping;

			if ( material.toneMapped ) {

				if ( _currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true ) {

					toneMapping = _this.toneMapping;

				}

			}

			const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
			const morphTargetsCount = ( morphAttribute !== undefined ) ? morphAttribute.length : 0;

			const materialProperties = properties.get( material );
			const lights = currentRenderState.state.lights;

			if ( _clippingEnabled === true ) {

				if ( _localClippingEnabled === true || camera !== _currentCamera ) {

					const useCache =
						camera === _currentCamera &&
						material.id === _currentMaterialId;

					// we might want to call this function with some ClippingGroup
					// object instead of the material, once it becomes feasible
					// (#8465, #8379)
					clipping.setState( material, camera, useCache );

				}

			}

			//

			let needsProgramChange = false;

			if ( material.version === materialProperties.__version ) {

				if ( materialProperties.needsLights && ( materialProperties.lightsStateVersion !== lights.state.version ) ) {

					needsProgramChange = true;

				} else if ( materialProperties.outputColorSpace !== colorSpace ) {

					needsProgramChange = true;

				} else if ( object.isBatchedMesh && materialProperties.batching === false ) {

					needsProgramChange = true;

				} else if ( ! object.isBatchedMesh && materialProperties.batching === true ) {

					needsProgramChange = true;

				} else if ( object.isBatchedMesh && materialProperties.batchingColor === true && object.colorTexture === null ) {

					needsProgramChange = true;

				} else if ( object.isBatchedMesh && materialProperties.batchingColor === false && object.colorTexture !== null ) {

					needsProgramChange = true;

				} else if ( object.isInstancedMesh && materialProperties.instancing === false ) {

					needsProgramChange = true;

				} else if ( ! object.isInstancedMesh && materialProperties.instancing === true ) {

					needsProgramChange = true;

				} else if ( object.isSkinnedMesh && materialProperties.skinning === false ) {

					needsProgramChange = true;

				} else if ( ! object.isSkinnedMesh && materialProperties.skinning === true ) {

					needsProgramChange = true;

				} else if ( object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null ) {

					needsProgramChange = true;

				} else if ( object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null ) {

					needsProgramChange = true;

				} else if ( object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null ) {

					needsProgramChange = true;

				} else if ( object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null ) {

					needsProgramChange = true;

				} else if ( materialProperties.envMap !== envMap ) {

					needsProgramChange = true;

				} else if ( material.fog === true && materialProperties.fog !== fog ) {

					needsProgramChange = true;

				} else if ( materialProperties.numClippingPlanes !== undefined &&
					( materialProperties.numClippingPlanes !== clipping.numPlanes ||
					materialProperties.numIntersection !== clipping.numIntersection ) ) {

					needsProgramChange = true;

				} else if ( materialProperties.vertexAlphas !== vertexAlphas ) {

					needsProgramChange = true;

				} else if ( materialProperties.vertexTangents !== vertexTangents ) {

					needsProgramChange = true;

				} else if ( materialProperties.morphTargets !== morphTargets ) {

					needsProgramChange = true;

				} else if ( materialProperties.morphNormals !== morphNormals ) {

					needsProgramChange = true;

				} else if ( materialProperties.morphColors !== morphColors ) {

					needsProgramChange = true;

				} else if ( materialProperties.toneMapping !== toneMapping ) {

					needsProgramChange = true;

				} else if ( materialProperties.morphTargetsCount !== morphTargetsCount ) {

					needsProgramChange = true;

				}

			} else {

				needsProgramChange = true;
				materialProperties.__version = material.version;

			}

			//

			let program = materialProperties.currentProgram;

			if ( needsProgramChange === true ) {

				program = getProgram( material, scene, object );

			}

			let refreshProgram = false;
			let refreshMaterial = false;
			let refreshLights = false;

			const p_uniforms = program.getUniforms(),
				m_uniforms = materialProperties.uniforms;

			if ( state.useProgram( program.program ) ) {

				refreshProgram = true;
				refreshMaterial = true;
				refreshLights = true;

			}

			if ( material.id !== _currentMaterialId ) {

				_currentMaterialId = material.id;

				refreshMaterial = true;

			}

			if ( refreshProgram || _currentCamera !== camera ) {

				// common camera uniforms

				p_uniforms.setValue( _gl, 'projectionMatrix', camera.projectionMatrix );
				p_uniforms.setValue( _gl, 'viewMatrix', camera.matrixWorldInverse );

				const uCamPos = p_uniforms.map.cameraPosition;

				if ( uCamPos !== undefined ) {

					uCamPos.setValue( _gl, _vector3.setFromMatrixPosition( camera.matrixWorld ) );

				}

				if ( capabilities.logarithmicDepthBuffer ) {

					p_uniforms.setValue( _gl, 'logDepthBufFC',
						2.0 / ( Math.log( camera.far + 1.0 ) / Math.LN2 ) );

				}

				// consider moving isOrthographic to UniformLib and WebGLMaterials, see https://github.com/mrdoob/three.js/pull/26467#issuecomment-1645185067

				if ( material.isMeshPhongMaterial ||
					material.isMeshToonMaterial ||
					material.isMeshLambertMaterial ||
					material.isMeshBasicMaterial ||
					material.isMeshStandardMaterial ||
					material.isShaderMaterial ) {

					p_uniforms.setValue( _gl, 'isOrthographic', camera.isOrthographicCamera === true );

				}

				if ( _currentCamera !== camera ) {

					_currentCamera = camera;

					// lighting uniforms depend on the camera so enforce an update
					// now, in case this material supports lights - or later, when
					// the next material that does gets activated:

					refreshMaterial = true;		// set to true on material change
					refreshLights = true;		// remains set until update done

				}

			}

			// skinning and morph target uniforms must be set even if material didn't change
			// auto-setting of texture unit for bone and morph texture must go before other textures
			// otherwise textures used for skinning and morphing can take over texture units reserved for other material textures

			if ( object.isSkinnedMesh ) {

				p_uniforms.setOptional( _gl, object, 'bindMatrix' );
				p_uniforms.setOptional( _gl, object, 'bindMatrixInverse' );

				const skeleton = object.skeleton;

				if ( skeleton ) {

					if ( skeleton.boneTexture === null ) skeleton.computeBoneTexture();

					p_uniforms.setValue( _gl, 'boneTexture', skeleton.boneTexture, textures );

				}

			}

			if ( object.isBatchedMesh ) {

				p_uniforms.setOptional( _gl, object, 'batchingTexture' );
				p_uniforms.setValue( _gl, 'batchingTexture', object._matricesTexture, textures );

				p_uniforms.setOptional( _gl, object, 'batchingIdTexture' );
				p_uniforms.setValue( _gl, 'batchingIdTexture', object._indirectTexture, textures );

				p_uniforms.setOptional( _gl, object, 'batchingColorTexture' );
				if ( object._colorsTexture !== null ) {

					p_uniforms.setValue( _gl, 'batchingColorTexture', object._colorsTexture, textures );

				}

			}

			const morphAttributes = geometry.morphAttributes;

			if ( morphAttributes.position !== undefined || morphAttributes.normal !== undefined || ( morphAttributes.color !== undefined ) ) {

				morphtargets.update( object, geometry, program );

			}

			if ( refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow ) {

				materialProperties.receiveShadow = object.receiveShadow;
				p_uniforms.setValue( _gl, 'receiveShadow', object.receiveShadow );

			}

			// https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512

			if ( material.isMeshGouraudMaterial && material.envMap !== null ) {

				m_uniforms.envMap.value = envMap;

				m_uniforms.flipEnvMap.value = ( envMap.isCubeTexture && envMap.isRenderTargetTexture === false ) ? - 1 : 1;

			}

			if ( material.isMeshStandardMaterial && material.envMap === null && scene.environment !== null ) {

				m_uniforms.envMapIntensity.value = scene.environmentIntensity;

			}

			if ( refreshMaterial ) {

				p_uniforms.setValue( _gl, 'toneMappingExposure', _this.toneMappingExposure );

				if ( materialProperties.needsLights ) {

					// the current material requires lighting info

					// note: all lighting uniforms are always set correctly
					// they simply reference the renderer's state for their
					// values
					//
					// use the current material's .needsUpdate flags to set
					// the GL state when required

					markUniformsLightsNeedsUpdate( m_uniforms, refreshLights );

				}

				// refresh uniforms common to several materials

				if ( fog && material.fog === true ) {

					materials.refreshFogUniforms( m_uniforms, fog );

				}

				materials.refreshMaterialUniforms( m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget[ camera.id ] );

				WebGLUniforms.upload( _gl, getUniformList( materialProperties ), m_uniforms, textures );

			}

			if ( material.isShaderMaterial && material.uniformsNeedUpdate === true ) {

				WebGLUniforms.upload( _gl, getUniformList( materialProperties ), m_uniforms, textures );
				material.uniformsNeedUpdate = false;

			}

			if ( material.isSpriteMaterial ) {

				p_uniforms.setValue( _gl, 'center', object.center );

			}

			// common matrices

			p_uniforms.setValue( _gl, 'modelViewMatrix', object.modelViewMatrix );
			p_uniforms.setValue( _gl, 'normalMatrix', object.normalMatrix );
			p_uniforms.setValue( _gl, 'modelMatrix', object.matrixWorld );

			// UBOs

			if ( material.isShaderMaterial || material.isRawShaderMaterial ) {

				const groups = material.uniformsGroups;

				for ( let i = 0, l = groups.length; i < l; i ++ ) {

					const group = groups[ i ];

					uniformsGroups.update( group, program );
					uniformsGroups.bind( group, program );

				}

			}

			return program;

		}

		// If uniforms are marked as clean, they don't need to be loaded to the GPU.

		function markUniformsLightsNeedsUpdate( uniforms, value ) {

			uniforms.ambientLightColor.needsUpdate = value;
			uniforms.lightProbe.needsUpdate = value;

			uniforms.directionalLights.needsUpdate = value;
			uniforms.directionalLightShadows.needsUpdate = value;
			uniforms.pointLights.needsUpdate = value;
			uniforms.pointLightShadows.needsUpdate = value;
			uniforms.spotLights.needsUpdate = value;
			uniforms.spotLightShadows.needsUpdate = value;
			uniforms.rectAreaLights.needsUpdate = value;
			uniforms.hemisphereLights.needsUpdate = value;

		}

		function materialNeedsLights( material ) {

			return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial ||
				material.isMeshStandardMaterial || material.isShadowMaterial ||
				( material.isShaderMaterial && material.lights === true );

		}

		this.getActiveCubeFace = function () {

			return _currentActiveCubeFace;

		};

		this.getActiveMipmapLevel = function () {

			return _currentActiveMipmapLevel;

		};

		this.getRenderTarget = function () {

			return _currentRenderTarget;

		};

		this.setRenderTargetTextures = function ( renderTarget, colorTexture, depthTexture ) {

			properties.get( renderTarget.texture ).__webglTexture = colorTexture;
			properties.get( renderTarget.depthTexture ).__webglTexture = depthTexture;

			const renderTargetProperties = properties.get( renderTarget );
			renderTargetProperties.__hasExternalTextures = true;

			renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;

			if ( ! renderTargetProperties.__autoAllocateDepthBuffer ) {

				// The multisample_render_to_texture extension doesn't work properly if there
				// are midframe flushes and an external depth buffer. Disable use of the extension.
				if ( extensions.has( 'WEBGL_multisampled_render_to_texture' ) === true ) {

					console.warn( 'THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided' );
					renderTargetProperties.__useRenderToTexture = false;

				}

			}

		};

		this.setRenderTargetFramebuffer = function ( renderTarget, defaultFramebuffer ) {

			const renderTargetProperties = properties.get( renderTarget );
			renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
			renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;

		};

		this.setRenderTarget = function ( renderTarget, activeCubeFace = 0, activeMipmapLevel = 0 ) {

			_currentRenderTarget = renderTarget;
			_currentActiveCubeFace = activeCubeFace;
			_currentActiveMipmapLevel = activeMipmapLevel;

			let useDefaultFramebuffer = true;
			let framebuffer = null;
			let isCube = false;
			let isRenderTarget3D = false;

			if ( renderTarget ) {

				const renderTargetProperties = properties.get( renderTarget );

				if ( renderTargetProperties.__useDefaultFramebuffer !== undefined ) {

					// We need to make sure to rebind the framebuffer.
					state.bindFramebuffer( _gl.FRAMEBUFFER, null );
					useDefaultFramebuffer = false;

				} else if ( renderTargetProperties.__webglFramebuffer === undefined ) {

					textures.setupRenderTarget( renderTarget );

				} else if ( renderTargetProperties.__hasExternalTextures ) {

					// Color and depth texture must be rebound in order for the swapchain to update.
					textures.rebindTextures( renderTarget, properties.get( renderTarget.texture ).__webglTexture, properties.get( renderTarget.depthTexture ).__webglTexture );

				}

				const texture = renderTarget.texture;

				if ( texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture ) {

					isRenderTarget3D = true;

				}

				const __webglFramebuffer = properties.get( renderTarget ).__webglFramebuffer;

				if ( renderTarget.isWebGLCubeRenderTarget ) {

					if ( Array.isArray( __webglFramebuffer[ activeCubeFace ] ) ) {

						framebuffer = __webglFramebuffer[ activeCubeFace ][ activeMipmapLevel ];

					} else {

						framebuffer = __webglFramebuffer[ activeCubeFace ];

					}

					isCube = true;

				} else if ( ( renderTarget.samples > 0 ) && textures.useMultisampledRTT( renderTarget ) === false ) {

					framebuffer = properties.get( renderTarget ).__webglMultisampledFramebuffer;

				} else {

					if ( Array.isArray( __webglFramebuffer ) ) {

						framebuffer = __webglFramebuffer[ activeMipmapLevel ];

					} else {

						framebuffer = __webglFramebuffer;

					}

				}

				_currentViewport.copy( renderTarget.viewport );
				_currentScissor.copy( renderTarget.scissor );
				_currentScissorTest = renderTarget.scissorTest;

			} else {

				_currentViewport.copy( _viewport ).multiplyScalar( _pixelRatio ).floor();
				_currentScissor.copy( _scissor ).multiplyScalar( _pixelRatio ).floor();
				_currentScissorTest = _scissorTest;

			}

			const framebufferBound = state.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

			if ( framebufferBound && useDefaultFramebuffer ) {

				state.drawBuffers( renderTarget, framebuffer );

			}

			state.viewport( _currentViewport );
			state.scissor( _currentScissor );
			state.setScissorTest( _currentScissorTest );

			if ( isCube ) {

				const textureProperties = properties.get( renderTarget.texture );
				_gl.framebufferTexture2D( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel );

			} else if ( isRenderTarget3D ) {

				const textureProperties = properties.get( renderTarget.texture );
				const layer = activeCubeFace || 0;
				_gl.framebufferTextureLayer( _gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel || 0, layer );

			}

			_currentMaterialId = - 1; // reset current material to ensure correct uniform bindings

		};

		this.readRenderTargetPixels = function ( renderTarget, x, y, width, height, buffer, activeCubeFaceIndex ) {

			if ( ! ( renderTarget && renderTarget.isWebGLRenderTarget ) ) {

				console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.' );
				return;

			}

			let framebuffer = properties.get( renderTarget ).__webglFramebuffer;

			if ( renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined ) {

				framebuffer = framebuffer[ activeCubeFaceIndex ];

			}

			if ( framebuffer ) {

				state.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

				try {

					const texture = renderTarget.texture;
					const textureFormat = texture.format;
					const textureType = texture.type;

					if ( ! capabilities.textureFormatReadable( textureFormat ) ) {

						console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.' );
						return;

					}

					if ( ! capabilities.textureTypeReadable( textureType ) ) {

						console.error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.' );
						return;

					}

					// the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)

					if ( ( x >= 0 && x <= ( renderTarget.width - width ) ) && ( y >= 0 && y <= ( renderTarget.height - height ) ) ) {

						_gl.readPixels( x, y, width, height, utils.convert( textureFormat ), utils.convert( textureType ), buffer );

					}

				} finally {

					// restore framebuffer of current render target if necessary

					const framebuffer = ( _currentRenderTarget !== null ) ? properties.get( _currentRenderTarget ).__webglFramebuffer : null;
					state.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

				}

			}

		};

		this.readRenderTargetPixelsAsync = async function ( renderTarget, x, y, width, height, buffer, activeCubeFaceIndex ) {

			if ( ! ( renderTarget && renderTarget.isWebGLRenderTarget ) ) {

				throw new Error( 'THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.' );

			}

			let framebuffer = properties.get( renderTarget ).__webglFramebuffer;
			if ( renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined ) {

				framebuffer = framebuffer[ activeCubeFaceIndex ];

			}

			if ( framebuffer ) {

				state.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

				try {

					const texture = renderTarget.texture;
					const textureFormat = texture.format;
					const textureType = texture.type;

					if ( ! capabilities.textureFormatReadable( textureFormat ) ) {

						throw new Error( 'THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.' );

					}

					if ( ! capabilities.textureTypeReadable( textureType ) ) {

						throw new Error( 'THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.' );

					}

					// the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
					if ( ( x >= 0 && x <= ( renderTarget.width - width ) ) && ( y >= 0 && y <= ( renderTarget.height - height ) ) ) {

						const glBuffer = _gl.createBuffer();
						_gl.bindBuffer( _gl.PIXEL_PACK_BUFFER, glBuffer );
						_gl.bufferData( _gl.PIXEL_PACK_BUFFER, buffer.byteLength, _gl.STREAM_READ );
						_gl.readPixels( x, y, width, height, utils.convert( textureFormat ), utils.convert( textureType ), 0 );
						_gl.flush();

						// check if the commands have finished every 8 ms
						const sync = _gl.fenceSync( _gl.SYNC_GPU_COMMANDS_COMPLETE, 0 );
						await probeAsync( _gl, sync, 4 );

						try {

							_gl.bindBuffer( _gl.PIXEL_PACK_BUFFER, glBuffer );
							_gl.getBufferSubData( _gl.PIXEL_PACK_BUFFER, 0, buffer );

						} finally {

							_gl.deleteBuffer( glBuffer );
							_gl.deleteSync( sync );

						}

						return buffer;

					}

				} finally {

					// restore framebuffer of current render target if necessary

					const framebuffer = ( _currentRenderTarget !== null ) ? properties.get( _currentRenderTarget ).__webglFramebuffer : null;
					state.bindFramebuffer( _gl.FRAMEBUFFER, framebuffer );

				}

			}

		};

		this.copyFramebufferToTexture = function ( texture, position = null, level = 0 ) {

			// support previous signature with position first
			if ( texture.isTexture !== true ) {

				// @deprecated, r165
				console.warn( 'WebGLRenderer: copyFramebufferToTexture function signature has changed.' );

				position = arguments[ 0 ] || null;
				texture = arguments[ 1 ];

			}

			const levelScale = Math.pow( 2, - level );
			const width = Math.floor( texture.image.width * levelScale );
			const height = Math.floor( texture.image.height * levelScale );

			const x = position !== null ? position.x : 0;
			const y = position !== null ? position.y : 0;

			textures.setTexture2D( texture, 0 );

			_gl.copyTexSubImage2D( _gl.TEXTURE_2D, level, 0, 0, x, y, width, height );

			state.unbindTexture();

		};

		this.copyTextureToTexture = function ( srcTexture, dstTexture, srcRegion = null, dstPosition = null, level = 0 ) {

			// support previous signature with dstPosition first
			if ( srcTexture.isTexture !== true ) {

				// @deprecated, r165
				console.warn( 'WebGLRenderer: copyTextureToTexture function signature has changed.' );

				dstPosition = arguments[ 0 ] || null;
				srcTexture = arguments[ 1 ];
				dstTexture = arguments[ 2 ];
				level = arguments[ 3 ] || 0;
				srcRegion = null;

			}

			let width, height, minX, minY;
			let dstX, dstY;
			if ( srcRegion !== null ) {

				width = srcRegion.max.x - srcRegion.min.x;
				height = srcRegion.max.y - srcRegion.min.y;
				minX = srcRegion.min.x;
				minY = srcRegion.min.y;

			} else {

				width = srcTexture.image.width;
				height = srcTexture.image.height;
				minX = 0;
				minY = 0;

			}

			if ( dstPosition !== null ) {

				dstX = dstPosition.x;
				dstY = dstPosition.y;

			} else {

				dstX = 0;
				dstY = 0;

			}

			const glFormat = utils.convert( dstTexture.format );
			const glType = utils.convert( dstTexture.type );

			textures.setTexture2D( dstTexture, 0 );

			// As another texture upload may have changed pixelStorei
			// parameters, make sure they are correct for the dstTexture
			_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY );
			_gl.pixelStorei( _gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha );
			_gl.pixelStorei( _gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment );

			const currentUnpackRowLen = _gl.getParameter( _gl.UNPACK_ROW_LENGTH );
			const currentUnpackImageHeight = _gl.getParameter( _gl.UNPACK_IMAGE_HEIGHT );
			const currentUnpackSkipPixels = _gl.getParameter( _gl.UNPACK_SKIP_PIXELS );
			const currentUnpackSkipRows = _gl.getParameter( _gl.UNPACK_SKIP_ROWS );
			const currentUnpackSkipImages = _gl.getParameter( _gl.UNPACK_SKIP_IMAGES );

			const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[ level ] : srcTexture.image;

			_gl.pixelStorei( _gl.UNPACK_ROW_LENGTH, image.width );
			_gl.pixelStorei( _gl.UNPACK_IMAGE_HEIGHT, image.height );
			_gl.pixelStorei( _gl.UNPACK_SKIP_PIXELS, minX );
			_gl.pixelStorei( _gl.UNPACK_SKIP_ROWS, minY );

			if ( srcTexture.isDataTexture ) {

				_gl.texSubImage2D( _gl.TEXTURE_2D, level, dstX, dstY, width, height, glFormat, glType, image.data );

			} else {

				if ( srcTexture.isCompressedTexture ) {

					_gl.compressedTexSubImage2D( _gl.TEXTURE_2D, level, dstX, dstY, image.width, image.height, glFormat, image.data );

				} else {

					_gl.texSubImage2D( _gl.TEXTURE_2D, level, dstX, dstY, width, height, glFormat, glType, image );

				}

			}

			_gl.pixelStorei( _gl.UNPACK_ROW_LENGTH, currentUnpackRowLen );
			_gl.pixelStorei( _gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight );
			_gl.pixelStorei( _gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels );
			_gl.pixelStorei( _gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows );
			_gl.pixelStorei( _gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages );

			// Generate mipmaps only when copying level 0
			if ( level === 0 && dstTexture.generateMipmaps ) _gl.generateMipmap( _gl.TEXTURE_2D );

			state.unbindTexture();

		};

		this.copyTextureToTexture3D = function ( srcTexture, dstTexture, srcRegion = null, dstPosition = null, level = 0 ) {

			// support previous signature with source box first
			if ( srcTexture.isTexture !== true ) {

				// @deprecated, r165
				console.warn( 'WebGLRenderer: copyTextureToTexture3D function signature has changed.' );

				srcRegion = arguments[ 0 ] || null;
				dstPosition = arguments[ 1 ] || null;
				srcTexture = arguments[ 2 ];
				dstTexture = arguments[ 3 ];
				level = arguments[ 4 ] || 0;

			}

			let width, height, depth, minX, minY, minZ;
			let dstX, dstY, dstZ;
			const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[ level ] : srcTexture.image;
			if ( srcRegion !== null ) {

				width = srcRegion.max.x - srcRegion.min.x;
				height = srcRegion.max.y - srcRegion.min.y;
				depth = srcRegion.max.z - srcRegion.min.z;
				minX = srcRegion.min.x;
				minY = srcRegion.min.y;
				minZ = srcRegion.min.z;

			} else {

				width = image.width;
				height = image.height;
				depth = image.depth;
				minX = 0;
				minY = 0;
				minZ = 0;

			}

			if ( dstPosition !== null ) {

				dstX = dstPosition.x;
				dstY = dstPosition.y;
				dstZ = dstPosition.z;

			} else {

				dstX = 0;
				dstY = 0;
				dstZ = 0;

			}

			const glFormat = utils.convert( dstTexture.format );
			const glType = utils.convert( dstTexture.type );
			let glTarget;

			if ( dstTexture.isData3DTexture ) {

				textures.setTexture3D( dstTexture, 0 );
				glTarget = _gl.TEXTURE_3D;

			} else if ( dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture ) {

				textures.setTexture2DArray( dstTexture, 0 );
				glTarget = _gl.TEXTURE_2D_ARRAY;

			} else {

				console.warn( 'THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.' );
				return;

			}

			_gl.pixelStorei( _gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY );
			_gl.pixelStorei( _gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha );
			_gl.pixelStorei( _gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment );

			const currentUnpackRowLen = _gl.getParameter( _gl.UNPACK_ROW_LENGTH );
			const currentUnpackImageHeight = _gl.getParameter( _gl.UNPACK_IMAGE_HEIGHT );
			const currentUnpackSkipPixels = _gl.getParameter( _gl.UNPACK_SKIP_PIXELS );
			const currentUnpackSkipRows = _gl.getParameter( _gl.UNPACK_SKIP_ROWS );
			const currentUnpackSkipImages = _gl.getParameter( _gl.UNPACK_SKIP_IMAGES );

			_gl.pixelStorei( _gl.UNPACK_ROW_LENGTH, image.width );
			_gl.pixelStorei( _gl.UNPACK_IMAGE_HEIGHT, image.height );
			_gl.pixelStorei( _gl.UNPACK_SKIP_PIXELS, minX );
			_gl.pixelStorei( _gl.UNPACK_SKIP_ROWS, minY );
			_gl.pixelStorei( _gl.UNPACK_SKIP_IMAGES, minZ );

			if ( srcTexture.isDataTexture || srcTexture.isData3DTexture ) {

				_gl.texSubImage3D( glTarget, level, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image.data );

			} else {

				if ( dstTexture.isCompressedArrayTexture ) {

					_gl.compressedTexSubImage3D( glTarget, level, dstX, dstY, dstZ, width, height, depth, glFormat, image.data );

				} else {

					_gl.texSubImage3D( glTarget, level, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image );

				}

			}

			_gl.pixelStorei( _gl.UNPACK_ROW_LENGTH, currentUnpackRowLen );
			_gl.pixelStorei( _gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight );
			_gl.pixelStorei( _gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels );
			_gl.pixelStorei( _gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows );
			_gl.pixelStorei( _gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages );

			// Generate mipmaps only when copying level 0
			if ( level === 0 && dstTexture.generateMipmaps ) _gl.generateMipmap( glTarget );

			state.unbindTexture();

		};

		this.initRenderTarget = function ( target ) {

			if ( properties.get( target ).__webglFramebuffer === undefined ) {

				textures.setupRenderTarget( target );

			}

		};

		this.initTexture = function ( texture ) {

			if ( texture.isCubeTexture ) {

				textures.setTextureCube( texture, 0 );

			} else if ( texture.isData3DTexture ) {

				textures.setTexture3D( texture, 0 );

			} else if ( texture.isDataArrayTexture || texture.isCompressedArrayTexture ) {

				textures.setTexture2DArray( texture, 0 );

			} else {

				textures.setTexture2D( texture, 0 );

			}

			state.unbindTexture();

		};

		this.resetState = function () {

			_currentActiveCubeFace = 0;
			_currentActiveMipmapLevel = 0;
			_currentRenderTarget = null;

			state.reset();
			bindingStates.reset();

		};

		if ( typeof __THREE_DEVTOOLS__ !== 'undefined' ) {

			__THREE_DEVTOOLS__.dispatchEvent( new CustomEvent( 'observe', { detail: this } ) );

		}

	}

	get coordinateSystem() {

		return WebGLCoordinateSystem;

	}

	get outputColorSpace() {

		return this._outputColorSpace;

	}

	set outputColorSpace( colorSpace ) {

		this._outputColorSpace = colorSpace;

		const gl = this.getContext();
		gl.drawingBufferColorSpace = colorSpace === DisplayP3ColorSpace ? 'display-p3' : 'srgb';
		gl.unpackColorSpace = ColorManagement.workingColorSpace === LinearDisplayP3ColorSpace ? 'display-p3' : 'srgb';

	}

}

class Scene extends Object3D {

	constructor() {

		super();

		this.isScene = true;

		this.type = 'Scene';

		this.background = null;
		this.environment = null;
		this.fog = null;

		this.backgroundBlurriness = 0;
		this.backgroundIntensity = 1;
		this.backgroundRotation = new Euler();

		this.environmentIntensity = 1;
		this.environmentRotation = new Euler();

		this.overrideMaterial = null;

		if ( typeof __THREE_DEVTOOLS__ !== 'undefined' ) {

			__THREE_DEVTOOLS__.dispatchEvent( new CustomEvent( 'observe', { detail: this } ) );

		}

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		if ( source.background !== null ) this.background = source.background.clone();
		if ( source.environment !== null ) this.environment = source.environment.clone();
		if ( source.fog !== null ) this.fog = source.fog.clone();

		this.backgroundBlurriness = source.backgroundBlurriness;
		this.backgroundIntensity = source.backgroundIntensity;
		this.backgroundRotation.copy( source.backgroundRotation );

		this.environmentIntensity = source.environmentIntensity;
		this.environmentRotation.copy( source.environmentRotation );

		if ( source.overrideMaterial !== null ) this.overrideMaterial = source.overrideMaterial.clone();

		this.matrixAutoUpdate = source.matrixAutoUpdate;

		return this;

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		if ( this.fog !== null ) data.object.fog = this.fog.toJSON();

		if ( this.backgroundBlurriness > 0 ) data.object.backgroundBlurriness = this.backgroundBlurriness;
		if ( this.backgroundIntensity !== 1 ) data.object.backgroundIntensity = this.backgroundIntensity;
		data.object.backgroundRotation = this.backgroundRotation.toArray();

		if ( this.environmentIntensity !== 1 ) data.object.environmentIntensity = this.environmentIntensity;
		data.object.environmentRotation = this.environmentRotation.toArray();

		return data;

	}

}

class LineBasicMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isLineBasicMaterial = true;

		this.type = 'LineBasicMaterial';

		this.color = new Color( 0xffffff );

		this.map = null;

		this.linewidth = 1;
		this.linecap = 'round';
		this.linejoin = 'round';

		this.fog = true;

		this.setValues( parameters );

	}


	copy( source ) {

		super.copy( source );

		this.color.copy( source.color );

		this.map = source.map;

		this.linewidth = source.linewidth;
		this.linecap = source.linecap;
		this.linejoin = source.linejoin;

		this.fog = source.fog;

		return this;

	}

}

const _vStart = /*@__PURE__*/ new Vector3();
const _vEnd = /*@__PURE__*/ new Vector3();

const _inverseMatrix$1 = /*@__PURE__*/ new Matrix4();
const _ray$1$1 = /*@__PURE__*/ new Ray();
const _sphere$1 = /*@__PURE__*/ new Sphere();

const _intersectPointOnRay = /*@__PURE__*/ new Vector3();
const _intersectPointOnSegment = /*@__PURE__*/ new Vector3();

class Line extends Object3D {

	constructor( geometry = new BufferGeometry(), material = new LineBasicMaterial() ) {

		super();

		this.isLine = true;

		this.type = 'Line';

		this.geometry = geometry;
		this.material = material;

		this.updateMorphTargets();

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.material = Array.isArray( source.material ) ? source.material.slice() : source.material;
		this.geometry = source.geometry;

		return this;

	}

	computeLineDistances() {

		const geometry = this.geometry;

		// we assume non-indexed geometry

		if ( geometry.index === null ) {

			const positionAttribute = geometry.attributes.position;
			const lineDistances = [ 0 ];

			for ( let i = 1, l = positionAttribute.count; i < l; i ++ ) {

				_vStart.fromBufferAttribute( positionAttribute, i - 1 );
				_vEnd.fromBufferAttribute( positionAttribute, i );

				lineDistances[ i ] = lineDistances[ i - 1 ];
				lineDistances[ i ] += _vStart.distanceTo( _vEnd );

			}

			geometry.setAttribute( 'lineDistance', new Float32BufferAttribute( lineDistances, 1 ) );

		} else {

			console.warn( 'THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.' );

		}

		return this;

	}

	raycast( raycaster, intersects ) {

		const geometry = this.geometry;
		const matrixWorld = this.matrixWorld;
		const threshold = raycaster.params.Line.threshold;
		const drawRange = geometry.drawRange;

		// Checking boundingSphere distance to ray

		if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

		_sphere$1.copy( geometry.boundingSphere );
		_sphere$1.applyMatrix4( matrixWorld );
		_sphere$1.radius += threshold;

		if ( raycaster.ray.intersectsSphere( _sphere$1 ) === false ) return;

		//

		_inverseMatrix$1.copy( matrixWorld ).invert();
		_ray$1$1.copy( raycaster.ray ).applyMatrix4( _inverseMatrix$1 );

		const localThreshold = threshold / ( ( this.scale.x + this.scale.y + this.scale.z ) / 3 );
		const localThresholdSq = localThreshold * localThreshold;

		const step = this.isLineSegments ? 2 : 1;

		const index = geometry.index;
		const attributes = geometry.attributes;
		const positionAttribute = attributes.position;

		if ( index !== null ) {

			const start = Math.max( 0, drawRange.start );
			const end = Math.min( index.count, ( drawRange.start + drawRange.count ) );

			for ( let i = start, l = end - 1; i < l; i += step ) {

				const a = index.getX( i );
				const b = index.getX( i + 1 );

				const intersect = checkIntersection( this, raycaster, _ray$1$1, localThresholdSq, a, b );

				if ( intersect ) {

					intersects.push( intersect );

				}

			}

			if ( this.isLineLoop ) {

				const a = index.getX( end - 1 );
				const b = index.getX( start );

				const intersect = checkIntersection( this, raycaster, _ray$1$1, localThresholdSq, a, b );

				if ( intersect ) {

					intersects.push( intersect );

				}

			}

		} else {

			const start = Math.max( 0, drawRange.start );
			const end = Math.min( positionAttribute.count, ( drawRange.start + drawRange.count ) );

			for ( let i = start, l = end - 1; i < l; i += step ) {

				const intersect = checkIntersection( this, raycaster, _ray$1$1, localThresholdSq, i, i + 1 );

				if ( intersect ) {

					intersects.push( intersect );

				}

			}

			if ( this.isLineLoop ) {

				const intersect = checkIntersection( this, raycaster, _ray$1$1, localThresholdSq, end - 1, start );

				if ( intersect ) {

					intersects.push( intersect );

				}

			}

		}

	}

	updateMorphTargets() {

		const geometry = this.geometry;

		const morphAttributes = geometry.morphAttributes;
		const keys = Object.keys( morphAttributes );

		if ( keys.length > 0 ) {

			const morphAttribute = morphAttributes[ keys[ 0 ] ];

			if ( morphAttribute !== undefined ) {

				this.morphTargetInfluences = [];
				this.morphTargetDictionary = {};

				for ( let m = 0, ml = morphAttribute.length; m < ml; m ++ ) {

					const name = morphAttribute[ m ].name || String( m );

					this.morphTargetInfluences.push( 0 );
					this.morphTargetDictionary[ name ] = m;

				}

			}

		}

	}

}

function checkIntersection( object, raycaster, ray, thresholdSq, a, b ) {

	const positionAttribute = object.geometry.attributes.position;

	_vStart.fromBufferAttribute( positionAttribute, a );
	_vEnd.fromBufferAttribute( positionAttribute, b );

	const distSq = ray.distanceSqToSegment( _vStart, _vEnd, _intersectPointOnRay, _intersectPointOnSegment );

	if ( distSq > thresholdSq ) return;

	_intersectPointOnRay.applyMatrix4( object.matrixWorld ); // Move back to world space for distance calculation

	const distance = raycaster.ray.origin.distanceTo( _intersectPointOnRay );

	if ( distance < raycaster.near || distance > raycaster.far ) return;

	return {

		distance: distance,
		// What do we want? intersection point on the ray or on the segment??
		// point: raycaster.ray.at( distance ),
		point: _intersectPointOnSegment.clone().applyMatrix4( object.matrixWorld ),
		index: a,
		face: null,
		faceIndex: null,
		object: object

	};

}

const _start = /*@__PURE__*/ new Vector3();
const _end = /*@__PURE__*/ new Vector3();

class LineSegments extends Line {

	constructor( geometry, material ) {

		super( geometry, material );

		this.isLineSegments = true;

		this.type = 'LineSegments';

	}

	computeLineDistances() {

		const geometry = this.geometry;

		// we assume non-indexed geometry

		if ( geometry.index === null ) {

			const positionAttribute = geometry.attributes.position;
			const lineDistances = [];

			for ( let i = 0, l = positionAttribute.count; i < l; i += 2 ) {

				_start.fromBufferAttribute( positionAttribute, i );
				_end.fromBufferAttribute( positionAttribute, i + 1 );

				lineDistances[ i ] = ( i === 0 ) ? 0 : lineDistances[ i - 1 ];
				lineDistances[ i + 1 ] = lineDistances[ i ] + _start.distanceTo( _end );

			}

			geometry.setAttribute( 'lineDistance', new Float32BufferAttribute( lineDistances, 1 ) );

		} else {

			console.warn( 'THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.' );

		}

		return this;

	}

}

class PointsMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isPointsMaterial = true;

		this.type = 'PointsMaterial';

		this.color = new Color( 0xffffff );

		this.map = null;

		this.alphaMap = null;

		this.size = 1;
		this.sizeAttenuation = true;

		this.fog = true;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.color.copy( source.color );

		this.map = source.map;

		this.alphaMap = source.alphaMap;

		this.size = source.size;
		this.sizeAttenuation = source.sizeAttenuation;

		this.fog = source.fog;

		return this;

	}

}

const _inverseMatrix = /*@__PURE__*/ new Matrix4();
const _ray$5 = /*@__PURE__*/ new Ray();
const _sphere = /*@__PURE__*/ new Sphere();
const _position$2 = /*@__PURE__*/ new Vector3();

class Points extends Object3D {

	constructor( geometry = new BufferGeometry(), material = new PointsMaterial() ) {

		super();

		this.isPoints = true;

		this.type = 'Points';

		this.geometry = geometry;
		this.material = material;

		this.updateMorphTargets();

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.material = Array.isArray( source.material ) ? source.material.slice() : source.material;
		this.geometry = source.geometry;

		return this;

	}

	raycast( raycaster, intersects ) {

		const geometry = this.geometry;
		const matrixWorld = this.matrixWorld;
		const threshold = raycaster.params.Points.threshold;
		const drawRange = geometry.drawRange;

		// Checking boundingSphere distance to ray

		if ( geometry.boundingSphere === null ) geometry.computeBoundingSphere();

		_sphere.copy( geometry.boundingSphere );
		_sphere.applyMatrix4( matrixWorld );
		_sphere.radius += threshold;

		if ( raycaster.ray.intersectsSphere( _sphere ) === false ) return;

		//

		_inverseMatrix.copy( matrixWorld ).invert();
		_ray$5.copy( raycaster.ray ).applyMatrix4( _inverseMatrix );

		const localThreshold = threshold / ( ( this.scale.x + this.scale.y + this.scale.z ) / 3 );
		const localThresholdSq = localThreshold * localThreshold;

		const index = geometry.index;
		const attributes = geometry.attributes;
		const positionAttribute = attributes.position;

		if ( index !== null ) {

			const start = Math.max( 0, drawRange.start );
			const end = Math.min( index.count, ( drawRange.start + drawRange.count ) );

			for ( let i = start, il = end; i < il; i ++ ) {

				const a = index.getX( i );

				_position$2.fromBufferAttribute( positionAttribute, a );

				testPoint( _position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this );

			}

		} else {

			const start = Math.max( 0, drawRange.start );
			const end = Math.min( positionAttribute.count, ( drawRange.start + drawRange.count ) );

			for ( let i = start, l = end; i < l; i ++ ) {

				_position$2.fromBufferAttribute( positionAttribute, i );

				testPoint( _position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this );

			}

		}

	}

	updateMorphTargets() {

		const geometry = this.geometry;

		const morphAttributes = geometry.morphAttributes;
		const keys = Object.keys( morphAttributes );

		if ( keys.length > 0 ) {

			const morphAttribute = morphAttributes[ keys[ 0 ] ];

			if ( morphAttribute !== undefined ) {

				this.morphTargetInfluences = [];
				this.morphTargetDictionary = {};

				for ( let m = 0, ml = morphAttribute.length; m < ml; m ++ ) {

					const name = morphAttribute[ m ].name || String( m );

					this.morphTargetInfluences.push( 0 );
					this.morphTargetDictionary[ name ] = m;

				}

			}

		}

	}

}

function testPoint( point, index, localThresholdSq, matrixWorld, raycaster, intersects, object ) {

	const rayPointDistanceSq = _ray$5.distanceSqToPoint( point );

	if ( rayPointDistanceSq < localThresholdSq ) {

		const intersectPoint = new Vector3();

		_ray$5.closestPointToPoint( point, intersectPoint );
		intersectPoint.applyMatrix4( matrixWorld );

		const distance = raycaster.ray.origin.distanceTo( intersectPoint );

		if ( distance < raycaster.near || distance > raycaster.far ) return;

		intersects.push( {

			distance: distance,
			distanceToRay: Math.sqrt( rayPointDistanceSq ),
			point: intersectPoint,
			index: index,
			face: null,
			object: object

		} );

	}

}

class SphereGeometry extends BufferGeometry {

	constructor( radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI ) {

		super();

		this.type = 'SphereGeometry';

		this.parameters = {
			radius: radius,
			widthSegments: widthSegments,
			heightSegments: heightSegments,
			phiStart: phiStart,
			phiLength: phiLength,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		widthSegments = Math.max( 3, Math.floor( widthSegments ) );
		heightSegments = Math.max( 2, Math.floor( heightSegments ) );

		const thetaEnd = Math.min( thetaStart + thetaLength, Math.PI );

		let index = 0;
		const grid = [];

		const vertex = new Vector3();
		const normal = new Vector3();

		// buffers

		const indices = [];
		const vertices = [];
		const normals = [];
		const uvs = [];

		// generate vertices, normals and uvs

		for ( let iy = 0; iy <= heightSegments; iy ++ ) {

			const verticesRow = [];

			const v = iy / heightSegments;

			// special case for the poles

			let uOffset = 0;

			if ( iy === 0 && thetaStart === 0 ) {

				uOffset = 0.5 / widthSegments;

			} else if ( iy === heightSegments && thetaEnd === Math.PI ) {

				uOffset = - 0.5 / widthSegments;

			}

			for ( let ix = 0; ix <= widthSegments; ix ++ ) {

				const u = ix / widthSegments;

				// vertex

				vertex.x = - radius * Math.cos( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );
				vertex.y = radius * Math.cos( thetaStart + v * thetaLength );
				vertex.z = radius * Math.sin( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );

				vertices.push( vertex.x, vertex.y, vertex.z );

				// normal

				normal.copy( vertex ).normalize();
				normals.push( normal.x, normal.y, normal.z );

				// uv

				uvs.push( u + uOffset, 1 - v );

				verticesRow.push( index ++ );

			}

			grid.push( verticesRow );

		}

		// indices

		for ( let iy = 0; iy < heightSegments; iy ++ ) {

			for ( let ix = 0; ix < widthSegments; ix ++ ) {

				const a = grid[ iy ][ ix + 1 ];
				const b = grid[ iy ][ ix ];
				const c = grid[ iy + 1 ][ ix ];
				const d = grid[ iy + 1 ][ ix + 1 ];

				if ( iy !== 0 || thetaStart > 0 ) indices.push( a, b, d );
				if ( iy !== heightSegments - 1 || thetaEnd < Math.PI ) indices.push( b, c, d );

			}

		}

		// build geometry

		this.setIndex( indices );
		this.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
		this.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );
		this.setAttribute( 'uv', new Float32BufferAttribute( uvs, 2 ) );

	}

	copy( source ) {

		super.copy( source );

		this.parameters = Object.assign( {}, source.parameters );

		return this;

	}

	static fromJSON( data ) {

		return new SphereGeometry( data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength );

	}

}

class MeshPhongMaterial extends Material {

	constructor( parameters ) {

		super();

		this.isMeshPhongMaterial = true;

		this.type = 'MeshPhongMaterial';

		this.color = new Color( 0xffffff ); // diffuse
		this.specular = new Color( 0x111111 );
		this.shininess = 30;

		this.map = null;

		this.lightMap = null;
		this.lightMapIntensity = 1.0;

		this.aoMap = null;
		this.aoMapIntensity = 1.0;

		this.emissive = new Color( 0x000000 );
		this.emissiveIntensity = 1.0;
		this.emissiveMap = null;

		this.bumpMap = null;
		this.bumpScale = 1;

		this.normalMap = null;
		this.normalMapType = TangentSpaceNormalMap;
		this.normalScale = new Vector2( 1, 1 );

		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;

		this.specularMap = null;

		this.alphaMap = null;

		this.envMap = null;
		this.envMapRotation = new Euler();
		this.combine = MultiplyOperation;
		this.reflectivity = 1;
		this.refractionRatio = 0.98;

		this.wireframe = false;
		this.wireframeLinewidth = 1;
		this.wireframeLinecap = 'round';
		this.wireframeLinejoin = 'round';

		this.flatShading = false;

		this.fog = true;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.color.copy( source.color );
		this.specular.copy( source.specular );
		this.shininess = source.shininess;

		this.map = source.map;

		this.lightMap = source.lightMap;
		this.lightMapIntensity = source.lightMapIntensity;

		this.aoMap = source.aoMap;
		this.aoMapIntensity = source.aoMapIntensity;

		this.emissive.copy( source.emissive );
		this.emissiveMap = source.emissiveMap;
		this.emissiveIntensity = source.emissiveIntensity;

		this.bumpMap = source.bumpMap;
		this.bumpScale = source.bumpScale;

		this.normalMap = source.normalMap;
		this.normalMapType = source.normalMapType;
		this.normalScale.copy( source.normalScale );

		this.displacementMap = source.displacementMap;
		this.displacementScale = source.displacementScale;
		this.displacementBias = source.displacementBias;

		this.specularMap = source.specularMap;

		this.alphaMap = source.alphaMap;

		this.envMap = source.envMap;
		this.envMapRotation.copy( source.envMapRotation );
		this.combine = source.combine;
		this.reflectivity = source.reflectivity;
		this.refractionRatio = source.refractionRatio;

		this.wireframe = source.wireframe;
		this.wireframeLinewidth = source.wireframeLinewidth;
		this.wireframeLinecap = source.wireframeLinecap;
		this.wireframeLinejoin = source.wireframeLinejoin;

		this.flatShading = source.flatShading;

		this.fog = source.fog;

		return this;

	}

}

class LineDashedMaterial extends LineBasicMaterial {

	constructor( parameters ) {

		super();

		this.isLineDashedMaterial = true;

		this.type = 'LineDashedMaterial';

		this.scale = 1;
		this.dashSize = 3;
		this.gapSize = 1;

		this.setValues( parameters );

	}

	copy( source ) {

		super.copy( source );

		this.scale = source.scale;
		this.dashSize = source.dashSize;
		this.gapSize = source.gapSize;

		return this;

	}

}

const Cache = {

	enabled: false,

	files: {},

	add: function ( key, file ) {

		if ( this.enabled === false ) return;

		// console.log( 'THREE.Cache', 'Adding key:', key );

		this.files[ key ] = file;

	},

	get: function ( key ) {

		if ( this.enabled === false ) return;

		// console.log( 'THREE.Cache', 'Checking key:', key );

		return this.files[ key ];

	},

	remove: function ( key ) {

		delete this.files[ key ];

	},

	clear: function () {

		this.files = {};

	}

};

class LoadingManager {

	constructor( onLoad, onProgress, onError ) {

		const scope = this;

		let isLoading = false;
		let itemsLoaded = 0;
		let itemsTotal = 0;
		let urlModifier = undefined;
		const handlers = [];

		// Refer to #5689 for the reason why we don't set .onStart
		// in the constructor

		this.onStart = undefined;
		this.onLoad = onLoad;
		this.onProgress = onProgress;
		this.onError = onError;

		this.itemStart = function ( url ) {

			itemsTotal ++;

			if ( isLoading === false ) {

				if ( scope.onStart !== undefined ) {

					scope.onStart( url, itemsLoaded, itemsTotal );

				}

			}

			isLoading = true;

		};

		this.itemEnd = function ( url ) {

			itemsLoaded ++;

			if ( scope.onProgress !== undefined ) {

				scope.onProgress( url, itemsLoaded, itemsTotal );

			}

			if ( itemsLoaded === itemsTotal ) {

				isLoading = false;

				if ( scope.onLoad !== undefined ) {

					scope.onLoad();

				}

			}

		};

		this.itemError = function ( url ) {

			if ( scope.onError !== undefined ) {

				scope.onError( url );

			}

		};

		this.resolveURL = function ( url ) {

			if ( urlModifier ) {

				return urlModifier( url );

			}

			return url;

		};

		this.setURLModifier = function ( transform ) {

			urlModifier = transform;

			return this;

		};

		this.addHandler = function ( regex, loader ) {

			handlers.push( regex, loader );

			return this;

		};

		this.removeHandler = function ( regex ) {

			const index = handlers.indexOf( regex );

			if ( index !== - 1 ) {

				handlers.splice( index, 2 );

			}

			return this;

		};

		this.getHandler = function ( file ) {

			for ( let i = 0, l = handlers.length; i < l; i += 2 ) {

				const regex = handlers[ i ];
				const loader = handlers[ i + 1 ];

				if ( regex.global ) regex.lastIndex = 0; // see #17920

				if ( regex.test( file ) ) {

					return loader;

				}

			}

			return null;

		};

	}

}

const DefaultLoadingManager = /*@__PURE__*/ new LoadingManager();

class Loader {

	constructor( manager ) {

		this.manager = ( manager !== undefined ) ? manager : DefaultLoadingManager;

		this.crossOrigin = 'anonymous';
		this.withCredentials = false;
		this.path = '';
		this.resourcePath = '';
		this.requestHeader = {};

	}

	load( /* url, onLoad, onProgress, onError */ ) {}

	loadAsync( url, onProgress ) {

		const scope = this;

		return new Promise( function ( resolve, reject ) {

			scope.load( url, resolve, onProgress, reject );

		} );

	}

	parse( /* data */ ) {}

	setCrossOrigin( crossOrigin ) {

		this.crossOrigin = crossOrigin;
		return this;

	}

	setWithCredentials( value ) {

		this.withCredentials = value;
		return this;

	}

	setPath( path ) {

		this.path = path;
		return this;

	}

	setResourcePath( resourcePath ) {

		this.resourcePath = resourcePath;
		return this;

	}

	setRequestHeader( requestHeader ) {

		this.requestHeader = requestHeader;
		return this;

	}

}

Loader.DEFAULT_MATERIAL_NAME = '__DEFAULT';

class ImageLoader extends Loader {

	constructor( manager ) {

		super( manager );

	}

	load( url, onLoad, onProgress, onError ) {

		if ( this.path !== undefined ) url = this.path + url;

		url = this.manager.resolveURL( url );

		const scope = this;

		const cached = Cache.get( url );

		if ( cached !== undefined ) {

			scope.manager.itemStart( url );

			setTimeout( function () {

				if ( onLoad ) onLoad( cached );

				scope.manager.itemEnd( url );

			}, 0 );

			return cached;

		}

		const image = createElementNS( 'img' );

		function onImageLoad() {

			removeEventListeners();

			Cache.add( url, this );

			if ( onLoad ) onLoad( this );

			scope.manager.itemEnd( url );

		}

		function onImageError( event ) {

			removeEventListeners();

			if ( onError ) onError( event );

			scope.manager.itemError( url );
			scope.manager.itemEnd( url );

		}

		function removeEventListeners() {

			image.removeEventListener( 'load', onImageLoad, false );
			image.removeEventListener( 'error', onImageError, false );

		}

		image.addEventListener( 'load', onImageLoad, false );
		image.addEventListener( 'error', onImageError, false );

		if ( url.slice( 0, 5 ) !== 'data:' ) {

			if ( this.crossOrigin !== undefined ) image.crossOrigin = this.crossOrigin;

		}

		scope.manager.itemStart( url );

		image.src = url;

		return image;

	}

}

class TextureLoader extends Loader {

	constructor( manager ) {

		super( manager );

	}

	load( url, onLoad, onProgress, onError ) {

		const texture = new Texture();

		const loader = new ImageLoader( this.manager );
		loader.setCrossOrigin( this.crossOrigin );
		loader.setPath( this.path );

		loader.load( url, function ( image ) {

			texture.image = image;
			texture.needsUpdate = true;

			if ( onLoad !== undefined ) {

				onLoad( texture );

			}

		}, onProgress, onError );

		return texture;

	}

}

class Light extends Object3D {

	constructor( color, intensity = 1 ) {

		super();

		this.isLight = true;

		this.type = 'Light';

		this.color = new Color( color );
		this.intensity = intensity;

	}

	dispose() {

		// Empty here in base class; some subclasses override.

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.color.copy( source.color );
		this.intensity = source.intensity;

		return this;

	}

	toJSON( meta ) {

		const data = super.toJSON( meta );

		data.object.color = this.color.getHex();
		data.object.intensity = this.intensity;

		if ( this.groundColor !== undefined ) data.object.groundColor = this.groundColor.getHex();

		if ( this.distance !== undefined ) data.object.distance = this.distance;
		if ( this.angle !== undefined ) data.object.angle = this.angle;
		if ( this.decay !== undefined ) data.object.decay = this.decay;
		if ( this.penumbra !== undefined ) data.object.penumbra = this.penumbra;

		if ( this.shadow !== undefined ) data.object.shadow = this.shadow.toJSON();
		if ( this.target !== undefined ) data.object.target = this.target.uuid;

		return data;

	}

}

const _projScreenMatrix$1 = /*@__PURE__*/ new Matrix4();
const _lightPositionWorld$1 = /*@__PURE__*/ new Vector3();
const _lookTarget$1 = /*@__PURE__*/ new Vector3();

class LightShadow {

	constructor( camera ) {

		this.camera = camera;

		this.intensity = 1;

		this.bias = 0;
		this.normalBias = 0;
		this.radius = 1;
		this.blurSamples = 8;

		this.mapSize = new Vector2( 512, 512 );

		this.map = null;
		this.mapPass = null;
		this.matrix = new Matrix4();

		this.autoUpdate = true;
		this.needsUpdate = false;

		this._frustum = new Frustum();
		this._frameExtents = new Vector2( 1, 1 );

		this._viewportCount = 1;

		this._viewports = [

			new Vector4( 0, 0, 1, 1 )

		];

	}

	getViewportCount() {

		return this._viewportCount;

	}

	getFrustum() {

		return this._frustum;

	}

	updateMatrices( light ) {

		const shadowCamera = this.camera;
		const shadowMatrix = this.matrix;

		_lightPositionWorld$1.setFromMatrixPosition( light.matrixWorld );
		shadowCamera.position.copy( _lightPositionWorld$1 );

		_lookTarget$1.setFromMatrixPosition( light.target.matrixWorld );
		shadowCamera.lookAt( _lookTarget$1 );
		shadowCamera.updateMatrixWorld();

		_projScreenMatrix$1.multiplyMatrices( shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse );
		this._frustum.setFromProjectionMatrix( _projScreenMatrix$1 );

		shadowMatrix.set(
			0.5, 0.0, 0.0, 0.5,
			0.0, 0.5, 0.0, 0.5,
			0.0, 0.0, 0.5, 0.5,
			0.0, 0.0, 0.0, 1.0
		);

		shadowMatrix.multiply( _projScreenMatrix$1 );

	}

	getViewport( viewportIndex ) {

		return this._viewports[ viewportIndex ];

	}

	getFrameExtents() {

		return this._frameExtents;

	}

	dispose() {

		if ( this.map ) {

			this.map.dispose();

		}

		if ( this.mapPass ) {

			this.mapPass.dispose();

		}

	}

	copy( source ) {

		this.camera = source.camera.clone();

		this.intensity = source.intensity;

		this.bias = source.bias;
		this.radius = source.radius;

		this.mapSize.copy( source.mapSize );

		return this;

	}

	clone() {

		return new this.constructor().copy( this );

	}

	toJSON() {

		const object = {};

		if ( this.intensity !== 1 ) object.intensity = this.intensity;
		if ( this.bias !== 0 ) object.bias = this.bias;
		if ( this.normalBias !== 0 ) object.normalBias = this.normalBias;
		if ( this.radius !== 1 ) object.radius = this.radius;
		if ( this.mapSize.x !== 512 || this.mapSize.y !== 512 ) object.mapSize = this.mapSize.toArray();

		object.camera = this.camera.toJSON( false ).object;
		delete object.camera.matrix;

		return object;

	}

}

class DirectionalLightShadow extends LightShadow {

	constructor() {

		super( new OrthographicCamera( - 5, 5, 5, - 5, 0.5, 500 ) );

		this.isDirectionalLightShadow = true;

	}

}

class DirectionalLight extends Light {

	constructor( color, intensity ) {

		super( color, intensity );

		this.isDirectionalLight = true;

		this.type = 'DirectionalLight';

		this.position.copy( Object3D.DEFAULT_UP );
		this.updateMatrix();

		this.target = new Object3D();

		this.shadow = new DirectionalLightShadow();

	}

	dispose() {

		this.shadow.dispose();

	}

	copy( source ) {

		super.copy( source );

		this.target = source.target.clone();
		this.shadow = source.shadow.clone();

		return this;

	}

}

class AmbientLight extends Light {

	constructor( color, intensity ) {

		super( color, intensity );

		this.isAmbientLight = true;

		this.type = 'AmbientLight';

	}

}

const _matrix$3 = /*@__PURE__*/ new Matrix4();

class Raycaster {

	constructor( origin, direction, near = 0, far = Infinity ) {

		this.ray = new Ray( origin, direction );
		// direction is assumed to be normalized (for accurate distance calculations)

		this.near = near;
		this.far = far;
		this.camera = null;
		this.layers = new Layers();

		this.params = {
			Mesh: {},
			Line: { threshold: 1 },
			LOD: {},
			Points: { threshold: 1 },
			Sprite: {}
		};

	}

	set( origin, direction ) {

		// direction is assumed to be normalized (for accurate distance calculations)

		this.ray.set( origin, direction );

	}

	setFromCamera( coords, camera ) {

		if ( camera.isPerspectiveCamera ) {

			this.ray.origin.setFromMatrixPosition( camera.matrixWorld );
			this.ray.direction.set( coords.x, coords.y, 0.5 ).unproject( camera ).sub( this.ray.origin ).normalize();
			this.camera = camera;

		} else if ( camera.isOrthographicCamera ) {

			this.ray.origin.set( coords.x, coords.y, ( camera.near + camera.far ) / ( camera.near - camera.far ) ).unproject( camera ); // set origin in plane of camera
			this.ray.direction.set( 0, 0, - 1 ).transformDirection( camera.matrixWorld );
			this.camera = camera;

		} else {

			console.error( 'THREE.Raycaster: Unsupported camera type: ' + camera.type );

		}

	}

	setFromXRController( controller ) {

		_matrix$3.identity().extractRotation( controller.matrixWorld );

		this.ray.origin.setFromMatrixPosition( controller.matrixWorld );
		this.ray.direction.set( 0, 0, - 1 ).applyMatrix4( _matrix$3 );

		return this;

	}

	intersectObject( object, recursive = true, intersects = [] ) {

		intersect( object, this, intersects, recursive );

		intersects.sort( ascSort );

		return intersects;

	}

	intersectObjects( objects, recursive = true, intersects = [] ) {

		for ( let i = 0, l = objects.length; i < l; i ++ ) {

			intersect( objects[ i ], this, intersects, recursive );

		}

		intersects.sort( ascSort );

		return intersects;

	}

}

function ascSort( a, b ) {

	return a.distance - b.distance;

}

function intersect( object, raycaster, intersects, recursive ) {

	let propagate = true;

	if ( object.layers.test( raycaster.layers ) ) {

		const result = object.raycast( raycaster, intersects );

		if ( result === false ) propagate = false;

	}

	if ( propagate === true && recursive === true ) {

		const children = object.children;

		for ( let i = 0, l = children.length; i < l; i ++ ) {

			intersect( children[ i ], raycaster, intersects, true );

		}

	}

}

/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * phi (the polar angle) is measured from the positive y-axis. The positive y-axis is up.
 * theta (the azimuthal angle) is measured from the positive z-axis.
 */
class Spherical {

	constructor( radius = 1, phi = 0, theta = 0 ) {

		this.radius = radius;
		this.phi = phi; // polar angle
		this.theta = theta; // azimuthal angle

		return this;

	}

	set( radius, phi, theta ) {

		this.radius = radius;
		this.phi = phi;
		this.theta = theta;

		return this;

	}

	copy( other ) {

		this.radius = other.radius;
		this.phi = other.phi;
		this.theta = other.theta;

		return this;

	}

	// restrict phi to be between EPS and PI-EPS
	makeSafe() {

		const EPS = 0.000001;
		this.phi = Math.max( EPS, Math.min( Math.PI - EPS, this.phi ) );

		return this;

	}

	setFromVector3( v ) {

		return this.setFromCartesianCoords( v.x, v.y, v.z );

	}

	setFromCartesianCoords( x, y, z ) {

		this.radius = Math.sqrt( x * x + y * y + z * z );

		if ( this.radius === 0 ) {

			this.theta = 0;
			this.phi = 0;

		} else {

			this.theta = Math.atan2( x, z );
			this.phi = Math.acos( clamp( y / this.radius, - 1, 1 ) );

		}

		return this;

	}

	clone() {

		return new this.constructor().copy( this );

	}

}

if ( typeof __THREE_DEVTOOLS__ !== 'undefined' ) {

	__THREE_DEVTOOLS__.dispatchEvent( new CustomEvent( 'register', { detail: {
		revision: REVISION,
	} } ) );

}

if ( typeof window !== 'undefined' ) {

	if ( window.__THREE__ ) {

		console.warn( 'WARNING: Multiple instances of Three.js being imported.' );

	} else {

		window.__THREE__ = REVISION;

	}

}/**
 * 坐标系存储器
 */
class CoordinateStore {
    constructor() {
        /**
         * 工作平面
         */
        this.workPlane = new Plane$1();
        /**
         * 用户坐标系
         */
        this.ucsMap = new Map();
        /**
         * 当前激活坐标系
         */
        this.activeUcs = new Matrix4();
        /**
         * 当前激活坐标系的逆矩阵，用以减少瞬时计算量
         */
        this.activeUcsInv = new Matrix4();
        /**
         * 不考虑捕捉吸附等作用，光标位置直接对应的工作平面上的三维坐标
         */
        this.originalPos = new Point();
        /**
         * 当前激活视口的鼠标NDC二维坐标
         */
        this.ndcViewportPos2 = new Point2();
        /**
         * 当前世界坐标系下的三维点坐标 含捕捉
         */
        this.currentPos = new Point();
        /**
         * 当前用户坐标系下的三维点坐标
         */
        this.currentUcsPos = new Point();
        /**
         * 光标射线
         */
        this.viewCursorRay = new Ray$2();
        /**
         * 显示用长度
         */
        this.showLength = 0;
        /**
         * 显示用角度
         */
        this.showAngle = 0;
        /**
         * 长度尺寸比例换算 引擎尺寸/真实尺寸
         * 用于大尺度建模时，实际尺寸和显示尺寸成比例缩放，避免边界被裁切问题
         */
        this.lengthUnitRatio = 1;
        /**
         * 显示ucs
         */
        this.showUcs = true;
    }
    /**
     * 设置当前坐标点
     */
    setCurrentPos(point) {
        this.currentPos.copy(point);
        this.currentUcsPos.copy(this.currentPos).applyMatrix4(this.activeUcsInv);
    }
    /**
     * 设置当前坐标系（同时设置其逆矩阵）
     */
    setActiveUcs(ucs) {
        this.activeUcs.copy(ucs);
        _matrix$1.copy(ucs).invert();
        this.activeUcsInv.copy(_matrix$1);
    }
    /**
     * 按照当前UCS的基点和normal重新设置工作面
     */
    resetWorkPlane() {
        const element = this.activeUcs.elements;
        _ucsZ$1.set(element[8], element[9], element[10]);
        _ucsP$1.set(element[12], element[13], element[14]);
        this.workPlane.setFromNormalAndCoplanarPoint(_ucsZ$1, _ucsP$1);
    }
    /**
     * 销毁
     */
    dispose() {
        delete this.ucsMap;
    }
}
const _matrix$1 = new Matrix4();
const _ucsZ$1 = new Vector3();
const _ucsP$1 = new Vector3();/**
 * 图元存储器
 */
class PrimitiveStore {
    constructor() {
        /**
         * 和创建图元相关的系统变量
         */
        this.systemVarDict = {};
        /**
         * 存储所有图元
         */
        this.primitiveDict = {};
        /**
         * 存储所有临时图元
         */
        this.tempPrimitiveDict = {};
        /**
         * 视口内的图元
         */
        this.primitiveInView = {};
        /**
         * 系统图元
         */
        this.systemPrimitiveDict = {};
    }
    /**
     * 销毁
     */
    dispose() {
        delete this.primitiveDict;
        delete this.tempPrimitiveDict;
        delete this.primitiveInView;
        delete this.systemPrimitiveDict;
    }
}/**
 * 引擎事件类型划分
 */
const PythaEventName = {
    // 输入事件
    // 命令
    CMD: 'CMD',
    // 鼠标
    POINTER_DOWN: 'pointer_down',
    POINTER_MOVE: 'pointer_move',
    POINTER_UP: 'pointer_up',
    MOUSE_WHEEL: 'mouse_wheel',
    // 键盘输入
    OPTION: 'option',
    NUMBER: 'number', // 有长度单位
    COUNT: 'count', // 无量纲
    ANGLE: 'angle',
    TEXT: 'text',
    STRING: 'string',
    STRING_ARRAY: 'string_array',
    OBJECT: 'object',
    DY_TEXT: 'dy_text', // 动态输入框事件
    // 结束
    END: 'end',
    // 确认
    CONFIRM: 'confirm',
    // 加载外部数据
    LOAD_DATA: 'load_data',
    // 视图缩放
    ZOOM_IN: 'zoom_in',
    ZOOM_OUT: 'zoom_out',
    ZOOM_All: 'zoom_all',
    // 设置
    SETTING: 'setting',
    // 传递需要布置的块图元信息
    BLOCK: 'block',
    // 内部事件
    ZOOM_CHANGE: 'zoom_change',
    CURSOR_CHANGE: 'cursor_change',
    SELECT_CHANGE: 'select_change',
    // 输出事件
    NOTICE: 'Notice', // 给外部系统发送文本消息
    NEED_INPUT: 'need_input', // 请求特定类型的输入
    DATA_CHANGE: 'data_change', // 图元数据变更，便于外部系统的同步、存储等操作
    OUTPUT_DATA: 'output_data', // 输出指定格式的数据集 例如拾取点、距离等
};
const OutputDataType = {
    STRING: 'string',
    NUMBER: 'number',
    POINT: 'point',
    VECTOR3: 'vector3',
    OBJECT: 'objcet',
};
/* *******************************************输入start******************************************* */
/**
 * 功能命令型事件
 */
class PythaEventCMD {
    constructor() {
        this.cmd = PythaEventName.CMD;
    }
}
/**
 * 指定点事件（光标点击、系统输入指定点）
 */
class PythaEventPointerDown {
    constructor() {
        this.cmd = PythaEventName.POINTER_DOWN;
        this.data = new Pointer();
    }
}
/**
 * 光标点移动事件
 */
class PythaEventPointerMove {
    constructor() {
        this.cmd = PythaEventName.POINTER_MOVE;
        this.data = new Pointer();
    }
}
/**
 * 光标点抬起事件
 */
class PythaEventPointerUp {
    constructor() {
        this.cmd = PythaEventName.POINTER_UP;
        this.data = new Pointer();
    }
}
/**
 * 鼠标滚轮滚动事件
 */
class PythaEventMouseWheel {
    constructor() {
        this.cmd = PythaEventName.MOUSE_WHEEL;
        this.data = new Pointer();
    }
}
/**
 * 命令选项事件
 */
class PythaEventOption {
    constructor() {
        this.cmd = PythaEventName.OPTION;
    }
}
/**
 * 结束事件
 */
class PythaEventEnd {
    constructor(data = true) {
        this.cmd = PythaEventName.END;
        this.data = true;
        this.data = data;
    }
}
/**
 * 确认事件
 */
class PythaEventConfirm {
    constructor() {
        this.cmd = PythaEventName.CONFIRM;
    }
}
/**
 * 接收数值类型事件 有长度量纲
 */
class PythaEventNumber {
    constructor() {
        this.cmd = PythaEventName.NUMBER;
    }
}
/**
 * 输入文字事件
 */
class PythaEventText {
    constructor() {
        this.cmd = PythaEventName.TEXT;
    }
}
/**
 * 输入动态输入框文字事件
 */
class PythaEventDyText {
    constructor() {
        this.cmd = PythaEventName.DY_TEXT;
    }
}
/**
 * 输入角度事件
 */
class PythaEventAngle {
    constructor() {
        this.cmd = PythaEventName.ANGLE;
    }
}
/**
 * 输入数量事件 无量纲
 */
class PythaEventCount {
    constructor() {
        this.cmd = PythaEventName.COUNT;
    }
}
/**
 * 输入字符事件
 */
class PythaEventString {
    constructor() {
        this.cmd = PythaEventName.STRING;
    }
}
/**
 * 输入字符数组事件
 */
class PythaEventStringArray {
    constructor() {
        this.cmd = PythaEventName.STRING_ARRAY;
    }
}
/**
 * 输入对象事件
 */
class PythaEventObject {
    constructor() {
        this.cmd = PythaEventName.OBJECT;
    }
}
/**
 * 监听加载图元
 */
class PythaEventLoadData {
    constructor() {
        this.cmd = PythaEventName.LOAD_DATA;
    }
}
/**
 * 监听固定倍率缩放
 */
class PythaEventZoomInOut {
    constructor() {
        this.cmd = PythaEventName.ZOOM_IN;
        this.data = true; // isZoomIn
    }
}
/**
 * 监听缩放至中心
 */
class PythaEventZoomAll {
    constructor() {
        this.cmd = PythaEventName.ZOOM_All;
    }
}
/**
 * 设置事件
 */
class PythaEventSetting {
    constructor() {
        this.cmd = PythaEventName.SETTING;
    }
}
class PythaEventBlock {
    constructor() {
        this.cmd = PythaEventName.BLOCK;
    }
}
/* *******************************************输入end******************************************* */
/* *******************************************内部事件****************************************** */
/**
 * 光标形状变更事件
 */
class PythaEventCursorTypeChange {
    constructor() {
        this.cmd = PythaEventName.CURSOR_CHANGE;
    }
}
/**
 * 监听zoom变化
 */
class PythaEventZoomChange {
    constructor() {
        this.cmd = PythaEventName.ZOOM_CHANGE;
    }
}
/**
 * 监听zoom变化
 */
class PythaEventSelectChange {
    constructor() {
        this.cmd = PythaEventName.SELECT_CHANGE;
    }
}
/* *******************************************输出start******************************************* */
/**
 * 输出通知事件
 */
class PythaEventNotice {
    constructor() {
        this.cmd = PythaEventName.NOTICE;
    }
}
/**
 * 输出向引擎输入数据事件
 */
class PythaEventNeedInput {
    constructor(data) {
        this.cmd = PythaEventName.NEED_INPUT;
        this.data = data;
    }
}
/**
 * 输出引擎内部状态与数据变更的事件
 */
class PythaEventDataChange {
    constructor(data = {}) {
        this.cmd = PythaEventName.DATA_CHANGE;
        this.data = data;
    }
}
/**
 * 输出向引擎输入数据事件
 */
class PythaEventOutputData {
    constructor(data) {
        this.cmd = PythaEventName.OUTPUT_DATA;
        this.data = data;
    }
}
/* *******************************************输出end******************************************* */
/**
 * 光标事件数据格式封装
 */
class Pointer {
    copy(pointer) {
        if (pointer.point2 != null) {
            if (this.point2 == null)
                this.point2 = new Point2();
            this.point2.copy(pointer.point2);
        }
        this.type = pointer.type;
        this.ctrlKey = pointer.ctrlKey;
        this.shiftKey = pointer.shiftKey;
        this.altKey = pointer.altKey;
        this.id = pointer.id;
        this.button = pointer.button;
        this.deltaY = pointer.deltaY;
        this.option = pointer.option;
        if (pointer.point != null) {
            if (this.point == null)
                this.point = new Point();
            this.point.copy(pointer.point);
        }
        return this;
    }
    clone() {
        let res = new Pointer();
        return res.copy(this);
    }
    setPoint(point) {
        if (this.point == null)
            this.point = new Point();
        this.point.copy(point);
    }
}/**
 * 图的状态
 */
var GRAPH_STATUS;
(function (GRAPH_STATUS) {
    /**
     * 运行
     */
    GRAPH_STATUS[GRAPH_STATUS["RUNNING"] = 0] = "RUNNING";
    /**
     * 暂停挂起
     */
    GRAPH_STATUS[GRAPH_STATUS["HANG_UP"] = 1] = "HANG_UP";
    /**
     * 空
     */
    GRAPH_STATUS[GRAPH_STATUS["NONE"] = 2] = "NONE";
})(GRAPH_STATUS || (GRAPH_STATUS = {}));
/**
 * 边的类型
 */
var EDGE_TYPE;
(function (EDGE_TYPE) {
    /**
     * 普通边
     */
    EDGE_TYPE[EDGE_TYPE["EXECUTE"] = 0] = "EXECUTE";
    /**
     * 终止边
     */
    EDGE_TYPE[EDGE_TYPE["STOP"] = 1] = "STOP";
})(EDGE_TYPE || (EDGE_TYPE = {}));
/**
 * 事件中介每一页的基类，构造成链表模式
 */
class EventGraphBase {
    /**
     * 构造函数
     * @param mediator 事件中介
     */
    constructor(mediator) {
        /**
         * 是否是常驻图
         */
        this.isAlwaysActive = false;
        /**
         * 事件图的执行状态
         */
        this.status = GRAPH_STATUS.NONE;
        /**
         * 是否可以被上一次命令重复执行
         */
        this.putInLastCmd = true;
        /**
         * 指向当前激活的节点
         */
        this.currentPointers = [];
        /**
         * 事件处理器共享的内存
         */
        this.cache = {
            pointerDownList: [],
            pointerUpList: [],
            pointerMove: new Pointer(),
            orthoPolarBasePoint: null,
            primitiveList: [],
            deletePrimitiveList: [],
            pointerWheel: new Pointer(),
            inputNumber: {},
            inputString: {},
            inputObject: {},
            inputOption: null,
            needInput: null,
            optionsCanSwitch: [],
            data: {}
        };
        /**
         * 起始节点
         */
        this.head = null;
        /**
         * 事件图
         */
        this.graph = new Map();
        /**
         * 挂起的节点
         */
        this.hangupNodes = new Map();
        /**
         * 挂起的节点 只接收一次事件
         */
        this.hangUpNodesOnce = new Map();
        /**
         * 嫁接节点
         */
        this.graftNodes = new Map();
        this.eventMediator = mediator;
        this.generate();
    }
    /**
     * 获得头节点
     * @returns
     */
    getHead() {
        return this.head;
    }
    /**
     * 添加节点
     */
    addNode(node) {
        if (!this.graph.has(node.id)) {
            if (node.isGraftNode) {
                this.graftNodes.set(node.graftKey, node);
            }
            this.graph.set(node.id, node);
        }
    }
    /**
     * 连接两个节点
     * @param from 上一级处理器
     * @param to 下一级处理器
     */
    addEdge(from, to, type = EDGE_TYPE.EXECUTE) {
        if (!this.graph.has(from.id))
            this.addNode(from);
        if (!this.graph.has(to.id))
            this.addNode(to);
        from.addOut(to, type);
        to.addEntry(from);
    }
    /**
     * 删除边
     * @param from 边的起点
     * @param to 边的终点
     */
    deleteEdge(from, to) {
        from.deleteOut(to);
        to.deleteEntry(from);
    }
    /**
     * 打印图的所有边
     */
    printGraph() {
        var _a;
        for (const [_, node] of this.graph) {
            for (const out of node.outNodes) {
                console.log(`${node.handlerName} -> ${(_a = out.node) === null || _a === void 0 ? void 0 : _a.handlerName}`); // TODO: 打印名字方式要改
            }
        }
    }
    /**
     * 创建图 override
     */
    generate() { }
    /**
     * 启动图
     */
    start() {
        if (this.head == null)
            return null;
        this.status = GRAPH_STATUS.RUNNING;
        return this.head;
    }
    /**
     * 暂停
     */
    pause() {
        this.status = GRAPH_STATUS.HANG_UP;
    }
    /**
     * 继续
     */
    goOn() {
        this.status = GRAPH_STATUS.RUNNING;
    }
    /**
     * 结束事件触发图的销毁, 常驻图需要覆写
     */
    end() {
        // 重新设置正交为激活
        this.cleanCache();
        this.status = GRAPH_STATUS.NONE;
        for (const [_, node] of this.graph) {
            node.dispose();
        }
        // delete this.hangUpNodesOnce;
        // delete this.hangupNodes;
        // this.cache.pointerDownList = [];
        // this.cache.pointerUpList = [];
        // this.cache.pointerMove = new Pointer();
        // this.cache.lastPointerMove = undefined;
        // for (let pri of this.cache.primitiveList) {
        //     if (pri.temporary) {
        //         pri.needDelete = true;
        //     }
        // }
        // this.cache.primitiveList = [];
        this.hangUpNodesOnce = new Map();
        this.hangupNodes = new Map();
        delete this.graph;
        this.eventMediator = undefined;
        this.head = null;
    }
    /**
     * 匹配挂起的节点
     * @param event
     * @returns
     */
    matchEventAndNode(event) {
        var _a, _b;
        // console.log("match event:", event, this.hangUpNodesOnce)
        if (this.status != GRAPH_STATUS.RUNNING)
            return;
        // 匹配一次性挂起的节点
        let onceMatchs = (_a = this.hangUpNodesOnce) === null || _a === void 0 ? void 0 : _a[event.cmd];
        if (onceMatchs != null) {
            for (const node of [...onceMatchs]) { // 防止遍历过程中有新的元素加入后直接进入循环
                node.run(event);
            }
        }
        // 匹配一直挂起的节点
        let matchs = (_b = this.hangupNodes) === null || _b === void 0 ? void 0 : _b[event.cmd];
        if (matchs != null) {
            for (const node of [...matchs]) {
                node.run(event);
            }
        }
        // 匹配插件图节点
        for (const [_, node] of this.graftNodes) {
            for (const pluginGraph of node.graftOutsBefore) {
                pluginGraph.matchEventAndNode(event);
            }
            for (const pluginGraph of node.graftOutsAfter) {
                pluginGraph.matchEventAndNode(event);
            }
        }
    }
    /**
     * 清空缓存数据
     */
    cleanCache() {
        var _a, _b;
        // 清空可能的辅助线
        if (this.cache.data['helpline'] != null) {
            let helpline = this.cache.data['helpline'];
            (_a = helpline.remove) === null || _a === void 0 ? void 0 : _a.call(helpline);
        }
        // 清空缓存图元
        for (let pri of this.cache.primitiveList) {
            if (pri.temporary) {
                pri.needDelete = true;
            }
        }
        // 清空捕捉
        const storage = (_b = this.eventMediator) === null || _b === void 0 ? void 0 : _b.storage;
        if (storage != null) {
            storage.captureStore.capturePoint = null;
            storage.captureStore.captureActived = false;
            storage.orthoPolarStore.orthoActive = true;
        }
        // 清空缓存
        this.cache.pointerDownList = [];
        this.cache.pointerUpList = [];
        this.cache.pointerMove = new Pointer();
        this.cache.orthoPolarBasePoint = null;
        this.cache.primitiveList = [];
        this.cache.deletePrimitiveList = [];
        this.cache.pointerWheel = new Pointer();
        this.cache.data = {};
        this.cache.inputNumber = {};
        this.cache.inputString = {};
        this.cache.inputObject = {};
    }
    /**
     * 嫁接 优先执行
     * @param key 嫁接节点的key
     * @param graph
     * @returns
     */
    addGraphPluginAtBefore(key, graph) {
        let graft = this.graftNodes.get(key);
        if (graft == null)
            return;
        if (graph == null)
            return;
        graph.parentGraph = this;
        graft.graftOutsBefore.push(graph);
    }
    /**
     * 嫁接 最后执行
     * @param key 嫁接节点的key
     * @param graph
     * @returns
     */
    addGraphPluginAtAfter(key, graph) {
        let graft = this.graftNodes.get(key);
        if (graft == null)
            return;
        graph.parentGraph = this;
        graft.graftOutsAfter.push(graph);
    }
    /**
     * 清除插件
     * @param key 嫁接节点的key
     * @returns
     */
    clearPlugin(key) {
        let graft = this.graftNodes.get(key);
        if (graft == null)
            return;
        graft.clear();
    }
}/**
 * 事件处理器的编号计数器
 */
let IdCount = 1;
class EventGraphNode {
    /**
     * 构造函数
     * @param handlerName 处理器类名
     */
    constructor(graph, handlerName = null) {
        /**
         * 是否是嫁接节点
         */
        this.isGraftNode = false;
        /**
         * 节点编号
         */
        this.id = IdCount++;
        /**
         * 下一级节点列表
         */
        this.outNodes = [];
        /**
         * 上一级节点列表
         */
        this.entryNodes = [];
        /**
         * 节点本轮执行完毕
         */
        this.isRunFinished = false;
        /**
         * 节点被挂起
         */
        this.isWaitingEvent = false;
        this.handlerName = handlerName;
        this.graph = graph;
        this.needExtraFuncOnHandlerActive = () => { };
    }
    /**
     * 设置处理器
     * @param handlerName
     */
    setHandler(handlerName) {
        this.handlerName = handlerName;
        if (this._handler) {
            this._handler.dispose();
            this._handler = null;
        }
    }
    /**
     * 添加下一级节点
     * @param node 节点
     * @returns
     */
    addOut(node, edgeType = EDGE_TYPE.EXECUTE) {
        // 检查有无重复
        let idx = this.outNodes.findIndex(item => { var _a; return ((_a = item.node) === null || _a === void 0 ? void 0 : _a.id) == node.id; });
        if (idx >= 0)
            return false;
        // 添加操作
        this.outNodes.push({
            type: edgeType,
            node: node,
        });
        return true;
    }
    /**
     * 添加上一级节点
     * @param node 节点
     * @returns
     */
    addEntry(node) {
        // 检查有无重复
        let idx = this.entryNodes.findIndex(item => item.id == node.id);
        if (idx >= 0)
            return false;
        // 添加操作
        this.entryNodes.push(node);
        return true;
    }
    /**
     * 删除下一级连接关系
     * @param node 节点
     */
    deleteOut(node) {
        this.outNodes = this.outNodes.filter(item => { var _a; return ((_a = item.node) === null || _a === void 0 ? void 0 : _a.id) != node.id; });
    }
    /**
     * 删除上一级连接关系
     * @param node 节点
     */
    deleteEntry(node) {
        this.entryNodes = this.entryNodes.filter(item => item.id != node.id);
    }
    /**
     * 获取处理器
     */
    getHandler() {
        var _a;
        if (this._handler == null && this.handlerName != null) {
            this._handler = new (this.handlerName)(this);
            (_a = this.needExtraFuncOnHandlerActive) === null || _a === void 0 ? void 0 : _a.call(this, this._handler);
        }
        return this._handler;
    }
    /**
     * 运行节点
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a, _b, _c, _d, _e;
        // 获取处理器
        const handler = this.getHandler();
        // 确认输入事件
        if (handler != null) {
            if (handler.needEvent != null && !this.isWaitingEvent) {
                // 需要 挂起节点
                if (handler.needEventOnce) {
                    let executeSet = this.graph.hangUpNodesOnce[(_a = handler.needEvent) === null || _a === void 0 ? void 0 : _a.cmd];
                    if (executeSet == null) {
                        executeSet = new Set();
                        this.graph.hangUpNodesOnce[(_b = handler.needEvent) === null || _b === void 0 ? void 0 : _b.cmd] = executeSet;
                    }
                    executeSet.add(this);
                    this.isWaitingEvent = true;
                }
                else {
                    let executeSet = this.graph.hangupNodes[(_c = handler.needEvent) === null || _c === void 0 ? void 0 : _c.cmd];
                    if (executeSet == null) {
                        executeSet = new Set();
                        this.graph.hangupNodes[(_d = handler.needEvent) === null || _d === void 0 ? void 0 : _d.cmd] = executeSet;
                    }
                    executeSet.add(this);
                    this.isWaitingEvent = true;
                }
                // console.log("handler2: ", handler, {...handler.node});
                return;
            }
            // 不需要，执行处理器动作
            let res = handler.run(data);
            // 接收处理器状态
            if (res == false) {
                return;
            }
            if (this.isWaitingEvent && handler.needEventOnce) {
                // 撤销本节点的单次执行挂起
                this.onHangupEndEvent();
            }
        }
        this.isRunFinished = true;
        // 获取下一级节点
        for (let next of this.outNodes) {
            if (next.type == EDGE_TYPE.STOP && next.node.isWaitingEvent) {
                // 识别是撤销挂起的边，将节点的挂起状态撤销
                next.node.onHangupEndEvent();
            }
            else {
                // 识别是正常执行的边
                next.node.run();
            }
        }
        (_e = this.needExtraFuncAfter) === null || _e === void 0 ? void 0 : _e.call(this, this._handler);
    }
    /**
     * 结束挂起
     */
    onHangupEndEvent() {
        var _a, _b;
        if (this._handler == null) {
            this.isWaitingEvent = false;
            return;
        }
        let hangupSet = this.graph.hangupNodes[(_a = this._handler.needEvent) === null || _a === void 0 ? void 0 : _a.cmd];
        if (hangupSet != null) {
            hangupSet.delete(this);
        }
        let onceExecuteSet = this.graph.hangUpNodesOnce[(_b = this._handler.needEvent) === null || _b === void 0 ? void 0 : _b.cmd];
        if (onceExecuteSet != null) {
            onceExecuteSet.delete(this);
        }
        this.isWaitingEvent = false;
    }
    /**
     * 销毁节点
     */
    dispose() {
        if (this._handler != null) {
            this._handler.dispose();
        }
        this.onHangupEndEvent();
    }
}/**
 * 事件处理器的编号计数器
 */
let eventHandlerIdCount = 1;
/**
 * 事件处理器的基类
 */
class EventHandlerBase {
    set(key, value) {
        this[key] = value;
    }
    constructor(node) {
        /**
         * 事件处理器编号
         */
        this.id = eventHandlerIdCount++;
        /**
         * 当前节点是否执行完毕
         */
        this.isFinish = false;
        /**
         * 处理器是否是分支处理器
         */
        this.isSwitch = false;
        /**
         * 是否只需要接收一次事件
         */
        this.needEventOnce = true;
        this.node = node;
    }
    /**
     * 事件处理器的核心方法 override
     * @param data
     */
    run(data = {}) {
        return true;
    }
    /**
     * 销毁
     */
    dispose() { }
    /**
     * 获取引擎存储器
     * @returns
     */
    getPythaStorage() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.node) === null || _a === void 0 ? void 0 : _a.graph) === null || _b === void 0 ? void 0 : _b.eventMediator) === null || _c === void 0 ? void 0 : _c.storage;
    }
}const MOUSE_BUTTON = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
};/**
 * 计算点处理器
 */
class EventHandlerCalPointerDown extends EventHandlerBase {
    constructor(node) {
        super(node);
        /**
         * 指定鼠标按下的类型，默认是左键
         */
        this.buttonTypes = [MOUSE_BUTTON.LEFT];
        this.needEvent = new PythaEventPointerDown();
        this.needEventOnce = true;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(event) {
        var _a, _b, _c, _d;
        if (event.cmd != this.needEvent.cmd)
            return false; // 如果传入事件不符 则不执行处理器
        let needInput = this.node.graph.cache.needInput;
        if (needInput != null && !(needInput === null || needInput === void 0 ? void 0 : needInput.inputTypes.includes(PythaEventName.POINTER_DOWN)))
            return false;
        let point = new Point();
        if (event.data.type === "MOUSE") {
            // 识别是鼠标按下事件
            // 如果鼠标事件类型不符，则不处理
            if (this.buttonTypes.indexOf(event.data.button) < 0)
                return false;
            this.node.graph.cache.data['pointdown_timestamp'] = Date.now(); // 存储鼠标按下时间，用于判断click
            // 求垂直屏幕的线和工作面的交点
            const storage = PythaStorage.instance;
            let mousePos = event.data.point2;
            const viewportStore = storage.viewportStore;
            let rect = viewportStore.getViewportRect(viewportStore.currentViewportKey);
            if (rect == null)
                return false;
            let x = (mousePos.x - rect.x) / rect.width * 2 - 1;
            let y = -(mousePos.y - rect.y) / rect.height * 2 + 1;
            const coordinateStore = storage.coordinateStore;
            coordinateStore.ndcViewportPos2.set(x, y);
            let workPlane = coordinateStore.workPlane;
            const camera = (_a = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
            if (camera == null)
                return false;
            _rayStart$4.set(x, y, -1).unproject(camera);
            _rayEnd$4.set(x, y, 1).unproject(camera);
            _ray$4.set(_rayStart$4, _rayEnd$4);
            GeoIntersection.LineIntersectPlane(_ray$4, workPlane, point);
            // 正交极轴位置
            if (storage.orthoPolarStore.orthoPolarPoint != null) {
                point.copy(storage.orthoPolarStore.orthoPolarPoint);
            }
            // 捕捉点位置
            if (storage.captureStore.capturePoint != null) {
                point.copy(storage.captureStore.capturePoint);
            }
            // 夹点位置
            if (((_b = storage.clampStore.activeClampPoints) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                let _p = storage.clampStore.activeClampPoints[0].featurePoint.point;
                point.copy(_p);
            }
            event.data.point = point;
            event.data.option = (_c = this.node.graph.cache.needInput) === null || _c === void 0 ? void 0 : _c.option; // 给确定点赋予选项类型
            this.node.graph.cache.pointerDownList.push(event.data.clone());
            // 同步给pointmove
            // let pointmove = this.node.graph.cache.pointerMove;
            // if (!pointmove.point) {
            //     pointmove.point = new Point();
            // }
            // pointmove.point.copy(point);
            // if (!pointmove.point2) {
            //     pointmove.point2 = new Point2();
            // }
            // pointmove.point2.copy(event.data.point2);
            this.node.graph.cache.data['isPointDown'] = true;
            return true;
        }
        else if (event.data.type === "SPECIFY" && event.data.point != null) {
            // 人为输入确定的点
            event.data.option = (_d = this.node.graph.cache.needInput) === null || _d === void 0 ? void 0 : _d.option; // 给确定点赋予选项类型
            this.node.graph.cache.pointerDownList.push(event.data.clone());
            // if (this.node.graph.cache.pointerMove.point) {
            //     this.node.graph.cache.pointerMove.point.copy(event.data.point);
            // } else {
            //     this.node.graph.cache.pointerMove.point = new Point();
            //     this.node.graph.cache.pointerMove.point.copy(event.data.point);
            // }
            this.node.graph.cache.data['isPointDown'] = true;
            return true;
        }
        return false;
    }
}
const _rayStart$4 = new Vector3();
const _rayEnd$4 = new Vector3();
const _ray$4 = new Line$2();/**
 * 计算点处理器
 */
class EventHandlerCalPointerMove extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventPointerMove();
        this.needEventOnce = false;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(event) {
        var _a, _b, _c;
        if (event.cmd != this.needEvent.cmd)
            return false; // 如果传入事件不符 则不执行处理器
        const storage = PythaStorage.instance;
        if (event.data.id != storage.coordinateStore.originalPosKey) {
            // 求垂直屏幕的线和工作面的交点
            let mousePos = event.data.point2;
            const viewportStore = storage.viewportStore;
            let rect = viewportStore.getViewportRect(viewportStore.currentViewportKey);
            if (rect == null)
                return false;
            let x = (mousePos.x - rect.x) / rect.width * 2 - 1;
            let y = -(mousePos.y - rect.y) / rect.height * 2 + 1;
            const coordinateStore = storage.coordinateStore;
            coordinateStore.ndcViewportPos2.set(x, y);
            let workPlane = coordinateStore.workPlane;
            const camera = (_a = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
            if (camera == null)
                return false;
            const ray = storage.coordinateStore.viewCursorRay;
            _rayStart$3.set(x, y, -1).unproject(camera);
            _rayEnd$3.set(x, y, 1).unproject(camera);
            _ray$3.set(_rayStart$3, _rayEnd$3);
            GeoIntersection.LineIntersectPlane(_ray$3, workPlane, _point$a);
            _rayDir.set(x, y, 1).unproject(camera).sub(_rayStart$3).normalize();
            ray.set(_rayStart$3, _rayDir);
            // 存入图缓存
            event.data.option = (_b = this.node.graph.cache.needInput) === null || _b === void 0 ? void 0 : _b.option; // 给确定点赋予选项类型
            this.node.graph.cache.pointerMove.copy(event.data);
            this.node.graph.cache.pointerMove.setPoint(_point$a);
            // 将原始三维点存入存储器
            storage.coordinateStore.originalPos.copy(_point$a);
            storage.coordinateStore.setCurrentPos(_point$a);
            // 存入pointermove编号
            storage.coordinateStore.originalPosKey = event.data.id;
        }
        else {
            // 已经计算过了,直接取
            _point$a.copy(storage.coordinateStore.originalPos);
            event.data.option = (_c = this.node.graph.cache.needInput) === null || _c === void 0 ? void 0 : _c.option; // 给确定点赋予选项类型
            this.node.graph.cache.pointerMove.copy(event.data);
            this.node.graph.cache.pointerMove.setPoint(_point$a);
        }
        this.node.graph.cache.data['isPointDown'] = false;
        return true;
    }
}
const _rayStart$3 = new Vector3();
const _rayEnd$3 = new Vector3();
const _rayDir = new Vector3();
const _ray$3 = new Line$2();
const _point$a = new Point();/**
 * 计算点处理器
 */
class EventHandlerCalPointerUp extends EventHandlerBase {
    constructor(node) {
        super(node);
        /**
         * 指定鼠标按下的类型，默认是左键
         */
        this.buttonTypes = [MOUSE_BUTTON.LEFT, MOUSE_BUTTON.MIDDLE];
        this.needEvent = new PythaEventPointerUp();
        this.needEventOnce = true;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(event) {
        var _a;
        if (event.cmd != this.needEvent.cmd)
            return false; // 如果传入事件不符 则不执行处理器
        let point = new Point();
        if (event.data.type === "MOUSE") {
            // 识别是鼠标按下事件
            // 如果鼠标事件类型不符，则不处理
            if (this.buttonTypes.indexOf(event.data.button) < 0)
                return false;
            // 计算是否是click事件
            let pointDownTime = this.node.graph.cache.data['pointdown_timestamp'];
            let pointUpTime = Date.now();
            let delta = pointUpTime - pointDownTime;
            if (delta < 200) {
                this.node.graph.cache.data['onClick'] = true;
            }
            else {
                this.node.graph.cache.data['onClick'] = false;
            }
            delete this.node.graph.cache.data['pointdown_timestamp'];
            // 求垂直屏幕的线和工作面的交点
            const storage = PythaStorage.instance;
            let mousePos = event.data.point2;
            const viewportStore = storage.viewportStore;
            let rect = viewportStore.getViewportRect(viewportStore.currentViewportKey);
            if (rect == null)
                return false;
            let x = (mousePos.x - rect.x) / rect.width * 2 - 1;
            let y = -(mousePos.y - rect.y) / rect.height * 2 + 1;
            const coordinateStore = storage.coordinateStore;
            coordinateStore.ndcViewportPos2.set(x, y);
            let workPlane = coordinateStore.workPlane;
            const camera = (_a = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
            if (camera == null)
                return false;
            _rayStart$2.set(x, y, -1).unproject(camera);
            _rayEnd$2.set(x, y, 1).unproject(camera);
            _ray$2.set(_rayStart$2, _rayEnd$2);
            GeoIntersection.LineIntersectPlane(_ray$2, workPlane, point);
            // TODO: 正交极轴
            if (storage.captureStore.capturePoint != null) {
                point.copy(storage.captureStore.capturePoint);
            }
            event.data.point = point;
            this.node.graph.cache.pointerUpList.push(event.data.clone());
            return true;
        }
        return false;
    }
}
const _rayStart$2 = new Vector3();
const _rayEnd$2 = new Vector3();
const _ray$2 = new Line$2();/**
 * 启动处理器
 */
class EventHandlerStart extends EventHandlerBase {
    /**
     * 运行处理器
     * @param data
     * @returns
     */
    run(data = {}) {
        const storage = PythaStorage.instance;
        this.node.graph.cache.pointerDownList = [];
        this.node.graph.cache.pointerMove = new Pointer();
        this.node.graph.cache.pointerWheel = new Pointer();
        this.node.graph.cache.pointerUpList = [];
        this.node.graph.cache.orthoPolarBasePoint = null;
        // this.node.graph.cache.lastPointerMove = undefined;
        this.node.graph.cache.primitiveList = [];
        this.node.graph.cache.data = {};
        this.node.graph.cache.inputNumber = {};
        this.node.graph.cache.inputOption = null;
        this.node.graph.cache.needInput = null;
        this.node.graph.cache.optionsCanSwitch = [];
        if (this.node.graph.cache.pointerMove.point == null) {
            this.node.graph.cache.pointerMove.point = new Point();
            this.node.graph.cache.pointerMove.point.copy(storage.coordinateStore.currentPos);
        }
        return true;
    }
}const RenderMode = {
    /**
     * 线框模型
     */
    WIREFRAME: 1,
    /**
     * 概念模型
     */
    CONCEPT: 2,
    /**
     * 透明模式
     */
    OPACITY: 3,
};/**
 * 图元中渲染对象的渲染类型，点模式、线模式、面模式
 */
const RenderItemType = {
    /**
     * 面渲染
     */
    MESH: 'Mesh',
    /**
     * 线渲染
     */
    LINE: 'Line',
    /**
     * 点渲染
     */
    POINT: 'Point',
};/**
 * 渲染桶的上限
 */
const RenderBucketLimit = 60000;
/**
 * 单次添加数组的上限
 */
const CHUNK_SIZE = 10000;
/**
 * 点的贴图
 */
const PointTexturePng = 'data:image/png;base64,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';
/**
 * 点的纹理，因为是异步的，所以要提前加载好
 */
const pointTexture = new TextureLoader().load(PointTexturePng);
/**
 * 更新模式
 */
var UpdateType;
(function (UpdateType) {
    UpdateType[UpdateType["ALL"] = 0] = "ALL";
    UpdateType[UpdateType["MAIN"] = 1] = "MAIN";
    UpdateType[UpdateType["TEMP"] = 2] = "TEMP";
    UpdateType[UpdateType["SYSTEM"] = 3] = "SYSTEM";
})(UpdateType || (UpdateType = {}));
/**
 * 防止栈溢出，将数组arrayA中的元素添加到arrayB末尾
 * @param arrayA 添加的数组
 * @param arrayB 被添加的数组
 */
function pushArrayAToArrayB(arrayA, arrayB) {
    for (let i = 0; i < arrayA.length; i++) {
        arrayB.push(arrayA[i]);
    }
}
/**
 * 防止栈溢出的数组splice方法
 * @param arrayA 添加的数组
 * @param arrayB 被添加的数组
 * @param start 在数组B中的添加的起点索引
 * @param deleteCount 在数组B中需要删除的数组长度
 * @param maxSize 单次添加块的最大长度
 */
function spliceArrayAToArrayB(arrayA, arrayB, start, deleteCount, maxSize = CHUNK_SIZE) {
    let i = 0;
    let tmpDeleteCount = deleteCount;
    while (i < arrayA.length) {
        // 计算最终的 splice 操作范围
        const chunk = arrayA.slice(i, i + maxSize);
        // 执行 splice 操作，更新 arrayB
        arrayB.splice(start, tmpDeleteCount, ...chunk);
        // 更新 start 和 deleteCount 以确保下次操作的位置正确
        start += chunk.length; // 更新插入的起始位置
        tmpDeleteCount = 0; // 仅删除一次，后续不再删除
        i += maxSize;
    }
}
/**
 * 渲染处理器，由中介直接管理
 */
class EventHandlerRender {
    constructor(eventMediator) {
        /**
         * 临时变量
         */
        this._target = new Vector3();
        /**
         * 根据uuid列表删除图元
         * @param uuids
         */
        this.removePrimitiveByUuidsInPrimitiveDict = (uuids = [], primitiveDict) => {
            // const primitiveStore = PythaStorage.instance.primitiveStore;
            for (let i = 0; i < uuids.length; i++) {
                let primitive = primitiveDict[uuids[i]];
                if (!primitive)
                    continue;
                delete primitiveDict[uuids[i]];
                //TODO 缺少视口内图元的逻辑
            }
        };
        this.eventMediator = eventMediator;
    }
    /**
     * 渲染
     */
    render(needRedraw = false, updateType = UpdateType.ALL) {
        if (needRedraw) {
            const primitiveStore = PythaStorage.instance.primitiveStore;
            if (updateType === UpdateType.ALL) {
                this.genRenderData(primitiveStore.primitiveDict);
                this.genRenderData(primitiveStore.tempPrimitiveDict);
                this.genRenderData(primitiveStore.systemPrimitiveDict);
            }
            else if (updateType === UpdateType.TEMP) {
                this.genRenderData(primitiveStore.tempPrimitiveDict);
            }
            else if (updateType === UpdateType.MAIN) {
                this.genRenderData(primitiveStore.primitiveDict);
            }
            else if (updateType === UpdateType.SYSTEM) {
                this.genRenderData(primitiveStore.systemPrimitiveDict);
            }
            this.addRenderDataToScene();
        }
        const viewportStore = PythaStorage.instance.viewportStore;
        const renderer = viewportStore.renderer;
        const labelRenderer = viewportStore.labelRenderer;
        const viewportItems = viewportStore.viewportItems;
        const scene = viewportStore.scene;
        renderer.setClearColor(viewportStore.background, 0);
        for (const key in viewportItems) {
            const viewport = viewportItems[key];
            const camera = viewport.camera;
            let range = viewport.range;
            const root = viewportStore.rootHTML;
            const clientWidth = root.offsetWidth;
            const clientHeight = root.offsetHeight;
            renderer.setSize(clientWidth, clientHeight);
            labelRenderer.setSize(clientWidth, clientHeight);
            renderer.setViewport(range[0] * clientWidth, range[1] * clientHeight, range[2] * clientWidth, range[3] * clientHeight);
            renderer.setScissor(range[0] * clientWidth, range[1] * clientHeight, range[2] * clientWidth, range[3] * clientHeight);
            renderer.clear();
            camera.getWorldDirection(this._target);
            this._target.applyAxisAngle(camera.up, Math.PI / 12).multiplyScalar(-1).normalize(); // 修改光照方向跟随相机
            PythaStorage.instance.renderStore.light.position.copy(this._target);
            renderer.render(scene, camera);
            labelRenderer.render(scene, camera);
        }
    }
    /**
     * 获取当前渲染分桶（renderBucket）用的key
     * @param renderItem 渲染单元
     * @param renderMode 渲染模式
     * @returns
     */
    getRenderItemKey(renderItem, renderMode) {
        var _a;
        PythaStorage.instance.blockStore;
        if (renderItem.primitive == null) {
            return "-";
        }
        const primitive = renderItem.primitive;
        let mat;
        if (primitive.type == "Block") {
            // 块图元需要去模板里找材质
            // let block = storage.blockTemplateDict[(primitive as BlockPrimitive).blockTemplateUuid];
            // let blockRenderItem: RenderItem = block?.findBlockRenderItem(renderItem.uuid);
            // mat = blockRenderItem?.mat;
            mat = (_a = renderItem._blockRenderItem) === null || _a === void 0 ? void 0 : _a.mat;
        }
        else {
            mat = primitive.materials[renderItem.uuid];
        }
        if (mat == null) {
            return "-";
        }
        let arr = [];
        arr.push(renderItem.renderType);
        arr.push((mat === null || mat === void 0 ? void 0 : mat.opacity) || 1);
        //概念模型下，mesh对象需要添加对材质图片的说明
        if (renderItem.renderType === RenderItemType.MESH) {
            arr.push((mat === null || mat === void 0 ? void 0 : mat.textureUuid) || "color");
            arr.push((mat === null || mat === void 0 ? void 0 : mat.imageWidth) || 0);
            arr.push((mat === null || mat === void 0 ? void 0 : mat.imageHeight) || 0);
        }
        arr.push(primitive.layerUuid);
        arr.push(primitive.temporary);
        if (primitive.renderGroupKeys && primitive.renderGroupKeys.length > 0) {
            arr.push(...primitive.renderGroupKeys);
        }
        return arr.join('-');
    }
    /**
     * 根据传入的图元字典生成渲染数据
     * @param primitiveDict 图元字典 { [key: string]: Primitive }
     */
    genRenderData(primitiveDict) {
        //TODO 现在只处理图元本身，不处理边线
        let deleteUuidsList = [];
        this.genDeleteList(primitiveDict, deleteUuidsList); // 先缓存需要删除的
        this.genRenderDataForSelfAndChildren(primitiveDict);
        this.removePrimitiveByUuidsInPrimitiveDict(deleteUuidsList, primitiveDict);
    }
    genRenderDataForSelfAndChildren(primitiveDict) {
        var _a;
        const pythaStorage = PythaStorage.instance;
        const blockStore = pythaStorage.blockStore;
        for (const uuid of Object.keys(primitiveDict)) {
            let primitive = primitiveDict[uuid];
            let needDelete = primitive.needDelete;
            if (primitive.hidden) {
                needDelete = true;
            }
            if (!primitive.needRedraw && !primitive.needDelete) {
                continue;
            }
            if (primitive.type === PrimitiveType.Block) {
                Object.values(primitive.renderItemDict).forEach(item => item.rendered = false);
            }
            if (((_a = Object.keys(primitive === null || primitive === void 0 ? void 0 : primitive.children)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                this.genRenderDataForSelfAndChildren(primitive === null || primitive === void 0 ? void 0 : primitive.children);
            }
            if (!!needDelete || primitive.type != "Block") {
                // 普通图元更新或者 删除图元，块的删除逻辑和普通图元一致
                for (let key of Object.keys(primitive.renderItemDict)) {
                    let renderItem = primitive.renderItemDict[key];
                    this._genRenderDataForOneRenderItem(renderItem, primitive, needDelete);
                }
            }
            else {
                // 块图元 更新 需要递归获取世界坐标矩阵 因为块嵌套块时，每个图元的世界坐标矩阵不能跨越块
                let blockPrimitive = primitive;
                let bt = blockStore.blockTemplateDict[blockPrimitive.blockTemplateUuid];
                this._genRenderDataForOneBlockPrimitive(bt, blockPrimitive, blockPrimitive.worldModelMatrix);
            }
            primitive.needDelete = false; // 很重要，影响撤回操作的显示
            primitive.needRedraw = false;
        }
    }
    /**
     * 因为有块，需要递归计算每个子图元
     * @param primitive 模板块中遍历到的图元
     * @param rawPrimitive 原始的块图元
     * @param parentWorldMatrix 块的父图元的变换矩阵
     * @returns
     */
    _genRenderDataForOneBlockPrimitive(primitive, rawPrimitive, parentWorldMatrix) {
        if (primitive == null)
            return;
        if (primitive.type != "Block") {
            // 叶子结点
            for (let key of Object.keys(primitive.renderItemDict)) {
                // let renderItem = primitive.renderItemDict[key];
                let rawRenderItem = Object.values(rawPrimitive.renderItemDict).find(item => {
                    return item._blockRenderItem.uuid === key && (!item.rendered);
                }); // 传入真实块的渲染单元
                if (!rawRenderItem) {
                    return;
                }
                rawRenderItem.rendered = true;
                this._genRenderDataForOneRenderItem(rawRenderItem, rawPrimitive, false, parentWorldMatrix);
            }
            return;
        }
        if (primitive.type == "Block" && Object.keys(primitive.children).length > 0) {
            // 根结点
            for (let key of Object.keys(primitive.children)) {
                let child = primitive.children[key];
                this._genRenderDataForOneBlockPrimitive(child, rawPrimitive, parentWorldMatrix);
            }
            return;
        }
        const pythaStorage = PythaStorage.instance;
        const blockStore = pythaStorage.blockStore;
        let blockTemplateUuid = primitive.blockTemplateUuid;
        if (blockTemplateUuid == null)
            return;
        let childBt = blockStore.blockTemplateDict[blockTemplateUuid];
        if (childBt == null)
            return;
        // 非叶子结点 需要跨越块模板
        // 先计算新的转换矩阵
        if (primitive.worldModelMatrix != null && parentWorldMatrix != null) {
            _transMatrix.copy(primitive.worldModelMatrix);
            _transMatrix.premultiply(parentWorldMatrix);
        }
        else {
            _transMatrix.identity();
        }
        this._genRenderDataForOneBlockPrimitive(childBt, rawPrimitive, _transMatrix);
    }
    /**
     * 生成一个渲染单元的数据
     * @param renderItem 渲染单元 对于块来说 是真实块的渲染单元
     * @param primitive 真实单元
     * @param needDelete
     * @param parentMatrix 用于块嵌套块渲染时传递的转换矩阵 默认为null
     * @returns
     */
    _genRenderDataForOneRenderItem(renderItem, primitive, needDelete, parentMatrix = null) {
        var _a;
        if (renderItem == null)
            return;
        const pythaStorage = PythaStorage.instance;
        const renderStore = pythaStorage.renderStore;
        let key = renderItem.lastRenderKey;
        if (key == null) {
            // 说明是新加入的图元
            key = this.getRenderItemKey(renderItem, renderStore.renderMode);
            renderItem.lastRenderKey = key;
            renderItem.needUpdate = true;
        }
        // 同时满足不需要重绘、不需要更新、不需要删除的，直接遍历下一个
        if ((!primitive.needRedraw) && (!renderItem.needUpdate) && (!needDelete)) {
            return;
        }
        // 获取对应的MapItem
        let lastMapItem = this._findRenderItemFromObjectBucketByTextureMesh(key, renderItem, primitive);
        // 到这里就拿到了需要处理的桶以及具体的renderMapItem了，后面就不用再管定位的事了
        if (needDelete) {
            // 需要删除
            let currentIdx = lastMapItem.renderItems.findIndex(item => renderItem.uuid === item.uuid);
            if (currentIdx == -1) {
                return;
            }
            // 自动导出缓存
            this.copyMainObjectBufferAuto(lastMapItem);
            // 移除缓存
            lastMapItem.positions.splice(renderItem.start, renderItem.size);
            if (renderItem.mat.textureUuid) {
                lastMapItem.uvs.splice(renderItem.start / 3 * 2, renderItem.size / 3 * 2);
            }
            else {
                lastMapItem.colors.splice(renderItem.start, renderItem.size);
            }
            // 修改其他renderItem的缓存
            for (let idx = currentIdx + 1; idx < lastMapItem.renderItems.length; idx++) {
                lastMapItem.renderItems[idx].start -= renderItem.size;
            }
            lastMapItem.renderItems.splice(currentIdx, 1);
            lastMapItem.needRegenerate = true;
            if (((_a = lastMapItem.positions) === null || _a === void 0 ? void 0 : _a.length) == 0) {
                lastMapItem.isDeleteToEmpty = true;
            }
            renderItem.lastRenderKey = null;
            renderItem.size = null;
            renderItem.start = null;
            renderItem.renderGeometryBucketIndex = null;
            return;
        }
        // let meshBuffer = primitive.getRenderBuffer(renderItem);
        let verticeBuffer = renderItem._positionBuffer;
        if (renderItem._blockRenderItem) {
            verticeBuffer = renderItem._blockRenderItem._positionBuffer; // 块图元拿模板的数组
        }
        if (!!parentMatrix) {
            // 此时 拿到的数组是块内子图元相对于块基点的顶点数组
            // 需要做转换矩阵
            verticeBuffer = [...verticeBuffer]; // 防止污染块模板
            for (let i = 0; i < verticeBuffer.length; i += 3) {
                _point$9.set(verticeBuffer[i], verticeBuffer[i + 1], verticeBuffer[i + 2]);
                _point$9.applyMatrix4(parentMatrix);
                verticeBuffer[i] = _point$9.x;
                verticeBuffer[i + 1] = _point$9.y;
                verticeBuffer[i + 2] = _point$9.z;
            }
        }
        if (verticeBuffer.length <= 0) {
            // 可能前步没有网格划分，只是想统一改颜色，直接从渲染数组拿
            const oldSize = renderItem.size;
            const oldStart = renderItem.start;
            verticeBuffer = lastMapItem.positions.slice(oldStart, oldStart + oldSize);
        }
        let count = verticeBuffer.length / 3;
        if (verticeBuffer.length == 0 && renderItem.size != null) {
            count = renderItem.size / 3;
        }
        let colorBuffer = renderItem.getColorBuffer(count);
        let uvBuffer = []; // TODO: 设置uv坐标
        this.copyMainObjectBufferAuto(lastMapItem);
        if (renderItem.start == null || renderItem.size == null) {
            // 新加入的renderItem
            renderItem.size = verticeBuffer.length;
            renderItem.start = lastMapItem.positions.length;
            pushArrayAToArrayB(verticeBuffer, lastMapItem.positions);
            pushArrayAToArrayB(colorBuffer, lastMapItem.colors);
            pushArrayAToArrayB(uvBuffer, lastMapItem.uvs);
            lastMapItem.renderItems.push(renderItem);
            lastMapItem.needRegenerate = true;
        }
        else {
            // 已经渲染过的
            let updateKey = this.getRenderItemKey(renderItem, renderStore.renderMode);
            const oldSize = renderItem.size;
            const oldStart = renderItem.start;
            // const currentSize = verticeBuffer.length;
            const currentSize = count * 3;
            if (updateKey === key) { // 材质一致
                if (currentSize === oldSize) { // 长度不变，只是数值变了
                    if (verticeBuffer.length > 0) {
                        spliceArrayAToArrayB(verticeBuffer, lastMapItem.positions, oldStart, currentSize);
                        // lastMapItem.positions.splice(oldStart, currentSize, ...verticeBuffer);
                    }
                    if (renderItem.mat.textureUuid) {
                        spliceArrayAToArrayB(uvBuffer, lastMapItem.uvs, oldStart / 3 * 2, currentSize / 3 * 2);
                        // lastMapItem.uvs.splice(oldStart / 3 * 2, currentSize / 3 * 2, ...uvBuffer);
                    }
                    else {
                        spliceArrayAToArrayB(colorBuffer, lastMapItem.colors, oldStart, currentSize);
                        // lastMapItem.colors.splice(oldStart, currentSize, ...colorBuffer);
                    }
                }
                else { // 长度发生了变化，可能使用了布尔操作等
                    // 复杂的做法是当前插入，后面的数字都往后移，更新后面的图元start，简单的做法就是直接从头刷新
                    // 另一种做法是先删除，然后从末尾插入
                    // 删除
                    let currentIdx = lastMapItem.renderItems.findIndex(item => renderItem.uuid === item.uuid);
                    if (currentIdx == -1)
                        return;
                    lastMapItem.positions.splice(renderItem.start, renderItem.size);
                    if (renderItem.mat.textureUuid) {
                        lastMapItem.uvs.splice(renderItem.start / 3 * 2, renderItem.size / 3 * 2);
                    }
                    else {
                        lastMapItem.colors.splice(renderItem.start, renderItem.size);
                    }
                    for (let idx = currentIdx + 1; idx < lastMapItem.renderItems.length; idx++) {
                        lastMapItem.renderItems[idx].start -= renderItem.size;
                    }
                    lastMapItem.renderItems.splice(currentIdx, 1);
                    if (lastMapItem.positions.length == 0) {
                        lastMapItem.isDeleteToEmpty = true;
                    }
                    // 末尾加入
                    renderItem.size = verticeBuffer.length;
                    renderItem.start = lastMapItem.positions.length;
                    //分块添加防止栈溢出
                    //数组的push(...)方法会默认把数组的每一个元素作为push方法的一个入参
                    //当verticeBuffer的长度太长，就会导致push方法入参占用的栈空间过多，进而导致栈溢出
                    pushArrayAToArrayB(verticeBuffer, lastMapItem.positions);
                    pushArrayAToArrayB(colorBuffer, lastMapItem.colors);
                    pushArrayAToArrayB(uvBuffer, lastMapItem.uvs);
                    lastMapItem.renderItems.push(renderItem);
                }
                lastMapItem.needRegenerate = true;
            }
            else { // 材质不一致
                // 从原来的材质里删除，再添加至新的材质
                let currentIdx = lastMapItem.renderItems.findIndex(item => renderItem.uuid === item.uuid);
                lastMapItem.positions.splice(renderItem.start, renderItem.size);
                if (renderItem.mat.textureUuid) {
                    lastMapItem.uvs.splice(renderItem.start / 3 * 2, renderItem.size / 3 * 2);
                }
                else {
                    lastMapItem.colors.splice(renderItem.start, renderItem.size);
                }
                renderItem.lastRenderKey = updateKey;
                for (let idx = currentIdx + 1; idx < lastMapItem.renderItems.length; idx++) {
                    lastMapItem.renderItems[idx].start -= renderItem.size;
                }
                lastMapItem.renderItems.splice(currentIdx, 1);
                if (lastMapItem.positions.length == 0) {
                    lastMapItem.isDeleteToEmpty = true;
                }
                // 获取新材质的renderItem位置
                renderItem.renderGeometryBucketIndex;
                let newMapItem = this._findRenderItemFromObjectBucketByTextureMesh(updateKey, renderItem, primitive);
                if (newMapItem.object != null) {
                    newMapItem.object.material = renderStore.objectRenderBucket[updateKey].material;
                }
                // 自动导出缓存
                this.copyMainObjectBufferAuto(newMapItem);
                // 更新材质
                renderItem.size = verticeBuffer.length;
                renderItem.start = newMapItem.positions.length;
                pushArrayAToArrayB(verticeBuffer, newMapItem.positions);
                pushArrayAToArrayB(colorBuffer, newMapItem.colors);
                pushArrayAToArrayB(uvBuffer, newMapItem.uvs);
                newMapItem.renderItems.push(renderItem);
                lastMapItem.needRegenerate = true;
                newMapItem.needRegenerate = true;
            }
        }
        // 更新attribute
        if (!(lastMapItem === null || lastMapItem === void 0 ? void 0 : lastMapItem.buffer)) {
            lastMapItem.buffer = new BufferGeometry();
        }
        renderItem.needUpdate = false;
    }
    /**
     * 清空渲染数据
     */
    clearRenderData() {
        const pythaStorage = PythaStorage.instance;
        const renderStore = pythaStorage.renderStore;
        this.clearRenderBucket(renderStore.objectRenderBucket);
        this.clearRenderBucket(renderStore.edgeRenderBucket);
        this.clearRenderBucket(renderStore.tmpRenderBucket);
    }
    /**
     * 清空一个渲染对象的字典
     */
    clearRenderBucket(renderBucketDict) {
        //如果为空，直接返回
        if (!renderBucketDict)
            return;
        Object.keys(renderBucketDict).forEach(key => {
            let bucket = renderBucketDict[key];
            bucket.renderBucketItems.forEach(mapItem => {
                //置空渲染单元
                if (mapItem.renderItems && mapItem.renderItems.length > 0) {
                    mapItem.renderItems.forEach(item => {
                        item.lastRenderKey = null;
                        item.start = null;
                        item.size = null;
                        item.renderGeometryBucketIndex = null;
                    });
                }
                //从场景中移除
                if (mapItem.object && mapItem.object.parent) {
                    mapItem.object.parent.remove(mapItem.object);
                }
            });
            //从map中删除
            delete renderBucketDict[key];
        });
        renderBucketDict = {};
    }
    /**
     * 将渲染数据加入场景
     */
    addRenderDataToScene() {
        var _a, _b, _c, _d, _e, _f;
        const pythaStorage = PythaStorage.instance;
        const renderStore = pythaStorage.renderStore;
        for (let key in renderStore.objectRenderBucket) {
            for (let mapItem of renderStore.objectRenderBucket[key].renderBucketItems) {
                if (mapItem.hidden) {
                    if (mapItem.object && mapItem.object.parent) {
                        mapItem.object.parent.remove(mapItem.object);
                    }
                    continue;
                }
                // 若未初始化，则初始化obj
                if (mapItem.object == null) {
                    if (!(mapItem === null || mapItem === void 0 ? void 0 : mapItem.buffer)) {
                        mapItem.buffer = new BufferGeometry();
                    }
                    let geo = mapItem.buffer;
                    if (((_a = mapItem.positions) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                        mapItem.needRegenerate = false;
                        mapItem.isDeleteToEmpty = false;
                        mapItem.object = null;
                        continue;
                    }
                    geo.setAttribute('position', new Float32BufferAttribute(mapItem.positions, 3));
                    if (mapItem.renderType === "Mesh" && ((_b = mapItem.uvs) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                        geo.setAttribute('uv', new Float32BufferAttribute(mapItem.uvs, 2));
                    }
                    else {
                        let colorAttribute = new Float32BufferAttribute(mapItem.colors, 3);
                        geo.setAttribute('color', colorAttribute);
                    }
                    geo.computeBoundingBox();
                    geo.computeBoundingSphere();
                    geo.computeVertexNormals();
                    let material = renderStore.objectRenderBucket[key].material;
                    switch (mapItem.renderType) {
                        case 'Line':
                            let line = new LineSegments(geo, material);
                            pythaStorage.viewportStore.scene.add(line);
                            mapItem.object = line;
                            break;
                        case 'Mesh':
                            if (renderStore.renderMode === RenderMode.WIREFRAME) {
                                let meshlLine = new LineSegments(geo, material);
                                pythaStorage.viewportStore.scene.add(meshlLine);
                                mapItem.object = meshlLine;
                            }
                            else {
                                if (material.opacity < 1)
                                    material.depthWrite = false;
                                let mesh = new Mesh(geo, material);
                                if (material.opacity < 1) {
                                    mesh.renderOrder = 9999999;
                                }
                                else if (!key.includes("color")) {
                                    mesh.renderOrder = 500000;
                                }
                                else {
                                    mesh.renderOrder = 0;
                                }
                                pythaStorage.viewportStore.scene.add(mesh);
                                mapItem.object = mesh;
                            }
                            break;
                        case 'Point':
                            let point = new Points(geo, material);
                            pythaStorage.viewportStore.scene.add(point);
                            mapItem.object = point;
                            break;
                    }
                }
                else if (mapItem.needRegenerate) {
                    // 若需要重新生成obj，此时obj必然不为null
                    if (mapItem.object && !mapItem.object.parent) {
                        pythaStorage.viewportStore.scene.add(mapItem.object);
                    }
                    let geo = mapItem.buffer;
                    if (((_c = mapItem.positions) === null || _c === void 0 ? void 0 : _c.length) === 0) {
                        (_e = (_d = mapItem.object) === null || _d === void 0 ? void 0 : _d.parent) === null || _e === void 0 ? void 0 : _e.remove(mapItem.object);
                        mapItem.needRegenerate = false;
                        mapItem.isDeleteToEmpty = false;
                        mapItem.object = null;
                        geo.deleteAttribute('position');
                        geo.deleteAttribute('uv');
                        geo.deleteAttribute('color');
                        continue;
                    }
                    let positionAttribute = new Float32BufferAttribute(mapItem.positions, 3);
                    geo.setAttribute('position', positionAttribute);
                    if (mapItem.renderType === "Mesh" && ((_f = mapItem.uvs) === null || _f === void 0 ? void 0 : _f.length) > 0) {
                        geo.setAttribute('uv', new Float32BufferAttribute(mapItem.uvs, 2));
                    }
                    else {
                        let colorAttribute = new Float32BufferAttribute(mapItem.colors, 3);
                        geo.setAttribute('color', colorAttribute);
                    }
                    geo.computeBoundingBox();
                    geo.computeBoundingSphere();
                    geo.deleteAttribute('normal');
                    geo.computeVertexNormals();
                }
                mapItem.needRegenerate = false;
                mapItem.isDeleteToEmpty = false;
            }
        }
        // 清空缓存数组
        Object.keys(renderStore.objectRenderBucket).forEach(key => {
            for (let mapItem of renderStore.objectRenderBucket[key].renderBucketItems) {
                mapItem.positions = [];
                mapItem.colors = [];
                mapItem.uvs = [];
            }
        });
    }
    /**
     * 生成单个图元的集合与需要删除的uuid数组
     * @param primitiveDict
     * @param singlePrimitiveDict
     * @param deleteUuidsList
     */
    genDeleteList(primitiveDict, deleteUuidsList) {
        for (let uuid in primitiveDict) {
            let primitive = primitiveDict[uuid];
            if (primitive.needDelete) {
                deleteUuidsList.push(uuid);
            }
        }
    }
    /**
     * 自动将需要修改的缓存数组拷贝到结构体内-主图元
     * @param lastMapItem 一个合并渲染对象结构体
     */
    copyMainObjectBufferAuto(lastMapItem) {
        var _a, _b, _c, _d, _e, _f;
        if (lastMapItem.buffer != null && lastMapItem.positions.length == 0) {
            if (!(lastMapItem === null || lastMapItem === void 0 ? void 0 : lastMapItem.isDeleteToEmpty)) {
                let pos = Array.from(((_b = (_a = lastMapItem.buffer.attributes) === null || _a === void 0 ? void 0 : _a.position) === null || _b === void 0 ? void 0 : _b.array) || []);
                let colors = Array.from(((_d = (_c = lastMapItem.buffer.attributes) === null || _c === void 0 ? void 0 : _c.color) === null || _d === void 0 ? void 0 : _d.array) || []);
                let uv = Array.from(((_f = (_e = lastMapItem.buffer.attributes) === null || _e === void 0 ? void 0 : _e.uv) === null || _f === void 0 ? void 0 : _f.array) || []);
                lastMapItem.positions = pos;
                lastMapItem.colors = colors;
                lastMapItem.uvs = uv;
            }
            else {
                lastMapItem.positions = [];
                lastMapItem.colors = [];
                lastMapItem.uvs = [];
            }
        }
    }
    /**
     * 获取一个桶内的最小数组长度对应的索引, 如果过长，则自动扩充桶，用于主图元
     */
    _findMinBucketIndexFromObjectBucket(bucket, renderType) {
        let minIndex = -1;
        let minLength = 0;
        for (let index = 0; index < bucket.renderBucketItems.length; index++) {
            const item = bucket.renderBucketItems[index];
            if (item.positions.length < minLength || minLength == 0) {
                minLength = item.positions.length;
                minIndex = index;
            }
        }
        if (minLength > RenderBucketLimit || minIndex == -1) {
            let renderMap = {
                positions: [],
                colors: [],
                uvs: [],
                models: [],
                needRegenerate: false,
                renderType: renderType,
                renderItems: [],
                hidden: false
            };
            bucket.renderBucketItems.push(renderMap);
            minIndex = bucket.renderBucketItems.length - 1;
            minLength = 0;
        }
        return minIndex;
    }
    /**
     * 获取渲染材质
     * @param renderItem 渲染单元
     * @param renderMode 渲染模式
     * @returns
     */
    getRenderItemMaterial(renderItem, renderMode) {
        if (renderItem.mat == null)
            return null;
        if (renderMode === RenderMode.WIREFRAME || renderItem.renderType == "Line") {
            let lineMaterial = new LineDashedMaterial({
                vertexColors: true,
            });
            return lineMaterial;
        }
        else if (renderItem.renderType == RenderItemType.POINT) {
            // let pointMaterial = new PointsMaterial({
            //     size: 6,
            //     vertexColors: true,
            //     transparent: true,
            //     map: this.createCircleTexture(6),
            // })
            let material = new ShaderMaterial({
                uniforms: {
                    pointTexture: { value: pointTexture },
                    size: { value: 8 },
                    alphaTest: { value: 0.2 }
                },
                vertexShader: `
                    uniform float size;
			        attribute vec3 color;
			        varying vec3 vColor;
			        void main() {
				        vColor = color;
				        vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
				        gl_PointSize = size;
				        gl_Position = projectionMatrix * mvPosition;
			        }
                `,
                fragmentShader: `
			        uniform sampler2D pointTexture;
			        uniform float alphaTest;
			        varying vec3 vColor;
			        void main() {
			        	gl_FragColor = vec4( vColor, 1.0 );
			        	gl_FragColor = gl_FragColor * texture2D( pointTexture, gl_PointCoord );
			        	if ( gl_FragColor.a < alphaTest ) discard;
			        }
                `,
                transparent: true,
                depthTest: true,
            });
            return material;
        }
        else {
            const storage = this.eventMediator.storage;
            const textureStore = storage.textureStore;
            // 设置透明度系数
            let opacityRatio = storage.renderStore.opacityModeRatio;
            if (storage.renderStore.renderMode != RenderMode.OPACITY) {
                opacityRatio = 1;
            }
            if (renderItem.mat.textureUuid == null) {
                return new MeshPhongMaterial({
                    side: DoubleSide,
                    // emissive: textureStore.globalEmissive,
                    vertexColors: true,
                    opacity: renderItem.mat.opacity * opacityRatio,
                    transparent: true,
                    depthFunc: LessDepth,
                    // flatShading: true
                    // metalness: 0,
                });
            }
            else {
                let texture = textureStore.getTexture(renderItem.mat.textureUuid);
                return new MeshPhongMaterial({
                    side: DoubleSide,
                    map: texture,
                    emissive: textureStore.globalEmissive,
                    opacity: renderItem.mat.opacity * opacityRatio,
                    transparent: true,
                    depthFunc: LessDepth,
                });
            }
        }
    }
    /***
      * 根据桶key查找lastMapItem，用于可以贴材质的TextureMesh
      */
    _findRenderItemFromObjectBucketByTextureMesh(key, renderItem, primitive) {
        const renderStore = PythaStorage.instance.renderStore;
        let bucket = renderStore.objectRenderBucket[key];
        if (bucket == null) {
            let mat = this.getRenderItemMaterial(renderItem, renderStore.renderMode);
            bucket = {
                material: mat,
                renderBucketItems: [{
                        // material: mat,
                        positions: [],
                        colors: [],
                        uvs: [],
                        needRegenerate: false,
                        renderType: renderItem.renderType,
                        renderItems: [],
                        hidden: false
                    }],
                minStorageIndex: 0
            };
            renderStore.objectRenderBucket[key] = bucket;
        }
        let lastMapItem;
        if (renderItem.renderGeometryBucketIndex != null && renderItem.renderGeometryBucketIndex >= 0) {
            // 存过索引，说明原来有生成过
            lastMapItem = bucket.renderBucketItems[renderItem.renderGeometryBucketIndex];
        }
        if (lastMapItem == null) {
            // 说明找不到了，重新存 或者原来就没有生成过
            let index = bucket.minStorageIndex;
            if (index >= bucket.renderBucketItems.length) {
                index = bucket.renderBucketItems.length - 1;
                bucket.minStorageIndex = index;
            }
            lastMapItem = bucket.renderBucketItems[index];
            renderItem.renderGeometryBucketIndex = index;
            if (lastMapItem.positions.length > RenderBucketLimit) {
                // 寻找最小的桶索引，自动扩展
                let minIndex = this._findMinBucketIndexFromObjectBucket(bucket, renderItem.renderType);
                bucket.minStorageIndex = minIndex;
                lastMapItem = bucket.renderBucketItems[minIndex];
                renderItem.renderGeometryBucketIndex = minIndex;
            }
        }
        return lastMapItem;
    }
}
const _point$9 = new Point();
const _transMatrix = new Matrix4();/**
 * 渲染节点
 */
class EventGraphNodeRender extends EventGraphNode {
    constructor(graph, needRedraw = false, updateType = UpdateType.ALL) {
        var _a;
        super(graph);
        this.renderHandler = (_a = graph.eventMediator) === null || _a === void 0 ? void 0 : _a.renderHandler;
        this.neeRedraw = needRedraw;
        this.updateType = updateType;
    }
    run() {
        var _a, _b;
        (_a = this.renderHandler) === null || _a === void 0 ? void 0 : _a.render(this.neeRedraw, this.updateType);
        this.isRunFinished = true;
        // 获取下一级节点
        for (let next of this.outNodes) {
            if (next.type == EDGE_TYPE.STOP && next.node.isWaitingEvent) {
                // 识别是撤销挂起的边，将节点的挂起状态撤销
                next.node.onHangupEndEvent();
            }
            else {
                // 识别是正常执行的边
                next.node.run();
            }
        }
        (_b = this.needExtraFuncAfter) === null || _b === void 0 ? void 0 : _b.call(this);
    }
}/**
 * 开启默认视图平移
 */
class EventHandler3doStart extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        const viewportStore = PythaStorage.instance.viewportStore;
        viewportStore.enabled3do = true;
        return true;
    }
}/**
 * 结束命令处理器
 */
class EventHandlerCmdEnd extends EventHandlerBase {
    constructor() {
        super(...arguments);
        this.done = false; //保证只执行一次
        /**
         * 命令结束后是否会发送“*结束*”通知，默认为true
         */
        this.sendNotice = true;
    }
    run() {
        if (this.done)
            return false;
        this.done = true;
        this.node.graph.eventMediator.emitEvent(new PythaEventEnd(this.sendNotice));
        return true;
    }
}/**
 * 确认事件
 */
class EventHandlerConfirm extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventConfirm();
        this.needEventOnce = true;
    }
    run(event) {
        if (event.cmd != this.needEvent.cmd)
            return false; // 如果传入事件不符 则不执行处理器
        return true;
    }
}/**
 * 禁用默认视图旋转
 */
class EventHandlerDisable3do extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        const viewportStore = PythaStorage.instance.viewportStore;
        viewportStore.enabled3do = false;
        return true;
    }
}/**
 * 禁用默认视图平移
 */
class EventHandlerDisablePan extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        const viewportStore = PythaStorage.instance.viewportStore;
        viewportStore.enabledPan = false;
        return true;
    }
}/**
 * 禁用选择的节点
 */
class EventHandlerDisableSelect extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        const selectStore = PythaStorage.instance.selectStore;
        selectStore.enabled = false;
        return true;
    }
}/**
 * 开启默认视图平移
 */
class EventHandlerPanStart extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        const viewportStore = PythaStorage.instance.viewportStore;
        viewportStore.enabledPan = true;
        return true;
    }
}/**
 * 开启选择
 */
class EventHandlerSelectStart extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        const selectStore = PythaStorage.instance.selectStore;
        selectStore.enabled = true;
        return true;
    }
}// import { OrthographicCamera, PerspectiveCamera, Plane, Quaternion, Raycaster, Spherical, Vector2, Vector3 } from "three";
class EventHandler3do extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.rotateSpeed = 1;
        this._target = new Vector3();
        this._rotateCenter = new Vector3();
        const storage = PythaStorage.instance;
        this.storage = storage;
        const viewportStore = storage.viewportStore;
        this.viewportStore = viewportStore;
        let domElement = viewportStore.renderer.domElement;
        this.domElement = domElement;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a, _b, _c, _d, _e, _f;
        const camera = (_a = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        if (camera == null) {
            return false;
        }
        if (!this.node.graph.cache.data.startPoint) {
            const pointerDownList = this.node.graph.cache.pointerDownList;
            if (pointerDownList.length <= 0)
                return false;
            let downPointer = pointerDownList[pointerDownList.length - 1];
            let pointDown2 = downPointer.point2;
            this.node.graph.cache.data.startPoint = new Vector2().copy(pointDown2);
        }
        if (!((_b = this.node.graph.cache.pointerMove) === null || _b === void 0 ? void 0 : _b.point2))
            return false;
        let pointMove2 = this.node.graph.cache.pointerMove.point2;
        // 计算鼠标移动delta
        let _pointerDelta = new Vector2();
        _pointerDelta.subVectors(pointMove2, this.node.graph.cache.data.startPoint);
        // 修改相机up
        camera.up.set(0, 0, 1);
        // 初始化旋转四元数及其逆矩阵
        let _quat = new Quaternion().setFromUnitVectors(camera.up, new Vector3(0, 1, 0)); // 这个可能需要变成缓存对象
        let _quatInverse = _quat.clone().invert(); // 这个可能需要变成缓存对象
        // 重新设置当前UCS工作平面
        this.storage.coordinateStore.resetWorkPlane();
        // 初始化旋转角度和球坐标系
        let theta_delta = -2 * Math.PI * _pointerDelta.x * this.rotateSpeed / this.domElement.clientHeight;
        let phi_delta = -2 * Math.PI * _pointerDelta.y * this.rotateSpeed / this.domElement.clientHeight;
        let spherical = new Spherical();
        const position = camera.position;
        this._target.copy((_c = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _c === void 0 ? void 0 : _c.target);
        let rotateCenter = this.node.graph.cache.data["rotateCenter"];
        if (rotateCenter != null) {
            this._rotateCenter.copy(rotateCenter);
        }
        this.updateTarget(this._rotateCenter);
        // 计算相机偏移量
        let offset = new Vector3();
        offset.copy(position).sub((_d = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _d === void 0 ? void 0 : _d.target);
        // 设置旋转轴
        let rotateAxis1 = camera.up.clone().normalize();
        let rotateAxis2 = camera.up.clone().cross(offset).normalize();
        // 变换参考系（笛卡尔->球）
        offset.applyQuaternion(_quat);
        // 球坐标系下计算
        spherical.setFromVector3(offset);
        let last_theta = spherical.theta;
        let last_phi = spherical.phi;
        spherical.theta += theta_delta;
        spherical.phi += phi_delta;
        spherical.makeSafe();
        theta_delta = spherical.theta - last_theta;
        phi_delta = spherical.phi - last_phi;
        // 转回笛卡尔坐标系
        offset.setFromSpherical(spherical);
        offset.applyQuaternion(_quatInverse);
        // 更新相机positon
        position.copy((_e = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _e === void 0 ? void 0 : _e.target).add(offset);
        camera.lookAt((_f = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _f === void 0 ? void 0 : _f.target);
        // 更新相机target
        let _oq = new Quaternion().setFromAxisAngle(rotateAxis1, theta_delta).multiply(new Quaternion().setFromAxisAngle(rotateAxis2, phi_delta));
        let v1 = this._target.clone().sub(this._rotateCenter); // TODO 旋转中心
        v1.applyQuaternion(_oq);
        let new_target = this._rotateCenter.clone().add(v1); // TODO 旋转中心
        this.updateTarget(new_target); // TODO 修改target
        // this.updateZoomCenter(pointMove2);
        // updateZoomCenter(this.domElement, pointMove2);
        this.node.graph.cache.data.startPoint.copy(pointMove2);
        return true;
    }
    updateTarget(v) {
        var _a;
        const camera = (_a = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        const position = camera.position;
        let offset = position.clone().sub(this.viewportStore.viewportItems[this.viewportStore.currentViewportKey].target);
        this.viewportStore.viewportItems[this.viewportStore.currentViewportKey].target.set(v.x, v.y, v.z);
        position.copy(this.viewportStore.viewportItems[this.viewportStore.currentViewportKey].target).add(offset);
        camera.updateMatrixWorld();
        if (camera && (camera.type === 'OrthographicCamera' || camera.type === 'PerspectiveCamera')) {
            camera.updateProjectionMatrix();
        }
    }
}/**
 * 显示旋转中心
 */
class EventHandlerHideRotateCenter extends EventHandlerBase {
    constructor(node) {
        super(node);
        const storage = PythaStorage.instance;
        const viewportStore = storage.viewportStore;
        this.viewportStore = viewportStore;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        if (this.node.graph.cache.data.rotateCenterObj && this.node.graph.cache.data.rotateCenterObj.parent) {
            this.node.graph.cache.data.rotateCenterObj.parent.remove(this.node.graph.cache.data.rotateCenterObj);
        }
        return true;
    }
}/**
 * 显示旋转中心
 */
class EventHandlerShowRotateCenter extends EventHandlerBase {
    constructor(node) {
        super(node);
        const storage = PythaStorage.instance;
        const viewportStore = storage.viewportStore;
        this.viewportStore = viewportStore;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        if (!this.node.graph.cache.data.rotateCenterObj
            || (this.node.graph.cache.data.rotateCenterObj || !this.node.graph.cache.data.rotateCenterObj.parent)) {
            // 计算旋转中心
            let rotateCenter = this.countRotateCenter();
            this.node.graph.cache.data["rotateCenter"] = rotateCenter;
            let radius = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey].cameraEdge / 80;
            const geo = new SphereGeometry(radius);
            const mat = new MeshPhongMaterial({
                color: '#ff0000',
                emissive: 0x072534,
                transparent: false,
                side: 2,
                depthWrite: false,
                depthTest: false
            });
            let mesh = new Mesh(geo, mat);
            mesh.position.set(rotateCenter.x, rotateCenter.y, rotateCenter.z);
            mesh.visible = true;
            this.node.graph.cache.data.rotateCenterObj = mesh;
            this.viewportStore.scene.add(mesh);
        }
        return true;
    }
    /**
     * 计算旋转中心
     * @returns
     */
    countRotateCenter() {
        var _a;
        const storage = PythaStorage.instance;
        const primitiveInView = storage.primitiveStore.primitiveInView;
        let pointCount = 0;
        let center = new Vector3();
        // 判断是否选中图元
        if (((_a = storage.selectStore.selectPrimitives) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            for (let a = 0; a < storage.selectStore.selectPrimitives.length; a++) {
                const primitive = storage.selectStore.selectPrimitives[a];
                if (!primitive)
                    continue;
                let bbox = this.calBoundingBoxFromPri(primitive);
                _point$8.addVectors(bbox.min, bbox.max).multiplyScalar(0.5);
                if (isNaN(_point$8.x) || isNaN(_point$8.y) || isNaN(_point$8.z)) {
                    continue;
                }
                center.add(_point$8);
                pointCount += 1;
            }
        }
        else {
            for (let key in primitiveInView) {
                const primitive = primitiveInView[key];
                if (!primitive)
                    continue;
                let bbox = this.calBoundingBoxFromPri(primitive);
                _point$8.addVectors(bbox.min, bbox.max).multiplyScalar(0.5);
                if (isNaN(_point$8.x) || isNaN(_point$8.y) || isNaN(_point$8.z)) {
                    continue;
                }
                center.add(_point$8);
                pointCount += 1;
            }
        }
        // 空值判断
        if (pointCount != 0) {
            center.multiplyScalar(1 / pointCount);
        }
        return center;
    }
    /**
     * 计算图元的包围盒
     * @param primitive
     */
    calBoundingBoxFromPri(primitive) {
        const storage = this.getPythaStorage();
        if (!primitive)
            return new Box3();
        let boundingBox = primitive.getBoundingbox();
        if (primitive.type == "Block") {
            // 如果是块，需要去模板里计算 并且要考虑跨模板的转换矩阵问题
            let bt = storage.blockStore.blockTemplateDict[primitive.blockTemplateUuid];
            boundingBox = BlockPrimitive.calBlockBoundingBox(bt, primitive.worldModelMatrix, storage.blockStore.blockTemplateDict);
        }
        if (boundingBox.min == null || boundingBox.max == null)
            return new Box3();
        if (isNaN(boundingBox.min.x) || isNaN(boundingBox.min.y) || isNaN(boundingBox.min.z) || isNaN(boundingBox.max.x) || isNaN(boundingBox.max.y) || isNaN(boundingBox.max.z))
            return new Box3();
        return boundingBox;
    }
}
const _point$8 = new Point();const LOD_TYPE = {
    LOD1: 1,
    LOD2: 2,
    LOD3: 3,
    LOD4: 4,
    LOD5: 5,
};/**
 * 计算在视口内的图元 同时计算其LOD等级
 */
class EventHandlerCalPrimitiveInView extends EventHandlerBase {
    constructor() {
        super(...arguments);
        this._vecTopLeft = new Vector3();
        this._vecTopRight = new Vector3();
        this._vecDownRight = new Vector3();
        this._vecDownLeft = new Vector3();
        this._vecFarTopLeft = new Vector3();
        this._vecFarTopRight = new Vector3();
        this._vecFarDownRight = new Vector3();
        this._vecFarDownLeft = new Vector3();
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        // 获取存储
        const storage = PythaStorage.instance;
        const primitives = storage.primitiveStore.primitiveDict; // 获取图元
        const viewportItems = storage.viewportStore.viewportItems;
        const needCalLod = storage.renderStore.lodEnabled;
        // 剔除场景外的图元
        let primitivesInView = {};
        Object.keys(viewportItems).forEach(itemKey => {
            const camera = viewportItems[itemKey].camera;
            viewportItems[itemKey].inViewCount = 0; //情况当前图元的统计
            let viewMatrix = camera.matrixWorldInverse;
            let projectMatrix = camera.projectionMatrix;
            let transMat = new Matrix4().identity().premultiply(viewMatrix).premultiply(projectMatrix);
            if (!_pickRect$3) {
                _pickRect$3 = new SelectionRect(camera);
                _pickRect$3.update(new Vector2(-1, -1), new Vector2(1, 1)); // 相机在二维就是 -1~1
            }
            Object.keys(primitives).forEach(key => {
                if (primitivesInView[key] != null)
                    return;
                let primitive = primitives[key];
                primitive.isInView = false;
                let boundingBox = primitive.getBoundingbox();
                if (primitive.type == "Block") {
                    // 如果是块，需要去模板里计算 并且要考虑跨模板的转换矩阵问题
                    let bt = storage.blockStore.blockTemplateDict[primitive.blockTemplateUuid];
                    boundingBox = BlockPrimitive.calBlockBoundingBox(bt, primitive.worldModelMatrix, storage.blockStore.blockTemplateDict);
                }
                if (boundingBox.min == null || boundingBox.max == null)
                    return;
                let isInView = this.isBoxInView(boundingBox, transMat);
                if (isInView) {
                    primitive.isInView = true;
                    primitivesInView[key] = primitive;
                    viewportItems[itemKey].inViewCount += 1;
                }
                if (needCalLod) {
                    // 计算LOD
                    _p1$1.copy(_point1$4).project(camera);
                    _p2$2.copy(_point6$3).project(camera);
                    _p2$2.sub(_p1$1);
                    let length = Math.sqrt(_p2$2.x * _p2$2.x + _p2$2.y * _p2$2.y);
                    let ratio = length / 2.8284;
                    let lod = this.checkLOD(ratio);
                    primitive.lod = lod;
                    if (primitive.lastLod == primitive.lod)
                        return;
                    if (!primitive.isInView)
                        return;
                    primitive.needRedraw = true;
                    primitive.lastLod = lod;
                    if (primitive.isBoolPrimitive()) {
                        primitive.needReGenerateBoolGeo = true;
                    }
                }
            });
        });
        // 存入TS
        // this.node.graph.cache.data['primitivesInView'] = primitivesInView;
        storage.primitiveStore.primitiveInView = primitivesInView;
        return true;
    }
    /**
     * 计算LOD等级
     * @param ratio 图元占画布比例
     * @returns
     */
    checkLOD(ratio) {
        if (ratio < 1 / 100)
            return LOD_TYPE.LOD1;
        if (ratio < 1 / 50)
            return LOD_TYPE.LOD2;
        if (ratio < 1 / 10)
            return LOD_TYPE.LOD3;
        return LOD_TYPE.LOD4;
    }
    isBoxInView(boundingBox, transMat) {
        _point1$4.copy(boundingBox.min); // min
        _point2$5.set(boundingBox.min.x, boundingBox.min.y, boundingBox.max.z);
        _point3$3.set(boundingBox.min.x, boundingBox.max.y, boundingBox.min.z);
        _point4$3.set(boundingBox.min.x, boundingBox.max.y, boundingBox.max.z);
        _point5$3.set(boundingBox.max.x, boundingBox.max.y, boundingBox.min.z);
        _point6$3.set(boundingBox.max.x, boundingBox.max.y, boundingBox.max.z); // max
        _point7$3.set(boundingBox.max.x, boundingBox.min.y, boundingBox.min.z);
        _point8$3.set(boundingBox.max.x, boundingBox.min.y, boundingBox.max.z);
        let points = [_point1$4, _point2$5, _point3$3, _point4$3, _point5$3, _point6$3, _point7$3, _point8$3];
        // 将包围盒点投影到屏幕空间
        const vertices = this.projectBuffer(points, transMat);
        const triangles = [
            // 前面
            [vertices[0], vertices[1], vertices[3]], // 三角形 1
            [vertices[0], vertices[2], vertices[3]], // 三角形 2
            // 后面
            [vertices[4], vertices[5], vertices[6]], // 三角形 3
            [vertices[4], vertices[6], vertices[7]], // 三角形 4
            // 左面
            [vertices[0], vertices[1], vertices[7]], // 三角形 5
            [vertices[0], vertices[4], vertices[7]], // 三角形 6
            // 右面
            [vertices[2], vertices[3], vertices[6]], // 三角形 7
            [vertices[2], vertices[5], vertices[6]], // 三角形 8
            // 顶面
            [vertices[1], vertices[3], vertices[6]], // 三角形 9
            [vertices[1], vertices[6], vertices[7]], // 三角形 10
            // 底面
            [vertices[0], vertices[2], vertices[5]], // 三角形 11
            [vertices[0], vertices[4], vertices[5]] // 三角形 12
        ];
        let success = false;
        for (let i = 0; i < 12; i++) {
            let triangle = triangles[i];
            let res = _pickRect$3.select(triangle[0], triangle[1], triangle[2]);
            if (res) {
                success = true;
                break;
            }
        }
        return success;
    }
    /**
     * 将3维点数组投影成2维点数组
     */
    projectBuffer(points, matrix) {
        let result = [];
        for (let i = 0; i < (points === null || points === void 0 ? void 0 : points.length); i++) {
            _vector$5.set(points[i].x, points[i].y, points[i].z);
            _vector$5.applyMatrix4(matrix);
            result.push(new Point2(_vector$5.x, _vector$5.y));
        }
        return result;
    }
}
const _point1$4 = new Point();
const _point2$5 = new Point();
const _point3$3 = new Point();
const _point4$3 = new Point();
const _point5$3 = new Point();
const _point6$3 = new Point();
const _point7$3 = new Point();
const _point8$3 = new Point();
const _p1$1 = new Point();
const _p2$2 = new Point();
const _vector$5 = new Vector3();
let _pickRect$3;/**
 * 网格划分处理器
 * 同时处理块图元的renderItem同步
 */
class EventHandlerGrid extends EventHandlerBase {
    constructor(node) {
        super(node);
        /**
         * 临时变量
         */
        this._mat = new Matrix4();
    }
    run(data) {
        // 从PS中获取存储对象
        const storage = PythaStorage.instance;
        const primitiveStore = storage.primitiveStore;
        this.meshGrid(primitiveStore.tempPrimitiveDict);
        this.meshGrid(primitiveStore.primitiveDict);
        this.meshGrid(primitiveStore.systemPrimitiveDict);
        return true;
    }
    /**
     * 网格划分
     * @param primitives
     */
    meshGrid(primitives) {
        // 划分网格
        // const storage = PythaStorage.instance;
        // const renderStore = storage.renderStore;
        Object.keys(primitives).forEach(key => {
            var _a;
            let primitive = primitives[key];
            this.meshOnePrimitive(primitive);
            if (((_a = Object.keys(primitive === null || primitive === void 0 ? void 0 : primitive.children)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                this.meshGrid(primitive === null || primitive === void 0 ? void 0 : primitive.children);
            }
        });
    }
    /**
     * 划分一个图元的网格
     * @param primitive
     */
    meshOnePrimitive(primitive, isBlockTemplate = false) {
        const storage = PythaStorage.instance;
        const renderStore = storage.renderStore;
        const blockStore = storage.blockStore;
        if (!primitive.needRedraw)
            return;
        //重新生成布尔操作图元
        primitive.reGenerateBoolGeo(renderStore.divisionNums);
        if (primitive.type == "Block") {
            let btUuid = primitive.blockTemplateUuid;
            let bt = blockStore.blockTemplateDict[btUuid];
            if (bt == null)
                return;
            let keys = Object.keys(bt.children) || [];
            for (let key of keys) {
                let pri = bt.children[key];
                pri.needRedraw = true;
                this.meshOnePrimitive(pri, true);
            }
            if (!isBlockTemplate && Object.keys(primitive.renderItemDict).length <= 0) {
                // 非模板图元 但是是块 需要同步renderItem
                this.syncBlockRenderItem(primitive, bt);
            }
            return;
        }
        if (isBlockTemplate) {
            // 认为是块模板图元 且 已经更新过数组了
            let keys = Object.keys(primitive.renderItemDict);
            if (keys.length <= 0)
                return;
            if (primitive.renderItemDict[keys[0]]._positionBuffer.length > 0)
                return;
        }
        let geos = primitive.geos || [];
        if (geos.length == 0 && primitive.type != "Point")
            return;
        // 分解基元
        primitive.geoElements = [];
        for (let geo of geos) {
            let geoelemtns = geo.getGeoElements();
            primitive.geoElements.push(...geoelemtns);
        }
        // 采样
        Object.keys(primitive.renderItemDict).forEach(renderItemKey => {
            var _a;
            let renderItem = primitive.renderItemDict[renderItemKey];
            if (renderItem._positionBuffer.length > 0)
                renderItem._positionBuffer = [];
            let initRenderType = renderItem.renderType ? true : false;
            if (primitive.type == "Point") {
                // 处理 点
                let p = primitive.getP();
                renderItem._positionBuffer = [p.x, p.y, p.z];
                return;
            }
            //遍历渲染对象中所含基元
            for (let k of renderItem.geoElements) {
                const geo = primitive.geoElements[k];
                if (!initRenderType) { //如果渲染类型没有被初始化，则通过第一个基元的类型来确定
                    //@ts-ignore
                    if (!!geo.isCurve || geo instanceof Curve) {
                        renderItem.renderType = RenderItemType.LINE;
                        initRenderType = true;
                        //@ts-ignore
                    }
                    else if (!!geo.isSurface || geo instanceof Surface) {
                        renderItem.renderType = RenderItemType.MESH;
                        initRenderType = true;
                    }
                }
                // 根据图元尺度与当前相机缩放比例动态计算
                let lod = primitive.lod;
                if (primitive.temporary)
                    lod = 3;
                let divNums = (_a = renderStore.divisionNums[geo.type]) === null || _a === void 0 ? void 0 : _a[lod];
                if (!divNums)
                    divNums = [2, 2];
                //@ts-ignore
                if (!!geo.isCurve || geo instanceof Curve) { //如果是曲线
                    let num;
                    if (divNums.length < 1 && divNums[0] < 2) { //如果没有段数或者默认段数小于2，则设置为2
                        num = 2;
                    }
                    else {
                        num = divNums[0];
                    }
                    for (let i = 0; i < num; i++) {
                        const t = i / (num - 1);
                        geo.getPointAt(t, _point$7); //获取插值点
                        if (!!primitive.worldModelMatrix) {
                            _point$7.applyMatrix4(primitive.worldModelMatrix); //获取世界坐标
                        }
                        renderItem._positionBuffer.push(_point$7.x, _point$7.y, _point$7.z);
                        if (i != 0 && i != num - 1) { //线段收尾相连，中间的点会被使用两次
                            renderItem._positionBuffer.push(_point$7.x, _point$7.y, _point$7.z);
                        }
                    }
                    //@ts-ignore
                }
                else if (!!geo.isSurface || geo instanceof Surface) {
                    // 曲面划分
                    //获取网格化段数
                    let numU;
                    let numV;
                    if (divNums.length < 1 && divNums[0] < 2) { //如果没有段数或者默认段数小于2，则设置为2
                        numU = 2;
                    }
                    else {
                        numU = divNums[0];
                    }
                    if (divNums.length < 2 && divNums[1] < 2) { //如果没有段数或者默认段数小于2，则设置为2
                        numV = 2;
                    }
                    else {
                        numV = divNums[1];
                    }
                    //TODO 暂时使用耳切法进行处理，后续需要改为包围盒采样 + 德劳内三角剖分。
                    if (geo.type == "RegionFace" || geo.type == "GeneralRegion") {
                        let polygonPoints = [];
                        let holesIndics = [];
                        if (geo.type == "RegionFace") { //对面域的处理
                            //处理边
                            const ringSize = geo.edges.length === 1 ? 0 : 1;
                            geo.edges.forEach(edge => {
                                var _a, _b, _c;
                                let division;
                                if (((_a = renderStore.divisionNums[edge.type]) === null || _a === void 0 ? void 0 : _a[lod].length) < 1 && ((_b = renderStore.divisionNums[edge.type]) === null || _b === void 0 ? void 0 : _b[lod][0]) < 2) { //如果没有段数或者默认段数小于2，则设置为2
                                    division = 2;
                                }
                                else {
                                    division = (_c = renderStore.divisionNums[edge.type]) === null || _c === void 0 ? void 0 : _c[lod][0];
                                }
                                for (let divisionItem = 0; divisionItem < division - ringSize; divisionItem++) {
                                    const t = divisionItem / (division - 1);
                                    edge.getPointAt(t, _point$7);
                                    _point$7.applyMatrix4(geo.transformMatrix);
                                    polygonPoints.push(_point$7.clone());
                                }
                            });
                            //处理洞
                            geo.holes.forEach(hole => {
                                holesIndics.push(polygonPoints.length);
                                const holeRingSize = geo.edges.length === 1 ? 0 : 1;
                                hole.edges.forEach(edge => {
                                    var _a, _b, _c;
                                    let division;
                                    if (((_a = renderStore.divisionNums[edge.type]) === null || _a === void 0 ? void 0 : _a[lod].length) < 1 && ((_b = renderStore.divisionNums[edge.type]) === null || _b === void 0 ? void 0 : _b[lod][0]) < 2) { //如果没有段数或者默认段数小于2，则设置为2
                                        division = 2;
                                    }
                                    else {
                                        division = (_c = renderStore.divisionNums[edge.type]) === null || _c === void 0 ? void 0 : _c[lod][0];
                                    }
                                    for (let divisionItem = 0; divisionItem < division - holeRingSize; divisionItem++) {
                                        const t = divisionItem / (division - 1);
                                        edge.getPointAt(t, _point$7);
                                        _point$7.applyMatrix4(hole.transformMatrix).applyMatrix4(geo.transformMatrix);
                                        polygonPoints.push(_point$7.clone());
                                    }
                                });
                            });
                        }
                        else {
                            if (geo.rings.length === 0) { //如果只有一个环，是空图元，直接返回
                                continue;
                            }
                            //处理外环
                            geo.rings[0].forEach(point2 => {
                                _point$7.set(point2.x, point2.y, 0);
                                _point$7.applyMatrix4(geo.transformMatrix);
                                polygonPoints.push(_point$7.clone());
                            });
                            //处理洞
                            for (let ringIndex = 1; ringIndex < geo.rings.length; ringIndex++) {
                                holesIndics.push(polygonPoints.length);
                                geo.rings[ringIndex].forEach(point2 => {
                                    _point$7.set(point2.x, point2.y, 0);
                                    _point$7.applyMatrix4(geo.transformMatrix);
                                    polygonPoints.push(_point$7.clone());
                                });
                            }
                        }
                        //耳切法
                        let coords = [];
                        let ucsZ = new Vector3(0, 0, 1);
                        let ucsY = new Vector3(0, 1, 0);
                        let normal = geo.getNormalizeZ();
                        let signZ = Math.abs(normal.dot(ucsZ)) <= 1e-6 ? 0 : 1;
                        let signY = Math.abs(normal.dot(ucsY)) <= 1e-6 ? 0 : 1;
                        polygonPoints.forEach(point => {
                            if (!!signZ) {
                                coords.push(point.x, point.y);
                            }
                            else if (!!signY) {
                                coords.push(point.x, point.z);
                            }
                            else {
                                coords.push(point.y, point.z);
                            }
                        });
                        let triangulationIndex = triangulationByEarcut(coords, holesIndics);
                        for (let i = 0; i < triangulationIndex.length; i++) {
                            _point$7.copy(polygonPoints[triangulationIndex[i]]);
                            if (!!primitive.worldModelMatrix) {
                                _point$7.applyMatrix4(primitive.worldModelMatrix); //获取世界坐标
                            }
                            renderItem._positionBuffer.push(_point$7.x, _point$7.y, _point$7.z);
                        }
                        continue;
                    }
                    let points = [];
                    // 先拿到所有插值点
                    for (let i = 0; i < numU; i++) {
                        const u = i / (numU - 1);
                        if (!points[i]) {
                            points[i] = [];
                        }
                        for (let j = 0; j < numV; j++) {
                            const v = j / (numV - 1);
                            geo.getPointAt(u, v, _point$7); //获取插值点
                            if (!!primitive.worldModelMatrix) {
                                _point$7.applyMatrix4(primitive.worldModelMatrix); //获取世界坐标
                            }
                            // renderItem._positionBuffer.push(_point.x, _point.y, _point.z);
                            points[i][j] = _point$7.clone();
                        }
                    }
                    // 将插值点连成三角形
                    for (let i = 0; i < numU - 1; i++) {
                        for (let j = 0; j < numV - 1; j++) {
                            // 4个角点坐标，组成2个三角形
                            let pointUV = points[i][j];
                            let pointU1V = points[i + 1][j];
                            let pointUV1 = points[i][j + 1];
                            let pointU1V1 = points[i + 1][j + 1];
                            /** 坐标索引方式
                             * u,v      u+1,v
                             * u,v+1    u+1,v+1
                             */
                            // 左上三角形
                            _v1$7.subVectors(pointU1V, pointUV);
                            _v2$6.subVectors(pointUV1, pointUV);
                            // 验证三个点互相不重合
                            if (Math.abs(_v1$7.cross(_v2$6).length()) > 1e-6) {
                                // 组成三角形网格
                                renderItem._positionBuffer.push(pointUV.x, pointUV.y, pointUV.z);
                                renderItem._positionBuffer.push(pointUV1.x, pointUV1.y, pointUV1.z);
                                renderItem._positionBuffer.push(pointU1V.x, pointU1V.y, pointU1V.z);
                            }
                            // 右下三角形
                            _v1$7.subVectors(pointU1V, pointU1V1);
                            _v2$6.subVectors(pointUV1, pointU1V1);
                            // 验证三个点互相不重合
                            if (Math.abs(_v1$7.cross(_v2$6).length()) > 1e-6) {
                                // 组成三角形网格
                                renderItem._positionBuffer.push(pointUV1.x, pointUV1.y, pointUV1.z);
                                renderItem._positionBuffer.push(pointU1V1.x, pointU1V1.y, pointU1V1.z);
                                renderItem._positionBuffer.push(pointU1V.x, pointU1V.y, pointU1V.z);
                            }
                        }
                    }
                }
            }
        });
    }
    /**
     * 将块模板的renderItem同步给图元
     * @param primitive
     */
    syncBlockRenderItem(primitive, bt) {
        if (primitive.blockTemplateUuid != bt.uuid)
            return;
        Object.keys(bt.children).forEach(key => {
            let child = bt.children[key];
            this._syncBlockTemplateRenderItemToBlock(primitive, child);
        });
        if (bt.type !== "Block") {
            Object.keys(bt.renderItemDict).forEach(key => {
                let renderItem = bt.renderItemDict[key];
                let copyItem = renderItem.clone();
                copyItem.uuid = renderItem.uuid;
                copyItem.mat = renderItem.mat.clone();
                copyItem.primitive = primitive;
                copyItem._blockRenderItem = renderItem;
                primitive.renderItemDict[copyItem.uuid] = copyItem;
            });
            return;
        }
    }
    _syncBlockTemplateRenderItemToBlock(primitive, bt) {
        if (bt.type !== "Block") {
            Object.keys(bt.renderItemDict).forEach(key => {
                let renderItem = bt.renderItemDict[key];
                let copyItem = renderItem.clone();
                copyItem.uuid = renderItem.uuid;
                copyItem.mat = renderItem.mat.clone();
                copyItem.primitive = primitive;
                copyItem._blockRenderItem = renderItem;
                primitive.renderItemDict[copyItem.uuid] = copyItem;
            });
            return;
        }
        // 遇到子块
        const storage = PythaStorage.instance;
        const blockStore = storage.blockStore;
        let btx = bt;
        if (btx.blockTemplateUuid == null)
            return;
        let childBt = blockStore.blockTemplateDict[btx.blockTemplateUuid];
        if (childBt == null)
            return;
        Object.keys(childBt.children).forEach(key => {
            let child = childBt.children[key];
            this._syncBlockTemplateRenderItemToBlock(primitive, child);
        });
    }
}
const _point$7 = new Point();
const _v1$7 = new Vector3();
const _v2$6 = new Vector3();/**
 * 延时 节点
 */
class EventGraphNodeTimer extends EventGraphNode {
    /**
     * 构造函数
     * @param graph
     * @param timeCount 延时时间 ms
     */
    constructor(graph, timeCount = 600) {
        super(graph);
        this.timeCount = timeCount;
    }
    /**
     * 运行节点
     */
    run() {
        // 上级处理器只要有一个做完就执行
        this.isRunFinished = false;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.isRunFinished = true;
            // 获取下一级节点
            for (let next of this.outNodes) {
                if (next.type == EDGE_TYPE.STOP && next.node.isWaitingEvent) {
                    // 识别是撤销挂起的边，将节点的挂起状态撤销
                    next.node.onHangupEndEvent();
                }
                else {
                    // 识别是正常执行的边
                    next.node.run();
                }
            }
        }, this.timeCount);
    }
}/**
 * 显示旋转光标
 */
class EventHandlerShowRotateCursor extends EventHandlerBase {
    run(event) {
        // 获取存储
        const storage = PythaStorage.instance;
        storage.cursorStore.hiddenCursor = true;
        let color = storage.viewportStore.background;
        if (this.isDarkColor(this.hexToRgb(color))) {
            storage.viewportStore.renderer.domElement.style.cursor = "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTUuMDUyNiA2LjIyNjYxQzEyLjcyNDUgNS44NzM1IDEwLjIyNjcgNS45MzQwNCA3Ljk3MDE0IDYuNDAxMzhDNS43MzA4IDYuODY1MTYgMy43NzA0NiA3LjcyMTg5IDIuNDk3NDMgOC45MTI3M0MxLjE5MDg1IDEwLjEzNDkgMC42MjA1OTIgMTEuNzMwOSAxLjI2Mjc1IDEzLjM0NTFDMS44NTk2OSAxNC44NDU2IDMuMzc5MDkgMTYuMDExNyA1LjI3NjIyIDE2Ljc5MDJDNi45MzkzNCAxNy40NzI2IDguOTMyNjggMTcuODc3MyAxMC45OTk4IDE3Ljk3NjFWMjBMMTQuOTk5OCAxNy4xMDUzTDEwLjk5OTggMTRWMTUuOTczNkM5LjE2MDE0IDE1Ljg3NjMgNy40MzE2IDE1LjUxMjggNi4wMzU0NyAxNC45Mzk5QzQuMzU1OCAxNC4yNTA3IDMuNDI2ODcgMTMuMzc0NCAzLjEyMTEgMTIuNjA1OEMyLjg2MDU1IDExLjk1MDkgMi45ODkwOCAxMS4xOTE1IDMuODYzNyAxMC4zNzMzQzQuNzcxODcgOS41MjM3OCA2LjM0MDE5IDguNzgxNCA4LjM3NTc1IDguMzU5ODJDMTAuMzk0MSA3Ljk0MTgxIDEyLjY1MjkgNy44ODU1MSAxNC43NTI3IDguMjAzOTlDMTYuODY0NSA4LjUyNDMgMTguNjAzNyA5LjE5MDk2IDE5LjcxNTMgMTAuMDIyOEMyMC44MjUxIDEwLjg1MzMgMjEuMDk1NiAxMS42NjE2IDIwLjk3MDUgMTIuMjk2OEMyMC44MzA4IDEzLjAwNTggMjAuMTM5NyAxMy44ODMxIDE4LjYyMzYgMTQuNjQxMUMxOC4xMjk3IDE0Ljg4ODEgMTcuOTI5NCAxNS40ODg4IDE4LjE3NjQgMTUuOTgyN0MxOC40MjM0IDE2LjQ3NjcgMTkuMDI0MSAxNi42NzcgMTkuNTE4MSAxNi40M0MyMS4yNzM5IDE1LjU1MjEgMjIuNjE4OSAxNC4yNzY4IDIyLjkzMjggMTIuNjgzNEMyMy4yNjEyIDExLjAxNjIgMjIuMzc0NSA5LjUxNDY4IDIwLjkxMzYgOC40MjE1QzE5LjQ1NDYgNy4zMjk2OSAxNy4zNjg2IDYuNTc3ODkgMTUuMDUyNiA2LjIyNjYxWiIgZmlsbD0id2hpdGUiLz4NCjwvc3ZnPg0K') 16 16, auto";
        }
        else {
            storage.viewportStore.renderer.domElement.style.cursor = "url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS4zMzAyIDguMjQ3MjFDMTYuNzkwOCA3Ljg2MiAxNC4wNjYzIDcuOTI4MDQgMTEuNjA0OSA4LjQzNzg3QzkuMTYyMyA4Ljk0MzgxIDcuMDI0MDQgOS44Nzg0MiA1LjYzNTQ3IDExLjE3NzVDNC4yMTAzIDEyLjUxMDggMy41ODgyOSAxNC4yNTE5IDQuMjg4NzMgMTYuMDEyOEM0LjkzOTg1IDE3LjY0OTcgNi41OTcxNSAxOC45MjE5IDguNjY2NDYgMTkuNzcxMUMxMC40ODA1IDIwLjUxNTYgMTIuNjU0OCAyMC45NTcxIDE0LjkwOTUgMjEuMDY0OFYyMy4yNzI3TDE5LjI3MjYgMjAuMTE0OUwxNC45MDk1IDE2LjcyNzNWMTguODgwM0MxMi45MDI5IDE4Ljc3NDEgMTEuMDE3NSAxOC4zNzc2IDkuNDk0NjIgMTcuNzUyNkM3LjY2MjUxIDE3LjAwMDggNi42NDkyNyAxNi4wNDQ4IDYuMzE1NzQgMTUuMjA2M0M2LjAzMTU1IDE0LjQ5MTkgNi4xNzE3NCAxMy42NjM1IDcuMTI1NzQgMTIuNzcwOUM4LjExNjM0IDExLjg0NDEgOS44MjcgMTEuMDM0MyAxMi4wNDczIDEwLjU3NDNDMTQuMjQ4OCAxMC4xMTgzIDE2LjcxMjcgMTAuMDU2OSAxOS4wMDMgMTAuNDA0NEMyMS4zMDY1IDEwLjc1MzggMjMuMjAzNiAxMS40ODEgMjQuNDE2IDEyLjM4ODVDMjUuNjI2NiAxMy4yOTQ1IDI1LjkyMTYgMTQuMTc2MyAyNS43ODUyIDE0Ljg2OTJDMjUuNjMyOCAxNS42NDI3IDI0Ljg3OSAxNi41OTk3IDIzLjIyNTMgMTcuNDI2N0MyMi42ODY1IDE3LjY5NjEgMjIuNDY4MSAxOC4zNTE0IDIyLjczNzUgMTguODkwMkMyMy4wMDY5IDE5LjQyOTEgMjMuNjYyMSAxOS42NDc2IDI0LjIwMDkgMTkuMzc4MkMyNi4xMTYxIDE4LjQyMDUgMjcuNTgzMiAxNy4wMjkyIDI3LjkyNTYgMTUuMjkxQzI4LjI4MzggMTMuNDcyMiAyNy4zMTY2IDExLjgzNDIgMjUuNzIzMSAxMC42NDE2QzI0LjEzMTcgOS40NTA1NyAyMS44NTY0IDguNjMwNDIgMTkuMzMwMiA4LjI0NzIxWiIgZmlsbD0iIzIyMjYyNyIvPgo8L3N2Zz4K) 32 32, auto";
        }
        return true;
    }
    isDarkColor(rgb) {
        // 解构 RGB 值
        const [r, g, b] = rgb;
        // 根据公式计算亮度
        const brightness = 0.299 * r + 0.587 * g + 0.114 * b;
        // 判断颜色是否为深色
        return brightness < 128;
    }
    hexToRgb(hex) {
        // 将 #RRGGBB 转换为 RGB 数组
        const bigint = parseInt(hex.slice(1), 16);
        return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
    }
}/**
 * 用于通知节点向外发needinput时的激活项和可选项
 */
const NeedInputEnum = {
    NONE: 0,
    ACTIVE: 1, // 当前需要输入的
    OPTION: 2, // 可选项
};/**
 * 通知节点
 */
class EventGraphNodeNotice extends EventGraphNode {
    constructor(graph, event) {
        var _a;
        super(graph);
        this.noticeHandler = (_a = graph.eventMediator) === null || _a === void 0 ? void 0 : _a.noticeHandler;
        this.notice = event;
    }
    run() {
        var _a, _b;
        // 识别请求输入事件，通知给图
        if (this.notice.cmd === PythaEventName.NEED_INPUT) {
            let e = this.notice.data.find(item => item.type === NeedInputEnum.ACTIVE);
            if (e != null) {
                this.graph.cache.needInput = e;
            }
            let options = this.notice.data.filter(item => item.type === NeedInputEnum.OPTION) || [];
            this.graph.cache.optionsCanSwitch = options;
        }
        // 输出给外部系统
        (_a = this.noticeHandler) === null || _a === void 0 ? void 0 : _a.notice(this, this.notice);
        // 获取下一级节点
        this.isRunFinished = true;
        for (let next of this.outNodes) {
            if (next.type == EDGE_TYPE.STOP && next.node.isWaitingEvent) {
                // 识别是撤销挂起的边，将节点的挂起状态撤销
                next.node.onHangupEndEvent();
            }
            else {
                // 识别是正常执行的边
                next.node.run();
            }
        }
        (_b = this.needExtraFuncAfter) === null || _b === void 0 ? void 0 : _b.call(this);
    }
}class EventGraph3do extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerCalPointerDown);
        node2.needExtraFuncOnHandlerActive = (handler) => {
            handler.set("buttonTypes", [MOUSE_BUTTON.LEFT, MOUSE_BUTTON.MIDDLE]);
        };
        const node3 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node4 = new EventGraphNode(this, EventHandler3do);
        const node5 = new EventGraphNode(this, EventHandlerCalPointerUp);
        const node6 = new EventGraphNode(this, EventHandlerDisablePan);
        const node7 = new EventGraphNode(this, EventHandlerDisable3do);
        const node9 = new EventGraphNode(this, EventHandlerConfirm);
        const node10 = new EventGraphNode(this, EventHandlerPanStart);
        const node11 = new EventGraphNode(this, EventHandler3doStart);
        const node13 = new EventGraphNode(this, EventHandlerSelectStart);
        const node14 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node15 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node16 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        const node17 = new EventGraphNode(this, EventHandlerShowRotateCenter);
        const node18 = new EventGraphNode(this, EventHandlerHideRotateCenter);
        const node19 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node20 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node22 = new EventGraphNodeTimer(this, null);
        const node23 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node24 = new EventGraphNode(this, EventHandlerGrid);
        const node25 = new EventGraphNodeRender(this, true, UpdateType.MAIN);
        const node26 = new EventGraphNode(this, EventHandlerShowRotateCursor);
        const node28 = new EventGraphNodeNotice(this, {
            cmd: 'data_change', data: {
                viewChangeStart: true
            }
        });
        const node29 = new EventGraphNodeNotice(this, {
            cmd: 'data_change', data: {
                viewChangeEnd: true
            }
        });
        this.addEdge(node1, node2);
        this.addEdge(node1, node6);
        this.addEdge(node6, node7);
        this.addEdge(node7, node14);
        this.addEdge(node9, node10);
        this.addEdge(node10, node11);
        this.addEdge(node11, node13);
        this.addEdge(node13, node15);
        this.addEdge(node2, node5);
        this.addEdge(node3, node4);
        this.addEdge(node5, node3, EDGE_TYPE.STOP);
        this.addEdge(node2, node17);
        this.addEdge(node17, node19);
        this.addEdge(node18, node1);
        this.addEdge(node18, node20);
        this.addEdge(node16, node22);
        this.addEdge(node22, node23);
        this.addEdge(node23, node24);
        this.addEdge(node24, node25);
        this.addEdge(node4, node16);
        this.addEdge(node17, node3);
        this.addEdge(node5, node18);
        this.addEdge(node14, node26);
        this.addEdge(node1, node9);
        this.addEdge(node19, node28);
        this.addEdge(node5, node29);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/72
    }
    /**
    * 结束图
    */
    end() {
        super.end();
        // 开启原生平移和旋转
        const viewportStore = PythaStorage.instance.viewportStore;
        viewportStore.enabledPan = true;
        viewportStore.enabled3do = true;
        // 开启选择
        const selectStore = PythaStorage.instance.selectStore;
        selectStore.enabled = true;
    }
}
/**
 * 3do指令 控制器旋转视图
 */
EventGraph3do.cmd = '3DO';class CSS2DObject extends Object3D {

	constructor( element = document.createElement( 'div' ) ) {

		super();

		this.isCSS2DObject = true;

		this.element = element;

		this.element.style.position = 'absolute';
		this.element.style.userSelect = 'none';

		this.element.setAttribute( 'draggable', false );

		this.center = new Vector2( 0.5, 0.5 ); // ( 0, 0 ) is the lower left; ( 1, 1 ) is the top right

		this.addEventListener( 'removed', function () {

			this.traverse( function ( object ) {

				if ( object.element instanceof Element && object.element.parentNode !== null ) {

					object.element.parentNode.removeChild( object.element );

				}

			} );

		} );

	}

	copy( source, recursive ) {

		super.copy( source, recursive );

		this.element = source.element.cloneNode( true );

		this.center = source.center;

		return this;

	}

}

//

const _vector$4 = new Vector3();
const _viewMatrix = new Matrix4();
const _viewProjectionMatrix = new Matrix4();
const _a = new Vector3();
const _b = new Vector3();

class CSS2DRenderer {

	constructor( parameters = {} ) {

		const _this = this;

		let _width, _height;
		let _widthHalf, _heightHalf;

		const cache = {
			objects: new WeakMap()
		};

		const domElement = parameters.element !== undefined ? parameters.element : document.createElement( 'div' );

		domElement.style.overflow = 'hidden';

		this.domElement = domElement;

		this.getSize = function () {

			return {
				width: _width,
				height: _height
			};

		};

		this.render = function ( scene, camera ) {

			if ( scene.matrixWorldAutoUpdate === true ) scene.updateMatrixWorld();
			if ( camera.parent === null && camera.matrixWorldAutoUpdate === true ) camera.updateMatrixWorld();

			_viewMatrix.copy( camera.matrixWorldInverse );
			_viewProjectionMatrix.multiplyMatrices( camera.projectionMatrix, _viewMatrix );

			renderObject( scene, scene, camera );
			zOrder( scene );

		};

		this.setSize = function ( width, height ) {

			_width = width;
			_height = height;

			_widthHalf = _width / 2;
			_heightHalf = _height / 2;

			domElement.style.width = width + 'px';
			domElement.style.height = height + 'px';

		};

		function hideObject( object ) {

			if ( object.isCSS2DObject ) object.element.style.display = 'none';

			for ( let i = 0, l = object.children.length; i < l; i ++ ) {

				hideObject( object.children[ i ] );

			}

		}

		function renderObject( object, scene, camera ) {

			if ( object.visible === false ) {

				hideObject( object );

				return;

			}
			
			if ( object.isCSS2DObject ) {

				_vector$4.setFromMatrixPosition( object.matrixWorld );
				_vector$4.applyMatrix4( _viewProjectionMatrix );

				const visible = ( _vector$4.z >= - 1 && _vector$4.z <= 1 ) && ( object.layers.test( camera.layers ) === true );

				const element = object.element;
				element.style.display = visible === true ? '' : 'none';

				if ( visible === true ) {

					object.onBeforeRender( _this, scene, camera );

					element.style.transform = 'translate(' + ( - 100 * object.center.x ) + '%,' + ( - 100 * object.center.y ) + '%)' + 'translate(' + ( _vector$4.x * _widthHalf + _widthHalf ) + 'px,' + ( - _vector$4.y * _heightHalf + _heightHalf ) + 'px)';

					if ( element.parentNode !== domElement ) {

						domElement.appendChild( element );

					}

					object.onAfterRender( _this, scene, camera );

				}

				const objectData = {
					distanceToCameraSquared: getDistanceToSquared( camera, object )
				};

				cache.objects.set( object, objectData );

			}

			for ( let i = 0, l = object.children.length; i < l; i ++ ) {

				renderObject( object.children[ i ], scene, camera );

			}

		}

		function getDistanceToSquared( object1, object2 ) {

			_a.setFromMatrixPosition( object1.matrixWorld );
			_b.setFromMatrixPosition( object2.matrixWorld );

			return _a.distanceToSquared( _b );

		}

		function filterAndFlatten( scene ) {

			const result = [];

			scene.traverseVisible( function ( object ) {

				if ( object.isCSS2DObject ) result.push( object );

			} );

			return result;

		}

		function zOrder( scene ) {

			const sorted = filterAndFlatten( scene ).sort( function ( a, b ) {

				if ( a.renderOrder !== b.renderOrder ) {

					return b.renderOrder - a.renderOrder;

				}

				const distanceA = cache.objects.get( a ).distanceToCameraSquared;
				const distanceB = cache.objects.get( b ).distanceToCameraSquared;

				return distanceA - distanceB;

			} );

			const zMax = sorted.length;

			for ( let i = 0, l = sorted.length; i < l; i ++ ) {

				sorted[ i ].element.style.zIndex = zMax - i;

			}

		}

	}

}/**
 * 2D标签图元
 */
class LabelBase {
    /**
     * 构造函数
     */
    constructor(generate = true) {
        const root = document.createElement('div');
        root.className = "render-label";
        root.style.backgroundColor = 'transparent';
        this.obj = new CSS2DObject(root);
        if (generate) {
            this.generate();
        }
    }
    /**
     * 生成标签样式
     */
    generate() { }
    /**
     * 设置标签坐标
     * @param point
     */
    setPosition(point) {
        if (this.obj != null) {
            this.obj.position.set(point.x, point.y, point.z);
        }
    }
    /**
     * 销毁
     */
    remove() {
        if (this.obj != null && this.obj.parent) {
            this.obj.parent.remove(this.obj);
        }
    }
}/**
 * 捕捉点标签
 */
class CaptureLabel extends LabelBase {
    /**
     * 构造函数
     * @param type 标签类型
     */
    constructor(type) {
        super(false); // 不自动生成
        this._type = type;
        this.generate();
    }
    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value;
        this.generate();
    }
    /**
     * 生成捕捉点标签
     */
    generate() {
        const root = this.obj.element;
        root.innerHTML = ''; // 清空旧内容，避免重复叠加
        this.obj.renderOrder = 200;
        if (this._type === FEATURE_POINT_TYPE.END) {
            this.drawBoxLabel(root);
        }
        else if (this._type === FEATURE_POINT_TYPE.MIDDLE) {
            this.drawTriangleLabel(root);
        }
        else if (this._type === FEATURE_POINT_TYPE.CENTER || this._type === FEATURE_POINT_TYPE.FACE_CENTER) {
            this.drawCircleLabel(root);
        }
        else if (this._type === FEATURE_POINT_TYPE.QUADRANTAL) {
            this.drawRhombusLabel(root);
        }
        else if (this._type === FEATURE_POINT_TYPE.INTERSECTION) {
            this.drawCrossLabel(root);
        }
        else {
            this.drawBoxLabel(root);
        }
    }
    /**
     * 四边形捕捉点
     * @param root
     */
    drawBoxLabel(root) {
        // 渲染四边形
        const captureLabel = document.createElement('div');
        captureLabel.style.backgroundColor = "transparent";
        captureLabel.style.border = "2px solid green";
        captureLabel.style.width = "12px";
        captureLabel.style.height = "12px";
        root.appendChild(captureLabel);
    }
    /**
     * 三角形捕捉点
     * @param root
     */
    drawTriangleLabel(root) {
        // 渲染三角形
        const canvas = document.createElement('canvas');
        canvas.width = 16;
        canvas.height = 16;
        const ctx = canvas.getContext('2d');
        if (ctx) {
            ctx.clearRect(0, 0, 16, 16); // 清空画布
            ctx.beginPath();
            ctx.moveTo(8, 0); // 三角形顶部
            ctx.lineTo(2, 16); // 左下角
            ctx.lineTo(16, 16); // 右下角
            ctx.closePath();
            ctx.lineWidth = 2;
            ctx.strokeStyle = 'green';
            ctx.stroke();
        }
        root.appendChild(canvas);
    }
    /**
     * 圆形捕捉点
     * @param root
     */
    drawCircleLabel(root) {
        // 渲染圆形
        const captureLabel = document.createElement('div');
        captureLabel.style.backgroundColor = "transparent";
        captureLabel.style.border = "2px solid green";
        captureLabel.style.borderRadius = "50%";
        captureLabel.style.width = "12px";
        captureLabel.style.height = "12px";
        root.appendChild(captureLabel);
    }
    /**
     * 菱形捕捉点
     * @param root
     */
    drawRhombusLabel(root) {
        const canvas = document.createElement('canvas');
        canvas.width = 16;
        canvas.height = 16;
        const ctx = canvas.getContext('2d');
        if (ctx) {
            ctx.clearRect(0, 0, canvas.width, canvas.height); // 清空画布
            ctx.beginPath();
            ctx.moveTo(8, 2); // 顶部点
            ctx.lineTo(14, 8); // 右侧点
            ctx.lineTo(8, 14); // 底部点
            ctx.lineTo(2, 8); // 左侧点
            ctx.closePath();
            // 设置样式
            ctx.lineWidth = 2;
            ctx.strokeStyle = 'green'; // 边框颜色
            ctx.stroke();
        }
        root.appendChild(canvas);
    }
    /**
     * 交点叉号捕捉点
     * @param root
     */
    drawCrossLabel(root) {
        // 创建 canvas
        const canvas = document.createElement('canvas');
        canvas.width = 16;
        canvas.height = 16;
        const ctx = canvas.getContext('2d');
        if (ctx) {
            ctx.clearRect(0, 0, canvas.width, canvas.height); // 清空画布
            // 设置叉号的线宽和颜色
            ctx.lineWidth = 2;
            ctx.strokeStyle = 'green';
            // 画叉号的第一条线
            ctx.beginPath();
            ctx.moveTo(2, 2); // 左上角
            ctx.lineTo(14, 14); // 右下角
            ctx.stroke();
            // 画叉号的第二条线
            ctx.beginPath();
            ctx.moveTo(14, 2); // 右上角
            ctx.lineTo(2, 14); // 左下角
            ctx.stroke();
        }
        root.appendChild(canvas);
    }
}/**
 * 计算捕捉处理器
 */
class EventHandlerCapture extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a, _b;
        // 输入
        const storage = PythaStorage.instance;
        let pointmove = this.node.graph.cache.pointerMove;
        const pool = storage.captureStore.capturePointsPool;
        const viewportItems = storage.viewportStore.viewportItems;
        const camera = (_a = viewportItems[storage.viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        const ndc = storage.coordinateStore.ndcViewportPos2;
        if (camera == null)
            return true;
        if (pointmove.point == null) {
            return true;
        }
        if (pool.length <= 0) {
            storage.coordinateStore.setCurrentPos(pointmove.point);
            return true;
        }
        // 计算捕捉阈值
        let aspect = storage.viewportStore.aspect;
        if (storage.viewportStore.viewportMode == ViewportMode.TWO_HORIZON) {
            aspect *= 2;
        }
        else if (storage.viewportStore.viewportMode == ViewportMode.TWO_VERTICAL) {
            aspect /= 2;
        }
        let rect = storage.viewportStore.rootHTML.getBoundingClientRect();
        let capThreshold = storage.captureStore.captureThreshold / Math.min(rect.width, rect.height);
        // 计算捕捉点
        let capturedPoint = null;
        // 捕捉类型列表
        let capturedTypeList = storage.captureStore.captureTypeList;
        for (let fp of pool) {
            // 判断是否开启捕捉类型
            if (!capturedTypeList.includes(fp.type))
                continue;
            _screenPoint.copy(fp.point).project(camera);
            let dist = Math.sqrt(Math.pow((ndc.x - _screenPoint.x) * aspect, 2) + Math.pow((ndc.y - _screenPoint.y), 2));
            if (dist < capThreshold) {
                capturedPoint = fp;
                capThreshold = dist;
            }
        }
        if (this.node.graph.cache['captureLabel'] == null) {
            this.node.graph.cache['captureLabel'] = new CaptureLabel(FEATURE_POINT_TYPE.END);
        }
        const captureLabel = this.node.graph.cache['captureLabel'];
        if (capturedPoint != null) {
            // 捕捉到
            storage.coordinateStore.setCurrentPos(capturedPoint.point);
            (_b = this.node.graph.cache.pointerMove.point) === null || _b === void 0 ? void 0 : _b.copy(capturedPoint.point);
            captureLabel.type = capturedPoint.type; // 修改label的type
            if (!captureLabel.obj.parent) {
                storage.viewportStore.scene.add(captureLabel.obj); // 显示标签
            }
            captureLabel.setPosition(capturedPoint.point);
            storage.captureStore.capturePoint = capturedPoint.point;
        }
        else {
            // 未捕捉到
            storage.coordinateStore.setCurrentPos(pointmove.point);
            captureLabel.remove(); // 移除标签
            storage.captureStore.capturePoint = null;
        }
        return true;
    }
    dispose() {
        const captureLabel = this.node.graph.cache['captureLabel'];
        if (captureLabel != null) {
            captureLabel.remove();
        }
    }
}
const _screenPoint = new Point();const CursorType = {
    NONE: 0, // 无光标
    PICK_CROSS: 1, // 默认，十字架＋框
    CROSS: 2, // 框选，框
    PICK: 3, // 点选，十字架
    PAN: 4, // 移动
    ROTATE: 5, // 旋转
};/**
 * 切换至十字光标
 */
class EHChangeCrossCursor extends EventHandlerBase {
    /**
     * 运行处理器
     * @param data
     * @returns
     */
    run(data) {
        let event = new PythaEventCursorTypeChange();
        event.data = CursorType.CROSS;
        this.node.graph.eventMediator.emitEvent(event);
        return true;
    }
}/**
 * 用于撤销重做的指令基类
 */
class CommandBase {
}/**
 * 添加图元历史指令
 */
class AddPrimitiveCmd extends CommandBase {
    /**
     * 构造函数
     * @param primitives
     * @param eventMediator
     */
    constructor(primitives, eventMediator) {
        super();
        /**
         * 生成的图元
         */
        this.primitives = [];
        this.eventMediator = eventMediator;
        this.primitives = [...primitives];
    }
    /**
     * 执行
     */
    execute() {
        const storage = PythaStorage.instance;
        const primitiveDict = storage.primitiveStore.primitiveDict;
        this.primitives.forEach(primitive => {
            primitive.needRedraw = true;
            primitive.temporary = false;
            primitive.needDelete = false;
            if (primitive.layerUuid == null) {
                primitive.layerUuid = storage.layerStore.currentLayerUuid || null;
            }
            primitiveDict[primitive.uuid] = primitive;
        });
        this.eventMediator.noticeHandler.notice(this, new PythaEventDataChange({ add_primitives: this.primitives }));
    }
    /**
     * 撤销
     */
    undo() {
        this.primitives.forEach(primitive => {
            primitive.needDelete = true;
        });
        this.eventMediator.noticeHandler.notice(this, new PythaEventDataChange({ delete_primitives: this.primitives }));
    }
}/**
 * 指令组 一次撤销多个或执行多个时使用
 */
class CommandGroup extends CommandBase {
    /**
     * 构造函数
     * @param cmds
     */
    constructor(cmds = []) {
        super();
        /**
         * 指令集
         */
        this.cmds = [];
        this.cmds = cmds;
    }
    /**
     * 执行
     */
    execute() {
        this.cmds.forEach(cmd => cmd.execute());
    }
    /**
     * 撤销
     */
    undo() {
        for (let i = this.cmds.length - 1; i >= 0; i--) {
            let cmd = this.cmds[i];
            cmd.undo();
        }
    }
    /**
     * 添加指令
     * @param cmd
     */
    addCmd(cmd) {
        this.cmds.push(cmd);
    }
    /**
     * 插入指令
     * @param cmd
     */
    insertCmd(cmd) {
        this.cmds.unshift(cmd);
    }
}/**
 * 生成图元
 */
class EventHandlerGeneratePri extends EventHandlerBase {
    constructor(node) {
        super(node);
    }
    run(data) {
        // 0 这里是开始逻辑
        // 获取存储
        const tempPrimitives = this.node.graph.cache.primitiveList;
        const storage = PythaStorage.instance;
        tempPrimitives.forEach(primitive => {
            delete storage.primitiveStore.tempPrimitiveDict[primitive.uuid];
            primitive.uuid = BaseUtils.genUUID();
        });
        if (tempPrimitives.length < 1) {
            return true;
        }
        // 执行命令
        const cmd = new AddPrimitiveCmd(tempPrimitives, this.node.graph.eventMediator);
        // 判断缓存中是否有commandGroup
        const graphCache = this.node.graph.cache;
        const commandGroup = graphCache.data['commandGroup'];
        if (!commandGroup || !(commandGroup instanceof CommandGroup)) {
            storage.historyStore.undos.push(cmd);
            cmd.execute();
        }
        else {
            commandGroup.addCmd(cmd);
        }
        return true;
    }
}/**
 * 辅助线标签
 */
class HelpLineLabel extends LabelBase {
    constructor() {
        super(...arguments);
        /**
         * 辅助线起点
         */
        this.start = new Point();
    }
    /**
     * 生成辅助线标签
     */
    generate() {
        const root = this.obj.element;
        this.obj.renderOrder = 300;
        const helpline = document.createElement('div');
        helpline.style.position = "absolute";
        helpline.style.height = "0px";
        helpline.style.width = "0px";
        helpline.style.borderTop = "1px dashed orange";
        helpline.style.transformOrigin = "left";
        this.obj.center.set(0, 0);
        this.helpline = helpline;
        root.appendChild(helpline);
    }
    /**
     * 设置起点
     * @param start
     */
    setStart(start) {
        this.start.copy(start);
        this.setPosition(this.start);
    }
    /**
     * 通过长度和角度设置终点
     * @param width 屏幕像素长度
     * @param theta 弧度角
     */
    setEnd(width, theta) {
        this.helpline.style.width = `${width}px`;
        if (width > 0) {
            this.helpline.style.transform = `rotate(${-theta}deg)`;
        }
        else {
            this.helpline.style.transform = `rotate(0deg)`;
        }
    }
}/**
 * 计算辅助线处理器
 */
class EventHandlerHelpLine extends EventHandlerBase {
    /**
     * 辅助线
     */
    // helpline: HelpLineLabel;
    constructor(node) {
        super(node);
    }
    /**
     * 运行处理器
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a;
        // 获取存储
        const storage = this.getPythaStorage();
        const viewportStore = storage.viewportStore;
        const viewportItems = storage.viewportStore.viewportItems;
        const camera = (_a = viewportItems[storage.viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        let helpline = this.node.graph.cache.data['helpline'];
        // 生成辅助线
        if (helpline == null) {
            helpline = new HelpLineLabel();
            this.node.graph.cache.data['helpline'] = helpline;
            let pdlist = this.node.graph.cache.pointerDownList;
            let start = new Point();
            if (pdlist.length === 0) { //如果当前没有点击点，则直接用坐标系原点
                start.set(storage.coordinateStore.activeUcs.elements[12], storage.coordinateStore.activeUcs.elements[13], storage.coordinateStore.activeUcs.elements[14]);
            }
            else {
                start.copy(pdlist[pdlist.length - 1].point);
            }
            helpline.setStart(start);
        }
        let startPoint = helpline.start;
        let end;
        if (!!this.node.graph.cache.data['isPointDown'] && this.node.graph.cache.pointerDownList.length > 0) {
            // 按下点或输入点
            let pd = this.node.graph.cache.pointerDownList[this.node.graph.cache.pointerDownList.length - 1].point;
            end = pd;
            this.node.graph.cache.data['isPointDown'] = false;
        }
        else {
            end = this.node.graph.cache.pointerMove.point;
        }
        _vec$4.subVectors(_p1.copy(end).project(camera), _p2$1.copy(startPoint).project(camera));
        let rect = viewportStore.getViewportRect(viewportStore.currentViewportKey);
        if (rect == null)
            return true;
        let x = _vec$4.x / 2 * rect.width;
        let y = _vec$4.y / 2 * rect.height;
        let length = Math.sqrt(x ** 2 + y ** 2);
        let theta = Math.acos(x / length);
        if (y < 0) {
            theta = Math.PI * 2 - theta;
        }
        theta = theta * 180 / Math.PI;
        helpline.setEnd(length, theta);
        // 显示
        if (!helpline.obj.parent) {
            storage.viewportStore.scene.add(helpline.obj);
        }
        return true;
    }
    dispose() {
        let helpline = this.node.graph.cache.data['helpline'];
        helpline === null || helpline === void 0 ? void 0 : helpline.remove();
    }
}
const _vec$4 = new Vector3();
const _p1 = new Point();
const _p2$1 = new Point();/**
 * 捕捉初始化
 */
class EventHandlerInitCapture extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        // 获取存储
        const storage = PythaStorage.instance;
        // let primitivesInView: { [key: string]: Primitive } = storage.primitiveStore.primitiveInView;
        if (!storage.captureStore.enabled) {
            storage.captureStore.capturePoint = null;
            return true;
        }
        storage.captureStore.captureActived = true;
        // // 获取图元特征点
        // let featurePoints: FeaturePoint[] = [];
        // Object.keys(primitivesInView).forEach(key => {
        //     const primitive = primitivesInView[key];
        //     if (primitive.hidden) {
        //         // 跳过隐藏的图元
        //         return;
        //     }
        //     if (primitive.type == "Block") {
        //         // 块的捕捉点要去模板里拿
        //         let bt = storage.blockStore.blockTemplateDict[(primitive as BlockPrimitive).blockTemplateUuid];
        //         let fps = [];
        //         this.findBlockFeaturePoints(bt, primitive.worldModelMatrix, fps);
        //         featurePoints.push(...fps);
        //         return;
        //     }
        //     if (primitive.type == "Text") {
        //         // 文字不捕捉
        //         return;
        //     }
        //     let fps = primitive.getFeaturePoints();
        //     featurePoints.push(...fps);
        // })
        // // 添加捕捉交点
        // let primitivesList: Primitive[] = Object.values(primitivesInView);
        // let intersectionPointList: Point[] = []
        // for (let i = 0; i < primitivesList.length - 1; i++) {
        //     let primitiveA = primitivesList[i]
        //     let geosA = primitiveA.geos
        //     let worldModelMatrixA = primitiveA.worldModelMatrix
        //     if (worldModelMatrixA) {
        //         geosA.forEach(geo => {
        //             geo.transformMatrix.premultiply(worldModelMatrixA)
        //         })
        //     }
        //     for (let j = i + 1; j < primitivesList.length; j++) {
        //         let primitiveB = primitivesList[j]
        //         let geosB = primitiveB.geos
        //         let worldModelMatrixB = primitiveB.worldModelMatrix
        //         if (worldModelMatrixB) {
        //             geosB.forEach(geo => {
        //                 geo.transformMatrix.premultiply(worldModelMatrixB)
        //             })
        //         }
        //         intersectionPointList.push(...this.getGeoIntersectionGeoPoints(geosA, geosB))
        //         if (worldModelMatrixB) {
        //             let worldModelMatrixBInvert = worldModelMatrixB.clone().invert()
        //             geosB.forEach(geo => {
        //                 geo.transformMatrix.premultiply(worldModelMatrixBInvert)
        //             })
        //         }
        //     }
        //     if (worldModelMatrixA) {
        //         let worldModelMatrixAInvert = worldModelMatrixA.clone().invert()
        //         geosA.forEach(geo => {
        //             geo.transformMatrix.premultiply(worldModelMatrixAInvert)
        //         })
        //     }
        // }
        // let intersectionFeaturePoint: FeaturePoint[] = intersectionPointList.map(item => {
        //     let midFP: FeaturePoint = {
        //         type: FEATURE_POINT_TYPE.INTERSECTION,
        //         geoType: "INTERSECTION",
        //         point: item
        //     }
        //     // 以下为测试交点代码
        //     // let geometry = new SphereGeometry(2)
        //     // let material = new MeshBasicMaterial({ color: 0xff0000 }); // 红色材质
        //     // let textSph = new Mesh(geometry,material)
        //     // textSph.position.set(item.x, item.y, item.z);
        //     // storage.viewportStore.scene.add(textSph)
        //     return midFP
        // }) || []
        // // 存入捕捉池
        // storage.captureStore.capturePointsPool = [...featurePoints, ...intersectionFeaturePoint];
        return true;
    }
    /**
     * 获取块的捕捉点
     */
    findBlockFeaturePoints(primitive, parentWorldMatrix, fps) {
        if (primitive == null)
            return;
        const storage = PythaStorage.instance;
        // let bt = storage.blockStore.blockTemplateDict[primitive.blockTemplateUuid];
        for (let key of Object.keys(primitive.children)) {
            // 遍历块模板的子图元
            let child = primitive.children[key];
            if (child.type == "Block") {
                // 子图元是块时，再次查找模板
                let mat = child.worldModelMatrix.clone().premultiply(parentWorldMatrix); // 同时传递外部变换矩阵
                let bt = storage.blockStore.blockTemplateDict[child.blockTemplateUuid];
                this.findBlockFeaturePoints(bt, mat, fps);
                continue;
            }
            let childFps = child.getFeaturePoints();
            for (let fp of childFps) {
                if (!!parentWorldMatrix) {
                    fp.point.applyMatrix4(parentWorldMatrix);
                }
            }
            fps.push(...childFps);
        }
    }
    /**
     * 获取两组geo的交点集合
     * @param geosA
     * @param geosB
     * @returns
     */
    getGeoIntersectionGeoPoints(geosA, geosB) {
        if (!((geosA === null || geosA === void 0 ? void 0 : geosA.length) > 0) || !((geosB === null || geosB === void 0 ? void 0 : geosB.length) > 0))
            return [];
        let res = [];
        for (let i = 0; i < geosA.length; i++) {
            for (let j = 0; j < geosB.length; j++) {
                res.push(...this.getIntersctionPoints(geosA[i], geosB[j]));
            }
        }
        return res;
    }
    /**
     * 获取线两两交点
     * @param geo1
     * @param geo2
     * @returns
     */
    getIntersctionPoints(geo1, geo2) {
        if (geo1.type == "Line") {
            let lineGeo1 = geo1;
            if (geo2.type == "Line") {
                let lineGeo2 = geo2;
                let intersectionPoint = GeoIntersection.LineSegmentIntersection(lineGeo1.start, lineGeo1.end, lineGeo2.start, lineGeo2.end);
                if (intersectionPoint) {
                    return [intersectionPoint];
                }
                else {
                    return [];
                }
            }
            else if (geo2.type == "Arc") {
                let arcGeo2 = geo2;
                let intersectionPoints = GeoIntersection.ArcIntersectLine(arcGeo2, lineGeo1, true, true);
                return intersectionPoints;
            }
            else if (geo2.type == "Circle") {
                let circleGeo2 = geo2;
                let intersectionPoints = GeoIntersection.ArcIntersectLine(circleGeo2, lineGeo1, true, true);
                return intersectionPoints;
            }
        }
        else if (geo1.type == "Arc") {
            let arcGeo1 = geo1;
            if (geo2.type == "Line") {
                let lineGeo2 = geo2;
                let intersectionPoints = GeoIntersection.ArcIntersectLine(arcGeo1, lineGeo2, true, true);
                return intersectionPoints;
            }
            else if (geo2.type == "Arc") {
                let arcGeo2 = geo2;
                let intersectionPoints = GeoIntersection.ArcIntersectArc(arcGeo1, arcGeo2, true, true);
                return intersectionPoints;
            }
            else if (geo2.type == "Circle") {
                let circleGeo2 = geo2;
                let intersectionPoints = GeoIntersection.ArcIntersectArc(arcGeo1, circleGeo2, true, true);
                return intersectionPoints;
            }
        }
        else if (geo1.type == "Circle") {
            let circleGeo1 = geo1;
            if (geo2.type == "Line") {
                let lineGeo2 = geo2;
                let intersectionPoints = GeoIntersection.ArcIntersectLine(circleGeo1, lineGeo2, true, true);
                return intersectionPoints;
            }
            else if (geo2.type == "Arc") {
                let arcGeo2 = geo2;
                let intersectionPoints = GeoIntersection.ArcIntersectArc(circleGeo1, arcGeo2, true, true);
                return intersectionPoints;
            }
            else if (geo2.type == "Circle") {
                let circleGeo2 = geo2;
                let intersectionPoints = GeoIntersection.ArcIntersectArc(circleGeo1, circleGeo2, true, true);
                return intersectionPoints;
            }
        }
        return [];
    }
}/**
 * 根据当前图中的确定点来平移当前工作面
 */
class EHMoveWorkPlane extends EventHandlerBase {
    constructor() {
        super(...arguments);
        /**
         * 存储工作面旧的点，用于在处理器销毁时还原
         */
        this.oldPoint = new Point();
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        //1.获取工作平面
        const pointerDownList = this.node.graph.cache.pointerDownList;
        if (pointerDownList.length < 1)
            return false;
        let workPlane = PythaStorage.instance.coordinateStore.workPlane;
        //2，将当前工作平面基点存储
        workPlane.getP(this.oldPoint);
        //3.将设置当前工作平面基点为最后一个确定点
        workPlane.setP(pointerDownList[pointerDownList.length - 1].point);
        return true;
    }
    /**
     * 销毁函数
     */
    dispose() {
        //还原工作平面
        let workPlane = PythaStorage.instance.coordinateStore.workPlane;
        workPlane.setP(this.oldPoint);
    }
}/**
 * 键盘数值输入 实际接收类型为 number count angle，在中介那里统一合并成number输入到本节点
 */
class EventHandlerNumberInput extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventNumber();
        this.needEventOnce = true;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(event) {
        if (event.cmd != this.needEvent.cmd)
            return false;
        let needInput = this.node.graph.cache.needInput; // 当前接收输入的类型在上一个通知节点里已经存入了needInput.option
        if (needInput == null || needInput.option == null)
            return false;
        this.node.graph.cache.inputNumber[needInput.option.toUpperCase()] = event.data;
        return true;
    }
}/**
 * 正交极轴处理器
 */
class EventHandlerOrthoPolar extends EventHandlerBase {
    constructor() {
        super(...arguments);
        this._helpLineZ = new Line$2();
        this.lineX = new Line$2();
        this.lineY = new Line$2();
        this.lineZ = new Line$2();
        this.endX = new Point();
        this.endY = new Point();
        this.endZ = new Point();
        this.pointz = new Vector3();
        this.moveFootPoint = new Point();
        this.firpoint = new Vector3();
        this.secpoint = new Vector3();
        this.moveLine = new Vector3();
        this.orthoPlane = new Plane$1();
        /**
         * 鼠标移动点
         */
        this.pointMove = new Point();
        /**
         * 极轴的基点
         */
        this.pointDown = new Point();
        this._rayStart = new Vector3();
        this._rayEnd = new Vector3();
        this.unprojectCursorPoint = (x, y, camera, point_move = null, workPlane = null) => {
            if (point_move == null) {
                point_move = new Vector3();
            }
            this._rayStart.set(x, y, -1).unproject(camera);
            this._rayEnd.set(x, y, 1).unproject(camera);
            if (!this._ray)
                this._ray = new Line$2();
            this._ray.set(this._rayStart, this._rayEnd);
            return GeoIntersection.LineIntersectPlane(this._ray, workPlane, point_move);
        };
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a;
        const storage = PythaStorage.instance;
        // 判断是否开启正交
        if (!storage.orthoPolarStore.orthoEnabled || !storage.orthoPolarStore.orthoActive) {
            storage.orthoPolarStore.orthoPolarPoint = null;
            return true;
        }
        // 判断是否开启捕捉且被捕捉
        if (storage.captureStore.enabled && storage.captureStore.capturePoint) {
            storage.orthoPolarStore.orthoPolarPoint = null;
            return true;
        }
        // 判断是否有正交基点
        const orthoPolarBasePoint = this.node.graph.cache.orthoPolarBasePoint;
        if (!orthoPolarBasePoint) {
            storage.orthoPolarStore.orthoPolarPoint = null;
            return true;
        }
        // 以下计算正交
        const viewportItems = storage.viewportStore.viewportItems;
        const camera = (_a = viewportItems[storage.viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        if (!camera) {
            storage.orthoPolarStore.orthoPolarPoint = null;
            return true;
        }
        // 获取工作平面上x轴、y轴方向向量
        const globalWorkPlane = storage.coordinateStore.workPlane;
        let axisX = globalWorkPlane.getNormalizeX();
        let axisY = globalWorkPlane.getNormalizeY();
        let axisZ = globalWorkPlane.getNormalizeZ();
        // 构造以pointdown为原点的正交轴
        this.pointDown.copy(orthoPolarBasePoint);
        this.endX.addVectors(this.pointDown, axisX);
        this.endY.addVectors(this.pointDown, axisY);
        this.endZ.addVectors(this.pointDown, axisZ);
        // 构造pointdown点所在的正交平面
        this.orthoPlane.setFromNormalAndCoplanarPoint(globalWorkPlane.normal, this.pointDown);
        this.lineX.set(this.pointDown, this.endX);
        this.lineY.set(this.pointDown, this.endY);
        this.lineZ.set(this.pointDown, this.endZ);
        //计算移动点与x轴角度
        let ndcPoint = storage.coordinateStore.ndcViewportPos2;
        this.unprojectCursorPoint(ndcPoint.x, ndcPoint.y, camera, this.pointMove, this.orthoPlane);
        this.moveLine.subVectors(this.pointMove, this.pointDown).normalize();
        let angle = this.moveLine.angleTo(axisX);
        let dirAngle = new Vector3();
        let valueZ = dirAngle.copy(this.moveLine).cross(axisX).angleTo(axisZ);
        if (valueZ > Math.PI / 2) {
            angle = angle;
        }
        else {
            angle = 2 * Math.PI - angle;
        }
        if (angle > Math.PI && angle < 2 * Math.PI) {
            angle = angle - Math.PI;
        }
        this.pointz.copy(this.pointDown);
        // todo 获取当前激活的ucs的原点与z方向
        let ucsOrigin = globalWorkPlane.getP();
        let ucsAxisZ = axisZ.clone();
        this.firpoint.copy(ucsOrigin);
        this.secpoint.copy(ucsOrigin).add(ucsAxisZ);
        this.firpoint.project(camera);
        this.secpoint.project(camera);
        let deltaX = this.secpoint.x - this.firpoint.x;
        let deltaY = this.secpoint.y - this.firpoint.y;
        this.pointz.project(camera);
        this.pointz.setX(this.pointz.x + deltaX);
        this.pointz.setY(this.pointz.y + deltaY);
        this.unprojectCursorPoint(this.pointz.x, this.pointz.y, camera, this.pointz, this.orthoPlane);
        this._helpLineZ.set(this.pointDown, this.pointz);
        let helplineLength = new Vector3().subVectors(this.pointDown, this.pointz).length();
        let dir = this._helpLineZ.getNormalizeX();
        let rotateAxis = this._helpLineZ.getNormalizeX().cross(axisZ).normalize();
        let rotateQuaternion = new Quaternion();
        rotateQuaternion.setFromAxisAngle(rotateAxis, Math.PI / 2);
        //计算辅助点与x轴角度
        let helpangle = dir.angleTo(axisX);
        let valueHelpZ = dir.clone().cross(axisX).angleTo(axisZ);
        if (valueHelpZ > Math.PI / 2) {
            helpangle = helpangle;
        }
        else {
            helpangle = 2 * Math.PI - helpangle;
        }
        if (helpangle > Math.PI && helpangle < 2 * Math.PI) {
            helpangle = helpangle - Math.PI;
        }
        //根据鼠标移动角度计算垂足 
        const limit = 1e-4;
        this.moveFootPoint.copy(storage.coordinateStore.currentPos);
        if (-limit < helplineLength && helplineLength < limit) {
            // 如果是俯视UCS的情况下，计算 X 和 Y的正交
            let angleCos = this.moveLine.dot(axisX);
            if (Math.abs(angleCos) < Math.cos(Math.PI / 4)) {
                GeoRelation.LineClosestPointToPoint(this.lineY, this.pointMove, false, this.moveFootPoint);
            }
            else {
                GeoRelation.LineClosestPointToPoint(this.lineX, this.pointMove, false, this.moveFootPoint);
            }
        }
        else if (-limit < (helpangle - Math.PI / 2) && (helpangle - Math.PI / 2) < limit) {
            // helpangle == 90度时
            // 看向UCS Y轴负方向时 计算 X 和Z正交
            let currentAxisX = axisZ.clone().cross(globalWorkPlane.normal.clone());
            let currentX = new Vector3();
            currentX.addVectors(this.pointDown, currentAxisX);
            let currentLineX = new Line$2(this.pointDown, currentX);
            let angleCos = this.moveLine.dot(currentAxisX);
            if (Math.abs(angleCos) < Math.cos(Math.PI / 4)) {
                GeoRelation.LineClosestPointToPoint(this.lineZ, this.pointMove, false, this.moveFootPoint);
            }
            else {
                GeoRelation.LineClosestPointToPoint(currentLineX, this.pointMove, false, this.moveFootPoint);
            }
        }
        else if (helpangle > 0 && helpangle < Math.PI / 2) {
            // 看向UCS Y轴负方向时 计算 X 和Z正交
            if (angle <= helpangle / 2 || angle > 3 * Math.PI / 4) {
                GeoRelation.LineClosestPointToPoint(this.lineX, this.pointMove, false, this.moveFootPoint);
            }
            else if (angle > helpangle / 2 && angle <= (helpangle / 2 + Math.PI / 4)) {
                GeoRelation.LineClosestPointToPoint(this._helpLineZ, this.pointMove, false, this.moveFootPoint);
                this.moveFootPoint.sub(this.pointDown).multiplyScalar(1 / helplineLength).applyQuaternion(rotateQuaternion).add(this.pointDown);
            }
            else {
                GeoRelation.LineClosestPointToPoint(this.lineY, this.pointMove, false, this.moveFootPoint);
            }
        }
        else if (helpangle > Math.PI / 2 && helpangle < Math.PI) {
            if (angle <= Math.PI / 4 || angle > (helpangle + Math.PI) / 2) {
                GeoRelation.LineClosestPointToPoint(this.lineX, this.pointMove, false, this.moveFootPoint);
            }
            else if (angle > Math.PI / 4 && angle <= (helpangle / 2 + Math.PI / 4)) {
                GeoRelation.LineClosestPointToPoint(this.lineY, this.pointMove, false, this.moveFootPoint);
            }
            else {
                GeoRelation.LineClosestPointToPoint(this._helpLineZ, this.pointMove, false, this.moveFootPoint);
                this.moveFootPoint.sub(this.pointDown).multiplyScalar(1 / helplineLength).applyQuaternion(rotateQuaternion).add(this.pointDown);
            }
        }
        // 分别给图内和存储器赋值当前正交点
        this.node.graph.cache.pointerMove.point.copy(this.moveFootPoint);
        storage.orthoPolarStore.orthoPolarPoint = this.moveFootPoint;
        // storage.coordinateStore.currentPos.copy(this.moveFootPoint);
        // 将极轴点覆盖移动点
        return true;
    }
}/**
 * 将确定点设置为正交的基点
 */
class EventHandlerSettingOrthoPoint extends EventHandlerBase {
    run(data) {
        const pointerDownList = this.node.graph.cache.pointerDownList;
        this.node.graph.cache.orthoPolarBasePoint = pointerDownList[pointerDownList.length - 1].point.clone();
        return true;
    }
}/**
 * 渲染材质
 */
class RenderMaterial {
    constructor(uuid) {
        /**
         * 透明度
         */
        this.opacity = 1;
        /**
         * 渲染单元颜色
         */
        this.color = new Color().set(0xffba84);
        if (uuid == null) {
            uuid = BaseUtils.genUUID();
        }
        this.uuid = uuid;
    }
    /**
     * 复制材质
     * @param mat
     * @returns
     */
    copy(mat) {
        this.opacity = mat.opacity;
        this.color.copy(mat.color);
        this.textureUuid = mat.textureUuid;
        this.imageHeight = mat.imageHeight;
        this.imageWidth = mat.imageWidth;
        return this;
    }
    /**
     * 克隆材质
     * @returns
     */
    clone() {
        return new RenderMaterial().copy(this);
    }
    /**
     * 抽象成json数据格式
     * @returns
     */
    toJson() {
        return {
            uuid: this.uuid,
            opacity: this.opacity,
            color: `#${this.color.getHexString()}`,
            textureUuid: this.textureUuid,
            imageHeight: this.imageHeight,
            imageWidth: this.imageWidth,
        };
    }
    /**
     * 解析数据成对象
     */
    fromJson(json) {
        this.uuid = json.uuid;
        this.color.set(json.color);
        this.textureUuid = json.textureUuid;
        this.opacity = json.opacity;
        this.imageHeight = json.imageHeight;
        this.imageWidth = json.imageWidth;
        return this;
    }
}/**
 * 同一类材质的渲染最小单元
 */
class RenderItem {
    get mat() {
        return this._mat;
    }
    set mat(value) {
        this._mat = value;
        if (!!value) {
            this.uuid = value.uuid;
        }
    }
    /**
     * 构造函数
     * @param uuid
     */
    constructor(mat) {
        /**
         * 基元索引
         */
        this.geoElements = [];
        /**
         * 标记选中
         */
        this.isSelected = false;
        /**
         * 网格划分的临时存储，渲染时会自动移除
         */
        this._positionBuffer = [];
        if (mat != null) {
            this.mat = mat;
        }
        else {
            this.mat = new RenderMaterial();
        }
    }
    /**
     * 获取渲染的颜色
     * @returns
     */
    getRenderColor() {
        //TODO暂时不添加其他逻辑
        if (this.isSelected) {
            _color.set(0, 1, 0);
        }
        else if (this.mat) {
            _color.copy(this.mat.color);
        }
        if (this.primitive.lock) {
            // 锁定的时候将颜色变暗
            let hsl = { h: 0, s: 0, l: 0 };
            _color.getHSL(hsl);
            hsl.l = Math.max(0, hsl.l * 0.5);
            _color.setHSL(hsl.h, hsl.s, hsl.l);
            return _color;
        }
        return _color;
    }
    /**
     * 获取颜色数组 顶点数量
     * @param count
     */
    getColorBuffer(count, colorsBuffer = []) {
        this.getRenderColor();
        for (let i = 0; i < count * 3; i += 3) {
            colorsBuffer[i] = _color.r;
            colorsBuffer[i + 1] = _color.g;
            colorsBuffer[i + 2] = _color.b;
        }
        return colorsBuffer;
    }
    /**
     * 复制材质
     * @param mat
     * @returns
     */
    copy(item) {
        this.renderType = item.renderType;
        this.geoElements = [...item.geoElements];
        this.primitive = item.primitive;
        this.mat = item.mat.clone();
        return this;
    }
    /**
     * 克隆材质
     * @returns
     */
    clone() {
        return new RenderItem().copy(this);
    }
    /**
     * 抽象成json数据格式
     * @returns
     */
    toJson() {
        return {
            uuid: this.uuid,
            renderType: this.renderType,
            geoElements: [...this.geoElements],
        };
    }
    /**
     * 解析数据成对象
     */
    fromJson(json) {
        this.uuid = json.uuid;
        this.renderType = json.renderType;
        this.geoElements = [...json.geoElements];
        return this;
    }
}
const _color = new Color();/**
 * 图元
 */
class Primitive {
    get lod() {
        return this._lod;
    }
    set lod(value) {
        this._lod = value;
        if (this.leftPrimitive) {
            this.leftPrimitive.lod = value;
        }
        if (this.rightPrimitive) {
            this.rightPrimitive.lod = value;
        }
    }
    /**
     * get 获取重新生成布尔操作图元的获取方法
     */
    get needReGenerateBoolGeo() {
        return this._needReGenerateBoolGeo;
    }
    /**
     * set 重新生成布尔操作图元的方法
     */
    set needReGenerateBoolGeo(value) {
        this._needReGenerateBoolGeo = value;
        if (this.leftPrimitive && this.leftPrimitive.isBoolPrimitive()) {
            this.leftPrimitive.needReGenerateBoolGeo = value;
        }
        if (this.rightPrimitive && this.rightPrimitive.isBoolPrimitive()) {
            this.leftPrimitive.needReGenerateBoolGeo = value;
        }
    }
    /**
     * 构造函数
     * @param uuid
     */
    constructor(type = null, uuid = null) {
        /**
         * 是否为临时图元
         */
        this.temporary = false;
        /**
         * 类型 - 每类图元复写，用于存入数据库时标记图元类型
         */
        this.type = 'Primitive';
        /**
         * 图元名称
         */
        this.name = '';
        /**
         * 子图元集
         */
        this._children = {};
        /**
         * 组
         */
        this.group = [];
        /**
         * 颜色随图层
         */
        this.colorByLayer = true;
        /**
        * 渲染基本单元
        */
        this.renderItemDict = {};
        /**
         * 几何属性列表
         */
        this.geos = [];
        /**
         * 基元列表
         */
        this.geoElements = [];
        /**
         * 材质
         */
        this.materials = {};
        /**
         * 删除图元标记
         */
        this._needDelete = false;
        /**
         * 如果需要重新渲染就设置为true
         */
        this._needRedraw = false;
        /**
         * 图元是否隐藏
         */
        this._hidden = false;
        /**
         * 图元是否被选中 改变选中会刷新图元
         */
        this._isSelected = false;
        /**
         * 图元锁定
         */
        this.lock = false;
        /**
         * 精细度
         */
        this._lod = 3;
        /**
         * 上一次渲染的精细度
         */
        this.lastLod = 3;
        /**
         * 是否在视口内
         */
        this.isInView = false;
        /**
         * 设置不可被选中
         */
        this.unselectable = false;
        /**
         * 选中的控制点
         */
        this.selectedControlPoints = [];
        /**
         * 包围盒，needredraw时会自动置空
         */
        this._boundingbox = {
            min: null,
            max: null,
        };
        if (type != null)
            this.type = type;
        if (uuid) {
            this.uuid = uuid;
        }
        else {
            this.uuid = BaseUtils.genUUID();
        }
        // 初始化材质和渲染单元
        let renderItem = new RenderItem();
        renderItem.primitive = this;
        this.renderItemDict[renderItem.uuid] = renderItem;
        let mat = renderItem.mat;
        this.materials[mat.uuid] = mat;
    }
    /**
     * 创建渲染单元
     */
    addRenderItem() {
        let renderItem = new RenderItem();
        renderItem.primitive = this;
        this.renderItemDict[renderItem.uuid] = renderItem;
        let mat = renderItem.mat;
        this.materials[mat.uuid] = mat;
        return renderItem;
    }
    /**
     * 标记需要删除
     */
    set needDelete(value) {
        if (value === this._needDelete) {
            return;
        }
        this._needDelete = value;
        Object.keys(this.children).forEach(key => {
            let child = this.children[key];
            child.needDelete = value;
        });
    }
    get needDelete() {
        return this._needDelete;
    }
    /**
     * 标记需要重绘
     */
    set needRedraw(value) {
        this._needRedraw = value;
        Object.keys(this.children).forEach(key => {
            let child = this.children[key];
            child.needRedraw = value;
        });
        if (!value) {
            // 清空缓存数组
            Object.keys(this.renderItemDict).forEach(key => {
                let item = this.renderItemDict[key];
                item._positionBuffer = [];
            });
        }
        else {
            // 重置boundingbox
            this._boundingbox = {
                min: null,
                max: null,
            };
        }
    }
    get needRedraw() {
        return this._needRedraw;
    }
    /**
     * 标记需要隐藏
     */
    set hidden(value) {
        if (this._hidden !== value) {
            this.needRedraw = true;
        }
        this._hidden = value;
        Object.keys(this.children).forEach(key => {
            let child = this.children[key];
            child.hidden = value;
        });
    }
    get hidden() {
        return this._hidden;
    }
    /**
     * 标记图元被选中
     */
    get isSelected() {
        return this._isSelected;
    }
    set isSelected(value) {
        if (this._isSelected !== value) {
            this.needRedraw = true;
        }
        this._isSelected = value;
        Object.keys(this.renderItemDict).forEach(key => {
            let renderItem = this.renderItemDict[key];
            renderItem.isSelected = value;
        });
    }
    /**
     * 获取子图元
     */
    get children() {
        return this._children;
    }
    /**
     *
     * @param value
     */
    setOpacity(value) {
        Object.keys(this.materials).forEach(key => {
            let mat = this.materials[key];
            mat.opacity = value;
        });
    }
    /**
     * 添加渲染的人为分组
     * @param key
     */
    addKeyToGroup(key) {
        this.renderGroupKeys.push(key);
        Object.keys(this._children).forEach(primitiveKey => {
            this._children[primitiveKey].addKeyToGroup(key);
        });
    }
    /**
     * 根据父子图元关系，使用局部变换矩阵更新世界变换矩阵
     * @param updateParents 是否更新父图元矩阵
     * @param updateChildren 是否更新子图元矩阵
     * @returns
     */
    updateWorldModelMatrix(updateParents = false, updateChildren = true) {
        if (this.localModelMatrix == null && !this.parentUuid) {
            return;
        }
        else if (this.localModelMatrix == null) {
            this.localModelMatrix = new Matrix4();
        }
        if (this.worldModelMatrix == null)
            this.worldModelMatrix = new Matrix4();
        this.worldModelMatrix.copy(this.localModelMatrix);
        let parent = this.parent;
        if (parent != null) {
            if (updateParents === true) {
                parent.updateWorldModelMatrix(true, false);
            }
            let mat = parent.worldModelMatrix;
            this.worldModelMatrix.premultiply(mat);
        }
        if (this.worldModelMatrixInverse == null)
            this.worldModelMatrixInverse = new Matrix4();
        this.worldModelMatrixInverse.copy(this.worldModelMatrix).invert();
        if (updateChildren === true) {
            const children = this.children;
            Object.keys(children).forEach(key => {
                let child = children[key];
                child.updateWorldModelMatrix(false, true);
            });
        }
    }
    /**
     * 设置子图元
     */
    setChildren(entities) {
        this._children = {};
        entities.forEach(primitive => {
            primitive.parent = this;
            this._children[primitive.uuid] = primitive;
        });
    }
    /**
     * 向图元中添加一个子图元
     */
    addChildPrimitive(primitive) {
        if (primitive.uuid === this.uuid)
            return;
        primitive.parent = this;
        primitive.parentUuid = this.uuid;
        primitive.group = [];
        this._children[primitive.uuid] = primitive;
    }
    /**
     * 向图元中添加多个子图元
     */
    addChildEntities(entities) {
        entities.forEach(primitive => {
            primitive.parent = this;
            primitive.parentUuid = this.uuid;
            primitive.group = [];
            this._children[primitive.uuid] = primitive;
        });
    }
    /**
     * 手动设置局部坐标系
     */
    setXYZP(x = new Vector3(1, 0, 0), y = new Vector3(0, 1, 0), z = new Vector3(0, 0, 1), p = new Point()) {
        if (this.localModelMatrix == null)
            this.localModelMatrix = new Matrix4();
        this.localModelMatrix.elements[0] = x.x;
        this.localModelMatrix.elements[1] = x.y;
        this.localModelMatrix.elements[2] = x.z;
        this.localModelMatrix.elements[3] = 0;
        this.localModelMatrix.elements[4] = y.x;
        this.localModelMatrix.elements[5] = y.y;
        this.localModelMatrix.elements[6] = y.z;
        this.localModelMatrix.elements[7] = 0;
        this.localModelMatrix.elements[8] = z.x;
        this.localModelMatrix.elements[9] = z.y;
        this.localModelMatrix.elements[10] = z.z;
        this.localModelMatrix.elements[11] = 0;
        this.localModelMatrix.elements[12] = p.x;
        this.localModelMatrix.elements[13] = p.y;
        this.localModelMatrix.elements[14] = p.z;
        this.localModelMatrix.elements[15] = 1;
        this.updateWorldModelMatrix(false, true);
    }
    /**
     * 获取图元基点
     */
    getP() {
        let p = new Point();
        if (this.worldModelMatrix == null)
            return p;
        p.set(this.worldModelMatrix.elements[12], this.worldModelMatrix.elements[13], this.worldModelMatrix.elements[14]);
        return p;
    }
    /**
     * 判断该图元是否是体图元
     * @returns
     */
    isSolid() {
        //@ts-ignore
        if (this.geos && this.geos.length === 1 && (!!this.geos[0].isSolid || this.geos[0] instanceof Solid)) {
            return true;
        }
        if (this.isBoolPrimitive() && this.leftPrimitive.isSolid() && this.rightPrimitive.isSolid()) {
            return true;
        }
        return false;
    }
    /**
     * 判断该图元是否是平面图元
     * @returns
     */
    isRegion() {
        //@ts-ignore
        if (this.geos && this.geos.length === 1 && (!!this.geos[0].isPlane || this.geos[0] instanceof Plane$1)) {
            return true;
        }
        if (this.isBoolPrimitive() && this.leftPrimitive.isRegion() && this.rightPrimitive.isRegion()) {
            return true;
        }
        return false;
    }
    /**
     * 判断该图元是否是布尔操作图元
     */
    isBoolPrimitive() {
        if (this.leftPrimitive && this.rightPrimitive && this.boolOpe) {
            return true;
        }
        return false;
    }
    /**
     *
     * @param rings
     * @param polygon
     * @param divisionNums
     */
    generateRings(rings, polygon, divisionNums = {}) {
        let ring = [];
        polygon.edges.forEach(edge => {
            var _a, _b;
            const ringSize = polygon.edges.length === 1 ? 1 : 0;
            let division = (_b = (_a = divisionNums[edge.type]) === null || _a === void 0 ? void 0 : _a[this.lod]) === null || _b === void 0 ? void 0 : _b[0];
            if (!division) {
                division = 2;
            }
            for (let d = 0; d < division - ringSize; d++) {
                ring.push(edge.getPointAt(d / (division - 1)));
            }
        });
        rings.push(ring);
        polygon.holes.forEach(polygon => {
            this.generateRings(rings, polygon, divisionNums);
        });
    }
    getGeneralRegion(geo, divisionNums = {}) {
        if (geo.type == "GeneralRegion") {
            return geo;
        }
        else if (geo.type == "RegionFace") {
            let res = new GeneralRegion();
            let rings = [];
            this.generateRings(rings, geo, divisionNums);
            res.setByRingsAndNormal(rings, geo.normal);
            return res;
        }
        return new GeneralRegion();
    }
    getGeneralSolid(geo, divisionNums = {}) {
        if (geo.type == "GeneralSolid") {
            return geo;
        }
        else if (geo.type == "Box") {
            let gsolid = new GeneralSolid();
            gsolid.transformMatrix.copy(geo.transformMatrix);
            gsolid.points = [
                new Point(0, 0, 0),
                new Point(1, 0, 0),
                new Point(1, 1, 0),
                new Point(0, 1, 0),
                new Point(0, 0, 1),
                new Point(1, 0, 1),
                new Point(1, 1, 1),
                new Point(0, 1, 1),
            ];
            let ringIndexListList = [
                [[0, 1, 2, 3]], //底面
                [[4, 7, 6, 5]], //顶面
                [[0, 3, 7, 4]], //左面
                [[1, 5, 6, 2]], //右面
                [[0, 4, 5, 1]], //前面
                [[3, 2, 6, 7]] //后面
            ];
            let normalList = [
                new Vector3(0, 0, 1),
                new Vector3(0, 0, -1),
                new Vector3(1, 0, 0),
                new Vector3(-1, 0, 0),
                new Vector3(0, 1, 0),
                new Vector3(0, -1, 0),
            ];
            for (let i = 0; i < 6; i++) {
                let tmpPolygonIndex = new PolygonIndex(ringIndexListList[i], normalList[i]);
                gsolid.faces.push(tmpPolygonIndex);
            }
            return gsolid;
        }
        return new GeneralSolid();
    }
    /**
     * 重生成布尔操作的几何类
     * @param divisionNums 划分段数
     */
    reGenerateBoolGeo(divisionNums = {}) {
        if (!this.isBoolPrimitive()) { //不是布尔操作图元则不需要重生成
            return;
        }
        if (this.geos.length > 0 && !this.needReGenerateBoolGeo) { //如果不需要划分，直接跳过
            return;
        }
        //做面的布尔操作
        if (this.leftPrimitive.isRegion() && this.rightPrimitive.isRegion()) {
            //获取左图元的几何面
            if (this.leftPrimitive.isBoolPrimitive()) {
                this.leftPrimitive.needReGenerateBoolGeo = true;
                this.leftPrimitive.reGenerateBoolGeo(divisionNums);
            }
            let leftGeo = this.getGeneralRegion(this.leftPrimitive.geos[0], divisionNums);
            //获取右图元的几何面
            if (this.rightPrimitive.isBoolPrimitive()) {
                this.rightPrimitive.needReGenerateBoolGeo = true;
                this.rightPrimitive.reGenerateBoolGeo(divisionNums);
            }
            let rightGeo = this.getGeneralRegion(this.rightPrimitive.geos[0], divisionNums);
            //重新生成面
            this.geos = [];
            this.geos.push(BoolOperation.boolOperation2D(leftGeo, rightGeo, this.boolOpe));
            this.needReGenerateBoolGeo = false; //标记为不需要重新生成
        }
        //做体的布尔操作
        if (this.leftPrimitive.isSolid() && this.rightPrimitive.isSolid()) {
            //获取左图元的几何面
            if (this.leftPrimitive.isBoolPrimitive()) {
                this.leftPrimitive.needReGenerateBoolGeo = true;
                this.leftPrimitive.reGenerateBoolGeo(divisionNums);
            }
            let leftGeo = this.getGeneralSolid(this.leftPrimitive.geos[0], divisionNums);
            //获取右图元的几何面
            if (this.rightPrimitive.isBoolPrimitive()) {
                this.rightPrimitive.needReGenerateBoolGeo = true;
                this.rightPrimitive.reGenerateBoolGeo(divisionNums);
            }
            let rightGeo = this.getGeneralSolid(this.rightPrimitive.geos[0], divisionNums);
            //重新生成面
            this.geos = [];
            this.geos.push(BoolOperation.boolOperation3D(leftGeo, rightGeo, this.boolOpe));
        }
    }
    /**
     * 复制图元
     * @param primitive
     * @returns
     */
    copy(primitive) {
        if (primitive.type !== this.type)
            return this;
        // 复制几何
        this.geos = [];
        for (let i = 0; i < primitive.geos.length; i++) {
            this.geos.push(primitive.geos[i].clone());
        }
        // 复制渲染单元
        this.renderItemDict = {};
        Object.keys(primitive.renderItemDict).forEach(key => {
            let item = primitive.renderItemDict[key].clone();
            item.primitive = this;
            this.renderItemDict[item.uuid] = item;
        });
        // 复制材质
        this.materials = {};
        Object.keys(this.renderItemDict).forEach(key => {
            let mat = this.renderItemDict[key].mat;
            this.materials[mat.uuid] = mat;
        });
        // 复制图元自身属性
        this.parentUuid = primitive.parentUuid;
        this.layerUuid = primitive.layerUuid;
        this.colorByLayer = primitive.colorByLayer;
        this.lock = primitive.lock;
        this.group = [...primitive.group];
        this.renderGroupKeys = primitive.renderGroupKeys;
        if (!!primitive.localModelMatrix) {
            if (this.localModelMatrix == null)
                this.localModelMatrix = new Matrix4();
            this.localModelMatrix.copy(primitive.localModelMatrix);
        }
        this.parent = primitive.parent;
        // 复制子图元
        Object.keys(primitive.children).forEach(key => {
            let child = primitive.children[key].clone();
            this.addChildPrimitive(child);
        });
        // 更新自身及子图元的变换矩阵
        this.updateWorldModelMatrix(false, true);
        // =============复制布尔操作属性============
        //复制左图元
        if (primitive.leftPrimitive) {
            if (!this.leftPrimitive) {
                this.leftPrimitive = new Primitive();
            }
            this.leftPrimitive.copy(primitive.leftPrimitive);
        }
        //复制右图元
        if (primitive.rightPrimitive) {
            if (!this.rightPrimitive) {
                this.rightPrimitive = new Primitive();
            }
            this.rightPrimitive.copy(primitive.rightPrimitive);
        }
        //复制操作类型
        if (primitive.boolOpe) {
            this.boolOpe = primitive.boolOpe;
        }
        return this;
    }
    /**
     * 克隆图元
     */
    clone() {
        return new Primitive(this.type).copy(this);
    }
    /**
     * 获取祖先图元
     * @returns
     */
    getRootPrimitive() {
        let primitive = this;
        while (primitive.parent) {
            primitive = primitive.parent;
        }
        return primitive;
    }
    /**
     * 旋转图元
     * @param axis 旋转轴
     * @param angle 旋转角度
     * @param center 旋转中心
     * @returns
     **/
    rotate(point, axis, angle) {
        // this.geos.forEach(geo => {
        //     geo.rotate(point, axis, angle);
        // })
        _beforeMatrix.set(1, 0, 0, -point.x, 0, 1, 0, -point.y, 0, 0, 1, -point.z, 0, 0, 0, 1);
        _afterMatrix.set(1, 0, 0, point.x, 0, 1, 0, point.y, 0, 0, 1, point.z, 0, 0, 0, 1);
        _quaternion.setFromAxisAngle(axis, angle);
        _transformMatrix.makeRotationFromQuaternion(_quaternion);
        // this.transformMatrix = _beforeMatrix.premultiply(_transformMatrix).premultiply(_afterMatrix).premultiply(this.transformMatrix);
        if (this.localModelMatrix == null)
            this.localModelMatrix = new Matrix4();
        this.localModelMatrix.premultiply(_beforeMatrix).premultiply(_transformMatrix).premultiply(_afterMatrix);
        this.updateWorldModelMatrix(false, true);
        return this;
    }
    /**
     * 获取图元中心 - 每类图元复写
     * @returns
     */
    getCenter() {
        const box = this.getBoundingbox();
        if (!box) {
            return null;
        }
        const priCenter = new Vector3().addVectors(box.min, box.max).multiplyScalar(0.5);
        return priCenter;
    }
    /**
     * 平移图元
     * @param vec 移动方向
     */
    move(vec) {
        // this.geos.forEach(geo => {
        //     geo.move(dir);
        // })
        _transformMatrix.set(1, 0, 0, vec.x, 0, 1, 0, vec.y, 0, 0, 1, vec.z, 0, 0, 0, 1);
        if (this.localModelMatrix == null)
            this.localModelMatrix = new Matrix4();
        this.localModelMatrix.premultiply(_transformMatrix);
        this.updateWorldModelMatrix(false, true);
        return this;
    }
    /**
     * 缩放中心
     * @param center
     * @param factor
     * @returns
     */
    scale(point, factorX, factorY = null, factorZ = null) {
        // this.geos.forEach(geo => {
        //     geo.scale(center, factor);
        // })
        if (factorY == null)
            factorY = factorX;
        if (factorZ == null)
            factorZ = factorX;
        _transformMatrix.set(factorX, 0, 0, point.x * (1 - factorX), 0, factorY, 0, point.y * (1 - factorY), 0, 0, factorZ, point.z * (1 - factorZ), 0, 0, 0, 1);
        if (this.localModelMatrix == null)
            this.localModelMatrix = new Matrix4();
        this.localModelMatrix.premultiply(_transformMatrix);
        this.updateWorldModelMatrix(false, true);
        return this;
    }
    /**
     * 镜像图元
     * @param plane 镜像平面
     * @returns
     **/
    mirror(plane) {
        let mirrorPlaneNormal = plane.normal;
        // let point1 = plane.coplanarPoint()
        let d = plane.constant;
        let nx = mirrorPlaneNormal.x;
        let ny = mirrorPlaneNormal.y;
        let nz = mirrorPlaneNormal.z;
        let mirrorMatrix = new Matrix4();
        mirrorMatrix.set(1 - 2 * nx * nx, -2 * nx * ny, -2 * nx * nz, -2 * d * nx, -2 * nx * ny, 1 - 2 * ny * ny, -2 * ny * nz, -2 * d * ny, -2 * nx * nz, -2 * ny * nz, 1 - 2 * nz * nz, -2 * d * nz, 0, 0, 0, 1);
        if (this.localModelMatrix == null)
            this.localModelMatrix = new Matrix4();
        this.localModelMatrix.premultiply(mirrorMatrix);
        this.updateWorldModelMatrix(false, true);
    }
    /**
     * 抽象成json数据格式
     * @returns
     */
    toJson() {
        var _a, _b, _c;
        let geos = ((_a = this.geos) === null || _a === void 0 ? void 0 : _a.map(item => item.toJson())) || [];
        let mats = [];
        let items = [];
        if (this.renderItemDict) {
            Object.keys(this.renderItemDict).forEach(key => {
                var _a;
                let item = this.renderItemDict[key];
                items.push(((_a = item === null || item === void 0 ? void 0 : item.toJson) === null || _a === void 0 ? void 0 : _a.call(item)) || {});
            });
        }
        if (this.materials) {
            Object.keys(this.materials).forEach(key => {
                var _a;
                let mat = this.materials[key];
                mats.push(((_a = mat === null || mat === void 0 ? void 0 : mat.toJson) === null || _a === void 0 ? void 0 : _a.call(mat)) || {});
            });
        }
        let data = {
            uuid: this.uuid || "",
            type: this.type || "Unknown",
            parentUuid: this.parentUuid || "",
            layerUuid: this.layerUuid || "",
            colorByLayer: this.colorByLayer,
            group: this.group || [],
            geos: geos,
            materials: mats,
            renderItems: items,
            name: this.name,
        };
        if (((_b = this.localModelMatrix) === null || _b === void 0 ? void 0 : _b.elements) && !this.localModelMatrix.elements.includes(null)) {
            data['localModelMatrix'] = this.localModelMatrix.elements;
        }
        //存储布尔操作图元
        if (this.leftPrimitive) {
            data['leftPrimitive'] = this.leftPrimitive.toJson();
        }
        if (this.rightPrimitive) {
            data['rightPrimitive'] = this.rightPrimitive.toJson();
        }
        if (this.boolOpe) {
            data['boolOpe'] = this.boolOpe;
        }
        if (((_c = Object.keys(this.children)) === null || _c === void 0 ? void 0 : _c.length) > 0) {
            let childJson = [];
            Object.keys(this.children).forEach(key => {
                let child = this.children[key];
                childJson.push(child.toJson());
            });
            data['children'] = childJson;
        }
        return data;
    }
    /**
     * 解析数据成对象
     */
    fromJson(json) {
        var _a;
        this.uuid = json.uuid;
        if (json.localModelMatrix) {
            if (this.localModelMatrix == null) {
                this.localModelMatrix = new Matrix4();
            }
            this.localModelMatrix.fromArray(json.localModelMatrix);
            if (this.localModelMatrix.elements.includes(null)) {
                this.localModelMatrix = new Matrix4();
            }
        }
        this.type = json.type;
        this.parentUuid = json.parentUuid;
        this.layerUuid = json.layerUuid;
        this.colorByLayer = !!json.colorByLayer;
        this.name = json.name || '';
        this.group = (json === null || json === void 0 ? void 0 : json.group) ? json === null || json === void 0 ? void 0 : json.group : [];
        this.renderGroupKeys = [];
        (_a = this.group) === null || _a === void 0 ? void 0 : _a.forEach(uuid => {
            this.addKeyToGroup(uuid);
        });
        this.materials = {};
        for (let item of json.materials) {
            let mat = new RenderMaterial().fromJson(item);
            this.materials[mat.uuid] = mat;
        }
        this.renderItemDict = {};
        for (let item of json.renderItems) {
            let renderItem = new RenderItem().fromJson(item);
            renderItem.primitive = this;
            this.renderItemDict[renderItem.uuid] = renderItem;
            renderItem.mat = this.materials[renderItem.uuid];
        }
        this.geos = [];
        const storage = PythaStorage.instance.registerStore;
        for (let item of json.geos) {
            const geoTemplate = storage.getGeometry(item.type);
            if (geoTemplate == null)
                continue;
            let geo = new (geoTemplate)().fromJson(item);
            this.geos.push(geo);
        }
        //存储布尔操作图元
        if (json.leftPrimitive) {
            this.leftPrimitive = new Primitive();
            this.leftPrimitive.fromJson(json.leftPrimitive);
        }
        if (json.rightPrimitive) {
            this.rightPrimitive = new Primitive();
            this.rightPrimitive.fromJson(json.rightPrimitive);
        }
        if (json.boolOpe) {
            this.boolOpe = json.boolOpe;
        }
        this.updateWorldModelMatrix(false, true);
        return this;
    }
    /**
     * 从渲染数组中获取图元包围盒
     * @param renderBucketDict 渲染数组存储对象
     */
    getBoundingbox(calChildBox = true) {
        if (this._boundingbox.max != null && this._boundingbox.min != null)
            return this._boundingbox;
        let minX = +Infinity;
        let minY = +Infinity;
        let minZ = +Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        let counter = 0;
        for (let geo of this.geos) {
            let bounding = geo.getBoundingBox();
            if (bounding.min == null || bounding.max == null)
                continue;
            let min = bounding.min;
            let max = bounding.max;
            if (this.worldModelMatrix != null) {
                boundingPoint1.set(min.x, min.y, min.z).applyMatrix4(this.worldModelMatrix);
                boundingPoint2.set(max.x, min.y, min.z).applyMatrix4(this.worldModelMatrix);
                boundingPoint3.set(max.x, max.y, min.z).applyMatrix4(this.worldModelMatrix);
                boundingPoint4.set(min.x, max.y, min.z).applyMatrix4(this.worldModelMatrix);
                boundingPoint5.set(min.x, min.y, max.z).applyMatrix4(this.worldModelMatrix);
                boundingPoint6.set(max.x, min.y, max.z).applyMatrix4(this.worldModelMatrix);
                boundingPoint7.set(max.x, max.y, max.z).applyMatrix4(this.worldModelMatrix);
                boundingPoint8.set(min.x, max.y, max.z).applyMatrix4(this.worldModelMatrix);
                helpBoundingBox.set(new Vector3(0, 0, 0), new Vector3(0, 0, 0));
                helpBoundingBox.setFromPoints([boundingPoint1, boundingPoint2, boundingPoint3, boundingPoint4, boundingPoint5, boundingPoint6, boundingPoint7, boundingPoint8]);
                min.copy(helpBoundingBox.min);
                max.copy(helpBoundingBox.max);
            }
            if (min.x < minX)
                minX = min.x;
            if (min.y < minY)
                minY = min.y;
            if (min.z < minZ)
                minZ = min.z;
            if (max.x > maxX)
                maxX = max.x;
            if (max.y > maxY)
                maxY = max.y;
            if (max.z > maxZ)
                maxZ = max.z;
            counter++;
        }
        if (counter == 0 && Object.keys(this.children).length <= 0) {
            this._boundingbox = {
                min: this.getP(),
                max: this.getP(),
            };
            return this._boundingbox;
        }
        if (calChildBox) {
            for (let key of Object.keys(this.children)) {
                let child = this.children[key];
                let bounding = child.getBoundingbox();
                let min = bounding.min;
                let max = bounding.max;
                if (min.x < minX)
                    minX = min.x;
                if (min.y < minY)
                    minY = min.y;
                if (min.z < minZ)
                    minZ = min.z;
                if (max.x > maxX)
                    maxX = max.x;
                if (max.y > maxY)
                    maxY = max.y;
                if (max.z > maxZ)
                    maxZ = max.z;
            }
        }
        this._boundingbox = {
            min: new Point(minX, minY, minZ),
            max: new Point(maxX, maxY, maxZ)
        };
        return this._boundingbox;
    }
    /**
     * 获取图元特征点 用于捕捉
     */
    getFeaturePoints() {
        var _a, _b;
        let res = [];
        if (this.geos.length <= 0) {
            let fp = {
                /**
                 * 特征点类型
                 */
                type: FEATURE_POINT_TYPE.CENTER,
                /**
                 * 特征点坐标
                 */
                point: this.getP(),
                primitive: this,
            };
            res.push(fp);
            // 判断children
            if (!!this.children) {
                (_a = Object.keys(this.children)) === null || _a === void 0 ? void 0 : _a.forEach(key => {
                    const child = this.children[key];
                    let childPoints = child.getFeaturePoints();
                    res.push(...childPoints);
                });
            }
            return res;
        }
        for (let geo of this.geos) {
            let fps = geo.getFeaturePoints();
            for (let fp of fps) {
                if (!!this.worldModelMatrix) {
                    fp.point.applyMatrix4(this.worldModelMatrix);
                }
                fp.geo = geo;
                fp.primitive = this;
                res.push(fp);
            }
        }
        // 判断children
        if (!!this.children) {
            (_b = Object.keys(this.children)) === null || _b === void 0 ? void 0 : _b.forEach(key => {
                const child = this.children[key];
                let childPoints = child.getFeaturePoints();
                res.push(...childPoints);
            });
        }
        return res;
    }
    /**
     * 获取控制点 用于夹点和stretch
     */
    getControlPoints() {
        let res = [];
        if (this.geos.length > 1 || this.geos.length <= 0) {
            let fp = {
                /**
                 * 特征点类型
                 */
                type: FEATURE_POINT_TYPE.CENTER,
                /**
                 * 特征点坐标
                 */
                point: this.getP(),
                primitive: this,
            };
            res.push(fp);
            return res;
        }
        for (let geo of this.geos) {
            let fps = geo.getControlPoints();
            for (let fp of fps) {
                if (!!this.worldModelMatrix) {
                    fp.point.applyMatrix4(this.worldModelMatrix);
                }
                fp.geo = geo;
                fp.primitive = this;
                res.push(fp);
            }
        }
        return res;
    }
}
//全局临时存储
const _beforeMatrix = new Matrix4();
const _transformMatrix = new Matrix4();
const _afterMatrix = new Matrix4();
//临时四元数
const _quaternion = new Quaternion();
// 包围盒计算临时变量
const boundingPoint1 = new Point();
const boundingPoint2 = new Point();
const boundingPoint3 = new Point();
const boundingPoint4 = new Point();
const boundingPoint5 = new Point();
const boundingPoint6 = new Point();
const boundingPoint7 = new Point();
const boundingPoint8 = new Point();
const helpBoundingBox = new Box3();/**
 * 计算临时圆
 */
class EventHandlerCalTempCircle extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a;
        // 获取存储
        const storage = PythaStorage.instance;
        const workPlane = storage.coordinateStore.workPlane;
        const pointerDownList = this.node.graph.cache.pointerDownList;
        if (pointerDownList.length < 1)
            return false;
        let primitiveList = this.node.graph.cache.primitiveList;
        if (primitiveList.length < 1) {
            // 创建圆
            let pointer = pointerDownList[pointerDownList.length - 1];
            let circle = new Circle(pointer.point, 0, workPlane.normal, workPlane.getX());
            // console.log("ucs",storage.coordinateStore.activeUcs, "workPlane", workPlane, "workPlane.normal", workPlane.normal, "workPlane.getX()", workPlane.getX())
            let primitive = new Primitive("Circle");
            primitive.geos.push(circle);
            let keys = Object.keys(primitive.renderItemDict);
            if (keys.length > 0) {
                let renderItem = primitive.renderItemDict[keys[0]];
                renderItem.geoElements = circle.getGeoElementsIdxList();
                (_a = renderItem.mat) === null || _a === void 0 ? void 0 : _a.color.set(storage.layerStore.getColor());
            }
            primitive.temporary = true;
            this.node.graph.cache.primitiveList.push(primitive);
            this.node.graph.cache.data['circle'] = circle;
            storage.primitiveStore.tempPrimitiveDict[primitive.uuid] = primitive;
            //防止第一个pointdown错误
            circle.radius = 0;
            primitive.needRedraw = true;
            return true;
        }
        // 更新圆半径
        // 判断是否有输入半径
        let radius = 0;
        let inputNumber = this.node.graph.cache.inputNumber;
        if (inputNumber["T"]) {
            radius = inputNumber["T"];
        }
        else {
            //判断是否有输入点
            let pd;
            if (!!this.node.graph.cache.data['isPointDown'] && this.node.graph.cache.pointerDownList.length > 0) {
                // 按下点或输入点
                pd = this.node.graph.cache.pointerDownList[this.node.graph.cache.pointerDownList.length - 1].point;
                this.node.graph.cache.data['isPointDown'] = false;
            }
            else {
                pd = this.node.graph.cache.pointerMove.point;
            }
            GeoMeasurement.getPointProjectToPlane(pd, workPlane, _pointInPlane$1);
            radius = _pointInPlane$1.distanceTo(pointerDownList[0].point);
            if (radius < 1e-6) {
                radius = 1e-5;
            }
        }
        let primitive = this.node.graph.cache.primitiveList[0];
        let circle = this.node.graph.cache.data['circle'];
        circle.radius = radius;
        primitive.needRedraw = true;
        return true;
    }
    /**
     * 销毁
     */
    dispose() {
        // this.primitive.needDelete = true;
    }
}
/**
 * 投影到当前工作平面的点，用以处理捕捉点不在当前工作平面上的情况
 */
const _pointInPlane$1 = new Point();/**
 * 绘制圆
 */
class EventGraphCircle extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node3 = new EventGraphNode(this, EventHandlerCapture);
        const node4 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node5 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node7 = new EventGraphNode(this, EventHandlerCalTempCircle);
        const node8 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node10 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node11 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node12 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node13 = new EventGraphNode(this, EventHandlerConfirm);
        const node16 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node17 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node22 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定圆心", option: "C", inputTypes: [PythaEventName.POINTER_DOWN] }
            ] });
        const node24 = new EventGraphNode(this, EventHandlerNumberInput);
        const node25 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "半径", option: "T", inputTypes: [PythaEventName.NUMBER, PythaEventName.POINTER_DOWN] }
            ] });
        const node26 = new EventGraphNode(this, EventHandlerGrid);
        const node27 = new EventGraphNode(this, EventHandlerGrid);
        const node28 = new EventGraphNode(this, EventHandlerInitCapture);
        const node29 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node30 = new EventGraphNode(this, EventHandlerCalTempCircle);
        const node32 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        const node33 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node34 = new EventGraphNode(this, EHChangeCrossCursor);
        const node35 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        const node36 = new EventGraphNode(this, EventHandlerHelpLine);
        const node37 = new EventGraphNode(this, EHMoveWorkPlane);
        this.addEdge(node2, node3);
        this.addEdge(node1, node4);
        this.addEdge(node16, node7);
        this.addEdge(node13, node17);
        this.addEdge(node26, node12);
        this.addEdge(node27, node8);
        this.addEdge(node29, node28);
        this.addEdge(node28, node2);
        this.addEdge(node3, node32);
        this.addEdge(node30, node11);
        this.addEdge(node11, node33);
        this.addEdge(node33, node26);
        this.addEdge(node22, node13);
        this.addEdge(node25, node10);
        this.addEdge(node25, node24);
        this.addEdge(node12, node17);
        this.addEdge(node1, node22);
        this.addEdge(node24, node10, EDGE_TYPE.STOP);
        this.addEdge(node10, node24, EDGE_TYPE.STOP);
        this.addEdge(node4, node34);
        this.addEdge(node34, node29);
        this.addEdge(node22, node5);
        this.addEdge(node3, node16);
        this.addEdge(node5, node7);
        this.addEdge(node10, node30);
        this.addEdge(node24, node30);
        this.addEdge(node35, node25);
        this.addEdge(node7, node36);
        this.addEdge(node36, node27);
        this.addEdge(node5, node37);
        this.addEdge(node37, node35);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/79
    }
}
/**
 * circle指令 用于注册事件图
 */
EventGraphCircle.cmd = 'CIRCLE';/**
 * 计算临时圆锥
 */
class EventHandlerCalTempCone extends EventHandlerBase {
    constructor() {
        super(...arguments);
        this._cameraDir = new Vector3();
        this._vec = new Vector3();
        this._x = new Vector3();
        this._y = new Vector3();
        this._z = new Vector3();
        this._vec12 = new Vector3();
        this._vec13 = new Vector3();
        this._p1 = new Point();
        this._p2 = new Point();
        this._p3 = new Point();
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a, _b, _c;
        // 获取存储
        const storage = PythaStorage.instance;
        storage.coordinateStore.workPlane;
        const pointerDownList = this.node.graph.cache.pointerDownList;
        if (pointerDownList.length < 1)
            return false;
        const primitiveList = this.node.graph.cache.primitiveList;
        // 使用ucs的坐标轴
        let ucs = storage.coordinateStore.activeUcs;
        this._x.set(ucs.elements[0], ucs.elements[1], ucs.elements[2]).normalize();
        this._y.set(ucs.elements[4], ucs.elements[5], ucs.elements[6]).normalize();
        this._z.set(ucs.elements[8], ucs.elements[9], ucs.elements[10]).normalize();
        if (primitiveList.length < 1) {
            // console.log("初始化:::", this._x.x.toFixed(4), this._x.y.toFixed(4), this._x.z.toFixed(4))
            // console.log("初始化:::", this._y.x.toFixed(4), this._y.y.toFixed(4), this._y.z.toFixed(4))
            // console.log("初始化:::", this._z.x.toFixed(4), this._z.y.toFixed(4), this._z.z.toFixed(4))
            // 生成临时圆锥图元
            let pointer = pointerDownList[0];
            let cone = new Cone(pointer.point, 1e-4, 1e-4, this._z, this._x);
            let primitive = new Primitive("Cone");
            primitive.geos.push(cone);
            let keys = Object.keys(primitive.renderItemDict);
            if (keys.length > 0) {
                let renderItem = primitive.renderItemDict[keys[0]];
                renderItem.geoElements = cone.getGeoElementsIdxList();
                (_a = renderItem.mat) === null || _a === void 0 ? void 0 : _a.color.set(storage.layerStore.getColor());
            }
            primitive.temporary = true;
            this.node.graph.cache.primitiveList.push(primitive);
            this.node.graph.cache.data['cone'] = cone;
            storage.primitiveStore.tempPrimitiveDict[primitive.uuid] = primitive;
        }
        let cone = this.node.graph.cache.data['cone'];
        let primitive = this.node.graph.cache.primitiveList[0];
        // 判断当前的步骤 1：指定半径，2：指定高度
        let step = this.node.graph.cache.data['step'] || 1;
        let inputNumberMap = this.node.graph.cache.inputNumber;
        if (step == 1) {
            // 计算半径
            let radius = 0;
            // 判断是否有输入
            if (inputNumberMap["R"] != null) {
                radius = inputNumberMap["R"];
            }
            else {
                const pointMove = storage.coordinateStore.currentPos;
                radius = pointMove.distanceTo(pointerDownList[0].point);
            }
            cone.radius = radius;
        }
        else if (step == 2) {
            // 计算高度
            // 判断是否有输入
            if (inputNumberMap["H"] != null) {
                cone.height = inputNumberMap["H"];
            }
            else {
                //如果含有R，则移动更新高度 
                let currentPoint;
                let heightPointIdx = pointerDownList.findIndex(item => item.option === "H");
                let heightPoint = (_b = pointerDownList[heightPointIdx]) === null || _b === void 0 ? void 0 : _b.point;
                if (!!this.node.graph.cache.data['isPointDown'] && heightPoint) {
                    // 按下点或输入点
                    currentPoint = heightPoint;
                    this.node.graph.cache.data['isPointDown'] = false;
                }
                else {
                    currentPoint = this.node.graph.cache.pointerMove.point;
                    // 捕捉点位置
                    if (storage.captureStore.capturePoint != null) {
                        currentPoint.copy(storage.captureStore.capturePoint);
                    }
                    // 正交极轴位置
                    if (storage.orthoPolarStore.orthoPolarPoint != null) {
                        currentPoint.copy(storage.orthoPolarStore.orthoPolarPoint);
                    }
                }
                let height = 1e-5;
                let basePoint = pointerDownList[0].point;
                let normal = this._z.normalize();
                // 计算投影到屏幕的长度
                let viewportStore = storage.viewportStore;
                const camera = (_c = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _c === void 0 ? void 0 : _c.camera;
                this._p1.copy(basePoint).project(camera);
                this._p2.copy(currentPoint).project(camera);
                this._p3.copy(basePoint).add(normal).project(camera);
                this._vec12.subVectors(this._p2, this._p1);
                this._vec13.subVectors(this._p3, this._p1);
                let ratio = Math.sqrt(this._vec13.x * this._vec13.x + this._vec13.y * this._vec13.y);
                if (storage.captureStore.capturePoint != null) {
                    // 捕捉到时，按捕捉位置计算高度
                    currentPoint.copy(storage.captureStore.capturePoint);
                    height = this._vec.subVectors(storage.captureStore.capturePoint, basePoint).dot(this._z);
                }
                else if (ratio < 1e-6) {
                    // 如果视角刚好俯视立方体的z轴，则将鼠标与第二基点的距离设置为高度
                    height = this._vec.subVectors(currentPoint, basePoint).length();
                }
                else {
                    // 按投影计算高度
                    camera.getWorldDirection(this._cameraDir);
                    let up = this._vec.crossVectors(normal, this._cameraDir).cross(this._cameraDir).multiplyScalar(-1).normalize();
                    let zLengthRatio = normal.dot(up); // 求ucs z轴在屏幕上的投影长度占总长度的比例
                    let ndcHeight = (this._vec12.x * this._vec13.x + this._vec12.y * this._vec13.y) / ratio;
                    this._vec13.x = this._vec13.x / ratio * ndcHeight;
                    this._vec13.y = this._vec13.y / ratio * ndcHeight;
                    height = this._p1.add(this._vec13).unproject(camera).sub(basePoint).dot(normal); // 这里求出需要拉长的高度
                    height = height / zLengthRatio / zLengthRatio; // 由于ucs z轴不是平行于平面的，需要在z轴方向上找到于光标位置高度平齐的点，等同于逆求两次cos theta
                }
                this._z.normalize().multiplyScalar(height);
                let eles = cone.transformMatrix.elements;
                eles[8] = this._z.x;
                eles[9] = this._z.y;
                eles[10] = this._z.z;
            }
        }
        primitive.needRedraw = true;
        return true;
    }
}/**
 * 逻辑AND 节点
 */
class EventGraphNodeAND extends EventGraphNode {
    run() {
        // 上级处理器全部做完才执行下一级节点
        this.isRunFinished = false;
        let finishFlag = true;
        for (let entry of this.entryNodes) {
            if (!entry.isRunFinished) {
                finishFlag = false;
                break;
            }
        }
        if (!finishFlag)
            return;
        super.run();
    }
}class EventHandlerUpdateConeStep extends EventHandlerBase {
    run(data) {
        if (!this.node.graph.cache.data['step']) {
            this.node.graph.cache.data['step'] = 0;
        }
        let step = this.node.graph.cache.data['step'] + 1;
        this.node.graph.cache.data['step'] = step;
        return true;
    }
}/**
 * cone指令,绘制圆锥
 */
class EventGraphCone extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                    type: NeedInputEnum.ACTIVE,
                    description: "指定底面的中心点",
                    option: "C",
                    inputTypes: [PythaEventName.POINTER_DOWN]
                }]
        });
        const node3 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node4 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node5 = new EventGraphNode(this, EventHandlerCapture);
        const node8 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                    type: NeedInputEnum.ACTIVE,
                    description: "指定底面半径",
                    option: "R",
                    inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER]
                }]
        });
        const node10 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node11 = new EventGraphNode(this, EventHandlerNumberInput);
        const node15 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node18 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node19 = new EventGraphNode(this, EventHandlerNumberInput);
        const node20 = new EventGraphNode(this, EventHandlerCalTempCone);
        const node21 = new EventGraphNode(this, EventHandlerGrid);
        const node22 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node23 = new EventGraphNode(this, EventHandlerConfirm);
        const node24 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node25 = new EventGraphNode(this, EventHandlerGrid);
        const node26 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node28 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node29 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node30 = new EventGraphNode(this, EventHandlerInitCapture);
        const node31 = new EventGraphNode(this, EHChangeCrossCursor);
        const node32 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node34 = new EventGraphNode(this, EventHandlerUpdateConeStep);
        const node35 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node37 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                    type: NeedInputEnum.ACTIVE,
                    description: "指定高度",
                    option: "H",
                    inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER]
                }]
        });
        const node39 = new EventGraphNodeAND(this, null);
        const node40 = new EventGraphNode(this, EventHandlerCalTempCone);
        const node41 = new EventGraphNode(this, EventHandlerUpdateConeStep);
        const node42 = new EventGraphNode(this, EventHandlerCalTempCone);
        this.addEdge(node1, node2);
        this.addEdge(node4, node5);
        this.addEdge(node19, node20);
        this.addEdge(node21, node22);
        this.addEdge(node1, node23);
        this.addEdge(node23, node24);
        this.addEdge(node22, node24);
        this.addEdge(node25, node26);
        this.addEdge(node20, node28);
        this.addEdge(node18, node28);
        this.addEdge(node3, node29);
        this.addEdge(node29, node30);
        this.addEdge(node30, node4);
        this.addEdge(node3, node31);
        this.addEdge(node28, node32);
        this.addEdge(node32, node21);
        this.addEdge(node8, node10);
        this.addEdge(node8, node11);
        this.addEdge(node10, node11, EDGE_TYPE.STOP);
        this.addEdge(node11, node10, EDGE_TYPE.STOP);
        this.addEdge(node19, node18, EDGE_TYPE.STOP);
        this.addEdge(node18, node19, EDGE_TYPE.STOP);
        this.addEdge(node2, node3);
        this.addEdge(node31, node35);
        this.addEdge(node35, node34);
        this.addEdge(node34, node8);
        this.addEdge(node37, node19);
        this.addEdge(node37, node18);
        this.addEdge(node34, node39);
        this.addEdge(node5, node39);
        this.addEdge(node39, node15);
        this.addEdge(node15, node40);
        this.addEdge(node40, node25);
        this.addEdge(node10, node42);
        this.addEdge(node11, node42);
        this.addEdge(node41, node37);
        this.addEdge(node42, node41);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/82
    }
}
/**
 * cone指令 用于注册事件图
 */
EventGraphCone.cmd = 'CONE';/**
 * 条件分支节点
 */
class EventGraphNodeSwitch extends EventGraphNode {
    /**
     * 构造函数
     * @param handlerName 处理器类名
     */
    constructor(graph, condition) {
        super(graph, null);
        this.graph = graph;
        this.conditionFunction = condition;
    }
    run() {
        var _a;
        // 按照条件分支函数的执行结果选择对应idx的节点执行
        this.isRunFinished = false;
        const branchIdxList = ((_a = this.conditionFunction) === null || _a === void 0 ? void 0 : _a.call(this)) || [];
        if (branchIdxList.length <= 0)
            return false;
        for (let branchIdx of branchIdxList) {
            if (branchIdx < 0 || branchIdx >= this.outNodes.length)
                continue;
            this.isRunFinished = true;
            let out = this.outNodes[branchIdx];
            if (out.type == EDGE_TYPE.STOP) ;
            else {
                out.node.run();
            }
        }
        return true;
    }
}class EventHandlerCalTempMoveObj extends EventHandlerBase {
    constructor(node) {
        super(node);
        this._copyEntitiyMap = {};
    }
    run() {
        // 存储第一个点
        const pointerList = this.node.graph.cache.pointerDownList;
        if (pointerList.length < 1)
            return false;
        //初始化
        if (this.node.graph.cache.data['firstPoint'] == null) {
            this.node.graph.cache.data['firstPoint'] = pointerList[pointerList.length - 1].point.clone();
            const selectPrimitives = PythaStorage.instance.selectStore.getUnlockedPrimitives();
            this.generateTempRenderItems(selectPrimitives);
        }
        //获得pointdown或者pointmove
        let currentPoint;
        if (!!this.node.graph.cache.data['isPointDown'] && this.node.graph.cache.pointerDownList.length > 0) {
            // 按下点或输入点
            currentPoint = this.node.graph.cache.pointerDownList[this.node.graph.cache.pointerDownList.length - 1].point;
            this.node.graph.cache.data['isPointDown'] = false;
        }
        else {
            currentPoint = this.node.graph.cache.pointerMove.point;
        }
        //通过当前点更新临时图元
        const x = currentPoint.x - this.node.graph.cache.data['firstPoint'].x;
        const y = currentPoint.y - this.node.graph.cache.data['firstPoint'].y;
        const z = currentPoint.z - this.node.graph.cache.data['firstPoint'].z;
        for (let key in this._copyEntitiyMap) {
            let mapItem = this._copyEntitiyMap[key];
            if (mapItem.object == null)
                continue;
            mapItem.object.position.set(x, y, z);
        }
        return true;
    }
    dispose() {
        for (let key in this._copyEntitiyMap) {
            let mapItem = this._copyEntitiyMap[key];
            if (mapItem.object == null)
                continue;
            if (mapItem.object.parent) {
                mapItem.object.parent.remove(mapItem.object);
            }
        }
    }
    /**
     * 生成临时渲染对象
     */
    generateTempRenderItems(selectPrimitives) {
        var _a;
        for (let i = 0; i < selectPrimitives.length; i++) {
            let primitive = selectPrimitives[i];
            Object.keys(primitive.renderItemDict).forEach(renderKey => {
                var _a, _b, _c, _d;
                let renderItem = primitive.renderItemDict[renderKey];
                const key = renderItem.lastRenderKey;
                let bucket = PythaStorage.instance.renderStore.objectRenderBucket[key];
                if (bucket == null)
                    return;
                let renderMapItem = bucket.renderBucketItems[renderItem.renderGeometryBucketIndex];
                if (renderMapItem == null)
                    return;
                const start = renderItem.start;
                const size = renderItem.size;
                const mat = bucket.material;
                let copyRenderMapItem = this._copyEntitiyMap[key];
                if (copyRenderMapItem == null) {
                    copyRenderMapItem = {
                        material: mat,
                        positions: [],
                        colors: [],
                        uvs: [],
                        renderType: renderMapItem.renderType,
                        needRegenerate: false,
                        hidden: false
                    };
                    this._copyEntitiyMap[key] = copyRenderMapItem;
                }
                if (renderMapItem.buffer == null)
                    return;
                let positions = (_b = (_a = renderMapItem.buffer.attributes) === null || _a === void 0 ? void 0 : _a.position) === null || _b === void 0 ? void 0 : _b.array;
                let colors = (_d = (_c = renderMapItem.buffer.attributes) === null || _c === void 0 ? void 0 : _c.color) === null || _d === void 0 ? void 0 : _d.array;
                if (positions == null || colors == null)
                    return;
                for (let index = 0; (index < size) && (index + start) < positions.length; index++) {
                    copyRenderMapItem.positions.push(positions[index + start]);
                    copyRenderMapItem.colors.push(colors[index + start]);
                }
            });
        }
        const storage = PythaStorage.instance;
        for (let key in this._copyEntitiyMap) {
            let mapItem = this._copyEntitiyMap[key];
            let geo = new BufferGeometry();
            geo.setAttribute('position', new Float32BufferAttribute(mapItem.positions, 3));
            if (((_a = mapItem.uvs) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                geo.setAttribute('uv', new Float32BufferAttribute(mapItem.uvs, 2));
            }
            else {
                let colorAttribute = new Float32BufferAttribute(mapItem.colors, 3);
                geo.setAttribute('color', colorAttribute);
            }
            geo.computeBoundingBox();
            geo.computeVertexNormals();
            switch (mapItem.renderType) {
                case 'Line':
                    let line = new LineSegments(geo, mapItem.material);
                    storage.viewportStore.scene.add(line);
                    mapItem.object = line;
                    break;
                case 'Mesh':
                    let mesh = new Mesh(geo, mapItem.material);
                    storage.viewportStore.scene.add(mesh);
                    mapItem.object = mesh;
                    break;
                case 'Point':
                    let point = new Points(geo, mapItem.material);
                    storage.viewportStore.scene.add(point);
                    mapItem.object = point;
                    break;
            }
        }
    }
}/**
 * 根据平移向量，将选中的图元全部进行复制
 */
class EventHandlerCalCopyPosition extends EventHandlerBase {
    constructor() {
        super(...arguments);
        /**
         * 临时移动向量
         */
        this._vec = new Vector3();
        /**
         * 上一次移动总距离
         */
        this._lastDistance = 0;
    }
    run(data) {
        if (this.node.graph.cache.primitiveList.length > 0) {
            this.node.graph.cache.primitiveList = [];
        }
        if (!this.node.graph.cache.data['firstPoint'])
            return false;
        //获得pointdown或者pointmove
        let currentPoint;
        if (!!this.node.graph.cache.data['isPointDown'] && this.node.graph.cache.pointerDownList.length > 0) {
            // 按下点或输入点
            currentPoint = this.node.graph.cache.pointerDownList[this.node.graph.cache.pointerDownList.length - 1].point;
            this.node.graph.cache.data['isPointDown'] = false;
        }
        else {
            currentPoint = this.node.graph.cache.pointerMove.point;
        }
        // 同时判断键盘输入和两点
        let inputNumber = this.node.graph.cache.inputNumber['E'];
        if (inputNumber == null) {
            const x = currentPoint.x - this.node.graph.cache.data['firstPoint'].x;
            const y = currentPoint.y - this.node.graph.cache.data['firstPoint'].y;
            const z = currentPoint.z - this.node.graph.cache.data['firstPoint'].z;
            this._vec.set(x, y, z);
        }
        else {
            // 有输入值，通过输入距离的方式
            const firstPoint = this.node.graph.cache.data['firstPoint'];
            if (!firstPoint)
                return false;
            const pointerMove = this.node.graph.cache.pointerMove;
            if (!(pointerMove === null || pointerMove === void 0 ? void 0 : pointerMove.point))
                return false;
            const pointMove = pointerMove.point;
            // 计算方向向量
            this._vec = pointMove.clone().sub(firstPoint).normalize();
            this._vec.multiplyScalar(inputNumber);
        }
        this.generateClonePri();
        return true;
    }
    generateClonePri() {
        const primitiveList = PythaStorage.instance.selectStore.getUnlockedPrimitives();
        const cloneAndMovePrimitives = (primitives, vec, needRedraw, isSelected) => {
            primitives.forEach(primitive => {
                let clonePrimitive = primitive.clone();
                clonePrimitive.move(vec);
                clonePrimitive.needRedraw = needRedraw;
                clonePrimitive.isSelected = isSelected;
                this.node.graph.cache.primitiveList.push(clonePrimitive);
            });
        };
        if (this.node.graph.cache.inputOption == null) { //正常复制
            cloneAndMovePrimitives(primitiveList, this._vec, true, false);
            this.node.graph.cache.inputNumber['E'] = null; // 清空输入，避免下次确定点依然使用这个距离
        }
        else {
            let input = this.node.graph.cache.data['text'];
            let priNum = 1;
            let distance = [];
            if (input.includes("*")) {
                const [base, count] = input.split("*").map(s => s.trim()).map(Number);
                priNum = count;
                distance = Array(priNum).fill(base);
            }
            else {
                distance = input.split(",").map((s) => s.trim()).map(Number);
                priNum = distance.length;
            }
            let currentVec = new Vector3();
            if (this.node.graph.cache.inputOption === 'L') { //直线复制
                let lengthUnitRatio = PythaStorage.instance.coordinateStore.lengthUnitRatio;
                for (let i = 0; i < priNum; i++) {
                    currentVec.copy(this._vec).normalize().multiplyScalar((distance[i] + this._lastDistance) * lengthUnitRatio);
                    cloneAndMovePrimitives(primitiveList, currentVec, true, false);
                    if (i === priNum - 1) {
                        this._lastDistance += distance[i];
                    }
                    else {
                        distance[i + 1] = distance[i] + distance[i + 1];
                    }
                }
            }
            else if (this.node.graph.cache.inputOption === 'C') { // 环形复制
                let axis = PythaStorage.instance.coordinateStore.workPlane.normal;
                for (let i = 0; i < priNum; i++) {
                    let angle = (distance[i] + this._lastDistance) / 180 * Math.PI; //转化为弧度制
                    primitiveList.forEach(primitive => {
                        let clonePrimitive = primitive.clone();
                        clonePrimitive.rotate(this.node.graph.cache.data['firstPoint'], axis, angle);
                        clonePrimitive.needRedraw = true;
                        clonePrimitive.isSelected = false;
                        this.node.graph.cache.primitiveList.push(clonePrimitive);
                    });
                    if (i === priNum - 1) {
                        this._lastDistance += distance[i];
                    }
                    else {
                        distance[i + 1] = distance[i] + distance[i + 1];
                    }
                }
            }
        }
    }
}/**
 * 切换至pick光标
 */
class EHChangePickCursor extends EventHandlerBase {
    /**
     * 运行处理器
     * @param data
     * @returns
     */
    run(data) {
        let event = new PythaEventCursorTypeChange();
        event.data = CursorType.PICK;
        this.node.graph.eventMediator.emitEvent(event);
        return true;
    }
}/**
 * 禁用夹点
 */
class EventHandlerDisableClamp extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        const storage = PythaStorage.instance;
        storage.clampStore.clampHidden = true;
        storage.clampStore.clear();
        return true;
    }
}/**
 * 选项输入
 */
class EventHandlerOptionInput extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventOption();
        this.needEventOnce = true;
    }
    run(event) {
        var _a;
        if (event.cmd != this.needEvent.cmd)
            return false;
        let option = (_a = event.data) === null || _a === void 0 ? void 0 : _a.toUpperCase();
        if (option == null)
            return false;
        // 如果当前输入的选项在候选中不存在，则视为无效
        let options = this.node.graph.cache.optionsCanSwitch;
        if (!options.map(item => item.option.toUpperCase()).includes(option)) {
            // console.log("输入选项无效");
            return false;
        }
        this.node.graph.cache.inputOption = event.data.toUpperCase();
        this.node.graph.cache.optionsCanSwitch = [];
        return true;
    }
}/**
 * 文本输入
 */
class EventHandlerTextInput extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventText();
        this.needEventOnce = true;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(event) {
        if (event.cmd != this.needEvent.cmd)
            return false;
        this.node.graph.cache.data['text'] = event.data;
        return true;
    }
}class EventGraphCopy extends EventGraphBase {
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerConfirm);
        const node3 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node4 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node5 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node6 = new EventGraphNode(this, EventHandlerCapture);
        const node7 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node8 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node9 = new EventGraphNodeSwitch(this, () => {
            if (this.checkSelectPrimitives()) {
                return [1];
            }
            return [0];
        });
        const node10 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定基点或指定批量复制方式", option: 'S', inputTypes: [PythaEventName.POINTER_DOWN] },
                { type: NeedInputEnum.OPTION, description: "直线批量复制", option: 'L' },
                { type: NeedInputEnum.OPTION, description: "环形批量复制", option: 'C' },
            ]
        });
        const node11 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "请选择对象", option: 'SELECT', inputTypes: [PythaEventName.POINTER_DOWN] },
            ]
        });
        const node13 = new EventGraphNodeSwitch(this, () => {
            if (this.checkSelectPrimitives()) {
                return [1];
            }
            return [0];
        });
        const node14 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                    type: NeedInputEnum.ACTIVE,
                    description: "指定第二点",
                    option: 'E',
                    inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER]
                }]
        });
        const node16 = new EventGraphNode(this, EventHandlerCalTempMoveObj);
        const node18 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node19 = new EventGraphNodeRender(this, false, UpdateType.TEMP);
        const node20 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node21 = new EventGraphNode(this, EventHandlerGrid);
        const node23 = new EventGraphNode(this, EventHandlerHelpLine);
        const node24 = new EventGraphNode(this, EventHandlerCalCopyPosition);
        const node26 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node27 = new EventGraphNode(this, EventHandlerDisableClamp);
        const node28 = new EventGraphNode(this, EventHandlerInitCapture);
        const node29 = new EventGraphNode(this, EHChangePickCursor);
        const node30 = new EventGraphNode(this, EHChangeCrossCursor);
        const node31 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        const node32 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node33 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "输入图元间隔，例：100,100或100*2", option: 'D', inputTypes: [PythaEventName.TEXT] },
            ]
        });
        const node34 = new EventGraphNode(this, EventHandlerOptionInput);
        const node35 = new EventGraphNode(this, EventHandlerTextInput);
        const node38 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定基点", option: 'S', inputTypes: [PythaEventName.POINTER_DOWN] },
            ]
        });
        const node41 = new EventGraphNodeSwitch(this, () => {
            if (!!this.cache.inputOption && this.cache.inputOption === 'C') {
                return [1];
            }
            else {
                return [0];
            }
        });
        const node42 = new EventGraphNode(this, EventHandlerConfirm);
        const node43 = new EventGraphNode(this, EventHandlerNumberInput);
        const node44 = new EventGraphNodeSwitch(this, () => {
            if (this.cache.inputOption === 'C') {
                return [1];
            }
            else {
                return [0];
            }
        });
        const node45 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "输入图元复制角度，例：30,30或30*2", option: 'D', inputTypes: [PythaEventName.TEXT] },
            ]
        });
        this.addEdge(node11, node2);
        this.addEdge(node2, node13);
        /**未选中图元*/
        this.addEdge(node13, node3);
        this.addEdge(node10, node4);
        this.addEdge(node5, node6);
        this.addEdge(node14, node7);
        this.addEdge(node21, node18);
        this.addEdge(node24, node20);
        this.addEdge(node26, node16);
        this.addEdge(node7, node24);
        this.addEdge(node1, node27);
        this.addEdge(node27, node9);
        this.addEdge(node8, node28);
        this.addEdge(node9, node29);
        this.addEdge(node29, node11);
        this.addEdge(node28, node30);
        this.addEdge(node30, node10);
        this.addEdge(node6, node26);
        this.addEdge(node16, node23);
        this.addEdge(node23, node19);
        this.addEdge(node4, node16);
        this.addEdge(node28, node5);
        this.addEdge(node31, node14);
        this.addEdge(node20, node32);
        this.addEdge(node32, node21);
        this.addEdge(node10, node34);
        this.addEdge(node33, node35);
        this.addEdge(node35, node38);
        this.addEdge(node38, node4);
        this.addEdge(node4, node41);
        /**未选择或选择直线复制*/
        this.addEdge(node41, node31);
        this.addEdge(node18, node14);
        this.addEdge(node28, node42);
        this.addEdge(node42, node3);
        this.addEdge(node14, node43);
        this.addEdge(node43, node24);
        this.addEdge(node34, node44);
        this.addEdge(node44, node33);
        this.addEdge(node45, node35);
        /**已经选中图元*/
        this.addEdge(node9, node8);
        /**已经选中图元*/
        this.addEdge(node13, node8);
        /**选择了环形复制*/
        this.addEdge(node41, node24);
        this.addEdge(node44, node45);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/99
    }
    checkSelectPrimitives() {
        if (PythaStorage.instance.selectStore.selectPrimitives.length > 0) {
            return true;
        }
        return false;
    }
}
/**
 * COPY指令 用于注册事件图
 */
EventGraphCopy.cmd = 'COPY';class EventHandlerCalTempLine extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        // 渲染临时线
        // if (this.node.graph.cache.pointerMove?.point) {
        //     (this.node.graph.cache['line'] as Line).end = this.node.graph.cache.pointerMove.point;//不需要克隆
        // }
        const line = this.node.graph.cache['line'];
        if (line == null)
            return false;
        if (this.node.graph.cache.inputNumber["N"]) {
            //如果拥有了数值输入，数值输入为直线段的长度，更新直线段长度
            let length = this.node.graph.cache.inputNumber["N"];
            if (Math.abs(length) < 1e-6) {
                //如果直线段长度过短，则不设置
                return true;
            }
            let currentLength = line.scaleX;
            let scale; //新的直线段长度
            if (currentLength < 1e-6) {
                scale = 1;
            }
            else {
                scale = length / currentLength;
            }
            line.transformMatrix.elements[0] *= scale;
            line.transformMatrix.elements[1] *= scale;
            line.transformMatrix.elements[2] *= scale;
            this.node.graph.cache.inputNumber["N"] = null; //处理了数值输入的长度后，将数值输入清空（避免影响后续的移动）
            //保持点的数量一致
            let pointer = new Pointer();
            pointer.point = line.end.clone();
            this.node.graph.cache.orthoPolarBasePoint = pointer.point;
            this.node.graph.cache.pointerDownList.push(pointer);
        }
        else {
            if (!!this.node.graph.cache.data['isPointDown'] && this.node.graph.cache.pointerDownList.length > 0) {
                // 按下点或输入点
                let pd = this.node.graph.cache.pointerDownList[this.node.graph.cache.pointerDownList.length - 1].point;
                line.end = pd;
                this.node.graph.cache.data['isPointDown'] = false;
            }
            else {
                line.end = this.node.graph.cache.pointerMove.point;
            }
        }
        this.node.graph.cache['primitive'].needRedraw = true;
        //显示长度
        this.getPythaStorage().coordinateStore.showLength = line.scaleX;
        return true;
    }
    /**
     * 销毁
     */
    dispose() {
        this.getPythaStorage().coordinateStore.showLength = 0;
    }
}/**
 * 图元类型标识
 */
const PrimitiveType = {
    /**
     * 圆弧
     */
    Arc: 'Arc',
    /**
     * 块
     */
    Block: 'Block',
    /**
     * 立方体
     */
    Box: 'Box',
    /**
     * 圆
     */
    Circle: 'Circle',
    /**
     * 圆锥
     */
    Cone: 'Cone',
    /**
     * 拉伸体
     */
    ExtrudeSoild: 'ExtrudeSoild',
    /**
     * 拉伸面
     */
    ExtrudeSurface: 'ExtrudeSurface',
    /**
     * 直线
     */
    Line: 'Line',
    /**
     * 多段线
     */
    Pline: 'Pline',
    /**
     * 棱锥
     */
    Pyramid: 'Pyramid',
    /**
     * 矩形
     */
    Rect: 'Rect',
    /**
     * 旋转体
     */
    RevolveSolid: 'RevolveSolid',
    /**
     * 旋转面
     */
    RevolveSurface: 'RevolveSurface',
    /**
     * 球体
     */
    Sphere: 'Sphere',
    /**
     * 圆环体
     */
    Torus: 'Torus',
    /**
     * 椭圆
     */
    Ellipse: "Ellipse",
    /**
     * 面域
     */
    RegionFace: "RegionFace",
    /**
     * 多边形
     */
    Polygon: "Polygon"
};/**
 * 生成线特殊处理器
 */
class EHGenLine extends EventHandlerBase {
    constructor() {
        super(...arguments);
        /**
         * 生成线图元的type 默认为Line
         */
        this.lineType = PrimitiveType.Line;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a;
        const storage = PythaStorage.instance;
        //获取当前点
        const pointerDownList = this.node.graph.cache.pointerDownList;
        if (pointerDownList.length < 1)
            return false;
        //新建图元
        let primitive = new Primitive(this.lineType);
        //根据坐标点新建几何线
        let pointer = pointerDownList[pointerDownList.length - 1];
        let end = storage.coordinateStore.currentPos;
        if (storage.orthoPolarStore.orthoPolarPoint) {
            end = storage.orthoPolarStore.orthoPolarPoint;
        }
        let line = new Line$2(pointer.point, end);
        //将图元与几何线绑定
        primitive.temporary = true;
        primitive.geos.push(line);
        let keys = Object.keys(primitive.renderItemDict);
        if (keys.length > 0) {
            let renderItem = primitive.renderItemDict[keys[0]];
            renderItem.geoElements = line.getGeoElementsIdxList();
            (_a = renderItem.mat) === null || _a === void 0 ? void 0 : _a.color.set(storage.layerStore.getColor());
        }
        //将线存入图的缓存区
        this.node.graph.cache['line'] = line; // geo 放入缓存 方便计算调用
        this.node.graph.cache['primitive'] = primitive;
        this.node.graph.cache.data['isPointDown'] = false;
        //将线存入临时图元中
        storage.primitiveStore.tempPrimitiveDict[primitive.uuid] = primitive;
        this.node.graph.cache.primitiveList = [primitive];
        return true;
    }
}/**
 * 绘制线
 */
class EventGraphLine extends EventGraphBase {
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node3 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node4 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定下一点", inputTypes: [PythaEventName.POINTER_DOWN] },
            ] });
        const node5 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node8 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node9 = new EventGraphNode(this, EventHandlerConfirm);
        const node10 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node11 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node12 = new EventGraphNode(this, EventHandlerCapture);
        const node14 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node15 = new EventGraphNode(this, EventHandlerCalTempLine);
        const node16 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node17 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定第一点", option: 'S', inputTypes: [PythaEventName.POINTER_DOWN] },
            ] });
        const node18 = new EventGraphNode(this, EventHandlerCalTempLine);
        const node19 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node21 = new EventGraphNode(this, EventHandlerNumberInput);
        const node22 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                {
                    type: NeedInputEnum.ACTIVE, description: "指定下一点", option: "N", inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER]
                }
            ] });
        const node24 = new EventGraphNode(this, EventHandlerGrid);
        const node25 = new EventGraphNode(this, EventHandlerGrid);
        const node27 = new EventGraphNode(this, EHGenLine);
        const node28 = new EventGraphNode(this, EHChangeCrossCursor);
        const node29 = new EventGraphNode(this, EventHandlerInitCapture);
        const node31 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node32 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        const node33 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        const node34 = new EventGraphNode(this, EventHandlerInitCapture);
        this.addEdge(node9, node10);
        this.addEdge(node11, node12);
        this.addEdge(node14, node15);
        this.addEdge(node3, node4);
        this.addEdge(node18, node19);
        this.addEdge(node1, node2);
        this.addEdge(node22, node21);
        this.addEdge(node22, node5);
        this.addEdge(node21, node18);
        this.addEdge(node15, node24);
        this.addEdge(node24, node16);
        this.addEdge(node25, node8);
        this.addEdge(node27, node22);
        this.addEdge(node2, node28);
        this.addEdge(node1, node29);
        this.addEdge(node19, node31);
        this.addEdge(node32, node27);
        this.addEdge(node5, node33);
        this.addEdge(node33, node18);
        this.addEdge(node4, node32);
        this.addEdge(node29, node11);
        this.addEdge(node1, node9);
        this.addEdge(node28, node17);
        this.addEdge(node17, node3);
        this.addEdge(node31, node34);
        this.addEdge(node34, node25);
        this.addEdge(node8, node27);
        this.addEdge(node12, node14);
        this.addEdge(node27, node14);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/74
    }
}
/**
 * line指令 用于注册事件图
 */
EventGraphLine.cmd = 'LINE';/**
 * 平移处理器
 */
class EventHandlerPan extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.panSpeed = 1;
        this.screenSpacePanning = true;
        const storage = PythaStorage.instance;
        const viewportStore = storage.viewportStore;
        this.viewportStore = viewportStore;
        let domElement = viewportStore.renderer.domElement;
        this.domElement = domElement;
    }
    run(data = {}) {
        var _a, _b, _c;
        // 1.获取相机对象
        const camera = (_a = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        if (camera == null) {
            return false;
        }
        // 2.计算相机偏移量
        if (!this.node.graph.cache.data.startPoint) {
            const pointerDownList = this.node.graph.cache.pointerDownList;
            if (pointerDownList.length <= 0)
                return false;
            let downPointer = pointerDownList[pointerDownList.length - 1];
            let pointDown2 = downPointer.point2;
            this.node.graph.cache.data.startPoint = new Vector2().copy(pointDown2);
        }
        if (!((_b = this.node.graph.cache.pointerMove) === null || _b === void 0 ? void 0 : _b.point))
            return false;
        let pointMove2 = this.node.graph.cache.pointerMove.point2;
        // 3.计算平移距离
        let _pointerDelta = new Vector2();
        _pointerDelta.subVectors(pointMove2, this.node.graph.cache.data.startPoint);
        let deltaX = _pointerDelta.x * this.panSpeed;
        let deltaY = _pointerDelta.y * this.panSpeed;
        let element = this.domElement;
        let offset = new Vector3();
        let target = (_c = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _c === void 0 ? void 0 : _c.target;
        let position = camera.position;
        offset.copy(position).sub(target);
        const isOrthographic = camera.type === 'OrthographicCamera';
        const isPerspective = camera.type === 'PerspectiveCamera';
        let distanceX;
        let distanceY;
        if (isOrthographic) { // 如果相机类型为正交相机
            let orthoCamera = camera;
            distanceX = deltaX * (orthoCamera.right - orthoCamera.left) / orthoCamera.zoom / element.clientWidth;
            distanceY = deltaY * (orthoCamera.top - orthoCamera.bottom) / orthoCamera.zoom / element.clientHeight;
        }
        else if (isPerspective) { // 如果相机类型为透视相机
            let persCamera = camera;
            let targetDistance = offset.length();
            targetDistance *= Math.tan((persCamera.fov / 2) * Math.PI / 180.0);
            distanceX = 2 * deltaX * targetDistance / element.clientHeight;
            distanceY = 2 * deltaY * targetDistance / element.clientHeight;
        }
        // 4.获取相机矩阵
        const cameraMatrix = camera.matrix;
        // 5.沿X、Y平移相机位置
        let panOffset = new Vector3();
        let v = new Vector3();
        // 5.1横向平移
        v.setFromMatrixColumn(cameraMatrix, 0);
        v.multiplyScalar(-distanceX);
        panOffset.add(v);
        // 5.2纵向平移
        if (this.screenSpacePanning) {
            v.setFromMatrixColumn(cameraMatrix, 1);
        }
        else {
            v.setFromMatrixColumn(cameraMatrix, 0);
            v.crossVectors(camera.up, v);
        }
        v.multiplyScalar(distanceY);
        panOffset.add(v);
        // 6.修改相机target
        target.add(panOffset);
        position.copy(target).add(offset);
        camera.lookAt(target.clone());
        camera.position.copy(position.clone());
        this.viewportStore.viewportItems[this.viewportStore.currentViewportKey].target.copy(target.clone());
        // 7.更新相机矩阵
        if (isOrthographic) {
            camera.updateMatrixWorld();
            camera.updateProjectionMatrix();
        }
        else if (isPerspective) {
            camera.updateMatrixWorld();
        }
        // 8.更新缩放中心 
        // this.updateZoomCenter(pointMove2);
        // updateZoomCenter(this.domElement, pointMove2);
        this.node.graph.cache.data.startPoint.copy(pointMove2);
        return true;
    }
}/**
 * 显示平移光标
 */
class EventHandlerShowPanCursor extends EventHandlerBase {
    run(event) {
        // 获取存储
        const storage = PythaStorage.instance;
        storage.cursorStore.hiddenCursor = true;
        let color = storage.viewportStore.background;
        if (this.isDarkColor(this.hexToRgb(color))) {
            storage.viewportStore.renderer.domElement.style.cursor = "url('data:image/svg+xml;base64,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') 16 16, auto";
        }
        else {
            storage.viewportStore.renderer.domElement.style.cursor = "url(data:image/svg+xml;base64,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) 16 16, auto";
        }
        return true;
    }
    isDarkColor(rgb) {
        // 解构 RGB 值
        const [r, g, b] = rgb;
        // 根据公式计算亮度
        const brightness = 0.299 * r + 0.587 * g + 0.114 * b;
        // 判断颜色是否为深色
        return brightness < 128;
    }
    hexToRgb(hex) {
        // 将 #RRGGBB 转换为 RGB 数组
        const bigint = parseInt(hex.slice(1), 16);
        return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
    }
}class EventGraphPan extends EventGraphBase {
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerCalPointerDown);
        node2.needExtraFuncOnHandlerActive = (handler) => {
            handler.set("buttonTypes", [MOUSE_BUTTON.LEFT, MOUSE_BUTTON.MIDDLE]);
        };
        const node4 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node5 = new EventGraphNode(this, EventHandlerCalPointerUp);
        const node6 = new EventGraphNode(this, EventHandlerPan);
        const node7 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        const node8 = new EventGraphNode(this, EventHandlerDisablePan);
        const node9 = new EventGraphNode(this, EventHandlerDisable3do);
        const node10 = new EventGraphNode(this, EventHandlerConfirm);
        const node11 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node12 = new EventGraphNode(this, EventHandler3doStart);
        const node13 = new EventGraphNode(this, EventHandlerPanStart);
        const node14 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node15 = new EventGraphNode(this, EventHandlerSelectStart);
        const node17 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node19 = new EventGraphNodeRender(this, true, UpdateType.MAIN);
        const node20 = new EventGraphNode(this, null);
        const node21 = new EventGraphNode(this, EventHandlerShowPanCursor);
        const node22 = new EventGraphNodeNotice(this, {
            cmd: 'data_change', data: {
                viewChangeStart: true
            }
        });
        const node23 = new EventGraphNodeNotice(this, {
            cmd: 'data_change', data: {
                viewChangeEnd: true
            }
        });
        this.addEdge(node1, node2);
        this.addEdge(node4, node6);
        this.addEdge(node1, node10);
        this.addEdge(node5, node4, EDGE_TYPE.STOP);
        this.addEdge(node5, node1);
        this.addEdge(node10, node13);
        this.addEdge(node13, node12);
        this.addEdge(node2, node5);
        this.addEdge(node1, node14);
        this.addEdge(node12, node15);
        this.addEdge(node15, node11);
        this.addEdge(node7, node20);
        this.addEdge(node20, node17);
        this.addEdge(node17, node19);
        this.addEdge(node6, node7);
        this.addEdge(node14, node21);
        this.addEdge(node21, node9);
        this.addEdge(node9, node8);
        this.addEdge(node2, node22);
        this.addEdge(node22, node4);
        this.addEdge(node5, node23);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/67
    }
    end() {
        this.status = GRAPH_STATUS.NONE;
        for (const [_, node] of this.graph) {
            node.dispose();
        }
        this.eventMediator = undefined;
        this.head = null;
        // 清空缓存
        this.cleanCache();
        // this.cache.pointerDownList = [];
        // this.cache.pointerUpList = [];
        // this.cache.pointerMove = new Pointer();
        // this.cache.lastPointerMove = undefined;
        // this.cache.primitiveList = [];
        // this.cache.pointerWheel = new Pointer();
        // this.cache.data = {};
        // this.cache.inputNumber = undefined;
        delete this.hangUpNodesOnce;
        delete this.hangupNodes;
        delete this.graph;
        // 开启原生平移和旋转
        const viewportStore = PythaStorage.instance.viewportStore;
        viewportStore.enabledPan = true;
        viewportStore.enabled3do = true;
        // 开启选择
        const selectStore = PythaStorage.instance.selectStore;
        selectStore.enabled = true;
    }
}
/**
 * pan指令 平移视图控制器图
 */
EventGraphPan.cmd = 'PAN';// import { Point2 } from "tnbase";
/**
 * 结束命令处理器
 */
class EventHandlerView3do extends EventHandlerBase {
    // private _rotateCenter: Vector3 = new Vector3();
    constructor(node) {
        super(node);
        this.rotateSpeed = 1;
        this._target = new Vector3();
        const storage = PythaStorage.instance;
        this.storage = storage;
        const viewportStore = storage.viewportStore;
        this.viewportStore = viewportStore;
        let domElement = viewportStore.renderer.domElement;
        this.domElement = domElement;
    }
    run(data = {}) {
        var _a, _b, _c, _d, _e, _f;
        if (!this.viewportStore.enabled3do)
            return false;
        const camera = (_a = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        if (camera == null) {
            return false;
        }
        if (!this.node.graph.cache.data.startPoint) {
            const pointerDownList = this.node.graph.cache.pointerDownList;
            if (pointerDownList.length <= 0)
                return false;
            let downPointer = pointerDownList[pointerDownList.length - 1];
            if (downPointer.button !== MOUSE_BUTTON.MIDDLE || !downPointer.shiftKey)
                return false;
            let pointDown2 = downPointer.point2;
            this.node.graph.cache.data.startPoint = new Vector2().copy(pointDown2);
        }
        if (!((_b = this.node.graph.cache.pointerMove) === null || _b === void 0 ? void 0 : _b.point2))
            return false;
        let pointMove2 = this.node.graph.cache.pointerMove.point2;
        // 计算鼠标移动delta
        let _pointerDelta = new Vector2();
        _pointerDelta.subVectors(pointMove2, this.node.graph.cache.data.startPoint);
        // 修改相机up
        camera.up.set(0, 0, 1);
        // 初始化旋转四元数及其逆矩阵
        let _quat = new Quaternion().setFromUnitVectors(camera.up, new Vector3(0, 1, 0)); // 这个可能需要变成缓存对象
        let _quatInverse = _quat.clone().invert(); // 这个可能需要变成缓存对象
        // 重新设置当前UCS工作平面
        this.storage.coordinateStore.resetWorkPlane();
        // 初始化旋转角度和球坐标系
        let theta_delta = -2 * Math.PI * _pointerDelta.x * this.rotateSpeed / this.domElement.clientHeight;
        let phi_delta = -2 * Math.PI * _pointerDelta.y * this.rotateSpeed / this.domElement.clientHeight;
        let spherical = new Spherical();
        const position = camera.position;
        let rotateCenter = this.node.graph.cache.data["rotateCenter"];
        if (!rotateCenter)
            return false;
        this._target.copy((_c = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _c === void 0 ? void 0 : _c.target);
        this.updateTarget(rotateCenter);
        // 计算相机偏移量
        let offset = new Vector3();
        offset.copy(position).sub((_d = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _d === void 0 ? void 0 : _d.target);
        // 设置旋转轴
        let rotateAxis1 = camera.up.clone().normalize();
        let rotateAxis2 = camera.up.clone().cross(offset).normalize();
        // 变换参考系（笛卡尔->球）
        offset.applyQuaternion(_quat);
        // 球坐标系下计算
        spherical.setFromVector3(offset);
        let last_theta = spherical.theta;
        let last_phi = spherical.phi;
        spherical.theta += theta_delta;
        spherical.phi += phi_delta;
        spherical.makeSafe();
        theta_delta = spherical.theta - last_theta;
        phi_delta = spherical.phi - last_phi;
        // 转回笛卡尔坐标系
        offset.setFromSpherical(spherical);
        offset.applyQuaternion(_quatInverse);
        // 更新相机positon
        position.copy((_e = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _e === void 0 ? void 0 : _e.target).add(offset);
        camera.lookAt((_f = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _f === void 0 ? void 0 : _f.target);
        // 更新相机target
        let _oq = new Quaternion().setFromAxisAngle(rotateAxis1, theta_delta).multiply(new Quaternion().setFromAxisAngle(rotateAxis2, phi_delta));
        // let v1 = this._target.clone().sub(this.viewportStore.getEntityViewCenter().clone()); // TODO 旋转中心
        let v1 = this._target.clone().sub(rotateCenter); // TODO 旋转中心
        v1.applyQuaternion(_oq);
        // let new_target = this.viewportStore.getEntityViewCenter().clone().add(v1); // TODO 旋转中心
        let new_target = rotateCenter.clone().add(v1); // TODO 旋转中心
        this.updateTarget(new_target); // TODO 修改target
        // this.updateZoomCenter(pointMove2);
        // updateZoomCenter(this.domElement, pointMove2);
        this.node.graph.cache.data.startPoint.copy(pointMove2);
        return true;
    }
    updateTarget(v) {
        var _a;
        const camera = (_a = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        const position = camera.position;
        let offset = position.clone().sub(this.viewportStore.viewportItems[this.viewportStore.currentViewportKey].target);
        this.viewportStore.viewportItems[this.viewportStore.currentViewportKey].target.set(v.x, v.y, v.z);
        position.copy(this.viewportStore.viewportItems[this.viewportStore.currentViewportKey].target).add(offset);
        camera.updateMatrixWorld();
        if (camera && (camera.type === 'OrthographicCamera' || camera.type === 'PerspectiveCamera')) {
            camera.updateProjectionMatrix();
        }
    }
}/**
 * 显示光标
 */
class EventHandlerShowDefaultCursor extends EventHandlerBase {
    run(event) {
        // 获取存储
        const storage = PythaStorage.instance;
        storage.cursorStore.hiddenCursor = !storage.cursorStore.cursorShow;
        if (!storage.cursorStore.hiddenCursor) {
            storage.viewportStore.renderer.domElement.style.cursor = "none";
        }
        else {
            storage.viewportStore.renderer.domElement.style.cursor = "default";
        }
        // 找到光标
        let cursor = storage.cursorStore.cursors[storage.cursorStore.currentCursorType];
        if (cursor == null) {
            return true;
        }
        // 显示光标
        if (!cursor.obj.parent && !storage.cursorStore.hiddenCursor) {
            storage.viewportStore.scene.add(cursor.obj); // 显示标签
        }
        return true;
    }
}// import { Pointer } from "../../declare/interface/PythaEvent";
class EventGraphView3do extends EventGraphBase {
    constructor() {
        super(...arguments);
        /**
         * 是否是常驻图
         */
        this.isAlwaysActive = true;
    }
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerCalPointerDown);
        node2.needExtraFuncOnHandlerActive = (handler) => {
            handler.set("buttonTypes", [MOUSE_BUTTON.MIDDLE]);
        };
        const node4 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node5 = new EventGraphNode(this, EventHandlerView3do);
        const node6 = new EventGraphNode(this, EventHandlerCalPointerUp);
        const node9 = new EventGraphNodeSwitch(this, () => {
            const downPointer = this.cache.pointerDownList[this.cache.pointerDownList.length - 1];
            if (downPointer.button === MOUSE_BUTTON.MIDDLE && downPointer.shiftKey) {
                return [1, 2];
            }
            else {
                return [0];
            }
        });
        const node10 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        const node11 = new EventGraphNode(this, EventHandlerShowRotateCenter);
        const node12 = new EventGraphNode(this, EventHandlerHideRotateCenter);
        const node13 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node14 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node16 = new EventGraphNodeTimer(this, null);
        const node17 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node18 = new EventGraphNodeRender(this, true, UpdateType.MAIN);
        const node20 = new EventGraphNode(this, EventHandlerShowRotateCursor);
        const node21 = new EventGraphNode(this, EventHandlerShowDefaultCursor);
        const node22 = new EventGraphNodeNotice(this, {
            cmd: 'data_change', data: {
                viewChangeStart: true
            }
        });
        const node23 = new EventGraphNodeNotice(this, {
            cmd: 'data_change', data: {
                viewChangeEnd: true
            }
        });
        this.addEdge(node1, node2);
        this.addEdge(node4, node5);
        this.addEdge(node6, node4, EDGE_TYPE.STOP);
        /**没有同时按下鼠标中键和Shift*/
        this.addEdge(node9, node1);
        this.addEdge(node12, node1);
        this.addEdge(node12, node13);
        this.addEdge(node2, node9);
        this.addEdge(node10, node16);
        this.addEdge(node16, node17);
        this.addEdge(node5, node10);
        this.addEdge(node11, node20);
        this.addEdge(node20, node14);
        this.addEdge(node14, node4);
        this.addEdge(node6, node21);
        this.addEdge(node21, node12);
        this.addEdge(node17, node18);
        this.addEdge(node11, node22);
        this.addEdge(node6, node23);
        this.addEdge(node9, node6);
        this.addEdge(node9, node11);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/68
    }
    /**
    * 结束图
    */
    end() {
        // 清空缓存
        this.cleanCache();
        // this.cache.pointerDownList = [];
        // this.cache.pointerUpList = [];
        // this.cache.pointerMove = new Pointer();
        // this.cache.lastPointerMove = undefined;
        // this.cache.primitiveList = [];
        // this.cache.pointerWheel = new Pointer();
        // this.cache.data = {};
        // this.cache.inputNumber = undefined;
        this.head.run();
    }
}
/**
 * view3do指令 常驻旋转视图
 */
EventGraphView3do.cmd = 'VIEW3DO';// import { Point2 } from "tnbase";
/**
 * 结束命令处理器
 */
class EventHandlerViewPan extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.panSpeed = 1;
        this.screenSpacePanning = true;
        const storage = PythaStorage.instance;
        const viewportStore = storage.viewportStore;
        this.viewportStore = viewportStore;
        let domElement = viewportStore.renderer.domElement;
        this.domElement = domElement;
    }
    run(data = {}) {
        var _a, _b, _c;
        if (!this.viewportStore.enabledPan)
            return false;
        // 1.获取相机对象
        const camera = (_a = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        if (camera == null) {
            return false;
        }
        // 2.计算相机偏移量
        if (!this.node.graph.cache.data.startPoint) {
            const pointerDownList = this.node.graph.cache.pointerDownList;
            if (pointerDownList.length <= 0)
                return false;
            let downPointer = pointerDownList[pointerDownList.length - 1];
            if (downPointer.button !== MOUSE_BUTTON.MIDDLE)
                return false;
            let pointDown2 = downPointer.point2;
            this.node.graph.cache.data.startPoint = new Vector2().copy(pointDown2);
        }
        if (!((_b = this.node.graph.cache.pointerMove) === null || _b === void 0 ? void 0 : _b.point))
            return false;
        let pointMove2 = this.node.graph.cache.pointerMove.point2;
        // 3.计算平移距离
        let _pointerDelta = new Vector2();
        _pointerDelta.subVectors(pointMove2, this.node.graph.cache.data.startPoint);
        let deltaX = _pointerDelta.x * this.panSpeed;
        let deltaY = _pointerDelta.y * this.panSpeed;
        let element = this.domElement;
        let offset = new Vector3();
        let target = (_c = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _c === void 0 ? void 0 : _c.target;
        let position = camera.position;
        offset.copy(position).sub(target);
        const isOrthographic = camera.type === 'OrthographicCamera';
        const isPerspective = camera.type === 'PerspectiveCamera';
        let distanceX;
        let distanceY;
        if (isOrthographic) { // 如果相机类型为正交相机
            let orthoCamera = camera;
            distanceX = deltaX * (orthoCamera.right - orthoCamera.left) / orthoCamera.zoom / element.clientWidth;
            distanceY = deltaY * (orthoCamera.top - orthoCamera.bottom) / orthoCamera.zoom / element.clientHeight;
        }
        else if (isPerspective) { // 如果相机类型为透视相机
            let persCamera = camera;
            let targetDistance = offset.length();
            targetDistance *= Math.tan((persCamera.fov / 2) * Math.PI / 180.0);
            distanceX = 2 * deltaX * targetDistance / element.clientHeight;
            distanceY = 2 * deltaY * targetDistance / element.clientHeight;
        }
        // 4.获取相机矩阵
        const cameraMatrix = camera.matrix;
        // 5.沿X、Y平移相机位置
        let panOffset = new Vector3();
        let v = new Vector3();
        // 5.1横向平移
        v.setFromMatrixColumn(cameraMatrix, 0);
        v.multiplyScalar(-distanceX);
        panOffset.add(v);
        // 5.2纵向平移
        if (this.screenSpacePanning) {
            v.setFromMatrixColumn(cameraMatrix, 1);
        }
        else {
            v.setFromMatrixColumn(cameraMatrix, 0);
            v.crossVectors(camera.up, v);
        }
        v.multiplyScalar(distanceY);
        panOffset.add(v);
        // 6.修改相机target
        target.add(panOffset);
        position.copy(target).add(offset);
        camera.lookAt(target.clone());
        camera.position.copy(position.clone());
        this.viewportStore.viewportItems[this.viewportStore.currentViewportKey].target.copy(target.clone());
        // 7.更新相机矩阵
        if (isOrthographic) {
            camera.updateMatrixWorld();
            camera.updateProjectionMatrix();
        }
        else if (isPerspective) {
            camera.updateMatrixWorld();
        }
        // 8.更新缩放中心 
        // this.updateZoomCenter(pointMove2);
        // updateZoomCenter(this.domElement, pointMove2);
        this.node.graph.cache.data.startPoint.copy(pointMove2);
        return true;
    }
}// import { Pointer } from "../../declare/interface/PythaEvent";
class EventGraphViewPan extends EventGraphBase {
    constructor() {
        super(...arguments);
        /**
         * 是否是常驻图
         */
        this.isAlwaysActive = true;
    }
    generate() {
        const node2 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node3 = new EventGraphNode(this, EventHandlerStart);
        const node4 = new EventGraphNode(this, EventHandlerCalPointerDown);
        node4.needExtraFuncOnHandlerActive = (handler) => {
            handler.set("buttonTypes", [MOUSE_BUTTON.MIDDLE]);
        };
        const node5 = new EventGraphNode(this, EventHandlerViewPan);
        const node6 = new EventGraphNode(this, EventHandlerCalPointerUp);
        const node7 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        const node9 = new EventGraphNodeSwitch(this, () => {
            const downPointer = this.cache.pointerDownList[this.cache.pointerDownList.length - 1];
            if (downPointer.button === MOUSE_BUTTON.MIDDLE && !downPointer.shiftKey) {
                return [1, 2];
            }
            else {
                return [0];
            }
        });
        const node11 = new EventGraphNodeTimer(this, null);
        const node12 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node13 = new EventGraphNodeRender(this, true, UpdateType.MAIN);
        const node14 = new EventGraphNode(this, EventHandlerGrid);
        const node15 = new EventGraphNode(this, EventHandlerShowPanCursor);
        const node16 = new EventGraphNode(this, EventHandlerShowDefaultCursor);
        const node17 = new EventGraphNodeNotice(this, {
            cmd: 'data_change', data: {
                viewChangeStart: true
            }
        });
        const node18 = new EventGraphNodeNotice(this, {
            cmd: 'data_change', data: {
                viewChangeEnd: true
            }
        });
        this.addEdge(node3, node4);
        this.addEdge(node4, node9);
        /**不是中键按下或者按下了Shift*/
        this.addEdge(node9, node3);
        this.addEdge(node2, node5);
        this.addEdge(node6, node2, EDGE_TYPE.STOP);
        this.addEdge(node7, node11);
        this.addEdge(node11, node12);
        this.addEdge(node14, node13);
        this.addEdge(node5, node7);
        this.addEdge(node15, node2);
        this.addEdge(node6, node16);
        this.addEdge(node16, node3);
        this.addEdge(node12, node14);
        this.addEdge(node15, node17);
        this.addEdge(node6, node18);
        this.addEdge(node9, node15);
        this.addEdge(node9, node6);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node3];
        this.head = node3;
        // https://event.graph.tncet.com/graphs/35
    }
    /**
    * 结束图（平移是常驻图）
    */
    end() {
        // 清空缓存
        this.cleanCache();
        // this.cache.pointerDownList = [];
        // this.cache.pointerUpList = [];
        // this.cache.pointerMove = new Pointer();
        // this.cache.lastPointerMove = undefined;
        // this.cache.primitiveList = [];
        // this.cache.pointerWheel = new Pointer();
        // this.cache.data = {};
        // this.cache.inputNumber = undefined;
        this.head.run();
    }
}
/**
 * viewpan指令 常驻平移视图
 */
EventGraphViewPan.cmd = 'VIEWPAN';/**
 * 鼠标滚轮处理器
 */
class EventHandlerMouseWheel extends EventHandlerBase {
    constructor(node) {
        super(node);
        /**
         * 正交相机缩放速率
         */
        this.oZoomSpeed = 2.0;
        /**
         * 透视相机缩放速率
         */
        this.pZoomSpeed = 0.5;
        this.needEvent = new PythaEventMouseWheel();
        this.needEventOnce = false;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(event) {
        var _a, _b;
        if (event.cmd != this.needEvent.cmd)
            return false;
        const storage = PythaStorage.instance;
        // 获取相机对象
        const viewportStore = storage.viewportStore;
        const camera = (_a = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        if (camera == null) {
            return false;
        }
        // 计算缩放比例
        const speed = camera.type === 'OrthographicCamera' ? this.oZoomSpeed : this.pZoomSpeed;
        let zoomScale = Math.round(Math.pow(0.92, speed) * 100) / 100;
        let delta = event.data.deltaY;
        if (delta < 0) {
            // zoomIn 放大
            zoomScale = 1 / zoomScale;
        }
        if (((_b = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _b === void 0 ? void 0 : _b.cameraEdge) < viewportStore.minCameraEdge && zoomScale > 1) {
            zoomScale = 1;
        }
        this.node.graph.cache.data['zoomScale'] = zoomScale;
        if (event.data.id != storage.coordinateStore.wheelEventKey) {
            viewportStore.viewportItems[viewportStore.currentViewportKey].cameraEdge /= zoomScale;
            // 发送zoomchange事件
            let zoomChange = new PythaEventZoomChange();
            zoomChange.data = zoomScale;
            this.node.graph.eventMediator.emitEvent(zoomChange);
            // 存入pointermove编号
            storage.coordinateStore.wheelEventKey = event.data.id;
        }
        this.node.graph.cache.pointerWheel.copy(event.data);
        // 更新坐标点位置
        let mousePos = event.data.point2;
        let rect = viewportStore.getViewportRect(viewportStore.currentViewportKey);
        if (rect == null)
            return false;
        let x = (mousePos.x - rect.x) / rect.width * 2 - 1;
        let y = -(mousePos.y - rect.y) / rect.height * 2 + 1;
        const coordinateStore = storage.coordinateStore;
        coordinateStore.ndcViewportPos2.set(x, y);
        let workPlane = coordinateStore.workPlane;
        if (camera == null)
            return false;
        _rayStart$1.set(x, y, -1).unproject(camera);
        _rayEnd$1.set(x, y, 1).unproject(camera);
        _ray$1.set(_rayStart$1, _rayEnd$1);
        GeoIntersection.LineIntersectPlane(_ray$1, workPlane, _point$6);
        // 将原始三维点存入存储器
        storage.coordinateStore.originalPos.copy(_point$6);
        // 捕捉点位置
        if (storage.captureStore.capturePoint != null) {
            _point$6.copy(storage.captureStore.capturePoint);
        }
        storage.coordinateStore.setCurrentPos(_point$6);
        return true;
    }
}
const _rayStart$1 = new Vector3();
const _rayEnd$1 = new Vector3();
const _ray$1 = new Line$2();
const _point$6 = new Point();class EventHandlerViewZoom extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.oZoomSpeed = 2.0;
        this.pZoomSpeed = 0.5;
        this._perspectiveDir = new Vector3();
        this._cameraLookAt = new Vector3();
        this.handleZoom = (zoomScale, camera) => {
            var _a, _b, _c, _d, _e, _f;
            // 修改相机边界
            if (((_a = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.cameraEdge) < this.viewportStore.minCameraEdge && zoomScale >= 1)
                return;
            let _target = (_b = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _b === void 0 ? void 0 : _b.target.clone();
            if (camera.type === 'OrthographicCamera') {
                // 修改相机参数
                this.updateTarget((_c = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _c === void 0 ? void 0 : _c.zoomCenter);
                let orthoCamera = camera;
                orthoCamera.left = orthoCamera.left / zoomScale;
                orthoCamera.right = orthoCamera.right / zoomScale;
                orthoCamera.top = orthoCamera.top / zoomScale;
                orthoCamera.bottom = orthoCamera.bottom / zoomScale;
                orthoCamera.far = orthoCamera.far / zoomScale;
                // 修改相机矩阵
                orthoCamera.updateProjectionMatrix();
                // 修改相机target
                let v1 = (_d = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _d === void 0 ? void 0 : _d.zoomCenter.clone().sub(_target);
                v1.multiplyScalar(1 / zoomScale);
                let new_target = (_e = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _e === void 0 ? void 0 : _e.zoomCenter.sub(v1);
                this.updateTarget(new_target);
                let dir = (_f = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _f === void 0 ? void 0 : _f.target.clone().sub(orthoCamera.position);
                dir.multiplyScalar(1 / zoomScale);
                orthoCamera.position.copy(new_target).sub(dir);
                orthoCamera.updateProjectionMatrix();
            }
            else if (camera.type === 'PerspectiveCamera') {
                //对于透视相机的视图操作，即平移相机所在点，相机距离物体越近，物体越大
                let persCamera = camera;
                //获取相机目视方向
                persCamera.getWorldDirection(this._cameraLookAt);
                this._perspectiveDir.copy(persCamera.position).sub(this.viewportStore.scene.position);
                //相机目视点平移
                persCamera.position.addScaledVector(this._cameraLookAt, this._perspectiveDir.length() * (zoomScale - 1));
                // 修改相机矩阵
                persCamera.updateProjectionMatrix();
            }
            // 重新计算光标位置
            this.calMousePos(this.node.graph.cache.pointerWheel.point2);
        };
        const storage = PythaStorage.instance;
        const viewportStore = storage.viewportStore;
        this.viewportStore = viewportStore;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a;
        // // 获取相机对象
        const camera = (_a = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        if (camera == null) {
            return false;
        }
        // // 修改缩中心
        // // updateZoomCenter(this.domElement, this.node.graph.cache.pointerWheel.point2);
        // // 计算缩放比例
        // const speed = camera.type === 'OrthographicCamera' ? this.oZoomSpeed : this.pZoomSpeed;
        // let zoomScale = Math.round(Math.pow(0.92, speed) * 100) / 100;
        let zoomScale = this.node.graph.cache.data['zoomScale'] || 1;
        this.handleZoom(zoomScale, camera);
        // let delta = this.node.graph.cache.pointerWheel.deltaY;
        // if (delta < 0) {
        //     // zoomIn 放大
        //     this.handleZoom(1 / zoomScale, camera);
        // } else if (delta > 0) {
        //     // zoomOut 缩小
        //     this.handleZoom(zoomScale, camera);
        // }
        // TODO 光源暂不考虑
        // this.dirLight.position.set(cameraPosition?.x || 10000, cameraPosition?.y || 10000, cameraPosition?.z || 10000)
        // 修改缩中心
        // updateZoomCenter(this.domElement, this.node.graph.cache.pointerWheel.point2);
        return true;
    }
    /**
     * 更新相机目标
     * @param v
     */
    updateTarget(v) {
        var _a;
        const camera = (_a = this.viewportStore.viewportItems[this.viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        const position = camera.position;
        let offset = position.clone().sub(this.viewportStore.viewportItems[this.viewportStore.currentViewportKey].target);
        this.viewportStore.viewportItems[this.viewportStore.currentViewportKey].target.set(v.x, v.y, v.z);
        position.copy(this.viewportStore.viewportItems[this.viewportStore.currentViewportKey].target).add(offset);
        camera.updateMatrixWorld();
        if (camera && (camera.type === 'OrthographicCamera' || camera.type === 'PerspectiveCamera')) {
            camera.updateProjectionMatrix();
        }
    }
    /**
     * 计算滚轮缩放后的鼠标位置
     * @param point2
     * @returns
     */
    calMousePos(point2) {
        var _a;
        if (point2 == null)
            return;
        // 求垂直屏幕的线和工作面的交点
        let mousePos = point2;
        const storage = PythaStorage.instance;
        const viewportStore = this.viewportStore;
        let rect = viewportStore.getViewportRect(viewportStore.currentViewportKey);
        if (rect == null)
            return;
        let x = (mousePos.x - rect.x) / rect.width * 2 - 1;
        let y = -(mousePos.y - rect.y) / rect.height * 2 + 1;
        const coordinateStore = storage.coordinateStore;
        coordinateStore.ndcViewportPos2.set(x, y);
        let workPlane = coordinateStore.workPlane;
        const camera = (_a = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        if (camera == null)
            return;
        _rayStart.set(x, y, -1).unproject(camera);
        _rayEnd.set(x, y, 1).unproject(camera);
        _ray.set(_rayStart, _rayEnd);
        GeoIntersection.LineIntersectPlane(_ray, workPlane, _point$5);
        // 将原始三维点存入存储器
        storage.coordinateStore.originalPos.copy(_point$5);
        storage.coordinateStore.setCurrentPos(_point$5);
    }
}
const _rayStart = new Vector3();
const _rayEnd = new Vector3();
const _ray = new Line$2();
const _point$5 = new Point();/**
 * 显示夹点处理器
 */
class EventHandlerUpdateZoomCenter extends EventHandlerBase {
    /**
     * 运行处理器
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a, _b, _c, _d;
        // 获取存储
        const storage = PythaStorage.instance;
        const viewportStore = storage.viewportStore;
        const camera = (_a = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        const point2 = storage.coordinateStore.ndcViewportPos2;
        let _target = (_b = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _b === void 0 ? void 0 : _b.target.clone();
        if (camera.type === 'OrthographicCamera') {
            const position = camera.position;
            const orthoCamera = camera;
            // // 鼠标在投影面上距中心点的距离
            // let pos_x = (mouse.x - element.clientWidth / 2) * (orthoCamera.right - orthoCamera.left) / orthoCamera.zoom / element.clientWidth;
            // let pos_y = (element.clientHeight / 2 - mouse.y) * (orthoCamera.top - orthoCamera.bottom) / orthoCamera.zoom / element.clientHeight;
            let pos_x = point2.x * (orthoCamera.right - orthoCamera.left) / 2 / orthoCamera.zoom;
            let pos_y = point2.y * (orthoCamera.top - orthoCamera.bottom) / 2 / orthoCamera.zoom;
            // 计算相机的偏移向量
            let offset = _p$5.copy(position).sub(_target).normalize();
            let camera_u_axis = _u.copy(camera.up).cross(offset).normalize(); // 相机的水平轴
            let camera_v_axis = _v.copy(offset).cross(camera_u_axis).normalize(); // 相机的垂直轴
            // 计算鼠标位置对应的世界坐标
            let mousePos = _target
                .add(camera_u_axis.multiplyScalar(pos_x)) // 添加水平位移
                .add(camera_v_axis.multiplyScalar(pos_y)); // 添加垂直位移
            (_c = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _c === void 0 ? void 0 : _c.zoomCenter.set(mousePos.x, mousePos.y, mousePos.z);
        }
        else if (camera.type === 'PerspectiveCamera') {
            // 创建并配置射线投射器
            let raycaster = new Raycaster();
            raycaster.setFromCamera(point2, camera); // 根据鼠标在 NDC 空间的坐标和相机生成射线
            // 定义目标平面：法向量由相机的方向定义，且平面经过目标点 _target
            let planeNormal = new Vector3(0, 0, -1).applyQuaternion(camera.quaternion); // 平面法向量
            let plane = new Plane().setFromNormalAndCoplanarPoint(planeNormal, _target); // 通过法向量和点定义平面
            // 计算射线与平面的交点
            // let intersectionPoint = new Vector3();
            raycaster.ray.intersectPlane(plane, _p$5); // 计算交点并存储到 intersectionPoint
            // 更新缩放中心点
            (_d = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _d === void 0 ? void 0 : _d.zoomCenter.copy(_p$5);
        }
        return true;
    }
}
const _u = new Vector3();
const _v = new Vector3();
const _p$5 = new Vector3();/**
 * 视图缩放
 */
class EventGraphViewZoom extends EventGraphBase {
    constructor() {
        super(...arguments);
        /**
         * 是否是常驻图
         */
        this.isAlwaysActive = true;
    }
    /**
     * 创建节点
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerMouseWheel);
        const node3 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        const node4 = new EventGraphNode(this, EventHandlerViewZoom);
        const node5 = new EventGraphNodeTimer(this, null);
        const node6 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node8 = new EventGraphNode(this, EventHandlerGrid);
        const node9 = new EventGraphNodeRender(this, true, UpdateType.MAIN);
        const node10 = new EventGraphNode(this, EventHandlerUpdateZoomCenter);
        const node11 = new EventGraphNodeNotice(this, {
            cmd: 'data_change', data: {
                viewChangeEnd: true
            }
        });
        this.addEdge(node1, node2);
        this.addEdge(node5, node6);
        this.addEdge(node3, node5);
        this.addEdge(node8, node9);
        this.addEdge(node2, node10);
        this.addEdge(node10, node4);
        this.addEdge(node6, node8);
        this.addEdge(node4, node11);
        this.addEdge(node11, node3);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/73
    }
    /**
    * 结束图
    */
    end() {
        this.cache.pointerDownList = [];
        this.cache.pointerUpList = [];
        this.cache.pointerMove = new Pointer();
        this.cache.primitiveList = [];
        this.cache.pointerWheel = new Pointer();
        this.cache.data = {};
        // this.head.run();
    }
}
/**
 * zoom指令 控制器缩放视图
 */
EventGraphViewZoom.cmd = 'ZOOM';/**
 * 替换图元指令
 */
class UpdatePrimitiveCmd extends CommandBase {
    /**
     * 构造函数
     * @param newPrimitives
     * @param eventMediator
     */
    constructor(newPrimitives, eventMediator) {
        super();
        /**
         * 原来的图元
         */
        this.oldPrimitives = [];
        /**
         * 修改后的图元
         */
        this.newPrimitives = [];
        const storage = PythaStorage.instance;
        const primitiveDict = storage.primitiveStore.primitiveDict;
        // this.newPrimitives = [...newPrimitives];
        for (let primitive of newPrimitives) {
            let old = primitiveDict[primitive.uuid];
            this.oldPrimitives.push(old);
        }
        this.newPrimitives = [...newPrimitives];
        this.eventMediator = eventMediator;
    }
    /**
     * 执行
     */
    execute() {
        const storage = PythaStorage.instance;
        const primitiveDict = storage.primitiveStore.primitiveDict;
        const tempPrimitiveDict = storage.primitiveStore.tempPrimitiveDict;
        this.newPrimitives.forEach(primitive => {
            primitive.needRedraw = true;
            primitive.temporary = false;
            primitiveDict[primitive.uuid] = primitive;
        });
        this.oldPrimitives.forEach(primitive => {
            primitive.temporary = true;
            primitive.needDelete = true;
            primitive.isSelected = false;
            tempPrimitiveDict[primitive.uuid] = primitive;
        });
        this.eventMediator.noticeHandler.notice(this, new PythaEventDataChange({ add_primitives: this.newPrimitives }));
    }
    /**
     * 撤销
     */
    undo() {
        const storage = PythaStorage.instance;
        const primitiveDict = storage.primitiveStore.primitiveDict;
        const tempPrimitiveDict = storage.primitiveStore.tempPrimitiveDict;
        this.newPrimitives.forEach(primitive => {
            primitive.temporary = true;
            primitive.needDelete = true;
            tempPrimitiveDict[primitive.uuid] = primitive;
        });
        this.oldPrimitives.forEach(primitive => {
            primitive.temporary = false;
            primitive.needRedraw = true;
            primitiveDict[primitive.uuid] = primitive;
        });
        this.eventMediator.noticeHandler.notice(this, new PythaEventDataChange({ add_primitives: this.oldPrimitives }));
    }
}/**
 * 编辑图元
 */
class EventHandlerEditPri extends EventHandlerBase {
    constructor(node) {
        super(node);
    }
    run(data) {
        // 0 这里是开始逻辑
        const storage = PythaStorage.instance;
        const tempPrimitives = this.node.graph.cache.primitiveList;
        // 执行命令
        const cmd = new UpdatePrimitiveCmd(tempPrimitives, this.node.graph.eventMediator);
        // 判断缓存中是否有commandGroup
        const graphCache = this.node.graph.cache;
        const commandGroup = graphCache.data['commandGroup'];
        if (!commandGroup || !(commandGroup instanceof CommandGroup)) {
            storage.historyStore.undos.push(cmd);
            cmd.execute();
        }
        else {
            commandGroup.addCmd(cmd);
        }
        return true;
    }
}/**
 * 计算临时缩放图元的渲染对象
 */
class EHCalTempScaleObj extends EventHandlerBase {
    constructor() {
        super(...arguments);
        this._copyEntitiyMap = {};
        this._vec = new Vector3();
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a;
        // 计算临时缩放图元
        const pointerList = this.node.graph.cache.pointerDownList;
        if (pointerList.length < 1)
            return false;
        //初始化
        if (this.node.graph.cache.data['firstPoint'] == null) {
            this.node.graph.cache.data['firstPoint'] = pointerList[pointerList.length - 1].point.clone();
            const selectPrimitives = PythaStorage.instance.selectStore.getUnlockedPrimitives();
            this.generateTempRenderItems(selectPrimitives);
        }
        //获得pointdown或者pointmove
        let currentPoint;
        if (!!this.node.graph.cache.data['isPointDown'] && this.node.graph.cache.pointerDownList.length > 0) {
            // 按下点或输入点
            currentPoint = this.node.graph.cache.pointerDownList[this.node.graph.cache.pointerDownList.length - 1].point;
            this.node.graph.cache.data['isPointDown'] = false;
        }
        else {
            currentPoint = this.node.graph.cache.pointerMove.point;
        }
        const basePoint = this.node.graph.cache.data['firstPoint'];
        const viewportStore = PythaStorage.instance.viewportStore;
        const camera = (_a = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        _v1$6.copy(this.node.graph.cache.data['firstPoint']).project(camera);
        _v2$5.copy(currentPoint).project(camera);
        this._vec.subVectors(_v1$6, _v2$5);
        let scale = this._vec.length() * 5;
        if (scale == 0) {
            scale = 1e-4;
        }
        //缩放
        for (let key in this._copyEntitiyMap) {
            let mapItem = this._copyEntitiyMap[key];
            if (mapItem.object == null)
                continue;
            // 设置缩放后位置
            mapItem.object.position.set(basePoint.x * (1 - scale), basePoint.y * (1 - scale), basePoint.z * (1 - scale));
            // 应用缩放
            mapItem.object.scale.set(scale, scale, scale);
        }
        return true;
    }
    dispose() {
        for (let key in this._copyEntitiyMap) {
            let mapItem = this._copyEntitiyMap[key];
            if (mapItem.object == null)
                continue;
            if (mapItem.object.parent) {
                mapItem.object.parent.remove(mapItem.object);
            }
        }
    }
    /**
    * 生成临时渲染对象
    */
    generateTempRenderItems(selectPrimitives) {
        var _a;
        for (let i = 0; i < selectPrimitives.length; i++) {
            let primitive = selectPrimitives[i];
            Object.keys(primitive.renderItemDict).forEach(renderKey => {
                var _a, _b, _c, _d;
                let renderItem = primitive.renderItemDict[renderKey];
                const key = renderItem.lastRenderKey;
                let bucket = PythaStorage.instance.renderStore.objectRenderBucket[key];
                if (bucket == null)
                    return;
                let renderMapItem = bucket.renderBucketItems[renderItem.renderGeometryBucketIndex];
                if (renderMapItem == null)
                    return;
                const start = renderItem.start;
                const size = renderItem.size;
                const mat = bucket.material;
                let copyRenderMapItem = this._copyEntitiyMap[key];
                if (copyRenderMapItem == null) {
                    copyRenderMapItem = {
                        material: mat,
                        positions: [],
                        colors: [],
                        uvs: [],
                        renderType: renderMapItem.renderType,
                        needRegenerate: false,
                        hidden: false
                    };
                    this._copyEntitiyMap[key] = copyRenderMapItem;
                }
                if (renderMapItem.buffer == null)
                    return;
                let positions = (_b = (_a = renderMapItem.buffer.attributes) === null || _a === void 0 ? void 0 : _a.position) === null || _b === void 0 ? void 0 : _b.array;
                let colors = (_d = (_c = renderMapItem.buffer.attributes) === null || _c === void 0 ? void 0 : _c.color) === null || _d === void 0 ? void 0 : _d.array;
                if (positions == null || colors == null)
                    return;
                for (let index = 0; (index < size) && (index + start) < positions.length; index++) {
                    copyRenderMapItem.positions.push(positions[index + start]);
                    copyRenderMapItem.colors.push(colors[index + start]);
                }
            });
        }
        const storage = PythaStorage.instance;
        for (let key in this._copyEntitiyMap) {
            let mapItem = this._copyEntitiyMap[key];
            let geo = new BufferGeometry();
            geo.setAttribute('position', new Float32BufferAttribute(mapItem.positions, 3));
            if (((_a = mapItem.uvs) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                geo.setAttribute('uv', new Float32BufferAttribute(mapItem.uvs, 2));
            }
            else {
                let colorAttribute = new Float32BufferAttribute(mapItem.colors, 3);
                geo.setAttribute('color', colorAttribute);
            }
            geo.computeBoundingBox();
            geo.computeVertexNormals();
            switch (mapItem.renderType) {
                case 'Line':
                    let line = new LineSegments(geo, mapItem.material);
                    storage.viewportStore.scene.add(line);
                    mapItem.object = line;
                    break;
                case 'Mesh':
                    let mesh = new Mesh(geo, mapItem.material);
                    storage.viewportStore.scene.add(mesh);
                    mapItem.object = mesh;
                    break;
                case 'Point':
                    let point = new Points(geo, mapItem.material);
                    storage.viewportStore.scene.add(point);
                    mapItem.object = point;
                    break;
            }
        }
    }
}
const _v1$6 = new Vector3();
const _v2$5 = new Vector3();class EventHandlerCalTempScalePri extends EventHandlerBase {
    constructor(node) {
        super(node);
        this._vec = new Vector3();
    }
    run(data) {
        var _a;
        if (this.node.graph.cache.primitiveList.length > 0) {
            this.node.graph.cache.primitiveList = [];
        }
        //如果存在数值输入，则直接采用数值输入作为旋转值
        if (this.node.graph.cache.inputNumber.hasOwnProperty('SCALE_NUM')) {
            this.generateClonePri(this.node.graph.cache.inputNumber['SCALE_NUM'] > 1e-6 ? this.node.graph.cache.inputNumber['SCALE_NUM'] : 1e-4);
            return true;
        }
        //获得pointdown或者pointmove
        let currentPoint;
        if (!!this.node.graph.cache.data['isPointDown'] && this.node.graph.cache.pointerDownList.length > 0) {
            // 按下点或输入点
            currentPoint = this.node.graph.cache.pointerDownList[this.node.graph.cache.pointerDownList.length - 1].point;
            this.node.graph.cache.data['isPointDown'] = false;
        }
        else {
            currentPoint = this.node.graph.cache.pointerMove.point;
        }
        this.node.graph.cache.data['firstPoint'];
        const viewportStore = PythaStorage.instance.viewportStore;
        const camera = (_a = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        const _v1 = new Vector3();
        const _v2 = new Vector3();
        _v1.copy(this.node.graph.cache.data['firstPoint']).project(camera);
        _v2.copy(currentPoint).project(camera);
        this._vec.subVectors(_v1, _v2);
        let scale = this._vec.length() * 5;
        if (scale == 0) {
            scale = 1e-4;
        }
        this.generateClonePri(scale);
        return true;
    }
    /**
     * 生成缩放图元
     * @param scale 缩放系数
     */
    generateClonePri(scale) {
        const firstPoint = this.node.graph.cache.data['firstPoint'];
        const primitiveList = PythaStorage.instance.selectStore.getUnlockedPrimitives();
        primitiveList.forEach(primitive => {
            let clonePrimitive = primitive.clone();
            clonePrimitive.uuid = primitive.uuid;
            clonePrimitive.scale(firstPoint, scale, scale, scale);
            clonePrimitive.needRedraw = true;
            clonePrimitive.isSelected = false;
            this.node.graph.cache.primitiveList.push(clonePrimitive);
        });
    }
}class EventGraphScale extends EventGraphBase {
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerConfirm);
        const node4 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node5 = new EventGraphNode(this, EventHandlerCapture);
        const node7 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node8 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node9 = new EventGraphNode(this, EHCalTempScaleObj);
        const node10 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node11 = new EventGraphNode(this, EventHandlerEditPri);
        const node14 = new EventGraphNode(this, EventHandlerGrid);
        const node15 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node16 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node18 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '请选择图元' });
        const node19 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{ type: NeedInputEnum.ACTIVE, description: "请点击下一点或输入比例", option: 'SCALE_NUM', inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.COUNT] }
            ]
        });
        const node20 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node21 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node23 = new EventGraphNodeSwitch(this, () => {
            let selectPrimitives = PythaStorage.instance.selectStore.getUnlockedPrimitives();
            if (selectPrimitives.length < 1) {
                return [0];
            }
            return [1];
        });
        const node24 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{ type: NeedInputEnum.ACTIVE, description: "指定基点", option: 'BASE', inputTypes: [PythaEventName.POINTER_DOWN] }
            ]
        });
        const node25 = new EventGraphNode(this, EventHandlerCalTempScalePri);
        const node27 = new EventGraphNode(this, EventHandlerInitCapture);
        const node29 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node30 = new EventGraphNode(this, EHChangeCrossCursor);
        const node31 = new EventGraphNode(this, EventHandlerDisableClamp);
        const node32 = new EventGraphNode(this, EHChangePickCursor);
        const node33 = new EventGraphNode(this, EventHandlerHelpLine);
        const node34 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        const node35 = new EventGraphNode(this, EventHandlerNumberInput);
        this.addEdge(node4, node5);
        this.addEdge(node8, node9);
        this.addEdge(node7, node19);
        this.addEdge(node14, node21);
        this.addEdge(node25, node11);
        this.addEdge(node11, node29);
        this.addEdge(node29, node14);
        this.addEdge(node27, node4);
        this.addEdge(node21, node15);
        this.addEdge(node16, node30);
        this.addEdge(node30, node24);
        this.addEdge(node24, node7);
        this.addEdge(node1, node31);
        this.addEdge(node31, node23);
        /**未选中*/
        this.addEdge(node23, node18);
        this.addEdge(node18, node32);
        this.addEdge(node32, node2);
        this.addEdge(node2, node23);
        this.addEdge(node24, node27);
        this.addEdge(node9, node33);
        this.addEdge(node5, node8);
        this.addEdge(node7, node34);
        this.addEdge(node34, node9);
        this.addEdge(node19, node35);
        this.addEdge(node19, node10);
        this.addEdge(node10, node25);
        this.addEdge(node35, node25);
        this.addEdge(node33, node20);
        /**选中*/
        this.addEdge(node23, node16);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/33
    }
}
/**
 * scale指令 用于注册事件图
 */
EventGraphScale.cmd = 'SCALE';/**
 * 移动临时图元
 */
class EventHandlerCalTempMovePri extends EventHandlerBase {
    constructor() {
        super(...arguments);
        /**
          * 临时移动向量
          */
        this._vec = new Vector3();
    }
    run(data) {
        if (this.node.graph.cache.primitiveList.length > 0) {
            this.node.graph.cache.primitiveList = [];
        }
        // 同时判断键盘输入和两点
        let inputNumber = this.node.graph.cache.inputNumber['E'];
        if (inputNumber == null) {
            // 没有输入值，通过两点的方式
            const pointerList = this.node.graph.cache.pointerDownList;
            if (pointerList.length < 2)
                return false;
            const firstPoint = pointerList[pointerList.length - 2].point;
            const secPoint = pointerList[pointerList.length - 1].point;
            const x = secPoint.x - firstPoint.x;
            const y = secPoint.y - firstPoint.y;
            const z = secPoint.z - firstPoint.z;
            this._vec.set(x, y, z);
        }
        else {
            // 有输入值，通过输入距离的方式
            const pointerList = this.node.graph.cache.pointerDownList;
            if (pointerList.length < 1)
                return false;
            const firstPoint = pointerList[0].point;
            const pointerMove = this.node.graph.cache.pointerMove;
            if (!(pointerMove === null || pointerMove === void 0 ? void 0 : pointerMove.point))
                return false;
            const pointMove = pointerMove.point;
            // 计算方向向量
            this._vec = pointMove.clone().sub(firstPoint).normalize();
            this._vec.multiplyScalar(inputNumber);
        }
        this.generateClonePri();
        return true;
    }
    generateClonePri() {
        const primitiveList = PythaStorage.instance.selectStore.getUnlockedPrimitives();
        primitiveList.forEach(primitive => {
            let clonePrimitive = primitive.clone();
            clonePrimitive.uuid = primitive.uuid;
            clonePrimitive.move(this._vec);
            clonePrimitive.needRedraw = true;
            clonePrimitive.isSelected = false;
            this.node.graph.cache.primitiveList.push(clonePrimitive);
        });
    }
}/**
 * 移动图元
 */
class EventGraphMove extends EventGraphBase {
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node3 = new EventGraphNode(this, EventHandlerCapture);
        const node8 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node11 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node12 = new EventGraphNode(this, EventHandlerEditPri);
        const node14 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node17 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node18 = new EventGraphNode(this, EventHandlerCalTempMoveObj);
        const node20 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                    type: NeedInputEnum.ACTIVE,
                    description: "指定第二点",
                    option: 'E',
                    inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER]
                }]
        });
        const node21 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                    type: NeedInputEnum.ACTIVE,
                    description: "指定基点",
                    option: 'P',
                    inputTypes: [PythaEventName.POINTER_DOWN]
                }]
        });
        const node22 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node28 = new EventGraphNodeSwitch(this, () => {
            if (PythaStorage.instance.selectStore.getUnlockedPrimitives().length != 0)
                return [0];
            return [1];
        });
        const node29 = new EventGraphNode(this, EventHandlerConfirm);
        const node30 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node32 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '请选择对象' });
        const node33 = new EventGraphNode(this, EventHandlerCalTempMovePri);
        const node34 = new EventGraphNode(this, EventHandlerHelpLine);
        const node37 = new EventGraphNode(this, EventHandlerGrid);
        const node38 = new EventGraphNode(this, EHChangePickCursor);
        const node39 = new EventGraphNode(this, EHChangeCrossCursor);
        const node40 = new EventGraphNode(this, EventHandlerInitCapture);
        const node41 = new EventGraphNode(this, EventHandlerDisableClamp);
        const node42 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node43 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        const node44 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node45 = new EventGraphNodeSwitch(this, () => {
            if (PythaStorage.instance.selectStore.getUnlockedPrimitives().length != 0)
                return [0];
            return [1];
        });
        const node46 = new EventGraphNode(this, EventHandlerNumberInput);
        this.addEdge(node2, node3);
        this.addEdge(node32, node29);
        this.addEdge(node11, node33);
        this.addEdge(node33, node12);
        this.addEdge(node30, node2);
        this.addEdge(node37, node14);
        this.addEdge(node14, node17);
        this.addEdge(node38, node32);
        this.addEdge(node39, node30);
        this.addEdge(node30, node21);
        this.addEdge(node21, node8);
        this.addEdge(node28, node40);
        this.addEdge(node40, node39);
        this.addEdge(node1, node41);
        this.addEdge(node41, node28);
        this.addEdge(node18, node34);
        this.addEdge(node34, node22);
        this.addEdge(node3, node42);
        this.addEdge(node8, node43);
        this.addEdge(node42, node18);
        this.addEdge(node8, node18);
        this.addEdge(node43, node20);
        this.addEdge(node12, node44);
        this.addEdge(node44, node37);
        this.addEdge(node29, node45);
        this.addEdge(node45, node40);
        this.addEdge(node20, node11);
        this.addEdge(node46, node33);
        this.addEdge(node20, node46);
        this.addEdge(node46, node11, EDGE_TYPE.STOP);
        this.addEdge(node11, node46, EDGE_TYPE.STOP);
        this.addEdge(node28, node38);
        this.addEdge(node45, node17);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/26
    }
}
/**
 * MOVE指令 用于注册事件图
 */
EventGraphMove.cmd = 'MOVE';/**
 * 计算临时旋转图元的渲染对象
 */
class EHCalTempRotateObj extends EventHandlerBase {
    constructor() {
        super(...arguments);
        this._copyEntitiyMap = {};
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a;
        // 计算临时旋转图元
        const pointerList = this.node.graph.cache.pointerDownList;
        if (pointerList.length < 1)
            return false;
        //初始化
        if (this.node.graph.cache.data['firstPoint'] == null) {
            this.node.graph.cache.data['firstPoint'] = pointerList[pointerList.length - 1].point.clone();
        }
        if (((_a = Object.keys(this._copyEntitiyMap)) === null || _a === void 0 ? void 0 : _a.length) === 0) {
            const selectPrimitives = PythaStorage.instance.selectStore.getUnlockedPrimitives();
            this.generateTempRenderItems(selectPrimitives);
        }
        //获得pointdown或者pointmove
        let currentPoint;
        if (!!this.node.graph.cache.data['isPointDown'] && this.node.graph.cache.pointerDownList.length > 0) {
            // 按下点或输入点
            currentPoint = this.node.graph.cache.pointerDownList[this.node.graph.cache.pointerDownList.length - 1].point;
            this.node.graph.cache.data['isPointDown'] = false;
        }
        else {
            currentPoint = this.node.graph.cache.pointerMove.point;
        }
        //旋转角度计算
        const storage = PythaStorage.instance;
        let axisX = storage.coordinateStore.workPlane.getX();
        let axisZ = storage.coordinateStore.workPlane.normal;
        let direction = currentPoint.clone().sub(this.node.graph.cache.data['firstPoint']).normalize();
        let posAngle = direction.angleTo(axisX);
        // let valueZ = axisX.clone().cross(this._helpLine.direction).z;
        let _moveDir = new Vector3();
        let valueZ = _moveDir.copy(direction).cross(axisX).angleTo(axisZ) * 180 / Math.PI;
        if (valueZ > 90) {
            this.angle = posAngle;
        }
        else {
            this.angle = 2 * Math.PI - posAngle;
        }
        for (let key in this._copyEntitiyMap) {
            let mapItem = this._copyEntitiyMap[key];
            if (mapItem.object == null)
                continue;
            //恢复默认位置
            mapItem.object.position.set(0, 0, 0);
            quaternion.setFromAxisAngle(axisZ, this.angle);
            // 将对象平移到基点坐标系
            mapItem.object.position.sub(this.node.graph.cache.data['firstPoint']);
            // 应用旋转
            mapItem.object.position.applyQuaternion(quaternion);
            // 平移回全局坐标系
            mapItem.object.position.add(this.node.graph.cache.data['firstPoint']);
            //恢复默认角度
            mapItem.object.quaternion.set(0, 0, 0, 1);
            // 如果需要旋转整个对象（包括其方向），应用四元数到对象本身
            mapItem.object.quaternion.premultiply(quaternion);
        }
        return true;
    }
    dispose() {
        for (let key in this._copyEntitiyMap) {
            let mapItem = this._copyEntitiyMap[key];
            if (mapItem.object == null)
                continue;
            if (mapItem.object.parent) {
                mapItem.object.parent.remove(mapItem.object);
            }
        }
    }
    /**
    * 生成临时渲染对象
    */
    generateTempRenderItems(selectPrimitives) {
        var _a;
        for (let i = 0; i < selectPrimitives.length; i++) {
            let primitive = selectPrimitives[i];
            Object.keys(primitive.renderItemDict).forEach(renderKey => {
                var _a, _b, _c, _d;
                let renderItem = primitive.renderItemDict[renderKey];
                const key = renderItem.lastRenderKey;
                let bucket = PythaStorage.instance.renderStore.objectRenderBucket[key];
                if (bucket == null)
                    return;
                let renderMapItem = bucket.renderBucketItems[renderItem.renderGeometryBucketIndex];
                if (renderMapItem == null)
                    return;
                const start = renderItem.start;
                const size = renderItem.size;
                const mat = bucket.material;
                let copyRenderMapItem = this._copyEntitiyMap[key];
                if (copyRenderMapItem == null) {
                    copyRenderMapItem = {
                        material: mat,
                        positions: [],
                        colors: [],
                        uvs: [],
                        renderType: renderMapItem.renderType,
                        needRegenerate: false,
                        hidden: false
                    };
                    this._copyEntitiyMap[key] = copyRenderMapItem;
                }
                if (renderMapItem.buffer == null)
                    return;
                let positions = (_b = (_a = renderMapItem.buffer.attributes) === null || _a === void 0 ? void 0 : _a.position) === null || _b === void 0 ? void 0 : _b.array;
                let colors = (_d = (_c = renderMapItem.buffer.attributes) === null || _c === void 0 ? void 0 : _c.color) === null || _d === void 0 ? void 0 : _d.array;
                if (positions == null || colors == null)
                    return;
                for (let index = 0; (index < size) && (index + start) < positions.length; index++) {
                    copyRenderMapItem.positions.push(positions[index + start]);
                    copyRenderMapItem.colors.push(colors[index + start]);
                }
            });
        }
        const storage = PythaStorage.instance;
        for (let key in this._copyEntitiyMap) {
            let mapItem = this._copyEntitiyMap[key];
            let geo = new BufferGeometry();
            geo.setAttribute('position', new Float32BufferAttribute(mapItem.positions, 3));
            if (((_a = mapItem.uvs) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                geo.setAttribute('uv', new Float32BufferAttribute(mapItem.uvs, 2));
            }
            else {
                let colorAttribute = new Float32BufferAttribute(mapItem.colors, 3);
                geo.setAttribute('color', colorAttribute);
            }
            geo.computeBoundingBox();
            geo.computeVertexNormals();
            switch (mapItem.renderType) {
                case 'Line':
                    let line = new LineSegments(geo, mapItem.material);
                    storage.viewportStore.scene.add(line);
                    mapItem.object = line;
                    break;
                case 'Mesh':
                    let mesh = new Mesh(geo, mapItem.material);
                    storage.viewportStore.scene.add(mesh);
                    mapItem.object = mesh;
                    break;
                case 'Point':
                    let point = new Points(geo, mapItem.material);
                    storage.viewportStore.scene.add(point);
                    mapItem.object = point;
                    break;
            }
        }
    }
}
/**
 * 临时旋转四元数
 */
const quaternion = new Quaternion();/**
 * 旋转临时图元
 */
class EventHandlerCalTempRotatePri extends EventHandlerBase {
    constructor() {
        super(...arguments);
        /**
          * 临时旋转向量
          */
        this._vec = new Vector3();
    }
    run(data) {
        if (this.node.graph.cache.primitiveList.length > 0) {
            this.node.graph.cache.primitiveList = [];
        }
        //如果存在数值输入，则直接采用数值输入作为旋转值
        if (this.node.graph.cache.inputNumber.hasOwnProperty('ANGLE')) {
            const lengthUnitRatio = this.getPythaStorage().coordinateStore.lengthUnitRatio;
            let angle = this.node.graph.cache.inputNumber['ANGLE'] / lengthUnitRatio;
            this.generateClonePri(angle / 180 * Math.PI);
            return true;
        }
        const pointerList = this.node.graph.cache.pointerDownList;
        if (pointerList.length < 2)
            return false;
        const firstPoint = pointerList[pointerList.length - 2].point;
        const secPoint = pointerList[pointerList.length - 1].point;
        const x = secPoint.x - firstPoint.x;
        const y = secPoint.y - firstPoint.y;
        const z = secPoint.z - firstPoint.z;
        this._vec.set(x, y, z);
        const storage = PythaStorage.instance;
        let axisX = storage.coordinateStore.workPlane.getX();
        let axisZ = storage.coordinateStore.workPlane.normal;
        this._vec.normalize();
        let posAngle = this._vec.angleTo(axisX);
        // let valueZ = axisX.clone().cross(this._helpLine.direction).z;
        let _moveDir = new Vector3();
        let valueZ = _moveDir.copy(this._vec).cross(axisX).angleTo(axisZ) * 180 / Math.PI;
        if (valueZ > 90) ;
        else {
            posAngle = 2 * Math.PI - posAngle;
        }
        this.generateClonePri(posAngle);
        return true;
    }
    generateClonePri(posAngle) {
        const firstPoint = this.node.graph.cache.data['firstPoint'];
        const primitiveList = PythaStorage.instance.selectStore.getUnlockedPrimitives();
        primitiveList.forEach(primitive => {
            let clonePrimitive = primitive.clone();
            clonePrimitive.uuid = primitive.uuid;
            clonePrimitive.rotate(firstPoint, PythaStorage.instance.coordinateStore.workPlane.normal, posAngle);
            clonePrimitive.needRedraw = true;
            clonePrimitive.isSelected = false;
            this.node.graph.cache.primitiveList.push(clonePrimitive);
        });
    }
}/**
 * rotate指令 旋转
 */
class EventGraphRotate extends EventGraphBase {
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNodeSwitch(this, () => {
            var _a;
            if (((_a = PythaStorage.instance.selectStore.selectPrimitives) === null || _a === void 0 ? void 0 : _a.length) > 0)
                return [0];
            return [1];
        });
        const node4 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node5 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node6 = new EventGraphNode(this, EventHandlerCapture);
        const node7 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node9 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node13 = new EventGraphNode(this, EventHandlerCalTempRotatePri);
        const node14 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node15 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node18 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [{ type: NeedInputEnum.ACTIVE, description: "请选择旋转角度", option: 'ANGLE', inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER] }
            ] });
        const node19 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node20 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [{ type: NeedInputEnum.ACTIVE, description: "请选择基点", option: 'BASE', inputTypes: [PythaEventName.POINTER_DOWN] }
            ] });
        const node21 = new EventGraphNode(this, EventHandlerConfirm);
        const node23 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: 'Rotate,请选择图元' });
        const node24 = new EventGraphNode(this, EventHandlerHelpLine);
        const node27 = new EventGraphNode(this, EventHandlerGrid);
        const node28 = new EventGraphNode(this, EventHandlerEditPri);
        const node29 = new EventGraphNode(this, EventHandlerGrid);
        const node30 = new EventGraphNode(this, EventHandlerDisableClamp);
        const node31 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node32 = new EventGraphNode(this, EventHandlerNumberInput);
        const node34 = new EventGraphNode(this, EHChangeCrossCursor);
        const node35 = new EventGraphNode(this, EventHandlerInitCapture);
        const node36 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node37 = new EventGraphNode(this, EHChangePickCursor);
        const node38 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        const node39 = new EventGraphNode(this, EHCalTempRotateObj);
        this.addEdge(node9, node6);
        this.addEdge(node4, node18);
        /**选中图元*/
        this.addEdge(node2, node19);
        this.addEdge(node21, node2);
        this.addEdge(node7, node15);
        this.addEdge(node27, node7);
        this.addEdge(node29, node14);
        this.addEdge(node28, node31);
        this.addEdge(node31, node27);
        this.addEdge(node18, node32);
        this.addEdge(node18, node5);
        this.addEdge(node19, node34);
        this.addEdge(node20, node4);
        this.addEdge(node35, node9);
        this.addEdge(node1, node30);
        this.addEdge(node30, node2);
        this.addEdge(node23, node37);
        this.addEdge(node37, node21);
        this.addEdge(node34, node35);
        this.addEdge(node19, node20);
        this.addEdge(node6, node36);
        this.addEdge(node24, node29);
        this.addEdge(node4, node38);
        this.addEdge(node38, node39);
        this.addEdge(node36, node39);
        this.addEdge(node32, node13);
        this.addEdge(node5, node13);
        this.addEdge(node13, node28);
        this.addEdge(node39, node24);
        /**未选中图元*/
        this.addEdge(node2, node23);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/36
    }
}
/**
 * rotate指令 用于注册事件图
 */
EventGraphRotate.cmd = 'ROTATE';/**
 * 删除图元指令
 */
class DeletePrimitiveCmd extends CommandBase {
    /**
     * 构造函数
     * @param primitives
     * @param eventMediator
     */
    constructor(primitives, eventMediator) {
        super();
        /**
         * 待删除的图元
         */
        this.primitives = [];
        this.primitives = [...primitives];
        this.eventMediator = eventMediator;
    }
    /**
     * 撤销
     */
    undo() {
        const storage = PythaStorage.instance;
        const primitiveDict = storage.primitiveStore.primitiveDict;
        this.primitives.forEach(primitive => {
            primitive.needRedraw = true;
            primitive.temporary = false;
            primitive.needDelete = false;
            primitiveDict[primitive.uuid] = primitive;
        });
        this.eventMediator.noticeHandler.notice(this, new PythaEventDataChange({ add_primitives: this.primitives }));
    }
    /**
     * 执行
     */
    execute() {
        this.primitives.forEach(primitive => {
            primitive.needDelete = true;
        });
        this.eventMediator.noticeHandler.notice(this, new PythaEventDataChange({ delete_primitives: this.primitives }));
    }
}/**
 * 删除图元
 */
class EventHandlerDeletePri extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        const graphCache = this.node.graph.cache;
        const commandGroup = graphCache.data['commandGroup'];
        const groupExist = commandGroup && commandGroup instanceof CommandGroup;
        // 删除图元
        let selectPrimitives = PythaStorage.instance.selectStore.getUnlockedPrimitives(); //之前选中的图元
        if (selectPrimitives.length > 0) {
            const cmd = new DeletePrimitiveCmd(selectPrimitives, this.node.graph.eventMediator);
            const storage = PythaStorage.instance;
            if (!groupExist) {
                storage.historyStore.undos.push(cmd);
                cmd.execute();
            }
            else {
                commandGroup.addCmd(cmd);
            }
        }
        this.node.graph.eventMediator.noticeHandler.notice(this.node, {
            cmd: 'Notice',
            data: `已删除对象：${selectPrimitives.length}个`
        });
        return true;
    }
}/**
 * 嫁接节点
 */
class EventGraphNodeGraft extends EventGraphNode {
    constructor(graph, graftKey) {
        super(graph, null);
        /**
         * 是否是嫁接节点
         */
        this.isGraftNode = true;
        /**
         * 嫁接上的节点列表 优先执行
         */
        this.graftOutsBefore = [];
        /**
         * 嫁接上的节点列表 最后执行
         */
        this.graftOutsAfter = [];
        this.graftKey = graftKey;
    }
    /**
     * 运行节点
     */
    run() {
        var _a, _b;
        this.isRunFinished = true;
        // 执行优先嫁接节点
        for (let next of this.graftOutsBefore) {
            (_a = next.getHead()) === null || _a === void 0 ? void 0 : _a.run();
        }
        // 获取下一级节点
        for (let next of this.outNodes) {
            if (next.type == EDGE_TYPE.STOP && next.node.isWaitingEvent) {
                // 识别是撤销挂起的边，将节点的挂起状态撤销
                next.node.onHangupEndEvent();
            }
            else {
                // 识别是正常执行的边
                next.node.run();
            }
        }
        // 执行滞后嫁接节点
        for (let next of this.graftOutsAfter) {
            (_b = next.getHead()) === null || _b === void 0 ? void 0 : _b.run();
        }
    }
    clear() {
        for (let graph of this.graftOutsBefore) {
            graph.end();
        }
        for (let graph of this.graftOutsAfter) {
            graph.end();
        }
        this.graftOutsBefore = [];
        this.graftOutsAfter = [];
    }
}class EventGraphDelete extends EventGraphBase {
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node4 = new EventGraphNode(this, EventHandlerDeletePri);
        const node6 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node14 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node15 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node16 = new EventGraphNodeGraft(this, null);
        const node17 = new EventGraphNode(this, EventHandlerGenCommandGroup);
        const node18 = new EventGraphNode(this, EventHandlerRunCommandGroup);
        const node19 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '请选择对象' });
        const node20 = new EventGraphNodeSwitch(this, () => {
            const storage = this.eventMediator.storage;
            if (storage.selectStore.getUnlockedPrimitives().length > 0) {
                return [0];
            }
            return [1];
        });
        const node21 = new EventGraphNode(this, EventHandlerConfirm);
        const node22 = new EventGraphNode(this, EHChangePickCursor);
        const node23 = new EventGraphNode(this, EventHandlerDisableClamp);
        const node24 = new EventGraphNodeSwitch(this, () => {
            const storage = this.eventMediator.storage;
            if (storage.selectStore.getUnlockedPrimitives().length > 0) {
                return [0];
            }
            return [1];
        });
        this.addEdge(node6, node15);
        this.addEdge(node15, node14);
        this.addEdge(node16, node4);
        this.addEdge(node17, node16);
        this.addEdge(node4, node18);
        this.addEdge(node1, node20);
        this.addEdge(node20, node17);
        this.addEdge(node19, node22);
        this.addEdge(node22, node23);
        this.addEdge(node23, node21);
        this.addEdge(node18, node6);
        this.addEdge(node21, node24);
        this.addEdge(node24, node17);
        this.addEdge(node20, node19);
        this.addEdge(node24, node14);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/142
    }
}
/**
 * delete指令 用于删除事件图
 */
EventGraphDelete.cmd = 'DELETE';/**
 * 撤销处理器
 */
class EventHandlerUndo extends EventHandlerBase {
    /**
     * 运行处理器
     * @param data
     * @returns
     */
    run(data = {}) {
        // 获取存储
        // console.log("EventHandlerUndo");
        const storage = PythaStorage.instance.historyStore;
        let cmd = storage.undos.pop();
        if (cmd != null) {
            cmd.undo();
            storage.redos.push(cmd);
        }
        return true;
    }
}/**
 * 撤销
 */
class EventGraphUndo extends EventGraphBase {
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node3 = new EventGraphNode(this, EventHandlerUndo);
        const node4 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node5 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '撤销操作' });
        const node6 = new EventGraphNodeSwitch(this, () => {
            const store = PythaStorage.instance.historyStore;
            if (store.undos.length <= 0) {
                return [0];
            }
            return [1];
        });
        const node7 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '无操作可撤销' });
        const node8 = new EventGraphNodeRender(this, true, UpdateType.MAIN);
        const node9 = new EventGraphNode(this, EventHandlerGrid);
        this.addEdge(node5, node4);
        this.addEdge(node1, node6);
        this.addEdge(node7, node4);
        this.addEdge(node6, node7);
        this.addEdge(node8, node5);
        this.addEdge(node3, node9);
        this.addEdge(node9, node8);
        this.addEdge(node6, node3);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
    }
}
/**
 * 指令 用于注册事件图
 */
EventGraphUndo.cmd = 'UNDO';/**
 * 重做处理器
 */
class EventHandlerRedo extends EventHandlerBase {
    /**
     * 运行处理器
     * @param data
     * @returns
     */
    run(data = {}) {
        // 获取存储
        // console.log("EventHandlerRedo");
        const storage = PythaStorage.instance.historyStore;
        let cmd = storage.redos.pop();
        if (cmd != null) {
            cmd.execute();
            storage.undos.push(cmd);
        }
        return true;
    }
}/**
 * 重做
 */
class EventGraphRedo extends EventGraphBase {
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerRedo);
        const node3 = new EventGraphNodeRender(this, true, UpdateType.MAIN);
        const node4 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: 'Redo操作' });
        const node5 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node6 = new EventGraphNodeSwitch(this, () => {
            const store = PythaStorage.instance.historyStore;
            if (store.redos.length <= 0) {
                return [0];
            }
            return [1];
        });
        const node7 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '无操作可重做' });
        const node8 = new EventGraphNode(this, EventHandlerGrid);
        this.addEdge(node3, node4);
        this.addEdge(node4, node5);
        this.addEdge(node1, node6);
        this.addEdge(node6, node7);
        this.addEdge(node7, node5);
        this.addEdge(node2, node8);
        this.addEdge(node8, node3);
        this.addEdge(node6, node2);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
    }
}
/**
 * 指令 用于注册事件图
 */
EventGraphRedo.cmd = 'REDO';class EventHandlerCalTempRectangle extends EventHandlerBase {
    run(data) {
        const pointerDownList = this.node.graph.cache.pointerDownList;
        if (pointerDownList.length < 1)
            return false;
        const is_line = this.node.graph.cache.data['is_line'];
        if (!is_line) {
            this.calcRect();
        }
        else {
            this.calcPolygon();
        }
        this.primitive.needRedraw = true;
        return true;
    }
    // 正常的面渲染矩形
    calcRect() {
        var _a;
        const storage = PythaStorage.instance;
        const pointerDownList = this.node.graph.cache.pointerDownList;
        const pointer = pointerDownList[pointerDownList.length - 1];
        if (this._rectangle == null) {
            // 创建矩形
            const workPlane = storage.coordinateStore.workPlane;
            this._rectangle = new RectFace(pointer.point, workPlane.getX(), workPlane.getY());
            this.primitive = new Primitive("RectFace");
            this.primitive.geos.push(this._rectangle);
            let keys = Object.keys(this.primitive.renderItemDict);
            if (keys.length > 0) {
                let renderItem = this.primitive.renderItemDict[keys[0]];
                renderItem.geoElements = this._rectangle.getGeoElementsIdxList();
                (_a = renderItem.mat) === null || _a === void 0 ? void 0 : _a.color.set(storage.layerStore.getColor());
            }
            this.primitive.temporary = true;
            this.node.graph.cache.primitiveList.push(this.primitive);
            storage.primitiveStore.tempPrimitiveDict[this.primitive.uuid] = this.primitive;
        }
        // 更新矩形
        //const pointMove = this.node.graph.cache.pointerMove.point;
        const pointMove = storage.coordinateStore.currentPos;
        // pointMove投影
        const pointMoveProject = this._rectangle.projectPoint(pointMove);
        // pointMove和pointer.point是对角线上两点，基点永远固定左下角
        // 利用两点计算基点和x、y轴长度，带方向
        const basePoint = new Vector3(Math.min(pointer.point.x, pointMoveProject.x), Math.min(pointer.point.y, pointMoveProject.y), Math.min(pointer.point.z, pointMoveProject.z));
        const topRightPoint = new Vector3(Math.max(pointer.point.x, pointMoveProject.x), Math.max(pointer.point.y, pointMoveProject.y), Math.max(pointer.point.z, pointMoveProject.z));
        const vecX = new Vector3(topRightPoint.x - basePoint.x, 0, 0);
        const vecY = new Vector3(0, topRightPoint.y - basePoint.y, 0);
        const dirZ = vecX.clone().cross(vecY).normalize();
        this._rectangle.transformMatrix.set(vecX.x, vecY.x, dirZ.x, basePoint.x, vecX.y, vecY.y, dirZ.y, basePoint.y, vecX.z, vecY.z, dirZ.z, basePoint.z, 0, 0, 0, 1);
    }
    calcPolygon() {
        var _a;
        // basePoint是中心点，pointMove是其中角点，依据两点生成各角点
        const vertices = [];
        const storage = PythaStorage.instance;
        const workPlane = storage.coordinateStore.workPlane;
        const pointMove = this.node.graph.cache.pointerMove.point;
        const basePoint = this.node.graph.cache.pointerDownList[0].point;
        workPlane.getNormalizeZ(_v1$5);
        workPlane.getNormalizeX(_v2$4);
        const delta = Math.PI * 2 / 4;
        workPlane.projectPoint(basePoint, _v3$4);
        workPlane.projectPoint(pointMove, _v4$2);
        p_delta$1.subVectors(_v4$2, _v3$4);
        vertices.push(basePoint);
        for (let i = 1; i < 4; i++) {
            vertices[i] = new Point();
            vertices[i].copy(vertices[i - 1]).add(p_delta$1.clone().applyAxisAngle(_v1$5, delta * (i - 1)));
        }
        if (this._rectangle == null) {
            this._rectangle = new Polygon([], _v2$4, basePoint);
            this.primitive = new Primitive("Polygon");
            this.primitive.geos.push(this._rectangle);
            this.primitive.temporary = true;
            this.node.graph.cache.primitiveList.push(this.primitive);
            storage.primitiveStore.tempPrimitiveDict[this.primitive.uuid] = this.primitive;
        }
        const edges = [];
        if (vertices.length > 0) {
            for (let i = 0; i < 4; i++) {
                edges.push(new Line$2(vertices[i], vertices[(i + 1) % 4]));
            }
            let keys = Object.keys(this.primitive.renderItemDict);
            if (keys.length > 0) {
                let renderItem = this.primitive.renderItemDict[keys[0]];
                renderItem.geoElements = this._rectangle.getGeoElementsIdxList();
                (_a = renderItem.mat) === null || _a === void 0 ? void 0 : _a.color.set(storage.layerStore.getColor());
            }
        }
        this._rectangle.setPolygon(edges);
    }
}
const _v1$5 = new Vector3();
const _v2$4 = new Vector3();
const _v3$4 = new Vector3();
const _v4$2 = new Vector3();
const p_delta$1 = new Vector3();class EventGraphRectangle extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node3 = new EventGraphNode(this, EventHandlerConfirm);
        const node4 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node5 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node6 = new EventGraphNode(this, EventHandlerCapture);
        const node7 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node8 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node9 = new EventGraphNode(this, EventHandlerCalTempRectangle);
        const node10 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node13 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node14 = new EventGraphNodeRender(this, true, UpdateType.MAIN);
        const node20 = new EventGraphNodeAND(this, null);
        const node21 = new EventGraphNodeNotice(this, new PythaEventNeedInput([{ type: NeedInputEnum.ACTIVE, description: "指定另一个角点", option: 'E', inputTypes: [PythaEventName.POINTER_DOWN] },]));
        const node22 = new EventGraphNodeNotice(this, new PythaEventNeedInput([{ type: NeedInputEnum.ACTIVE, description: "指定第一个角点", option: 'S', inputTypes: [PythaEventName.POINTER_DOWN] },]));
        const node23 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node24 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node25 = new EventGraphNode(this, EventHandlerGrid);
        const node26 = new EventGraphNode(this, EventHandlerGrid);
        const node27 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node28 = new EventGraphNode(this, EventHandlerInitCapture);
        const node29 = new EventGraphNode(this, EHChangeCrossCursor);
        const node30 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        this.addEdge(node1, node4);
        this.addEdge(node1, node3);
        this.addEdge(node8, node9);
        this.addEdge(node5, node6);
        this.addEdge(node6, node20);
        this.addEdge(node7, node20);
        this.addEdge(node20, node8);
        this.addEdge(node7, node21);
        this.addEdge(node3, node23);
        this.addEdge(node25, node14);
        this.addEdge(node9, node26);
        this.addEdge(node26, node13);
        this.addEdge(node10, node24);
        this.addEdge(node4, node27);
        this.addEdge(node27, node28);
        this.addEdge(node28, node5);
        this.addEdge(node4, node29);
        this.addEdge(node24, node30);
        this.addEdge(node30, node25);
        this.addEdge(node14, node23);
        this.addEdge(node21, node10);
        this.addEdge(node29, node22);
        this.addEdge(node22, node7);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/5
    }
}
EventGraphRectangle.cmd = "RECTANGLE";/**
 * 生成并更新临时圆柱体
 */
class EHGenTempCylinder extends EventHandlerBase {
    constructor() {
        super(...arguments);
        // 用于计算高度的临时变量，避免重复new
        this._cameraDir = new Vector3();
        this._screenUp = new Vector3();
        this.heightVec = new Vector3();
        // private _normal = new Vector3()
        this._extrudePlane = new Plane$1();
        this._projectPoint = new Point();
        this._vec = new Vector3();
        this._x = new Vector3();
        this._y = new Vector3();
        this._z = new Vector3();
        this._vec12 = new Vector3();
        this._vec13 = new Vector3();
        this._p1 = new Point();
        this._p2 = new Point();
        this._p3 = new Point();
    }
    run(data) {
        var _a, _b, _c, _d;
        // 获取存储
        const storage = PythaStorage.instance;
        const workPlane = storage.coordinateStore.workPlane;
        const pointerDownList = this.node.graph.cache.pointerDownList;
        if (pointerDownList.length < 1)
            return false;
        const primitiveList = this.node.graph.cache.primitiveList;
        // 使用ucs的坐标轴
        let ucs = storage.coordinateStore.activeUcs;
        this._x.set(ucs.elements[0], ucs.elements[1], ucs.elements[2]).normalize();
        this._y.set(ucs.elements[4], ucs.elements[5], ucs.elements[6]).normalize();
        this._z.set(ucs.elements[8], ucs.elements[9], ucs.elements[10]).normalize();
        // this._normal.copy(workPlane.normal); // 工作平面法向量
        if (primitiveList.length < 1) {
            // 创建圆柱
            let pointer = pointerDownList[0];
            let cylinder = new Cylinder(pointer.point, 1e-4, 1e-4, this._z, this._x);
            let primitive = new Primitive("Cylinder");
            primitive.geos.push(cylinder);
            let keys = Object.keys(primitive.renderItemDict);
            if (keys.length > 0) {
                let renderItem = primitive.renderItemDict[keys[0]];
                renderItem.geoElements = cylinder.getGeoElementsIdxList();
                (_a = renderItem.mat) === null || _a === void 0 ? void 0 : _a.color.set(storage.layerStore.getColor());
            }
            primitive.temporary = true;
            this.node.graph.cache.primitiveList.push(primitive);
            this.node.graph.cache.data["cylinder"] = cylinder;
            storage.primitiveStore.tempPrimitiveDict[primitive.uuid] = primitive;
        }
        let cylinder = this.node.graph.cache.data["cylinder"];
        const inputNumMap = this.node.graph.cache.inputNumber;
        //更新半径
        if (inputNumMap["R"] != null) { //优先考虑数值输入
            // 更新半径
            cylinder.radius = inputNumMap["R"];
        }
        else if (pointerDownList.map(pd => pd.option).includes("C") && !pointerDownList.map(pd => pd.option).includes("R")) {
            //如果含有C，但是没有R，则移动更新 底面半径
            let currentPoint;
            let radiusPointIdx = pointerDownList.findIndex(item => item.option === "R");
            let radiusPoint = (_b = pointerDownList[radiusPointIdx]) === null || _b === void 0 ? void 0 : _b.point;
            if (!!this.node.graph.cache.data['isPointDown'] && radiusPoint) {
                // 按下点或输入点
                currentPoint = radiusPoint;
                this.node.graph.cache.data['isPointDown'] = false;
            }
            else {
                currentPoint = this.node.graph.cache.pointerMove.point;
            }
            GeoMeasurement.getPointProjectToPlane(currentPoint, workPlane, _pointInPlane);
            cylinder.radius = _pointInPlane.distanceTo(pointerDownList[0].point);
        }
        //更新高度
        if (this.node.graph.cache.inputNumber['H'] != null && !Number.isNaN(this.node.graph.cache.inputNumber['H'])) { //优先考虑数值输入
            cylinder.height = +inputNumMap['H'];
        }
        else if (pointerDownList.map(pd => pd.option).includes("R") || inputNumMap["R"] != null) {
            //如果含有R，则移动更新高度 
            let currentPoint;
            let heightPointIdx = pointerDownList.findIndex(item => item.option === "H");
            let heightPoint = (_c = pointerDownList[heightPointIdx]) === null || _c === void 0 ? void 0 : _c.point;
            if (!!this.node.graph.cache.data['isPointDown'] && heightPoint) {
                // 按下点或输入点
                currentPoint = heightPoint;
                this.node.graph.cache.data['isPointDown'] = false;
            }
            else {
                currentPoint = this.node.graph.cache.pointerMove.point;
                // 捕捉点位置
                if (storage.captureStore.capturePoint != null) {
                    currentPoint.copy(storage.captureStore.capturePoint);
                }
                // 正交极轴位置
                if (storage.orthoPolarStore.orthoPolarPoint != null) {
                    currentPoint.copy(storage.orthoPolarStore.orthoPolarPoint);
                }
            }
            let height = 1e-5;
            let basePoint = pointerDownList[0].point;
            let normal = this._z.normalize();
            // 计算投影到屏幕的长度
            let viewportStore = storage.viewportStore;
            const camera = (_d = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _d === void 0 ? void 0 : _d.camera;
            this._p1.copy(basePoint).project(camera);
            this._p2.copy(currentPoint).project(camera);
            this._p3.copy(basePoint).add(normal).project(camera);
            this._vec12.subVectors(this._p2, this._p1);
            this._vec13.subVectors(this._p3, this._p1);
            let ratio = Math.sqrt(this._vec13.x * this._vec13.x + this._vec13.y * this._vec13.y);
            if (storage.captureStore.capturePoint != null) {
                // 捕捉到时，按捕捉位置计算高度
                currentPoint.copy(storage.captureStore.capturePoint);
                height = this._vec.subVectors(storage.captureStore.capturePoint, basePoint).dot(this._z);
            }
            else if (ratio < 1e-6) {
                // 如果视角刚好俯视立方体的z轴，则将鼠标与第二基点的距离设置为高度
                height = this._vec.subVectors(currentPoint, basePoint).length();
            }
            else {
                // 按投影计算高度
                camera.getWorldDirection(this._cameraDir);
                let up = this._vec.crossVectors(normal, this._cameraDir).cross(this._cameraDir).multiplyScalar(-1).normalize();
                let zLengthRatio = normal.dot(up); // 求ucs z轴在屏幕上的投影长度占总长度的比例
                let ndcHeight = (this._vec12.x * this._vec13.x + this._vec12.y * this._vec13.y) / ratio;
                this._vec13.x = this._vec13.x / ratio * ndcHeight;
                this._vec13.y = this._vec13.y / ratio * ndcHeight;
                height = this._p1.add(this._vec13).unproject(camera).sub(basePoint).dot(normal); // 这里求出需要拉长的高度
                height = height / zLengthRatio / zLengthRatio; // 由于ucs z轴不是平行于平面的，需要在z轴方向上找到于光标位置高度平齐的点，等同于逆求两次cos theta
            }
            this._z.normalize().multiplyScalar(height);
            let eles = cylinder.transformMatrix.elements;
            eles[8] = this._z.x;
            eles[9] = this._z.y;
            eles[10] = this._z.z;
            // // 判断相机方向是否与法向量同向
            // camera.getWorldDirection(this._cameraDir);
            // this._screenUp.copy(camera.up).cross(this._cameraDir).cross(this._cameraDir);
            // // 获得光标所在平面，该平面垂直于屏幕，且水平
            // this._extrudePlane.setFromNormalAndCoplanarPoint(this._screenUp, currentPoint);
            // this.heightVec = currentPoint.clone().sub(center);
            // if (Math.abs(this._screenUp.dot(this._normal)) < 1e-6) {
            //     cylinder.height = this.heightVec.length();
            // } else {
            //     GeoIntersection.PlaneIntersectStraightLine(this._extrudePlane, center, this._normal, this._projectPoint)
            //     let height = this._projectPoint.sub(center).length();
            //     if (this._projectPoint.angleTo(this._normal) > Math.PI / 2) {
            //         // this._normal.negate()
            //         cylinder.setNormal(this._normal.x, this._normal.y, this._normal.z)
            //     }
            //     cylinder.height = height
            // }
        }
        let primitive = this.node.graph.cache.primitiveList[0];
        primitive.needRedraw = true;
        return true;
    }
}
/**
 * 投影到当前工作平面的点，用以处理捕捉点不在当前工作平面上的情况
 */
const _pointInPlane = new Point();/**
 * 绘制圆柱体的图
 */
class EventGraphCylinder extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node3 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node4 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "确定圆柱底面中点", option: "C", inputTypes: [PythaEventName.POINTER_DOWN] }
            ] });
        const node5 = new EventGraphNode(this, EventHandlerConfirm);
        const node6 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node8 = new EventGraphNode(this, EHGenTempCylinder);
        const node9 = new EventGraphNode(this, EventHandlerCapture);
        const node10 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node11 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node12 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node13 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node17 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node18 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node23 = new EventGraphNode(this, EventHandlerGrid);
        const node24 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node25 = new EventGraphNode(this, EventHandlerGrid);
        const node28 = new EventGraphNode(this, EventHandlerInitCapture);
        const node29 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node30 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node31 = new EventGraphNode(this, EHChangeCrossCursor);
        const node33 = new EventGraphNode(this, EventHandlerNumberInput);
        const node34 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指点圆柱底面半径", option: "R", inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER] }
            ] });
        const node35 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定圆柱高度", option: "H", inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER] }
            ] });
        const node37 = new EventGraphNode(this, EventHandlerNumberInput);
        const node38 = new EventGraphNode(this, EHGenTempCylinder);
        const node39 = new EventGraphNode(this, EHMoveWorkPlane);
        const node40 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        const node41 = new EventGraphNode(this, null);
        const node42 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        this.addEdge(node5, node3);
        this.addEdge(node2, node9);
        this.addEdge(node23, node13);
        this.addEdge(node25, node12);
        this.addEdge(node8, node23);
        this.addEdge(node10, node8);
        this.addEdge(node24, node30);
        this.addEdge(node30, node25);
        this.addEdge(node4, node17);
        this.addEdge(node34, node18);
        this.addEdge(node34, node33);
        this.addEdge(node33, node18, EDGE_TYPE.STOP);
        this.addEdge(node18, node33, EDGE_TYPE.STOP);
        this.addEdge(node35, node11);
        this.addEdge(node35, node37);
        this.addEdge(node37, node11, EDGE_TYPE.STOP);
        this.addEdge(node11, node37, EDGE_TYPE.STOP);
        this.addEdge(node37, node38);
        this.addEdge(node38, node24);
        this.addEdge(node1, node6);
        this.addEdge(node31, node29);
        this.addEdge(node29, node28);
        this.addEdge(node28, node2);
        this.addEdge(node9, node10);
        this.addEdge(node1, node4);
        this.addEdge(node4, node5);
        this.addEdge(node17, node39);
        this.addEdge(node39, node40);
        this.addEdge(node40, node34);
        this.addEdge(node11, node38);
        this.addEdge(node12, node3);
        this.addEdge(node17, node8);
        this.addEdge(node18, node41);
        this.addEdge(node33, node41);
        this.addEdge(node41, node35);
        this.addEdge(node41, node8);
        this.addEdge(node9, node42);
        this.addEdge(node6, node31);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/18
    }
}
EventGraphCylinder.cmd = 'CYLINDER';/**
 * 生成并计算临时椭圆
 */
class EventHandlerCalTempEllipse extends EventHandlerBase {
    run(data) {
        const storage = PythaStorage.instance;
        const workPlane = storage.coordinateStore.workPlane;
        const pointerDownList = this.node.graph.cache.pointerDownList;
        if (pointerDownList.length < 1)
            return false;
        const primitiveList = this.node.graph.cache.primitiveList;
        if (primitiveList.length < 1) {
            let pointer = pointerDownList[0];
            let ellipse = new Ellipse(pointer.point, workPlane.getNormalizeX().multiplyScalar(1e-5), workPlane.getNormalizeY().multiplyScalar(1e-5));
            let primitive = new Primitive("Ellipse");
            primitive.geos.push(ellipse);
            let keys = Object.keys(primitive.renderItemDict);
            if (keys.length > 0) {
                let renderItem = primitive.renderItemDict[keys[0]];
                renderItem.geoElements = ellipse.getGeoElementsIdxList();
            }
            primitive.temporary = true;
            this.node.graph.cache.primitiveList.push(primitive);
            this.node.graph.cache.data["ellipse"] = ellipse;
            storage.primitiveStore.tempPrimitiveDict[primitive.uuid] = primitive;
        }
        let ellipse = this.node.graph.cache.data["ellipse"];
        const inputNumMap = this.node.graph.cache.inputNumber;
        // 若是当前通知需要半长轴
        if (this.node.graph.cache.needInput.option == "A") {
            const pointMove = storage.coordinateStore.currentPos;
            // 输入值
            if (inputNumMap["A"] != null) {
                let axisX = new Vector3().subVectors(pointMove, pointerDownList[0].point).normalize().multiplyScalar(inputNumMap["A"]);
                ellipse.axisA = axisX;
                ellipse.setXYZ(axisX.clone(), ellipse.getZ());
            }
            else { // 更新a轴半径
                let axisX = new Vector3().subVectors(pointMove, pointerDownList[0].point);
                ellipse.axisA = axisX;
                ellipse.setXYZ(axisX.clone(), ellipse.getZ());
            }
        }
        else {
            const pointMove = storage.coordinateStore.currentPos;
            let axisY = ellipse.getNormalizeY();
            if (Math.abs(axisY.length()) < 1e-5) {
                axisY = ellipse.getZ().cross(ellipse.getX()).normalize();
            }
            if (inputNumMap["B"] != null) {
                ellipse.axisB = axisY.multiplyScalar(inputNumMap["B"]);
            }
            else {
                // 计算半径
                let radius_b = pointMove.distanceTo(pointerDownList[0].point);
                ellipse.axisB = axisY.multiplyScalar(radius_b);
            }
        }
        this.node.graph.cache.primitiveList[0].needRedraw = true;
        return true;
    }
}/**
 * 生成椭圆图
 */
class EventGraphEllipse extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node3 = new EventGraphNode(this, EventHandlerConfirm);
        const node4 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node5 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node6 = new EventGraphNode(this, EventHandlerCapture);
        const node7 = new EventGraphNodeAND(this, null);
        const node8 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node10 = new EventGraphNode(this, EventHandlerCalTempEllipse);
        const node11 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node12 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node14 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node16 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node18 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node19 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                    type: NeedInputEnum.ACTIVE,
                    description: "指定椭圆的中心点",
                    option: "C",
                    inputTypes: [PythaEventName.POINTER_DOWN]
                }]
        });
        const node20 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                    type: NeedInputEnum.ACTIVE,
                    description: "指定椭圆的b轴长度",
                    option: "B",
                    inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER]
                }]
        });
        const node21 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                    type: NeedInputEnum.ACTIVE,
                    description: "指定椭圆的a轴",
                    option: "A",
                    inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER]
                }]
        });
        const node22 = new EventGraphNode(this, EventHandlerGrid);
        const node23 = new EventGraphNode(this, EventHandlerGrid);
        const node24 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node25 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node26 = new EventGraphNode(this, EventHandlerInitCapture);
        const node28 = new EventGraphNode(this, EHChangeCrossCursor);
        const node29 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node30 = new EventGraphNode(this, EventHandlerNumberInput);
        const node31 = new EventGraphNode(this, EventHandlerCalTempEllipse);
        const node32 = new EventGraphNode(this, EventHandlerNumberInput);
        const node33 = new EventGraphNode(this, EventHandlerCalTempEllipse);
        this.addEdge(node1, node3);
        this.addEdge(node3, node4);
        this.addEdge(node5, node6);
        this.addEdge(node6, node7);
        this.addEdge(node7, node8);
        this.addEdge(node8, node10);
        this.addEdge(node14, node24);
        this.addEdge(node23, node16);
        this.addEdge(node10, node22);
        this.addEdge(node22, node11);
        this.addEdge(node2, node25);
        this.addEdge(node25, node26);
        this.addEdge(node26, node5);
        this.addEdge(node24, node29);
        this.addEdge(node29, node23);
        this.addEdge(node1, node28);
        this.addEdge(node28, node2);
        this.addEdge(node1, node19);
        this.addEdge(node19, node18);
        this.addEdge(node21, node12);
        this.addEdge(node21, node30);
        this.addEdge(node16, node4);
        this.addEdge(node18, node21);
        this.addEdge(node12, node30, EDGE_TYPE.STOP);
        this.addEdge(node30, node12, EDGE_TYPE.STOP);
        this.addEdge(node20, node14);
        this.addEdge(node20, node32);
        this.addEdge(node32, node14, EDGE_TYPE.STOP);
        this.addEdge(node14, node32, EDGE_TYPE.STOP);
        this.addEdge(node32, node31);
        this.addEdge(node31, node24);
        this.addEdge(node12, node33);
        this.addEdge(node30, node33);
        this.addEdge(node33, node20);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/11
    }
}
EventGraphEllipse.cmd = 'ELLIPSE';// EventHandlerCalTempSphere
/**
 * 计算临时球
 */
class EventHandlerCalTempSphere extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a, _b;
        // 获取存储
        const storage = PythaStorage.instance;
        const pointerDownList = this.node.graph.cache.pointerDownList;
        if (pointerDownList.length < 1)
            return false;
        if (!this.node.graph.cache.data.sphere) {
            // 创建球
            let pointer = pointerDownList[pointerDownList.length - 1];
            this.node.graph.cache.data.sphere = new Sphere$2(pointer.point, 1e-5);
            this.node.graph.cache.data.primitive = new Primitive("Sphere");
            this.node.graph.cache.data.primitive.geos.push(this.node.graph.cache.data.sphere);
            let keys = Object.keys(this.node.graph.cache.data.primitive.renderItemDict);
            if (keys.length > 0) {
                let renderItem = this.node.graph.cache.data.primitive.renderItemDict[keys[0]];
                renderItem.geoElements = this.node.graph.cache.data.sphere.getGeoElementsIdxList();
                (_a = renderItem.mat) === null || _a === void 0 ? void 0 : _a.color.set(storage.layerStore.getColor());
            }
            this.node.graph.cache.data.primitive.temporary = true;
            this.node.graph.cache.primitiveList.push(this.node.graph.cache.data.primitive);
            storage.primitiveStore.tempPrimitiveDict[this.node.graph.cache.data.primitive.uuid] = this.node.graph.cache.data.primitive;
        }
        // 更新球半径
        if (this.node.graph.cache.inputNumber['R']) {
            //console.log('我进来了，我接受到了输入的半径：', this.node.graph.cache.inputNumber['R']);
            let radius = this.node.graph.cache.inputNumber['R'];
            if (radius == null || radius < 1e-6) {
                radius = 1e-5;
            }
            this.node.graph.cache.data.sphere.radius = radius;
        }
        else if ((_b = this.node.graph.cache.pointerMove) === null || _b === void 0 ? void 0 : _b.point) {
            // 计算半径
            //let pointMove = this.node.graph.cache.pointerMove.point;
            const pointMove = storage.coordinateStore.currentPos;
            let radius = pointMove.distanceTo(pointerDownList[pointerDownList.length - 1].point);
            if (radius < 1e-6) {
                radius = 1e-5;
            }
            this.node.graph.cache.data.sphere.radius = radius;
        }
        this.node.graph.cache.data.primitive.needRedraw = true;
        // this.node.graph.cache.inputNumber = null;
        return true;
    }
    /**
     * 销毁
     */
    dispose() {
        // this.primitive.needDelete = true;
    }
}class EventGraphSphere extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node3 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node4 = new EventGraphNode(this, EventHandlerCapture);
        const node5 = new EventGraphNode(this, EventHandlerConfirm);
        const node6 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node7 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node8 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node9 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node10 = new EventGraphNodeAND(this, null);
        const node11 = new EventGraphNode(this, EventHandlerCalTempSphere);
        const node12 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node13 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node14 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node15 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node19 = new EventGraphNode(this, EventHandlerGrid);
        const node20 = new EventGraphNode(this, EventHandlerGrid);
        const node21 = new EventGraphNode(this, EventHandlerNumberInput);
        const node23 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{ type: NeedInputEnum.ACTIVE, description: "指定半径", option: 'R', inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER] }
            ]
        });
        const node24 = new EventGraphNode(this, EventHandlerCalTempSphere);
        const node25 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{ type: NeedInputEnum.ACTIVE, description: "指定中心点", option: 'C', inputTypes: [PythaEventName.POINTER_DOWN] }
            ]
        });
        const node26 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node27 = new EventGraphNode(this, EHChangeCrossCursor);
        const node28 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node29 = new EventGraphNode(this, EventHandlerInitCapture);
        this.addEdge(node3, node4);
        this.addEdge(node4, node10);
        this.addEdge(node8, node10);
        this.addEdge(node10, node9);
        this.addEdge(node1, node5);
        this.addEdge(node5, node6);
        this.addEdge(node9, node11);
        this.addEdge(node12, node13);
        this.addEdge(node11, node20);
        this.addEdge(node20, node14);
        this.addEdge(node8, node23);
        this.addEdge(node1, node7);
        this.addEdge(node21, node24);
        this.addEdge(node24, node13);
        this.addEdge(node13, node26);
        this.addEdge(node26, node19);
        this.addEdge(node19, node15);
        this.addEdge(node15, node6);
        this.addEdge(node7, node27);
        this.addEdge(node7, node28);
        this.addEdge(node28, node29);
        this.addEdge(node29, node3);
        this.addEdge(node27, node25);
        this.addEdge(node25, node8);
        this.addEdge(node23, node21);
        this.addEdge(node23, node12);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/19
    }
}
/**
 * sphere指令 用于注册事件图
 */
EventGraphSphere.cmd = 'SPHERE';// import { PythaStorage } from "../../storage";
/**
 * 计算临时长方体
 */
class EventHandlerCalTempBox extends EventHandlerBase {
    constructor() {
        super(...arguments);
        /**
         * 临时变量，不存储任何信息，只为了减少瞬时内存消耗
         */
        this._cameraDir = new Vector3();
        this._normal = new Vector3();
        this._x = new Vector3();
        this._y = new Vector3();
        this._z = new Vector3();
        this._vec = new Vector3();
        this._vec12 = new Vector3();
        this._vec13 = new Vector3();
        this._p1 = new Point();
        this._p2 = new Point();
        this._p3 = new Point();
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a, _b, _c;
        // 获取存储
        const storage = PythaStorage.instance;
        const pointerDownList = this.node.graph.cache.pointerDownList;
        if (pointerDownList.length < 1)
            return false;
        // 使用ucs的坐标轴
        let ucs = storage.coordinateStore.activeUcs;
        this._x.set(ucs.elements[0], ucs.elements[1], ucs.elements[2]).normalize();
        this._y.set(ucs.elements[4], ucs.elements[5], ucs.elements[6]).normalize();
        this._z.set(ucs.elements[8], ucs.elements[9], ucs.elements[10]).normalize();
        if (pointerDownList.length === 1) {
            // 创建长方体
            if (!this.node.graph.cache.data.box) {
                // 基点
                let pointer = pointerDownList[pointerDownList.length - 1];
                // 创建并存入缓存
                this.node.graph.cache.data.box = new Box(pointer.point, this._x.multiplyScalar(1e-5), this._y.multiplyScalar(1e-5), this._z.multiplyScalar(1e-5));
                this.node.graph.cache.data.primitive = new Primitive("Box");
                this.node.graph.cache.data.primitive.geos.push(this.node.graph.cache.data.box);
                let keys = Object.keys(this.node.graph.cache.data.primitive.renderItemDict);
                if (keys.length > 0) {
                    let renderItem = this.node.graph.cache.data.primitive.renderItemDict[keys[0]];
                    renderItem.geoElements = this.node.graph.cache.data.box.getGeoElementsIdxList();
                    (_a = renderItem.mat) === null || _a === void 0 ? void 0 : _a.color.set(storage.layerStore.getColor());
                }
                this.node.graph.cache.data.primitive.temporary = true;
                this.node.graph.cache.primitiveList.push(this.node.graph.cache.data.primitive);
                storage.primitiveStore.tempPrimitiveDict[this.node.graph.cache.data.primitive.uuid] = this.node.graph.cache.data.primitive;
                // // 设置法向量
                // this._normal.copy(this._z).normalize();
            }
            // 移动点 第二角点
            let pointMove = this.node.graph.cache.pointerMove.point;
            // 设置长和宽
            let eles = this.node.graph.cache.data.box.transformMatrix.elements;
            let basePoint = this.node.graph.cache.data.box.getP();
            this._vec.subVectors(pointMove, basePoint);
            let scaleX = this._x.normalize().dot(this._vec);
            if (Math.abs(scaleX) < 1e-6) {
                scaleX = 1e-5;
            }
            this._x.multiplyScalar(scaleX);
            eles[0] = this._x.x;
            eles[1] = this._x.y;
            eles[2] = this._x.z;
            let scaleY = this._y.normalize().dot(this._vec);
            if (Math.abs(scaleY) < 1e-6) {
                scaleY = 1e-5;
            }
            this._y.multiplyScalar(scaleY);
            eles[4] = this._y.x;
            eles[5] = this._y.y;
            eles[6] = this._y.z;
            this.node.graph.cache.data.primitive.needRedraw = true;
            return true;
        }
        else if (pointerDownList.length === 2) {
            let pointMove;
            if (!!this.node.graph.cache.data['isPointDown']) {
                // 这里用户按下了点或输入点 确定第二角点
                let pd = this.node.graph.cache.pointerDownList[this.node.graph.cache.pointerDownList.length - 1].point;
                pointMove = pd;
                this.node.graph.cache.data['isPointDown'] = false;
                // 设置长和宽
                let eles = this.node.graph.cache.data.box.transformMatrix.elements;
                let basePoint = this.node.graph.cache.data.box.getP();
                let subVector = new Vector3().subVectors(pointMove, basePoint);
                if (Math.abs(subVector.x) < 1e-6) {
                    subVector.x = 1e-5;
                }
                if (Math.abs(subVector.y) < 1e-6) {
                    subVector.y = 1e-5;
                }
                this._x.normalize().multiplyScalar(subVector.x);
                eles[0] = this._x.x;
                eles[1] = this._x.y;
                eles[2] = this._x.z;
                this._y.normalize().multiplyScalar(subVector.y);
                eles[4] = this._y.x;
                eles[5] = this._y.y;
                eles[6] = this._y.z;
                this.node.graph.cache.data.primitive.needRedraw = true;
                return true;
            }
            let height = 1e-5;
            if (this.node.graph.cache.inputNumber['H'] != null && !Number.isNaN(this.node.graph.cache.inputNumber['H'])) {
                // 这里用户输入了高度H，直接赋值返回
                height = +this.node.graph.cache.inputNumber['H'];
                this._z.normalize().multiplyScalar(height);
                let eles = this.node.graph.cache.data.box.transformMatrix.elements;
                eles[8] = this._z.x;
                eles[9] = this._z.y;
                eles[10] = this._z.z;
                this.node.graph.cache.data.primitive.needRedraw = true;
                return true;
            }
            // 这里是用户鼠标沿高度方向移动
            let viewportStore = storage.viewportStore;
            const camera = (_b = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _b === void 0 ? void 0 : _b.camera;
            pointMove = this.node.graph.cache.pointerMove.point;
            // let basePoint = this.node.graph.cache.data.box.getP();
            let basePoint = this.node.graph.cache.pointerDownList[this.node.graph.cache.pointerDownList.length - 1].point;
            let normal = this._z.normalize();
            // 计算投影到屏幕的长度
            this._p1.copy(basePoint).project(camera);
            this._p2.copy(pointMove).project(camera);
            this._p3.copy(basePoint).add(normal).project(camera);
            this._vec12.subVectors(this._p2, this._p1);
            this._vec13.subVectors(this._p3, this._p1);
            let ratio = Math.sqrt(this._vec13.x * this._vec13.x + this._vec13.y * this._vec13.y);
            if (storage.captureStore.capturePoint) {
                // 如果有捕捉点，按捕捉点计算高度
                height = this._vec.subVectors(storage.captureStore.capturePoint, basePoint).dot(normal);
            }
            else if (ratio < 1e-6) {
                // 如果视角刚好俯视立方体的z轴，则将鼠标与第二基点的距离设置为高度
                height = this._vec.subVectors(pointMove, basePoint).length();
            }
            else {
                // 按投影计算高度
                camera.getWorldDirection(this._cameraDir);
                let up = this._vec.crossVectors(normal, this._cameraDir).cross(this._cameraDir).multiplyScalar(-1).normalize();
                let zLengthRatio = normal.dot(up); // 求ucs z轴在屏幕上的投影长度占总长度的比例
                let ndcHeight = (this._vec12.x * this._vec13.x + this._vec12.y * this._vec13.y) / ratio;
                this._vec13.x = this._vec13.x / ratio * ndcHeight;
                this._vec13.y = this._vec13.y / ratio * ndcHeight;
                height = this._p1.add(this._vec13).unproject(camera).sub(basePoint).dot(normal); // 这里求出需要拉长的高度
                height = height / zLengthRatio / zLengthRatio; // 由于ucs z轴不是平行于平面的，需要在z轴方向上找到于光标位置高度平齐的点，等同于逆求两次cos theta
            }
            this._z.normalize().multiplyScalar(height);
            let eles = this.node.graph.cache.data.box.transformMatrix.elements;
            eles[8] = this._z.x;
            eles[9] = this._z.y;
            eles[10] = this._z.z;
            this.node.graph.cache.data.primitive.needRedraw = true;
            return true;
        }
        else if (pointerDownList.length === 3) {
            // 这里用户按下了第三个点 计算方法和前面移动是一样的
            let basePoint = this.node.graph.cache.pointerDownList[this.node.graph.cache.pointerDownList.length - 2].point;
            let pointMove = this.node.graph.cache.pointerDownList[this.node.graph.cache.pointerDownList.length - 1].point;
            let viewportStore = storage.viewportStore;
            const camera = (_c = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _c === void 0 ? void 0 : _c.camera;
            let normal = this._z.normalize();
            // 计算投影到屏幕的长度
            this._p1.copy(basePoint).project(camera);
            this._p2.copy(pointMove).project(camera);
            this._p3.copy(basePoint).add(normal).project(camera);
            this._vec12.subVectors(this._p2, this._p1);
            this._vec13.subVectors(this._p3, this._p1);
            let ratio = Math.sqrt(this._vec13.x * this._vec13.x + this._vec13.y * this._vec13.y);
            let height = 1e-5;
            if (storage.captureStore.capturePoint) {
                // 如果有捕捉点，按捕捉点计算高度
                height = this._vec.subVectors(storage.captureStore.capturePoint, basePoint).dot(normal);
            }
            else if (ratio < 1e-6) {
                height = this._vec.subVectors(pointMove, basePoint).length();
            }
            else {
                camera.getWorldDirection(this._cameraDir);
                let up = this._vec.crossVectors(normal, this._cameraDir).cross(this._cameraDir).multiplyScalar(-1).normalize();
                let zLengthRatio = normal.dot(up); // 求ucs z轴在屏幕上的投影长度占总长度的比例
                let ndcHeight = (this._vec12.x * this._vec13.x + this._vec12.y * this._vec13.y) / ratio;
                this._vec13.x = this._vec13.x / ratio * ndcHeight;
                this._vec13.y = this._vec13.y / ratio * ndcHeight;
                height = this._p1.add(this._vec13).unproject(camera).sub(basePoint).dot(normal); // 这里求出需要拉长的高度
                height = height / zLengthRatio / zLengthRatio; // 由于ucs z轴不是平行于平面的，需要在z轴方向上找到于光标位置高度平齐的点，等同于逆求两次cos theta
            }
            this._z.normalize().multiplyScalar(height);
            let eles = this.node.graph.cache.data.box.transformMatrix.elements;
            eles[8] = this._z.x;
            eles[9] = this._z.y;
            eles[10] = this._z.z;
            this.node.graph.cache.data.primitive.needRedraw = true;
            return true;
        }
        // 更新长方体
        // this.node.graph.cache.data.primitive.needRedraw = true;
        // if (this.node.graph.cache.inputNumber['H']) this.node.graph.cache.data.box.height = this.node.graph.cache.inputNumber['H'];
        return true;
    }
}class EventGraphBox extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node3 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node5 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node6 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node7 = new EventGraphNode(this, EventHandlerCapture);
        const node8 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node9 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node10 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定第二个角点", option: 'E', inputTypes: [PythaEventName.POINTER_DOWN] }
            ] });
        const node11 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        const node12 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node13 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定高度", option: 'H', inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER] }
            ] });
        const node14 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node15 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node18 = new EventGraphNode(this, EventHandlerCalTempBox);
        const node19 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node20 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定第一个角点", option: 'S', inputTypes: [PythaEventName.POINTER_DOWN] }
            ] });
        const node21 = new EventGraphNode(this, EventHandlerGrid);
        const node22 = new EventGraphNode(this, EventHandlerGrid);
        const node23 = new EventGraphNode(this, EventHandlerNumberInput);
        const node27 = new EventGraphNode(this, EventHandlerCalTempBox);
        const node29 = new EventGraphNode(this, EventHandlerInitCapture);
        const node30 = new EventGraphNode(this, EHChangeCrossCursor);
        const node31 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node32 = new EventGraphNode(this, EventHandlerConfirm);
        this.addEdge(node9, node10);
        this.addEdge(node3, node7);
        this.addEdge(node9, node11);
        this.addEdge(node8, node13);
        this.addEdge(node18, node21);
        this.addEdge(node21, node19);
        this.addEdge(node6, node18);
        this.addEdge(node23, node27);
        this.addEdge(node27, node15);
        this.addEdge(node22, node14);
        this.addEdge(node14, node5);
        this.addEdge(node29, node3);
        this.addEdge(node2, node30);
        this.addEdge(node15, node31);
        this.addEdge(node31, node22);
        this.addEdge(node10, node8);
        this.addEdge(node13, node12);
        this.addEdge(node13, node23);
        this.addEdge(node23, node12, EDGE_TYPE.STOP);
        this.addEdge(node12, node23, EDGE_TYPE.STOP);
        this.addEdge(node30, node20);
        this.addEdge(node20, node9);
        this.addEdge(node1, node2);
        this.addEdge(node2, node29);
        this.addEdge(node7, node6);
        this.addEdge(node11, node18);
        this.addEdge(node12, node27);
        this.addEdge(node1, node32);
        this.addEdge(node32, node5);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/6
    }
}
/**
 * box指令 用于注册事件图
 */
EventGraphBox.cmd = 'BOX';/**
 * 生成并更新临时拉伸的图元
 */
class EventHandlerGenTempExtrude extends EventHandlerBase {
    constructor(node) {
        super(node);
        /**
         * 临时变量
         */
        this._z = new Vector3();
        /**
         * 拉伸中心
         */
        this.extCenter = new Point();
        // 计算拉伸高度的临时变量，避免频繁new
        this._screenUp = new Vector3();
        this._cameraDir = new Vector3();
        this._extrudePlane = new Plane$1();
        this.heightVec = new Vector3();
        this._normal = new Vector3();
        this._projectPoint = new Point();
        this._faceNormals = [];
        this._solidNormals = [];
        if (this.node.graph.cache.data["extrudePrimitiveList"])
            return;
        const storage = PythaStorage.instance;
        const workPlane = storage.coordinateStore.workPlane;
        const selectStore = PythaStorage.instance.selectStore;
        const selectPrimitives = selectStore.getUnlockedPrimitives();
        const extrudePrimitiveList = [];
        const extrudeSurfaceList = [];
        const exturdeSolidList = [];
        let extPriCount = 0;
        for (let i = 0; i < selectPrimitives.length; i++) {
            const pri = selectPrimitives[i];
            let isExt = false;
            for (let j = 0; j < pri.geos.length; j++) {
                let midGeo = pri.geos[j];
                //@ts-ignore
                if (!!midGeo.isCurve || midGeo instanceof Curve) {
                    // 生成线拉伸图元
                    // 拉伸图元拉伸方向确认
                    let extrudeSurface;
                    let midGeoClone = midGeo.clone();
                    // 复制坐标系
                    if (pri.worldModelMatrix) {
                        midGeoClone.transformMatrix.premultiply(pri.worldModelMatrix);
                    }
                    //@ts-ignore
                    extrudeSurface = new ExtrudeSurface(midGeoClone, workPlane.normal);
                    this._faceNormals.push(extrudeSurface.getNormalizeZ());
                    extrudeSurfaceList.push(extrudeSurface);
                    let surfacePrimitive = new Primitive("ExtrudeSurface");
                    this.addPrimitive(surfacePrimitive, [extrudeSurface]);
                    extrudePrimitiveList.push(surfacePrimitive);
                    this.node.graph.cache.primitiveList.push(surfacePrimitive);
                    if (!isExt) {
                        // 一个图元有很多geo，但是只需要放入一次pri
                        isExt = true;
                        this.node.graph.cache.deletePrimitiveList.push(pri);
                        let bbox = pri.getBoundingbox();
                        if (bbox) {
                            extPriCount++;
                            this.extCenter.add(new Vector3().addVectors(bbox.min, bbox.max).multiplyScalar(0.5));
                        }
                    }
                }
                //@ts-ignore
                if (!!midGeo.isSurface || midGeo instanceof Surface) {
                    // 生成面拉伸图元
                    // 复制坐标系
                    let midGeoClone = midGeo.clone();
                    if (pri.worldModelMatrix) {
                        midGeoClone.transformMatrix.premultiply(pri.worldModelMatrix);
                    }
                    //@ts-ignore
                    let extrudeSolid = new ExtrudeSolid(midGeoClone);
                    this._solidNormals.push(extrudeSolid.getNormalizeZ());
                    exturdeSolidList.push(extrudeSolid);
                    let solidPrimitive = new Primitive("ExtrudeSolid");
                    this.addPrimitive(solidPrimitive, [extrudeSolid]);
                    extrudePrimitiveList.push(solidPrimitive);
                    this.node.graph.cache.primitiveList.push(solidPrimitive);
                    if (!isExt) {
                        isExt = true;
                        this.node.graph.cache.deletePrimitiveList.push(pri);
                        let bbox = pri.getBoundingbox();
                        if (bbox) {
                            extPriCount++;
                            this.extCenter.add(new Vector3().addVectors(bbox.min, bbox.max).multiplyScalar(0.5));
                        }
                    }
                }
            }
        }
        if (extPriCount > 0) {
            this.extCenter.multiplyScalar(1 / extPriCount);
        }
        this.node.graph.cache.data["extrudePrimitiveList"] = extrudePrimitiveList;
        this.node.graph.cache.data["extrudeSurfaceList"] = extrudeSurfaceList;
        this.node.graph.cache.data["exturdeSolidList"] = exturdeSolidList;
    }
    run() {
        var _a;
        const extrudePrimitiveList = this.node.graph.cache.data["extrudePrimitiveList"];
        const extrudeSurfaceList = this.node.graph.cache.data["extrudeSurfaceList"];
        const exturdeSolidList = this.node.graph.cache.data["exturdeSolidList"];
        if (extrudePrimitiveList.length < 1)
            return false;
        const storage = PythaStorage.instance;
        const workPlane = storage.coordinateStore.workPlane;
        this._normal.copy(workPlane.normal).normalize();
        let viewportStore = storage.viewportStore;
        const camera = (_a = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        const pointMove = storage.coordinateStore.currentPos;
        const inputNumMap = this.node.graph.cache.inputNumber;
        this._z.copy(this._normal).normalize();
        // 计算底面的中心
        let center = this.extCenter.clone();
        // 计算拉伸高度
        let height = 1e-5;
        // 判断是否输入
        if (this.node.graph.cache.inputNumber['H'] != null && !Number.isNaN(this.node.graph.cache.inputNumber['H'])) {
            // 这里用户输入了高度H，直接赋值
            height = +inputNumMap["H"];
        }
        else if (storage.captureStore.capturePoint) {
            // 判断是否捕捉
            // 计算捕捉点到平面的投影点
            // height = this._vec.subVectors(storage.captureStore.capturePoint, center).dot(this._normal);
            let helpLine = new StraightLine(center, this._normal);
            let helpPoint = GeoRelation.StraightLineClosestPointToPoint(helpLine, storage.captureStore.capturePoint);
            height = helpPoint.sub(center).length();
            if (helpPoint.angleTo(this._normal) > Math.PI / 2) {
                height *= -1;
            }
        }
        else {
            height = this.calExtudeHeight(camera, pointMove, center);
        }
        for (let i = 0; i < extrudeSurfaceList.length; i++) {
            let midSurface = extrudeSurfaceList[i];
            if (height > 0 && height < 1e-6) {
                height = 1e-5;
            }
            else if (height < 0 && height > -1e-6) {
                height = -1e-5;
            }
            this._z.copy(this._faceNormals[i]).normalize();
            if (this._z.dot(this._normal) < -1e-6) {
                this._z.negate();
            }
            this._z.multiplyScalar(height);
            let eles = midSurface.transformMatrix.elements;
            eles[8] = this._z.x;
            eles[9] = this._z.y;
            eles[10] = this._z.z;
        }
        for (let i = 0; i < exturdeSolidList.length; i++) {
            let midSolid = exturdeSolidList[i];
            if (height > 0 && height < 1e-6) {
                height = 1e-5;
            }
            else if (height < 0 && height > -1e-6) {
                height = -1e-5;
            }
            this._z.copy(this._solidNormals[i]).normalize();
            if (this._z.dot(this._normal) < -1e-6) {
                this._z.negate();
            }
            this._z.multiplyScalar(height);
            let eles = midSolid.transformMatrix.elements;
            eles[8] = this._z.x;
            eles[9] = this._z.y;
            eles[10] = this._z.z;
        }
        extrudePrimitiveList.forEach(pri => {
            pri.needRedraw = true;
        });
        return true;
    }
    /**
     * 计算拉伸高度
     * @param camera
     * @param pointMove
     * @param center
     * @returns
     */
    calExtudeHeight(camera, pointMove, center) {
        camera.getWorldDirection(this._cameraDir);
        this._screenUp.copy(camera.up).cross(this._cameraDir).cross(this._cameraDir);
        // 获得光标所在平面，该平面垂直于屏幕，且水平
        this._extrudePlane.setFromNormalAndCoplanarPoint(this._screenUp, pointMove);
        this.heightVec = pointMove.clone().sub(center);
        let height = 1e-5;
        if (Math.abs(this._screenUp.dot(this._normal)) < 1e-6) {
            height = this.heightVec.length();
        }
        else {
            GeoIntersection.PlaneIntersectStraightLine(this._extrudePlane, center, this._normal, this._projectPoint);
            height = this._projectPoint.sub(center).length();
            if (this._projectPoint.angleTo(this._normal) > Math.PI / 2) {
                height *= -1;
            }
        }
        return height;
    }
    /**
     * 往图元添加几何属性
     * @param primitive
     * @param geos
     */
    addPrimitive(primitive, geos) {
        const storage = PythaStorage.instance;
        primitive.geos.push(...geos);
        let keys = Object.keys(primitive.renderItemDict);
        if (keys.length > 0) {
            let renderItem = primitive.renderItemDict[keys[0]];
            renderItem.geoElements = [];
            geos.forEach(geo => {
                let geoElementsLength = renderItem.geoElements.length;
                geo.getGeoElementsIdxList().forEach(idx => {
                    renderItem.geoElements.push(idx + geoElementsLength);
                });
            });
        }
        primitive.temporary = true;
        storage.primitiveStore.tempPrimitiveDict[primitive.uuid] = primitive;
        primitive.needRedraw = true;
    }
}/**
 * 生成和删除图元事件处理器
 */
class EventHandlerGenAndDeletePrimitives extends EventHandlerBase {
    run(data) {
        const storage = PythaStorage.instance;
        // 获取添加图元
        const tempPrimitives = this.node.graph.cache.primitiveList;
        tempPrimitives.forEach(primitive => {
            delete storage.primitiveStore.tempPrimitiveDict[primitive.uuid];
            primitive.uuid = BaseUtils.genUUID();
        });
        let cmds = [];
        if (tempPrimitives.length > 0) {
            // 添加命令
            cmds.push(new AddPrimitiveCmd(tempPrimitives, this.node.graph.eventMediator));
        }
        // 获取删除图元
        const deletePrimitives = this.node.graph.cache.deletePrimitiveList;
        if (deletePrimitives.length > 0) {
            cmds.push(new DeletePrimitiveCmd(deletePrimitives, this.node.graph.eventMediator));
        }
        if (cmds.length < 1)
            return true;
        // 判断缓存中是否有commandGroup
        const graphCache = this.node.graph.cache;
        const commandGroup = graphCache.data['commandGroup'];
        if (!commandGroup || !(commandGroup instanceof CommandGroup)) {
            // 组合命令
            const cmdGroup = new CommandGroup(cmds);
            storage.historyStore.undos.push(cmdGroup);
            cmdGroup.execute();
        }
        else {
            cmds.forEach(c => {
                commandGroup.addCmd(c);
            });
        }
        return true;
    }
}/**
 * 拉伸图
 */
class EventGraphExtrude extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerConfirm);
        const node3 = new EventGraphNode(this, EventHandlerGrid);
        const node4 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node5 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node6 = new EventGraphNodeSwitch(this, () => {
            // 判断是否已经选中了可以拉伸的图元
            if (this.checkSelectExtrudeEntity()) {
                return [1];
            }
            return [0];
        });
        const node7 = new EventGraphNode(this, EventHandlerGrid);
        const node8 = new EventGraphNode(this, EventHandlerCapture);
        const node9 = new EventGraphNode(this, EventHandlerGenTempExtrude);
        const node10 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node11 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node12 = new EventGraphNodeSwitch(this, () => {
            // 判断是否已经选中了可以拉伸的图元
            if (this.checkSelectExtrudeEntity()) {
                return [0];
            }
            return [1];
        });
        const node13 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node14 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node15 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node16 = new EventGraphNode(this, EventHandlerGenAndDeletePrimitives);
        const node17 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "请选择拉伸对象", option: 'CONFIRM', inputTypes: [PythaEventName.CONFIRM] },
            ]
        });
        const node18 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                    type: NeedInputEnum.ACTIVE,
                    description: "请确定拉伸高度",
                    option: "H",
                    inputTypes: [PythaEventName.NUMBER, PythaEventName.POINTER_DOWN]
                }]
        });
        const node19 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '未选中图元' });
        const node20 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node21 = new EventGraphNode(this, EventHandlerInitCapture);
        const node22 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node23 = new EventGraphNode(this, EHChangeCrossCursor);
        const node25 = new EventGraphNode(this, EventHandlerNumberInput);
        const node27 = new EventGraphNode(this, EventHandlerDisableClamp);
        const node28 = new EventGraphNode(this, EHChangePickCursor);
        const node29 = new EventGraphNodeSwitch(this, () => {
            const inputNumMap = this.cache.inputNumber;
            // 判断是否输入
            if (inputNumMap['H'] != null && !Number.isNaN(inputNumMap['H'])) {
                // 这里用户输入了高度H
                return [1];
            }
            return [0];
        });
        this.addEdge(node4, node8);
        this.addEdge(node8, node10);
        this.addEdge(node2, node12);
        /**选中图元*/
        this.addEdge(node12, node5);
        this.addEdge(node10, node9);
        this.addEdge(node7, node14);
        this.addEdge(node15, node16);
        this.addEdge(node3, node13);
        this.addEdge(node5, node18);
        /**未选中图元*/
        this.addEdge(node6, node17);
        this.addEdge(node13, node11);
        this.addEdge(node20, node21);
        this.addEdge(node21, node4);
        this.addEdge(node16, node22);
        this.addEdge(node22, node3);
        this.addEdge(node1, node6);
        this.addEdge(node5, node23);
        this.addEdge(node18, node25);
        this.addEdge(node18, node15);
        this.addEdge(node25, node15, EDGE_TYPE.STOP);
        this.addEdge(node15, node25, EDGE_TYPE.STOP);
        this.addEdge(node19, node11);
        this.addEdge(node23, node27);
        this.addEdge(node27, node20);
        this.addEdge(node17, node28);
        this.addEdge(node28, node2);
        this.addEdge(node25, node9);
        this.addEdge(node9, node29);
        /**没有输入高度*/
        this.addEdge(node29, node7);
        /**已经选中图元*/
        this.addEdge(node6, node5);
        /**未选中图元*/
        this.addEdge(node12, node19);
        /**输入了高度*/
        this.addEdge(node29, node16);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/91
    }
    /**
     * 判断是否选中了可以拉伸的图元（curve，surface）
     * @returns
     */
    checkSelectExtrudeEntity() {
        const selectStore = PythaStorage.instance.selectStore;
        const selectPrimitives = selectStore.selectPrimitives;
        for (let i = 0; i < (selectPrimitives === null || selectPrimitives === void 0 ? void 0 : selectPrimitives.length); i++) {
            let pri = selectPrimitives[i];
            for (let j = 0; j < pri.geos.length; j++) {
                let midGeo = pri.geos[j];
                //@ts-ignore
                if (!!midGeo.isCurve || midGeo instanceof Curve) {
                    return true;
                }
                //@ts-ignore
                if (midGeo.isSurface || midGeo instanceof Surface) {
                    return true;
                }
            }
        }
        return false;
    }
}
EventGraphExtrude.cmd = 'EXTRUDE';/**
 * 块
 */
class BlockPrimitive extends Primitive {
    /**
     * 构造函数
     * @param uuid
     */
    constructor(type = "Block", uuid = null) {
        super(type);
        /**
         * 类型
         */
        this.type = "Block";
        /**
         * 颜色随图层
         */
        this.colorByLayer = false;
        /**
         * 是否是模板块
         */
        this.isTemplate = false;
        this.type = "Block";
        // 清空渲染相关的信息
        this.renderItemDict = {};
        this.materials = {};
        this.localModelMatrix = new Matrix4();
    }
    /**
     * 静态方法，块模版和块图元的世界矩阵求当前块图元的包围盒
     * @param primitive 块模版图元
     * @param parentWorldMatrix 实际块图元的世界矩阵
     * @param blockTemplateDict 块模版字典
     * @returns
     */
    static calBlockBoundingBox(primitive, parentWorldMatrix, blockTemplateDict, target = null) {
        if (target == null) {
            target = new Box3();
        }
        if (primitive == null) {
            target.makeEmpty();
            return target;
        }
        /**
         * 如果没有子图元，不将点设置为1e10，直接返回
         */
        if (Object.keys(primitive.children).length === 0) {
            target.makeEmpty();
            return target;
        }
        target.set(new Point(1e10, 1e10, 1e10), new Point(-1e10, -1e10, -1e10));
        for (let key of Object.keys(primitive.children)) {
            let child = primitive.children[key];
            const box = child.getBoundingbox();
            bbox.set(box.min, box.max);
            if (!!parentWorldMatrix) {
                bbox.applyMatrix4(parentWorldMatrix);
            }
            if (child.type == "Block") {
                // 子图元也是块
                let bt = blockTemplateDict[child.blockTemplateUuid];
                let mat = child.worldModelMatrix.clone();
                if (!!parentWorldMatrix) {
                    mat.premultiply(parentWorldMatrix);
                }
                BlockPrimitive.calBlockBoundingBox(bt, mat, blockTemplateDict, bbox);
            }
            if (bbox.min == null || bbox.max == null)
                return target;
            // 更新包围盒
            if (bbox.min.x < target.min.x)
                target.min.x = bbox.min.x;
            if (bbox.min.y < target.min.y)
                target.min.y = bbox.min.y;
            if (bbox.min.z < target.min.z)
                target.min.z = bbox.min.z;
            if (bbox.max.x > target.max.x)
                target.max.x = bbox.max.x;
            if (bbox.max.y > target.max.y)
                target.max.y = bbox.max.y;
            if (bbox.max.z > target.max.z)
                target.max.z = bbox.max.z;
        }
        return target;
    }
    /**
     * 复制图元
     * @param primitive
     * @returns
     */
    copy(primitive) {
        if (primitive.type !== this.type)
            return this;
        // 复制图元自身属性
        this.parentUuid = primitive.parentUuid;
        this.layerUuid = primitive.layerUuid;
        this.group = primitive.group;
        this.blockTemplateUuid = primitive.blockTemplateUuid; // 块模板索引
        // this.isTemplate = primitive.isTemplate;
        this.renderGroupKeys = primitive.renderGroupKeys;
        if (!!primitive.localModelMatrix) {
            if (this.localModelMatrix == null)
                this.localModelMatrix = new Matrix4();
            this.localModelMatrix.copy(primitive.localModelMatrix);
        }
        this.parent = primitive.parent;
        // 复制子图元
        Object.keys(primitive.children).forEach(key => {
            let child = primitive.children[key].clone();
            this.addChildPrimitive(child);
        });
        // 更新自身及子图元的变换矩阵
        this.updateWorldModelMatrix(false, true);
        return this;
    }
    /**
     * 克隆图元
     */
    clone() {
        return new BlockPrimitive(this.type).copy(this);
    }
    /**
     * 抽象成json数据格式
     * @returns
     */
    toJson() {
        var _a;
        let data = super.toJson();
        let res = Object.assign(Object.assign({}, data), { blockTemplateUuid: this.blockTemplateUuid, isTemplate: this.isTemplate, geos: [], materials: [], renderItems: [] });
        if (((_a = this.localModelMatrix) === null || _a === void 0 ? void 0 : _a.elements) && !this.localModelMatrix.elements.includes(null)) {
            data['localModelMatrix'] = this.localModelMatrix.elements;
        }
        if (this.isTemplate && Object.keys(this.children).length > 0) {
            // 模板块 需要将子图元一同存入
            let childJson = [];
            for (let key of Object.keys(this.children)) {
                let child = this.children[key];
                if (child == null)
                    continue;
                childJson.push(child.toJson());
            }
            res['children'] = childJson;
        }
        return res;
    }
    /**
     * 解析数据成对象
     */
    fromJson(json) {
        var _a;
        this.uuid = json.uuid;
        if (json.localModelMatrix) {
            if (this.localModelMatrix == null) {
                this.localModelMatrix = new Matrix4();
            }
            this.localModelMatrix.fromArray(json.localModelMatrix);
            if (this.localModelMatrix.elements.includes(null)) {
                this.localModelMatrix = new Matrix4();
            }
        }
        this.type = json.type;
        this.parentUuid = json.parentUuid;
        this.layerUuid = json.layerUuid;
        this.name = json.name || '';
        this.group = (json === null || json === void 0 ? void 0 : json.group) ? json === null || json === void 0 ? void 0 : json.group : {};
        this.renderGroupKeys = [];
        (_a = this.group) === null || _a === void 0 ? void 0 : _a.forEach(uuid => {
            this.addKeyToGroup(uuid);
        });
        this.materials = {};
        this.renderItemDict = {};
        this.geos = [];
        this.isTemplate = !!json.isTemplate;
        this.blockTemplateUuid = json.blockTemplateUuid;
        this.updateWorldModelMatrix(false, true);
        return this;
    }
    /**
     * 查找块内子图元的renderItem
     * @param renderItemUuid
     * @param primitive
     * @returns
     */
    findBlockRenderItem(renderItemUuid, primitive = this) {
        if (primitive.type == "Block") {
            for (let key of Object.keys(primitive.children)) {
                let child = primitive.children[key];
                let res = this.findBlockRenderItem(renderItemUuid, child);
                if (res != null)
                    return res;
            }
        }
        else {
            for (let key of Object.keys(primitive.renderItemDict)) {
                let renderItem = primitive.renderItemDict[key];
                if (renderItem.uuid == renderItemUuid)
                    return renderItem;
            }
        }
        return null;
    }
    /**
     * 获取控制点
     */
    getControlPoints() {
        let res = [];
        let fp = {
            /**
             * 特征点类型
             */
            type: FEATURE_POINT_TYPE.CENTER,
            /**
             * 特征点坐标
             */
            point: this.getP()
        };
        res.push(fp);
        return res;
    }
}
/**
 * 计算包围盒的临时变量
 */
const bbox = new Box3();/**
 * 渲染测试专用节点，测试用例请以函数的方式保存在文件中
 */
class EHTestRender extends EventHandlerBase {
    addPrimitive(primitive, geos) {
        const storage = PythaStorage.instance;
        primitive.geos.push(...geos);
        let keys = Object.keys(primitive.renderItemDict);
        if (keys.length > 0) {
            let renderItem = primitive.renderItemDict[keys[0]];
            renderItem.geoElements = [];
            geos.forEach(geo => {
                let geoElementsLength = renderItem.geoElements.length;
                geo.getGeoElementsIdxList().forEach(idx => {
                    renderItem.geoElements.push(idx + geoElementsLength);
                });
            });
            if (primitive.isBoolPrimitive()) {
                primitive.renderItemDict[keys[0]].geoElements = [];
                primitive.renderItemDict[keys[0]].geoElements.push(0);
            }
        }
        primitive.temporary = false;
        storage.primitiveStore.primitiveDict[primitive.uuid] = primitive;
        primitive.needRedraw = true;
    }
    run(data) {
        // this.lineRender();
        // this.revolveSurfaceRender();
        // this.revolveSolidRender();
        // this.textGenCircle();
        //this.testFontBox("1324.23", 400, 0.7)
        // this.sectionRender();
        // this.mockAxis();
        // this.extrudeSur();
        // this.generalRegion();
        this.drawBoundingBoxForSelects();
        // this.holeRegion();
        return true;
    }
    drawBoundingBoxForSelects() {
        const selects = this.getPythaStorage().selectStore.getUnlockedPrimitives();
        selects.forEach(select => {
            let bbox = this.calBoundingBoxFromPri(select);
            this.testBoundingBox(bbox.min, bbox.max);
        });
    }
    holeRegion() {
        let outCilcle = new Circle(new Point(0, 0, 0), 0.4 * 1000 / 2);
        let inCilcle = new Circle(new Point(0, 0, 0), 0.4 * 1000 / 2 - 0.02 * 1000);
        let regionface = new RegionFace();
        regionface.holes = [new RegionFace([inCilcle], new Vector3(1, 0, 0), new Point(0, 0, 0))];
        regionface.setRegionFace([outCilcle]);
        const p1 = new Primitive("RegionFace");
        this.addPrimitive(p1, [regionface]);
    }
    generalRegion() {
        const l1 = new Line$2(new Vector3(0, 0, 0), new Vector3(20, 0, 0));
        const l2 = new Line$2(new Vector3(20, 0, 0), new Vector3(10, 20, 0));
        const l3 = new Line$2(new Vector3(10, 20, 0), new Vector3(10, -20, 0));
        const l4 = new Line$2(new Vector3(10, -20, 0), new Vector3(0, 0, 0));
        const e1 = new ExtrudeSurface(l1);
        const e2 = new ExtrudeSurface(l2);
        const e3 = new ExtrudeSurface(l3);
        const e4 = new ExtrudeSurface(l4);
        const p1 = new Primitive("ExtrudeSurface");
        const p2 = new Primitive("ExtrudeSurface");
        const p3 = new Primitive("ExtrudeSurface");
        const p4 = new Primitive("ExtrudeSurface");
        this.addPrimitive(p1, [e1]);
        this.addPrimitive(p2, [e2]);
        this.addPrimitive(p3, [e3]);
        this.addPrimitive(p4, [e4]);
        const p5 = new Primitive("Board");
        p5.children[p1.uuid] = p1;
        p5.children[p2.uuid] = p2;
        p5.children[p3.uuid] = p3;
        p5.children[p4.uuid] = p4;
        this.addPrimitive(p2, []);
        // const region = new RegionFace([l1, l2, l3, l4], new Vector3(1, 0, 0));
        // const p1 = new Primitive(PrimitiveType.RegionFace);
        // this.addPrimitive(p1, [region]);
    }
    extrudeSur() {
        const circle = new Circle(new Vector3(0, 0, 0), 20);
        const region = new RegionFace([circle]);
        const transformMatrix = region.transformMatrix;
        const axisZ = new Vector3(0, 0, 1);
        const axisY = new Vector3(0, 1, 0);
        // 创建一个旋转矩阵，绕 Z 轴旋转 -90 度
        const rotationZ = new Matrix4().makeRotationAxis(axisZ, -Math.PI / 2);
        // 创建一个旋转矩阵，绕 Y 轴旋转 90 度
        const rotationY = new Matrix4().makeRotationAxis(axisY, Math.PI / 2);
        const m1 = new Matrix4().premultiply(transformMatrix).premultiply(rotationZ).premultiply(rotationY);
        transformMatrix.copy(m1);
        const ext = new ExtrudeSolid(region, 50);
        const p2 = new Primitive(PrimitiveType.ExtrudeSoild);
        const v = new Vector3(0, 0, 10);
        if (!p2.localModelMatrix) {
            p2.localModelMatrix = new Matrix4();
        }
        v.applyMatrix4(p2.localModelMatrix.clone().invert());
        ext.offsetDirection = v;
        p2.move(new Vector3(10, 0, 0));
        p2.move(new Vector3(0, 10, 0));
        this.addPrimitive(p2, [ext]);
        // const p1 = new Primitive(PrimitiveType.Circle);
        // const ext = new ExtrudeSurface(circle, new Vector3(10, 0, 10));
        // const p2 = new Primitive(PrimitiveType.ExtrudeSurface);
        // this.addPrimitive(p2, [ext]);
    }
    testFontBox(text, fontSize, widthRatio) {
        var _a, _b;
        let textPrimitive = new TextPrimitive("Text");
        const storage = this.getPythaStorage();
        const font = storage.textStore.font;
        if (font == null)
            return null;
        textPrimitive.temporary = true;
        let keys = Object.keys(textPrimitive.renderItemDict);
        if (keys.length <= 0)
            return null;
        let renderItem = textPrimitive.renderItemDict[keys[0]];
        textPrimitive = textPrimitive;
        textPrimitive.text = text;
        textPrimitive.fontSize = fontSize;
        textPrimitive.widthRatio = widthRatio;
        let offsetX = 0; // 文字偏移 每个文字的起点移到已有文字的最右边
        let geoIndex = 0;
        // 在局部坐标系内解析文字
        for (let i = 0; i < text.length; i++) {
            const char = text[i];
            if (char === ' ') {
                // 空格直接偏移
                offsetX += fontSize / 4;
                continue;
            }
            let glyph = font.charToGlyph(char);
            if (((_b = (_a = glyph === null || glyph === void 0 ? void 0 : glyph.path) === null || _a === void 0 ? void 0 : _a.commands) === null || _b === void 0 ? void 0 : _b.length) <= 0) {
                glyph = font.charToGlyph("?");
            }
            const path = glyph.getPath(0, 0, fontSize);
            const commands = path.commands || [];
            let startX = 0, startY = 0; // 起点
            let x = 0, y = 0; // 当前点
            let maxX = 0; // 解析到的最右侧坐标
            for (let cmd of commands) {
                switch (cmd.type) {
                    case 'M':
                        startX = cmd.x * widthRatio + offsetX;
                        startY = -cmd.y;
                        x = cmd.x * widthRatio + offsetX;
                        y = -cmd.y;
                        break;
                    case 'L':
                    case 'Q':
                    case 'C':
                        x = cmd.x * widthRatio + offsetX;
                        y = -cmd.y;
                        let line = new Line$2(new Point(startX, startY), new Point(x, y));
                        textPrimitive.geos.push(line);
                        renderItem.geoElements.push(geoIndex);
                        geoIndex++;
                        startX = x;
                        startY = y;
                        break;
                }
                if (maxX < x)
                    maxX = x;
            }
            offsetX = maxX + 0; // 偏移到最右侧 + 字间距
        }
        let box = textPrimitive.getBoundingbox();
        this.testBoundingBox(box.min, box.max);
        textPrimitive.temporary = false;
        storage.primitiveStore.primitiveDict[textPrimitive.uuid] = textPrimitive;
        textPrimitive.needRedraw = true;
    }
    textGenCircle() {
        let primitive = new Primitive("Circle");
        let circle = new Circle(new Point(1, 1, 1), 1, new Vector3(0, 0, 1), new Vector3(1, 0, 0));
        this.addPrimitive(primitive, [circle]);
    }
    textBlockMove() {
        const block = new BlockPrimitive();
        block.blockTemplateUuid = "455f86af-25cc-42ef-8b10-2f26863bd60a";
        this.addPrimitive(block, []);
        const blockMove = block.clone();
        blockMove.move(new Vector3(0, 10, 0));
        this.addPrimitive(blockMove, []);
    }
    circleRender() {
        let circle = new Circle(new Point(0, 0, 0), 50);
        let primitive = new Primitive("circle");
        this.addPrimitive(primitive, [circle]);
    }
    ellipseSurfaceRender() {
        let ellipseFace = new EllipseSurface(new Point(2, 0, 0), new Vector3(2, 0, 0), new Vector3(0, 1, 0));
        let primitive = new Primitive("ellipseFace");
        this.addPrimitive(primitive, [ellipseFace]);
    }
    lineRender() {
        // const line = new Line(new Point(20, 0, 0), new Point(80, 0, 0));
        // const line2 = new Line(new Point(60, 80, 0), new Point(60, -80, 0));
        // let primitive = new Primitive("Line");
        // let primitive2 = new Primitive("Line");
        // this.addPrimitive(primitive, [line]);
        // this.addPrimitive(primitive2, [line2]);
        // console.log("primitive", primitive)
        const line3 = new Line$2(new Point(-40, 0, 0), new Point(-20, 0, 0));
        const line4 = new Line$2(new Point(-20, 0, 0), new Point(-20, 20, 0));
        const line5 = new Line$2(new Point(-20, 20, 0), new Point(-40, 20, 0));
        const line6 = new Line$2(new Point(-40, 20, 0), new Point(-40, 0, 0));
        let primitive3 = new Primitive("Line");
        let primitive4 = new Primitive("Line");
        let primitive5 = new Primitive("Line");
        let primitive6 = new Primitive("Line");
        primitive6.lock = true;
        this.addPrimitive(primitive3, [line3]);
        this.addPrimitive(primitive4, [line4]);
        this.addPrimitive(primitive5, [line5]);
        this.addPrimitive(primitive6, [line6]);
        // const arc = new Arc(new Point(0, 0, 0), 20, Math.PI);
        // const primitive1 = new Primitive("Arc");
        // this.addPrimitive(primitive1, [arc]);
        // const line = new Line(new Point(-20, 0, 0), new Point(20, 0, 0));
        // const primitive2 = new Primitive("Line");
        // this.addPrimitive(primitive2, [line]);
    }
    /**
     * 测试用例-一般体渲染
     */
    bool3Render() {
        const left = new Box(new Point(0, 0, 0), new Point(2, 0, 0), new Point(3, 0, 0), new Point(4, 0, 0));
        const right = new Box(new Point(1, 1, 0), new Point(2, 0, 0), new Point(3, 0, 0), new Point(4, 0, 0));
        let primitiveLeft = new Primitive("left");
        let primitiveRight = new Primitive("right");
        primitiveLeft.geos.push(left);
        primitiveRight.geos.push(right);
        let primitiveBool3 = new Primitive("bool");
        primitiveBool3.leftPrimitive = primitiveLeft;
        primitiveBool3.rightPrimitive = primitiveRight;
        primitiveBool3.boolOpe = BoolOpeType.SUBSTRACT;
        this.addPrimitive(primitiveBool3, []);
    }
    /**
     * 测试用例-一般面域渲染
     */
    generalRegionRender() {
        const generalRegion = new GeneralRegion([
            [new Point(0, 0, 0), new Point(4, 0, 0), new Point(4, 4, 0), new Point(0, 4, 0)],
            [new Point(1, 1, 0), new Point(1, 2, 0), new Point(2, 2, 0), new Point(2, 1, 0)]
        ], new Vector3(0, 0, 1));
        let primitive = new Primitive("Line");
        this.addPrimitive(primitive, [generalRegion]);
    }
    /**
     * 测试用例-一般面域渲染
     */
    bool2Render() {
        const left = new GeneralRegion([
            [
                new Point(0, 0, 0),
                new Point(3, 0, 0),
                new Point(3, 3, 0),
                new Point(0, 3, 0),
            ],
        ], new Vector3(0, 0, 1));
        const right = new RegionFace([
            new Circle(new Point(1, 1, 0), 0.4, new Vector3(0, 0, 1), new Vector3(1, 0, 0))
        ], new Vector3(1, 0, 0), new Point(0, 0, 0));
        let primitiveLeft = new Primitive("left");
        let primitiveRight = new Primitive("right");
        primitiveLeft.geos.push(left);
        primitiveRight.geos.push(right);
        let primitiveBool2 = new Primitive("bool");
        primitiveBool2.leftPrimitive = primitiveLeft;
        primitiveBool2.rightPrimitive = primitiveRight;
        primitiveBool2.boolOpe = BoolOpeType.SUBSTRACT;
        this.addPrimitive(primitiveBool2, []);
    }
    /**
     * 测试用例，楔体
     */
    wedgeRender() {
        let geo = new Wedge(new Point(-14.668148271506652, 6.735434324538801, 2), 4.073956329288194, 25.93477344576968, 22.903569283255806, new Point(-1, 0, 0), new Point(0, 0, 1));
        let primitive = new Primitive("Wedge");
        this.addPrimitive(primitive, [geo]);
    }
    /**
     * 测试用例，旋转体
     */
    revolveSurfaceRender() {
        // 以200，200， 0为旋转轴，旋转一周得到的图形（锥面）
        let revolveSurface1 = new RevolveSurface(new Line$2(new Point(200, 200, 50), new Point(230, 230, 0)), new StraightLine(new Point(200, 200, 0), new Vector3(0, 0, 1)), 2 * Math.PI);
        let primitive1 = new Primitive("旋转图元");
        this.addPrimitive(primitive1, [revolveSurface1]);
        // 以0，0， 0为旋转轴，旋转一周得到的图形（锥面）
        let revolveSurface2 = new RevolveSurface(new Line$2(new Point(0, 0, 50), new Point(-70, -70, 0)), new StraightLine(new Point(0, 0, 0), new Vector3(0, 0, 1)), 2 * Math.PI);
        let primitive2 = new Primitive("旋转图元");
        this.addPrimitive(primitive2, [revolveSurface2]);
        // 以0，0， 0为旋转轴，旋转一周得到的图形（锥面）
        let revolveSurface3 = revolveSurface2.clone().rotate(new Point(-50, -50, 0), new Vector3(0, 0, 1), Math.PI / 2);
        let primitive3 = new Primitive("旋转图元");
        this.addPrimitive(primitive3, [revolveSurface3]);
        // 圆环面
        let revolveSurface4 = new RevolveSurface(new Circle(new Point(-300, 300, 0), 30, new Vector3(1, 0, 0), new Vector3(0, 0, 1)), new StraightLine(new Point(-400, 400, 0), new Vector3(0, 0, 1)), 2 * Math.PI);
        let primitive4 = new Primitive("旋转图元");
        this.addPrimitive(primitive4, [revolveSurface4]);
    }
    /**
     * 测试用例、旋转体
     */
    revolveSolidRender() {
        // const l1 = new Line(new Point(0, 0, 0), new Point(100, 0, 0));
        // const l2 = new Line(new Point(100, 0, 0), new Point(100, 100, 0));
        // const l3 = new Line(new Point(100, 100, 0), new Point(0, 100, 0));
        // const l4 = new Line(new Point(0, 100, 0), new Point(0, 0, 0));
        const circle = new Circle(new Point(0, 0, 0), 50, new Vector3(0, 0, 1), new Vector3(1, 0, 0));
        const region = new RegionFace([circle]);
        // const e = new ExtrudeSolid(region, 100);
        const l = new StraightLine(new Point(-100, 0, 0), new Vector3(0, 1, 0));
        const solid = new RevolveSolid(region, l, Math.PI / 2);
        // const p = new Primitive("RevolveSolid");
        const p = new Primitive("RevolveSolid");
        // // this.addPrimitive(p, [polygon]);
        this.addPrimitive(p, [solid]);
        // this.addPrimitive(p, [solid]);
    }
    /**
     * 测试用例 圆环体
     */
    torusRender() {
        let torus5 = new Torus(new Point(0, 0, 0), 50, new Vector3(0, 0, 1), new Vector3(1, 0, 0), 20);
        let primitive5 = new Primitive("Torus");
        this.addPrimitive(primitive5, [torus5]);
    }
    /**
     * 测试椭圆弧
     */
    ellipseArcRender() {
        new EllipseArc(new Point(2, 0, 0), new Vector3(2, 0, 0), new Vector3(0, 1, 0), Math.PI);
        let ellipseArc2 = new EllipseArc(new Point(2, 2, 0), new Vector3(2, 0, 0), new Vector3(0, 1, 0), Math.PI * 2);
        new EllipseArc(new Point(-6, 0, 0), new Vector3(2, 0, 0), new Vector3(0, 1, 0), Math.PI * 3 / 2);
        let primitive5 = new Primitive("ellipseArcs");
        this.addPrimitive(primitive5, [ellipseArc2]);
        const p1 = ellipseArc2.getPointAt(0);
        const p2 = ellipseArc2.getPointAt(0.25);
        const p3 = ellipseArc2.getPointAt(0.5);
        const p4 = ellipseArc2.getPointAt(0.75);
        const c1 = ellipseArc2.getCutLineDir(p1);
        const c2 = ellipseArc2.getCutLineDir(p2);
        const c3 = ellipseArc2.getCutLineDir(p3);
        const c4 = ellipseArc2.getCutLineDir(p4);
        const l1 = new Line$2(p1, p1.clone().add(c1.multiplyScalar(10)));
        const l2 = new Line$2(p2, p2.clone().add(c2.multiplyScalar(10)));
        const l3 = new Line$2(p3, p3.clone().add(c3.multiplyScalar(10)));
        const l4 = new Line$2(p4, p4.clone().add(c4.multiplyScalar(10)));
        const pr1 = new Primitive("Line");
        const pr2 = new Primitive("Line");
        const pr3 = new Primitive("Line");
        const pr4 = new Primitive("Line");
        this.addPrimitive(pr1, [l1]);
        this.addPrimitive(pr2, [l2]);
        this.addPrimitive(pr3, [l3]);
        this.addPrimitive(pr4, [l4]);
    }
    /**
     * 测试包围盒
     */
    testBoundingBox(min, max) {
        // 创建点
        const p1 = new Point(min.x, min.y, min.z); // 000
        const p2 = new Point(max.x, min.y, min.z); // 100
        const p3 = new Point(max.x, max.y, min.z); // 110
        const p4 = new Point(min.x, max.y, min.z); // 010
        const p5 = new Point(min.x, min.y, max.z); // 001
        const p6 = new Point(max.x, min.y, max.z); // 101
        const p7 = new Point(max.x, max.y, max.z); // 111
        const p8 = new Point(min.x, max.y, max.z); // 011
        // 创建边线
        const lines = [
            // 底面
            new Line$2(p1, p2),
            new Line$2(p2, p3),
            new Line$2(p3, p4),
            new Line$2(p4, p1),
            // 顶面
            new Line$2(p5, p6),
            new Line$2(p6, p7),
            new Line$2(p7, p8),
            new Line$2(p8, p5),
            // 竖直线
            new Line$2(p1, p5),
            new Line$2(p2, p6),
            new Line$2(p3, p7),
            new Line$2(p4, p8),
        ];
        let primitive = new Primitive("boundingBox");
        this.addPrimitive(primitive, [...lines]);
    }
    /**
     * 测试截面
     */
    sectionRender() {
        // const section = {
        // let sectionFaces = SectionTools.getRegionFaceBySection(1, section);
        // console.log(sectionFaces);
        // let primitive = new Primitive("RegionFace");
        // // primitive.rotate(new Vector3(0, 0, 0), new Vector3(1, 0, 0), Math.PI / 2);
        // // this.addPrimitive(primitive, sectionFaces);
        // const region = sectionFaces[0].clone();
        // const transformMatrix = region.transformMatrix;
        // const axisZ = new Vector3(0, 0, 1);
        // const axisY = new Vector3(0, 1, 0);
        // // 创建一个旋转矩阵，绕 Z 轴旋转 -90 度
        // const rotationZ = new Matrix4().makeRotationAxis(axisZ, -Math.PI / 2);
        // // 创建一个旋转矩阵，绕 Y 轴旋转 -90 度
        // const rotationY = new Matrix4().makeRotationAxis(axisY, -Math.PI / 2);
        // const m1 = new Matrix4().premultiply(transformMatrix).premultiply(rotationZ).premultiply(rotationY);
        // transformMatrix.copy(m1);
        // const extP = new ExtrudeSolid(region, 10);
        // // extP.move(new Vector3(50, 0, 0));
        // const newP = new Primitive(PrimitiveType.ExtrudeSoild);
        // newP.move(new Vector3(50, 0, 0))
        // const p1 = new Vector3(0, 50, 0);
        // const p2 = new Vector3(50, 0, 0);
        // const vec = new Vector3().subVectors(p1, p2);
        // const angle = GeoRelation.Vector3AngleTo(new Vector3(1, 0, 0), vec, new Vector3(0, 0, 1));
        // console.log('angle', angle);
        // newP.rotate(p2, new Vector3(0, 0, 1), angle);
        // extP.height = 50;
        // console.log('first', extP.getNormalizeX().applyMatrix4(newP.worldModelMatrix))
        // console.log('first2', extP.getNormalizeY().applyMatrix4(newP.worldModelMatrix))
        // console.log('first3', extP.getNormalizeZ().applyMatrix4(newP.worldModelMatrix));
        // console.log('first', extP.getNormalizeX().applyMatrix4(newP.localModelMatrix))
        // console.log('first2', extP.getNormalizeY().applyMatrix4(newP.localModelMatrix))
        // console.log('first3', extP.getNormalizeZ().applyMatrix4(newP.localModelMatrix));
        // console.log('getP', extP.getP().applyMatrix4(newP.localModelMatrix));
        // console.log('getP', extP.getP().applyMatrix4(newP.worldModelMatrix));
        // this.addPrimitive(newP, [extP]);
    }
    /**
     * 模拟轴网
     */
    mockAxis() {
        new Primitive("AxisNet");
        const l1 = new Line$2(new Vector3(0, 0, 0), new Vector3(10, 0, 0));
        const l2 = new Line$2(new Vector3(10, 0, 0), new Vector3(10, 10, 0));
        const l3 = new Line$2(new Vector3(10, 10, 0), new Vector3(0, 10, 0));
        const l4 = new Line$2(new Vector3(0, 10, 0), new Vector3(0, 0, 0));
        const p1 = new Primitive("AxisLine");
        const p2 = new Primitive("AxisLine");
        const p3 = new Primitive("AxisLine");
        const p4 = new Primitive("AxisLine");
        // primitive.setChildren([p1, p2, p3, p4]);
        this.addPrimitive(p1, [l1]);
        this.addPrimitive(p2, [l2]);
        this.addPrimitive(p3, [l3]);
        this.addPrimitive(p4, [l4]);
        // this.addPrimitive(primitive, []);
    }
    /**
     * 计算图元的包围盒
     * @param primitive
     */
    calBoundingBoxFromPri(primitive) {
        const storage = this.getPythaStorage();
        if (!primitive)
            return { min: new Vector3(), max: new Vector3() };
        let boundingBox = primitive.getBoundingbox();
        if (primitive.type == "Block") {
            // 如果是块，需要去模板里计算 并且要考虑跨模板的转换矩阵问题
            let bt = storage.blockStore.blockTemplateDict[primitive.blockTemplateUuid];
            boundingBox = BlockPrimitive.calBlockBoundingBox(bt, primitive.worldModelMatrix, storage.blockStore.blockTemplateDict);
        }
        if (boundingBox.min == null || boundingBox.max == null)
            return { min: new Vector3(), max: new Vector3() };
        return boundingBox;
    }
}class EventGraphTestRender extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerGrid);
        const node3 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node4 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node5 = new EventGraphNode(this, EHTestRender);
        this.addEdge(node1, node5);
        this.addEdge(node5, node2);
        this.addEdge(node2, node4);
        this.addEdge(node4, node3);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
    }
}
/**
 * 3do指令 控制器旋转视图
 */
EventGraphTestRender.cmd = 'TEST';// import { OutputDataFormat, OutputDataType, PythaEventOutputData } from "../../declare/interface/PythaEvent";
/**
 * 计算向量 结果保存在cache.data.vector3中
 */
class EventHandlerGenVector3 extends EventHandlerBase {
    run(data) {
        let pdList = this.node.graph.cache.pointerDownList || [];
        if ((pdList === null || pdList === void 0 ? void 0 : pdList.length) < 2)
            return false;
        const startPoint = pdList[0].point;
        const endPoint = pdList[1].point;
        // 计算向量
        let vector = new Vector3();
        vector.subVectors(endPoint, startPoint);
        this.node.graph.cache.data.vector = vector;
        // // 发送通知
        // let outputData: OutputDataFormat = {
        //     type: OutputDataType.VECTOR3,
        //     data: vector
        // }
        // this.node.graph.eventMediator.noticeHandler.notice(this.node, new PythaEventOutputData(outputData));
        return true;
    }
}/**
 * 清除辅助线
 */
class EventHandlerRemoveHelpLine extends EventHandlerBase {
    /**
     * 运行处理器
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a;
        // 获取存储
        if (this.node.graph.cache.data['helpline']) {
            (_a = this.node.graph.cache.data['helpline']) === null || _a === void 0 ? void 0 : _a.remove();
            this.node.graph.cache.data['helpline'] = null;
        }
        return true;
    }
}/**
 * 键盘数值输入 实际接收类型为 string
 */
class EventHandlerStringInput extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventString();
        this.needEventOnce = true;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(event) {
        if (event.cmd != this.needEvent.cmd)
            return false;
        let needInput = this.node.graph.cache.needInput; // 当前接收输入的类型在上一个通知节点里已经存入了needInput.option
        if (needInput == null || needInput.option == null)
            return false;
        this.node.graph.cache.inputString[needInput.option.toUpperCase()] = event.data;
        return true;
    }
}/**
 * 对象输入
 */
class EventHandlerObjectInput extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventObject();
        this.needEventOnce = true;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(event) {
        if (event.cmd != this.needEvent.cmd)
            return false;
        let needInput = this.node.graph.cache.needInput; // 当前接收输入的类型在上一个通知节点里已经存入了needInput.option
        if (needInput == null || needInput.option == null)
            return false;
        this.node.graph.cache.inputObject[needInput.option.toUpperCase()] = event.data;
        return true;
    }
}/**
 * 更新并删除图元处理器
 */
class EventHandlerUpdateAndDeletePri extends EventHandlerBase {
    constructor(node) {
        super(node);
    }
    run(data) {
        // 0 这里是开始逻辑
        const storage = PythaStorage.instance;
        // 执行命令
        // 更新图元
        const updatePrimitives = this.node.graph.cache.primitiveList;
        // 删除图元
        const deletePrimitives = this.node.graph.cache.deletePrimitiveList;
        const updateCmd = new UpdatePrimitiveCmd(updatePrimitives, this.node.graph.eventMediator);
        const deleteCmd = new DeletePrimitiveCmd(deletePrimitives, this.node.graph.eventMediator);
        // 合并命令
        let cmds = [];
        if (updatePrimitives.length > 0) {
            cmds.push(updateCmd);
        }
        if (deletePrimitives.length > 0) {
            cmds.push(deleteCmd);
        }
        if (cmds.length < 1) {
            return true;
        }
        const cmd = new CommandGroup(cmds);
        storage.historyStore.undos.push(cmd);
        cmd.execute();
        return true;
    }
}/**
 * 计算所有图元包围盒
 * 结果以 allBoundingBox 存放在cache中
 */
class EventHanderCalAllBoundingBox extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data) {
        const storage = this.getPythaStorage();
        // 准备最值
        const boxLimit = 1e9; //TODO 放置到一个单独的可设置处
        let minX = +Infinity;
        let minY = +Infinity;
        let minZ = +Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        let counter = 0;
        // 获取所有Primitive
        const primitiveDict = PythaStorage.instance.primitiveStore.primitiveDict;
        for (let key in primitiveDict) {
            let primitive = primitiveDict[key];
            if (primitive == null)
                continue;
            let geoBox = this.calBoundingBoxFromPri(primitive);
            if (!geoBox || !geoBox.min || !geoBox.max) { //空值判断
                continue;
            }
            // 超出阈值的boundingBox不参与计算
            if (geoBox.max.x > boxLimit || geoBox.max.y > boxLimit || geoBox.max.z > boxLimit
                || geoBox.min.x < -boxLimit || geoBox.min.y < -boxLimit || geoBox.min.z < -boxLimit) {
                continue;
            }
            // 修改最值
            if (geoBox.min.x < minX)
                minX = geoBox.min.x;
            if (geoBox.min.y < minY)
                minY = geoBox.min.y;
            if (geoBox.min.z < minZ)
                minZ = geoBox.min.z;
            if (geoBox.max.x > maxX)
                maxX = geoBox.max.x;
            if (geoBox.max.y > maxY)
                maxY = geoBox.max.y;
            if (geoBox.max.z > maxZ)
                maxZ = geoBox.max.z;
            counter++;
        }
        // 获取所有TempPrimitive
        const tempPrimitiveDict = PythaStorage.instance.primitiveStore.tempPrimitiveDict;
        for (let key in tempPrimitiveDict) {
            let primitive = tempPrimitiveDict[key];
            if (primitive == null)
                continue;
            let geoBox = this.calBoundingBoxFromPri(primitive);
            if (!geoBox || !geoBox.min || !geoBox.max) { //空值判断
                continue;
            }
            //判断图元是否存在世界矩阵，如果存在则用世界矩阵更新几何图元包围盒
            if (!!primitive.worldModelMatrix) {
                geoBox.min.applyMatrix4(primitive.worldModelMatrix); //获取世界坐标
                geoBox.max.applyMatrix4(primitive.worldModelMatrix); //获取世界坐标
            }
            // 超出阈值的boundingBox不参与计算
            if (geoBox.max.x > boxLimit || geoBox.max.y > boxLimit || geoBox.max.z > boxLimit
                || geoBox.min.x < -boxLimit || geoBox.min.y < -boxLimit || geoBox.min.z < -boxLimit) {
                continue;
            }
            // 修改最值
            if (geoBox.min.x < minX)
                minX = geoBox.min.x;
            if (geoBox.min.y < minY)
                minY = geoBox.min.y;
            if (geoBox.min.z < minZ)
                minZ = geoBox.min.z;
            if (geoBox.max.x > maxX)
                maxX = geoBox.max.x;
            if (geoBox.max.y > maxY)
                maxY = geoBox.max.y;
            if (geoBox.max.z > maxZ)
                maxZ = geoBox.max.z;
            counter++;
        }
        // 没有参与计算的图元，修改视口为±100
        if ((Object.keys(primitiveDict).length === 0 && Object.keys(tempPrimitiveDict).length === 0) || counter === 0) {
            let s = storage.viewportStore.initialCameraEdge;
            let allBoundingBox = {
                min: new Point(-s, -s, 0),
                max: new Point(s, s, 0)
            };
            this.node.graph.cache.data.allBoundingBox = allBoundingBox;
            return true;
        }
        // 视口过小，修改±100
        if (Math.abs(maxX - minX) < 200) {
            minX -= 100;
            maxX += 100;
        }
        if (Math.abs(maxY - minY) < 200) {
            minY -= 100;
            maxY += 100;
        }
        if (Math.abs(maxZ - minZ) < 200) {
            minZ -= 100;
            maxZ += 100;
        }
        let allBoundingBox = {
            min: new Point(minX, minY, minZ),
            max: new Point(maxX, maxY, maxZ),
        };
        this.node.graph.cache.data.allBoundingBox = allBoundingBox;
        return true;
    }
    /**
     * 计算图元的包围盒
     * @param primitive
     */
    calBoundingBoxFromPri(primitive) {
        const storage = this.getPythaStorage();
        if (!primitive)
            return { min: new Vector3(), max: new Vector3() };
        let boundingBox = primitive.getBoundingbox();
        if (primitive.type == "Block") {
            // 如果是块，需要去模板里计算 并且要考虑跨模板的转换矩阵问题
            let bt = storage.blockStore.blockTemplateDict[primitive.blockTemplateUuid];
            boundingBox = BlockPrimitive.calBlockBoundingBox(bt, primitive.worldModelMatrix, storage.blockStore.blockTemplateDict);
        }
        if (boundingBox.min == null || boundingBox.max == null)
            return { min: new Vector3(), max: new Vector3() };
        return boundingBox;
    }
}/**
 * 视口显示所有图元
 */
class EventHanderShowAllInRect extends EventHandlerBase {
    constructor() {
        super(...arguments);
        this.target = new Vector3();
        this.showEntitiesInRect = (x1, y1, x2, y2, alpha) => {
            var _a;
            let scale1 = Math.abs(y1 - y2) / 2;
            let scale2 = Math.abs(x1 - x2) / 2;
            // max
            let scale = Math.max(scale1, scale2) * alpha;
            let x = (x1 + x2) / 2;
            let y = (y1 + y2) / 2;
            const storage = PythaStorage.instance;
            const viewportStore = storage.viewportStore;
            let camera = viewportStore.viewportItems[viewportStore.currentViewportKey].camera;
            if (!camera)
                return;
            if (((_a = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.cameraEdge) < viewportStore.minCameraEdge && scale < 1) {
                scale = 1;
            }
            if (camera.type === 'OrthographicCamera') {
                //正交相机
                let orthographicCamera = camera;
                // 获取当前工作平面
                const coordinateStore = storage.coordinateStore;
                let workPlane = coordinateStore.workPlane;
                // 计算在工作面上的投影
                this.unprojectCursorPoint(x, y, camera, workPlane, this.target);
                // 计算新的相机位置
                let lastTarget = viewportStore.viewportItems[viewportStore.currentViewportKey].target.clone();
                let offset = orthographicCamera.position.clone().sub(lastTarget);
                offset.multiplyScalar(scale);
                viewportStore.viewportItems[viewportStore.currentViewportKey].target.copy(this.target);
                const position = orthographicCamera.position;
                position.copy(this.target).add(offset);
                orthographicCamera.lookAt(this.target);
                // scale框和当前边界的比例
                viewportStore.viewportItems[viewportStore.currentViewportKey].cameraEdge *= scale;
                orthographicCamera.left = orthographicCamera.left * scale;
                orthographicCamera.right = orthographicCamera.right * scale;
                orthographicCamera.top = orthographicCamera.top * scale;
                orthographicCamera.bottom = orthographicCamera.bottom * scale;
                orthographicCamera.far = orthographicCamera.far * scale;
                // 修改相机矩阵
                orthographicCamera.updateMatrixWorld();
                orthographicCamera.updateProjectionMatrix();
            }
            else if (camera.type === 'PerspectiveCamera') {
                //透视相机
                let persCamera = camera;
                let cameraLookAt = new Vector3();
                let perspectiveDir = new Vector3();
                //获取相机目视方向
                persCamera.getWorldDirection(cameraLookAt);
                //相机目视点到场景的距离，根据这个距离对相机进行缩放
                perspectiveDir.copy(persCamera.position).sub(viewportStore.scene.position);
                //相机目视点平移
                persCamera.position.addScaledVector(cameraLookAt, perspectiveDir.length() * (1 / scale - 1));
                persCamera.updateProjectionMatrix();
            }
            // 发送zoomchange事件（修改坐标轴）
            let zoomChange = new PythaEventZoomChange();
            zoomChange.data = 1 / scale;
            this.node.graph.eventMediator.emitEvent(zoomChange);
        };
        this._rayStart = new Vector3();
        this._rayEnd = new Vector3();
        this.unprojectCursorPoint = (x, y, camera, workPlane, point_move = null) => {
            if (point_move == null) {
                point_move = new Vector3();
            }
            this._rayStart.set(x, y, -1).unproject(camera);
            this._rayEnd.set(x, y, 1).unproject(camera);
            if (!this._ray)
                this._ray = new Line$2();
            this._ray.set(this._rayStart, this._rayEnd);
            // console.log("this._rayStart", this._rayStart.x.toFixed(4), this._rayStart.y.toFixed(4), this._rayStart.z.toFixed(4))
            // console.log("this._rayEnd", this._rayEnd.x.toFixed(4), this._rayEnd.y.toFixed(4), this._rayEnd.z.toFixed(4))
            // console.log("this._ray", this._ray.clone())
            // console.log("this.workPlane", workPlane.clone())
            return GeoIntersection.LineIntersectPlane(this._ray, workPlane, point_move);
        };
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        const storage = this.getPythaStorage();
        let box = this.node.graph.cache.data.allBoundingBox;
        if (!box) {
            let s = storage.viewportStore.initialCameraEdge;
            box = {
                min: new Point(-s, -s, 0),
                max: new Point(s, s, 0)
            };
        }
        const viewportStore = storage.viewportStore;
        let camera = viewportStore.viewportItems[viewportStore.currentViewportKey].camera;
        if (!camera)
            return false;
        box.min.project(camera);
        box.max.project(camera);
        this.showEntitiesInRect(box.min.x, box.min.y, box.max.x, box.max.y, 1.2);
        return true;
    }
}/**
 * 需要zoomAll激活后续流程
 */
class EventHandlerOnZoomAll extends EventHandlerBase {
    /**
     * 构造函数
     * @param node
     */
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventZoomAll();
        this.needEventOnce = false;
    }
    run(event) {
        if (event.cmd != this.needEvent.cmd)
            return false; // 如果传入事件不符 则不执行处理器
        // this.node.graph.cache.data = event.data;
        return true;
    }
}// import { PythaStorage } from "../../storage";
/**
 * 计算临时楔形
 */
class EventHandlerCalTempWedge extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    //todo后续要抽取出方法
    run(data = {}) {
        // 获取存储
        if (this.node.graph.cache.data.step == null) {
            this.node.graph.cache.data.step = 1;
        }
        let step = this.node.graph.cache.data.step;
        if (step === 1) {
            this.firstStep();
            this.node.graph.cache.data.step += 1;
        }
        else if (step === 2) {
            this.secondStep();
        }
        else if (step === 3) {
            this.thirdStep();
        }
        if (!!this.node.graph.cache.data.primitive) {
            this.node.graph.cache.data.primitive.needRedraw = true;
        }
        // 更新长方体
        // this.node.graph.cache.inputNumber = null;
        // console.log("Wedge", this.node.graph.cache.data.wedge)
        return true;
    }
    firstStep() {
        var _a;
        const storage = PythaStorage.instance;
        const pointerDownList = this.node.graph.cache.pointerDownList;
        if (this.node.graph.cache.data._normal == null) {
            this.node.graph.cache.data._normal = new Vector3();
        }
        if (!this.node.graph.cache.data.wedge) {
            let pointer = pointerDownList[pointerDownList.length - 1];
            this.node.graph.cache.data.wedge = new Wedge(pointer.point, 0, 0, 0, new Vector3(1, 0, 0), new Vector3(0, 0, 1));
            this.node.graph.cache.data.primitive = new Primitive("Wedge");
            this.node.graph.cache.data.primitive.geos.push(this.node.graph.cache.data.wedge);
            let keys = Object.keys(this.node.graph.cache.data.primitive.renderItemDict);
            if (keys.length > 0) {
                let renderItem = this.node.graph.cache.data.primitive.renderItemDict[keys[0]];
                renderItem.geoElements = this.node.graph.cache.data.wedge.getGeoElementsIdxList();
                (_a = renderItem.mat) === null || _a === void 0 ? void 0 : _a.color.set(storage.layerStore.getColor());
            }
            this.node.graph.cache.data.primitive.temporary = true;
            this.node.graph.cache.primitiveList.push(this.node.graph.cache.data.primitive);
            storage.primitiveStore.tempPrimitiveDict[this.node.graph.cache.data.primitive.uuid] = this.node.graph.cache.data.primitive;
            // 设置法向量
            const workPlane = storage.coordinateStore.workPlane;
            _normal.copy(workPlane.normal);
        }
    }
    secondStep() {
        const pointerDownList = this.node.graph.cache.pointerDownList;
        let pointMove;
        if (pointerDownList.length === 2) {
            pointMove = pointerDownList[pointerDownList.length - 1].point;
            this.node.graph.cache.data.step += 1;
        }
        else {
            pointMove = this.node.graph.cache.pointerMove.point;
        }
        let eles = this.node.graph.cache.data.wedge.transformMatrix.elements;
        let basePoint = this.node.graph.cache.data.wedge.getP();
        let subVector = new Vector3().subVectors(pointMove, basePoint);
        if (Math.abs(subVector.x) < 1e-6) {
            subVector.x = 1e-5;
        }
        if (Math.abs(subVector.y) < 1e-6) {
            subVector.y = 1e-5;
        }
        eles[0] = subVector.x;
        eles[1] = 0;
        eles[2] = 0;
        eles[4] = 0;
        eles[5] = subVector.y;
        eles[6] = 0;
    }
    thirdStep() {
        var _a, _b;
        const storage = PythaStorage.instance;
        let height = 1e-5;
        const H = this.node.graph.cache.inputNumber['H'];
        let eles = this.node.graph.cache.data.wedge.transformMatrix.elements;
        if (H != null && !isNaN(H) && H > 0) {
            height = H;
            this.node.graph.cache.data.step += 1;
        }
        else if ((_a = this.node.graph.cache.pointerMove) === null || _a === void 0 ? void 0 : _a.point) {
            let pointMove = this.node.graph.cache.pointerMove.point;
            let center = this.node.graph.cache.data.wedge.getP();
            // 判断相机方向是否与法向量同向
            let viewportStore = storage.viewportStore;
            const camera = (_b = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _b === void 0 ? void 0 : _b.camera;
            camera.getWorldDirection(_cameraDir);
            _screenUp.copy(camera.up).cross(_cameraDir).cross(_cameraDir);
            // 获得光标所在平面，该平面垂直于屏幕，且水平
            _extrudePlane.setFromNormalAndCoplanarPoint(_screenUp, pointMove);
            heightVec.subVectors(pointMove, center);
            if (Math.abs(_screenUp.dot(_normal)) < 1e-6) {
                height = heightVec.length();
            }
            else {
                GeoIntersection.PlaneIntersectStraightLine(_extrudePlane, center, _normal, _projectPoint);
                height = _projectPoint.sub(center).length();
                if (_projectPoint.angleTo(_normal) > Math.PI / 2) {
                    height *= -1;
                }
            }
            if (this.node.graph.cache.pointerDownList.length >= 3) {
                this.node.graph.cache.data.step += 1;
            }
        }
        eles[8] = 0;
        eles[9] = 0;
        eles[10] = height;
    }
}
const _cameraDir = new Vector3();
const _screenUp = new Vector3();
const heightVec = new Vector3();
const _normal = new Vector3();
const _extrudePlane = new Plane$1();
const _projectPoint = new Point();class EventGraphWedge extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "确定第一点", option: 'S', inputTypes: [PythaEventName.POINTER_DOWN] },
            ]
        });
        const node3 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node4 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node5 = new EventGraphNode(this, EventHandlerCapture);
        const node6 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node8 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "确定第二点", option: 'E', inputTypes: [PythaEventName.POINTER_DOWN] },
            ]
        });
        const node10 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node12 = new EventGraphNodeAND(this, null);
        const node14 = new EventGraphNode(this, EventHandlerCalTempWedge);
        const node15 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node17 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定高度", option: 'H', inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER] },
            ]
        });
        const node18 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node20 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node21 = new EventGraphNode(this, EventHandlerGrid);
        const node22 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node23 = new EventGraphNode(this, EventHandlerConfirm);
        const node24 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node25 = new EventGraphNode(this, EventHandlerGrid);
        const node26 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node27 = new EventGraphNode(this, EventHandlerNumberInput);
        const node28 = new EventGraphNode(this, EventHandlerCalTempWedge);
        const node29 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node30 = new EventGraphNode(this, EHChangeCrossCursor);
        const node31 = new EventGraphNode(this, EventHandlerCalTempWedge);
        const node32 = new EventGraphNode(this, EventHandlerCalTempWedge);
        this.addEdge(node1, node2);
        this.addEdge(node1, node4);
        this.addEdge(node4, node5);
        this.addEdge(node5, node12);
        this.addEdge(node12, node15);
        this.addEdge(node15, node14);
        this.addEdge(node1, node23);
        this.addEdge(node23, node24);
        this.addEdge(node14, node25);
        this.addEdge(node25, node26);
        this.addEdge(node6, node12);
        this.addEdge(node6, node8);
        this.addEdge(node21, node22);
        this.addEdge(node22, node24);
        this.addEdge(node17, node18);
        this.addEdge(node2, node3);
        this.addEdge(node8, node10);
        this.addEdge(node10, node17);
        this.addEdge(node17, node27);
        this.addEdge(node27, node18, EDGE_TYPE.STOP);
        this.addEdge(node18, node27, EDGE_TYPE.STOP);
        this.addEdge(node27, node28);
        this.addEdge(node28, node20);
        this.addEdge(node18, node20);
        this.addEdge(node20, node29);
        this.addEdge(node29, node21);
        this.addEdge(node3, node30);
        this.addEdge(node30, node6);
        this.addEdge(node6, node31);
        this.addEdge(node10, node32);
        this.addEdge(node31, node25);
        this.addEdge(node32, node25);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/85
    }
}
/**
 * Wedge指令 用于注册事件图
 */
EventGraphWedge.cmd = 'WEDGE';/**
 * 监听图元选中事件
 */
class EventHandlerListenPrimitiveSelect extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventSelectChange();
        this.needEventOnce = true;
    }
    run(event) {
        if (event.cmd != this.needEvent.cmd)
            return false; // 如果传入事件不符 则不执行处理器
        let uuids = event.data.uuids || [];
        this.node.graph.cache.data['lastSelectedPrimitiveUuids'] = uuids;
        this.node.graph.cache.data['selectRange'] = event.data.selectRange;
        return true;
    }
}class EventHandlerCalExtendPoint extends EventHandlerBase {
    run(data) {
        // 获取存储
        const storage = this.getPythaStorage();
        const graphCache = this.node.graph.cache;
        // 第一次选中的剪切参考对象
        const selectFirst = graphCache.data["copySelects"] || [];
        if (selectFirst == null || selectFirst.length < 1) {
            return true;
        }
        // 第二次选中的剪切对象
        const uuids = this.node.graph.cache.data['lastSelectedPrimitiveUuids'] || [];
        const selectSecond = [];
        for (let uuid of uuids) {
            let pri = storage.primitiveStore.primitiveDict[uuid];
            if (pri != null) {
                selectSecond.push(pri);
            }
        }
        if (selectSecond.length <= 0) {
            return true;
        }
        let cmdGroup = graphCache.data['extendCmdGroup']; // 撤销重做命令集 
        if (graphCache.data['extendCmdGroup'] == null) {
            cmdGroup = new CommandGroup();
            graphCache.data['extendCmdGroup'] = cmdGroup; // 缓存到cache里，方便最后一起放入撤销重做
        }
        // const extendIntersectPoints = [];
        // const extendPoints = [];
        // const ray = storage.coordinateStore.viewCursorRay;
        for (let i = 0; i < selectSecond.length; i++) {
            // 遍历第二次选中的图元
            const extendPrimitive = selectSecond[i];
            let intersectPoints = [];
            for (let j = 0; j < selectFirst.length; j++) {
                const primitive = selectFirst[j];
                let points = [];
                if (extendPrimitive.uuid === primitive.uuid) {
                    // 多线延伸到自身的情况
                    if (extendPrimitive.type === "Pline") {
                        // extendPoints.push(null);
                        continue;
                    }
                    else {
                        // extendPoints.push(null);
                        continue;
                    }
                }
                if (extendPrimitive.type === PrimitiveType.Line) {
                    const line = extendPrimitive.geos[0].clone();
                    if (extendPrimitive.worldModelMatrix != null) {
                        line.transformMatrix.premultiply(extendPrimitive.worldModelMatrix);
                    }
                    points = this.handleLineIntersectAny(line, primitive);
                    // TODO 射线求最近点
                    // const point = Relation.RayClosestPointInLine(ray, primitive.geos[0] as Line);
                    // extendPoints.push(point);
                }
                else if (extendPrimitive.type === PrimitiveType.Arc) {
                    const arc = extendPrimitive.geos[0].clone();
                    if (extendPrimitive.worldModelMatrix != null) {
                        arc.transformMatrix.premultiply(extendPrimitive.worldModelMatrix);
                    }
                    points = this.handleArcIntersectAny(arc, primitive);
                    // const point = GeoRelation.RayClosestPointInArc(ray, arc);
                    // extendPoints.push(point);
                }
                else if (extendPrimitive.type === "Pline") ;
                points.forEach(point => {
                    if (!intersectPoints.some(item => item.equals(point))) {
                        intersectPoints.push(point);
                    }
                });
                if (intersectPoints.length <= 0)
                    continue;
                if (extendPrimitive.type === PrimitiveType.Line) {
                    let originLine = extendPrimitive.geos[0].clone();
                    if (extendPrimitive.worldModelMatrix != null) {
                        originLine.transformMatrix.premultiply(extendPrimitive.worldModelMatrix);
                    }
                    // 对交点排序
                    let tValues = intersectPoints.map(point => {
                        const t = GeoIntersection.closestPointToLineParameter(originLine, point, false);
                        return { point, t };
                    });
                    tValues.sort((a, b) => a.t - b.t);
                    let max = tValues[tValues.length - 1];
                    let min = tValues[0];
                    let extended = false;
                    if (max.t > 1) {
                        // 延伸端点
                        originLine.end = max.point;
                        extended = true;
                    }
                    if (min.t < 0) {
                        // 延伸起点
                        originLine.start = min.point;
                        extended = true;
                    }
                    if (!extended)
                        continue;
                    // 创建图元
                    if (extendPrimitive.worldModelMatrix != null) {
                        originLine.transformMatrix.premultiply(extendPrimitive.worldModelMatrix.clone().invert());
                    }
                    let pri = extendPrimitive.clone();
                    pri.uuid = extendPrimitive.uuid;
                    pri.geos = [];
                    pri.geos.push(originLine);
                    let keys = Object.keys(pri.renderItemDict);
                    if (keys.length > 0) {
                        let renderItem = pri.renderItemDict[keys[0]];
                        renderItem.geoElements = originLine.getGeoElementsIdxList();
                        // renderItem.mat?.color.set(storage.layerStore.getColor());
                    }
                    pri.isSelected = true;
                    pri.needRedraw = true;
                    let addCmd = new UpdatePrimitiveCmd([pri], this.node.graph.eventMediator);
                    storage.selectStore.selectPrimitives = storage.selectStore.selectPrimitives.filter(item => item.uuid != pri.uuid);
                    storage.selectStore.selectPrimitives.push(pri); // 手动存入选择缓存，这样结束后颜色可以复原
                    addCmd.execute();
                    cmdGroup.addCmd(addCmd);
                    graphCache.data["copySelects"] = selectFirst.filter(item => item.uuid != extendPrimitive.uuid) || [];
                    graphCache.data["copySelects"].push(pri);
                }
                else if (extendPrimitive.type === PrimitiveType.Arc) {
                    let originArc = extendPrimitive.geos[0].clone();
                    if (extendPrimitive.worldModelMatrix != null) {
                        originArc.transformMatrix.premultiply(extendPrimitive.worldModelMatrix);
                    }
                    const center = originArc.center;
                    const normal = originArc.normal;
                    // 对交点排序
                    let tValues = intersectPoints.map(point => {
                        const t = GeoIntersection.PointToArcParameter(originArc, point, false);
                        return { point, t };
                    });
                    tValues.sort((a, b) => a.t - b.t);
                    // console.log(tValues);
                    // 圆弧的t肯定是大于0的，因为局部坐标系起点为0
                    let max = tValues[tValues.length - 1];
                    let extended = false;
                    if (max.t > 1) {
                        // 延伸端点
                        let start = originArc.getPointAt(0);
                        let end = originArc.getPointAt(1);
                        let angle = originArc.angle;
                        let angleT = angle * max.t;
                        let reverseAngle = Math.PI * 2 - angleT;
                        if ((angleT - angle) < (reverseAngle)) {
                            // 离端点更近
                            originArc.setFromTwoPointAndCenter(start, max.point, center, normal);
                        }
                        else {
                            // 离起点更近
                            originArc.setFromTwoPointAndCenter(max.point, end, center, normal);
                        }
                        extended = true;
                    }
                    if (!extended)
                        continue;
                    if (extendPrimitive.worldModelMatrix != null) {
                        originArc.transformMatrix.premultiply(extendPrimitive.worldModelMatrix.clone().invert());
                    }
                    // 创建图元
                    let pri = extendPrimitive.clone();
                    pri.uuid = extendPrimitive.uuid;
                    pri.geos = [];
                    pri.geos.push(originArc);
                    let keys = Object.keys(pri.renderItemDict);
                    if (keys.length > 0) {
                        let renderItem = pri.renderItemDict[keys[0]];
                        renderItem.geoElements = originArc.getGeoElementsIdxList();
                        // renderItem.mat?.color.set(storage.layerStore.getColor());
                    }
                    pri.isSelected = true;
                    pri.needRedraw = true;
                    let addCmd = new UpdatePrimitiveCmd([pri], this.node.graph.eventMediator);
                    storage.selectStore.selectPrimitives = storage.selectStore.selectPrimitives.filter(item => item.uuid != pri.uuid);
                    storage.selectStore.selectPrimitives.push(pri); // 手动存入选择缓存，这样结束后颜色可以复原
                    addCmd.execute();
                    cmdGroup.addCmd(addCmd);
                    graphCache.data["copySelects"] = selectFirst.filter(item => item.uuid != extendPrimitive.uuid) || [];
                    graphCache.data["copySelects"].push(pri);
                }
            }
            // extendIntersectPoints.push(intersectPoints);
        }
        // graphCache.data['intersectPoints'] = extendIntersectPoints;
        // graphCache.data['extendPoints'] = extendPoints;
        return true;
    }
    /**
     * 求线和其他图元的延伸交点
     * @param line
     * @param otherPrimitive
     * @returns
     */
    handleLineIntersectAny(line, otherPrimitive) {
        if (otherPrimitive.type === PrimitiveType.Line) {
            const geo = otherPrimitive.geos[0].clone();
            if (otherPrimitive.worldModelMatrix != null) {
                geo.transformMatrix.premultiply(otherPrimitive.worldModelMatrix);
            }
            let point = GeoIntersection.LineIntersectSegment(line, geo.start, geo.end, false, true);
            if (point != null)
                return [point];
            return [];
        }
        else if (otherPrimitive.type === PrimitiveType.Arc || otherPrimitive.type === PrimitiveType.Circle) {
            let geo = otherPrimitive.geos[0].clone();
            if (otherPrimitive.worldModelMatrix != null) {
                geo.transformMatrix.premultiply(otherPrimitive.worldModelMatrix);
            }
            return GeoIntersection.ArcIntersectExtendLine(geo, line);
        }
        return [];
    }
    handleArcIntersectAny(arc, otherPrimitive) {
        if (otherPrimitive.type === "Line") {
            return GeoIntersection.ArcIntersectExtendLine(arc, otherPrimitive.geos[0]);
        }
        else if (otherPrimitive.type === "Arc") {
            return GeoIntersection.ArcIntersectExtendArc(arc, otherPrimitive.geos[0]);
        }
        return [];
    }
}let EventHandlerCopySelect$1=class EventHandlerCopySelect extends EventHandlerBase {
    run(data) {
        const storage = PythaStorage.instance;
        const primitives = storage.selectStore.selectPrimitives;
        const graphCache = this.node.graph.cache;
        graphCache.data = {};
        const copySelects = [];
        primitives.forEach(primitive => {
            copySelects.push(primitive);
        });
        graphCache.data["copySelects"] = copySelects;
        return true;
    }
};/**
 * 延伸
 */
class EventGraphExtend extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '选择对象' });
        const node3 = new EventGraphNodeSwitch(this, () => {
            const storage = this.eventMediator.storage;
            if (storage.selectStore.getUnlockedPrimitives().length < 1) {
                return [0];
            }
            return [1];
        });
        const node4 = new EventGraphNode(this, EventHandlerConfirm);
        const node6 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node7 = new EventGraphNode(this, EventHandlerConfirm);
        const node8 = new EventGraphNode(this, EventHandlerCopySelect$1);
        const node9 = new EventGraphNode(this, EventHandlerListenPrimitiveSelect);
        const node10 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '选择延伸对象' });
        const node11 = new EventGraphNode(this, EventHandlerCalExtendPoint);
        const node14 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node15 = new EventGraphNode(this, EventHandlerGrid);
        const node17 = new EventGraphNode(this, EventHandlerDisableClamp);
        const node18 = new EventGraphNode(this, EHChangePickCursor);
        const node19 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        /**没有选中图元*/
        this.addEdge(node3, node2);
        this.addEdge(node2, node4);
        this.addEdge(node7, node6);
        this.addEdge(node8, node10);
        this.addEdge(node10, node9);
        this.addEdge(node9, node11);
        this.addEdge(node15, node14);
        this.addEdge(node14, node10);
        this.addEdge(node4, node3);
        this.addEdge(node1, node17);
        this.addEdge(node17, node18);
        this.addEdge(node18, node3);
        this.addEdge(node8, node7);
        this.addEdge(node19, node15);
        this.addEdge(node11, node19);
        /**选中了图元*/
        this.addEdge(node3, node8);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/95
    }
    end() {
        let cmdGroup = this.cache.data['extendCmdGroup'];
        if (cmdGroup != null && cmdGroup.cmds.length > 0) {
            let storage = this.eventMediator.storage;
            storage === null || storage === void 0 ? void 0 : storage.historyStore.undos.push(cmdGroup);
        }
        super.end();
    }
}
EventGraphExtend.cmd = "EXTEND";const DefaultPolygonEdgeNum = 4;
class EventHandlerCalTempPolygon extends EventHandlerBase {
    run(data) {
        var _a;
        const storage = PythaStorage.instance;
        const pointerDownList = this.node.graph.cache.pointerDownList;
        const workPlane = storage.coordinateStore.workPlane;
        if (pointerDownList.length < 1)
            return false;
        workPlane.getNormalizeZ(_v1$4);
        const pointer = pointerDownList[pointerDownList.length - 1];
        if (this.primitive == null) {
            workPlane.getNormalizeX(_v6);
            this._polygon = new Polygon([], _v6, pointer.point);
            this.primitive = new Primitive("Polygon");
            this.primitive.geos.push(this._polygon);
            this.primitive.temporary = true;
            this.node.graph.cache.primitiveList.push(this.primitive);
            storage.primitiveStore.tempPrimitiveDict[this.primitive.uuid] = this.primitive;
        }
        const pointMove = storage.coordinateStore.currentPos;
        let option = this.node.graph.cache.inputOption;
        if (option == null) {
            option = "C";
        }
        let edgeNumber = this.node.graph.cache.inputNumber['EDGE_NUMBER']; // TODO
        if (edgeNumber == null) {
            edgeNumber = DefaultPolygonEdgeNum;
        }
        let vertices = [];
        if (pointMove) {
            if (option === "C") {
                vertices = this.calcByCenter(pointer.point, pointMove, edgeNumber);
            }
            else if (option === "E") {
                vertices = this.calcByEdge(pointer.point, pointMove, edgeNumber);
            }
        }
        const edges = [];
        if (vertices.length > 0) {
            for (let i = 0; i < edgeNumber; i++) {
                edges.push(new Line$2(vertices[i], vertices[(i + 1) % edgeNumber]));
            }
            let keys = Object.keys(this.primitive.renderItemDict);
            if (keys.length > 0) {
                let renderItem = this.primitive.renderItemDict[keys[0]];
                renderItem.geoElements = this._polygon.getGeoElementsIdxList();
                (_a = renderItem.mat) === null || _a === void 0 ? void 0 : _a.color.set(storage.layerStore.getColor());
            }
        }
        this._polygon.setPolygon(edges);
        this.primitive.needRedraw = true;
        return true;
    }
    /**
     * 根据边计算多边形
     * @param basePoint 边的一个角点
     * @param pointMove 与basePoint相邻的角点
     * @param edgeNumber
     */
    calcByEdge(basePoint, pointMove, edgeNumber) {
        // basePoint是中心点，pointMove是其中角点，依据两点生成各角点
        const vertices = [];
        const storage = PythaStorage.instance;
        const workPlane = storage.coordinateStore.workPlane;
        workPlane.getZ(_v3$3);
        const delta = Math.PI * 2 / edgeNumber;
        workPlane.projectPoint(basePoint, _v1$4);
        workPlane.projectPoint(pointMove, _v2$3);
        p_delta.subVectors(_v2$3, _v1$4);
        vertices.push(basePoint);
        for (let i = 1; i < edgeNumber; i++) {
            vertices[i] = new Point();
            vertices[i].copy(vertices[i - 1]).add(p_delta.clone().applyAxisAngle(_v3$3, delta * (i - 1)));
        }
        return vertices;
    }
    /**
     * 中心点生成
     * @param basePoint
     * @param pointMove
     * @param edgeNumber 边数
     */
    calcByCenter(basePoint, pointMove, edgeNumber) {
        // basePoint是中心点，pointMove是其中角点，依据两点生成各角点
        const storage = PythaStorage.instance;
        const workPlane = storage.coordinateStore.workPlane;
        workPlane.getX(_v4$1);
        workPlane.getX(_v5$1);
        workPlane.getZ(_v3$3);
        workPlane.projectPoint(basePoint, _v1$4);
        workPlane.projectPoint(pointMove, _v2$3);
        const distance = _v1$4.distanceTo(_v2$3);
        const delta = Math.PI * 2 / edgeNumber;
        p_delta.subVectors(_v2$3, _v1$4);
        let initAngle = _v4$1.angleTo(p_delta);
        const value = _v4$1.cross(p_delta).angleTo(_v3$3) * 180 / Math.PI;
        if (value > 90) {
            initAngle = Math.PI * 2 - initAngle;
        }
        const vertices = [];
        for (let i = 0; i < edgeNumber; i++) {
            _v4$1.copy(_v5$1);
            vertices[i] = new Point();
            vertices[i].copy(basePoint).add(_v4$1.normalize().multiplyScalar(distance).applyAxisAngle(_v3$3, delta * i + initAngle));
        }
        return vertices;
    }
}
const _v1$4 = new Vector3();
const _v2$3 = new Vector3();
const _v3$3 = new Vector3();
const _v4$1 = new Vector3();
const _v5$1 = new Vector3();
const _v6 = new Vector3();
const p_delta = new Vector3();class EventGraphPolygon extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node3 = new EventGraphNode(this, EventHandlerConfirm);
        const node4 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node5 = new EventGraphNode(this, EventHandlerCapture);
        const node6 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node9 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node10 = new EventGraphNode(this, EventHandlerCalTempPolygon);
        const node12 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node13 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node14 = new EventGraphNodeAND(this, null);
        const node17 = new EventGraphNode(this, EventHandlerGrid);
        const node19 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node20 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node21 = new EventGraphNode(this, EventHandlerNumberInput);
        const node25 = new EventGraphNode(this, EventHandlerOptionInput);
        const node26 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "输入侧面数<4>", option: 'EDGE_NUMBER', inputTypes: [PythaEventName.COUNT] },
            ]
        });
        const node27 = new EventGraphNode(this, EventHandlerGrid);
        const node28 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node29 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node32 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定底面中心", option: 'CENTER', inputTypes: [PythaEventName.POINTER_DOWN] },
                { type: NeedInputEnum.OPTION, description: "按中心点", option: "C" },
                { type: NeedInputEnum.OPTION, description: "按边", option: "E" },
            ]
        });
        const node33 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node34 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node35 = new EventGraphNode(this, EHChangeCrossCursor);
        const node36 = new EventGraphNode(this, EventHandlerInitCapture);
        this.addEdge(node1, node3);
        this.addEdge(node1, node4);
        this.addEdge(node5, node14);
        this.addEdge(node14, node9);
        this.addEdge(node9, node10);
        this.addEdge(node3, node19);
        this.addEdge(node6, node5);
        this.addEdge(node12, node14);
        this.addEdge(node13, node20);
        this.addEdge(node10, node27);
        this.addEdge(node17, node28);
        this.addEdge(node27, node29);
        this.addEdge(node26, node21);
        this.addEdge(node21, node32);
        this.addEdge(node25, node36);
        this.addEdge(node36, node33);
        this.addEdge(node20, node34);
        this.addEdge(node34, node17);
        this.addEdge(node25, node12);
        this.addEdge(node33, node35);
        this.addEdge(node35, node6);
        this.addEdge(node1, node26);
        this.addEdge(node32, node25);
        this.addEdge(node28, node19);
        this.addEdge(node12, node13);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/7
    }
}
EventGraphPolygon.cmd = "POLYGON";class EventHandlerCalcTempTorus extends EventHandlerBase {
    run(data) {
        var _a;
        const tempPrimitives = this.node.graph.cache.primitiveList;
        const tempPrimitive = tempPrimitives[0];
        if ((tempPrimitive === null || tempPrimitive === void 0 ? void 0 : tempPrimitive.type) === PrimitiveType.Circle) {
            // 删除掉临时图元
            tempPrimitives.splice(0, 1);
            tempPrimitive.needDelete = true;
        }
        const storage = PythaStorage.instance;
        const workPlane = storage.coordinateStore.workPlane;
        const pointerDownList = this.node.graph.cache.pointerDownList;
        let inputNumberMap = this.node.graph.cache.inputNumber;
        if (pointerDownList.length < 2 && inputNumberMap['T'] == null) {
            return false;
        }
        const clickP1 = pointerDownList[0].point;
        let clickP2 = clickP1.clone();
        if (inputNumberMap['T'] != null) {
            clickP2 = clickP1.clone().add(workPlane.getNormalizeX().multiplyScalar(inputNumberMap['T']));
        }
        else {
            clickP2 = pointerDownList[1].point;
        }
        const radius = clickP1.distanceTo(clickP2);
        if (!this.node.graph.cache.data.torus) {
            // 创建临时圆环体
            this.node.graph.cache.data.primitive = new Primitive(PrimitiveType.Torus);
            this.node.graph.cache.data.torus = new Torus(clickP1, radius, workPlane.getZ(), workPlane.getX());
            this.node.graph.cache.data.primitive.geos.push(this.node.graph.cache.data.torus);
            let keys = Object.keys(this.node.graph.cache.data.primitive.renderItemDict);
            if (keys.length > 0) {
                let renderItem = this.node.graph.cache.data.primitive.renderItemDict[keys[0]];
                renderItem.geoElements = this.node.graph.cache.data.torus.getGeoElementsIdxList();
                (_a = renderItem.mat) === null || _a === void 0 ? void 0 : _a.color.set(storage.layerStore.getColor());
            }
            this.node.graph.cache.data.primitive.temporary = true;
            this.node.graph.cache.primitiveList.push(this.node.graph.cache.data.primitive);
            storage.primitiveStore.tempPrimitiveDict[this.node.graph.cache.data.primitive.uuid] = this.node.graph.cache.data.primitive;
        }
        //const movePoint = this.node.graph.cache.pointerMove?.point;
        const movePoint = PythaStorage.instance.coordinateStore.currentPos;
        if (!!movePoint) {
            const radius = clickP2.distanceTo(movePoint);
            this.node.graph.cache.data.torus.setSegmentRadius(radius);
        }
        if (inputNumberMap['SECTION_R'] != null)
            this.node.graph.cache.data.torus.setSegmentRadius(inputNumberMap['SECTION_R']);
        this.node.graph.cache.data.primitive.needRedraw = true;
        return true;
    }
}class EventGraphTorus extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node4 = new EventGraphNode(this, EventHandlerConfirm);
        const node5 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node6 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node7 = new EventGraphNode(this, EventHandlerCapture);
        const node8 = new EventGraphNodeAND(this, null);
        const node10 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node12 = new EventGraphNode(this, EventHandlerCalcTempTorus);
        const node13 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node15 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node16 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node18 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node19 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定圆环中心点", option: 'C', inputTypes: [PythaEventName.POINTER_DOWN] }
            ]
        });
        const node20 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定圆环半径", option: 'T', inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER] }
            ]
        });
        const node21 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定截面半径", option: 'SECTION_R', inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER] }
            ]
        });
        const node22 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node24 = new EventGraphNode(this, EventHandlerCalTempCircle);
        const node25 = new EventGraphNodeSwitch(this, () => {
            if (this.cache.pointerDownList.length > 1 || this.cache.inputNumber['T'] != null) {
                return [0];
            }
            return [1];
        });
        const node26 = new EventGraphNode(this, EventHandlerGrid);
        const node27 = new EventGraphNode(this, EventHandlerGrid);
        const node28 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node29 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node30 = new EventGraphNode(this, EventHandlerInitCapture);
        const node31 = new EventGraphNode(this, EHChangeCrossCursor);
        const node32 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node33 = new EventGraphNode(this, EventHandlerNumberInput);
        const node34 = new EventGraphNode(this, EventHandlerNumberInput);
        const node35 = new EventGraphNode(this, EventHandlerCalcTempTorus);
        this.addEdge(node1, node4);
        this.addEdge(node2, node7);
        this.addEdge(node7, node8);
        this.addEdge(node6, node8);
        this.addEdge(node4, node18);
        this.addEdge(node1, node19);
        this.addEdge(node6, node20);
        this.addEdge(node10, node21);
        this.addEdge(node15, node25);
        this.addEdge(node25, node12);
        this.addEdge(node8, node15);
        this.addEdge(node27, node16);
        this.addEdge(node26, node22);
        this.addEdge(node24, node26);
        this.addEdge(node12, node26);
        this.addEdge(node16, node18);
        this.addEdge(node21, node13);
        this.addEdge(node20, node10);
        this.addEdge(node13, node28);
        this.addEdge(node5, node31);
        this.addEdge(node31, node6);
        this.addEdge(node5, node29);
        this.addEdge(node29, node30);
        this.addEdge(node30, node2);
        this.addEdge(node28, node32);
        this.addEdge(node32, node27);
        this.addEdge(node19, node5);
        this.addEdge(node20, node33);
        this.addEdge(node10, node33, EDGE_TYPE.STOP);
        this.addEdge(node33, node10, EDGE_TYPE.STOP);
        this.addEdge(node21, node34);
        this.addEdge(node34, node35);
        this.addEdge(node35, node28);
        this.addEdge(node13, node34, EDGE_TYPE.STOP);
        this.addEdge(node34, node13, EDGE_TYPE.STOP);
        this.addEdge(node33, node21);
        this.addEdge(node25, node24);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/20
    }
}
EventGraphTorus.cmd = "TORUS";/**
 * 计算多段线临时的辅助线
 */
class EventHandlerCalTempPlineCurve extends EventHandlerBase {
    constructor(node) {
        super(node);
        // 当前的绘制类型 L：线 A：圆弧
        this.currentType = 'L';
        // 计算圆弧的中间变量，避免频繁new
        this.sLine_1 = new StraightLine();
        this.sLine_2 = new StraightLine();
        this.crossDir = new Vector3();
        this.line2Dir = new Vector3();
        // 获取存储
        const storage = PythaStorage.instance;
        this.tempLine = new Line$2(new Point(0, 0, 0), new Point(0, 0, 0));
        this.tempArc = new Arc(new Point(0, 0, 0), 0, 0, new Vector3(0, 0, 1), new Vector3(1, 0, 0));
        this.tempArcPrimitive = new Primitive('Arc');
        this.tempLinePrimitive = new Primitive('Line');
        this.tempArcPrimitive.geos.push(this.tempArc);
        let arcKeys = Object.keys(this.tempArcPrimitive.renderItemDict);
        if (arcKeys.length > 0) {
            let renderItem = this.tempArcPrimitive.renderItemDict[arcKeys[0]];
            renderItem.geoElements = this.tempArc.getGeoElementsIdxList();
        }
        this.tempArcPrimitive.temporary = true;
        this.tempLinePrimitive.geos.push(this.tempLine);
        let lineKeys = Object.keys(this.tempLinePrimitive.renderItemDict);
        if (lineKeys.length > 0) {
            let renderItem = this.tempLinePrimitive.renderItemDict[lineKeys[0]];
            renderItem.geoElements = this.tempLine.getGeoElementsIdxList();
        }
        this.tempLinePrimitive.temporary = true;
        storage.primitiveStore.tempPrimitiveDict[this.tempLinePrimitive.uuid] = this.tempLinePrimitive;
        this.node.graph.cache.data["tempLine"] = this.tempLine;
        this.node.graph.cache.data["tempArc"] = this.tempArc;
        this.node.graph.cache.data['tempLinePrimitive'] = this.tempLinePrimitive;
        this.node.graph.cache.data['tempArcPrimitive'] = this.tempArcPrimitive;
        this.node.graph.cache.data['direction'] = new Vector3(0, 1, 0);
    }
    run() {
        if (!this.node.graph.cache.data['type']) {
            this.node.graph.cache.data['type'] = 'L';
        }
        let type = this.node.graph.cache.data['type'];
        const storage = PythaStorage.instance;
        const pointMove = storage.coordinateStore.currentPos;
        const pointerDownList = this.node.graph.cache.pointerDownList;
        if ((pointerDownList === null || pointerDownList === void 0 ? void 0 : pointerDownList.length) < 1)
            return false;
        if (type == 'L') {
            this.tempLine.set(pointerDownList[pointerDownList.length - 1].point, pointMove);
            this.tempLinePrimitive.needRedraw = true;
            if (this.currentType != type) {
                // 切换类型，先取消显示Arc，再更新并添加Line
                this.tempArcPrimitive.needDelete = true;
                this.tempLinePrimitive.needDelete = false;
                // 获取存储
                const storage = PythaStorage.instance;
                storage.primitiveStore.tempPrimitiveDict[this.tempLinePrimitive.uuid] = this.tempLinePrimitive;
                this.currentType = type;
            }
        }
        else if (type == 'A') {
            const direction = this.node.graph.cache.data['direction'];
            const storage = PythaStorage.instance;
            const workPlane = storage.coordinateStore.workPlane;
            let lastPoint = pointerDownList[pointerDownList.length - 1].point.clone();
            // 计算参考法向量
            const normal = direction.clone().cross(pointMove.clone().sub(lastPoint)).normalize();
            if (normal.length() < 1e-5)
                normal.set(0, 0, 1);
            // 计算中垂线
            // 中垂线中心点
            let lineCenter = lastPoint.clone().add(pointMove).multiplyScalar(0.5);
            // 中垂线方向
            let v2_1 = pointMove.clone().sub(lastPoint).normalize();
            this.line2Dir.copy(v2_1).cross(workPlane.normal);
            // 计算圆弧的圆心
            let center = new Point();
            this.sLine_2.setFromPoints(lineCenter, lineCenter.clone().add(this.line2Dir));
            if (!direction)
                return false;
            // 判断移动的连线是否与direction垂直
            if (Math.abs(direction.dot(v2_1)) < 1e-6) {
                center.copy(lastPoint).add(pointMove).multiplyScalar(0.5);
            }
            else {
                this.crossDir.copy(direction).cross(normal).normalize();
                this.sLine_1.setFromPoints(lastPoint, lastPoint.clone().add(this.crossDir));
                GeoIntersection.StraightLineIntersectStraightLine(this.sLine_1, this.sLine_2, center);
            }
            this.tempArc.setFromTwoPointAndCenter(lastPoint, pointMove, center, normal);
            this.tempArcPrimitive.needRedraw = true;
            if (this.currentType != type) {
                // 切换类型，先取消显示Line，再更新并添加Arc
                this.tempArcPrimitive.needDelete = false;
                this.tempLinePrimitive.needDelete = true;
                // 获取存储
                const storage = PythaStorage.instance;
                storage.primitiveStore.tempPrimitiveDict[this.tempArcPrimitive.uuid] = this.tempArcPrimitive;
                this.currentType = type;
            }
        }
        return true;
    }
}class EventHandlerClosePline extends EventHandlerBase {
    run() {
        const pointerDownList = this.node.graph.cache.pointerDownList;
        let primitive = this.node.graph.cache.primitiveList[0];
        let type = this.node.graph.cache.data['type'];
        if (!primitive)
            return false;
        if (pointerDownList.length < 2)
            return false;
        // 判断多线是否已经闭合
        let firstPointer = pointerDownList[0];
        let endPointer = pointerDownList[pointerDownList.length - 1];
        if (firstPointer.point.distanceTo(endPointer.point) < 1e-6) {
            return true;
        }
        if (type == "L") {
            let line = new Line$2(endPointer.point, firstPointer.point);
            primitive.geos.push(line);
        }
        else {
            const direction = this.node.graph.cache.data['direction'];
            const storage = PythaStorage.instance;
            const workPlane = storage.coordinateStore.workPlane;
            let lastPoint = endPointer.point.clone();
            let endPoint = firstPointer.point.clone();
            let sLine_1 = new StraightLine();
            let sLine_2 = new StraightLine();
            let line2Dir = new Vector3();
            let crossDir = new Vector3();
            // 计算参考法向量
            const normal = direction.clone().cross(endPoint.clone().sub(lastPoint)).normalize();
            if (normal.length() < 1e-5)
                normal.set(0, 0, 1);
            // 计算中垂线
            // 中垂线中心点
            let lineCenter = lastPoint.clone().add(endPoint).multiplyScalar(0.5);
            // 中垂线方向
            let v2_1 = endPoint.clone().sub(lastPoint).normalize();
            line2Dir.copy(v2_1).cross(workPlane.normal);
            // 计算圆弧的圆心
            let center = new Point();
            sLine_2.setFromPoints(lineCenter, lineCenter.clone().add(line2Dir));
            if (!direction)
                return false;
            // 判断移动的连线是否与direction垂直
            if (Math.abs(direction.dot(v2_1)) < 1e-6) {
                center.copy(lastPoint).add(endPoint).multiplyScalar(0.5);
            }
            else {
                crossDir.copy(direction).cross(normal).normalize();
                sLine_1.setFromPoints(lastPoint, lastPoint.clone().add(crossDir));
                GeoIntersection.StraightLineIntersectStraightLine(sLine_1, sLine_2, center);
            }
            let arc = new Arc();
            arc.setFromTwoPointAndCenter(lastPoint, endPoint, center, normal);
            primitive.geos.push(arc);
        }
        let keys = Object.keys(primitive.renderItemDict);
        if (keys.length > 0) {
            let renderItem = primitive.renderItemDict[keys[0]];
            renderItem.geoElements = [];
            primitive.geos.forEach(geo => {
                let geoElementsLength = renderItem.geoElements.length;
                geo.getGeoElementsIdxList().forEach(idx => {
                    renderItem.geoElements.push(idx + geoElementsLength);
                });
            });
        }
        return true;
    }
}/**
 * 生成多段线图元
 */
class EventHandlerGenTempPLine extends EventHandlerBase {
    run() {
        if (this.primitive == null) {
            const storage = PythaStorage.instance;
            this.primitive = new Primitive("Pline");
            this.primitive.temporary = true;
            this.primitive.needRedraw = true;
            this.node.graph.cache.primitiveList.push(this.primitive);
            storage.primitiveStore.tempPrimitiveDict[this.primitive.uuid] = this.primitive;
        }
        return true;
    }
}/**
 * 确定点时更新多段线
 */
class EventHandlerUpdatePline extends EventHandlerBase {
    run() {
        var _a, _b;
        let primitive = this.node.graph.cache.primitiveList[0];
        let type = this.node.graph.cache.data['type'];
        if (!primitive)
            return false;
        let curve;
        if (type == 'L') {
            curve = (_a = this.node.graph.cache.data['tempLine']) === null || _a === void 0 ? void 0 : _a.clone();
        }
        else {
            curve = (_b = this.node.graph.cache.data['tempArc']) === null || _b === void 0 ? void 0 : _b.clone();
        }
        if (!curve)
            return false;
        // 更新direction
        if (type == 'L') {
            let line = curve;
            let dir = this.node.graph.cache.data['direction'];
            dir.copy(line.end).sub(line.start).normalize();
        }
        else {
            let arc = curve;
            let dir = this.node.graph.cache.data['direction'];
            const pointerDownList = this.node.graph.cache.pointerDownList;
            let center = arc.center;
            let endPoint = pointerDownList[pointerDownList.length - 1].point;
            let pointDir = endPoint.clone().sub(center).normalize();
            dir.copy(arc.getNormalizeZ()).cross(pointDir);
        }
        primitive.geos.push(curve);
        let keys = Object.keys(primitive.renderItemDict);
        if (keys.length > 0) {
            let renderItem = primitive.renderItemDict[keys[0]];
            renderItem.geoElements = [];
            primitive.geos.forEach(geo => {
                let geoElementsLength = renderItem.geoElements.length;
                geo.getGeoElementsIdxList().forEach(idx => {
                    renderItem.geoElements.push(idx + geoElementsLength);
                });
            });
        }
        primitive.needRedraw = true;
        return true;
    }
}class EventHandlerUpdatePlineType extends EventHandlerBase {
    run() {
        let type = this.node.graph.cache.inputOption;
        if (type == 'L') {
            this.node.graph.cache.data['type'] = 'L';
        }
        else if (type == 'A') {
            this.node.graph.cache.data['type'] = 'A';
        }
        return true;
    }
}/**
 * 更新自身图元指令
 */
class UpdateOwnPrimitiveCmd extends CommandBase {
    /**
     * 构造函数
     * @param newPrimitives
     * @param eventMediator
     */
    constructor(newPrimitives, eventMediator) {
        super();
        /**
         * 原来的图元
         */
        this.oldPrimitives = [];
        /**
         * 修改后的图元
         */
        this.newPrimitives = [];
        const storage = PythaStorage.instance;
        storage.primitiveStore.primitiveDict;
        for (let primitive of newPrimitives) {
            let old = primitive.clone();
            old.uuid = primitive.uuid;
            this.oldPrimitives.push(old);
        }
        this.newPrimitives = [...newPrimitives];
        this.eventMediator = eventMediator;
    }
    /**
     * 执行
     */
    execute() {
        const storage = PythaStorage.instance;
        const primitiveDict = storage.primitiveStore.primitiveDict;
        const tempPrimitiveDict = storage.primitiveStore.tempPrimitiveDict;
        this.newPrimitives.forEach(primitive => {
            primitive.needRedraw = true;
            primitive.temporary = false;
            primitiveDict[primitive.uuid] = primitive;
        });
        this.oldPrimitives.forEach(primitive => {
            primitive.temporary = true;
            primitive.needDelete = true;
            primitive.isSelected = false;
            tempPrimitiveDict[primitive.uuid] = primitive;
        });
        this.eventMediator.noticeHandler.notice(this, new PythaEventDataChange({ add_primitives: this.newPrimitives }));
    }
    /**
     * 撤销
     */
    undo() {
        const storage = PythaStorage.instance;
        const primitiveDict = storage.primitiveStore.primitiveDict;
        const tempPrimitiveDict = storage.primitiveStore.tempPrimitiveDict;
        this.newPrimitives.forEach(primitive => {
            primitive.temporary = true;
            primitive.needDelete = true;
            tempPrimitiveDict[primitive.uuid] = primitive;
        });
        this.oldPrimitives.forEach(primitive => {
            primitive.temporary = false;
            primitive.needRedraw = true;
            primitiveDict[primitive.uuid] = primitive;
        });
        this.eventMediator.noticeHandler.notice(this, new PythaEventDataChange({ add_primitives: this.oldPrimitives }));
    }
}/**
 * 编辑图元
 */
class EventHandlerUpdateOwnPri extends EventHandlerBase {
    constructor(node) {
        super(node);
    }
    run(data) {
        // 0 这里是开始逻辑
        const storage = PythaStorage.instance;
        const tempPrimitives = this.node.graph.cache.primitiveList;
        // 执行命令
        const cmd = new UpdateOwnPrimitiveCmd(tempPrimitives, this.node.graph.eventMediator);
        // 判断缓存中是否有commandGroup
        const graphCache = this.node.graph.cache;
        const commandGroup = graphCache.data['commandGroup'];
        if (!commandGroup || !(commandGroup instanceof CommandGroup)) {
            storage.historyStore.undos.push(cmd);
            cmd.execute();
        }
        else {
            commandGroup.addCmd(cmd);
        }
        return true;
    }
}/**
 * 绘制多段线图
 */
class EventGraphPline extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node3 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node4 = new EventGraphNode(this, EventHandlerCapture);
        const node5 = new EventGraphNode(this, EventHandlerOptionInput);
        const node6 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node7 = new EventGraphNodeAND(this, null);
        const node8 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node12 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node13 = new EventGraphNode(this, EventHandlerCalTempPlineCurve);
        const node14 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node16 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node18 = new EventGraphNode(this, EventHandlerGenTempPLine);
        const node19 = new EventGraphNode(this, EventHandlerUpdatePline);
        const node23 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定起点", option: 'S', inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.OPTION, PythaEventName.CONFIRM] },
                { type: NeedInputEnum.OPTION, description: "圆弧", option: "A" },
                { type: NeedInputEnum.OPTION, description: "直线", option: "L" },
            ]
        });
        const node25 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定下一点", option: 'P', inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.OPTION, PythaEventName.CONFIRM] },
                { type: NeedInputEnum.OPTION, description: "闭合", option: "C" },
                { type: NeedInputEnum.OPTION, description: "圆弧", option: "A" },
                { type: NeedInputEnum.OPTION, description: "直线", option: "L" },
            ]
        });
        const node27 = new EventGraphNode(this, EventHandlerUpdateOwnPri);
        const node28 = new EventGraphNode(this, EventHandlerGrid);
        const node29 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node30 = new EventGraphNode(this, EventHandlerGrid);
        const node31 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定下一点", option: 'P', inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.OPTION, PythaEventName.CONFIRM] },
                { type: NeedInputEnum.OPTION, description: "闭合", option: "C" },
                { type: NeedInputEnum.OPTION, description: "圆弧", option: "A" },
                { type: NeedInputEnum.OPTION, description: "直线", option: "L" },
            ]
        });
        const node32 = new EventGraphNode(this, EventHandlerUpdatePlineType);
        const node33 = new EventGraphNodeSwitch(this, () => {
            if (this.cache.inputOption == "C") {
                return [1];
            }
            else {
                return [0];
            }
        });
        const node34 = new EventGraphNode(this, EventHandlerClosePline);
        const node35 = new EventGraphNode(this, EventHandlerConfirm);
        const node36 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node38 = new EventGraphNode(this, EventHandlerInitCapture);
        const node39 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node40 = new EventGraphNode(this, EHChangeCrossCursor);
        const node41 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node42 = new EventGraphNode(this, EventHandlerInitCapture);
        const node43 = new EventGraphNodeAND(this, null);
        const node44 = new EventGraphNode(this, EventHandlerConfirm);
        const node45 = new EventGraphNode(this, EventHandlerOptionInput);
        const node46 = new EventGraphNode(this, EventHandlerUpdatePlineType);
        const node47 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定起点", option: 'S', inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.OPTION, PythaEventName.CONFIRM] },
                { type: NeedInputEnum.OPTION, description: "圆弧", option: "A" },
                { type: NeedInputEnum.OPTION, description: "直线", option: "L" },
            ]
        });
        const node48 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定下一点", option: 'P', inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.OPTION, PythaEventName.CONFIRM] },
                { type: NeedInputEnum.OPTION, description: "闭合", option: "C" },
                { type: NeedInputEnum.OPTION, description: "圆弧", option: "A" },
                { type: NeedInputEnum.OPTION, description: "直线", option: "L" },
            ]
        });
        const node49 = new EventGraphNodeSwitch(this, () => {
            if (this.cache.primitiveList.length === 1 && this.eventMediator.storage.primitiveStore.primitiveDict[this.cache.primitiveList[0].uuid] != null) {
                return [0];
            }
            else {
                return [1];
            }
        });
        const node50 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node51 = new EventGraphNode(this, null);
        const node52 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        const node53 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        this.addEdge(node1, node3);
        this.addEdge(node2, node4);
        this.addEdge(node4, node7);
        this.addEdge(node19, node14);
        this.addEdge(node18, node14);
        this.addEdge(node7, node8);
        this.addEdge(node1, node23);
        this.addEdge(node13, node30);
        this.addEdge(node30, node16);
        this.addEdge(node8, node13);
        this.addEdge(node32, node13);
        this.addEdge(node5, node33);
        /**输入选项为切换*/
        this.addEdge(node33, node32);
        this.addEdge(node28, node29);
        this.addEdge(node35, node12);
        this.addEdge(node1, node38);
        this.addEdge(node27, node39);
        this.addEdge(node3, node40);
        this.addEdge(node38, node41);
        this.addEdge(node41, node2);
        this.addEdge(node23, node6);
        this.addEdge(node25, node19);
        this.addEdge(node39, node42);
        this.addEdge(node42, node28);
        this.addEdge(node43, node36);
        this.addEdge(node29, node43);
        this.addEdge(node23, node35);
        this.addEdge(node6, node31);
        this.addEdge(node31, node18);
        this.addEdge(node6, node5);
        this.addEdge(node6, node13);
        this.addEdge(node6, node35, EDGE_TYPE.STOP);
        this.addEdge(node6, node44);
        this.addEdge(node23, node45);
        this.addEdge(node45, node46);
        this.addEdge(node6, node45, EDGE_TYPE.STOP);
        this.addEdge(node46, node47);
        this.addEdge(node47, node45);
        this.addEdge(node32, node48);
        this.addEdge(node48, node5);
        this.addEdge(node19, node49);
        /**图元存在*/
        this.addEdge(node49, node27);
        this.addEdge(node50, node39);
        this.addEdge(node34, node51);
        this.addEdge(node44, node51);
        this.addEdge(node51, node43);
        this.addEdge(node51, node49);
        this.addEdge(node6, node52);
        this.addEdge(node52, node7);
        this.addEdge(node14, node53);
        this.addEdge(node53, node25);
        /**选项为闭合多边形*/
        this.addEdge(node33, node34);
        /**图元不存在（第一条线）*/
        this.addEdge(node49, node50);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/9
    }
    /**
     * 清空临时线与临时圆弧
     */
    end() {
        let tempLine = this.cache.data['tempLinePrimitive'];
        let tempArc = this.cache.data['tempArcPrimitive'];
        if (tempArc)
            tempArc.needDelete = true;
        if (tempLine)
            tempLine.needDelete = true;
    }
}
EventGraphPline.cmd = 'PLINE';/**
 * 计算临时棱锥
 */
class EventHandlerCalTempPyramid extends EventHandlerBase {
    constructor() {
        super(...arguments);
        this._cameraDir = new Vector3();
        this._screenUp = new Vector3();
        this.heightVec = new Vector3();
        this._normal = new Vector3();
        this._extrudePlane = new Plane$1();
        this._projectPoint = new Point();
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a, _b;
        // 获取存储
        //console.log("计算临时棱锥~~~")
        const storage = PythaStorage.instance;
        const workPlane = storage.coordinateStore.workPlane;
        const pointerDownList = this.node.graph.cache.pointerDownList;
        let edge = this.node.graph.cache.inputNumber['EDGE_NUMBER']; // TODO
        if (edge == null)
            edge = 4;
        if (pointerDownList.length < 1)
            return false;
        let primitiveList = this.node.graph.cache.primitiveList;
        if (primitiveList.length < 1) {
            // 创建棱锥
            let pointer = pointerDownList[0];
            this._normal.copy(workPlane.normal);
            let pyramid = new Pyramid(pointer.point, 1e-4, 1e-4, edge, 0, this._normal);
            let primitive = new Primitive("pyramid");
            primitive.geos.push(pyramid);
            let keys = Object.keys(primitive.renderItemDict);
            if (keys.length > 0) {
                let renderItem = primitive.renderItemDict[keys[0]];
                renderItem.geoElements = pyramid.getGeoElementsIdxList();
                (_a = renderItem.mat) === null || _a === void 0 ? void 0 : _a.color.set(storage.layerStore.getColor());
            }
            primitive.temporary = true;
            this.node.graph.cache.primitiveList.push(primitive);
            this.node.graph.cache.data['pyramid'] = pyramid;
            storage.primitiveStore.tempPrimitiveDict[primitive.uuid] = primitive;
        }
        let pyramid = this.node.graph.cache.data['pyramid'];
        let primitive = this.node.graph.cache.primitiveList[0];
        let inputNumberMap = this.node.graph.cache.inputNumber;
        if (!pointerDownList.map(pd => pd.option).includes("R") && inputNumberMap['R'] == null) {
            // 计算半径
            const pointMove = storage.coordinateStore.currentPos;
            // 计算x轴方向
            let subVector = new Vector3().subVectors(pointMove, pointerDownList[0].point);
            if (Math.abs(subVector.x) < 1e-6) {
                subVector.x = 1e-5;
            }
            if (Math.abs(subVector.y) < 1e-6) {
                subVector.y = 1e-5;
            }
            // 计算半径
            let radius = pointMove.distanceTo(pointerDownList[0].point);
            pyramid.setXYZ(subVector, this._normal);
            pyramid.radius = radius;
        }
        else if (!pointerDownList.map(pd => pd.option).includes("H") && inputNumberMap['H'] == null) {
            // 计算高度
            const pointMove = storage.coordinateStore.currentPos;
            let center = pointerDownList[0].point;
            // 判断相机方向是否与法向量同向
            let viewportStore = storage.viewportStore;
            const camera = (_b = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _b === void 0 ? void 0 : _b.camera;
            camera.getWorldDirection(this._cameraDir);
            this._screenUp.copy(camera.up).cross(this._cameraDir).cross(this._cameraDir);
            // 获得光标所在平面，该平面垂直于屏幕，且水平
            this._extrudePlane.setFromNormalAndCoplanarPoint(this._screenUp, pointMove);
            this.heightVec = pointMove.clone().sub(center);
            if (Math.abs(this._screenUp.dot(this._normal)) < 1e-6) {
                pyramid.height = this.heightVec.length();
            }
            else {
                // this._extrudePlane.intersectStraightLine(this.center, this._axisZ, this._projectPoint);
                GeoIntersection.PlaneIntersectStraightLine(this._extrudePlane, center, this._normal, this._projectPoint);
                let height = this._projectPoint.sub(center).length();
                if (this._projectPoint.angleTo(this._normal) > Math.PI / 2) {
                    // height *= -1;
                    this._normal.negate();
                    pyramid.setNormal(this._normal.x, this._normal.y, this._normal.z);
                }
                pyramid.height = height;
            }
        }
        if (inputNumberMap['R'])
            pyramid.radius = inputNumberMap['R'];
        if (inputNumberMap['H'])
            pyramid.height = inputNumberMap['H'];
        //console.log("pyramid", pyramid, pyramid.radius, pyramid.height)
        primitive.needRedraw = true;
        return true;
    }
}/**
 * pyramid指令 用于绘制棱锥
 */
class EventGraphPyramid extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node3 = new EventGraphNode(this, EventHandlerCapture);
        const node4 = new EventGraphNodeAND(this, null);
        const node6 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{ type: NeedInputEnum.ACTIVE, description: "指定底面的中心点或", option: 'C', inputTypes: [PythaEventName.POINTER_DOWN] },
                { type: NeedInputEnum.OPTION, description: "侧面", option: "S" },
            ]
        });
        const node7 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node8 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node9 = new EventGraphNode(this, EventHandlerConfirm);
        const node10 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node11 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定底面半径", option: "R", inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER] },
            ]
        });
        const node13 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node14 = new EventGraphNode(this, EventHandlerNumberInput);
        const node15 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定高度", option: "H", inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER] },
            ]
        });
        const node17 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node18 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node19 = new EventGraphNode(this, EventHandlerNumberInput);
        const node20 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node21 = new EventGraphNode(this, EventHandlerGrid);
        const node22 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node23 = new EventGraphNode(this, EventHandlerGrid);
        const node24 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node27 = new EventGraphNode(this, EventHandlerCalTempPyramid);
        const node28 = new EventGraphNode(this, EventHandlerNumberInput);
        const node29 = new EventGraphNode(this, EventHandlerCalTempPyramid);
        const node30 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定底面中心", option: 'C', inputTypes: [PythaEventName.POINTER_DOWN] },
            ]
        });
        const node33 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node34 = new EventGraphNode(this, EventHandlerInitCapture);
        const node35 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node36 = new EventGraphNode(this, EHChangeCrossCursor);
        const node38 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定侧面数量", option: 'EDGE_NUMBER', inputTypes: [PythaEventName.COUNT] },
            ]
        });
        const node39 = new EventGraphNode(this, EventHandlerOptionInput);
        this.addEdge(node2, node3);
        this.addEdge(node3, node4);
        this.addEdge(node1, node9);
        this.addEdge(node9, node10);
        this.addEdge(node8, node11);
        this.addEdge(node13, node15);
        this.addEdge(node4, node17);
        this.addEdge(node18, node20);
        this.addEdge(node21, node22);
        this.addEdge(node23, node24);
        this.addEdge(node24, node10);
        this.addEdge(node8, node4);
        this.addEdge(node17, node29);
        this.addEdge(node29, node21);
        this.addEdge(node13, node29);
        this.addEdge(node19, node27);
        this.addEdge(node27, node20);
        this.addEdge(node1, node7);
        this.addEdge(node7, node33);
        this.addEdge(node33, node34);
        this.addEdge(node34, node2);
        this.addEdge(node20, node35);
        this.addEdge(node35, node23);
        this.addEdge(node7, node36);
        this.addEdge(node36, node6);
        this.addEdge(node15, node18);
        this.addEdge(node15, node19);
        this.addEdge(node11, node13);
        this.addEdge(node11, node14);
        this.addEdge(node14, node15);
        this.addEdge(node30, node8);
        this.addEdge(node28, node30);
        this.addEdge(node38, node28);
        this.addEdge(node6, node39);
        this.addEdge(node39, node38);
        this.addEdge(node8, node39, EDGE_TYPE.STOP);
        this.addEdge(node13, node14, EDGE_TYPE.STOP);
        this.addEdge(node14, node13, EDGE_TYPE.STOP);
        this.addEdge(node6, node8);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/84
    }
}
/**
 * pyramid指令 用于注册事件图
 */
EventGraphPyramid.cmd = 'PYRAMID';/**
 * 清空选择
 */
class EventHandlerEmptySelect extends EventHandlerBase {
    run(data) {
        PythaStorage.instance.selectStore.selectPrimitives.forEach(p => {
            p.isSelected = false;
            p.needRedraw = true;
        });
        PythaStorage.instance.selectStore.selectPrimitives = [];
        return true;
    }
}/**
 * 计算临时偏移对象
 */
class EventHandlerCalTempOffset extends EventHandlerBase {
    // private primitive: Primitive;
    run(data) {
        var _a, _b;
        const graphCache = this.node.graph.cache;
        const pointerDownList = graphCache.pointerDownList;
        // 是否存在偏移距离
        if (this._offsetDist == null) {
            // 获取或计算偏移距离
            if (graphCache.inputNumber['D'] != null) {
                // 直接输入的值
                this._offsetDist = graphCache.inputNumber['D'];
            }
            else {
                // 两点确定的值
                const clickP1 = (_a = pointerDownList[0]) === null || _a === void 0 ? void 0 : _a.point;
                const clickP2 = (_b = pointerDownList[1]) === null || _b === void 0 ? void 0 : _b.point;
                if (clickP1 == null || clickP2 == null) {
                    return false;
                }
                this._offsetDist = clickP1.distanceTo(clickP2);
            }
        }
        const storage = this.getPythaStorage();
        let primitive = graphCache.primitiveList[0];
        if (primitive == null) {
            // 创建偏移对象
            const selectPrimitives = storage.selectStore.selectPrimitives;
            const selectPrimitive = selectPrimitives[0];
            if (selectPrimitive == null)
                return false;
            primitive = selectPrimitive.clone();
            primitive.temporary = true;
            // let keys = Object.keys(this.primitive.renderItemDict);
            // if (keys.length > 0) {
            //     let renderItem = this.primitive.renderItemDict[keys[0]];
            //     renderItem.geoElements = this.primitive.geos[0].getGeoElementsIdxList();
            // }
            storage.primitiveStore.tempPrimitiveDict[primitive.uuid] = primitive;
            graphCache.primitiveList.push(primitive);
        }
        const pointMove = storage.coordinateStore.currentPos;
        if (primitive.type === PrimitiveType.Line) {
            let geo = primitive.geos[0];
            this.calcLineOffset(pointMove, geo, primitive);
        }
        else if (primitive.type === PrimitiveType.Circle) {
            const geo = primitive.geos[0];
            this.calcCircleOffset(pointMove, geo, primitive);
        }
        else if (primitive.type === PrimitiveType.Arc) {
            const geo = primitive.geos[0];
            this.calcArcOffset(pointMove, geo, primitive);
        }
        primitive.needRedraw = true;
        return true;
    }
    /**
     * line计算偏移
     * @param point
     * @param geo
     * @param primitive
     */
    calcLineOffset(point, geo, primitive) {
        var _a;
        const graphCache = this.node.graph.cache;
        if (!!(primitive === null || primitive === void 0 ? void 0 : primitive.worldModelMatrix)) {
            // 将geo转换到世界坐标系下
            geo.transformMatrix.premultiply(primitive === null || primitive === void 0 ? void 0 : primitive.worldModelMatrix);
        }
        if (graphCache.data["start"] == null) {
            graphCache.data["start"] = geo.start;
        }
        if (graphCache.data["end"] == null) {
            graphCache.data["end"] = geo.end;
        }
        geo.set(graphCache.data["start"], graphCache.data["end"]);
        const delta = new Vector3().subVectors(geo.end, geo.start);
        let direction = delta.normalize();
        const _offsetDir = new Vector3();
        const normal = PythaStorage.instance.coordinateStore.workPlane.normal.clone();
        _offsetDir.crossVectors(normal, direction).normalize();
        // 通过鼠标指针所在位置与线的起点连成的向量判断偏移方向
        // const _dirPointSubStart = new Vector3();
        // _dirPointSubStart.subVectors(point, geo.start);
        // let angle = _offsetDir.angleTo(_dirPointSubStart) * 180 / Math.PI;
        // if (angle > 90) {
        //     _offsetDir.multiplyScalar(-1);
        // }
        // _offsetDir.multiplyScalar(this._offsetDist);
        // 这里通过二维的方式解决
        const viewportStore = this.getPythaStorage().viewportStore;
        const camera = viewportStore.viewportItems[viewportStore.currentViewportKey].camera;
        let viewMatrix = camera.matrixWorldInverse;
        let projectMatrix = camera.projectionMatrix;
        let transMat = new Matrix4().identity().premultiply(viewMatrix).premultiply(projectMatrix);
        this.projectBuffer(geo.start, transMat, _start2D);
        this.projectBuffer(geo.end, transMat, _end2D);
        this.projectBuffer(point, transMat, _pointMove2D);
        // 计算线段的二维方向向量
        _lineDir2D.copy(_vector2.subVectors(_end2D, _start2D).normalize());
        // 计算鼠标点相对线段的二维法向量
        _mouseDir2D.copy(_vector2.subVectors(_pointMove2D, _start2D));
        // 通过二维叉积判断偏移方向
        const crossProduct = _lineDir2D.x * _mouseDir2D.y - _lineDir2D.y * _mouseDir2D.x;
        if (crossProduct < 0) {
            _offsetDir.multiplyScalar(-1); // 调整偏移方向
        }
        _offsetDir.multiplyScalar(this._offsetDist);
        geo.move(_offsetDir);
        if (!!(primitive === null || primitive === void 0 ? void 0 : primitive.worldModelMatrix)) {
            // 做完全部操作后，从世界坐标系下转回局部
            geo.transformMatrix.premultiply((_a = primitive === null || primitive === void 0 ? void 0 : primitive.worldModelMatrix) === null || _a === void 0 ? void 0 : _a.clone().invert());
        }
    }
    /**
     * circle偏移
     * @param point
     * @param geo
     */
    calcCircleOffset(point, geo, primitive) {
        const graphCache = this.node.graph.cache;
        if (graphCache.data["radius"] == null) {
            graphCache.data["radius"] = geo.radius;
        }
        geo.radius = graphCache.data["radius"];
        let center = geo.center.clone();
        if (!!(primitive === null || primitive === void 0 ? void 0 : primitive.worldModelMatrix)) {
            center = center.applyMatrix4(primitive === null || primitive === void 0 ? void 0 : primitive.worldModelMatrix);
        }
        const radius = geo.radius;
        const distance = point.distanceTo(center);
        if (distance > radius) {
            geo.radius = geo.radius + this._offsetDist;
        }
        else if (distance < radius) {
            if (this._offsetDist < radius) {
                geo.radius = geo.radius - this._offsetDist;
            }
        }
    }
    /**
     * arc偏移
     * @param point
     * @param geo
     */
    calcArcOffset(point, geo, primitive) {
        // TODO 暂时不写
    }
    /**
     * 将3维点数组投影成2维点数组
     */
    projectBuffer(point, matrix, point2) {
        _vector$3.set(point.x, point.y, point.z);
        _vector$3.applyMatrix4(matrix);
        point2.set(_vector$3.x, _vector$3.y);
    }
}
const _vector$3 = new Vector3();
const _vector2 = new Vector2();
const _start2D = new Vector2();
const _end2D = new Vector2();
const _pointMove2D = new Vector2();
const _lineDir2D = new Vector2();
const _mouseDir2D = new Vector2();/**
 * 抑制框选
 */
class EventHandlerDisableRangeSelect extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        const selectStore = PythaStorage.instance.selectStore;
        selectStore.rangeSelectEnabled = false;
        return true;
    }
}/**
 * 清空当前捕捉点与捕捉池，删除捕捉点标签（如果有）
 */
class EventHandlerCaptureClear extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        // 输入
        const storage = this.getPythaStorage().captureStore;
        storage.capturePoint = null;
        storage.capturePointsPool = [];
        const captureLabel = this.node.graph.cache['captureLabel'];
        if (captureLabel != null) {
            captureLabel.remove();
        }
        return true;
    }
}class EGOffset extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node4 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node5 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node7 = new EventGraphNode(this, EventHandlerSelectStart);
        const node8 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node9 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node10 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node11 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                    type: NeedInputEnum.ACTIVE,
                    description: `指定偏移距离<${this.eventMediator.storage.primitiveStore.systemVarDict["OFFSET_DIST"] || 10}>`,
                    option: "D",
                    inputTypes: [PythaEventName.NUMBER, PythaEventName.POINTER_DOWN]
                }]
        });
        const node12 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定第二点", option: 'E', inputTypes: [PythaEventName.POINTER_DOWN] },
            ]
        });
        const node13 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node14 = new EventGraphNode(this, EventHandlerNumberInput);
        const node16 = new EventGraphNodeSwitch(this, () => {
            const storage = this.eventMediator.storage;
            const selectPrimitives = storage.selectStore.selectPrimitives;
            if (selectPrimitives.length === 0) {
                return [1];
            }
            // 选中多个图元或选中非处理图元
            if (selectPrimitives.length > 1) {
                return [3];
            }
            const primitive = selectPrimitives[0];
            if (primitive.type !== PrimitiveType.Circle && primitive.type !== PrimitiveType.Line && primitive.type !== PrimitiveType.Arc) {
                return [3];
            }
            this.cache.primitiveList = [];
            this.cache.data["end"] = null;
            this.cache.data["start"] = null;
            this.cache.data["radius"] = null;
            return [0, 2, 4];
        });
        const node17 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node21 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '选择要偏移的对象' });
        const node23 = new EventGraphNode(this, EventHandlerCalTempOffset);
        const node24 = new EventGraphNode(this, EventHandlerGrid);
        const node25 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node27 = new EventGraphNode(this, EventHandlerGrid);
        const node28 = new EventGraphNode(this, EventHandlerEmptySelect);
        const node29 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '偏移距离必须为正且非零' });
        const node30 = new EventGraphNodeSwitch(this, () => {
            var _a, _b;
            let inputNumber = this.cache.inputNumber['D'];
            if (this.cache.pointerDownList.length >= 2) {
                const clickP1 = (_a = this.cache.pointerDownList[0]) === null || _a === void 0 ? void 0 : _a.point;
                const clickP2 = (_b = this.cache.pointerDownList[1]) === null || _b === void 0 ? void 0 : _b.point;
                inputNumber = clickP1.distanceTo(clickP2);
            }
            else if (inputNumber == null) {
                inputNumber = this.eventMediator.storage.primitiveStore.systemVarDict["OFFSET_DIST"] || 10;
                this.cache.inputNumber['D'] = inputNumber;
                this.cache.pointerDownList = [];
            }
            if (inputNumber == null || isNaN(inputNumber) || inputNumber <= 0) {
                this.cache.inputNumber['D'] = null;
                this.cache.pointerDownList = [];
                return [0];
            }
            this.eventMediator.storage.primitiveStore.systemVarDict["OFFSET_DIST"] = inputNumber;
            return [1];
        });
        const node31 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node33 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node35 = new EventGraphNode(this, EHChangeCrossCursor);
        const node36 = new EventGraphNode(this, EHChangePickCursor);
        const node37 = new EventGraphNode(this, EventHandlerDisableRangeSelect);
        const node38 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node39 = new EventGraphNode(this, EventHandlerEmptySelect);
        const node40 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定要偏移那一侧上的点", option: 'OFF_POINT', inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.CONFIRM] },
            ]
        });
        const node41 = new EventGraphNode(this, EventHandlerConfirm);
        const node42 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node43 = new EventGraphNode(this, EventHandlerInitCapture);
        const node44 = new EventGraphNode(this, EventHandlerCapture);
        const node45 = new EventGraphNode(this, EventHandlerCaptureClear);
        const node46 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node48 = new EventGraphNode(this, EventHandlerHelpLine);
        const node49 = new EventGraphNode(this, EventHandlerMouseWheel);
        const node50 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        const node51 = new EventGraphNodeAND(this, null);
        const node52 = new EventGraphNode(this, EventHandlerRemoveHelpLine);
        const node53 = new EventGraphNode(this, EHChangeCrossCursor);
        const node54 = new EventGraphNode(this, EventHandlerDisableClamp);
        const node55 = new EventGraphNode(this, EventHandlerConfirm);
        const node56 = new EventGraphNode(this, EventHandlerCmdEnd);
        this.addEdge(node14, node9, EDGE_TYPE.STOP);
        this.addEdge(node9, node14, EDGE_TYPE.STOP);
        /**只选中一个图元，且为指定类型*/
        this.addEdge(node16, node5);
        this.addEdge(node5, node23);
        this.addEdge(node23, node27);
        this.addEdge(node27, node25);
        this.addEdge(node9, node12);
        this.addEdge(node12, node10);
        this.addEdge(node21, node8);
        this.addEdge(node14, node30);
        /**输入值非法*/
        this.addEdge(node30, node29);
        this.addEdge(node28, node33);
        this.addEdge(node4, node35);
        this.addEdge(node35, node11);
        this.addEdge(node11, node14);
        this.addEdge(node11, node9);
        this.addEdge(node33, node7);
        this.addEdge(node7, node36);
        this.addEdge(node36, node37);
        this.addEdge(node37, node21);
        this.addEdge(node8, node16);
        this.addEdge(node13, node31);
        this.addEdge(node31, node38);
        this.addEdge(node40, node13);
        this.addEdge(node11, node41);
        this.addEdge(node41, node30);
        this.addEdge(node1, node43);
        this.addEdge(node46, node44);
        this.addEdge(node49, node48);
        this.addEdge(node9, node51);
        this.addEdge(node51, node48);
        this.addEdge(node48, node50);
        this.addEdge(node44, node51);
        this.addEdge(node51, node49);
        this.addEdge(node11, node46);
        this.addEdge(node45, node46, EDGE_TYPE.STOP);
        this.addEdge(node45, node52);
        this.addEdge(node52, node16);
        this.addEdge(node42, node53);
        this.addEdge(node53, node40);
        this.addEdge(node43, node54);
        this.addEdge(node54, node4);
        this.addEdge(node17, node16);
        this.addEdge(node40, node55);
        this.addEdge(node55, node56);
        this.addEdge(node29, node11);
        this.addEdge(node10, node30);
        this.addEdge(node45, node49, EDGE_TYPE.STOP);
        this.addEdge(node24, node17);
        this.addEdge(node39, node24);
        this.addEdge(node38, node39);
        this.addEdge(node13, node5, EDGE_TYPE.STOP);
        /**没有选中图元*/
        this.addEdge(node16, node7);
        this.addEdge(node30, node45);
        /**只选中一个图元，且为指定类型*/
        this.addEdge(node16, node23);
        /**选中多个图元或选中的图元类型不为指定类型*/
        this.addEdge(node16, node28);
        this.addEdge(node16, node42);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/31
    }
}
EGOffset.cmd = "OFFSET";/**
 * 将选中的图元放入copySelect缓存
 */
class EventHandlerCopySelect extends EventHandlerBase {
    run(data) {
        const storage = PythaStorage.instance;
        const primitives = storage.selectStore.getUnlockedPrimitives();
        const graphCache = this.node.graph.cache;
        graphCache.data = {};
        const copySelects = [];
        primitives.forEach(primitive => {
            copySelects.push(primitive);
        });
        graphCache.data["copySelects"] = copySelects;
        return true;
    }
}/**
 * 计算图元交点
 */
class EventHandlerCalTrimPoint extends EventHandlerBase {
    constructor() {
        super(...arguments);
        this._vec = new Vector3();
        this._vector = new Vector3();
    }
    run(data) {
        // 获取存储
        const storage = this.getPythaStorage();
        const graphCache = this.node.graph.cache;
        // const selectPrimitives = storage.selectStore.selectPrimitives;
        // if (selectPrimitives.length < 1) {
        //     return false;
        // }
        // 第一次选中的剪切参考对象
        const selectFirst = graphCache.data["copySelects"] || [];
        if (selectFirst == null || selectFirst.length < 1) {
            return true;
        }
        // 第二次选中的剪切对象
        const uuids = this.node.graph.cache.data['lastSelectedPrimitiveUuids'] || [];
        const selectSecond = [];
        for (let uuid of uuids) {
            let pri = storage.primitiveStore.primitiveDict[uuid];
            if (pri != null) {
                selectSecond.push(pri);
            }
        }
        if (selectSecond.length <= 0) {
            return true;
        }
        // // 剪切参考对象
        // const selectFirst = [];
        // selectPrimitives.forEach(primitive => {
        //     if (copySelects.find(p => p.uuid === primitive.uuid)) {
        //         selectFirst.push(primitive);
        //     }
        // })
        // if (selectFirst.length === 0) {
        //     return true;
        // }
        // const trimIntersectPoints = [];
        // const trimPoints = [];
        // const ray = storage.coordinateStore.viewCursorRay;
        // 计算投影至ndc坐标的转换矩阵
        const viewportStore = storage.viewportStore;
        const currentCamera = viewportStore.viewportItems[viewportStore.currentViewportKey].camera;
        if (!currentCamera)
            return false;
        let viewMatrix = currentCamera.matrixWorldInverse;
        let projectMatrix = currentCamera.projectionMatrix;
        let transMat = new Matrix4().identity().premultiply(viewMatrix).premultiply(projectMatrix);
        let cmdGroup = graphCache.data['trimCmdGroup']; // 撤销重做命令集 
        if (graphCache.data['trimCmdGroup'] == null) {
            cmdGroup = new CommandGroup();
            graphCache.data['trimCmdGroup'] = cmdGroup; // 缓存到cache里，方便最后一起放入撤销重做
        }
        for (let i = 0; i < selectSecond.length; i++) {
            // 遍历第二次选中的剪切对象，求其与第一次选中对象的交点
            const trimPrimitive = selectSecond[i];
            let intersectPoints = [];
            for (let j = 0; j < selectFirst.length; j++) {
                const primitive = selectFirst[j];
                let points = [];
                // 求与第一次选中图元的交点
                if (primitive.uuid === trimPrimitive.uuid) {
                    // 如果遇到相同的图元，处理多段线的情况
                    if (trimPrimitive.type === PrimitiveType.Pline) ;
                    continue;
                }
                if (trimPrimitive.type === PrimitiveType.Arc || trimPrimitive.type === PrimitiveType.Circle) {
                    const arc = trimPrimitive.geos[0].clone();
                    if (trimPrimitive.worldModelMatrix != null) {
                        arc.transformMatrix.premultiply(trimPrimitive.worldModelMatrix);
                    }
                    points = this.handleArcIntersectAny(arc, primitive);
                }
                else if (trimPrimitive.type === PrimitiveType.Line) {
                    let line = trimPrimitive.geos[0].clone();
                    // 这里需要将几何统一至世界坐标
                    if (trimPrimitive.worldModelMatrix != null) {
                        line.transformMatrix.premultiply(trimPrimitive.worldModelMatrix);
                    }
                    points = this.handleLineIntersectAny(line, primitive);
                }
                // TODO 处理多段线
                points.forEach(point => {
                    if (!intersectPoints.some(item => item.equals(point))) {
                        intersectPoints.push(point);
                    }
                });
            }
            // 按交点分解第二次选中的图元
            if (intersectPoints.length <= 0)
                continue;
            let _pickRect = this.node.graph.cache.data['selectRange'];
            if (_pickRect == null) {
                // console.log("没有选框 无法判断剪切");
                continue;
            }
            if (trimPrimitive.type === PrimitiveType.Line) {
                let originLine = trimPrimitive.geos[0].clone();
                if (trimPrimitive.worldModelMatrix != null) {
                    originLine.transformMatrix.premultiply(trimPrimitive.worldModelMatrix);
                }
                let start = originLine.start;
                let lines = [];
                // 对交点排序
                let tValues = intersectPoints.map(point => {
                    const t = GeoIntersection.closestPointToLineParameter(originLine, point, true);
                    return { point, t };
                });
                tValues.sort((a, b) => a.t - b.t);
                let orderedIntersectPoints = tValues.map(item => item.point) || []; // 拿到排序后的交点序列
                let lastIntersectPoint = originLine.start; // 上一个交点
                let lastT = 0; // 上一个交点的位置
                for (let i = 0; i < orderedIntersectPoints.length; i++) {
                    let end = orderedIntersectPoints[i]; // 当前线段的终点
                    let endT = tValues[i].t;
                    if (this._vec.subVectors(end, lastIntersectPoint).length() < 1e-5)
                        continue; // 起点和终点重合，跳过
                    if (Math.abs(endT - lastT - 1) < 1e-5)
                        break; // 只有一段线，交点在边上
                    // 判断是否与选框相交 使用屏幕求交
                    let screenPoints = this.projectPoint([lastIntersectPoint, end], transMat);
                    let selected = this.pickSelect(screenPoints, _pickRect);
                    if (selected) {
                        // 如果相交 则剪除该段
                        if (i == 0) ;
                        else if (this._vec.subVectors(lastIntersectPoint, start).length() > 1e-5) {
                            // 将前一步的线存下来
                            let line = new Line$2(start, lastIntersectPoint);
                            lines.push(line);
                        }
                        // 将当前end设置为新的start
                        start = end.clone();
                    }
                    lastIntersectPoint = end;
                    lastT = endT;
                }
                // 单独处理一次末端的裁剪
                if (Math.abs(1 - lastT - 1) < 1e-5)
                    continue; // 只有一段线，交点在边上
                let screenPoints = this.projectPoint([lastIntersectPoint, originLine.end], transMat);
                let selected = this.pickSelect(screenPoints, _pickRect);
                if (!selected) {
                    lastIntersectPoint = originLine.end;
                }
                if (this._vec.subVectors(lastIntersectPoint, start).length() > 1e-5) {
                    //将最后一段没有被缓存的线存下来
                    let line = new Line$2(start, lastIntersectPoint);
                    lines.push(line);
                }
                // 创建图元
                let newPrimitives = [];
                for (let line of lines) {
                    let pri = trimPrimitive.clone();
                    pri.geos = [];
                    if (trimPrimitive.worldModelMatrixInverse != null) {
                        line.transformMatrix.premultiply(trimPrimitive.worldModelMatrixInverse);
                    }
                    pri.geos.push(line);
                    let keys = Object.keys(pri.renderItemDict);
                    if (keys.length > 0) {
                        let renderItem = pri.renderItemDict[keys[0]];
                        renderItem.geoElements = line.getGeoElementsIdxList();
                        // renderItem.mat?.color.set(storage.layerStore.getColor());
                    }
                    pri.isSelected = true;
                    pri.needRedraw = true;
                    newPrimitives.push(pri);
                }
                // 将新线添加，将旧线删除
                if (newPrimitives.length > 0) {
                    let addCmd = new AddPrimitiveCmd(newPrimitives, this.node.graph.eventMediator);
                    storage.selectStore.selectPrimitives.push(...newPrimitives); // 手动存入选择缓存，这样结束后颜色可以复原
                    addCmd.execute();
                    cmdGroup.addCmd(addCmd);
                }
                let deleteCmd = new DeletePrimitiveCmd([trimPrimitive], this.node.graph.eventMediator);
                deleteCmd.execute();
                graphCache.data["copySelects"] = selectFirst.filter(item => item.uuid != trimPrimitive.uuid) || [];
                cmdGroup.addCmd(deleteCmd);
            }
            else if (trimPrimitive.type === PrimitiveType.Arc) {
                let originArc = trimPrimitive.geos[0].clone();
                if (trimPrimitive.worldModelMatrix != null) {
                    originArc.transformMatrix.premultiply(trimPrimitive.worldModelMatrix);
                }
                const center = originArc.center;
                const normal = originArc.normal;
                let start = originArc.getPointAt(0);
                let arcs = [];
                // 对交点排序
                let tValues = intersectPoints.map(point => {
                    const t = GeoIntersection.PointToArcParameter(originArc, point, true);
                    return { point, t };
                });
                tValues.sort((a, b) => a.t - b.t);
                let orderedIntersectPoints = tValues.map(item => item.point) || []; // 拿到排序后的交点序列
                let lastIntersectPoint = originArc.getPointAt(0);
                let lastT = 0;
                for (let i = 0; i < orderedIntersectPoints.length; i++) {
                    let end = orderedIntersectPoints[i];
                    let endT = tValues[i].t;
                    if (this._vec.subVectors(end, lastIntersectPoint).length() < 1e-5)
                        continue; // 起点和终点重合，跳过
                    if (Math.abs(endT - lastT - 1) < 1e-5)
                        break; // 只有一段线，交点在边上
                    // 判断是否与选框相交
                    let points = [];
                    for (let t = lastT; t <= endT; t += (endT - lastT) / 50) {
                        let point = originArc.getPointAt(t);
                        points.push(point);
                    }
                    let screenPoints = this.projectPoint(points, transMat);
                    let selected = this.pickSelect(screenPoints, _pickRect);
                    if (selected) {
                        // 如果相交 则剪除该段
                        if (i == 0) ;
                        else if (this._vec.subVectors(lastIntersectPoint, start).length() > 1e-5) {
                            // 将前一步的线存下来
                            let arc = new Arc();
                            arc.setFromTwoPointAndCenter(start, lastIntersectPoint, center, normal);
                            arcs.push(arc);
                        }
                        // 将当前end设置为新的start
                        start = end.clone();
                    }
                    lastIntersectPoint = end;
                    lastT = endT;
                }
                // 单独处理一次末端的裁剪
                if (Math.abs(1 - lastT - 1) < 1e-5)
                    continue; // 只有一段线，交点在边上
                let points = [];
                for (let t = lastT; t <= 1; t += (1 - lastT) / 50) {
                    let point = originArc.getPointAt(t);
                    points.push(point);
                }
                let screenPoints = this.projectPoint(points, transMat);
                let selected = this.pickSelect(screenPoints, _pickRect);
                if (!selected) {
                    lastIntersectPoint = originArc.getPointAt(1);
                }
                if (this._vec.subVectors(lastIntersectPoint, start).length() > 1e-5) {
                    //将最后一段没有被缓存的线存下来
                    let arc = new Arc();
                    arc.setFromTwoPointAndCenter(start, lastIntersectPoint, center, normal);
                    arcs.push(arc);
                }
                // 创建图元
                let newPrimitives = [];
                for (let arc of arcs) {
                    let pri = trimPrimitive.clone();
                    pri.geos = [];
                    if (trimPrimitive.worldModelMatrixInverse != null) {
                        arc.transformMatrix.premultiply(trimPrimitive.worldModelMatrixInverse);
                    }
                    pri.geos.push(arc);
                    let keys = Object.keys(pri.renderItemDict);
                    if (keys.length > 0) {
                        let renderItem = pri.renderItemDict[keys[0]];
                        renderItem.geoElements = arc.getGeoElementsIdxList();
                        // renderItem.mat?.color.set(storage.layerStore.getColor());
                    }
                    pri.isSelected = true;
                    pri.needRedraw = true;
                    newPrimitives.push(pri);
                }
                // 将新线添加，将旧线删除
                if (newPrimitives.length > 0) {
                    let addCmd = new AddPrimitiveCmd(newPrimitives, this.node.graph.eventMediator);
                    storage.selectStore.selectPrimitives.push(...newPrimitives); // 手动存入选择缓存，这样结束后颜色可以复原
                    addCmd.execute();
                    cmdGroup.addCmd(addCmd);
                }
                let deleteCmd = new DeletePrimitiveCmd([trimPrimitive], this.node.graph.eventMediator);
                deleteCmd.execute();
                graphCache.data["copySelects"] = selectFirst.filter(item => item.uuid != trimPrimitive.uuid) || [];
                cmdGroup.addCmd(deleteCmd);
            }
            else if (trimPrimitive.type === PrimitiveType.Circle) {
                if (intersectPoints.length <= 1)
                    continue; // 只有一个交点时 跳过
                let originCircle = trimPrimitive.geos[0].clone();
                if (trimPrimitive.worldModelMatrix != null) {
                    originCircle.transformMatrix.premultiply(trimPrimitive.worldModelMatrix);
                }
                const center = originCircle.center;
                const normal = originCircle.normal;
                let arcs = [];
                // 对交点排序
                let tValues = intersectPoints.map(point => {
                    const t = GeoIntersection.PointToArcParameter(originCircle, point, true);
                    return { point, t };
                });
                tValues.sort((a, b) => a.t - b.t);
                let orderedIntersectPoints = tValues.map(item => item.point) || []; // 拿到排序后的交点序列
                let start = orderedIntersectPoints[0];
                let lastIntersectPoint = orderedIntersectPoints[0];
                let lastT = tValues[0].t;
                let stopPoint = null; // 圆要记录第一次打断的起点，方便最后一个弧的生成
                let stopPointT = null;
                for (let i = 0; i < orderedIntersectPoints.length; i++) {
                    // 圆要从交点开始生成弧段，按圆弧那样做会从x轴处打断成两个圆弧
                    let end = orderedIntersectPoints[i];
                    let endT = tValues[i].t;
                    if (this._vec.subVectors(end, lastIntersectPoint).length() < 1e-5)
                        continue; // 起点和终点重合，跳过
                    // if (Math.abs(endT - lastT - 1) < 1e-5) break; // 只有一段线，交点在边上
                    // 判断是否与选框相交
                    let points = [];
                    for (let t = lastT; t <= endT; t += (endT - lastT) / 50) {
                        let point = originCircle.getPointAt(t);
                        points.push(point);
                    }
                    let screenPoints = this.projectPoint(points, transMat);
                    let selected = this.pickSelect(screenPoints, _pickRect);
                    if (selected) {
                        // 如果相交 则剪除该段
                        if (!stopPoint) {
                            // 说明是第一段线被裁剪
                            stopPoint = lastIntersectPoint;
                            stopPointT = lastT;
                        }
                        else if (this._vec.subVectors(lastIntersectPoint, start).length() > 1e-5) {
                            // 将前一步的线存下来
                            let arc = new Arc();
                            arc.setFromTwoPointAndCenter(start, lastIntersectPoint, center, normal);
                            arcs.push(arc);
                        }
                        // 将当前end设置为新的start
                        start = end.clone();
                    }
                    lastIntersectPoint = end;
                    lastT = endT;
                }
                // 单独处理一次末端的裁剪
                if (stopPoint == null) {
                    // 前面都没有修剪命中
                    stopPoint = orderedIntersectPoints[0];
                    stopPointT = tValues[0].t;
                }
                if (this._vec.subVectors(lastIntersectPoint, stopPoint).length() < 1e-5)
                    continue; // 最后一段线重合
                let points = [];
                for (let t = lastT; t <= 1 + stopPointT; t += (1 + stopPointT - lastT) / 50) {
                    let point = originCircle.getPointAt(t);
                    points.push(point);
                }
                let screenPoints = this.projectPoint(points, transMat);
                let selected = this.pickSelect(screenPoints, _pickRect);
                if (!selected) {
                    lastIntersectPoint = stopPoint;
                }
                if (this._vec.subVectors(lastIntersectPoint, start).length() > 1e-5) {
                    //将最后一段没有被缓存的线存下来
                    let arc = new Arc();
                    arc.setFromTwoPointAndCenter(start, lastIntersectPoint, center, normal);
                    arcs.push(arc);
                }
                // 创建图元
                let newPrimitives = [];
                for (let arc of arcs) {
                    let pri = trimPrimitive.clone();
                    pri.type = PrimitiveType.Arc; // 圆被修建以后只能是圆弧
                    pri.geos = [];
                    if (trimPrimitive.worldModelMatrixInverse != null) {
                        arc.transformMatrix.premultiply(trimPrimitive.worldModelMatrixInverse);
                    }
                    pri.geos.push(arc);
                    let keys = Object.keys(pri.renderItemDict);
                    if (keys.length > 0) {
                        let renderItem = pri.renderItemDict[keys[0]];
                        renderItem.geoElements = arc.getGeoElementsIdxList();
                        // renderItem.mat?.color.set(storage.layerStore.getColor());
                    }
                    pri.isSelected = true;
                    pri.needRedraw = true;
                    newPrimitives.push(pri);
                }
                // 将新线添加，将旧线删除
                if (newPrimitives.length > 0) {
                    let addCmd = new AddPrimitiveCmd(newPrimitives, this.node.graph.eventMediator);
                    storage.selectStore.selectPrimitives.push(...newPrimitives); // 手动存入选择缓存，这样结束后颜色可以复原
                    addCmd.execute();
                    cmdGroup.addCmd(addCmd);
                }
                let deleteCmd = new DeletePrimitiveCmd([trimPrimitive], this.node.graph.eventMediator);
                deleteCmd.execute();
                graphCache.data["copySelects"] = selectFirst.filter(item => item.uuid != trimPrimitive.uuid) || [];
                cmdGroup.addCmd(deleteCmd);
            }
            // trimIntersectPoints.push(intersectPoints);
        }
        // graphCache.data['intersectPoints'] = trimIntersectPoints;
        // graphCache.data['trimPoints'] = trimPoints;
        // if (cmdGroup.cmds.length > 0) {
        //     storage.historyStore.undos.push(cmdGroup);
        //     cmdGroup.execute();
        // }
        return true;
    }
    /**
     * 弧形和其他图元求交
     * @param arc
     * @param otherPrimitive
     * @returns
     */
    handleArcIntersectAny(arc, otherPrimitive) {
        if (otherPrimitive.type === PrimitiveType.Line) {
            const geo = otherPrimitive.geos[0].clone();
            if (otherPrimitive.worldModelMatrix != null) {
                geo.transformMatrix.premultiply(otherPrimitive.worldModelMatrix);
            }
            return GeoIntersection.ArcIntersectLine(arc, geo, true, true);
        }
        else if (otherPrimitive.type === PrimitiveType.Arc || otherPrimitive.type === PrimitiveType.Circle) {
            const geo = otherPrimitive.geos[0].clone();
            if (otherPrimitive.worldModelMatrix != null) {
                geo.transformMatrix.premultiply(otherPrimitive.worldModelMatrix);
            }
            return GeoIntersection.ArcIntersectArc(arc, geo, true, true);
        }
        return [];
    }
    /**
     * 线段和其他图元求交
     * @param line
     * @param otherPrimitive
     * @returns
     */
    handleLineIntersectAny(line, otherPrimitive) {
        if (otherPrimitive.type === PrimitiveType.Line) {
            const geo = otherPrimitive.geos[0].clone();
            if (otherPrimitive.worldModelMatrix != null) {
                geo.transformMatrix.premultiply(otherPrimitive.worldModelMatrix);
            }
            let point = GeoIntersection.LineIntersectSegment(line, geo.start, geo.end, true, true);
            if (point != null)
                return [point];
            return [];
        }
        else if (otherPrimitive.type === PrimitiveType.Arc || otherPrimitive.type === PrimitiveType.Circle) {
            let geo = otherPrimitive.geos[0].clone();
            if (otherPrimitive.worldModelMatrix != null) {
                geo.transformMatrix.premultiply(otherPrimitive.worldModelMatrix);
            }
            return GeoIntersection.ArcIntersectLine(geo, line, true, true);
        }
        return [];
    }
    /**
     * 将点投影至屏幕ndc坐标
     * @param points
     * @param matrix
     * @returns 返回二维点坐标 值域[-1, 1]
     */
    projectPoint(points, matrix) {
        const count = points.length;
        let result = [];
        for (let i = 0; i < count; i++) {
            let point = points[i];
            this._vector.set(point.x, point.y, point.z);
            this._vector.applyMatrix4(matrix);
            result.push(new Point2(this._vector.x, this._vector.y));
        }
        return result;
    }
    /**
     * 判断是否选中
     * @param points 曲线插值点构成的点集
     * @param _pickRect
     * @returns
     */
    pickSelect(points, _pickRect) {
        for (let i = 0; i < points.length; i += 2) {
            let selected = _pickRect.select(points[i], points[i + 1]);
            if (selected) {
                return true;
            }
        }
        return false;
    }
}class EventGraphTrim extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNodeSwitch(this, () => {
            const storage = PythaStorage.instance;
            if (storage.selectStore.selectPrimitives.length < 1) {
                return [0];
            }
            return [1];
        });
        const node3 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '请选择对象' });
        const node4 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '选择剪切对象' });
        const node5 = new EventGraphNode(this, EventHandlerConfirm);
        const node7 = new EventGraphNode(this, EventHandlerListenPrimitiveSelect);
        const node8 = new EventGraphNode(this, EventHandlerCalTrimPoint);
        const node11 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node12 = new EventGraphNode(this, EventHandlerGrid);
        const node14 = new EventGraphNode(this, EventHandlerConfirm);
        const node15 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node16 = new EventGraphNode(this, EventHandlerCopySelect);
        const node17 = new EventGraphNode(this, EHChangePickCursor);
        const node18 = new EventGraphNode(this, EventHandlerDisableClamp);
        const node19 = new EventGraphNode(this, EHChangePickCursor);
        const node20 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        this.addEdge(node1, node2);
        this.addEdge(node3, node5);
        this.addEdge(node4, node7);
        this.addEdge(node14, node15);
        this.addEdge(node12, node11);
        this.addEdge(node11, node4);
        this.addEdge(node7, node8);
        this.addEdge(node16, node14);
        this.addEdge(node2, node17);
        this.addEdge(node17, node18);
        this.addEdge(node18, node3);
        this.addEdge(node5, node2);
        this.addEdge(node16, node19);
        this.addEdge(node19, node4);
        this.addEdge(node20, node12);
        this.addEdge(node8, node20);
        /**选中了图元*/
        this.addEdge(node2, node16);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/93
    }
    end() {
        let cmdGroup = this.cache.data['trimCmdGroup'];
        if (cmdGroup != null && cmdGroup.cmds.length > 0) {
            let storage = this.eventMediator.storage;
            storage === null || storage === void 0 ? void 0 : storage.historyStore.undos.push(cmdGroup);
        }
        super.end();
    }
}
EventGraphTrim.cmd = "TRIM";/**
 * 计算拖拽图元
 */
class EventHandlerStretch extends EventHandlerBase {
    constructor() {
        super(...arguments);
        this._vec = new Vector3(); // 临时变量 减少瞬时内存开销
        this.primitives = [];
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        const storage = PythaStorage.instance;
        let selectPrimitives = PythaStorage.instance.selectStore.getUnlockedPrimitives();
        if (selectPrimitives.length <= 0)
            return false;
        if (this.primitives.length <= 0) {
            for (let sp of selectPrimitives) {
                let pri = sp.clone();
                pri.uuid = sp.uuid;
                pri.temporary = true;
                pri.selectedControlPoints = sp.selectedControlPoints;
                this.primitives.push(pri);
                storage.primitiveStore.tempPrimitiveDict[pri.uuid] = pri;
            }
            this.node.graph.cache.primitiveList = [...this.primitives];
        }
        const pointerDownList = this.node.graph.cache.pointerDownList;
        if (pointerDownList.length < 1)
            return false;
        let pointdown = pointerDownList[0].point;
        let pointmove = storage.coordinateStore.currentPos;
        this._vec.subVectors(pointmove, pointdown);
        for (let i = 0; i < this.primitives.length; i++) {
            let primitive = this.primitives[i];
            let old = selectPrimitives[i];
            for (let k = 0; k < old.geos.length; k++) {
                primitive.geos[k].copy(old.geos[k]);
            }
            for (let j = 0; j < primitive.geos.length; j++) {
                let geo = primitive.geos[j];
                let cps = primitive.selectedControlPoints[j];
                if (cps == null || cps.length <= 0)
                    continue;
                geo.setByControlPoint(cps, this._vec);
            }
            primitive.needRedraw = true;
        }
        return true;
    }
    /**
     * 销毁
     */
    dispose() {
        for (let pri of this.primitives) {
            pri.needDelete = true;
        }
    }
}/**
 * 拖拽
 */
class EventGraphStretch extends EventGraphBase {
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerConfirm);
        const node3 = new EventGraphNodeSwitch(this, () => {
            const storage = PythaStorage.instance;
            if (storage.selectStore.getUnlockedPrimitives().length <= 0) {
                return [0];
            }
            return [1];
        });
        const node4 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node5 = new EventGraphNodeSwitch(this, () => {
            const storage = PythaStorage.instance;
            if (storage.selectStore.getUnlockedPrimitives().length <= 0) {
                return [0];
            }
            return [1];
        });
        const node6 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node7 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node8 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node9 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定基点", option: 'P', inputTypes: [PythaEventName.POINTER_DOWN] },
            ] });
        const node10 = new EventGraphNode(this, EventHandlerCapture);
        const node11 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node12 = new EventGraphNodeAND(this, null);
        const node13 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定第二点", option: 'E', inputTypes: [PythaEventName.POINTER_DOWN] },
            ] });
        const node14 = new EventGraphNode(this, EventHandlerStretch);
        const node15 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node16 = new EventGraphNode(this, EventHandlerGrid);
        const node17 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node18 = new EventGraphNode(this, EventHandlerEditPri);
        const node19 = new EventGraphNode(this, EventHandlerInitCapture);
        const node20 = new EventGraphNode(this, EventHandlerGrid);
        const node21 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node22 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        const node23 = new EventGraphNode(this, EventHandlerMouseWheel);
        const node24 = new EventGraphNode(this, EventHandlerHelpLine);
        const node25 = new EventGraphNode(this, EventHandlerDisableClamp);
        const node26 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '选择对象' });
        const node27 = new EventGraphNode(this, EHChangeCrossCursor);
        const node28 = new EventGraphNode(this, EHChangePickCursor);
        this.addEdge(node2, node5);
        /**没有选中图元*/
        this.addEdge(node5, node4);
        this.addEdge(node8, node9);
        this.addEdge(node9, node6);
        this.addEdge(node6, node13);
        this.addEdge(node7, node10);
        this.addEdge(node10, node12);
        this.addEdge(node12, node11);
        this.addEdge(node13, node12);
        this.addEdge(node11, node14);
        this.addEdge(node13, node15);
        this.addEdge(node14, node16);
        this.addEdge(node16, node17);
        this.addEdge(node9, node19);
        this.addEdge(node19, node7);
        this.addEdge(node15, node18);
        this.addEdge(node18, node20);
        this.addEdge(node20, node21);
        this.addEdge(node10, node22);
        this.addEdge(node21, node4);
        this.addEdge(node23, node24);
        this.addEdge(node24, node17);
        this.addEdge(node11, node23);
        this.addEdge(node11, node24);
        this.addEdge(node1, node25);
        this.addEdge(node25, node3);
        /**没有选中的图元*/
        this.addEdge(node3, node26);
        this.addEdge(node8, node27);
        this.addEdge(node26, node28);
        this.addEdge(node28, node2);
        this.addEdge(node3, node8);
        /**选中图元*/
        this.addEdge(node5, node8);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/97
    }
}
/**
 * 指令 用于注册事件图
 */
EventGraphStretch.cmd = 'STRETCH';/**
 * 计算倒角
 */
class EventHandlerCalTempChamfer extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    //todo可优化逻辑减少不必要运算
    run(data = {}) {
        var _a;
        // 获取存储
        const storage = PythaStorage.instance;
        const pointerDownList = this.node.graph.cache.data.SavePoints;
        if (pointerDownList.length != 2)
            return false;
        let pointer1 = pointerDownList[0];
        let pointer2 = pointerDownList[1];
        const selectPrimitives = storage.selectStore.getUnlockedPrimitives();
        if (selectPrimitives.length != 2)
            return false;
        if (selectPrimitives[0].type != PrimitiveType.Line || selectPrimitives[1].type != PrimitiveType.Line)
            return false;
        let line1 = selectPrimitives[0].geos[0];
        let line2 = selectPrimitives[1].geos[0];
        let start1 = line1.start;
        let end1 = line1.end;
        let start2 = line2.start;
        let end2 = line2.end;
        let crossPoint = new Point();
        let pointAfterChamferLine1 = new Point();
        let pointAfterChamferLine2 = new Point();
        //判断两条线是否相交,若不相交则无法计算倒角
        if (!GeoIntersection.StraightLineIntersectStraightLine(new StraightLine(start1, new Vector3(end1.x, end1.y, end1.z).sub(start1)), new StraightLine(start2, new Vector3(end2.x, end2.y, end2.z).sub(start2)), crossPoint))
            return false;
        let viewportStore = storage.viewportStore;
        const camera = (_a = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        //line1为AB(start1为A)，line2为CD，交点为T
        let A = line1.start.project(camera);
        line1.end.project(camera);
        let C = line2.start.project(camera);
        line2.end.project(camera);
        let T = crossPoint.clone().project(camera);
        let P1 = pointer1.point.project(camera);
        let P2 = pointer2.point.project(camera); //TODO应该用哪个值？point2还是point
        //用向量判断在哪一段上，通过AT·AP1与AT·AT大小判断P1在哪一段上
        let ATdotAP1 = new Vector3().subVectors(A, T).dot(new Vector3().subVectors(A, P1));
        let ATdotAT = new Vector3().subVectors(A, T).dot(new Vector3().subVectors(A, T));
        if (ATdotAP1 > ATdotAT) {
            pointAfterChamferLine1 = end1;
        }
        else {
            pointAfterChamferLine1 = start1;
        }
        //用向量判断在哪一段上，通过CT·CP2与CT·CT大小判断P2在哪一段上
        let CTdotCP2 = new Vector3().subVectors(C, T).dot(new Vector3().subVectors(C, P2));
        let CTdotCT = new Vector3().subVectors(C, T).dot(new Vector3().subVectors(C, T));
        if (CTdotCP2 > CTdotCT) {
            pointAfterChamferLine2 = end2;
        }
        else {
            pointAfterChamferLine2 = start2;
        }
        let distanceS1 = crossPoint.distanceTo(start1);
        let distanceE1 = crossPoint.distanceTo(end1);
        let distanceL1 = start1.distanceTo(end1);
        let distanceS2 = crossPoint.distanceTo(start2);
        let distanceE2 = crossPoint.distanceTo(end2);
        let distanceL2 = start2.distanceTo(end2);
        if (Math.abs(distanceE1 - distanceS1 - distanceL1) < 1e-5 * distanceL1) {
            pointAfterChamferLine1 = end1;
        }
        if (Math.abs(distanceS1 - distanceE1 - distanceL1) < 1e-5 * distanceL1) {
            pointAfterChamferLine1 = start1;
        }
        if (Math.abs(distanceE2 - distanceS2 - distanceL2) < 1e-5 * distanceL2) {
            pointAfterChamferLine2 = end2;
        }
        if (Math.abs(distanceS2 - distanceE2 - distanceL2) < 1e-5 * distanceL2) {
            pointAfterChamferLine2 = start2;
        }
        //判断倒角半径是否合法,这是倒直线角部分
        let r = this.node.graph.cache.inputNumber['R']; // TODO
        if (r == null)
            r = 0;
        if (r > crossPoint.distanceTo(pointAfterChamferLine1) || r > crossPoint.distanceTo(pointAfterChamferLine2))
            return false;
        let vec1 = new Vector3().subVectors(pointAfterChamferLine1, crossPoint).normalize().multiplyScalar(r);
        let vec2 = new Vector3().subVectors(pointAfterChamferLine2, crossPoint).normalize().multiplyScalar(r);
        //线段统一转化为由交点指向外部的方向
        line1.start = crossPoint.clone().add(vec1);
        line1.end = pointAfterChamferLine1;
        line2.start = crossPoint.clone().add(vec2);
        line2.end = pointAfterChamferLine2;
        selectPrimitives[0].needRedraw = true;
        selectPrimitives[1].needRedraw = true;
        //若r!=0加入新的直线
        if (r != 0) {
            let line3 = new Line$2(line1.start, line2.start);
            let primitive = new Primitive();
            primitive.type = PrimitiveType.Line;
            primitive.geos.push(line3);
            let keys = Object.keys(primitive.renderItemDict);
            if (keys.length > 0) {
                let renderItem = primitive.renderItemDict[keys[0]];
                renderItem.geoElements = line3.getGeoElementsIdxList();
            }
            primitive.temporary = true;
            this.node.graph.cache.primitiveList.push(primitive);
            storage.primitiveStore.tempPrimitiveDict[primitive.uuid] = primitive;
            selectPrimitives.push(primitive);
            primitive.needRedraw = true;
        }
        this.node.graph.cache.data.SavePoints = [];
        // this.node.graph.cache.inputNumber = null;
        return true;
    }
}/**
 * 保存上一个确定点点
 */
class EventHandlerSavePointDown extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        const pointerDownList = this.node.graph.cache.pointerDownList;
        if (pointerDownList.length < 1)
            return false;
        if (!this.node.graph.cache.data.SavePoints) {
            this.node.graph.cache.data.SavePoints = [];
        }
        const pointer = pointerDownList[pointerDownList.length - 1];
        this.node.graph.cache.data.SavePoints.push(pointer);
        return true;
    }
}class EventGraphChamfer extends EventGraphBase {
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node5 = new EventGraphNode(this, EventHandlerGrid);
        const node6 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        const node7 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: 'Chamfer,选择第一条直线' });
        const node9 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node10 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node12 = new EventGraphNode(this, EventHandlerSavePointDown);
        const node13 = new EventGraphNode(this, EventHandlerSavePointDown);
        const node14 = new EventGraphNodeSwitch(this, () => {
            let selected = PythaStorage.instance.selectStore.getUnlockedPrimitives();
            if (selected.length == 0)
                return [2];
            if (selected.length != 1)
                return [0];
            if (selected[0].type != PrimitiveType.Line)
                return [0];
            return [1];
        });
        const node15 = new EventGraphNode(this, EventHandlerEmptySelect);
        const node16 = new EventGraphNodeSwitch(this, () => {
            let selected = PythaStorage.instance.selectStore.getUnlockedPrimitives();
            if (selected.length == 1)
                return [2];
            if (selected.length != 2)
                return [0];
            if (selected[1].type != PrimitiveType.Line)
                return [0];
            return [1];
        });
        const node18 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: 'Chamfer,请选择第二条直线' });
        const node19 = new EventGraphNode(this, EventHandlerCalTempChamfer);
        const node20 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node21 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '后续要加入只允许点选' });
        const node22 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node23 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: 'Chamfer,请输入倒角半径大小' });
        const node24 = new EventGraphNode(this, EventHandlerNumberInput);
        this.addEdge(node5, node9);
        this.addEdge(node9, node6);
        this.addEdge(node6, node10);
        /**选中图元不为线段*/
        this.addEdge(node14, node15);
        /**选中图元不为线段*/
        this.addEdge(node16, node15);
        this.addEdge(node12, node18);
        this.addEdge(node13, node19);
        this.addEdge(node19, node5);
        this.addEdge(node15, node7);
        this.addEdge(node7, node20);
        this.addEdge(node20, node14);
        this.addEdge(node21, node15);
        this.addEdge(node18, node22);
        this.addEdge(node22, node16);
        this.addEdge(node23, node24);
        this.addEdge(node1, node23);
        this.addEdge(node24, node21);
        /**选中图元为线段*/
        this.addEdge(node14, node12);
        /**选中图元为线段*/
        this.addEdge(node16, node13);
        /**未选中图元*/
        this.addEdge(node14, node7);
        /**选中图元数为1*/
        this.addEdge(node16, node18);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/88
    }
}
/**
 * SELECT指令 用于注册事件图
 */
EventGraphChamfer.cmd = 'CHAMFER';/**
 * 计算倒角
 */
class EventHandlerCalTempFillet extends EventHandlerBase {
    constructor() {
        super(...arguments);
        this._cameraDir = new Vector3();
        this._screenUp = new Vector3();
        this.heightVec = new Vector3();
        this._normal = new Vector3();
        this._extrudePlane = new Plane$1();
        this._projectPoint = new Point();
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    //todo可优化逻辑减少不必要运算
    run(data = {}) {
        var _a;
        // 获取存储
        const storage = PythaStorage.instance;
        const pointerDownList = this.node.graph.cache.data.SavePoints;
        if (pointerDownList.length != 2)
            return false;
        let pointer1 = pointerDownList[0];
        let pointer2 = pointerDownList[1];
        const selectPrimitives = storage.selectStore.getUnlockedPrimitives();
        if (selectPrimitives.length != 2)
            return false;
        if (selectPrimitives[0].type != PrimitiveType.Line || selectPrimitives[1].type != PrimitiveType.Line)
            return false;
        let line1 = selectPrimitives[0].geos[0];
        let line2 = selectPrimitives[1].geos[0];
        let start1 = line1.start;
        let end1 = line1.end;
        let start2 = line2.start;
        let end2 = line2.end;
        let crossPoint = new Point();
        let pointAfterChamferLine1 = new Point();
        let pointAfterChamferLine2 = new Point();
        //判断两条线是否相交,若不相交则无法计算倒角
        if (!GeoIntersection.StraightLineIntersectStraightLine(new StraightLine(start1, new Vector3(end1.x, end1.y, end1.z).sub(start1)), new StraightLine(start2, new Vector3(end2.x, end2.y, end2.z).sub(start2)), crossPoint))
            return false;
        // console.log("crossPoint", crossPoint.clone())
        let viewportStore = storage.viewportStore;
        const camera = (_a = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        //line1为AB(start1为A)，line2为CD，交点为T
        let A = line1.start.project(camera);
        line1.end.project(camera);
        let C = line2.start.project(camera);
        line2.end.project(camera);
        let T = crossPoint.clone().project(camera);
        let P1 = pointer1.point.project(camera);
        let P2 = pointer2.point.project(camera); //TODO应该用哪个值？point2还是point
        //用向量判断在哪一段上，通过AT·AP1与AT·AT大小判断P1在哪一段上
        let ATdotAP1 = new Vector3().subVectors(A, T).dot(new Vector3().subVectors(A, P1));
        let ATdotAT = new Vector3().subVectors(A, T).dot(new Vector3().subVectors(A, T));
        if (ATdotAP1 > ATdotAT) {
            pointAfterChamferLine1 = end1;
        }
        else {
            pointAfterChamferLine1 = start1;
        }
        //用向量判断在哪一段上，通过CT·CP2与CT·CT大小判断P2在哪一段上
        let CTdotCP2 = new Vector3().subVectors(C, T).dot(new Vector3().subVectors(C, P2));
        let CTdotCT = new Vector3().subVectors(C, T).dot(new Vector3().subVectors(C, T));
        if (CTdotCP2 > CTdotCT) {
            pointAfterChamferLine2 = end2;
        }
        else {
            pointAfterChamferLine2 = start2;
        }
        let distanceS1 = crossPoint.distanceTo(start1);
        let distanceE1 = crossPoint.distanceTo(end1);
        let distanceL1 = start1.distanceTo(end1);
        let distanceS2 = crossPoint.distanceTo(start2);
        let distanceE2 = crossPoint.distanceTo(end2);
        let distanceL2 = start2.distanceTo(end2);
        if (Math.abs(distanceE1 - distanceS1 - distanceL1) < 1e-5 * distanceL1) {
            pointAfterChamferLine1 = end1;
        }
        if (Math.abs(distanceS1 - distanceE1 - distanceL1) < 1e-5 * distanceL1) {
            pointAfterChamferLine1 = start1;
        }
        if (Math.abs(distanceE2 - distanceS2 - distanceL2) < 1e-5 * distanceL2) {
            pointAfterChamferLine2 = end2;
        }
        if (Math.abs(distanceS2 - distanceE2 - distanceL2) < 1e-5 * distanceL2) {
            pointAfterChamferLine2 = start2;
        }
        // console.log("pointAfterChamferLine1", pointAfterChamferLine1)
        // console.log("pointAfterChamferLine2", pointAfterChamferLine2)
        //判断倒角半径是否合法,这是倒直线角部分
        // let r = this.node.graph.cache.inputNumber;
        // if(r==null) r = 0;
        // if (r > crossPoint.distanceTo(pointAfterChamferLine1)||r>crossPoint.distanceTo(pointAfterChamferLine2)) return false;
        // let vec1 = new Vector3().subVectors(pointAfterChamferLine1, crossPoint).normalize().multiplyScalar(r);
        // let vec2 = new Vector3().subVectors(pointAfterChamferLine2, crossPoint).normalize().multiplyScalar(r);
        //线段统一转化为由交点指向外部的方向
        //计算两直线夹角
        let vec1 = new Vector3().subVectors(pointAfterChamferLine1, crossPoint).normalize();
        let vec2 = new Vector3().subVectors(pointAfterChamferLine2, crossPoint).normalize();
        let angle = vec1.angleTo(vec2);
        //获取圆弧半径
        let r = this.node.graph.cache.inputNumber['R']; // TODO
        if (r == null)
            r = 0;
        //计算直线上的切点
        let h = r / Math.tan(angle / 2);
        if (h > crossPoint.distanceTo(pointAfterChamferLine1) || h > crossPoint.distanceTo(pointAfterChamferLine2))
            return false;
        vec1.multiplyScalar(h);
        vec2.multiplyScalar(h);
        line1.start = crossPoint.clone().add(vec1);
        line1.end = pointAfterChamferLine1;
        line2.start = crossPoint.clone().add(vec2);
        line2.end = pointAfterChamferLine2;
        selectPrimitives[0].needRedraw = true;
        selectPrimitives[1].needRedraw = true;
        //计算垂直于直线的向量
        let normal = new Vector3().crossVectors(vec1, vec2).normalize();
        let heightVec = new Vector3().crossVectors(normal, vec1).normalize().multiplyScalar(r);
        if (heightVec.dot(vec2) < 0)
            heightVec.negate();
        //计算圆弧圆心
        let center = line1.start.clone().add(heightVec);
        let arc = new Arc();
        //计算圆弧并存入缓存
        arc.setFromTwoPointAndCenter(line1.start, line2.start, center, normal);
        if (arc.angle > Math.PI) {
            arc.setFromTwoPointAndCenter(line2.start, line1.start, center, normal);
        }
        let primitive = new Primitive();
        primitive.type = "圆弧";
        primitive.geos.push(arc);
        let keys = Object.keys(primitive.renderItemDict);
        if (keys.length > 0) {
            let renderItem = primitive.renderItemDict[keys[0]];
            renderItem.geoElements = arc.getGeoElementsIdxList();
        }
        primitive.temporary = true;
        this.node.graph.cache.primitiveList.push(primitive);
        storage.primitiveStore.tempPrimitiveDict[primitive.uuid] = primitive;
        selectPrimitives.push(primitive);
        primitive.needRedraw = true;
        this.node.graph.cache.data.SavePoints = [];
        // this.node.graph.cache.inputNumber = null;
        return true;
    }
}class EventGraphFillet extends EventGraphBase {
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node5 = new EventGraphNode(this, EventHandlerGrid);
        const node6 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        const node7 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: 'Fillet,选择第一条直线' });
        const node9 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node10 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node12 = new EventGraphNode(this, EventHandlerSavePointDown);
        const node13 = new EventGraphNode(this, EventHandlerSavePointDown);
        const node14 = new EventGraphNodeSwitch(this, () => {
            let selected = PythaStorage.instance.selectStore.getUnlockedPrimitives();
            if (selected.length == 0)
                return [2];
            if (selected.length != 1)
                return [0];
            if (selected[0].type != PrimitiveType.Line)
                return [0];
            return [1];
        });
        const node15 = new EventGraphNode(this, EventHandlerEmptySelect);
        const node16 = new EventGraphNodeSwitch(this, () => {
            let selected = PythaStorage.instance.selectStore.getUnlockedPrimitives();
            if (selected.length == 1)
                return [2];
            if (selected.length != 2)
                return [0];
            if (selected[1].type != PrimitiveType.Line)
                return [0];
            return [1];
        });
        const node18 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: 'Fillet,请选择第二条直线' });
        const node19 = new EventGraphNode(this, EventHandlerCalTempFillet);
        const node20 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node21 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '后续要加入只允许点选' });
        const node22 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node23 = new EventGraphNode(this, EventHandlerNumberInput);
        const node24 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: 'Fillet,请输入倒圆角半径大小' });
        this.addEdge(node5, node9);
        this.addEdge(node9, node6);
        this.addEdge(node6, node10);
        /**选中图元不为线段*/
        this.addEdge(node14, node15);
        /**选中图元不为线段*/
        this.addEdge(node16, node15);
        this.addEdge(node12, node18);
        this.addEdge(node13, node19);
        this.addEdge(node19, node5);
        this.addEdge(node15, node7);
        this.addEdge(node7, node20);
        this.addEdge(node20, node14);
        this.addEdge(node21, node15);
        this.addEdge(node18, node22);
        this.addEdge(node22, node16);
        this.addEdge(node23, node21);
        this.addEdge(node1, node24);
        this.addEdge(node24, node23);
        /**选中图元数为1且图元为线段*/
        this.addEdge(node14, node12);
        /**选中图元数为2且为线段*/
        this.addEdge(node16, node13);
        /**选中图元数为零*/
        this.addEdge(node14, node7);
        /**选中图元数为1*/
        this.addEdge(node16, node18);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/96
    }
}
/**
 * SELECT指令 用于注册事件图
 */
EventGraphFillet.cmd = 'FILLET';// import { ArcT, LineT } from "../models/ModelTrans";
class Vertex {
    constructor(index, position = null) {
        this.adjEdgeNum = 0;
        this.position = new Vector3();
        this.index = index;
        if (position) {
            this.position.copy(position);
        }
    }
    clone(rename = false) {
        let res = new Vertex(this.index, this.position);
        if (this.firstEdge) {
            res.firstEdge = this.firstEdge.clone();
        }
        return res;
    }
    cloneNoLink() {
        let res = new Vertex(this.index, this.position);
        return res;
    }
}
// 由顶点x指向y的边
class Edge {
    constructor(fromVerIdx, nextVerIdx, data, nextEdge = null) {
        // 边的序号
        this.index = -1;
        this.fromVerIdx = fromVerIdx;
        this.nextVerIdx = nextVerIdx;
        this.data = data;
        this.nextEdge = nextEdge;
        // this.index = index || 0;
    }
    clone(rename = false) {
        let res = new Edge(this.fromVerIdx, this.nextVerIdx, this.data);
        if (this.nextEdge) {
            res.nextEdge = this.nextEdge.clone();
        }
        res.index = this.index;
        return res;
    }
    cloneNoLink() {
        let res = new Edge(this.fromVerIdx, this.nextVerIdx, this.data);
        res.index = this.index;
        return res;
    }
}
class Ring {
    constructor(header) {
        this.verSet = new Set();
        this.edgeIndexs = new Set();
        this.header = header;
        this.verSet.add(header.index);
    }
    clone(rename = false) {
        let newHeader = this.header.clone();
        let newRing = new Ring(newHeader);
        let edge = newHeader.firstEdge;
        while (edge) {
            newRing.curEdge = edge;
            newRing.verSet.add(edge.nextVerIdx);
            newRing.edgeIndexs.add(edge.index);
            edge = edge.nextEdge;
        }
        return newRing;
    }
    addEdge(edge) {
        let edgeIndex = edge.index;
        // 边已经存在
        if (this.edgeIndexs.has(edgeIndex))
            return false;
        let y = edge.nextVerIdx;
        // 边去往的顶点已经存在，且不是起始点
        if (this.verSet.has(y) && y !== this.header.index)
            return false;
        this.edgeIndexs.add(edgeIndex);
        this.verSet.add(edge.nextVerIdx);
        if (!this.curEdge) {
            this.header.firstEdge = edge;
        }
        else {
            this.curEdge.nextEdge = edge;
        }
        this.curEdge = edge;
        return true;
    }
    getRingNums() {
        let nums = [];
        nums.push(this.header.index);
        let edge = this.header.firstEdge;
        while (edge) {
            nums.push(edge.nextVerIdx);
            edge = edge.nextEdge;
        }
        return nums;
    }
    isLoop() {
        var _a, _b;
        if (!this.header || !this.header.firstEdge || !this.curEdge)
            return false;
        return ((_a = this.curEdge) === null || _a === void 0 ? void 0 : _a.nextVerIdx) === ((_b = this.header) === null || _b === void 0 ? void 0 : _b.index);
    }
    getHashCode() {
        let nums = [];
        let edge = this.header.firstEdge;
        while (edge) {
            nums.push(edge.index);
            edge = edge.nextEdge;
        }
        nums.sort((a, b) => a - b);
        return nums.toString();
    }
    getDataList() {
        let res = [];
        let edge = this.header.firstEdge;
        while (edge) {
            if (!!edge.data) {
                res.push(edge.data);
            }
            edge = edge.nextEdge;
        }
        return res;
    }
}
class Face extends Ring {
    constructor(header) {
        super(header);
        this.normal = new Vector3();
        this.vertexList = [];
        this._vector1 = new Vector3();
        this._vector2 = new Vector3();
        this.vertexList.push(header.position);
    }
    addEdgeInFace(edge, ver) {
        let edgeIndex = edge.index;
        // 边已经存在
        if (this.edgeIndexs.has(edgeIndex))
            return false;
        let y = edge.nextVerIdx;
        // 边去往的顶点已经存在，且不是起始点
        if (this.verSet.has(y) && y !== this.header.index)
            return false;
        if (this.vertexList.length > 2 && this.normal.length() > 1e-6) {
            let dist = this.distanceToPoint(ver.position);
            if (Math.abs(dist) > 1e-6)
                return false;
        }
        if (!this.verSet.has(y)) {
            this.vertexList.push(ver.position);
        }
        this.edgeIndexs.add(edgeIndex);
        this.verSet.add(edge.nextVerIdx);
        if (!this.curEdge) {
            this.header.firstEdge = edge;
        }
        else {
            this.curEdge.nextEdge = edge;
        }
        this.curEdge = edge;
        if (this.vertexList.length === 3) {
            this.setFromCoplanarPoints(this.vertexList[0], this.vertexList[1], this.vertexList[2]);
        }
        return true;
    }
    clone(rename = false) {
        let newHeader = this.header.clone();
        let newRing = new Face(newHeader);
        newRing.vertexList = [...this.vertexList];
        newRing.normal.copy(this.normal);
        newRing.constant = this.constant;
        let edge = newHeader.firstEdge;
        while (edge) {
            newRing.curEdge = edge;
            newRing.verSet.add(edge.nextVerIdx);
            newRing.edgeIndexs.add(edge.index);
            edge = edge.nextEdge;
        }
        return newRing;
    }
    _setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal).normalize();
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = this._vector1.subVectors(c, b).cross(this._vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this._setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
}
class Graph {
    constructor() {
        // 邻接表
        this.adjVertexList = [];
        // 是否是有向图，默认为无向图
        this.isDirect = false;
        // 边的最大序号计数
        this._edgeNums = 0;
    }
    // 初始化顶点表
    initVertex(vertexArr) {
        for (let i = 0; i < vertexArr.length; i++) {
            let vertexIdx = vertexArr[i];
            let vertex = new Vertex(vertexIdx);
            this.adjVertexList[i] = vertex;
        }
    }
    // 插入新的顶点
    insertVertex(vertexIdx, position = null) {
        let vertex = new Vertex(vertexIdx, position);
        this.adjVertexList.push(vertex);
    }
    setVertexPos(vertexIdx, position) {
        if (!position)
            return;
        let vertex = this._findVer(vertexIdx);
        if (!vertex)
            return;
        vertex.position.copy(position);
    }
    // 找到节点x在adj中所在的位置
    _findVer(x) {
        return this.adjVertexList.find(item => item.index === x);
    }
    _findVerPos(x) {
        return this.adjVertexList.findIndex(item => item.index === x);
    }
    // 判断图中是否存在边(x,y)或者<x, y>。
    hasEdge(x, y) {
        let verX = this._findVer(x);
        if (!verX)
            return false;
        let currentEdge = verX.firstEdge;
        if (!currentEdge) {
            return false;
        }
        while (currentEdge) {
            if (currentEdge.nextVerIdx === y)
                return true;
            currentEdge = currentEdge.nextEdge;
        }
        return false;
    }
    // 向图中插入边(x, y)或者边<x, y>
    addEdge(x, y, data, index = null) {
        let verX = this._findVer(x);
        let verY = this._findVer(y);
        let edgeX = new Edge(y, x, data);
        let edgeY = new Edge(x, y, data);
        if (!verX || !verY)
            return;
        // if (this.hasEdge(x, y) || this.hasEdge(y, x)) return;
        if (!this.hasEdge(x, y)) {
            // 给x顶点添加指向y的边
            let currentEdge = verX.firstEdge;
            if (!currentEdge) {
                verX.firstEdge = edgeY;
                verX.adjEdgeNum++;
            }
            else {
                while (!!currentEdge.nextEdge) {
                    currentEdge = currentEdge.nextEdge;
                }
                currentEdge.nextEdge = edgeY;
                verX.adjEdgeNum++;
            }
            this._edgeNums++;
            edgeY.index = index == null ? this._edgeNums : index;
        }
        // 给y顶点添加指向x的边, 无向图使用
        if (this.isDirect) {
            return;
        }
        if (!this.hasEdge(y, x)) {
            let currentEdge = verY.firstEdge;
            if (!currentEdge) {
                verY.firstEdge = edgeX;
                verY.adjEdgeNum++;
            }
            else {
                while (!!currentEdge.nextEdge) {
                    currentEdge = currentEdge.nextEdge;
                }
                currentEdge.nextEdge = edgeX;
                verY.adjEdgeNum++;
            }
            edgeX.index = index == null ? this._edgeNums : index;
        }
    }
    // 在图中删除边(x, y)或者边<x, y>
    removeEdge(x, y) {
        // 删除x指向y的边
        let verX = this._findVer(x);
        let currentEdge = verX.firstEdge;
        if (!!currentEdge) {
            if (currentEdge.nextVerIdx === y) {
                verX.adjEdgeNum--;
                verX.firstEdge = currentEdge.nextEdge;
            }
            else {
                while (currentEdge) {
                    let nextEdge = currentEdge.nextEdge;
                    if ((nextEdge === null || nextEdge === void 0 ? void 0 : nextEdge.nextVerIdx) === y) {
                        verX.adjEdgeNum--;
                        currentEdge.nextEdge = nextEdge.nextEdge;
                        break;
                    }
                    currentEdge = currentEdge.nextEdge;
                }
            }
        }
        // 删除y指向x的边
        let verY = this._findVer(y);
        currentEdge = verY.firstEdge;
        if (!!currentEdge) {
            if (currentEdge.nextVerIdx === x) {
                verY.adjEdgeNum--;
                verY.firstEdge = currentEdge.nextEdge;
            }
            else {
                while (currentEdge) {
                    let nextEdge = currentEdge.nextEdge;
                    if ((nextEdge === null || nextEdge === void 0 ? void 0 : nextEdge.nextVerIdx) === x) {
                        verY.adjEdgeNum--;
                        currentEdge.nextEdge = nextEdge.nextEdge;
                        break;
                    }
                    currentEdge = currentEdge.nextEdge;
                }
            }
        }
    }
    // 从图中删除顶点x
    deleteVertex(x) {
        let pos = this._findVerPos(x);
        if (pos === -1)
            return;
        let verX = this.adjVertexList[pos];
        if (!verX)
            return;
        let curVertex = verX.firstEdge;
        while (curVertex) {
            this.removeEdge(x, curVertex.nextVerIdx);
            curVertex = curVertex.nextEdge;
        }
        this.adjVertexList.splice(pos, 1);
    }
    // 与顶点x邻接的所有节点
    allNeightbors(x) {
        let verX = this._findVer(x);
        if (!verX)
            return;
        let result = `${x}`;
        let curVertex = verX.firstEdge;
        while (curVertex) {
            result += `=>${curVertex.nextVerIdx}`;
            curVertex = curVertex.nextEdge;
        }
    }
    traverseRings(primitives) {
        let rings = [];
        // 选中了至少两个entity 且只有两个节点 说明是环
        if (primitives.length === 2 && this.adjVertexList.length === 2) {
            const entity1 = primitives[0];
            const entity2 = primitives[1];
            if (entity1.type === PrimitiveType.Arc && entity2.type === PrimitiveType.Arc) {
                const geo1 = entity1.geos[0];
                const geo2 = entity2.geos[0];
                // 这里不能调用arc的equals，内部使用==判断角度和半径，浮点数总是false
                if (geo1.center.equals(geo2.center) && Math.abs(geo1.radius - geo2.radius) < 1e-6
                    && (Math.abs(geo1.angle - geo2.angle) < 1e-6 || Math.abs(2 * Math.PI - geo1.angle + geo2.angle) < 1e-6)) {
                    return [];
                }
            }
            else if (entity1.type === PrimitiveType.Line && entity2.type === PrimitiveType.Line) {
                const geo1 = entity1.geos[0];
                const geo2 = entity2.geos[0];
                if (geo1.start.equals(geo2.start) && geo1.end.equals(geo2.end)) {
                    return [];
                }
            }
            const startVertex = this.adjVertexList[0];
            const endVertex = this.adjVertexList[1];
            startVertex.firstEdge.data = entity1;
            endVertex.firstEdge.data = entity2;
            startVertex.firstEdge.nextEdge = endVertex.firstEdge.cloneNoLink();
            if (!startVertex.firstEdge || !endVertex.firstEdge)
                return [];
            const newRing = new Ring(startVertex.clone());
            // newRing.header.firstEdge = startVertex.firstEdge.clone();
            newRing.curEdge = endVertex.firstEdge.cloneNoLink();
            rings.push(newRing);
        }
        else {
            // 以每个顶点为起始，构建环
            for (let i = 0; i < this.adjVertexList.length; i++) {
                let startVertex = this.adjVertexList[i];
                if (!startVertex.firstEdge)
                    continue;
                let header = startVertex.cloneNoLink();
                // header.firstEdge = startVertex.firstEdge.cloneNoLink();
                let newRing = new Ring(header);
                rings.push(newRing);
                this._dfsRings(rings, newRing);
            }
            // rings = rings.filter(ring => ring.isLoop()) || [];
        }
        let hash = new Set();
        rings = rings.filter(ring => {
            if (!ring.isLoop())
                return false;
            let hashCode = ring.getHashCode();
            if (hash.has(hashCode))
                return false;
            hash.add(hashCode);
            return true;
        });
        return rings;
    }
    _dfsRings(rings, curRing) {
        if (curRing == null)
            return;
        // let x = curRing.curEdge ? curRing.curEdge.fromVerIdx : curRing.header.index;
        let y = curRing.curEdge ? curRing.curEdge.nextVerIdx : curRing.header.index;
        if (y == null)
            return;
        let header = this._findVer(y);
        if (!header || !header.firstEdge)
            return;
        let edge = header.firstEdge;
        while (edge) {
            let ringCopy = curRing.clone();
            let res = ringCopy.addEdge(edge.cloneNoLink());
            edge = edge.nextEdge;
            if (!res) {
                // 边添加失败，意味着这条路不通了
                continue;
            }
            if (res) {
                // 边添加成功后，这条路加入到rings里，保留后续递归可能
                rings.push(ringCopy);
            }
            if (res && !ringCopy.isLoop()) {
                this._dfsRings(rings, ringCopy);
            }
        }
    }
    traverseFaces() {
        let rings = [];
        // 以每个顶点为起始，构建环
        for (let i = 0; i < this.adjVertexList.length; i++) {
            let startVertex = this.adjVertexList[i];
            if (!startVertex.firstEdge)
                continue;
            let header = startVertex.cloneNoLink();
            // header.firstEdge = startVertex.firstEdge.cloneNoLink();
            let newRing = new Face(header);
            rings.push(newRing);
            this._dfsFaces(rings, newRing);
        }
        // rings = rings.filter(ring => ring.isLoop()) || [];
        let hash = new Set();
        rings = rings.filter(ring => {
            if (!ring.isLoop())
                return false;
            let hashCode = ring.getHashCode();
            if (hash.has(hashCode))
                return false;
            hash.add(hashCode);
            return true;
        });
        return rings;
    }
    _dfsFaces(rings, curRing) {
        if (curRing == null)
            return;
        // let x = curRing.curEdge ? curRing.curEdge.fromVerIdx : curRing.header.index;
        let x = curRing.curEdge ? curRing.curEdge.nextVerIdx : curRing.header.index;
        if (x == null)
            return;
        let header = this._findVer(x);
        if (!header || !header.firstEdge)
            return;
        let edge = header.firstEdge;
        while (edge) {
            let ringCopy = curRing.clone();
            let y = edge.nextVerIdx;
            let ver = this._findVer(y);
            let res = ringCopy.addEdgeInFace(edge.cloneNoLink(), ver);
            edge = edge.nextEdge;
            if (!res) {
                // 边添加失败，意味着这条路不通了
                continue;
            }
            if (res) {
                // 边添加成功后，这条路加入到rings里，保留后续递归可能
                rings.push(ringCopy);
            }
            if (res && !ringCopy.isLoop()) {
                this._dfsFaces(rings, ringCopy);
            }
        }
    }
}/**
 * 生成面域
 */
class EventHandlerGenRegion extends EventHandlerBase {
    run(data) {
        let selectPrimitives = [];
        if (this.node.graph.cache.data.primitives && this.node.graph.cache.data.primitives.length > 0) {
            selectPrimitives = this.node.graph.cache.data.primitives;
        }
        else {
            selectPrimitives = this.getPythaStorage().selectStore.selectPrimitives;
        }
        if (!selectPrimitives || (selectPrimitives === null || selectPrimitives === void 0 ? void 0 : selectPrimitives.length) === 0) {
            // todo 发结束的消息
            return true;
        }
        // 存储原本就是闭合的曲线，圆，椭圆，闭合的多段线
        const loopPrimitives = [];
        // 未闭合的图元
        const unLoopPrimitives = [];
        // TODO 面域的图
        const regionGraph = new Graph();
        regionGraph.isDirect = true;
        // 把图元拆分成curve
        const curveList = [];
        const entityUuidMap = {};
        for (let i = 0; i < selectPrimitives.length; i++) {
            let entity = selectPrimitives[i];
            if (entity.type === PrimitiveType.Circle || entity.type === PrimitiveType.Ellipse) {
                loopPrimitives.push(entity);
                entityUuidMap[entity.uuid] = entity.uuid;
                continue;
            }
            if (entity.type === PrimitiveType.Arc || entity.type === PrimitiveType.Line) {
                curveList.push(entity);
                entityUuidMap[entity.uuid] = entity.uuid;
                continue;
            }
            if (entity.type === PrimitiveType.Pline) {
                let geos = entity.geos;
                for (let i = 0; i < geos.length; i++) {
                    let newPrimitive = new Primitive();
                    if (entity.worldModelMatrix) {
                        newPrimitive.localModelMatrix = entity.worldModelMatrix.clone();
                    }
                    if (geos[i].type == PrimitiveType.Line) {
                        newPrimitive.geos = [geos[i].clone()];
                        newPrimitive.type = PrimitiveType.Line;
                    }
                    else if (geos[i].type == PrimitiveType.Arc) {
                        newPrimitive.geos = [geos[i].clone()];
                        newPrimitive.type = PrimitiveType.Arc;
                    }
                    entityUuidMap[newPrimitive.uuid] = entity.uuid;
                    curveList.push(newPrimitive);
                }
            }
        }
        const vertexList = this.calcUnLoopCurve(curveList, unLoopPrimitives, regionGraph);
        for (let primitive of loopPrimitives) {
            this.generateRegion([primitive], entityUuidMap);
        }
        // 闭合环的数量
        loopPrimitives.length;
        if (!this.isCommonPlane(unLoopPrimitives, vertexList)) ;
        else if (vertexList.length >= 2) {
            let rings = regionGraph.traverseRings(curveList);
            for (let i = 0; i < rings.length; i++) {
                let ring = rings[i];
                let ringPrimitives = ring.getDataList();
                if (this.intersectWithItself(ringPrimitives)) {
                    continue;
                }
                if (this.isCommonLine(ringPrimitives, vertexList)) {
                    continue;
                }
                if (this.intersectWithOther(ringPrimitives)) {
                    continue;
                }
                this.generateRegion(ringPrimitives, entityUuidMap);
            }
        }
        // TODO 提示 已提取xx个环，被拒绝xx个环，已创建xx个面域
        return true;
    }
    /**
     * 生成面域
     * @param primitives
     * @param primitiveUuidDict
     */
    generateRegion(primitives, primitiveUuidDict = {}) {
        var _a;
        const primitiveUuidSet = new Set();
        const edges = [];
        const storage = this.getPythaStorage();
        for (const primitive of primitives) {
            primitive.needDelete = true;
            primitive.needRedraw = true;
            if (primitiveUuidDict[primitive.uuid]) {
                primitiveUuidSet.add(primitiveUuidDict[primitive.uuid]);
            }
            if (primitive.type === PrimitiveType.Pline) ;
            else if (primitive.type === PrimitiveType.Line) {
                //需要乘以图元的变换矩阵
                let geo = primitive.geos[0].clone();
                if (primitive.worldModelMatrix) {
                    geo.transformMatrix.premultiply(primitive.worldModelMatrix);
                }
                edges.push(geo);
            }
            else if (primitive.type === PrimitiveType.Arc) {
                let geo = primitive.geos[0].clone();
                if (primitive.worldModelMatrix) {
                    geo.transformMatrix.premultiply(primitive.worldModelMatrix);
                }
                edges.push(geo);
            }
            else if (primitive.type === PrimitiveType.Circle) {
                let geo = primitive.geos[0].clone();
                if (primitive.worldModelMatrix) {
                    geo.transformMatrix.premultiply(primitive.worldModelMatrix);
                }
                edges.push(geo);
            }
            else if (primitive.type === PrimitiveType.Ellipse) ;
        }
        const region = new RegionFace();
        region.setXYZ(edges[0].getNormalizeX(), edges[0].getNormalizeZ(), true);
        region.setRegionFace(edges);
        const primitive = new Primitive(PrimitiveType.RegionFace);
        primitive.geos.push(region);
        let keys = Object.keys(primitive.renderItemDict);
        if (keys.length > 0) {
            let renderItem = primitive.renderItemDict[keys[0]];
            (_a = renderItem.mat) === null || _a === void 0 ? void 0 : _a.color.set(storage.layerStore.getColor());
            renderItem.geoElements = [];
            let geoElementsLength = renderItem.geoElements.length;
            region.getGeoElementsIdxList().forEach(idx => {
                renderItem.geoElements.push(idx + geoElementsLength);
            });
        }
        primitive.temporary = true;
        primitive.needRedraw = true;
        storage.primitiveStore.tempPrimitiveDict[primitive.uuid] = primitive;
        this.node.graph.cache.primitiveList.push(primitive);
        const primitiveDict = storage.primitiveStore.primitiveDict;
        primitiveUuidSet.forEach(uuid => {
            if (primitiveDict[uuid]) {
                this.node.graph.cache.deletePrimitiveList.push(primitiveDict[uuid]);
            }
        });
    }
    /**
     * 计算未闭合曲线
     * @param primitiveList
     * @param unLoopPrimitives
     * @param regionGraph
     * @returns
     */
    calcUnLoopCurve(primitiveList, unLoopPrimitives, regionGraph) {
        const vertexList = [];
        for (let i = 0, edgeIndex = 0; i < primitiveList.length; i++) {
            let primitive = primitiveList[i];
            let endPoints = [];
            if (primitive.type === PrimitiveType.Arc || primitive.type === PrimitiveType.Line) {
                const geo = primitive.geos[0];
                if (primitive.worldModelMatrix) { //需要
                    endPoints.push(geo.getPointAt(0).applyMatrix4(primitive.worldModelMatrix));
                    endPoints.push(geo.getPointAt(1).applyMatrix4(primitive.worldModelMatrix));
                }
                else {
                    endPoints.push(geo.getPointAt(0));
                    endPoints.push(geo.getPointAt(1));
                }
            }
            // 剔除闭合曲线及无法生成面域的曲线后，剩余的放入非闭合曲线，并存储端点
            let endPointIdxs = [];
            // 将图元端点存入顶点表，去重
            for (let j = 0; j < endPoints.length; j++) {
                let point = endPoints[j];
                let index = vertexList.findIndex(item => GeoRelation.Vector3IsClose(item, point));
                if (index === -1) {
                    // 新顶点
                    vertexList.push(point);
                    endPointIdxs.push(vertexList.length - 1);
                    regionGraph.insertVertex(vertexList.length - 1);
                }
                else {
                    // 已经放入的相同位置顶点
                    endPointIdxs.push(index);
                }
            }
            let entityIdx = unLoopPrimitives.findIndex(e => e.uuid === primitive.uuid);
            if (entityIdx === -1) {
                unLoopPrimitives.push(primitive);
                entityIdx = unLoopPrimitives.length - 1;
            }
            regionGraph.addEdge(endPointIdxs[0], endPointIdxs[1], primitive, edgeIndex + 1);
            const inverseEntity = this.inversePrimitive(primitive);
            inverseEntity.uuid = primitive.uuid;
            regionGraph.addEdge(endPointIdxs[1], endPointIdxs[0], inverseEntity, edgeIndex + 1);
            edgeIndex++;
        }
        return vertexList;
    }
    /**
     * 是否共面
     * @param primitives
     * @param vertexList
     * @returns
     */
    isCommonPlane(primitives, vertexList) {
        if (vertexList.length > 2) {
            const plane = new Plane$1();
            plane.setFromCoplanarPoints(vertexList[0], vertexList[1], vertexList[2]);
            for (const primitive of primitives) {
                const endPoints = [];
                if (primitive.type === PrimitiveType.Circle) {
                    continue;
                }
                else if (primitive.type === PrimitiveType.Pline) {
                    // TODO
                    continue;
                }
                else {
                    if (primitive.type === PrimitiveType.Arc) {
                        const geo = primitive.geos[0];
                        // 判断法向量平行
                        let normal = geo.normal;
                        if (primitive.worldModelMatrix) {
                            normal.applyMatrix4(primitive.worldModelMatrix);
                        }
                        normal.normalize();
                        if (GeoRelation.Vector3IsClose(normal, plane.normal) ||
                            GeoRelation.Vector3IsClose(normal.clone().negate(), plane.normal)) {
                            continue;
                        }
                        // endPoints.push(geo.getPointAt(0));
                        // endPoints.push(geo.getPointAt(1));
                        if (primitive.worldModelMatrix) { //需要
                            endPoints.push(geo.getPointAt(0).applyMatrix4(primitive.worldModelMatrix));
                            endPoints.push(geo.getPointAt(1).applyMatrix4(primitive.worldModelMatrix));
                        }
                        else {
                            endPoints.push(geo.getPointAt(0));
                            endPoints.push(geo.getPointAt(1));
                        }
                    }
                    else if (primitive.type === PrimitiveType.Line) {
                        const geo = primitive.geos[0];
                        // endPoints.push(geo.start);
                        // endPoints.push(geo.end);
                        if (primitive.worldModelMatrix) { //需要
                            endPoints.push(geo.getPointAt(0).applyMatrix4(primitive.worldModelMatrix));
                            endPoints.push(geo.getPointAt(1).applyMatrix4(primitive.worldModelMatrix));
                        }
                        else {
                            endPoints.push(geo.getPointAt(0));
                            endPoints.push(geo.getPointAt(1));
                        }
                    }
                }
                if (endPoints.length === 0) {
                    continue;
                }
                // 线段或开口多段线或圆弧
                for (let point of endPoints) {
                    let dist = GeoRelation.DistanceToPoint(plane, point);
                    if (Math.abs(dist) > 1e-2) {
                        // 不共面
                        return false;
                    }
                }
            }
        }
        else if (vertexList.length === 2) {
            // 遍历找到第一个多段线或圆弧，作为基准面
            let baseNormal = null;
            for (let primitive of primitives) {
                if (primitive.type === PrimitiveType.Line) {
                    continue;
                }
                let normal = null;
                if (primitive.type === PrimitiveType.Pline) ;
                else if (primitive.type === PrimitiveType.Arc) {
                    const geo = primitive.geos[0];
                    if (baseNormal == null) {
                        baseNormal = geo.normal;
                        continue;
                    }
                    normal = geo.normal;
                }
                if (GeoRelation.Vector3IsClose(baseNormal, normal) ||
                    GeoRelation.Vector3IsClose(baseNormal.clone().multiplyScalar(-1), normal)) {
                    continue;
                }
                return false;
            }
        }
        return true;
    }
    /**
     * 是否共线
     * @param primitives
     * @param vertexList
     * @returns
     */
    isCommonLine(primitives, vertexList) {
        if (vertexList.length <= 2)
            return false;
        if (primitives.some(e => e.type === PrimitiveType.Arc))
            return false;
        let direction = vertexList[1].clone().sub(vertexList[0]).normalize();
        for (let i = 2; i < vertexList.length; i++) {
            let dir = vertexList[i].clone().sub(vertexList[0]).normalize();
            if (!(Math.abs((Math.abs(direction.dot(dir)) - 1)) < 1e-2)) {
                return false;
            }
        }
        return true;
    }
    /**
     * 只交在图元上
     * @param primitives
     * @returns
     */
    intersectWithItself(primitives) {
        if (primitives.length < 2)
            return false;
        for (let i = 0; i < primitives.length - 1; i++) {
            let basePrimitive = primitives[i];
            for (let j = i + 1; j < primitives.length; j++) {
                let primitive = primitives[j];
                const intersectPoints = this.primitiveIntersection(basePrimitive, primitive, true, false);
                let points = [];
                intersectPoints.forEach(point => {
                    if (!points.some(item => GeoRelation.Vector3IsClose(item, point))) {
                        points.push(point);
                    }
                });
                if (points.length > 2) {
                    return true;
                }
            }
        }
        return false;
    }
    /**
     * 可以交在其他图元上
     * @param primitives
     * @returns
     */
    intersectWithOther(primitives) {
        if (primitives.length < 2)
            return false;
        for (let i = 0; i < primitives.length - 1; i++) {
            let basePrimitive = primitives[i];
            const baseEndPoints = [];
            if (basePrimitive.type === PrimitiveType.Arc) {
                const geo = basePrimitive.geos[0];
                if (basePrimitive.worldModelMatrix) {
                    baseEndPoints.push(geo.getPointAt(0).applyMatrix4(basePrimitive.worldModelMatrix));
                    baseEndPoints.push(geo.getPointAt(1).applyMatrix4(basePrimitive.worldModelMatrix));
                }
                else {
                    baseEndPoints.push(geo.getPointAt(0));
                    baseEndPoints.push(geo.getPointAt(1));
                }
            }
            else if (basePrimitive.type === PrimitiveType.Line) {
                const geo = basePrimitive.geos[0];
                // baseEndPoints.push(geo.getPointAt(0));
                // baseEndPoints.push(geo.getPointAt(1));
                if (basePrimitive.worldModelMatrix) {
                    baseEndPoints.push(geo.getPointAt(0).applyMatrix4(basePrimitive.worldModelMatrix));
                    baseEndPoints.push(geo.getPointAt(1).applyMatrix4(basePrimitive.worldModelMatrix));
                }
                else {
                    baseEndPoints.push(geo.getPointAt(0));
                    baseEndPoints.push(geo.getPointAt(1));
                }
            }
            for (let j = i + 1; j < primitives.length; j++) {
                let primitive = primitives[j];
                let intersectPointList = this.primitiveIntersection(basePrimitive, primitive, true, true);
                if (intersectPointList.length == 0) {
                    continue;
                }
                else {
                    // 判断交点是否在端点处
                    const endPoints = [];
                    if (basePrimitive.type === PrimitiveType.Arc) {
                        const geo = basePrimitive.geos[0];
                        // endPoints.push(geo.getPointAt(0));
                        // endPoints.push(geo.getPointAt(1));
                        if (basePrimitive.worldModelMatrix) {
                            endPoints.push(geo.getPointAt(0).applyMatrix4(basePrimitive.worldModelMatrix));
                            endPoints.push(geo.getPointAt(1).applyMatrix4(basePrimitive.worldModelMatrix));
                        }
                        else {
                            endPoints.push(geo.getPointAt(0));
                            endPoints.push(geo.getPointAt(1));
                        }
                    }
                    else if (basePrimitive.type === PrimitiveType.Line) {
                        const geo = basePrimitive.geos[0];
                        // endPoints.push(geo.getPointAt(0));
                        // endPoints.push(geo.getPointAt(1));
                        if (basePrimitive.worldModelMatrix) {
                            endPoints.push(geo.getPointAt(0).applyMatrix4(basePrimitive.worldModelMatrix));
                            endPoints.push(geo.getPointAt(1).applyMatrix4(basePrimitive.worldModelMatrix));
                        }
                        else {
                            endPoints.push(geo.getPointAt(0));
                            endPoints.push(geo.getPointAt(1));
                        }
                    }
                    for (let m = 0; m < intersectPointList.length; m++) {
                        if (baseEndPoints.find(item => GeoRelation.Vector3IsClose(item, intersectPointList[m]))
                            || endPoints.find(item => GeoRelation.Vector3IsClose(item, intersectPointList[m]))) {
                            continue;
                        }
                        else {
                            // 两线相交，不能构成面域
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }
    /**
     * 反转图元
     * @param primitive
     * @returns
     */
    inversePrimitive(primitive) {
        const clone = primitive.clone();
        if (primitive.type === PrimitiveType.Line) {
            const line = clone.geos[0];
            const start = line.start;
            const end = line.end;
            line.set(end, start);
        }
        else if (primitive.type === PrimitiveType.Arc) {
            const arc = clone.geos[0];
            const endDir = arc.getPointAt(1).sub(arc.center);
            arc.setXYZ(endDir.normalize(), arc.getNormalizeZ().multiplyScalar(-1));
        }
        return clone;
    }
    //TODO 考虑是否需要抽取出公共方法
    /**
     * 寻找相应求交方法并返回交点
     * @param basePrimitive
     * @param primitive
     * @param clampToBase
     * @param clampToPrimitve
     * @returns
     */
    primitiveIntersection(basePrimitive, primitive, clampToBase = false, clampToPrimitve = false) {
        if (basePrimitive.type === PrimitiveType.Arc) {
            return this.arcIntersection(basePrimitive.geos[0], primitive, clampToBase, clampToPrimitve);
        }
        return [];
    }
    /**
     * 圆弧求交
     * @param arc
     * @param primitive
     * @param clampToBase
     * @param clampToPrimitve
     * @returns
     */
    arcIntersection(arc, primitive, clampToBase = false, clampToPrimitve = false) {
        if (primitive.type === PrimitiveType.Arc) {
            const geo = primitive.geos[0];
            GeoIntersection.ArcIntersectArc(arc, geo, clampToBase, clampToPrimitve);
        }
        else if (primitive.type === PrimitiveType.Line) {
            const geo = primitive.geos[0];
            GeoIntersection.ArcIntersectLine(arc, geo, clampToBase, clampToPrimitve);
        }
        return [];
    }
}/**
 * 面域图
 */
class EventGraphRegion extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerSelectStart);
        const node3 = new EventGraphNode(this, EventHandlerEmptySelect);
        const node5 = new EventGraphNode(this, EventHandlerGenRegion);
        const node6 = new EventGraphNode(this, EventHandlerGrid);
        const node7 = new EventGraphNode(this, EventHandlerEmptySelect);
        const node8 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node9 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node10 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                    type: NeedInputEnum.ACTIVE,
                    description: "选择对象",
                    option: 'SELECT',
                    inputTypes: [PythaEventName.CONFIRM]
                }]
        });
        const node11 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '面域结束' });
        const node12 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node13 = new EventGraphNodeSwitch(this, () => {
            const storage = PythaStorage.instance;
            if (storage.selectStore.selectPrimitives.length < 1) {
                return [1];
            }
            return [0];
        });
        const node14 = new EventGraphNode(this, EventHandlerGenAndDeletePrimitives);
        const node15 = new EventGraphNode(this, null);
        const node16 = new EventGraphNode(this, EventHandlerDisableClamp);
        const node18 = new EventGraphNode(this, EHChangePickCursor);
        const node19 = new EventGraphNode(this, EventHandlerConfirm);
        const node20 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        this.addEdge(node6, node8);
        this.addEdge(node11, node9);
        this.addEdge(node5, node7);
        this.addEdge(node8, node11);
        this.addEdge(node7, node14);
        /**选中了图元*/
        this.addEdge(node13, node15);
        this.addEdge(node15, node5);
        this.addEdge(node1, node16);
        this.addEdge(node16, node3);
        this.addEdge(node3, node18);
        this.addEdge(node18, node12);
        this.addEdge(node12, node2);
        this.addEdge(node2, node10);
        this.addEdge(node10, node19);
        this.addEdge(node19, node13);
        this.addEdge(node14, node20);
        this.addEdge(node20, node6);
        /**没有选中图元*/
        this.addEdge(node13, node9);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/90
    }
}
/**
 * region指令 用于注册事件图
 */
EventGraphRegion.cmd = 'REGION';/**
 * 计算临时圆弧
 */
class EventHandlerCalArc extends EventHandlerBase {
    /**
     * 构造函数
     * @param node
     */
    constructor(node) {
        super(node);
        /**
         * 临时变量，用于使用圆心端点设置圆弧时，只修改一次辅助线
         */
        this._helplineModifiedByCenter = false;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a, _b, _c, _d, _e;
        let pointdownlist = this.node.graph.cache.pointerDownList;
        if (pointdownlist.length < 2)
            return false;
        // 获取存储
        const storage = PythaStorage.instance;
        const graphCache = this.node.graph.cache;
        // 生成圆弧图元
        if (this.arc == null) {
            this.arc = graphCache.data.arc;
            this.primitive = graphCache.data.primitive;
            if (this.arc == null) {
                this.arc = new Arc();
                this.primitive = new Primitive("Arc");
                this.primitive.geos.push(this.arc);
                let keys = Object.keys(this.primitive.renderItemDict);
                if (keys.length > 0) {
                    let renderItem = this.primitive.renderItemDict[keys[0]];
                    renderItem.geoElements = this.arc.getGeoElementsIdxList();
                    (_a = renderItem.mat) === null || _a === void 0 ? void 0 : _a.color.set(storage.layerStore.getColor());
                }
                this.primitive.temporary = true;
                this.node.graph.cache.primitiveList.push(this.primitive);
                storage.primitiveStore.tempPrimitiveDict[this.primitive.uuid] = this.primitive;
                graphCache.data.arc = this.arc;
                graphCache.data.primitive = this.primitive;
            }
        }
        // 两点加半径生成圆弧
        if (graphCache.inputOption === "R" || graphCache.inputOption === "REV") {
            let startIdx = pointdownlist.findIndex(item => item.option === "S");
            let start = (_b = pointdownlist[startIdx]) === null || _b === void 0 ? void 0 : _b.point;
            let endIdx = pointdownlist.findIndex(item => item.option === "M");
            let end = (_c = pointdownlist[endIdx]) === null || _c === void 0 ? void 0 : _c.point;
            if (start == null || end == null) {
                return false;
            }
            const move = graphCache.pointerMove;
            const pointMove = move.point;
            const input = graphCache.inputNumber['RADIUS'];
            let radius;
            if (input != null && !isNaN(input) && input > 0) {
                radius = Number(input);
            }
            else {
                radius = pointMove.distanceTo(end);
            }
            let normal = storage.coordinateStore.workPlane.normal;
            let isReverse = graphCache.data.isReverse;
            if (graphCache.inputOption === "REV") {
                if (isReverse == null) {
                    isReverse = false;
                }
                isReverse = !isReverse;
                graphCache.data.isReverse = isReverse;
                graphCache.inputOption = "R";
            }
            if (isReverse) {
                normal.multiplyScalar(-1);
            }
            let res = this.arc.setByTwoPointAndRadius(start, end, radius, normal);
            if (!res) {
                graphCache.data.canGenerate = false;
            }
            else {
                graphCache.data.canGenerate = true;
            }
            // 需要修改辅助线的起点为端点
            let helpline = this.node.graph.cache.data['helpline'];
            if (helpline != null && !this._helplineModifiedByCenter) {
                helpline.setStart(end);
                if (endIdx > startIdx) {
                    helpline.setEnd(0, 0); // 先起点后圆心时，圆心和端点在初始时刻是重合的，此时辅助线长度应为0
                }
                this._helplineModifiedByCenter = true;
            }
            this.primitive.needRedraw = true;
            return true;
        }
        else if (pointdownlist.map(pd => pd.option).includes("C")) {
            // 使用圆心+端点生成圆弧
            let startIdx = pointdownlist.findIndex(item => item.option === "S");
            let start = (_d = pointdownlist[startIdx]) === null || _d === void 0 ? void 0 : _d.point;
            let end = storage.coordinateStore.currentPos;
            let centerIdx = pointdownlist.findIndex(item => item.option === "C");
            let center = (_e = pointdownlist[centerIdx]) === null || _e === void 0 ? void 0 : _e.point;
            if (start == null || center == null) {
                return false;
            }
            let normal = storage.coordinateStore.workPlane.normal;
            this.arc.setFromTwoPointAndCenter(start, end, center, normal);
            this.primitive.needRedraw = true;
            // 需要修改辅助线的起点为圆心
            let helpline = this.node.graph.cache.data['helpline'];
            if (helpline != null && !this._helplineModifiedByCenter) {
                helpline.setStart(center);
                if (centerIdx > startIdx) {
                    helpline.setEnd(0, 0); // 先起点后圆心时，圆心和端点在初始时刻是重合的，此时辅助线长度应为0
                }
                this._helplineModifiedByCenter = true;
            }
            return true;
        }
        else {
            // 默认三点确定圆弧
            let start = pointdownlist[0].point;
            let mid = pointdownlist[1].point;
            let end = storage.coordinateStore.currentPos;
            this.arc.setByThreePoint(start, mid, end);
            this.primitive.needRedraw = true;
        }
        return true;
    }
    /**
     * 销毁
     */
    dispose() {
        this.primitive = undefined;
        this.arc = undefined;
    }
}/**
 * 绘制圆弧
 */
class EventGraphArc extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node4 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node5 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node6 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node7 = new EventGraphNode(this, EventHandlerCapture);
        const node8 = new EventGraphNodeAND(this, null);
        const node9 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node10 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node11 = new EventGraphNode(this, EventHandlerCalArc);
        const node12 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node13 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node14 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node15 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node16 = new EventGraphNode(this, EventHandlerGrid);
        const node17 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定第一点", option: 'S', inputTypes: [PythaEventName.POINTER_DOWN] },
                { type: NeedInputEnum.OPTION, description: "圆心", option: "C" },
            ]
        });
        const node18 = new EventGraphNode(this, EventHandlerHelpLine);
        const node19 = new EventGraphNodeAND(this, null);
        const node20 = new EventGraphNode(this, EventHandlerInitCapture);
        const node21 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定第二点", option: 'M', inputTypes: [PythaEventName.POINTER_DOWN] },
                { type: NeedInputEnum.OPTION, description: "圆心", option: "C" },
            ]
        });
        const node22 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定端点", option: 'E', inputTypes: [PythaEventName.POINTER_DOWN] },
                { type: NeedInputEnum.OPTION, description: "指定半径", option: "R" },
            ]
        });
        const node23 = new EventGraphNode(this, EventHandlerGrid);
        const node24 = new EventGraphNode(this, EventHandlerMouseWheel);
        const node25 = new EventGraphNode(this, EHChangeCrossCursor);
        const node26 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node27 = new EventGraphNode(this, EventHandlerOptionInput);
        const node28 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node29 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定圆心", option: 'C', inputTypes: [PythaEventName.POINTER_DOWN] },
            ]
        });
        const node30 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定第一点", option: 'S', inputTypes: [PythaEventName.POINTER_DOWN] },
            ]
        });
        const node31 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node33 = new EventGraphNode(this, EventHandlerOptionInput);
        const node34 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node35 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定圆心", option: 'C', inputTypes: [PythaEventName.POINTER_DOWN] },
            ]
        });
        const node37 = new EventGraphNode(this, null);
        const node38 = new EventGraphNode(this, null);
        const node39 = new EventGraphNode(this, EventHandlerConfirm);
        const node40 = new EventGraphNode(this, EventHandlerOptionInput);
        const node41 = new EventGraphNode(this, EventHandlerNumberInput);
        const node42 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node43 = new EventGraphNode(this, EventHandlerCalArc);
        const node44 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定半径", option: 'Radius', inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.NUMBER] },
                { type: NeedInputEnum.OPTION, description: "反向圆弧", option: "REV" },
            ]
        });
        const node45 = new EventGraphNodeSwitch(this, () => {
            if (this.cache.data.canGenerate != null && !this.cache.data.canGenerate) {
                this.cache.primitiveList.forEach(primitive => {
                    primitive.needDelete = true;
                });
                return [1];
            }
            return [0];
        });
        const node46 = new EventGraphNode(this, EventHandlerOptionInput);
        const node47 = new EventGraphNode(this, EventHandlerCalArc);
        const node48 = new EventGraphNode(this, EventHandlerGrid);
        const node49 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        this.addEdge(node1, node2);
        this.addEdge(node7, node8);
        this.addEdge(node10, node11);
        this.addEdge(node13, node14);
        this.addEdge(node16, node15);
        this.addEdge(node15, node4);
        this.addEdge(node18, node12);
        this.addEdge(node2, node20);
        this.addEdge(node20, node6);
        this.addEdge(node17, node5);
        this.addEdge(node21, node9);
        this.addEdge(node9, node22);
        this.addEdge(node22, node13);
        this.addEdge(node11, node23);
        this.addEdge(node23, node12);
        this.addEdge(node24, node18);
        this.addEdge(node2, node25);
        this.addEdge(node25, node17);
        this.addEdge(node6, node7);
        this.addEdge(node8, node18);
        this.addEdge(node8, node24);
        this.addEdge(node19, node10);
        this.addEdge(node8, node19);
        this.addEdge(node14, node26);
        this.addEdge(node26, node16);
        this.addEdge(node17, node27);
        this.addEdge(node27, node29);
        this.addEdge(node29, node28);
        this.addEdge(node28, node30);
        this.addEdge(node30, node31);
        this.addEdge(node5, node27, EDGE_TYPE.STOP);
        this.addEdge(node27, node5, EDGE_TYPE.STOP);
        this.addEdge(node21, node33);
        this.addEdge(node33, node35);
        this.addEdge(node35, node34);
        this.addEdge(node34, node22);
        this.addEdge(node9, node33, EDGE_TYPE.STOP);
        this.addEdge(node33, node9, EDGE_TYPE.STOP);
        this.addEdge(node9, node37);
        this.addEdge(node37, node19);
        this.addEdge(node34, node37);
        this.addEdge(node31, node22);
        this.addEdge(node5, node21);
        this.addEdge(node5, node38);
        this.addEdge(node38, node8);
        this.addEdge(node28, node38);
        this.addEdge(node31, node37);
        this.addEdge(node1, node39);
        this.addEdge(node39, node4);
        this.addEdge(node22, node40);
        this.addEdge(node40, node13, EDGE_TYPE.STOP);
        this.addEdge(node13, node40, EDGE_TYPE.STOP);
        this.addEdge(node41, node42, EDGE_TYPE.STOP);
        this.addEdge(node42, node41, EDGE_TYPE.STOP);
        this.addEdge(node41, node43);
        this.addEdge(node40, node44);
        this.addEdge(node44, node42);
        this.addEdge(node44, node41);
        this.addEdge(node42, node45);
        this.addEdge(node43, node45);
        /**可以构成圆弧*/
        this.addEdge(node45, node14);
        this.addEdge(node44, node46);
        this.addEdge(node46, node47);
        this.addEdge(node47, node48);
        this.addEdge(node48, node49);
        this.addEdge(node49, node44);
        /**无法构成圆弧*/
        this.addEdge(node45, node15);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/103
    }
}
/**
 * 指令 用于注册事件图
 */
EventGraphArc.cmd = 'ARC';/**
 * 文字图元
 * 存在文字的内容、字高等属性是普通图元不具备的
 */
class TextPrimitive extends Primitive {
    constructor() {
        super(...arguments);
        /**
         * 图元类型
         */
        this.type = "Text";
        /**
         * 宽度因子
         */
        this.widthRatio = 1;
    }
    /**
     * 复制图元
     * @param primitive
     * @returns
     */
    copy(primitive) {
        super.copy(primitive);
        this.text = primitive.text;
        this.widthRatio = primitive.widthRatio;
        this.fontSize = primitive.fontSize;
        return this;
    }
    /**
     * 克隆图元
     */
    clone() {
        return new TextPrimitive(this.type).copy(this);
    }
    /**
     * 抽象成json数据格式
     * @returns
     */
    toJson() {
        let data = super.toJson();
        let res = Object.assign(Object.assign({}, data), { type: this.type, fontSize: this.fontSize, widthRatio: this.widthRatio, text: this.text });
        return res;
    }
    /**
     * 解析数据成对象
     */
    fromJson(json) {
        super.fromJson(json);
        this.fontSize = json.fontSize || 14;
        this.text = json.text || '';
        this.widthRatio = json.widthRatio || 1;
        return this;
    }
    /**
     * 获取图元特征点 用于捕捉
     */
    getFeaturePoints() {
        return [];
    }
    /**
     * 获取控制点
     */
    getControlPoints() {
        let res = [];
        let fp = {
            /**
             * 特征点类型
             */
            type: FEATURE_POINT_TYPE.CENTER,
            /**
             * 特征点坐标
             */
            point: this.getP()
        };
        res.push(fp);
        return res;
    }
}/**
 * 计算临时文字图元
 */
class EventHandlerCalTempText extends EventHandlerBase {
    constructor(node) {
        super(node);
        /**
         * 临时变量
         */
        this._x = new Vector3();
        this._y = new Vector3();
        this._z = new Vector3();
        this._point = new Point();
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data) {
        var _a, _b, _c;
        // 获取存储
        const storage = PythaStorage.instance;
        let pos = this.node.graph.cache.pointerDownList[0].point;
        if (pos == null)
            pos = new Point();
        if (this.node.graph.cache.primitiveList.length <= 0) {
            // 创建图元
            let text = this.node.graph.cache.data['text'];
            if (text == null)
                return false;
            const font = storage.textStore.font;
            if (font == null)
                return false;
            let fontSize = this.node.graph.cache.inputNumber['H'] || storage.textStore.defaultHeight;
            let widthRatio = 0.7;
            let primitive = new TextPrimitive("Text");
            primitive.temporary = true;
            let keys = Object.keys(primitive.renderItemDict);
            if (keys.length <= 0)
                return false;
            let renderItem = primitive.renderItemDict[keys[0]];
            (_a = renderItem.mat) === null || _a === void 0 ? void 0 : _a.color.set(storage.layerStore.getColor());
            this.primitive = primitive;
            this.primitive.text = text;
            this.primitive.fontSize = fontSize;
            this.primitive.widthRatio = widthRatio;
            this.node.graph.cache.primitiveList.push(primitive);
            storage.primitiveStore.tempPrimitiveDict[primitive.uuid] = primitive;
            let offsetX = 0; // 文字偏移 每个文字的起点移到已有文字的最右边
            let geoIndex = 0;
            // 在局部坐标系内解析文字
            for (let i = 0; i < text.length; i++) {
                const char = text[i];
                if (char === ' ') {
                    // 空格直接偏移
                    offsetX += fontSize / 4;
                    continue;
                }
                let glyph = font.charToGlyph(char);
                if (((_c = (_b = glyph === null || glyph === void 0 ? void 0 : glyph.path) === null || _b === void 0 ? void 0 : _b.commands) === null || _c === void 0 ? void 0 : _c.length) <= 0) {
                    glyph = font.charToGlyph("?");
                }
                const path = glyph.getPath(0, 0, fontSize);
                const commands = path.commands || [];
                let startX = 0, startY = 0; // 起点
                let x = 0, y = 0; // 当前点
                let maxX = 0; // 解析到的最右侧坐标
                for (let cmd of commands) {
                    switch (cmd.type) {
                        case 'M':
                            startX = cmd.x * widthRatio + offsetX;
                            startY = -cmd.y;
                            x = cmd.x * widthRatio + offsetX;
                            y = -cmd.y;
                            break;
                        case 'L':
                        case 'Q':
                        case 'C':
                            x = cmd.x * widthRatio + offsetX;
                            y = -cmd.y;
                            let line = new Line$2(new Point(startX, startY), new Point(x, y));
                            primitive.geos.push(line);
                            renderItem.geoElements.push(geoIndex);
                            geoIndex++;
                            startX = x;
                            startY = y;
                            break;
                    }
                    if (maxX < x)
                        maxX = x;
                }
                offsetX = maxX + 0; // 偏移到最右侧 + 字间距
            }
        }
        else {
            this.primitive = this.node.graph.cache.primitiveList[0];
            if (this.primitive.type != "Text")
                return false;
        }
        // 设置图元局部坐标系
        this._point.copy(storage.coordinateStore.currentPos); // 当前点
        let ucs = storage.coordinateStore.activeUcs;
        this._x.set(ucs.elements[0], ucs.elements[1], ucs.elements[2]);
        this._y.set(ucs.elements[4], ucs.elements[5], ucs.elements[6]);
        this._z.set(ucs.elements[8], ucs.elements[9], ucs.elements[10]);
        this.primitive.setXYZP(this._x, this._y, this._z, pos);
        let angle = this._point.sub(pos).angleTo(this._x);
        let sign = this._point.cross(this._x).dot(this._z);
        if (sign > 0) {
            angle = Math.PI * 2 - angle;
        }
        // 判断是否有输入的角度
        let input = +this.node.graph.cache.inputNumber['ANGLE'];
        if (!Number.isNaN(input)) {
            angle = input;
        }
        // 旋转图元
        this.primitive.rotate(pos, this._z, angle);
        this.primitive.needRedraw = true;
        return true;
    }
}/**
 * 文字编辑框标签
 */
class TextAreaLabel extends LabelBase {
    /**
     * 生成标签
     */
    generate() {
        const root = this.obj.element;
        this.obj.renderOrder = 30000;
        this.obj.center.set(0, 1);
        const textArea = document.createElement('input');
        textArea.style.height = '32px';
        textArea.style.fontSize = '20px';
        textArea.style.width = '16px';
        textArea.style.outline = 'none';
        textArea.style.border = '1px solid #000';
        textArea.style.backgroundColor = '#959494';
        this.textArea = textArea;
        root.appendChild(textArea);
    }
}/**
 * 显示文字编辑框
 */
class EventHandlerShowTextArea extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.letterSpacing = 0;
        /**
         * 文本框文字输入
         * @param event
         */
        this.onInputChange = (event) => {
            this.text = event.target.value;
            // this.textAreaLabel.textArea.style.width = `${this.text.length * 14}px`
            // this.node.graph.eventMediator.renderHandler.render(false, UpdateType.ALL);
        };
        this.onMouseDown = (event) => {
            var _a, _b;
            // 鼠标右键的指定事件
            if (MOUSE_BUTTON.RIGHT === event.button) {
                let e = new PythaEventText();
                e.data = this.text.trim();
                (_a = this.node.graph.eventMediator) === null || _a === void 0 ? void 0 : _a.emitEvent(e);
                (_b = this.textAreaLabel) === null || _b === void 0 ? void 0 : _b.remove();
                const storage = PythaStorage.instance;
                storage.viewportStore.labelRenderer.domElement.style.pointerEvents = 'none';
                storage.viewportStore.renderer.domElement.style.cursor = "none";
            }
        };
        /**
         * 确认文字输入，发送事件
         * @param event
         */
        this.onKeyDown = (event) => {
            var _a, _b;
            const code = event.code;
            let text = event.target.value;
            // 测量文字宽度
            const textWidth = this.context.measureText(text).width * 2 + this.letterSpacing * text.length;
            this.textAreaLabel.textArea.style.width = `${textWidth + 16}px`;
            if (code === "Enter") {
                let e = new PythaEventText();
                e.data = text.trim();
                (_a = this.node.graph.eventMediator) === null || _a === void 0 ? void 0 : _a.emitEvent(e);
                (_b = this.textAreaLabel) === null || _b === void 0 ? void 0 : _b.remove();
                const storage = PythaStorage.instance;
                storage.viewportStore.labelRenderer.domElement.style.pointerEvents = 'none';
                storage.viewportStore.renderer.domElement.style.cursor = "none";
            }
        };
        // 创建一个隐藏的 canvas 来测量文字宽度
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        this.context = context;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data) {
        // 获取存储
        const storage = PythaStorage.instance;
        let plist = this.node.graph.cache.primitiveList || [];
        let pd;
        if (plist.length > 0) {
            // 已经选中了文字 认为是编辑文字
            let primitive = plist[0];
            pd = primitive.getP();
        }
        else {
            // 是创建文字
            let pdlist = this.node.graph.cache.pointerDownList;
            if (pdlist.length <= 0)
                return false;
            pd = pdlist[pdlist.length - 1].point;
        }
        // 创建文本框
        const textAreaLabel = new TextAreaLabel();
        textAreaLabel.setPosition(pd);
        this.textAreaLabel = textAreaLabel;
        storage.viewportStore.scene.add(textAreaLabel.obj);
        // 设置与输入框一致的样式
        const computedStyle = window.getComputedStyle(this.textAreaLabel.textArea);
        this.letterSpacing = parseFloat(computedStyle.letterSpacing) || 0; // 获取字间距
        this.context.font = computedStyle.font;
        // 聚焦
        setTimeout(() => {
            var _a;
            textAreaLabel.textArea.addEventListener('focus', () => {
                const length = textAreaLabel.textArea.value.length;
                textAreaLabel.textArea.setSelectionRange(length, length);
            });
            (_a = textAreaLabel.textArea) === null || _a === void 0 ? void 0 : _a.focus();
        }, 0);
        // 编辑文字时，设置文字初始内容
        if (plist.length > 0) {
            let primitive = plist[0];
            textAreaLabel.textArea.value = primitive.text;
            const textWidth = this.context.measureText(primitive.text).width * 2 + this.letterSpacing * primitive.text.length;
            this.textAreaLabel.textArea.style.width = `${textWidth + 16}px`;
        }
        // 设置输入监听事件
        textAreaLabel.textArea.addEventListener('input', this.onInputChange);
        textAreaLabel.textArea.addEventListener('keyup', this.onKeyDown);
        // 设置蒙皮接收鼠标事件
        storage.viewportStore.labelRenderer.domElement.style.pointerEvents = 'auto';
        storage.viewportStore.labelRenderer.domElement.addEventListener('mousedown', this.onMouseDown);
        storage.viewportStore.renderer.domElement.style.cursor = 'default';
        this.node.graph.cache.data['textArea'] = textAreaLabel;
        return true;
    }
    /**
     * 销毁
     */
    dispose() {
        var _a, _b, _c, _d;
        const storage = PythaStorage.instance;
        (_a = this.textAreaLabel) === null || _a === void 0 ? void 0 : _a.remove();
        (_b = this.textAreaLabel.textArea) === null || _b === void 0 ? void 0 : _b.removeEventListener('input', this.onInputChange);
        (_c = this.textAreaLabel.textArea) === null || _c === void 0 ? void 0 : _c.removeEventListener('keyup', this.onKeyDown);
        storage.viewportStore.labelRenderer.domElement.style.pointerEvents = 'none';
        (_d = storage.viewportStore.labelRenderer.domElement) === null || _d === void 0 ? void 0 : _d.removeEventListener('mousedown', this.onMouseDown);
        storage.viewportStore.renderer.domElement.style.cursor = "none";
        delete this.node.graph.cache.data['textArea'];
    }
}/**
 * 单行文字
 */
class EventGraphText extends EventGraphBase {
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerNumberInput);
        const node3 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node4 = new EventGraphNode(this, EventHandlerMouseWheel);
        const node5 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node6 = new EventGraphNode(this, EventHandlerShowTextArea);
        const node7 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        const node9 = new EventGraphNode(this, EventHandlerTextInput);
        const node10 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node11 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node12 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '请输入正数' });
        const node13 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: `指定文字高度<${this.eventMediator.storage.textStore.defaultHeight}>`, option: 'H', inputTypes: [PythaEventName.NUMBER, PythaEventName.CONFIRM] },
            ] });
        const node14 = new EventGraphNodeSwitch(this, () => {
            let height = this.cache.inputNumber['H'] || PythaStorage.instance.textStore.defaultHeight;
            if (height == null || height <= 0) {
                return [1];
            }
            PythaStorage.instance.textStore.defaultHeight = height;
            return [0];
        });
        const node15 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定基点", option: 'P', inputTypes: [PythaEventName.POINTER_DOWN] },
            ] });
        const node16 = new EventGraphNode(this, EventHandlerHelpLine);
        const node17 = new EventGraphNode(this, EventHandlerCapture);
        const node18 = new EventGraphNode(this, EventHandlerNumberInput);
        const node19 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定旋转角度", option: 'ANGLE', inputTypes: [PythaEventName.ANGLE, PythaEventName.POINTER_DOWN] },
            ] });
        const node20 = new EventGraphNode(this, EventHandlerGrid);
        const node21 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node22 = new EventGraphNode(this, EventHandlerCalTempText);
        const node23 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node24 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node25 = new EventGraphNode(this, EventHandlerGrid);
        const node26 = new EventGraphNodeAND(this, null);
        const node27 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node28 = new EventGraphNode(this, EventHandlerCalTempText);
        const node29 = new EventGraphNode(this, EHChangeCrossCursor);
        const node30 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node31 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定文字内容", option: 'TEXT', inputTypes: [PythaEventName.DY_TEXT] },
            ] });
        const node32 = new EventGraphNode(this, EventHandlerInitCapture);
        const node33 = new EventGraphNode(this, EventHandlerConfirm);
        this.addEdge(node13, node2);
        this.addEdge(node2, node14);
        this.addEdge(node12, node2);
        this.addEdge(node14, node15);
        this.addEdge(node15, node3);
        this.addEdge(node6, node7);
        this.addEdge(node7, node9);
        this.addEdge(node16, node11);
        this.addEdge(node4, node16);
        this.addEdge(node10, node17);
        this.addEdge(node9, node19);
        this.addEdge(node19, node18);
        this.addEdge(node5, node21);
        this.addEdge(node21, node20);
        this.addEdge(node20, node23);
        this.addEdge(node23, node24);
        this.addEdge(node22, node25);
        this.addEdge(node25, node11);
        this.addEdge(node17, node26);
        this.addEdge(node26, node22);
        this.addEdge(node9, node26);
        this.addEdge(node26, node16);
        this.addEdge(node26, node4);
        this.addEdge(node19, node27);
        this.addEdge(node28, node5);
        this.addEdge(node18, node28);
        this.addEdge(node27, node28);
        this.addEdge(node15, node29);
        this.addEdge(node3, node31);
        this.addEdge(node31, node6);
        this.addEdge(node1, node30);
        this.addEdge(node30, node13);
        this.addEdge(node29, node32);
        this.addEdge(node32, node10);
        this.addEdge(node13, node33);
        this.addEdge(node33, node14);
        this.addEdge(node14, node12);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/32
    }
}
/**
 * 指令 用于注册事件图
 */
EventGraphText.cmd = 'DTEXT';/**
 * 修改图元颜色
 */
class EventHandlerPriColor extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        const storage = this.getPythaStorage();
        let selectPrimitives = storage.selectStore.getUnlockedPrimitives(); //之前选中的图元
        const tempPrimitiveDict = storage.primitiveStore.tempPrimitiveDict;
        let newPrimitives = [];
        if (selectPrimitives.length < 1)
            return true;
        const colorData = this.node.graph.cache.data['color'];
        if (!colorData)
            return true;
        const color = new Color(colorData);
        let currentLayer = storage.layerStore.layers.find(item => item.uuid === storage.layerStore.currentLayerUuid);
        selectPrimitives.forEach(primitive => {
            let newPrimitive = primitive.clone();
            tempPrimitiveDict[primitive.uuid] = newPrimitive;
            newPrimitive.uuid = primitive.uuid;
            newPrimitive.colorByLayer = false;
            if (colorData.toLocaleUpperCase() == currentLayer.color.toLocaleUpperCase()) {
                newPrimitive.colorByLayer = true;
            }
            newPrimitive.temporary = true;
            newPrimitive.isInView = primitive.isInView;
            let keys = Object.keys(newPrimitive.renderItemDict);
            if (keys.length > 0) {
                let renderItem = newPrimitive.renderItemDict[keys[0]];
                renderItem.mat.color = color;
            }
            newPrimitives.push(newPrimitive);
        });
        const cmd = new UpdatePrimitiveCmd(newPrimitives, this.node.graph.eventMediator);
        // 判断缓存中是否有commandGroup
        const graphCache = this.node.graph.cache;
        const commandGroup = graphCache.data['commandGroup'];
        if (!commandGroup || !(commandGroup instanceof CommandGroup)) {
            const storage = PythaStorage.instance;
            storage.historyStore.undos.push(cmd);
            cmd.execute();
        }
        else {
            commandGroup.addCmd(cmd);
        }
        return true;
    }
}/**
 * 监听图元颜色修改事件
 */
class EventHandlerListenColor extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventSetting();
        this.needEventOnce = false;
    }
    run(event) {
        if (event.cmd != this.needEvent.cmd)
            return false; // 如果传入事件不符 则不执行处理器
        if (event.data.key != SETTING_KEY.COLOR) {
            return false;
        }
        this.node.graph.cache.data['color'] = event.data.value;
        return true;
    }
}/**
 * color指令 改变图元颜色
 */
class EventGraphColor extends EventGraphBase {
    constructor() {
        super(...arguments);
        /**
         * 是否是常驻图
         */
        this.isAlwaysActive = true;
    }
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNodeSwitch(this, () => {
            if (this.eventMediator.storage.selectStore.getUnlockedPrimitives().length != 0)
                return [0];
            return [1];
        });
        const node6 = new EventGraphNode(this, EventHandlerPriColor);
        const node7 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node11 = new EventGraphNode(this, EventHandlerGrid);
        const node12 = new EventGraphNode(this, EventHandlerListenColor);
        const node13 = new EventGraphNode(this, EventHandlerCmdEnd);
        this.addEdge(node6, node11);
        this.addEdge(node1, node12);
        this.addEdge(node12, node2);
        this.addEdge(node2, node6);
        this.addEdge(node11, node7);
        this.addEdge(node7, node13);
        this.addEdge(node2, node12);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/104
    }
    end() {
        this.cache.data = {};
        this.head.run();
    }
}
/**
 * color指令 用于注册事件图
 */
EventGraphColor.cmd = 'COLOR';class AxesPrimitive extends Primitive {
    constructor(matrix = new Matrix4(), isWcs = false) {
        super("Axes");
        /**
         * 是否是世界坐标矩阵
         */
        this.isWcs = false;
        this.unselectable = true;
        if (isWcs) {
            this.name = "WCS";
        }
        else {
            this.name = `Axes-${this.uuid.substring(0, 7)}`;
        }
        if (matrix == null) {
            matrix = new Matrix4();
        }
        this.setByMatrix(matrix);
        this.isWcs = isWcs;
    }
    /**
     * 获取正则化矩阵（三个方向向量尺度为1）
     */
    getNormalMatrix() {
        _vec3$1.set(this.localModelMatrix.elements[0], this.localModelMatrix.elements[1], this.localModelMatrix.elements[2]);
        const X = _vec3$1.length();
        _vec3$1.set(this.localModelMatrix.elements[4], this.localModelMatrix.elements[5], this.localModelMatrix.elements[6]);
        const Y = _vec3$1.length();
        _vec3$1.set(this.localModelMatrix.elements[8], this.localModelMatrix.elements[9], this.localModelMatrix.elements[10]);
        const Z = _vec3$1.length();
        const m = this.localModelMatrix.elements;
        const resMatrix = new Matrix4();
        resMatrix.set(m[0] / X, m[4] / Y, m[8] / Z, m[12], m[1] / X, m[5] / Y, m[9] / Z, m[13], m[2] / X, m[6] / Y, m[10] / Z, m[14], 0, 0, 0, 1);
        return resMatrix;
    }
    setByMatrix(matrix, cameraEdge = 30) {
        if (this.localModelMatrix == null) {
            this.localModelMatrix = new Matrix4();
        }
        this.localModelMatrix.copy(matrix);
        matrix.elements;
        _point$4.set(0, 0, 0);
        // 创建坐标轴
        const fac = cameraEdge / 5;
        // x轴
        _x$1.set(1, 0, 0).multiplyScalar(fac);
        // y轴
        _y$1.set(0, 1, 0).multiplyScalar(fac);
        // z轴
        _z$3.set(0, 0, 1).multiplyScalar(fac);
        if (this.geos.length === 0) {
            const lineX = new Line$2(_point$4, _x$1);
            const lineY = new Line$2(_point$4, _y$1);
            const lineZ = new Line$2(_point$4, _z$3);
            this.geos.push(lineX);
            this.geos.push(lineY);
            this.geos.push(lineZ);
        }
        else {
            this.geos[0].set(_point$4, _x$1);
            this.geos[1].set(_point$4, _y$1);
            this.geos[2].set(_point$4, _z$3);
        }
        if (Object.keys(this.renderItemDict).length !== 3) {
            this.renderItemDict = {};
            this.materials = {};
            const renderItemX = this.addRenderItem();
            const renderItemY = this.addRenderItem();
            const renderItemZ = this.addRenderItem(); // 将renderItem补足到3个;
            renderItemX.geoElements = [0];
            renderItemY.geoElements = [1];
            renderItemZ.geoElements = [2]; // 设置几何关联索引
            renderItemX.mat.color.set(1, 0, 0);
            renderItemY.mat.color.set(0, 1, 0);
            renderItemZ.mat.color.set(0, 0, 1); // 设置坐标轴颜色
        }
        this.updateWorldModelMatrix(false, true);
    }
    /**
     * 复制
     * @param axes
     * @returns
     */
    copy(axes) {
        super.copy(axes);
        this.name = axes.name;
        return this;
    }
    /**
     * 克隆
     * @returns
     */
    clone() {
        return new AxesPrimitive().copy(this);
    }
    /**
     * 转json
     * @returns
     */
    toJson() {
        const data = Object.assign(Object.assign({}, super.toJson()), { name: this.name, isWcs: this.isWcs });
        return data;
    }
    fromJson(json) {
        super.fromJson(json);
        if (this.localModelMatrix != null) {
            _matrix.copy(this.localModelMatrix);
            this.setByMatrix(_matrix);
        }
        this.name = json.name;
        this.isWcs = json.isWcs;
        return this;
    }
}
const _vec3$1 = new Vector3();
const _point$4 = new Point();
const _x$1 = new Vector3();
const _y$1 = new Vector3();
const _z$3 = new Vector3();
const _matrix = new Matrix4();/**
 * 新增用户坐标系
 */
class AddAxesCmd extends CommandBase {
    constructor(axes, eventMediator) {
        super();
        this.eventMediator = eventMediator;
        this.axes = axes;
        const storage = PythaStorage.instance;
        const oldAxes = storage.primitiveStore.axes;
        this.oldAxes = oldAxes.clone();
        this.oldAxes.uuid = oldAxes.uuid;
    }
    execute() {
        const storage = PythaStorage.instance;
        const matrix = this.axes.getNormalMatrix();
        storage.coordinateStore.activeUcs = matrix;
        storage.coordinateStore.ucsMap.set(this.axes.uuid, matrix);
        _z$2.set(matrix.elements[8], matrix.elements[9], matrix.elements[10]);
        _p$4.set(matrix.elements[12], matrix.elements[13], matrix.elements[14]);
        storage.coordinateStore.workPlane.setFromNormalAndCoplanarPoint(_z$2, _p$4);
        storage.primitiveStore.axes.needDelete = true;
        this.axes.needRedraw = true;
        storage.primitiveStore.systemPrimitiveDict[this.axes.uuid] = this.axes;
        storage.primitiveStore.axes = this.axes;
        this.eventMediator.noticeHandler.notice(this, new PythaEventDataChange({ add_axes: [this.axes] }));
    }
    undo() {
        // 还原
        const storage = PythaStorage.instance;
        const matrix = this.oldAxes.getNormalMatrix();
        storage.coordinateStore.activeUcs = matrix;
        storage.coordinateStore.ucsMap.delete(this.axes.uuid);
        _z$2.set(matrix.elements[8], matrix.elements[9], matrix.elements[10]);
        _p$4.set(matrix.elements[12], matrix.elements[13], matrix.elements[14]);
        storage.coordinateStore.workPlane.setFromNormalAndCoplanarPoint(_z$2, _p$4);
        storage.primitiveStore.axes.needDelete = true;
        this.oldAxes.needRedraw = true;
        storage.primitiveStore.systemPrimitiveDict[this.oldAxes.uuid] = this.oldAxes;
        storage.primitiveStore.axes = this.oldAxes;
        this.eventMediator.noticeHandler.notice(this, new PythaEventDataChange({ delete_axes: this.axes }));
    }
}
const _z$2 = new Vector3();
const _p$4 = new Vector3();const SETTING_KEY = {
    CAPTURE: 'CAPTURE', // 捕捉
    CAPTURE_TYPE_LIST: 'CAPTURE_TYPE_LIST', // 捕捉类型设置
    ORTHA: 'ORTHA', // 正交
    POLAR: 'POLAR', // 极轴
    AXES: "AXES", // 坐标轴
    COLOR: 'COLOR', // 设置图元颜色
    LAYER_COLOR: 'LAYER_COLOR', // 图层颜色
    LAYER_LOCK: 'LAYER_LOCK', // 图层锁定
    LAYER_SHOW: 'LAYER_SHOW', // 图层显示
    LAYER_CHANGE: 'LAYER_CHANGE', // 图层切换
    AXES_KEEP: 'AXES_KEEP', // 保持坐标轴大小
    FORCE_SELECT: 'FORCE_SELECT', // 强制选择
    RENDER_MODE: 'RENDER_MODE', // 设置渲染模式
    CAMERA_PERSPECTIVE: 'CAMERA_PERSPECTIVE', // 相机视角
    CANVAS_RESIZE: 'CANVAS_RESIZE', // 画布大小
};//todo确定后消失以及生成坐标系方向有误
/**
 * 计算坐标轴图元
 */
class EventHandlerCalTempUCS extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        if (this.node.graph.cache['done'])
            return false; //保证最后的代码只执行一次
        const storage = PythaStorage.instance;
        const pointerDownList = this.node.graph.cache.pointerDownList;
        const ucs = storage.coordinateStore.activeUcs.elements;
        const pointMove = storage.coordinateStore.currentPos;
        storage.viewportStore.viewportItems[storage.viewportStore.currentViewportKey].cameraEdge / 15;
        let axes = this.node.graph.cache.data['axes'];
        let lineX = this.node.graph.cache.data['lineX'];
        let lineY = this.node.graph.cache.data['lineY'];
        let lineZ = this.node.graph.cache.data['lineZ'];
        // 初始化临时axes
        if (this.node.graph.cache.data['axes'] == null) {
            _point$3.set(ucs[12], ucs[13], ucs[14]); //初始化_point为原点
            // 创建坐标轴
            axes = new AxesPrimitive();
            axes.setByMatrix(storage.coordinateStore.activeUcs, storage.viewportStore.viewportItems[storage.viewportStore.currentViewportKey].cameraEdge);
            storage.primitiveStore.tempPrimitiveDict[axes.uuid] = axes;
            lineX = axes.geos[0];
            lineY = axes.geos[1];
            lineZ = axes.geos[2];
            this.node.graph.cache.data['axes'] = axes;
            this.node.graph.cache.data['lineX'] = lineX;
            this.node.graph.cache.data['lineY'] = lineY;
            this.node.graph.cache.data['lineZ'] = lineZ;
        }
        _x.set(axes.localModelMatrix.elements[0], axes.localModelMatrix.elements[1], axes.localModelMatrix.elements[2]).normalize();
        _y.set(axes.localModelMatrix.elements[4], axes.localModelMatrix.elements[5], axes.localModelMatrix.elements[6]).normalize();
        _z$1.set(axes.localModelMatrix.elements[8], axes.localModelMatrix.elements[9], axes.localModelMatrix.elements[10]).normalize();
        //未确定点时,代表设置坐标系原点
        if (pointerDownList.length < 1) {
            axes.localModelMatrix.setPosition(pointMove);
            axes.setByMatrix(axes.localModelMatrix, storage.viewportStore.viewportItems[storage.viewportStore.currentViewportKey].cameraEdge);
            _point$3.copy(pointMove);
            axes.needRedraw = true;
        }
        if (this.node.graph.cache.inputOption === 'ZA') {
            // 直接Z轴
            // 确定一个点时,代表设置Z轴方向
            if (pointerDownList.length == 1) {
                // 计算z轴
                _z$1.copy(pointMove).sub(pointerDownList[0].point);
                if (_z$1.length() < 1e-5)
                    return false;
                _z$1.normalize();
                _base.transformMatrix.set(1, 0, 0, pointerDownList[0].point.x, 0, 1, 0, pointerDownList[0].point.y, 0, 0, 1, pointerDownList[0].point.z, 0, 0, 0, 1);
                _base.updateMatrixByZ(_z$1);
                axes.localModelMatrix.copy(_base.transformMatrix);
                axes.setByMatrix(axes.localModelMatrix, storage.viewportStore.viewportItems[storage.viewportStore.currentViewportKey].cameraEdge);
                axes.needRedraw = true;
            }
            else if (pointerDownList.length == 2) {
                this.node.graph.cache['done'] = true;
                const cmd = new AddAxesCmd(axes, this.node.graph.eventMediator);
                storage.historyStore.undos.push(cmd);
                cmd.execute();
                axes.needDelete = true;
            }
        }
        else {
            // 先X轴后Y轴
            //确定一个点时,代表设置x轴方向
            if (pointerDownList.length == 1) {
                _x.copy(pointMove).sub(pointerDownList[0].point);
                if (_x.length() < 1e-5)
                    return false;
                _x.normalize();
                _base.transformMatrix.set(1, 0, 0, pointerDownList[0].point.x, 0, 1, 0, pointerDownList[0].point.y, 0, 0, 1, pointerDownList[0].point.z, 0, 0, 0, 1);
                _base.updateMatrixByX(_x);
                axes.localModelMatrix.copy(_base.transformMatrix);
                axes.setByMatrix(axes.localModelMatrix, storage.viewportStore.viewportItems[storage.viewportStore.currentViewportKey].cameraEdge);
                axes.needRedraw = true;
            }
            //确定两个点时代表设置y轴方向/x轴方向
            else if (pointerDownList.length == 2) {
                _y.copy(pointMove).sub(pointerDownList[0].point);
                if (_y.length() < 1e-5)
                    return false;
                _y.normalize();
                if (Math.abs(_y.dot(_x) - 1) < 1e-6)
                    return false;
                _z$1.copy(_x.clone().cross(_y).normalize());
                _y.copy(_z$1.clone().cross(_x).normalize());
                axes.localModelMatrix.set(_x.x, _y.x, _z$1.x, pointerDownList[0].point.x, _x.y, _y.y, _z$1.y, pointerDownList[0].point.y, _x.z, _y.z, _z$1.z, pointerDownList[0].point.z, 0, 0, 0, 1);
                axes.setByMatrix(axes.localModelMatrix, storage.viewportStore.viewportItems[storage.viewportStore.currentViewportKey].cameraEdge);
                axes.needRedraw = true;
            }
            //确定三个点时代表更新坐标系
            else if (pointerDownList.length == 3) {
                this.node.graph.cache['done'] = true;
                const cmd = new AddAxesCmd(axes, this.node.graph.eventMediator);
                storage.historyStore.undos.push(cmd);
                cmd.execute();
                axes.needDelete = true;
            }
        }
        return true;
    }
    dispose() {
        var _a;
        if (this.node.graph.cache.data['axes'] != null) {
            this.node.graph.cache.data['axes'].needDelete = true;
            this.node.graph.cache.data['axes'].needRedraw = true;
        }
        //修正坐标轴大小
        let pythaEventKeep = new PythaEventSetting();
        pythaEventKeep.data = { key: SETTING_KEY.AXES_KEEP, value: null };
        (_a = this.node.graph.eventMediator) === null || _a === void 0 ? void 0 : _a.emitEvent(pythaEventKeep);
    }
}
const _point$3 = new Point();
const _x = new Vector3();
const _y = new Vector3();
const _z$1 = new Vector3();
const _base = new GeometryBase();/**
 * 监听Zoom变化
 */
class EventHandlerOnZoomChanged extends EventHandlerBase {
    /**
     * 构造函数
     * @param node
     */
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventZoomChange();
        this.needEventOnce = false;
    }
    /**
     * 执行处理器
     * @param event
     * @returns
     */
    run(event) {
        if (event.cmd != this.needEvent.cmd)
            return false; // 如果传入事件不符 则不执行处理器
        this.node.graph.cache.data['scale'] = event.data; // 将scale值传入缓存TS
        return true;
    }
}/**
 * 缩放临时坐标轴
 */
class EventHandlerZoomTmpAxes extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        if (this.node.graph.cache.data['scale'] == null || this.node.graph.cache.data['axes'] == null) {
            return false;
        }
        let axes = this.node.graph.cache.data['axes'];
        let scale = this.node.graph.cache.data['scale'];
        if (scale != null && scale != 0) {
            const storage = this.getPythaStorage();
            axes.setByMatrix(axes.localModelMatrix, storage.viewportStore.viewportItems[storage.viewportStore.currentViewportKey].cameraEdge);
            axes.needRedraw = true;
        }
        return true;
    }
}/**
 * 显示坐标轴
 */
class EventGraphUCS extends EventGraphBase {
    /**
     * 创建节点
     */
    generate() {
        const node3 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node4 = new EventGraphNode(this, EventHandlerCapture);
        const node5 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node6 = new EventGraphNode(this, EventHandlerStart);
        const node11 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node12 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node18 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node20 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定UCS的原点", option: 'S', inputTypes: [PythaEventName.POINTER_DOWN] }
            ]
        });
        const node21 = new EventGraphNode(this, EventHandlerCalTempUCS);
        const node23 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node24 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定XY平面上的点", option: 'Y', inputTypes: [PythaEventName.POINTER_DOWN] }
            ]
        });
        const node26 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                {
                    type: NeedInputEnum.ACTIVE,
                    description: "指定X轴上的点",
                    option: 'X',
                    inputTypes: [PythaEventName.POINTER_DOWN]
                },
                {
                    type: NeedInputEnum.OPTION,
                    description: "Z轴",
                    option: 'ZA'
                }
            ]
        });
        const node27 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node28 = new EventGraphNode(this, EventHandlerGrid);
        const node29 = new EventGraphNodeAND(this, EventHandlerGrid);
        const node30 = new EventGraphNode(this, EventHandlerCalTempUCS);
        const node31 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node32 = new EventGraphNode(this, EventHandlerInitCapture);
        const node33 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node34 = new EventGraphNode(this, EventHandlerHelpLine);
        const node35 = new EventGraphNode(this, EHChangeCrossCursor);
        const node36 = new EventGraphNode(this, EventHandlerOnZoomChanged);
        const node37 = new EventGraphNode(this, EventHandlerZoomTmpAxes);
        const node38 = new EventGraphNode(this, EventHandlerGrid);
        const node39 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node40 = new EventGraphNode(this, EventHandlerOptionInput);
        const node41 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                    type: NeedInputEnum.ACTIVE,
                    description: "在正Z轴范围上指定点",
                    option: 'Z',
                    inputTypes: [PythaEventName.POINTER_DOWN]
                }]
        });
        const node42 = new EventGraphNode(this, EventHandlerCalPointerDown);
        this.addEdge(node3, node4);
        this.addEdge(node5, node26);
        this.addEdge(node26, node11);
        this.addEdge(node11, node24);
        this.addEdge(node24, node12);
        this.addEdge(node28, node27);
        this.addEdge(node21, node28);
        this.addEdge(node12, node30);
        this.addEdge(node29, node31);
        this.addEdge(node31, node18);
        this.addEdge(node32, node3);
        this.addEdge(node33, node32);
        this.addEdge(node33, node20);
        this.addEdge(node20, node5);
        this.addEdge(node34, node21);
        this.addEdge(node23, node34);
        this.addEdge(node30, node29);
        this.addEdge(node6, node35);
        this.addEdge(node35, node33);
        this.addEdge(node4, node23);
        this.addEdge(node6, node36);
        this.addEdge(node36, node37);
        this.addEdge(node37, node38);
        this.addEdge(node38, node39);
        this.addEdge(node40, node41);
        this.addEdge(node41, node42);
        this.addEdge(node26, node40);
        this.addEdge(node11, node40, EDGE_TYPE.STOP);
        this.addEdge(node40, node11, EDGE_TYPE.STOP);
        this.addEdge(node42, node30);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node6];
        this.head = node6;
        // https://event.graph.tncet.com/graphs/55
        // const node3 = new EventGraphNode(this, EventHandlerCalPointerMove);
        // const node4 = new EventGraphNode(this, EventHandlerCapture);
        // const node5 = new EventGraphNode(this, EventHandlerCalPointerDown);
        // const node6 = new EventGraphNode(this, EventHandlerStart);
        // const node11 = new EventGraphNode(this, EventHandlerCalPointerDown);
        // const node12 = new EventGraphNode(this, EventHandlerCalPointerDown);
        // const node18 = new EventGraphNode(this, EventHandlerCmdEnd);
        // const node20 = new EventGraphNodeNotice(this, {
        //     cmd: 'need_input', data: [
        //         { type: NeedInputEnum.ACTIVE, description: "指定UCS的原点", option: 'S', inputTypes: [PythaEventName.POINTER_DOWN] }
        //     ]
        // });
        // const node21 = new EventGraphNode(this, EventHandlerCalTempUCS);
        // const node23 = new EventGraphNode(this, EventHandlerOrthoPolar);
        // const node24 = new EventGraphNodeNotice(this, {
        //     cmd: 'need_input', data: [
        //         {
        //             type: NeedInputEnum.ACTIVE, description: "指定XY平面上的点", option: 'Y', inputTypes: [PythaEventName.POINTER_DOWN],
        //         },
        //         {
        //             type: NeedInputEnum.OPTION, description: "在正Z轴范围上指定点", option: 'Z'
        //         }
        //     ]
        // });
        // const node26 = new EventGraphNodeNotice(this, {
        //     cmd: 'need_input', data: [
        //         { type: NeedInputEnum.ACTIVE, description: "指定X轴上的点", option: 'X', inputTypes: [PythaEventName.POINTER_DOWN] }
        //     ]
        // });
        // const node27 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        // const node28 = new EventGraphNode(this, EventHandlerGrid);
        // const node29 = new EventGraphNodeAND(this, EventHandlerGrid);
        // const node30 = new EventGraphNode(this, EventHandlerCalTempUCS);
        // const node31 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        // const node32 = new EventGraphNode(this, EventHandlerInitCapture);
        // const node33 = new EventGraphNode(this, EventHandlerDisableSelect);
        // const node34 = new EventGraphNode(this, EventHandlerHelpLine);
        // const node35 = new EventGraphNode(this, EHChangeCrossCursor);
        // const node36 = new EventGraphNode(this, EventHandlerOnZoomChanged);
        // const node37 = new EventGraphNode(this, EventHandlerZoomTmpAxes);
        // const node38 = new EventGraphNode(this, EventHandlerGrid);
        // const node39 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        // this.addEdge(node3, node4);
        // this.addEdge(node5, node26);
        // this.addEdge(node26, node11);
        // this.addEdge(node11, node24);
        // this.addEdge(node24, node12);
        // this.addEdge(node28, node27);
        // this.addEdge(node21, node28);
        // this.addEdge(node12, node30);
        // this.addEdge(node29, node31);
        // this.addEdge(node31, node18);
        // this.addEdge(node32, node3);
        // this.addEdge(node33, node32);
        // this.addEdge(node33, node20);
        // this.addEdge(node20, node5);
        // this.addEdge(node34, node21);
        // this.addEdge(node23, node34);
        // this.addEdge(node30, node29);
        // this.addEdge(node6, node35);
        // this.addEdge(node35, node33);
        // this.addEdge(node4, node23);
        // this.addEdge(node6, node36);
        // this.addEdge(node36, node37);
        // this.addEdge(node37, node38);
        // this.addEdge(node38, node39);
        // // 指定初始状态下的当前节点和头节点
        // this.currentPointers = [node6];
        // this.head = node6;
        // // https://event.graph.tncet.com/graphs/55
    }
    end() {
        let axes = this.cache.data['axes'];
        if (axes != null) {
            axes.needDelete = true;
        }
        super.end();
    }
}
/**
 * 指令
 */
EventGraphUCS.cmd = 'UCS';/**
 * 编辑文字内容
 */
class EventHandlerEditText extends EventHandlerBase {
    /**
     * 运行处理器
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a, _b;
        // 获取存储
        const storage = PythaStorage.instance;
        let plist = this.node.graph.cache.primitiveList || [];
        if (plist.length <= 0)
            return true;
        let primitive = plist[0];
        if (primitive.type != "Text")
            return true;
        let text = this.node.graph.cache.data['text'];
        if (text == null || text.length <= 0)
            return true;
        primitive.text = text;
        let keys = Object.keys(primitive.renderItemDict);
        if (keys.length <= 0)
            return true;
        let renderItem = primitive.renderItemDict[keys[0]];
        const font = storage.textStore.font;
        if (font == null)
            return true;
        const fontSize = primitive.fontSize;
        const widthRatio = primitive.widthRatio;
        // 清空几何
        primitive.geos = [];
        renderItem.geoElements = [];
        let offsetX = 0; // 文字偏移 每个文字的起点移到已有文字的最右边
        let geoIndex = 0;
        // 在局部坐标系内解析文字
        for (let i = 0; i < text.length; i++) {
            const char = text[i];
            if (char === ' ') {
                // 空格直接偏移
                offsetX += fontSize / 4;
                continue;
            }
            let glyph = font.charToGlyph(char);
            if (((_b = (_a = glyph === null || glyph === void 0 ? void 0 : glyph.path) === null || _a === void 0 ? void 0 : _a.commands) === null || _b === void 0 ? void 0 : _b.length) <= 0) {
                glyph = font.charToGlyph("?");
            }
            const path = glyph.getPath(0, 0, fontSize);
            const commands = path.commands || [];
            let startX = 0, startY = 0; // 起点
            let x = 0, y = 0; // 当前点
            let maxX = 0; // 解析到的最右侧坐标
            for (let cmd of commands) {
                switch (cmd.type) {
                    case 'M':
                        startX = cmd.x * widthRatio + offsetX;
                        startY = -cmd.y;
                        x = cmd.x * widthRatio + offsetX;
                        y = -cmd.y;
                        break;
                    case 'L':
                    case 'Q':
                    case 'C':
                        x = cmd.x * widthRatio + offsetX;
                        y = -cmd.y;
                        let line = new Line$2(new Point(startX, startY), new Point(x, y));
                        primitive.geos.push(line);
                        renderItem.geoElements.push(geoIndex);
                        geoIndex++;
                        startX = x;
                        startY = y;
                        break;
                }
                if (maxX < x)
                    maxX = x;
            }
            offsetX = maxX + 0; // 偏移到最右侧 + 字间距
        }
        primitive.needRedraw = true;
        return true;
    }
}/**
 * 选择框 迁移过来 待补注释
 */
class SelectionRect {
    constructor(camera) {
        this.startPoint = new Vector2();
        this.endPoint = new Vector2();
        this.minX = +Infinity;
        this.minY = +Infinity;
        this.maxX = +Infinity;
        this.maxY = +Infinity;
        /**
         * 平面矩形的4条边线
         */
        this._r1 = new Vector2();
        this._r2 = new Vector2();
        this._r3 = new Vector2();
        this._r4 = new Vector2();
        /**
         * 判断两个点是否重合
         * 精度为_precision 1e-9
         */
        this._precision = 1e-9; // 设定精度范围
        this.arePointsClose = (p1, p2) => {
            return p1.distanceToSquared(p2) < this._precision;
        };
        this._v0 = new Vector2();
        this._v1 = new Vector2();
        this._v2 = new Vector2();
        /**
         * 判断点 p 是否在三角形 abc 内部或边上
         * @param p 点 p
         * @param a 三角形顶点 a
         * @param b 三角形顶点 b
         * @param c 三角形顶点 c
         * @returns 如果点 p 在三角形 abc 内部或边上，返回 true；否则返回 false
         */
        this.isPointInTriangle = (p, a, b, c) => {
            // 计算向量
            this._v0.subVectors(c, a);
            this._v1.subVectors(b, a);
            this._v2.subVectors(p, a);
            // 计算点积
            const dot00 = this._v0.dot(this._v0);
            const dot01 = this._v0.dot(this._v1);
            const dot02 = this._v0.dot(this._v2);
            const dot11 = this._v1.dot(this._v1);
            const dot12 = this._v1.dot(this._v2);
            // 计算重心坐标
            const invDenom = 1 / (dot00 * dot11 - dot01 * dot01);
            const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
            const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
            let res = (u >= 0) && (v >= 0) && (u + v <= 1);
            if (res) {
                // checkRenderTri(a, b, c)
                // 检查是否有两个点重合
                if (this.arePointsClose(a, b) || this.arePointsClose(b, c) || this.arePointsClose(a, c)) {
                    return false; // 顶点重合，无法形成三角形
                }
                // 计算叉积判断是否共线
                const area = (b.x - a.x) * (c.y - a.y) - (b.y - a.y) * (c.x - a.x);
                if (Math.abs(area) < this._precision) {
                    return false; // 三角形退化，共线
                }
                return true;
            }
            // 检查点是否在三角形内或边上
            return res;
        };
        this.camera = camera;
        this.startPoint = new Vector2();
        this.endPoint = new Vector2();
    }
    update(startPoint, endPoint) {
        if (startPoint) {
            this.startPoint.copy(startPoint);
        }
        if (endPoint) {
            this.endPoint.copy(endPoint);
        }
        this.minX = endPoint.x > startPoint.x ? startPoint.x : endPoint.x;
        this.minY = endPoint.y > startPoint.y ? startPoint.y : endPoint.y;
        this.maxX = endPoint.x > startPoint.x ? endPoint.x : startPoint.x;
        this.maxY = endPoint.y > startPoint.y ? endPoint.y : startPoint.y;
        this._r1.set(this.minX, this.minY);
        this._r2.set(this.maxX, this.minY);
        this._r3.set(this.maxX, this.maxY);
        this._r4.set(this.minX, this.maxY);
    }
    selectContains(point1, point2, point3) {
        if (point2 == null && point3 == null) {
            // POINT
            if (this.containsPoint(point1))
                return true;
        }
        else if (point3 == null) {
            // line
            if (this.containsPoint(point1) && this.containsPoint(point2))
                return true;
        }
        else {
            // triangle
            if (this.containsPoint(point1)
                && this.containsPoint(point2)
                && this.containsPoint(point3)) {
                return true;
            }
        }
        return false;
    }
    /**
     * 判断渲染对象是否被选择框选中
     * @param point1 如果仅含point1，则判断为点
     * @param point2 如果仅含point1和point2，则判断为线
     * @param point3 如果含有三个点，则判断为三角面
     * @returns
     */
    select(point1, point2, point3) {
        if (this.selectContains(point1))
            return true;
        if (point2 != null && this.selectContains(point2))
            return true;
        if (point3 != null && this.selectContains(point3))
            return true;
        if (point2 != null && point3 == null) {
            // line
            if (this.intersectLine(point1, point2, this._r1, this._r2))
                return true;
            if (this.intersectLine(point1, point2, this._r2, this._r3))
                return true;
            if (this.intersectLine(point1, point2, this._r3, this._r4))
                return true;
            if (this.intersectLine(point1, point2, this._r4, this._r1))
                return true;
        }
        else if (point2 != null && point3 != null) {
            // triangle
            if (this.intersectLine(point1, point2, this._r1, this._r2))
                return true;
            if (this.intersectLine(point1, point2, this._r2, this._r3))
                return true;
            if (this.intersectLine(point1, point2, this._r3, this._r4))
                return true;
            if (this.intersectLine(point1, point2, this._r4, this._r1))
                return true;
            if (this.intersectLine(point1, point3, this._r1, this._r2))
                return true;
            if (this.intersectLine(point1, point3, this._r2, this._r3))
                return true;
            if (this.intersectLine(point1, point3, this._r3, this._r4))
                return true;
            if (this.intersectLine(point1, point3, this._r4, this._r1))
                return true;
            if (this.intersectLine(point3, point2, this._r1, this._r2))
                return true;
            if (this.intersectLine(point3, point2, this._r2, this._r3))
                return true;
            if (this.intersectLine(point3, point2, this._r3, this._r4))
                return true;
            if (this.intersectLine(point3, point2, this._r4, this._r1))
                return true;
            //点选三角面的逻辑
            // //三角形在矩形内部
            // if (point1.x >= this._r1.x && point1.x <= this._r3.x && point1.y >= this._r1.y && point1.y <= this._r3.y) return true;
            //矩形在三角形内部
            if (this.isPointInTriangle(this._r1, point1, point2, point3))
                return true;
        }
        return false;
    }
    containsPoint(point) {
        return point.x < this.minX || point.x > this.maxX ||
            point.y < this.minY || point.y > this.maxY ? false : true;
    }
    intersectLine(p1, p2, q1, q2) {
        if (p1 == null || p2 == null || q1 == null || q2 == null)
            return false;
        if (p1.equals(p2) || q1.equals(q2))
            return false;
        let p1p2 = p2.clone().sub(p1);
        let p1q1 = q1.clone().sub(p1);
        let p1q2 = q2.clone().sub(p1);
        let cross1 = p1p2.cross(p1q1);
        let cross2 = p1p2.cross(p1q2);
        if (cross1 * cross2 > 0)
            return false;
        let q1q2 = q2.clone().sub(q1);
        let q1p1 = p1.clone().sub(q1);
        let q1p2 = p2.clone().sub(q1);
        let cross3 = q1q2.cross(q1p1);
        let cross4 = q1q2.cross(q1p2);
        if (cross3 * cross4 > 0)
            return false;
        return true;
    }
}/**
 * 点选
 */
class EventHandlerPointSelect extends EventHandlerBase {
    constructor() {
        super(...arguments);
        /**
         * 包围盒在选择框之外的图元
         */
        this.priBoxOutRects = {};
    }
    /**
     * 计算图元是否在选择框之外
     * @param primitive
     */
    calPriBoxOutRect(primitive, transMat) {
        const storage = this.getPythaStorage();
        //如果有计算包围盒，并且包围盒与点选点没有交点，直接返回
        if (this.priBoxOutRects[primitive.uuid]) {
            return true;
        }
        let boundingBox;
        if (primitive.type == PrimitiveType.Block) {
            // 如果是块，需要去模板里计算 并且要考虑跨模板的转换矩阵问题
            let bt = storage.blockStore.blockTemplateDict[primitive.blockTemplateUuid];
            boundingBox = BlockPrimitive.calBlockBoundingBox(bt, primitive.worldModelMatrix, storage.blockStore.blockTemplateDict);
        }
        else {
            boundingBox = primitive.getBoundingbox();
        }
        if (boundingBox.min == null || boundingBox.max == null) {
            this.priBoxOutRects[primitive.uuid] = true;
            return true;
        }
        let isInView = this.isBoxInView(boundingBox, transMat);
        if (!isInView) {
            this.priBoxOutRects[primitive.uuid] = true;
            return true;
        }
        return false;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        this.priBoxOutRects = {};
        const storage = this.getPythaStorage();
        const selectStore = storage.selectStore;
        this.node.graph.cache.data['pointSelect'] = false;
        let x = storage.coordinateStore.ndcViewportPos2.x;
        let y = storage.coordinateStore.ndcViewportPos2.y;
        let start_x = x - selectStore.pickEpsilon;
        let start_y = y - selectStore.pickEpsilon;
        let end_x = x + selectStore.pickEpsilon;
        let end_y = y + selectStore.pickEpsilon;
        let filteredEntities = this.selectPrimitivesFromRect(start_x, start_y, end_x, end_y);
        if (Object.keys(filteredEntities).length === 0) {
            return true;
        }
        _vector2_1$1.set(start_x, start_y);
        _vector2_2$1.set(end_x, end_y);
        const camera = storage.viewportStore.viewportItems[storage.viewportStore.currentViewportKey].camera;
        _selectBox$1.update(_vector2_1$1, _vector2_2$1, camera);
        let selectPrimitive = filteredEntities[Object.keys(filteredEntities)[0]];
        let minDist = Number.MAX_VALUE;
        Object.keys(filteredEntities).forEach(key => {
            let primitive = filteredEntities[key];
            if (primitive == null) {
                return;
            }
            let primitiveMinDist = this.getDistFromCameraToPri(primitive, camera);
            if (primitiveMinDist < minDist) {
                minDist = primitiveMinDist;
                selectPrimitive = primitive;
            }
        });
        const shiftKey = this.node.graph.cache.pointerDownList[this.node.graph.cache.pointerDownList.length - 1].shiftKey;
        // 是否开启单选
        if (selectStore.pickOnly) {
            let oldSelectList = selectStore.selectPrimitives.filter(i => i.uuid != selectPrimitive.uuid);
            const uuids = [];
            if (oldSelectList.length > 0) {
                for (let i = 0; i < oldSelectList.length; i++) {
                    oldSelectList[i].isSelected = false;
                    uuids.push(oldSelectList[i].uuid);
                }
            }
            uuids.push(selectPrimitive.uuid);
            if (selectPrimitive.isSelected) {
                selectPrimitive.isSelected = false;
                selectStore.selectPrimitives = [];
            }
            else {
                selectPrimitive.isSelected = true;
                selectStore.selectPrimitives = [selectPrimitive];
            }
            // 发送选中图元的事件
            let selectChangeEvent = new PythaEventSelectChange();
            selectChangeEvent.data = {
                uuids: uuids,
                selectRange: _pickRect$2,
            };
            this.node.graph.eventMediator.emitEvent(selectChangeEvent);
            // 设置点选成功信号
            this.node.graph.cache.data['pointSelect'] = true;
            return true;
        }
        else {
            if (!selectPrimitive.isSelected && !shiftKey) {
                selectStore.selectPrimitives.push(selectPrimitive);
                selectPrimitive.isSelected = true;
                this.node.graph.cache.data['pointSelect'] = true;
                // 发送选中图元的事件
                let selectChangeEvent = new PythaEventSelectChange();
                selectChangeEvent.data = {
                    uuids: [selectPrimitive.uuid],
                    selectRange: _pickRect$2,
                };
                this.node.graph.eventMediator.emitEvent(selectChangeEvent);
                // 计算控制点 为了stretch用
                for (let i = 0; i < selectPrimitive.geos.length; i++) {
                    // let geo = selectPrimitive.geos[i];
                    selectPrimitive.selectedControlPoints[i] = [
                        { type: FEATURE_POINT_TYPE.CENTER },
                    ];
                }
            }
            else if (selectPrimitive.isSelected) {
                const uuids = [];
                if (!shiftKey) {
                    uuids.push(selectPrimitive.uuid);
                }
                else {
                    selectPrimitive.isSelected = false;
                    const idx = selectStore.selectPrimitives.findIndex(p => p.uuid === selectPrimitive.uuid);
                    if (idx !== -1) {
                        selectStore.selectPrimitives.splice(idx, 1);
                    }
                }
                // 发送选中图元的事件
                let selectChangeEvent = new PythaEventSelectChange();
                selectChangeEvent.data = {
                    uuids: uuids,
                    selectRange: _pickRect$2,
                };
                this.node.graph.eventMediator.emitEvent(selectChangeEvent);
                // 设置点选成功信号
                this.node.graph.cache.data['pointSelect'] = true;
                return true;
            }
        }
        return true;
    }
    /**
     * 从矩形框中返回选择的图元
     * @param start_x
     * @param start_y
     * @param end_x
     * @param end_y
     * @returns
     */
    selectPrimitivesFromRect(start_x, start_y, end_x, end_y) {
        var _a, _b, _c, _d;
        const storage = this.getPythaStorage();
        const viewportStore = storage.viewportStore;
        const currentCamera = viewportStore.viewportItems[viewportStore.currentViewportKey].camera;
        const renderStore = storage.renderStore;
        if (!currentCamera)
            return {};
        if (!_pickRect$2) {
            _pickRect$2 = new SelectionRect(currentCamera);
        }
        _pickRect$2.update(new Vector2(start_x, start_y), new Vector2(end_x, end_y));
        if (_pickRect$2.minX === _pickRect$2.maxX && _pickRect$2.minY === _pickRect$2.maxY)
            return {};
        let viewMatrix = currentCamera.matrixWorldInverse;
        let projectMatrix = currentCamera.projectionMatrix;
        let transMat = new Matrix4().identity().premultiply(viewMatrix).premultiply(projectMatrix);
        let filteredEntities = {};
        for (let key in renderStore.objectRenderBucket) {
            let bucket = renderStore.objectRenderBucket[key];
            for (let mapItem of bucket.renderBucketItems) {
                let position = new Float32Array();
                if (((_b = (_a = mapItem.buffer) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.position) != null) {
                    position = (_d = (_c = mapItem.buffer) === null || _c === void 0 ? void 0 : _c.attributes) === null || _d === void 0 ? void 0 : _d.position.array;
                }
                if (position.length <= 0 || mapItem.hidden)
                    continue;
                // let result = this.projectBuffer(position, transMat);
                let result = [];
                let resultIsInit = false;
                if (mapItem.renderType === PrimitiveType.Line) {
                    for (let mi = 0; mi < mapItem.renderItems.length; mi++) {
                        let renderItem = mapItem.renderItems[mi];
                        let primitive = renderItem.primitive.getRootPrimitive();
                        if (primitive == null)
                            continue;
                        if (!primitive.isInView)
                            continue; // 剔除视口外的图元
                        if (filteredEntities[primitive.uuid] != null) {
                            continue;
                        }
                        let flag = this.calPriBoxOutRect(primitive, transMat);
                        if (flag)
                            continue;
                        if (!resultIsInit) {
                            result = this.projectBuffer(position, transMat);
                            resultIsInit = true;
                        }
                        for (let i = 0; i < renderItem.size * 2 / 3; i += 4) {
                            let start = i + renderItem.start * 2 / 3;
                            _vector2_1$1.set(result[start], result[start + 1]);
                            _vector2_2$1.set(result[start + 2], result[start + 3]);
                            let selected = _pickRect$2.select(_vector2_1$1, _vector2_2$1);
                            if (selected) {
                                let rootPrimitive = primitive.getRootPrimitive();
                                if (!rootPrimitive.unselectable) {
                                    filteredEntities[rootPrimitive.uuid] = rootPrimitive;
                                }
                                break;
                            }
                        }
                    }
                }
                else if (mapItem.renderType === "Mesh") {
                    for (let mi = 0; mi < mapItem.renderItems.length; mi++) {
                        let renderItem = mapItem.renderItems[mi];
                        let primitive = renderItem.primitive.getRootPrimitive();
                        if (primitive == null)
                            continue;
                        if (!primitive.isInView)
                            continue; // 剔除视口外的图元
                        if (filteredEntities[primitive.uuid] != null) {
                            continue;
                        }
                        let flag = this.calPriBoxOutRect(primitive, transMat);
                        if (flag)
                            continue;
                        if (!resultIsInit) {
                            result = this.projectBuffer(position, transMat);
                            resultIsInit = true;
                        }
                        if (!resultIsInit) {
                            result = this.projectBuffer(position, transMat);
                            resultIsInit = true;
                        }
                        if (renderStore.renderMode === RenderMode.WIREFRAME) {
                            for (let i = 0; i < renderItem.size * 2 / 3; i += 4) {
                                let start = i + renderItem.start * 2 / 3;
                                _vector2_1$1.set(result[start], result[start + 1]);
                                _vector2_2$1.set(result[start + 2], result[start + 3]);
                                let selected = _pickRect$2.select(_vector2_1$1, _vector2_2$1);
                                if (selected) {
                                    let rootPrimitive = primitive.getRootPrimitive();
                                    if (!rootPrimitive.unselectable) {
                                        filteredEntities[rootPrimitive.uuid] = rootPrimitive;
                                    }
                                    break;
                                }
                            }
                        }
                        else {
                            for (let i = 0; i < renderItem.size * 2 / 3; i += 6) {
                                let start = i + renderItem.start * 2 / 3;
                                _vector2_1$1.set(result[start], result[start + 1]);
                                _vector2_2$1.set(result[start + 2], result[start + 3]);
                                _vector2_3$1.set(result[start + 4], result[start + 5]);
                                let selected = _pickRect$2.select(_vector2_1$1, _vector2_2$1, _vector2_3$1);
                                if (selected) {
                                    let rootPrimitive = primitive.getRootPrimitive();
                                    if (!rootPrimitive.unselectable) {
                                        filteredEntities[rootPrimitive.uuid] = rootPrimitive;
                                    }
                                    break;
                                }
                            }
                        }
                    }
                }
                else if (mapItem.renderType === "Point") {
                    for (let mi = 0; mi < mapItem.renderItems.length; mi++) {
                        let renderItem = mapItem.renderItems[mi];
                        let primitive = renderItem.primitive.getRootPrimitive();
                        if (primitive == null)
                            continue;
                        if (!primitive.isInView)
                            continue; // 剔除视口外的图元
                        if (filteredEntities[primitive.uuid] != null) {
                            continue;
                        }
                        let flag = this.calPriBoxOutRect(primitive, transMat);
                        if (flag)
                            continue;
                        if (!resultIsInit) {
                            result = this.projectBuffer(position, transMat);
                            resultIsInit = true;
                        }
                        if (!resultIsInit) {
                            result = this.projectBuffer(position, transMat);
                            resultIsInit = true;
                        }
                        for (let i = 0; i < renderItem.size * 2 / 3; i += 2) {
                            let start = i + renderItem.start * 2 / 3;
                            _vector2_1$1.set(result[start], result[start + 1]);
                            let selected = false;
                            selected = _pickRect$2.select(_vector2_1$1);
                            if (selected) {
                                let rootPrimitive = primitive.getRootPrimitive();
                                if (!rootPrimitive.unselectable) {
                                    filteredEntities[rootPrimitive.uuid] = rootPrimitive;
                                }
                            }
                        }
                    }
                }
            }
        }
        return filteredEntities;
    }
    /**
     * 将3维点数组投影成2维点数组
     */
    projectBuffer(points, matrix) {
        const count = points.length / 3;
        let result = [];
        for (let i = 0; i < count; i++) {
            _vector$2.set(points[i * 3], points[i * 3 + 1], points[i * 3 + 2]);
            _vector$2.applyMatrix4(matrix);
            result.push(_vector$2.x, _vector$2.y);
        }
        return result;
    }
    /**
     * 通过图元渲染出来的渲染数组，获取某个图元到相机的距离
     * @param primitive 图元
     * @param camera 相机
     *
     */
    getDistFromCameraToPri(primitive, camera) {
        var _a, _b, _c, _d;
        const storage = this.getPythaStorage();
        const objectRenderBucket = storage.renderStore.objectRenderBucket;
        // 遍历renderItem
        const renderItemDict = primitive.renderItemDict;
        let minDist = Number.MAX_VALUE; //图元距离相机的最小距离
        for (const renderItemKey in renderItemDict) {
            const renderItem = renderItemDict[renderItemKey];
            if (!renderItem) {
                continue;
            }
            const start = renderItem.start;
            const size = renderItem.size;
            const renderKey = renderItem.lastRenderKey;
            const index = renderItem.renderGeometryBucketIndex;
            const bucket = objectRenderBucket[renderKey];
            const mapItem = bucket.renderBucketItems[index];
            let position = new Float32Array();
            if (((_b = (_a = mapItem.buffer) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.position) != null) {
                position = (_d = (_c = mapItem.buffer) === null || _c === void 0 ? void 0 : _c.attributes) === null || _d === void 0 ? void 0 : _d.position.array;
            }
            position = position.slice(start, start + size);
            if (position.length <= 0 || mapItem.hidden) {
                continue;
            }
            if (renderItem.renderType === RenderItemType.MESH) {
                //面渲染类型，转化为三角面与相机轴射线求交
                for (let i = 0; i < position.length - 8; i += 9) {
                    _v1$3.set(position[i], position[i + 1], position[i + 2]);
                    _v2$2.set(position[i + 3], position[i + 4], position[i + 5]);
                    _v3$2.set(position[i + 6], position[i + 7], position[i + 8]);
                    let dist = this.getDistFromCameraToTriangle(_v1$3, _v2$2, _v3$2, camera.position);
                    minDist = minDist > dist ? dist : minDist;
                }
            }
            else if (renderItem.renderType === RenderItemType.LINE) {
                //线渲染类型，转化为直线段与相机轴射线求交
                for (let i = 0; i < position.length - 5; i += 6) {
                    _v1$3.set(position[i], position[i + 1], position[i + 2]);
                    _v2$2.set(position[i + 3], position[i + 4], position[i + 5]);
                    let dist = this.getDistFromCameraToLine(_v1$3, _v2$2, camera.position);
                    minDist = minDist > dist ? dist : minDist;
                }
            }
            else if (renderItem.renderType === RenderItemType.POINT) {
                //点渲染类型，转化为点与相机轴射线求交
                for (let i = 0; i < position.length - 2; i += 3) {
                    _v1$3.set(position[i], position[i + 1], position[i + 2]);
                    let dist = this.getDistFromCameraToPoint(_v1$3, camera.position);
                    minDist = minDist > dist ? dist : minDist;
                }
            }
        }
        return minDist;
    }
    /**
     * 获取一个点到相机的距离
     * @param point
     * @param cameraPoint
     */
    getDistFromCameraToPoint(point, cameraPoint) {
        if (_selectBox$1.containsPoint(point)) {
            return cameraPoint.distanceTo(point);
        }
        return Number.MAX_VALUE;
    }
    /**
     * 获取一条线段到相机的距离
     * @param start
     * @param end
     * @param cameraPoint
     * @returns
     */
    getDistFromCameraToLine(start, end, cameraPoint) {
        const planes = _selectBox$1.planes;
        let shoot = new Point();
        _line$2.set(start, end);
        for (let i = 0; i < 6; i++) {
            let plane = planes[i];
            if (!GeoIntersection.LineIntersectPlane(_line$2, plane))
                continue;
            if (!_selectBox$1.containsPoint(shoot))
                continue;
            return shoot.distanceTo(cameraPoint);
        }
        return Number.MAX_VALUE;
    }
    /**
     * 获取三角面到相机位置的距离
     * @param a 三角面第1点
     * @param b 三角面第2点
     * @param c 三角面第3点
     * @param cameraPoint 相机坐标
     * @returns
     */
    getDistFromCameraToTriangle(a, b, c, cameraPoint) {
        _plane$1.setFromCoplanarPoints(a, b, c);
        let normal = _plane$1.normal;
        GeoIntersection.RayIntersectPlane(_selectBox$1.ray, _plane$1, _point$2);
        let angleNum = 0;
        _v1$3.subVectors(a, _point$2);
        _v2$2.subVectors(b, _point$2);
        _v3$2.subVectors(c, _point$2);
        let angle = _v1$3.angleTo(_v2$2);
        if (_v1$3.clone().cross(_v2$2).angleTo(normal) > Math.PI / 2) {
            angle *= -1;
        }
        angleNum += angle;
        angle = _v2$2.angleTo(_v3$2);
        if (_v2$2.clone().cross(_v3$2).angleTo(normal) > Math.PI / 2) {
            angle *= -1;
        }
        angleNum += angle;
        angle = _v3$2.angleTo(_v1$3);
        if (_v3$2.clone().cross(_v1$3).angleTo(normal) > Math.PI / 2) {
            angle *= -1;
        }
        angleNum += angle;
        if (Math.abs(angleNum - 2 * Math.PI) < 1e-6) {
            return _point$2.distanceTo(cameraPoint);
        }
        return Number.MAX_VALUE;
    }
    isBoxInView(boundingBox, transMat) {
        _point1$3.copy(boundingBox.min); // min
        _point2$4.set(boundingBox.min.x, boundingBox.min.y, boundingBox.max.z);
        _point3$2.set(boundingBox.min.x, boundingBox.max.y, boundingBox.min.z);
        _point4$2.set(boundingBox.min.x, boundingBox.max.y, boundingBox.max.z);
        _point5$2.set(boundingBox.max.x, boundingBox.max.y, boundingBox.min.z);
        _point6$2.set(boundingBox.max.x, boundingBox.max.y, boundingBox.max.z); // max
        _point7$2.set(boundingBox.max.x, boundingBox.min.y, boundingBox.min.z);
        _point8$2.set(boundingBox.max.x, boundingBox.min.y, boundingBox.max.z);
        let points = [_point1$3, _point2$4, _point3$2, _point4$2, _point5$2, _point6$2, _point7$2, _point8$2];
        // 将包围盒点投影到屏幕空间
        const vertices = this.projectBufferFromPoints(points, transMat);
        const triangles = [
            // 前面
            [vertices[0], vertices[1], vertices[3]], // 三角形 1
            [vertices[0], vertices[2], vertices[3]], // 三角形 2
            // 后面
            [vertices[4], vertices[5], vertices[6]], // 三角形 3
            [vertices[4], vertices[6], vertices[7]], // 三角形 4
            // 左面
            [vertices[0], vertices[1], vertices[7]], // 三角形 5
            [vertices[0], vertices[4], vertices[7]], // 三角形 6
            // 右面
            [vertices[2], vertices[3], vertices[6]], // 三角形 7
            [vertices[2], vertices[5], vertices[6]], // 三角形 8
            // 顶面
            [vertices[1], vertices[3], vertices[6]], // 三角形 9
            [vertices[1], vertices[6], vertices[7]], // 三角形 10
            // 底面
            [vertices[0], vertices[2], vertices[5]], // 三角形 11
            [vertices[0], vertices[4], vertices[5]] // 三角形 12
        ];
        let success = false;
        for (let i = 0; i < 12; i++) {
            let triangle = triangles[i];
            let res = _pickRect$2.select(triangle[0], triangle[1], triangle[2]);
            if (res) {
                success = true;
                break;
            }
        }
        return success;
    }
    /**
     * 通过三维点集来生成屏幕坐标下的二位数组
     * @param points
     * @param matrix
     * @returns
     */
    projectBufferFromPoints(points, matrix) {
        let result = [];
        for (let i = 0; i < (points === null || points === void 0 ? void 0 : points.length); i++) {
            _vector$2.set(points[i].x, points[i].y, points[i].z);
            _vector$2.applyMatrix4(matrix);
            result.push(new Point2(_vector$2.x, _vector$2.y));
        }
        return result;
    }
}
/**
 * 辅助选择的数据结构，视锥立方体
 */
let SelectionBox$1=class SelectionBox {
    constructor() {
        this.startPoint = new Vector2();
        this.endPoint = new Vector2();
        this._vecTopLeft = new Vector3();
        this._vecTopRight = new Vector3();
        this._vecDownRight = new Vector3();
        this._vecDownLeft = new Vector3();
        this._vecFarTopLeft = new Vector3();
        this._vecFarTopRight = new Vector3();
        this._vecFarDownRight = new Vector3();
        this._vecFarDownLeft = new Vector3();
        /**
         * 视锥体的六个平面
         */
        this.planes = [new Plane$1(), new Plane$1(), new Plane$1(), new Plane$1(), new Plane$1(), new Plane$1()];
        this._vecCenter = new Point();
        this._dir = new Vector3();
        this.ray = new Ray$2();
        this.startPoint = new Vector2();
        this.endPoint = new Vector2();
    }
    update(startPoint, endPoint, camera) {
        if (startPoint) {
            this.startPoint.copy(startPoint);
        }
        if (endPoint) {
            this.endPoint.copy(endPoint);
        }
        this.updateFrustum(camera);
    }
    updateFrustum(camera) {
        const startPoint = this.startPoint;
        const endPoint = this.endPoint;
        // Avoid invalid frustum
        if (startPoint.x === endPoint.x) {
            endPoint.x += Number.EPSILON;
        }
        if (startPoint.y === endPoint.y) {
            endPoint.y += Number.EPSILON;
        }
        if (camera && (camera.type === 'OrthographicCamera' || camera.type === 'PerspectiveCamera')) {
            camera.updateProjectionMatrix();
        }
        camera.updateMatrixWorld();
        const left = Math.min(startPoint.x, endPoint.x);
        const top = Math.max(startPoint.y, endPoint.y);
        const right = Math.max(startPoint.x, endPoint.x);
        const down = Math.min(startPoint.y, endPoint.y);
        this._vecTopLeft.set(left, top, -1);
        this._vecTopRight.set(right, top, -1);
        this._vecDownRight.set(right, down, -1);
        this._vecDownLeft.set(left, down, -1);
        this._vecFarTopLeft.set(left, top, 1);
        this._vecFarTopRight.set(right, top, 1);
        this._vecFarDownRight.set(right, down, 1);
        this._vecFarDownLeft.set(left, down, 1);
        this._vecTopLeft.unproject(camera);
        this._vecTopRight.unproject(camera);
        this._vecDownRight.unproject(camera);
        this._vecDownLeft.unproject(camera);
        this._vecFarTopLeft.unproject(camera);
        this._vecFarTopRight.unproject(camera);
        this._vecFarDownRight.unproject(camera);
        this._vecFarDownLeft.unproject(camera);
        const planes = this.planes;
        planes[0].setFromCoplanarPoints(this._vecTopLeft, this._vecFarTopLeft, this._vecFarTopRight);
        planes[1].setFromCoplanarPoints(this._vecTopRight, this._vecFarTopRight, this._vecFarDownRight);
        planes[2].setFromCoplanarPoints(this._vecFarDownRight, this._vecFarDownLeft, this._vecDownLeft);
        planes[3].setFromCoplanarPoints(this._vecFarDownLeft, this._vecFarTopLeft, this._vecTopLeft);
        planes[4].setFromCoplanarPoints(this._vecTopRight, this._vecDownRight, this._vecDownLeft);
        planes[5].setFromCoplanarPoints(this._vecFarDownRight, this._vecFarTopRight, this._vecFarTopLeft);
        planes[5].normal.multiplyScalar(-1);
        this._vecCenter.copy(this._vecTopLeft).add(this._vecDownRight).multiplyScalar(0.5);
        this._dir.copy(this._vecFarTopLeft).sub(this._vecTopLeft);
        const ray = this.ray;
        ray.set(this._vecCenter, this._dir);
    }
    /**
     * 判断点是否在视锥体内
     * @param point
     * @returns
     */
    containsPoint(point) {
        const planes = this.planes;
        for (let i = 0; i < 6; i++) {
            if (GeoMeasurement.PointDistanceToPlane(point, planes[i]) < -1e-6) { // 当点在平面内时，可能会存在负的计算误差
                return false;
            }
        }
        return true;
    }
};
//选择过程中的临时变量，防止重复创建的开销
const _vector2_1$1 = new Vector2();
const _vector2_2$1 = new Vector2();
const _vector2_3$1 = new Vector2();
let _pickRect$2;
const _vector$2 = new Vector3();
const _plane$1 = new Plane$1();
const _point$2 = new Point();
const _v1$3 = new Vector3();
const _v2$2 = new Vector3();
const _v3$2 = new Vector3();
const _line$2 = new Line$2();
const _selectBox$1 = new SelectionBox$1();
const _point1$3 = new Point();
const _point2$4 = new Point();
const _point3$2 = new Point();
const _point4$2 = new Point();
const _point5$2 = new Point();
const _point6$2 = new Point();
const _point7$2 = new Point();
const _point8$2 = new Point();/**
 * 单行文字 修改
 */
class EventGraphTextEdit extends EventGraphBase {
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerConfirm);
        const node4 = new EventGraphNode(this, EventHandlerShowTextArea);
        const node5 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        const node6 = new EventGraphNode(this, EHChangePickCursor);
        const node7 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node8 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '选择文字对象' });
        const node9 = new EventGraphNode(this, EventHandlerTextInput);
        const node10 = new EventGraphNode(this, EventHandlerEditText);
        const node11 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node12 = new EventGraphNodeSwitch(this, () => {
            const storage = PythaStorage.instance;
            if (storage.selectStore.getUnlockedPrimitives().length <= 0)
                return [1];
            let plist = storage.selectStore.getUnlockedPrimitives();
            let p = plist.find(item => item.type == "Text");
            if (p == null)
                return [1];
            let temp = p.clone();
            temp.uuid = p.uuid;
            this.cache.primitiveList = [temp];
            return [0];
        });
        const node13 = new EventGraphNode(this, EventHandlerPointSelect);
        const node14 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node15 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node16 = new EventGraphNode(this, EventHandlerGrid);
        const node17 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node18 = new EventGraphNode(this, EventHandlerEditPri);
        const node19 = new EventGraphNode(this, EventHandlerEmptySelect);
        const node20 = new EventGraphNode(this, EventHandlerDisableClamp);
        const node21 = new EventGraphNode(this, EventHandlerEmptySelect);
        const node22 = new EventGraphNodeRender(this, true, UpdateType.MAIN);
        const node23 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "编辑文字内容", option: 'TEXT', inputTypes: [PythaEventName.DY_TEXT] },
            ] });
        this.addEdge(node4, node5);
        this.addEdge(node5, node9);
        this.addEdge(node9, node10);
        this.addEdge(node2, node7);
        this.addEdge(node6, node8);
        this.addEdge(node8, node12);
        this.addEdge(node14, node6);
        this.addEdge(node15, node13);
        this.addEdge(node13, node12);
        this.addEdge(node17, node16);
        this.addEdge(node10, node18);
        this.addEdge(node18, node17);
        this.addEdge(node16, node19);
        this.addEdge(node19, node11);
        this.addEdge(node14, node2);
        this.addEdge(node11, node1);
        this.addEdge(node1, node20);
        this.addEdge(node20, node14);
        this.addEdge(node21, node22);
        this.addEdge(node22, node15);
        this.addEdge(node12, node23);
        this.addEdge(node23, node4);
        this.addEdge(node12, node21);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/54
    }
}
/**
 * 指令 用于注册事件图
 */
EventGraphTextEdit.cmd = 'TEXTEDIT';/**
 * 创建块模板
 */
class AddBlockTemplateCmd extends CommandBase {
    /**
     * 构造函数
     * @param primitives
     * @param eventMediator
     */
    constructor(blockTemplate, eventMediator) {
        super();
        this.eventMediator = eventMediator;
        this.blockTemplate = blockTemplate;
        this.blockTemplate.isTemplate = true;
    }
    /**
     * 执行
     */
    execute() {
        const storage = PythaStorage.instance;
        // const primitiveDict = storage.primitiveStore.primitiveDict;
        storage.blockStore.blockTemplateDict[this.blockTemplate.uuid] = this.blockTemplate;
        this.eventMediator.noticeHandler.notice(this, new PythaEventDataChange({ add_block_template: this.blockTemplate }));
    }
    /**
     * 撤销
     */
    undo() {
        const storage = PythaStorage.instance;
        delete storage.blockStore.blockTemplateDict[this.blockTemplate.uuid];
        this.eventMediator.noticeHandler.notice(this, new PythaEventDataChange({ delete_block_template: this.blockTemplate }));
    }
}/**
 * 生成块处理器
 */
class EventHandlerGenBlock extends EventHandlerBase {
    constructor() {
        super(...arguments);
        this._x = new Vector3();
        this._y = new Vector3();
        this._z = new Vector3();
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        const storage = PythaStorage.instance;
        //获取当前点
        const pointerDownList = this.node.graph.cache.pointerDownList;
        if (pointerDownList.length < 1)
            return false;
        let point = pointerDownList[pointerDownList.length - 1].point; // 基点
        // 获取坐标系
        let ucs = storage.coordinateStore.activeUcs;
        let axisX = this._x.set(ucs.elements[0], ucs.elements[1], ucs.elements[2]);
        let axisY = this._y.set(ucs.elements[4], ucs.elements[5], ucs.elements[6]);
        let axisZ = this._z.set(ucs.elements[8], ucs.elements[9], ucs.elements[10]);
        // 名称
        let name = this.node.graph.cache.data['text'] || "";
        if (name.trim().length <= 0)
            return true;
        // 生成块模板
        let selectedPrimitives = storage.selectStore.getUnlockedPrimitives() || [];
        if (selectedPrimitives.length <= 0)
            return false;
        let blockTemplate = new BlockPrimitive();
        blockTemplate.isTemplate = true;
        blockTemplate.name = name;
        blockTemplate.setXYZP(axisX, axisY, axisZ, point); // 设置模板块的坐标系
        for (let sp of selectedPrimitives) {
            if (sp.type != "Block") {
                let child = sp.clone();
                child.uuid = sp.uuid;
                child.layerUuid = null;
                if (child.localModelMatrix == null) {
                    child.localModelMatrix = new Matrix4();
                }
                child.localModelMatrix.premultiply(blockTemplate.worldModelMatrixInverse); // 需要对块的子图元做矩阵变换至以块基点为原点的局部坐标系
                blockTemplate.addChildPrimitive(child);
            }
            else {
                //新增新的块模板图元
                let child = new BlockPrimitive();
                child.localModelMatrix.copy(sp.localModelMatrix); //块图元一定有局部矩阵
                //将块图元的矩阵赋予新生成的块模板图元
                child.blockTemplateUuid = sp.blockTemplateUuid;
                child.localModelMatrix.premultiply(blockTemplate.worldModelMatrixInverse); // 需要对块的子图元做矩阵变换至以块基点为原点的局部坐标系
                blockTemplate.addChildPrimitive(child);
            }
        }
        blockTemplate.updateWorldModelMatrix(false, true);
        blockTemplate.needRedraw = true;
        // 生成块
        let block = new BlockPrimitive();
        block.blockTemplateUuid = blockTemplate.uuid;
        const addBlockCmd = new AddBlockTemplateCmd(blockTemplate, this.node.graph.eventMediator);
        const addPriCmd = new AddPrimitiveCmd([block], this.node.graph.eventMediator);
        const deleteCmd = new DeletePrimitiveCmd(selectedPrimitives, this.node.graph.eventMediator);
        // 判断缓存中是否有commandGroup
        const graphCache = this.node.graph.cache;
        const commandGroup = graphCache.data['commandGroup'];
        if (!commandGroup || !(commandGroup instanceof CommandGroup)) {
            const cmdGroup = new CommandGroup();
            cmdGroup.addCmd(addBlockCmd);
            cmdGroup.addCmd(addPriCmd);
            cmdGroup.addCmd(deleteCmd);
            storage.historyStore.undos.push(cmdGroup);
            cmdGroup.execute();
        }
        else {
            commandGroup.addCmd(addBlockCmd);
            commandGroup.addCmd(addPriCmd);
            commandGroup.addCmd(deleteCmd);
        }
        return true;
    }
}class EventGraphBlock extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNodeSwitch(this, () => {
            const storage = PythaStorage.instance;
            if (storage.selectStore.selectPrimitives.length <= 0) {
                return [0];
            }
            return [1];
        });
        const node3 = new EventGraphNode(this, EventHandlerConfirm);
        const node4 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '请选择对象' });
        const node5 = new EventGraphNode(this, EHChangePickCursor);
        const node6 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node7 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node8 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定基点", option: 'P', inputTypes: [PythaEventName.POINTER_DOWN] },
            ] });
        const node9 = new EventGraphNode(this, EHChangeCrossCursor);
        const node10 = new EventGraphNode(this, EventHandlerShowTextArea);
        const node11 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "命名块", option: 'TEXT', inputTypes: [PythaEventName.DY_TEXT] },
            ] });
        const node12 = new EventGraphNode(this, EventHandlerTextInput);
        const node13 = new EventGraphNode(this, EventHandlerGenBlock);
        const node14 = new EventGraphNode(this, EventHandlerDisableClamp);
        const node15 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node16 = new EventGraphNode(this, EventHandlerGrid);
        const node17 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node18 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node19 = new EventGraphNode(this, EventHandlerInitCapture);
        const node20 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node21 = new EventGraphNode(this, EventHandlerCapture);
        const node22 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        const node23 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        const node24 = new EventGraphNodeSwitch(this, () => {
            const storage = PythaStorage.instance;
            if (storage.selectStore.selectPrimitives.length <= 0) {
                return [0];
            }
            return [1];
        });
        this.addEdge(node2, node4);
        this.addEdge(node4, node5);
        this.addEdge(node5, node3);
        this.addEdge(node8, node7);
        this.addEdge(node6, node9);
        this.addEdge(node9, node8);
        this.addEdge(node7, node11);
        this.addEdge(node11, node10);
        this.addEdge(node1, node14);
        this.addEdge(node14, node2);
        this.addEdge(node12, node13);
        this.addEdge(node16, node17);
        this.addEdge(node17, node15);
        this.addEdge(node13, node18);
        this.addEdge(node18, node16);
        this.addEdge(node6, node19);
        this.addEdge(node19, node20);
        this.addEdge(node20, node21);
        this.addEdge(node21, node22);
        this.addEdge(node10, node23);
        this.addEdge(node23, node12);
        this.addEdge(node3, node24);
        this.addEdge(node24, node15);
        this.addEdge(node2, node6);
        this.addEdge(node24, node6);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/111
    }
}
/**
 * 用于注册事件图
 */
EventGraphBlock.cmd = 'BLOCK';/**
 * 计算距离
 */
class EventHandlerMeasureDist extends EventHandlerBase {
    run(data) {
        const storage = PythaStorage.instance;
        let pdList = this.node.graph.cache.pointerDownList || [];
        if ((pdList === null || pdList === void 0 ? void 0 : pdList.length) < 2)
            return false;
        const startPoint = pdList[0].point;
        const endPoint = pdList[1].point;
        // 计算距离
        let delta = new Point();
        delta.subVectors(endPoint, startPoint);
        const dist = delta.length() / (storage.coordinateStore.lengthUnitRatio || 1);
        // 计算两点在当前工作面上的投影
        const workPlane = storage.coordinateStore.workPlane;
        let projectStartPoint = new Point();
        let projectEndPoint = new Point();
        workPlane.projectPoint(startPoint, projectStartPoint);
        workPlane.projectPoint(endPoint, projectEndPoint);
        const projectDelta = new Point();
        projectDelta.subVectors(projectEndPoint, projectStartPoint);
        // 获取当前UCS
        const ucsElements = storage.coordinateStore.activeUcs.elements;
        const ucsAxisX = new Vector3(ucsElements[0], ucsElements[1], ucsElements[2]);
        const ucsAxisY = new Vector3(ucsElements[4], ucsElements[5], ucsElements[6]);
        const ucsAxisZ = new Vector3(ucsElements[8], ucsElements[9], ucsElements[10]);
        // 计算XY平面中的倾角
        let theta1 = projectDelta.angleTo(ucsAxisX) * 180 / Math.PI;
        let value1 = ucsAxisX.clone().cross(projectDelta).angleTo(ucsAxisZ) * 180 / Math.PI;
        if (value1 > 90) {
            theta1 = 360 - theta1;
        }
        // 计算与XY平面的夹角
        let theta2 = delta.angleTo(projectDelta) * 180 / Math.PI;
        let value2 = delta.angleTo(ucsAxisZ) * 180 / Math.PI;
        if (value2 > 90) {
            theta2 = 360 - theta2;
        }
        // 计算XYZ的增量
        let incX = delta.dot(ucsAxisX) / (storage.coordinateStore.lengthUnitRatio || 1);
        let incY = delta.dot(ucsAxisY) / (storage.coordinateStore.lengthUnitRatio || 1);
        let incZ = delta.dot(ucsAxisZ) / (storage.coordinateStore.lengthUnitRatio || 1);
        // 发送通知
        let outputData = {
            type: OutputDataType.STRING,
            data: `距离=${dist.toFixed(4).toString()}， XY平面中的倾角=${theta1.toFixed(0)}， 与XY平面的夹角=${theta2.toFixed(0)}， 
            X增量=${incX.toFixed(4).toString()}， Y增量=${incY.toFixed(4).toString()}， Z增量=${incZ.toFixed(4).toString()}`
        };
        this.node.graph.eventMediator.noticeHandler.notice(this.node, new PythaEventOutputData(outputData));
        return true;
    }
}/**
 * 测量距离
 */
class EventGraphMeasureDist extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node3 = new EventGraphNode(this, EventHandlerInitCapture);
        const node4 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node5 = new EventGraphNode(this, EventHandlerCapture);
        const node6 = new EventGraphNode(this, EventHandlerConfirm);
        const node7 = new EventGraphNode(this, EventHandlerCmdEnd);
        node7.needExtraFuncOnHandlerActive = (handler) => {
            handler.set("sendNotice", false);
        };
        const node8 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node9 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node11 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定第一个点", option: 'S', inputTypes: [PythaEventName.POINTER_DOWN] }
            ]
        });
        const node12 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定第二个点", option: 'E', inputTypes: [PythaEventName.POINTER_DOWN] }
            ]
        });
        const node13 = new EventGraphNode(this, EHChangeCrossCursor);
        const node15 = new EventGraphNode(this, EventHandlerHelpLine);
        const node16 = new EventGraphNode(this, EventHandlerMeasureDist);
        const node17 = new EventGraphNodeAND(this, null);
        this.addEdge(node1, node13);
        this.addEdge(node13, node2);
        this.addEdge(node2, node3);
        this.addEdge(node3, node4);
        this.addEdge(node4, node5);
        this.addEdge(node5, node17);
        this.addEdge(node17, node15);
        this.addEdge(node1, node11);
        this.addEdge(node11, node8);
        this.addEdge(node8, node17);
        this.addEdge(node8, node12);
        this.addEdge(node12, node9);
        this.addEdge(node1, node6);
        this.addEdge(node6, node7);
        this.addEdge(node16, node7);
        this.addEdge(node9, node16);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/112
    }
}
/**
 * di指令 用于注册事件图
 */
EventGraphMeasureDist.cmd = 'DI';/**
 * 计算角度
 */
class EventHandlerMeasureAngle extends EventHandlerBase {
    run(data) {
        let pdList = this.node.graph.cache.pointerDownList || [];
        if ((pdList === null || pdList === void 0 ? void 0 : pdList.length) < 3)
            return false;
        const anglePoint = pdList[0].point;
        const startPoint = pdList[1].point;
        const endPoint = pdList[2].point;
        let delta1 = new Vector3();
        delta1.subVectors(anglePoint, startPoint);
        let delta2 = new Vector3();
        delta2.subVectors(anglePoint, endPoint);
        let angle = BaseUtils.NumFixed(delta1.angleTo(delta2) * 180 / Math.PI, 2);
        // 发送通知
        let outputData = {
            type: OutputDataType.STRING,
            data: `角度为：${angle}°`
        };
        this.node.graph.eventMediator.noticeHandler.notice(this.node, new PythaEventOutputData(outputData));
        return true;
    }
}/**
 * 测量角度
 */
class EventGraphMeasureAngle extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EHChangeCrossCursor);
        const node3 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node4 = new EventGraphNode(this, EventHandlerInitCapture);
        const node6 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node7 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node8 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node9 = new EventGraphNode(this, EventHandlerMeasureAngle);
        const node10 = new EventGraphNode(this, EventHandlerConfirm);
        const node11 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定夹角点", option: 'F', inputTypes: [PythaEventName.POINTER_DOWN] }
            ]
        });
        const node12 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定第一个点", option: 'S', inputTypes: [PythaEventName.POINTER_DOWN] }
            ]
        });
        const node13 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定第二个点", option: 'T', inputTypes: [PythaEventName.POINTER_DOWN] }
            ]
        });
        const node14 = new EventGraphNode(this, EventHandlerCmdEnd);
        node14.needExtraFuncOnHandlerActive = (handler) => {
            handler.set("sendNotice", false);
        };
        const node15 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node16 = new EventGraphNode(this, EventHandlerCapture);
        this.addEdge(node1, node2);
        this.addEdge(node2, node3);
        this.addEdge(node3, node4);
        this.addEdge(node1, node10);
        this.addEdge(node10, node14);
        this.addEdge(node1, node11);
        this.addEdge(node11, node6);
        this.addEdge(node6, node12);
        this.addEdge(node12, node7);
        this.addEdge(node7, node13);
        this.addEdge(node13, node8);
        this.addEdge(node8, node9);
        this.addEdge(node9, node14);
        this.addEdge(node4, node15);
        this.addEdge(node15, node16);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/113
    }
}
/**
 * mea指令 用于注册事件图
 */
EventGraphMeasureAngle.cmd = 'MEA';/**
 * 测量点
 */
class EventHandlerMeasureCoordinate extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        const pointerDownList = this.node.graph.cache.pointerDownList;
        const point = pointerDownList[0].point;
        const storage = this.getPythaStorage();
        // 发送通知
        let outputData = {
            type: OutputDataType.STRING,
            data: `x=${point.x / (storage.coordinateStore.lengthUnitRatio || 1)}， y=${point.y / (storage.coordinateStore.lengthUnitRatio || 1)}， z=${point.z / (storage.coordinateStore.lengthUnitRatio || 1)}`
        };
        this.node.graph.eventMediator.noticeHandler.notice(this.node, new PythaEventOutputData(outputData));
        return true;
    }
}/**
 * coordinate指令 测量坐标
 */
class EventGraphCoordinate extends EventGraphBase {
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node3 = new EventGraphNode(this, EHChangeCrossCursor);
        const node4 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定点", inputTypes: [PythaEventName.POINTER_DOWN] },
            ]
        });
        const node5 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node6 = new EventGraphNode(this, EventHandlerInitCapture);
        const node7 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node8 = new EventGraphNode(this, EventHandlerCapture);
        const node9 = new EventGraphNode(this, EventHandlerConfirm);
        const node10 = new EventGraphNode(this, EventHandlerCmdEnd);
        node10.needExtraFuncOnHandlerActive = (handler) => {
            handler.set("sendNotice", false);
        };
        const node12 = new EventGraphNode(this, EventHandlerMeasureCoordinate);
        this.addEdge(node1, node2);
        this.addEdge(node2, node3);
        this.addEdge(node3, node4);
        this.addEdge(node4, node5);
        this.addEdge(node6, node7);
        this.addEdge(node7, node8);
        this.addEdge(node2, node6);
        this.addEdge(node1, node9);
        this.addEdge(node9, node10);
        //this.addEdge(node11, node10);
        this.addEdge(node5, node12);
        //this.addEdge(node12, node11);
        this.addEdge(node12, node10);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/108
    }
}
/**
 * coordinate指令 用于注册事件图
 */
EventGraphCoordinate.cmd = 'COORDINATE';/**
 * 生成并计算临时镜像图元的处理器
 */
class EventHandlerCalTempMirrorPri extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.modelMatrixMap = {};
        this.mirrorPlane = new Plane$1();
        const storage = PythaStorage.instance;
        let selectPrimitives = storage.selectStore.getUnlockedPrimitives();
        let clonePrimitives = selectPrimitives.map(item => {
            let clonePri = item.clone();
            clonePri.temporary = true;
            storage.primitiveStore.tempPrimitiveDict[clonePri.uuid] = clonePri;
            // 保存局部矩阵
            let localMatrix = clonePri.localModelMatrix;
            if (!localMatrix) {
                localMatrix = new Matrix4();
                clonePri.localModelMatrix = new Matrix4();
            }
            this.modelMatrixMap[clonePri.uuid] = localMatrix.clone();
            return clonePri;
        });
        this.node.graph.cache.primitiveList = clonePrimitives;
    }
    run() {
        var _a;
        const storage = PythaStorage.instance;
        const workPlane = storage.coordinateStore.workPlane;
        // 获取点击的最后一个点
        const pointerDownList = this.node.graph.cache.pointerDownList;
        if (pointerDownList.length < 1)
            return false;
        let firstPoint = pointerDownList[pointerDownList.length - 1].point;
        // 获取移动点
        const pointMove = (_a = this.node.graph.cache.pointerMove.point) === null || _a === void 0 ? void 0 : _a.clone();
        if (!pointMove)
            return false;
        // 获取镜像轴
        let v = new Vector3().subVectors(pointMove, firstPoint);
        // 极值处理
        if (v.length() < 1e-6)
            return false;
        // 获取镜像平面的法向量
        let mirrorPlaneNormal = v.cross(workPlane.normal).normalize();
        // 判断如果镜像平面法向量垂直工作面，则不镜像
        if (workPlane.normal.cross(mirrorPlaneNormal).length() < 1e-6) {
            return false;
        }
        let d = -(firstPoint.x * mirrorPlaneNormal.x + firstPoint.y * mirrorPlaneNormal.y + firstPoint.z + mirrorPlaneNormal.z);
        // 构造镜像平面
        this.mirrorPlane.set(mirrorPlaneNormal, d);
        this.mirrorPlane.setP(firstPoint);
        // 将clonePri的localMatrix都变为初始状态并镜像
        let priList = this.node.graph.cache.primitiveList;
        priList.forEach(item => {
            item.localModelMatrix.copy(this.modelMatrixMap[item.uuid]);
            item.updateWorldModelMatrix(false, true);
            item.mirror(this.mirrorPlane);
            item.needRedraw = true;
        });
        return true;
    }
}/**
 * 判断是否需要删除镜像命令源对象的处理器
 */
class EventHandlerOrgMirrorPri extends EventHandlerBase {
    run(data) {
        var _a;
        // 获取是否删除源对象的用户输入
        let input = (_a = this.node.graph.cache) === null || _a === void 0 ? void 0 : _a.inputOption;
        if (input == "Y") {
            let selectPrimitives = PythaStorage.instance.selectStore.getUnlockedPrimitives();
            this.node.graph.cache.deletePrimitiveList = selectPrimitives;
        }
        return true;
    }
}/**
 * 镜像图
 */
class EventGraphMirror extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node3 = new EventGraphNodeSwitch(this, () => {
            if (this.checkSelectPrimitives()) {
                return [0];
            }
            return [1];
        });
        const node4 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node6 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node7 = new EventGraphNode(this, EventHandlerCalTempMirrorPri);
        const node8 = new EventGraphNode(this, EventHandlerConfirm);
        const node9 = new EventGraphNode(this, EventHandlerGrid);
        const node10 = new EventGraphNode(this, EventHandlerGenAndDeletePrimitives);
        const node11 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node12 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node13 = new EventGraphNode(this, EventHandlerInitCapture);
        const node14 = new EventGraphNode(this, EventHandlerCapture);
        const node15 = new EventGraphNodeAND(this, null);
        const node16 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node17 = new EventGraphNodeSwitch(this, () => {
            if (this.checkSelectPrimitives()) {
                return [0];
            }
            return [1];
        });
        const node18 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node19 = new EventGraphNode(this, EventHandlerGrid);
        const node20 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node21 = new EventGraphNode(this, EventHandlerOptionInput);
        const node22 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "要删除源对象吗？<N>", inputTypes: [PythaEventName.OPTION, PythaEventName.CONFIRM] },
                { type: NeedInputEnum.OPTION, description: "是", option: "Y" },
                { type: NeedInputEnum.OPTION, description: "否", option: "N" }
            ]
        });
        const node23 = new EventGraphNode(this, EventHandlerOrgMirrorPri);
        const node24 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "选中图元", option: "SELECT", inputTypes: [PythaEventName.CONFIRM] }
            ]
        });
        const node25 = new EventGraphNode(this, EventHandlerHelpLine);
        const node26 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定镜像线的第一点", option: '', inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.CONFIRM] }
            ]
        });
        const node27 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定镜像线的第二点", option: '', inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.CONFIRM] }
            ]
        });
        const node28 = new EventGraphNode(this, EHChangePickCursor);
        const node29 = new EventGraphNode(this, EventHandlerCaptureClear);
        const node30 = new EventGraphNode(this, EHChangeCrossCursor);
        const node31 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node32 = new EventGraphNode(this, EventHandlerConfirm);
        const node33 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node34 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        const node35 = new EventGraphNode(this, EventHandlerConfirm);
        this.addEdge(node1, node3);
        /**已经选中图元*/
        this.addEdge(node3, node2);
        this.addEdge(node7, node9);
        this.addEdge(node13, node16);
        this.addEdge(node16, node14);
        this.addEdge(node8, node17);
        /**已经选中图元*/
        this.addEdge(node17, node2);
        this.addEdge(node2, node13);
        this.addEdge(node10, node19);
        this.addEdge(node19, node11);
        this.addEdge(node9, node12);
        this.addEdge(node4, node22);
        this.addEdge(node22, node21);
        this.addEdge(node21, node23);
        this.addEdge(node23, node10);
        this.addEdge(node4, node16, EDGE_TYPE.STOP);
        this.addEdge(node4, node7);
        this.addEdge(node26, node6);
        this.addEdge(node6, node27);
        this.addEdge(node27, node4);
        this.addEdge(node24, node28);
        this.addEdge(node28, node8);
        this.addEdge(node4, node29);
        this.addEdge(node2, node30);
        this.addEdge(node30, node26);
        this.addEdge(node15, node25);
        this.addEdge(node25, node7);
        this.addEdge(node11, node31);
        this.addEdge(node31, node20);
        this.addEdge(node26, node32);
        this.addEdge(node32, node20);
        this.addEdge(node6, node25);
        this.addEdge(node14, node33);
        this.addEdge(node33, node15);
        this.addEdge(node6, node34);
        this.addEdge(node34, node15);
        this.addEdge(node22, node35);
        this.addEdge(node35, node23);
        this.addEdge(node35, node21, EDGE_TYPE.STOP);
        this.addEdge(node21, node35, EDGE_TYPE.STOP);
        this.addEdge(node4, node8, EDGE_TYPE.STOP);
        this.addEdge(node4, node32, EDGE_TYPE.STOP);
        /**未选中图元*/
        this.addEdge(node17, node18);
        /**未选中图元*/
        this.addEdge(node3, node24);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/105
    }
    /**
     * 判断是否选中了图元
     * @returns
     */
    checkSelectPrimitives() {
        if (PythaStorage.instance.selectStore.getUnlockedPrimitives().length > 0) {
            return true;
        }
        return false;
    }
}
EventGraphMirror.cmd = "MIRROR";/**
 * 阵列选项
 */
const POLAR_ARRAY_OPTION = {
    COUNT: "I",
    ANGLE: "A",
    ROW: "R",
    LEVEL: "L",
    CENTER: "CENTER", // 极轴中心点
};
/**
 * 阵列输入对应的key
 */
const POLAR_ARRAY_INPUT_OPTION = Object.assign(Object.assign({}, POLAR_ARRAY_OPTION), { ROW_DIST: "R_D", LEVEL_DIST: "L_D" });
/**
 * 计算临时极轴阵列图元
 */
class EventHandlerCalcPolarArray extends EventHandlerBase {
    run(data) {
        const graphCache = this.node.graph.cache;
        const isInit = graphCache.data['isInit'];
        if (!isInit) {
            this.firstGenerate();
            return true;
        }
        this.calcInput();
        this.undo();
        this.generatePolarAxis();
        return true;
    }
    /**
     * 处理输入的数据，修改对应的数值
     */
    calcInput() {
        var _a;
        const graphCache = this.node.graph.cache;
        const option = (_a = graphCache.needInput) === null || _a === void 0 ? void 0 : _a.option;
        const inputNumber = graphCache.inputNumber;
        if (!inputNumber || !option || option == '')
            return;
        Object.keys(inputNumber).forEach(key => {
            graphCache.data[key] = inputNumber[key];
        });
    }
    /**
     * 初次生成
     */
    firstGenerate() {
        const graphCache = this.node.graph.cache;
        const pointerDownList = graphCache.pointerDownList;
        if (pointerDownList.length < 1)
            return;
        const pointer = pointerDownList[pointerDownList.length - 1];
        // 阵列中心点
        graphCache.data[POLAR_ARRAY_INPUT_OPTION.CENTER] = pointer.point;
        this.initPolarAxis();
        this.generatePolarAxis();
        this.node.graph.cache.data['isInit'] = true;
    }
    /**
     * 撤销矩阵
     */
    undo() {
        this.node.graph.cache.primitiveList.forEach(primitive => {
            primitive.needDelete = true;
        });
        this.node.graph.cache.primitiveList = [];
    }
    /**
     * 极轴阵列
     */
    generatePolarAxis() {
        const graphCache = this.node.graph.cache;
        const storage = PythaStorage.instance;
        const center = graphCache.data[POLAR_ARRAY_INPUT_OPTION.CENTER];
        const level = graphCache.data[POLAR_ARRAY_INPUT_OPTION.LEVEL];
        const level_dist = graphCache.data[POLAR_ARRAY_INPUT_OPTION.LEVEL_DIST];
        const count = graphCache.data[POLAR_ARRAY_INPUT_OPTION.COUNT];
        const row = graphCache.data[POLAR_ARRAY_INPUT_OPTION.ROW];
        const row_dist = graphCache.data[POLAR_ARRAY_INPUT_OPTION.ROW_DIST];
        const angle = graphCache.data[POLAR_ARRAY_INPUT_OPTION.ANGLE];
        const selectPrimitives = storage.selectStore.getUnlockedPrimitives();
        const primitiveList = graphCache.primitiveList;
        const normal = storage.coordinateStore.workPlane.getNormalizeZ();
        for (const primitive of selectPrimitives) {
            // TODO 图元中心点获取
            const box = primitive.geos[0].getBoundingBox();
            const priCenter = new Vector3().addVectors(box.min, box.max).multiplyScalar(0.5);
            _dir.subVectors(priCenter, center).normalize();
            for (let z = 0; z < level; z++) {
                for (let i = 0; i < count; i++) {
                    for (let j = 0; j < row; j++) {
                        if (z === 0 && i === 0 && j === 0)
                            continue;
                        const newPrimitive = primitive.clone();
                        _vec$3.copy(_dir);
                        _vec$3.multiplyScalar(row_dist * j);
                        newPrimitive.move(_vec$3);
                        // 角度要转成弧度制
                        newPrimitive.rotate(center, normal, angle * i * Math.PI / 180);
                        _vec$3.copy(normal);
                        _vec$3.multiplyScalar(level_dist * z);
                        newPrimitive.move(_vec$3);
                        newPrimitive.temporary = true;
                        newPrimitive.needRedraw = true;
                        primitiveList.push(newPrimitive);
                        storage.primitiveStore.tempPrimitiveDict[newPrimitive.uuid] = newPrimitive;
                    }
                }
            }
        }
    }
    /**
     * 初始化极轴阵列需要的数据
     */
    initPolarAxis() {
        const graphCache = this.node.graph.cache;
        // 层数
        graphCache.data[POLAR_ARRAY_INPUT_OPTION.LEVEL] = 1;
        // 层之间的距离
        graphCache.data[POLAR_ARRAY_INPUT_OPTION.LEVEL_DIST] = 10;
        // 项目数
        graphCache.data[POLAR_ARRAY_INPUT_OPTION.COUNT] = 6;
        // 行数
        graphCache.data[POLAR_ARRAY_INPUT_OPTION.ROW] = 1;
        // 行之间的距离
        graphCache.data[POLAR_ARRAY_INPUT_OPTION.ROW_DIST] = 10;
        // 角度
        graphCache.data[POLAR_ARRAY_INPUT_OPTION.ANGLE] = 60;
    }
}
const _dir = new Vector3();
const _vec$3 = new Vector3();/**
 * 极轴阵列绘制
 */
class EventGraphPolarArray extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node3 = new EventGraphNodeSwitch(this, () => {
            if (PythaStorage.instance.selectStore.selectPrimitives.length < 1) {
                return [1];
            }
            return [0];
        });
        const node4 = new EventGraphNode(this, EventHandlerConfirm);
        const node6 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "选中图元", option: "SELECT", inputTypes: [PythaEventName.CONFIRM] }
            ] });
        const node13 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node18 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "编辑阵列", option: '', inputTypes: [PythaEventName.OPTION, PythaEventName.CONFIRM] },
                { type: NeedInputEnum.OPTION, description: "项目", option: POLAR_ARRAY_OPTION.COUNT, inputTypes: [PythaEventName.NUMBER, PythaEventName.CONFIRM] },
                { type: NeedInputEnum.OPTION, description: "项目间角度", option: POLAR_ARRAY_OPTION.ANGLE, inputTypes: [PythaEventName.NUMBER, PythaEventName.CONFIRM] },
                { type: NeedInputEnum.OPTION, description: "行数", option: POLAR_ARRAY_OPTION.ROW, inputTypes: [PythaEventName.NUMBER, PythaEventName.CONFIRM] },
                { type: NeedInputEnum.OPTION, description: "层数", option: POLAR_ARRAY_OPTION.LEVEL, inputTypes: [PythaEventName.NUMBER, PythaEventName.CONFIRM] },
                { type: NeedInputEnum.OPTION, description: "退出", option: "X" },
            ] });
        const node19 = new EventGraphNode(this, EventHandlerOptionInput);
        const node21 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: '指定阵列的中心点', option: '', inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.CONFIRM] },
            ] });
        const node22 = new EventGraphNode(this, EventHandlerCalcPolarArray);
        const node23 = new EventGraphNode(this, EventHandlerGrid);
        const node24 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node25 = new EventGraphNodeSwitch(this, () => {
            if (this.cache.inputOption === POLAR_ARRAY_OPTION.COUNT) {
                return [0];
            }
            else if (this.cache.inputOption === POLAR_ARRAY_OPTION.ANGLE) {
                return [1];
            }
            else if (this.cache.inputOption === POLAR_ARRAY_OPTION.ROW) {
                return [2];
            }
            else if (this.cache.inputOption === POLAR_ARRAY_OPTION.LEVEL) {
                return [3];
            }
            return [4];
        });
        const node26 = new EventGraphNode(this, EventHandlerNumberInput);
        const node27 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: '输入阵列中的项目数', option: POLAR_ARRAY_INPUT_OPTION.COUNT, inputTypes: [PythaEventName.NUMBER, PythaEventName.CONFIRM] },
            ] });
        const node31 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: '指定项目间的角度', option: POLAR_ARRAY_INPUT_OPTION.ANGLE, inputTypes: [PythaEventName.NUMBER, PythaEventName.CONFIRM] },
            ] });
        const node32 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: '输入行数', option: POLAR_ARRAY_INPUT_OPTION.ROW, inputTypes: [PythaEventName.NUMBER, PythaEventName.CONFIRM] },
            ] });
        const node33 = new EventGraphNode(this, EventHandlerNumberInput);
        const node35 = new EventGraphNode(this, EventHandlerCalcPolarArray);
        const node36 = new EventGraphNode(this, EventHandlerGrid);
        const node37 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node41 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: '指定行之间的距离', option: POLAR_ARRAY_INPUT_OPTION.ROW_DIST, inputTypes: [PythaEventName.NUMBER, PythaEventName.CONFIRM] },
            ] });
        const node42 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: '输入层数', option: POLAR_ARRAY_INPUT_OPTION.LEVEL, inputTypes: [PythaEventName.NUMBER, PythaEventName.CONFIRM] },
            ] });
        const node43 = new EventGraphNode(this, EventHandlerNumberInput);
        const node44 = new EventGraphNode(this, EventHandlerGrid);
        const node45 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node46 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: '指定层之间的距离', option: POLAR_ARRAY_INPUT_OPTION.LEVEL_DIST, inputTypes: [PythaEventName.NUMBER, PythaEventName.CONFIRM] },
            ] });
        const node67 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node68 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node69 = new EventGraphNode(this, EventHandlerGrid);
        const node70 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node72 = new EventGraphNode(this, EventHandlerCalcPolarArray);
        const node73 = new EventGraphNode(this, EventHandlerDisableClamp);
        const node74 = new EventGraphNode(this, EHChangePickCursor);
        const node75 = new EventGraphNode(this, EventHandlerInitCapture);
        const node76 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node77 = new EventGraphNode(this, EventHandlerCapture);
        const node78 = new EventGraphNode(this, EventHandlerConfirm);
        const node79 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node80 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node81 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node82 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node83 = new EventGraphNode(this, EventHandlerConfirm);
        const node84 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node85 = new EventGraphNode(this, EHChangeCrossCursor);
        const node86 = new EventGraphNode(this, EventHandlerCaptureClear);
        /**选中了图元*/
        this.addEdge(node3, node2);
        this.addEdge(node4, node3);
        this.addEdge(node6, node4);
        this.addEdge(node21, node13);
        this.addEdge(node13, node22);
        this.addEdge(node22, node23);
        this.addEdge(node23, node24);
        this.addEdge(node24, node18);
        this.addEdge(node18, node19);
        this.addEdge(node19, node25);
        this.addEdge(node25, node27);
        this.addEdge(node27, node26);
        this.addEdge(node33, node35);
        this.addEdge(node35, node36);
        this.addEdge(node36, node37);
        this.addEdge(node32, node33);
        this.addEdge(node31, node26);
        this.addEdge(node37, node41);
        this.addEdge(node42, node43);
        this.addEdge(node44, node45);
        this.addEdge(node45, node46);
        this.addEdge(node41, node26);
        this.addEdge(node46, node26);
        this.addEdge(node26, node22);
        this.addEdge(node69, node70);
        this.addEdge(node43, node72);
        this.addEdge(node72, node44);
        this.addEdge(node68, node69);
        this.addEdge(node1, node73);
        this.addEdge(node73, node74);
        this.addEdge(node74, node3);
        this.addEdge(node21, node75);
        this.addEdge(node75, node76);
        this.addEdge(node76, node77);
        this.addEdge(node77, node79);
        this.addEdge(node21, node78);
        this.addEdge(node78, node80);
        this.addEdge(node13, node78, EDGE_TYPE.STOP);
        this.addEdge(node81, node82);
        this.addEdge(node13, node83);
        this.addEdge(node70, node84);
        this.addEdge(node84, node67);
        this.addEdge(node83, node68);
        this.addEdge(node13, node76, EDGE_TYPE.STOP);
        this.addEdge(node2, node85);
        this.addEdge(node85, node21);
        this.addEdge(node13, node86);
        this.addEdge(node86, node81);
        /**没有选中图元*/
        this.addEdge(node3, node6);
        this.addEdge(node25, node31);
        this.addEdge(node25, node32);
        this.addEdge(node25, node42);
        this.addEdge(node25, node68);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/106
    }
}
EventGraphPolarArray.cmd = "POLARARRAY";/**
 * 阵列选项
 */
const RECT_ARRAY_OPTION = {
    ROW: "R",
    LEVEL: "L",
    COL: "C"
};
/**
 * 阵列输入对应的key
 */
const RECT_ARRAY_INPUT_OPTION = Object.assign(Object.assign({}, RECT_ARRAY_OPTION), { ROW_DIST: "R_D", LEVEL_DIST: "L_D", COL_DIST: "C_D" });
/**
 * 计算矩形阵列
 */
class EventHandlerCalRectArray extends EventHandlerBase {
    run(data) {
        const graphCache = this.node.graph.cache;
        const isInit = graphCache.data['isInit'];
        if (!isInit) {
            this.firstGenerate();
            return true;
        }
        this.calcInput();
        this.undo();
        this.generateRect();
        return true;
    }
    /**
     * 处理输入的数据，修改对应的数值
     */
    calcInput() {
        var _a;
        const graphCache = this.node.graph.cache;
        const option = (_a = graphCache.needInput) === null || _a === void 0 ? void 0 : _a.option;
        const inputNumber = graphCache.inputNumber;
        if (!inputNumber || !option || option == '')
            return;
        Object.keys(inputNumber).forEach(key => {
            graphCache.data[key] = inputNumber[key];
        });
    }
    /**
     * 初次生成
     */
    firstGenerate() {
        this.initRect();
        this.generateRect();
        this.node.graph.cache.data['isInit'] = true;
    }
    /**
     * 撤销阵列
     */
    undo() {
        this.node.graph.cache.primitiveList.forEach(primitive => {
            primitive.needDelete = true;
        });
        this.node.graph.cache.primitiveList = [];
    }
    /**
     * 初始化矩形阵列需要的数据
     */
    initRect() {
        const graphCache = this.node.graph.cache;
        // 列数
        graphCache.data[RECT_ARRAY_INPUT_OPTION.COL] = 4;
        // 列之间的距离
        graphCache.data[RECT_ARRAY_INPUT_OPTION.COL_DIST] = 10;
        // 层数
        graphCache.data[RECT_ARRAY_INPUT_OPTION.LEVEL] = 1;
        // 层之间的距离
        graphCache.data[RECT_ARRAY_INPUT_OPTION.LEVEL_DIST] = 10;
        // 行数
        graphCache.data[RECT_ARRAY_INPUT_OPTION.ROW] = 1;
        // 行之间的距离
        graphCache.data[RECT_ARRAY_INPUT_OPTION.ROW_DIST] = 10;
    }
    /**
     * 矩形阵列
     */
    generateRect() {
        const graphCache = this.node.graph.cache;
        const storage = PythaStorage.instance;
        const level = graphCache.data[RECT_ARRAY_INPUT_OPTION.LEVEL];
        const level_dist = graphCache.data[RECT_ARRAY_INPUT_OPTION.LEVEL_DIST];
        const col = graphCache.data[RECT_ARRAY_INPUT_OPTION.COL];
        const col_dist = graphCache.data[RECT_ARRAY_INPUT_OPTION.COL_DIST];
        const row = graphCache.data[RECT_ARRAY_INPUT_OPTION.ROW];
        const row_dist = graphCache.data[RECT_ARRAY_INPUT_OPTION.ROW_DIST];
        const workPlane = storage.coordinateStore.workPlane;
        const axisX = workPlane.getNormalizeX();
        const axisY = workPlane.getNormalizeY();
        const axisZ = workPlane.getNormalizeZ();
        const selectPrimitives = storage.selectStore.getUnlockedPrimitives();
        const primitiveList = graphCache.primitiveList;
        for (const primitive of selectPrimitives) {
            for (let z = 0; z < level; z++) {
                for (let i = 0; i < row; i++) {
                    for (let j = 0; j < col; j++) {
                        if (z === 0 && i === 0 && j === 0)
                            continue;
                        const newPrimitive = primitive.clone();
                        _vec$2.copy(axisX);
                        newPrimitive.move(_vec$2.multiplyScalar(col_dist * j));
                        _vec$2.copy(axisY);
                        newPrimitive.move(_vec$2.multiplyScalar(row_dist * i));
                        _vec$2.copy(axisZ);
                        newPrimitive.move(_vec$2.multiplyScalar(level_dist * z));
                        newPrimitive.temporary = true;
                        newPrimitive.needRedraw = true;
                        primitiveList.push(newPrimitive);
                        storage.primitiveStore.tempPrimitiveDict[newPrimitive.uuid] = newPrimitive;
                    }
                }
            }
        }
    }
}
const _vec$2 = new Vector3();/**
 * 矩形阵列
 */
class EventGraphRectArray extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNodeSwitch(this, () => {
            if (PythaStorage.instance.selectStore.getUnlockedPrimitives().length < 1) {
                return [0];
            }
            return [1];
        });
        const node3 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "选中图元", option: "SELECT", inputTypes: [PythaEventName.CONFIRM] }
            ] });
        const node4 = new EventGraphNode(this, EventHandlerConfirm);
        const node5 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node6 = new EventGraphNode(this, EventHandlerCalRectArray);
        const node7 = new EventGraphNode(this, EventHandlerGrid);
        const node8 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node9 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "编辑阵列", option: '', inputTypes: [PythaEventName.OPTION, PythaEventName.CONFIRM] },
                { type: NeedInputEnum.OPTION, description: "列数", option: RECT_ARRAY_INPUT_OPTION.COL },
                { type: NeedInputEnum.OPTION, description: "行数", option: RECT_ARRAY_INPUT_OPTION.ROW },
                { type: NeedInputEnum.OPTION, description: "层数", option: RECT_ARRAY_INPUT_OPTION.LEVEL },
                { type: NeedInputEnum.OPTION, description: "退出", option: "X" },
            ] });
        const node10 = new EventGraphNode(this, EventHandlerOptionInput);
        const node11 = new EventGraphNodeSwitch(this, () => {
            if (this.cache.inputOption === RECT_ARRAY_OPTION.COL) {
                return [0];
            }
            else if (this.cache.inputOption === RECT_ARRAY_OPTION.ROW) {
                return [1];
            }
            else if (this.cache.inputOption === RECT_ARRAY_OPTION.LEVEL) {
                return [2];
            }
            return [3];
        });
        const node12 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: '输入列数', option: RECT_ARRAY_INPUT_OPTION.COL, inputTypes: [PythaEventName.NUMBER] },
            ] });
        const node13 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: '输入行数', option: RECT_ARRAY_INPUT_OPTION.ROW, inputTypes: [PythaEventName.NUMBER] },
            ] });
        const node14 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: '输入层数', option: RECT_ARRAY_INPUT_OPTION.LEVEL, inputTypes: [PythaEventName.NUMBER] },
            ] });
        const node15 = new EventGraphNode(this, EventHandlerNumberInput);
        const node16 = new EventGraphNode(this, EventHandlerCalRectArray);
        const node17 = new EventGraphNode(this, EventHandlerGrid);
        const node18 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node19 = new EventGraphNode(this, EventHandlerNumberInput);
        const node20 = new EventGraphNode(this, EventHandlerCalRectArray);
        const node21 = new EventGraphNode(this, EventHandlerGrid);
        const node22 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node23 = new EventGraphNode(this, EventHandlerNumberInput);
        const node24 = new EventGraphNode(this, EventHandlerCalRectArray);
        const node25 = new EventGraphNode(this, EventHandlerGrid);
        const node26 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node27 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: '指定列之间的距离', option: RECT_ARRAY_INPUT_OPTION.COL_DIST, inputTypes: [PythaEventName.NUMBER] },
            ] });
        const node28 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: '指定行之间的距离', option: RECT_ARRAY_INPUT_OPTION.ROW_DIST, inputTypes: [PythaEventName.NUMBER] },
            ] });
        const node29 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: '指定层之间的距离', option: RECT_ARRAY_INPUT_OPTION.LEVEL_DIST, inputTypes: [PythaEventName.NUMBER] },
            ] });
        const node30 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node32 = new EventGraphNode(this, EventHandlerGrid);
        const node33 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node34 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node35 = new EventGraphNode(this, EventHandlerNumberInput);
        const node36 = new EventGraphNode(this, EventHandlerDisableClamp);
        const node37 = new EventGraphNode(this, EHChangePickCursor);
        const node38 = new EventGraphNode(this, EHChangeCrossCursor);
        const node39 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node40 = new EventGraphNode(this, null);
        const node41 = new EventGraphNode(this, EventHandlerConfirm);
        /**没有选中图元*/
        this.addEdge(node2, node3);
        this.addEdge(node3, node4);
        this.addEdge(node4, node2);
        this.addEdge(node6, node7);
        this.addEdge(node7, node8);
        this.addEdge(node8, node9);
        this.addEdge(node9, node10);
        this.addEdge(node10, node11);
        this.addEdge(node11, node12);
        this.addEdge(node12, node15);
        this.addEdge(node15, node16);
        this.addEdge(node16, node17);
        this.addEdge(node17, node18);
        this.addEdge(node13, node19);
        this.addEdge(node19, node20);
        this.addEdge(node20, node21);
        this.addEdge(node21, node22);
        this.addEdge(node14, node23);
        this.addEdge(node23, node24);
        this.addEdge(node24, node25);
        this.addEdge(node25, node26);
        this.addEdge(node26, node29);
        this.addEdge(node22, node28);
        this.addEdge(node18, node27);
        this.addEdge(node32, node33);
        this.addEdge(node29, node35);
        this.addEdge(node28, node35);
        this.addEdge(node27, node35);
        this.addEdge(node35, node6);
        this.addEdge(node30, node32);
        this.addEdge(node36, node2);
        this.addEdge(node1, node37);
        this.addEdge(node37, node36);
        this.addEdge(node5, node38);
        this.addEdge(node38, node6);
        this.addEdge(node33, node39);
        this.addEdge(node39, node34);
        this.addEdge(node40, node30);
        this.addEdge(node41, node40);
        this.addEdge(node5, node41);
        /**选中了图元*/
        this.addEdge(node2, node5);
        this.addEdge(node11, node13);
        this.addEdge(node11, node14);
        this.addEdge(node11, node40);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/107
    }
}
EventGraphRectArray.cmd = "RECTARRAY";/**
 * 路径阵列选项
 */
const PATH_ARRAY_OPTION = {
    COUNT: "C",
    LEVEL: "L",
};
/**
 * 路径阵列输入
 */
const PATH_ARRAY_INPUT_OPTION = Object.assign(Object.assign({}, PATH_ARRAY_OPTION), { LEVEL_DIST: "L_D" });
/**
 * 计算临时路径阵列
 */
class EventHandlerCalPathArray extends EventHandlerBase {
    run(data) {
        const graphCache = this.node.graph.cache;
        const isInit = graphCache.data['isInit'];
        if (!isInit) {
            this.firstGenerate();
            return true;
        }
        this.calcInput();
        this.undo();
        this.generatePath();
        return true;
    }
    /**
     * 初次生成
     */
    firstGenerate() {
        this.initRect();
        this.generatePath();
        this.node.graph.cache.data['isInit'] = true;
    }
    /**
     * 处理输入的数据，修改对应的数值
     */
    calcInput() {
        var _a;
        const graphCache = this.node.graph.cache;
        const option = (_a = graphCache.needInput) === null || _a === void 0 ? void 0 : _a.option;
        const inputNumber = graphCache.inputNumber;
        if (!inputNumber || !option || option == '')
            return;
        Object.keys(inputNumber).forEach(key => {
            graphCache.data[key] = inputNumber[key];
        });
    }
    /**
     * 撤销阵列
     */
    undo() {
        this.node.graph.cache.primitiveList.forEach(primitive => {
            primitive.needDelete = true;
        });
        this.node.graph.cache.primitiveList = [];
    }
    /**
     * 初始化矩形阵列需要的数据
     */
    initRect() {
        const graphCache = this.node.graph.cache;
        // 层数
        graphCache.data[PATH_ARRAY_INPUT_OPTION.LEVEL] = 1;
        // 层之间的距离
        graphCache.data[PATH_ARRAY_INPUT_OPTION.LEVEL_DIST] = 10;
        // 项目数
        graphCache.data[PATH_ARRAY_INPUT_OPTION.COUNT] = 5;
        // 基点
        const basePoint = graphCache.pointerDownList[graphCache.pointerDownList.length - 1];
        PythaStorage.instance.coordinateStore.workPlane.projectPoint(basePoint.point, baseVec);
        graphCache.data['basePoint'] = baseVec;
    }
    /**
     * 生成路径阵列
     */
    generatePath() {
        const graphCache = this.node.graph.cache;
        const storage = PythaStorage.instance;
        const basePoint = graphCache.data['basePoint'];
        const level = graphCache.data[PATH_ARRAY_INPUT_OPTION.LEVEL];
        const levelDist = graphCache.data[PATH_ARRAY_INPUT_OPTION.LEVEL_DIST];
        const count = graphCache.data[PATH_ARRAY_INPUT_OPTION.COUNT];
        let interval = 0;
        if (count !== 1) {
            interval = 1 / (count - 1);
        }
        const copySelects = graphCache.data['copySelects'];
        const basePrimitive = graphCache.data['baseCurve'];
        const baseCurve = basePrimitive.geos[0];
        const axisZ = baseCurve.getNormalizeZ();
        for (const primitive of copySelects) {
            for (let z = 0; z < level; z++) {
                for (let i = 0; i < count; i++) {
                    const newPrimitive = primitive.clone();
                    // 求曲线上对应的点
                    baseCurve.getPointAt(i * interval, _vec2);
                    const geo = newPrimitive.geos[0];
                    const box = geo.getBoundingBox();
                    // 记录包围盒中心点
                    _vec$1.addVectors(box.min, box.max).multiplyScalar(0.5);
                    // 先将图元移动到曲线上
                    _vec3.subVectors(_vec2, _vec$1);
                    newPrimitive.move(_vec3);
                    // 获取曲线上切线方向
                    const cutLine = baseCurve.getCutLineDir(_vec2);
                    // 获取图元x轴和切线的逆时针夹角
                    // const angle = GeoRelation.Vector3AngleTo(geo.getNormalizeX(), cutLine, axisZ);
                    // newPrimitive.rotate(_vec2, axisZ, angle);
                    // // 基点指向包围盒中心
                    // _vec3.subVectors(basePoint, _vec);
                    // 将移动后的图元向切线叉乘z轴方向偏移指定距离
                    newPrimitive.move(cutLine.cross(axisZ).multiplyScalar(_vec$1.distanceTo(basePoint)));
                    // 向z轴方向移动
                    _vec$1.copy(axisZ).multiplyScalar(z * levelDist);
                    newPrimitive.move(_vec$1);
                    newPrimitive.needRedraw = true;
                    newPrimitive.temporary = true;
                    graphCache.primitiveList.push(newPrimitive);
                    storage.primitiveStore.tempPrimitiveDict[newPrimitive.uuid] = newPrimitive;
                }
            }
        }
    }
}
const _vec$1 = new Vector3();
const _vec2 = new Vector3();
const _vec3 = new Vector3();
const baseVec = new Vector3();/**
 * 路径阵列
 */
class EventGraphPathArray extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNodeSwitch(this, () => {
            const selectPrimitives = PythaStorage.instance.selectStore.selectPrimitives;
            if (selectPrimitives.length > 0) {
                return [1];
            }
            return [0];
        });
        const node3 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "选中图元", option: "SELECT", inputTypes: [PythaEventName.CONFIRM] }
            ] });
        const node4 = new EventGraphNode(this, EventHandlerConfirm);
        const node6 = new EventGraphNode(this, EventHandlerCalPathArray);
        const node7 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node8 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node9 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定基点", option: '', inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.CONFIRM] }
            ] });
        const node10 = new EventGraphNode(this, EventHandlerGrid);
        const node11 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node12 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "编辑阵列", option: '', inputTypes: [PythaEventName.OPTION, PythaEventName.CONFIRM] },
                { type: NeedInputEnum.OPTION, description: "项目数", option: PATH_ARRAY_INPUT_OPTION.COUNT, inputTypes: [PythaEventName.NUMBER, PythaEventName.CONFIRM] },
                { type: NeedInputEnum.OPTION, description: "层数", option: PATH_ARRAY_INPUT_OPTION.LEVEL, inputTypes: [PythaEventName.NUMBER, PythaEventName.CONFIRM] },
                { type: NeedInputEnum.OPTION, description: "退出", option: "X" },
            ] });
        const node13 = new EventGraphNode(this, EventHandlerOptionInput);
        const node14 = new EventGraphNodeSwitch(this, () => {
            if (this.cache.inputOption === PATH_ARRAY_OPTION.COUNT) {
                return [0];
            }
            else if (this.cache.inputOption === PATH_ARRAY_OPTION.LEVEL) {
                return [1];
            }
            return [2];
        });
        const node15 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: '输入项目数', option: PATH_ARRAY_INPUT_OPTION.COUNT, inputTypes: [PythaEventName.NUMBER, PythaEventName.CONFIRM] },
            ] });
        const node16 = new EventGraphNode(this, EventHandlerNumberInput);
        const node21 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: '输入层数', option: PATH_ARRAY_INPUT_OPTION.LEVEL, inputTypes: [PythaEventName.NUMBER, PythaEventName.CONFIRM] },
            ] });
        const node22 = new EventGraphNode(this, EventHandlerNumberInput);
        const node23 = new EventGraphNode(this, EventHandlerCalPathArray);
        const node24 = new EventGraphNode(this, EventHandlerGrid);
        const node25 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node26 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: '指定层之间距离', option: PATH_ARRAY_INPUT_OPTION.LEVEL_DIST, inputTypes: [PythaEventName.NUMBER, PythaEventName.CONFIRM] },
            ] });
        const node27 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node28 = new EventGraphNode(this, EventHandlerGrid);
        const node29 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node30 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node31 = new EventGraphNode(this, EventHandlerNumberInput);
        const node32 = new EventGraphNode(this, EventHandlerConfirm);
        const node33 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "至少选择一条基准曲线", option: "SELECT2", inputTypes: [PythaEventName.CONFIRM] }
            ] });
        const node34 = new EventGraphNodeSwitch(this, () => {
            const storage = PythaStorage.instance;
            const primitives = storage.selectStore.selectPrimitives;
            const graphCache = this.cache;
            const copySelects = graphCache.data["copySelects"];
            // 留下copySelects中uuid不存在的图元
            const newSelects = [];
            primitives.filter(p => {
                if (!copySelects.find(c => c.uuid === p.uuid)) {
                    newSelects.push(p);
                }
            });
            if (newSelects.length === 1 && newSelects[0].geos[0] instanceof Curve) {
                graphCache.data['baseCurve'] = newSelects[0];
                return [1];
            }
            // 清空新的选择
            newSelects.forEach(c => {
                c.isSelected = false;
                c.needRedraw = true;
            });
            return [0];
        });
        const node35 = new EventGraphNode(this, EventHandlerCopySelect);
        const node37 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node38 = new EventGraphNode(this, EventHandlerDisableClamp);
        const node39 = new EventGraphNode(this, EHChangePickCursor);
        const node40 = new EventGraphNode(this, EHChangeCrossCursor);
        const node41 = new EventGraphNode(this, EventHandlerConfirm);
        const node42 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node43 = new EventGraphNode(this, EventHandlerConfirm);
        const node44 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node45 = new EventGraphNode(this, EventHandlerInitCapture);
        const node46 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node47 = new EventGraphNode(this, EventHandlerGrid);
        const node48 = new EventGraphNode(this, EventHandlerCapture);
        const node49 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node50 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node51 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node52 = new EventGraphNode(this, EventHandlerCaptureClear);
        /**没有选中图元*/
        this.addEdge(node2, node3);
        this.addEdge(node4, node2);
        this.addEdge(node9, node8);
        this.addEdge(node8, node6);
        this.addEdge(node6, node10);
        this.addEdge(node10, node11);
        this.addEdge(node11, node12);
        this.addEdge(node12, node13);
        this.addEdge(node13, node14);
        /**输入项目数*/
        this.addEdge(node14, node15);
        this.addEdge(node15, node16);
        this.addEdge(node21, node22);
        this.addEdge(node22, node23);
        this.addEdge(node23, node24);
        this.addEdge(node24, node25);
        this.addEdge(node25, node26);
        this.addEdge(node27, node28);
        this.addEdge(node28, node29);
        this.addEdge(node26, node31);
        this.addEdge(node16, node6);
        this.addEdge(node31, node6);
        this.addEdge(node3, node4);
        this.addEdge(node33, node32);
        this.addEdge(node32, node34);
        this.addEdge(node35, node33);
        this.addEdge(node37, node33);
        this.addEdge(node38, node2);
        this.addEdge(node1, node39);
        this.addEdge(node39, node38);
        this.addEdge(node7, node40);
        this.addEdge(node40, node9);
        this.addEdge(node9, node41);
        this.addEdge(node41, node42);
        this.addEdge(node29, node44);
        this.addEdge(node44, node30);
        this.addEdge(node34, node47);
        this.addEdge(node47, node37);
        this.addEdge(node9, node45);
        this.addEdge(node45, node46);
        this.addEdge(node46, node48);
        this.addEdge(node8, node41, EDGE_TYPE.STOP);
        this.addEdge(node8, node46, EDGE_TYPE.STOP);
        this.addEdge(node6, node43);
        this.addEdge(node43, node27);
        this.addEdge(node48, node49);
        this.addEdge(node50, node51);
        this.addEdge(node8, node52);
        this.addEdge(node52, node50);
        /**输入层数*/
        this.addEdge(node14, node21);
        /**新选中了一条曲线*/
        this.addEdge(node34, node7);
        /**选中了图元*/
        this.addEdge(node2, node35);
        /**退出*/
        this.addEdge(node14, node27);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/109
    }
}
EventGraphPathArray.cmd = "PATHARRAY";/**
 * 处理差集
 */
class EventHandlerSubtract extends EventHandlerBase {
    constructor() {
        super(...arguments);
        this._vec = new Vector3(); // 临时变量 减少瞬时内存开销
        this.primitives = [];
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        let selectPrimitives = PythaStorage.instance.selectStore.getUnlockedPrimitives();
        if (selectPrimitives.length < 2)
            return false;
        //主图元（用leftPrimitive来减去其他图元）
        let leftPrimitive = selectPrimitives[0];
        //判断图元类型是否一致，需要都是面图元或者体图元才能做布尔操作
        if (leftPrimitive.isRegion()) {
            for (let i = 1; i < selectPrimitives.length; i++) {
                if (!selectPrimitives[i].isRegion()) {
                    this.node.graph.eventMediator.noticeHandler.notice(this.node.graph.eventMediator, { "cmd": "Notice", "data": "所选图元类型不一致" });
                    return true;
                }
            }
        }
        if (leftPrimitive.isSolid()) {
            for (let i = 1; i < selectPrimitives.length; i++) {
                if (!selectPrimitives[i].isSolid()) {
                    this.node.graph.eventMediator.noticeHandler.notice(this.node.graph.eventMediator, { "cmd": "Notice", "data": "所选图元类型不一致" });
                    return true;
                }
            }
        }
        if (this.node.graph.cache.deletePrimitiveList == null) {
            this.node.graph.cache.deletePrimitiveList = [];
        }
        //将图元标记为需要被删除
        this.node.graph.cache.deletePrimitiveList.push(leftPrimitive);
        //右侧图元
        let rightPrimitive;
        if (selectPrimitives.length === 2) {
            rightPrimitive = selectPrimitives[1];
            this.node.graph.cache.deletePrimitiveList.push(rightPrimitive);
        }
        else {
            for (let i = 1; i < selectPrimitives.length; i++) {
                this.node.graph.cache.deletePrimitiveList.push(selectPrimitives[i]);
                //todo;
            }
        }
        let primitiveNew = new Primitive("GeneralSolid");
        primitiveNew.leftPrimitive = leftPrimitive;
        primitiveNew.rightPrimitive = rightPrimitive;
        primitiveNew.boolOpe = BoolOpeType.SUBSTRACT;
        primitiveNew.needRedraw = true;
        let keys = Object.keys(primitiveNew.renderItemDict);
        if (keys.length > 0) {
            primitiveNew.renderItemDict[keys[0]].geoElements = [];
            primitiveNew.renderItemDict[keys[0]].geoElements.push(0);
        }
        if (this.node.graph.cache.primitiveList == null) {
            this.node.graph.cache.primitiveList = [];
        }
        this.node.graph.cache.primitiveList.push(primitiveNew);
        return true;
    }
    /**
     * 销毁
     */
    dispose() {
        for (let pri of this.primitives) {
            pri.needDelete = true;
        }
    }
}/**
 * 布尔操作差集
 */
class EventGraphSubstract extends EventGraphBase {
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerConfirm);
        const node11 = new EventGraphNode(this, EventHandlerSubtract);
        const node14 = new EventGraphNode(this, EventHandlerGrid);
        const node15 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node18 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '选择至少两个图元' });
        const node21 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node23 = new EventGraphNodeSwitch(this, () => {
            let selectPrimitives = PythaStorage.instance.selectStore.getUnlockedPrimitives();
            if (selectPrimitives.length < 1) {
                return [0];
            }
            return [1];
        });
        const node29 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node31 = new EventGraphNode(this, EventHandlerDisableClamp);
        const node32 = new EventGraphNode(this, EHChangePickCursor);
        const node33 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '图元选择不足' });
        const node34 = new EventGraphNodeSwitch(this, () => {
            let selectPrimitives = PythaStorage.instance.selectStore.getUnlockedPrimitives();
            if (selectPrimitives.length < 1) {
                return [0];
            }
            return [1];
        });
        const node35 = new EventGraphNode(this, EventHandlerGenAndDeletePrimitives);
        this.addEdge(node14, node21);
        this.addEdge(node29, node14);
        this.addEdge(node21, node15);
        this.addEdge(node1, node31);
        this.addEdge(node31, node23);
        this.addEdge(node23, node18);
        this.addEdge(node18, node32);
        this.addEdge(node32, node2);
        this.addEdge(node2, node34);
        this.addEdge(node34, node33);
        this.addEdge(node33, node15);
        this.addEdge(node11, node35);
        this.addEdge(node35, node29);
        this.addEdge(node34, node11);
        this.addEdge(node23, node11);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/114
    }
}
/**
 * 指令 用于注册事件图
 */
EventGraphSubstract.cmd = 'SUBSTRACT';class EventGraphGenVector3 extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node3 = new EventGraphNode(this, EventHandlerInitCapture);
        const node4 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node5 = new EventGraphNode(this, EventHandlerCapture);
        const node6 = new EventGraphNode(this, EventHandlerConfirm);
        const node7 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node8 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node9 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node11 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                    type: NeedInputEnum.ACTIVE,
                    description: "指定第一个点",
                    option: 'S',
                    inputTypes: [PythaEventName.POINTER_DOWN]
                }]
        });
        const node12 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                    type: NeedInputEnum.ACTIVE,
                    description: "指定第二个点",
                    option: 'S',
                    inputTypes: [PythaEventName.POINTER_DOWN]
                }]
        });
        const node13 = new EventGraphNode(this, EHChangeCrossCursor);
        const node15 = new EventGraphNode(this, EventHandlerHelpLine);
        const node16 = new EventGraphNode(this, EventHandlerGenVector3);
        const node17 = new EventGraphNodeAND(this, null);
        this.addEdge(node1, node13);
        this.addEdge(node13, node2);
        this.addEdge(node2, node3);
        this.addEdge(node3, node4);
        this.addEdge(node4, node5);
        this.addEdge(node5, node17);
        this.addEdge(node17, node15);
        this.addEdge(node1, node11);
        this.addEdge(node11, node8);
        this.addEdge(node8, node17);
        this.addEdge(node8, node12);
        this.addEdge(node12, node9);
        this.addEdge(node1, node6);
        this.addEdge(node6, node7);
        this.addEdge(node16, node7);
        this.addEdge(node9, node16);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/124
    }
}
/**
 * genvector3指令 保存向量视图
 */
EventGraphGenVector3.cmd = 'GENVECTOR3';/**
 * 生成点
 */
class EventHandlerGenPoint extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a;
        // 获取存储
        const storage = PythaStorage.instance;
        //获得pointdown或者pointmove
        let currentPoint;
        if (!!this.node.graph.cache.data['isPointDown'] && this.node.graph.cache.pointerDownList.length > 0) {
            // 按下点或输入点
            currentPoint = this.node.graph.cache.pointerDownList[this.node.graph.cache.pointerDownList.length - 1].point;
            this.node.graph.cache.data['isPointDown'] = false;
        }
        else {
            return false;
        }
        let primitive = new Primitive("Point");
        primitive.move(currentPoint);
        let keys = Object.keys(primitive.renderItemDict);
        if (keys.length > 0) {
            let renderItem = primitive.renderItemDict[keys[0]];
            renderItem.renderType = RenderItemType.POINT;
            (_a = renderItem.mat) === null || _a === void 0 ? void 0 : _a.color.set(storage.layerStore.getColor());
        }
        // 执行命令
        const cmd = new AddPrimitiveCmd([primitive], this.node.graph.eventMediator);
        storage.historyStore.undos.push(cmd);
        cmd.execute();
        return true;
    }
    /**
     * 销毁
     */
    dispose() {
        // this.primitive.needDelete = true;
    }
}/**
 * 绘制点
 */
class EventGraphPoint extends EventGraphBase {
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node3 = new EventGraphNode(this, EventHandlerInitCapture);
        const node4 = new EventGraphNode(this, EHChangeCrossCursor);
        const node5 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定点", option: 'P', inputTypes: [PythaEventName.POINTER_DOWN] }
            ] });
        const node6 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node7 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node8 = new EventGraphNode(this, EventHandlerCapture);
        const node9 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        const node10 = new EventGraphNode(this, EventHandlerConfirm);
        const node11 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node12 = new EventGraphNode(this, EventHandlerGenPoint);
        const node13 = new EventGraphNode(this, EventHandlerGrid);
        const node14 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node15 = new EventGraphNodeRender(this, true, UpdateType.MAIN);
        this.addEdge(node1, node2);
        this.addEdge(node2, node3);
        this.addEdge(node2, node4);
        this.addEdge(node4, node5);
        this.addEdge(node5, node6);
        this.addEdge(node6, node12);
        this.addEdge(node14, node13);
        this.addEdge(node13, node15);
        this.addEdge(node2, node10);
        this.addEdge(node10, node11);
        this.addEdge(node3, node7);
        this.addEdge(node7, node8);
        this.addEdge(node8, node9);
        this.addEdge(node15, node5);
        this.addEdge(node12, node14);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/127
    }
}
/**
 * Point指令 用于注册事件图
 */
EventGraphPoint.cmd = 'POINT';/**
 * 显示选中图元，隐藏其他图元；或者隐藏显示图元，显示其他图元
 * 在执行之前，先获取当前所有图元的显示与隐藏状态；再根据选中的图元，把选中图元的状态设置为显示/隐藏，其余设置为隐藏/显示
 */
class ShowAndHiddenOtherCmd extends CommandBase {
    /**
     * 构造函数
     * @param primitives
     * @param eventMediator
     * @param needHidden 是否需要隐藏
     */
    constructor(primitives, eventMediator, needHidden = true) {
        super();
        /**
         * 旧的显示状态
         */
        this.oldShowStatusList = {};
        /**
         * 新的显示状态
         */
        this.newShowStatusList = {};
        //通过中介获取图元
        this.eventMediator = eventMediator;
        const primitiveDict = this.eventMediator.storage.primitiveStore.primitiveDict;
        //生成旧的显示隐藏状态，初始化新的隐藏状态，全部默认隐藏
        Object.keys(primitiveDict).forEach(key => {
            if (primitiveDict[key] != null) {
                this.oldShowStatusList[key] = primitiveDict[key].hidden;
                this.newShowStatusList[key] = !needHidden;
            }
        });
        //遍历新的图元，将选中的图元设置为显示/隐藏
        primitives.forEach(primitive => {
            if (this.newShowStatusList.hasOwnProperty(primitive.uuid)) {
                this.newShowStatusList[primitive.uuid] = needHidden;
            }
        });
    }
    /**
     * 撤销
     */
    undo() {
        const primitiveDict = this.eventMediator.storage.primitiveStore.primitiveDict;
        Object.keys(this.oldShowStatusList).forEach(key => {
            primitiveDict[key].hidden = this.oldShowStatusList[key];
        });
    }
    /**
     * 执行
     */
    execute() {
        const primitiveDict = this.eventMediator.storage.primitiveStore.primitiveDict;
        Object.keys(this.newShowStatusList).forEach(key => {
            primitiveDict[key].hidden = this.newShowStatusList[key];
        });
    }
}/**
 * 仅显示选中的图元
 */
class EventHandlerShowSelected extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        const storage = this.getPythaStorage();
        let selectPrimitives = storage.selectStore.selectPrimitives;
        if (selectPrimitives.length <= 0)
            return true; //没有选中的图元，直接结束，不做任何操作
        const graphCache = this.node.graph.cache;
        const commandGroup = graphCache.data['commandGroup'];
        const groupExist = commandGroup && commandGroup instanceof CommandGroup;
        const cmd = new ShowAndHiddenOtherCmd(selectPrimitives, this.node.graph.eventMediator, false);
        if (!groupExist) {
            storage.historyStore.undos.push(cmd);
            cmd.execute();
        }
        else {
            commandGroup.addCmd(cmd);
        }
        return true;
    }
}class EventGraphShowSelected extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node3 = new EventGraphNode(this, EventHandlerShowSelected);
        const node5 = new EventGraphNodeSwitch(this, () => {
            if (PythaStorage.instance.selectStore.selectPrimitives.length != 0)
                return [0];
            return [1];
        });
        const node7 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        const node11 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node12 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        this.addEdge(node1, node5);
        /**选中图元*/
        this.addEdge(node5, node3);
        this.addEdge(node3, node7);
        this.addEdge(node7, node12);
        this.addEdge(node12, node11);
        /**未选中图元*/
        this.addEdge(node5, node11);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/49
    }
}
/**
 * 显示选中的图元 用于注册事件图
 */
EventGraphShowSelected.cmd = 'SHOW_SELECTED';/**
 * 显隐选中图元（仅改变选中图元的显隐状态，不对其他图元进行操作）
 * 默认为隐藏选中图元，可通过needHidden进行控制
 */
class ShowPrimitiveCmd extends CommandBase {
    /**
     * 构造函数
     * @param primitives
     * @param eventMediator
     * @param needHidden 是否需要显示
     */
    constructor(primitives, eventMediator, needHidden = true) {
        super();
        /**
         * 旧的显示状态
         */
        this.oldShowStatusList = {};
        /**
         * 新的显示状态
         */
        this.newShowStatusList = {};
        //通过中介获取图元
        this.eventMediator = eventMediator;
        const primitiveDict = this.eventMediator.storage.primitiveStore.primitiveDict;
        //生成旧的显示隐藏状态，与新的显示隐藏状态
        Object.keys(primitiveDict).forEach(key => {
            if (primitiveDict[key] != null) {
                this.oldShowStatusList[key] = primitiveDict[key].hidden;
                this.newShowStatusList[key] = primitiveDict[key].hidden;
            }
        });
        //遍历新的图元，将选中的图元设置为显示/隐藏
        primitives.forEach(primitive => {
            if (this.newShowStatusList.hasOwnProperty(primitive.uuid)) {
                this.newShowStatusList[primitive.uuid] = needHidden;
            }
        });
    }
    /**
     * 撤销
     */
    undo() {
        const primitiveDict = this.eventMediator.storage.primitiveStore.primitiveDict;
        Object.keys(this.oldShowStatusList).forEach(key => {
            primitiveDict[key].hidden = this.oldShowStatusList[key];
        });
    }
    /**
     * 执行
     */
    execute() {
        const primitiveDict = this.eventMediator.storage.primitiveStore.primitiveDict;
        Object.keys(this.newShowStatusList).forEach(key => {
            primitiveDict[key].hidden = this.newShowStatusList[key];
        });
    }
}/**
 * 隐藏选中的图元
 */
class EventHandlerHiddenSelected extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        const storage = this.getPythaStorage();
        let selectPrimitives = storage.selectStore.selectPrimitives;
        if (selectPrimitives.length <= 0)
            return true; //没有选中的图元，直接结束，不做任何操作
        const graphCache = this.node.graph.cache;
        const commandGroup = graphCache.data['commandGroup'];
        const groupExist = commandGroup && commandGroup instanceof CommandGroup;
        const cmd = new ShowPrimitiveCmd(selectPrimitives, this.node.graph.eventMediator);
        if (!groupExist) {
            storage.historyStore.undos.push(cmd);
            cmd.execute();
        }
        else {
            commandGroup.addCmd(cmd);
        }
        return true;
    }
}class EventGraphHiddenSelected extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node3 = new EventGraphNode(this, EventHandlerHiddenSelected);
        const node5 = new EventGraphNodeSwitch(this, () => {
            if (PythaStorage.instance.selectStore.selectPrimitives.length != 0)
                return [0];
            return [1];
        });
        const node7 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        const node11 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node12 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        this.addEdge(node1, node5);
        this.addEdge(node5, node3);
        this.addEdge(node3, node7);
        this.addEdge(node7, node12);
        this.addEdge(node12, node11);
        this.addEdge(node5, node11);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/51
    }
}
/**
 * 显示选中的图元 用于注册事件图
 */
EventGraphHiddenSelected.cmd = 'HIDDEN_SELECTED';/**
 * 显隐全部图元
 * 默认为隐藏全部图元，可通过needHidden进行控制
 */
class ShowAllPrimitiveCmd extends CommandBase {
    /**
     * 构造函数
     * @param primitives
     * @param eventMediator
     * @param needHidden 是否需要显示
     */
    constructor(eventMediator, needHidden = true) {
        super();
        /**
         * 旧的显示状态
         */
        this.oldShowStatusList = {};
        //通过中介获取图元
        this.eventMediator = eventMediator;
        const primitiveDict = this.eventMediator.storage.primitiveStore.primitiveDict;
        this.needHidden = needHidden;
        //生成旧的显示隐藏状态
        Object.keys(primitiveDict).forEach(key => {
            if (primitiveDict[key] != null) {
                this.oldShowStatusList[key] = primitiveDict[key].hidden;
            }
        });
    }
    /**
     * 撤销
     */
    undo() {
        const primitiveDict = this.eventMediator.storage.primitiveStore.primitiveDict;
        Object.keys(this.oldShowStatusList).forEach(key => {
            if (primitiveDict[key] != null) {
                primitiveDict[key].hidden = this.oldShowStatusList[key];
            }
        });
    }
    /**
     * 执行
     */
    execute() {
        const primitiveDict = this.eventMediator.storage.primitiveStore.primitiveDict;
        Object.keys(primitiveDict).forEach(key => {
            if (primitiveDict[key] != null) {
                primitiveDict[key].hidden = this.needHidden;
            }
        });
        // console.log( Object.keys(primitiveDict).map(key => `${primitiveDict[key].uuid}-${primitiveDict[key].hidden}`));
    }
}/**
 * 仅显示选中的图元
 */
class EventHandlerShowAllPri extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        const storage = this.getPythaStorage();
        const graphCache = this.node.graph.cache;
        const commandGroup = graphCache.data['commandGroup'];
        const groupExist = commandGroup && commandGroup instanceof CommandGroup;
        const cmd = new ShowAllPrimitiveCmd(this.node.graph.eventMediator, false);
        if (!groupExist) {
            storage.historyStore.undos.push(cmd);
            cmd.execute();
        }
        else {
            commandGroup.addCmd(cmd);
        }
        return true;
    }
}class EventGraphShowAll extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerShowAllPri);
        const node3 = new EventGraphNodeRender(this, true, UpdateType.MAIN);
        const node6 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node7 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node8 = new EventGraphNode(this, EventHandlerGrid);
        this.addEdge(node1, node2);
        this.addEdge(node3, node7);
        this.addEdge(node7, node6);
        this.addEdge(node2, node8);
        this.addEdge(node8, node3);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/45
    }
}
/**
 * 显示所有图元 用于注册事件图
 */
EventGraphShowAll.cmd = 'SHOW_ALL';/**
 * 创建块模板
 */
class AddGroupCmd extends CommandBase {
    /**
     * 构造函数
     * @param primitives
     * @param eventMediator
     */
    constructor(primitives, group, eventMediator) {
        super();
        this.primitives = [];
        this.eventMediator = eventMediator;
        this.primitives = [...primitives];
        this.group = group;
    }
    /**
     * 执行
     */
    execute() {
        const storage = PythaStorage.instance;
        // const primitiveDict = storage.primitiveStore.primitiveDict;
        storage.groupStore.groupDict[this.group.uuid] = this.group;
        for (let pri of this.primitives) {
            pri.group.push(this.group.uuid);
        }
        this.eventMediator.noticeHandler.notice(this, new PythaEventDataChange({
            add_group: this.group,
            add_primitives: this.primitives
        }));
    }
    /**
     * 撤销
     */
    undo() {
        const storage = PythaStorage.instance;
        delete storage.groupStore.groupDict[this.group.uuid];
        for (let pri of this.primitives) {
            pri.group = pri.group.filter(item => item != this.group.uuid);
        }
        this.eventMediator.noticeHandler.notice(this, new PythaEventDataChange({
            delete_group: this.group,
            add_primitives: this.primitives
        }));
    }
}/**
 * 生成组
 */
class EventHandlerGenGroup extends EventHandlerBase {
    run() {
        const storage = this.getPythaStorage();
        // 名称
        let name = this.node.graph.cache.data['text'];
        // 选择的图元
        let selectedPrimitives = storage.selectStore.getUnlockedPrimitives() || [];
        let group = {
            uuid: BaseUtils.genUUID(),
            name: name
        };
        const cmd = new AddGroupCmd(selectedPrimitives, group, this.node.graph.eventMediator);
        storage.historyStore.undos.push(cmd);
        cmd.execute();
        return true;
    }
}/**
 * 组
 */
class EventGraphGroup extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNodeSwitch(this, () => {
            const storage = this.eventMediator.storage;
            if (storage.selectStore.getUnlockedPrimitives().length <= 0) {
                return [0];
            }
            return [1];
        });
        const node3 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '请选择对象' });
        const node4 = new EventGraphNode(this, EHChangePickCursor);
        const node5 = new EventGraphNode(this, EventHandlerConfirm);
        const node6 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node7 = new EventGraphNode(this, EventHandlerDisableClamp);
        const node8 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "命名组", option: 'TEXT', inputTypes: [PythaEventName.TEXT] },
            ] });
        const node10 = new EventGraphNode(this, EventHandlerTextInput);
        const node12 = new EventGraphNode(this, EventHandlerGenGroup);
        const node13 = new EventGraphNode(this, EventHandlerCmdEnd);
        this.addEdge(node1, node2);
        this.addEdge(node2, node3);
        this.addEdge(node3, node4);
        this.addEdge(node4, node5);
        this.addEdge(node5, node2);
        this.addEdge(node6, node7);
        this.addEdge(node7, node8);
        this.addEdge(node10, node12);
        this.addEdge(node12, node13);
        this.addEdge(node8, node10);
        this.addEdge(node2, node6);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/140
    }
}
/**
 * GROUP指令
 */
EventGraphGroup.cmd = 'GROUP';/**
 * 强制选中或取消选中
 * 参数：{
 *  key:SETTING_KEY.FORCE_SELECT
 *  value: {
 *      needSelectUuidList: string[]
 *      needCancelSelectUuidList: string[]
 *  }
 * }
 */
class EventHandlerForceSelect extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventSetting();
        this.needEventOnce = false;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(event) {
        if (event.cmd != this.needEvent.cmd)
            return false; // 如果传入事件不符 则不执行处理器
        // 获得存储
        const storage = PythaStorage.instance;
        if (event.data.key != SETTING_KEY.FORCE_SELECT) {
            return false;
        }
        let selectObejct = event.data.value;
        let needSelectUuidList = selectObejct.needSelectUuidList || []; // 需要选中的uuid列表
        let needCancelSelectUuidList = selectObejct.needCancelSelectUuidList || []; // 需要取消选中的uuid列表
        let priList = [...storage.selectStore.selectPrimitives || []];
        needSelectUuidList === null || needSelectUuidList === void 0 ? void 0 : needSelectUuidList.forEach(uuid => {
            let entity = storage.primitiveStore.primitiveDict[uuid];
            if (entity) {
                entity.isSelected = true;
                entity.needRedraw = true;
                priList.push(entity);
            }
        });
        needCancelSelectUuidList === null || needCancelSelectUuidList === void 0 ? void 0 : needCancelSelectUuidList.forEach(uuid => {
            let entity = storage.primitiveStore.primitiveDict[uuid];
            if (entity) {
                entity.isSelected = false;
                entity.needRedraw = true;
                let idx = priList === null || priList === void 0 ? void 0 : priList.findIndex(item => item.uuid === uuid);
                if (idx !== -1) {
                    priList.splice(idx, 1);
                }
            }
        });
        storage.selectStore.selectPrimitives = priList;
        return true;
    }
}/**
 * 修改选择状态
 */
class EventGraphForceSelect extends EventGraphBase {
    constructor() {
        super(...arguments);
        /**
         * 是否是常驻图
         */
        this.isAlwaysActive = true;
    }
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node4 = new EventGraphNode(this, EventHandlerForceSelect);
        const node5 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node7 = new EventGraphNode(this, EventHandlerGrid);
        this.addEdge(node4, node7);
        this.addEdge(node7, node5);
        this.addEdge(node1, node4);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/144
    }
    end() {
        this.cache.data = {};
        this.head.run();
    }
}
/**
 * 修改选择状态 用于注册事件图
 */
EventGraphForceSelect.cmd = 'FORCESELECT';/**
 * 返回拾取点
 */
class EventHandlerPickPoint extends EventHandlerBase {
    run(data) {
        const graphCache = this.node.graph.cache;
        const pointerDownList = graphCache.pointerDownList;
        const point = pointerDownList[pointerDownList.length - 1].point;
        const eventMediator = this.node.graph.eventMediator;
        eventMediator.noticeHandler.notice(this.node, new PythaEventDataChange({ point: point }));
        return true;
    }
}/**
 * 拾取一个点坐标
 */
class EventGraphPickPoint extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node3 = new EventGraphNode(this, null);
        const node4 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '拾取点，右键确认' });
        const node5 = new EventGraphNode(this, EventHandlerConfirm);
        const node6 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node7 = new EventGraphNode(this, EventHandlerPickPoint);
        const node8 = new EventGraphNode(this, EHChangeCrossCursor);
        const node9 = new EventGraphNode(this, EventHandlerInitCapture);
        const node10 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node11 = new EventGraphNode(this, EventHandlerCapture);
        const node12 = new EventGraphNode(this, EventHandlerDisableSelect);
        this.addEdge(node2, node3);
        this.addEdge(node3, node2);
        this.addEdge(node1, node8);
        this.addEdge(node1, node5);
        this.addEdge(node5, node7);
        this.addEdge(node7, node6);
        this.addEdge(node9, node10);
        this.addEdge(node10, node11);
        this.addEdge(node4, node2);
        this.addEdge(node4, node10);
        this.addEdge(node8, node12);
        this.addEdge(node12, node9);
        this.addEdge(node12, node4);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/150
    }
}
EventGraphPickPoint.cmd = "PICK_POINT";/**
 * 存储缓存变量，告知需要生成矩形边线，不是面
 */
class EventHandlerUpdateRectRes extends EventHandlerBase {
    run(data) {
        this.node.graph.cache.data['is_line'] = true;
        return true;
    }
}/**
 * 生成边线矩形
 */
class EventGraphRectangleLine extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node3 = new EventGraphNode(this, EventHandlerConfirm);
        const node4 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node5 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node6 = new EventGraphNode(this, EventHandlerCapture);
        const node7 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node8 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node9 = new EventGraphNode(this, EventHandlerCalTempRectangle);
        const node10 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node13 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node14 = new EventGraphNodeRender(this, true, UpdateType.MAIN);
        const node20 = new EventGraphNodeAND(this, null);
        const node21 = new EventGraphNodeNotice(this, new PythaEventNeedInput([{ type: NeedInputEnum.ACTIVE, description: "指定另一个角点", option: 'E', inputTypes: [PythaEventName.POINTER_DOWN] },]));
        const node22 = new EventGraphNodeNotice(this, new PythaEventNeedInput([{ type: NeedInputEnum.ACTIVE, description: "指定第一个角点", option: 'S', inputTypes: [PythaEventName.POINTER_DOWN] },]));
        const node23 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node24 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node25 = new EventGraphNode(this, EventHandlerGrid);
        const node26 = new EventGraphNode(this, EventHandlerGrid);
        const node27 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node28 = new EventGraphNode(this, EventHandlerInitCapture);
        const node29 = new EventGraphNode(this, EHChangeCrossCursor);
        const node30 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node31 = new EventGraphNode(this, EventHandlerUpdateRectRes);
        this.addEdge(node1, node31);
        this.addEdge(node31, node4);
        this.addEdge(node31, node3);
        this.addEdge(node8, node9);
        this.addEdge(node5, node6);
        this.addEdge(node6, node20);
        this.addEdge(node7, node20);
        this.addEdge(node20, node8);
        this.addEdge(node7, node21);
        this.addEdge(node3, node23);
        this.addEdge(node25, node14);
        this.addEdge(node9, node26);
        this.addEdge(node26, node13);
        this.addEdge(node10, node24);
        this.addEdge(node4, node27);
        this.addEdge(node27, node28);
        this.addEdge(node28, node5);
        this.addEdge(node4, node29);
        this.addEdge(node24, node30);
        this.addEdge(node30, node25);
        this.addEdge(node14, node23);
        this.addEdge(node21, node10);
        this.addEdge(node29, node22);
        this.addEdge(node22, node7);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/151
    }
}
EventGraphRectangleLine.cmd = "RECTANGLE_LINE";const CameraPerspectiveType = {
    UP: 1, // 上 pabcd
    DOWN: 2, // 下 pefgh
    LEFT: 3, // 左 pcdhg
    RIGHT: 4, // 右 pabfe
    FRONT: 5, // 前 pbcgf
    BACK: 6, // 后 pdaeh
};/**
 * 计算相机缩放
 */
class EventHandlerChangeCameraPerspective extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventSetting();
        this.needEventOnce = false;
    }
    run(event) {
        if (event.cmd != this.needEvent.cmd)
            return false; // 如果传入事件不符 则不执行处理器
        // 获得存储
        if (event.data.key != SETTING_KEY.CAMERA_PERSPECTIVE) {
            return false;
        }
        let value = event.data.value;
        const storage = this.getPythaStorage();
        const viewItem = storage.viewportStore.viewportItems[storage.viewportStore.currentViewportKey];
        const camera = viewItem.camera; // 相机
        const target = viewItem.target; // 相机目视点
        _offset.copy(camera.position).sub(target).normalize();
        let ucs = storage.coordinateStore.activeUcs; // 当前坐标
        let element = ucs.elements;
        let workPlane = storage.coordinateStore.workPlane; // 当前坐标系
        _ucsX.set(element[0], element[1], element[2]);
        _ucsY.set(element[4], element[5], element[6]);
        _ucsZ.set(element[8], element[9], element[10]);
        _ucsP.set(element[12], element[13], element[14]);
        _posX.copy(_ucsX);
        _posY.copy(_ucsY);
        _negX.copy(_ucsX).multiplyScalar(-1);
        _negY.copy(_ucsY).multiplyScalar(-1);
        _px = Math.abs(_offset.angleTo(_posX));
        _py = Math.abs(_offset.angleTo(_posY));
        _nx = Math.abs(_offset.angleTo(_negX));
        _ny = Math.abs(_offset.angleTo(_negY));
        // camera.up.set(0, 0, 1);
        if (value === CameraPerspectiveType.UP) { // 上
            // if ((Math.abs(_px - _py) < 1e-6) && (Math.abs(_px - _ny) < 1e-6)) {
            //     return true;
            // }
            _targetPosition.copy(_ucsZ).normalize();
            camera.up.set(0, 1, 0);
            if (_px <= _py && _px <= _nx && _px <= _ny) {
                // posX
                _targetQuaternion.setFromAxisAngle(_ucsZ, Math.PI / 2);
            }
            else if (_py <= _px && _py <= _nx && _py <= _ny) {
                // posY
                _targetQuaternion.setFromAxisAngle(_ucsZ, Math.PI);
            }
            else if (_nx <= _px && _nx <= _py && _nx <= _ny) {
                // negX
                _targetQuaternion.setFromAxisAngle(_ucsZ, -Math.PI / 2);
            }
            else if (_ny <= _px && _ny <= _py && _ny <= _nx) {
                // negY
                _targetQuaternion.setFromAxisAngle(_ucsZ, 0);
            }
            workPlane.setFromNormalAndCoplanarPoint(_ucsZ, _ucsP);
        }
        else if (value === CameraPerspectiveType.FRONT) { // 前
            _targetPosition.copy(_ucsY).multiplyScalar(-1);
            _targetQuaternion.setFromAxisAngle(_ucsX, Math.PI * 0.5);
            workPlane.setFromNormalAndCoplanarPoint(_targetPosition, _ucsP);
        }
        else if (value === CameraPerspectiveType.LEFT) { // 左
            _targetPosition.copy(_ucsX).multiplyScalar(-1);
            _targetQuaternion.setFromAxisAngle(_ucsX, Math.PI * 0.5).multiply(new Quaternion().setFromAxisAngle(_ucsY, -Math.PI * 0.5));
            workPlane.setFromNormalAndCoplanarPoint(_targetPosition, _ucsP);
        }
        else if (value === CameraPerspectiveType.RIGHT) { // 右
            _targetPosition.copy(_ucsX);
            _targetQuaternion.setFromAxisAngle(_ucsX, Math.PI * 0.5).multiply(new Quaternion().setFromAxisAngle(_ucsY, Math.PI * 0.5));
            workPlane.setFromNormalAndCoplanarPoint(_targetPosition, _ucsP);
        }
        else if (value === CameraPerspectiveType.DOWN) { // 下
            // if ((Math.abs(_px - _py) < 1e-6) && (Math.abs(_px - _ny) < 1e-6)) {
            //     return true;
            // }
            _targetPosition.copy(_ucsZ).multiplyScalar(-1).normalize();
            if (_px <= _py && _px <= _nx && _px <= _ny) {
                // posX
                _targetQuaternion.setFromAxisAngle(_ucsZ, Math.PI / 2).multiply(new Quaternion().setFromAxisAngle(_ucsX, Math.PI));
            }
            else if (_py <= _px && _py <= _nx && _py <= _ny) {
                // posY
                _targetQuaternion.setFromAxisAngle(_ucsZ, Math.PI).multiply(new Quaternion().setFromAxisAngle(_ucsX, Math.PI));
            }
            else if (_nx <= _px && _nx <= _py && _nx <= _ny) {
                // negX
                _targetQuaternion.setFromAxisAngle(_ucsZ, -Math.PI / 2).multiply(new Quaternion().setFromAxisAngle(_ucsX, Math.PI));
            }
            else if (_ny <= _px && _ny <= _py && _ny <= _nx) {
                // negY
                _targetQuaternion.setFromAxisAngle(_ucsZ, Math.PI);
            }
            workPlane.setFromNormalAndCoplanarPoint(_ucsZ, _ucsP);
        }
        else if (value === CameraPerspectiveType.BACK) { // 后
            _targetPosition.copy(_ucsY);
            _targetQuaternion.setFromAxisAngle(_ucsX, Math.PI * 0.5).multiply(new Quaternion().setFromAxisAngle(_ucsY, Math.PI));
            workPlane.setFromNormalAndCoplanarPoint(_targetPosition, _ucsP);
        }
        // 主视图相机位置到焦点的距离
        const _radius = camera.position.distanceTo(target);
        // 直接更新相机目标位置和四元数
        camera.position.set(0, 0, 1).applyQuaternion(_targetQuaternion).multiplyScalar(_radius).add(target);
        camera.quaternion.copy(_targetQuaternion);
        // 更新坐标系目标点
        storage.viewportStore.getEntityViewCenter(_f2);
        _f1.copy(target);
        if (_f1.distanceTo(_f2) > 1e-6) {
            // 直接设置目标点
            this.updateTarget(target);
        }
        return true;
    }
    /**
     * 更新相机目标
     * @param v
     */
    updateTarget(v) {
        var _a;
        const viewportStore = this.getPythaStorage().viewportStore;
        const camera = (_a = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        const position = camera.position;
        let offset = position.clone().sub(viewportStore.viewportItems[viewportStore.currentViewportKey].target);
        viewportStore.viewportItems[viewportStore.currentViewportKey].target.set(v.x, v.y, v.z);
        position.copy(viewportStore.viewportItems[viewportStore.currentViewportKey].target).add(offset);
        camera.updateMatrixWorld();
        if (camera && (camera.type === 'OrthographicCamera' || camera.type === 'PerspectiveCamera')) {
            camera.updateProjectionMatrix();
        }
    }
}
const _targetPosition = new Vector3();
const _targetQuaternion = new Quaternion();
const _offset = new Vector3();
const _posX = new Vector3(1, 0, 0);
const _posY = new Vector3(0, 1, 0);
const _negX = new Vector3(-1, 0, 0);
const _negY = new Vector3(0, -1, 0);
const _f1 = new Vector3(); // 原target
const _f2 = new Vector3(); // 目标的target
const _ucsX = new Vector3();
const _ucsY = new Vector3();
const _ucsZ = new Vector3();
const _ucsP = new Vector3();
let _px;
let _py;
let _nx;
let _ny;class EventGraphChangeCameraPerspective extends EventGraphBase {
    constructor() {
        super(...arguments);
        /**
         * 不可重复执行
         */
        this.putInLastCmd = false;
    }
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerChangeCameraPerspective);
        const node3 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node4 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node5 = new EventGraphNode(this, EventHandlerGrid);
        const node6 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node7 = new EventGraphNodeTimer(this, null);
        const node8 = new EventGraphNode(this, EventHandlerInitCapture);
        const node9 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node10 = new EventGraphNodeNotice(this, { cmd: 'data_change', data: {
                viewChangeEnd: true
            } });
        this.addEdge(node1, node2);
        this.addEdge(node3, node7);
        this.addEdge(node7, node4);
        this.addEdge(node4, node8);
        this.addEdge(node8, node5);
        this.addEdge(node5, node6);
        this.addEdge(node6, node9);
        this.addEdge(node2, node10);
        this.addEdge(node10, node3);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/154
    }
}
/**
 * SELECT指令 用于注册事件图
 */
EventGraphChangeCameraPerspective.cmd = 'CHANGE_CAMERA_PERSPECTIVE';/**
 * 画布大小变化
 */
class EventHandlerCanvasResize extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventSetting();
        this.needEventOnce = false;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(event) {
        if (event.cmd != this.needEvent.cmd)
            return false; // 如果传入事件不符 则不执行处理器
        if (event.data.key != SETTING_KEY.CANVAS_RESIZE) {
            return false;
        }
        // 获得存储
        const storage = this.getPythaStorage();
        const viewportStore = storage.viewportStore;
        const root = viewportStore.rootHTML;
        if (!root)
            return false;
        const aspect = root.offsetWidth / root.offsetHeight;
        viewportStore.aspect = aspect; // 将宽高比存入viewport
        for (const key in viewportStore.viewportItems) {
            let viewport = viewportStore.viewportItems[key];
            if (viewport.camera.type === "OrthographicCamera") {
                let camera = viewport.camera;
                camera.left = camera.bottom * aspect;
                camera.right = camera.top * aspect;
                camera.updateProjectionMatrix();
            }
            else if (viewport.camera.type === "PerspectiveCamera") {
                let camera = viewport.camera;
                camera.aspect = aspect;
                camera.updateProjectionMatrix();
            }
        }
        return true;
    }
}class EventGraphCanvasResize extends EventGraphBase {
    constructor() {
        super(...arguments);
        /**
         * 是否常驻图
         */
        this.isAlwaysActive = true;
        /**
         * 是否可以被上一次命令重复执行
         */
        this.putInLastCmd = false;
    }
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerCanvasResize);
        const node3 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        this.addEdge(node1, node2);
        this.addEdge(node2, node3);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/159
    }
    end() {
        this.cache.data = {};
        this.head.run();
    }
}
/**
 * box指令 用于注册事件图
 */
EventGraphCanvasResize.cmd = 'CANVAS_RESIZE';/**
 * 生成扫掠体
 */
class EventHandlerGenSweeper extends EventHandlerBase {
    addPrimitive(primitive, geos) {
        const storage = this.getPythaStorage();
        primitive.geos.push(...geos);
        let keys = Object.keys(primitive.renderItemDict);
        if (keys.length > 0) {
            let renderItem = primitive.renderItemDict[keys[0]];
            renderItem.geoElements = [];
            geos.forEach(geo => {
                let geoElementsLength = renderItem.geoElements.length;
                geo.getGeoElementsIdxList().forEach(idx => {
                    renderItem.geoElements.push(idx + geoElementsLength);
                });
            });
            if (primitive.isBoolPrimitive()) {
                primitive.renderItemDict[keys[0]].geoElements = [];
                primitive.renderItemDict[keys[0]].geoElements.push(0);
            }
        }
        primitive.temporary = false;
        storage.primitiveStore.tempPrimitiveDict[primitive.uuid] = primitive;
        this.node.graph.cache.primitiveList = [primitive];
        primitive.needRedraw = true;
    }
    run(data) {
        // 获取当前选择的路径和基线
        const primitiveList = this.getPythaStorage().selectStore.getUnlockedPrimitives();
        const base = primitiveList[0].geos[0];
        const sweepPath = primitiveList[1].geos[0];
        if (!base || !sweepPath) {
            return false;
        }
        if (base.isCurve && sweepPath.isCurve) {
            console.log("创建扫掠面");
            this.sweepSurfaceCreate(base, sweepPath);
            return true;
        }
        if (base.isSurface && sweepPath.isCurve) {
            console.log("创建扫掠体");
            this.sweepSolidCreate(base, sweepPath);
            return true;
        }
        console.log('没有进入分支', primitiveList);
        return false;
    }
    sweepSurfaceCreate(baseCurve, sweepPath) {
        console.log(baseCurve, "baseCurve");
        console.log(sweepPath, "sweepPath");
        const sweeperSurface = new SweeperSurface(baseCurve, sweepPath);
        console.log(sweeperSurface, "sweeperSurface");
        const primitive = new Primitive("SweeperSurface");
        console.log(primitive);
        this.addPrimitive(primitive, [sweeperSurface]);
    }
    sweepSolidCreate(baseSurface, sweepPath) {
        const sweeperSolid = new SweeperSolid(baseSurface, sweepPath);
        const primitive = new Primitive("SweeperSolid");
        this.addPrimitive(primitive, [sweeperSolid]);
    }
}/**
 * 扫掠功能
 */
class EventGraphSweep extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNodeSwitch(this, () => {
            // 判断当前存储器中选中元素个数
            const selectedItems = this.eventMediator.storage.selectStore.getUnlockedPrimitives();
            // 当前选中元素只有一个
            if (selectedItems.length === 1) {
                return [1];
            }
            // 当前有多个选中元素或没有选中元素
            // 进入轮廓路径选择分支
            return [0];
        });
        const node3 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [{
                    type: NeedInputEnum.ACTIVE,
                    description: '请选取轮廓',
                    inputTypes: [
                        PythaEventName.POINTER_DOWN,
                        PythaEventName.CONFIRM
                    ]
                }] });
        const node4 = new EventGraphNode(this, EHChangePickCursor);
        const node5 = new EventGraphNode(this, EventHandlerConfirm);
        const node6 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [{
                    type: NeedInputEnum.ACTIVE,
                    description: '请选取扫掠路径',
                    inputTypes: [
                        PythaEventName.POINTER_DOWN,
                        PythaEventName.CONFIRM
                    ]
                }] });
        const node7 = new EventGraphNode(this, EHChangePickCursor);
        const node8 = new EventGraphNode(this, EventHandlerConfirm);
        const node10 = new EventGraphNode(this, EventHandlerEmptySelect);
        const node14 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node15 = new EventGraphNode(this, EventHandlerGenSweeper);
        const node16 = new EventGraphNode(this, EventHandlerGrid);
        const node17 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node18 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node19 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        this.addEdge(node1, node2);
        this.addEdge(node4, node5);
        this.addEdge(node6, node7);
        this.addEdge(node7, node8);
        /**选中数量不为1*/
        this.addEdge(node2, node10);
        this.addEdge(node10, node3);
        this.addEdge(node3, node4);
        this.addEdge(node5, node2);
        this.addEdge(node8, node15);
        this.addEdge(node16, node17);
        this.addEdge(node17, node14);
        this.addEdge(node15, node18);
        this.addEdge(node18, node19);
        this.addEdge(node19, node16);
        /**选中1个图元*/
        this.addEdge(node2, node6);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/145
    }
}
/**
 * 扫掠命令
 */
EventGraphSweep.cmd = "SWEEP";/**
 * 计算旋转工作平面
 */
class EventHandlerCalRevolveWorkplane extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        // console.log("EHGenLine run")
        PythaStorage.instance;
        const graphCache = this.node.graph.cache;
        //获取当前点
        const pointerDownList = graphCache.pointerDownList;
        if (pointerDownList.length < 2)
            return false;
        // 获取临时图元
        const primitives = graphCache.data.primitives;
        if (!primitives)
            return false;
        // 获取第一个合法曲线的中心点
        const _center = graphCache.data._center;
        if (!_center)
            return false;
        // 获取旋转轴
        if (!graphCache.data._axis)
            return false;
        const _l1 = graphCache.data._axis;
        // 计算中心点到旋转轴的垂足
        GeoRelation.StraightLineClosestPointToPoint(_l1, _center, _v1$2);
        // 确定旋转基准面
        _p$3.setFromNormalAndCoplanarPoint(_l1.direction, _v1$2);
        graphCache.data._foot = _v1$2;
        graphCache.data._workPlane = _p$3;
        return true;
    }
}
const _p$3 = new Plane$1();
const _v1$2 = new Vector3();/**
 * 修改辅助线起点
 */
class EventHandlerModifyHelpLineStart extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        const graphCache = this.node.graph.cache;
        //获取当前点
        const pointerDownList = graphCache.pointerDownList;
        if (pointerDownList.length < 2)
            return false;
        // 获取辅助线
        const helpline = graphCache.data.helpline;
        if (!helpline)
            return false;
        graphCache.pointerMove.point;
        // 获取垂足
        const _foot = graphCache.data._foot;
        if (!_foot)
            return false;
        helpline.setStart(_foot);
        return true;
    }
}const CanRevolveTypes = [PrimitiveType.Line, PrimitiveType.Arc, PrimitiveType.Circle,
    PrimitiveType.RegionFace
];
/**
 * 计算临时旋转面
 */
class EventHandlerCalTempRevolve extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        // console.log("EHGenLine run")
        const storage = PythaStorage.instance;
        const graphCache = this.node.graph.cache;
        //获取当前点
        const pointerDownList = graphCache.pointerDownList;
        if (pointerDownList.length < 2)
            return false;
        let primitives = graphCache.data.primitives;
        if (!primitives || primitives.length === 0) {
            // 初始化创建
            this.initRevolveSurface();
        }
        primitives = graphCache.data.primitives;
        if (!primitives || primitives.length === 0)
            return true;
        const input = graphCache.inputNumber["ANGLE"];
        let angle = 1;
        let needDelete = false; // 是否需要删除原图元，指定角度后需要删除
        if (input != null && !isNaN(input)) {
            angle = input * Math.PI / 180;
            needDelete = true;
        }
        else {
            const _workPlane = graphCache.data._workPlane;
            if (!_workPlane)
                return false;
            _workPlane.getNormalizeZ(_v3$1);
            // 获取中心点
            const _center = graphCache.data._center;
            if (!_center)
                return false;
            const _foot = graphCache.data._foot;
            if (!_foot)
                return false;
            const _ray = storage.coordinateStore.viewCursorRay;
            // 把鼠标射线和基准面求交
            GeoIntersection.RayIntersectPlane(_ray, _workPlane, _v4);
            _v1$1.subVectors(_center, _foot);
            _v2$1.subVectors(_v4, _foot);
            // 求角度
            angle = GeoRelation.Vector3AngleTo(_v1$1, _v2$1, _v3$1);
            if (pointerDownList.length === 3)
                needDelete = true;
        }
        primitives.forEach(primitive => {
            const revolve = primitive.geos[0];
            revolve.angle = angle;
            primitive.needRedraw = true;
        });
        if (needDelete && graphCache.data.deletePrimitives && graphCache.data.deletePrimitives.length > 0) {
            graphCache.data.deletePrimitives.forEach(primitive => {
                primitive.needDelete = true;
                graphCache.deletePrimitiveList.push(primitive);
            });
        }
        return true;
    }
    // 初始化创建
    initRevolveSurface() {
        var _a;
        const storage = PythaStorage.instance;
        const graphCache = this.node.graph.cache;
        // 拿到选择的面
        const selected = storage.selectStore.selectPrimitives;
        const curveGeos = [];
        const deletePrimitives = [];
        for (let i = 0; i < selected.length; i++) {
            const primitive = selected[i];
            if (CanRevolveTypes.includes(primitive.type)) {
                const curve = primitive.geos[0].clone();
                deletePrimitives.push(primitive);
                if (primitive.localModelMatrix != null) {
                    curve.transformMatrix.premultiply(primitive.localModelMatrix);
                }
                curveGeos.push(curve);
            }
        }
        if (curveGeos.length === 0)
            return;
        const startPoint = graphCache.pointerDownList[graphCache.pointerDownList.length - 2].point;
        const endPoint = graphCache.pointerDownList[graphCache.pointerDownList.length - 1].point;
        _l1.setFromPoints(startPoint, endPoint);
        const workPlane = storage.coordinateStore.workPlane;
        workPlane.getNormalizeX(_v1$1);
        const primitives = [];
        let isFirst = true;
        for (let i = 0; i < curveGeos.length; i++) {
            const curve = curveGeos[i];
            curve.getNormalizeZ(_v2$1);
            // 曲线的平面和转轴不能平行
            if (Math.abs(_v2$1.cross(_l1.direction).length()) < 1e-6)
                continue;
            if (this.axisIntersectCurve(curve, _l1))
                continue;
            const isRegion = curve.type === PrimitiveType.RegionFace;
            if (isFirst) {
                // 拿第一个曲线的中心点
                const _center = new Vector3();
                if (!isRegion) {
                    curve.getCenter(_center);
                }
                else {
                    curve.getBasePoint(_center);
                }
                graphCache.data._center = _center;
                isFirst = false;
            }
            let revolve;
            let primitive;
            if (!isRegion) {
                revolve = new RevolveSurface(curve, _l1, Math.PI / 180);
                primitive = new Primitive(PrimitiveType.RevolveSurface);
            }
            else {
                revolve = new RevolveSolid(curve, _l1, Math.PI / 180);
                primitive = new Primitive(PrimitiveType.RevolveSolid);
            }
            primitive.geos.push(revolve);
            let keys = Object.keys(primitive.renderItemDict);
            if (keys.length > 0) {
                let renderItem = primitive.renderItemDict[keys[0]];
                renderItem.geoElements = revolve.getGeoElementsIdxList();
                (_a = renderItem.mat) === null || _a === void 0 ? void 0 : _a.color.set(storage.layerStore.getColor());
            }
            primitive.temporary = true;
            primitive.needRedraw = true;
            primitives.push(primitive);
            graphCache.primitiveList.push(primitive);
            storage.primitiveStore.tempPrimitiveDict[primitive.uuid] = primitive;
        }
        // 拿第一个图元的中心点
        graphCache.data._axis = _l1;
        graphCache.data.primitives = primitives;
        graphCache.data.deletePrimitives = deletePrimitives;
    }
    // 判断曲线与旋转轴是否相交
    axisIntersectCurve(curve, axis) {
        // TODO 曲线要位于转轴的一侧
        switch (curve.type) {
            case PrimitiveType.Arc:
                _l2.copy(axis);
                curve.getNormalizeZ(_v3$1);
                _l2.origin.copy(_l2.origin.projectOnPlane(_v3$1));
                _l2.direction.copy(_l2.direction.projectOnPlane(_v3$1));
                _v4.copy(axis.origin);
                axis.getPointAt(10, _v5);
                _line$1.start = _v4;
                _line$1.end = _v5;
                return GeoIntersection.ArcIntersectLine(curve, _line$1, true, false).length !== 0;
            case PrimitiveType.Circle:
                _l2.copy(axis);
                curve.getNormalizeZ(_v3$1);
                _l2.origin.copy(_l2.origin.projectOnPlane(_v3$1));
                _l2.direction.copy(_l2.direction.projectOnPlane(_v3$1));
                _v4.copy(axis.origin);
                axis.getPointAt(10, _v5);
                _line$1.start = _v4;
                _line$1.end = _v5;
                return GeoIntersection.ArcIntersectLine(curve, _line$1, true, false).length !== 0;
            case PrimitiveType.Line:
                curve.getX(_v4);
                _v3$1.copy(_v4).cross(axis.direction);
                if (_v3$1.length() < 1e-6) {
                    return false;
                }
                // 旋转轴投影
                _l2.copy(axis);
                _l2.origin.copy(_l2.origin.projectOnPlane(_v3$1));
                _l2.direction.copy(_l2.direction.projectOnPlane(_v3$1));
                axis.getPointAt(10, _v5);
                GeoIntersection.StraightLineIntersectLine(axis, curve, _v4);
                if (_v4 == null)
                    return false;
                const par = GeoRelation.getT(curve, _v4);
                if (par == null || isNaN(par) || par < 0 || par > 1)
                    return false;
                return true;
            case PrimitiveType.RegionFace:
                let edges = curve.edges;
                curve.holes.forEach(hole => edges = edges.concat(hole.edges));
                for (let i = 0; i < edges.length; i++) {
                    const edge = edges[i].clone();
                    edge.transformMatrix.premultiply(curve.transformMatrix);
                    if (this.axisIntersectCurve(edge, axis))
                        return true;
                }
                return false;
            default:
                return true;
        }
    }
}
const _v1$1 = new Vector3();
const _l1 = new StraightLine();
const _v2$1 = new Vector3();
const _v3$1 = new Vector3();
const _v4 = new Vector3();
const _v5 = new Vector3();
const _line$1 = new Line$2();
const _l2 = new StraightLine();/**
 * 旋转面
 */
class EventGraphRevolve extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerDisableClamp);
        const node3 = new EventGraphNodeSwitch(this, () => {
            const storage = this.eventMediator.storage;
            if (storage.selectStore.getUnlockedPrimitives().length < 1) {
                return [0];
            }
            return [1];
        });
        const node4 = new EventGraphNode(this, EHChangePickCursor);
        const node5 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '请选择要旋转的对象' });
        const node6 = new EventGraphNode(this, EventHandlerConfirm);
        const node7 = new EventGraphNodeSwitch(this, () => {
            const storage = this.eventMediator.storage;
            if (storage.selectStore.getUnlockedPrimitives().length < 1) {
                return [0];
            }
            return [1];
        });
        const node8 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                    type: NeedInputEnum.ACTIVE,
                    description: "指定轴起点",
                    option: "S",
                    inputTypes: [PythaEventName.POINTER_DOWN]
                }]
        });
        const node9 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node10 = new EventGraphNode(this, EHChangeCrossCursor);
        const node11 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node12 = new EventGraphNode(this, EventHandlerInitCapture);
        const node13 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node14 = new EventGraphNode(this, EventHandlerCapture);
        const node15 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node16 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        const node17 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        const node18 = new EventGraphNode(this, EventHandlerHelpLine);
        const node19 = new EventGraphNodeAND(this, null);
        const node20 = new EventGraphNode(this, EventHandlerMouseWheel);
        const node21 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                    type: NeedInputEnum.ACTIVE,
                    description: "指定轴端点",
                    option: "E",
                    inputTypes: [PythaEventName.POINTER_DOWN]
                }]
        });
        const node22 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node23 = new EventGraphNode(this, EventHandlerCalRevolveWorkplane);
        const node24 = new EventGraphNode(this, EventHandlerModifyHelpLineStart);
        const node25 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                    type: NeedInputEnum.ACTIVE,
                    description: "指定旋转角度",
                    option: "ANGLE",
                    inputTypes: [PythaEventName.POINTER_DOWN, PythaEventName.ANGLE]
                }]
        });
        const node26 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node27 = new EventGraphNode(this, EventHandlerNumberInput);
        const node28 = new EventGraphNode(this, EventHandlerCalTempRevolve);
        const node29 = new EventGraphNodeAND(this, null);
        const node30 = new EventGraphNode(this, EventHandlerCalTempRevolve);
        const node31 = new EventGraphNode(this, EventHandlerGrid);
        const node32 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node33 = new EventGraphNode(this, EventHandlerGenAndDeletePrimitives);
        const node34 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node35 = new EventGraphNode(this, EventHandlerGrid);
        const node36 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node37 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        const node38 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node39 = new EventGraphNodeSwitch(this, () => {
            const graphCache = this.cache;
            if (!graphCache.data.primitives || graphCache.data.primitives.length === 0) {
                return [1];
            }
            return [0];
        });
        const node40 = new EventGraphNode(this, EventHandlerEmptySelect);
        const node41 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        this.addEdge(node1, node2);
        this.addEdge(node2, node3);
        this.addEdge(node3, node4);
        this.addEdge(node4, node5);
        this.addEdge(node5, node6);
        this.addEdge(node6, node7);
        this.addEdge(node7, node9);
        this.addEdge(node10, node11);
        this.addEdge(node10, node12);
        this.addEdge(node12, node13);
        this.addEdge(node13, node14);
        this.addEdge(node14, node15);
        this.addEdge(node11, node16);
        this.addEdge(node15, node19);
        this.addEdge(node19, node18);
        this.addEdge(node18, node17);
        this.addEdge(node11, node19);
        this.addEdge(node19, node20);
        this.addEdge(node20, node18);
        this.addEdge(node16, node21);
        this.addEdge(node21, node22);
        this.addEdge(node24, node25);
        this.addEdge(node25, node26);
        this.addEdge(node25, node27);
        this.addEdge(node26, node27, EDGE_TYPE.STOP);
        this.addEdge(node27, node26, EDGE_TYPE.STOP);
        this.addEdge(node22, node29);
        this.addEdge(node29, node30);
        this.addEdge(node30, node31);
        this.addEdge(node31, node32);
        this.addEdge(node19, node29);
        this.addEdge(node26, node28);
        this.addEdge(node27, node28);
        this.addEdge(node28, node33);
        this.addEdge(node33, node34);
        this.addEdge(node34, node35);
        this.addEdge(node35, node36);
        this.addEdge(node36, node9);
        this.addEdge(node22, node37);
        this.addEdge(node8, node38);
        this.addEdge(node38, node10);
        this.addEdge(node40, node41);
        this.addEdge(node41, node9);
        this.addEdge(node37, node39);
        this.addEdge(node39, node23);
        this.addEdge(node23, node24);
        this.addEdge(node3, node8);
        this.addEdge(node7, node8);
        this.addEdge(node39, node40);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/153
    }
}
/**
 * 指令 用于注册事件图
 */
EventGraphRevolve.cmd = 'REVOLVE';/**
 * 组输入
 */
class EventHandlerGroupInput extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventText();
        this.needEventOnce = true;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(event) {
        if (event.cmd != this.needEvent.cmd)
            return false;
        this.node.graph.cache.data['groupUuid'] = event.data;
        return true;
    }
}/**
 * 选中组图元
 */
class EventHandlerSelectGroupPri extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run() {
        // 获得存储
        const storage = PythaStorage.instance;
        // 组uuid
        let groupUuid = this.node.graph.cache.data['groupUuid'];
        // 需要选中的图元
        let primitives = [];
        Object.keys(storage.primitiveStore.primitiveDict).forEach(key => {
            let primitive = storage.primitiveStore.primitiveDict[key];
            if (primitive.group.includes(groupUuid)) {
                primitive.isSelected = true;
                primitive.needRedraw = true;
                primitives.push(primitive);
            }
        });
        this.node.graph.cache.data['originPrimitives'] = [...primitives];
        storage.selectStore.selectPrimitives = primitives;
        return true;
    }
}/**
 * 更新组的命令
 * 添加图元对象到组
 * 从组中移除图元对象
 */
class UpdateGroupCmd extends CommandBase {
    /**
     * 构造函数
     * @param newPrimitives 要新加入组的图元
     * @param deletePrimitives 要从组中移除的图元
     * @param group 组
     * @param eventMediator 事件中介
     */
    constructor(newPrimitives, deletePrimitives, group, eventMediator) {
        super();
        this.newPrimitives = []; // 要新加入组的图元
        this.deletePrimitives = []; // 要从组中移除的图元
        this.group = group;
        this.eventMediator = eventMediator;
        this.newPrimitives = newPrimitives;
        this.deletePrimitives = deletePrimitives;
    }
    /**
     * 执行
     */
    execute() {
        // 对于新加入组的图元，添加组uuid
        for (let pri of this.newPrimitives) {
            pri.group.push(this.group.uuid);
        }
        // 对于要移除组的图元，移除组uuid
        for (let pri of this.deletePrimitives) {
            pri.group = pri.group.filter(item => item != this.group.uuid);
        }
        this.eventMediator.noticeHandler.notice(this, new PythaEventDataChange({
            update_group: this.group,
            add_primitives: [...this.newPrimitives, ...this.deletePrimitives]
        }));
    }
    /**
     * 撤销
     */
    undo() {
        // 对于新加入组的图元，撤销添加组uuid
        for (let pri of this.newPrimitives) {
            pri.group = pri.group.filter(item => item != this.group.uuid);
        }
        // 对于要移除组的图元，撤销移除组uuid
        for (let pri of this.deletePrimitives) {
            pri.group.push(this.group.uuid);
        }
        this.eventMediator.noticeHandler.notice(this, new PythaEventDataChange({
            update_group: this.group,
            add_primitives: [...this.newPrimitives, ...this.deletePrimitives]
        }));
    }
}/**
 * 更新组
 * 添加图元对象到组
 * 从组中移除图元对象
 */
class EventHandlerUpdateGroup extends EventHandlerBase {
    run() {
        // 当前图的存储
        const storage = this.getPythaStorage();
        // 组uuid
        let groupUuid = this.node.graph.cache.data['groupUuid'];
        // 目前选择的图元
        let selectedPrimitives = storage.selectStore.getUnlockedPrimitives() || [];
        // 之前的图元组
        let originPrimitives = this.node.graph.cache.data['originPrimitives'];
        // 之前选中的，现在没选中，需要移除组uuid的属性
        let deletePrimitives = originPrimitives.filter(origin => !selectedPrimitives.some(pri => pri.uuid == origin.uuid));
        // 之前没选中，现在选中的，需要添加组uuid的属性
        let newPrimitives = selectedPrimitives.filter(selected => !originPrimitives.some(origin => origin.uuid == selected.uuid));
        const globalStorage = PythaStorage.instance;
        let group = globalStorage.groupStore.groupDict[groupUuid];
        const cmd = new UpdateGroupCmd(newPrimitives, deletePrimitives, group, this.node.graph.eventMediator);
        // 判断缓存中是否有命令组
        const commandGroup = this.node.graph.cache.data['commandGroup'];
        const groupExist = commandGroup && commandGroup instanceof CommandGroup;
        if (!groupExist) {
            storage.historyStore.undos.push(cmd);
            cmd.execute();
        }
        else {
            commandGroup.addCmd(cmd);
        }
        return true;
    }
}/**
 * 编辑组
 */
class EventGraphGroupEdit extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerGroupInput);
        const node3 = new EventGraphNode(this, EventHandlerSelectGroupPri);
        const node4 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '选择对象或删除对象' });
        const node5 = new EventGraphNode(this, EHChangePickCursor);
        const node6 = new EventGraphNode(this, EventHandlerConfirm);
        const node7 = new EventGraphNode(this, EventHandlerUpdateGroup);
        const node8 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node9 = new EventGraphNode(this, EventHandlerEmptySelect);
        const node10 = new EventGraphNodeRender(this, true, UpdateType.MAIN);
        const node11 = new EventGraphNodeSwitch(this, () => {
            if (!this.cache.data['groupUuid'])
                return [0];
            return [1];
        });
        const node14 = new EventGraphNode(this, EventHandlerShowAllPri);
        const node20 = new EventGraphNode(this, EventHandlerDisableClamp);
        const node23 = new EventGraphNode(this, EventHandlerGrid);
        this.addEdge(node1, node2);
        this.addEdge(node4, node5);
        this.addEdge(node5, node6);
        this.addEdge(node9, node3);
        this.addEdge(node10, node4);
        this.addEdge(node11, node8);
        this.addEdge(node2, node11);
        this.addEdge(node14, node9);
        this.addEdge(node3, node20);
        this.addEdge(node20, node23);
        this.addEdge(node23, node10);
        this.addEdge(node6, node7);
        this.addEdge(node7, node8);
        this.addEdge(node11, node14);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/168
    }
    end() {
        let groupUuid = this.cache.data['groupUuid'];
        let groupUuids = [];
        this.getAllGroupUuids(groupUuid, groupUuids);
        // 仅显示该组包含的图元
        let primitives = [];
        const storage = PythaStorage.instance;
        Object.keys(storage.primitiveStore.primitiveDict).forEach(key => {
            let primitive = storage.primitiveStore.primitiveDict[key];
            if (groupUuids.some(uuid => { var _a; return (_a = primitive === null || primitive === void 0 ? void 0 : primitive.group) === null || _a === void 0 ? void 0 : _a.includes(uuid); })) {
                primitives.push(primitive);
            }
        });
        const cmd = new ShowAndHiddenOtherCmd(primitives, this.eventMediator, false);
        cmd.execute();
        super.end();
    }
    /**
     * 根据groupUuid获得子孙的groupUuid
     */
    getAllGroupUuids(rootGroupUuid, groupUuids = []) {
        groupUuids.push(rootGroupUuid);
        let children = Object.values(PythaStorage.instance.groupStore.groupDict).filter(item => item.parentUuid == rootGroupUuid);
        if (children && children.length > 0) {
            children.forEach((child) => {
                this.getAllGroupUuids(child.uuid, groupUuids);
            });
        }
    }
}
/**
 * GROUPEDIT指令
 */
EventGraphGroupEdit.cmd = "GROUPEDIT";/**
 * 炸开块
 */
class EventHandlerExplodeBlock extends EventHandlerBase {
    run(data) {
        const graphCache = this.node.graph.cache;
        const storage = this.getPythaStorage();
        let blocks = [];
        if (graphCache.data.blockTemplateUuid != null) {
            const block = storage.blockStore.blockTemplateDict[graphCache.data.blockTemplateUuid];
            if (!!block) {
                blocks.push(block);
            }
        }
        else {
            blocks = storage.selectStore.getUnlockedPrimitives().filter(pri => pri.type === PrimitiveType.Block);
        }
        blocks.forEach(block => {
            this.explodeBlock(block);
        });
        return true;
    }
    /**
     * 炸开块
     * @param block
     */
    explodeBlock(block) {
        //如果是模板，则将自身删除，将自身子图元添加到场景中
        if (block.isTemplate) {
            Object.keys(block.children).forEach(key => {
                //根据矩阵计算出块的子图元在世界坐标系下的位置，然后添加到场景中
                const pri = block.children[key].clone();
                if (block.worldModelMatrix) {
                    if (pri.localModelMatrix == null) {
                        pri.localModelMatrix = new Matrix4();
                    }
                    pri.localModelMatrix.premultiply(block.worldModelMatrix);
                }
                //如果子图元有父图元，则删除父图元（否则无法被选中）
                if (pri.parent) {
                    pri.parent = null;
                }
                if (pri.parentUuid) {
                    pri.parentUuid = null;
                }
                pri.updateWorldModelMatrix();
                //添加到需要被加入到场景中的列表中
                this.node.graph.cache.primitiveList.push(pri);
            });
            if (Object.keys(block.children).length > 0) {
                this.node.graph.cache.deletePrimitiveList.push(block);
            }
        }
        else {
            //如果不是模板，则将自身删除，将模板子图元乘以自身矩阵，添加到场景中
            const bt = this.getPythaStorage().blockStore.blockTemplateDict[block.blockTemplateUuid];
            if (bt == null) {
                return;
            }
            else {
                if (block.worldModelMatrix) {
                    block.worldModelMatrix.premultiply(bt.worldModelMatrix);
                }
                Object.keys(bt.children).forEach(key => {
                    const pri = bt.children[key].clone();
                    if (block.worldModelMatrix) {
                        if (pri.localModelMatrix == null) {
                            pri.localModelMatrix = new Matrix4();
                        }
                        pri.localModelMatrix.premultiply(block.worldModelMatrix);
                    }
                    //如果子图元有父图元，则删除父图元（否则无法被选中）
                    if (pri.parent) {
                        pri.parent = null;
                    }
                    if (pri.parentUuid) {
                        pri.parentUuid = null;
                    }
                    pri.updateWorldModelMatrix();
                    //添加到需要被加入到场景中的列表中
                    this.node.graph.cache.primitiveList.push(pri);
                });
                if (Object.keys(bt.children).length > 0) {
                    this.node.graph.cache.deletePrimitiveList.push(block);
                }
            }
        }
    }
}class EventGraphExplode extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerConfirm);
        const node11 = new EventGraphNode(this, EventHandlerExplodeBlock);
        const node14 = new EventGraphNode(this, EventHandlerGrid);
        const node15 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node18 = new EventGraphNodeNotice(this, { cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "请选择块", option: 'CONFIRM', inputTypes: [PythaEventName.CONFIRM] },
            ] });
        const node21 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node23 = new EventGraphNodeSwitch(this, () => {
            let selectPrimitives = this.eventMediator.storage.selectStore.getUnlockedPrimitives();
            for (let i = 0; i < selectPrimitives.length; i++) {
                if (selectPrimitives[i].type === PrimitiveType.Block) {
                    return [1];
                }
            }
            return [0];
        });
        const node29 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node31 = new EventGraphNode(this, EventHandlerDisableClamp);
        const node32 = new EventGraphNode(this, EHChangePickCursor);
        const node33 = new EventGraphNodeNotice(this, { cmd: 'Notice', data: '未选中任何块' });
        const node34 = new EventGraphNodeSwitch(this, () => {
            let selectPrimitives = this.eventMediator.storage.selectStore.getUnlockedPrimitives();
            for (let i = 0; i < selectPrimitives.length; i++) {
                if (selectPrimitives[i].type === PrimitiveType.Block) {
                    return [1];
                }
            }
            return [0];
        });
        const node35 = new EventGraphNode(this, EventHandlerGenAndDeletePrimitives);
        this.addEdge(node14, node21);
        this.addEdge(node29, node14);
        this.addEdge(node21, node15);
        this.addEdge(node1, node31);
        this.addEdge(node31, node23);
        this.addEdge(node23, node18);
        this.addEdge(node18, node32);
        this.addEdge(node32, node2);
        this.addEdge(node2, node34);
        this.addEdge(node34, node33);
        this.addEdge(node33, node15);
        this.addEdge(node11, node35);
        this.addEdge(node35, node29);
        this.addEdge(node34, node11);
        this.addEdge(node23, node11);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/162
    }
}
/**
 * 炸开指令 用于注册事件图
 */
EventGraphExplode.cmd = 'EXPLODE';/**
 * 计算布置块的临时图元
 */
class EventHandlerCalcTempBlock extends EventHandlerBase {
    run(data) {
        const graphCache = this.node.graph.cache;
        const blockTemplateUuid = graphCache.data['blockTemplateUuid'];
        if (!blockTemplateUuid)
            return false;
        const storage = this.getPythaStorage();
        if (!graphCache.data['primitive']) {
            const blockPrimitive = new BlockPrimitive();
            graphCache.data['primitive'] = blockPrimitive;
            blockPrimitive.blockTemplateUuid = blockTemplateUuid;
            blockPrimitive.temporary = true;
            graphCache.primitiveList.push(blockPrimitive);
            storage.primitiveStore.tempPrimitiveDict[blockPrimitive.uuid] = blockPrimitive;
        }
        const blockPrimitive = graphCache.data['primitive'];
        const pointerDownList = graphCache.pointerDownList;
        _p$2.copy(graphCache.pointerMove.point);
        if (pointerDownList.length === 1) {
            _p$2.copy(pointerDownList[0].point);
        }
        if (blockPrimitive.localModelMatrix == null) {
            blockPrimitive.localModelMatrix = new Matrix4();
        }
        const bt = storage.blockStore.blockTemplateDict[blockTemplateUuid];
        _p$2.applyMatrix4(bt.worldModelMatrixInverse);
        blockPrimitive.localModelMatrix.elements[12] = _p$2.x;
        blockPrimitive.localModelMatrix.elements[13] = _p$2.y;
        blockPrimitive.localModelMatrix.elements[14] = _p$2.z;
        blockPrimitive.updateWorldModelMatrix(false, true);
        blockPrimitive.needRedraw = true;
        return true;
    }
}
const _p$2 = new Vector3();/**
 * 清除临时布置块
 */
class EventHandlerClearTempBlock extends EventHandlerBase {
    run(data) {
        const graphCache = this.node.graph.cache;
        graphCache.data['primitive'] = null;
        graphCache.primitiveList = [];
        graphCache.pointerDownList = [];
        return true;
    }
}/**
 * 监听块数据获取
 */
class EventHandlerListenBlock extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventBlock();
        this.needEventOnce = true;
    }
    run(event) {
        if (event.cmd != this.needEvent.cmd)
            return false;
        const data = event.data;
        if (!data || !data['blockTemplateUuid'])
            return false;
        this.node.graph.cache.data['blockTemplateUuid'] = data['blockTemplateUuid'];
        return true;
    }
}/**
 * 布置块
 */
class EventGraphArrangeBlock extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerListenBlock);
        const node3 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [
                { type: NeedInputEnum.ACTIVE, description: "指定基点", option: 'B', inputTypes: [PythaEventName.POINTER_DOWN] }
            ]
        });
        const node4 = new EventGraphNode(this, EHChangeCrossCursor);
        const node5 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node6 = new EventGraphNode(this, EventHandlerInitCapture);
        const node7 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node8 = new EventGraphNode(this, EventHandlerCapture);
        const node9 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node10 = new EventGraphNode(this, EventHandlerCalcTempBlock);
        const node11 = new EventGraphNode(this, EventHandlerGrid);
        const node12 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node13 = new EventGraphNode(this, EventHandlerCalcTempBlock);
        const node14 = new EventGraphNode(this, EventHandlerGeneratePri);
        const node15 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node16 = new EventGraphNode(this, EventHandlerGrid);
        const node17 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node18 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node19 = new EventGraphNode(this, EventHandlerConfirm);
        const node20 = new EventGraphNode(this, EventHandlerClearTempBlock);
        this.addEdge(node1, node2);
        this.addEdge(node2, node3);
        this.addEdge(node3, node4);
        this.addEdge(node6, node7);
        this.addEdge(node3, node6);
        this.addEdge(node7, node8);
        this.addEdge(node4, node5);
        this.addEdge(node5, node9);
        this.addEdge(node8, node10);
        this.addEdge(node10, node11);
        this.addEdge(node11, node12);
        this.addEdge(node9, node13);
        this.addEdge(node13, node14);
        this.addEdge(node14, node15);
        this.addEdge(node15, node16);
        this.addEdge(node16, node17);
        this.addEdge(node1, node19);
        this.addEdge(node19, node18);
        this.addEdge(node17, node20);
        this.addEdge(node20, node9);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/163
    }
}
EventGraphArrangeBlock.cmd = "ARRANGE_BLOCK";/**
 * 炸开块
 */
class EventGraphExplodeBlock extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerListenBlock);
        const node3 = new EventGraphNode(this, EventHandlerGenAndDeletePrimitives);
        const node4 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node5 = new EventGraphNode(this, EventHandlerGrid);
        const node6 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node7 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node8 = new EventGraphNode(this, EventHandlerExplodeBlock);
        const node9 = new EventGraphNode(this, EventHanderShowAllInRect);
        const node10 = new EventGraphNode(this, EventHanderCalAllBoundingBox);
        this.addEdge(node1, node2);
        this.addEdge(node4, node5);
        this.addEdge(node5, node6);
        this.addEdge(node6, node7);
        this.addEdge(node2, node8);
        this.addEdge(node8, node3);
        this.addEdge(node9, node4);
        this.addEdge(node3, node10);
        this.addEdge(node10, node9);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/164
    }
}
EventGraphExplodeBlock.cmd = "EXPLODE_BLOCK";/**
 * 多个组输入
 */
class EventHandlerGroupsInput extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventStringArray();
        this.needEventOnce = true;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(event) {
        if (event.cmd != this.needEvent.cmd)
            return false;
        this.node.graph.cache.data['groupUuids'] = event.data;
        return true;
    }
}/**
 * 按组显示图元，仅显示该组的图元
 */
class EventHandlerShowByGroup extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        // 获得存储
        const storage = PythaStorage.instance;
        // 组uuid
        let groupUuids = this.node.graph.cache.data['groupUuids'];
        // 需要显示的图元
        let primitives = [];
        Object.keys(storage.primitiveStore.primitiveDict).forEach(key => {
            let primitive = storage.primitiveStore.primitiveDict[key];
            if (groupUuids.some(uuid => { var _a; return (_a = primitive === null || primitive === void 0 ? void 0 : primitive.group) === null || _a === void 0 ? void 0 : _a.includes(uuid); })) {
                primitives.push(primitive);
            }
        });
        const cmd = new ShowAndHiddenOtherCmd(primitives, this.node.graph.eventMediator, false);
        // 判断缓存中是否有命令组
        const commandGroup = this.node.graph.cache.data['commandGroup'];
        const groupExist = commandGroup && commandGroup instanceof CommandGroup;
        if (!groupExist) {
            storage.historyStore.undos.push(cmd);
            cmd.execute();
        }
        else {
            commandGroup.addCmd(cmd);
        }
        return true;
    }
}/**
 * 按组显示图元
 */
class EventGraphGroupShow extends EventGraphBase {
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerGroupsInput);
        const node3 = new EventGraphNode(this, EventHandlerShowByGroup);
        const node4 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node5 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node6 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        const node7 = new EventGraphNodeSwitch(this, () => {
            if (!this.cache.data['groupUuids'] || this.cache.data['groupUuids'].length == 0)
                return [0];
            return [1];
        });
        const node8 = new EventGraphNode(this, EventHandlerGrid);
        const node9 = new EventGraphNode(this, EventHanderShowAllInRect);
        const node10 = new EventGraphNode(this, EventHanderCalAllBoundingBox);
        const node11 = new EventGraphNodeNotice(this, { cmd: 'data_change', data: { viewChangeEnd: true } });
        this.addEdge(node1, node2);
        this.addEdge(node7, node5);
        this.addEdge(node2, node7);
        this.addEdge(node3, node8);
        this.addEdge(node8, node6);
        this.addEdge(node9, node4);
        this.addEdge(node6, node10);
        this.addEdge(node10, node9);
        this.addEdge(node4, node11);
        this.addEdge(node11, node5);
        this.addEdge(node7, node3);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/166
    }
}
/**
 * GROUPSHOW指令
 */
EventGraphGroupShow.cmd = "GROUPSHOW";/**
 * 类型注册存储器，含 图元类型、事件图类型，可开放接口
 */
class RegisterStore {
    // 命令列表的对外接口
    get cmdList() {
        return this._cmdList;
    }
    /**
     * 销毁
     */
    dispose() {
        delete this.geoRegister;
        delete this.eventGraphRegister;
        delete this.graftGraphRegister;
        this._cmdList = [];
    }
    /**
     * 根据命令获取注册的图类
     * @param cmd
     * @returns
     */
    getEventGraph(cmd) {
        return this.eventGraphRegister[cmd];
    }
    /**
     * 根据需要嫁接图命令找到对应嫁接图
     * @param cmd
     * @returns
     */
    getGraftGraph(cmd) {
        return this.graftGraphRegister[cmd];
    }
    /**
     * 根据名字获取注册的几何类
     * @param key
     * @returns
     */
    getGeometry(key) {
        return this.geoRegister[key];
    }
    /**
     * 获取图元构造器
     * @param key
     * @returns
     */
    getPrimitive(key) {
        let PriConstructor = this.primitiveRegester[key];
        if (PriConstructor == null) {
            return Primitive;
        }
        return PriConstructor;
    }
    /**
     * 注册几何类
     * name: string，几何类名，如Line、Arc
     * constructor: Constructor<GeometryBase>，几何类构造器
     */
    registGeo(name, constructor, divisionNums) {
        this.geoRegister[name] = constructor;
        this.registDivisionNums(name, divisionNums);
    }
    ;
    /**
     * 注册事件图
     * @param cmd 事件图的功能指令
     * @param constructor 事件图的类
     */
    registEventGraph(cmd, constructor, desciption = '') {
        this.eventGraphRegister[cmd] = constructor;
        // 找到索引
        const index = this._cmdList.findIndex(item => item.cmd === cmd);
        if (index !== -1) {
            // 如果存在，替换该位置的元素
            this._cmdList[index] = { cmd: cmd, desciption: desciption };
        }
        else {
            // 如果不存在，添加新元素
            this._cmdList.push({ cmd: cmd, desciption: desciption });
        }
    }
    /**
     * 注册嫁接图
     * @param cmd 需要嫁接图的命令
     * @param constructor 嫁接图的构造器
     */
    registGraftGraph(cmd, constructor) {
        let list = this.graftGraphRegister[cmd];
        if (list == null)
            list = [];
        list.push(constructor);
        this.graftGraphRegister[cmd] = list;
    }
    /**
     * 注册几何划分段数
     * @param name
     * @param divisionNums
     */
    registDivisionNums(name, divisionNums) {
        if (divisionNums != null && Object.keys(divisionNums).length > 0) {
            this.baseStore.renderStore.divisionNums[name] = divisionNums;
        }
    }
    /**
     * 注册图元类型
     */
    registPrimitiveType(name, constructor) {
        this.primitiveRegester[name] = constructor;
    }
    /**
     * 构造函数
     * @param baseStore 根存储器
     */
    constructor(baseStore) {
        /**
         * geo注册器
         */
        this.geoRegister = {};
        /**
         * 事件图注册器
         */
        this.eventGraphRegister = {};
        /**
         * 嫁接图注册器
         */
        this.graftGraphRegister = {};
        /**
         * 图元类型注册器
         */
        this.primitiveRegester = {};
        /**
         * 注册的命令列表
         */
        this._cmdList = [];
        this.baseStore = baseStore;
        this.initGeoRegister();
        this.initEventGraphRegister();
        this.initPrimitiveRegister();
    }
    /**
     * 初始化图元构造器
     */
    initPrimitiveRegister() {
        this.registPrimitiveType("Block", BlockPrimitive);
        this.registPrimitiveType("Text", TextPrimitive);
    }
    /**
     * 初始化事件图注册器
     */
    initEventGraphRegister() {
        this.registEventGraph(EventGraphLine.cmd, EventGraphLine, "线");
        this.registEventGraph(EventGraphCircle.cmd, EventGraphCircle, "圆");
        this.registEventGraph(EventGraphCopy.cmd, EventGraphCopy, "复制");
        this.registEventGraph(EventGraphCylinder.cmd, EventGraphCylinder, "圆柱");
        this.registEventGraph(EventGraphEllipse.cmd, EventGraphEllipse);
        this.registEventGraph(EventGraphPline.cmd, EventGraphPline);
        this.registEventGraph(EventGraphExtrude.cmd, EventGraphExtrude);
        this.registEventGraph(EventGraphSubstract.cmd, EventGraphSubstract, "差集(test)");
        this.registEventGraph(EventGraphCone.cmd, EventGraphCone);
        this.registEventGraph(EventGraphViewPan.cmd, EventGraphViewPan);
        this.registEventGraph(EventGraphPan.cmd, EventGraphPan);
        this.registEventGraph(EventGraphPyramid.cmd, EventGraphPyramid);
        this.registEventGraph(EventGraphView3do.cmd, EventGraphView3do);
        this.registEventGraph(EventGraph3do.cmd, EventGraph3do);
        this.registEventGraph(EventGraphViewZoom.cmd, EventGraphViewZoom);
        this.registEventGraph(EventGraphScale.cmd, EventGraphScale, "缩放");
        this.registEventGraph(EventGraphMove.cmd, EventGraphMove, "移动");
        this.registEventGraph(EventGraphRotate.cmd, EventGraphRotate, "旋转");
        this.registEventGraph(EventGraphDelete.cmd, EventGraphDelete, "删除");
        this.registEventGraph("ERASE", EventGraphDelete, "删除");
        this.registEventGraph(EventGraphUndo.cmd, EventGraphUndo, "撤销");
        this.registEventGraph(EventGraphRedo.cmd, EventGraphRedo, "重做");
        this.registEventGraph(EventGraphPolygon.cmd, EventGraphPolygon);
        this.registEventGraph(EventGraphRectangle.cmd, EventGraphRectangle);
        this.registEventGraph(EventGraphSphere.cmd, EventGraphSphere);
        this.registEventGraph(EventGraphBox.cmd, EventGraphBox, "长方体");
        this.registEventGraph(EGOffset.cmd, EGOffset);
        this.registEventGraph(EventGraphWedge.cmd, EventGraphWedge);
        this.registEventGraph(EventGraphTrim.cmd, EventGraphTrim);
        this.registEventGraph(EventGraphExtend.cmd, EventGraphExtend);
        this.registEventGraph(EventGraphStretch.cmd, EventGraphStretch);
        this.registEventGraph(EventGraphChamfer.cmd, EventGraphChamfer);
        this.registEventGraph(EventGraphFillet.cmd, EventGraphFillet);
        this.registEventGraph(EventGraphTorus.cmd, EventGraphTorus);
        this.registEventGraph(EventGraphRegion.cmd, EventGraphRegion);
        this.registEventGraph(EventGraphArc.cmd, EventGraphArc, "圆弧");
        this.registEventGraph(EventGraphColor.cmd, EventGraphColor);
        this.registEventGraph(EventGraphText.cmd, EventGraphText);
        this.registEventGraph(EventGraphUCS.cmd, EventGraphUCS);
        this.registEventGraph(EventGraphText.cmd, EventGraphText, "文字");
        this.registEventGraph(EventGraphTextEdit.cmd, EventGraphTextEdit, "编辑文字");
        this.registEventGraph(EventGraphBlock.cmd, EventGraphBlock, "创建块");
        this.registEventGraph(EventGraphMeasureDist.cmd, EventGraphMeasureDist);
        this.registEventGraph(EventGraphMeasureAngle.cmd, EventGraphMeasureAngle);
        this.registEventGraph(EventGraphCoordinate.cmd, EventGraphCoordinate);
        this.registEventGraph(EventGraphMirror.cmd, EventGraphMirror);
        this.registEventGraph(EventGraphPolarArray.cmd, EventGraphPolarArray);
        this.registEventGraph(EventGraphRectArray.cmd, EventGraphRectArray);
        this.registEventGraph(EventGraphPathArray.cmd, EventGraphPathArray);
        this.registEventGraph(EventGraphGenVector3.cmd, EventGraphGenVector3);
        this.registEventGraph(EventGraphPoint.cmd, EventGraphPoint, "绘制点");
        this.registEventGraph(EventGraphGroup.cmd, EventGraphGroup, "组");
        this.registEventGraph(EventGraphGroupEdit.cmd, EventGraphGroupEdit, "编辑组");
        this.registEventGraph(EventGraphGroupShow.cmd, EventGraphGroupShow, "按组显示");
        this.registEventGraph(EventGraphShowSelected.cmd, EventGraphShowSelected, "显示选中");
        this.registEventGraph(EventGraphHiddenSelected.cmd, EventGraphHiddenSelected, "隐藏选中");
        this.registEventGraph(EventGraphShowAll.cmd, EventGraphShowAll, "显示全部");
        this.registEventGraph(EventGraphForceSelect.cmd, EventGraphForceSelect);
        this.registEventGraph(EventGraphPickPoint.cmd, EventGraphPickPoint);
        this.registEventGraph(EventGraphRectangleLine.cmd, EventGraphRectangleLine);
        this.registEventGraph(EventGraphChangeCameraPerspective.cmd, EventGraphChangeCameraPerspective);
        this.registEventGraph(EventGraphCanvasResize.cmd, EventGraphCanvasResize);
        this.registEventGraph(EventGraphSweep.cmd, EventGraphSweep);
        this.registEventGraph(EventGraphRevolve.cmd, EventGraphRevolve);
        this.registEventGraph(EventGraphExplode.cmd, EventGraphExplode, "炸开块");
        this.registEventGraph(EventGraphArrangeBlock.cmd, EventGraphArrangeBlock);
        this.registEventGraph(EventGraphExplodeBlock.cmd, EventGraphExplodeBlock);
        this.initTestEventGraphRegister(); //测试用，正式环境下删除
    }
    /**
     * 注册测试图
     */
    initTestEventGraphRegister() {
        this.registEventGraph(EventGraphTestRender.cmd, EventGraphTestRender);
    }
    /**
     * 初始化图元注册器
     */
    initGeoRegister() {
        //1. 注册图元与划分段数
        this.registGeo("Line", Line$2, {
            1: [2],
            2: [2],
            3: [2],
            4: [2],
        }); // 直线段
        this.registGeo("Circle", Circle, {
            1: [6],
            2: [10],
            3: [20],
            4: [100],
        }); // 圆
        this.registGeo("Arc", Arc, {
            1: [6],
            2: [10],
            3: [20],
            4: [40],
        }); // 弧
        this.registGeo("Box", Box); // 长方体
        this.registGeo("Sphere", Sphere$2, { 1: [30] }); // 球体
        this.registGeo("Spherical", Spherical$1, {
            1: [6, 3],
            2: [10, 5],
            3: [20, 10],
            4: [40, 20],
        }); // 球体
        this.registGeo("RectFace", RectFace, {
            1: [2, 2],
            2: [2, 2],
            3: [2, 2],
            4: [2, 2],
        }); // 矩形面
        this.registGeo("Torus", Torus); // 圆环体
        this.registGeo("EllipseSurface", EllipseSurface, {
            1: [6, 2],
            2: [10, 2],
            3: [20, 2],
            4: [40, 2],
        }); // 椭圆面
        this.registGeo("Triangle", Triangle$1, {
            1: [2, 2],
            2: [2, 2],
            3: [2, 2],
            4: [2, 2],
        }); // 三角形
        this.registGeo("Polygon", Polygon, {
            1: [6],
            2: [10],
            3: [20],
            4: [40],
        }); //多边形
        this.registGeo("ExtrudeSurface", ExtrudeSurface, {
            1: [6, 2],
            2: [10, 2],
            3: [20, 2],
            4: [200, 2],
        }); // 拉伸面
        this.registGeo("ExtrudeSolid", ExtrudeSolid, {
            1: [6, 2],
            2: [10, 2],
            3: [20, 2],
            4: [200, 2],
        }); // 拉伸体
        this.registGeo("Cylinder", Cylinder, {
            1: [6, 2],
            2: [10, 2],
            3: [20, 2],
            4: [200, 2],
        }); // 圆柱
        this.registGeo("Wedge", Wedge, {
            1: [2, 2],
            2: [2, 2],
            3: [2, 2],
            4: [2, 2],
        }); // 楔形
        this.registGeo("RevolveSurface", RevolveSurface, {
            1: [6, 6],
            2: [10, 10],
            3: [30, 30],
            4: [200, 200],
        }); // 旋转面
        this.registGeo("Cone", Cone); // 圆锥
        this.registGeo("ConeSideSurface", ConeSideSurface, {
            1: [2, 6],
            2: [2, 10],
            3: [2, 20],
            4: [2, 40],
        });
        this.registGeo("Pyramid", Pyramid); // 棱锥
        this.registGeo("RegionFace", RegionFace, {
            1: [2, 2],
            2: [2, 2],
            3: [2, 2],
            4: [2, 2],
        });
        this.registGeo("Ellipse", Ellipse, {
            1: [6],
            2: [10],
            3: [20],
            4: [40],
        }); // 椭圆
        this.registGeo("EllipseArc", EllipseArc, {
            1: [6],
            2: [10],
            3: [20],
            4: [40],
        }); // 椭圆弧
        this.registGeo("GeneralRegion", GeneralRegion);
        this.registGeo("GeneralSolid", GeneralSolid);
        this.registGeo("SweeperSurface", SweeperSurface, {
            1: [6, 6],
            2: [10, 10],
            3: [30, 30],
            4: [150, 150],
        });
        this.registGeo("SweeperSolid", SweeperSolid);
    }
}/**
 * 渲染存储器
 */
class RenderStore {
    constructor() {
        /**
         * 字典 图元的渲染对象组
         */
        this.objectRenderBucket = {};
        /**
         * 字典 图元边线的渲染对象组
         */
        this.edgeRenderBucket = {};
        /**
         * 字典 临时图元的渲染对象组
         */
        this.tmpRenderBucket = {};
        /**
         * 当前渲染模式
         */
        this.renderMode = RenderMode.CONCEPT;
        /**
         * 透明模式的透明度系数
         */
        this.opacityModeRatio = 0.4;
        /**
         * 网格划分对于不同几何基类的采样数设置。对于曲线，number[]长度为1,对于曲面，长度为2
         * 外层key：需要划分的基元类型
         * 内层key：需要划分的基元lod等级
         */
        this.divisionNums = {};
        /**
         * 是否开启lod计算
         */
        this.lodEnabled = false;
    }
    /**
     * 销毁
     */
    dispose() {
        delete this.objectRenderBucket;
        delete this.edgeRenderBucket;
        delete this.tmpRenderBucket;
        delete this.divisionNums;
    }
}/**
 * 选择信息存储器
 */
class SelectStore {
    constructor() {
        /**
         * 开启选择
         */
        this.enabled = true;
        /**
         * 是否开启框选
         */
        this.rangeSelectEnabled = true;
        /**
         * 是否开启单选
         */
        this.pickOnly = false;
        /**
         * 被选中的图元
         */
        this.selectPrimitives = [];
        /**
         * 点选阈值
         */
        this.pickEpsilon = 0.0082;
    }
    /**
     * 获取没有锁定的选中图元
     * @returns
     */
    getUnlockedPrimitives() {
        return this.selectPrimitives.filter(item => item.lock == false) || [];
    }
    /**
     * 销毁
     */
    dispose() {
        this.selectPrimitives = [];
    }
}/**
 * 材质纹理存储器
 */
class TextureStore {
    constructor() {
        /**
         * 环境光反射亮度
         */
        this.globalEmissive = 0x444444;
    }
    /**
     * 销毁
     */
    dispose() {
        delete this.imageUrlMap;
        delete this.textureMap;
    }
    /**
     * 获取图片纹理
     * @param textureKey 纹理的编号
     * @returns
     */
    getTexture(textureKey) {
        // let texture = this.textureMap[textureKey];
        // if(texture == null){
        //     // TODO: 把load放到引擎外
        //     let imageUrl = this.imageUrlMap[textureKey]
        //     if (!(imageUrl?.length > 0)) return null
        //     texture = new TextureLoader().load(imageUrl)
        //     texture.wrapS = RepeatWrapping
        //     texture.wrapT = RepeatWrapping
        //     this.textureMap[textureKey] = texture;
        // }
        return this.textureMap[textureKey];
    }
    /**
     * 根据图片生成纹理
     * @param key
     * @param image
     * @param wrapType
     */
    genTexture(key, image, wrapType = RepeatWrapping) {
        let texture = this.textureMap[key];
        if (texture == null) {
            texture = new Texture();
            texture.wrapS = wrapType;
            texture.wrapT = wrapType;
            this.textureMap[key] = texture;
        }
        texture.image = image;
        texture.needsUpdate = true;
    }
}/**
 * 视口存储器
 */
class ViewportStore {
    constructor() {
        /**
         * 画布背景色
         */
        this.background = '#e3f2f4';
        /**
         * 窗口宽高比
         */
        this.aspect = 1;
        /**
         * 最小的缩放相对比例
         */
        this.minCameraEdge = 0.2;
        /**
         * 初始化项目边界范围
         */
        this.initialCameraEdge = 30;
        /**
         * 视口模式 单窗口、左右双窗口、上下双窗口、四窗口
         */
        this.viewportMode = ViewportMode.ONE;
        /**
         * 视口参数，range的四个取值分别为左上角与右下角的视口百分比坐标，取值范围[0, 1]
         */
        this.viewportItems = {};
        /**
         * 是否开启移动视图，默认开启
         */
        this.enabledPan = true;
        /**
         * 是否开启旋转视图，默认开启
         */
        this.enabled3do = true;
        /**
         * 获取视口内图元中心点
         * @param center
         * @returns
         */
        this.getEntityViewCenter = (center = null) => {
            var _a;
            if (center == null) {
                center = new Vector3();
            }
            let counter = 0;
            let selectPrimitive = PythaStorage.instance.selectStore.selectPrimitives;
            if ((selectPrimitive === null || selectPrimitive === void 0 ? void 0 : selectPrimitive.length) > 0) {
                selectPrimitive === null || selectPrimitive === void 0 ? void 0 : selectPrimitive.forEach(pri => {
                    if (!!pri.getCenter()) {
                        _center.copy(pri.getCenter());
                        center.add(_center);
                        counter++;
                    }
                });
            }
            else {
                (_a = (Object.keys(PythaStorage.instance.primitiveStore.primitiveInView))) === null || _a === void 0 ? void 0 : _a.forEach(key => {
                    let pri = PythaStorage.instance.primitiveStore.primitiveInView[key];
                    if (!!pri && !!pri.getCenter()) {
                        _center.copy(pri.getCenter());
                        center.add(_center);
                        counter++;
                    }
                });
            }
            if (counter === 0) {
                let elements = PythaStorage.instance.coordinateStore.activeUcs.elements;
                center.set(elements[12], elements[13], elements[14]);
                return center;
            }
            center.x /= counter;
            center.y /= counter;
            center.z /= counter;
            return center;
        };
    }
    /**
     * 销毁
     */
    dispose() {
        delete this.viewportItems;
        this.renderer.dispose();
        this.scene = null;
        this.rootHTML = null;
        this.currentViewportKey = null;
    }
    /**
     * 获取激活视口的视窗位置
     * @param key
     * @returns
     */
    getViewportRect(key) {
        var _a, _b;
        let item = this.viewportItems[key];
        if (item == null)
            return null;
        let range = item.range;
        let domRect = (_b = (_a = this.renderer.domElement) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        if (domRect == null)
            return null;
        let rect_x_1 = range[0] * domRect.width;
        let rect_y_1 = range[1] * domRect.height;
        let rect_x_2 = range[2] * domRect.width;
        let rect_y_2 = range[3] * domRect.height;
        return {
            x: rect_x_1 + domRect.x,
            y: rect_y_1 + domRect.y,
            width: (rect_x_2 - rect_x_1),
            height: (rect_y_2 - rect_y_1)
        };
    }
}
const _center = new Vector3();/**
 * 历史存储器（撤销重做）
 */
class HistoryStore {
    constructor() {
        /**
         * 待撤销的命令栈
         */
        this.undos = [];
        /**
         * 待重做的命令栈
         */
        this.redos = [];
    }
    /**
     * 销毁
     */
    dispose() {
        this.undos = [];
        this.redos = [];
    }
}/**
 * 十字光标标签
 */
class CrossCursorLabel extends LabelBase {
    /**
     * 构造函数
     */
    constructor(cursorColor = "#fff") {
        super(false);
        /**
         * 光标颜色
         */
        this.cursorColor = "#fff";
        this.cursorColor = cursorColor;
        this.generate();
    }
    /**
     * 生成光标标签
     */
    generate() {
        const root = this.obj.element;
        root.replaceChildren();
        const crossSize = 100;
        // 创建水平线
        const horizontalLine = document.createElement('div');
        horizontalLine.style.position = 'absolute';
        horizontalLine.style.width = `${crossSize}px`;
        horizontalLine.style.height = '1px';
        horizontalLine.style.backgroundColor = this.cursorColor;
        horizontalLine.style.right = `${-crossSize / 2}px`;
        // 创建垂直线
        const verticalLine = document.createElement('div');
        verticalLine.style.position = 'absolute';
        verticalLine.style.width = '1px';
        verticalLine.style.height = `${crossSize}px`;
        verticalLine.style.backgroundColor = this.cursorColor;
        verticalLine.style.bottom = `${-crossSize / 2}px`;
        root.appendChild(horizontalLine);
        root.appendChild(verticalLine);
    }
}/**
 * 默认光标标签
 */
class PickCrossCursorLabel extends LabelBase {
    /**
     * 构造函数
     */
    constructor(cursorColor = "#fff") {
        super(false);
        /**
         * 光标颜色
         */
        this.cursorColor = "#fff";
        this.cursorColor = cursorColor;
        this.generate();
    }
    /**
     * 生成光标标签
     */
    generate() {
        const root = this.obj.element;
        root.replaceChildren();
        const pickSize = 12;
        const crossSize = 100;
        this.obj.renderOrder = 10000;
        // 创建水平线
        const horizontalLine1 = document.createElement('div');
        horizontalLine1.style.position = 'absolute';
        horizontalLine1.style.width = `${crossSize / 2 - pickSize / 2}px`;
        horizontalLine1.style.height = '1px';
        horizontalLine1.style.backgroundColor = this.cursorColor;
        horizontalLine1.style.left = `${pickSize / 2}px`;
        horizontalLine1.style.bottom = `50%`;
        const horizontalLine2 = document.createElement('div');
        horizontalLine2.style.position = 'absolute';
        horizontalLine2.style.width = `${crossSize / 2 - pickSize / 2}px`;
        horizontalLine2.style.height = '1px';
        horizontalLine2.style.backgroundColor = this.cursorColor;
        horizontalLine2.style.right = `${pickSize / 2}px`;
        horizontalLine2.style.bottom = `50%`;
        // 创建垂直线
        const verticalLine1 = document.createElement('div');
        verticalLine1.style.position = 'absolute';
        verticalLine1.style.width = '1px';
        verticalLine1.style.height = `${crossSize / 2 - pickSize / 2}px`;
        verticalLine1.style.backgroundColor = this.cursorColor;
        verticalLine1.style.top = `${pickSize / 2}px`;
        verticalLine1.style.right = `-50%`;
        const verticalLine2 = document.createElement('div');
        verticalLine2.style.position = 'absolute';
        verticalLine2.style.width = '1px';
        verticalLine2.style.height = `${crossSize / 2 - pickSize / 2}px`;
        verticalLine2.style.backgroundColor = this.cursorColor;
        verticalLine2.style.bottom = `${pickSize / 2}px`;
        verticalLine2.style.right = `-50%`;
        // 创建框
        const rect = document.createElement('div');
        rect.style.position = 'absolute';
        rect.style.width = `${pickSize}px`;
        rect.style.height = `${pickSize}px`;
        rect.style.backgroundColor = 'transparent';
        rect.style.border = `1px solid ${this.cursorColor}`;
        rect.style.left = `${-pickSize / 2}px`;
        rect.style.top = `${-pickSize / 2}px`;
        rect.style.boxSizing = `border-box`;
        root.appendChild(horizontalLine1);
        root.appendChild(horizontalLine2);
        root.appendChild(verticalLine1);
        root.appendChild(verticalLine2);
        root.appendChild(rect);
    }
}/**
 * 拾取光标标签
 */
class PickCursorLabel extends LabelBase {
    /**
     * 构造函数
     */
    constructor(cursorColor = "#fff") {
        super(false);
        /**
         * 光标颜色
         */
        this.cursorColor = "#fff";
        this.cursorColor = cursorColor;
        this.generate();
    }
    /**
     * 生成光标标签
     */
    generate() {
        const root = this.obj.element;
        root.replaceChildren();
        const pickSize = 12;
        this.obj.renderOrder = 10000;
        // 创建框
        const rect = document.createElement('div');
        rect.style.position = 'absolute';
        rect.style.width = `${pickSize}px`;
        rect.style.height = `${pickSize}px`;
        rect.style.backgroundColor = 'transparent';
        rect.style.border = `1px solid ${this.cursorColor}`;
        rect.style.left = `${-pickSize / 2}px`;
        rect.style.top = `${-pickSize / 2}px`;
        rect.style.boxSizing = `border-box`;
        root.appendChild(rect);
    }
}/**
 * 光标信息存储器
 */
class CursorStore {
    set hiddenCursor(value) {
        this._hiddenCursor = value;
        let cursor = this.cursors[this.currentCursorType];
        if (cursor == null)
            return;
        if (!!value) {
            cursor.obj.visible = false;
        }
        else {
            cursor.obj.visible = true;
        }
    }
    get hiddenCursor() {
        return this._hiddenCursor;
    }
    /**
     * 构造函数 初始化光标
     */
    constructor() {
        /**
         * 光标池
         */
        this.cursors = {};
        /**
         * 当前光标类型
         */
        this.currentCursorType = CursorType.PICK_CROSS;
        /**
         * 光标颜色
         */
        this.cursorColor = "#111";
        /**
         * 光标全局显隐
         */
        this.cursorShow = true;
        /**
         * 光标隐藏
         */
        this._hiddenCursor = false;
        this.cursors[CursorType.PICK_CROSS] = new PickCrossCursorLabel(this.cursorColor);
        this.cursors[CursorType.CROSS] = new CrossCursorLabel(this.cursorColor);
        this.cursors[CursorType.PICK] = new PickCursorLabel(this.cursorColor);
    }
    /**
     * 销毁
     */
    dispose() {
        delete this.cursors;
    }
}/**
 * 夹点存储器
 */
class ClampStore {
    constructor() {
        /**
         * 夹点
         */
        this.clampPoints = [];
        /**
         * 激活的夹点
         */
        this.activeClampPoints = [];
        /**
         * 吸附夹点的阈值
         */
        this.threshold = 10;
        /**
         * 隐藏夹点
         */
        this.clampHidden = false;
        /**
         * 弃用夹点
         */
        this.clampDisable = false;
    }
    /**
     * 清空夹点
     */
    clear() {
        for (let cp of this.activeClampPoints) {
            cp.isActive = false;
        }
        this.activeClampPoints = [];
        for (let cp of this.clampPoints) {
            cp.remove();
        }
        this.clampPoints = [];
    }
    /**
     * 销毁
     */
    dispose() {
        this.clear();
    }
}/**
 * 正交极轴存储器
 */
class OrthoPolarStore {
    constructor() {
        /**
         * 正交追踪开关
         */
        this.orthoEnabled = false;
        /**
         * 正交追踪激活（默认激活）
         */
        this.orthoActive = true;
        /**
         * 极轴追踪开关
         */
        this.polarEnabled = false;
    }
    /**
     * 销毁
     */
    dispose() {
        this.orthoPolarPoint = null;
    }
}/**
 * 文字存储器
 */
class TextStore {
    constructor() {
        /**
         * 默认文字高度
         */
        this.defaultHeight = 10;
    }
    /**
     * 销毁
     */
    dispose() {
        this.font = null;
    }
}/**
 * 块存储器
 */
class BlockStore {
    constructor() {
        /**
         * 块模板列表
         */
        this.blockTemplateDict = {};
    }
    /**
     * 销毁
     */
    dispose() {
        delete this.blockTemplateDict;
        this.activeBlock = null;
    }
}/**
 * 图层存储
 */
class LayerStore {
    constructor() {
        /**
         * 图层列表
         */
        this.layers = [];
        /**
         * 当前默认颜色
         */
        this.defaultColor = "#ffba84";
        /**
         * 颜色是否随图层
         */
        this.colorByLayer = true;
    }
    /**
     * 获取当前颜色
     * @returns
     */
    getColor() {
        if (this.colorByLayer && !!this.currentLayerUuid) {
            let layer = this.layers.find(item => item.uuid === this.currentLayerUuid);
            return (layer === null || layer === void 0 ? void 0 : layer.color) || "#ffba84";
        }
        return this.defaultColor || "#ffba84";
    }
    /**
     * 销毁
     */
    dispose() {
    }
}/**
 * 组存储器
 */
class GroupStore {
    constructor() {
        /**
         * 块模板列表
         */
        this.groupDict = {};
    }
    /**
     * 销毁
     */
    dispose() {
        delete this.groupDict;
    }
}/**
 * 引擎存储器
 */
class PythaStorage {
    // 私有化构造函数，防止存储器被重复定义
    constructor() {
        //所有图元的外部注册初始化均需要写在此处，防止循环引用
        this.textureStore = new TextureStore();
        this.renderStore = new RenderStore();
        this.viewportStore = new ViewportStore();
        this.primitiveStore = new PrimitiveStore();
        this.captureStore = new CaptureStore();
        this.coordinateStore = new CoordinateStore();
        this.selectStore = new SelectStore();
        this.historyStore = new HistoryStore();
        this.cursorStore = new CursorStore();
        this.clampStore = new ClampStore();
        this.orthoPolarStore = new OrthoPolarStore();
        this.textStore = new TextStore();
        this.blockStore = new BlockStore();
        this.layerStore = new LayerStore();
        this.groupStore = new GroupStore();
        /**
         * 注册存储器放最后
         */
        this.registerStore = new RegisterStore(this);
    }
    /**
     * 初始化存储器
     * @returns
     */
    static init() {
        if (!PythaStorage._instance) {
            PythaStorage._instance = new PythaStorage();
        }
        return PythaStorage._instance;
    }
    /**
     * 关闭单例
     */
    static close() {
        if (PythaStorage._instance) {
            PythaStorage._instance.dispose();
        }
        PythaStorage._instance = null;
    }
    /**
     * 获取存储器唯一实例
     * @returns
     */
    static get instance() {
        if (!PythaStorage._instance) {
            PythaStorage._instance = new PythaStorage();
        }
        return PythaStorage._instance;
    }
    /**
     * 销毁
     */
    dispose() {
        this.textureStore.dispose();
        this.renderStore.dispose();
        this.viewportStore.dispose();
        this.primitiveStore.dispose();
        this.captureStore.dispose();
        this.coordinateStore.dispose();
        this.selectStore.dispose();
        this.historyStore.dispose();
        this.cursorStore.dispose();
        this.clampStore.dispose();
        this.orthoPolarStore.dispose();
        this.textStore.dispose();
        this.blockStore.dispose();
    }
}var dist$7 = {};var dist$6 = {};var DispatcherBase$1 = {};var DispatcherWrapper$1 = {};Object.defineProperty(DispatcherWrapper$1, "__esModule", { value: true });
DispatcherWrapper$1.DispatcherWrapper = void 0;
/**
 * Hides the implementation of the event dispatcher. Will expose methods that
 * are relevent to the event.
 *
 * @export
 * @class DispatcherWrapper
 * @implements {ISubscribable<TEventHandler>}
 * @template TEventHandler The type of event handler.
 */
class DispatcherWrapper {
    /**
     * Creates an instance of DispatcherWrapper.
     * @param {ISubscribable<TEventHandler>} dispatcher
     *
     * @memberOf DispatcherWrapper
     */
    constructor(dispatcher) {
        this._subscribe = (fn) => dispatcher.subscribe(fn);
        this._unsubscribe = (fn) => dispatcher.unsubscribe(fn);
        this._one = (fn) => dispatcher.one(fn);
        this._has = (fn) => dispatcher.has(fn);
        this._clear = () => dispatcher.clear();
        this._count = () => dispatcher.count;
        this._onSubscriptionChange = () => dispatcher.onSubscriptionChange;
    }
    /**
     * Triggered when subscriptions are changed (added or removed).
     *
     * @readonly
     * @type {ISubscribable<SubscriptionChangeEventHandler>}
     * @memberOf DispatcherWrapper
     */
    get onSubscriptionChange() {
        return this._onSubscriptionChange();
    }
    /**
     * Returns the number of subscriptions.
     *
     * @readonly
     * @type {number}
     * @memberOf DispatcherWrapper
     */
    get count() {
        return this._count();
    }
    /**
     * Subscribe to the event dispatcher.
     *
     * @param {TEventHandler} fn The event handler that is called when the event is dispatched.
     * @returns {() => void} A function that unsubscribes the event handler from the event.
     *
     * @memberOf DispatcherWrapper
     */
    subscribe(fn) {
        return this._subscribe(fn);
    }
    /**
     * Subscribe to the event dispatcher.
     *
     * @param {TEventHandler} fn The event handler that is called when the event is dispatched.
     * @returns {() => void} A function that unsubscribes the event handler from the event.
     *
     * @memberOf DispatcherWrapper
     */
    sub(fn) {
        return this.subscribe(fn);
    }
    /**
     * Unsubscribe from the event dispatcher.
     *
     * @param {TEventHandler} fn The event handler that is called when the event is dispatched.
     *
     * @memberOf DispatcherWrapper
     */
    unsubscribe(fn) {
        this._unsubscribe(fn);
    }
    /**
     * Unsubscribe from the event dispatcher.
     *
     * @param {TEventHandler} fn The event handler that is called when the event is dispatched.
     *
     * @memberOf DispatcherWrapper
     */
    unsub(fn) {
        this.unsubscribe(fn);
    }
    /**
     * Subscribe once to the event with the specified name.
     *
     * @returns {() => void} A function that unsubscribes the event handler from the event.
     *
     * @memberOf DispatcherWrapper
     */
    one(fn) {
        return this._one(fn);
    }
    /**
     * Checks it the event has a subscription for the specified handler.
     *
     * @param {TEventHandler} fn The event handler that is called when the event is dispatched.
     *
     * @memberOf DispatcherWrapper
     */
    has(fn) {
        return this._has(fn);
    }
    /**
     * Clears all the subscriptions.
     *
     * @memberOf DispatcherWrapper
     */
    clear() {
        this._clear();
    }
}
DispatcherWrapper$1.DispatcherWrapper = DispatcherWrapper;var Subscription$1 = {};Object.defineProperty(Subscription$1, "__esModule", { value: true });
Subscription$1.Subscription = void 0;
/**
 * Stores a handler. Manages execution meta data.
 * @class Subscription
 * @template TEventHandler
 */
class Subscription {
    /**
     * Creates an instance of Subscription.
     *
     * @param {TEventHandler} handler The handler for the subscription.
     * @param {boolean} isOnce Indicates if the handler should only be executed once.
     */
    constructor(handler, isOnce) {
        this.handler = handler;
        this.isOnce = isOnce;
        /**
         * Indicates if the subscription has been executed before.
         */
        this.isExecuted = false;
    }
    /**
     * Executes the handler.
     *
     * @param {boolean} executeAsync True if the even should be executed async.
     * @param {*} scope The scope the scope of the event.
     * @param {IArguments} args The arguments for the event.
     */
    execute(executeAsync, scope, args) {
        if (!this.isOnce || !this.isExecuted) {
            this.isExecuted = true;
            var fn = this.handler;
            if (executeAsync) {
                setTimeout(() => {
                    fn.apply(scope, args);
                }, 1);
            }
            else {
                fn.apply(scope, args);
            }
        }
    }
}
Subscription$1.Subscription = Subscription;var EventManagement$1 = {};Object.defineProperty(EventManagement$1, "__esModule", { value: true });
EventManagement$1.EventManagement = void 0;
/**
 * Allows the user to interact with the event.
 *
 * @export
 * @class EventManagement
 * @implements {IEventManagement}
 */
class EventManagement {
    /**
     * Creates an instance of EventManagement.
     * @param {() => void} unsub An unsubscribe handler.
     *
     * @memberOf EventManagement
     */
    constructor(unsub) {
        this.unsub = unsub;
        this.propagationStopped = false;
    }
    /**
     * Stops the propagation of the event.
     * Cannot be used when async dispatch is done.
     *
     * @memberOf EventManagement
     */
    stopPropagation() {
        this.propagationStopped = true;
    }
}
EventManagement$1.EventManagement = EventManagement;Object.defineProperty(DispatcherBase$1, "__esModule", { value: true });
DispatcherBase$1.SubscriptionChangeEventDispatcher = DispatcherBase$1.DispatcherBase = void 0;
const DispatcherWrapper_1 = DispatcherWrapper$1;
const Subscription_1 = Subscription$1;
const EventManagement_1$1 = EventManagement$1;
/**
 * Base class for implementation of the dispatcher. It facilitates the subscribe
 * and unsubscribe methods based on generic handlers. The TEventType specifies
 * the type of event that should be exposed. Use the asEvent to expose the
 * dispatcher as event.
 *
 * @export
 * @abstract
 * @class DispatcherBase
 * @implements {ISubscribable<TEventHandler>}
 * @template TEventHandler The type of event handler.
 */
class DispatcherBase {
    constructor() {
        /**
         * The subscriptions.
         *
         * @protected
         *
         * @memberOf DispatcherBase
         */
        this._subscriptions = new Array();
    }
    /**
     * Returns the number of subscriptions.
     *
     * @readonly
     * @type {number}
     * @memberOf DispatcherBase
     */
    get count() {
        return this._subscriptions.length;
    }
    /**
     * Triggered when subscriptions are changed (added or removed).
     *
     * @readonly
     * @type {ISubscribable<SubscriptionChangeEventHandler>}
     * @memberOf DispatcherBase
     */
    get onSubscriptionChange() {
        if (this._onSubscriptionChange == null) {
            this._onSubscriptionChange = new SubscriptionChangeEventDispatcher();
        }
        return this._onSubscriptionChange.asEvent();
    }
    /**
     * Subscribe to the event dispatcher.
     *
     * @param {TEventHandler} fn The event handler that is called when the event is dispatched.
     * @returns A function that unsubscribes the event handler from the event.
     *
     * @memberOf DispatcherBase
     */
    subscribe(fn) {
        if (fn) {
            this._subscriptions.push(this.createSubscription(fn, false));
            this.triggerSubscriptionChange();
        }
        return () => {
            this.unsubscribe(fn);
        };
    }
    /**
     * Subscribe to the event dispatcher.
     *
     * @param {TEventHandler} fn The event handler that is called when the event is dispatched.
     * @returns A function that unsubscribes the event handler from the event.
     *
     * @memberOf DispatcherBase
     */
    sub(fn) {
        return this.subscribe(fn);
    }
    /**
     * Subscribe once to the event with the specified name.
     *
     * @param {TEventHandler} fn The event handler that is called when the event is dispatched.
     * @returns A function that unsubscribes the event handler from the event.
     *
     * @memberOf DispatcherBase
     */
    one(fn) {
        if (fn) {
            this._subscriptions.push(this.createSubscription(fn, true));
            this.triggerSubscriptionChange();
        }
        return () => {
            this.unsubscribe(fn);
        };
    }
    /**
     * Checks it the event has a subscription for the specified handler.
     *
     * @param {TEventHandler} fn The event handler.
     *
     * @memberOf DispatcherBase
     */
    has(fn) {
        if (!fn)
            return false;
        return this._subscriptions.some((sub) => sub.handler == fn);
    }
    /**
     * Unsubscribes the handler from the dispatcher.
     *
     * @param {TEventHandler} fn The event handler.
     *
     * @memberOf DispatcherBase
     */
    unsubscribe(fn) {
        if (!fn)
            return;
        let changes = false;
        for (let i = 0; i < this._subscriptions.length; i++) {
            if (this._subscriptions[i].handler == fn) {
                this._subscriptions.splice(i, 1);
                changes = true;
                break;
            }
        }
        if (changes) {
            this.triggerSubscriptionChange();
        }
    }
    /**
     * Unsubscribes the handler from the dispatcher.
     *
     * @param {TEventHandler} fn The event handler.
     *
     * @memberOf DispatcherBase
     */
    unsub(fn) {
        this.unsubscribe(fn);
    }
    /**
     * Generic dispatch will dispatch the handlers with the given arguments.
     *
     * @protected
     * @param {boolean} executeAsync `True` if the even should be executed async.
     * @param {*} scope The scope of the event. The scope becomes the `this` for handler.
     * @param {IArguments} args The arguments for the event.
     * @returns {(IPropagationStatus | null)} The propagation status, or if an `executeAsync` is used `null`.
     *
     * @memberOf DispatcherBase
     */
    _dispatch(executeAsync, scope, args) {
        //execute on a copy because of bug #9
        for (let sub of [...this._subscriptions]) {
            let ev = new EventManagement_1$1.EventManagement(() => this.unsub(sub.handler));
            let nargs = Array.prototype.slice.call(args);
            nargs.push(ev);
            let s = sub;
            s.execute(executeAsync, scope, nargs);
            //cleanup subs that are no longer needed
            this.cleanup(sub);
            if (!executeAsync && ev.propagationStopped) {
                return { propagationStopped: true };
            }
        }
        if (executeAsync) {
            return null;
        }
        return { propagationStopped: false };
    }
    /**
     * Creates a subscription.
     *
     * @protected
     * @param {TEventHandler} handler The handler.
     * @param {boolean} isOnce True if the handler should run only one.
     * @returns {ISubscription<TEventHandler>} The subscription.
     *
     * @memberOf DispatcherBase
     */
    createSubscription(handler, isOnce) {
        return new Subscription_1.Subscription(handler, isOnce);
    }
    /**
     * Cleans up subs that ran and should run only once.
     *
     * @protected
     * @param {ISubscription<TEventHandler>} sub The subscription.
     *
     * @memberOf DispatcherBase
     */
    cleanup(sub) {
        let changes = false;
        if (sub.isOnce && sub.isExecuted) {
            let i = this._subscriptions.indexOf(sub);
            if (i > -1) {
                this._subscriptions.splice(i, 1);
                changes = true;
            }
        }
        if (changes) {
            this.triggerSubscriptionChange();
        }
    }
    /**
     * Creates an event from the dispatcher. Will return the dispatcher
     * in a wrapper. This will prevent exposure of any dispatcher methods.
     *
     * @returns {ISubscribable<TEventHandler>}
     *
     * @memberOf DispatcherBase
     */
    asEvent() {
        if (this._wrap == null) {
            this._wrap = new DispatcherWrapper_1.DispatcherWrapper(this);
        }
        return this._wrap;
    }
    /**
     * Clears the subscriptions.
     *
     * @memberOf DispatcherBase
     */
    clear() {
        if (this._subscriptions.length != 0) {
            this._subscriptions.splice(0, this._subscriptions.length);
            this.triggerSubscriptionChange();
        }
    }
    /**
     * Triggers the subscription change event.
     *
     * @private
     *
     * @memberOf DispatcherBase
     */
    triggerSubscriptionChange() {
        if (this._onSubscriptionChange != null) {
            this._onSubscriptionChange.dispatch(this.count);
        }
    }
}
DispatcherBase$1.DispatcherBase = DispatcherBase;
/**
 * Dispatcher for subscription changes.
 *
 * @export
 * @class SubscriptionChangeEventDispatcher
 * @extends {DispatcherBase<SubscriptionChangeEventHandler>}
 */
class SubscriptionChangeEventDispatcher extends DispatcherBase {
    /**
     * Dispatches the event.
     *
     * @param {number} count The currrent number of subscriptions.
     *
     * @memberOf SubscriptionChangeEventDispatcher
     */
    dispatch(count) {
        this._dispatch(false, this, arguments);
    }
}
DispatcherBase$1.SubscriptionChangeEventDispatcher = SubscriptionChangeEventDispatcher;var DispatchError$1 = {};Object.defineProperty(DispatchError$1, "__esModule", { value: true });
DispatchError$1.DispatchError = void 0;
/**
 * Indicates an error with dispatching.
 *
 * @export
 * @class DispatchError
 * @extends {Error}
 */
class DispatchError extends Error {
    /**
     * Creates an instance of DispatchError.
     * @param {string} message The message.
     *
     * @memberOf DispatchError
     */
    constructor(message) {
        super(message);
    }
}
DispatchError$1.DispatchError = DispatchError;var EventListBase$1 = {};Object.defineProperty(EventListBase$1, "__esModule", { value: true });
EventListBase$1.EventListBase = void 0;
/**
 * Base class for event lists classes. Implements the get and remove.
 *
 * @export
 * @abstract
 * @class EventListBaset
 * @template TEventDispatcher The type of event dispatcher.
 */
class EventListBase {
    constructor() {
        this._events = {};
    }
    /**
     * Gets the dispatcher associated with the name.
     *
     * @param {string} name The name of the event.
     * @returns {TEventDispatcher} The disptacher.
     *
     * @memberOf EventListBase
     */
    get(name) {
        let event = this._events[name];
        if (event) {
            return event;
        }
        event = this.createDispatcher();
        this._events[name] = event;
        return event;
    }
    /**
     * Removes the dispatcher associated with the name.
     *
     * @param {string} name
     *
     * @memberOf EventListBase
     */
    remove(name) {
        delete this._events[name];
    }
}
EventListBase$1.EventListBase = EventListBase;var HandlingBase$1 = {};Object.defineProperty(HandlingBase$1, "__esModule", { value: true });
HandlingBase$1.HandlingBase = void 0;
/**
 * Base class that implements event handling. With a an
 * event list this base class will expose events that can be
 * subscribed to. This will give your class generic events.
 *
 * @export
 * @abstract
 * @class HandlingBase
 * @template TEventHandler The type of event handler.
 * @template TDispatcher The type of dispatcher.
 * @template TList The type of event list.
 */
class HandlingBase {
    /**
     * Creates an instance of HandlingBase.
     * @param {TList} events The event list. Used for event management.
     *
     * @memberOf HandlingBase
     */
    constructor(events) {
        this.events = events;
    }
    /**
     * Subscribes once to the event with the specified name.
     * @param {string} name The name of the event.
     * @param {TEventHandler} fn The event handler.
     *
     * @memberOf HandlingBase
     */
    one(name, fn) {
        this.events.get(name).one(fn);
    }
    /**
     * Checks it the event has a subscription for the specified handler.
     * @param {string} name The name of the event.
     * @param {TEventHandler} fn The event handler.
     *
     * @memberOf HandlingBase
     */
    has(name, fn) {
        return this.events.get(name).has(fn);
    }
    /**
     * Subscribes to the event with the specified name.
     * @param {string} name The name of the event.
     * @param {TEventHandler} fn The event handler.
     *
     * @memberOf HandlingBase
     */
    subscribe(name, fn) {
        this.events.get(name).subscribe(fn);
    }
    /**
     * Subscribes to the event with the specified name.
     * @param {string} name The name of the event.
     * @param {TEventHandler} fn The event handler.
     *
     * @memberOf HandlingBase
     */
    sub(name, fn) {
        this.subscribe(name, fn);
    }
    /**
     * Unsubscribes from the event with the specified name.
     * @param {string} name The name of the event.
     * @param {TEventHandler} fn The event handler.
     *
     * @memberOf HandlingBase
     */
    unsubscribe(name, fn) {
        this.events.get(name).unsubscribe(fn);
    }
    /**
     * Unsubscribes from the event with the specified name.
     * @param {string} name The name of the event.
     * @param {TEventHandler} fn The event handler.
     *
     * @memberOf HandlingBase
     */
    unsub(name, fn) {
        this.unsubscribe(name, fn);
    }
}
HandlingBase$1.HandlingBase = HandlingBase;var PromiseDispatcherBase$1 = {};var PromiseSubscription$1 = {};Object.defineProperty(PromiseSubscription$1, "__esModule", { value: true });
PromiseSubscription$1.PromiseSubscription = void 0;
/**
 * Subscription implementation for events with promises.
 *
 * @export
 * @class PromiseSubscription
 * @implements {ISubscription<TEventHandler>}
 * @template TEventHandler The type of event handler.
 */
class PromiseSubscription {
    /**
     * Creates an instance of PromiseSubscription.
     * @param {TEventHandler} handler The handler for the subscription.
     * @param {boolean} isOnce Indicates if the handler should only be executed once.
     *
     * @memberOf PromiseSubscription
     */
    constructor(handler, isOnce) {
        this.handler = handler;
        this.isOnce = isOnce;
        /**
         * Indicates if the subscription has been executed before.
         *
         * @memberOf PromiseSubscription
         */
        this.isExecuted = false;
    }
    /**
     * Executes the handler.
     *
     * @param {boolean} executeAsync True if the even should be executed async.
     * @param {*} scope The scope the scope of the event.
     * @param {IArguments} args The arguments for the event.
     *
     * @memberOf PromiseSubscription
     */
    async execute(executeAsync, scope, args) {
        if (!this.isOnce || !this.isExecuted) {
            this.isExecuted = true;
            //TODO: do we need to cast to any -- seems yuck
            var fn = this.handler;
            if (executeAsync) {
                setTimeout(() => {
                    fn.apply(scope, args);
                }, 1);
                return;
            }
            let result = fn.apply(scope, args);
            await result;
        }
    }
}
PromiseSubscription$1.PromiseSubscription = PromiseSubscription;Object.defineProperty(PromiseDispatcherBase$1, "__esModule", { value: true });
PromiseDispatcherBase$1.PromiseDispatcherBase = void 0;
const PromiseSubscription_1 = PromiseSubscription$1;
const EventManagement_1 = EventManagement$1;
const DispatcherBase_1 = DispatcherBase$1;
const DispatchError_1 = DispatchError$1;
/**
 * Dispatcher base for dispatchers that use promises. Each promise
 * is awaited before the next is dispatched, unless the event is
 * dispatched with the executeAsync flag.
 *
 * @export
 * @abstract
 * @class PromiseDispatcherBase
 * @extends {DispatcherBase<TEventHandler>}
 * @template TEventHandler The type of event handler.
 */
class PromiseDispatcherBase extends DispatcherBase_1.DispatcherBase {
    /**
     * The normal dispatch cannot be used in this class.
     *
     * @protected
     * @param {boolean} executeAsync `True` if the even should be executed async.
     * @param {*} scope The scope of the event. The scope becomes the `this` for handler.
     * @param {IArguments} args The arguments for the event.
     * @returns {(IPropagationStatus | null)} The propagation status, or if an `executeAsync` is used `null`.
     *
     * @memberOf DispatcherBase
     */
    _dispatch(executeAsync, scope, args) {
        throw new DispatchError_1.DispatchError("_dispatch not supported. Use _dispatchAsPromise.");
    }
    /**
     * Crates a new subscription.
     *
     * @protected
     * @param {TEventHandler} handler The handler.
     * @param {boolean} isOnce Indicates if the handler should only run once.
     * @returns {ISubscription<TEventHandler>} The subscription.
     *
     * @memberOf PromiseDispatcherBase
     */
    createSubscription(handler, isOnce) {
        return new PromiseSubscription_1.PromiseSubscription(handler, isOnce);
    }
    /**
     * Generic dispatch will dispatch the handlers with the given arguments.
     *
     * @protected
     * @param {boolean} executeAsync `True` if the even should be executed async.
     * @param {*} scope The scope of the event. The scope becomes the `this` for handler.
     * @param {IArguments} args The arguments for the event.
     * @returns {(IPropagationStatus | null)} The propagation status, or if an `executeAsync` is used `null`.
     *
     * @memberOf DispatcherBase
     */
    async _dispatchAsPromise(executeAsync, scope, args) {
        //execute on a copy because of bug #9
        for (let sub of [...this._subscriptions]) {
            let ev = new EventManagement_1.EventManagement(() => this.unsub(sub.handler));
            let nargs = Array.prototype.slice.call(args);
            nargs.push(ev);
            let ps = sub;
            await ps.execute(executeAsync, scope, nargs);
            //cleanup subs that are no longer needed
            this.cleanup(sub);
            if (!executeAsync && ev.propagationStopped) {
                return { propagationStopped: true };
            }
        }
        if (executeAsync) {
            return null;
        }
        return { propagationStopped: false };
    }
}
PromiseDispatcherBase$1.PromiseDispatcherBase = PromiseDispatcherBase;(function (exports) {
	/*!
	 * Strongly Typed Events for TypeScript - Core
	 * https://github.com/KeesCBakker/StronlyTypedEvents/
	 * http://keestalkstech.com
	 *
	 * Copyright Kees C. Bakker / KeesTalksTech
	 * Released under the MIT license
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SubscriptionChangeEventDispatcher = exports.HandlingBase = exports.PromiseDispatcherBase = exports.PromiseSubscription = exports.DispatchError = exports.EventManagement = exports.EventListBase = exports.DispatcherWrapper = exports.DispatcherBase = exports.Subscription = void 0;
	const DispatcherBase_1 = DispatcherBase$1;
	Object.defineProperty(exports, "DispatcherBase", { enumerable: true, get: function () { return DispatcherBase_1.DispatcherBase; } });
	Object.defineProperty(exports, "SubscriptionChangeEventDispatcher", { enumerable: true, get: function () { return DispatcherBase_1.SubscriptionChangeEventDispatcher; } });
	const DispatchError_1 = DispatchError$1;
	Object.defineProperty(exports, "DispatchError", { enumerable: true, get: function () { return DispatchError_1.DispatchError; } });
	const DispatcherWrapper_1 = DispatcherWrapper$1;
	Object.defineProperty(exports, "DispatcherWrapper", { enumerable: true, get: function () { return DispatcherWrapper_1.DispatcherWrapper; } });
	const EventListBase_1 = EventListBase$1;
	Object.defineProperty(exports, "EventListBase", { enumerable: true, get: function () { return EventListBase_1.EventListBase; } });
	const EventManagement_1 = EventManagement$1;
	Object.defineProperty(exports, "EventManagement", { enumerable: true, get: function () { return EventManagement_1.EventManagement; } });
	const HandlingBase_1 = HandlingBase$1;
	Object.defineProperty(exports, "HandlingBase", { enumerable: true, get: function () { return HandlingBase_1.HandlingBase; } });
	const PromiseDispatcherBase_1 = PromiseDispatcherBase$1;
	Object.defineProperty(exports, "PromiseDispatcherBase", { enumerable: true, get: function () { return PromiseDispatcherBase_1.PromiseDispatcherBase; } });
	const PromiseSubscription_1 = PromiseSubscription$1;
	Object.defineProperty(exports, "PromiseSubscription", { enumerable: true, get: function () { return PromiseSubscription_1.PromiseSubscription; } });
	const Subscription_1 = Subscription$1;
	Object.defineProperty(exports, "Subscription", { enumerable: true, get: function () { return Subscription_1.Subscription; } }); 
} (dist$6));var dist$5 = {};var EventDispatcher$1 = {};Object.defineProperty(EventDispatcher$1, "__esModule", { value: true });
EventDispatcher$1.EventDispatcher = void 0;
const ste_core_1$h = dist$6;
/**
 * Dispatcher implementation for events. Can be used to subscribe, unsubscribe
 * or dispatch events. Use the ToEvent() method to expose the event.
 *
 * @export
 * @class EventDispatcher
 * @extends {DispatcherBase<IEventHandler<TSender, TArgs>>}
 * @implements {IEvent<TSender, TArgs>}
 * @template TSender The sender type.
 * @template TArgs The event arguments type.
 */
class EventDispatcher extends ste_core_1$h.DispatcherBase {
    /**
     * Creates an instance of EventDispatcher.
     *
     * @memberOf EventDispatcher
     */
    constructor() {
        super();
    }
    /**
     * Dispatches the event.
     *
     * @param {TSender} sender The sender.
     * @param {TArgs} args The arguments.
     * @returns {IPropagationStatus} The propagation status to interact with the event
     *
     * @memberOf EventDispatcher
     */
    dispatch(sender, args) {
        const result = this._dispatch(false, this, arguments);
        if (result == null) {
            throw new ste_core_1$h.DispatchError("Got `null` back from dispatch.");
        }
        return result;
    }
    /**
     * Dispatches the event in an async way. Does not support event interaction.
     *
     * @param {TSender} sender The sender.
     * @param {TArgs} args The arguments.
     *
     * @memberOf EventDispatcher
     */
    dispatchAsync(sender, args) {
        this._dispatch(true, this, arguments);
    }
    /**
     * Creates an event from the dispatcher. Will return the dispatcher
     * in a wrapper. This will prevent exposure of any dispatcher methods.
     *
     * @returns {IEvent<TSender, TArgs>} The event.
     *
     * @memberOf EventDispatcher
     */
    asEvent() {
        return super.asEvent();
    }
}
EventDispatcher$1.EventDispatcher = EventDispatcher;var EventHandlingBase$1 = {};var EventList$1 = {};Object.defineProperty(EventList$1, "__esModule", { value: true });
EventList$1.EventList = void 0;
const ste_core_1$g = dist$6;
const EventDispatcher_1$1 = EventDispatcher$1;
/**
 * Storage class for multiple events that are accessible by name.
 * Events dispatchers are automatically created.
 */
class EventList extends ste_core_1$g.EventListBase {
    /**
     * Creates a new EventList instance.
     */
    constructor() {
        super();
    }
    /**
     * Creates a new dispatcher instance.
     */
    createDispatcher() {
        return new EventDispatcher_1$1.EventDispatcher();
    }
}
EventList$1.EventList = EventList;Object.defineProperty(EventHandlingBase$1, "__esModule", { value: true });
EventHandlingBase$1.EventHandlingBase = void 0;
const ste_core_1$f = dist$6;
const EventList_1 = EventList$1;
/**
 * Extends objects with signal event handling capabilities.
 */
class EventHandlingBase extends ste_core_1$f.HandlingBase {
    constructor() {
        super(new EventList_1.EventList());
    }
}
EventHandlingBase$1.EventHandlingBase = EventHandlingBase;var NonUniformEventList$1 = {};Object.defineProperty(NonUniformEventList$1, "__esModule", { value: true });
NonUniformEventList$1.NonUniformEventList = void 0;
const EventDispatcher_1 = EventDispatcher$1;
/**
 * Similar to EventList, but instead of TArgs, a map of event names ang argument types is provided with TArgsMap.
 */
class NonUniformEventList {
    constructor() {
        this._events = {};
    }
    /**
     * Gets the dispatcher associated with the name.
     * @param name The name of the event.
     */
    get(name) {
        if (this._events[name]) {
            // @TODO avoid typecasting. Not sure why TS thinks this._events[name] could still be undefined.
            return this._events[name];
        }
        const event = this.createDispatcher();
        this._events[name] = event;
        return event;
    }
    /**
     * Removes the dispatcher associated with the name.
     * @param name The name of the event.
     */
    remove(name) {
        delete this._events[name];
    }
    /**
     * Creates a new dispatcher instance.
     */
    createDispatcher() {
        return new EventDispatcher_1.EventDispatcher();
    }
}
NonUniformEventList$1.NonUniformEventList = NonUniformEventList;(function (exports) {
	/*!
	 * Strongly Typed Events for TypeScript - Core
	 * https://github.com/KeesCBakker/StronlyTypedEvents/
	 * http://keestalkstech.com
	 *
	 * Copyright Kees C. Bakker / KeesTalksTech
	 * Released under the MIT license
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.NonUniformEventList = exports.EventList = exports.EventHandlingBase = exports.EventDispatcher = void 0;
	const EventDispatcher_1 = EventDispatcher$1;
	Object.defineProperty(exports, "EventDispatcher", { enumerable: true, get: function () { return EventDispatcher_1.EventDispatcher; } });
	const EventHandlingBase_1 = EventHandlingBase$1;
	Object.defineProperty(exports, "EventHandlingBase", { enumerable: true, get: function () { return EventHandlingBase_1.EventHandlingBase; } });
	const EventList_1 = EventList$1;
	Object.defineProperty(exports, "EventList", { enumerable: true, get: function () { return EventList_1.EventList; } });
	const NonUniformEventList_1 = NonUniformEventList$1;
	Object.defineProperty(exports, "NonUniformEventList", { enumerable: true, get: function () { return NonUniformEventList_1.NonUniformEventList; } }); 
} (dist$5));var dist$4 = {};var SimpleEventDispatcher$1 = {};Object.defineProperty(SimpleEventDispatcher$1, "__esModule", { value: true });
SimpleEventDispatcher$1.SimpleEventDispatcher = void 0;
const ste_core_1$e = dist$6;
/**
 * The dispatcher handles the storage of subsciptions and facilitates
 * subscription, unsubscription and dispatching of a simple event
 *
 * @export
 * @class SimpleEventDispatcher
 * @extends {DispatcherBase<ISimpleEventHandler<TArgs>>}
 * @implements {ISimpleEvent<TArgs>}
 * @template TArgs
 */
class SimpleEventDispatcher extends ste_core_1$e.DispatcherBase {
    /**
     * Creates an instance of SimpleEventDispatcher.
     *
     * @memberOf SimpleEventDispatcher
     */
    constructor() {
        super();
    }
    /**
     * Dispatches the event.
     *
     * @param {TArgs} args The arguments object.
     * @returns {IPropagationStatus} The status of the event.
     *
     * @memberOf SimpleEventDispatcher
     */
    dispatch(args) {
        const result = this._dispatch(false, this, arguments);
        if (result == null) {
            throw new ste_core_1$e.DispatchError("Got `null` back from dispatch.");
        }
        return result;
    }
    /**
     * Dispatches the event without waiting for the result.
     *
     * @param {TArgs} args The arguments object.
     *
     * @memberOf SimpleEventDispatcher
     */
    dispatchAsync(args) {
        this._dispatch(true, this, arguments);
    }
    /**
     * Creates an event from the dispatcher. Will return the dispatcher
     * in a wrapper. This will prevent exposure of any dispatcher methods.
     *
     * @returns {ISimpleEvent<TArgs>} The event.
     *
     * @memberOf SimpleEventDispatcher
     */
    asEvent() {
        return super.asEvent();
    }
}
SimpleEventDispatcher$1.SimpleEventDispatcher = SimpleEventDispatcher;var SimpleEventHandlingBase$1 = {};var SimpleEventList$1 = {};Object.defineProperty(SimpleEventList$1, "__esModule", { value: true });
SimpleEventList$1.SimpleEventList = void 0;
const ste_core_1$d = dist$6;
const SimpleEventDispatcher_1$1 = SimpleEventDispatcher$1;
/**
 * Storage class for multiple simple events that are accessible by name.
 * Events dispatchers are automatically created.
 */
class SimpleEventList extends ste_core_1$d.EventListBase {
    /**
     * Creates a new SimpleEventList instance.
     */
    constructor() {
        super();
    }
    /**
     * Creates a new dispatcher instance.
     */
    createDispatcher() {
        return new SimpleEventDispatcher_1$1.SimpleEventDispatcher();
    }
}
SimpleEventList$1.SimpleEventList = SimpleEventList;Object.defineProperty(SimpleEventHandlingBase$1, "__esModule", { value: true });
SimpleEventHandlingBase$1.SimpleEventHandlingBase = void 0;
const ste_core_1$c = dist$6;
const SimpleEventList_1 = SimpleEventList$1;
/**
 * Extends objects with signal event handling capabilities.
 */
class SimpleEventHandlingBase extends ste_core_1$c.HandlingBase {
    constructor() {
        super(new SimpleEventList_1.SimpleEventList());
    }
}
SimpleEventHandlingBase$1.SimpleEventHandlingBase = SimpleEventHandlingBase;var NonUniformSimpleEventList$1 = {};Object.defineProperty(NonUniformSimpleEventList$1, "__esModule", { value: true });
NonUniformSimpleEventList$1.NonUniformSimpleEventList = void 0;
const SimpleEventDispatcher_1 = SimpleEventDispatcher$1;
/**
 * Similar to EventList, but instead of TArgs, a map of event names ang argument types is provided with TArgsMap.
 */
class NonUniformSimpleEventList {
    constructor() {
        this._events = {};
    }
    /**
     * Gets the dispatcher associated with the name.
     * @param name The name of the event.
     */
    get(name) {
        if (this._events[name]) {
            // @TODO avoid typecasting. Not sure why TS thinks this._events[name] could still be undefined.
            return this._events[name];
        }
        const event = this.createDispatcher();
        this._events[name] = event;
        return event;
    }
    /**
     * Removes the dispatcher associated with the name.
     * @param name The name of the event.
     */
    remove(name) {
        delete this._events[name];
    }
    /**
     * Creates a new dispatcher instance.
     */
    createDispatcher() {
        return new SimpleEventDispatcher_1.SimpleEventDispatcher();
    }
}
NonUniformSimpleEventList$1.NonUniformSimpleEventList = NonUniformSimpleEventList;(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.NonUniformSimpleEventList = exports.SimpleEventList = exports.SimpleEventHandlingBase = exports.SimpleEventDispatcher = void 0;
	const SimpleEventDispatcher_1 = SimpleEventDispatcher$1;
	Object.defineProperty(exports, "SimpleEventDispatcher", { enumerable: true, get: function () { return SimpleEventDispatcher_1.SimpleEventDispatcher; } });
	const SimpleEventHandlingBase_1 = SimpleEventHandlingBase$1;
	Object.defineProperty(exports, "SimpleEventHandlingBase", { enumerable: true, get: function () { return SimpleEventHandlingBase_1.SimpleEventHandlingBase; } });
	const NonUniformSimpleEventList_1 = NonUniformSimpleEventList$1;
	Object.defineProperty(exports, "NonUniformSimpleEventList", { enumerable: true, get: function () { return NonUniformSimpleEventList_1.NonUniformSimpleEventList; } });
	const SimpleEventList_1 = SimpleEventList$1;
	Object.defineProperty(exports, "SimpleEventList", { enumerable: true, get: function () { return SimpleEventList_1.SimpleEventList; } }); 
} (dist$4));var dist$3 = {};var SignalDispatcher$1 = {};Object.defineProperty(SignalDispatcher$1, "__esModule", { value: true });
SignalDispatcher$1.SignalDispatcher = void 0;
const ste_core_1$b = dist$6;
/**
 * The dispatcher handles the storage of subsciptions and facilitates
 * subscription, unsubscription and dispatching of a signal event.
 *
 * @export
 * @class SignalDispatcher
 * @extends {DispatcherBase<ISignalHandler>}
 * @implements {ISignal}
 */
class SignalDispatcher extends ste_core_1$b.DispatcherBase {
    /**
     * Dispatches the signal.
     *
     * @returns {IPropagationStatus} The status of the signal.
     *
     * @memberOf SignalDispatcher
     */
    dispatch() {
        const result = this._dispatch(false, this, arguments);
        if (result == null) {
            throw new ste_core_1$b.DispatchError("Got `null` back from dispatch.");
        }
        return result;
    }
    /**
     * Dispatches the signal without waiting for the result.
     *
     * @memberOf SignalDispatcher
     */
    dispatchAsync() {
        this._dispatch(true, this, arguments);
    }
    /**
     * Creates an event from the dispatcher. Will return the dispatcher
     * in a wrapper. This will prevent exposure of any dispatcher methods.
     *
     * @returns {ISignal} The signal.
     *
     * @memberOf SignalDispatcher
     */
    asEvent() {
        return super.asEvent();
    }
}
SignalDispatcher$1.SignalDispatcher = SignalDispatcher;var SignalHandlingBase$1 = {};var SignalList$1 = {};Object.defineProperty(SignalList$1, "__esModule", { value: true });
SignalList$1.SignalList = void 0;
const ste_core_1$a = dist$6;
const SignalDispatcher_1 = SignalDispatcher$1;
/**
 * Storage class for multiple signal events that are accessible by name.
 * Events dispatchers are automatically created.
 *
 * @export
 * @class SignalList
 * @extends {EventListBase<SignalDispatcher>}
 */
class SignalList extends ste_core_1$a.EventListBase {
    /**
     * Creates an instance of SignalList.
     *
     * @memberOf SignalList
     */
    constructor() {
        super();
    }
    /**
     * Creates a new dispatcher instance.
     *
     * @protected
     * @returns {SignalDispatcher}
     *
     * @memberOf SignalList
     */
    createDispatcher() {
        return new SignalDispatcher_1.SignalDispatcher();
    }
}
SignalList$1.SignalList = SignalList;Object.defineProperty(SignalHandlingBase$1, "__esModule", { value: true });
SignalHandlingBase$1.SignalHandlingBase = void 0;
const ste_core_1$9 = dist$6;
const SignalList_1 = SignalList$1;
/**
 * Extends objects with signal event handling capabilities.
 *
 * @export
 * @abstract
 * @class SignalHandlingBase
 * @extends {HandlingBase<ISignalHandler, SignalDispatcher, SignalList>}
 * @implements {ISignalHandling}
 */
class SignalHandlingBase extends ste_core_1$9.HandlingBase {
    /**
     * Creates an instance of SignalHandlingBase.
     *
     * @memberOf SignalHandlingBase
     */
    constructor() {
        super(new SignalList_1.SignalList());
    }
}
SignalHandlingBase$1.SignalHandlingBase = SignalHandlingBase;(function (exports) {
	/*!
	 * Strongly Typed Events for TypeScript - Promise Signals
	 * https://github.com/KeesCBakker/StronlyTypedEvents/
	 * http://keestalkstech.com
	 *
	 * Copyright Kees C. Bakker / KeesTalksTech
	 * Released under the MIT license
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SignalList = exports.SignalHandlingBase = exports.SignalDispatcher = void 0;
	const SignalDispatcher_1 = SignalDispatcher$1;
	Object.defineProperty(exports, "SignalDispatcher", { enumerable: true, get: function () { return SignalDispatcher_1.SignalDispatcher; } });
	const SignalHandlingBase_1 = SignalHandlingBase$1;
	Object.defineProperty(exports, "SignalHandlingBase", { enumerable: true, get: function () { return SignalHandlingBase_1.SignalHandlingBase; } });
	const SignalList_1 = SignalList$1;
	Object.defineProperty(exports, "SignalList", { enumerable: true, get: function () { return SignalList_1.SignalList; } }); 
} (dist$3));var dist$2 = {};var PromiseEventDispatcher$1 = {};Object.defineProperty(PromiseEventDispatcher$1, "__esModule", { value: true });
PromiseEventDispatcher$1.PromiseEventDispatcher = void 0;
const ste_core_1$8 = dist$6;
/**
 * Dispatcher implementation for events. Can be used to subscribe, unsubscribe
 * or dispatch events. Use the ToEvent() method to expose the event.
 *
 * @export
 * @class PromiseEventDispatcher
 * @extends {PromiseDispatcherBase<IPromiseEventHandler<TSender, TArgs>>}
 * @implements {IPromiseEvent<TSender, TArgs>}
 * @template TSender
 * @template TArgs
 */
class PromiseEventDispatcher extends ste_core_1$8.PromiseDispatcherBase {
    /**
     * Creates a new EventDispatcher instance.
     */
    constructor() {
        super();
    }
    /**
     * Dispatches the event.
     *
     * @param {TSender} sender The sender object.
     * @param {TArgs} args The argument object.
     * @returns {Promise<IPropagationStatus>} The status.
     *
     * @memberOf PromiseEventDispatcher
     */
    async dispatch(sender, args) {
        const result = await this._dispatchAsPromise(false, this, arguments);
        if (result == null) {
            throw new ste_core_1$8.DispatchError("Got `null` back from dispatch.");
        }
        return result;
    }
    /**
     * Dispatches the event without waiting for the result.
     *
     * @param {TSender} sender The sender object.
     * @param {TArgs} args The argument object.
     *
     * @memberOf PromiseEventDispatcher
     */
    dispatchAsync(sender, args) {
        this._dispatchAsPromise(true, this, arguments);
    }
    /**
     * Creates an event from the dispatcher. Will return the dispatcher
     * in a wrapper. This will prevent exposure of any dispatcher methods.
     */
    asEvent() {
        return super.asEvent();
    }
}
PromiseEventDispatcher$1.PromiseEventDispatcher = PromiseEventDispatcher;var PromiseEventHandlingBase$1 = {};var PromiseEventList$1 = {};Object.defineProperty(PromiseEventList$1, "__esModule", { value: true });
PromiseEventList$1.PromiseEventList = void 0;
const ste_core_1$7 = dist$6;
const PromiseEventDispatcher_1$1 = PromiseEventDispatcher$1;
/**
 * Storage class for multiple events that are accessible by name.
 * Events dispatchers are automatically created.
 */
class PromiseEventList extends ste_core_1$7.EventListBase {
    /**
     * Creates a new EventList instance.
     */
    constructor() {
        super();
    }
    /**
     * Creates a new dispatcher instance.
     */
    createDispatcher() {
        return new PromiseEventDispatcher_1$1.PromiseEventDispatcher();
    }
}
PromiseEventList$1.PromiseEventList = PromiseEventList;Object.defineProperty(PromiseEventHandlingBase$1, "__esModule", { value: true });
PromiseEventHandlingBase$1.PromiseEventHandlingBase = void 0;
const ste_core_1$6 = dist$6;
const PromiseEventList_1 = PromiseEventList$1;
/**
 * Extends objects with signal event handling capabilities.
 */
class PromiseEventHandlingBase extends ste_core_1$6.HandlingBase {
    constructor() {
        super(new PromiseEventList_1.PromiseEventList());
    }
}
PromiseEventHandlingBase$1.PromiseEventHandlingBase = PromiseEventHandlingBase;var NonUniformPromiseEventList$1 = {};Object.defineProperty(NonUniformPromiseEventList$1, "__esModule", { value: true });
NonUniformPromiseEventList$1.NonUniformPromiseEventList = void 0;
const PromiseEventDispatcher_1 = PromiseEventDispatcher$1;
/**
 * Similar to EventList, but instead of TArgs, a map of event names ang argument types is provided with TArgsMap.
 */
class NonUniformPromiseEventList {
    constructor() {
        this._events = {};
    }
    /**
     * Gets the dispatcher associated with the name.
     * @param name The name of the event.
     */
    get(name) {
        if (this._events[name]) {
            // @TODO avoid typecasting. Not sure why TS thinks this._events[name] could still be undefined.
            return this._events[name];
        }
        const event = this.createDispatcher();
        this._events[name] = event;
        return event;
    }
    /**
     * Removes the dispatcher associated with the name.
     * @param name The name of the event.
     */
    remove(name) {
        delete this._events[name];
    }
    /**
     * Creates a new dispatcher instance.
     */
    createDispatcher() {
        return new PromiseEventDispatcher_1.PromiseEventDispatcher();
    }
}
NonUniformPromiseEventList$1.NonUniformPromiseEventList = NonUniformPromiseEventList;(function (exports) {
	/*!
	 * Strongly Typed Events for TypeScript - Core
	 * https://github.com/KeesCBakker/StronlyTypedEvents/
	 * http://keestalkstech.com
	 *
	 * Copyright Kees C. Bakker / KeesTalksTech
	 * Released under the MIT license
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.NonUniformPromiseEventList = exports.PromiseEventList = exports.PromiseEventHandlingBase = exports.PromiseEventDispatcher = void 0;
	const PromiseEventDispatcher_1 = PromiseEventDispatcher$1;
	Object.defineProperty(exports, "PromiseEventDispatcher", { enumerable: true, get: function () { return PromiseEventDispatcher_1.PromiseEventDispatcher; } });
	const PromiseEventHandlingBase_1 = PromiseEventHandlingBase$1;
	Object.defineProperty(exports, "PromiseEventHandlingBase", { enumerable: true, get: function () { return PromiseEventHandlingBase_1.PromiseEventHandlingBase; } });
	const PromiseEventList_1 = PromiseEventList$1;
	Object.defineProperty(exports, "PromiseEventList", { enumerable: true, get: function () { return PromiseEventList_1.PromiseEventList; } });
	const NonUniformPromiseEventList_1 = NonUniformPromiseEventList$1;
	Object.defineProperty(exports, "NonUniformPromiseEventList", { enumerable: true, get: function () { return NonUniformPromiseEventList_1.NonUniformPromiseEventList; } }); 
} (dist$2));var dist$1 = {};var PromiseSignalDispatcher$1 = {};Object.defineProperty(PromiseSignalDispatcher$1, "__esModule", { value: true });
PromiseSignalDispatcher$1.PromiseSignalDispatcher = void 0;
const ste_core_1$5 = dist$6;
/**
 * The dispatcher handles the storage of subsciptions and facilitates
 * subscription, unsubscription and dispatching of a signal event.
 */
class PromiseSignalDispatcher extends ste_core_1$5.PromiseDispatcherBase {
    /**
     * Creates a new SignalDispatcher instance.
     */
    constructor() {
        super();
    }
    /**
     * Dispatches the signal.
     *
     * @returns {IPropagationStatus} The status of the dispatch.
     *
     * @memberOf SignalDispatcher
     */
    async dispatch() {
        const result = await this._dispatchAsPromise(false, this, arguments);
        if (result == null) {
            throw new ste_core_1$5.DispatchError("Got `null` back from dispatch.");
        }
        return result;
    }
    /**
     * Dispatches the signal threaded.
     */
    dispatchAsync() {
        this._dispatchAsPromise(true, this, arguments);
    }
    /**
     * Creates an event from the dispatcher. Will return the dispatcher
     * in a wrapper. This will prevent exposure of any dispatcher methods.
     */
    asEvent() {
        return super.asEvent();
    }
}
PromiseSignalDispatcher$1.PromiseSignalDispatcher = PromiseSignalDispatcher;var PromiseSignalHandlingBase$1 = {};var PromiseSignalList$1 = {};Object.defineProperty(PromiseSignalList$1, "__esModule", { value: true });
PromiseSignalList$1.PromiseSignalList = void 0;
const ste_core_1$4 = dist$6;
const PromiseSignalDispatcher_1 = PromiseSignalDispatcher$1;
/**
 * Storage class for multiple signal events that are accessible by name.
 * Events dispatchers are automatically created.
 */
class PromiseSignalList extends ste_core_1$4.EventListBase {
    /**
     * Creates a new SignalList instance.
     */
    constructor() {
        super();
    }
    /**
     * Creates a new dispatcher instance.
     */
    createDispatcher() {
        return new PromiseSignalDispatcher_1.PromiseSignalDispatcher();
    }
}
PromiseSignalList$1.PromiseSignalList = PromiseSignalList;Object.defineProperty(PromiseSignalHandlingBase$1, "__esModule", { value: true });
PromiseSignalHandlingBase$1.PromiseSignalHandlingBase = void 0;
const ste_core_1$3 = dist$6;
const PromiseSignalList_1 = PromiseSignalList$1;
/**
 * Extends objects with signal event handling capabilities.
 */
class PromiseSignalHandlingBase extends ste_core_1$3.HandlingBase {
    constructor() {
        super(new PromiseSignalList_1.PromiseSignalList());
    }
}
PromiseSignalHandlingBase$1.PromiseSignalHandlingBase = PromiseSignalHandlingBase;(function (exports) {
	/*!
	 * Strongly Typed Events for TypeScript - Promise Signals
	 * https://github.com/KeesCBakker/StronlyTypedEvents/
	 * http://keestalkstech.com
	 *
	 * Copyright Kees C. Bakker / KeesTalksTech
	 * Released under the MIT license
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PromiseSignalList = exports.PromiseSignalHandlingBase = exports.PromiseSignalDispatcher = void 0;
	const PromiseSignalDispatcher_1 = PromiseSignalDispatcher$1;
	Object.defineProperty(exports, "PromiseSignalDispatcher", { enumerable: true, get: function () { return PromiseSignalDispatcher_1.PromiseSignalDispatcher; } });
	const PromiseSignalHandlingBase_1 = PromiseSignalHandlingBase$1;
	Object.defineProperty(exports, "PromiseSignalHandlingBase", { enumerable: true, get: function () { return PromiseSignalHandlingBase_1.PromiseSignalHandlingBase; } });
	const PromiseSignalList_1 = PromiseSignalList$1;
	Object.defineProperty(exports, "PromiseSignalList", { enumerable: true, get: function () { return PromiseSignalList_1.PromiseSignalList; } }); 
} (dist$1));var dist = {};var NonUniformPromiseSimpleEventList$1 = {};var PromiseSimpleEventDispatcher$1 = {};Object.defineProperty(PromiseSimpleEventDispatcher$1, "__esModule", { value: true });
PromiseSimpleEventDispatcher$1.PromiseSimpleEventDispatcher = void 0;
const ste_core_1$2 = dist$6;
/**
 * The dispatcher handles the storage of subsciptions and facilitates
 * subscription, unsubscription and dispatching of a simple event
 *
 * @export
 * @class PromiseSimpleEventDispatcher
 * @extends {PromiseDispatcherBase<IPromiseSimpleEventHandler<TArgs>>}
 * @implements {IPromiseSimpleEvent<TArgs>}
 * @template TArgs
 */
class PromiseSimpleEventDispatcher extends ste_core_1$2.PromiseDispatcherBase {
    /**
     * Creates a new SimpleEventDispatcher instance.
     */
    constructor() {
        super();
    }
    /**
     * Dispatches the event.
     * @param args The arguments object.
     * @returns {IPropagationStatus} The status of the dispatch.
     * @memberOf PromiseSimpleEventDispatcher
     */
    async dispatch(args) {
        const result = await this._dispatchAsPromise(false, this, arguments);
        if (result == null) {
            throw new ste_core_1$2.DispatchError("Got `null` back from dispatch.");
        }
        return result;
    }
    /**
     * Dispatches the event without waiting for it to complete.
     * @param args The argument object.
     * @memberOf PromiseSimpleEventDispatcher
     */
    dispatchAsync(args) {
        this._dispatchAsPromise(true, this, arguments);
    }
    /**
     * Creates an event from the dispatcher. Will return the dispatcher
     * in a wrapper. This will prevent exposure of any dispatcher methods.
     */
    asEvent() {
        return super.asEvent();
    }
}
PromiseSimpleEventDispatcher$1.PromiseSimpleEventDispatcher = PromiseSimpleEventDispatcher;Object.defineProperty(NonUniformPromiseSimpleEventList$1, "__esModule", { value: true });
NonUniformPromiseSimpleEventList$1.NonUniformPromiseSimpleEventList = void 0;
const PromiseSimpleEventDispatcher_1$1 = PromiseSimpleEventDispatcher$1;
/**
 * Similar to EventList, but instead of TArgs, a map of event names ang argument types is provided with TArgsMap.
 */
class NonUniformPromiseSimpleEventList {
    constructor() {
        this._events = {};
    }
    /**
     * Gets the dispatcher associated with the name.
     * @param name The name of the event.
     */
    get(name) {
        if (this._events[name]) {
            // @TODO avoid typecasting. Not sure why TS thinks this._events[name] could still be undefined.
            return this._events[name];
        }
        const event = this.createDispatcher();
        this._events[name] = event;
        return event;
    }
    /**
     * Removes the dispatcher associated with the name.
     * @param name The name of the event.
     */
    remove(name) {
        delete this._events[name];
    }
    /**
     * Creates a new dispatcher instance.
     */
    createDispatcher() {
        return new PromiseSimpleEventDispatcher_1$1.PromiseSimpleEventDispatcher();
    }
}
NonUniformPromiseSimpleEventList$1.NonUniformPromiseSimpleEventList = NonUniformPromiseSimpleEventList;var PromiseSimpleEventHandlingBase$1 = {};var PromiseSimpleEventList$1 = {};Object.defineProperty(PromiseSimpleEventList$1, "__esModule", { value: true });
PromiseSimpleEventList$1.PromiseSimpleEventList = void 0;
const ste_core_1$1 = dist$6;
const PromiseSimpleEventDispatcher_1 = PromiseSimpleEventDispatcher$1;
/**
 * Storage class for multiple simple events that are accessible by name.
 * Events dispatchers are automatically created.
 */
class PromiseSimpleEventList extends ste_core_1$1.EventListBase {
    /**
     * Creates a new SimpleEventList instance.
     */
    constructor() {
        super();
    }
    /**
     * Creates a new dispatcher instance.
     */
    createDispatcher() {
        return new PromiseSimpleEventDispatcher_1.PromiseSimpleEventDispatcher();
    }
}
PromiseSimpleEventList$1.PromiseSimpleEventList = PromiseSimpleEventList;Object.defineProperty(PromiseSimpleEventHandlingBase$1, "__esModule", { value: true });
PromiseSimpleEventHandlingBase$1.PromiseSimpleEventHandlingBase = void 0;
const ste_core_1 = dist$6;
const PromiseSimpleEventList_1 = PromiseSimpleEventList$1;
/**
 * Extends objects with signal event handling capabilities.
 */
class PromiseSimpleEventHandlingBase extends ste_core_1.HandlingBase {
    constructor() {
        super(new PromiseSimpleEventList_1.PromiseSimpleEventList());
    }
}
PromiseSimpleEventHandlingBase$1.PromiseSimpleEventHandlingBase = PromiseSimpleEventHandlingBase;(function (exports) {
	/*!
	 * Strongly Typed Events for TypeScript - Core
	 * https://github.com/KeesCBakker/StronlyTypedEvents/
	 * http://keestalkstech.com
	 *
	 * Copyright Kees C. Bakker / KeesTalksTech
	 * Released under the MIT license
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.NonUniformPromiseSimpleEventList = exports.PromiseSimpleEventList = exports.PromiseSimpleEventHandlingBase = exports.PromiseSimpleEventDispatcher = void 0;
	const NonUniformPromiseSimpleEventList_1 = NonUniformPromiseSimpleEventList$1;
	Object.defineProperty(exports, "NonUniformPromiseSimpleEventList", { enumerable: true, get: function () { return NonUniformPromiseSimpleEventList_1.NonUniformPromiseSimpleEventList; } });
	const PromiseSimpleEventDispatcher_1 = PromiseSimpleEventDispatcher$1;
	Object.defineProperty(exports, "PromiseSimpleEventDispatcher", { enumerable: true, get: function () { return PromiseSimpleEventDispatcher_1.PromiseSimpleEventDispatcher; } });
	const PromiseSimpleEventHandlingBase_1 = PromiseSimpleEventHandlingBase$1;
	Object.defineProperty(exports, "PromiseSimpleEventHandlingBase", { enumerable: true, get: function () { return PromiseSimpleEventHandlingBase_1.PromiseSimpleEventHandlingBase; } });
	const PromiseSimpleEventList_1 = PromiseSimpleEventList$1;
	Object.defineProperty(exports, "PromiseSimpleEventList", { enumerable: true, get: function () { return PromiseSimpleEventList_1.PromiseSimpleEventList; } }); 
} (dist));(function (exports) {
	/*!
	 * Strongly Typed Events for TypeScript
	 * https://github.com/KeesCBakker/StronlyTypedEvents/
	 * http://keestalkstech.com
	 *
	 * Copyright Kees C. Bakker / KeesTalksTech
	 * Released under the MIT license
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.NonUniformPromiseSimpleEventList = exports.PromiseSimpleEventList = exports.PromiseSimpleEventHandlingBase = exports.PromiseSimpleEventDispatcher = exports.PromiseSignalList = exports.PromiseSignalHandlingBase = exports.PromiseSignalDispatcher = exports.NonUniformPromiseEventList = exports.PromiseEventList = exports.PromiseEventHandlingBase = exports.PromiseEventDispatcher = exports.SignalList = exports.SignalHandlingBase = exports.SignalDispatcher = exports.NonUniformSimpleEventList = exports.SimpleEventList = exports.SimpleEventHandlingBase = exports.SimpleEventDispatcher = exports.NonUniformEventList = exports.EventList = exports.EventHandlingBase = exports.EventDispatcher = exports.HandlingBase = exports.PromiseDispatcherBase = exports.PromiseSubscription = exports.DispatchError = exports.EventManagement = exports.EventListBase = exports.DispatcherWrapper = exports.DispatcherBase = exports.Subscription = void 0;
	var ste_core_1 = dist$6;
	Object.defineProperty(exports, "Subscription", { enumerable: true, get: function () { return ste_core_1.Subscription; } });
	Object.defineProperty(exports, "DispatcherBase", { enumerable: true, get: function () { return ste_core_1.DispatcherBase; } });
	Object.defineProperty(exports, "DispatcherWrapper", { enumerable: true, get: function () { return ste_core_1.DispatcherWrapper; } });
	Object.defineProperty(exports, "EventListBase", { enumerable: true, get: function () { return ste_core_1.EventListBase; } });
	Object.defineProperty(exports, "EventManagement", { enumerable: true, get: function () { return ste_core_1.EventManagement; } });
	Object.defineProperty(exports, "DispatchError", { enumerable: true, get: function () { return ste_core_1.DispatchError; } });
	Object.defineProperty(exports, "PromiseSubscription", { enumerable: true, get: function () { return ste_core_1.PromiseSubscription; } });
	Object.defineProperty(exports, "PromiseDispatcherBase", { enumerable: true, get: function () { return ste_core_1.PromiseDispatcherBase; } });
	Object.defineProperty(exports, "HandlingBase", { enumerable: true, get: function () { return ste_core_1.HandlingBase; } });
	var ste_events_1 = dist$5;
	Object.defineProperty(exports, "EventDispatcher", { enumerable: true, get: function () { return ste_events_1.EventDispatcher; } });
	Object.defineProperty(exports, "EventHandlingBase", { enumerable: true, get: function () { return ste_events_1.EventHandlingBase; } });
	Object.defineProperty(exports, "EventList", { enumerable: true, get: function () { return ste_events_1.EventList; } });
	Object.defineProperty(exports, "NonUniformEventList", { enumerable: true, get: function () { return ste_events_1.NonUniformEventList; } });
	var ste_simple_events_1 = dist$4;
	Object.defineProperty(exports, "SimpleEventDispatcher", { enumerable: true, get: function () { return ste_simple_events_1.SimpleEventDispatcher; } });
	Object.defineProperty(exports, "SimpleEventHandlingBase", { enumerable: true, get: function () { return ste_simple_events_1.SimpleEventHandlingBase; } });
	Object.defineProperty(exports, "SimpleEventList", { enumerable: true, get: function () { return ste_simple_events_1.SimpleEventList; } });
	Object.defineProperty(exports, "NonUniformSimpleEventList", { enumerable: true, get: function () { return ste_simple_events_1.NonUniformSimpleEventList; } });
	var ste_signals_1 = dist$3;
	Object.defineProperty(exports, "SignalDispatcher", { enumerable: true, get: function () { return ste_signals_1.SignalDispatcher; } });
	Object.defineProperty(exports, "SignalHandlingBase", { enumerable: true, get: function () { return ste_signals_1.SignalHandlingBase; } });
	Object.defineProperty(exports, "SignalList", { enumerable: true, get: function () { return ste_signals_1.SignalList; } });
	var ste_promise_events_1 = dist$2;
	Object.defineProperty(exports, "PromiseEventDispatcher", { enumerable: true, get: function () { return ste_promise_events_1.PromiseEventDispatcher; } });
	Object.defineProperty(exports, "PromiseEventHandlingBase", { enumerable: true, get: function () { return ste_promise_events_1.PromiseEventHandlingBase; } });
	Object.defineProperty(exports, "PromiseEventList", { enumerable: true, get: function () { return ste_promise_events_1.PromiseEventList; } });
	Object.defineProperty(exports, "NonUniformPromiseEventList", { enumerable: true, get: function () { return ste_promise_events_1.NonUniformPromiseEventList; } });
	var ste_promise_signals_1 = dist$1;
	Object.defineProperty(exports, "PromiseSignalDispatcher", { enumerable: true, get: function () { return ste_promise_signals_1.PromiseSignalDispatcher; } });
	Object.defineProperty(exports, "PromiseSignalHandlingBase", { enumerable: true, get: function () { return ste_promise_signals_1.PromiseSignalHandlingBase; } });
	Object.defineProperty(exports, "PromiseSignalList", { enumerable: true, get: function () { return ste_promise_signals_1.PromiseSignalList; } });
	var ste_promise_simple_events_1 = dist;
	Object.defineProperty(exports, "PromiseSimpleEventDispatcher", { enumerable: true, get: function () { return ste_promise_simple_events_1.PromiseSimpleEventDispatcher; } });
	Object.defineProperty(exports, "PromiseSimpleEventHandlingBase", { enumerable: true, get: function () { return ste_promise_simple_events_1.PromiseSimpleEventHandlingBase; } });
	Object.defineProperty(exports, "PromiseSimpleEventList", { enumerable: true, get: function () { return ste_promise_simple_events_1.PromiseSimpleEventList; } });
	Object.defineProperty(exports, "NonUniformPromiseSimpleEventList", { enumerable: true, get: function () { return ste_promise_simple_events_1.NonUniformPromiseSimpleEventList; } }); 
} (dist$7));/**
 * 通知处理器，由事件中介直接管理，接受其他处理的消息，并发送给外部系统
 */
class EventHandlerNotice {
    constructor() {
        this._speaker = new dist$7.EventDispatcher();
    }
    /**
     * 用于订阅通知
     */
    get onNotice() {
        return this._speaker.asEvent();
    }
    /**
     * 用于发送通知
     * @param sender 发送者（事件处理器）
     * @param event 发送的通知事件
     */
    notice(sender, event) {
        this._speaker.dispatch(sender, event);
    }
}/**
 * 事件中介
 */
class EventMediator {
    constructor() {
        /**
         * 初始化后永久激活的图
         */
        this.alwaysActiveGraphs = [];
        /**
         * 传递指令给前台
         * @param e
         * @returns
         */
        this.emitEvent = (e) => {
            var _a, _b;
            // 识别事件
            if (e.cmd === PythaEventName.CMD) {
                // 识别是命令事件
                // 激活图 创建节点关系
                let event = e;
                const cmdData = (event.data || '').toUpperCase();
                let graphTemplate = this.getGraphTemplate(cmdData);
                if (graphTemplate == null) {
                    return;
                }
                const graph = new (graphTemplate)(this);
                if (graph.isAlwaysActive)
                    return;
                if (this.tempActiveGraph) {
                    this.tempActiveGraph.end();
                    // this.tempActiveGraph.pause();
                    // this.graphStack.push(this.tempActiveGraph);
                }
                this.tempActiveGraph = graph;
                // 嫁接图
                const constructors = this.storage.registerStore.getGraftGraph(cmdData);
                if (constructors != null) {
                    const graftMap = graph.graftNodes;
                    for (const graftGraphConstructor of constructors) {
                        const graftGraph = new (graftGraphConstructor)(this);
                        const graftKey = graftGraph._graftKey;
                        const graftNode = graftMap.get(graftKey);
                        if (!graftNode)
                            continue;
                        const order = graftGraph._graftOrder;
                        if (order === GraftOrderEnum.BEFORE) {
                            graph.addGraphPluginAtBefore(graftKey, graftGraph);
                        }
                        else if (order === GraftOrderEnum.AFTER) {
                            graph.addGraphPluginAtAfter(graftKey, graftGraph);
                        }
                    }
                }
                // 获取下一级节点
                let head = graph.start();
                if (head != null)
                    head.run();
                // 缓存上一次命令供调用
                if (graph.putInLastCmd) {
                    this.lastCmd = cmdData;
                }
            }
            else {
                // 识别是其它事件
                // 识别图
                let graphs = [...this.alwaysActiveGraphs];
                if (this.tempActiveGraph != null) {
                    graphs.push(this.tempActiveGraph);
                }
                if (e.cmd == PythaEventName.END) {
                    // 识别是结束事件
                    // 销毁图和处理器
                    for (const graph of graphs) {
                        graph.end();
                    }
                    // if (this.graphStack.length > 0) {
                    //     let graph = this.graphStack.pop();
                    //     graph.goOn();
                    //     this.tempActiveGraph = graph;
                    // } else {
                    this.tempActiveGraph = undefined;
                    // }
                    (_a = this.renderHandler) === null || _a === void 0 ? void 0 : _a.render(true, UpdateType.ALL);
                    if (e.data) {
                        (_b = this.noticeHandler) === null || _b === void 0 ? void 0 : _b.notice(this, { cmd: 'Notice', data: '*结束*' });
                    }
                }
                else {
                    // TODO 单位尺度转化
                    const lengthUnitRatio = this.storage.coordinateStore.lengthUnitRatio;
                    if (e.cmd === PythaEventName.POINTER_DOWN) {
                        //前端输入是ucs坐标，引擎里统一转化为世界坐标
                        const pointerDown = e;
                        if (pointerDown.data.type === "SPECIFY") {
                            pointerDown.data.point.applyMatrix4(this.storage.coordinateStore.activeUcs);
                            pointerDown.data.point.multiplyScalar(lengthUnitRatio); // 尺度转化
                        }
                    }
                    if (e.cmd === PythaEventName.NUMBER) {
                        const event = e;
                        event.data = event.data * lengthUnitRatio;
                    }
                    // 识别是过程事件
                    if (e.cmd === PythaEventName.ANGLE || e.cmd === PythaEventName.COUNT) {
                        e.cmd = PythaEventName.NUMBER; // 将角度和计数合并
                    }
                    for (const graph of graphs) {
                        graph.matchEventAndNode(e);
                    }
                }
            }
        };
        this.noticeHandler = new EventHandlerNotice();
        this.renderHandler = new EventHandlerRender(this);
    }
    /**
     * 根据cmd key获取图模板
     * @param key
     * @returns
     */
    getGraphTemplate(key) {
        const graphTemplate = PythaStorage.instance.registerStore.getEventGraph(key);
        return graphTemplate;
    }
    /**
     * 销毁，引擎关闭时调用
     */
    dispose() {
        // 防止可能的循环引用
        this.noticeHandler = undefined;
        this.renderHandler = undefined;
    }
}/**
 * 框选
 */
class EventHandlerRangeSelect extends EventHandlerBase {
    constructor() {
        super(...arguments);
        /**
         * 包围盒在选择框之外的图元
         */
        this.priBoxOutRects = {};
    }
    /**
     * 计算图元是否在选择框之外
     * @param primitive
     */
    calPriBoxOutRect(primitive, transMat) {
        const storage = this.getPythaStorage();
        //如果有计算包围盒，并且包围盒与点选点没有交点，直接返回
        if (this.priBoxOutRects[primitive.uuid]) {
            return true;
        }
        let boundingBox;
        if (primitive.type == PrimitiveType.Block) {
            // 如果是块，需要去模板里计算 并且要考虑跨模板的转换矩阵问题
            let bt = storage.blockStore.blockTemplateDict[primitive.blockTemplateUuid];
            boundingBox = BlockPrimitive.calBlockBoundingBox(bt, primitive.worldModelMatrix, storage.blockStore.blockTemplateDict);
        }
        else {
            boundingBox = primitive.getBoundingbox();
        }
        if (boundingBox.min == null || boundingBox.max == null) {
            this.priBoxOutRects[primitive.uuid] = true;
            return true;
        }
        let isInView = this.isBoxInView(boundingBox, transMat);
        if (!isInView) {
            this.priBoxOutRects[primitive.uuid] = true;
            return true;
        }
        return false;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        //清空判断图元是否在选择框内的布尔变量
        this.priBoxOutRects = {};
        // 0 这里是开始逻辑
        // 获取选择框
        const _rect = this.node.graph.cache.data['_rect'];
        // 2 选择框是否存在
        if (!_rect) {
            // 3 这里是输出逻辑
            return true;
        }
        const shiftKey = this.node.graph.cache.pointerDownList[this.node.graph.cache.pointerDownList.length - 1].shiftKey;
        // 计算选择图元
        this.rangeSelect(shiftKey);
        // 清除选择框
        _rect.parentElement.removeChild(_rect);
        this.node.graph.cache.data['_rect'] = null;
        // 5 这里是输出逻辑
        return true;
    }
    rangeSelect(shiftKey = false) {
        const _isRansgeSeletcReverse = this.node.graph.cache.data['_isRansgeSeletcReverse'];
        const start_x = this.node.graph.cache.data['start_x'];
        const start_y = this.node.graph.cache.data['start_y'];
        const end_x = this.node.graph.cache.data['end_x'];
        const end_y = this.node.graph.cache.data['end_y'];
        if (!start_x || !start_y || !end_x || !end_y) {
            return;
        }
        let filteredEntities = {};
        if (!!_isRansgeSeletcReverse) {
            filteredEntities = this.selectPrimitivesFromRectReverse(end_x, end_y, start_x, start_y);
        }
        else {
            filteredEntities = this.selectPrimitivesFromRect(start_x, start_y, end_x, end_y);
        }
        const selectStore = PythaStorage.instance.selectStore;
        const viewportStore = PythaStorage.instance.viewportStore;
        const currentCamera = viewportStore.viewportItems[viewportStore.currentViewportKey].camera;
        let selectedUuids = [];
        for (const key of Object.keys(filteredEntities)) {
            let selectPrimitive = filteredEntities[key];
            if (!selectPrimitive.isSelected && !selectPrimitive.unselectable) {
                if (shiftKey)
                    continue;
                selectStore.selectPrimitives.push(selectPrimitive);
                selectPrimitive.isSelected = true;
                this.node.graph.cache.data['rangeSelect'] = true;
                selectedUuids.push(selectPrimitive.uuid); // 将选中的编号置入信号中
                // 计算控制点 stretch用
                if (!currentCamera)
                    return;
                let i = 0;
                for (let geo of selectPrimitive.geos) {
                    let cps = geo.getControlPoints();
                    for (let cp of cps) {
                        _vector$1.copy(cp.point).project(currentCamera);
                        _vector2_1.set(_vector$1.x, _vector$1.y);
                        let selected = _pickRect$1.select(_vector2_1);
                        if (selected) {
                            if (selectPrimitive.selectedControlPoints[i] == null)
                                selectPrimitive.selectedControlPoints[i] = [];
                            selectPrimitive.selectedControlPoints[i].push(cp);
                        }
                    }
                    i++;
                }
            }
            else if (!!selectPrimitive.isSelected) {
                if (shiftKey) {
                    selectPrimitive.isSelected = false;
                    const idx = selectStore.selectPrimitives.findIndex(p => p.uuid === selectPrimitive.uuid);
                    if (idx !== -1) {
                        selectStore.selectPrimitives.splice(idx, 1);
                    }
                    continue;
                }
                selectedUuids.push(selectPrimitive.uuid); // 将选中的编号置入信号中
            }
        }
        // 发送选中图元的事件
        let selectChangeEvent = new PythaEventSelectChange();
        selectChangeEvent.data = {
            uuids: selectedUuids,
            selectRange: _pickRect$1,
        };
        this.node.graph.eventMediator.emitEvent(selectChangeEvent);
    }
    selectPrimitivesFromRectReverse(start_x, start_y, end_x, end_y) {
        var _a, _b, _c, _d;
        const viewportStore = PythaStorage.instance.viewportStore;
        const currentCamera = viewportStore.viewportItems[viewportStore.currentViewportKey].camera;
        const renderStore = PythaStorage.instance.renderStore;
        const objectRenderBucket = renderStore.objectRenderBucket;
        if (!currentCamera)
            return {};
        if (!_pickRect$1) {
            _pickRect$1 = new SelectionRect(currentCamera);
        }
        _pickRect$1.update(new Vector2(start_x, start_y), new Vector2(end_x, end_y));
        if (_pickRect$1.minX === _pickRect$1.maxX && _pickRect$1.minY === _pickRect$1.maxY)
            return {};
        let viewMatrix = currentCamera.matrixWorldInverse;
        let projectMatrix = currentCamera.projectionMatrix;
        let transMat = new Matrix4().identity().premultiply(viewMatrix).premultiply(projectMatrix);
        let filteredEntities = {};
        // 获取所有图元
        const primitiveDict = PythaStorage.instance.primitiveStore.primitiveDict;
        for (let key in primitiveDict) {
            const primitive = primitiveDict[key];
            let flag = this.calPriBoxOutRect(primitive, transMat);
            if (flag)
                continue;
            let isSelected = false;
            // 遍历renderItem
            const renderItemDict = primitive.renderItemDict;
            for (const renderItemKey in renderItemDict) {
                const renderItem = renderItemDict[renderItemKey];
                if (!renderItem) {
                    isSelected = false;
                    break;
                }
                const start = renderItem.start;
                const size = renderItem.size;
                const renderKey = renderItem.lastRenderKey;
                const index = renderItem.renderGeometryBucketIndex;
                const bucket = objectRenderBucket[renderKey];
                const mapItem = bucket.renderBucketItems[index];
                let position = new Float32Array();
                if (((_b = (_a = mapItem.buffer) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.position) != null) {
                    position = (_d = (_c = mapItem.buffer) === null || _c === void 0 ? void 0 : _c.attributes) === null || _d === void 0 ? void 0 : _d.position.array;
                }
                position = position.slice(start, start + size);
                if (position.length <= 0 || mapItem.hidden) {
                    isSelected = false;
                    break;
                }
                const result = this.projectBuffer(position, transMat);
                const calResultSize = result.length * 2 / 3;
                if (calResultSize <= 0) {
                    isSelected = false;
                    break;
                }
                isSelected = true;
                for (let i = 0; i < calResultSize; i += 2) {
                    _vector2_1.set(result[i], result[i + 1]);
                    const selected = _pickRect$1.select(_vector2_1);
                    if (!selected) {
                        isSelected = false;
                        break;
                    }
                }
            }
            if (isSelected) {
                filteredEntities[primitive.uuid] = primitive;
            }
        }
        return filteredEntities;
    }
    projectBuffer(points, matrix) {
        const count = points.length / 3;
        let result = [];
        for (let i = 0; i < count; i++) {
            _vector$1.set(points[i * 3], points[i * 3 + 1], points[i * 3 + 2]);
            _vector$1.applyMatrix4(matrix);
            result.push(_vector$1.x, _vector$1.y);
        }
        return result;
    }
    selectPrimitivesFromRect(start_x, start_y, end_x, end_y) {
        var _a, _b, _c, _d;
        const viewportStore = PythaStorage.instance.viewportStore;
        const currentCamera = viewportStore.viewportItems[viewportStore.currentViewportKey].camera;
        const renderStore = PythaStorage.instance.renderStore;
        if (!currentCamera)
            return {};
        if (!_pickRect$1) {
            _pickRect$1 = new SelectionRect(currentCamera);
        }
        _pickRect$1.update(new Vector2(start_x, start_y), new Vector2(end_x, end_y));
        if (_pickRect$1.minX === _pickRect$1.maxX && _pickRect$1.minY === _pickRect$1.maxY)
            return {};
        let viewMatrix = currentCamera.matrixWorldInverse;
        let projectMatrix = currentCamera.projectionMatrix;
        let transMat = new Matrix4().identity().premultiply(viewMatrix).premultiply(projectMatrix);
        let filteredEntities = {};
        for (let key in renderStore.objectRenderBucket) {
            let bucket = renderStore.objectRenderBucket[key];
            for (let mapItem of bucket.renderBucketItems) {
                let position = new Float32Array();
                if (((_b = (_a = mapItem.buffer) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.position) != null) {
                    position = (_d = (_c = mapItem.buffer) === null || _c === void 0 ? void 0 : _c.attributes) === null || _d === void 0 ? void 0 : _d.position.array;
                }
                if (position.length <= 0 || mapItem.hidden)
                    continue;
                // let result = this.projectBuffer(position, transMat);
                let result = [];
                let resultIsInit = false;
                // const itemSize = 2;
                if (mapItem.renderType === PrimitiveType.Line) {
                    for (let mi = 0; mi < mapItem.renderItems.length; mi++) {
                        let renderItem = mapItem.renderItems[mi];
                        let primitive = renderItem.primitive.getRootPrimitive();
                        if (primitive == null)
                            continue;
                        if (!primitive.isInView)
                            continue; // 剔除视口外的图元
                        if (filteredEntities[primitive.uuid] != null) {
                            continue;
                        }
                        let flag = this.calPriBoxOutRect(primitive, transMat);
                        if (flag)
                            continue;
                        if (!resultIsInit) {
                            result = this.projectBuffer(position, transMat);
                            resultIsInit = true;
                        }
                        for (let i = 0; i < renderItem.size * 2 / 3; i += 4) {
                            let start = i + renderItem.start * 2 / 3;
                            _vector2_1.set(result[start], result[start + 1]);
                            _vector2_2.set(result[start + 2], result[start + 3]);
                            let selected = _pickRect$1.select(_vector2_1, _vector2_2);
                            if (selected) {
                                let rootPrimitive = primitive.getRootPrimitive();
                                filteredEntities[rootPrimitive.uuid] = rootPrimitive;
                                break;
                            }
                        }
                    }
                }
                else if (mapItem.renderType === "Mesh") {
                    for (let mi = 0; mi < mapItem.renderItems.length; mi++) {
                        let renderItem = mapItem.renderItems[mi];
                        let primitive = renderItem.primitive.getRootPrimitive();
                        if (primitive == null)
                            continue;
                        if (!primitive.isInView)
                            continue; // 剔除视口外的图元
                        if (filteredEntities[primitive.uuid] != null) {
                            continue;
                        }
                        let flag = this.calPriBoxOutRect(primitive, transMat);
                        if (flag)
                            continue;
                        if (!resultIsInit) {
                            result = this.projectBuffer(position, transMat);
                            resultIsInit = true;
                        }
                        if (renderStore.renderMode === RenderMode.WIREFRAME) {
                            for (let i = 0; i < renderItem.size * 2 / 3; i += 4) {
                                let start = i + renderItem.start * 2 / 3;
                                _vector2_1.set(result[start], result[start + 1]);
                                _vector2_2.set(result[start + 2], result[start + 3]);
                                let selected = _pickRect$1.select(_vector2_1, _vector2_2);
                                if (selected) {
                                    let rootPrimitive = primitive.getRootPrimitive();
                                    filteredEntities[rootPrimitive.uuid] = rootPrimitive;
                                    break;
                                }
                            }
                        }
                        else {
                            for (let i = 0; i < renderItem.size * 2 / 3; i += 6) {
                                let start = i + renderItem.start * 2 / 3;
                                _vector2_1.set(result[start], result[start + 1]);
                                _vector2_2.set(result[start + 2], result[start + 3]);
                                _vector2_3.set(result[start + 4], result[start + 5]);
                                let selected = _pickRect$1.select(_vector2_1, _vector2_2, _vector2_3);
                                if (selected) {
                                    let rootPrimitive = primitive.getRootPrimitive();
                                    filteredEntities[rootPrimitive.uuid] = rootPrimitive;
                                    break;
                                }
                            }
                        }
                    }
                }
                else if (mapItem.renderType === "Point") {
                    for (let mi = 0; mi < mapItem.renderItems.length; mi++) {
                        let renderItem = mapItem.renderItems[mi];
                        let primitive = renderItem.primitive.getRootPrimitive();
                        if (primitive == null)
                            continue;
                        if (!primitive.isInView)
                            continue; // 剔除视口外的图元
                        if (filteredEntities[primitive.uuid] != null) {
                            continue;
                        }
                        let flag = this.calPriBoxOutRect(primitive, transMat);
                        if (flag)
                            continue;
                        if (!resultIsInit) {
                            result = this.projectBuffer(position, transMat);
                            resultIsInit = true;
                        }
                        for (let i = 0; i < renderItem.size * 2 / 3; i += 2) {
                            let start = i + renderItem.start * 2 / 3;
                            _vector2_1.set(result[start], result[start + 1]);
                            let selected = false;
                            selected = _pickRect$1.select(_vector2_1);
                            if (selected) {
                                let rootPrimitive = primitive.getRootPrimitive();
                                filteredEntities[rootPrimitive.uuid] = rootPrimitive;
                            }
                        }
                    }
                }
            }
        }
        return filteredEntities;
    }
    isBoxInView(boundingBox, transMat) {
        _point1$2.copy(boundingBox.min); // min
        _point2$3.set(boundingBox.min.x, boundingBox.min.y, boundingBox.max.z);
        _point3$1.set(boundingBox.min.x, boundingBox.max.y, boundingBox.min.z);
        _point4$1.set(boundingBox.min.x, boundingBox.max.y, boundingBox.max.z);
        _point5$1.set(boundingBox.max.x, boundingBox.max.y, boundingBox.min.z);
        _point6$1.set(boundingBox.max.x, boundingBox.max.y, boundingBox.max.z); // max
        _point7$1.set(boundingBox.max.x, boundingBox.min.y, boundingBox.min.z);
        _point8$1.set(boundingBox.max.x, boundingBox.min.y, boundingBox.max.z);
        let points = [_point1$2, _point2$3, _point3$1, _point4$1, _point5$1, _point6$1, _point7$1, _point8$1];
        // 将包围盒点投影到屏幕空间
        const vertices = this.projectBufferFromPoints(points, transMat);
        const triangles = [
            // 前面
            [vertices[0], vertices[1], vertices[3]], // 三角形 1
            [vertices[0], vertices[2], vertices[3]], // 三角形 2
            // 后面
            [vertices[4], vertices[5], vertices[6]], // 三角形 3
            [vertices[4], vertices[6], vertices[7]], // 三角形 4
            // 左面
            [vertices[0], vertices[1], vertices[7]], // 三角形 5
            [vertices[0], vertices[4], vertices[7]], // 三角形 6
            // 右面
            [vertices[2], vertices[3], vertices[6]], // 三角形 7
            [vertices[2], vertices[5], vertices[6]], // 三角形 8
            // 顶面
            [vertices[1], vertices[3], vertices[6]], // 三角形 9
            [vertices[1], vertices[6], vertices[7]], // 三角形 10
            // 底面
            [vertices[0], vertices[2], vertices[5]], // 三角形 11
            [vertices[0], vertices[4], vertices[5]] // 三角形 12
        ];
        let success = false;
        for (let i = 0; i < 12; i++) {
            let triangle = triangles[i];
            let res = _pickRect$1.select(triangle[0], triangle[1], triangle[2]);
            if (res) {
                success = true;
                break;
            }
        }
        return success;
    }
    /**
     * 通过三维点集来生成屏幕坐标下的二位数组
     * @param points
     * @param matrix
     * @returns
     */
    projectBufferFromPoints(points, matrix) {
        let result = [];
        for (let i = 0; i < (points === null || points === void 0 ? void 0 : points.length); i++) {
            _vector$1.set(points[i].x, points[i].y, points[i].z);
            _vector$1.applyMatrix4(matrix);
            result.push(new Point2(_vector$1.x, _vector$1.y));
        }
        return result;
    }
}
//选择过程中的临时变量，防止重复创建的开销
const _vector2_1 = new Vector2();
const _vector2_2 = new Vector2();
const _vector2_3 = new Vector2();
let _pickRect$1;
const _vector$1 = new Vector3();
const _point1$2 = new Point();
const _point2$3 = new Point();
const _point3$1 = new Point();
const _point4$1 = new Point();
const _point5$1 = new Point();
const _point6$1 = new Point();
const _point7$1 = new Point();
const _point8$1 = new Point();class EventHandlerCalSelectRect extends EventHandlerBase {
    run(data) {
        // 0 这里是开始逻辑
        // 获取鼠标点击和移动点
        const pointerDownList = this.node.graph.cache.pointerDownList;
        const movePointer = this.node.graph.cache.pointerMove;
        const clickPointer = pointerDownList[pointerDownList.length - 1];
        if (!clickPointer || !movePointer)
            return false;
        const clickPoint = clickPointer.point2;
        const movePoint = movePointer.point2;
        // 2 判断rect是否存在，不存在要创建
        let _rect = this.node.graph.cache.data['_rect'];
        if (!_rect) {
            // 创建rect
            _rect = document.createElement('div');
            _rect.classList.add('select-rect');
            _rect.style.pointerEvents = 'none';
            const viewportStore = PythaStorage.instance.viewportStore;
            viewportStore.renderer.domElement.parentElement.appendChild(_rect);
            this.node.graph.cache.data['_rect'] = _rect;
            _rect.style.pointerEvents = 'none';
            _rect.style.border = '1px dashed #fff';
            _rect.style.backgroundColor = 'rgba(25, 189, 19, 0.3)';
            _rect.style.position = 'fixed';
        }
        // 维护rect样式
        let top_left_x = Math.min(movePoint.x, clickPoint.x);
        let top_left_y = Math.min(movePoint.y, clickPoint.y);
        let bottom_right_x = Math.max(movePoint.x, clickPoint.x);
        let bottom_right_y = Math.max(movePoint.y, clickPoint.y);
        if (movePoint.x > clickPoint.x) {
            _rect.classList.add('reverse');
            _rect.style.border = '1px solid #fff';
            _rect.style.backgroundColor = 'rgba(19, 104, 231, 0.3)';
            this.node.graph.cache.data['_isRansgeSeletcReverse'] = true;
        }
        else {
            _rect.style.border = '1px dashed #fff';
            _rect.style.backgroundColor = 'rgba(25, 189, 19, 0.3)';
            _rect.classList.remove('reverse');
            this.node.graph.cache.data['_isRansgeSeletcReverse'] = false;
        }
        _rect.style.left = top_left_x + 'px';
        _rect.style.top = top_left_y + 'px';
        _rect.style.width = (bottom_right_x - top_left_x) + 'px';
        _rect.style.height = (bottom_right_y - top_left_y) + 'px';
        const viewportStore = PythaStorage.instance.viewportStore;
        const rect = viewportStore.renderer.domElement.getBoundingClientRect();
        const start_x = (top_left_x - rect.x) / rect.width * 2 - 1;
        const start_y = -(top_left_y - rect.y) / rect.height * 2 + 1;
        const end_x = (bottom_right_x - rect.x) / rect.width * 2 - 1;
        const end_y = -(bottom_right_y - rect.y) / rect.height * 2 + 1;
        this.node.graph.cache.data['start_x'] = start_x;
        this.node.graph.cache.data['start_y'] = start_y;
        this.node.graph.cache.data['end_x'] = end_x;
        this.node.graph.cache.data['end_y'] = end_y;
        return true;
    }
}/**
 * 切换至pick十字光标
 */
class EHChangePickCrossCursor extends EventHandlerBase {
    /**
     * 运行处理器
     * @param data
     * @returns
     */
    run(data) {
        let event = new PythaEventCursorTypeChange();
        event.data = CursorType.PICK_CROSS;
        this.node.graph.eventMediator.emitEvent(event);
        return true;
    }
}/**
 * 夹点标签
 */
class ClampPointLabel extends LabelBase {
    get isActive() {
        return this._isActive;
    }
    set isActive(value) {
        this._isActive = value;
        if (this.clampEle == null)
            return;
        if (value) {
            this.clampEle.style.backgroundColor = "#A50000";
        }
        else {
            this.clampEle.style.backgroundColor = "#007FFF";
        }
    }
    /**
     * 构造函数
     */
    constructor(featurePoint) {
        super();
        /**
         * 夹点激活状态
         */
        this._isActive = false;
        this.featurePoint = featurePoint;
    }
    /**
     * 生成夹点标签
     */
    generate() {
        const root = this.obj.element;
        this.obj.renderOrder = 100;
        const clamp = document.createElement('div');
        // clamp.style.position = 'absolute';
        clamp.style.height = '10px';
        clamp.style.width = '10px';
        clamp.style.backgroundColor = '#007FFF';
        clamp.style.border = '1px solid rgb(93,94,95)';
        this.clampEle = clamp;
        root.appendChild(clamp);
    }
}/**
 * 显示夹点处理器
 */
class EventHandlerShowClampPoint extends EventHandlerBase {
    constructor() {
        super(...arguments);
        // 临时变量
        this._mat = new Matrix4();
    }
    /**
     * 运行处理器
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a;
        // 获取存储
        // console.log("EventHandlerShowClampPoint");
        const storage = PythaStorage.instance;
        // 清空原来的
        storage.clampStore.clear();
        // 判断数量
        let selectedPrimitives = storage.selectStore.getUnlockedPrimitives();
        if (selectedPrimitives.length >= 3)
            return true; // 只有少数图元选中才激活夹点
        if (storage.clampStore.clampHidden)
            return true;
        // 获取图元特征点
        let featurePoints = [];
        for (let primitive of selectedPrimitives) {
            let fps = primitive.getControlPoints() || [];
            if (primitive.type == "Block") {
                // 块的夹点在基点上
                let bt = storage.blockStore.blockTemplateDict[primitive.blockTemplateUuid];
                if (bt != null) {
                    let mat = bt.localModelMatrix;
                    if (mat != null) {
                        if (primitive.localModelMatrix == null) {
                            primitive.localModelMatrix = new Matrix4();
                            primitive.updateWorldModelMatrix(false, true);
                        }
                        else if (primitive.worldModelMatrix == null) {
                            primitive.updateWorldModelMatrix(false, true);
                        }
                        this._mat.copy(mat).premultiply(primitive.worldModelMatrix);
                        (_a = fps[0]) === null || _a === void 0 ? void 0 : _a.point.set(this._mat.elements[12], this._mat.elements[13], this._mat.elements[14]);
                    }
                }
            }
            featurePoints.push(...fps);
        }
        // 识别特征点
        // 创建夹点
        for (let fp of featurePoints) {
            // TODO 暂时把非center夹点隐藏
            if (fp.type !== FEATURE_POINT_TYPE.CENTER
                && fp.primitive.type !== PrimitiveType.Line
                && fp.primitive.type !== PrimitiveType.Arc)
                continue;
            let clampPoint = new ClampPointLabel(fp);
            clampPoint.setPosition(fp.point);
            storage.clampStore.clampPoints.push(clampPoint);
        }
        // 显示
        for (let cp of storage.clampStore.clampPoints) {
            if (!cp.obj.parent) {
                storage.viewportStore.scene.add(cp.obj);
            }
        }
        return true;
    }
}/**
 * 选择图 单选和框选
 */
class EventGraphSelect extends EventGraphBase {
    constructor() {
        super(...arguments);
        /**
         * 是否是常驻图
         */
        this.isAlwaysActive = true;
    }
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node3 = new EventGraphNode(this, EventHandlerPointSelect);
        const node4 = new EventGraphNodeSwitch(this, () => {
            var _a;
            const storage = PythaStorage.instance;
            if (!!this.cache.data['pointSelect'] || !((_a = storage.selectStore) === null || _a === void 0 ? void 0 : _a.rangeSelectEnabled)) {
                return [0];
            }
            return [1, 2];
        });
        const node5 = new EventGraphNodeRender(this, true, UpdateType.MAIN);
        const node6 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node7 = new EventGraphNode(this, EventHandlerCalPointerUp);
        const node8 = new EventGraphNode(this, EventHandlerRangeSelect);
        const node10 = new EventGraphNode(this, EventHandlerCalSelectRect);
        const node11 = new EventGraphNodeSwitch(this, () => {
            if (!!this.cache.data['_rect'] && !this.cache.data['onClick']) {
                return [0];
            }
            return [1, 2];
        });
        const node12 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node13 = new EventGraphNodeSwitch(this, () => {
            const pointdownList = this.cache.pointerDownList;
            if (pointdownList.length < 1) {
                return [1];
            }
            const clickPointer = pointdownList[0];
            if (clickPointer.button !== MOUSE_BUTTON.LEFT) {
                return [1];
            }
            return [0];
        });
        const node14 = new EventGraphNode(this, EHChangeCrossCursor);
        const node15 = new EventGraphNode(this, EHChangePickCrossCursor);
        const node16 = new EventGraphNode(this, EventHandlerShowClampPoint);
        const node17 = new EventGraphNodeSwitch(this, () => {
            var _a;
            if (!!((_a = this.eventMediator) === null || _a === void 0 ? void 0 : _a.tempActiveGraph)) {
                return [1];
            }
            return [0];
        });
        const node18 = new EventGraphNode(this, EHChangePickCursor);
        const node19 = new EventGraphNodeNotice(this, {
            cmd: 'data_change', data: {
                selectChanged: true
            }
        });
        const node20 = new EventGraphNodeSwitch(this, () => {
            if (!!this.cache.data['pointSelect'] || !!this.cache.data['rangeSelect']) {
                return [0, 1];
            }
            return [0];
        });
        this.addEdge(node1, node2);
        this.addEdge(node3, node4);
        this.addEdge(node6, node10);
        this.addEdge(node7, node11);
        this.addEdge(node11, node8);
        this.addEdge(node12, node6, EDGE_TYPE.STOP);
        this.addEdge(node12, node8);
        this.addEdge(node2, node13);
        this.addEdge(node13, node3);
        this.addEdge(node14, node6);
        this.addEdge(node4, node16);
        this.addEdge(node16, node5);
        this.addEdge(node15, node16);
        this.addEdge(node17, node15);
        this.addEdge(node8, node17);
        this.addEdge(node18, node16);
        this.addEdge(node5, node20);
        this.addEdge(node20, node1);
        this.addEdge(node11, node6);
        /**不是左键*/
        this.addEdge(node13, node1);
        this.addEdge(node4, node14);
        this.addEdge(node17, node18);
        this.addEdge(node20, node19);
        this.addEdge(node11, node12);
        this.addEdge(node4, node7);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/75
    }
    /**
     * 结束图（选择是常驻图，结束命令只会清空当前选择集）
     */
    end() {
        // 清掉矩形框
        const _rect = this.cache.data['_rect'];
        if (!!_rect) {
            _rect.parentElement.removeChild(_rect);
            this.cache.data['_rect'] = null;
            this.cache.data['_isRansgeSeletcReverse'] = false;
        }
        // 清掉选中图元
        let selectPrimitives = PythaStorage.instance.selectStore.selectPrimitives;
        selectPrimitives.forEach(primitive => {
            primitive.isSelected = false;
        });
        PythaStorage.instance.selectStore.selectPrimitives = [];
        this.eventMediator.noticeHandler.notice(this, new PythaEventDataChange({ selectChanged: true })); // 清空选择项外部发送信号
        // 清空缓存
        for (const [_, node] of this.graph) {
            node.dispose();
        }
        // this.cleanCache();
        this.cache.pointerDownList = [];
        this.cache.pointerUpList = [];
        this.cache.pointerMove = new Pointer();
        this.cache.primitiveList = [];
        this.cache.pointerWheel = new Pointer();
        this.cache.data = {};
        PythaStorage.instance.selectStore.enabled = true; //TODO 暂时在这里激活选择
        PythaStorage.instance.selectStore.rangeSelectEnabled = !PythaStorage.instance.selectStore.pickOnly;
        this.head.run();
    }
    /**
     * 匹配挂起的节点
     * @param event
     * @returns
     */
    matchEventAndNode(event) {
        const selectStore = PythaStorage.instance.selectStore;
        if (!selectStore.enabled) {
            return;
        }
        super.matchEventAndNode(event);
    }
}
/**
 * SELECT指令 用于注册事件图
 */
EventGraphSelect.cmd = 'SELECT';/**
 * 监听光标修改事件 处理光标变更
 */
class EHConfirmCursorType extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventCursorTypeChange();
        this.needEventOnce = false;
    }
    run(event) {
        var _a;
        if (event.cmd != this.needEvent.cmd)
            return false; // 如果传入事件不符 则不执行处理器
        // 获取存储
        const storage = PythaStorage.instance;
        let type = event.data;
        if (type == null) {
            type = CursorType.PICK_CROSS;
        }
        const currentCursorType = storage.cursorStore.currentCursorType;
        const cursors = storage.cursorStore.cursors;
        // 设置光标类型
        if (type != currentCursorType) {
            (_a = cursors[currentCursorType]) === null || _a === void 0 ? void 0 : _a.remove(); // 切换光标时移除旧光标
        }
        storage.cursorStore.currentCursorType = type;
        let cursor = cursors[type];
        if (cursor == null) {
            cursor = cursors[CursorType.PICK_CROSS];
        }
        cursor.setPosition(storage.coordinateStore.currentPos);
        // 显示光标
        if (!cursor.obj.parent && !storage.cursorStore.hiddenCursor) {
            storage.viewportStore.scene.add(cursor.obj); // 显示标签
        }
        return true;
    }
}/**
 * 光标处理器
 */
class EHCursor extends EventHandlerBase {
    run() {
        // 输入
        const storage = PythaStorage.instance;
        // 找到光标
        let cursor = storage.cursorStore.cursors[storage.cursorStore.currentCursorType];
        if (cursor == null) {
            return true;
        }
        // 设置光标坐标
        cursor.setPosition(storage.coordinateStore.originalPos);
        // 判断是否捕捉
        if (storage.captureStore.capturePoint) {
            cursor.setPosition(storage.captureStore.capturePoint);
        }
        // 显示光标
        if (!cursor.obj.parent && !storage.cursorStore.hiddenCursor) {
            storage.viewportStore.scene.add(cursor.obj); // 显示标签
        }
        return true;
    }
}/**
 * 更新捕捉池
 */
class EventHandlerUpdateCapturePool extends EventHandlerBase {
    run(data) {
        const storage = this.getPythaStorage();
        if (!storage.captureStore.enabled)
            return false;
        if (!storage.captureStore.captureActived)
            return false;
        // 查找光标位置附近的图元列表 取前20个图元
        // 拿到光标附近的拾取框，扩大一下范围
        const selectStore = storage.selectStore;
        let epsilon = selectStore.pickEpsilon * 4;
        let x = storage.coordinateStore.ndcViewportPos2.x;
        let y = storage.coordinateStore.ndcViewportPos2.y;
        let start_x = x - epsilon;
        let start_y = y - epsilon;
        let end_x = x + epsilon;
        let end_y = y + epsilon;
        let filteredEntities = this.selectPrimitivesFromRect(start_x, start_y, end_x, end_y);
        // if (Object.values(filteredEntities).length === 0 || Object.values(filteredEntities).length >= 100) {
        //     storage.captureStore.capturePointsPool = [];
        //     return true;
        // }
        let primitives = [];
        for (let pri of Object.values(filteredEntities)) {
            primitives.push(pri);
            // if (primitives.length > 50) break;
        }
        // 获取图元特征点
        let featurePoints = [];
        for (let i = 0; i <= primitives.length - 1; i++) {
            const primitiveA = primitives[i];
            if (primitiveA.hidden) {
                // 跳过隐藏的图元
                continue;
            }
            if (primitiveA.type == "Text") {
                // 文字不捕捉
                continue;
            }
            if (primitiveA.type == "Block") {
                // 块的捕捉点要去模板里拿
                let bt = storage.blockStore.blockTemplateDict[primitiveA.blockTemplateUuid];
                let fps = [];
                this.findBlockFeaturePoints(bt, primitiveA.worldModelMatrix, fps);
                featurePoints.push(...fps);
            }
            else {
                let fps = primitiveA.getFeaturePoints();
                featurePoints.push(...fps);
            }
            let intersectionPointList = [];
            let geosA = primitiveA.geos;
            let worldModelMatrixA = primitiveA.worldModelMatrix;
            if (worldModelMatrixA) {
                geosA.forEach(geo => {
                    geo.transformMatrix.premultiply(worldModelMatrixA);
                });
            }
            for (let j = i + 1; j < primitives.length; j++) {
                let primitiveB = primitives[j];
                let geosB = primitiveB.geos;
                let worldModelMatrixB = primitiveB.worldModelMatrix;
                if (worldModelMatrixB) {
                    geosB.forEach(geo => {
                        geo.transformMatrix.premultiply(worldModelMatrixB);
                    });
                }
                intersectionPointList.push(...this.getGeoIntersectionGeoPoints(geosA, geosB));
                if (worldModelMatrixB) {
                    let worldModelMatrixBInvert = worldModelMatrixB.clone().invert();
                    geosB.forEach(geo => {
                        geo.transformMatrix.premultiply(worldModelMatrixBInvert);
                    });
                }
            }
            if (worldModelMatrixA) {
                let worldModelMatrixAInvert = worldModelMatrixA.clone().invert();
                geosA.forEach(geo => {
                    geo.transformMatrix.premultiply(worldModelMatrixAInvert);
                });
            }
            let intersectionFeaturePoint = intersectionPointList.map(item => {
                let midFP = {
                    type: FEATURE_POINT_TYPE.INTERSECTION,
                    geoType: "INTERSECTION",
                    point: item
                };
                return midFP;
            });
            featurePoints.push(...intersectionFeaturePoint);
        }
        // 存入捕捉池
        storage.captureStore.capturePointsPool = [...featurePoints];
        return true;
    }
    /**
     * 获取块的捕捉点
     */
    findBlockFeaturePoints(primitive, parentWorldMatrix, fps) {
        if (primitive == null)
            return;
        const storage = this.getPythaStorage();
        // let bt = storage.blockStore.blockTemplateDict[primitive.blockTemplateUuid];
        for (let key of Object.keys(primitive.children)) {
            // 遍历块模板的子图元
            let child = primitive.children[key];
            if (child.type == "Block") {
                // 子图元是块时，再次查找模板
                let mat = child.worldModelMatrix.clone().premultiply(parentWorldMatrix); // 同时传递外部变换矩阵
                let bt = storage.blockStore.blockTemplateDict[child.blockTemplateUuid];
                this.findBlockFeaturePoints(bt, mat, fps);
                continue;
            }
            let childFps = child.getFeaturePoints();
            for (let fp of childFps) {
                if (!!parentWorldMatrix) {
                    fp.point.applyMatrix4(parentWorldMatrix);
                }
            }
            fps.push(...childFps);
        }
    }
    /**
     * 从矩形框中返回选择的图元
     * @param start_x
     * @param start_y
     * @param end_x
     * @param end_y
     * @returns
     */
    selectPrimitivesFromRect(start_x, start_y, end_x, end_y) {
        const storage = this.getPythaStorage();
        const viewportStore = storage.viewportStore;
        const currentCamera = viewportStore.viewportItems[viewportStore.currentViewportKey].camera;
        // const renderStore = storage.renderStore;
        if (!currentCamera)
            return {};
        if (!_pickRect) {
            _pickRect = new SelectionRect(currentCamera);
        }
        _pickRect.update(new Vector2(start_x, start_y), new Vector2(end_x, end_y));
        if (_pickRect.minX === _pickRect.maxX && _pickRect.minY === _pickRect.maxY)
            return {};
        const primitives = storage.primitiveStore.primitiveDict; // 获取图元
        const viewportItems = storage.viewportStore.viewportItems;
        // 剔除鼠标小场景外的图元
        let primitivesInLittlRect = {};
        Object.keys(viewportItems).forEach(itemKey => {
            const camera = viewportItems[itemKey].camera;
            let viewMatrix = camera.matrixWorldInverse;
            let projectMatrix = camera.projectionMatrix;
            let transMat = new Matrix4().identity().premultiply(viewMatrix).premultiply(projectMatrix);
            if (viewportItems[itemKey].inViewCount >= 200) {
                primitivesInLittlRect = {};
                return;
            }
            Object.keys(primitives).forEach(key => {
                if (primitivesInLittlRect[key] != null)
                    return;
                let primitive = primitives[key];
                // primitive.isInView = false;
                if (!primitive.isInView) {
                    return;
                }
                let boundingBox = primitive.getBoundingbox();
                if (primitive.type == "Block") {
                    // 如果是块，需要去模板里计算 并且要考虑跨模板的转换矩阵问题
                    let bt = storage.blockStore.blockTemplateDict[primitive.blockTemplateUuid];
                    boundingBox = BlockPrimitive.calBlockBoundingBox(bt, primitive.worldModelMatrix, storage.blockStore.blockTemplateDict);
                }
                if (boundingBox.min == null || boundingBox.max == null)
                    return;
                let isInView = this.isBoxInView(boundingBox, transMat);
                if (isInView) {
                    primitivesInLittlRect[key] = primitive;
                }
            });
        });
        return primitivesInLittlRect;
    }
    /**
     * 将3维点数组投影成2维点数组
     */
    // projectBuffer(points: TypedArray, matrix: Matrix4) {
    //     const count = points.length / 3;
    //     let result = [];
    //     for (let i = 0; i < count; i++) {
    //         _vector.set(points[i * 3], points[i * 3 + 1], points[i * 3 + 2]);
    //         _vector.applyMatrix4(matrix);
    //         result.push(_vector.x, _vector.y);
    //     }
    //     return result;
    // }
    /**
     * 将3维点数组投影成2维点数组
     */
    projectBuffer(points, matrix) {
        let result = [];
        for (let i = 0; i < (points === null || points === void 0 ? void 0 : points.length); i++) {
            _vector.set(points[i].x, points[i].y, points[i].z);
            _vector.applyMatrix4(matrix);
            result.push(new Point2(_vector.x, _vector.y));
        }
        return result;
    }
    /**
     * 通过图元渲染出来的渲染数组，获取某个图元到相机的距离
     * @param primitive 图元
     * @param camera 相机
     *
     */
    getDistFromCameraToPri(primitive, camera) {
        var _a, _b, _c, _d;
        const storage = this.getPythaStorage();
        const objectRenderBucket = storage.renderStore.objectRenderBucket;
        // 遍历renderItem
        const renderItemDict = primitive.renderItemDict;
        let minDist = Number.MAX_VALUE; //图元距离相机的最小距离
        for (const renderItemKey in renderItemDict) {
            const renderItem = renderItemDict[renderItemKey];
            if (!renderItem) {
                continue;
            }
            const start = renderItem.start;
            const size = renderItem.size;
            const renderKey = renderItem.lastRenderKey;
            const index = renderItem.renderGeometryBucketIndex;
            const bucket = objectRenderBucket[renderKey];
            const mapItem = bucket.renderBucketItems[index];
            let position = new Float32Array();
            if (((_b = (_a = mapItem.buffer) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.position) != null) {
                position = (_d = (_c = mapItem.buffer) === null || _c === void 0 ? void 0 : _c.attributes) === null || _d === void 0 ? void 0 : _d.position.array;
            }
            position = position.slice(start, start + size);
            if (position.length <= 0 || mapItem.hidden) {
                continue;
            }
            if (renderItem.renderType === RenderItemType.MESH) {
                //面渲染类型，转化为三角面与相机轴射线求交
                for (let i = 0; i < position.length - 8; i += 9) {
                    _v1.set(position[i], position[i + 1], position[i + 2]);
                    _v2.set(position[i + 3], position[i + 4], position[i + 5]);
                    _v3.set(position[i + 6], position[i + 7], position[i + 8]);
                    let dist = this.getDistFromCameraToTriangle(_v1, _v2, _v3, camera.position);
                    minDist = minDist > dist ? dist : minDist;
                }
            }
            else if (renderItem.renderType === RenderItemType.LINE) {
                //线渲染类型，转化为直线段与相机轴射线求交
                for (let i = 0; i < position.length - 5; i += 6) {
                    _v1.set(position[i], position[i + 1], position[i + 2]);
                    _v2.set(position[i + 3], position[i + 4], position[i + 5]);
                    let dist = this.getDistFromCameraToLine(_v1, _v2, camera.position);
                    minDist = minDist > dist ? dist : minDist;
                }
            }
            else if (renderItem.renderType === RenderItemType.POINT) {
                //点渲染类型，转化为点与相机轴射线求交
                for (let i = 0; i < position.length - 2; i += 3) {
                    _v1.set(position[i], position[i + 1], position[i + 2]);
                    let dist = this.getDistFromCameraToPoint(_v1, camera.position);
                    minDist = minDist > dist ? dist : minDist;
                }
            }
        }
        return minDist;
    }
    /**
     * 获取一个点到相机的距离
     * @param point
     * @param cameraPoint
     */
    getDistFromCameraToPoint(point, cameraPoint) {
        if (_selectBox.containsPoint(point)) {
            return cameraPoint.distanceTo(point);
        }
        return Number.MAX_VALUE;
    }
    /**
     * 获取一条线段到相机的距离
     * @param start
     * @param end
     * @param cameraPoint
     * @returns
     */
    getDistFromCameraToLine(start, end, cameraPoint) {
        const planes = _selectBox.planes;
        let shoot = new Point();
        _line.set(start, end);
        for (let i = 0; i < 6; i++) {
            let plane = planes[i];
            if (!GeoIntersection.LineIntersectPlane(_line, plane))
                continue;
            if (!_selectBox.containsPoint(shoot))
                continue;
            return shoot.distanceTo(cameraPoint);
        }
        return Number.MAX_VALUE;
    }
    /**
     * 获取三角面到相机位置的距离
     * @param a 三角面第1点
     * @param b 三角面第2点
     * @param c 三角面第3点
     * @param cameraPoint 相机坐标
     * @returns
     */
    getDistFromCameraToTriangle(a, b, c, cameraPoint) {
        _plane.setFromCoplanarPoints(a, b, c);
        let normal = _plane.normal;
        GeoIntersection.RayIntersectPlane(_selectBox.ray, _plane, _point$1);
        let angleNum = 0;
        _v1.subVectors(a, _point$1);
        _v2.subVectors(b, _point$1);
        _v3.subVectors(c, _point$1);
        let angle = _v1.angleTo(_v2);
        if (_v1.clone().cross(_v2).angleTo(normal) > Math.PI / 2) {
            angle *= -1;
        }
        angleNum += angle;
        angle = _v2.angleTo(_v3);
        if (_v2.clone().cross(_v3).angleTo(normal) > Math.PI / 2) {
            angle *= -1;
        }
        angleNum += angle;
        angle = _v3.angleTo(_v1);
        if (_v3.clone().cross(_v1).angleTo(normal) > Math.PI / 2) {
            angle *= -1;
        }
        angleNum += angle;
        if (Math.abs(angleNum - 2 * Math.PI) < 1e-6) {
            return _point$1.distanceTo(cameraPoint);
        }
        return Number.MAX_VALUE;
    }
    /**
     * 获取两组geo的交点集合
     * @param geosA
     * @param geosB
     * @returns
     */
    getGeoIntersectionGeoPoints(geosA, geosB) {
        if (!((geosA === null || geosA === void 0 ? void 0 : geosA.length) > 0) || !((geosB === null || geosB === void 0 ? void 0 : geosB.length) > 0))
            return [];
        let res = [];
        for (let i = 0; i < geosA.length; i++) {
            for (let j = 0; j < geosB.length; j++) {
                res.push(...this.getIntersctionPoints(geosA[i], geosB[j]));
            }
        }
        return res;
    }
    /**
     * 获取线两两交点
     * @param geo1
     * @param geo2
     * @returns
     */
    getIntersctionPoints(geo1, geo2) {
        if (geo1.type == "Line") {
            let lineGeo1 = geo1;
            if (geo2.type == "Line") {
                let lineGeo2 = geo2;
                let intersectionPoint = GeoIntersection.LineSegmentIntersection(lineGeo1.start, lineGeo1.end, lineGeo2.start, lineGeo2.end);
                if (intersectionPoint) {
                    return [intersectionPoint];
                }
                else {
                    return [];
                }
            }
            else if (geo2.type == "Arc") {
                let arcGeo2 = geo2;
                let intersectionPoints = GeoIntersection.ArcIntersectLine(arcGeo2, lineGeo1, true, true);
                return intersectionPoints;
            }
            else if (geo2.type == "Circle") {
                let circleGeo2 = geo2;
                let intersectionPoints = GeoIntersection.ArcIntersectLine(circleGeo2, lineGeo1, true, true);
                return intersectionPoints;
            }
        }
        else if (geo1.type == "Arc") {
            let arcGeo1 = geo1;
            if (geo2.type == "Line") {
                let lineGeo2 = geo2;
                let intersectionPoints = GeoIntersection.ArcIntersectLine(arcGeo1, lineGeo2, true, true);
                return intersectionPoints;
            }
            else if (geo2.type == "Arc") {
                let arcGeo2 = geo2;
                let intersectionPoints = GeoIntersection.ArcIntersectArc(arcGeo1, arcGeo2, true, true);
                return intersectionPoints;
            }
            else if (geo2.type == "Circle") {
                let circleGeo2 = geo2;
                let intersectionPoints = GeoIntersection.ArcIntersectArc(arcGeo1, circleGeo2, true, true);
                return intersectionPoints;
            }
        }
        else if (geo1.type == "Circle") {
            let circleGeo1 = geo1;
            if (geo2.type == "Line") {
                let lineGeo2 = geo2;
                let intersectionPoints = GeoIntersection.ArcIntersectLine(circleGeo1, lineGeo2, true, true);
                return intersectionPoints;
            }
            else if (geo2.type == "Arc") {
                let arcGeo2 = geo2;
                let intersectionPoints = GeoIntersection.ArcIntersectArc(circleGeo1, arcGeo2, true, true);
                return intersectionPoints;
            }
            else if (geo2.type == "Circle") {
                let circleGeo2 = geo2;
                let intersectionPoints = GeoIntersection.ArcIntersectArc(circleGeo1, circleGeo2, true, true);
                return intersectionPoints;
            }
        }
        return [];
    }
    isBoxInView(boundingBox, transMat) {
        _point1$1.copy(boundingBox.min); // min
        _point2$2.set(boundingBox.min.x, boundingBox.min.y, boundingBox.max.z);
        _point3.set(boundingBox.min.x, boundingBox.max.y, boundingBox.min.z);
        _point4.set(boundingBox.min.x, boundingBox.max.y, boundingBox.max.z);
        _point5.set(boundingBox.max.x, boundingBox.max.y, boundingBox.min.z);
        _point6.set(boundingBox.max.x, boundingBox.max.y, boundingBox.max.z); // max
        _point7.set(boundingBox.max.x, boundingBox.min.y, boundingBox.min.z);
        _point8.set(boundingBox.max.x, boundingBox.min.y, boundingBox.max.z);
        let points = [_point1$1, _point2$2, _point3, _point4, _point5, _point6, _point7, _point8];
        // 将包围盒点投影到屏幕空间
        const vertices = this.projectBuffer(points, transMat);
        const triangles = [
            // 前面
            [vertices[0], vertices[1], vertices[3]], // 三角形 1
            [vertices[0], vertices[2], vertices[3]], // 三角形 2
            // 后面
            [vertices[4], vertices[5], vertices[6]], // 三角形 3
            [vertices[4], vertices[6], vertices[7]], // 三角形 4
            // 左面
            [vertices[0], vertices[1], vertices[7]], // 三角形 5
            [vertices[0], vertices[4], vertices[7]], // 三角形 6
            // 右面
            [vertices[2], vertices[3], vertices[6]], // 三角形 7
            [vertices[2], vertices[5], vertices[6]], // 三角形 8
            // 顶面
            [vertices[1], vertices[3], vertices[6]], // 三角形 9
            [vertices[1], vertices[6], vertices[7]], // 三角形 10
            // 底面
            [vertices[0], vertices[2], vertices[5]], // 三角形 11
            [vertices[0], vertices[4], vertices[5]] // 三角形 12
        ];
        let success = false;
        for (let i = 0; i < 12; i++) {
            let triangle = triangles[i];
            let res = _pickRect.select(triangle[0], triangle[1], triangle[2]);
            if (res) {
                success = true;
                break;
            }
        }
        return success;
    }
}
/**
 * 辅助选择的数据结构，视锥立方体
 */
class SelectionBox {
    constructor() {
        this.startPoint = new Vector2();
        this.endPoint = new Vector2();
        this._vecTopLeft = new Vector3();
        this._vecTopRight = new Vector3();
        this._vecDownRight = new Vector3();
        this._vecDownLeft = new Vector3();
        this._vecFarTopLeft = new Vector3();
        this._vecFarTopRight = new Vector3();
        this._vecFarDownRight = new Vector3();
        this._vecFarDownLeft = new Vector3();
        /**
         * 视锥体的六个平面
         */
        this.planes = [new Plane$1(), new Plane$1(), new Plane$1(), new Plane$1(), new Plane$1(), new Plane$1()];
        this._vecCenter = new Point();
        this._dir = new Vector3();
        this.ray = new Ray$2();
        this.startPoint = new Vector2();
        this.endPoint = new Vector2();
    }
    update(startPoint, endPoint, camera) {
        if (startPoint) {
            this.startPoint.copy(startPoint);
        }
        if (endPoint) {
            this.endPoint.copy(endPoint);
        }
        this.updateFrustum(camera);
    }
    updateFrustum(camera) {
        const startPoint = this.startPoint;
        const endPoint = this.endPoint;
        // Avoid invalid frustum
        if (startPoint.x === endPoint.x) {
            endPoint.x += Number.EPSILON;
        }
        if (startPoint.y === endPoint.y) {
            endPoint.y += Number.EPSILON;
        }
        if (camera && (camera.type === 'OrthographicCamera' || camera.type === 'PerspectiveCamera')) {
            camera.updateProjectionMatrix();
        }
        camera.updateMatrixWorld();
        const left = Math.min(startPoint.x, endPoint.x);
        const top = Math.max(startPoint.y, endPoint.y);
        const right = Math.max(startPoint.x, endPoint.x);
        const down = Math.min(startPoint.y, endPoint.y);
        this._vecTopLeft.set(left, top, -1);
        this._vecTopRight.set(right, top, -1);
        this._vecDownRight.set(right, down, -1);
        this._vecDownLeft.set(left, down, -1);
        this._vecFarTopLeft.set(left, top, 1);
        this._vecFarTopRight.set(right, top, 1);
        this._vecFarDownRight.set(right, down, 1);
        this._vecFarDownLeft.set(left, down, 1);
        this._vecTopLeft.unproject(camera);
        this._vecTopRight.unproject(camera);
        this._vecDownRight.unproject(camera);
        this._vecDownLeft.unproject(camera);
        this._vecFarTopLeft.unproject(camera);
        this._vecFarTopRight.unproject(camera);
        this._vecFarDownRight.unproject(camera);
        this._vecFarDownLeft.unproject(camera);
        const planes = this.planes;
        planes[0].setFromCoplanarPoints(this._vecTopLeft, this._vecFarTopLeft, this._vecFarTopRight);
        planes[1].setFromCoplanarPoints(this._vecTopRight, this._vecFarTopRight, this._vecFarDownRight);
        planes[2].setFromCoplanarPoints(this._vecFarDownRight, this._vecFarDownLeft, this._vecDownLeft);
        planes[3].setFromCoplanarPoints(this._vecFarDownLeft, this._vecFarTopLeft, this._vecTopLeft);
        planes[4].setFromCoplanarPoints(this._vecTopRight, this._vecDownRight, this._vecDownLeft);
        planes[5].setFromCoplanarPoints(this._vecFarDownRight, this._vecFarTopRight, this._vecFarTopLeft);
        planes[5].normal.multiplyScalar(-1);
        this._vecCenter.copy(this._vecTopLeft).add(this._vecDownRight).multiplyScalar(0.5);
        this._dir.copy(this._vecFarTopLeft).sub(this._vecTopLeft);
        const ray = this.ray;
        ray.set(this._vecCenter, this._dir);
    }
    /**
     * 判断点是否在视锥体内
     * @param point
     * @returns
     */
    containsPoint(point) {
        const planes = this.planes;
        for (let i = 0; i < 6; i++) {
            if (GeoMeasurement.PointDistanceToPlane(point, planes[i]) < -1e-6) { // 当点在平面内时，可能会存在负的计算误差
                return false;
            }
        }
        return true;
    }
}
//选择过程中的临时变量，防止重复创建的开销
let _pickRect;
const _vector = new Vector3();
const _plane = new Plane$1();
const _point$1 = new Point();
const _v1 = new Vector3();
const _v2 = new Vector3();
const _v3 = new Vector3();
const _line = new Line$2();
const _selectBox = new SelectionBox();
const _point1$1 = new Point();
const _point2$2 = new Point();
const _point3 = new Point();
const _point4 = new Point();
const _point5 = new Point();
const _point6 = new Point();
const _point7 = new Point();
const _point8 = new Point();/**
 * 光标图
 */
class EventGraphCursor extends EventGraphBase {
    constructor() {
        super(...arguments);
        /**
         * 是否是常驻图
         */
        this.isAlwaysActive = true;
    }
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node6 = new EventGraphNode(this, EHCursor);
        const node7 = new EventGraphNode(this, EHConfirmCursorType);
        const node8 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        const node9 = new EventGraphNodeTimer(this, 0);
        const node10 = new EventGraphNode(this, EventHandlerUpdateCapturePool);
        this.addEdge(node1, node2);
        this.addEdge(node1, node7);
        this.addEdge(node7, node6);
        this.addEdge(node2, node6);
        this.addEdge(node6, node8);
        this.addEdge(node2, node9);
        this.addEdge(node9, node10);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/78
    }
    /**
     * 常驻图的结束是重置
     */
    end() {
        var _a;
        // 获取存储
        const storage = PythaStorage.instance;
        storage.cursorStore.hiddenCursor = !storage.cursorStore.cursorShow;
        if (!storage.cursorStore.hiddenCursor) {
            storage.viewportStore.renderer.domElement.style.cursor = "none";
        }
        else {
            storage.viewportStore.renderer.domElement.style.cursor = "default";
        }
        // 切换光标时移除旧光标
        const cursors = storage.cursorStore.cursors;
        let currentCursorType = storage.cursorStore.currentCursorType;
        if (currentCursorType != CursorType.PICK_CROSS) {
            (_a = cursors[currentCursorType]) === null || _a === void 0 ? void 0 : _a.remove();
            storage.cursorStore.currentCursorType = CursorType.PICK_CROSS;
            currentCursorType = CursorType.PICK_CROSS;
        }
        // 找到光标
        let cursor = storage.cursorStore.cursors[currentCursorType];
        cursor.setPosition(storage.coordinateStore.currentPos);
        // 显示光标
        if (!cursor.obj.parent && !storage.cursorStore.hiddenCursor) {
            storage.viewportStore.scene.add(cursor.obj); // 显示标签
        }
        for (const [_, node] of this.graph) {
            node.dispose();
        }
        this.head.run();
    }
}
/**
 * CUROSR指令 用于注册事件图
 */
EventGraphCursor.cmd = 'CUROSR';/**
 * 嫁接节点执行顺序
 */
var GraftOrderEnum;
(function (GraftOrderEnum) {
    GraftOrderEnum[GraftOrderEnum["BEFORE"] = 0] = "BEFORE";
    GraftOrderEnum[GraftOrderEnum["AFTER"] = 1] = "AFTER";
})(GraftOrderEnum || (GraftOrderEnum = {}));
/**
 * 插件图
 */
class EventGraphPluginBase extends EventGraphBase {
    constructor() {
        super(...arguments);
        /**
         * 嫁接顺序
         */
        this._graftOrder = GraftOrderEnum.BEFORE;
    }
}/**
 * 夹点移动
 */
class EventGraphClampEdit extends EventGraphPluginBase {
    generate() {
        // const node1 = new EventGraphNode(this, EventHandlerStart); // 开始
        const node2 = new EventGraphNode(this, null); // 夹点编辑节点
        // const node3 = new EventGraphNode(this, EventHandlerGrid); // 划分网格
        // this.addEdge(node1, node2);
        // this.addEdge(node2, node3);
        this.addNode(node2);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node2];
        this.head = node2;
        this.clampNode = node2;
    }
    /**
     * 设置夹点编辑处理器
     * @param handler
     */
    setClampHandler(handler) {
        if (this.clampNode) {
            this.clampNode.setHandler(handler);
        }
    }
}/**
 * 夹点移动
 */
class EventHandlerClampMove extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a;
        // 获取存储
        const storage = PythaStorage.instance;
        const graph = this.node.graph;
        if (graph.parentGraph == null)
            return false;
        const pointerMove = graph.parentGraph.cache.pointerMove.point;
        const tempPrimitives = graph.cache.primitiveList;
        const activeClamps = storage.clampStore.activeClampPoints || [];
        if (tempPrimitives.length <= 0 || activeClamps.length <= 0) {
            return false;
        }
        let primitive = tempPrimitives[0];
        if (this.primitive == null) {
            this.primitive = primitive.clone(); // 放缓存用于编辑时复原
            if (this.primitive.localModelMatrix == null) {
                this.primitive.localModelMatrix = new Matrix4();
                this.primitive.updateWorldModelMatrix(false, false);
            }
        }
        if (pointerMove) {
            // 计算移动向量
            _vec.subVectors(pointerMove, activeClamps[0].featurePoint.point);
            if (!primitive.localModelMatrix) {
                primitive.localModelMatrix = new Matrix4();
            }
            (_a = primitive.localModelMatrix) === null || _a === void 0 ? void 0 : _a.copy(this.primitive.localModelMatrix);
            primitive.updateWorldModelMatrix(false, false);
            primitive.move(_vec);
            primitive.needRedraw = true;
        }
        return true;
    }
    /**
     * 销毁
     */
    dispose() {
        this.primitive = null;
    }
}
const _vec = new Vector3();/**
 * 直线段端部夹点编辑
 */
class EventHandlerLineEndClamp extends EventHandlerBase {
    constructor() {
        super(...arguments);
        this._vec = new Vector3();
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a;
        // 获取存储
        const storage = PythaStorage.instance;
        const graph = this.node.graph;
        if (graph.parentGraph == null)
            return false;
        const pointerMove = graph.parentGraph.cache.pointerMove.point;
        const tempPrimitives = graph.cache.primitiveList;
        const activeClamps = storage.clampStore.activeClampPoints || [];
        if (tempPrimitives.length <= 0 || activeClamps.length <= 0) {
            return false;
        }
        let primitive = tempPrimitives[0];
        if (primitive.type != PrimitiveType.Line)
            return false;
        if (this.primitive == null) {
            this.primitive = primitive.clone(); // 放缓存用于编辑时复原
            if (this.primitive.localModelMatrix == null) {
                this.primitive.localModelMatrix = new Matrix4();
                this.primitive.updateWorldModelMatrix(false, false);
            }
        }
        if (pointerMove) {
            let clamp = activeClamps[0];
            // this._vec.subVectors(pointerMove, clamp.featurePoint.point);
            if (!primitive.localModelMatrix) {
                primitive.localModelMatrix = new Matrix4();
            }
            (_a = primitive.localModelMatrix) === null || _a === void 0 ? void 0 : _a.copy(this.primitive.localModelMatrix);
            primitive.updateWorldModelMatrix(false, false);
            this._vec.copy(pointerMove).applyMatrix4(primitive.worldModelMatrixInverse);
            let geo = primitive.geos[0];
            if (clamp.featurePoint.uvtPosition == 0) {
                // 起点
                geo.start = this._vec;
            }
            else if (clamp.featurePoint.uvtPosition == 1) {
                // 终点
                geo.end = this._vec;
            }
            primitive.needRedraw = true;
        }
        return true;
    }
    /**
     * 销毁
     */
    dispose() {
        this.primitive = null;
    }
}/**
 * 圆弧夹点编辑
 */
class EventHandlerArcClamp extends EventHandlerBase {
    constructor() {
        super(...arguments);
        this._vec = new Vector3();
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a, _b;
        // 获取存储
        const storage = PythaStorage.instance;
        const graph = this.node.graph;
        if (graph.parentGraph == null)
            return false;
        const pointerMove = storage.coordinateStore.currentPos;
        const tempPrimitives = graph.cache.primitiveList;
        const activeClamps = storage.clampStore.activeClampPoints || [];
        if (tempPrimitives.length <= 0 || activeClamps.length <= 0) {
            return false;
        }
        let primitive = tempPrimitives[0];
        if (primitive.type != PrimitiveType.Arc)
            return false;
        if (this.primitive == null) {
            this.primitive = primitive.clone(); // 放缓存用于编辑时复原
            if (this.primitive.localModelMatrix == null) {
                this.primitive.localModelMatrix = new Matrix4();
                this.primitive.updateWorldModelMatrix(false, false);
            }
            let geo = this.primitive.geos[0];
            if (geo == null)
                return false;
            this.plane = new Plane$1().setFromNormalAndCoplanarPoint(geo.normal, geo.getPointAt(0));
        }
        let originChordHeight = (_a = this.primitive.geos[0]) === null || _a === void 0 ? void 0 : _a.getChordHeight();
        if (originChordHeight < 1e-5)
            originChordHeight = 1e-5;
        if (pointerMove) {
            let clamp = activeClamps[0];
            // this._vec.subVectors(pointerMove, clamp.featurePoint.point);
            if (!primitive.localModelMatrix) {
                primitive.localModelMatrix = new Matrix4();
            }
            (_b = primitive.localModelMatrix) === null || _b === void 0 ? void 0 : _b.copy(this.primitive.localModelMatrix);
            primitive.updateWorldModelMatrix(false, false);
            this._vec.copy(pointerMove).applyMatrix4(primitive.worldModelMatrixInverse);
            GeoMeasurement.getPointProjectToPlane(this._vec, this.plane, this._vec); // 将moved点投影到geo所在平面
            let geo = primitive.geos[0];
            if (clamp.featurePoint.uvtPosition == 0) {
                // 起点
                geo.setByEndPointChordHeight(this._vec, geo.getPointAt(1), originChordHeight, geo.normal);
            }
            else if (clamp.featurePoint.uvtPosition == 1) {
                // 终点
                geo.setByEndPointChordHeight(geo.getPointAt(0), this._vec, originChordHeight, geo.normal);
            }
            primitive.needRedraw = true;
        }
        return true;
    }
    /**
     * 销毁
     */
    dispose() {
        this.primitive = null;
    }
}/**
 * 激活夹点处理器 指点击夹点后激活行为
 */
class EventHandlerActiveClamp extends EventHandlerBase {
    /**
     * 运行处理器
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a;
        // 获取存储
        // console.log("EventHandlerActiveClamp");
        const storage = PythaStorage.instance;
        const clamps = storage.clampStore.activeClampPoints || [];
        this.node.graph.clearPlugin(EventGraphClamp.cmd);
        if (clamps.length <= 0)
            return false;
        for (let clamp of clamps) {
            clamp.isActive = true;
            // 找到需要嫁接的图
            let graph = this.findClampEditNodes(clamp);
            // 嫁接节点
            this.node.graph.addGraphPluginAtBefore(EventGraphClamp.cmd, graph);
            // 将图元复制一份放入
            let primitive = (_a = clamp.featurePoint.primitive) === null || _a === void 0 ? void 0 : _a.clone();
            primitive.temporary = true;
            primitive.uuid = clamp.featurePoint.primitive.uuid;
            this.node.graph.cache.primitiveList.push(primitive); // 放临时图元入缓存
            graph.cache.primitiveList.push(primitive); // 在插件图里也放一份相同的
            storage.primitiveStore.tempPrimitiveDict[primitive.uuid] = primitive; // 放PS 用于渲染
        }
        return true;
    }
    /**
     * 查找夹点对应的编辑节点
     * @param clamp
     */
    findClampEditNodes(clamp) {
        let featurePoint = clamp.featurePoint;
        let graph = new EventGraphClampEdit(this.node.graph.eventMediator);
        if (featurePoint.type == FEATURE_POINT_TYPE.CENTER || featurePoint.uvtPosition == null) {
            // 默认移动节点
            graph.setClampHandler(EventHandlerClampMove);
        }
        else if (featurePoint.primitive.type == PrimitiveType.Line) {
            graph.setClampHandler(EventHandlerLineEndClamp);
        }
        else if (featurePoint.primitive.type == PrimitiveType.Arc) {
            graph.setClampHandler(EventHandlerArcClamp);
        }
        // TODO 其他夹点对应的图在这里注册
        return graph;
    }
}/**
 * 计算邻近夹点
 */
class EventHandlerCalClamp extends EventHandlerBase {
    /**
     * 运行处理器
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a;
        // 获取存储
        const storage = PythaStorage.instance;
        const clamps = storage.clampStore.clampPoints;
        const point3 = storage.coordinateStore.currentPos;
        const viewportStore = storage.viewportStore;
        const camera = (_a = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        // 用捕捉后的光标点计算
        _p$1.copy(point3).project(camera);
        _p2.set(_p$1.x, _p$1.y);
        // 计算捕捉到的夹点
        let points = this.calClosestClamp(_p2, clamps);
        if (points.length <= 0) {
            storage.clampStore.activeClampPoints = [];
        }
        else {
            storage.clampStore.activeClampPoints = points;
            storage.coordinateStore.setCurrentPos(points[0].featurePoint.point);
        }
        return true;
    }
    /**
     * 计算最近的夹点
     * @param point2
     * @param clamps
     * @returns
     */
    calClosestClamp(point2, clamps) {
        var _a, _b, _c;
        let minDist = Number.MAX_VALUE;
        let closestPoint = null;
        const storage = PythaStorage.instance;
        const viewportStore = storage.viewportStore;
        const camera = (_a = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
        if (camera == null)
            return [];
        // 先找到最近的
        for (let clampPoint of clamps) {
            if (((_b = clampPoint.featurePoint) === null || _b === void 0 ? void 0 : _b.point) == null)
                continue;
            _point1.copy(clampPoint.featurePoint.point).project(camera);
            let distance = Math.sqrt((_point1.x - point2.x) ** 2 + (_point1.y - point2.y) ** 2);
            if (distance < minDist) {
                minDist = distance;
                closestPoint = clampPoint;
            }
        }
        let rect = viewportStore.renderer.domElement.getBoundingClientRect();
        let tmp = Math.min(rect.width, rect.height);
        let threshold = storage.clampStore.threshold / tmp;
        if (minDist > threshold)
            return [];
        if (closestPoint == null)
            return [];
        // 再找周围重合的
        let closestPoints = [];
        for (let clampPoint of clamps) {
            if (((_c = clampPoint.featurePoint) === null || _c === void 0 ? void 0 : _c.point) == null)
                continue;
            _point1.copy(clampPoint.featurePoint.point);
            _point2$1.copy(closestPoint.featurePoint.point);
            let distsq = _point1.sub(_point2$1).length();
            if (distsq < 1e-5) {
                closestPoints.push(clampPoint);
            }
        }
        return closestPoints;
    }
}
const _point1 = new Point();
const _point2$1 = new Point();
const _p$1 = new Point();
const _p2 = new Point2();/**
 * 钝化夹点
 */
class EventHandlerDisActiveClamp extends EventHandlerBase {
    /**
     * 运行处理器
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a;
        // 获取存储
        const storage = PythaStorage.instance;
        const selectedPrimitives = storage.selectStore.getUnlockedPrimitives();
        const clamps = storage.clampStore.activeClampPoints || [];
        for (let clamp of clamps) {
            clamp.isActive = false;
        }
        // 清除辅助线
        if (this.node.graph.cache.data['helpline'] != null) {
            let helpline = this.node.graph.cache.data['helpline'];
            (_a = helpline.remove) === null || _a === void 0 ? void 0 : _a.call(helpline);
        }
        // 清除缓存图元
        for (let pri of this.node.graph.cache.primitiveList) {
            if (pri.temporary) {
                pri.needDelete = true;
            }
            else if (!pri.isSelected) {
                pri.isSelected = true;
                selectedPrimitives.push(pri);
            }
        }
        storage.selectStore.selectPrimitives = selectedPrimitives.filter(item => !item.temporary);
        return true;
    }
}/**
 * 夹点编辑
 */
class EventGraphClamp extends EventGraphBase {
    constructor() {
        super(...arguments);
        /**
         * 是否是常驻图
         */
        this.isAlwaysActive = true;
    }
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node4 = new EventGraphNodeSwitch(this, () => {
            // 判断激活夹点
            const storage = PythaStorage.instance;
            let clamps = storage.clampStore.activeClampPoints;
            if (clamps == null || clamps.length <= 0) {
                return [0];
            }
            return [1, 2];
        });
        const node5 = new EventGraphNode(this, EventHandlerActiveClamp);
        const node6 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        const node7 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node8 = new EventGraphNode(this, EventHandlerCalPointerDown);
        const node10 = new EventGraphNode(this, EventHandlerEditPri);
        const node11 = new EventGraphNodeRender(this, true, UpdateType.TEMP);
        const node12 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node13 = new EventGraphNode(this, EventHandlerCalPointerMove);
        const node14 = new EventGraphNode(this, EventHandlerCalClamp);
        const node17 = new EventGraphNodeSwitch(this, () => {
            // 判断夹点数量
            const storage = PythaStorage.instance;
            if (storage.clampStore.clampPoints.length <= 0) {
                return [];
            }
            return [0];
        });
        const node18 = new EventGraphNodeSwitch(this, () => {
            const storage = PythaStorage.instance;
            let clamps = storage.clampStore.activeClampPoints;
            if (clamps != null && clamps.length > 0) {
                return [0];
            }
            return [1];
        });
        const node19 = new EventGraphNode(this, EventHandlerDisActiveClamp);
        const node20 = new EventGraphNode(this, EventHandlerDisableSelect);
        const node21 = new EventGraphNode(this, EventHandlerSelectStart);
        const node22 = new EventGraphNode(this, EventHandlerHelpLine);
        const node23 = new EventGraphNodeGraft(this, EventGraphClamp.cmd);
        const node24 = new EventGraphNode(this, EventHandlerCapture);
        const node25 = new EventGraphNode(this, EventHandlerOrthoPolar);
        const node26 = new EventGraphNode(this, EventHandlerInitCapture);
        const node28 = new EventGraphNode(this, EventHandlerGrid);
        const node29 = new EventGraphNode(this, EventHandlerShowClampPoint);
        const node30 = new EventGraphNode(this, EventHandlerMouseWheel);
        const node31 = new EventGraphNode(this, EHChangeCrossCursor);
        const node32 = new EventGraphNode(this, EHChangePickCrossCursor);
        const node33 = new EventGraphNode(this, EventHandlerCaptureClear);
        const node35 = new EventGraphNode(this, EventHandlerGrid);
        const node36 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node37 = new EventGraphNode(this, EventHandlerSettingOrthoPoint);
        this.addEdge(node1, node2);
        this.addEdge(node5, node6);
        this.addEdge(node1, node13);
        this.addEdge(node13, node17);
        this.addEdge(node14, node18);
        this.addEdge(node17, node14);
        this.addEdge(node8, node7, EDGE_TYPE.STOP);
        /**没有选中夹点*/
        this.addEdge(node4, node1);
        this.addEdge(node5, node13, EDGE_TYPE.STOP);
        this.addEdge(node8, node10);
        /**捕捉到夹点*/
        this.addEdge(node18, node20);
        this.addEdge(node22, node23);
        this.addEdge(node7, node24);
        this.addEdge(node24, node25);
        this.addEdge(node25, node22);
        this.addEdge(node26, node7);
        this.addEdge(node28, node19);
        this.addEdge(node19, node29);
        this.addEdge(node29, node12);
        this.addEdge(node26, node30);
        this.addEdge(node30, node22);
        this.addEdge(node6, node31);
        this.addEdge(node31, node26);
        this.addEdge(node12, node32);
        this.addEdge(node32, node33);
        this.addEdge(node33, node1);
        this.addEdge(node35, node11);
        this.addEdge(node23, node35);
        this.addEdge(node10, node36);
        this.addEdge(node36, node28);
        this.addEdge(node2, node37);
        this.addEdge(node37, node4);
        this.addEdge(node4, node5);
        this.addEdge(node18, node21);
        this.addEdge(node4, node8);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/92
    }
    /**
    * 结束图
    */
    end() {
        const storage = PythaStorage.instance;
        for (const [_, node] of this.graph) {
            node.dispose();
        }
        // 清空缓存图元
        for (let pri of this.cache.primitiveList) {
            if (pri.temporary) {
                pri.needDelete = true;
            }
        }
        // 清空夹点
        storage.clampStore.clear();
        // 恢复夹点显示
        storage.clampStore.clampHidden = storage.clampStore.clampDisable;
        // 清空缓存
        this.cache.pointerDownList = [];
        this.cache.pointerUpList = [];
        this.cache.pointerMove = new Pointer();
        this.cache.primitiveList = [];
        this.cache.pointerWheel = new Pointer();
        this.cache.data = {};
        // this.cache.lastPointerMove = new Pointer();
        // 从头监听
        this.head.run();
    }
    /**
     * 匹配挂起的节点
     * @param event
     * @returns
     */
    matchEventAndNode(event) {
        if (this.eventMediator.tempActiveGraph != null) {
            return;
        }
        super.matchEventAndNode(event);
    }
}
/**
 * zoom指令 控制器缩放视图
 */
EventGraphClamp.cmd = 'CLAMPPOINT';/**
 * 计算坐标轴图元
 */
class EventHandlerShowAxes extends EventHandlerBase {
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        var _a, _b;
        const storage = this.getPythaStorage();
        const ucs = storage.coordinateStore.activeUcs;
        // 原点
        _point.set(ucs.elements[12], ucs.elements[13], ucs.elements[14]);
        if (!storage.primitiveStore.axes) {
            let axes = new AxesPrimitive();
            axes.setByMatrix(ucs, (_a = storage.viewportStore.viewportItems[storage.viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.cameraEdge);
            axes.needRedraw = true;
            storage.primitiveStore.systemPrimitiveDict[axes.uuid] = axes;
            storage.primitiveStore.axes = axes;
        }
        let axes = storage.primitiveStore.axes;
        // 缩放
        let scale = this.node.graph.cache.data['scale'];
        if (scale != null && scale != 0) {
            axes.setByMatrix(ucs, (_b = storage.viewportStore.viewportItems[storage.viewportStore.currentViewportKey]) === null || _b === void 0 ? void 0 : _b.cameraEdge);
            axes.needRedraw = true;
        }
        if (!storage.coordinateStore.showUcs) {
            axes.hidden = true;
        }
        else {
            axes.hidden = false;
        }
        return true;
    }
}
const _point = new Point();/**
 * 监听修正坐标轴大小的指令
 */
class EventHandlerOnAxesKeep extends EventHandlerBase {
    /**
     * 构造函数
     * @param node
     */
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventSetting();
        this.needEventOnce = false;
    }
    /**
     * 执行处理器
     * @param event
     * @returns
     */
    run(event) {
        if (event.cmd != this.needEvent.cmd)
            return false; // 如果传入事件不符 则不执行处理器
        if (event.data.key !== SETTING_KEY.AXES_KEEP)
            return false;
        return true;
    }
}/**
 * 显示坐标轴
 */
class EventGraphAxes extends EventGraphBase {
    constructor() {
        super(...arguments);
        /**
         * 是否是常驻图
         */
        this.isAlwaysActive = true;
    }
    /**
     * 创建节点
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node3 = new EventGraphNode(this, EventHandlerShowAxes);
        const node4 = new EventGraphNode(this, EventHandlerGrid);
        const node5 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node6 = new EventGraphNode(this, EventHandlerOnZoomChanged);
        const node7 = new EventGraphNode(this, EventHandlerOnAxesKeep);
        this.addEdge(node1, node3);
        this.addEdge(node3, node4);
        this.addEdge(node4, node5);
        this.addEdge(node1, node6);
        this.addEdge(node6, node3);
        this.addEdge(node1, node7);
        this.addEdge(node7, node3);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/94
    }
    /**
    * 结束图
    */
    end() {
        // this.cache.pointerDownList = [];
        // this.cache.pointerUpList = [];
        // this.cache.pointerMove = new Pointer();
        // this.cache.primitiveList = [];
        // this.cache.pointerWheel = new Pointer();
        // this.cache.data = {};
        // this.cache.lastPointerMove = new Pointer();
        // this.head.run();
    }
}
/**
 * 指令
 */
EventGraphAxes.cmd = 'AXES_SHOW';/**
 * 监听加载图元处理器
 */
class EHLoadDataListener extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventDataChange();
        this.needEventOnce = false;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(data = {}) {
        //获取全局存储
        const storage = PythaStorage.instance;
        //判断接受事件是否为DATA_CHANGE类型，如果是，则进行处理
        if (data && data.cmd === PythaEventName.DATA_CHANGE) {
            let recvData = data.data;
            //如果存在需要添加的数据，则添加图元
            if (recvData.add_primitives && recvData.add_primitives.length > 0) {
                for (let i = 0; i < recvData.add_primitives.length; i++) {
                    let primitive = recvData.add_primitives[i];
                    if (storage.primitiveStore.primitiveDict[primitive.uuid]) { //如果原图元存在，则将原图元存放到临时数组中，并标记为需要删除
                        storage.primitiveStore.primitiveDict[primitive.uuid].needDelete = true;
                        storage.primitiveStore.primitiveDict[primitive.uuid].needRedraw = true;
                        storage.primitiveStore.tempPrimitiveDict[primitive.uuid] = storage.primitiveStore.primitiveDict[primitive.uuid];
                    }
                    //将新的图元放入
                    storage.primitiveStore.primitiveDict[primitive.uuid] = primitive;
                    primitive.needRedraw = true;
                }
            }
            if (recvData.add_axes && recvData.add_axes.length > 0) {
                for (const axes of recvData.add_axes) {
                    storage.coordinateStore.ucsMap[axes.uuid] = axes;
                }
                const matrix = recvData.add_axes[0].getNormalMatrix();
                storage.coordinateStore.activeUcs = matrix;
                if (storage.primitiveStore.axes) {
                    storage.primitiveStore.axes.needDelete = true;
                }
                storage.primitiveStore.axes = recvData.add_axes[0];
                storage.primitiveStore.systemPrimitiveDict[recvData.add_axes[0].uuid] = recvData.add_axes[0];
                storage.primitiveStore.axes.needRedraw = true;
                _z.set(matrix.elements[8], matrix.elements[9], matrix.elements[10]);
                _p.set(matrix.elements[12], matrix.elements[13], matrix.elements[14]);
                storage.coordinateStore.workPlane.setFromNormalAndCoplanarPoint(_z, _p);
            }
            //TODO 处理删除图元
        }
        return true;
    }
    /**
     * 销毁
     */
    dispose() {
    }
}
const _z = new Vector3();
const _p = new Vector3();/**
 * 加载数据的常驻事件图
 */
class EGLoadData extends EventGraphBase {
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node4 = new EventGraphNode(this, EventHandlerGrid);
        const node5 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node6 = new EventGraphNode(this, EHLoadDataListener);
        const node7 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        this.addEdge(node4, node5);
        this.addEdge(node1, node6);
        this.addEdge(node6, node7);
        this.addEdge(node7, node4);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/98
    }
    /*
    * 销毁
    */
    end() {
        //加载数据常驻图不需要被销毁
    }
}
EGLoadData.cmd = 'LOAD_DATA';/**
 * 计算相机缩放
 */
class EventHandlerCalZoomIn extends EventHandlerBase {
    constructor() {
        super(...arguments);
        /**
         * 更新目标点，计算相机矩阵
         * @param v
         */
        this.updateTarget = (v) => {
            var _a;
            const storage = PythaStorage.instance;
            const viewportStore = storage.viewportStore;
            const camera = (_a = viewportStore.viewportItems[viewportStore.currentViewportKey]) === null || _a === void 0 ? void 0 : _a.camera;
            const position = camera.position;
            let offset = position.clone().sub(viewportStore.viewportItems[viewportStore.currentViewportKey].target);
            viewportStore.viewportItems[viewportStore.currentViewportKey].target.set(v.x, v.y, v.z);
            position.copy(viewportStore.viewportItems[viewportStore.currentViewportKey].target).add(offset);
            camera.updateMatrixWorld();
            if (camera && (camera.type === 'OrthographicCamera' || camera.type === 'PerspectiveCamera')) {
                camera.updateProjectionMatrix();
            }
        };
    }
    run(data) {
        const isZoomIn = this.node.graph.cache.data;
        if (isZoomIn == null) {
            return true;
        }
        const storage = PythaStorage.instance;
        const viewportStore = storage.viewportStore;
        const viewportItem = viewportStore.viewportItems[viewportStore.currentViewportKey];
        if (!viewportItem) {
            return true;
        }
        const camera = viewportItem.camera;
        let zoomScale;
        if (isZoomIn) {
            zoomScale = camera.type === "OrthographicCamera" ? 1.4 : 1.05;
        }
        else {
            zoomScale = camera.type === "OrthographicCamera" ? 1 / 1.4 : 1 / 1.05;
        }
        if (viewportItem.cameraEdge < viewportStore.minCameraEdge && zoomScale >= 1) {
            return true;
        }
        viewportItem.cameraEdge /= zoomScale;
        const zoomCenter = viewportStore.getEntityViewCenter();
        const _target = viewportItem.target.clone();
        this.updateTarget(zoomCenter);
        // 发送zoomchange事件（修改坐标轴）
        let zoomChange = new PythaEventZoomChange();
        zoomChange.data = zoomScale;
        this.node.graph.eventMediator.emitEvent(zoomChange);
        if (camera.type === 'OrthographicCamera') {
            //TODO 
            let orthoCamera = camera;
            orthoCamera.left = orthoCamera.left / zoomScale;
            orthoCamera.right = orthoCamera.right / zoomScale;
            orthoCamera.top = orthoCamera.top / zoomScale;
            orthoCamera.bottom = orthoCamera.bottom / zoomScale;
            orthoCamera.updateProjectionMatrix();
        }
        else {
            let persCamera = camera;
            let cameraLookAt = new Vector3();
            let perspectiveDir = new Vector3();
            persCamera.getWorldDirection(cameraLookAt); //获取相机目视方向
            perspectiveDir.copy(persCamera.position).sub(viewportStore.scene.position); //相机目视点到场景的距离，根据这个距离对相机进行缩放
            persCamera.position.addScaledVector(cameraLookAt, perspectiveDir.length() * (zoomScale - 1)); //相机目视点平移
            persCamera.updateProjectionMatrix();
        }
        // update target
        let v1 = zoomCenter.clone().sub(_target);
        // v1.multiplyScalar(_lastZoom / camera.zoom);
        v1.multiplyScalar(1 / zoomScale);
        let new_target = zoomCenter.sub(v1);
        this.updateTarget(new_target);
        return true;
    }
}/**
 * 一次性事件处理，需要zoomInOut事件
 */
class EventHandlerOnZoomInOut extends EventHandlerBase {
    /**
     * 构造函数
     * @param node
     */
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventZoomInOut();
        this.needEventOnce = false;
    }
    run(event) {
        if (event.cmd != this.needEvent.cmd)
            return false; // 如果传入事件不符 则不执行处理器
        this.node.graph.cache.data = event.data;
        return true;
    }
}/**
 * 缩放控制图
 */
class EventGraphZoomInOut extends EventGraphBase {
    constructor() {
        super(...arguments);
        /**
         * 是否是常驻图
         */
        this.isAlwaysActive = true;
    }
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerCalZoomIn);
        const node3 = new EventGraphNode(this, EventHandlerOnZoomInOut);
        const node4 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        this.addEdge(node1, node3);
        this.addEdge(node3, node2);
        this.addEdge(node2, node4);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/100
    }
    end() {
    }
}
EventGraphZoomInOut.cmd = "ZOOMINOUT";/**
 * 缩放视图至显示的图元全部在视口中
 */
class EventGraphZoomAll extends EventGraphBase {
    constructor() {
        super(...arguments);
        /**
         * 是否常驻图
         */
        this.isAlwaysActive = true;
    }
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHanderCalAllBoundingBox);
        const node5 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node6 = new EventGraphNode(this, EventHanderShowAllInRect);
        const node7 = new EventGraphNodeRender(this, false, UpdateType.MAIN);
        const node8 = new EventGraphNode(this, EventHandlerGrid);
        const node9 = new EventGraphNode(this, EventHandlerOnZoomAll);
        const node10 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        const node11 = new EventGraphNodeNotice(this, { cmd: 'data_change', data: {
                viewChangeEnd: true
            } });
        this.addEdge(node2, node6);
        this.addEdge(node7, node5);
        this.addEdge(node8, node7);
        this.addEdge(node1, node9);
        this.addEdge(node9, node2);
        this.addEdge(node10, node8);
        this.addEdge(node6, node11);
        this.addEdge(node11, node10);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/48
    }
    end() {
    }
}
/**
 * 指令 用于注册事件图
 */
EventGraphZoomAll.cmd = 'ZOOMALL';/**
 * 设置
 */
class EventHandlerSetting extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventSetting();
        this.needEventOnce = false;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(event) {
        var _a;
        if (event.cmd != this.needEvent.cmd)
            return false; // 如果传入事件不符 则不执行处理器
        // 获得存储
        const storage = PythaStorage.instance;
        if (event.data.key == SETTING_KEY.CAPTURE) {
            // 设置捕捉开关
            storage.captureStore.enabled = !!event.data.value;
        }
        else if (event.data.key == SETTING_KEY.CAPTURE_TYPE_LIST) {
            // 设置捕捉类型列表
            let typeList = ((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.value) || [];
            storage.captureStore.captureTypeList = typeList;
        }
        else if (event.data.key == SETTING_KEY.ORTHA) {
            // 设置正交
            storage.orthoPolarStore.orthoEnabled = !!event.data.value;
            if (!!event.data.value) {
                storage.orthoPolarStore.polarEnabled = false;
            }
        }
        else if (event.data.key == SETTING_KEY.POLAR) {
            // 设置极轴
            storage.orthoPolarStore.polarEnabled = !!event.data.value;
            if (!!event.data.value) {
                storage.orthoPolarStore.orthoEnabled = false;
            }
        }
        else if (event.data.key === SETTING_KEY.AXES) {
            const axes = storage.primitiveStore.axes;
            const newAxes = event.data.value;
            if (!newAxes || axes.uuid === newAxes.uuid)
                return true;
            axes.needDelete = true;
            //修改坐标系
            storage.coordinateStore.ucsMap[newAxes.uuid] = newAxes.localModelMatrix;
            storage.coordinateStore.setActiveUcs(newAxes.localModelMatrix);
            storage.coordinateStore.workPlane.transformMatrix.copy(newAxes.localModelMatrix);
            storage.primitiveStore.axes = newAxes;
            storage.primitiveStore.systemPrimitiveDict[newAxes.uuid] = newAxes;
            newAxes.needRedraw = true;
            this.node.graph.cache.data['needRedraw'] = true;
        }
        else if (event.data.key === SETTING_KEY.RENDER_MODE) {
            // 设置渲染模式
            let mode = event.data.value;
            if (storage.renderStore.renderMode == mode) {
                return true;
            }
            const renderStore = storage.renderStore;
            if (mode == RenderMode.OPACITY) {
                for (let key in renderStore.objectRenderBucket) {
                    let material = renderStore.objectRenderBucket[key].material;
                    material.opacity = material.opacity * storage.renderStore.opacityModeRatio;
                    material.depthWrite = false;
                }
            }
            else if (storage.renderStore.renderMode == RenderMode.OPACITY) {
                for (let key in renderStore.objectRenderBucket) {
                    let material = renderStore.objectRenderBucket[key].material;
                    material.opacity = material.opacity / storage.renderStore.opacityModeRatio;
                    material.depthWrite = true;
                }
            }
            storage.renderStore.renderMode = mode;
            this.node.graph.cache.data['needRender'] = true;
        }
        return true;
    }
}/**
 * 设置图
 */
class EventGraphSetting extends EventGraphBase {
    constructor() {
        super(...arguments);
        /**
         * 是否是常驻图
         */
        this.isAlwaysActive = true;
    }
    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerSetting);
        const node3 = new EventGraphNodeSwitch(this, () => {
            if (!!this.cache.data['needRedraw']) {
                this.cache.data['needRedraw'] = false;
                return [0];
            }
            else if (!!this.cache.data['needRender']) {
                this.cache.data['needRender'] = false;
                return [1];
            }
            return [];
        });
        const node4 = new EventGraphNode(this, EventHandlerGrid);
        const node5 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node6 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node7 = new EventGraphNodeRender(this, false, UpdateType.ALL);
        this.addEdge(node1, node2);
        this.addEdge(node2, node3);
        this.addEdge(node3, node4);
        this.addEdge(node4, node5);
        this.addEdge(node5, node6);
        this.addEdge(node7, node6);
        this.addEdge(node3, node7);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/102
    }
    /**
     * 结束图
     */
    end() {
        // 清空缓存
        for (const [_, node] of this.graph) {
            node.dispose();
        }
        this.cache.pointerDownList = [];
        this.cache.pointerUpList = [];
        this.cache.pointerMove = new Pointer();
        this.cache.primitiveList = [];
        this.cache.pointerWheel = new Pointer();
        this.cache.data = {};
        this.head.run();
    }
    /**
     * 匹配挂起的节点
     * @param event
     * @returns
     */
    matchEventAndNode(event) {
        super.matchEventAndNode(event);
    }
}
/**
 * 指令
 */
EventGraphSetting.cmd = 'SETTING';/**
 * 切换图层
 */
class EventHandlerLayerChange extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventSetting();
        this.needEventOnce = false;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(event) {
        if (event.cmd != this.needEvent.cmd)
            return false; // 如果传入事件不符 则不执行处理器
        // 获得存储
        const storage = this.getPythaStorage();
        if (event.data.key != SETTING_KEY.LAYER_CHANGE) {
            return false;
        }
        let layer = event.data.value;
        let pris = [];
        // 修改选中图元的图层
        let primitives = storage.selectStore.getUnlockedPrimitives();
        if (primitives.length <= 0)
            return false;
        for (let pri of primitives) {
            if (pri.layerUuid == layer.uuid)
                continue;
            let newPri = pri.clone();
            newPri.uuid = pri.uuid;
            newPri.layerUuid = layer.uuid;
            for (let key in newPri.materials) {
                let mat = newPri.materials[key];
                if (pri.colorByLayer) {
                    mat.color.set(layer.color);
                }
            }
            newPri.needRedraw = true;
            pris.push(newPri);
        }
        // 设置撤销重做并执行
        let updatePriCmd = new UpdatePrimitiveCmd(pris, this.node.graph.eventMediator);
        storage.historyStore.undos.push(updatePriCmd);
        updatePriCmd.execute();
        return true;
    }
}/**
 * 更新图层指令
 */
class UpdateLayerCmd extends CommandBase {
    /**
     * 构造函数
     * @param primitives
     * @param eventMediator
     */
    constructor(layer, eventMediator) {
        super();
        this.eventMediator = eventMediator;
        this.newLayer = Object.assign({}, layer);
        const storage = eventMediator.storage;
        let oldLayer = storage.layerStore.layers.find(item => item.uuid == this.newLayer.uuid);
        this.oldLayer = Object.assign({}, oldLayer);
    }
    /**
     * 执行
     */
    execute() {
        const storage = this.eventMediator.storage;
        let idx = storage.layerStore.layers.findIndex(item => item.uuid == this.oldLayer.uuid);
        if (idx == -1) {
            storage.layerStore.layers.push(this.newLayer);
        }
        else {
            storage.layerStore.layers.splice(idx, 1, this.newLayer);
        }
        this.eventMediator.noticeHandler.notice(this, new PythaEventDataChange({ update_layer: this.newLayer }));
    }
    /**
     * 撤销
     */
    undo() {
        const storage = this.eventMediator.storage;
        let idx = storage.layerStore.layers.findIndex(item => item.uuid == this.newLayer.uuid);
        if (idx == -1) {
            storage.layerStore.layers.push(this.oldLayer);
        }
        else {
            storage.layerStore.layers.splice(idx, 1, this.oldLayer);
        }
        this.eventMediator.noticeHandler.notice(this, new PythaEventDataChange({ update_layer: this.oldLayer }));
    }
}/**
 * 设置
 */
class EventHandlerLayerColor extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventSetting();
        this.needEventOnce = false;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(event) {
        if (event.cmd != this.needEvent.cmd)
            return false; // 如果传入事件不符 则不执行处理器
        // 获得存储
        const storage = this.getPythaStorage();
        if (event.data.key != SETTING_KEY.LAYER_COLOR) {
            return false;
        }
        let layer = event.data.value;
        let pris = [];
        // 根据图层颜色 更新图元颜色
        Object.keys(storage.primitiveStore.primitiveDict).forEach(key => {
            let pri = storage.primitiveStore.primitiveDict[key];
            if (pri.layerUuid != layer.uuid)
                return;
            if (!pri.colorByLayer)
                return;
            let newPri = pri.clone();
            newPri.isInView = pri.isInView;
            newPri.uuid = pri.uuid;
            for (let key in newPri.materials) {
                let mat = newPri.materials[key];
                mat.color.set(layer.color);
            }
            newPri.needRedraw = true;
            pris.push(newPri);
        });
        // 设置撤销重做并执行
        let cmdGroup = new CommandGroup();
        let updatePriCmd = new UpdatePrimitiveCmd(pris, this.node.graph.eventMediator);
        cmdGroup.addCmd(updatePriCmd);
        let updateLayerCmd = new UpdateLayerCmd(layer, this.node.graph.eventMediator);
        cmdGroup.addCmd(updateLayerCmd);
        storage.historyStore.undos.push(cmdGroup);
        cmdGroup.execute();
        return true;
    }
}/**
 * 锁定图元指令
 */
class LockPrimitiveCmd extends CommandBase {
    /**
     * 构造函数
     * @param primitives
     * @param eventMediator
     */
    constructor(primitives, lock, eventMediator) {
        super();
        /**
         * 缓存图元
         */
        this.primitives = [];
        this.eventMediator = eventMediator;
        this.primitives = [...primitives];
        this.lock = lock;
    }
    /**
     * 执行
     */
    execute() {
        for (let pri of this.primitives) {
            pri.lock = this.lock;
            pri.needRedraw = true;
        }
    }
    /**
     * 撤销
     */
    undo() {
        for (let pri of this.primitives) {
            pri.lock = !this.lock;
            pri.needRedraw = true;
        }
    }
}/**
 * 设置
 */
class EventHandlerLayerLock extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventSetting();
        this.needEventOnce = false;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(event) {
        if (event.cmd != this.needEvent.cmd)
            return false; // 如果传入事件不符 则不执行处理器
        // 获得存储
        const storage = this.getPythaStorage();
        if (event.data.key != SETTING_KEY.LAYER_LOCK) {
            return false;
        }
        let layer = event.data.value;
        let pris = [];
        Object.keys(storage.primitiveStore.primitiveDict).forEach(key => {
            let pri = storage.primitiveStore.primitiveDict[key];
            if (pri.layerUuid != layer.uuid)
                return;
            pris.push(pri);
        });
        let cmdGroup = new CommandGroup();
        let lockCmd = new LockPrimitiveCmd(pris, layer.lock, this.node.graph.eventMediator);
        cmdGroup.addCmd(lockCmd);
        let updateLayerCmd = new UpdateLayerCmd(layer, this.node.graph.eventMediator);
        cmdGroup.addCmd(updateLayerCmd);
        storage.historyStore.undos.push(cmdGroup);
        cmdGroup.execute();
        return true;
    }
}/**
 * 设置
 */
class EventHandlerLayerShowHidden extends EventHandlerBase {
    constructor(node) {
        super(node);
        this.needEvent = new PythaEventSetting();
        this.needEventOnce = false;
    }
    /**
     * 处理器默认运行入口
     * @param data
     * @returns
     */
    run(event) {
        if (event.cmd != this.needEvent.cmd)
            return false; // 如果传入事件不符 则不执行处理器
        // 获得存储
        const storage = this.getPythaStorage();
        if (event.data.key != SETTING_KEY.LAYER_SHOW) {
            return false;
        }
        let layer = event.data.value;
        let pris = [];
        // 更新图元颜色
        Object.keys(storage.primitiveStore.primitiveDict).forEach(key => {
            let pri = storage.primitiveStore.primitiveDict[key];
            if (pri.layerUuid != layer.uuid)
                return;
            pris.push(pri);
        });
        let cmdGroup = new CommandGroup();
        let updateShowCmd = new ShowPrimitiveCmd(pris, this.node.graph.eventMediator, layer.hidden);
        cmdGroup.addCmd(updateShowCmd);
        let updateLayerCmd = new UpdateLayerCmd(layer, this.node.graph.eventMediator);
        cmdGroup.addCmd(updateLayerCmd);
        storage.historyStore.undos.push(cmdGroup);
        cmdGroup.execute();
        return true;
    }
}/**
 * 图层设置
 */
class EventGraphLayer extends EventGraphBase {
    constructor() {
        super(...arguments);
        /**
         * 是否是常驻图
         */
        this.isAlwaysActive = true;
    }
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNode(this, EventHandlerLayerShowHidden);
        const node3 = new EventGraphNode(this, EventHandlerLayerLock);
        const node4 = new EventGraphNode(this, EventHandlerLayerColor);
        const node5 = new EventGraphNode(this, EventHandlerGrid);
        const node6 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node7 = new EventGraphNode(this, EventHandlerLayerChange);
        const node8 = new EventGraphNode(this, EventHandlerCalPrimitiveInView);
        this.addEdge(node1, node2);
        this.addEdge(node1, node3);
        this.addEdge(node1, node4);
        this.addEdge(node2, node5);
        this.addEdge(node4, node5);
        this.addEdge(node1, node7);
        this.addEdge(node7, node5);
        this.addEdge(node5, node8);
        this.addEdge(node3, node8);
        this.addEdge(node8, node6);
        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;
        // https://event.graph.tncet.com/graphs/143
    }
    end() {
        this.cache.data = {};
        this.head.run();
    }
}
/**
 * 显示所有图元 用于注册事件图
 */
EventGraphLayer.cmd = 'LAYER_SETTING';/**
 * 引擎控制器
 */
class PythaEngineControl {
    constructor() {
        /**
         * 用来给pointerdown事件打唯一识别，防止不同事件处理器对象接收时重复计算
         */
        this.pointerDownId = 1;
        /**
         * 画布的鼠标按下事件
         * @param event
         */
        this.onPointerDown = (event) => {
            var _a, _b;
            _point2.set(event.clientX, event.clientY);
            // 鼠标右键的指定事件
            if (MOUSE_BUTTON.RIGHT === event.button) {
                if (this.eventMediator.tempActiveGraph != null) {
                    // 判定是右键确认
                    let confirmEvent = new PythaEventConfirm();
                    (_a = this.eventMediator) === null || _a === void 0 ? void 0 : _a.emitEvent(confirmEvent);
                }
                return;
            }
            // 左键、中键事件
            let pythaEvent = new PythaEventPointerDown();
            let pointer = pythaEvent.data;
            pointer.point2 = _point2;
            pointer.type = "MOUSE";
            pointer.ctrlKey = event.ctrlKey;
            pointer.shiftKey = event.shiftKey;
            pointer.altKey = event.altKey;
            pointer.button = event.button;
            pointer.id = this.pointerDownId++;
            pointer.deltaY = (event === null || event === void 0 ? void 0 : event.deltaY) || 0;
            if (this.pointerDownId > 100000)
                this.pointerDownId = 1;
            (_b = this.eventMediator) === null || _b === void 0 ? void 0 : _b.emitEvent(pythaEvent);
        };
        /**
         * 用来给pointermove事件打唯一识别，防止不同事件处理器对象接收时重复计算
         */
        this.pointerMoveId = 1;
        /**
         * 画布的鼠标移动事件
         * @param event
         */
        this.onPointerMove = (event) => {
            var _a;
            _point2.set(event.clientX, event.clientY);
            let pythaEvent = new PythaEventPointerMove();
            let pointer = pythaEvent.data;
            pointer.point2 = _point2;
            pointer.type = "MOUSE";
            pointer.ctrlKey = event.ctrlKey;
            pointer.shiftKey = event.shiftKey;
            pointer.altKey = event.altKey;
            pointer.button = event.button;
            pointer.id = this.pointerMoveId++;
            pointer.deltaY = (event === null || event === void 0 ? void 0 : event.deltaY) || 0;
            if (this.pointerMoveId > 100000)
                this.pointerMoveId = 1;
            (_a = this.eventMediator) === null || _a === void 0 ? void 0 : _a.emitEvent(pythaEvent);
        };
        /**
         * 用来给pointermove事件打唯一识别，防止不同事件处理器对象接收时重复计算
         */
        this.pointerUpId = 1;
        /**
         * 画布的鼠标抬起事件
         * @param event
         */
        this.onPointerUp = (event) => {
            var _a;
            _point2.set(event.clientX, event.clientY);
            let pythaEvent = new PythaEventPointerUp();
            let pointer = pythaEvent.data;
            pointer.point2 = _point2;
            pointer.type = "MOUSE";
            pointer.ctrlKey = event.ctrlKey;
            pointer.shiftKey = event.shiftKey;
            pointer.altKey = event.altKey;
            pointer.button = event.button;
            pointer.id = this.pointerUpId++;
            pointer.deltaY = (event === null || event === void 0 ? void 0 : event.deltaY) || 0;
            if (this.pointerUpId > 100000)
                this.pointerUpId = 1;
            (_a = this.eventMediator) === null || _a === void 0 ? void 0 : _a.emitEvent(pythaEvent);
        };
        /**
         * 键盘按下事件
         * @param event
         */
        this.onKeydown = (event) => {
            var _a, _b, _c;
            let code = event.code;
            if (code === "Enter" || code === "Space") ;
            else if (event.ctrlKey && (event.key === "z" || event.key === "Z")) {
                // 识别撤销
                let cmd = new PythaEventCMD();
                cmd.data = "UNDO";
                (_a = this.eventMediator) === null || _a === void 0 ? void 0 : _a.emitEvent(cmd);
                event.stopPropagation();
                event.preventDefault();
            }
            else if (event.ctrlKey && (event.key === "y" || event.key === "Y")) {
                // 识别重做
                let cmd = new PythaEventCMD();
                cmd.data = "REDO";
                (_b = this.eventMediator) === null || _b === void 0 ? void 0 : _b.emitEvent(cmd);
                event.stopPropagation();
                event.preventDefault();
            }
            else if (event.key === "Delete") {
                let cmd = new PythaEventCMD();
                cmd.data = 'DELETE';
                (_c = this.eventMediator) === null || _c === void 0 ? void 0 : _c.emitEvent(cmd);
                event.stopPropagation();
                event.preventDefault();
            }
        };
        this.onDocumentKeyDown = (event) => {
            var _a;
            let code = event.code;
            if (code === "Escape") {
                // 识别ESC键
                let endEvent = new PythaEventEnd();
                (_a = this.eventMediator) === null || _a === void 0 ? void 0 : _a.emitEvent(endEvent);
            }
        };
        /**
         * 画布外框大小发生变化
         * @param event
         */
        this.onWindowResize = (event) => {
            var _a, _b;
            const viewportStore = PythaStorage.instance.viewportStore;
            const root = viewportStore.rootHTML;
            if (!root)
                return;
            const aspect = root.offsetWidth / root.offsetHeight;
            viewportStore.aspect = aspect; // 将宽高比存入viewport
            for (const key in viewportStore.viewportItems) {
                let viewport = viewportStore.viewportItems[key];
                if (viewport.camera.type === "OrthographicCamera") {
                    let camera = viewport.camera;
                    camera.left = camera.bottom * aspect;
                    camera.right = camera.top * aspect;
                    camera.updateProjectionMatrix();
                }
                else if (viewport.camera.type === "PerspectiveCamera") {
                    let camera = viewport.camera;
                    camera.aspect = aspect;
                    camera.updateProjectionMatrix();
                }
            }
            (_b = (_a = this.eventMediator) === null || _a === void 0 ? void 0 : _a.renderHandler) === null || _b === void 0 ? void 0 : _b.render();
        };
        /**
         * 用来给pointermove事件打唯一识别，防止不同事件处理器对象接收时重复计算
         */
        this.pointerWheelId = 1;
        /**
         * 鼠标滚动滚轮事件
         * @param event
         */
        this.onMouseWheel = (event) => {
            var _a;
            _point2.set(event.clientX, event.clientY);
            let pythaEvent = new PythaEventMouseWheel();
            let pointer = pythaEvent.data;
            pointer.point2 = _point2;
            pointer.type = "MOUSE";
            pointer.ctrlKey = event.ctrlKey;
            pointer.shiftKey = event.shiftKey;
            pointer.altKey = event.altKey;
            pointer.button = event.button;
            pointer.id = this.pointerWheelId++;
            pointer.deltaY = (event === null || event === void 0 ? void 0 : event.deltaY) || 0;
            if (this.pointerWheelId > 100000)
                this.pointerWheelId = 1;
            (_a = this.eventMediator) === null || _a === void 0 ? void 0 : _a.emitEvent(pythaEvent);
        };
    }
    /**
     * 打开引擎开关，初始化各部件
     * @param root
     * 初始化相机
     * 初始化场景
     * 初始化渲染器
     * 渲染器绑定到画布上
     */
    switchOn(root) {
        if (!root)
            return;
        // 初始化存储器
        const storage = PythaStorage.init();
        this.storage = storage;
        // 初始化事件中介
        const eventMediator = new EventMediator();
        this.eventMediator = eventMediator;
        this.eventMediator.storage = storage;
        // 初始化视口
        const viewportStore = storage.viewportStore;
        viewportStore.rootHTML = root;
        const renderer = this.initRenderer(root);
        this.init2DRenderer(root);
        this.initScene();
        this.initOrghoCamera(root);
        this.initPointerEvent(renderer);
        this.eventMediator.renderHandler.render();
        //初始化常驻图
        this.initAlwaysActiveGraphs();
    }
    /**
     * 关闭引擎，销毁资源
     */
    switchOff() {
        var _a;
        // TODO: 销毁资源
        (_a = this.eventMediator) === null || _a === void 0 ? void 0 : _a.dispose();
        let renderer = this.storage.viewportStore.renderer;
        renderer.domElement.removeEventListener('pointerdown', this.onPointerDown);
        renderer.domElement.removeEventListener('pointermove', this.onPointerMove);
        renderer.domElement.removeEventListener('pointerup', this.onPointerUp);
        renderer.domElement.removeEventListener('keydown', this.onKeydown);
        renderer.domElement.removeEventListener('wheel', this.onMouseWheel);
        document.removeEventListener('keydown', this.onDocumentKeyDown);
        PythaStorage.close(); // 销毁存储器
        this.storage = null;
        if (window != null) {
            window.removeEventListener('resize', this.onWindowResize);
        }
    }
    /**
     * 注册字体库
     * @param font opentype字体
     */
    registFont(font) {
        if (!this.storage)
            return;
        this.storage.textStore.font = font;
    }
    /**
     * 注册块模板
     * @param blocks
     */
    registBlocks(blocks) {
        if (!this.storage)
            return;
        for (let json of blocks) {
            let block = new BlockPrimitive().fromJson(json);
            if (block.isTemplate) {
                let childJson = json['children'] || [];
                this._resolveChildrenPrimitive(block, childJson);
            }
            block.updateWorldModelMatrix(false, true);
            this.storage.blockStore.blockTemplateDict[block.uuid] = block;
        }
    }
    /**
     * 注册图层列表
     * @param layers
     */
    registLayers(layers) {
        if (!this.storage)
            return;
        this.storage.layerStore.layers = [...layers];
    }
    /**
     * 注册组
     * @param groups
     * @returns
     */
    registGroups(groups) {
        if (!this.storage)
            return;
        for (let group of groups) {
            this.storage.groupStore.groupDict[group.uuid] = group;
        }
    }
    /**
     * 设置当前图层
     * @param currentLayerUuid
     */
    registCurrentLayer(currentLayerUuid) {
        if (!this.storage)
            return;
        let layers = this.storage.layerStore.layers;
        layers.find(item => item.uuid == currentLayerUuid);
        this.storage.layerStore.currentLayerUuid = currentLayerUuid;
    }
    /**
     * 注册插件
     */
    registPlugin(plugin) {
        if (!this.storage)
            return;
        for (let graph of plugin.graphs) {
            this.storage.registerStore.registEventGraph(graph.cmd, graph.constructor, graph.desciption);
        }
        for (let graph of plugin.graftGraphs) {
            this.storage.registerStore.registGraftGraph(graph.cmd, graph.constructor);
        }
    }
    /**
     * 注册图元类型
     * @param name
     * @param constructor
     * @returns
     */
    registPrimitiveType(name, constructor) {
        if (!this.storage)
            return;
        this.storage.registerStore.registPrimitiveType(name, constructor);
    }
    /**
     * 设置单位换算比例
     * @param unitRatio
     * @returns
     */
    registUnitRatio(unitRatio = 1) {
        if (!this.storage)
            return;
        this.storage.coordinateStore.lengthUnitRatio = unitRatio || 1;
    }
    /**
     * 解析并加载图元
     * @param jsonList
     */
    resolvePrimitives(jsonList) {
        if (this.storage == null)
            return;
        let primitives = [];
        for (let json of jsonList) {
            let PriConstructor = this.storage.registerStore.getPrimitive(json.type);
            let primitive = new (PriConstructor)();
            primitive.fromJson(json);
            // 处理子图元
            let childJson = json['children'] || [];
            this._resolveChildrenPrimitive(primitive, childJson);
            primitive.updateWorldModelMatrix(false, true);
            primitives.push(primitive);
        }
        let dataChange = new PythaEventDataChange({ add_primitives: primitives });
        setTimeout(() => {
            var _a;
            this.eventMediator.emitEvent(dataChange);
            const pythaEvent = new PythaEventZoomAll();
            pythaEvent.data = {};
            (_a = this.eventMediator) === null || _a === void 0 ? void 0 : _a.emitEvent(pythaEvent);
        }, 0);
    }
    /**
     * 递归解析子图元
     * @param primitive
     * @param childJson
     */
    _resolveChildrenPrimitive(primitive, childJson) {
        for (let child of childJson) {
            let PriConstructor = this.storage.registerStore.getPrimitive(child.type);
            let childPrimitive = new (PriConstructor)();
            childPrimitive.fromJson(child);
            primitive.addChildPrimitive(childPrimitive);
            let childchild = child['children'] || [];
            this._resolveChildrenPrimitive(childPrimitive, childchild);
        }
    }
    /**
     * 用于给系统判断当前是否有激活的命令功能
     * @returns
     */
    get isCmdActive() {
        var _a;
        return ((_a = this.eventMediator) === null || _a === void 0 ? void 0 : _a.tempActiveGraph) != null;
    }
    /**
     * 返回当前正在执行的命令字符串
     * @returns str
     */
    getActiveCmdStr() {
        var _a;
        if (this.isCmdActive) {
            return (_a = this.eventMediator) === null || _a === void 0 ? void 0 : _a.lastCmd;
        }
        return '';
    }
    /**
     * 初始化常驻图
     */
    initAlwaysActiveGraphs() {
        //有中介时，初始化常驻图
        if (this.eventMediator) {
            //初始化选择控制图
            let selectGraph = new EventGraphSelect(this.eventMediator);
            let selectStartNode = selectGraph.start();
            if (selectStartNode)
                selectStartNode.run();
            this.eventMediator.alwaysActiveGraphs.push(selectGraph);
            // 初始化平移控制图
            let viewPanGraph = new EventGraphViewPan(this.eventMediator);
            let viewPanStartNode = viewPanGraph.start();
            if (viewPanStartNode)
                viewPanStartNode.run();
            this.eventMediator.alwaysActiveGraphs.push(viewPanGraph);
            // 初始化旋转控制图
            let view3doGraph = new EventGraphView3do(this.eventMediator);
            let view3doStartNode = view3doGraph.start();
            if (view3doStartNode)
                view3doStartNode.run();
            this.eventMediator.alwaysActiveGraphs.push(view3doGraph);
            // 初始化缩放控制图
            let viewZoomGraph = new EventGraphViewZoom(this.eventMediator);
            let viewZoomStartNode = viewZoomGraph.start();
            if (viewZoomStartNode)
                viewZoomStartNode.run();
            this.eventMediator.alwaysActiveGraphs.push(viewZoomGraph);
            // 初始化光标控制图
            let cursorGraph = new EventGraphCursor(this.eventMediator);
            let cursorStartNode = cursorGraph.start();
            if (cursorStartNode)
                cursorStartNode.run();
            this.eventMediator.alwaysActiveGraphs.push(cursorGraph);
            // 初始化夹点控制图
            let clampGraph = new EventGraphClamp(this.eventMediator);
            let clampStartNode = clampGraph.start();
            if (clampStartNode)
                clampStartNode.run();
            this.eventMediator.alwaysActiveGraphs.push(clampGraph);
            // 初始化坐标轴显示
            let axesGraph = new EventGraphAxes(this.eventMediator);
            let axesStartNode = axesGraph.start();
            if (axesStartNode)
                axesStartNode.run();
            this.eventMediator.alwaysActiveGraphs.push(axesGraph);
            // 初始化加载数据图
            let loadDataGraph = new EGLoadData(this.eventMediator);
            let loadDataStartNode = loadDataGraph.start();
            if (loadDataStartNode)
                loadDataStartNode.run();
            this.eventMediator.alwaysActiveGraphs.push(loadDataGraph);
            // 初始化zoomIn zoomOut缩放控制图
            let zoomInOutGraph = new EventGraphZoomInOut(this.eventMediator);
            let zoomInOutNode = zoomInOutGraph.start();
            if (zoomInOutNode)
                zoomInOutNode.run();
            this.eventMediator.alwaysActiveGraphs.push(zoomInOutGraph);
            // 初始化zoomAll控制图
            let zoomAllGraph = new EventGraphZoomAll(this.eventMediator);
            let zoomAllNode = zoomAllGraph.start();
            if (zoomAllNode)
                zoomAllNode.run();
            this.eventMediator.alwaysActiveGraphs.push(zoomAllGraph);
            // 初始化修改图元颜色控制图
            let colorGraph = new EventGraphColor(this.eventMediator);
            let colorNode = colorGraph.start();
            if (colorNode)
                colorNode.run();
            this.eventMediator.alwaysActiveGraphs.push(colorGraph);
            // 设置图
            let settingGraph = new EventGraphSetting(this.eventMediator);
            let settingStartNode = settingGraph.start();
            if (settingStartNode)
                settingStartNode.run();
            this.eventMediator.alwaysActiveGraphs.push(settingGraph);
            // 图层设置图
            let layerGraph = new EventGraphLayer(this.eventMediator);
            let layerStartNode = layerGraph.start();
            if (layerStartNode)
                layerStartNode.run();
            this.eventMediator.alwaysActiveGraphs.push(layerGraph);
            // 强制选择图
            let forceSelectGraph = new EventGraphForceSelect(this.eventMediator);
            let forceSelectStartNode = forceSelectGraph.start();
            if (forceSelectStartNode)
                forceSelectStartNode.run();
            this.eventMediator.alwaysActiveGraphs.push(forceSelectGraph);
            // 画布大小变化图
            let CanvasResizeGraph = new EventGraphCanvasResize(this.eventMediator);
            let CanvasResizeStartNode = CanvasResizeGraph.start();
            if (CanvasResizeStartNode)
                CanvasResizeStartNode.run();
            this.eventMediator.alwaysActiveGraphs.push(CanvasResizeGraph);
        }
    }
    /**
     * 初始化渲染器
     * @param root 引擎挂载的页面画布
     * @returns
     */
    initRenderer(root) {
        if (!root)
            return null;
        root.oncontextmenu = (e) => {
            e.preventDefault();
        };
        const viewportStore = PythaStorage.instance.viewportStore;
        const renderer = new WebGLRenderer({
            antialias: true,
            logarithmicDepthBuffer: true
        });
        root.appendChild(renderer.domElement);
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(root.offsetWidth, root.offsetHeight);
        renderer.setClearColor(viewportStore.background, 0);
        renderer.setScissorTest(true);
        renderer.autoClear = false;
        renderer.domElement.setAttribute('tabindex', '1');
        renderer.domElement.style.outline = '0px';
        renderer.domElement.style.cursor = "none";
        renderer.domElement.style.background = `linear-gradient(0deg, ${viewportStore.background} 25%, rgba(255, 255, 255, 1) 75%)`;
        renderer.domElement.focus();
        viewportStore.renderer = renderer;
        return renderer;
    }
    init2DRenderer(root) {
        if (!root)
            return null;
        const viewportStore = PythaStorage.instance.viewportStore;
        const labelRenderer = new CSS2DRenderer();
        labelRenderer.setSize(root.offsetWidth, root.offsetHeight);
        labelRenderer.domElement.style.position = 'absolute';
        labelRenderer.domElement.style.top = '0px';
        labelRenderer.domElement.style.pointerEvents = 'none';
        root.appendChild(labelRenderer.domElement);
        viewportStore.labelRenderer = labelRenderer;
        return labelRenderer;
    }
    /**
     * 初始化场景
     */
    initScene() {
        let scene = new Scene();
        // 环境光
        const ambientLight = new AmbientLight(0xff3300, 0.2);
        scene.add(ambientLight);
        // 平行光
        const directionalLight = new DirectionalLight(0xffffff, 2);
        directionalLight.position.set(1, 1, 1).normalize();
        // directionalLight.castShadow = true; // 使光源投射阴影
        scene.add(directionalLight);
        PythaStorage.instance.renderStore.light = directionalLight;
        // const directionalLight1 = new DirectionalLight(0xffffff, 0.7);
        // directionalLight1.position.set(-1, 1, 1).normalize();
        // directionalLight1.castShadow = true; // 使光源投射阴影
        // scene.add(directionalLight1);
        // const directionalLight2 = new DirectionalLight(0xffffff, 0.6);
        // directionalLight2.position.set(1, -1, -1).normalize();
        // directionalLight2.castShadow = true; // 使光源投射阴影
        // scene.add(directionalLight2);
        // const directionalLight3 = new DirectionalLight(0xffffff, 0.5);
        // directionalLight3.position.set(-1, -1, -1).normalize();
        // directionalLight3.castShadow = true; // 使光源投射阴影
        // scene.add(directionalLight3);
        const viewportStore = PythaStorage.instance.viewportStore;
        viewportStore.scene = scene;
        return scene;
    }
    /**
     * 初始化正交相机
     * @param root 挂载的画布
     * @param cameraType 初始化相机类型
     * @returns
     */
    initOrghoCamera(root, size = 5e5) {
        if (!root)
            return null;
        if (!this.storage)
            return null;
        const viewportStore = this.storage.viewportStore;
        let s = viewportStore.initialCameraEdge;
        let aspect = root.offsetWidth / root.offsetHeight;
        if (viewportStore.viewportMode == ViewportMode.ONE) {
            const camera = new OrthographicCamera(-s * aspect, s * aspect, s, -s, 0, size);
            // camera.position.set(0, 0, 1e6 / 2)
            let vec = new Vector3(1, -1, 1).normalize().multiplyScalar(size / 2);
            camera.position.set(vec.x, vec.y, vec.z);
            camera.up.set(0, 0, 1);
            camera.lookAt(0, 0, 0);
            const uuid = BaseUtils.genUUID();
            viewportStore.viewportItems[uuid] = {
                camera: camera,
                range: [0, 0, 1, 1],
                target: new Vector3(),
                offset: new Vector3(),
                zoomCenter: new Vector3(),
                cameraEdge: s,
                inViewCount: 0,
            };
            viewportStore.currentViewportKey = uuid;
            return camera;
        }
        else if (viewportStore.viewportMode == ViewportMode.TWO_HORIZON) {
            aspect = aspect / 2;
            // TODO
        }
        else if (viewportStore.viewportMode == ViewportMode.TWO_VERTICAL) {
            aspect = aspect * 2;
            // TODO
        }
        else if (viewportStore.viewportMode == ViewportMode.FOUR) ;
        return null;
    }
    /**
     * 初始化鼠标事件
     * @param renderer 渲染器，用于传递鼠标挂载的画布
     * @returns
     */
    initPointerEvent(renderer) {
        let domElement = renderer.domElement;
        if (domElement == null)
            return;
        renderer.domElement.addEventListener('pointerdown', this.onPointerDown);
        renderer.domElement.addEventListener('pointermove', this.onPointerMove);
        renderer.domElement.addEventListener('pointerup', this.onPointerUp);
        renderer.domElement.addEventListener('keydown', this.onKeydown);
        document.addEventListener('keydown', this.onDocumentKeyDown);
        renderer.domElement.addEventListener('wheel', this.onMouseWheel);
        if (window != null) {
            window.addEventListener('resize', this.onWindowResize);
        }
    }
}
const _point2 = new Point2();/**
 * 定义引擎插件注册接口
 */
class PythaPluginBase {
    constructor(data) {
        /**
         * 专业插件待注册的中介图
         */
        this.graphs = [];
        /**
         * 专业插件待注册的嫁接图
         */
        this.graftGraphs = [];
        /**
         * 专业插件待注册的几何类
         */
        this.geos = [];
        this.generate(data);
    }
}/**
 * 生成命令组
 */
class EventHandlerGenCommandGroup extends EventHandlerBase {
    run(data) {
        const graphCache = this.node.graph.cache;
        let commandGroup = graphCache.data['commandGroup'];
        // 如果当前缓存存在命令组，则跳过
        if (!!commandGroup && commandGroup instanceof CommandGroup)
            return true;
        // 如果当前缓存不存在命令组，则创建
        commandGroup = new CommandGroup();
        graphCache.data['commandGroup'] = commandGroup;
        return true;
    }
}/**
 * 执行并清空命令组
 */
class EventHandlerRunCommandGroup extends EventHandlerBase {
    run(data) {
        const graphCache = this.node.graph.cache;
        const commandGroup = graphCache.data['commandGroup'];
        // 异常数据
        if (!commandGroup || !(commandGroup instanceof CommandGroup))
            return false;
        const storage = PythaStorage.instance;
        storage.historyStore.undos.push(commandGroup);
        commandGroup.execute();
        graphCache.data['commandGroup'] = null;
        return true;
    }
}export{AxesPrimitive,BlockPrimitive,CameraPerspectiveType,CommandBase,CommandGroup,EDGE_TYPE,EHCalTempRotateObj,EHChangeCrossCursor,EHChangePickCursor,EHGenLine,EventGraphBase,EventGraphDelete,EventGraphNode,EventGraphNodeAND,EventGraphNodeGraft,EventGraphNodeNotice,EventGraphNodeRender,EventGraphNodeSwitch,EventGraphNodeTimer,EventGraphPluginBase,EventHanderCalAllBoundingBox,EventHanderShowAllInRect,EventHandlerBase,EventHandlerCalPointerDown,EventHandlerCalPointerMove,EventHandlerCalPointerUp,EventHandlerCalPrimitiveInView,EventHandlerCalTempLine,EventHandlerCalTempMoveObj,EventHandlerCalTempMovePri,EventHandlerCalTempPlineCurve,EventHandlerCalTempRotatePri,EventHandlerCapture,EventHandlerClosePline,EventHandlerCmdEnd,EventHandlerConfirm,EventHandlerDisableClamp,EventHandlerDisableRangeSelect,EventHandlerDisableSelect,EventHandlerEditPri,EventHandlerEmptySelect,EventHandlerGenAndDeletePrimitives,EventHandlerGenCommandGroup,EventHandlerGenRegion,EventHandlerGenTempPLine,EventHandlerGenVector3,EventHandlerGeneratePri,EventHandlerGrid,EventHandlerHelpLine,EventHandlerInitCapture,EventHandlerNumberInput,EventHandlerObjectInput,EventHandlerOnZoomAll,EventHandlerOptionInput,EventHandlerOrthoPolar,EventHandlerRemoveHelpLine,EventHandlerRender,EventHandlerRunCommandGroup,EventHandlerSelectStart,EventHandlerSettingOrthoPoint,EventHandlerStart,EventHandlerStringInput,EventHandlerUpdateAndDeletePri,EventHandlerUpdatePline,EventMediator,GraftOrderEnum,LabelBase,NeedInputEnum,OutputDataType,Pointer,Primitive,PrimitiveType,PythaEngineControl,PythaEventAngle,PythaEventBlock,PythaEventCMD,PythaEventConfirm,PythaEventCount,PythaEventCursorTypeChange,PythaEventDataChange,PythaEventDyText,PythaEventEnd,PythaEventLoadData,PythaEventMouseWheel,PythaEventName,PythaEventNeedInput,PythaEventNotice,PythaEventNumber,PythaEventObject,PythaEventOption,PythaEventOutputData,PythaEventPointerDown,PythaEventPointerMove,PythaEventPointerUp,PythaEventSelectChange,PythaEventSetting,PythaEventString,PythaEventStringArray,PythaEventText,PythaEventZoomAll,PythaEventZoomChange,PythaEventZoomInOut,PythaPluginBase,RenderItemType,RenderMode,SETTING_KEY,SelectionRect,TextPrimitive,UpdateType};